import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: string;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: string;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
};

export type ActivateEntraUserResponse = AlreadyLinked | InvalidOid | UserWithLoginData;

export type ActivateSsoLoginResponse = AlreadyLinked | InvalidEntraToken | InvalidOid | SsoLoginData;

export type AllocationArea = {
  __typename?: 'AllocationArea';
  /** Reads and enables pagination through a set of `AllocationAreaPhase`. */
  allocationAreaPhasesByAllocationId: AllocationAreaPhasesConnection;
  /** Reads a single `Area` that is related to this `AllocationArea`. */
  area: Area;
  areaId: Scalars['UUID'];
  conflicts: Scalars['Int'];
  end: Scalars['Datetime'];
  /** Reads a single `EventVariant` that is related to this `AllocationArea`. */
  eventVariant: EventVariant;
  eventVariantId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `EventVariant`. */
  eventVariantsByReferenceAllocationAreaId: EventVariantsConnection;
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  start: Scalars['Datetime'];
};


export type AllocationAreaAllocationAreaPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationAreaPhaseCondition>;
  filter?: InputMaybe<AllocationAreaPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationAreaPhasesOrderBy>>;
};


export type AllocationAreaEventVariantsByReferenceAllocationAreaIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventVariantCondition>;
  filter?: InputMaybe<EventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** The fields on `allocationArea` to look up the row to connect. */
export type AllocationAreaAllocationAreaPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationArea` to look up the row to delete. */
export type AllocationAreaAllocationAreaPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `allocationArea` to be created by this mutation. */
export type AllocationAreaAreaIdFkeyAllocationAreaCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
};

/** The `area` to be created by this mutation. */
export type AllocationAreaAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `area` in the `AllocationAreaInput` mutation. */
export type AllocationAreaAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationAreaAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `allocationArea` in the `AreaInput` mutation. */
export type AllocationAreaAreaIdFkeyInverseInput = {
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationAreaAllocationAreaPkeyConnect>>;
  /** A `AllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationAreaAreaIdFkeyAllocationAreaCreateInput>>;
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationAreaAllocationAreaPkeyDelete>>;
  /** Flag indicating whether all other `allocationArea` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationAreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAllocationAreaPkeyUpdate>>;
};

/**
 * A condition to be used against `AllocationArea` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllocationAreaCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `conflicts` field. */
  conflicts?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `eventVariantId` field. */
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** All input for the `allocationAreaDuplicate` mutation. */
export type AllocationAreaDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The output of our `allocationAreaDuplicate` mutation. */
export type AllocationAreaDuplicatePayload = {
  __typename?: 'AllocationAreaDuplicatePayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our `allocationAreaDuplicate` mutation. */
export type AllocationAreaDuplicatePayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** The `allocationArea` to be created by this mutation. */
export type AllocationAreaEventVariantIdFkeyAllocationAreaCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
};

/** The `eventVariant` to be created by this mutation. */
export type AllocationAreaEventVariantIdFkeyEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `eventVariant` in the `AllocationAreaInput` mutation. */
export type AllocationAreaEventVariantIdFkeyInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<EventVariantEventVariantEventIdIndexKeyConnect>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<EventVariantEventVariantPkeyConnect>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationAreaEventVariantIdFkeyEventVariantCreateInput>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<EventVariantEventVariantEventIdIndexKeyDelete>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<EventVariantEventVariantPkeyDelete>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<EventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyUsingEventVariantEventIdIndexKeyUpdate>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<EventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyUsingEventVariantPkeyUpdate>;
};

/** Input for the nested mutation of `allocationArea` in the `EventVariantInput` mutation. */
export type AllocationAreaEventVariantIdFkeyInverseInput = {
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationAreaAllocationAreaPkeyConnect>>;
  /** A `AllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationAreaEventVariantIdFkeyAllocationAreaCreateInput>>;
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationAreaAllocationAreaPkeyDelete>>;
  /** Flag indicating whether all other `allocationArea` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationAreaOnAllocationAreaForAllocationAreaEventVariantIdFkeyUsingAllocationAreaPkeyUpdate>>;
};

/** A filter to be used against `AllocationArea` object types. All fields are combined with a logical ‘and.’ */
export type AllocationAreaFilter = {
  /** Filter by the object’s `allocationAreaPhasesByAllocationId` relation. */
  allocationAreaPhasesByAllocationId?: InputMaybe<AllocationAreaToManyAllocationAreaPhaseFilter>;
  /** Some related `allocationAreaPhasesByAllocationId` exist. */
  allocationAreaPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationAreaFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `conflicts` field. */
  conflicts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventVariant` relation. */
  eventVariant?: InputMaybe<EventVariantFilter>;
  /** Filter by the object’s `eventVariantId` field. */
  eventVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `eventVariantsByReferenceAllocationAreaId` relation. */
  eventVariantsByReferenceAllocationAreaId?: InputMaybe<AllocationAreaToManyEventVariantFilter>;
  /** Some related `eventVariantsByReferenceAllocationAreaId` exist. */
  eventVariantsByReferenceAllocationAreaIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationAreaFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationAreaFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AllocationArea` */
export type AllocationAreaInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
};

/** The fields on `allocationArea` to look up the row to update. */
export type AllocationAreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationArea` being updated. */
  patch: UpdateAllocationAreaOnAllocationAreaForAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `allocationArea` to look up the row to update. */
export type AllocationAreaOnAllocationAreaForAllocationAreaEventVariantIdFkeyUsingAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationArea` being updated. */
  patch: UpdateAllocationAreaOnAllocationAreaForAllocationAreaEventVariantIdFkeyPatch;
};

/** The fields on `allocationArea` to look up the row to update. */
export type AllocationAreaOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationArea` being updated. */
  patch: UpdateAllocationAreaOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyPatch;
};

/** The fields on `allocationArea` to look up the row to update. */
export type AllocationAreaOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFUsingAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationArea` being updated. */
  patch: UpdateAllocationAreaOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFPatch;
};

/** Represents an update to a `AllocationArea`. Fields that are set will be updated. */
export type AllocationAreaPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type AllocationAreaPhase = {
  __typename?: 'AllocationAreaPhase';
  /** Reads a single `AllocationArea` that is related to this `AllocationAreaPhase`. */
  allocation: AllocationArea;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `AllocationUsage` that is related to this `AllocationAreaPhase`. */
  usage: AllocationUsage;
  usageId: Scalars['UUID'];
};

/** The fields on `allocationAreaPhase` to look up the row to connect. */
export type AllocationAreaPhaseAllocationAreaPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationAreaPhase` to look up the row to delete. */
export type AllocationAreaPhaseAllocationAreaPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/** The `allocationArea` to be created by this mutation. */
export type AllocationAreaPhaseAllocationIdFkeyAllocationAreaCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
};

/** The `allocationAreaPhase` to be created by this mutation. */
export type AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput = {
  allocationAreaToAllocationId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `allocationArea` in the `AllocationAreaPhaseInput` mutation. */
export type AllocationAreaPhaseAllocationIdFkeyInput = {
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationAreaAllocationAreaPkeyConnect>;
  /** A `AllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyAllocationAreaCreateInput>;
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationAreaAllocationAreaPkeyDelete>;
  /** The primary key(s) and patch data for `allocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationAreaOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPkeyUpdate>;
};

/** Input for the nested mutation of `allocationAreaPhase` in the `AllocationAreaInput` mutation. */
export type AllocationAreaPhaseAllocationIdFkeyInverseInput = {
  /** The primary key(s) for `allocationAreaPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationAreaPhaseAllocationAreaPhasePkeyConnect>>;
  /** A `AllocationAreaPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput>>;
  /** The primary key(s) for `allocationAreaPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationAreaPhaseAllocationAreaPhasePkeyDelete>>;
  /** Flag indicating whether all other `allocationAreaPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationAreaPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPhasePkeyUpdate>>;
};

/**
 * A condition to be used against `AllocationAreaPhase` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AllocationAreaPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `AllocationAreaPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationAreaPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<AllocationAreaFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationAreaPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationAreaPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationAreaPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<AllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `AllocationAreaPhase` */
export type AllocationAreaPhaseInput = {
  allocationAreaToAllocationId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInput>;
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationUsageToUsageId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `allocationAreaPhase` to look up the row to update. */
export type AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationAreaPhase` being updated. */
  patch: UpdateAllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyPatch;
};

/** The fields on `allocationAreaPhase` to look up the row to update. */
export type AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationAreaPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationAreaPhase` being updated. */
  patch: UpdateAllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch;
};

/** Represents an update to a `AllocationAreaPhase`. Fields that are set will be updated. */
export type AllocationAreaPhasePatch = {
  allocationAreaToAllocationId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInput>;
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationUsageToUsageId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The `allocationAreaPhase` to be created by this mutation. */
export type AllocationAreaPhaseUsageIdFkeyAllocationAreaPhaseCreateInput = {
  allocationAreaToAllocationId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInput>;
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationUsageToUsageId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `allocationUsage` to be created by this mutation. */
export type AllocationAreaPhaseUsageIdFkeyAllocationUsageCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: AllocationUsageType;
};

/** Input for the nested mutation of `allocationUsage` in the `AllocationAreaPhaseInput` mutation. */
export type AllocationAreaPhaseUsageIdFkeyInput = {
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationUsageAllocationUsagePkeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<AllocationUsageAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AllocationUsageAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<AllocationUsageAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<AllocationUsageAllocationUsageTypeKeyConnect>;
  /** A `AllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationAreaPhaseUsageIdFkeyAllocationUsageCreateInput>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationUsageAllocationUsagePkeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<AllocationUsageAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AllocationUsageAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<AllocationUsageAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<AllocationUsageAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `allocationAreaPhase` in the `AllocationUsageInput` mutation. */
export type AllocationAreaPhaseUsageIdFkeyInverseInput = {
  /** The primary key(s) for `allocationAreaPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationAreaPhaseAllocationAreaPhasePkeyConnect>>;
  /** A `AllocationAreaPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationAreaPhaseUsageIdFkeyAllocationAreaPhaseCreateInput>>;
  /** The primary key(s) for `allocationAreaPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationAreaPhaseAllocationAreaPhasePkeyDelete>>;
  /** Flag indicating whether all other `allocationAreaPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationAreaPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationAreaPhasePkeyUpdate>>;
};

/** A connection to a list of `AllocationAreaPhase` values. */
export type AllocationAreaPhasesConnection = {
  __typename?: 'AllocationAreaPhasesConnection';
  /** A list of edges which contains the `AllocationAreaPhase` and cursor to aid in pagination. */
  edges: Array<AllocationAreaPhasesEdge>;
  /** A list of `AllocationAreaPhase` objects. */
  nodes: Array<AllocationAreaPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationAreaPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationAreaPhase` edge in the connection. */
export type AllocationAreaPhasesEdge = {
  __typename?: 'AllocationAreaPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationAreaPhase` at the end of the edge. */
  node: AllocationAreaPhase;
};

/** Methods to use when ordering `AllocationAreaPhase`. */
export enum AllocationAreaPhasesOrderBy {
  AllocationAreaByAllocationIdAreaIdAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__AREA_ID_ASC',
  AllocationAreaByAllocationIdAreaIdDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__AREA_ID_DESC',
  AllocationAreaByAllocationIdConflictsAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__CONFLICTS_ASC',
  AllocationAreaByAllocationIdConflictsDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__CONFLICTS_DESC',
  AllocationAreaByAllocationIdEndAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__END_ASC',
  AllocationAreaByAllocationIdEndDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__END_DESC',
  AllocationAreaByAllocationIdEventVariantIdAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__EVENT_VARIANT_ID_ASC',
  AllocationAreaByAllocationIdEventVariantIdDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__EVENT_VARIANT_ID_DESC',
  AllocationAreaByAllocationIdIdAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__ID_ASC',
  AllocationAreaByAllocationIdIdDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__ID_DESC',
  AllocationAreaByAllocationIdIsOptionalAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  AllocationAreaByAllocationIdIsOptionalDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  AllocationAreaByAllocationIdStartAsc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__START_ASC',
  AllocationAreaByAllocationIdStartDesc = 'ALLOCATION_AREA_BY_ALLOCATION_ID__START_DESC',
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  AllocationUsageByUsageIdColorAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__COLOR_ASC',
  AllocationUsageByUsageIdColorDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__COLOR_DESC',
  AllocationUsageByUsageIdDefaultDaysAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__DEFAULT_DAYS_ASC',
  AllocationUsageByUsageIdDefaultDaysDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__DEFAULT_DAYS_DESC',
  AllocationUsageByUsageIdDescriptionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__DESCRIPTION_ASC',
  AllocationUsageByUsageIdDescriptionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__DESCRIPTION_DESC',
  AllocationUsageByUsageIdIdAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  AllocationUsageByUsageIdIdDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  AllocationUsageByUsageIdIsExecutionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  AllocationUsageByUsageIdIsExecutionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  AllocationUsageByUsageIdNameAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  AllocationUsageByUsageIdNameDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  AllocationUsageByUsageIdNameShortAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  AllocationUsageByUsageIdNameShortDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  AllocationUsageByUsageIdPositionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  AllocationUsageByUsageIdPositionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  AllocationUsageByUsageIdTypeAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  AllocationUsageByUsageIdTypeDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** A filter to be used against many `AllocationAreaPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationAreaToManyAllocationAreaPhaseFilter = {
  /** Every related `AllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationAreaPhaseFilter>;
  /** No related `AllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationAreaPhaseFilter>;
  /** Some related `AllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationAreaPhaseFilter>;
};

/** A filter to be used against many `EventVariant` object types. All fields are combined with a logical ‘and.’ */
export type AllocationAreaToManyEventVariantFilter = {
  /** Every related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventVariantFilter>;
  /** No related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventVariantFilter>;
  /** Some related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventVariantFilter>;
};

/** All input for the `allocationAreaUpdateAndDuplicate` mutation. */
export type AllocationAreaUpdateAndDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  updateAllocation?: InputMaybe<AllocationUpdateInput>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>>>;
};

/** The output of our `allocationAreaUpdateAndDuplicate` mutation. */
export type AllocationAreaUpdateAndDuplicatePayload = {
  __typename?: 'AllocationAreaUpdateAndDuplicatePayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our `allocationAreaUpdateAndDuplicate` mutation. */
export type AllocationAreaUpdateAndDuplicatePayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** A connection to a list of `AllocationArea` values. */
export type AllocationAreasConnection = {
  __typename?: 'AllocationAreasConnection';
  /** A list of edges which contains the `AllocationArea` and cursor to aid in pagination. */
  edges: Array<AllocationAreasEdge>;
  /** A list of `AllocationArea` objects. */
  nodes: Array<AllocationArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationArea` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationArea` edge in the connection. */
export type AllocationAreasEdge = {
  __typename?: 'AllocationAreasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationArea` at the end of the edge. */
  node: AllocationArea;
};

/** Methods to use when ordering `AllocationArea`. */
export enum AllocationAreasOrderBy {
  AllocationAreaPhasesByAllocationIdCountAsc = 'ALLOCATION_AREA_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  AllocationAreaPhasesByAllocationIdCountDesc = 'ALLOCATION_AREA_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  ConflictsAsc = 'CONFLICTS_ASC',
  ConflictsDesc = 'CONFLICTS_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  EventVariantsByReferenceAllocationAreaIdCountAsc = 'EVENT_VARIANTS_BY_REFERENCE_ALLOCATION_AREA_ID__COUNT_ASC',
  EventVariantsByReferenceAllocationAreaIdCountDesc = 'EVENT_VARIANTS_BY_REFERENCE_ALLOCATION_AREA_ID__COUNT_DESC',
  EventVariantByEventVariantIdChangesIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CHANGES_ID_ASC',
  EventVariantByEventVariantIdChangesIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CHANGES_ID_DESC',
  EventVariantByEventVariantIdCreatedAtAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CREATED_AT_ASC',
  EventVariantByEventVariantIdCreatedAtDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CREATED_AT_DESC',
  EventVariantByEventVariantIdDescriptionAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__DESCRIPTION_ASC',
  EventVariantByEventVariantIdDescriptionDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__DESCRIPTION_DESC',
  EventVariantByEventVariantIdEndAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__END_ASC',
  EventVariantByEventVariantIdEndDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__END_DESC',
  EventVariantByEventVariantIdEventIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__EVENT_ID_ASC',
  EventVariantByEventVariantIdEventIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__EVENT_ID_DESC',
  EventVariantByEventVariantIdIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__ID_ASC',
  EventVariantByEventVariantIdIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__ID_DESC',
  EventVariantByEventVariantIdIndexAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__INDEX_ASC',
  EventVariantByEventVariantIdIndexDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__INDEX_DESC',
  EventVariantByEventVariantIdIsArchivedAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_ARCHIVED_ASC',
  EventVariantByEventVariantIdIsArchivedDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_ARCHIVED_DESC',
  EventVariantByEventVariantIdIsCurrentAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_CURRENT_ASC',
  EventVariantByEventVariantIdIsCurrentDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_CURRENT_DESC',
  EventVariantByEventVariantIdNameAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__NAME_ASC',
  EventVariantByEventVariantIdNameDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__NAME_DESC',
  EventVariantByEventVariantIdReferenceAllocationAreaIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_AREA_ID_ASC',
  EventVariantByEventVariantIdReferenceAllocationAreaIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_AREA_ID_DESC',
  EventVariantByEventVariantIdReferenceAllocationRoomIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_ROOM_ID_ASC',
  EventVariantByEventVariantIdReferenceAllocationRoomIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_ROOM_ID_DESC',
  EventVariantByEventVariantIdStartAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__START_ASC',
  EventVariantByEventVariantIdStartDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__START_DESC',
  EventVariantByEventVariantIdStatusAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__STATUS_ASC',
  EventVariantByEventVariantIdStatusDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__STATUS_DESC',
  EventVariantByEventVariantIdVersionAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__VERSION_ASC',
  EventVariantByEventVariantIdVersionDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__VERSION_DESC',
  EventVariantIdAsc = 'EVENT_VARIANT_ID_ASC',
  EventVariantIdDesc = 'EVENT_VARIANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/** An input for mutations affecting `AllocationPhaseCreate` */
export type AllocationPhaseCreateInput = {
  duration?: InputMaybe<IntervalInput>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `AllocationPhaseUpdate` */
export type AllocationPhaseUpdateInput = {
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

export type AllocationPlot = {
  __typename?: 'AllocationPlot';
  /** Reads and enables pagination through a set of `AllocationPlotPhase`. */
  allocationPlotPhasesByAllocationId: AllocationPlotPhasesConnection;
  conflicts: Scalars['Int'];
  end: Scalars['Datetime'];
  /** Reads a single `EventVariant` that is related to this `AllocationPlot`. */
  eventVariant: EventVariant;
  eventVariantId: Scalars['UUID'];
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  /** Reads a single `Plot` that is related to this `AllocationPlot`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start: Scalars['Datetime'];
};


export type AllocationPlotAllocationPlotPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationPlotPhaseCondition>;
  filter?: InputMaybe<AllocationPlotPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationPlotPhasesOrderBy>>;
};

/** The fields on `allocationPlot` to look up the row to connect. */
export type AllocationPlotAllocationPlotPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationPlot` to look up the row to delete. */
export type AllocationPlotAllocationPlotPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AllocationPlot` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllocationPlotCondition = {
  /** Checks for equality with the object’s `conflicts` field. */
  conflicts?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `eventVariantId` field. */
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `allocationPlot` to be created by this mutation. */
export type AllocationPlotEventVariantIdFkeyAllocationPlotCreateInput = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `eventVariant` to be created by this mutation. */
export type AllocationPlotEventVariantIdFkeyEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `eventVariant` in the `AllocationPlotInput` mutation. */
export type AllocationPlotEventVariantIdFkeyInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<EventVariantEventVariantEventIdIndexKeyConnect>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<EventVariantEventVariantPkeyConnect>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationPlotEventVariantIdFkeyEventVariantCreateInput>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<EventVariantEventVariantEventIdIndexKeyDelete>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<EventVariantEventVariantPkeyDelete>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<EventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyUsingEventVariantEventIdIndexKeyUpdate>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<EventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyUsingEventVariantPkeyUpdate>;
};

/** Input for the nested mutation of `allocationPlot` in the `EventVariantInput` mutation. */
export type AllocationPlotEventVariantIdFkeyInverseInput = {
  /** The primary key(s) for `allocationPlot` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationPlotAllocationPlotPkeyConnect>>;
  /** A `AllocationPlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationPlotEventVariantIdFkeyAllocationPlotCreateInput>>;
  /** The primary key(s) for `allocationPlot` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationPlotAllocationPlotPkeyDelete>>;
  /** Flag indicating whether all other `allocationPlot` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationPlot` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationPlotOnAllocationPlotForAllocationPlotEventVariantIdFkeyUsingAllocationPlotPkeyUpdate>>;
};

/** A filter to be used against `AllocationPlot` object types. All fields are combined with a logical ‘and.’ */
export type AllocationPlotFilter = {
  /** Filter by the object’s `allocationPlotPhasesByAllocationId` relation. */
  allocationPlotPhasesByAllocationId?: InputMaybe<AllocationPlotToManyAllocationPlotPhaseFilter>;
  /** Some related `allocationPlotPhasesByAllocationId` exist. */
  allocationPlotPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationPlotFilter>>;
  /** Filter by the object’s `conflicts` field. */
  conflicts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventVariant` relation. */
  eventVariant?: InputMaybe<EventVariantFilter>;
  /** Filter by the object’s `eventVariantId` field. */
  eventVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationPlotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationPlotFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AllocationPlot` */
export type AllocationPlotInput = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The fields on `allocationPlot` to look up the row to update. */
export type AllocationPlotOnAllocationPlotForAllocationPlotEventVariantIdFkeyUsingAllocationPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationPlot` being updated. */
  patch: UpdateAllocationPlotOnAllocationPlotForAllocationPlotEventVariantIdFkeyPatch;
};

/** The fields on `allocationPlot` to look up the row to update. */
export type AllocationPlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingAllocationPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationPlot` being updated. */
  patch: UpdateAllocationPlotOnAllocationPlotForAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `allocationPlot` to look up the row to update. */
export type AllocationPlotOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyUsingAllocationPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationPlot` being updated. */
  patch: UpdateAllocationPlotOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyPatch;
};

/** Represents an update to a `AllocationPlot`. Fields that are set will be updated. */
export type AllocationPlotPatch = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type AllocationPlotPhase = {
  __typename?: 'AllocationPlotPhase';
  /** Reads a single `AllocationPlot` that is related to this `AllocationPlotPhase`. */
  allocation: AllocationPlot;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `AllocationUsage` that is related to this `AllocationPlotPhase`. */
  usage: AllocationUsage;
  usageId: Scalars['UUID'];
};

/** The `allocationPlot` to be created by this mutation. */
export type AllocationPlotPhaseAllocationIdFkeyAllocationPlotCreateInput = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `allocationPlotPhase` to be created by this mutation. */
export type AllocationPlotPhaseAllocationIdFkeyAllocationPlotPhaseCreateInput = {
  allocationPlotToAllocationId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `allocationPlot` in the `AllocationPlotPhaseInput` mutation. */
export type AllocationPlotPhaseAllocationIdFkeyInput = {
  /** The primary key(s) for `allocationPlot` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationPlotAllocationPlotPkeyConnect>;
  /** A `AllocationPlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyAllocationPlotCreateInput>;
  /** The primary key(s) for `allocationPlot` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationPlotAllocationPlotPkeyDelete>;
  /** The primary key(s) and patch data for `allocationPlot` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationPlotOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyUsingAllocationPlotPkeyUpdate>;
};

/** Input for the nested mutation of `allocationPlotPhase` in the `AllocationPlotInput` mutation. */
export type AllocationPlotPhaseAllocationIdFkeyInverseInput = {
  /** The primary key(s) for `allocationPlotPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationPlotPhaseAllocationPlotPhasePkeyConnect>>;
  /** A `AllocationPlotPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationPlotPhaseAllocationIdFkeyAllocationPlotPhaseCreateInput>>;
  /** The primary key(s) for `allocationPlotPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationPlotPhaseAllocationPlotPhasePkeyDelete>>;
  /** Flag indicating whether all other `allocationPlotPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationPlotPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyUsingAllocationPlotPhasePkeyUpdate>>;
};

/** The fields on `allocationPlotPhase` to look up the row to connect. */
export type AllocationPlotPhaseAllocationPlotPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationPlotPhase` to look up the row to delete. */
export type AllocationPlotPhaseAllocationPlotPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AllocationPlotPhase` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AllocationPlotPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `AllocationPlotPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationPlotPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<AllocationPlotFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationPlotPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationPlotPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationPlotPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<AllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `AllocationPlotPhase` */
export type AllocationPlotPhaseInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationPlotToAllocationId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `allocationPlotPhase` to look up the row to update. */
export type AllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyUsingAllocationPlotPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationPlotPhase` being updated. */
  patch: UpdateAllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyPatch;
};

/** The fields on `allocationPlotPhase` to look up the row to update. */
export type AllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationPlotPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationPlotPhase` being updated. */
  patch: UpdateAllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch;
};

/** Represents an update to a `AllocationPlotPhase`. Fields that are set will be updated. */
export type AllocationPlotPhasePatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationPlotToAllocationId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The `allocationPlotPhase` to be created by this mutation. */
export type AllocationPlotPhaseUsageIdFkeyAllocationPlotPhaseCreateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationPlotToAllocationId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `allocationUsage` to be created by this mutation. */
export type AllocationPlotPhaseUsageIdFkeyAllocationUsageCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: AllocationUsageType;
};

/** Input for the nested mutation of `allocationUsage` in the `AllocationPlotPhaseInput` mutation. */
export type AllocationPlotPhaseUsageIdFkeyInput = {
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationUsageAllocationUsagePkeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<AllocationUsageAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AllocationUsageAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<AllocationUsageAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<AllocationUsageAllocationUsageTypeKeyConnect>;
  /** A `AllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationPlotPhaseUsageIdFkeyAllocationUsageCreateInput>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationUsageAllocationUsagePkeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<AllocationUsageAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AllocationUsageAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<AllocationUsageAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<AllocationUsageAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `allocationPlotPhase` in the `AllocationUsageInput` mutation. */
export type AllocationPlotPhaseUsageIdFkeyInverseInput = {
  /** The primary key(s) for `allocationPlotPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationPlotPhaseAllocationPlotPhasePkeyConnect>>;
  /** A `AllocationPlotPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationPlotPhaseUsageIdFkeyAllocationPlotPhaseCreateInput>>;
  /** The primary key(s) for `allocationPlotPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationPlotPhaseAllocationPlotPhasePkeyDelete>>;
  /** Flag indicating whether all other `allocationPlotPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationPlotPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationPlotPhasePkeyUpdate>>;
};

/** A connection to a list of `AllocationPlotPhase` values. */
export type AllocationPlotPhasesConnection = {
  __typename?: 'AllocationPlotPhasesConnection';
  /** A list of edges which contains the `AllocationPlotPhase` and cursor to aid in pagination. */
  edges: Array<AllocationPlotPhasesEdge>;
  /** A list of `AllocationPlotPhase` objects. */
  nodes: Array<AllocationPlotPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationPlotPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationPlotPhase` edge in the connection. */
export type AllocationPlotPhasesEdge = {
  __typename?: 'AllocationPlotPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationPlotPhase` at the end of the edge. */
  node: AllocationPlotPhase;
};

/** Methods to use when ordering `AllocationPlotPhase`. */
export enum AllocationPlotPhasesOrderBy {
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  AllocationPlotByAllocationIdConflictsAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__CONFLICTS_ASC',
  AllocationPlotByAllocationIdConflictsDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__CONFLICTS_DESC',
  AllocationPlotByAllocationIdEndAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__END_ASC',
  AllocationPlotByAllocationIdEndDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__END_DESC',
  AllocationPlotByAllocationIdEventVariantIdAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__EVENT_VARIANT_ID_ASC',
  AllocationPlotByAllocationIdEventVariantIdDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__EVENT_VARIANT_ID_DESC',
  AllocationPlotByAllocationIdIdAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__ID_ASC',
  AllocationPlotByAllocationIdIdDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__ID_DESC',
  AllocationPlotByAllocationIdIsOptionalAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  AllocationPlotByAllocationIdIsOptionalDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  AllocationPlotByAllocationIdPlotIdAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__PLOT_ID_ASC',
  AllocationPlotByAllocationIdPlotIdDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__PLOT_ID_DESC',
  AllocationPlotByAllocationIdStartAsc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__START_ASC',
  AllocationPlotByAllocationIdStartDesc = 'ALLOCATION_PLOT_BY_ALLOCATION_ID__START_DESC',
  AllocationUsageByUsageIdColorAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__COLOR_ASC',
  AllocationUsageByUsageIdColorDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__COLOR_DESC',
  AllocationUsageByUsageIdDefaultDaysAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__DEFAULT_DAYS_ASC',
  AllocationUsageByUsageIdDefaultDaysDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__DEFAULT_DAYS_DESC',
  AllocationUsageByUsageIdDescriptionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__DESCRIPTION_ASC',
  AllocationUsageByUsageIdDescriptionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__DESCRIPTION_DESC',
  AllocationUsageByUsageIdIdAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  AllocationUsageByUsageIdIdDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  AllocationUsageByUsageIdIsExecutionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  AllocationUsageByUsageIdIsExecutionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  AllocationUsageByUsageIdNameAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  AllocationUsageByUsageIdNameDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  AllocationUsageByUsageIdNameShortAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  AllocationUsageByUsageIdNameShortDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  AllocationUsageByUsageIdPositionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  AllocationUsageByUsageIdPositionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  AllocationUsageByUsageIdTypeAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  AllocationUsageByUsageIdTypeDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** The `allocationPlot` to be created by this mutation. */
export type AllocationPlotPlotIdFkeyAllocationPlotCreateInput = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** Input for the nested mutation of `plot` in the `AllocationPlotInput` mutation. */
export type AllocationPlotPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationPlotPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `allocationPlot` in the `PlotInput` mutation. */
export type AllocationPlotPlotIdFkeyInverseInput = {
  /** The primary key(s) for `allocationPlot` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationPlotAllocationPlotPkeyConnect>>;
  /** A `AllocationPlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationPlotPlotIdFkeyAllocationPlotCreateInput>>;
  /** The primary key(s) for `allocationPlot` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationPlotAllocationPlotPkeyDelete>>;
  /** Flag indicating whether all other `allocationPlot` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationPlot` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationPlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingAllocationPlotPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type AllocationPlotPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `AllocationPlotPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationPlotToManyAllocationPlotPhaseFilter = {
  /** Every related `AllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationPlotPhaseFilter>;
  /** No related `AllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationPlotPhaseFilter>;
  /** Some related `AllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationPlotPhaseFilter>;
};

/** A connection to a list of `AllocationPlot` values. */
export type AllocationPlotsConnection = {
  __typename?: 'AllocationPlotsConnection';
  /** A list of edges which contains the `AllocationPlot` and cursor to aid in pagination. */
  edges: Array<AllocationPlotsEdge>;
  /** A list of `AllocationPlot` objects. */
  nodes: Array<AllocationPlot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationPlot` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationPlot` edge in the connection. */
export type AllocationPlotsEdge = {
  __typename?: 'AllocationPlotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationPlot` at the end of the edge. */
  node: AllocationPlot;
};

/** Methods to use when ordering `AllocationPlot`. */
export enum AllocationPlotsOrderBy {
  AllocationPlotPhasesByAllocationIdCountAsc = 'ALLOCATION_PLOT_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  AllocationPlotPhasesByAllocationIdCountDesc = 'ALLOCATION_PLOT_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  ConflictsAsc = 'CONFLICTS_ASC',
  ConflictsDesc = 'CONFLICTS_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  EventVariantByEventVariantIdChangesIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CHANGES_ID_ASC',
  EventVariantByEventVariantIdChangesIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CHANGES_ID_DESC',
  EventVariantByEventVariantIdCreatedAtAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CREATED_AT_ASC',
  EventVariantByEventVariantIdCreatedAtDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CREATED_AT_DESC',
  EventVariantByEventVariantIdDescriptionAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__DESCRIPTION_ASC',
  EventVariantByEventVariantIdDescriptionDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__DESCRIPTION_DESC',
  EventVariantByEventVariantIdEndAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__END_ASC',
  EventVariantByEventVariantIdEndDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__END_DESC',
  EventVariantByEventVariantIdEventIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__EVENT_ID_ASC',
  EventVariantByEventVariantIdEventIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__EVENT_ID_DESC',
  EventVariantByEventVariantIdIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__ID_ASC',
  EventVariantByEventVariantIdIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__ID_DESC',
  EventVariantByEventVariantIdIndexAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__INDEX_ASC',
  EventVariantByEventVariantIdIndexDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__INDEX_DESC',
  EventVariantByEventVariantIdIsArchivedAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_ARCHIVED_ASC',
  EventVariantByEventVariantIdIsArchivedDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_ARCHIVED_DESC',
  EventVariantByEventVariantIdIsCurrentAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_CURRENT_ASC',
  EventVariantByEventVariantIdIsCurrentDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_CURRENT_DESC',
  EventVariantByEventVariantIdNameAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__NAME_ASC',
  EventVariantByEventVariantIdNameDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__NAME_DESC',
  EventVariantByEventVariantIdReferenceAllocationAreaIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_AREA_ID_ASC',
  EventVariantByEventVariantIdReferenceAllocationAreaIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_AREA_ID_DESC',
  EventVariantByEventVariantIdReferenceAllocationRoomIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_ROOM_ID_ASC',
  EventVariantByEventVariantIdReferenceAllocationRoomIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_ROOM_ID_DESC',
  EventVariantByEventVariantIdStartAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__START_ASC',
  EventVariantByEventVariantIdStartDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__START_DESC',
  EventVariantByEventVariantIdStatusAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__STATUS_ASC',
  EventVariantByEventVariantIdStatusDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__STATUS_DESC',
  EventVariantByEventVariantIdVersionAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__VERSION_ASC',
  EventVariantByEventVariantIdVersionDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__VERSION_DESC',
  EventVariantIdAsc = 'EVENT_VARIANT_ID_ASC',
  EventVariantIdDesc = 'EVENT_VARIANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

export type AllocationRoom = {
  __typename?: 'AllocationRoom';
  /** Reads and enables pagination through a set of `AllocationRoomPhase`. */
  allocationRoomPhasesByAllocationId: AllocationRoomPhasesConnection;
  conflicts: Scalars['Int'];
  end: Scalars['Datetime'];
  /** Reads a single `EventVariant` that is related to this `AllocationRoom`. */
  eventVariant: EventVariant;
  eventVariantId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `EventVariant`. */
  eventVariantsByReferenceAllocationRoomId: EventVariantsConnection;
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  /** Reads a single `Room` that is related to this `AllocationRoom`. */
  room: Room;
  roomId: Scalars['UUID'];
  start: Scalars['Datetime'];
};


export type AllocationRoomAllocationRoomPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationRoomPhaseCondition>;
  filter?: InputMaybe<AllocationRoomPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationRoomPhasesOrderBy>>;
};


export type AllocationRoomEventVariantsByReferenceAllocationRoomIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventVariantCondition>;
  filter?: InputMaybe<EventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** The fields on `allocationRoom` to look up the row to connect. */
export type AllocationRoomAllocationRoomPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationRoom` to look up the row to delete. */
export type AllocationRoomAllocationRoomPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AllocationRoom` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllocationRoomCondition = {
  /** Checks for equality with the object’s `conflicts` field. */
  conflicts?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `eventVariantId` field. */
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** All input for the `allocationRoomDuplicate` mutation. */
export type AllocationRoomDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The output of our `allocationRoomDuplicate` mutation. */
export type AllocationRoomDuplicatePayload = {
  __typename?: 'AllocationRoomDuplicatePayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our `allocationRoomDuplicate` mutation. */
export type AllocationRoomDuplicatePayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** The `allocationRoom` to be created by this mutation. */
export type AllocationRoomEventVariantIdFkeyAllocationRoomCreateInput = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `eventVariant` to be created by this mutation. */
export type AllocationRoomEventVariantIdFkeyEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `eventVariant` in the `AllocationRoomInput` mutation. */
export type AllocationRoomEventVariantIdFkeyInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<EventVariantEventVariantEventIdIndexKeyConnect>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<EventVariantEventVariantPkeyConnect>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationRoomEventVariantIdFkeyEventVariantCreateInput>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<EventVariantEventVariantEventIdIndexKeyDelete>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<EventVariantEventVariantPkeyDelete>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<EventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyUsingEventVariantEventIdIndexKeyUpdate>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<EventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyUsingEventVariantPkeyUpdate>;
};

/** Input for the nested mutation of `allocationRoom` in the `EventVariantInput` mutation. */
export type AllocationRoomEventVariantIdFkeyInverseInput = {
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationRoomAllocationRoomPkeyConnect>>;
  /** A `AllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationRoomEventVariantIdFkeyAllocationRoomCreateInput>>;
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationRoomAllocationRoomPkeyDelete>>;
  /** Flag indicating whether all other `allocationRoom` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationRoomOnAllocationRoomForAllocationRoomEventVariantIdFkeyUsingAllocationRoomPkeyUpdate>>;
};

/** A filter to be used against `AllocationRoom` object types. All fields are combined with a logical ‘and.’ */
export type AllocationRoomFilter = {
  /** Filter by the object’s `allocationRoomPhasesByAllocationId` relation. */
  allocationRoomPhasesByAllocationId?: InputMaybe<AllocationRoomToManyAllocationRoomPhaseFilter>;
  /** Some related `allocationRoomPhasesByAllocationId` exist. */
  allocationRoomPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationRoomFilter>>;
  /** Filter by the object’s `conflicts` field. */
  conflicts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventVariant` relation. */
  eventVariant?: InputMaybe<EventVariantFilter>;
  /** Filter by the object’s `eventVariantId` field. */
  eventVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `eventVariantsByReferenceAllocationRoomId` relation. */
  eventVariantsByReferenceAllocationRoomId?: InputMaybe<AllocationRoomToManyEventVariantFilter>;
  /** Some related `eventVariantsByReferenceAllocationRoomId` exist. */
  eventVariantsByReferenceAllocationRoomIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationRoomFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationRoomFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AllocationRoom` */
export type AllocationRoomInput = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The fields on `allocationRoom` to look up the row to update. */
export type AllocationRoomOnAllocationRoomForAllocationRoomEventVariantIdFkeyUsingAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationRoom` being updated. */
  patch: UpdateAllocationRoomOnAllocationRoomForAllocationRoomEventVariantIdFkeyPatch;
};

/** The fields on `allocationRoom` to look up the row to update. */
export type AllocationRoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationRoom` being updated. */
  patch: UpdateAllocationRoomOnAllocationRoomForAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `allocationRoom` to look up the row to update. */
export type AllocationRoomOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationRoom` being updated. */
  patch: UpdateAllocationRoomOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyPatch;
};

/** The fields on `allocationRoom` to look up the row to update. */
export type AllocationRoomOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFUsingAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationRoom` being updated. */
  patch: UpdateAllocationRoomOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFPatch;
};

/** Represents an update to a `AllocationRoom`. Fields that are set will be updated. */
export type AllocationRoomPatch = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type AllocationRoomPhase = {
  __typename?: 'AllocationRoomPhase';
  /** Reads a single `AllocationRoom` that is related to this `AllocationRoomPhase`. */
  allocation: AllocationRoom;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `AllocationUsage` that is related to this `AllocationRoomPhase`. */
  usage: AllocationUsage;
  usageId: Scalars['UUID'];
};

/** The `allocationRoom` to be created by this mutation. */
export type AllocationRoomPhaseAllocationIdFkeyAllocationRoomCreateInput = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `allocationRoomPhase` to be created by this mutation. */
export type AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput = {
  allocationRoomToAllocationId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `allocationRoom` in the `AllocationRoomPhaseInput` mutation. */
export type AllocationRoomPhaseAllocationIdFkeyInput = {
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationRoomAllocationRoomPkeyConnect>;
  /** A `AllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyAllocationRoomCreateInput>;
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationRoomAllocationRoomPkeyDelete>;
  /** The primary key(s) and patch data for `allocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationRoomOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPkeyUpdate>;
};

/** Input for the nested mutation of `allocationRoomPhase` in the `AllocationRoomInput` mutation. */
export type AllocationRoomPhaseAllocationIdFkeyInverseInput = {
  /** The primary key(s) for `allocationRoomPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationRoomPhaseAllocationRoomPhasePkeyConnect>>;
  /** A `AllocationRoomPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput>>;
  /** The primary key(s) for `allocationRoomPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationRoomPhaseAllocationRoomPhasePkeyDelete>>;
  /** Flag indicating whether all other `allocationRoomPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationRoomPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPhasePkeyUpdate>>;
};

/** The fields on `allocationRoomPhase` to look up the row to connect. */
export type AllocationRoomPhaseAllocationRoomPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationRoomPhase` to look up the row to delete. */
export type AllocationRoomPhaseAllocationRoomPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AllocationRoomPhase` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AllocationRoomPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `AllocationRoomPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationRoomPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<AllocationRoomFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationRoomPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationRoomPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationRoomPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<AllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `AllocationRoomPhase` */
export type AllocationRoomPhaseInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationRoomToAllocationId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `allocationRoomPhase` to look up the row to update. */
export type AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationRoomPhase` being updated. */
  patch: UpdateAllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyPatch;
};

/** The fields on `allocationRoomPhase` to look up the row to update. */
export type AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationRoomPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationRoomPhase` being updated. */
  patch: UpdateAllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch;
};

/** Represents an update to a `AllocationRoomPhase`. Fields that are set will be updated. */
export type AllocationRoomPhasePatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationRoomToAllocationId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The `allocationRoomPhase` to be created by this mutation. */
export type AllocationRoomPhaseUsageIdFkeyAllocationRoomPhaseCreateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationRoomToAllocationId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInput>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `allocationUsage` to be created by this mutation. */
export type AllocationRoomPhaseUsageIdFkeyAllocationUsageCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: AllocationUsageType;
};

/** Input for the nested mutation of `allocationUsage` in the `AllocationRoomPhaseInput` mutation. */
export type AllocationRoomPhaseUsageIdFkeyInput = {
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationUsageAllocationUsagePkeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<AllocationUsageAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AllocationUsageAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<AllocationUsageAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<AllocationUsageAllocationUsageTypeKeyConnect>;
  /** A `AllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationRoomPhaseUsageIdFkeyAllocationUsageCreateInput>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationUsageAllocationUsagePkeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<AllocationUsageAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AllocationUsageAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<AllocationUsageAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `allocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<AllocationUsageAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `allocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `allocationRoomPhase` in the `AllocationUsageInput` mutation. */
export type AllocationRoomPhaseUsageIdFkeyInverseInput = {
  /** The primary key(s) for `allocationRoomPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationRoomPhaseAllocationRoomPhasePkeyConnect>>;
  /** A `AllocationRoomPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationRoomPhaseUsageIdFkeyAllocationRoomPhaseCreateInput>>;
  /** The primary key(s) for `allocationRoomPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationRoomPhaseAllocationRoomPhasePkeyDelete>>;
  /** Flag indicating whether all other `allocationRoomPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationRoomPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationRoomPhasePkeyUpdate>>;
};

/** A connection to a list of `AllocationRoomPhase` values. */
export type AllocationRoomPhasesConnection = {
  __typename?: 'AllocationRoomPhasesConnection';
  /** A list of edges which contains the `AllocationRoomPhase` and cursor to aid in pagination. */
  edges: Array<AllocationRoomPhasesEdge>;
  /** A list of `AllocationRoomPhase` objects. */
  nodes: Array<AllocationRoomPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationRoomPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationRoomPhase` edge in the connection. */
export type AllocationRoomPhasesEdge = {
  __typename?: 'AllocationRoomPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationRoomPhase` at the end of the edge. */
  node: AllocationRoomPhase;
};

/** Methods to use when ordering `AllocationRoomPhase`. */
export enum AllocationRoomPhasesOrderBy {
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  AllocationRoomByAllocationIdConflictsAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__CONFLICTS_ASC',
  AllocationRoomByAllocationIdConflictsDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__CONFLICTS_DESC',
  AllocationRoomByAllocationIdEndAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__END_ASC',
  AllocationRoomByAllocationIdEndDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__END_DESC',
  AllocationRoomByAllocationIdEventVariantIdAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__EVENT_VARIANT_ID_ASC',
  AllocationRoomByAllocationIdEventVariantIdDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__EVENT_VARIANT_ID_DESC',
  AllocationRoomByAllocationIdIdAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__ID_ASC',
  AllocationRoomByAllocationIdIdDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__ID_DESC',
  AllocationRoomByAllocationIdIsOptionalAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  AllocationRoomByAllocationIdIsOptionalDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  AllocationRoomByAllocationIdRoomIdAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__ROOM_ID_ASC',
  AllocationRoomByAllocationIdRoomIdDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__ROOM_ID_DESC',
  AllocationRoomByAllocationIdStartAsc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__START_ASC',
  AllocationRoomByAllocationIdStartDesc = 'ALLOCATION_ROOM_BY_ALLOCATION_ID__START_DESC',
  AllocationUsageByUsageIdColorAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__COLOR_ASC',
  AllocationUsageByUsageIdColorDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__COLOR_DESC',
  AllocationUsageByUsageIdDefaultDaysAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__DEFAULT_DAYS_ASC',
  AllocationUsageByUsageIdDefaultDaysDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__DEFAULT_DAYS_DESC',
  AllocationUsageByUsageIdDescriptionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__DESCRIPTION_ASC',
  AllocationUsageByUsageIdDescriptionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__DESCRIPTION_DESC',
  AllocationUsageByUsageIdIdAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  AllocationUsageByUsageIdIdDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  AllocationUsageByUsageIdIsExecutionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  AllocationUsageByUsageIdIsExecutionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  AllocationUsageByUsageIdNameAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  AllocationUsageByUsageIdNameDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  AllocationUsageByUsageIdNameShortAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  AllocationUsageByUsageIdNameShortDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  AllocationUsageByUsageIdPositionAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  AllocationUsageByUsageIdPositionDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  AllocationUsageByUsageIdTypeAsc = 'ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  AllocationUsageByUsageIdTypeDesc = 'ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** The `allocationRoom` to be created by this mutation. */
export type AllocationRoomRoomIdFkeyAllocationRoomCreateInput = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** Input for the nested mutation of `room` in the `AllocationRoomInput` mutation. */
export type AllocationRoomRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<AllocationRoomRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `allocationRoom` in the `RoomInput` mutation. */
export type AllocationRoomRoomIdFkeyInverseInput = {
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AllocationRoomAllocationRoomPkeyConnect>>;
  /** A `AllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AllocationRoomRoomIdFkeyAllocationRoomCreateInput>>;
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AllocationRoomAllocationRoomPkeyDelete>>;
  /** Flag indicating whether all other `allocationRoom` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `allocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AllocationRoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingAllocationRoomPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type AllocationRoomRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `AllocationRoomPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationRoomToManyAllocationRoomPhaseFilter = {
  /** Every related `AllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationRoomPhaseFilter>;
  /** No related `AllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationRoomPhaseFilter>;
  /** Some related `AllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationRoomPhaseFilter>;
};

/** A filter to be used against many `EventVariant` object types. All fields are combined with a logical ‘and.’ */
export type AllocationRoomToManyEventVariantFilter = {
  /** Every related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventVariantFilter>;
  /** No related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventVariantFilter>;
  /** Some related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventVariantFilter>;
};

/** All input for the `allocationRoomUpdateAndDuplicate` mutation. */
export type AllocationRoomUpdateAndDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  updateAllocation?: InputMaybe<AllocationUpdateInput>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>>>;
};

/** The output of our `allocationRoomUpdateAndDuplicate` mutation. */
export type AllocationRoomUpdateAndDuplicatePayload = {
  __typename?: 'AllocationRoomUpdateAndDuplicatePayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our `allocationRoomUpdateAndDuplicate` mutation. */
export type AllocationRoomUpdateAndDuplicatePayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** A connection to a list of `AllocationRoom` values. */
export type AllocationRoomsConnection = {
  __typename?: 'AllocationRoomsConnection';
  /** A list of edges which contains the `AllocationRoom` and cursor to aid in pagination. */
  edges: Array<AllocationRoomsEdge>;
  /** A list of `AllocationRoom` objects. */
  nodes: Array<AllocationRoom>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationRoom` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationRoom` edge in the connection. */
export type AllocationRoomsEdge = {
  __typename?: 'AllocationRoomsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationRoom` at the end of the edge. */
  node: AllocationRoom;
};

/** Methods to use when ordering `AllocationRoom`. */
export enum AllocationRoomsOrderBy {
  AllocationRoomPhasesByAllocationIdCountAsc = 'ALLOCATION_ROOM_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  AllocationRoomPhasesByAllocationIdCountDesc = 'ALLOCATION_ROOM_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  ConflictsAsc = 'CONFLICTS_ASC',
  ConflictsDesc = 'CONFLICTS_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  EventVariantsByReferenceAllocationRoomIdCountAsc = 'EVENT_VARIANTS_BY_REFERENCE_ALLOCATION_ROOM_ID__COUNT_ASC',
  EventVariantsByReferenceAllocationRoomIdCountDesc = 'EVENT_VARIANTS_BY_REFERENCE_ALLOCATION_ROOM_ID__COUNT_DESC',
  EventVariantByEventVariantIdChangesIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CHANGES_ID_ASC',
  EventVariantByEventVariantIdChangesIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CHANGES_ID_DESC',
  EventVariantByEventVariantIdCreatedAtAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CREATED_AT_ASC',
  EventVariantByEventVariantIdCreatedAtDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__CREATED_AT_DESC',
  EventVariantByEventVariantIdDescriptionAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__DESCRIPTION_ASC',
  EventVariantByEventVariantIdDescriptionDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__DESCRIPTION_DESC',
  EventVariantByEventVariantIdEndAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__END_ASC',
  EventVariantByEventVariantIdEndDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__END_DESC',
  EventVariantByEventVariantIdEventIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__EVENT_ID_ASC',
  EventVariantByEventVariantIdEventIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__EVENT_ID_DESC',
  EventVariantByEventVariantIdIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__ID_ASC',
  EventVariantByEventVariantIdIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__ID_DESC',
  EventVariantByEventVariantIdIndexAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__INDEX_ASC',
  EventVariantByEventVariantIdIndexDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__INDEX_DESC',
  EventVariantByEventVariantIdIsArchivedAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_ARCHIVED_ASC',
  EventVariantByEventVariantIdIsArchivedDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_ARCHIVED_DESC',
  EventVariantByEventVariantIdIsCurrentAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_CURRENT_ASC',
  EventVariantByEventVariantIdIsCurrentDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__IS_CURRENT_DESC',
  EventVariantByEventVariantIdNameAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__NAME_ASC',
  EventVariantByEventVariantIdNameDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__NAME_DESC',
  EventVariantByEventVariantIdReferenceAllocationAreaIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_AREA_ID_ASC',
  EventVariantByEventVariantIdReferenceAllocationAreaIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_AREA_ID_DESC',
  EventVariantByEventVariantIdReferenceAllocationRoomIdAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_ROOM_ID_ASC',
  EventVariantByEventVariantIdReferenceAllocationRoomIdDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__REFERENCE_ALLOCATION_ROOM_ID_DESC',
  EventVariantByEventVariantIdStartAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__START_ASC',
  EventVariantByEventVariantIdStartDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__START_DESC',
  EventVariantByEventVariantIdStatusAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__STATUS_ASC',
  EventVariantByEventVariantIdStatusDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__STATUS_DESC',
  EventVariantByEventVariantIdVersionAsc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__VERSION_ASC',
  EventVariantByEventVariantIdVersionDesc = 'EVENT_VARIANT_BY_EVENT_VARIANT_ID__VERSION_DESC',
  EventVariantIdAsc = 'EVENT_VARIANT_ID_ASC',
  EventVariantIdDesc = 'EVENT_VARIANT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/** An input for mutations affecting `AllocationUpdate` */
export type AllocationUpdateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type AllocationUsage = {
  __typename?: 'AllocationUsage';
  /** Reads and enables pagination through a set of `AllocationAreaPhase`. */
  allocationAreaPhasesByUsageId: AllocationAreaPhasesConnection;
  /** Reads and enables pagination through a set of `AllocationPlotPhase`. */
  allocationPlotPhasesByUsageId: AllocationPlotPhasesConnection;
  /** Reads and enables pagination through a set of `AllocationRoomPhase`. */
  allocationRoomPhasesByUsageId: AllocationRoomPhasesConnection;
  color: Scalars['String'];
  defaultDays?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  isExecution: Scalars['Boolean'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: AllocationUsageType;
};


export type AllocationUsageAllocationAreaPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationAreaPhaseCondition>;
  filter?: InputMaybe<AllocationAreaPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationAreaPhasesOrderBy>>;
};


export type AllocationUsageAllocationPlotPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationPlotPhaseCondition>;
  filter?: InputMaybe<AllocationPlotPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationPlotPhasesOrderBy>>;
};


export type AllocationUsageAllocationRoomPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationRoomPhaseCondition>;
  filter?: InputMaybe<AllocationRoomPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationRoomPhasesOrderBy>>;
};

/** The fields on `allocationUsage` to look up the row to connect. */
export type AllocationUsageAllocationUsageNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `allocationUsage` to look up the row to delete. */
export type AllocationUsageAllocationUsageNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `allocationUsage` to look up the row to connect. */
export type AllocationUsageAllocationUsageNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `allocationUsage` to look up the row to delete. */
export type AllocationUsageAllocationUsageNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `allocationUsage` to look up the row to connect. */
export type AllocationUsageAllocationUsagePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `allocationUsage` to look up the row to delete. */
export type AllocationUsageAllocationUsagePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `allocationUsage` to look up the row to connect. */
export type AllocationUsageAllocationUsagePositionKeyConnect = {
  position: Scalars['Int'];
};

/** The fields on `allocationUsage` to look up the row to delete. */
export type AllocationUsageAllocationUsagePositionKeyDelete = {
  position: Scalars['Int'];
};

/** The fields on `allocationUsage` to look up the row to connect. */
export type AllocationUsageAllocationUsageTypeKeyConnect = {
  type: AllocationUsageType;
};

/** The fields on `allocationUsage` to look up the row to delete. */
export type AllocationUsageAllocationUsageTypeKeyDelete = {
  type: AllocationUsageType;
};

/**
 * A condition to be used against `AllocationUsage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllocationUsageCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `defaultDays` field. */
  defaultDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isExecution` field. */
  isExecution?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AllocationUsageType>;
};

/** A filter to be used against `AllocationUsage` object types. All fields are combined with a logical ‘and.’ */
export type AllocationUsageFilter = {
  /** Filter by the object’s `allocationAreaPhasesByUsageId` relation. */
  allocationAreaPhasesByUsageId?: InputMaybe<AllocationUsageToManyAllocationAreaPhaseFilter>;
  /** Some related `allocationAreaPhasesByUsageId` exist. */
  allocationAreaPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `allocationPlotPhasesByUsageId` relation. */
  allocationPlotPhasesByUsageId?: InputMaybe<AllocationUsageToManyAllocationPlotPhaseFilter>;
  /** Some related `allocationPlotPhasesByUsageId` exist. */
  allocationPlotPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `allocationRoomPhasesByUsageId` relation. */
  allocationRoomPhasesByUsageId?: InputMaybe<AllocationUsageToManyAllocationRoomPhaseFilter>;
  /** Some related `allocationRoomPhasesByUsageId` exist. */
  allocationRoomPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllocationUsageFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultDays` field. */
  defaultDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isExecution` field. */
  isExecution?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AllocationUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllocationUsageFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AllocationUsageTypeFilter>;
};

/** An input for mutations affecting `AllocationUsage` */
export type AllocationUsageInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: AllocationUsageType;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch;
  position: Scalars['Int'];
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyUsingAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch;
  type: AllocationUsageType;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch;
  position: Scalars['Int'];
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyUsingAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch;
  type: AllocationUsageType;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch;
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch;
  position: Scalars['Int'];
};

/** The fields on `allocationUsage` to look up the row to update. */
export type AllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyUsingAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `allocationUsage` being updated. */
  patch: UpdateAllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch;
  type: AllocationUsageType;
};

/** Represents an update to a `AllocationUsage`. Fields that are set will be updated. */
export type AllocationUsagePatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AllocationUsageType>;
};

/** A filter to be used against many `AllocationAreaPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationUsageToManyAllocationAreaPhaseFilter = {
  /** Every related `AllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationAreaPhaseFilter>;
  /** No related `AllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationAreaPhaseFilter>;
  /** Some related `AllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationAreaPhaseFilter>;
};

/** A filter to be used against many `AllocationPlotPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationUsageToManyAllocationPlotPhaseFilter = {
  /** Every related `AllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationPlotPhaseFilter>;
  /** No related `AllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationPlotPhaseFilter>;
  /** Some related `AllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationPlotPhaseFilter>;
};

/** A filter to be used against many `AllocationRoomPhase` object types. All fields are combined with a logical ‘and.’ */
export type AllocationUsageToManyAllocationRoomPhaseFilter = {
  /** Every related `AllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationRoomPhaseFilter>;
  /** No related `AllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationRoomPhaseFilter>;
  /** Some related `AllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationRoomPhaseFilter>;
};

export enum AllocationUsageType {
  EarlySetUp = 'Early_Set_Up',
  ExtendedBreakdown = 'Extended_Breakdown',
  ExtendedTechnicalBreakdown = 'Extended_Technical_Breakdown',
  ExtendedTechnicalSetUp = 'Extended_Technical_Set_Up',
  RegularBreakdown = 'Regular_Breakdown',
  RegularSetUp = 'Regular_Set_Up',
  ShowDays = 'Show_Days',
  TechnicalBreakdown = 'Technical_Breakdown',
  TechnicalSetUp = 'Technical_Set_Up'
}

/** A filter to be used against AllocationUsageType fields. All fields are combined with a logical ‘and.’ */
export type AllocationUsageTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AllocationUsageType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AllocationUsageType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AllocationUsageType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AllocationUsageType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AllocationUsageType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AllocationUsageType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AllocationUsageType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AllocationUsageType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AllocationUsageType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AllocationUsageType>>;
};

/** A connection to a list of `AllocationUsage` values. */
export type AllocationUsagesConnection = {
  __typename?: 'AllocationUsagesConnection';
  /** A list of edges which contains the `AllocationUsage` and cursor to aid in pagination. */
  edges: Array<AllocationUsagesEdge>;
  /** A list of `AllocationUsage` objects. */
  nodes: Array<AllocationUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllocationUsage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllocationUsage` edge in the connection. */
export type AllocationUsagesEdge = {
  __typename?: 'AllocationUsagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllocationUsage` at the end of the edge. */
  node: AllocationUsage;
};

/** Methods to use when ordering `AllocationUsage`. */
export enum AllocationUsagesOrderBy {
  AllocationAreaPhasesByUsageIdCountAsc = 'ALLOCATION_AREA_PHASES_BY_USAGE_ID__COUNT_ASC',
  AllocationAreaPhasesByUsageIdCountDesc = 'ALLOCATION_AREA_PHASES_BY_USAGE_ID__COUNT_DESC',
  AllocationPlotPhasesByUsageIdCountAsc = 'ALLOCATION_PLOT_PHASES_BY_USAGE_ID__COUNT_ASC',
  AllocationPlotPhasesByUsageIdCountDesc = 'ALLOCATION_PLOT_PHASES_BY_USAGE_ID__COUNT_DESC',
  AllocationRoomPhasesByUsageIdCountAsc = 'ALLOCATION_ROOM_PHASES_BY_USAGE_ID__COUNT_ASC',
  AllocationRoomPhasesByUsageIdCountDesc = 'ALLOCATION_ROOM_PHASES_BY_USAGE_ID__COUNT_DESC',
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  DefaultDaysAsc = 'DEFAULT_DAYS_ASC',
  DefaultDaysDesc = 'DEFAULT_DAYS_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsExecutionAsc = 'IS_EXECUTION_ASC',
  IsExecutionDesc = 'IS_EXECUTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type AlreadyHasPasswordLogin = {
  __typename?: 'AlreadyHasPasswordLogin';
  message: Scalars['String'];
};

export type AlreadyLinked = {
  __typename?: 'AlreadyLinked';
  message: Scalars['String'];
};

export type Area = {
  __typename?: 'Area';
  /** Reads and enables pagination through a set of `AllocationArea`. */
  allocationAreas: AllocationAreasConnection;
  /** Reads and enables pagination through a set of `AreaCadGrossSpaceMin`. */
  areaCadGrossSpaceMins: AreaCadGrossSpaceMinsConnection;
  /** Reads and enables pagination through a set of `AreaClearanceConstruction`. */
  areaClearanceConstructions: AreaClearanceConstructionsConnection;
  /** Reads and enables pagination through a set of `AreaContactBooking`. */
  areaContactBookings: AreaContactBookingsConnection;
  /** Reads and enables pagination through a set of `AreaDescription`. */
  areaDescriptions: AreaDescriptionsConnection;
  /** Reads and enables pagination through a set of `AreaKeyIssuanceNote`. */
  areaKeyIssuanceNotes: AreaKeyIssuanceNotesConnection;
  /** Reads and enables pagination through a set of `AreaKeyIssuance`. */
  areaKeyIssuances: AreaKeyIssuancesConnection;
  /** Reads and enables pagination through a set of `AreaNameExtra`. */
  areaNameExtras: AreaNameExtrasConnection;
  /** Reads and enables pagination through a set of `AreaNameKeyCad`. */
  areaNameKeyCads: AreaNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `AreaNameKeyCafm`. */
  areaNameKeyCafms: AreaNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `AreaNameKeyEbm`. */
  areaNameKeyEbms: AreaNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `AreaNameKeyMarketing`. */
  areaNameKeyMarketings: AreaNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `AreaNameLong`. */
  areaNameLongs: AreaNameLongsConnection;
  /** Reads and enables pagination through a set of `AreaNameShort`. */
  areaNameShorts: AreaNameShortsConnection;
  /** Reads and enables pagination through a set of `AreaPublicGrossSpace`. */
  areaPublicGrossSpaces: AreaPublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `AreaTypeAttr`. */
  areaTypeAttrs: AreaTypeAttrsConnection;
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads and enables pagination through a set of `Plot`. */
  plots: PlotsConnection;
  /** Reads and enables pagination through a set of `ProjectAllocationArea`. */
  projectAllocationAreas: ProjectAllocationAreasConnection;
  /** Reads a single `AreaType` that is related to this `Area`. */
  type?: Maybe<AreaType>;
  typeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Zone` that is related to this `Area`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};


export type AreaAllocationAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationAreaCondition>;
  filter?: InputMaybe<AllocationAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationAreasOrderBy>>;
};


export type AreaAreaCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaCadGrossSpaceMinCondition>;
  filter?: InputMaybe<AreaCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaCadGrossSpaceMinsOrderBy>>;
};


export type AreaAreaClearanceConstructionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaClearanceConstructionCondition>;
  filter?: InputMaybe<AreaClearanceConstructionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaClearanceConstructionsOrderBy>>;
};


export type AreaAreaContactBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaContactBookingCondition>;
  filter?: InputMaybe<AreaContactBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaContactBookingsOrderBy>>;
};


export type AreaAreaDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaDescriptionCondition>;
  filter?: InputMaybe<AreaDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaDescriptionsOrderBy>>;
};


export type AreaAreaKeyIssuanceNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaKeyIssuanceNoteCondition>;
  filter?: InputMaybe<AreaKeyIssuanceNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaKeyIssuanceNotesOrderBy>>;
};


export type AreaAreaKeyIssuancesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaKeyIssuanceCondition>;
  filter?: InputMaybe<AreaKeyIssuanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaKeyIssuancesOrderBy>>;
};


export type AreaAreaNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameExtraCondition>;
  filter?: InputMaybe<AreaNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameExtrasOrderBy>>;
};


export type AreaAreaNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyCadCondition>;
  filter?: InputMaybe<AreaNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyCadsOrderBy>>;
};


export type AreaAreaNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyCafmCondition>;
  filter?: InputMaybe<AreaNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyCafmsOrderBy>>;
};


export type AreaAreaNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyEbmCondition>;
  filter?: InputMaybe<AreaNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyEbmsOrderBy>>;
};


export type AreaAreaNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyMarketingCondition>;
  filter?: InputMaybe<AreaNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyMarketingsOrderBy>>;
};


export type AreaAreaNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameLongCondition>;
  filter?: InputMaybe<AreaNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameLongsOrderBy>>;
};


export type AreaAreaNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameShortCondition>;
  filter?: InputMaybe<AreaNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameShortsOrderBy>>;
};


export type AreaAreaPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaPublicGrossSpaceCondition>;
  filter?: InputMaybe<AreaPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaPublicGrossSpacesOrderBy>>;
};


export type AreaAreaTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaTypeAttrCondition>;
  filter?: InputMaybe<AreaTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaTypeAttrsOrderBy>>;
};


export type AreaPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotCondition>;
  filter?: InputMaybe<PlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotsOrderBy>>;
};


export type AreaProjectAllocationAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationAreaCondition>;
  filter?: InputMaybe<ProjectAllocationAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationAreasOrderBy>>;
};

/** The fields on `area` to look up the row to connect. */
export type AreaAreaExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `area` to look up the row to delete. */
export type AreaAreaExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `area` to look up the row to connect. */
export type AreaAreaNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `area` to look up the row to delete. */
export type AreaAreaNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `area` to look up the row to connect. */
export type AreaAreaPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `area` to look up the row to delete. */
export type AreaAreaPkeyDelete = {
  id: Scalars['UUID'];
};

export type AreaCadGrossSpaceMin = {
  __typename?: 'AreaCadGrossSpaceMin';
  /** Reads a single `Area` that is related to this `AreaCadGrossSpaceMin`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `areaCadGrossSpaceMin` to look up the row to connect. */
export type AreaCadGrossSpaceMinAreaCadGrossSpaceMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaCadGrossSpaceMin` to look up the row to delete. */
export type AreaCadGrossSpaceMinAreaCadGrossSpaceMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `areaCadGrossSpaceMin` to be created by this mutation. */
export type AreaCadGrossSpaceMinAreaIdFkeyAreaCadGrossSpaceMinCreateInput = {
  areaToAreaId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `area` to be created by this mutation. */
export type AreaCadGrossSpaceMinAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `area` in the `AreaCadGrossSpaceMinInput` mutation. */
export type AreaCadGrossSpaceMinAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaCadGrossSpaceMin` in the `AreaInput` mutation. */
export type AreaCadGrossSpaceMinAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaCadGrossSpaceMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaCadGrossSpaceMinAreaCadGrossSpaceMinPkeyConnect>>;
  /** A `AreaCadGrossSpaceMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaCadGrossSpaceMinAreaIdFkeyAreaCadGrossSpaceMinCreateInput>>;
  /** The primary key(s) for `areaCadGrossSpaceMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaCadGrossSpaceMinAreaCadGrossSpaceMinPkeyDelete>>;
  /** Flag indicating whether all other `areaCadGrossSpaceMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaCadGrossSpaceMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaCadGrossSpaceMinOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaCadGrossSpaceMinPkeyUpdate>>;
};

/**
 * A condition to be used against `AreaCadGrossSpaceMin` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AreaCadGrossSpaceMinCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `AreaCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type AreaCadGrossSpaceMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaCadGrossSpaceMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `AreaCadGrossSpaceMin` */
export type AreaCadGrossSpaceMinInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `areaCadGrossSpaceMin` to look up the row to update. */
export type AreaCadGrossSpaceMinOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaCadGrossSpaceMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaCadGrossSpaceMin` being updated. */
  patch: UpdateAreaCadGrossSpaceMinOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyPatch;
};

/** Represents an update to a `AreaCadGrossSpaceMin`. Fields that are set will be updated. */
export type AreaCadGrossSpaceMinPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `AreaCadGrossSpaceMin` values. */
export type AreaCadGrossSpaceMinsConnection = {
  __typename?: 'AreaCadGrossSpaceMinsConnection';
  /** A list of edges which contains the `AreaCadGrossSpaceMin` and cursor to aid in pagination. */
  edges: Array<AreaCadGrossSpaceMinsEdge>;
  /** A list of `AreaCadGrossSpaceMin` objects. */
  nodes: Array<AreaCadGrossSpaceMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaCadGrossSpaceMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaCadGrossSpaceMin` edge in the connection. */
export type AreaCadGrossSpaceMinsEdge = {
  __typename?: 'AreaCadGrossSpaceMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaCadGrossSpaceMin` at the end of the edge. */
  node: AreaCadGrossSpaceMin;
};

/** Methods to use when ordering `AreaCadGrossSpaceMin`. */
export enum AreaCadGrossSpaceMinsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaClearanceConstruction = {
  __typename?: 'AreaClearanceConstruction';
  /** Reads a single `Area` that is related to this `AreaClearanceConstruction`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaClearanceConstruction` to look up the row to connect. */
export type AreaClearanceConstructionAreaClearanceConstructionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaClearanceConstruction` to look up the row to delete. */
export type AreaClearanceConstructionAreaClearanceConstructionPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `areaClearanceConstruction` to be created by this mutation. */
export type AreaClearanceConstructionAreaIdFkeyAreaClearanceConstructionCreateInput = {
  areaToAreaId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaClearanceConstructionAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `area` in the `AreaClearanceConstructionInput` mutation. */
export type AreaClearanceConstructionAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaClearanceConstructionAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaClearanceConstruction` in the `AreaInput` mutation. */
export type AreaClearanceConstructionAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaClearanceConstruction` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaClearanceConstructionAreaClearanceConstructionPkeyConnect>>;
  /** A `AreaClearanceConstructionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaClearanceConstructionAreaIdFkeyAreaClearanceConstructionCreateInput>>;
  /** The primary key(s) for `areaClearanceConstruction` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaClearanceConstructionAreaClearanceConstructionPkeyDelete>>;
  /** Flag indicating whether all other `areaClearanceConstruction` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaClearanceConstruction` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaClearanceConstructionOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaClearanceConstructionPkeyUpdate>>;
};

/**
 * A condition to be used against `AreaClearanceConstruction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AreaClearanceConstructionCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaClearanceConstruction` object types. All fields are combined with a logical ‘and.’ */
export type AreaClearanceConstructionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaClearanceConstructionFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaClearanceConstructionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaClearanceConstructionFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaClearanceConstruction` */
export type AreaClearanceConstructionInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaClearanceConstruction` to look up the row to update. */
export type AreaClearanceConstructionOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaClearanceConstructionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaClearanceConstruction` being updated. */
  patch: UpdateAreaClearanceConstructionOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyPatch;
};

/** Represents an update to a `AreaClearanceConstruction`. Fields that are set will be updated. */
export type AreaClearanceConstructionPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaClearanceConstruction` values. */
export type AreaClearanceConstructionsConnection = {
  __typename?: 'AreaClearanceConstructionsConnection';
  /** A list of edges which contains the `AreaClearanceConstruction` and cursor to aid in pagination. */
  edges: Array<AreaClearanceConstructionsEdge>;
  /** A list of `AreaClearanceConstruction` objects. */
  nodes: Array<AreaClearanceConstruction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaClearanceConstruction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaClearanceConstruction` edge in the connection. */
export type AreaClearanceConstructionsEdge = {
  __typename?: 'AreaClearanceConstructionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaClearanceConstruction` at the end of the edge. */
  node: AreaClearanceConstruction;
};

/** Methods to use when ordering `AreaClearanceConstruction`. */
export enum AreaClearanceConstructionsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A condition to be used against `Area` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AreaCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

export type AreaContactBooking = {
  __typename?: 'AreaContactBooking';
  /** Reads a single `Area` that is related to this `AreaContactBooking`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaContactBooking` to look up the row to connect. */
export type AreaContactBookingAreaContactBookingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaContactBooking` to look up the row to delete. */
export type AreaContactBookingAreaContactBookingPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `areaContactBooking` to be created by this mutation. */
export type AreaContactBookingAreaIdFkeyAreaContactBookingCreateInput = {
  areaToAreaId?: InputMaybe<AreaContactBookingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaContactBookingAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `area` in the `AreaContactBookingInput` mutation. */
export type AreaContactBookingAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaContactBookingAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaContactBooking` in the `AreaInput` mutation. */
export type AreaContactBookingAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaContactBooking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaContactBookingAreaContactBookingPkeyConnect>>;
  /** A `AreaContactBookingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaContactBookingAreaIdFkeyAreaContactBookingCreateInput>>;
  /** The primary key(s) for `areaContactBooking` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaContactBookingAreaContactBookingPkeyDelete>>;
  /** Flag indicating whether all other `areaContactBooking` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaContactBooking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaContactBookingOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaContactBookingPkeyUpdate>>;
};

/**
 * A condition to be used against `AreaContactBooking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaContactBookingCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaContactBooking` object types. All fields are combined with a logical ‘and.’ */
export type AreaContactBookingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaContactBookingFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaContactBookingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaContactBookingFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaContactBooking` */
export type AreaContactBookingInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaContactBookingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaContactBooking` to look up the row to update. */
export type AreaContactBookingOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaContactBookingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaContactBooking` being updated. */
  patch: UpdateAreaContactBookingOnAreaContactBookingForAreaContactBookingAreaIdFkeyPatch;
};

/** Represents an update to a `AreaContactBooking`. Fields that are set will be updated. */
export type AreaContactBookingPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaContactBookingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaContactBooking` values. */
export type AreaContactBookingsConnection = {
  __typename?: 'AreaContactBookingsConnection';
  /** A list of edges which contains the `AreaContactBooking` and cursor to aid in pagination. */
  edges: Array<AreaContactBookingsEdge>;
  /** A list of `AreaContactBooking` objects. */
  nodes: Array<AreaContactBooking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaContactBooking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaContactBooking` edge in the connection. */
export type AreaContactBookingsEdge = {
  __typename?: 'AreaContactBookingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaContactBooking` at the end of the edge. */
  node: AreaContactBooking;
};

/** Methods to use when ordering `AreaContactBooking`. */
export enum AreaContactBookingsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaDescription = {
  __typename?: 'AreaDescription';
  /** Reads a single `Area` that is related to this `AreaDescription`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaDescription` to look up the row to connect. */
export type AreaDescriptionAreaDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaDescription` to look up the row to delete. */
export type AreaDescriptionAreaDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `area` to be created by this mutation. */
export type AreaDescriptionAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaDescription` to be created by this mutation. */
export type AreaDescriptionAreaIdFkeyAreaDescriptionCreateInput = {
  areaToAreaId?: InputMaybe<AreaDescriptionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaDescriptionInput` mutation. */
export type AreaDescriptionAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaDescriptionAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaDescription` in the `AreaInput` mutation. */
export type AreaDescriptionAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaDescriptionAreaDescriptionPkeyConnect>>;
  /** A `AreaDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaDescriptionAreaIdFkeyAreaDescriptionCreateInput>>;
  /** The primary key(s) for `areaDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaDescriptionAreaDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `areaDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaDescriptionOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaDescriptionPkeyUpdate>>;
};

/**
 * A condition to be used against `AreaDescription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaDescriptionCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaDescription` object types. All fields are combined with a logical ‘and.’ */
export type AreaDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaDescriptionFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaDescriptionFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaDescription` */
export type AreaDescriptionInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaDescriptionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaDescription` to look up the row to update. */
export type AreaDescriptionOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaDescription` being updated. */
  patch: UpdateAreaDescriptionOnAreaDescriptionForAreaDescriptionAreaIdFkeyPatch;
};

/** Represents an update to a `AreaDescription`. Fields that are set will be updated. */
export type AreaDescriptionPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaDescriptionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaDescription` values. */
export type AreaDescriptionsConnection = {
  __typename?: 'AreaDescriptionsConnection';
  /** A list of edges which contains the `AreaDescription` and cursor to aid in pagination. */
  edges: Array<AreaDescriptionsEdge>;
  /** A list of `AreaDescription` objects. */
  nodes: Array<AreaDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaDescription` edge in the connection. */
export type AreaDescriptionsEdge = {
  __typename?: 'AreaDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaDescription` at the end of the edge. */
  node: AreaDescription;
};

/** Methods to use when ordering `AreaDescription`. */
export enum AreaDescriptionsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against `Area` object types. All fields are combined with a logical ‘and.’ */
export type AreaFilter = {
  /** Filter by the object’s `allocationAreas` relation. */
  allocationAreas?: InputMaybe<AreaToManyAllocationAreaFilter>;
  /** Some related `allocationAreas` exist. */
  allocationAreasExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaFilter>>;
  /** Filter by the object’s `areaCadGrossSpaceMins` relation. */
  areaCadGrossSpaceMins?: InputMaybe<AreaToManyAreaCadGrossSpaceMinFilter>;
  /** Some related `areaCadGrossSpaceMins` exist. */
  areaCadGrossSpaceMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaClearanceConstructions` relation. */
  areaClearanceConstructions?: InputMaybe<AreaToManyAreaClearanceConstructionFilter>;
  /** Some related `areaClearanceConstructions` exist. */
  areaClearanceConstructionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaContactBookings` relation. */
  areaContactBookings?: InputMaybe<AreaToManyAreaContactBookingFilter>;
  /** Some related `areaContactBookings` exist. */
  areaContactBookingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaDescriptions` relation. */
  areaDescriptions?: InputMaybe<AreaToManyAreaDescriptionFilter>;
  /** Some related `areaDescriptions` exist. */
  areaDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaKeyIssuanceNotes` relation. */
  areaKeyIssuanceNotes?: InputMaybe<AreaToManyAreaKeyIssuanceNoteFilter>;
  /** Some related `areaKeyIssuanceNotes` exist. */
  areaKeyIssuanceNotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaKeyIssuances` relation. */
  areaKeyIssuances?: InputMaybe<AreaToManyAreaKeyIssuanceFilter>;
  /** Some related `areaKeyIssuances` exist. */
  areaKeyIssuancesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameExtras` relation. */
  areaNameExtras?: InputMaybe<AreaToManyAreaNameExtraFilter>;
  /** Some related `areaNameExtras` exist. */
  areaNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameKeyCads` relation. */
  areaNameKeyCads?: InputMaybe<AreaToManyAreaNameKeyCadFilter>;
  /** Some related `areaNameKeyCads` exist. */
  areaNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameKeyCafms` relation. */
  areaNameKeyCafms?: InputMaybe<AreaToManyAreaNameKeyCafmFilter>;
  /** Some related `areaNameKeyCafms` exist. */
  areaNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameKeyEbms` relation. */
  areaNameKeyEbms?: InputMaybe<AreaToManyAreaNameKeyEbmFilter>;
  /** Some related `areaNameKeyEbms` exist. */
  areaNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameKeyMarketings` relation. */
  areaNameKeyMarketings?: InputMaybe<AreaToManyAreaNameKeyMarketingFilter>;
  /** Some related `areaNameKeyMarketings` exist. */
  areaNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameLongs` relation. */
  areaNameLongs?: InputMaybe<AreaToManyAreaNameLongFilter>;
  /** Some related `areaNameLongs` exist. */
  areaNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaNameShorts` relation. */
  areaNameShorts?: InputMaybe<AreaToManyAreaNameShortFilter>;
  /** Some related `areaNameShorts` exist. */
  areaNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaPublicGrossSpaces` relation. */
  areaPublicGrossSpaces?: InputMaybe<AreaToManyAreaPublicGrossSpaceFilter>;
  /** Some related `areaPublicGrossSpaces` exist. */
  areaPublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areaTypeAttrs` relation. */
  areaTypeAttrs?: InputMaybe<AreaToManyAreaTypeAttrFilter>;
  /** Some related `areaTypeAttrs` exist. */
  areaTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaFilter>>;
  /** Filter by the object’s `plots` relation. */
  plots?: InputMaybe<AreaToManyPlotFilter>;
  /** Some related `plots` exist. */
  plotsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectAllocationAreas` relation. */
  projectAllocationAreas?: InputMaybe<AreaToManyProjectAllocationAreaFilter>;
  /** Some related `projectAllocationAreas` exist. */
  projectAllocationAreasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<AreaTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Area` */
export type AreaInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

export type AreaKeyIssuance = {
  __typename?: 'AreaKeyIssuance';
  /** Reads a single `Area` that is related to this `AreaKeyIssuance`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaKeyIssuanceAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaKeyIssuance` to be created by this mutation. */
export type AreaKeyIssuanceAreaIdFkeyAreaKeyIssuanceCreateInput = {
  areaToAreaId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaKeyIssuanceInput` mutation. */
export type AreaKeyIssuanceAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaKeyIssuanceAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaKeyIssuance` in the `AreaInput` mutation. */
export type AreaKeyIssuanceAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaKeyIssuance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaKeyIssuanceAreaKeyIssuancePkeyConnect>>;
  /** A `AreaKeyIssuanceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaKeyIssuanceAreaIdFkeyAreaKeyIssuanceCreateInput>>;
  /** The primary key(s) for `areaKeyIssuance` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaKeyIssuanceAreaKeyIssuancePkeyDelete>>;
  /** Flag indicating whether all other `areaKeyIssuance` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaKeyIssuance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaKeyIssuanceOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaKeyIssuancePkeyUpdate>>;
};

/** The fields on `areaKeyIssuance` to look up the row to connect. */
export type AreaKeyIssuanceAreaKeyIssuancePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaKeyIssuance` to look up the row to delete. */
export type AreaKeyIssuanceAreaKeyIssuancePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaKeyIssuance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaKeyIssuanceCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaKeyIssuance` object types. All fields are combined with a logical ‘and.’ */
export type AreaKeyIssuanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaKeyIssuanceFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaKeyIssuanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaKeyIssuanceFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaKeyIssuance` */
export type AreaKeyIssuanceInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type AreaKeyIssuanceNote = {
  __typename?: 'AreaKeyIssuanceNote';
  /** Reads a single `Area` that is related to this `AreaKeyIssuanceNote`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaKeyIssuanceNote` to look up the row to connect. */
export type AreaKeyIssuanceNoteAreaKeyIssuanceNotesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaKeyIssuanceNote` to look up the row to delete. */
export type AreaKeyIssuanceNoteAreaKeyIssuanceNotesPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaKeyIssuanceNote` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AreaKeyIssuanceNoteCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaKeyIssuanceNote` object types. All fields are combined with a logical ‘and.’ */
export type AreaKeyIssuanceNoteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaKeyIssuanceNoteFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaKeyIssuanceNoteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaKeyIssuanceNoteFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaKeyIssuanceNote` */
export type AreaKeyIssuanceNoteInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaKeyIssuanceNote` to look up the row to update. */
export type AreaKeyIssuanceNoteOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaKeyIssuanceNotesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaKeyIssuanceNote` being updated. */
  patch: UpdateAreaKeyIssuanceNoteOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyPatch;
};

/** Represents an update to a `AreaKeyIssuanceNote`. Fields that are set will be updated. */
export type AreaKeyIssuanceNotePatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `area` to be created by this mutation. */
export type AreaKeyIssuanceNotesAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaKeyIssuanceNote` to be created by this mutation. */
export type AreaKeyIssuanceNotesAreaIdFkeyAreaKeyIssuanceNotesCreateInput = {
  areaToAreaId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaKeyIssuanceNoteInput` mutation. */
export type AreaKeyIssuanceNotesAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaKeyIssuanceNote` in the `AreaInput` mutation. */
export type AreaKeyIssuanceNotesAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaKeyIssuanceNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaKeyIssuanceNoteAreaKeyIssuanceNotesPkeyConnect>>;
  /** A `AreaKeyIssuanceNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaKeyIssuanceNotesAreaIdFkeyAreaKeyIssuanceNotesCreateInput>>;
  /** The primary key(s) for `areaKeyIssuanceNote` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaKeyIssuanceNoteAreaKeyIssuanceNotesPkeyDelete>>;
  /** Flag indicating whether all other `areaKeyIssuanceNote` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaKeyIssuanceNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaKeyIssuanceNoteOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaKeyIssuanceNotesPkeyUpdate>>;
};

/** A connection to a list of `AreaKeyIssuanceNote` values. */
export type AreaKeyIssuanceNotesConnection = {
  __typename?: 'AreaKeyIssuanceNotesConnection';
  /** A list of edges which contains the `AreaKeyIssuanceNote` and cursor to aid in pagination. */
  edges: Array<AreaKeyIssuanceNotesEdge>;
  /** A list of `AreaKeyIssuanceNote` objects. */
  nodes: Array<AreaKeyIssuanceNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaKeyIssuanceNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaKeyIssuanceNote` edge in the connection. */
export type AreaKeyIssuanceNotesEdge = {
  __typename?: 'AreaKeyIssuanceNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaKeyIssuanceNote` at the end of the edge. */
  node: AreaKeyIssuanceNote;
};

/** Methods to use when ordering `AreaKeyIssuanceNote`. */
export enum AreaKeyIssuanceNotesOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `areaKeyIssuance` to look up the row to update. */
export type AreaKeyIssuanceOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaKeyIssuancePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaKeyIssuance` being updated. */
  patch: UpdateAreaKeyIssuanceOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyPatch;
};

/** Represents an update to a `AreaKeyIssuance`. Fields that are set will be updated. */
export type AreaKeyIssuancePatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaKeyIssuance` values. */
export type AreaKeyIssuancesConnection = {
  __typename?: 'AreaKeyIssuancesConnection';
  /** A list of edges which contains the `AreaKeyIssuance` and cursor to aid in pagination. */
  edges: Array<AreaKeyIssuancesEdge>;
  /** A list of `AreaKeyIssuance` objects. */
  nodes: Array<AreaKeyIssuance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaKeyIssuance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaKeyIssuance` edge in the connection. */
export type AreaKeyIssuancesEdge = {
  __typename?: 'AreaKeyIssuancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaKeyIssuance` at the end of the edge. */
  node: AreaKeyIssuance;
};

/** Methods to use when ordering `AreaKeyIssuance`. */
export enum AreaKeyIssuancesOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameExtra = {
  __typename?: 'AreaNameExtra';
  /** Reads a single `Area` that is related to this `AreaNameExtra`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaNameExtraAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameExtra` to be created by this mutation. */
export type AreaNameExtraAreaIdFkeyAreaNameExtraCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameExtraAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameExtraInput` mutation. */
export type AreaNameExtraAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameExtraAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameExtra` in the `AreaInput` mutation. */
export type AreaNameExtraAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameExtraAreaNameExtraPkeyConnect>>;
  /** A `AreaNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameExtraAreaIdFkeyAreaNameExtraCreateInput>>;
  /** The primary key(s) for `areaNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameExtraAreaNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `areaNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameExtraOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaNameExtraPkeyUpdate>>;
};

/** The fields on `areaNameExtra` to look up the row to connect. */
export type AreaNameExtraAreaNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameExtra` to look up the row to delete. */
export type AreaNameExtraAreaNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaNameExtraCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameExtraFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameExtraFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameExtra` */
export type AreaNameExtraInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameExtraAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameExtra` to look up the row to update. */
export type AreaNameExtraOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameExtra` being updated. */
  patch: UpdateAreaNameExtraOnAreaNameExtraForAreaNameExtraAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameExtra`. Fields that are set will be updated. */
export type AreaNameExtraPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameExtraAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaNameExtra` values. */
export type AreaNameExtrasConnection = {
  __typename?: 'AreaNameExtrasConnection';
  /** A list of edges which contains the `AreaNameExtra` and cursor to aid in pagination. */
  edges: Array<AreaNameExtrasEdge>;
  /** A list of `AreaNameExtra` objects. */
  nodes: Array<AreaNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameExtra` edge in the connection. */
export type AreaNameExtrasEdge = {
  __typename?: 'AreaNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameExtra` at the end of the edge. */
  node: AreaNameExtra;
};

/** Methods to use when ordering `AreaNameExtra`. */
export enum AreaNameExtrasOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameKeyCad = {
  __typename?: 'AreaNameKeyCad';
  /** Reads a single `Area` that is related to this `AreaNameKeyCad`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaNameKeyCadAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameKeyCad` to be created by this mutation. */
export type AreaNameKeyCadAreaIdFkeyAreaNameKeyCadCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameKeyCadInput` mutation. */
export type AreaNameKeyCadAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameKeyCadAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameKeyCad` in the `AreaInput` mutation. */
export type AreaNameKeyCadAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameKeyCadAreaNameKeyCadPkeyConnect>>;
  /** A `AreaNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameKeyCadAreaIdFkeyAreaNameKeyCadCreateInput>>;
  /** The primary key(s) for `areaNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameKeyCadAreaNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `areaNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameKeyCadOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaNameKeyCadPkeyUpdate>>;
};

/** The fields on `areaNameKeyCad` to look up the row to connect. */
export type AreaNameKeyCadAreaNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameKeyCad` to look up the row to delete. */
export type AreaNameKeyCadAreaNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaNameKeyCadCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameKeyCadFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameKeyCadFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameKeyCad` */
export type AreaNameKeyCadInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameKeyCad` to look up the row to update. */
export type AreaNameKeyCadOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameKeyCad` being updated. */
  patch: UpdateAreaNameKeyCadOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameKeyCad`. Fields that are set will be updated. */
export type AreaNameKeyCadPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaNameKeyCad` values. */
export type AreaNameKeyCadsConnection = {
  __typename?: 'AreaNameKeyCadsConnection';
  /** A list of edges which contains the `AreaNameKeyCad` and cursor to aid in pagination. */
  edges: Array<AreaNameKeyCadsEdge>;
  /** A list of `AreaNameKeyCad` objects. */
  nodes: Array<AreaNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameKeyCad` edge in the connection. */
export type AreaNameKeyCadsEdge = {
  __typename?: 'AreaNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameKeyCad` at the end of the edge. */
  node: AreaNameKeyCad;
};

/** Methods to use when ordering `AreaNameKeyCad`. */
export enum AreaNameKeyCadsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameKeyCafm = {
  __typename?: 'AreaNameKeyCafm';
  /** Reads a single `Area` that is related to this `AreaNameKeyCafm`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaNameKeyCafmAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameKeyCafm` to be created by this mutation. */
export type AreaNameKeyCafmAreaIdFkeyAreaNameKeyCafmCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameKeyCafmInput` mutation. */
export type AreaNameKeyCafmAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameKeyCafmAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameKeyCafm` in the `AreaInput` mutation. */
export type AreaNameKeyCafmAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameKeyCafmAreaNameKeyCafmPkeyConnect>>;
  /** A `AreaNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameKeyCafmAreaIdFkeyAreaNameKeyCafmCreateInput>>;
  /** The primary key(s) for `areaNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameKeyCafmAreaNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `areaNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameKeyCafmOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaNameKeyCafmPkeyUpdate>>;
};

/** The fields on `areaNameKeyCafm` to look up the row to connect. */
export type AreaNameKeyCafmAreaNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameKeyCafm` to look up the row to delete. */
export type AreaNameKeyCafmAreaNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameKeyCafm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaNameKeyCafmCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameKeyCafmFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameKeyCafmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameKeyCafm` */
export type AreaNameKeyCafmInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameKeyCafm` to look up the row to update. */
export type AreaNameKeyCafmOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameKeyCafm` being updated. */
  patch: UpdateAreaNameKeyCafmOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameKeyCafm`. Fields that are set will be updated. */
export type AreaNameKeyCafmPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaNameKeyCafm` values. */
export type AreaNameKeyCafmsConnection = {
  __typename?: 'AreaNameKeyCafmsConnection';
  /** A list of edges which contains the `AreaNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<AreaNameKeyCafmsEdge>;
  /** A list of `AreaNameKeyCafm` objects. */
  nodes: Array<AreaNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameKeyCafm` edge in the connection. */
export type AreaNameKeyCafmsEdge = {
  __typename?: 'AreaNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameKeyCafm` at the end of the edge. */
  node: AreaNameKeyCafm;
};

/** Methods to use when ordering `AreaNameKeyCafm`. */
export enum AreaNameKeyCafmsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameKeyEbm = {
  __typename?: 'AreaNameKeyEbm';
  /** Reads a single `Area` that is related to this `AreaNameKeyEbm`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameKeyEbm` to look up the row to connect. */
export type AreaNameKeyEbmAreaNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameKeyEbm` to look up the row to delete. */
export type AreaNameKeyEbmAreaNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaNameKeyEbmCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameKeyEbmFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameKeyEbmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameKeyEbm` */
export type AreaNameKeyEbmInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameKeyEbm` to look up the row to update. */
export type AreaNameKeyEbmOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameKeyEbm` being updated. */
  patch: UpdateAreaNameKeyEbmOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameKeyEbm`. Fields that are set will be updated. */
export type AreaNameKeyEbmPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `area` to be created by this mutation. */
export type AreaNameKeyEbmsAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameKeyEbm` to be created by this mutation. */
export type AreaNameKeyEbmsAreaIdFkeyAreaNameKeyEbmsCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameKeyEbmInput` mutation. */
export type AreaNameKeyEbmsAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameKeyEbm` in the `AreaInput` mutation. */
export type AreaNameKeyEbmsAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameKeyEbmAreaNameKeyEbmsPkeyConnect>>;
  /** A `AreaNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameKeyEbmsAreaIdFkeyAreaNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `areaNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameKeyEbmAreaNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `areaNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameKeyEbmOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaNameKeyEbmsPkeyUpdate>>;
};

/** A connection to a list of `AreaNameKeyEbm` values. */
export type AreaNameKeyEbmsConnection = {
  __typename?: 'AreaNameKeyEbmsConnection';
  /** A list of edges which contains the `AreaNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<AreaNameKeyEbmsEdge>;
  /** A list of `AreaNameKeyEbm` objects. */
  nodes: Array<AreaNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameKeyEbm` edge in the connection. */
export type AreaNameKeyEbmsEdge = {
  __typename?: 'AreaNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameKeyEbm` at the end of the edge. */
  node: AreaNameKeyEbm;
};

/** Methods to use when ordering `AreaNameKeyEbm`. */
export enum AreaNameKeyEbmsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameKeyMarketing = {
  __typename?: 'AreaNameKeyMarketing';
  /** Reads a single `Area` that is related to this `AreaNameKeyMarketing`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaNameKeyMarketingAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameKeyMarketing` to be created by this mutation. */
export type AreaNameKeyMarketingAreaIdFkeyAreaNameKeyMarketingCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameKeyMarketingInput` mutation. */
export type AreaNameKeyMarketingAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameKeyMarketing` in the `AreaInput` mutation. */
export type AreaNameKeyMarketingAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameKeyMarketingAreaNameKeyMarketingPkeyConnect>>;
  /** A `AreaNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameKeyMarketingAreaIdFkeyAreaNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `areaNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameKeyMarketingAreaNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `areaNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameKeyMarketingOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaNameKeyMarketingPkeyUpdate>>;
};

/** The fields on `areaNameKeyMarketing` to look up the row to connect. */
export type AreaNameKeyMarketingAreaNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameKeyMarketing` to look up the row to delete. */
export type AreaNameKeyMarketingAreaNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameKeyMarketing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AreaNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameKeyMarketingFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameKeyMarketingFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameKeyMarketing` */
export type AreaNameKeyMarketingInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameKeyMarketing` to look up the row to update. */
export type AreaNameKeyMarketingOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameKeyMarketing` being updated. */
  patch: UpdateAreaNameKeyMarketingOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameKeyMarketing`. Fields that are set will be updated. */
export type AreaNameKeyMarketingPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaNameKeyMarketing` values. */
export type AreaNameKeyMarketingsConnection = {
  __typename?: 'AreaNameKeyMarketingsConnection';
  /** A list of edges which contains the `AreaNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<AreaNameKeyMarketingsEdge>;
  /** A list of `AreaNameKeyMarketing` objects. */
  nodes: Array<AreaNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameKeyMarketing` edge in the connection. */
export type AreaNameKeyMarketingsEdge = {
  __typename?: 'AreaNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameKeyMarketing` at the end of the edge. */
  node: AreaNameKeyMarketing;
};

/** Methods to use when ordering `AreaNameKeyMarketing`. */
export enum AreaNameKeyMarketingsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameLong = {
  __typename?: 'AreaNameLong';
  /** Reads a single `Area` that is related to this `AreaNameLong`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaNameLongAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameLong` to be created by this mutation. */
export type AreaNameLongAreaIdFkeyAreaNameLongCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameLongAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameLongInput` mutation. */
export type AreaNameLongAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameLongAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameLong` in the `AreaInput` mutation. */
export type AreaNameLongAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameLongAreaNameLongPkeyConnect>>;
  /** A `AreaNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameLongAreaIdFkeyAreaNameLongCreateInput>>;
  /** The primary key(s) for `areaNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameLongAreaNameLongPkeyDelete>>;
  /** Flag indicating whether all other `areaNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameLongOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaNameLongPkeyUpdate>>;
};

/** The fields on `areaNameLong` to look up the row to connect. */
export type AreaNameLongAreaNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameLong` to look up the row to delete. */
export type AreaNameLongAreaNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaNameLongCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameLong` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameLongFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameLongFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameLong` */
export type AreaNameLongInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameLongAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameLong` to look up the row to update. */
export type AreaNameLongOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameLong` being updated. */
  patch: UpdateAreaNameLongOnAreaNameLongForAreaNameLongAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameLong`. Fields that are set will be updated. */
export type AreaNameLongPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameLongAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaNameLong` values. */
export type AreaNameLongsConnection = {
  __typename?: 'AreaNameLongsConnection';
  /** A list of edges which contains the `AreaNameLong` and cursor to aid in pagination. */
  edges: Array<AreaNameLongsEdge>;
  /** A list of `AreaNameLong` objects. */
  nodes: Array<AreaNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameLong` edge in the connection. */
export type AreaNameLongsEdge = {
  __typename?: 'AreaNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameLong` at the end of the edge. */
  node: AreaNameLong;
};

/** Methods to use when ordering `AreaNameLong`. */
export enum AreaNameLongsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type AreaNameShort = {
  __typename?: 'AreaNameShort';
  /** Reads a single `Area` that is related to this `AreaNameShort`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `area` to be created by this mutation. */
export type AreaNameShortAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaNameShort` to be created by this mutation. */
export type AreaNameShortAreaIdFkeyAreaNameShortCreateInput = {
  areaToAreaId?: InputMaybe<AreaNameShortAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `area` in the `AreaNameShortInput` mutation. */
export type AreaNameShortAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaNameShortAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaNameShort` in the `AreaInput` mutation. */
export type AreaNameShortAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaNameShortAreaNameShortPkeyConnect>>;
  /** A `AreaNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaNameShortAreaIdFkeyAreaNameShortCreateInput>>;
  /** The primary key(s) for `areaNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaNameShortAreaNameShortPkeyDelete>>;
  /** Flag indicating whether all other `areaNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaNameShortOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaNameShortPkeyUpdate>>;
};

/** The fields on `areaNameShort` to look up the row to connect. */
export type AreaNameShortAreaNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaNameShort` to look up the row to delete. */
export type AreaNameShortAreaNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaNameShortCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaNameShort` object types. All fields are combined with a logical ‘and.’ */
export type AreaNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaNameShortFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaNameShortFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AreaNameShort` */
export type AreaNameShortInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameShortAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `areaNameShort` to look up the row to update. */
export type AreaNameShortOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaNameShort` being updated. */
  patch: UpdateAreaNameShortOnAreaNameShortForAreaNameShortAreaIdFkeyPatch;
};

/** Represents an update to a `AreaNameShort`. Fields that are set will be updated. */
export type AreaNameShortPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaNameShortAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AreaNameShort` values. */
export type AreaNameShortsConnection = {
  __typename?: 'AreaNameShortsConnection';
  /** A list of edges which contains the `AreaNameShort` and cursor to aid in pagination. */
  edges: Array<AreaNameShortsEdge>;
  /** A list of `AreaNameShort` objects. */
  nodes: Array<AreaNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaNameShort` edge in the connection. */
export type AreaNameShortsEdge = {
  __typename?: 'AreaNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaNameShort` at the end of the edge. */
  node: AreaNameShort;
};

/** Methods to use when ordering `AreaNameShort`. */
export enum AreaNameShortsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `area` to look up the row to update. */
export type AreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAllocationAreaForAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAllocationAreaForAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAllocationAreaForAllocationAreaAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAllocationAreaForAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaForAreaTypeIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaForAreaTypeIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaForAreaTypeIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaForAreaTypeIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaForAreaTypeIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaForAreaTypeIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaForAreaZoneIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaForAreaZoneIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaForAreaZoneIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaForAreaZoneIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaForAreaZoneIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaForAreaZoneIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameLongForAreaNameLongAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameLongForAreaNameLongAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameLongForAreaNameLongAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameLongForAreaNameLongAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameShortForAreaNameShortAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameShortForAreaNameShortAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaNameShortForAreaNameShortAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaNameShortForAreaNameShortAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnPlotForPlotAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnPlotForPlotAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnPlotForPlotAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnPlotForPlotAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnPlotForPlotAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnPlotForPlotAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingAreaExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingAreaNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `area` to look up the row to update. */
export type AreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `area` being updated. */
  patch: UpdateAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyPatch;
};

/** Represents an update to a `Area`. Fields that are set will be updated. */
export type AreaPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

export type AreaPublicGrossSpace = {
  __typename?: 'AreaPublicGrossSpace';
  /** Reads a single `Area` that is related to this `AreaPublicGrossSpace`. */
  area: Area;
  areaId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `area` to be created by this mutation. */
export type AreaPublicGrossSpaceAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaPublicGrossSpace` to be created by this mutation. */
export type AreaPublicGrossSpaceAreaIdFkeyAreaPublicGrossSpaceCreateInput = {
  areaToAreaId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** Input for the nested mutation of `area` in the `AreaPublicGrossSpaceInput` mutation. */
export type AreaPublicGrossSpaceAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaPublicGrossSpace` in the `AreaInput` mutation. */
export type AreaPublicGrossSpaceAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaPublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaPublicGrossSpaceAreaPublicGrossSpacePkeyConnect>>;
  /** A `AreaPublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaPublicGrossSpaceAreaIdFkeyAreaPublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `areaPublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaPublicGrossSpaceAreaPublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `areaPublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaPublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaPublicGrossSpaceOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaPublicGrossSpacePkeyUpdate>>;
};

/** The fields on `areaPublicGrossSpace` to look up the row to connect. */
export type AreaPublicGrossSpaceAreaPublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaPublicGrossSpace` to look up the row to delete. */
export type AreaPublicGrossSpaceAreaPublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `AreaPublicGrossSpace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AreaPublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `AreaPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type AreaPublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaPublicGrossSpaceFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaPublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaPublicGrossSpaceFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `AreaPublicGrossSpace` */
export type AreaPublicGrossSpaceInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `areaPublicGrossSpace` to look up the row to update. */
export type AreaPublicGrossSpaceOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyUsingAreaPublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaPublicGrossSpace` being updated. */
  patch: UpdateAreaPublicGrossSpaceOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyPatch;
};

/** Represents an update to a `AreaPublicGrossSpace`. Fields that are set will be updated. */
export type AreaPublicGrossSpacePatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `AreaPublicGrossSpace` values. */
export type AreaPublicGrossSpacesConnection = {
  __typename?: 'AreaPublicGrossSpacesConnection';
  /** A list of edges which contains the `AreaPublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<AreaPublicGrossSpacesEdge>;
  /** A list of `AreaPublicGrossSpace` objects. */
  nodes: Array<AreaPublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaPublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaPublicGrossSpace` edge in the connection. */
export type AreaPublicGrossSpacesEdge = {
  __typename?: 'AreaPublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaPublicGrossSpace` at the end of the edge. */
  node: AreaPublicGrossSpace;
};

/** Methods to use when ordering `AreaPublicGrossSpace`. */
export enum AreaPublicGrossSpacesOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against many `AllocationArea` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAllocationAreaFilter = {
  /** Every related `AllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationAreaFilter>;
  /** No related `AllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationAreaFilter>;
  /** Some related `AllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationAreaFilter>;
};

/** A filter to be used against many `AreaCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaCadGrossSpaceMinFilter = {
  /** Every related `AreaCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaCadGrossSpaceMinFilter>;
  /** No related `AreaCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaCadGrossSpaceMinFilter>;
  /** Some related `AreaCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaCadGrossSpaceMinFilter>;
};

/** A filter to be used against many `AreaClearanceConstruction` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaClearanceConstructionFilter = {
  /** Every related `AreaClearanceConstruction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaClearanceConstructionFilter>;
  /** No related `AreaClearanceConstruction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaClearanceConstructionFilter>;
  /** Some related `AreaClearanceConstruction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaClearanceConstructionFilter>;
};

/** A filter to be used against many `AreaContactBooking` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaContactBookingFilter = {
  /** Every related `AreaContactBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaContactBookingFilter>;
  /** No related `AreaContactBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaContactBookingFilter>;
  /** Some related `AreaContactBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaContactBookingFilter>;
};

/** A filter to be used against many `AreaDescription` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaDescriptionFilter = {
  /** Every related `AreaDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaDescriptionFilter>;
  /** No related `AreaDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaDescriptionFilter>;
  /** Some related `AreaDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaDescriptionFilter>;
};

/** A filter to be used against many `AreaKeyIssuance` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaKeyIssuanceFilter = {
  /** Every related `AreaKeyIssuance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaKeyIssuanceFilter>;
  /** No related `AreaKeyIssuance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaKeyIssuanceFilter>;
  /** Some related `AreaKeyIssuance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaKeyIssuanceFilter>;
};

/** A filter to be used against many `AreaKeyIssuanceNote` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaKeyIssuanceNoteFilter = {
  /** Every related `AreaKeyIssuanceNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaKeyIssuanceNoteFilter>;
  /** No related `AreaKeyIssuanceNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaKeyIssuanceNoteFilter>;
  /** Some related `AreaKeyIssuanceNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaKeyIssuanceNoteFilter>;
};

/** A filter to be used against many `AreaNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameExtraFilter = {
  /** Every related `AreaNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameExtraFilter>;
  /** No related `AreaNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameExtraFilter>;
  /** Some related `AreaNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameExtraFilter>;
};

/** A filter to be used against many `AreaNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameKeyCadFilter = {
  /** Every related `AreaNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameKeyCadFilter>;
  /** No related `AreaNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameKeyCadFilter>;
  /** Some related `AreaNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameKeyCadFilter>;
};

/** A filter to be used against many `AreaNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameKeyCafmFilter = {
  /** Every related `AreaNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameKeyCafmFilter>;
  /** No related `AreaNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameKeyCafmFilter>;
  /** Some related `AreaNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameKeyCafmFilter>;
};

/** A filter to be used against many `AreaNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameKeyEbmFilter = {
  /** Every related `AreaNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameKeyEbmFilter>;
  /** No related `AreaNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameKeyEbmFilter>;
  /** Some related `AreaNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameKeyEbmFilter>;
};

/** A filter to be used against many `AreaNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameKeyMarketingFilter = {
  /** Every related `AreaNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameKeyMarketingFilter>;
  /** No related `AreaNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameKeyMarketingFilter>;
  /** Some related `AreaNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameKeyMarketingFilter>;
};

/** A filter to be used against many `AreaNameLong` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameLongFilter = {
  /** Every related `AreaNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameLongFilter>;
  /** No related `AreaNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameLongFilter>;
  /** Some related `AreaNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameLongFilter>;
};

/** A filter to be used against many `AreaNameShort` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaNameShortFilter = {
  /** Every related `AreaNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaNameShortFilter>;
  /** No related `AreaNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaNameShortFilter>;
  /** Some related `AreaNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaNameShortFilter>;
};

/** A filter to be used against many `AreaPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaPublicGrossSpaceFilter = {
  /** Every related `AreaPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaPublicGrossSpaceFilter>;
  /** No related `AreaPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaPublicGrossSpaceFilter>;
  /** Some related `AreaPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaPublicGrossSpaceFilter>;
};

/** A filter to be used against many `AreaTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyAreaTypeAttrFilter = {
  /** Every related `AreaTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaTypeAttrFilter>;
  /** No related `AreaTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaTypeAttrFilter>;
  /** Some related `AreaTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaTypeAttrFilter>;
};

/** A filter to be used against many `Plot` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyPlotFilter = {
  /** Every related `Plot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotFilter>;
  /** No related `Plot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotFilter>;
  /** Some related `Plot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotFilter>;
};

/** A filter to be used against many `ProjectAllocationArea` object types. All fields are combined with a logical ‘and.’ */
export type AreaToManyProjectAllocationAreaFilter = {
  /** Every related `ProjectAllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationAreaFilter>;
  /** No related `ProjectAllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationAreaFilter>;
  /** Some related `ProjectAllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationAreaFilter>;
};

export type AreaType = {
  __typename?: 'AreaType';
  /** Reads and enables pagination through a set of `AreaTypeAttr`. */
  areaTypeAttrs: AreaTypeAttrsConnection;
  /** Reads and enables pagination through a set of `Area`. */
  areasByTypeId: AreasConnection;
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  name: Scalars['String'];
};


export type AreaTypeAreaTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaTypeAttrCondition>;
  filter?: InputMaybe<AreaTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaTypeAttrsOrderBy>>;
};


export type AreaTypeAreasByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaCondition>;
  filter?: InputMaybe<AreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreasOrderBy>>;
};

/** The fields on `areaType` to look up the row to connect. */
export type AreaTypeAreaTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `areaType` to look up the row to delete. */
export type AreaTypeAreaTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `areaType` to look up the row to connect. */
export type AreaTypeAreaTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaType` to look up the row to delete. */
export type AreaTypeAreaTypePkeyDelete = {
  id: Scalars['UUID'];
};

export type AreaTypeAttr = {
  __typename?: 'AreaTypeAttr';
  /** Reads a single `Area` that is related to this `AreaTypeAttr`. */
  area: Area;
  areaId: Scalars['UUID'];
  /** Reads a single `AreaType` that is related to this `AreaTypeAttr`. */
  areaType: AreaType;
  areaTypeId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
};

/** The `area` to be created by this mutation. */
export type AreaTypeAttrAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaTypeAttr` to be created by this mutation. */
export type AreaTypeAttrAreaIdFkeyAreaTypeAttrCreateInput = {
  areaToAreaId?: InputMaybe<AreaTypeAttrAreaIdFkeyInput>;
  areaTypeId?: InputMaybe<Scalars['UUID']>;
  areaTypeToAreaTypeId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `area` in the `AreaTypeAttrInput` mutation. */
export type AreaTypeAttrAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaTypeAttrAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `areaTypeAttr` in the `AreaInput` mutation. */
export type AreaTypeAttrAreaIdFkeyInverseInput = {
  /** The primary key(s) for `areaTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaTypeAttrAreaTypeAttrPkeyConnect>>;
  /** A `AreaTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaTypeAttrAreaIdFkeyAreaTypeAttrCreateInput>>;
  /** The primary key(s) for `areaTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaTypeAttrAreaTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `areaTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaTypeAttrPkeyUpdate>>;
};

/** The fields on `areaTypeAttr` to look up the row to connect. */
export type AreaTypeAttrAreaTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `areaTypeAttr` to look up the row to delete. */
export type AreaTypeAttrAreaTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `areaTypeAttr` to be created by this mutation. */
export type AreaTypeAttrAreaTypeIdFkeyAreaTypeAttrCreateInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaTypeAttrAreaIdFkeyInput>;
  areaTypeToAreaTypeId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `areaType` to be created by this mutation. */
export type AreaTypeAttrAreaTypeIdFkeyAreaTypeCreateInput = {
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInverseInput>;
  areasUsingId?: InputMaybe<AreaTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `areaType` in the `AreaTypeAttrInput` mutation. */
export type AreaTypeAttrAreaTypeIdFkeyInput = {
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  connectById?: InputMaybe<AreaTypeAreaTypePkeyConnect>;
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  connectByName?: InputMaybe<AreaTypeAreaTypeNameKeyConnect>;
  /** A `AreaTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyAreaTypeCreateInput>;
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaTypeAreaTypePkeyDelete>;
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  deleteByName?: InputMaybe<AreaTypeAreaTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `areaType` for the far side of the relationship. */
  updateById?: InputMaybe<AreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyUsingAreaTypePkeyUpdate>;
  /** The primary key(s) and patch data for `areaType` for the far side of the relationship. */
  updateByName?: InputMaybe<AreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyUsingAreaTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `areaTypeAttr` in the `AreaTypeInput` mutation. */
export type AreaTypeAttrAreaTypeIdFkeyInverseInput = {
  /** The primary key(s) for `areaTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaTypeAttrAreaTypeAttrPkeyConnect>>;
  /** A `AreaTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaTypeAttrAreaTypeIdFkeyAreaTypeAttrCreateInput>>;
  /** The primary key(s) for `areaTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaTypeAttrAreaTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `areaTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `areaTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyUsingAreaTypeAttrPkeyUpdate>>;
};

/**
 * A condition to be used against `AreaTypeAttr` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AreaTypeAttrCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `areaTypeId` field. */
  areaTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AreaTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type AreaTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaTypeAttrFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `areaType` relation. */
  areaType?: InputMaybe<AreaTypeFilter>;
  /** Filter by the object’s `areaTypeId` field. */
  areaTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaTypeAttrFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AreaTypeAttr` */
export type AreaTypeAttrInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaTypeAttrAreaIdFkeyInput>;
  areaTypeId?: InputMaybe<Scalars['UUID']>;
  areaTypeToAreaTypeId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `areaTypeAttr` to look up the row to update. */
export type AreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyUsingAreaTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaTypeAttr` being updated. */
  patch: UpdateAreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyPatch;
};

/** The fields on `areaTypeAttr` to look up the row to update. */
export type AreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyUsingAreaTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaTypeAttr` being updated. */
  patch: UpdateAreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyPatch;
};

/** Represents an update to a `AreaTypeAttr`. Fields that are set will be updated. */
export type AreaTypeAttrPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaTypeAttrAreaIdFkeyInput>;
  areaTypeId?: InputMaybe<Scalars['UUID']>;
  areaTypeToAreaTypeId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `AreaTypeAttr` values. */
export type AreaTypeAttrsConnection = {
  __typename?: 'AreaTypeAttrsConnection';
  /** A list of edges which contains the `AreaTypeAttr` and cursor to aid in pagination. */
  edges: Array<AreaTypeAttrsEdge>;
  /** A list of `AreaTypeAttr` objects. */
  nodes: Array<AreaTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaTypeAttr` edge in the connection. */
export type AreaTypeAttrsEdge = {
  __typename?: 'AreaTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaTypeAttr` at the end of the edge. */
  node: AreaTypeAttr;
};

/** Methods to use when ordering `AreaTypeAttr`. */
export enum AreaTypeAttrsOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  AreaTypeByAreaTypeIdDescriptionAsc = 'AREA_TYPE_BY_AREA_TYPE_ID__DESCRIPTION_ASC',
  AreaTypeByAreaTypeIdDescriptionDesc = 'AREA_TYPE_BY_AREA_TYPE_ID__DESCRIPTION_DESC',
  AreaTypeByAreaTypeIdIdAsc = 'AREA_TYPE_BY_AREA_TYPE_ID__ID_ASC',
  AreaTypeByAreaTypeIdIdDesc = 'AREA_TYPE_BY_AREA_TYPE_ID__ID_DESC',
  AreaTypeByAreaTypeIdIndexAsc = 'AREA_TYPE_BY_AREA_TYPE_ID__INDEX_ASC',
  AreaTypeByAreaTypeIdIndexDesc = 'AREA_TYPE_BY_AREA_TYPE_ID__INDEX_DESC',
  AreaTypeByAreaTypeIdNameAsc = 'AREA_TYPE_BY_AREA_TYPE_ID__NAME_ASC',
  AreaTypeByAreaTypeIdNameDesc = 'AREA_TYPE_BY_AREA_TYPE_ID__NAME_DESC',
  AreaTypeIdAsc = 'AREA_TYPE_ID_ASC',
  AreaTypeIdDesc = 'AREA_TYPE_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/**
 * A condition to be used against `AreaType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AreaTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AreaType` object types. All fields are combined with a logical ‘and.’ */
export type AreaTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AreaTypeFilter>>;
  /** Filter by the object’s `areaTypeAttrs` relation. */
  areaTypeAttrs?: InputMaybe<AreaTypeToManyAreaTypeAttrFilter>;
  /** Some related `areaTypeAttrs` exist. */
  areaTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `areasByTypeId` relation. */
  areasByTypeId?: InputMaybe<AreaTypeToManyAreaFilter>;
  /** Some related `areasByTypeId` exist. */
  areasByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AreaTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AreaTypeFilter>>;
};

/** The `area` to be created by this mutation. */
export type AreaTypeIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** The `areaType` to be created by this mutation. */
export type AreaTypeIdFkeyAreaTypeCreateInput = {
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInverseInput>;
  areasUsingId?: InputMaybe<AreaTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `areaType` in the `AreaInput` mutation. */
export type AreaTypeIdFkeyInput = {
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  connectById?: InputMaybe<AreaTypeAreaTypePkeyConnect>;
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  connectByName?: InputMaybe<AreaTypeAreaTypeNameKeyConnect>;
  /** A `AreaTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaTypeIdFkeyAreaTypeCreateInput>;
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaTypeAreaTypePkeyDelete>;
  /** The primary key(s) for `areaType` for the far side of the relationship. */
  deleteByName?: InputMaybe<AreaTypeAreaTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `areaType` for the far side of the relationship. */
  updateById?: InputMaybe<AreaTypeOnAreaForAreaTypeIdFkeyUsingAreaTypePkeyUpdate>;
  /** The primary key(s) and patch data for `areaType` for the far side of the relationship. */
  updateByName?: InputMaybe<AreaTypeOnAreaForAreaTypeIdFkeyUsingAreaTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `area` in the `AreaTypeInput` mutation. */
export type AreaTypeIdFkeyInverseInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<AreaAreaExtIdKeyConnect>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaAreaPkeyConnect>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<AreaAreaNameShortKeyConnect>>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaTypeIdFkeyAreaCreateInput>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<AreaAreaExtIdKeyDelete>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaAreaPkeyDelete>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<AreaAreaNameShortKeyDelete>>;
  /** Flag indicating whether all other `area` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<AreaOnAreaForAreaTypeIdFkeyUsingAreaExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaOnAreaForAreaTypeIdFkeyUsingAreaPkeyUpdate>>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<AreaOnAreaForAreaTypeIdFkeyUsingAreaNameShortKeyUpdate>>;
};

/** An input for mutations affecting `AreaType` */
export type AreaTypeInput = {
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInverseInput>;
  areasUsingId?: InputMaybe<AreaTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** The fields on `areaType` to look up the row to update. */
export type AreaTypeOnAreaForAreaTypeIdFkeyUsingAreaTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `areaType` being updated. */
  patch: UpdateAreaTypeOnAreaForAreaTypeIdFkeyPatch;
};

/** The fields on `areaType` to look up the row to update. */
export type AreaTypeOnAreaForAreaTypeIdFkeyUsingAreaTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaType` being updated. */
  patch: UpdateAreaTypeOnAreaForAreaTypeIdFkeyPatch;
};

/** The fields on `areaType` to look up the row to update. */
export type AreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyUsingAreaTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `areaType` being updated. */
  patch: UpdateAreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyPatch;
};

/** The fields on `areaType` to look up the row to update. */
export type AreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyUsingAreaTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `areaType` being updated. */
  patch: UpdateAreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyPatch;
};

/** Represents an update to a `AreaType`. Fields that are set will be updated. */
export type AreaTypePatch = {
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInverseInput>;
  areasUsingId?: InputMaybe<AreaTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `Area` object types. All fields are combined with a logical ‘and.’ */
export type AreaTypeToManyAreaFilter = {
  /** Every related `Area` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaFilter>;
  /** No related `Area` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaFilter>;
  /** Some related `Area` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaFilter>;
};

/** A filter to be used against many `AreaTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type AreaTypeToManyAreaTypeAttrFilter = {
  /** Every related `AreaTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaTypeAttrFilter>;
  /** No related `AreaTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaTypeAttrFilter>;
  /** Some related `AreaTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaTypeAttrFilter>;
};

/** A connection to a list of `AreaType` values. */
export type AreaTypesConnection = {
  __typename?: 'AreaTypesConnection';
  /** A list of edges which contains the `AreaType` and cursor to aid in pagination. */
  edges: Array<AreaTypesEdge>;
  /** A list of `AreaType` objects. */
  nodes: Array<AreaType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AreaType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AreaType` edge in the connection. */
export type AreaTypesEdge = {
  __typename?: 'AreaTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AreaType` at the end of the edge. */
  node: AreaType;
};

/** Methods to use when ordering `AreaType`. */
export enum AreaTypesOrderBy {
  AreasByTypeIdCountAsc = 'AREAS_BY_TYPE_ID__COUNT_ASC',
  AreasByTypeIdCountDesc = 'AREAS_BY_TYPE_ID__COUNT_DESC',
  AreaTypeAttrsByAreaTypeIdCountAsc = 'AREA_TYPE_ATTRS_BY_AREA_TYPE_ID__COUNT_ASC',
  AreaTypeAttrsByAreaTypeIdCountDesc = 'AREA_TYPE_ATTRS_BY_AREA_TYPE_ID__COUNT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The `area` to be created by this mutation. */
export type AreaZoneIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `AreaInput` mutation. */
export type AreaZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<AreaZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnAreaForAreaZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnAreaForAreaZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnAreaForAreaZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `area` in the `ZoneInput` mutation. */
export type AreaZoneIdFkeyInverseInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<AreaAreaExtIdKeyConnect>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AreaAreaPkeyConnect>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<AreaAreaNameShortKeyConnect>>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AreaZoneIdFkeyAreaCreateInput>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<AreaAreaExtIdKeyDelete>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AreaAreaPkeyDelete>>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<AreaAreaNameShortKeyDelete>>;
  /** Flag indicating whether all other `area` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<AreaOnAreaForAreaZoneIdFkeyUsingAreaExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AreaOnAreaForAreaZoneIdFkeyUsingAreaPkeyUpdate>>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<AreaOnAreaForAreaZoneIdFkeyUsingAreaNameShortKeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type AreaZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** A connection to a list of `Area` values. */
export type AreasConnection = {
  __typename?: 'AreasConnection';
  /** A list of edges which contains the `Area` and cursor to aid in pagination. */
  edges: Array<AreasEdge>;
  /** A list of `Area` objects. */
  nodes: Array<Area>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Area` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Area` edge in the connection. */
export type AreasEdge = {
  __typename?: 'AreasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Area` at the end of the edge. */
  node: Area;
};

/** Methods to use when ordering `Area`. */
export enum AreasOrderBy {
  AllocationAreasByAreaIdCountAsc = 'ALLOCATION_AREAS_BY_AREA_ID__COUNT_ASC',
  AllocationAreasByAreaIdCountDesc = 'ALLOCATION_AREAS_BY_AREA_ID__COUNT_DESC',
  AreaCadGrossSpaceMinsByAreaIdCountAsc = 'AREA_CAD_GROSS_SPACE_MINS_BY_AREA_ID__COUNT_ASC',
  AreaCadGrossSpaceMinsByAreaIdCountDesc = 'AREA_CAD_GROSS_SPACE_MINS_BY_AREA_ID__COUNT_DESC',
  AreaClearanceConstructionsByAreaIdCountAsc = 'AREA_CLEARANCE_CONSTRUCTIONS_BY_AREA_ID__COUNT_ASC',
  AreaClearanceConstructionsByAreaIdCountDesc = 'AREA_CLEARANCE_CONSTRUCTIONS_BY_AREA_ID__COUNT_DESC',
  AreaContactBookingsByAreaIdCountAsc = 'AREA_CONTACT_BOOKINGS_BY_AREA_ID__COUNT_ASC',
  AreaContactBookingsByAreaIdCountDesc = 'AREA_CONTACT_BOOKINGS_BY_AREA_ID__COUNT_DESC',
  AreaDescriptionsByAreaIdCountAsc = 'AREA_DESCRIPTIONS_BY_AREA_ID__COUNT_ASC',
  AreaDescriptionsByAreaIdCountDesc = 'AREA_DESCRIPTIONS_BY_AREA_ID__COUNT_DESC',
  AreaKeyIssuancesByAreaIdCountAsc = 'AREA_KEY_ISSUANCES_BY_AREA_ID__COUNT_ASC',
  AreaKeyIssuancesByAreaIdCountDesc = 'AREA_KEY_ISSUANCES_BY_AREA_ID__COUNT_DESC',
  AreaKeyIssuanceNotesByAreaIdCountAsc = 'AREA_KEY_ISSUANCE_NOTES_BY_AREA_ID__COUNT_ASC',
  AreaKeyIssuanceNotesByAreaIdCountDesc = 'AREA_KEY_ISSUANCE_NOTES_BY_AREA_ID__COUNT_DESC',
  AreaNameExtrasByAreaIdCountAsc = 'AREA_NAME_EXTRAS_BY_AREA_ID__COUNT_ASC',
  AreaNameExtrasByAreaIdCountDesc = 'AREA_NAME_EXTRAS_BY_AREA_ID__COUNT_DESC',
  AreaNameKeyCadsByAreaIdCountAsc = 'AREA_NAME_KEY_CADS_BY_AREA_ID__COUNT_ASC',
  AreaNameKeyCadsByAreaIdCountDesc = 'AREA_NAME_KEY_CADS_BY_AREA_ID__COUNT_DESC',
  AreaNameKeyCafmsByAreaIdCountAsc = 'AREA_NAME_KEY_CAFMS_BY_AREA_ID__COUNT_ASC',
  AreaNameKeyCafmsByAreaIdCountDesc = 'AREA_NAME_KEY_CAFMS_BY_AREA_ID__COUNT_DESC',
  AreaNameKeyEbmsByAreaIdCountAsc = 'AREA_NAME_KEY_EBMS_BY_AREA_ID__COUNT_ASC',
  AreaNameKeyEbmsByAreaIdCountDesc = 'AREA_NAME_KEY_EBMS_BY_AREA_ID__COUNT_DESC',
  AreaNameKeyMarketingsByAreaIdCountAsc = 'AREA_NAME_KEY_MARKETINGS_BY_AREA_ID__COUNT_ASC',
  AreaNameKeyMarketingsByAreaIdCountDesc = 'AREA_NAME_KEY_MARKETINGS_BY_AREA_ID__COUNT_DESC',
  AreaNameLongsByAreaIdCountAsc = 'AREA_NAME_LONGS_BY_AREA_ID__COUNT_ASC',
  AreaNameLongsByAreaIdCountDesc = 'AREA_NAME_LONGS_BY_AREA_ID__COUNT_DESC',
  AreaNameShortsByAreaIdCountAsc = 'AREA_NAME_SHORTS_BY_AREA_ID__COUNT_ASC',
  AreaNameShortsByAreaIdCountDesc = 'AREA_NAME_SHORTS_BY_AREA_ID__COUNT_DESC',
  AreaPublicGrossSpacesByAreaIdCountAsc = 'AREA_PUBLIC_GROSS_SPACES_BY_AREA_ID__COUNT_ASC',
  AreaPublicGrossSpacesByAreaIdCountDesc = 'AREA_PUBLIC_GROSS_SPACES_BY_AREA_ID__COUNT_DESC',
  AreaTypeAttrsByAreaIdCountAsc = 'AREA_TYPE_ATTRS_BY_AREA_ID__COUNT_ASC',
  AreaTypeAttrsByAreaIdCountDesc = 'AREA_TYPE_ATTRS_BY_AREA_ID__COUNT_DESC',
  AreaTypeByTypeIdDescriptionAsc = 'AREA_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  AreaTypeByTypeIdDescriptionDesc = 'AREA_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  AreaTypeByTypeIdIdAsc = 'AREA_TYPE_BY_TYPE_ID__ID_ASC',
  AreaTypeByTypeIdIdDesc = 'AREA_TYPE_BY_TYPE_ID__ID_DESC',
  AreaTypeByTypeIdIndexAsc = 'AREA_TYPE_BY_TYPE_ID__INDEX_ASC',
  AreaTypeByTypeIdIndexDesc = 'AREA_TYPE_BY_TYPE_ID__INDEX_DESC',
  AreaTypeByTypeIdNameAsc = 'AREA_TYPE_BY_TYPE_ID__NAME_ASC',
  AreaTypeByTypeIdNameDesc = 'AREA_TYPE_BY_TYPE_ID__NAME_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PlotsByAreaIdCountAsc = 'PLOTS_BY_AREA_ID__COUNT_ASC',
  PlotsByAreaIdCountDesc = 'PLOTS_BY_AREA_ID__COUNT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationAreasByAreaIdCountAsc = 'PROJECT_ALLOCATION_AREAS_BY_AREA_ID__COUNT_ASC',
  ProjectAllocationAreasByAreaIdCountDesc = 'PROJECT_ALLOCATION_AREAS_BY_AREA_ID__COUNT_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type Building = {
  __typename?: 'Building';
  /** Reads and enables pagination through a set of `BuildingDescription`. */
  buildingDescriptions: BuildingDescriptionsConnection;
  /** Reads and enables pagination through a set of `BuildingNameExtra`. */
  buildingNameExtras: BuildingNameExtrasConnection;
  /** Reads and enables pagination through a set of `BuildingNameKeyCad`. */
  buildingNameKeyCads: BuildingNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `BuildingNameKeyCafm`. */
  buildingNameKeyCafms: BuildingNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `BuildingNameKeyEbm`. */
  buildingNameKeyEbms: BuildingNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `BuildingNameKeyMarketing`. */
  buildingNameKeyMarketings: BuildingNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `BuildingNameLong`. */
  buildingNameLongs: BuildingNameLongsConnection;
  /** Reads and enables pagination through a set of `BuildingNameShort`. */
  buildingNameShorts: BuildingNameShortsConnection;
  /** Reads and enables pagination through a set of `BuildingPublicGrossSpace`. */
  buildingPublicGrossSpaces: BuildingPublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `BuildingTypeAttr`. */
  buildingTypeAttrs: BuildingTypeAttrsConnection;
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Level`. */
  levels: LevelsConnection;
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `Site` that is related to this `Building`. */
  site: Site;
  siteId: Scalars['UUID'];
  /** Reads a single `BuildingType` that is related to this `Building`. */
  type?: Maybe<BuildingType>;
  typeId?: Maybe<Scalars['UUID']>;
};


export type BuildingBuildingDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingDescriptionCondition>;
  filter?: InputMaybe<BuildingDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingDescriptionsOrderBy>>;
};


export type BuildingBuildingNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameExtraCondition>;
  filter?: InputMaybe<BuildingNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameExtrasOrderBy>>;
};


export type BuildingBuildingNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyCadCondition>;
  filter?: InputMaybe<BuildingNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyCadsOrderBy>>;
};


export type BuildingBuildingNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyCafmCondition>;
  filter?: InputMaybe<BuildingNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyCafmsOrderBy>>;
};


export type BuildingBuildingNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyEbmCondition>;
  filter?: InputMaybe<BuildingNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyEbmsOrderBy>>;
};


export type BuildingBuildingNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyMarketingCondition>;
  filter?: InputMaybe<BuildingNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyMarketingsOrderBy>>;
};


export type BuildingBuildingNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameLongCondition>;
  filter?: InputMaybe<BuildingNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameLongsOrderBy>>;
};


export type BuildingBuildingNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameShortCondition>;
  filter?: InputMaybe<BuildingNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameShortsOrderBy>>;
};


export type BuildingBuildingPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingPublicGrossSpaceCondition>;
  filter?: InputMaybe<BuildingPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingPublicGrossSpacesOrderBy>>;
};


export type BuildingBuildingTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingTypeAttrCondition>;
  filter?: InputMaybe<BuildingTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingTypeAttrsOrderBy>>;
};


export type BuildingLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelCondition>;
  filter?: InputMaybe<LevelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};

/** The fields on `building` to look up the row to connect. */
export type BuildingBuildingExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to delete. */
export type BuildingBuildingExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to connect. */
export type BuildingBuildingNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `building` to look up the row to delete. */
export type BuildingBuildingNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `building` to look up the row to connect. */
export type BuildingBuildingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `building` to look up the row to delete. */
export type BuildingBuildingPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `building` to look up the row to connect. */
export type BuildingBuildingSiteIdIdKeyConnect = {
  id: Scalars['UUID'];
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to delete. */
export type BuildingBuildingSiteIdIdKeyDelete = {
  id: Scalars['UUID'];
  siteId: Scalars['UUID'];
};

/**
 * A condition to be used against `Building` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BuildingCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type BuildingDescription = {
  __typename?: 'BuildingDescription';
  /** Reads a single `Building` that is related to this `BuildingDescription`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingDescription` to look up the row to connect. */
export type BuildingDescriptionBuildingDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingDescription` to look up the row to delete. */
export type BuildingDescriptionBuildingDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `building` to be created by this mutation. */
export type BuildingDescriptionBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingDescription` to be created by this mutation. */
export type BuildingDescriptionBuildingIdFkeyBuildingDescriptionCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingDescriptionInput` mutation. */
export type BuildingDescriptionBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingDescriptionBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingDescription` in the `BuildingInput` mutation. */
export type BuildingDescriptionBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingDescriptionBuildingDescriptionPkeyConnect>>;
  /** A `BuildingDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingDescriptionBuildingIdFkeyBuildingDescriptionCreateInput>>;
  /** The primary key(s) for `buildingDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingDescriptionBuildingDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `buildingDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingDescriptionOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingDescriptionPkeyUpdate>>;
};

/**
 * A condition to be used against `BuildingDescription` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BuildingDescriptionCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingDescription` object types. All fields are combined with a logical ‘and.’ */
export type BuildingDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingDescriptionFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingDescriptionFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingDescription` */
export type BuildingDescriptionInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingDescription` to look up the row to update. */
export type BuildingDescriptionOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingDescription` being updated. */
  patch: UpdateBuildingDescriptionOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingDescription`. Fields that are set will be updated. */
export type BuildingDescriptionPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingDescription` values. */
export type BuildingDescriptionsConnection = {
  __typename?: 'BuildingDescriptionsConnection';
  /** A list of edges which contains the `BuildingDescription` and cursor to aid in pagination. */
  edges: Array<BuildingDescriptionsEdge>;
  /** A list of `BuildingDescription` objects. */
  nodes: Array<BuildingDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingDescription` edge in the connection. */
export type BuildingDescriptionsEdge = {
  __typename?: 'BuildingDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingDescription` at the end of the edge. */
  node: BuildingDescription;
};

/** Methods to use when ordering `BuildingDescription`. */
export enum BuildingDescriptionsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against `Building` object types. All fields are combined with a logical ‘and.’ */
export type BuildingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingFilter>>;
  /** Filter by the object’s `buildingDescriptions` relation. */
  buildingDescriptions?: InputMaybe<BuildingToManyBuildingDescriptionFilter>;
  /** Some related `buildingDescriptions` exist. */
  buildingDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameExtras` relation. */
  buildingNameExtras?: InputMaybe<BuildingToManyBuildingNameExtraFilter>;
  /** Some related `buildingNameExtras` exist. */
  buildingNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameKeyCads` relation. */
  buildingNameKeyCads?: InputMaybe<BuildingToManyBuildingNameKeyCadFilter>;
  /** Some related `buildingNameKeyCads` exist. */
  buildingNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameKeyCafms` relation. */
  buildingNameKeyCafms?: InputMaybe<BuildingToManyBuildingNameKeyCafmFilter>;
  /** Some related `buildingNameKeyCafms` exist. */
  buildingNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameKeyEbms` relation. */
  buildingNameKeyEbms?: InputMaybe<BuildingToManyBuildingNameKeyEbmFilter>;
  /** Some related `buildingNameKeyEbms` exist. */
  buildingNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameKeyMarketings` relation. */
  buildingNameKeyMarketings?: InputMaybe<BuildingToManyBuildingNameKeyMarketingFilter>;
  /** Some related `buildingNameKeyMarketings` exist. */
  buildingNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameLongs` relation. */
  buildingNameLongs?: InputMaybe<BuildingToManyBuildingNameLongFilter>;
  /** Some related `buildingNameLongs` exist. */
  buildingNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingNameShorts` relation. */
  buildingNameShorts?: InputMaybe<BuildingToManyBuildingNameShortFilter>;
  /** Some related `buildingNameShorts` exist. */
  buildingNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingPublicGrossSpaces` relation. */
  buildingPublicGrossSpaces?: InputMaybe<BuildingToManyBuildingPublicGrossSpaceFilter>;
  /** Some related `buildingPublicGrossSpaces` exist. */
  buildingPublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingTypeAttrs` relation. */
  buildingTypeAttrs?: InputMaybe<BuildingToManyBuildingTypeAttrFilter>;
  /** Some related `buildingTypeAttrs` exist. */
  buildingTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `levels` relation. */
  levels?: InputMaybe<BuildingToManyLevelFilter>;
  /** Some related `levels` exist. */
  levelsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<BuildingTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Building` */
export type BuildingInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type BuildingNameExtra = {
  __typename?: 'BuildingNameExtra';
  /** Reads a single `Building` that is related to this `BuildingNameExtra`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `building` to be created by this mutation. */
export type BuildingNameExtraBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameExtra` to be created by this mutation. */
export type BuildingNameExtraBuildingIdFkeyBuildingNameExtraCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameExtraInput` mutation. */
export type BuildingNameExtraBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameExtraBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameExtra` in the `BuildingInput` mutation. */
export type BuildingNameExtraBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameExtraBuildingNameExtraPkeyConnect>>;
  /** A `BuildingNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameExtraBuildingIdFkeyBuildingNameExtraCreateInput>>;
  /** The primary key(s) for `buildingNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameExtraBuildingNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameExtraOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingNameExtraPkeyUpdate>>;
};

/** The fields on `buildingNameExtra` to look up the row to connect. */
export type BuildingNameExtraBuildingNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameExtra` to look up the row to delete. */
export type BuildingNameExtraBuildingNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameExtraCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameExtraFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameExtraFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameExtra` */
export type BuildingNameExtraInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameExtra` to look up the row to update. */
export type BuildingNameExtraOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameExtra` being updated. */
  patch: UpdateBuildingNameExtraOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameExtra`. Fields that are set will be updated. */
export type BuildingNameExtraPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingNameExtra` values. */
export type BuildingNameExtrasConnection = {
  __typename?: 'BuildingNameExtrasConnection';
  /** A list of edges which contains the `BuildingNameExtra` and cursor to aid in pagination. */
  edges: Array<BuildingNameExtrasEdge>;
  /** A list of `BuildingNameExtra` objects. */
  nodes: Array<BuildingNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameExtra` edge in the connection. */
export type BuildingNameExtrasEdge = {
  __typename?: 'BuildingNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameExtra` at the end of the edge. */
  node: BuildingNameExtra;
};

/** Methods to use when ordering `BuildingNameExtra`. */
export enum BuildingNameExtrasOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type BuildingNameKeyCad = {
  __typename?: 'BuildingNameKeyCad';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCad`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `building` to be created by this mutation. */
export type BuildingNameKeyCadBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameKeyCad` to be created by this mutation. */
export type BuildingNameKeyCadBuildingIdFkeyBuildingNameKeyCadCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameKeyCadInput` mutation. */
export type BuildingNameKeyCadBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameKeyCad` in the `BuildingInput` mutation. */
export type BuildingNameKeyCadBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameKeyCadBuildingNameKeyCadPkeyConnect>>;
  /** A `BuildingNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameKeyCadBuildingIdFkeyBuildingNameKeyCadCreateInput>>;
  /** The primary key(s) for `buildingNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameKeyCadBuildingNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameKeyCadOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingNameKeyCadPkeyUpdate>>;
};

/** The fields on `buildingNameKeyCad` to look up the row to connect. */
export type BuildingNameKeyCadBuildingNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameKeyCad` to look up the row to delete. */
export type BuildingNameKeyCadBuildingNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameKeyCadCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameKeyCadFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameKeyCadFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameKeyCad` */
export type BuildingNameKeyCadInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameKeyCad` to look up the row to update. */
export type BuildingNameKeyCadOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameKeyCad` being updated. */
  patch: UpdateBuildingNameKeyCadOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameKeyCad`. Fields that are set will be updated. */
export type BuildingNameKeyCadPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingNameKeyCad` values. */
export type BuildingNameKeyCadsConnection = {
  __typename?: 'BuildingNameKeyCadsConnection';
  /** A list of edges which contains the `BuildingNameKeyCad` and cursor to aid in pagination. */
  edges: Array<BuildingNameKeyCadsEdge>;
  /** A list of `BuildingNameKeyCad` objects. */
  nodes: Array<BuildingNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameKeyCad` edge in the connection. */
export type BuildingNameKeyCadsEdge = {
  __typename?: 'BuildingNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameKeyCad` at the end of the edge. */
  node: BuildingNameKeyCad;
};

/** Methods to use when ordering `BuildingNameKeyCad`. */
export enum BuildingNameKeyCadsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type BuildingNameKeyCafm = {
  __typename?: 'BuildingNameKeyCafm';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCafm`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `building` to be created by this mutation. */
export type BuildingNameKeyCafmBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameKeyCafm` to be created by this mutation. */
export type BuildingNameKeyCafmBuildingIdFkeyBuildingNameKeyCafmCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameKeyCafmInput` mutation. */
export type BuildingNameKeyCafmBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameKeyCafm` in the `BuildingInput` mutation. */
export type BuildingNameKeyCafmBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameKeyCafmBuildingNameKeyCafmPkeyConnect>>;
  /** A `BuildingNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameKeyCafmBuildingIdFkeyBuildingNameKeyCafmCreateInput>>;
  /** The primary key(s) for `buildingNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameKeyCafmBuildingNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameKeyCafmOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingNameKeyCafmPkeyUpdate>>;
};

/** The fields on `buildingNameKeyCafm` to look up the row to connect. */
export type BuildingNameKeyCafmBuildingNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameKeyCafm` to look up the row to delete. */
export type BuildingNameKeyCafmBuildingNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameKeyCafm` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameKeyCafmCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameKeyCafmFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameKeyCafmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameKeyCafm` */
export type BuildingNameKeyCafmInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameKeyCafm` to look up the row to update. */
export type BuildingNameKeyCafmOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameKeyCafm` being updated. */
  patch: UpdateBuildingNameKeyCafmOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameKeyCafm`. Fields that are set will be updated. */
export type BuildingNameKeyCafmPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingNameKeyCafm` values. */
export type BuildingNameKeyCafmsConnection = {
  __typename?: 'BuildingNameKeyCafmsConnection';
  /** A list of edges which contains the `BuildingNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<BuildingNameKeyCafmsEdge>;
  /** A list of `BuildingNameKeyCafm` objects. */
  nodes: Array<BuildingNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameKeyCafm` edge in the connection. */
export type BuildingNameKeyCafmsEdge = {
  __typename?: 'BuildingNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameKeyCafm` at the end of the edge. */
  node: BuildingNameKeyCafm;
};

/** Methods to use when ordering `BuildingNameKeyCafm`. */
export enum BuildingNameKeyCafmsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type BuildingNameKeyEbm = {
  __typename?: 'BuildingNameKeyEbm';
  /** Reads a single `Building` that is related to this `BuildingNameKeyEbm`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameKeyEbm` to look up the row to connect. */
export type BuildingNameKeyEbmBuildingNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameKeyEbm` to look up the row to delete. */
export type BuildingNameKeyEbmBuildingNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameKeyEbmCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameKeyEbmFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameKeyEbmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameKeyEbm` */
export type BuildingNameKeyEbmInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameKeyEbm` to look up the row to update. */
export type BuildingNameKeyEbmOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameKeyEbm` being updated. */
  patch: UpdateBuildingNameKeyEbmOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameKeyEbm`. Fields that are set will be updated. */
export type BuildingNameKeyEbmPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `building` to be created by this mutation. */
export type BuildingNameKeyEbmsBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameKeyEbm` to be created by this mutation. */
export type BuildingNameKeyEbmsBuildingIdFkeyBuildingNameKeyEbmsCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameKeyEbmInput` mutation. */
export type BuildingNameKeyEbmsBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameKeyEbm` in the `BuildingInput` mutation. */
export type BuildingNameKeyEbmsBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameKeyEbmBuildingNameKeyEbmsPkeyConnect>>;
  /** A `BuildingNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameKeyEbmsBuildingIdFkeyBuildingNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `buildingNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameKeyEbmBuildingNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameKeyEbmOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingNameKeyEbmsPkeyUpdate>>;
};

/** A connection to a list of `BuildingNameKeyEbm` values. */
export type BuildingNameKeyEbmsConnection = {
  __typename?: 'BuildingNameKeyEbmsConnection';
  /** A list of edges which contains the `BuildingNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<BuildingNameKeyEbmsEdge>;
  /** A list of `BuildingNameKeyEbm` objects. */
  nodes: Array<BuildingNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameKeyEbm` edge in the connection. */
export type BuildingNameKeyEbmsEdge = {
  __typename?: 'BuildingNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameKeyEbm` at the end of the edge. */
  node: BuildingNameKeyEbm;
};

/** Methods to use when ordering `BuildingNameKeyEbm`. */
export enum BuildingNameKeyEbmsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type BuildingNameKeyMarketing = {
  __typename?: 'BuildingNameKeyMarketing';
  /** Reads a single `Building` that is related to this `BuildingNameKeyMarketing`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `building` to be created by this mutation. */
export type BuildingNameKeyMarketingBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameKeyMarketing` to be created by this mutation. */
export type BuildingNameKeyMarketingBuildingIdFkeyBuildingNameKeyMarketingCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameKeyMarketingInput` mutation. */
export type BuildingNameKeyMarketingBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameKeyMarketing` in the `BuildingInput` mutation. */
export type BuildingNameKeyMarketingBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameKeyMarketingBuildingNameKeyMarketingPkeyConnect>>;
  /** A `BuildingNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameKeyMarketingBuildingIdFkeyBuildingNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `buildingNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameKeyMarketingBuildingNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameKeyMarketingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingNameKeyMarketingPkeyUpdate>>;
};

/** The fields on `buildingNameKeyMarketing` to look up the row to connect. */
export type BuildingNameKeyMarketingBuildingNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameKeyMarketing` to look up the row to delete. */
export type BuildingNameKeyMarketingBuildingNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameKeyMarketing` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameKeyMarketingFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameKeyMarketingFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameKeyMarketing` */
export type BuildingNameKeyMarketingInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameKeyMarketing` to look up the row to update. */
export type BuildingNameKeyMarketingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameKeyMarketing` being updated. */
  patch: UpdateBuildingNameKeyMarketingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameKeyMarketing`. Fields that are set will be updated. */
export type BuildingNameKeyMarketingPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingNameKeyMarketing` values. */
export type BuildingNameKeyMarketingsConnection = {
  __typename?: 'BuildingNameKeyMarketingsConnection';
  /** A list of edges which contains the `BuildingNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<BuildingNameKeyMarketingsEdge>;
  /** A list of `BuildingNameKeyMarketing` objects. */
  nodes: Array<BuildingNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameKeyMarketing` edge in the connection. */
export type BuildingNameKeyMarketingsEdge = {
  __typename?: 'BuildingNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameKeyMarketing` at the end of the edge. */
  node: BuildingNameKeyMarketing;
};

/** Methods to use when ordering `BuildingNameKeyMarketing`. */
export enum BuildingNameKeyMarketingsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type BuildingNameLong = {
  __typename?: 'BuildingNameLong';
  /** Reads a single `Building` that is related to this `BuildingNameLong`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `building` to be created by this mutation. */
export type BuildingNameLongBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameLong` to be created by this mutation. */
export type BuildingNameLongBuildingIdFkeyBuildingNameLongCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameLongInput` mutation. */
export type BuildingNameLongBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameLongBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameLong` in the `BuildingInput` mutation. */
export type BuildingNameLongBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameLongBuildingNameLongPkeyConnect>>;
  /** A `BuildingNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameLongBuildingIdFkeyBuildingNameLongCreateInput>>;
  /** The primary key(s) for `buildingNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameLongBuildingNameLongPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameLongOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingNameLongPkeyUpdate>>;
};

/** The fields on `buildingNameLong` to look up the row to connect. */
export type BuildingNameLongBuildingNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameLong` to look up the row to delete. */
export type BuildingNameLongBuildingNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameLongCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameLong` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameLongFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameLongFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameLong` */
export type BuildingNameLongInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameLong` to look up the row to update. */
export type BuildingNameLongOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameLong` being updated. */
  patch: UpdateBuildingNameLongOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameLong`. Fields that are set will be updated. */
export type BuildingNameLongPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingNameLong` values. */
export type BuildingNameLongsConnection = {
  __typename?: 'BuildingNameLongsConnection';
  /** A list of edges which contains the `BuildingNameLong` and cursor to aid in pagination. */
  edges: Array<BuildingNameLongsEdge>;
  /** A list of `BuildingNameLong` objects. */
  nodes: Array<BuildingNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameLong` edge in the connection. */
export type BuildingNameLongsEdge = {
  __typename?: 'BuildingNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameLong` at the end of the edge. */
  node: BuildingNameLong;
};

/** Methods to use when ordering `BuildingNameLong`. */
export enum BuildingNameLongsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type BuildingNameShort = {
  __typename?: 'BuildingNameShort';
  /** Reads a single `Building` that is related to this `BuildingNameShort`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `building` to be created by this mutation. */
export type BuildingNameShortBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingNameShort` to be created by this mutation. */
export type BuildingNameShortBuildingIdFkeyBuildingNameShortCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `building` in the `BuildingNameShortInput` mutation. */
export type BuildingNameShortBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingNameShortBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingNameShort` in the `BuildingInput` mutation. */
export type BuildingNameShortBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingNameShortBuildingNameShortPkeyConnect>>;
  /** A `BuildingNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingNameShortBuildingIdFkeyBuildingNameShortCreateInput>>;
  /** The primary key(s) for `buildingNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingNameShortBuildingNameShortPkeyDelete>>;
  /** Flag indicating whether all other `buildingNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingNameShortOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingNameShortPkeyUpdate>>;
};

/** The fields on `buildingNameShort` to look up the row to connect. */
export type BuildingNameShortBuildingNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingNameShort` to look up the row to delete. */
export type BuildingNameShortBuildingNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingNameShortCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingNameShort` object types. All fields are combined with a logical ‘and.’ */
export type BuildingNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingNameShortFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingNameShortFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingNameShort` */
export type BuildingNameShortInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `buildingNameShort` to look up the row to update. */
export type BuildingNameShortOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingNameShort` being updated. */
  patch: UpdateBuildingNameShortOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingNameShort`. Fields that are set will be updated. */
export type BuildingNameShortPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `BuildingNameShort` values. */
export type BuildingNameShortsConnection = {
  __typename?: 'BuildingNameShortsConnection';
  /** A list of edges which contains the `BuildingNameShort` and cursor to aid in pagination. */
  edges: Array<BuildingNameShortsEdge>;
  /** A list of `BuildingNameShort` objects. */
  nodes: Array<BuildingNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingNameShort` edge in the connection. */
export type BuildingNameShortsEdge = {
  __typename?: 'BuildingNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingNameShort` at the end of the edge. */
  node: BuildingNameShort;
};

/** Methods to use when ordering `BuildingNameShort`. */
export enum BuildingNameShortsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingSiteIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingSiteIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingSiteIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingSiteIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingTypeIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingTypeIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingTypeIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingForBuildingTypeIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnLevelForLevelBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnLevelForLevelBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnLevelForLevelBuildingIdFkeyPatch;
};

/** The fields on `building` to look up the row to update. */
export type BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `building` being updated. */
  patch: UpdateBuildingOnLevelForLevelBuildingIdFkeyPatch;
  siteId: Scalars['UUID'];
};

/** Represents an update to a `Building`. Fields that are set will be updated. */
export type BuildingPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type BuildingPublicGrossSpace = {
  __typename?: 'BuildingPublicGrossSpace';
  /** Reads a single `Building` that is related to this `BuildingPublicGrossSpace`. */
  building: Building;
  buildingId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `building` to be created by this mutation. */
export type BuildingPublicGrossSpaceBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingPublicGrossSpace` to be created by this mutation. */
export type BuildingPublicGrossSpaceBuildingIdFkeyBuildingPublicGrossSpaceCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** Input for the nested mutation of `building` in the `BuildingPublicGrossSpaceInput` mutation. */
export type BuildingPublicGrossSpaceBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingPublicGrossSpace` in the `BuildingInput` mutation. */
export type BuildingPublicGrossSpaceBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingPublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingPublicGrossSpaceBuildingPublicGrossSpacePkeyConnect>>;
  /** A `BuildingPublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingPublicGrossSpaceBuildingIdFkeyBuildingPublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `buildingPublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingPublicGrossSpaceBuildingPublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `buildingPublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingPublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingPublicGrossSpaceOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingPublicGrossSpacePkeyUpdate>>;
};

/** The fields on `buildingPublicGrossSpace` to look up the row to connect. */
export type BuildingPublicGrossSpaceBuildingPublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingPublicGrossSpace` to look up the row to delete. */
export type BuildingPublicGrossSpaceBuildingPublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingPublicGrossSpace` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BuildingPublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `BuildingPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type BuildingPublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingPublicGrossSpaceFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingPublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingPublicGrossSpaceFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `BuildingPublicGrossSpace` */
export type BuildingPublicGrossSpaceInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `buildingPublicGrossSpace` to look up the row to update. */
export type BuildingPublicGrossSpaceOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyUsingBuildingPublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingPublicGrossSpace` being updated. */
  patch: UpdateBuildingPublicGrossSpaceOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch;
};

/** Represents an update to a `BuildingPublicGrossSpace`. Fields that are set will be updated. */
export type BuildingPublicGrossSpacePatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `BuildingPublicGrossSpace` values. */
export type BuildingPublicGrossSpacesConnection = {
  __typename?: 'BuildingPublicGrossSpacesConnection';
  /** A list of edges which contains the `BuildingPublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<BuildingPublicGrossSpacesEdge>;
  /** A list of `BuildingPublicGrossSpace` objects. */
  nodes: Array<BuildingPublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingPublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingPublicGrossSpace` edge in the connection. */
export type BuildingPublicGrossSpacesEdge = {
  __typename?: 'BuildingPublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingPublicGrossSpace` at the end of the edge. */
  node: BuildingPublicGrossSpace;
};

/** Methods to use when ordering `BuildingPublicGrossSpace`. */
export enum BuildingPublicGrossSpacesOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The `building` to be created by this mutation. */
export type BuildingSiteIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `site` in the `BuildingInput` mutation. */
export type BuildingSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnBuildingForBuildingSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnBuildingForBuildingSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnBuildingForBuildingSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `building` in the `SiteInput` mutation. */
export type BuildingSiteIdFkeyInverseInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<BuildingBuildingExtIdKeyConnect>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingBuildingPkeyConnect>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<Array<BuildingBuildingSiteIdIdKeyConnect>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<BuildingBuildingNameShortKeyConnect>>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingSiteIdFkeyBuildingCreateInput>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<BuildingBuildingExtIdKeyDelete>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingBuildingPkeyDelete>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<Array<BuildingBuildingSiteIdIdKeyDelete>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<BuildingBuildingNameShortKeyDelete>>;
  /** Flag indicating whether all other `building` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingPkeyUpdate>>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<Array<BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingSiteIdIdKeyUpdate>>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<BuildingOnBuildingForBuildingSiteIdFkeyUsingBuildingNameShortKeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type BuildingSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** A filter to be used against many `BuildingDescription` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingDescriptionFilter = {
  /** Every related `BuildingDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingDescriptionFilter>;
  /** No related `BuildingDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingDescriptionFilter>;
  /** Some related `BuildingDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingDescriptionFilter>;
};

/** A filter to be used against many `BuildingNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameExtraFilter = {
  /** Every related `BuildingNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameExtraFilter>;
  /** No related `BuildingNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameExtraFilter>;
  /** Some related `BuildingNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameExtraFilter>;
};

/** A filter to be used against many `BuildingNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameKeyCadFilter = {
  /** Every related `BuildingNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameKeyCadFilter>;
  /** No related `BuildingNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameKeyCadFilter>;
  /** Some related `BuildingNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameKeyCadFilter>;
};

/** A filter to be used against many `BuildingNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameKeyCafmFilter = {
  /** Every related `BuildingNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameKeyCafmFilter>;
  /** No related `BuildingNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameKeyCafmFilter>;
  /** Some related `BuildingNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameKeyCafmFilter>;
};

/** A filter to be used against many `BuildingNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameKeyEbmFilter = {
  /** Every related `BuildingNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameKeyEbmFilter>;
  /** No related `BuildingNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameKeyEbmFilter>;
  /** Some related `BuildingNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameKeyEbmFilter>;
};

/** A filter to be used against many `BuildingNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameKeyMarketingFilter = {
  /** Every related `BuildingNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameKeyMarketingFilter>;
  /** No related `BuildingNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameKeyMarketingFilter>;
  /** Some related `BuildingNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameKeyMarketingFilter>;
};

/** A filter to be used against many `BuildingNameLong` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameLongFilter = {
  /** Every related `BuildingNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameLongFilter>;
  /** No related `BuildingNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameLongFilter>;
  /** Some related `BuildingNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameLongFilter>;
};

/** A filter to be used against many `BuildingNameShort` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingNameShortFilter = {
  /** Every related `BuildingNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingNameShortFilter>;
  /** No related `BuildingNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingNameShortFilter>;
  /** Some related `BuildingNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingNameShortFilter>;
};

/** A filter to be used against many `BuildingPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingPublicGrossSpaceFilter = {
  /** Every related `BuildingPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingPublicGrossSpaceFilter>;
  /** No related `BuildingPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingPublicGrossSpaceFilter>;
  /** Some related `BuildingPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingPublicGrossSpaceFilter>;
};

/** A filter to be used against many `BuildingTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyBuildingTypeAttrFilter = {
  /** Every related `BuildingTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingTypeAttrFilter>;
  /** No related `BuildingTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingTypeAttrFilter>;
  /** Some related `BuildingTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingTypeAttrFilter>;
};

/** A filter to be used against many `Level` object types. All fields are combined with a logical ‘and.’ */
export type BuildingToManyLevelFilter = {
  /** Every related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelFilter>;
  /** No related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelFilter>;
  /** Some related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelFilter>;
};

export type BuildingType = {
  __typename?: 'BuildingType';
  /** Reads and enables pagination through a set of `BuildingTypeAttr`. */
  buildingTypeAttrs: BuildingTypeAttrsConnection;
  /** Reads and enables pagination through a set of `Building`. */
  buildingsByTypeId: BuildingsConnection;
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  name: Scalars['String'];
};


export type BuildingTypeBuildingTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingTypeAttrCondition>;
  filter?: InputMaybe<BuildingTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingTypeAttrsOrderBy>>;
};


export type BuildingTypeBuildingsByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingCondition>;
  filter?: InputMaybe<BuildingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingsOrderBy>>;
};

export type BuildingTypeAttr = {
  __typename?: 'BuildingTypeAttr';
  /** Reads a single `Building` that is related to this `BuildingTypeAttr`. */
  building: Building;
  buildingId: Scalars['UUID'];
  /** Reads a single `BuildingType` that is related to this `BuildingTypeAttr`. */
  buildingType: BuildingType;
  buildingTypeId: Scalars['UUID'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
};

/** The `building` to be created by this mutation. */
export type BuildingTypeAttrBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `buildingTypeAttr` to be created by this mutation. */
export type BuildingTypeAttrBuildingIdFkeyBuildingTypeAttrCreateInput = {
  buildingToBuildingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInput>;
  buildingTypeId?: InputMaybe<Scalars['UUID']>;
  buildingTypeToBuildingTypeId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `building` in the `BuildingTypeAttrInput` mutation. */
export type BuildingTypeAttrBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingTypeAttrBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `buildingTypeAttr` in the `BuildingInput` mutation. */
export type BuildingTypeAttrBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `buildingTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingTypeAttrBuildingTypeAttrPkeyConnect>>;
  /** A `BuildingTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingTypeAttrBuildingIdFkeyBuildingTypeAttrCreateInput>>;
  /** The primary key(s) for `buildingTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingTypeAttrBuildingTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `buildingTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingTypeAttrPkeyUpdate>>;
};

/** The fields on `buildingTypeAttr` to look up the row to connect. */
export type BuildingTypeAttrBuildingTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingTypeAttr` to look up the row to delete. */
export type BuildingTypeAttrBuildingTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `buildingTypeAttr` to be created by this mutation. */
export type BuildingTypeAttrBuildingTypeIdFkeyBuildingTypeAttrCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInput>;
  buildingTypeToBuildingTypeId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `buildingType` to be created by this mutation. */
export type BuildingTypeAttrBuildingTypeIdFkeyBuildingTypeCreateInput = {
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInverseInput>;
  buildingsUsingId?: InputMaybe<BuildingTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `buildingType` in the `BuildingTypeAttrInput` mutation. */
export type BuildingTypeAttrBuildingTypeIdFkeyInput = {
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingTypeBuildingTypePkeyConnect>;
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  connectByName?: InputMaybe<BuildingTypeBuildingTypeNameKeyConnect>;
  /** A `BuildingTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyBuildingTypeCreateInput>;
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingTypeBuildingTypePkeyDelete>;
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  deleteByName?: InputMaybe<BuildingTypeBuildingTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `buildingType` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyUsingBuildingTypePkeyUpdate>;
  /** The primary key(s) and patch data for `buildingType` for the far side of the relationship. */
  updateByName?: InputMaybe<BuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyUsingBuildingTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `buildingTypeAttr` in the `BuildingTypeInput` mutation. */
export type BuildingTypeAttrBuildingTypeIdFkeyInverseInput = {
  /** The primary key(s) for `buildingTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingTypeAttrBuildingTypeAttrPkeyConnect>>;
  /** A `BuildingTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingTypeAttrBuildingTypeIdFkeyBuildingTypeAttrCreateInput>>;
  /** The primary key(s) for `buildingTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingTypeAttrBuildingTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `buildingTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `buildingTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyUsingBuildingTypeAttrPkeyUpdate>>;
};

/**
 * A condition to be used against `BuildingTypeAttr` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingTypeAttrCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `buildingTypeId` field. */
  buildingTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `BuildingTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type BuildingTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingTypeAttrFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `buildingType` relation. */
  buildingType?: InputMaybe<BuildingTypeFilter>;
  /** Filter by the object’s `buildingTypeId` field. */
  buildingTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingTypeAttrFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BuildingTypeAttr` */
export type BuildingTypeAttrInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInput>;
  buildingTypeId?: InputMaybe<Scalars['UUID']>;
  buildingTypeToBuildingTypeId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `buildingTypeAttr` to look up the row to update. */
export type BuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyUsingBuildingTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingTypeAttr` being updated. */
  patch: UpdateBuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch;
};

/** The fields on `buildingTypeAttr` to look up the row to update. */
export type BuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyUsingBuildingTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingTypeAttr` being updated. */
  patch: UpdateBuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyPatch;
};

/** Represents an update to a `BuildingTypeAttr`. Fields that are set will be updated. */
export type BuildingTypeAttrPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInput>;
  buildingTypeId?: InputMaybe<Scalars['UUID']>;
  buildingTypeToBuildingTypeId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `BuildingTypeAttr` values. */
export type BuildingTypeAttrsConnection = {
  __typename?: 'BuildingTypeAttrsConnection';
  /** A list of edges which contains the `BuildingTypeAttr` and cursor to aid in pagination. */
  edges: Array<BuildingTypeAttrsEdge>;
  /** A list of `BuildingTypeAttr` objects. */
  nodes: Array<BuildingTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingTypeAttr` edge in the connection. */
export type BuildingTypeAttrsEdge = {
  __typename?: 'BuildingTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingTypeAttr` at the end of the edge. */
  node: BuildingTypeAttr;
};

/** Methods to use when ordering `BuildingTypeAttr`. */
export enum BuildingTypeAttrsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  BuildingTypeByBuildingTypeIdDescriptionAsc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__DESCRIPTION_ASC',
  BuildingTypeByBuildingTypeIdDescriptionDesc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__DESCRIPTION_DESC',
  BuildingTypeByBuildingTypeIdIdAsc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__ID_ASC',
  BuildingTypeByBuildingTypeIdIdDesc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__ID_DESC',
  BuildingTypeByBuildingTypeIdIndexAsc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__INDEX_ASC',
  BuildingTypeByBuildingTypeIdIndexDesc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__INDEX_DESC',
  BuildingTypeByBuildingTypeIdNameAsc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__NAME_ASC',
  BuildingTypeByBuildingTypeIdNameDesc = 'BUILDING_TYPE_BY_BUILDING_TYPE_ID__NAME_DESC',
  BuildingTypeIdAsc = 'BUILDING_TYPE_ID_ASC',
  BuildingTypeIdDesc = 'BUILDING_TYPE_ID_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/** The fields on `buildingType` to look up the row to connect. */
export type BuildingTypeBuildingTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `buildingType` to look up the row to delete. */
export type BuildingTypeBuildingTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `buildingType` to look up the row to connect. */
export type BuildingTypeBuildingTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `buildingType` to look up the row to delete. */
export type BuildingTypeBuildingTypePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `BuildingType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BuildingType` object types. All fields are combined with a logical ‘and.’ */
export type BuildingTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingTypeFilter>>;
  /** Filter by the object’s `buildingTypeAttrs` relation. */
  buildingTypeAttrs?: InputMaybe<BuildingTypeToManyBuildingTypeAttrFilter>;
  /** Some related `buildingTypeAttrs` exist. */
  buildingTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `buildingsByTypeId` relation. */
  buildingsByTypeId?: InputMaybe<BuildingTypeToManyBuildingFilter>;
  /** Some related `buildingsByTypeId` exist. */
  buildingsByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingTypeFilter>>;
};

/** The `building` to be created by this mutation. */
export type BuildingTypeIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
};

/** The `buildingType` to be created by this mutation. */
export type BuildingTypeIdFkeyBuildingTypeCreateInput = {
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInverseInput>;
  buildingsUsingId?: InputMaybe<BuildingTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `buildingType` in the `BuildingInput` mutation. */
export type BuildingTypeIdFkeyInput = {
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingTypeBuildingTypePkeyConnect>;
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  connectByName?: InputMaybe<BuildingTypeBuildingTypeNameKeyConnect>;
  /** A `BuildingTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<BuildingTypeIdFkeyBuildingTypeCreateInput>;
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingTypeBuildingTypePkeyDelete>;
  /** The primary key(s) for `buildingType` for the far side of the relationship. */
  deleteByName?: InputMaybe<BuildingTypeBuildingTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `buildingType` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingTypeOnBuildingForBuildingTypeIdFkeyUsingBuildingTypePkeyUpdate>;
  /** The primary key(s) and patch data for `buildingType` for the far side of the relationship. */
  updateByName?: InputMaybe<BuildingTypeOnBuildingForBuildingTypeIdFkeyUsingBuildingTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `building` in the `BuildingTypeInput` mutation. */
export type BuildingTypeIdFkeyInverseInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<BuildingBuildingExtIdKeyConnect>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BuildingBuildingPkeyConnect>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<Array<BuildingBuildingSiteIdIdKeyConnect>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<BuildingBuildingNameShortKeyConnect>>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BuildingTypeIdFkeyBuildingCreateInput>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<BuildingBuildingExtIdKeyDelete>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<BuildingBuildingPkeyDelete>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<Array<BuildingBuildingSiteIdIdKeyDelete>>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<BuildingBuildingNameShortKeyDelete>>;
  /** Flag indicating whether all other `building` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<Array<BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingPkeyUpdate>>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<Array<BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingSiteIdIdKeyUpdate>>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<BuildingOnBuildingForBuildingTypeIdFkeyUsingBuildingNameShortKeyUpdate>>;
};

/** An input for mutations affecting `BuildingType` */
export type BuildingTypeInput = {
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInverseInput>;
  buildingsUsingId?: InputMaybe<BuildingTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** The fields on `buildingType` to look up the row to update. */
export type BuildingTypeOnBuildingForBuildingTypeIdFkeyUsingBuildingTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `buildingType` being updated. */
  patch: UpdateBuildingTypeOnBuildingForBuildingTypeIdFkeyPatch;
};

/** The fields on `buildingType` to look up the row to update. */
export type BuildingTypeOnBuildingForBuildingTypeIdFkeyUsingBuildingTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingType` being updated. */
  patch: UpdateBuildingTypeOnBuildingForBuildingTypeIdFkeyPatch;
};

/** The fields on `buildingType` to look up the row to update. */
export type BuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyUsingBuildingTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `buildingType` being updated. */
  patch: UpdateBuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyPatch;
};

/** The fields on `buildingType` to look up the row to update. */
export type BuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyUsingBuildingTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `buildingType` being updated. */
  patch: UpdateBuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyPatch;
};

/** Represents an update to a `BuildingType`. Fields that are set will be updated. */
export type BuildingTypePatch = {
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInverseInput>;
  buildingsUsingId?: InputMaybe<BuildingTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `Building` object types. All fields are combined with a logical ‘and.’ */
export type BuildingTypeToManyBuildingFilter = {
  /** Every related `Building` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingFilter>;
  /** No related `Building` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingFilter>;
  /** Some related `Building` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingFilter>;
};

/** A filter to be used against many `BuildingTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type BuildingTypeToManyBuildingTypeAttrFilter = {
  /** Every related `BuildingTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingTypeAttrFilter>;
  /** No related `BuildingTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingTypeAttrFilter>;
  /** Some related `BuildingTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingTypeAttrFilter>;
};

/** A connection to a list of `BuildingType` values. */
export type BuildingTypesConnection = {
  __typename?: 'BuildingTypesConnection';
  /** A list of edges which contains the `BuildingType` and cursor to aid in pagination. */
  edges: Array<BuildingTypesEdge>;
  /** A list of `BuildingType` objects. */
  nodes: Array<BuildingType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BuildingType` edge in the connection. */
export type BuildingTypesEdge = {
  __typename?: 'BuildingTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BuildingType` at the end of the edge. */
  node: BuildingType;
};

/** Methods to use when ordering `BuildingType`. */
export enum BuildingTypesOrderBy {
  BuildingsByTypeIdCountAsc = 'BUILDINGS_BY_TYPE_ID__COUNT_ASC',
  BuildingsByTypeIdCountDesc = 'BUILDINGS_BY_TYPE_ID__COUNT_DESC',
  BuildingTypeAttrsByBuildingTypeIdCountAsc = 'BUILDING_TYPE_ATTRS_BY_BUILDING_TYPE_ID__COUNT_ASC',
  BuildingTypeAttrsByBuildingTypeIdCountDesc = 'BUILDING_TYPE_ATTRS_BY_BUILDING_TYPE_ID__COUNT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Building` values. */
export type BuildingsConnection = {
  __typename?: 'BuildingsConnection';
  /** A list of edges which contains the `Building` and cursor to aid in pagination. */
  edges: Array<BuildingsEdge>;
  /** A list of `Building` objects. */
  nodes: Array<Building>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Building` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Building` edge in the connection. */
export type BuildingsEdge = {
  __typename?: 'BuildingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Building` at the end of the edge. */
  node: Building;
};

/** Methods to use when ordering `Building`. */
export enum BuildingsOrderBy {
  BuildingDescriptionsByBuildingIdCountAsc = 'BUILDING_DESCRIPTIONS_BY_BUILDING_ID__COUNT_ASC',
  BuildingDescriptionsByBuildingIdCountDesc = 'BUILDING_DESCRIPTIONS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameExtrasByBuildingIdCountAsc = 'BUILDING_NAME_EXTRAS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameExtrasByBuildingIdCountDesc = 'BUILDING_NAME_EXTRAS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameKeyCadsByBuildingIdCountAsc = 'BUILDING_NAME_KEY_CADS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameKeyCadsByBuildingIdCountDesc = 'BUILDING_NAME_KEY_CADS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameKeyCafmsByBuildingIdCountAsc = 'BUILDING_NAME_KEY_CAFMS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameKeyCafmsByBuildingIdCountDesc = 'BUILDING_NAME_KEY_CAFMS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameKeyEbmsByBuildingIdCountAsc = 'BUILDING_NAME_KEY_EBMS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameKeyEbmsByBuildingIdCountDesc = 'BUILDING_NAME_KEY_EBMS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameKeyMarketingsByBuildingIdCountAsc = 'BUILDING_NAME_KEY_MARKETINGS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameKeyMarketingsByBuildingIdCountDesc = 'BUILDING_NAME_KEY_MARKETINGS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameLongsByBuildingIdCountAsc = 'BUILDING_NAME_LONGS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameLongsByBuildingIdCountDesc = 'BUILDING_NAME_LONGS_BY_BUILDING_ID__COUNT_DESC',
  BuildingNameShortsByBuildingIdCountAsc = 'BUILDING_NAME_SHORTS_BY_BUILDING_ID__COUNT_ASC',
  BuildingNameShortsByBuildingIdCountDesc = 'BUILDING_NAME_SHORTS_BY_BUILDING_ID__COUNT_DESC',
  BuildingPublicGrossSpacesByBuildingIdCountAsc = 'BUILDING_PUBLIC_GROSS_SPACES_BY_BUILDING_ID__COUNT_ASC',
  BuildingPublicGrossSpacesByBuildingIdCountDesc = 'BUILDING_PUBLIC_GROSS_SPACES_BY_BUILDING_ID__COUNT_DESC',
  BuildingTypeAttrsByBuildingIdCountAsc = 'BUILDING_TYPE_ATTRS_BY_BUILDING_ID__COUNT_ASC',
  BuildingTypeAttrsByBuildingIdCountDesc = 'BUILDING_TYPE_ATTRS_BY_BUILDING_ID__COUNT_DESC',
  BuildingTypeByTypeIdDescriptionAsc = 'BUILDING_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  BuildingTypeByTypeIdDescriptionDesc = 'BUILDING_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  BuildingTypeByTypeIdIdAsc = 'BUILDING_TYPE_BY_TYPE_ID__ID_ASC',
  BuildingTypeByTypeIdIdDesc = 'BUILDING_TYPE_BY_TYPE_ID__ID_DESC',
  BuildingTypeByTypeIdIndexAsc = 'BUILDING_TYPE_BY_TYPE_ID__INDEX_ASC',
  BuildingTypeByTypeIdIndexDesc = 'BUILDING_TYPE_BY_TYPE_ID__INDEX_DESC',
  BuildingTypeByTypeIdNameAsc = 'BUILDING_TYPE_BY_TYPE_ID__NAME_ASC',
  BuildingTypeByTypeIdNameDesc = 'BUILDING_TYPE_BY_TYPE_ID__NAME_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelsByBuildingIdCountAsc = 'LEVELS_BY_BUILDING_ID__COUNT_ASC',
  LevelsByBuildingIdCountDesc = 'LEVELS_BY_BUILDING_ID__COUNT_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

/** All input for the `copyEventVariantAllocations` mutation. */
export type CopyEventVariantAllocationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sourceVariantId?: InputMaybe<Scalars['UUID']>;
  targetVariantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `copyEventVariantAllocations` mutation. */
export type CopyEventVariantAllocationsPayload = {
  __typename?: 'CopyEventVariantAllocationsPayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our `copyEventVariantAllocations` mutation. */
export type CopyEventVariantAllocationsPayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** All input for the `copyExternalEventVariantAllocations` mutation. */
export type CopyExternalEventVariantAllocationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sourceVariantId?: InputMaybe<Scalars['UUID']>;
  targetVariantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `copyExternalEventVariantAllocations` mutation. */
export type CopyExternalEventVariantAllocationsPayload = {
  __typename?: 'CopyExternalEventVariantAllocationsPayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our `copyExternalEventVariantAllocations` mutation. */
export type CopyExternalEventVariantAllocationsPayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/** All input for the `copyProjectVariantAllocations` mutation. */
export type CopyProjectVariantAllocationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sourceVariantId?: InputMaybe<Scalars['UUID']>;
  targetVariantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `copyProjectVariantAllocations` mutation. */
export type CopyProjectVariantAllocationsPayload = {
  __typename?: 'CopyProjectVariantAllocationsPayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our `copyProjectVariantAllocations` mutation. */
export type CopyProjectVariantAllocationsPayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** All input for the create `AllocationArea` mutation. */
export type CreateAllocationAreaInput = {
  /** The `AllocationArea` to be created by this mutation. */
  allocationArea: AllocationAreaInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationArea` mutation. */
export type CreateAllocationAreaPayload = {
  __typename?: 'CreateAllocationAreaPayload';
  /** The `AllocationArea` that was created by this mutation. */
  allocationArea?: Maybe<AllocationArea>;
  /** An edge for our `AllocationArea`. May be used by Relay 1. */
  allocationAreaEdge?: Maybe<AllocationAreasEdge>;
  /** Reads a single `Area` that is related to this `AllocationArea`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EventVariant` that is related to this `AllocationArea`. */
  eventVariant?: Maybe<EventVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AllocationArea` mutation. */
export type CreateAllocationAreaPayloadAllocationAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationAreasOrderBy>>;
};

/** All input for the create `AllocationAreaPhase` mutation. */
export type CreateAllocationAreaPhaseInput = {
  /** The `AllocationAreaPhase` to be created by this mutation. */
  allocationAreaPhase: AllocationAreaPhaseInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationAreaPhase` mutation. */
export type CreateAllocationAreaPhasePayload = {
  __typename?: 'CreateAllocationAreaPhasePayload';
  /** Reads a single `AllocationArea` that is related to this `AllocationAreaPhase`. */
  allocation?: Maybe<AllocationArea>;
  /** The `AllocationAreaPhase` that was created by this mutation. */
  allocationAreaPhase?: Maybe<AllocationAreaPhase>;
  /** An edge for our `AllocationAreaPhase`. May be used by Relay 1. */
  allocationAreaPhaseEdge?: Maybe<AllocationAreaPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationAreaPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our create `AllocationAreaPhase` mutation. */
export type CreateAllocationAreaPhasePayloadAllocationAreaPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationAreaPhasesOrderBy>>;
};

/** All input for the create `AllocationPlot` mutation. */
export type CreateAllocationPlotInput = {
  /** The `AllocationPlot` to be created by this mutation. */
  allocationPlot: AllocationPlotInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationPlot` mutation. */
export type CreateAllocationPlotPayload = {
  __typename?: 'CreateAllocationPlotPayload';
  /** The `AllocationPlot` that was created by this mutation. */
  allocationPlot?: Maybe<AllocationPlot>;
  /** An edge for our `AllocationPlot`. May be used by Relay 1. */
  allocationPlotEdge?: Maybe<AllocationPlotsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EventVariant` that is related to this `AllocationPlot`. */
  eventVariant?: Maybe<EventVariant>;
  /** Reads a single `Plot` that is related to this `AllocationPlot`. */
  plot?: Maybe<Plot>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AllocationPlot` mutation. */
export type CreateAllocationPlotPayloadAllocationPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationPlotsOrderBy>>;
};

/** All input for the create `AllocationPlotPhase` mutation. */
export type CreateAllocationPlotPhaseInput = {
  /** The `AllocationPlotPhase` to be created by this mutation. */
  allocationPlotPhase: AllocationPlotPhaseInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationPlotPhase` mutation. */
export type CreateAllocationPlotPhasePayload = {
  __typename?: 'CreateAllocationPlotPhasePayload';
  /** Reads a single `AllocationPlot` that is related to this `AllocationPlotPhase`. */
  allocation?: Maybe<AllocationPlot>;
  /** The `AllocationPlotPhase` that was created by this mutation. */
  allocationPlotPhase?: Maybe<AllocationPlotPhase>;
  /** An edge for our `AllocationPlotPhase`. May be used by Relay 1. */
  allocationPlotPhaseEdge?: Maybe<AllocationPlotPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationPlotPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our create `AllocationPlotPhase` mutation. */
export type CreateAllocationPlotPhasePayloadAllocationPlotPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationPlotPhasesOrderBy>>;
};

/** All input for the create `AllocationRoom` mutation. */
export type CreateAllocationRoomInput = {
  /** The `AllocationRoom` to be created by this mutation. */
  allocationRoom: AllocationRoomInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationRoom` mutation. */
export type CreateAllocationRoomPayload = {
  __typename?: 'CreateAllocationRoomPayload';
  /** The `AllocationRoom` that was created by this mutation. */
  allocationRoom?: Maybe<AllocationRoom>;
  /** An edge for our `AllocationRoom`. May be used by Relay 1. */
  allocationRoomEdge?: Maybe<AllocationRoomsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EventVariant` that is related to this `AllocationRoom`. */
  eventVariant?: Maybe<EventVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `AllocationRoom`. */
  room?: Maybe<Room>;
};


/** The output of our create `AllocationRoom` mutation. */
export type CreateAllocationRoomPayloadAllocationRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationRoomsOrderBy>>;
};

/** All input for the create `AllocationRoomPhase` mutation. */
export type CreateAllocationRoomPhaseInput = {
  /** The `AllocationRoomPhase` to be created by this mutation. */
  allocationRoomPhase: AllocationRoomPhaseInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationRoomPhase` mutation. */
export type CreateAllocationRoomPhasePayload = {
  __typename?: 'CreateAllocationRoomPhasePayload';
  /** Reads a single `AllocationRoom` that is related to this `AllocationRoomPhase`. */
  allocation?: Maybe<AllocationRoom>;
  /** The `AllocationRoomPhase` that was created by this mutation. */
  allocationRoomPhase?: Maybe<AllocationRoomPhase>;
  /** An edge for our `AllocationRoomPhase`. May be used by Relay 1. */
  allocationRoomPhaseEdge?: Maybe<AllocationRoomPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationRoomPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our create `AllocationRoomPhase` mutation. */
export type CreateAllocationRoomPhasePayloadAllocationRoomPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationRoomPhasesOrderBy>>;
};

/** All input for the create `AllocationUsage` mutation. */
export type CreateAllocationUsageInput = {
  /** The `AllocationUsage` to be created by this mutation. */
  allocationUsage: AllocationUsageInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AllocationUsage` mutation. */
export type CreateAllocationUsagePayload = {
  __typename?: 'CreateAllocationUsagePayload';
  /** The `AllocationUsage` that was created by this mutation. */
  allocationUsage?: Maybe<AllocationUsage>;
  /** An edge for our `AllocationUsage`. May be used by Relay 1. */
  allocationUsageEdge?: Maybe<AllocationUsagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AllocationUsage` mutation. */
export type CreateAllocationUsagePayloadAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationUsagesOrderBy>>;
};

/** All input for the create `AreaCadGrossSpaceMin` mutation. */
export type CreateAreaCadGrossSpaceMinInput = {
  /** The `AreaCadGrossSpaceMin` to be created by this mutation. */
  areaCadGrossSpaceMin: AreaCadGrossSpaceMinInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaCadGrossSpaceMin` mutation. */
export type CreateAreaCadGrossSpaceMinPayload = {
  __typename?: 'CreateAreaCadGrossSpaceMinPayload';
  /** Reads a single `Area` that is related to this `AreaCadGrossSpaceMin`. */
  area?: Maybe<Area>;
  /** The `AreaCadGrossSpaceMin` that was created by this mutation. */
  areaCadGrossSpaceMin?: Maybe<AreaCadGrossSpaceMin>;
  /** An edge for our `AreaCadGrossSpaceMin`. May be used by Relay 1. */
  areaCadGrossSpaceMinEdge?: Maybe<AreaCadGrossSpaceMinsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaCadGrossSpaceMin` mutation. */
export type CreateAreaCadGrossSpaceMinPayloadAreaCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaCadGrossSpaceMinsOrderBy>>;
};

/** All input for the create `AreaClearanceConstruction` mutation. */
export type CreateAreaClearanceConstructionInput = {
  /** The `AreaClearanceConstruction` to be created by this mutation. */
  areaClearanceConstruction: AreaClearanceConstructionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaClearanceConstruction` mutation. */
export type CreateAreaClearanceConstructionPayload = {
  __typename?: 'CreateAreaClearanceConstructionPayload';
  /** Reads a single `Area` that is related to this `AreaClearanceConstruction`. */
  area?: Maybe<Area>;
  /** The `AreaClearanceConstruction` that was created by this mutation. */
  areaClearanceConstruction?: Maybe<AreaClearanceConstruction>;
  /** An edge for our `AreaClearanceConstruction`. May be used by Relay 1. */
  areaClearanceConstructionEdge?: Maybe<AreaClearanceConstructionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaClearanceConstruction` mutation. */
export type CreateAreaClearanceConstructionPayloadAreaClearanceConstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaClearanceConstructionsOrderBy>>;
};

/** All input for the create `AreaContactBooking` mutation. */
export type CreateAreaContactBookingInput = {
  /** The `AreaContactBooking` to be created by this mutation. */
  areaContactBooking: AreaContactBookingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaContactBooking` mutation. */
export type CreateAreaContactBookingPayload = {
  __typename?: 'CreateAreaContactBookingPayload';
  /** Reads a single `Area` that is related to this `AreaContactBooking`. */
  area?: Maybe<Area>;
  /** The `AreaContactBooking` that was created by this mutation. */
  areaContactBooking?: Maybe<AreaContactBooking>;
  /** An edge for our `AreaContactBooking`. May be used by Relay 1. */
  areaContactBookingEdge?: Maybe<AreaContactBookingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaContactBooking` mutation. */
export type CreateAreaContactBookingPayloadAreaContactBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaContactBookingsOrderBy>>;
};

/** All input for the create `AreaDescription` mutation. */
export type CreateAreaDescriptionInput = {
  /** The `AreaDescription` to be created by this mutation. */
  areaDescription: AreaDescriptionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaDescription` mutation. */
export type CreateAreaDescriptionPayload = {
  __typename?: 'CreateAreaDescriptionPayload';
  /** Reads a single `Area` that is related to this `AreaDescription`. */
  area?: Maybe<Area>;
  /** The `AreaDescription` that was created by this mutation. */
  areaDescription?: Maybe<AreaDescription>;
  /** An edge for our `AreaDescription`. May be used by Relay 1. */
  areaDescriptionEdge?: Maybe<AreaDescriptionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaDescription` mutation. */
export type CreateAreaDescriptionPayloadAreaDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaDescriptionsOrderBy>>;
};

/** All input for the create `Area` mutation. */
export type CreateAreaInput = {
  /** The `Area` to be created by this mutation. */
  area: AreaInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `AreaKeyIssuance` mutation. */
export type CreateAreaKeyIssuanceInput = {
  /** The `AreaKeyIssuance` to be created by this mutation. */
  areaKeyIssuance: AreaKeyIssuanceInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `AreaKeyIssuanceNote` mutation. */
export type CreateAreaKeyIssuanceNoteInput = {
  /** The `AreaKeyIssuanceNote` to be created by this mutation. */
  areaKeyIssuanceNote: AreaKeyIssuanceNoteInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaKeyIssuanceNote` mutation. */
export type CreateAreaKeyIssuanceNotePayload = {
  __typename?: 'CreateAreaKeyIssuanceNotePayload';
  /** Reads a single `Area` that is related to this `AreaKeyIssuanceNote`. */
  area?: Maybe<Area>;
  /** The `AreaKeyIssuanceNote` that was created by this mutation. */
  areaKeyIssuanceNote?: Maybe<AreaKeyIssuanceNote>;
  /** An edge for our `AreaKeyIssuanceNote`. May be used by Relay 1. */
  areaKeyIssuanceNoteEdge?: Maybe<AreaKeyIssuanceNotesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaKeyIssuanceNote` mutation. */
export type CreateAreaKeyIssuanceNotePayloadAreaKeyIssuanceNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaKeyIssuanceNotesOrderBy>>;
};

/** The output of our create `AreaKeyIssuance` mutation. */
export type CreateAreaKeyIssuancePayload = {
  __typename?: 'CreateAreaKeyIssuancePayload';
  /** Reads a single `Area` that is related to this `AreaKeyIssuance`. */
  area?: Maybe<Area>;
  /** The `AreaKeyIssuance` that was created by this mutation. */
  areaKeyIssuance?: Maybe<AreaKeyIssuance>;
  /** An edge for our `AreaKeyIssuance`. May be used by Relay 1. */
  areaKeyIssuanceEdge?: Maybe<AreaKeyIssuancesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaKeyIssuance` mutation. */
export type CreateAreaKeyIssuancePayloadAreaKeyIssuanceEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaKeyIssuancesOrderBy>>;
};

/** All input for the create `AreaNameExtra` mutation. */
export type CreateAreaNameExtraInput = {
  /** The `AreaNameExtra` to be created by this mutation. */
  areaNameExtra: AreaNameExtraInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameExtra` mutation. */
export type CreateAreaNameExtraPayload = {
  __typename?: 'CreateAreaNameExtraPayload';
  /** Reads a single `Area` that is related to this `AreaNameExtra`. */
  area?: Maybe<Area>;
  /** The `AreaNameExtra` that was created by this mutation. */
  areaNameExtra?: Maybe<AreaNameExtra>;
  /** An edge for our `AreaNameExtra`. May be used by Relay 1. */
  areaNameExtraEdge?: Maybe<AreaNameExtrasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameExtra` mutation. */
export type CreateAreaNameExtraPayloadAreaNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameExtrasOrderBy>>;
};

/** All input for the create `AreaNameKeyCad` mutation. */
export type CreateAreaNameKeyCadInput = {
  /** The `AreaNameKeyCad` to be created by this mutation. */
  areaNameKeyCad: AreaNameKeyCadInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameKeyCad` mutation. */
export type CreateAreaNameKeyCadPayload = {
  __typename?: 'CreateAreaNameKeyCadPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyCad`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyCad` that was created by this mutation. */
  areaNameKeyCad?: Maybe<AreaNameKeyCad>;
  /** An edge for our `AreaNameKeyCad`. May be used by Relay 1. */
  areaNameKeyCadEdge?: Maybe<AreaNameKeyCadsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameKeyCad` mutation. */
export type CreateAreaNameKeyCadPayloadAreaNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyCadsOrderBy>>;
};

/** All input for the create `AreaNameKeyCafm` mutation. */
export type CreateAreaNameKeyCafmInput = {
  /** The `AreaNameKeyCafm` to be created by this mutation. */
  areaNameKeyCafm: AreaNameKeyCafmInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameKeyCafm` mutation. */
export type CreateAreaNameKeyCafmPayload = {
  __typename?: 'CreateAreaNameKeyCafmPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyCafm`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyCafm` that was created by this mutation. */
  areaNameKeyCafm?: Maybe<AreaNameKeyCafm>;
  /** An edge for our `AreaNameKeyCafm`. May be used by Relay 1. */
  areaNameKeyCafmEdge?: Maybe<AreaNameKeyCafmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameKeyCafm` mutation. */
export type CreateAreaNameKeyCafmPayloadAreaNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyCafmsOrderBy>>;
};

/** All input for the create `AreaNameKeyEbm` mutation. */
export type CreateAreaNameKeyEbmInput = {
  /** The `AreaNameKeyEbm` to be created by this mutation. */
  areaNameKeyEbm: AreaNameKeyEbmInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameKeyEbm` mutation. */
export type CreateAreaNameKeyEbmPayload = {
  __typename?: 'CreateAreaNameKeyEbmPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyEbm`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyEbm` that was created by this mutation. */
  areaNameKeyEbm?: Maybe<AreaNameKeyEbm>;
  /** An edge for our `AreaNameKeyEbm`. May be used by Relay 1. */
  areaNameKeyEbmEdge?: Maybe<AreaNameKeyEbmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameKeyEbm` mutation. */
export type CreateAreaNameKeyEbmPayloadAreaNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyEbmsOrderBy>>;
};

/** All input for the create `AreaNameKeyMarketing` mutation. */
export type CreateAreaNameKeyMarketingInput = {
  /** The `AreaNameKeyMarketing` to be created by this mutation. */
  areaNameKeyMarketing: AreaNameKeyMarketingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameKeyMarketing` mutation. */
export type CreateAreaNameKeyMarketingPayload = {
  __typename?: 'CreateAreaNameKeyMarketingPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyMarketing`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyMarketing` that was created by this mutation. */
  areaNameKeyMarketing?: Maybe<AreaNameKeyMarketing>;
  /** An edge for our `AreaNameKeyMarketing`. May be used by Relay 1. */
  areaNameKeyMarketingEdge?: Maybe<AreaNameKeyMarketingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameKeyMarketing` mutation. */
export type CreateAreaNameKeyMarketingPayloadAreaNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyMarketingsOrderBy>>;
};

/** All input for the create `AreaNameLong` mutation. */
export type CreateAreaNameLongInput = {
  /** The `AreaNameLong` to be created by this mutation. */
  areaNameLong: AreaNameLongInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameLong` mutation. */
export type CreateAreaNameLongPayload = {
  __typename?: 'CreateAreaNameLongPayload';
  /** Reads a single `Area` that is related to this `AreaNameLong`. */
  area?: Maybe<Area>;
  /** The `AreaNameLong` that was created by this mutation. */
  areaNameLong?: Maybe<AreaNameLong>;
  /** An edge for our `AreaNameLong`. May be used by Relay 1. */
  areaNameLongEdge?: Maybe<AreaNameLongsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameLong` mutation. */
export type CreateAreaNameLongPayloadAreaNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameLongsOrderBy>>;
};

/** All input for the create `AreaNameShort` mutation. */
export type CreateAreaNameShortInput = {
  /** The `AreaNameShort` to be created by this mutation. */
  areaNameShort: AreaNameShortInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaNameShort` mutation. */
export type CreateAreaNameShortPayload = {
  __typename?: 'CreateAreaNameShortPayload';
  /** Reads a single `Area` that is related to this `AreaNameShort`. */
  area?: Maybe<Area>;
  /** The `AreaNameShort` that was created by this mutation. */
  areaNameShort?: Maybe<AreaNameShort>;
  /** An edge for our `AreaNameShort`. May be used by Relay 1. */
  areaNameShortEdge?: Maybe<AreaNameShortsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaNameShort` mutation. */
export type CreateAreaNameShortPayloadAreaNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameShortsOrderBy>>;
};

/** The output of our create `Area` mutation. */
export type CreateAreaPayload = {
  __typename?: 'CreateAreaPayload';
  /** The `Area` that was created by this mutation. */
  area?: Maybe<Area>;
  /** An edge for our `Area`. May be used by Relay 1. */
  areaEdge?: Maybe<AreasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AreaType` that is related to this `Area`. */
  type?: Maybe<AreaType>;
  /** Reads a single `Zone` that is related to this `Area`. */
  zone?: Maybe<Zone>;
};


/** The output of our create `Area` mutation. */
export type CreateAreaPayloadAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<AreasOrderBy>>;
};

/** All input for the create `AreaPublicGrossSpace` mutation. */
export type CreateAreaPublicGrossSpaceInput = {
  /** The `AreaPublicGrossSpace` to be created by this mutation. */
  areaPublicGrossSpace: AreaPublicGrossSpaceInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaPublicGrossSpace` mutation. */
export type CreateAreaPublicGrossSpacePayload = {
  __typename?: 'CreateAreaPublicGrossSpacePayload';
  /** Reads a single `Area` that is related to this `AreaPublicGrossSpace`. */
  area?: Maybe<Area>;
  /** The `AreaPublicGrossSpace` that was created by this mutation. */
  areaPublicGrossSpace?: Maybe<AreaPublicGrossSpace>;
  /** An edge for our `AreaPublicGrossSpace`. May be used by Relay 1. */
  areaPublicGrossSpaceEdge?: Maybe<AreaPublicGrossSpacesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaPublicGrossSpace` mutation. */
export type CreateAreaPublicGrossSpacePayloadAreaPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaPublicGrossSpacesOrderBy>>;
};

/** All input for the create `AreaTypeAttr` mutation. */
export type CreateAreaTypeAttrInput = {
  /** The `AreaTypeAttr` to be created by this mutation. */
  areaTypeAttr: AreaTypeAttrInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaTypeAttr` mutation. */
export type CreateAreaTypeAttrPayload = {
  __typename?: 'CreateAreaTypeAttrPayload';
  /** Reads a single `Area` that is related to this `AreaTypeAttr`. */
  area?: Maybe<Area>;
  /** Reads a single `AreaType` that is related to this `AreaTypeAttr`. */
  areaType?: Maybe<AreaType>;
  /** The `AreaTypeAttr` that was created by this mutation. */
  areaTypeAttr?: Maybe<AreaTypeAttr>;
  /** An edge for our `AreaTypeAttr`. May be used by Relay 1. */
  areaTypeAttrEdge?: Maybe<AreaTypeAttrsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaTypeAttr` mutation. */
export type CreateAreaTypeAttrPayloadAreaTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaTypeAttrsOrderBy>>;
};

/** All input for the create `AreaType` mutation. */
export type CreateAreaTypeInput = {
  /** The `AreaType` to be created by this mutation. */
  areaType: AreaTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AreaType` mutation. */
export type CreateAreaTypePayload = {
  __typename?: 'CreateAreaTypePayload';
  /** The `AreaType` that was created by this mutation. */
  areaType?: Maybe<AreaType>;
  /** An edge for our `AreaType`. May be used by Relay 1. */
  areaTypeEdge?: Maybe<AreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AreaType` mutation. */
export type CreateAreaTypePayloadAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaTypesOrderBy>>;
};

/** All input for the create `BuildingDescription` mutation. */
export type CreateBuildingDescriptionInput = {
  /** The `BuildingDescription` to be created by this mutation. */
  buildingDescription: BuildingDescriptionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingDescription` mutation. */
export type CreateBuildingDescriptionPayload = {
  __typename?: 'CreateBuildingDescriptionPayload';
  /** Reads a single `Building` that is related to this `BuildingDescription`. */
  building?: Maybe<Building>;
  /** The `BuildingDescription` that was created by this mutation. */
  buildingDescription?: Maybe<BuildingDescription>;
  /** An edge for our `BuildingDescription`. May be used by Relay 1. */
  buildingDescriptionEdge?: Maybe<BuildingDescriptionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingDescription` mutation. */
export type CreateBuildingDescriptionPayloadBuildingDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingDescriptionsOrderBy>>;
};

/** All input for the create `Building` mutation. */
export type CreateBuildingInput = {
  /** The `Building` to be created by this mutation. */
  building: BuildingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the create `BuildingNameExtra` mutation. */
export type CreateBuildingNameExtraInput = {
  /** The `BuildingNameExtra` to be created by this mutation. */
  buildingNameExtra: BuildingNameExtraInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameExtra` mutation. */
export type CreateBuildingNameExtraPayload = {
  __typename?: 'CreateBuildingNameExtraPayload';
  /** Reads a single `Building` that is related to this `BuildingNameExtra`. */
  building?: Maybe<Building>;
  /** The `BuildingNameExtra` that was created by this mutation. */
  buildingNameExtra?: Maybe<BuildingNameExtra>;
  /** An edge for our `BuildingNameExtra`. May be used by Relay 1. */
  buildingNameExtraEdge?: Maybe<BuildingNameExtrasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameExtra` mutation. */
export type CreateBuildingNameExtraPayloadBuildingNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameExtrasOrderBy>>;
};

/** All input for the create `BuildingNameKeyCad` mutation. */
export type CreateBuildingNameKeyCadInput = {
  /** The `BuildingNameKeyCad` to be created by this mutation. */
  buildingNameKeyCad: BuildingNameKeyCadInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameKeyCad` mutation. */
export type CreateBuildingNameKeyCadPayload = {
  __typename?: 'CreateBuildingNameKeyCadPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCad`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyCad` that was created by this mutation. */
  buildingNameKeyCad?: Maybe<BuildingNameKeyCad>;
  /** An edge for our `BuildingNameKeyCad`. May be used by Relay 1. */
  buildingNameKeyCadEdge?: Maybe<BuildingNameKeyCadsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameKeyCad` mutation. */
export type CreateBuildingNameKeyCadPayloadBuildingNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyCadsOrderBy>>;
};

/** All input for the create `BuildingNameKeyCafm` mutation. */
export type CreateBuildingNameKeyCafmInput = {
  /** The `BuildingNameKeyCafm` to be created by this mutation. */
  buildingNameKeyCafm: BuildingNameKeyCafmInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameKeyCafm` mutation. */
export type CreateBuildingNameKeyCafmPayload = {
  __typename?: 'CreateBuildingNameKeyCafmPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCafm`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyCafm` that was created by this mutation. */
  buildingNameKeyCafm?: Maybe<BuildingNameKeyCafm>;
  /** An edge for our `BuildingNameKeyCafm`. May be used by Relay 1. */
  buildingNameKeyCafmEdge?: Maybe<BuildingNameKeyCafmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameKeyCafm` mutation. */
export type CreateBuildingNameKeyCafmPayloadBuildingNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyCafmsOrderBy>>;
};

/** All input for the create `BuildingNameKeyEbm` mutation. */
export type CreateBuildingNameKeyEbmInput = {
  /** The `BuildingNameKeyEbm` to be created by this mutation. */
  buildingNameKeyEbm: BuildingNameKeyEbmInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameKeyEbm` mutation. */
export type CreateBuildingNameKeyEbmPayload = {
  __typename?: 'CreateBuildingNameKeyEbmPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyEbm`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyEbm` that was created by this mutation. */
  buildingNameKeyEbm?: Maybe<BuildingNameKeyEbm>;
  /** An edge for our `BuildingNameKeyEbm`. May be used by Relay 1. */
  buildingNameKeyEbmEdge?: Maybe<BuildingNameKeyEbmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameKeyEbm` mutation. */
export type CreateBuildingNameKeyEbmPayloadBuildingNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyEbmsOrderBy>>;
};

/** All input for the create `BuildingNameKeyMarketing` mutation. */
export type CreateBuildingNameKeyMarketingInput = {
  /** The `BuildingNameKeyMarketing` to be created by this mutation. */
  buildingNameKeyMarketing: BuildingNameKeyMarketingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameKeyMarketing` mutation. */
export type CreateBuildingNameKeyMarketingPayload = {
  __typename?: 'CreateBuildingNameKeyMarketingPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyMarketing`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyMarketing` that was created by this mutation. */
  buildingNameKeyMarketing?: Maybe<BuildingNameKeyMarketing>;
  /** An edge for our `BuildingNameKeyMarketing`. May be used by Relay 1. */
  buildingNameKeyMarketingEdge?: Maybe<BuildingNameKeyMarketingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameKeyMarketing` mutation. */
export type CreateBuildingNameKeyMarketingPayloadBuildingNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyMarketingsOrderBy>>;
};

/** All input for the create `BuildingNameLong` mutation. */
export type CreateBuildingNameLongInput = {
  /** The `BuildingNameLong` to be created by this mutation. */
  buildingNameLong: BuildingNameLongInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameLong` mutation. */
export type CreateBuildingNameLongPayload = {
  __typename?: 'CreateBuildingNameLongPayload';
  /** Reads a single `Building` that is related to this `BuildingNameLong`. */
  building?: Maybe<Building>;
  /** The `BuildingNameLong` that was created by this mutation. */
  buildingNameLong?: Maybe<BuildingNameLong>;
  /** An edge for our `BuildingNameLong`. May be used by Relay 1. */
  buildingNameLongEdge?: Maybe<BuildingNameLongsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameLong` mutation. */
export type CreateBuildingNameLongPayloadBuildingNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameLongsOrderBy>>;
};

/** All input for the create `BuildingNameShort` mutation. */
export type CreateBuildingNameShortInput = {
  /** The `BuildingNameShort` to be created by this mutation. */
  buildingNameShort: BuildingNameShortInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingNameShort` mutation. */
export type CreateBuildingNameShortPayload = {
  __typename?: 'CreateBuildingNameShortPayload';
  /** Reads a single `Building` that is related to this `BuildingNameShort`. */
  building?: Maybe<Building>;
  /** The `BuildingNameShort` that was created by this mutation. */
  buildingNameShort?: Maybe<BuildingNameShort>;
  /** An edge for our `BuildingNameShort`. May be used by Relay 1. */
  buildingNameShortEdge?: Maybe<BuildingNameShortsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingNameShort` mutation. */
export type CreateBuildingNameShortPayloadBuildingNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameShortsOrderBy>>;
};

/** The output of our create `Building` mutation. */
export type CreateBuildingPayload = {
  __typename?: 'CreateBuildingPayload';
  /** The `Building` that was created by this mutation. */
  building?: Maybe<Building>;
  /** An edge for our `Building`. May be used by Relay 1. */
  buildingEdge?: Maybe<BuildingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `Building`. */
  site?: Maybe<Site>;
  /** Reads a single `BuildingType` that is related to this `Building`. */
  type?: Maybe<BuildingType>;
};


/** The output of our create `Building` mutation. */
export type CreateBuildingPayloadBuildingEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingsOrderBy>>;
};

/** All input for the create `BuildingPublicGrossSpace` mutation. */
export type CreateBuildingPublicGrossSpaceInput = {
  /** The `BuildingPublicGrossSpace` to be created by this mutation. */
  buildingPublicGrossSpace: BuildingPublicGrossSpaceInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingPublicGrossSpace` mutation. */
export type CreateBuildingPublicGrossSpacePayload = {
  __typename?: 'CreateBuildingPublicGrossSpacePayload';
  /** Reads a single `Building` that is related to this `BuildingPublicGrossSpace`. */
  building?: Maybe<Building>;
  /** The `BuildingPublicGrossSpace` that was created by this mutation. */
  buildingPublicGrossSpace?: Maybe<BuildingPublicGrossSpace>;
  /** An edge for our `BuildingPublicGrossSpace`. May be used by Relay 1. */
  buildingPublicGrossSpaceEdge?: Maybe<BuildingPublicGrossSpacesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingPublicGrossSpace` mutation. */
export type CreateBuildingPublicGrossSpacePayloadBuildingPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingPublicGrossSpacesOrderBy>>;
};

/** All input for the create `BuildingTypeAttr` mutation. */
export type CreateBuildingTypeAttrInput = {
  /** The `BuildingTypeAttr` to be created by this mutation. */
  buildingTypeAttr: BuildingTypeAttrInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingTypeAttr` mutation. */
export type CreateBuildingTypeAttrPayload = {
  __typename?: 'CreateBuildingTypeAttrPayload';
  /** Reads a single `Building` that is related to this `BuildingTypeAttr`. */
  building?: Maybe<Building>;
  /** Reads a single `BuildingType` that is related to this `BuildingTypeAttr`. */
  buildingType?: Maybe<BuildingType>;
  /** The `BuildingTypeAttr` that was created by this mutation. */
  buildingTypeAttr?: Maybe<BuildingTypeAttr>;
  /** An edge for our `BuildingTypeAttr`. May be used by Relay 1. */
  buildingTypeAttrEdge?: Maybe<BuildingTypeAttrsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingTypeAttr` mutation. */
export type CreateBuildingTypeAttrPayloadBuildingTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingTypeAttrsOrderBy>>;
};

/** All input for the create `BuildingType` mutation. */
export type CreateBuildingTypeInput = {
  /** The `BuildingType` to be created by this mutation. */
  buildingType: BuildingTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BuildingType` mutation. */
export type CreateBuildingTypePayload = {
  __typename?: 'CreateBuildingTypePayload';
  /** The `BuildingType` that was created by this mutation. */
  buildingType?: Maybe<BuildingType>;
  /** An edge for our `BuildingType`. May be used by Relay 1. */
  buildingTypeEdge?: Maybe<BuildingTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BuildingType` mutation. */
export type CreateBuildingTypePayloadBuildingTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingTypesOrderBy>>;
};

/** All input for the create `ElevationLevel` mutation. */
export type CreateElevationLevelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ElevationLevel` to be created by this mutation. */
  elevationLevel: ElevationLevelInput;
};

/** The output of our create `ElevationLevel` mutation. */
export type CreateElevationLevelPayload = {
  __typename?: 'CreateElevationLevelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ElevationLevel` that was created by this mutation. */
  elevationLevel?: Maybe<ElevationLevel>;
  /** An edge for our `ElevationLevel`. May be used by Relay 1. */
  elevationLevelEdge?: Maybe<ElevationLevelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ElevationLevel` mutation. */
export type CreateElevationLevelPayloadElevationLevelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElevationLevelsOrderBy>>;
};

/** All input for the create `Event` mutation. */
export type CreateEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Event` to be created by this mutation. */
  event: EventInput;
};

/** The output of our create `Event` mutation. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionNational?: Maybe<Multilink>;
  /** The `Event` that was created by this mutation. */
  event?: Maybe<Event>;
  /** An edge for our `Event`. May be used by Relay 1. */
  eventEdge?: Maybe<EventsEdge>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  externalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraSystems?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  /** Reads a single `File` that is related to this `Event`. */
  icon?: Maybe<File>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  internalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionNational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksInternal?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `EventSeries` that is related to this `Event`. */
  series?: Maybe<EventSeries>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsLocal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsOtherLocations?: Maybe<Multilink>;
};


/** The output of our create `Event` mutation. */
export type CreateEventPayloadEventEdgeArgs = {
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** All input for the create `EventSeries` mutation. */
export type CreateEventSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EventSeries` to be created by this mutation. */
  eventSeries: EventSeriesInput;
};

/** The output of our create `EventSeries` mutation. */
export type CreateEventSeriesPayload = {
  __typename?: 'CreateEventSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionNational?: Maybe<Multilink>;
  /** The `EventSeries` that was created by this mutation. */
  eventSeries?: Maybe<EventSeries>;
  /** An edge for our `EventSeries`. May be used by Relay 1. */
  eventSeriesEdge?: Maybe<EventSeriesEdge>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  executors?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  externalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraSystems?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  /** Reads a single `File` that is related to this `EventSeries`. */
  icon?: Maybe<File>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  internalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  organizers?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionNational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksInternal?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  sponsors?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsLocal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsOtherLocations?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our create `EventSeries` mutation. */
export type CreateEventSeriesPayloadEventSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};

/** All input for the create `EventVariant` mutation. */
export type CreateEventVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EventVariant` to be created by this mutation. */
  eventVariant: EventVariantInput;
};

/** The output of our create `EventVariant` mutation. */
export type CreateEventVariantPayload = {
  __typename?: 'CreateEventVariantPayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  /** The `EventVariant` that was created by this mutation. */
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our create `EventVariant` mutation. */
export type CreateEventVariantPayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** All input for the `createEventVariantWithAllocationsFrom` mutation. */
export type CreateEventVariantWithAllocationsFromInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  newVariantName?: InputMaybe<Scalars['String']>;
  sourceVariantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createEventVariantWithAllocationsFrom` mutation. */
export type CreateEventVariantWithAllocationsFromPayload = {
  __typename?: 'CreateEventVariantWithAllocationsFromPayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our `createEventVariantWithAllocationsFrom` mutation. */
export type CreateEventVariantWithAllocationsFromPayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** All input for the create `ExternalEventAllocation` mutation. */
export type CreateExternalEventAllocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventAllocation` to be created by this mutation. */
  externalEventAllocation: ExternalEventAllocationInput;
};

/** The output of our create `ExternalEventAllocation` mutation. */
export type CreateExternalEventAllocationPayload = {
  __typename?: 'CreateExternalEventAllocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventAllocation` that was created by this mutation. */
  externalEventAllocation?: Maybe<ExternalEventAllocation>;
  /** An edge for our `ExternalEventAllocation`. May be used by Relay 1. */
  externalEventAllocationEdge?: Maybe<ExternalEventAllocationsEdge>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventAllocation`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventVariant` that is related to this `ExternalEventAllocation`. */
  variant?: Maybe<ExternalEventVariant>;
};


/** The output of our create `ExternalEventAllocation` mutation. */
export type CreateExternalEventAllocationPayloadExternalEventAllocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationsOrderBy>>;
};

/** All input for the create `ExternalEventAllocationPhase` mutation. */
export type CreateExternalEventAllocationPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventAllocationPhase` to be created by this mutation. */
  externalEventAllocationPhase: ExternalEventAllocationPhaseInput;
};

/** The output of our create `ExternalEventAllocationPhase` mutation. */
export type CreateExternalEventAllocationPhasePayload = {
  __typename?: 'CreateExternalEventAllocationPhasePayload';
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventAllocationPhase`. */
  allocation?: Maybe<ExternalEventAllocation>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventAllocationPhase` that was created by this mutation. */
  externalEventAllocationPhase?: Maybe<ExternalEventAllocationPhase>;
  /** An edge for our `ExternalEventAllocationPhase`. May be used by Relay 1. */
  externalEventAllocationPhaseEdge?: Maybe<ExternalEventAllocationPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocationUsage` that is related to this `ExternalEventAllocationPhase`. */
  usage?: Maybe<ExternalEventAllocationUsage>;
};


/** The output of our create `ExternalEventAllocationPhase` mutation. */
export type CreateExternalEventAllocationPhasePayloadExternalEventAllocationPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationPhasesOrderBy>>;
};

/** All input for the create `ExternalEventAllocationUsage` mutation. */
export type CreateExternalEventAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventAllocationUsage` to be created by this mutation. */
  externalEventAllocationUsage: ExternalEventAllocationUsageInput;
};

/** The output of our create `ExternalEventAllocationUsage` mutation. */
export type CreateExternalEventAllocationUsagePayload = {
  __typename?: 'CreateExternalEventAllocationUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventAllocationUsage` that was created by this mutation. */
  externalEventAllocationUsage?: Maybe<ExternalEventAllocationUsage>;
  /** An edge for our `ExternalEventAllocationUsage`. May be used by Relay 1. */
  externalEventAllocationUsageEdge?: Maybe<ExternalEventAllocationUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ExternalEventAllocationUsage` mutation. */
export type CreateExternalEventAllocationUsagePayloadExternalEventAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationUsagesOrderBy>>;
};

/** All input for the create `ExternalEventEventLocationVisibility` mutation. */
export type CreateExternalEventEventLocationVisibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventEventLocationVisibility` to be created by this mutation. */
  externalEventEventLocationVisibility: ExternalEventEventLocationVisibilityInput;
};

/** The output of our create `ExternalEventEventLocationVisibility` mutation. */
export type CreateExternalEventEventLocationVisibilityPayload = {
  __typename?: 'CreateExternalEventEventLocationVisibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventEventLocationVisibility`. */
  event?: Maybe<ExternalEvent>;
  /** The `ExternalEventEventLocationVisibility` that was created by this mutation. */
  externalEventEventLocationVisibility?: Maybe<ExternalEventEventLocationVisibility>;
  /** An edge for our `ExternalEventEventLocationVisibility`. May be used by Relay 1. */
  externalEventEventLocationVisibilityEdge?: Maybe<ExternalEventEventLocationVisibilitiesEdge>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventEventLocationVisibility`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ExternalEventEventLocationVisibility` mutation. */
export type CreateExternalEventEventLocationVisibilityPayloadExternalEventEventLocationVisibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventEventLocationVisibilitiesOrderBy>>;
};

/** All input for the create `ExternalEvent` mutation. */
export type CreateExternalEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEvent` to be created by this mutation. */
  externalEvent: ExternalEventInput;
};

/** All input for the create `ExternalEventLocation` mutation. */
export type CreateExternalEventLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventLocation` to be created by this mutation. */
  externalEventLocation: ExternalEventLocationInput;
};

/** The output of our create `ExternalEventLocation` mutation. */
export type CreateExternalEventLocationPayload = {
  __typename?: 'CreateExternalEventLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventLocation` that was created by this mutation. */
  externalEventLocation?: Maybe<ExternalEventLocation>;
  /** An edge for our `ExternalEventLocation`. May be used by Relay 1. */
  externalEventLocationEdge?: Maybe<ExternalEventLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ExternalEventLocation` mutation. */
export type CreateExternalEventLocationPayloadExternalEventLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventLocationsOrderBy>>;
};

/** The output of our create `ExternalEvent` mutation. */
export type CreateExternalEventPayload = {
  __typename?: 'CreateExternalEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEvent` that was created by this mutation. */
  externalEvent?: Maybe<ExternalEvent>;
  /** An edge for our `ExternalEvent`. May be used by Relay 1. */
  externalEventEdge?: Maybe<ExternalEventsEdge>;
  /** Reads a single `Multilink` that is related to this `ExternalEvent`. */
  links?: Maybe<Multilink>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEvent`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventSeries` that is related to this `ExternalEvent`. */
  series?: Maybe<ExternalEventSeries>;
};


/** The output of our create `ExternalEvent` mutation. */
export type CreateExternalEventPayloadExternalEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};

/** All input for the create `ExternalEventSeries` mutation. */
export type CreateExternalEventSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventSeries` to be created by this mutation. */
  externalEventSeries: ExternalEventSeriesInput;
};

/** The output of our create `ExternalEventSeries` mutation. */
export type CreateExternalEventSeriesPayload = {
  __typename?: 'CreateExternalEventSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventSeries` that was created by this mutation. */
  externalEventSeries?: Maybe<ExternalEventSeries>;
  /** An edge for our `ExternalEventSeries`. May be used by Relay 1. */
  externalEventSeriesEdge?: Maybe<ExternalEventSeriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `ExternalEventSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our create `ExternalEventSeries` mutation. */
export type CreateExternalEventSeriesPayloadExternalEventSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventSeriesOrderBy>>;
};

/** All input for the create `ExternalEventVariant` mutation. */
export type CreateExternalEventVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalEventVariant` to be created by this mutation. */
  externalEventVariant: ExternalEventVariantInput;
};

/** The output of our create `ExternalEventVariant` mutation. */
export type CreateExternalEventVariantPayload = {
  __typename?: 'CreateExternalEventVariantPayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  /** The `ExternalEventVariant` that was created by this mutation. */
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our create `ExternalEventVariant` mutation. */
export type CreateExternalEventVariantPayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/** All input for the `createExternalEventVariantWithAllocationsFrom` mutation. */
export type CreateExternalEventVariantWithAllocationsFromInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  newVariantName?: InputMaybe<Scalars['String']>;
  sourceVariantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createExternalEventVariantWithAllocationsFrom` mutation. */
export type CreateExternalEventVariantWithAllocationsFromPayload = {
  __typename?: 'CreateExternalEventVariantWithAllocationsFromPayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our `createExternalEventVariantWithAllocationsFrom` mutation. */
export type CreateExternalEventVariantWithAllocationsFromPayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/** All input for the create `FeedEntry` mutation. */
export type CreateFeedEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FeedEntry` to be created by this mutation. */
  feedEntry: FeedEntryInput;
};

/** The output of our create `FeedEntry` mutation. */
export type CreateFeedEntryPayload = {
  __typename?: 'CreateFeedEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `FeedEntry`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Feed` that is related to this `FeedEntry`. */
  feed?: Maybe<Feed>;
  /** The `FeedEntry` that was created by this mutation. */
  feedEntry?: Maybe<FeedEntry>;
  /** An edge for our `FeedEntry`. May be used by Relay 1. */
  feedEntryEdge?: Maybe<FeedEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FeedEntry`. */
  updatedBy?: Maybe<User>;
};


/** The output of our create `FeedEntry` mutation. */
export type CreateFeedEntryPayloadFeedEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};

/** All input for the create `Feed` mutation. */
export type CreateFeedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Feed` to be created by this mutation. */
  feed: FeedInput;
};

/** The output of our create `Feed` mutation. */
export type CreateFeedPayload = {
  __typename?: 'CreateFeedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Feed` that was created by this mutation. */
  feed?: Maybe<Feed>;
  /** An edge for our `Feed`. May be used by Relay 1. */
  feedEdge?: Maybe<FeedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Feed` mutation. */
export type CreateFeedPayloadFeedEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedsOrderBy>>;
};

/** All input for the create `LevelCapacityPax` mutation. */
export type CreateLevelCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelCapacityPax` to be created by this mutation. */
  levelCapacityPax: LevelCapacityPaxInput;
};

/** The output of our create `LevelCapacityPax` mutation. */
export type CreateLevelCapacityPaxPayload = {
  __typename?: 'CreateLevelCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelCapacityPax`. */
  level?: Maybe<Level>;
  /** The `LevelCapacityPax` that was created by this mutation. */
  levelCapacityPax?: Maybe<LevelCapacityPax>;
  /** An edge for our `LevelCapacityPax`. May be used by Relay 1. */
  levelCapacityPaxEdge?: Maybe<LevelCapacityPaxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelCapacityPax` mutation. */
export type CreateLevelCapacityPaxPayloadLevelCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelCapacityPaxesOrderBy>>;
};

/** All input for the create `LevelDescription` mutation. */
export type CreateLevelDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelDescription` to be created by this mutation. */
  levelDescription: LevelDescriptionInput;
};

/** The output of our create `LevelDescription` mutation. */
export type CreateLevelDescriptionPayload = {
  __typename?: 'CreateLevelDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelDescription`. */
  level?: Maybe<Level>;
  /** The `LevelDescription` that was created by this mutation. */
  levelDescription?: Maybe<LevelDescription>;
  /** An edge for our `LevelDescription`. May be used by Relay 1. */
  levelDescriptionEdge?: Maybe<LevelDescriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelDescription` mutation. */
export type CreateLevelDescriptionPayloadLevelDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelDescriptionsOrderBy>>;
};

/** All input for the create `LevelFkmGrossSpace` mutation. */
export type CreateLevelFkmGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelFkmGrossSpace` to be created by this mutation. */
  levelFkmGrossSpace: LevelFkmGrossSpaceInput;
};

/** The output of our create `LevelFkmGrossSpace` mutation. */
export type CreateLevelFkmGrossSpacePayload = {
  __typename?: 'CreateLevelFkmGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelFkmGrossSpace`. */
  level?: Maybe<Level>;
  /** The `LevelFkmGrossSpace` that was created by this mutation. */
  levelFkmGrossSpace?: Maybe<LevelFkmGrossSpace>;
  /** An edge for our `LevelFkmGrossSpace`. May be used by Relay 1. */
  levelFkmGrossSpaceEdge?: Maybe<LevelFkmGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelFkmGrossSpace` mutation. */
export type CreateLevelFkmGrossSpacePayloadLevelFkmGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelFkmGrossSpacesOrderBy>>;
};

/** All input for the create `Level` mutation. */
export type CreateLevelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Level` to be created by this mutation. */
  level: LevelInput;
};

/** All input for the create `LevelNameExtra` mutation. */
export type CreateLevelNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameExtra` to be created by this mutation. */
  levelNameExtra: LevelNameExtraInput;
};

/** The output of our create `LevelNameExtra` mutation. */
export type CreateLevelNameExtraPayload = {
  __typename?: 'CreateLevelNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameExtra`. */
  level?: Maybe<Level>;
  /** The `LevelNameExtra` that was created by this mutation. */
  levelNameExtra?: Maybe<LevelNameExtra>;
  /** An edge for our `LevelNameExtra`. May be used by Relay 1. */
  levelNameExtraEdge?: Maybe<LevelNameExtrasEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameExtra` mutation. */
export type CreateLevelNameExtraPayloadLevelNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameExtrasOrderBy>>;
};

/** All input for the create `LevelNameKeyCad` mutation. */
export type CreateLevelNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameKeyCad` to be created by this mutation. */
  levelNameKeyCad: LevelNameKeyCadInput;
};

/** The output of our create `LevelNameKeyCad` mutation. */
export type CreateLevelNameKeyCadPayload = {
  __typename?: 'CreateLevelNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyCad`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyCad` that was created by this mutation. */
  levelNameKeyCad?: Maybe<LevelNameKeyCad>;
  /** An edge for our `LevelNameKeyCad`. May be used by Relay 1. */
  levelNameKeyCadEdge?: Maybe<LevelNameKeyCadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameKeyCad` mutation. */
export type CreateLevelNameKeyCadPayloadLevelNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyCadsOrderBy>>;
};

/** All input for the create `LevelNameKeyCafm` mutation. */
export type CreateLevelNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameKeyCafm` to be created by this mutation. */
  levelNameKeyCafm: LevelNameKeyCafmInput;
};

/** The output of our create `LevelNameKeyCafm` mutation. */
export type CreateLevelNameKeyCafmPayload = {
  __typename?: 'CreateLevelNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyCafm`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyCafm` that was created by this mutation. */
  levelNameKeyCafm?: Maybe<LevelNameKeyCafm>;
  /** An edge for our `LevelNameKeyCafm`. May be used by Relay 1. */
  levelNameKeyCafmEdge?: Maybe<LevelNameKeyCafmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameKeyCafm` mutation. */
export type CreateLevelNameKeyCafmPayloadLevelNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyCafmsOrderBy>>;
};

/** All input for the create `LevelNameKeyEbm` mutation. */
export type CreateLevelNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameKeyEbm` to be created by this mutation. */
  levelNameKeyEbm: LevelNameKeyEbmInput;
};

/** The output of our create `LevelNameKeyEbm` mutation. */
export type CreateLevelNameKeyEbmPayload = {
  __typename?: 'CreateLevelNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyEbm`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyEbm` that was created by this mutation. */
  levelNameKeyEbm?: Maybe<LevelNameKeyEbm>;
  /** An edge for our `LevelNameKeyEbm`. May be used by Relay 1. */
  levelNameKeyEbmEdge?: Maybe<LevelNameKeyEbmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameKeyEbm` mutation. */
export type CreateLevelNameKeyEbmPayloadLevelNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyEbmsOrderBy>>;
};

/** All input for the create `LevelNameKeyMarketing` mutation. */
export type CreateLevelNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameKeyMarketing` to be created by this mutation. */
  levelNameKeyMarketing: LevelNameKeyMarketingInput;
};

/** The output of our create `LevelNameKeyMarketing` mutation. */
export type CreateLevelNameKeyMarketingPayload = {
  __typename?: 'CreateLevelNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyMarketing`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyMarketing` that was created by this mutation. */
  levelNameKeyMarketing?: Maybe<LevelNameKeyMarketing>;
  /** An edge for our `LevelNameKeyMarketing`. May be used by Relay 1. */
  levelNameKeyMarketingEdge?: Maybe<LevelNameKeyMarketingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameKeyMarketing` mutation. */
export type CreateLevelNameKeyMarketingPayloadLevelNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyMarketingsOrderBy>>;
};

/** All input for the create `LevelNameLong` mutation. */
export type CreateLevelNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameLong` to be created by this mutation. */
  levelNameLong: LevelNameLongInput;
};

/** The output of our create `LevelNameLong` mutation. */
export type CreateLevelNameLongPayload = {
  __typename?: 'CreateLevelNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameLong`. */
  level?: Maybe<Level>;
  /** The `LevelNameLong` that was created by this mutation. */
  levelNameLong?: Maybe<LevelNameLong>;
  /** An edge for our `LevelNameLong`. May be used by Relay 1. */
  levelNameLongEdge?: Maybe<LevelNameLongsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameLong` mutation. */
export type CreateLevelNameLongPayloadLevelNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameLongsOrderBy>>;
};

/** All input for the create `LevelNameShort` mutation. */
export type CreateLevelNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelNameShort` to be created by this mutation. */
  levelNameShort: LevelNameShortInput;
};

/** The output of our create `LevelNameShort` mutation. */
export type CreateLevelNameShortPayload = {
  __typename?: 'CreateLevelNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameShort`. */
  level?: Maybe<Level>;
  /** The `LevelNameShort` that was created by this mutation. */
  levelNameShort?: Maybe<LevelNameShort>;
  /** An edge for our `LevelNameShort`. May be used by Relay 1. */
  levelNameShortEdge?: Maybe<LevelNameShortsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelNameShort` mutation. */
export type CreateLevelNameShortPayloadLevelNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameShortsOrderBy>>;
};

/** The output of our create `Level` mutation. */
export type CreateLevelPayload = {
  __typename?: 'CreateLevelPayload';
  /** Reads a single `Building` that is related to this `Level`. */
  building?: Maybe<Building>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ElevationLevel` that is related to this `Level`. */
  elevation?: Maybe<ElevationLevel>;
  /** The `Level` that was created by this mutation. */
  level?: Maybe<Level>;
  /** An edge for our `Level`. May be used by Relay 1. */
  levelEdge?: Maybe<LevelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `LevelType` that is related to this `Level`. */
  type?: Maybe<LevelType>;
};


/** The output of our create `Level` mutation. */
export type CreateLevelPayloadLevelEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};

/** All input for the create `LevelPublicGrossSpace` mutation. */
export type CreateLevelPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelPublicGrossSpace` to be created by this mutation. */
  levelPublicGrossSpace: LevelPublicGrossSpaceInput;
};

/** The output of our create `LevelPublicGrossSpace` mutation. */
export type CreateLevelPublicGrossSpacePayload = {
  __typename?: 'CreateLevelPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelPublicGrossSpace`. */
  level?: Maybe<Level>;
  /** The `LevelPublicGrossSpace` that was created by this mutation. */
  levelPublicGrossSpace?: Maybe<LevelPublicGrossSpace>;
  /** An edge for our `LevelPublicGrossSpace`. May be used by Relay 1. */
  levelPublicGrossSpaceEdge?: Maybe<LevelPublicGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelPublicGrossSpace` mutation. */
export type CreateLevelPublicGrossSpacePayloadLevelPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelPublicGrossSpacesOrderBy>>;
};

/** All input for the create `LevelTypeAttr` mutation. */
export type CreateLevelTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelTypeAttr` to be created by this mutation. */
  levelTypeAttr: LevelTypeAttrInput;
};

/** The output of our create `LevelTypeAttr` mutation. */
export type CreateLevelTypeAttrPayload = {
  __typename?: 'CreateLevelTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelTypeAttr`. */
  level?: Maybe<Level>;
  /** Reads a single `LevelType` that is related to this `LevelTypeAttr`. */
  levelType?: Maybe<LevelType>;
  /** The `LevelTypeAttr` that was created by this mutation. */
  levelTypeAttr?: Maybe<LevelTypeAttr>;
  /** An edge for our `LevelTypeAttr`. May be used by Relay 1. */
  levelTypeAttrEdge?: Maybe<LevelTypeAttrsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelTypeAttr` mutation. */
export type CreateLevelTypeAttrPayloadLevelTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelTypeAttrsOrderBy>>;
};

/** All input for the create `LevelType` mutation. */
export type CreateLevelTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LevelType` to be created by this mutation. */
  levelType: LevelTypeInput;
};

/** The output of our create `LevelType` mutation. */
export type CreateLevelTypePayload = {
  __typename?: 'CreateLevelTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LevelType` that was created by this mutation. */
  levelType?: Maybe<LevelType>;
  /** An edge for our `LevelType`. May be used by Relay 1. */
  levelTypeEdge?: Maybe<LevelTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LevelType` mutation. */
export type CreateLevelTypePayloadLevelTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelTypesOrderBy>>;
};

/** All input for the create `Link` mutation. */
export type CreateLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Link` to be created by this mutation. */
  link: LinkInput;
};

/** The output of our create `Link` mutation. */
export type CreateLinkPayload = {
  __typename?: 'CreateLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Link` that was created by this mutation. */
  link?: Maybe<Link>;
  /** An edge for our `Link`. May be used by Relay 1. */
  linkEdge?: Maybe<LinksEdge>;
  /** Reads a single `Multilink` that is related to this `Link`. */
  multilink?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Link` mutation. */
export type CreateLinkPayloadLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};

/** All input for the create `Multilink` mutation. */
export type CreateMultilinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Multilink` to be created by this mutation. */
  multilink: MultilinkInput;
};

/** The output of our create `Multilink` mutation. */
export type CreateMultilinkPayload = {
  __typename?: 'CreateMultilinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Multilink` that was created by this mutation. */
  multilink?: Maybe<Multilink>;
  /** An edge for our `Multilink`. May be used by Relay 1. */
  multilinkEdge?: Maybe<MultilinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Multilink` mutation. */
export type CreateMultilinkPayloadMultilinkEdgeArgs = {
  orderBy?: InputMaybe<Array<MultilinksOrderBy>>;
};

export type CreatePasswordLoginResponse = AlreadyHasPasswordLogin | EmailTaken | Success;

/** All input for the create `PlotCadGrossSpaceMin` mutation. */
export type CreatePlotCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotCadGrossSpaceMin` to be created by this mutation. */
  plotCadGrossSpaceMin: PlotCadGrossSpaceMinInput;
};

/** The output of our create `PlotCadGrossSpaceMin` mutation. */
export type CreatePlotCadGrossSpaceMinPayload = {
  __typename?: 'CreatePlotCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotCadGrossSpaceMin`. */
  plot?: Maybe<Plot>;
  /** The `PlotCadGrossSpaceMin` that was created by this mutation. */
  plotCadGrossSpaceMin?: Maybe<PlotCadGrossSpaceMin>;
  /** An edge for our `PlotCadGrossSpaceMin`. May be used by Relay 1. */
  plotCadGrossSpaceMinEdge?: Maybe<PlotCadGrossSpaceMinsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotCadGrossSpaceMin` mutation. */
export type CreatePlotCadGrossSpaceMinPayloadPlotCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotCadGrossSpaceMinsOrderBy>>;
};

/** All input for the create `PlotDescription` mutation. */
export type CreatePlotDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotDescription` to be created by this mutation. */
  plotDescription: PlotDescriptionInput;
};

/** The output of our create `PlotDescription` mutation. */
export type CreatePlotDescriptionPayload = {
  __typename?: 'CreatePlotDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotDescription`. */
  plot?: Maybe<Plot>;
  /** The `PlotDescription` that was created by this mutation. */
  plotDescription?: Maybe<PlotDescription>;
  /** An edge for our `PlotDescription`. May be used by Relay 1. */
  plotDescriptionEdge?: Maybe<PlotDescriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotDescription` mutation. */
export type CreatePlotDescriptionPayloadPlotDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotDescriptionsOrderBy>>;
};

/** All input for the create `Plot` mutation. */
export type CreatePlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Plot` to be created by this mutation. */
  plot: PlotInput;
};

/** All input for the create `PlotNameExtra` mutation. */
export type CreatePlotNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameExtra` to be created by this mutation. */
  plotNameExtra: PlotNameExtraInput;
};

/** The output of our create `PlotNameExtra` mutation. */
export type CreatePlotNameExtraPayload = {
  __typename?: 'CreatePlotNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameExtra`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameExtra` that was created by this mutation. */
  plotNameExtra?: Maybe<PlotNameExtra>;
  /** An edge for our `PlotNameExtra`. May be used by Relay 1. */
  plotNameExtraEdge?: Maybe<PlotNameExtrasEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameExtra` mutation. */
export type CreatePlotNameExtraPayloadPlotNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameExtrasOrderBy>>;
};

/** All input for the create `PlotNameKeyCad` mutation. */
export type CreatePlotNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameKeyCad` to be created by this mutation. */
  plotNameKeyCad: PlotNameKeyCadInput;
};

/** The output of our create `PlotNameKeyCad` mutation. */
export type CreatePlotNameKeyCadPayload = {
  __typename?: 'CreatePlotNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyCad`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyCad` that was created by this mutation. */
  plotNameKeyCad?: Maybe<PlotNameKeyCad>;
  /** An edge for our `PlotNameKeyCad`. May be used by Relay 1. */
  plotNameKeyCadEdge?: Maybe<PlotNameKeyCadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameKeyCad` mutation. */
export type CreatePlotNameKeyCadPayloadPlotNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyCadsOrderBy>>;
};

/** All input for the create `PlotNameKeyCafm` mutation. */
export type CreatePlotNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameKeyCafm` to be created by this mutation. */
  plotNameKeyCafm: PlotNameKeyCafmInput;
};

/** The output of our create `PlotNameKeyCafm` mutation. */
export type CreatePlotNameKeyCafmPayload = {
  __typename?: 'CreatePlotNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyCafm`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyCafm` that was created by this mutation. */
  plotNameKeyCafm?: Maybe<PlotNameKeyCafm>;
  /** An edge for our `PlotNameKeyCafm`. May be used by Relay 1. */
  plotNameKeyCafmEdge?: Maybe<PlotNameKeyCafmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameKeyCafm` mutation. */
export type CreatePlotNameKeyCafmPayloadPlotNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyCafmsOrderBy>>;
};

/** All input for the create `PlotNameKeyEbm` mutation. */
export type CreatePlotNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameKeyEbm` to be created by this mutation. */
  plotNameKeyEbm: PlotNameKeyEbmInput;
};

/** The output of our create `PlotNameKeyEbm` mutation. */
export type CreatePlotNameKeyEbmPayload = {
  __typename?: 'CreatePlotNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyEbm`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyEbm` that was created by this mutation. */
  plotNameKeyEbm?: Maybe<PlotNameKeyEbm>;
  /** An edge for our `PlotNameKeyEbm`. May be used by Relay 1. */
  plotNameKeyEbmEdge?: Maybe<PlotNameKeyEbmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameKeyEbm` mutation. */
export type CreatePlotNameKeyEbmPayloadPlotNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyEbmsOrderBy>>;
};

/** All input for the create `PlotNameKeyMarketing` mutation. */
export type CreatePlotNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameKeyMarketing` to be created by this mutation. */
  plotNameKeyMarketing: PlotNameKeyMarketingInput;
};

/** The output of our create `PlotNameKeyMarketing` mutation. */
export type CreatePlotNameKeyMarketingPayload = {
  __typename?: 'CreatePlotNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyMarketing`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyMarketing` that was created by this mutation. */
  plotNameKeyMarketing?: Maybe<PlotNameKeyMarketing>;
  /** An edge for our `PlotNameKeyMarketing`. May be used by Relay 1. */
  plotNameKeyMarketingEdge?: Maybe<PlotNameKeyMarketingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameKeyMarketing` mutation. */
export type CreatePlotNameKeyMarketingPayloadPlotNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyMarketingsOrderBy>>;
};

/** All input for the create `PlotNameLong` mutation. */
export type CreatePlotNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameLong` to be created by this mutation. */
  plotNameLong: PlotNameLongInput;
};

/** The output of our create `PlotNameLong` mutation. */
export type CreatePlotNameLongPayload = {
  __typename?: 'CreatePlotNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameLong`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameLong` that was created by this mutation. */
  plotNameLong?: Maybe<PlotNameLong>;
  /** An edge for our `PlotNameLong`. May be used by Relay 1. */
  plotNameLongEdge?: Maybe<PlotNameLongsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameLong` mutation. */
export type CreatePlotNameLongPayloadPlotNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameLongsOrderBy>>;
};

/** All input for the create `PlotNameShort` mutation. */
export type CreatePlotNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotNameShort` to be created by this mutation. */
  plotNameShort: PlotNameShortInput;
};

/** The output of our create `PlotNameShort` mutation. */
export type CreatePlotNameShortPayload = {
  __typename?: 'CreatePlotNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameShort`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameShort` that was created by this mutation. */
  plotNameShort?: Maybe<PlotNameShort>;
  /** An edge for our `PlotNameShort`. May be used by Relay 1. */
  plotNameShortEdge?: Maybe<PlotNameShortsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotNameShort` mutation. */
export type CreatePlotNameShortPayloadPlotNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameShortsOrderBy>>;
};

/** The output of our create `Plot` mutation. */
export type CreatePlotPayload = {
  __typename?: 'CreatePlotPayload';
  /** Reads a single `Area` that is related to this `Plot`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Plot` that was created by this mutation. */
  plot?: Maybe<Plot>;
  /** An edge for our `Plot`. May be used by Relay 1. */
  plotEdge?: Maybe<PlotsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PlotType` that is related to this `Plot`. */
  type?: Maybe<PlotType>;
};


/** The output of our create `Plot` mutation. */
export type CreatePlotPayloadPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotsOrderBy>>;
};

/** All input for the create `PlotPublicGrossSpace` mutation. */
export type CreatePlotPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotPublicGrossSpace` to be created by this mutation. */
  plotPublicGrossSpace: PlotPublicGrossSpaceInput;
};

/** The output of our create `PlotPublicGrossSpace` mutation. */
export type CreatePlotPublicGrossSpacePayload = {
  __typename?: 'CreatePlotPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotPublicGrossSpace`. */
  plot?: Maybe<Plot>;
  /** The `PlotPublicGrossSpace` that was created by this mutation. */
  plotPublicGrossSpace?: Maybe<PlotPublicGrossSpace>;
  /** An edge for our `PlotPublicGrossSpace`. May be used by Relay 1. */
  plotPublicGrossSpaceEdge?: Maybe<PlotPublicGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotPublicGrossSpace` mutation. */
export type CreatePlotPublicGrossSpacePayloadPlotPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotPublicGrossSpacesOrderBy>>;
};

/** All input for the create `PlotTypeAttr` mutation. */
export type CreatePlotTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotTypeAttr` to be created by this mutation. */
  plotTypeAttr: PlotTypeAttrInput;
};

/** The output of our create `PlotTypeAttr` mutation. */
export type CreatePlotTypeAttrPayload = {
  __typename?: 'CreatePlotTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotTypeAttr`. */
  plot?: Maybe<Plot>;
  /** Reads a single `PlotType` that is related to this `PlotTypeAttr`. */
  plotType?: Maybe<PlotType>;
  /** The `PlotTypeAttr` that was created by this mutation. */
  plotTypeAttr?: Maybe<PlotTypeAttr>;
  /** An edge for our `PlotTypeAttr`. May be used by Relay 1. */
  plotTypeAttrEdge?: Maybe<PlotTypeAttrsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotTypeAttr` mutation. */
export type CreatePlotTypeAttrPayloadPlotTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotTypeAttrsOrderBy>>;
};

/** All input for the create `PlotType` mutation. */
export type CreatePlotTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PlotType` to be created by this mutation. */
  plotType: PlotTypeInput;
};

/** The output of our create `PlotType` mutation. */
export type CreatePlotTypePayload = {
  __typename?: 'CreatePlotTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PlotType` that was created by this mutation. */
  plotType?: Maybe<PlotType>;
  /** An edge for our `PlotType`. May be used by Relay 1. */
  plotTypeEdge?: Maybe<PlotTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PlotType` mutation. */
export type CreatePlotTypePayloadPlotTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotTypesOrderBy>>;
};

/** All input for the create `ProjectAllocationArea` mutation. */
export type CreateProjectAllocationAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationArea` to be created by this mutation. */
  projectAllocationArea: ProjectAllocationAreaInput;
};

/** The output of our create `ProjectAllocationArea` mutation. */
export type CreateProjectAllocationAreaPayload = {
  __typename?: 'CreateProjectAllocationAreaPayload';
  /** Reads a single `Area` that is related to this `ProjectAllocationArea`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationArea` that was created by this mutation. */
  projectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** An edge for our `ProjectAllocationArea`. May be used by Relay 1. */
  projectAllocationAreaEdge?: Maybe<ProjectAllocationAreasEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationArea`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectAllocationArea` mutation. */
export type CreateProjectAllocationAreaPayloadProjectAllocationAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationAreasOrderBy>>;
};

/** All input for the create `ProjectAllocationAreaPhase` mutation. */
export type CreateProjectAllocationAreaPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationAreaPhase` to be created by this mutation. */
  projectAllocationAreaPhase: ProjectAllocationAreaPhaseInput;
};

/** The output of our create `ProjectAllocationAreaPhase` mutation. */
export type CreateProjectAllocationAreaPhasePayload = {
  __typename?: 'CreateProjectAllocationAreaPhasePayload';
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectAllocationAreaPhase`. */
  allocation?: Maybe<ProjectAllocationArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationAreaPhase` that was created by this mutation. */
  projectAllocationAreaPhase?: Maybe<ProjectAllocationAreaPhase>;
  /** An edge for our `ProjectAllocationAreaPhase`. May be used by Relay 1. */
  projectAllocationAreaPhaseEdge?: Maybe<ProjectAllocationAreaPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationAreaPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our create `ProjectAllocationAreaPhase` mutation. */
export type CreateProjectAllocationAreaPhasePayloadProjectAllocationAreaPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationAreaPhasesOrderBy>>;
};

/** All input for the create `ProjectAllocationPlot` mutation. */
export type CreateProjectAllocationPlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationPlot` to be created by this mutation. */
  projectAllocationPlot: ProjectAllocationPlotInput;
};

/** The output of our create `ProjectAllocationPlot` mutation. */
export type CreateProjectAllocationPlotPayload = {
  __typename?: 'CreateProjectAllocationPlotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `ProjectAllocationPlot`. */
  plot?: Maybe<Plot>;
  /** The `ProjectAllocationPlot` that was created by this mutation. */
  projectAllocationPlot?: Maybe<ProjectAllocationPlot>;
  /** An edge for our `ProjectAllocationPlot`. May be used by Relay 1. */
  projectAllocationPlotEdge?: Maybe<ProjectAllocationPlotsEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationPlot`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectAllocationPlot` mutation. */
export type CreateProjectAllocationPlotPayloadProjectAllocationPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationPlotsOrderBy>>;
};

/** All input for the create `ProjectAllocationPlotPhase` mutation. */
export type CreateProjectAllocationPlotPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationPlotPhase` to be created by this mutation. */
  projectAllocationPlotPhase: ProjectAllocationPlotPhaseInput;
};

/** The output of our create `ProjectAllocationPlotPhase` mutation. */
export type CreateProjectAllocationPlotPhasePayload = {
  __typename?: 'CreateProjectAllocationPlotPhasePayload';
  /** Reads a single `ProjectAllocationPlot` that is related to this `ProjectAllocationPlotPhase`. */
  allocation?: Maybe<ProjectAllocationPlot>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationPlotPhase` that was created by this mutation. */
  projectAllocationPlotPhase?: Maybe<ProjectAllocationPlotPhase>;
  /** An edge for our `ProjectAllocationPlotPhase`. May be used by Relay 1. */
  projectAllocationPlotPhaseEdge?: Maybe<ProjectAllocationPlotPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationPlotPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our create `ProjectAllocationPlotPhase` mutation. */
export type CreateProjectAllocationPlotPhasePayloadProjectAllocationPlotPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationPlotPhasesOrderBy>>;
};

/** All input for the create `ProjectAllocationRoom` mutation. */
export type CreateProjectAllocationRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationRoom` to be created by this mutation. */
  projectAllocationRoom: ProjectAllocationRoomInput;
};

/** The output of our create `ProjectAllocationRoom` mutation. */
export type CreateProjectAllocationRoomPayload = {
  __typename?: 'CreateProjectAllocationRoomPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationRoom` that was created by this mutation. */
  projectAllocationRoom?: Maybe<ProjectAllocationRoom>;
  /** An edge for our `ProjectAllocationRoom`. May be used by Relay 1. */
  projectAllocationRoomEdge?: Maybe<ProjectAllocationRoomsEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationRoom`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `ProjectAllocationRoom`. */
  room?: Maybe<Room>;
};


/** The output of our create `ProjectAllocationRoom` mutation. */
export type CreateProjectAllocationRoomPayloadProjectAllocationRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationRoomsOrderBy>>;
};

/** All input for the create `ProjectAllocationRoomPhase` mutation. */
export type CreateProjectAllocationRoomPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationRoomPhase` to be created by this mutation. */
  projectAllocationRoomPhase: ProjectAllocationRoomPhaseInput;
};

/** The output of our create `ProjectAllocationRoomPhase` mutation. */
export type CreateProjectAllocationRoomPhasePayload = {
  __typename?: 'CreateProjectAllocationRoomPhasePayload';
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectAllocationRoomPhase`. */
  allocation?: Maybe<ProjectAllocationRoom>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationRoomPhase` that was created by this mutation. */
  projectAllocationRoomPhase?: Maybe<ProjectAllocationRoomPhase>;
  /** An edge for our `ProjectAllocationRoomPhase`. May be used by Relay 1. */
  projectAllocationRoomPhaseEdge?: Maybe<ProjectAllocationRoomPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationRoomPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our create `ProjectAllocationRoomPhase` mutation. */
export type CreateProjectAllocationRoomPhasePayloadProjectAllocationRoomPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationRoomPhasesOrderBy>>;
};

/** All input for the create `ProjectAllocationUsage` mutation. */
export type CreateProjectAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectAllocationUsage` to be created by this mutation. */
  projectAllocationUsage: ProjectAllocationUsageInput;
};

/** The output of our create `ProjectAllocationUsage` mutation. */
export type CreateProjectAllocationUsagePayload = {
  __typename?: 'CreateProjectAllocationUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationUsage` that was created by this mutation. */
  projectAllocationUsage?: Maybe<ProjectAllocationUsage>;
  /** An edge for our `ProjectAllocationUsage`. May be used by Relay 1. */
  projectAllocationUsageEdge?: Maybe<ProjectAllocationUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectAllocationUsage` mutation. */
export type CreateProjectAllocationUsagePayloadProjectAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationUsagesOrderBy>>;
};

/** All input for the create `Project` mutation. */
export type CreateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Project` to be created by this mutation. */
  project: ProjectInput;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherLinks?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherSystems?: Maybe<Multilink>;
  /** The `Project` that was created by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectSeries` that is related to this `Project`. */
  series?: Maybe<ProjectSeries>;
};


/** The output of our create `Project` mutation. */
export type CreateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the create `ProjectSeries` mutation. */
export type CreateProjectSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectSeries` to be created by this mutation. */
  projectSeries: ProjectSeriesInput;
};

/** The output of our create `ProjectSeries` mutation. */
export type CreateProjectSeriesPayload = {
  __typename?: 'CreateProjectSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherLinks?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherSystems?: Maybe<Multilink>;
  /** The `ProjectSeries` that was created by this mutation. */
  projectSeries?: Maybe<ProjectSeries>;
  /** An edge for our `ProjectSeries`. May be used by Relay 1. */
  projectSeriesEdge?: Maybe<ProjectSeriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our create `ProjectSeries` mutation. */
export type CreateProjectSeriesPayloadProjectSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};

/** All input for the create `ProjectVariant` mutation. */
export type CreateProjectVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectVariant` to be created by this mutation. */
  projectVariant: ProjectVariantInput;
};

/** The output of our create `ProjectVariant` mutation. */
export type CreateProjectVariantPayload = {
  __typename?: 'CreateProjectVariantPayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  /** The `ProjectVariant` that was created by this mutation. */
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our create `ProjectVariant` mutation. */
export type CreateProjectVariantPayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** All input for the `createProjectVariantWithAllocationsFrom` mutation. */
export type CreateProjectVariantWithAllocationsFromInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  newVariantName?: InputMaybe<Scalars['String']>;
  sourceVariantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createProjectVariantWithAllocationsFrom` mutation. */
export type CreateProjectVariantWithAllocationsFromPayload = {
  __typename?: 'CreateProjectVariantWithAllocationsFromPayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our `createProjectVariantWithAllocationsFrom` mutation. */
export type CreateProjectVariantWithAllocationsFromPayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** All input for the create `RoomAirChangeRate` mutation. */
export type CreateRoomAirChangeRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomAirChangeRate` to be created by this mutation. */
  roomAirChangeRate: RoomAirChangeRateInput;
};

/** The output of our create `RoomAirChangeRate` mutation. */
export type CreateRoomAirChangeRatePayload = {
  __typename?: 'CreateRoomAirChangeRatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomAirChangeRate`. */
  room?: Maybe<Room>;
  /** The `RoomAirChangeRate` that was created by this mutation. */
  roomAirChangeRate?: Maybe<RoomAirChangeRate>;
  /** An edge for our `RoomAirChangeRate`. May be used by Relay 1. */
  roomAirChangeRateEdge?: Maybe<RoomAirChangeRatesEdge>;
};


/** The output of our create `RoomAirChangeRate` mutation. */
export type CreateRoomAirChangeRatePayloadRoomAirChangeRateEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomAirChangeRatesOrderBy>>;
};

/** All input for the create `RoomAirConditioning` mutation. */
export type CreateRoomAirConditioningInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomAirConditioning` to be created by this mutation. */
  roomAirConditioning: RoomAirConditioningInput;
};

/** The output of our create `RoomAirConditioning` mutation. */
export type CreateRoomAirConditioningPayload = {
  __typename?: 'CreateRoomAirConditioningPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomAirConditioning`. */
  room?: Maybe<Room>;
  /** The `RoomAirConditioning` that was created by this mutation. */
  roomAirConditioning?: Maybe<RoomAirConditioning>;
  /** An edge for our `RoomAirConditioning`. May be used by Relay 1. */
  roomAirConditioningEdge?: Maybe<RoomAirConditioningsEdge>;
};


/** The output of our create `RoomAirConditioning` mutation. */
export type CreateRoomAirConditioningPayloadRoomAirConditioningEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomAirConditioningsOrderBy>>;
};

/** All input for the create `RoomCadGrossSpaceMin` mutation. */
export type CreateRoomCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadGrossSpaceMin` to be created by this mutation. */
  roomCadGrossSpaceMin: RoomCadGrossSpaceMinInput;
};

/** The output of our create `RoomCadGrossSpaceMin` mutation. */
export type CreateRoomCadGrossSpaceMinPayload = {
  __typename?: 'CreateRoomCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadGrossSpaceMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadGrossSpaceMin` that was created by this mutation. */
  roomCadGrossSpaceMin?: Maybe<RoomCadGrossSpaceMin>;
  /** An edge for our `RoomCadGrossSpaceMin`. May be used by Relay 1. */
  roomCadGrossSpaceMinEdge?: Maybe<RoomCadGrossSpaceMinsEdge>;
};


/** The output of our create `RoomCadGrossSpaceMin` mutation. */
export type CreateRoomCadGrossSpaceMinPayloadRoomCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadGrossSpaceMinsOrderBy>>;
};

/** All input for the create `RoomCadHeightMax` mutation. */
export type CreateRoomCadHeightMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadHeightMax` to be created by this mutation. */
  roomCadHeightMax: RoomCadHeightMaxInput;
};

/** The output of our create `RoomCadHeightMax` mutation. */
export type CreateRoomCadHeightMaxPayload = {
  __typename?: 'CreateRoomCadHeightMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadHeightMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadHeightMax` that was created by this mutation. */
  roomCadHeightMax?: Maybe<RoomCadHeightMax>;
  /** An edge for our `RoomCadHeightMax`. May be used by Relay 1. */
  roomCadHeightMaxEdge?: Maybe<RoomCadHeightMaxesEdge>;
};


/** The output of our create `RoomCadHeightMax` mutation. */
export type CreateRoomCadHeightMaxPayloadRoomCadHeightMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadHeightMaxesOrderBy>>;
};

/** All input for the create `RoomCadHeightMin` mutation. */
export type CreateRoomCadHeightMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadHeightMin` to be created by this mutation. */
  roomCadHeightMin: RoomCadHeightMinInput;
};

/** The output of our create `RoomCadHeightMin` mutation. */
export type CreateRoomCadHeightMinPayload = {
  __typename?: 'CreateRoomCadHeightMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadHeightMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadHeightMin` that was created by this mutation. */
  roomCadHeightMin?: Maybe<RoomCadHeightMin>;
  /** An edge for our `RoomCadHeightMin`. May be used by Relay 1. */
  roomCadHeightMinEdge?: Maybe<RoomCadHeightMinsEdge>;
};


/** The output of our create `RoomCadHeightMin` mutation. */
export type CreateRoomCadHeightMinPayloadRoomCadHeightMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadHeightMinsOrderBy>>;
};

/** All input for the create `RoomCadLengthMax` mutation. */
export type CreateRoomCadLengthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadLengthMax` to be created by this mutation. */
  roomCadLengthMax: RoomCadLengthMaxInput;
};

/** The output of our create `RoomCadLengthMax` mutation. */
export type CreateRoomCadLengthMaxPayload = {
  __typename?: 'CreateRoomCadLengthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadLengthMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadLengthMax` that was created by this mutation. */
  roomCadLengthMax?: Maybe<RoomCadLengthMax>;
  /** An edge for our `RoomCadLengthMax`. May be used by Relay 1. */
  roomCadLengthMaxEdge?: Maybe<RoomCadLengthMaxesEdge>;
};


/** The output of our create `RoomCadLengthMax` mutation. */
export type CreateRoomCadLengthMaxPayloadRoomCadLengthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadLengthMaxesOrderBy>>;
};

/** All input for the create `RoomCadLengthMin` mutation. */
export type CreateRoomCadLengthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadLengthMin` to be created by this mutation. */
  roomCadLengthMin: RoomCadLengthMinInput;
};

/** The output of our create `RoomCadLengthMin` mutation. */
export type CreateRoomCadLengthMinPayload = {
  __typename?: 'CreateRoomCadLengthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadLengthMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadLengthMin` that was created by this mutation. */
  roomCadLengthMin?: Maybe<RoomCadLengthMin>;
  /** An edge for our `RoomCadLengthMin`. May be used by Relay 1. */
  roomCadLengthMinEdge?: Maybe<RoomCadLengthMinsEdge>;
};


/** The output of our create `RoomCadLengthMin` mutation. */
export type CreateRoomCadLengthMinPayloadRoomCadLengthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadLengthMinsOrderBy>>;
};

/** All input for the create `RoomCadWidthMax` mutation. */
export type CreateRoomCadWidthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadWidthMax` to be created by this mutation. */
  roomCadWidthMax: RoomCadWidthMaxInput;
};

/** The output of our create `RoomCadWidthMax` mutation. */
export type CreateRoomCadWidthMaxPayload = {
  __typename?: 'CreateRoomCadWidthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadWidthMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadWidthMax` that was created by this mutation. */
  roomCadWidthMax?: Maybe<RoomCadWidthMax>;
  /** An edge for our `RoomCadWidthMax`. May be used by Relay 1. */
  roomCadWidthMaxEdge?: Maybe<RoomCadWidthMaxesEdge>;
};


/** The output of our create `RoomCadWidthMax` mutation. */
export type CreateRoomCadWidthMaxPayloadRoomCadWidthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadWidthMaxesOrderBy>>;
};

/** All input for the create `RoomCadWidthMin` mutation. */
export type CreateRoomCadWidthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCadWidthMin` to be created by this mutation. */
  roomCadWidthMin: RoomCadWidthMinInput;
};

/** The output of our create `RoomCadWidthMin` mutation. */
export type CreateRoomCadWidthMinPayload = {
  __typename?: 'CreateRoomCadWidthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadWidthMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadWidthMin` that was created by this mutation. */
  roomCadWidthMin?: Maybe<RoomCadWidthMin>;
  /** An edge for our `RoomCadWidthMin`. May be used by Relay 1. */
  roomCadWidthMinEdge?: Maybe<RoomCadWidthMinsEdge>;
};


/** The output of our create `RoomCadWidthMin` mutation. */
export type CreateRoomCadWidthMinPayloadRoomCadWidthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadWidthMinsOrderBy>>;
};

/** All input for the create `RoomCapacityCar` mutation. */
export type CreateRoomCapacityCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCapacityCar` to be created by this mutation. */
  roomCapacityCar: RoomCapacityCarInput;
};

/** The output of our create `RoomCapacityCar` mutation. */
export type CreateRoomCapacityCarPayload = {
  __typename?: 'CreateRoomCapacityCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityCar`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityCar` that was created by this mutation. */
  roomCapacityCar?: Maybe<RoomCapacityCar>;
  /** An edge for our `RoomCapacityCar`. May be used by Relay 1. */
  roomCapacityCarEdge?: Maybe<RoomCapacityCarsEdge>;
};


/** The output of our create `RoomCapacityCar` mutation. */
export type CreateRoomCapacityCarPayloadRoomCapacityCarEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityCarsOrderBy>>;
};

/** All input for the create `RoomCapacityPax` mutation. */
export type CreateRoomCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCapacityPax` to be created by this mutation. */
  roomCapacityPax: RoomCapacityPaxInput;
};

/** The output of our create `RoomCapacityPax` mutation. */
export type CreateRoomCapacityPaxPayload = {
  __typename?: 'CreateRoomCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityPax`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityPax` that was created by this mutation. */
  roomCapacityPax?: Maybe<RoomCapacityPax>;
  /** An edge for our `RoomCapacityPax`. May be used by Relay 1. */
  roomCapacityPaxEdge?: Maybe<RoomCapacityPaxesEdge>;
};


/** The output of our create `RoomCapacityPax` mutation. */
export type CreateRoomCapacityPaxPayloadRoomCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityPaxesOrderBy>>;
};

/** All input for the create `RoomCapacityTruck` mutation. */
export type CreateRoomCapacityTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCapacityTruck` to be created by this mutation. */
  roomCapacityTruck: RoomCapacityTruckInput;
};

/** The output of our create `RoomCapacityTruck` mutation. */
export type CreateRoomCapacityTruckPayload = {
  __typename?: 'CreateRoomCapacityTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityTruck`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityTruck` that was created by this mutation. */
  roomCapacityTruck?: Maybe<RoomCapacityTruck>;
  /** An edge for our `RoomCapacityTruck`. May be used by Relay 1. */
  roomCapacityTruckEdge?: Maybe<RoomCapacityTrucksEdge>;
};


/** The output of our create `RoomCapacityTruck` mutation. */
export type CreateRoomCapacityTruckPayloadRoomCapacityTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityTrucksOrderBy>>;
};

/** All input for the create `RoomCleaningGrossSpace` mutation. */
export type CreateRoomCleaningGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomCleaningGrossSpace` to be created by this mutation. */
  roomCleaningGrossSpace: RoomCleaningGrossSpaceInput;
};

/** The output of our create `RoomCleaningGrossSpace` mutation. */
export type CreateRoomCleaningGrossSpacePayload = {
  __typename?: 'CreateRoomCleaningGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCleaningGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomCleaningGrossSpace` that was created by this mutation. */
  roomCleaningGrossSpace?: Maybe<RoomCleaningGrossSpace>;
  /** An edge for our `RoomCleaningGrossSpace`. May be used by Relay 1. */
  roomCleaningGrossSpaceEdge?: Maybe<RoomCleaningGrossSpacesEdge>;
};


/** The output of our create `RoomCleaningGrossSpace` mutation. */
export type CreateRoomCleaningGrossSpacePayloadRoomCleaningGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCleaningGrossSpacesOrderBy>>;
};

/** All input for the create `RoomClearanceConstruction` mutation. */
export type CreateRoomClearanceConstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomClearanceConstruction` to be created by this mutation. */
  roomClearanceConstruction: RoomClearanceConstructionInput;
};

/** The output of our create `RoomClearanceConstruction` mutation. */
export type CreateRoomClearanceConstructionPayload = {
  __typename?: 'CreateRoomClearanceConstructionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomClearanceConstruction`. */
  room?: Maybe<Room>;
  /** The `RoomClearanceConstruction` that was created by this mutation. */
  roomClearanceConstruction?: Maybe<RoomClearanceConstruction>;
  /** An edge for our `RoomClearanceConstruction`. May be used by Relay 1. */
  roomClearanceConstructionEdge?: Maybe<RoomClearanceConstructionsEdge>;
};


/** The output of our create `RoomClearanceConstruction` mutation. */
export type CreateRoomClearanceConstructionPayloadRoomClearanceConstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomClearanceConstructionsOrderBy>>;
};

/** All input for the create `RoomContactBooking` mutation. */
export type CreateRoomContactBookingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomContactBooking` to be created by this mutation. */
  roomContactBooking: RoomContactBookingInput;
};

/** The output of our create `RoomContactBooking` mutation. */
export type CreateRoomContactBookingPayload = {
  __typename?: 'CreateRoomContactBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomContactBooking`. */
  room?: Maybe<Room>;
  /** The `RoomContactBooking` that was created by this mutation. */
  roomContactBooking?: Maybe<RoomContactBooking>;
  /** An edge for our `RoomContactBooking`. May be used by Relay 1. */
  roomContactBookingEdge?: Maybe<RoomContactBookingsEdge>;
};


/** The output of our create `RoomContactBooking` mutation. */
export type CreateRoomContactBookingPayloadRoomContactBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomContactBookingsOrderBy>>;
};

/** All input for the create `RoomDaylight` mutation. */
export type CreateRoomDaylightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomDaylight` to be created by this mutation. */
  roomDaylight: RoomDaylightInput;
};

/** The output of our create `RoomDaylight` mutation. */
export type CreateRoomDaylightPayload = {
  __typename?: 'CreateRoomDaylightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomDaylight`. */
  room?: Maybe<Room>;
  /** The `RoomDaylight` that was created by this mutation. */
  roomDaylight?: Maybe<RoomDaylight>;
  /** An edge for our `RoomDaylight`. May be used by Relay 1. */
  roomDaylightEdge?: Maybe<RoomDaylightsEdge>;
};


/** The output of our create `RoomDaylight` mutation. */
export type CreateRoomDaylightPayloadRoomDaylightEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomDaylightsOrderBy>>;
};

/** All input for the create `RoomDescription` mutation. */
export type CreateRoomDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomDescription` to be created by this mutation. */
  roomDescription: RoomDescriptionInput;
};

/** The output of our create `RoomDescription` mutation. */
export type CreateRoomDescriptionPayload = {
  __typename?: 'CreateRoomDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomDescription`. */
  room?: Maybe<Room>;
  /** The `RoomDescription` that was created by this mutation. */
  roomDescription?: Maybe<RoomDescription>;
  /** An edge for our `RoomDescription`. May be used by Relay 1. */
  roomDescriptionEdge?: Maybe<RoomDescriptionsEdge>;
};


/** The output of our create `RoomDescription` mutation. */
export type CreateRoomDescriptionPayloadRoomDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomDescriptionsOrderBy>>;
};

/** All input for the create `Room` mutation. */
export type CreateRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Room` to be created by this mutation. */
  room: RoomInput;
};

/** All input for the create `RoomKeyIssuance` mutation. */
export type CreateRoomKeyIssuanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomKeyIssuance` to be created by this mutation. */
  roomKeyIssuance: RoomKeyIssuanceInput;
};

/** All input for the create `RoomKeyIssuanceNote` mutation. */
export type CreateRoomKeyIssuanceNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomKeyIssuanceNote` to be created by this mutation. */
  roomKeyIssuanceNote: RoomKeyIssuanceNoteInput;
};

/** The output of our create `RoomKeyIssuanceNote` mutation. */
export type CreateRoomKeyIssuanceNotePayload = {
  __typename?: 'CreateRoomKeyIssuanceNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomKeyIssuanceNote`. */
  room?: Maybe<Room>;
  /** The `RoomKeyIssuanceNote` that was created by this mutation. */
  roomKeyIssuanceNote?: Maybe<RoomKeyIssuanceNote>;
  /** An edge for our `RoomKeyIssuanceNote`. May be used by Relay 1. */
  roomKeyIssuanceNoteEdge?: Maybe<RoomKeyIssuanceNotesEdge>;
};


/** The output of our create `RoomKeyIssuanceNote` mutation. */
export type CreateRoomKeyIssuanceNotePayloadRoomKeyIssuanceNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomKeyIssuanceNotesOrderBy>>;
};

/** The output of our create `RoomKeyIssuance` mutation. */
export type CreateRoomKeyIssuancePayload = {
  __typename?: 'CreateRoomKeyIssuancePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomKeyIssuance`. */
  room?: Maybe<Room>;
  /** The `RoomKeyIssuance` that was created by this mutation. */
  roomKeyIssuance?: Maybe<RoomKeyIssuance>;
  /** An edge for our `RoomKeyIssuance`. May be used by Relay 1. */
  roomKeyIssuanceEdge?: Maybe<RoomKeyIssuancesEdge>;
};


/** The output of our create `RoomKeyIssuance` mutation. */
export type CreateRoomKeyIssuancePayloadRoomKeyIssuanceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomKeyIssuancesOrderBy>>;
};

/** All input for the create `RoomLightShutter` mutation. */
export type CreateRoomLightShutterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomLightShutter` to be created by this mutation. */
  roomLightShutter: RoomLightShutterInput;
};

/** The output of our create `RoomLightShutter` mutation. */
export type CreateRoomLightShutterPayload = {
  __typename?: 'CreateRoomLightShutterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomLightShutter`. */
  room?: Maybe<Room>;
  /** The `RoomLightShutter` that was created by this mutation. */
  roomLightShutter?: Maybe<RoomLightShutter>;
  /** An edge for our `RoomLightShutter`. May be used by Relay 1. */
  roomLightShutterEdge?: Maybe<RoomLightShuttersEdge>;
};


/** The output of our create `RoomLightShutter` mutation. */
export type CreateRoomLightShutterPayloadRoomLightShutterEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomLightShuttersOrderBy>>;
};

/** All input for the create `RoomMaxLoadCeiling` mutation. */
export type CreateRoomMaxLoadCeilingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomMaxLoadCeiling` to be created by this mutation. */
  roomMaxLoadCeiling: RoomMaxLoadCeilingInput;
};

/** The output of our create `RoomMaxLoadCeiling` mutation. */
export type CreateRoomMaxLoadCeilingPayload = {
  __typename?: 'CreateRoomMaxLoadCeilingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomMaxLoadCeiling`. */
  room?: Maybe<Room>;
  /** The `RoomMaxLoadCeiling` that was created by this mutation. */
  roomMaxLoadCeiling?: Maybe<RoomMaxLoadCeiling>;
  /** An edge for our `RoomMaxLoadCeiling`. May be used by Relay 1. */
  roomMaxLoadCeilingEdge?: Maybe<RoomMaxLoadCeilingsEdge>;
};


/** The output of our create `RoomMaxLoadCeiling` mutation. */
export type CreateRoomMaxLoadCeilingPayloadRoomMaxLoadCeilingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomMaxLoadCeilingsOrderBy>>;
};

/** All input for the create `RoomMaxLoadFloor` mutation. */
export type CreateRoomMaxLoadFloorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomMaxLoadFloor` to be created by this mutation. */
  roomMaxLoadFloor: RoomMaxLoadFloorInput;
};

/** The output of our create `RoomMaxLoadFloor` mutation. */
export type CreateRoomMaxLoadFloorPayload = {
  __typename?: 'CreateRoomMaxLoadFloorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomMaxLoadFloor`. */
  room?: Maybe<Room>;
  /** The `RoomMaxLoadFloor` that was created by this mutation. */
  roomMaxLoadFloor?: Maybe<RoomMaxLoadFloor>;
  /** An edge for our `RoomMaxLoadFloor`. May be used by Relay 1. */
  roomMaxLoadFloorEdge?: Maybe<RoomMaxLoadFloorsEdge>;
};


/** The output of our create `RoomMaxLoadFloor` mutation. */
export type CreateRoomMaxLoadFloorPayloadRoomMaxLoadFloorEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomMaxLoadFloorsOrderBy>>;
};

/** All input for the create `RoomNameExtra` mutation. */
export type CreateRoomNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameExtra` to be created by this mutation. */
  roomNameExtra: RoomNameExtraInput;
};

/** The output of our create `RoomNameExtra` mutation. */
export type CreateRoomNameExtraPayload = {
  __typename?: 'CreateRoomNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameExtra`. */
  room?: Maybe<Room>;
  /** The `RoomNameExtra` that was created by this mutation. */
  roomNameExtra?: Maybe<RoomNameExtra>;
  /** An edge for our `RoomNameExtra`. May be used by Relay 1. */
  roomNameExtraEdge?: Maybe<RoomNameExtrasEdge>;
};


/** The output of our create `RoomNameExtra` mutation. */
export type CreateRoomNameExtraPayloadRoomNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameExtrasOrderBy>>;
};

/** All input for the create `RoomNameKeyCad` mutation. */
export type CreateRoomNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameKeyCad` to be created by this mutation. */
  roomNameKeyCad: RoomNameKeyCadInput;
};

/** The output of our create `RoomNameKeyCad` mutation. */
export type CreateRoomNameKeyCadPayload = {
  __typename?: 'CreateRoomNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyCad`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyCad` that was created by this mutation. */
  roomNameKeyCad?: Maybe<RoomNameKeyCad>;
  /** An edge for our `RoomNameKeyCad`. May be used by Relay 1. */
  roomNameKeyCadEdge?: Maybe<RoomNameKeyCadsEdge>;
};


/** The output of our create `RoomNameKeyCad` mutation. */
export type CreateRoomNameKeyCadPayloadRoomNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyCadsOrderBy>>;
};

/** All input for the create `RoomNameKeyCafm` mutation. */
export type CreateRoomNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameKeyCafm` to be created by this mutation. */
  roomNameKeyCafm: RoomNameKeyCafmInput;
};

/** The output of our create `RoomNameKeyCafm` mutation. */
export type CreateRoomNameKeyCafmPayload = {
  __typename?: 'CreateRoomNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyCafm`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyCafm` that was created by this mutation. */
  roomNameKeyCafm?: Maybe<RoomNameKeyCafm>;
  /** An edge for our `RoomNameKeyCafm`. May be used by Relay 1. */
  roomNameKeyCafmEdge?: Maybe<RoomNameKeyCafmsEdge>;
};


/** The output of our create `RoomNameKeyCafm` mutation. */
export type CreateRoomNameKeyCafmPayloadRoomNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyCafmsOrderBy>>;
};

/** All input for the create `RoomNameKeyEbm` mutation. */
export type CreateRoomNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameKeyEbm` to be created by this mutation. */
  roomNameKeyEbm: RoomNameKeyEbmInput;
};

/** The output of our create `RoomNameKeyEbm` mutation. */
export type CreateRoomNameKeyEbmPayload = {
  __typename?: 'CreateRoomNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyEbm`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyEbm` that was created by this mutation. */
  roomNameKeyEbm?: Maybe<RoomNameKeyEbm>;
  /** An edge for our `RoomNameKeyEbm`. May be used by Relay 1. */
  roomNameKeyEbmEdge?: Maybe<RoomNameKeyEbmsEdge>;
};


/** The output of our create `RoomNameKeyEbm` mutation. */
export type CreateRoomNameKeyEbmPayloadRoomNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyEbmsOrderBy>>;
};

/** All input for the create `RoomNameKeyMarketing` mutation. */
export type CreateRoomNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameKeyMarketing` to be created by this mutation. */
  roomNameKeyMarketing: RoomNameKeyMarketingInput;
};

/** The output of our create `RoomNameKeyMarketing` mutation. */
export type CreateRoomNameKeyMarketingPayload = {
  __typename?: 'CreateRoomNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyMarketing`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyMarketing` that was created by this mutation. */
  roomNameKeyMarketing?: Maybe<RoomNameKeyMarketing>;
  /** An edge for our `RoomNameKeyMarketing`. May be used by Relay 1. */
  roomNameKeyMarketingEdge?: Maybe<RoomNameKeyMarketingsEdge>;
};


/** The output of our create `RoomNameKeyMarketing` mutation. */
export type CreateRoomNameKeyMarketingPayloadRoomNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyMarketingsOrderBy>>;
};

/** All input for the create `RoomNameLong` mutation. */
export type CreateRoomNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameLong` to be created by this mutation. */
  roomNameLong: RoomNameLongInput;
};

/** The output of our create `RoomNameLong` mutation. */
export type CreateRoomNameLongPayload = {
  __typename?: 'CreateRoomNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameLong`. */
  room?: Maybe<Room>;
  /** The `RoomNameLong` that was created by this mutation. */
  roomNameLong?: Maybe<RoomNameLong>;
  /** An edge for our `RoomNameLong`. May be used by Relay 1. */
  roomNameLongEdge?: Maybe<RoomNameLongsEdge>;
};


/** The output of our create `RoomNameLong` mutation. */
export type CreateRoomNameLongPayloadRoomNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameLongsOrderBy>>;
};

/** All input for the create `RoomNameShort` mutation. */
export type CreateRoomNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNameShort` to be created by this mutation. */
  roomNameShort: RoomNameShortInput;
};

/** The output of our create `RoomNameShort` mutation. */
export type CreateRoomNameShortPayload = {
  __typename?: 'CreateRoomNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameShort`. */
  room?: Maybe<Room>;
  /** The `RoomNameShort` that was created by this mutation. */
  roomNameShort?: Maybe<RoomNameShort>;
  /** An edge for our `RoomNameShort`. May be used by Relay 1. */
  roomNameShortEdge?: Maybe<RoomNameShortsEdge>;
};


/** The output of our create `RoomNameShort` mutation. */
export type CreateRoomNameShortPayloadRoomNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameShortsOrderBy>>;
};

/** All input for the create `RoomNoVehicle` mutation. */
export type CreateRoomNoVehicleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomNoVehicle` to be created by this mutation. */
  roomNoVehicle: RoomNoVehicleInput;
};

/** The output of our create `RoomNoVehicle` mutation. */
export type CreateRoomNoVehiclePayload = {
  __typename?: 'CreateRoomNoVehiclePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNoVehicle`. */
  room?: Maybe<Room>;
  /** The `RoomNoVehicle` that was created by this mutation. */
  roomNoVehicle?: Maybe<RoomNoVehicle>;
  /** An edge for our `RoomNoVehicle`. May be used by Relay 1. */
  roomNoVehicleEdge?: Maybe<RoomNoVehiclesEdge>;
};


/** The output of our create `RoomNoVehicle` mutation. */
export type CreateRoomNoVehiclePayloadRoomNoVehicleEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNoVehiclesOrderBy>>;
};

/** All input for the create `RoomPartitionCadGrossSpaceMin` mutation. */
export type CreateRoomPartitionCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadGrossSpaceMin` to be created by this mutation. */
  roomPartitionCadGrossSpaceMin: RoomPartitionCadGrossSpaceMinInput;
};

/** The output of our create `RoomPartitionCadGrossSpaceMin` mutation. */
export type CreateRoomPartitionCadGrossSpaceMinPayload = {
  __typename?: 'CreateRoomPartitionCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadGrossSpaceMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadGrossSpaceMin` that was created by this mutation. */
  roomPartitionCadGrossSpaceMin?: Maybe<RoomPartitionCadGrossSpaceMin>;
  /** An edge for our `RoomPartitionCadGrossSpaceMin`. May be used by Relay 1. */
  roomPartitionCadGrossSpaceMinEdge?: Maybe<RoomPartitionCadGrossSpaceMinsEdge>;
};


/** The output of our create `RoomPartitionCadGrossSpaceMin` mutation. */
export type CreateRoomPartitionCadGrossSpaceMinPayloadRoomPartitionCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinsOrderBy>>;
};

/** All input for the create `RoomPartitionCadHeightMax` mutation. */
export type CreateRoomPartitionCadHeightMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadHeightMax` to be created by this mutation. */
  roomPartitionCadHeightMax: RoomPartitionCadHeightMaxInput;
};

/** The output of our create `RoomPartitionCadHeightMax` mutation. */
export type CreateRoomPartitionCadHeightMaxPayload = {
  __typename?: 'CreateRoomPartitionCadHeightMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadHeightMax` that was created by this mutation. */
  roomPartitionCadHeightMax?: Maybe<RoomPartitionCadHeightMax>;
  /** An edge for our `RoomPartitionCadHeightMax`. May be used by Relay 1. */
  roomPartitionCadHeightMaxEdge?: Maybe<RoomPartitionCadHeightMaxesEdge>;
};


/** The output of our create `RoomPartitionCadHeightMax` mutation. */
export type CreateRoomPartitionCadHeightMaxPayloadRoomPartitionCadHeightMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMaxesOrderBy>>;
};

/** All input for the create `RoomPartitionCadHeightMin` mutation. */
export type CreateRoomPartitionCadHeightMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadHeightMin` to be created by this mutation. */
  roomPartitionCadHeightMin: RoomPartitionCadHeightMinInput;
};

/** The output of our create `RoomPartitionCadHeightMin` mutation. */
export type CreateRoomPartitionCadHeightMinPayload = {
  __typename?: 'CreateRoomPartitionCadHeightMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadHeightMin` that was created by this mutation. */
  roomPartitionCadHeightMin?: Maybe<RoomPartitionCadHeightMin>;
  /** An edge for our `RoomPartitionCadHeightMin`. May be used by Relay 1. */
  roomPartitionCadHeightMinEdge?: Maybe<RoomPartitionCadHeightMinsEdge>;
};


/** The output of our create `RoomPartitionCadHeightMin` mutation. */
export type CreateRoomPartitionCadHeightMinPayloadRoomPartitionCadHeightMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMinsOrderBy>>;
};

/** All input for the create `RoomPartitionCadLengthMax` mutation. */
export type CreateRoomPartitionCadLengthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadLengthMax` to be created by this mutation. */
  roomPartitionCadLengthMax: RoomPartitionCadLengthMaxInput;
};

/** The output of our create `RoomPartitionCadLengthMax` mutation. */
export type CreateRoomPartitionCadLengthMaxPayload = {
  __typename?: 'CreateRoomPartitionCadLengthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadLengthMax` that was created by this mutation. */
  roomPartitionCadLengthMax?: Maybe<RoomPartitionCadLengthMax>;
  /** An edge for our `RoomPartitionCadLengthMax`. May be used by Relay 1. */
  roomPartitionCadLengthMaxEdge?: Maybe<RoomPartitionCadLengthMaxesEdge>;
};


/** The output of our create `RoomPartitionCadLengthMax` mutation. */
export type CreateRoomPartitionCadLengthMaxPayloadRoomPartitionCadLengthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMaxesOrderBy>>;
};

/** All input for the create `RoomPartitionCadLengthMin` mutation. */
export type CreateRoomPartitionCadLengthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadLengthMin` to be created by this mutation. */
  roomPartitionCadLengthMin: RoomPartitionCadLengthMinInput;
};

/** The output of our create `RoomPartitionCadLengthMin` mutation. */
export type CreateRoomPartitionCadLengthMinPayload = {
  __typename?: 'CreateRoomPartitionCadLengthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadLengthMin` that was created by this mutation. */
  roomPartitionCadLengthMin?: Maybe<RoomPartitionCadLengthMin>;
  /** An edge for our `RoomPartitionCadLengthMin`. May be used by Relay 1. */
  roomPartitionCadLengthMinEdge?: Maybe<RoomPartitionCadLengthMinsEdge>;
};


/** The output of our create `RoomPartitionCadLengthMin` mutation. */
export type CreateRoomPartitionCadLengthMinPayloadRoomPartitionCadLengthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMinsOrderBy>>;
};

/** All input for the create `RoomPartitionCadWidthMax` mutation. */
export type CreateRoomPartitionCadWidthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadWidthMax` to be created by this mutation. */
  roomPartitionCadWidthMax: RoomPartitionCadWidthMaxInput;
};

/** The output of our create `RoomPartitionCadWidthMax` mutation. */
export type CreateRoomPartitionCadWidthMaxPayload = {
  __typename?: 'CreateRoomPartitionCadWidthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadWidthMax` that was created by this mutation. */
  roomPartitionCadWidthMax?: Maybe<RoomPartitionCadWidthMax>;
  /** An edge for our `RoomPartitionCadWidthMax`. May be used by Relay 1. */
  roomPartitionCadWidthMaxEdge?: Maybe<RoomPartitionCadWidthMaxesEdge>;
};


/** The output of our create `RoomPartitionCadWidthMax` mutation. */
export type CreateRoomPartitionCadWidthMaxPayloadRoomPartitionCadWidthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMaxesOrderBy>>;
};

/** All input for the create `RoomPartitionCadWidthMin` mutation. */
export type CreateRoomPartitionCadWidthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCadWidthMin` to be created by this mutation. */
  roomPartitionCadWidthMin: RoomPartitionCadWidthMinInput;
};

/** The output of our create `RoomPartitionCadWidthMin` mutation. */
export type CreateRoomPartitionCadWidthMinPayload = {
  __typename?: 'CreateRoomPartitionCadWidthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadWidthMin` that was created by this mutation. */
  roomPartitionCadWidthMin?: Maybe<RoomPartitionCadWidthMin>;
  /** An edge for our `RoomPartitionCadWidthMin`. May be used by Relay 1. */
  roomPartitionCadWidthMinEdge?: Maybe<RoomPartitionCadWidthMinsEdge>;
};


/** The output of our create `RoomPartitionCadWidthMin` mutation. */
export type CreateRoomPartitionCadWidthMinPayloadRoomPartitionCadWidthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMinsOrderBy>>;
};

/** All input for the create `RoomPartitionCapacityPax` mutation. */
export type CreateRoomPartitionCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCapacityPax` to be created by this mutation. */
  roomPartitionCapacityPax: RoomPartitionCapacityPaxInput;
};

/** The output of our create `RoomPartitionCapacityPax` mutation. */
export type CreateRoomPartitionCapacityPaxPayload = {
  __typename?: 'CreateRoomPartitionCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCapacityPax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCapacityPax` that was created by this mutation. */
  roomPartitionCapacityPax?: Maybe<RoomPartitionCapacityPax>;
  /** An edge for our `RoomPartitionCapacityPax`. May be used by Relay 1. */
  roomPartitionCapacityPaxEdge?: Maybe<RoomPartitionCapacityPaxesEdge>;
};


/** The output of our create `RoomPartitionCapacityPax` mutation. */
export type CreateRoomPartitionCapacityPaxPayloadRoomPartitionCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCapacityPaxesOrderBy>>;
};

/** All input for the create `RoomPartitionCleaningGrossSpace` mutation. */
export type CreateRoomPartitionCleaningGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionCleaningGrossSpace` to be created by this mutation. */
  roomPartitionCleaningGrossSpace: RoomPartitionCleaningGrossSpaceInput;
};

/** The output of our create `RoomPartitionCleaningGrossSpace` mutation. */
export type CreateRoomPartitionCleaningGrossSpacePayload = {
  __typename?: 'CreateRoomPartitionCleaningGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCleaningGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCleaningGrossSpace` that was created by this mutation. */
  roomPartitionCleaningGrossSpace?: Maybe<RoomPartitionCleaningGrossSpace>;
  /** An edge for our `RoomPartitionCleaningGrossSpace`. May be used by Relay 1. */
  roomPartitionCleaningGrossSpaceEdge?: Maybe<RoomPartitionCleaningGrossSpacesEdge>;
};


/** The output of our create `RoomPartitionCleaningGrossSpace` mutation. */
export type CreateRoomPartitionCleaningGrossSpacePayloadRoomPartitionCleaningGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCleaningGrossSpacesOrderBy>>;
};

/** All input for the create `RoomPartitionDescription` mutation. */
export type CreateRoomPartitionDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionDescription` to be created by this mutation. */
  roomPartitionDescription: RoomPartitionDescriptionInput;
};

/** The output of our create `RoomPartitionDescription` mutation. */
export type CreateRoomPartitionDescriptionPayload = {
  __typename?: 'CreateRoomPartitionDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionDescription`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionDescription` that was created by this mutation. */
  roomPartitionDescription?: Maybe<RoomPartitionDescription>;
  /** An edge for our `RoomPartitionDescription`. May be used by Relay 1. */
  roomPartitionDescriptionEdge?: Maybe<RoomPartitionDescriptionsEdge>;
};


/** The output of our create `RoomPartitionDescription` mutation. */
export type CreateRoomPartitionDescriptionPayloadRoomPartitionDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionDescriptionsOrderBy>>;
};

/** All input for the create `RoomPartition` mutation. */
export type CreateRoomPartitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartition` to be created by this mutation. */
  roomPartition: RoomPartitionInput;
};

/** All input for the create `RoomPartitionNameExtra` mutation. */
export type CreateRoomPartitionNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameExtra` to be created by this mutation. */
  roomPartitionNameExtra: RoomPartitionNameExtraInput;
};

/** The output of our create `RoomPartitionNameExtra` mutation. */
export type CreateRoomPartitionNameExtraPayload = {
  __typename?: 'CreateRoomPartitionNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameExtra`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameExtra` that was created by this mutation. */
  roomPartitionNameExtra?: Maybe<RoomPartitionNameExtra>;
  /** An edge for our `RoomPartitionNameExtra`. May be used by Relay 1. */
  roomPartitionNameExtraEdge?: Maybe<RoomPartitionNameExtrasEdge>;
};


/** The output of our create `RoomPartitionNameExtra` mutation. */
export type CreateRoomPartitionNameExtraPayloadRoomPartitionNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameExtrasOrderBy>>;
};

/** All input for the create `RoomPartitionNameKeyCad` mutation. */
export type CreateRoomPartitionNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameKeyCad` to be created by this mutation. */
  roomPartitionNameKeyCad: RoomPartitionNameKeyCadInput;
};

/** The output of our create `RoomPartitionNameKeyCad` mutation. */
export type CreateRoomPartitionNameKeyCadPayload = {
  __typename?: 'CreateRoomPartitionNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCad`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyCad` that was created by this mutation. */
  roomPartitionNameKeyCad?: Maybe<RoomPartitionNameKeyCad>;
  /** An edge for our `RoomPartitionNameKeyCad`. May be used by Relay 1. */
  roomPartitionNameKeyCadEdge?: Maybe<RoomPartitionNameKeyCadsEdge>;
};


/** The output of our create `RoomPartitionNameKeyCad` mutation. */
export type CreateRoomPartitionNameKeyCadPayloadRoomPartitionNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCadsOrderBy>>;
};

/** All input for the create `RoomPartitionNameKeyCafm` mutation. */
export type CreateRoomPartitionNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameKeyCafm` to be created by this mutation. */
  roomPartitionNameKeyCafm: RoomPartitionNameKeyCafmInput;
};

/** The output of our create `RoomPartitionNameKeyCafm` mutation. */
export type CreateRoomPartitionNameKeyCafmPayload = {
  __typename?: 'CreateRoomPartitionNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCafm`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyCafm` that was created by this mutation. */
  roomPartitionNameKeyCafm?: Maybe<RoomPartitionNameKeyCafm>;
  /** An edge for our `RoomPartitionNameKeyCafm`. May be used by Relay 1. */
  roomPartitionNameKeyCafmEdge?: Maybe<RoomPartitionNameKeyCafmsEdge>;
};


/** The output of our create `RoomPartitionNameKeyCafm` mutation. */
export type CreateRoomPartitionNameKeyCafmPayloadRoomPartitionNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCafmsOrderBy>>;
};

/** All input for the create `RoomPartitionNameKeyEbm` mutation. */
export type CreateRoomPartitionNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameKeyEbm` to be created by this mutation. */
  roomPartitionNameKeyEbm: RoomPartitionNameKeyEbmInput;
};

/** The output of our create `RoomPartitionNameKeyEbm` mutation. */
export type CreateRoomPartitionNameKeyEbmPayload = {
  __typename?: 'CreateRoomPartitionNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyEbm`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyEbm` that was created by this mutation. */
  roomPartitionNameKeyEbm?: Maybe<RoomPartitionNameKeyEbm>;
  /** An edge for our `RoomPartitionNameKeyEbm`. May be used by Relay 1. */
  roomPartitionNameKeyEbmEdge?: Maybe<RoomPartitionNameKeyEbmsEdge>;
};


/** The output of our create `RoomPartitionNameKeyEbm` mutation. */
export type CreateRoomPartitionNameKeyEbmPayloadRoomPartitionNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyEbmsOrderBy>>;
};

/** All input for the create `RoomPartitionNameKeyMarketing` mutation. */
export type CreateRoomPartitionNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameKeyMarketing` to be created by this mutation. */
  roomPartitionNameKeyMarketing: RoomPartitionNameKeyMarketingInput;
};

/** The output of our create `RoomPartitionNameKeyMarketing` mutation. */
export type CreateRoomPartitionNameKeyMarketingPayload = {
  __typename?: 'CreateRoomPartitionNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyMarketing`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyMarketing` that was created by this mutation. */
  roomPartitionNameKeyMarketing?: Maybe<RoomPartitionNameKeyMarketing>;
  /** An edge for our `RoomPartitionNameKeyMarketing`. May be used by Relay 1. */
  roomPartitionNameKeyMarketingEdge?: Maybe<RoomPartitionNameKeyMarketingsEdge>;
};


/** The output of our create `RoomPartitionNameKeyMarketing` mutation. */
export type CreateRoomPartitionNameKeyMarketingPayloadRoomPartitionNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyMarketingsOrderBy>>;
};

/** All input for the create `RoomPartitionNameLong` mutation. */
export type CreateRoomPartitionNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameLong` to be created by this mutation. */
  roomPartitionNameLong: RoomPartitionNameLongInput;
};

/** The output of our create `RoomPartitionNameLong` mutation. */
export type CreateRoomPartitionNameLongPayload = {
  __typename?: 'CreateRoomPartitionNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameLong`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameLong` that was created by this mutation. */
  roomPartitionNameLong?: Maybe<RoomPartitionNameLong>;
  /** An edge for our `RoomPartitionNameLong`. May be used by Relay 1. */
  roomPartitionNameLongEdge?: Maybe<RoomPartitionNameLongsEdge>;
};


/** The output of our create `RoomPartitionNameLong` mutation. */
export type CreateRoomPartitionNameLongPayloadRoomPartitionNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameLongsOrderBy>>;
};

/** All input for the create `RoomPartitionNameShort` mutation. */
export type CreateRoomPartitionNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionNameShort` to be created by this mutation. */
  roomPartitionNameShort: RoomPartitionNameShortInput;
};

/** The output of our create `RoomPartitionNameShort` mutation. */
export type CreateRoomPartitionNameShortPayload = {
  __typename?: 'CreateRoomPartitionNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameShort`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameShort` that was created by this mutation. */
  roomPartitionNameShort?: Maybe<RoomPartitionNameShort>;
  /** An edge for our `RoomPartitionNameShort`. May be used by Relay 1. */
  roomPartitionNameShortEdge?: Maybe<RoomPartitionNameShortsEdge>;
};


/** The output of our create `RoomPartitionNameShort` mutation. */
export type CreateRoomPartitionNameShortPayloadRoomPartitionNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameShortsOrderBy>>;
};

/** The output of our create `RoomPartition` mutation. */
export type CreateRoomPartitionPayload = {
  __typename?: 'CreateRoomPartitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPartition`. */
  room?: Maybe<Room>;
  /** The `RoomPartition` that was created by this mutation. */
  roomPartition?: Maybe<RoomPartition>;
  /** An edge for our `RoomPartition`. May be used by Relay 1. */
  roomPartitionEdge?: Maybe<RoomPartitionsEdge>;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartition`. */
  type?: Maybe<RoomPartitionType>;
};


/** The output of our create `RoomPartition` mutation. */
export type CreateRoomPartitionPayloadRoomPartitionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionsOrderBy>>;
};

/** All input for the create `RoomPartitionPublicGrossSpace` mutation. */
export type CreateRoomPartitionPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionPublicGrossSpace` to be created by this mutation. */
  roomPartitionPublicGrossSpace: RoomPartitionPublicGrossSpaceInput;
};

/** The output of our create `RoomPartitionPublicGrossSpace` mutation. */
export type CreateRoomPartitionPublicGrossSpacePayload = {
  __typename?: 'CreateRoomPartitionPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionPublicGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionPublicGrossSpace` that was created by this mutation. */
  roomPartitionPublicGrossSpace?: Maybe<RoomPartitionPublicGrossSpace>;
  /** An edge for our `RoomPartitionPublicGrossSpace`. May be used by Relay 1. */
  roomPartitionPublicGrossSpaceEdge?: Maybe<RoomPartitionPublicGrossSpacesEdge>;
};


/** The output of our create `RoomPartitionPublicGrossSpace` mutation. */
export type CreateRoomPartitionPublicGrossSpacePayloadRoomPartitionPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionPublicGrossSpacesOrderBy>>;
};

/** All input for the create `RoomPartitionSbvGrossSpace` mutation. */
export type CreateRoomPartitionSbvGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionSbvGrossSpace` to be created by this mutation. */
  roomPartitionSbvGrossSpace: RoomPartitionSbvGrossSpaceInput;
};

/** The output of our create `RoomPartitionSbvGrossSpace` mutation. */
export type CreateRoomPartitionSbvGrossSpacePayload = {
  __typename?: 'CreateRoomPartitionSbvGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionSbvGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionSbvGrossSpace` that was created by this mutation. */
  roomPartitionSbvGrossSpace?: Maybe<RoomPartitionSbvGrossSpace>;
  /** An edge for our `RoomPartitionSbvGrossSpace`. May be used by Relay 1. */
  roomPartitionSbvGrossSpaceEdge?: Maybe<RoomPartitionSbvGrossSpacesEdge>;
};


/** The output of our create `RoomPartitionSbvGrossSpace` mutation. */
export type CreateRoomPartitionSbvGrossSpacePayloadRoomPartitionSbvGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionSbvGrossSpacesOrderBy>>;
};

/** All input for the create `RoomPartitionTypeAttr` mutation. */
export type CreateRoomPartitionTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionTypeAttr` to be created by this mutation. */
  roomPartitionTypeAttr: RoomPartitionTypeAttrInput;
};

/** The output of our create `RoomPartitionTypeAttr` mutation. */
export type CreateRoomPartitionTypeAttrPayload = {
  __typename?: 'CreateRoomPartitionTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionTypeAttr`. */
  roomPartition?: Maybe<RoomPartition>;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartitionTypeAttr`. */
  roomPartitionType?: Maybe<RoomPartitionType>;
  /** The `RoomPartitionTypeAttr` that was created by this mutation. */
  roomPartitionTypeAttr?: Maybe<RoomPartitionTypeAttr>;
  /** An edge for our `RoomPartitionTypeAttr`. May be used by Relay 1. */
  roomPartitionTypeAttrEdge?: Maybe<RoomPartitionTypeAttrsEdge>;
};


/** The output of our create `RoomPartitionTypeAttr` mutation. */
export type CreateRoomPartitionTypeAttrPayloadRoomPartitionTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionTypeAttrsOrderBy>>;
};

/** All input for the create `RoomPartitionType` mutation. */
export type CreateRoomPartitionTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPartitionType` to be created by this mutation. */
  roomPartitionType: RoomPartitionTypeInput;
};

/** The output of our create `RoomPartitionType` mutation. */
export type CreateRoomPartitionTypePayload = {
  __typename?: 'CreateRoomPartitionTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoomPartitionType` that was created by this mutation. */
  roomPartitionType?: Maybe<RoomPartitionType>;
  /** An edge for our `RoomPartitionType`. May be used by Relay 1. */
  roomPartitionTypeEdge?: Maybe<RoomPartitionTypesEdge>;
};


/** The output of our create `RoomPartitionType` mutation. */
export type CreateRoomPartitionTypePayloadRoomPartitionTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionTypesOrderBy>>;
};

/** The output of our create `Room` mutation. */
export type CreateRoomPayload = {
  __typename?: 'CreateRoomPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `Room`. */
  level?: Maybe<Level>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Room` that was created by this mutation. */
  room?: Maybe<Room>;
  /** An edge for our `Room`. May be used by Relay 1. */
  roomEdge?: Maybe<RoomsEdge>;
  /** Reads a single `RoomType` that is related to this `Room`. */
  type?: Maybe<RoomType>;
};


/** The output of our create `Room` mutation. */
export type CreateRoomPayloadRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomsOrderBy>>;
};

/** All input for the create `RoomPhoneNumber` mutation. */
export type CreateRoomPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPhoneNumber` to be created by this mutation. */
  roomPhoneNumber: RoomPhoneNumberInput;
};

/** The output of our create `RoomPhoneNumber` mutation. */
export type CreateRoomPhoneNumberPayload = {
  __typename?: 'CreateRoomPhoneNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPhoneNumber`. */
  room?: Maybe<Room>;
  /** The `RoomPhoneNumber` that was created by this mutation. */
  roomPhoneNumber?: Maybe<RoomPhoneNumber>;
  /** An edge for our `RoomPhoneNumber`. May be used by Relay 1. */
  roomPhoneNumberEdge?: Maybe<RoomPhoneNumbersEdge>;
};


/** The output of our create `RoomPhoneNumber` mutation. */
export type CreateRoomPhoneNumberPayloadRoomPhoneNumberEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPhoneNumbersOrderBy>>;
};

/** All input for the create `RoomPublicGrossSpace` mutation. */
export type CreateRoomPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomPublicGrossSpace` to be created by this mutation. */
  roomPublicGrossSpace: RoomPublicGrossSpaceInput;
};

/** The output of our create `RoomPublicGrossSpace` mutation. */
export type CreateRoomPublicGrossSpacePayload = {
  __typename?: 'CreateRoomPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPublicGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomPublicGrossSpace` that was created by this mutation. */
  roomPublicGrossSpace?: Maybe<RoomPublicGrossSpace>;
  /** An edge for our `RoomPublicGrossSpace`. May be used by Relay 1. */
  roomPublicGrossSpaceEdge?: Maybe<RoomPublicGrossSpacesEdge>;
};


/** The output of our create `RoomPublicGrossSpace` mutation. */
export type CreateRoomPublicGrossSpacePayloadRoomPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPublicGrossSpacesOrderBy>>;
};

/** All input for the create `RoomSbvGrossSpace` mutation. */
export type CreateRoomSbvGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomSbvGrossSpace` to be created by this mutation. */
  roomSbvGrossSpace: RoomSbvGrossSpaceInput;
};

/** The output of our create `RoomSbvGrossSpace` mutation. */
export type CreateRoomSbvGrossSpacePayload = {
  __typename?: 'CreateRoomSbvGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomSbvGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomSbvGrossSpace` that was created by this mutation. */
  roomSbvGrossSpace?: Maybe<RoomSbvGrossSpace>;
  /** An edge for our `RoomSbvGrossSpace`. May be used by Relay 1. */
  roomSbvGrossSpaceEdge?: Maybe<RoomSbvGrossSpacesEdge>;
};


/** The output of our create `RoomSbvGrossSpace` mutation. */
export type CreateRoomSbvGrossSpacePayloadRoomSbvGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomSbvGrossSpacesOrderBy>>;
};

/** All input for the create `RoomTireLoadCar` mutation. */
export type CreateRoomTireLoadCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomTireLoadCar` to be created by this mutation. */
  roomTireLoadCar: RoomTireLoadCarInput;
};

/** The output of our create `RoomTireLoadCar` mutation. */
export type CreateRoomTireLoadCarPayload = {
  __typename?: 'CreateRoomTireLoadCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadCar`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadCar` that was created by this mutation. */
  roomTireLoadCar?: Maybe<RoomTireLoadCar>;
  /** An edge for our `RoomTireLoadCar`. May be used by Relay 1. */
  roomTireLoadCarEdge?: Maybe<RoomTireLoadCarsEdge>;
};


/** The output of our create `RoomTireLoadCar` mutation. */
export type CreateRoomTireLoadCarPayloadRoomTireLoadCarEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadCarsOrderBy>>;
};

/** All input for the create `RoomTireLoadForklift` mutation. */
export type CreateRoomTireLoadForkliftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomTireLoadForklift` to be created by this mutation. */
  roomTireLoadForklift: RoomTireLoadForkliftInput;
};

/** The output of our create `RoomTireLoadForklift` mutation. */
export type CreateRoomTireLoadForkliftPayload = {
  __typename?: 'CreateRoomTireLoadForkliftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadForklift`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadForklift` that was created by this mutation. */
  roomTireLoadForklift?: Maybe<RoomTireLoadForklift>;
  /** An edge for our `RoomTireLoadForklift`. May be used by Relay 1. */
  roomTireLoadForkliftEdge?: Maybe<RoomTireLoadForkliftsEdge>;
};


/** The output of our create `RoomTireLoadForklift` mutation. */
export type CreateRoomTireLoadForkliftPayloadRoomTireLoadForkliftEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadForkliftsOrderBy>>;
};

/** All input for the create `RoomTireLoadTruck` mutation. */
export type CreateRoomTireLoadTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomTireLoadTruck` to be created by this mutation. */
  roomTireLoadTruck: RoomTireLoadTruckInput;
};

/** The output of our create `RoomTireLoadTruck` mutation. */
export type CreateRoomTireLoadTruckPayload = {
  __typename?: 'CreateRoomTireLoadTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadTruck`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadTruck` that was created by this mutation. */
  roomTireLoadTruck?: Maybe<RoomTireLoadTruck>;
  /** An edge for our `RoomTireLoadTruck`. May be used by Relay 1. */
  roomTireLoadTruckEdge?: Maybe<RoomTireLoadTrucksEdge>;
};


/** The output of our create `RoomTireLoadTruck` mutation. */
export type CreateRoomTireLoadTruckPayloadRoomTireLoadTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadTrucksOrderBy>>;
};

/** All input for the create `RoomTypeAttr` mutation. */
export type CreateRoomTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomTypeAttr` to be created by this mutation. */
  roomTypeAttr: RoomTypeAttrInput;
};

/** The output of our create `RoomTypeAttr` mutation. */
export type CreateRoomTypeAttrPayload = {
  __typename?: 'CreateRoomTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTypeAttr`. */
  room?: Maybe<Room>;
  /** Reads a single `RoomType` that is related to this `RoomTypeAttr`. */
  roomType?: Maybe<RoomType>;
  /** The `RoomTypeAttr` that was created by this mutation. */
  roomTypeAttr?: Maybe<RoomTypeAttr>;
  /** An edge for our `RoomTypeAttr`. May be used by Relay 1. */
  roomTypeAttrEdge?: Maybe<RoomTypeAttrsEdge>;
};


/** The output of our create `RoomTypeAttr` mutation. */
export type CreateRoomTypeAttrPayloadRoomTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTypeAttrsOrderBy>>;
};

/** All input for the create `RoomType` mutation. */
export type CreateRoomTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoomType` to be created by this mutation. */
  roomType: RoomTypeInput;
};

/** The output of our create `RoomType` mutation. */
export type CreateRoomTypePayload = {
  __typename?: 'CreateRoomTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoomType` that was created by this mutation. */
  roomType?: Maybe<RoomType>;
  /** An edge for our `RoomType`. May be used by Relay 1. */
  roomTypeEdge?: Maybe<RoomTypesEdge>;
};


/** The output of our create `RoomType` mutation. */
export type CreateRoomTypePayloadRoomTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTypesOrderBy>>;
};

/** All input for the create `ScenarioGroup` mutation. */
export type CreateScenarioGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScenarioGroup` to be created by this mutation. */
  scenarioGroup: ScenarioGroupInput;
};

/** The output of our create `ScenarioGroup` mutation. */
export type CreateScenarioGroupPayload = {
  __typename?: 'CreateScenarioGroupPayload';
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  organisationalChanges?: Maybe<Feed>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScenarioGroup` that was created by this mutation. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  /** An edge for our `ScenarioGroup`. May be used by Relay 1. */
  scenarioGroupEdge?: Maybe<ScenarioGroupsEdge>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our create `ScenarioGroup` mutation. */
export type CreateScenarioGroupPayloadScenarioGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};

/** All input for the create `Scenario` mutation. */
export type CreateScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Scenario` to be created by this mutation. */
  scenario: ScenarioInput;
};

/** The output of our create `Scenario` mutation. */
export type CreateScenarioPayload = {
  __typename?: 'CreateScenarioPayload';
  /** Reads a single `Feed` that is related to this `Scenario`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Scenario` that was created by this mutation. */
  scenario?: Maybe<Scenario>;
  /** An edge for our `Scenario`. May be used by Relay 1. */
  scenarioEdge?: Maybe<ScenariosEdge>;
  /** Reads a single `ScenarioGroup` that is related to this `Scenario`. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our create `Scenario` mutation. */
export type CreateScenarioPayloadScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** All input for the create `ScenarioSetting` mutation. */
export type CreateScenarioSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScenarioSetting` to be created by this mutation. */
  scenarioSetting: ScenarioSettingInput;
};

/** The output of our create `ScenarioSetting` mutation. */
export type CreateScenarioSettingPayload = {
  __typename?: 'CreateScenarioSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Scenario` that is related to this `ScenarioSetting`. */
  scenario?: Maybe<Scenario>;
  /** The `ScenarioSetting` that was created by this mutation. */
  scenarioSetting?: Maybe<ScenarioSetting>;
  /** An edge for our `ScenarioSetting`. May be used by Relay 1. */
  scenarioSettingEdge?: Maybe<ScenarioSettingsEdge>;
};


/** The output of our create `ScenarioSetting` mutation. */
export type CreateScenarioSettingPayloadScenarioSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioSettingsOrderBy>>;
};

/** All input for the create `ScenarioVariantVisibility` mutation. */
export type CreateScenarioVariantVisibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScenarioVariantVisibility` to be created by this mutation. */
  scenarioVariantVisibility: ScenarioVariantVisibilityInput;
};

/** The output of our create `ScenarioVariantVisibility` mutation. */
export type CreateScenarioVariantVisibilityPayload = {
  __typename?: 'CreateScenarioVariantVisibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Scenario` that is related to this `ScenarioVariantVisibility`. */
  scenario?: Maybe<Scenario>;
  /** The `ScenarioVariantVisibility` that was created by this mutation. */
  scenarioVariantVisibility?: Maybe<ScenarioVariantVisibility>;
  /** An edge for our `ScenarioVariantVisibility`. May be used by Relay 1. */
  scenarioVariantVisibilityEdge?: Maybe<ScenarioVariantVisibilitiesEdge>;
};


/** The output of our create `ScenarioVariantVisibility` mutation. */
export type CreateScenarioVariantVisibilityPayloadScenarioVariantVisibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioVariantVisibilitiesOrderBy>>;
};

/** All input for the create `SiteDescription` mutation. */
export type CreateSiteDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteDescription` to be created by this mutation. */
  siteDescription: SiteDescriptionInput;
};

/** The output of our create `SiteDescription` mutation. */
export type CreateSiteDescriptionPayload = {
  __typename?: 'CreateSiteDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteDescription`. */
  site?: Maybe<Site>;
  /** The `SiteDescription` that was created by this mutation. */
  siteDescription?: Maybe<SiteDescription>;
  /** An edge for our `SiteDescription`. May be used by Relay 1. */
  siteDescriptionEdge?: Maybe<SiteDescriptionsEdge>;
};


/** The output of our create `SiteDescription` mutation. */
export type CreateSiteDescriptionPayloadSiteDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteDescriptionsOrderBy>>;
};

/** All input for the create `Site` mutation. */
export type CreateSiteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Site` to be created by this mutation. */
  site: SiteInput;
};

/** All input for the create `SiteNameExtra` mutation. */
export type CreateSiteNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameExtra` to be created by this mutation. */
  siteNameExtra: SiteNameExtraInput;
};

/** The output of our create `SiteNameExtra` mutation. */
export type CreateSiteNameExtraPayload = {
  __typename?: 'CreateSiteNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameExtra`. */
  site?: Maybe<Site>;
  /** The `SiteNameExtra` that was created by this mutation. */
  siteNameExtra?: Maybe<SiteNameExtra>;
  /** An edge for our `SiteNameExtra`. May be used by Relay 1. */
  siteNameExtraEdge?: Maybe<SiteNameExtrasEdge>;
};


/** The output of our create `SiteNameExtra` mutation. */
export type CreateSiteNameExtraPayloadSiteNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameExtrasOrderBy>>;
};

/** All input for the create `SiteNameKeyCad` mutation. */
export type CreateSiteNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameKeyCad` to be created by this mutation. */
  siteNameKeyCad: SiteNameKeyCadInput;
};

/** The output of our create `SiteNameKeyCad` mutation. */
export type CreateSiteNameKeyCadPayload = {
  __typename?: 'CreateSiteNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyCad`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyCad` that was created by this mutation. */
  siteNameKeyCad?: Maybe<SiteNameKeyCad>;
  /** An edge for our `SiteNameKeyCad`. May be used by Relay 1. */
  siteNameKeyCadEdge?: Maybe<SiteNameKeyCadsEdge>;
};


/** The output of our create `SiteNameKeyCad` mutation. */
export type CreateSiteNameKeyCadPayloadSiteNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyCadsOrderBy>>;
};

/** All input for the create `SiteNameKeyCafm` mutation. */
export type CreateSiteNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameKeyCafm` to be created by this mutation. */
  siteNameKeyCafm: SiteNameKeyCafmInput;
};

/** The output of our create `SiteNameKeyCafm` mutation. */
export type CreateSiteNameKeyCafmPayload = {
  __typename?: 'CreateSiteNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyCafm`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyCafm` that was created by this mutation. */
  siteNameKeyCafm?: Maybe<SiteNameKeyCafm>;
  /** An edge for our `SiteNameKeyCafm`. May be used by Relay 1. */
  siteNameKeyCafmEdge?: Maybe<SiteNameKeyCafmsEdge>;
};


/** The output of our create `SiteNameKeyCafm` mutation. */
export type CreateSiteNameKeyCafmPayloadSiteNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyCafmsOrderBy>>;
};

/** All input for the create `SiteNameKeyEbm` mutation. */
export type CreateSiteNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameKeyEbm` to be created by this mutation. */
  siteNameKeyEbm: SiteNameKeyEbmInput;
};

/** The output of our create `SiteNameKeyEbm` mutation. */
export type CreateSiteNameKeyEbmPayload = {
  __typename?: 'CreateSiteNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyEbm`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyEbm` that was created by this mutation. */
  siteNameKeyEbm?: Maybe<SiteNameKeyEbm>;
  /** An edge for our `SiteNameKeyEbm`. May be used by Relay 1. */
  siteNameKeyEbmEdge?: Maybe<SiteNameKeyEbmsEdge>;
};


/** The output of our create `SiteNameKeyEbm` mutation. */
export type CreateSiteNameKeyEbmPayloadSiteNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyEbmsOrderBy>>;
};

/** All input for the create `SiteNameKeyMarketing` mutation. */
export type CreateSiteNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameKeyMarketing` to be created by this mutation. */
  siteNameKeyMarketing: SiteNameKeyMarketingInput;
};

/** The output of our create `SiteNameKeyMarketing` mutation. */
export type CreateSiteNameKeyMarketingPayload = {
  __typename?: 'CreateSiteNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyMarketing`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyMarketing` that was created by this mutation. */
  siteNameKeyMarketing?: Maybe<SiteNameKeyMarketing>;
  /** An edge for our `SiteNameKeyMarketing`. May be used by Relay 1. */
  siteNameKeyMarketingEdge?: Maybe<SiteNameKeyMarketingsEdge>;
};


/** The output of our create `SiteNameKeyMarketing` mutation. */
export type CreateSiteNameKeyMarketingPayloadSiteNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyMarketingsOrderBy>>;
};

/** All input for the create `SiteNameLong` mutation. */
export type CreateSiteNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameLong` to be created by this mutation. */
  siteNameLong: SiteNameLongInput;
};

/** The output of our create `SiteNameLong` mutation. */
export type CreateSiteNameLongPayload = {
  __typename?: 'CreateSiteNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameLong`. */
  site?: Maybe<Site>;
  /** The `SiteNameLong` that was created by this mutation. */
  siteNameLong?: Maybe<SiteNameLong>;
  /** An edge for our `SiteNameLong`. May be used by Relay 1. */
  siteNameLongEdge?: Maybe<SiteNameLongsEdge>;
};


/** The output of our create `SiteNameLong` mutation. */
export type CreateSiteNameLongPayloadSiteNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameLongsOrderBy>>;
};

/** All input for the create `SiteNameShort` mutation. */
export type CreateSiteNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SiteNameShort` to be created by this mutation. */
  siteNameShort: SiteNameShortInput;
};

/** The output of our create `SiteNameShort` mutation. */
export type CreateSiteNameShortPayload = {
  __typename?: 'CreateSiteNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameShort`. */
  site?: Maybe<Site>;
  /** The `SiteNameShort` that was created by this mutation. */
  siteNameShort?: Maybe<SiteNameShort>;
  /** An edge for our `SiteNameShort`. May be used by Relay 1. */
  siteNameShortEdge?: Maybe<SiteNameShortsEdge>;
};


/** The output of our create `SiteNameShort` mutation. */
export type CreateSiteNameShortPayloadSiteNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameShortsOrderBy>>;
};

/** The output of our create `Site` mutation. */
export type CreateSitePayload = {
  __typename?: 'CreateSitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Site` that was created by this mutation. */
  site?: Maybe<Site>;
  /** An edge for our `Site`. May be used by Relay 1. */
  siteEdge?: Maybe<SitesEdge>;
};


/** The output of our create `Site` mutation. */
export type CreateSitePayloadSiteEdgeArgs = {
  orderBy?: InputMaybe<Array<SitesOrderBy>>;
};

export type CreateUploadUrlResponse = {
  __typename?: 'CreateUploadUrlResponse';
  upload_id: Scalars['String'];
  url: Scalars['String'];
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** All input for the create `UserPasswordLogin` mutation. */
export type CreateUserPasswordLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserPasswordLogin` to be created by this mutation. */
  userPasswordLogin: UserPasswordLoginInput;
};

/** The output of our create `UserPasswordLogin` mutation. */
export type CreateUserPasswordLoginPayload = {
  __typename?: 'CreateUserPasswordLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserPasswordLogin`. */
  user?: Maybe<User>;
  /** The `UserPasswordLogin` that was created by this mutation. */
  userPasswordLogin?: Maybe<UserPasswordLogin>;
  /** An edge for our `UserPasswordLogin`. May be used by Relay 1. */
  userPasswordLoginEdge?: Maybe<UserPasswordLoginsEdge>;
};


/** The output of our create `UserPasswordLogin` mutation. */
export type CreateUserPasswordLoginPayloadUserPasswordLoginEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPasswordLoginsOrderBy>>;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserSsoLogin` mutation. */
export type CreateUserSsoLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserSsoLogin` to be created by this mutation. */
  userSsoLogin: UserSsoLoginInput;
};

/** The output of our create `UserSsoLogin` mutation. */
export type CreateUserSsoLoginPayload = {
  __typename?: 'CreateUserSsoLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSsoLogin`. */
  user?: Maybe<User>;
  /** The `UserSsoLogin` that was created by this mutation. */
  userSsoLogin?: Maybe<UserSsoLogin>;
  /** An edge for our `UserSsoLogin`. May be used by Relay 1. */
  userSsoLoginEdge?: Maybe<UserSsoLoginsEdge>;
};


/** The output of our create `UserSsoLogin` mutation. */
export type CreateUserSsoLoginPayloadUserSsoLoginEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSsoLoginsOrderBy>>;
};

export type CreateUserWithPasswordLoginResponse = CreatedUser | EmailTaken;

/** All input for the create `ZoneCadGrossSpaceMin` mutation. */
export type CreateZoneCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneCadGrossSpaceMin` to be created by this mutation. */
  zoneCadGrossSpaceMin: ZoneCadGrossSpaceMinInput;
};

/** The output of our create `ZoneCadGrossSpaceMin` mutation. */
export type CreateZoneCadGrossSpaceMinPayload = {
  __typename?: 'CreateZoneCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCadGrossSpaceMin`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCadGrossSpaceMin` that was created by this mutation. */
  zoneCadGrossSpaceMin?: Maybe<ZoneCadGrossSpaceMin>;
  /** An edge for our `ZoneCadGrossSpaceMin`. May be used by Relay 1. */
  zoneCadGrossSpaceMinEdge?: Maybe<ZoneCadGrossSpaceMinsEdge>;
};


/** The output of our create `ZoneCadGrossSpaceMin` mutation. */
export type CreateZoneCadGrossSpaceMinPayloadZoneCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCadGrossSpaceMinsOrderBy>>;
};

/** All input for the create `ZoneCapacityCar` mutation. */
export type CreateZoneCapacityCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneCapacityCar` to be created by this mutation. */
  zoneCapacityCar: ZoneCapacityCarInput;
};

/** The output of our create `ZoneCapacityCar` mutation. */
export type CreateZoneCapacityCarPayload = {
  __typename?: 'CreateZoneCapacityCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCapacityCar`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCapacityCar` that was created by this mutation. */
  zoneCapacityCar?: Maybe<ZoneCapacityCar>;
  /** An edge for our `ZoneCapacityCar`. May be used by Relay 1. */
  zoneCapacityCarEdge?: Maybe<ZoneCapacityCarsEdge>;
};


/** The output of our create `ZoneCapacityCar` mutation. */
export type CreateZoneCapacityCarPayloadZoneCapacityCarEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCapacityCarsOrderBy>>;
};

/** All input for the create `ZoneCapacityTruck` mutation. */
export type CreateZoneCapacityTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneCapacityTruck` to be created by this mutation. */
  zoneCapacityTruck: ZoneCapacityTruckInput;
};

/** The output of our create `ZoneCapacityTruck` mutation. */
export type CreateZoneCapacityTruckPayload = {
  __typename?: 'CreateZoneCapacityTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCapacityTruck`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCapacityTruck` that was created by this mutation. */
  zoneCapacityTruck?: Maybe<ZoneCapacityTruck>;
  /** An edge for our `ZoneCapacityTruck`. May be used by Relay 1. */
  zoneCapacityTruckEdge?: Maybe<ZoneCapacityTrucksEdge>;
};


/** The output of our create `ZoneCapacityTruck` mutation. */
export type CreateZoneCapacityTruckPayloadZoneCapacityTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCapacityTrucksOrderBy>>;
};

/** All input for the create `ZoneDescription` mutation. */
export type CreateZoneDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneDescription` to be created by this mutation. */
  zoneDescription: ZoneDescriptionInput;
};

/** The output of our create `ZoneDescription` mutation. */
export type CreateZoneDescriptionPayload = {
  __typename?: 'CreateZoneDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneDescription`. */
  zone?: Maybe<Zone>;
  /** The `ZoneDescription` that was created by this mutation. */
  zoneDescription?: Maybe<ZoneDescription>;
  /** An edge for our `ZoneDescription`. May be used by Relay 1. */
  zoneDescriptionEdge?: Maybe<ZoneDescriptionsEdge>;
};


/** The output of our create `ZoneDescription` mutation. */
export type CreateZoneDescriptionPayloadZoneDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneDescriptionsOrderBy>>;
};

/** All input for the create `Zone` mutation. */
export type CreateZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Zone` to be created by this mutation. */
  zone: ZoneInput;
};

/** All input for the create `ZoneMaxLoadFloor` mutation. */
export type CreateZoneMaxLoadFloorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneMaxLoadFloor` to be created by this mutation. */
  zoneMaxLoadFloor: ZoneMaxLoadFloorInput;
};

/** The output of our create `ZoneMaxLoadFloor` mutation. */
export type CreateZoneMaxLoadFloorPayload = {
  __typename?: 'CreateZoneMaxLoadFloorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneMaxLoadFloor`. */
  zone?: Maybe<Zone>;
  /** The `ZoneMaxLoadFloor` that was created by this mutation. */
  zoneMaxLoadFloor?: Maybe<ZoneMaxLoadFloor>;
  /** An edge for our `ZoneMaxLoadFloor`. May be used by Relay 1. */
  zoneMaxLoadFloorEdge?: Maybe<ZoneMaxLoadFloorsEdge>;
};


/** The output of our create `ZoneMaxLoadFloor` mutation. */
export type CreateZoneMaxLoadFloorPayloadZoneMaxLoadFloorEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneMaxLoadFloorsOrderBy>>;
};

/** All input for the create `ZoneNameExtra` mutation. */
export type CreateZoneNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameExtra` to be created by this mutation. */
  zoneNameExtra: ZoneNameExtraInput;
};

/** The output of our create `ZoneNameExtra` mutation. */
export type CreateZoneNameExtraPayload = {
  __typename?: 'CreateZoneNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameExtra`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameExtra` that was created by this mutation. */
  zoneNameExtra?: Maybe<ZoneNameExtra>;
  /** An edge for our `ZoneNameExtra`. May be used by Relay 1. */
  zoneNameExtraEdge?: Maybe<ZoneNameExtrasEdge>;
};


/** The output of our create `ZoneNameExtra` mutation. */
export type CreateZoneNameExtraPayloadZoneNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameExtrasOrderBy>>;
};

/** All input for the create `ZoneNameKeyCad` mutation. */
export type CreateZoneNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameKeyCad` to be created by this mutation. */
  zoneNameKeyCad: ZoneNameKeyCadInput;
};

/** The output of our create `ZoneNameKeyCad` mutation. */
export type CreateZoneNameKeyCadPayload = {
  __typename?: 'CreateZoneNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCad`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyCad` that was created by this mutation. */
  zoneNameKeyCad?: Maybe<ZoneNameKeyCad>;
  /** An edge for our `ZoneNameKeyCad`. May be used by Relay 1. */
  zoneNameKeyCadEdge?: Maybe<ZoneNameKeyCadsEdge>;
};


/** The output of our create `ZoneNameKeyCad` mutation. */
export type CreateZoneNameKeyCadPayloadZoneNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyCadsOrderBy>>;
};

/** All input for the create `ZoneNameKeyCafm` mutation. */
export type CreateZoneNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameKeyCafm` to be created by this mutation. */
  zoneNameKeyCafm: ZoneNameKeyCafmInput;
};

/** The output of our create `ZoneNameKeyCafm` mutation. */
export type CreateZoneNameKeyCafmPayload = {
  __typename?: 'CreateZoneNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCafm`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyCafm` that was created by this mutation. */
  zoneNameKeyCafm?: Maybe<ZoneNameKeyCafm>;
  /** An edge for our `ZoneNameKeyCafm`. May be used by Relay 1. */
  zoneNameKeyCafmEdge?: Maybe<ZoneNameKeyCafmsEdge>;
};


/** The output of our create `ZoneNameKeyCafm` mutation. */
export type CreateZoneNameKeyCafmPayloadZoneNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyCafmsOrderBy>>;
};

/** All input for the create `ZoneNameKeyEbm` mutation. */
export type CreateZoneNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameKeyEbm` to be created by this mutation. */
  zoneNameKeyEbm: ZoneNameKeyEbmInput;
};

/** The output of our create `ZoneNameKeyEbm` mutation. */
export type CreateZoneNameKeyEbmPayload = {
  __typename?: 'CreateZoneNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyEbm`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyEbm` that was created by this mutation. */
  zoneNameKeyEbm?: Maybe<ZoneNameKeyEbm>;
  /** An edge for our `ZoneNameKeyEbm`. May be used by Relay 1. */
  zoneNameKeyEbmEdge?: Maybe<ZoneNameKeyEbmsEdge>;
};


/** The output of our create `ZoneNameKeyEbm` mutation. */
export type CreateZoneNameKeyEbmPayloadZoneNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyEbmsOrderBy>>;
};

/** All input for the create `ZoneNameKeyMarketing` mutation. */
export type CreateZoneNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameKeyMarketing` to be created by this mutation. */
  zoneNameKeyMarketing: ZoneNameKeyMarketingInput;
};

/** The output of our create `ZoneNameKeyMarketing` mutation. */
export type CreateZoneNameKeyMarketingPayload = {
  __typename?: 'CreateZoneNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyMarketing`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyMarketing` that was created by this mutation. */
  zoneNameKeyMarketing?: Maybe<ZoneNameKeyMarketing>;
  /** An edge for our `ZoneNameKeyMarketing`. May be used by Relay 1. */
  zoneNameKeyMarketingEdge?: Maybe<ZoneNameKeyMarketingsEdge>;
};


/** The output of our create `ZoneNameKeyMarketing` mutation. */
export type CreateZoneNameKeyMarketingPayloadZoneNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyMarketingsOrderBy>>;
};

/** All input for the create `ZoneNameLong` mutation. */
export type CreateZoneNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameLong` to be created by this mutation. */
  zoneNameLong: ZoneNameLongInput;
};

/** The output of our create `ZoneNameLong` mutation. */
export type CreateZoneNameLongPayload = {
  __typename?: 'CreateZoneNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameLong`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameLong` that was created by this mutation. */
  zoneNameLong?: Maybe<ZoneNameLong>;
  /** An edge for our `ZoneNameLong`. May be used by Relay 1. */
  zoneNameLongEdge?: Maybe<ZoneNameLongsEdge>;
};


/** The output of our create `ZoneNameLong` mutation. */
export type CreateZoneNameLongPayloadZoneNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameLongsOrderBy>>;
};

/** All input for the create `ZoneNameShort` mutation. */
export type CreateZoneNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNameShort` to be created by this mutation. */
  zoneNameShort: ZoneNameShortInput;
};

/** The output of our create `ZoneNameShort` mutation. */
export type CreateZoneNameShortPayload = {
  __typename?: 'CreateZoneNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameShort`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameShort` that was created by this mutation. */
  zoneNameShort?: Maybe<ZoneNameShort>;
  /** An edge for our `ZoneNameShort`. May be used by Relay 1. */
  zoneNameShortEdge?: Maybe<ZoneNameShortsEdge>;
};


/** The output of our create `ZoneNameShort` mutation. */
export type CreateZoneNameShortPayloadZoneNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameShortsOrderBy>>;
};

/** All input for the create `ZoneNoVehicle` mutation. */
export type CreateZoneNoVehicleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneNoVehicle` to be created by this mutation. */
  zoneNoVehicle: ZoneNoVehicleInput;
};

/** The output of our create `ZoneNoVehicle` mutation. */
export type CreateZoneNoVehiclePayload = {
  __typename?: 'CreateZoneNoVehiclePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNoVehicle`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNoVehicle` that was created by this mutation. */
  zoneNoVehicle?: Maybe<ZoneNoVehicle>;
  /** An edge for our `ZoneNoVehicle`. May be used by Relay 1. */
  zoneNoVehicleEdge?: Maybe<ZoneNoVehiclesEdge>;
};


/** The output of our create `ZoneNoVehicle` mutation. */
export type CreateZoneNoVehiclePayloadZoneNoVehicleEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNoVehiclesOrderBy>>;
};

/** The output of our create `Zone` mutation. */
export type CreateZonePayload = {
  __typename?: 'CreateZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `Zone`. */
  site?: Maybe<Site>;
  /** Reads a single `ZoneType` that is related to this `Zone`. */
  type?: Maybe<ZoneType>;
  /** The `Zone` that was created by this mutation. */
  zone?: Maybe<Zone>;
  /** An edge for our `Zone`. May be used by Relay 1. */
  zoneEdge?: Maybe<ZonesEdge>;
};


/** The output of our create `Zone` mutation. */
export type CreateZonePayloadZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** All input for the create `ZonePublicGrossSpace` mutation. */
export type CreateZonePublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZonePublicGrossSpace` to be created by this mutation. */
  zonePublicGrossSpace: ZonePublicGrossSpaceInput;
};

/** The output of our create `ZonePublicGrossSpace` mutation. */
export type CreateZonePublicGrossSpacePayload = {
  __typename?: 'CreateZonePublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZonePublicGrossSpace`. */
  zone?: Maybe<Zone>;
  /** The `ZonePublicGrossSpace` that was created by this mutation. */
  zonePublicGrossSpace?: Maybe<ZonePublicGrossSpace>;
  /** An edge for our `ZonePublicGrossSpace`. May be used by Relay 1. */
  zonePublicGrossSpaceEdge?: Maybe<ZonePublicGrossSpacesEdge>;
};


/** The output of our create `ZonePublicGrossSpace` mutation. */
export type CreateZonePublicGrossSpacePayloadZonePublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonePublicGrossSpacesOrderBy>>;
};

/** All input for the create `ZoneTireLoadCar` mutation. */
export type CreateZoneTireLoadCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneTireLoadCar` to be created by this mutation. */
  zoneTireLoadCar: ZoneTireLoadCarInput;
};

/** The output of our create `ZoneTireLoadCar` mutation. */
export type CreateZoneTireLoadCarPayload = {
  __typename?: 'CreateZoneTireLoadCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadCar`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadCar` that was created by this mutation. */
  zoneTireLoadCar?: Maybe<ZoneTireLoadCar>;
  /** An edge for our `ZoneTireLoadCar`. May be used by Relay 1. */
  zoneTireLoadCarEdge?: Maybe<ZoneTireLoadCarsEdge>;
};


/** The output of our create `ZoneTireLoadCar` mutation. */
export type CreateZoneTireLoadCarPayloadZoneTireLoadCarEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadCarsOrderBy>>;
};

/** All input for the create `ZoneTireLoadForklift` mutation. */
export type CreateZoneTireLoadForkliftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneTireLoadForklift` to be created by this mutation. */
  zoneTireLoadForklift: ZoneTireLoadForkliftInput;
};

/** The output of our create `ZoneTireLoadForklift` mutation. */
export type CreateZoneTireLoadForkliftPayload = {
  __typename?: 'CreateZoneTireLoadForkliftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadForklift`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadForklift` that was created by this mutation. */
  zoneTireLoadForklift?: Maybe<ZoneTireLoadForklift>;
  /** An edge for our `ZoneTireLoadForklift`. May be used by Relay 1. */
  zoneTireLoadForkliftEdge?: Maybe<ZoneTireLoadForkliftsEdge>;
};


/** The output of our create `ZoneTireLoadForklift` mutation. */
export type CreateZoneTireLoadForkliftPayloadZoneTireLoadForkliftEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadForkliftsOrderBy>>;
};

/** All input for the create `ZoneTireLoadTruck` mutation. */
export type CreateZoneTireLoadTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneTireLoadTruck` to be created by this mutation. */
  zoneTireLoadTruck: ZoneTireLoadTruckInput;
};

/** The output of our create `ZoneTireLoadTruck` mutation. */
export type CreateZoneTireLoadTruckPayload = {
  __typename?: 'CreateZoneTireLoadTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadTruck`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadTruck` that was created by this mutation. */
  zoneTireLoadTruck?: Maybe<ZoneTireLoadTruck>;
  /** An edge for our `ZoneTireLoadTruck`. May be used by Relay 1. */
  zoneTireLoadTruckEdge?: Maybe<ZoneTireLoadTrucksEdge>;
};


/** The output of our create `ZoneTireLoadTruck` mutation. */
export type CreateZoneTireLoadTruckPayloadZoneTireLoadTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadTrucksOrderBy>>;
};

/** All input for the create `ZoneTypeAttr` mutation. */
export type CreateZoneTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneTypeAttr` to be created by this mutation. */
  zoneTypeAttr: ZoneTypeAttrInput;
};

/** The output of our create `ZoneTypeAttr` mutation. */
export type CreateZoneTypeAttrPayload = {
  __typename?: 'CreateZoneTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTypeAttr`. */
  zone?: Maybe<Zone>;
  /** Reads a single `ZoneType` that is related to this `ZoneTypeAttr`. */
  zoneType?: Maybe<ZoneType>;
  /** The `ZoneTypeAttr` that was created by this mutation. */
  zoneTypeAttr?: Maybe<ZoneTypeAttr>;
  /** An edge for our `ZoneTypeAttr`. May be used by Relay 1. */
  zoneTypeAttrEdge?: Maybe<ZoneTypeAttrsEdge>;
};


/** The output of our create `ZoneTypeAttr` mutation. */
export type CreateZoneTypeAttrPayloadZoneTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTypeAttrsOrderBy>>;
};

/** All input for the create `ZoneType` mutation. */
export type CreateZoneTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ZoneType` to be created by this mutation. */
  zoneType: ZoneTypeInput;
};

/** The output of our create `ZoneType` mutation. */
export type CreateZoneTypePayload = {
  __typename?: 'CreateZoneTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ZoneType` that was created by this mutation. */
  zoneType?: Maybe<ZoneType>;
  /** An edge for our `ZoneType`. May be used by Relay 1. */
  zoneTypeEdge?: Maybe<ZoneTypesEdge>;
};


/** The output of our create `ZoneType` mutation. */
export type CreateZoneTypePayloadZoneTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTypesOrderBy>>;
};

export type CreatedUser = {
  __typename?: 'CreatedUser';
  id: Scalars['UUID'];
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

export type DeactivatePasswordLoginResponse = NotFound | Success;

export type DeactivateSsoLoginResponse = NotFound | Success;

export type DeactivateUserResponse = {
  __typename?: 'DeactivateUserResponse';
  id?: Maybe<Scalars['UUID']>;
};

/** All input for the `deleteAllocationArea` mutation. */
export type DeleteAllocationAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationArea` mutation. */
export type DeleteAllocationAreaPayload = {
  __typename?: 'DeleteAllocationAreaPayload';
  /** The `AllocationArea` that was deleted by this mutation. */
  allocationArea?: Maybe<AllocationArea>;
  /** An edge for our `AllocationArea`. May be used by Relay 1. */
  allocationAreaEdge?: Maybe<AllocationAreasEdge>;
  /** Reads a single `Area` that is related to this `AllocationArea`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationAreaNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `EventVariant` that is related to this `AllocationArea`. */
  eventVariant?: Maybe<EventVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AllocationArea` mutation. */
export type DeleteAllocationAreaPayloadAllocationAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationAreasOrderBy>>;
};

/** All input for the `deleteAllocationAreaPhase` mutation. */
export type DeleteAllocationAreaPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationAreaPhase` mutation. */
export type DeleteAllocationAreaPhasePayload = {
  __typename?: 'DeleteAllocationAreaPhasePayload';
  /** Reads a single `AllocationArea` that is related to this `AllocationAreaPhase`. */
  allocation?: Maybe<AllocationArea>;
  /** The `AllocationAreaPhase` that was deleted by this mutation. */
  allocationAreaPhase?: Maybe<AllocationAreaPhase>;
  /** An edge for our `AllocationAreaPhase`. May be used by Relay 1. */
  allocationAreaPhaseEdge?: Maybe<AllocationAreaPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationAreaPhaseNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationAreaPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our delete `AllocationAreaPhase` mutation. */
export type DeleteAllocationAreaPhasePayloadAllocationAreaPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationAreaPhasesOrderBy>>;
};

/** All input for the `deleteAllocationPlot` mutation. */
export type DeleteAllocationPlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationPlot` mutation. */
export type DeleteAllocationPlotPayload = {
  __typename?: 'DeleteAllocationPlotPayload';
  /** The `AllocationPlot` that was deleted by this mutation. */
  allocationPlot?: Maybe<AllocationPlot>;
  /** An edge for our `AllocationPlot`. May be used by Relay 1. */
  allocationPlotEdge?: Maybe<AllocationPlotsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationPlotNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `EventVariant` that is related to this `AllocationPlot`. */
  eventVariant?: Maybe<EventVariant>;
  /** Reads a single `Plot` that is related to this `AllocationPlot`. */
  plot?: Maybe<Plot>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AllocationPlot` mutation. */
export type DeleteAllocationPlotPayloadAllocationPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationPlotsOrderBy>>;
};

/** All input for the `deleteAllocationPlotPhase` mutation. */
export type DeleteAllocationPlotPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationPlotPhase` mutation. */
export type DeleteAllocationPlotPhasePayload = {
  __typename?: 'DeleteAllocationPlotPhasePayload';
  /** Reads a single `AllocationPlot` that is related to this `AllocationPlotPhase`. */
  allocation?: Maybe<AllocationPlot>;
  /** The `AllocationPlotPhase` that was deleted by this mutation. */
  allocationPlotPhase?: Maybe<AllocationPlotPhase>;
  /** An edge for our `AllocationPlotPhase`. May be used by Relay 1. */
  allocationPlotPhaseEdge?: Maybe<AllocationPlotPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationPlotPhaseNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationPlotPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our delete `AllocationPlotPhase` mutation. */
export type DeleteAllocationPlotPhasePayloadAllocationPlotPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationPlotPhasesOrderBy>>;
};

/** All input for the `deleteAllocationRoom` mutation. */
export type DeleteAllocationRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationRoom` mutation. */
export type DeleteAllocationRoomPayload = {
  __typename?: 'DeleteAllocationRoomPayload';
  /** The `AllocationRoom` that was deleted by this mutation. */
  allocationRoom?: Maybe<AllocationRoom>;
  /** An edge for our `AllocationRoom`. May be used by Relay 1. */
  allocationRoomEdge?: Maybe<AllocationRoomsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationRoomNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `EventVariant` that is related to this `AllocationRoom`. */
  eventVariant?: Maybe<EventVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `AllocationRoom`. */
  room?: Maybe<Room>;
};


/** The output of our delete `AllocationRoom` mutation. */
export type DeleteAllocationRoomPayloadAllocationRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationRoomsOrderBy>>;
};

/** All input for the `deleteAllocationRoomPhase` mutation. */
export type DeleteAllocationRoomPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationRoomPhase` mutation. */
export type DeleteAllocationRoomPhasePayload = {
  __typename?: 'DeleteAllocationRoomPhasePayload';
  /** Reads a single `AllocationRoom` that is related to this `AllocationRoomPhase`. */
  allocation?: Maybe<AllocationRoom>;
  /** The `AllocationRoomPhase` that was deleted by this mutation. */
  allocationRoomPhase?: Maybe<AllocationRoomPhase>;
  /** An edge for our `AllocationRoomPhase`. May be used by Relay 1. */
  allocationRoomPhaseEdge?: Maybe<AllocationRoomPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationRoomPhaseNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationRoomPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our delete `AllocationRoomPhase` mutation. */
export type DeleteAllocationRoomPhasePayloadAllocationRoomPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationRoomPhasesOrderBy>>;
};

/** All input for the `deleteAllocationUsageByName` mutation. */
export type DeleteAllocationUsageByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteAllocationUsageByNameShort` mutation. */
export type DeleteAllocationUsageByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteAllocationUsageByPosition` mutation. */
export type DeleteAllocationUsageByPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
};

/** All input for the `deleteAllocationUsageByType` mutation. */
export type DeleteAllocationUsageByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  type: AllocationUsageType;
};

/** All input for the `deleteAllocationUsage` mutation. */
export type DeleteAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AllocationUsage` mutation. */
export type DeleteAllocationUsagePayload = {
  __typename?: 'DeleteAllocationUsagePayload';
  /** The `AllocationUsage` that was deleted by this mutation. */
  allocationUsage?: Maybe<AllocationUsage>;
  /** An edge for our `AllocationUsage`. May be used by Relay 1. */
  allocationUsageEdge?: Maybe<AllocationUsagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAllocationUsageNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AllocationUsage` mutation. */
export type DeleteAllocationUsagePayloadAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationUsagesOrderBy>>;
};

/** All input for the `deleteAreaByExtId` mutation. */
export type DeleteAreaByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteAreaByNameShort` mutation. */
export type DeleteAreaByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteAreaCadGrossSpaceMin` mutation. */
export type DeleteAreaCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaCadGrossSpaceMin` mutation. */
export type DeleteAreaCadGrossSpaceMinPayload = {
  __typename?: 'DeleteAreaCadGrossSpaceMinPayload';
  /** Reads a single `Area` that is related to this `AreaCadGrossSpaceMin`. */
  area?: Maybe<Area>;
  /** The `AreaCadGrossSpaceMin` that was deleted by this mutation. */
  areaCadGrossSpaceMin?: Maybe<AreaCadGrossSpaceMin>;
  /** An edge for our `AreaCadGrossSpaceMin`. May be used by Relay 1. */
  areaCadGrossSpaceMinEdge?: Maybe<AreaCadGrossSpaceMinsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaCadGrossSpaceMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaCadGrossSpaceMin` mutation. */
export type DeleteAreaCadGrossSpaceMinPayloadAreaCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `deleteAreaClearanceConstruction` mutation. */
export type DeleteAreaClearanceConstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaClearanceConstruction` mutation. */
export type DeleteAreaClearanceConstructionPayload = {
  __typename?: 'DeleteAreaClearanceConstructionPayload';
  /** Reads a single `Area` that is related to this `AreaClearanceConstruction`. */
  area?: Maybe<Area>;
  /** The `AreaClearanceConstruction` that was deleted by this mutation. */
  areaClearanceConstruction?: Maybe<AreaClearanceConstruction>;
  /** An edge for our `AreaClearanceConstruction`. May be used by Relay 1. */
  areaClearanceConstructionEdge?: Maybe<AreaClearanceConstructionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaClearanceConstructionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaClearanceConstruction` mutation. */
export type DeleteAreaClearanceConstructionPayloadAreaClearanceConstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaClearanceConstructionsOrderBy>>;
};

/** All input for the `deleteAreaContactBooking` mutation. */
export type DeleteAreaContactBookingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaContactBooking` mutation. */
export type DeleteAreaContactBookingPayload = {
  __typename?: 'DeleteAreaContactBookingPayload';
  /** Reads a single `Area` that is related to this `AreaContactBooking`. */
  area?: Maybe<Area>;
  /** The `AreaContactBooking` that was deleted by this mutation. */
  areaContactBooking?: Maybe<AreaContactBooking>;
  /** An edge for our `AreaContactBooking`. May be used by Relay 1. */
  areaContactBookingEdge?: Maybe<AreaContactBookingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaContactBookingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaContactBooking` mutation. */
export type DeleteAreaContactBookingPayloadAreaContactBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaContactBookingsOrderBy>>;
};

/** All input for the `deleteAreaDescription` mutation. */
export type DeleteAreaDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaDescription` mutation. */
export type DeleteAreaDescriptionPayload = {
  __typename?: 'DeleteAreaDescriptionPayload';
  /** Reads a single `Area` that is related to this `AreaDescription`. */
  area?: Maybe<Area>;
  /** The `AreaDescription` that was deleted by this mutation. */
  areaDescription?: Maybe<AreaDescription>;
  /** An edge for our `AreaDescription`. May be used by Relay 1. */
  areaDescriptionEdge?: Maybe<AreaDescriptionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaDescription` mutation. */
export type DeleteAreaDescriptionPayloadAreaDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaDescriptionsOrderBy>>;
};

/** All input for the `deleteArea` mutation. */
export type DeleteAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteAreaKeyIssuance` mutation. */
export type DeleteAreaKeyIssuanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteAreaKeyIssuanceNote` mutation. */
export type DeleteAreaKeyIssuanceNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaKeyIssuanceNote` mutation. */
export type DeleteAreaKeyIssuanceNotePayload = {
  __typename?: 'DeleteAreaKeyIssuanceNotePayload';
  /** Reads a single `Area` that is related to this `AreaKeyIssuanceNote`. */
  area?: Maybe<Area>;
  /** The `AreaKeyIssuanceNote` that was deleted by this mutation. */
  areaKeyIssuanceNote?: Maybe<AreaKeyIssuanceNote>;
  /** An edge for our `AreaKeyIssuanceNote`. May be used by Relay 1. */
  areaKeyIssuanceNoteEdge?: Maybe<AreaKeyIssuanceNotesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaKeyIssuanceNoteNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaKeyIssuanceNote` mutation. */
export type DeleteAreaKeyIssuanceNotePayloadAreaKeyIssuanceNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaKeyIssuanceNotesOrderBy>>;
};

/** The output of our delete `AreaKeyIssuance` mutation. */
export type DeleteAreaKeyIssuancePayload = {
  __typename?: 'DeleteAreaKeyIssuancePayload';
  /** Reads a single `Area` that is related to this `AreaKeyIssuance`. */
  area?: Maybe<Area>;
  /** The `AreaKeyIssuance` that was deleted by this mutation. */
  areaKeyIssuance?: Maybe<AreaKeyIssuance>;
  /** An edge for our `AreaKeyIssuance`. May be used by Relay 1. */
  areaKeyIssuanceEdge?: Maybe<AreaKeyIssuancesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaKeyIssuanceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaKeyIssuance` mutation. */
export type DeleteAreaKeyIssuancePayloadAreaKeyIssuanceEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaKeyIssuancesOrderBy>>;
};

/** All input for the `deleteAreaNameExtra` mutation. */
export type DeleteAreaNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameExtra` mutation. */
export type DeleteAreaNameExtraPayload = {
  __typename?: 'DeleteAreaNameExtraPayload';
  /** Reads a single `Area` that is related to this `AreaNameExtra`. */
  area?: Maybe<Area>;
  /** The `AreaNameExtra` that was deleted by this mutation. */
  areaNameExtra?: Maybe<AreaNameExtra>;
  /** An edge for our `AreaNameExtra`. May be used by Relay 1. */
  areaNameExtraEdge?: Maybe<AreaNameExtrasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameExtra` mutation. */
export type DeleteAreaNameExtraPayloadAreaNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameExtrasOrderBy>>;
};

/** All input for the `deleteAreaNameKeyCad` mutation. */
export type DeleteAreaNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameKeyCad` mutation. */
export type DeleteAreaNameKeyCadPayload = {
  __typename?: 'DeleteAreaNameKeyCadPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyCad`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyCad` that was deleted by this mutation. */
  areaNameKeyCad?: Maybe<AreaNameKeyCad>;
  /** An edge for our `AreaNameKeyCad`. May be used by Relay 1. */
  areaNameKeyCadEdge?: Maybe<AreaNameKeyCadsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameKeyCad` mutation. */
export type DeleteAreaNameKeyCadPayloadAreaNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyCadsOrderBy>>;
};

/** All input for the `deleteAreaNameKeyCafm` mutation. */
export type DeleteAreaNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameKeyCafm` mutation. */
export type DeleteAreaNameKeyCafmPayload = {
  __typename?: 'DeleteAreaNameKeyCafmPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyCafm`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyCafm` that was deleted by this mutation. */
  areaNameKeyCafm?: Maybe<AreaNameKeyCafm>;
  /** An edge for our `AreaNameKeyCafm`. May be used by Relay 1. */
  areaNameKeyCafmEdge?: Maybe<AreaNameKeyCafmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameKeyCafm` mutation. */
export type DeleteAreaNameKeyCafmPayloadAreaNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteAreaNameKeyEbm` mutation. */
export type DeleteAreaNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameKeyEbm` mutation. */
export type DeleteAreaNameKeyEbmPayload = {
  __typename?: 'DeleteAreaNameKeyEbmPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyEbm`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyEbm` that was deleted by this mutation. */
  areaNameKeyEbm?: Maybe<AreaNameKeyEbm>;
  /** An edge for our `AreaNameKeyEbm`. May be used by Relay 1. */
  areaNameKeyEbmEdge?: Maybe<AreaNameKeyEbmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameKeyEbm` mutation. */
export type DeleteAreaNameKeyEbmPayloadAreaNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteAreaNameKeyMarketing` mutation. */
export type DeleteAreaNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameKeyMarketing` mutation. */
export type DeleteAreaNameKeyMarketingPayload = {
  __typename?: 'DeleteAreaNameKeyMarketingPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyMarketing`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyMarketing` that was deleted by this mutation. */
  areaNameKeyMarketing?: Maybe<AreaNameKeyMarketing>;
  /** An edge for our `AreaNameKeyMarketing`. May be used by Relay 1. */
  areaNameKeyMarketingEdge?: Maybe<AreaNameKeyMarketingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameKeyMarketing` mutation. */
export type DeleteAreaNameKeyMarketingPayloadAreaNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteAreaNameLong` mutation. */
export type DeleteAreaNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameLong` mutation. */
export type DeleteAreaNameLongPayload = {
  __typename?: 'DeleteAreaNameLongPayload';
  /** Reads a single `Area` that is related to this `AreaNameLong`. */
  area?: Maybe<Area>;
  /** The `AreaNameLong` that was deleted by this mutation. */
  areaNameLong?: Maybe<AreaNameLong>;
  /** An edge for our `AreaNameLong`. May be used by Relay 1. */
  areaNameLongEdge?: Maybe<AreaNameLongsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameLong` mutation. */
export type DeleteAreaNameLongPayloadAreaNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameLongsOrderBy>>;
};

/** All input for the `deleteAreaNameShort` mutation. */
export type DeleteAreaNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaNameShort` mutation. */
export type DeleteAreaNameShortPayload = {
  __typename?: 'DeleteAreaNameShortPayload';
  /** Reads a single `Area` that is related to this `AreaNameShort`. */
  area?: Maybe<Area>;
  /** The `AreaNameShort` that was deleted by this mutation. */
  areaNameShort?: Maybe<AreaNameShort>;
  /** An edge for our `AreaNameShort`. May be used by Relay 1. */
  areaNameShortEdge?: Maybe<AreaNameShortsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaNameShort` mutation. */
export type DeleteAreaNameShortPayloadAreaNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameShortsOrderBy>>;
};

/** The output of our delete `Area` mutation. */
export type DeleteAreaPayload = {
  __typename?: 'DeleteAreaPayload';
  /** The `Area` that was deleted by this mutation. */
  area?: Maybe<Area>;
  /** An edge for our `Area`. May be used by Relay 1. */
  areaEdge?: Maybe<AreasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AreaType` that is related to this `Area`. */
  type?: Maybe<AreaType>;
  /** Reads a single `Zone` that is related to this `Area`. */
  zone?: Maybe<Zone>;
};


/** The output of our delete `Area` mutation. */
export type DeleteAreaPayloadAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<AreasOrderBy>>;
};

/** All input for the `deleteAreaPublicGrossSpace` mutation. */
export type DeleteAreaPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaPublicGrossSpace` mutation. */
export type DeleteAreaPublicGrossSpacePayload = {
  __typename?: 'DeleteAreaPublicGrossSpacePayload';
  /** Reads a single `Area` that is related to this `AreaPublicGrossSpace`. */
  area?: Maybe<Area>;
  /** The `AreaPublicGrossSpace` that was deleted by this mutation. */
  areaPublicGrossSpace?: Maybe<AreaPublicGrossSpace>;
  /** An edge for our `AreaPublicGrossSpace`. May be used by Relay 1. */
  areaPublicGrossSpaceEdge?: Maybe<AreaPublicGrossSpacesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaPublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaPublicGrossSpace` mutation. */
export type DeleteAreaPublicGrossSpacePayloadAreaPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaPublicGrossSpacesOrderBy>>;
};

/** All input for the `deleteAreaTypeAttr` mutation. */
export type DeleteAreaTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaTypeAttr` mutation. */
export type DeleteAreaTypeAttrPayload = {
  __typename?: 'DeleteAreaTypeAttrPayload';
  /** Reads a single `Area` that is related to this `AreaTypeAttr`. */
  area?: Maybe<Area>;
  /** Reads a single `AreaType` that is related to this `AreaTypeAttr`. */
  areaType?: Maybe<AreaType>;
  /** The `AreaTypeAttr` that was deleted by this mutation. */
  areaTypeAttr?: Maybe<AreaTypeAttr>;
  /** An edge for our `AreaTypeAttr`. May be used by Relay 1. */
  areaTypeAttrEdge?: Maybe<AreaTypeAttrsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaTypeAttr` mutation. */
export type DeleteAreaTypeAttrPayloadAreaTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaTypeAttrsOrderBy>>;
};

/** All input for the `deleteAreaTypeByName` mutation. */
export type DeleteAreaTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteAreaType` mutation. */
export type DeleteAreaTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `AreaType` mutation. */
export type DeleteAreaTypePayload = {
  __typename?: 'DeleteAreaTypePayload';
  /** The `AreaType` that was deleted by this mutation. */
  areaType?: Maybe<AreaType>;
  /** An edge for our `AreaType`. May be used by Relay 1. */
  areaTypeEdge?: Maybe<AreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAreaTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AreaType` mutation. */
export type DeleteAreaTypePayloadAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaTypesOrderBy>>;
};

/** All input for the `deleteBuildingByExtId` mutation. */
export type DeleteBuildingByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteBuildingByIdAndSiteId` mutation. */
export type DeleteBuildingByIdAndSiteIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  siteId: Scalars['UUID'];
};

/** All input for the `deleteBuildingByNameShort` mutation. */
export type DeleteBuildingByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteBuildingDescription` mutation. */
export type DeleteBuildingDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingDescription` mutation. */
export type DeleteBuildingDescriptionPayload = {
  __typename?: 'DeleteBuildingDescriptionPayload';
  /** Reads a single `Building` that is related to this `BuildingDescription`. */
  building?: Maybe<Building>;
  /** The `BuildingDescription` that was deleted by this mutation. */
  buildingDescription?: Maybe<BuildingDescription>;
  /** An edge for our `BuildingDescription`. May be used by Relay 1. */
  buildingDescriptionEdge?: Maybe<BuildingDescriptionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingDescription` mutation. */
export type DeleteBuildingDescriptionPayloadBuildingDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingDescriptionsOrderBy>>;
};

/** All input for the `deleteBuilding` mutation. */
export type DeleteBuildingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteBuildingNameExtra` mutation. */
export type DeleteBuildingNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameExtra` mutation. */
export type DeleteBuildingNameExtraPayload = {
  __typename?: 'DeleteBuildingNameExtraPayload';
  /** Reads a single `Building` that is related to this `BuildingNameExtra`. */
  building?: Maybe<Building>;
  /** The `BuildingNameExtra` that was deleted by this mutation. */
  buildingNameExtra?: Maybe<BuildingNameExtra>;
  /** An edge for our `BuildingNameExtra`. May be used by Relay 1. */
  buildingNameExtraEdge?: Maybe<BuildingNameExtrasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameExtra` mutation. */
export type DeleteBuildingNameExtraPayloadBuildingNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameExtrasOrderBy>>;
};

/** All input for the `deleteBuildingNameKeyCad` mutation. */
export type DeleteBuildingNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameKeyCad` mutation. */
export type DeleteBuildingNameKeyCadPayload = {
  __typename?: 'DeleteBuildingNameKeyCadPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCad`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyCad` that was deleted by this mutation. */
  buildingNameKeyCad?: Maybe<BuildingNameKeyCad>;
  /** An edge for our `BuildingNameKeyCad`. May be used by Relay 1. */
  buildingNameKeyCadEdge?: Maybe<BuildingNameKeyCadsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameKeyCad` mutation. */
export type DeleteBuildingNameKeyCadPayloadBuildingNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyCadsOrderBy>>;
};

/** All input for the `deleteBuildingNameKeyCafm` mutation. */
export type DeleteBuildingNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameKeyCafm` mutation. */
export type DeleteBuildingNameKeyCafmPayload = {
  __typename?: 'DeleteBuildingNameKeyCafmPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCafm`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyCafm` that was deleted by this mutation. */
  buildingNameKeyCafm?: Maybe<BuildingNameKeyCafm>;
  /** An edge for our `BuildingNameKeyCafm`. May be used by Relay 1. */
  buildingNameKeyCafmEdge?: Maybe<BuildingNameKeyCafmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameKeyCafm` mutation. */
export type DeleteBuildingNameKeyCafmPayloadBuildingNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteBuildingNameKeyEbm` mutation. */
export type DeleteBuildingNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameKeyEbm` mutation. */
export type DeleteBuildingNameKeyEbmPayload = {
  __typename?: 'DeleteBuildingNameKeyEbmPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyEbm`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyEbm` that was deleted by this mutation. */
  buildingNameKeyEbm?: Maybe<BuildingNameKeyEbm>;
  /** An edge for our `BuildingNameKeyEbm`. May be used by Relay 1. */
  buildingNameKeyEbmEdge?: Maybe<BuildingNameKeyEbmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameKeyEbm` mutation. */
export type DeleteBuildingNameKeyEbmPayloadBuildingNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteBuildingNameKeyMarketing` mutation. */
export type DeleteBuildingNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameKeyMarketing` mutation. */
export type DeleteBuildingNameKeyMarketingPayload = {
  __typename?: 'DeleteBuildingNameKeyMarketingPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyMarketing`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyMarketing` that was deleted by this mutation. */
  buildingNameKeyMarketing?: Maybe<BuildingNameKeyMarketing>;
  /** An edge for our `BuildingNameKeyMarketing`. May be used by Relay 1. */
  buildingNameKeyMarketingEdge?: Maybe<BuildingNameKeyMarketingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameKeyMarketing` mutation. */
export type DeleteBuildingNameKeyMarketingPayloadBuildingNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteBuildingNameLong` mutation. */
export type DeleteBuildingNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameLong` mutation. */
export type DeleteBuildingNameLongPayload = {
  __typename?: 'DeleteBuildingNameLongPayload';
  /** Reads a single `Building` that is related to this `BuildingNameLong`. */
  building?: Maybe<Building>;
  /** The `BuildingNameLong` that was deleted by this mutation. */
  buildingNameLong?: Maybe<BuildingNameLong>;
  /** An edge for our `BuildingNameLong`. May be used by Relay 1. */
  buildingNameLongEdge?: Maybe<BuildingNameLongsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameLong` mutation. */
export type DeleteBuildingNameLongPayloadBuildingNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameLongsOrderBy>>;
};

/** All input for the `deleteBuildingNameShort` mutation. */
export type DeleteBuildingNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingNameShort` mutation. */
export type DeleteBuildingNameShortPayload = {
  __typename?: 'DeleteBuildingNameShortPayload';
  /** Reads a single `Building` that is related to this `BuildingNameShort`. */
  building?: Maybe<Building>;
  /** The `BuildingNameShort` that was deleted by this mutation. */
  buildingNameShort?: Maybe<BuildingNameShort>;
  /** An edge for our `BuildingNameShort`. May be used by Relay 1. */
  buildingNameShortEdge?: Maybe<BuildingNameShortsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingNameShort` mutation. */
export type DeleteBuildingNameShortPayloadBuildingNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameShortsOrderBy>>;
};

/** The output of our delete `Building` mutation. */
export type DeleteBuildingPayload = {
  __typename?: 'DeleteBuildingPayload';
  /** The `Building` that was deleted by this mutation. */
  building?: Maybe<Building>;
  /** An edge for our `Building`. May be used by Relay 1. */
  buildingEdge?: Maybe<BuildingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `Building`. */
  site?: Maybe<Site>;
  /** Reads a single `BuildingType` that is related to this `Building`. */
  type?: Maybe<BuildingType>;
};


/** The output of our delete `Building` mutation. */
export type DeleteBuildingPayloadBuildingEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingsOrderBy>>;
};

/** All input for the `deleteBuildingPublicGrossSpace` mutation. */
export type DeleteBuildingPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingPublicGrossSpace` mutation. */
export type DeleteBuildingPublicGrossSpacePayload = {
  __typename?: 'DeleteBuildingPublicGrossSpacePayload';
  /** Reads a single `Building` that is related to this `BuildingPublicGrossSpace`. */
  building?: Maybe<Building>;
  /** The `BuildingPublicGrossSpace` that was deleted by this mutation. */
  buildingPublicGrossSpace?: Maybe<BuildingPublicGrossSpace>;
  /** An edge for our `BuildingPublicGrossSpace`. May be used by Relay 1. */
  buildingPublicGrossSpaceEdge?: Maybe<BuildingPublicGrossSpacesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingPublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingPublicGrossSpace` mutation. */
export type DeleteBuildingPublicGrossSpacePayloadBuildingPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingPublicGrossSpacesOrderBy>>;
};

/** All input for the `deleteBuildingTypeAttr` mutation. */
export type DeleteBuildingTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingTypeAttr` mutation. */
export type DeleteBuildingTypeAttrPayload = {
  __typename?: 'DeleteBuildingTypeAttrPayload';
  /** Reads a single `Building` that is related to this `BuildingTypeAttr`. */
  building?: Maybe<Building>;
  /** Reads a single `BuildingType` that is related to this `BuildingTypeAttr`. */
  buildingType?: Maybe<BuildingType>;
  /** The `BuildingTypeAttr` that was deleted by this mutation. */
  buildingTypeAttr?: Maybe<BuildingTypeAttr>;
  /** An edge for our `BuildingTypeAttr`. May be used by Relay 1. */
  buildingTypeAttrEdge?: Maybe<BuildingTypeAttrsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingTypeAttr` mutation. */
export type DeleteBuildingTypeAttrPayloadBuildingTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingTypeAttrsOrderBy>>;
};

/** All input for the `deleteBuildingTypeByName` mutation. */
export type DeleteBuildingTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteBuildingType` mutation. */
export type DeleteBuildingTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `BuildingType` mutation. */
export type DeleteBuildingTypePayload = {
  __typename?: 'DeleteBuildingTypePayload';
  /** The `BuildingType` that was deleted by this mutation. */
  buildingType?: Maybe<BuildingType>;
  /** An edge for our `BuildingType`. May be used by Relay 1. */
  buildingTypeEdge?: Maybe<BuildingTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedBuildingTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BuildingType` mutation. */
export type DeleteBuildingTypePayloadBuildingTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingTypesOrderBy>>;
};

/** All input for the `deleteElevationLevelByValue` mutation. */
export type DeleteElevationLevelByValueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  value: Scalars['BigFloat'];
};

/** All input for the `deleteElevationLevel` mutation. */
export type DeleteElevationLevelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ElevationLevel` mutation. */
export type DeleteElevationLevelPayload = {
  __typename?: 'DeleteElevationLevelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedElevationLevelNodeId?: Maybe<Scalars['ID']>;
  /** The `ElevationLevel` that was deleted by this mutation. */
  elevationLevel?: Maybe<ElevationLevel>;
  /** An edge for our `ElevationLevel`. May be used by Relay 1. */
  elevationLevelEdge?: Maybe<ElevationLevelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ElevationLevel` mutation. */
export type DeleteElevationLevelPayloadElevationLevelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElevationLevelsOrderBy>>;
};

/** All input for the `deleteEventByNameShort` mutation. */
export type DeleteEventByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteEvent` mutation. */
export type DeleteEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Event` mutation. */
export type DeleteEventPayload = {
  __typename?: 'DeleteEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionNational?: Maybe<Multilink>;
  deletedEventNodeId?: Maybe<Scalars['ID']>;
  /** The `Event` that was deleted by this mutation. */
  event?: Maybe<Event>;
  /** An edge for our `Event`. May be used by Relay 1. */
  eventEdge?: Maybe<EventsEdge>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  externalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraSystems?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  /** Reads a single `File` that is related to this `Event`. */
  icon?: Maybe<File>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  internalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionNational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksInternal?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `EventSeries` that is related to this `Event`. */
  series?: Maybe<EventSeries>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsLocal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsOtherLocations?: Maybe<Multilink>;
};


/** The output of our delete `Event` mutation. */
export type DeleteEventPayloadEventEdgeArgs = {
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** All input for the `deleteEventSeriesByNameShort` mutation. */
export type DeleteEventSeriesByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteEventSeries` mutation. */
export type DeleteEventSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `EventSeries` mutation. */
export type DeleteEventSeriesPayload = {
  __typename?: 'DeleteEventSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionNational?: Maybe<Multilink>;
  deletedEventSeriesNodeId?: Maybe<Scalars['ID']>;
  /** The `EventSeries` that was deleted by this mutation. */
  eventSeries?: Maybe<EventSeries>;
  /** An edge for our `EventSeries`. May be used by Relay 1. */
  eventSeriesEdge?: Maybe<EventSeriesEdge>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  executors?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  externalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraSystems?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  /** Reads a single `File` that is related to this `EventSeries`. */
  icon?: Maybe<File>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  internalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  organizers?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionNational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksInternal?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  sponsors?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsLocal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsOtherLocations?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our delete `EventSeries` mutation. */
export type DeleteEventSeriesPayloadEventSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};

/** All input for the `deleteEventVariantByEventIdAndIndex` mutation. */
export type DeleteEventVariantByEventIdAndIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};

/** All input for the `deleteEventVariant` mutation. */
export type DeleteEventVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `EventVariant` mutation. */
export type DeleteEventVariantPayload = {
  __typename?: 'DeleteEventVariantPayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEventVariantNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  /** The `EventVariant` that was deleted by this mutation. */
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our delete `EventVariant` mutation. */
export type DeleteEventVariantPayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** All input for the `deleteExternalEventAllocation` mutation. */
export type DeleteExternalEventAllocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventAllocation` mutation. */
export type DeleteExternalEventAllocationPayload = {
  __typename?: 'DeleteExternalEventAllocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventAllocationNodeId?: Maybe<Scalars['ID']>;
  /** The `ExternalEventAllocation` that was deleted by this mutation. */
  externalEventAllocation?: Maybe<ExternalEventAllocation>;
  /** An edge for our `ExternalEventAllocation`. May be used by Relay 1. */
  externalEventAllocationEdge?: Maybe<ExternalEventAllocationsEdge>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventAllocation`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventVariant` that is related to this `ExternalEventAllocation`. */
  variant?: Maybe<ExternalEventVariant>;
};


/** The output of our delete `ExternalEventAllocation` mutation. */
export type DeleteExternalEventAllocationPayloadExternalEventAllocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationsOrderBy>>;
};

/** All input for the `deleteExternalEventAllocationPhase` mutation. */
export type DeleteExternalEventAllocationPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventAllocationPhase` mutation. */
export type DeleteExternalEventAllocationPhasePayload = {
  __typename?: 'DeleteExternalEventAllocationPhasePayload';
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventAllocationPhase`. */
  allocation?: Maybe<ExternalEventAllocation>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventAllocationPhaseNodeId?: Maybe<Scalars['ID']>;
  /** The `ExternalEventAllocationPhase` that was deleted by this mutation. */
  externalEventAllocationPhase?: Maybe<ExternalEventAllocationPhase>;
  /** An edge for our `ExternalEventAllocationPhase`. May be used by Relay 1. */
  externalEventAllocationPhaseEdge?: Maybe<ExternalEventAllocationPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocationUsage` that is related to this `ExternalEventAllocationPhase`. */
  usage?: Maybe<ExternalEventAllocationUsage>;
};


/** The output of our delete `ExternalEventAllocationPhase` mutation. */
export type DeleteExternalEventAllocationPhasePayloadExternalEventAllocationPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationPhasesOrderBy>>;
};

/** All input for the `deleteExternalEventAllocationUsageByName` mutation. */
export type DeleteExternalEventAllocationUsageByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteExternalEventAllocationUsageByNameShort` mutation. */
export type DeleteExternalEventAllocationUsageByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteExternalEventAllocationUsageByPosition` mutation. */
export type DeleteExternalEventAllocationUsageByPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
};

/** All input for the `deleteExternalEventAllocationUsageByType` mutation. */
export type DeleteExternalEventAllocationUsageByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  type: ExternalEventAllocationUsageType;
};

/** All input for the `deleteExternalEventAllocationUsage` mutation. */
export type DeleteExternalEventAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventAllocationUsage` mutation. */
export type DeleteExternalEventAllocationUsagePayload = {
  __typename?: 'DeleteExternalEventAllocationUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventAllocationUsageNodeId?: Maybe<Scalars['ID']>;
  /** The `ExternalEventAllocationUsage` that was deleted by this mutation. */
  externalEventAllocationUsage?: Maybe<ExternalEventAllocationUsage>;
  /** An edge for our `ExternalEventAllocationUsage`. May be used by Relay 1. */
  externalEventAllocationUsageEdge?: Maybe<ExternalEventAllocationUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ExternalEventAllocationUsage` mutation. */
export type DeleteExternalEventAllocationUsagePayloadExternalEventAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationUsagesOrderBy>>;
};

/** All input for the `deleteExternalEventByNameShort` mutation. */
export type DeleteExternalEventByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteExternalEventEventLocationVisibilityByEventIdAndLocationId` mutation. */
export type DeleteExternalEventEventLocationVisibilityByEventIdAndLocationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
};

/** All input for the `deleteExternalEventEventLocationVisibility` mutation. */
export type DeleteExternalEventEventLocationVisibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventEventLocationVisibility` mutation. */
export type DeleteExternalEventEventLocationVisibilityPayload = {
  __typename?: 'DeleteExternalEventEventLocationVisibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventEventLocationVisibilityNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventEventLocationVisibility`. */
  event?: Maybe<ExternalEvent>;
  /** The `ExternalEventEventLocationVisibility` that was deleted by this mutation. */
  externalEventEventLocationVisibility?: Maybe<ExternalEventEventLocationVisibility>;
  /** An edge for our `ExternalEventEventLocationVisibility`. May be used by Relay 1. */
  externalEventEventLocationVisibilityEdge?: Maybe<ExternalEventEventLocationVisibilitiesEdge>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventEventLocationVisibility`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ExternalEventEventLocationVisibility` mutation. */
export type DeleteExternalEventEventLocationVisibilityPayloadExternalEventEventLocationVisibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventEventLocationVisibilitiesOrderBy>>;
};

/** All input for the `deleteExternalEvent` mutation. */
export type DeleteExternalEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteExternalEventLocationByName` mutation. */
export type DeleteExternalEventLocationByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteExternalEventLocation` mutation. */
export type DeleteExternalEventLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventLocation` mutation. */
export type DeleteExternalEventLocationPayload = {
  __typename?: 'DeleteExternalEventLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventLocationNodeId?: Maybe<Scalars['ID']>;
  /** The `ExternalEventLocation` that was deleted by this mutation. */
  externalEventLocation?: Maybe<ExternalEventLocation>;
  /** An edge for our `ExternalEventLocation`. May be used by Relay 1. */
  externalEventLocationEdge?: Maybe<ExternalEventLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ExternalEventLocation` mutation. */
export type DeleteExternalEventLocationPayloadExternalEventLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventLocationsOrderBy>>;
};

/** The output of our delete `ExternalEvent` mutation. */
export type DeleteExternalEventPayload = {
  __typename?: 'DeleteExternalEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventNodeId?: Maybe<Scalars['ID']>;
  /** The `ExternalEvent` that was deleted by this mutation. */
  externalEvent?: Maybe<ExternalEvent>;
  /** An edge for our `ExternalEvent`. May be used by Relay 1. */
  externalEventEdge?: Maybe<ExternalEventsEdge>;
  /** Reads a single `Multilink` that is related to this `ExternalEvent`. */
  links?: Maybe<Multilink>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEvent`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventSeries` that is related to this `ExternalEvent`. */
  series?: Maybe<ExternalEventSeries>;
};


/** The output of our delete `ExternalEvent` mutation. */
export type DeleteExternalEventPayloadExternalEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};

/** All input for the `deleteExternalEventSeriesByNameShort` mutation. */
export type DeleteExternalEventSeriesByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteExternalEventSeries` mutation. */
export type DeleteExternalEventSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventSeries` mutation. */
export type DeleteExternalEventSeriesPayload = {
  __typename?: 'DeleteExternalEventSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventSeriesNodeId?: Maybe<Scalars['ID']>;
  /** The `ExternalEventSeries` that was deleted by this mutation. */
  externalEventSeries?: Maybe<ExternalEventSeries>;
  /** An edge for our `ExternalEventSeries`. May be used by Relay 1. */
  externalEventSeriesEdge?: Maybe<ExternalEventSeriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `ExternalEventSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our delete `ExternalEventSeries` mutation. */
export type DeleteExternalEventSeriesPayloadExternalEventSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventSeriesOrderBy>>;
};

/** All input for the `deleteExternalEventVariantByEventIdAndIndex` mutation. */
export type DeleteExternalEventVariantByEventIdAndIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};

/** All input for the `deleteExternalEventVariant` mutation. */
export type DeleteExternalEventVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalEventVariant` mutation. */
export type DeleteExternalEventVariantPayload = {
  __typename?: 'DeleteExternalEventVariantPayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExternalEventVariantNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  /** The `ExternalEventVariant` that was deleted by this mutation. */
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our delete `ExternalEventVariant` mutation. */
export type DeleteExternalEventVariantPayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/** All input for the `deleteFeedEntry` mutation. */
export type DeleteFeedEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `FeedEntry` mutation. */
export type DeleteFeedEntryPayload = {
  __typename?: 'DeleteFeedEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `FeedEntry`. */
  createdBy?: Maybe<User>;
  deletedFeedEntryNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Feed` that is related to this `FeedEntry`. */
  feed?: Maybe<Feed>;
  /** The `FeedEntry` that was deleted by this mutation. */
  feedEntry?: Maybe<FeedEntry>;
  /** An edge for our `FeedEntry`. May be used by Relay 1. */
  feedEntryEdge?: Maybe<FeedEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FeedEntry`. */
  updatedBy?: Maybe<User>;
};


/** The output of our delete `FeedEntry` mutation. */
export type DeleteFeedEntryPayloadFeedEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};

/** All input for the `deleteFeed` mutation. */
export type DeleteFeedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Feed` mutation. */
export type DeleteFeedPayload = {
  __typename?: 'DeleteFeedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFeedNodeId?: Maybe<Scalars['ID']>;
  /** The `Feed` that was deleted by this mutation. */
  feed?: Maybe<Feed>;
  /** An edge for our `Feed`. May be used by Relay 1. */
  feedEdge?: Maybe<FeedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Feed` mutation. */
export type DeleteFeedPayloadFeedEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedsOrderBy>>;
};

/** All input for the `deleteLevelByExtId` mutation. */
export type DeleteLevelByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteLevelByNameShort` mutation. */
export type DeleteLevelByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteLevelCapacityPax` mutation. */
export type DeleteLevelCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelCapacityPax` mutation. */
export type DeleteLevelCapacityPaxPayload = {
  __typename?: 'DeleteLevelCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelCapacityPaxNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelCapacityPax`. */
  level?: Maybe<Level>;
  /** The `LevelCapacityPax` that was deleted by this mutation. */
  levelCapacityPax?: Maybe<LevelCapacityPax>;
  /** An edge for our `LevelCapacityPax`. May be used by Relay 1. */
  levelCapacityPaxEdge?: Maybe<LevelCapacityPaxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelCapacityPax` mutation. */
export type DeleteLevelCapacityPaxPayloadLevelCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelCapacityPaxesOrderBy>>;
};

/** All input for the `deleteLevelDescription` mutation. */
export type DeleteLevelDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelDescription` mutation. */
export type DeleteLevelDescriptionPayload = {
  __typename?: 'DeleteLevelDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelDescription`. */
  level?: Maybe<Level>;
  /** The `LevelDescription` that was deleted by this mutation. */
  levelDescription?: Maybe<LevelDescription>;
  /** An edge for our `LevelDescription`. May be used by Relay 1. */
  levelDescriptionEdge?: Maybe<LevelDescriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelDescription` mutation. */
export type DeleteLevelDescriptionPayloadLevelDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelDescriptionsOrderBy>>;
};

/** All input for the `deleteLevelFkmGrossSpace` mutation. */
export type DeleteLevelFkmGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelFkmGrossSpace` mutation. */
export type DeleteLevelFkmGrossSpacePayload = {
  __typename?: 'DeleteLevelFkmGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelFkmGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelFkmGrossSpace`. */
  level?: Maybe<Level>;
  /** The `LevelFkmGrossSpace` that was deleted by this mutation. */
  levelFkmGrossSpace?: Maybe<LevelFkmGrossSpace>;
  /** An edge for our `LevelFkmGrossSpace`. May be used by Relay 1. */
  levelFkmGrossSpaceEdge?: Maybe<LevelFkmGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelFkmGrossSpace` mutation. */
export type DeleteLevelFkmGrossSpacePayloadLevelFkmGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelFkmGrossSpacesOrderBy>>;
};

/** All input for the `deleteLevel` mutation. */
export type DeleteLevelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteLevelNameExtra` mutation. */
export type DeleteLevelNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameExtra` mutation. */
export type DeleteLevelNameExtraPayload = {
  __typename?: 'DeleteLevelNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameExtra`. */
  level?: Maybe<Level>;
  /** The `LevelNameExtra` that was deleted by this mutation. */
  levelNameExtra?: Maybe<LevelNameExtra>;
  /** An edge for our `LevelNameExtra`. May be used by Relay 1. */
  levelNameExtraEdge?: Maybe<LevelNameExtrasEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameExtra` mutation. */
export type DeleteLevelNameExtraPayloadLevelNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameExtrasOrderBy>>;
};

/** All input for the `deleteLevelNameKeyCad` mutation. */
export type DeleteLevelNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameKeyCad` mutation. */
export type DeleteLevelNameKeyCadPayload = {
  __typename?: 'DeleteLevelNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyCad`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyCad` that was deleted by this mutation. */
  levelNameKeyCad?: Maybe<LevelNameKeyCad>;
  /** An edge for our `LevelNameKeyCad`. May be used by Relay 1. */
  levelNameKeyCadEdge?: Maybe<LevelNameKeyCadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameKeyCad` mutation. */
export type DeleteLevelNameKeyCadPayloadLevelNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyCadsOrderBy>>;
};

/** All input for the `deleteLevelNameKeyCafm` mutation. */
export type DeleteLevelNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameKeyCafm` mutation. */
export type DeleteLevelNameKeyCafmPayload = {
  __typename?: 'DeleteLevelNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyCafm`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyCafm` that was deleted by this mutation. */
  levelNameKeyCafm?: Maybe<LevelNameKeyCafm>;
  /** An edge for our `LevelNameKeyCafm`. May be used by Relay 1. */
  levelNameKeyCafmEdge?: Maybe<LevelNameKeyCafmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameKeyCafm` mutation. */
export type DeleteLevelNameKeyCafmPayloadLevelNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteLevelNameKeyEbm` mutation. */
export type DeleteLevelNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameKeyEbm` mutation. */
export type DeleteLevelNameKeyEbmPayload = {
  __typename?: 'DeleteLevelNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyEbm`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyEbm` that was deleted by this mutation. */
  levelNameKeyEbm?: Maybe<LevelNameKeyEbm>;
  /** An edge for our `LevelNameKeyEbm`. May be used by Relay 1. */
  levelNameKeyEbmEdge?: Maybe<LevelNameKeyEbmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameKeyEbm` mutation. */
export type DeleteLevelNameKeyEbmPayloadLevelNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteLevelNameKeyMarketing` mutation. */
export type DeleteLevelNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameKeyMarketing` mutation. */
export type DeleteLevelNameKeyMarketingPayload = {
  __typename?: 'DeleteLevelNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyMarketing`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyMarketing` that was deleted by this mutation. */
  levelNameKeyMarketing?: Maybe<LevelNameKeyMarketing>;
  /** An edge for our `LevelNameKeyMarketing`. May be used by Relay 1. */
  levelNameKeyMarketingEdge?: Maybe<LevelNameKeyMarketingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameKeyMarketing` mutation. */
export type DeleteLevelNameKeyMarketingPayloadLevelNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteLevelNameLong` mutation. */
export type DeleteLevelNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameLong` mutation. */
export type DeleteLevelNameLongPayload = {
  __typename?: 'DeleteLevelNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameLong`. */
  level?: Maybe<Level>;
  /** The `LevelNameLong` that was deleted by this mutation. */
  levelNameLong?: Maybe<LevelNameLong>;
  /** An edge for our `LevelNameLong`. May be used by Relay 1. */
  levelNameLongEdge?: Maybe<LevelNameLongsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameLong` mutation. */
export type DeleteLevelNameLongPayloadLevelNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameLongsOrderBy>>;
};

/** All input for the `deleteLevelNameShort` mutation. */
export type DeleteLevelNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelNameShort` mutation. */
export type DeleteLevelNameShortPayload = {
  __typename?: 'DeleteLevelNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelNameShort`. */
  level?: Maybe<Level>;
  /** The `LevelNameShort` that was deleted by this mutation. */
  levelNameShort?: Maybe<LevelNameShort>;
  /** An edge for our `LevelNameShort`. May be used by Relay 1. */
  levelNameShortEdge?: Maybe<LevelNameShortsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelNameShort` mutation. */
export type DeleteLevelNameShortPayloadLevelNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameShortsOrderBy>>;
};

/** The output of our delete `Level` mutation. */
export type DeleteLevelPayload = {
  __typename?: 'DeleteLevelPayload';
  /** Reads a single `Building` that is related to this `Level`. */
  building?: Maybe<Building>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `ElevationLevel` that is related to this `Level`. */
  elevation?: Maybe<ElevationLevel>;
  /** The `Level` that was deleted by this mutation. */
  level?: Maybe<Level>;
  /** An edge for our `Level`. May be used by Relay 1. */
  levelEdge?: Maybe<LevelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `LevelType` that is related to this `Level`. */
  type?: Maybe<LevelType>;
};


/** The output of our delete `Level` mutation. */
export type DeleteLevelPayloadLevelEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};

/** All input for the `deleteLevelPublicGrossSpace` mutation. */
export type DeleteLevelPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelPublicGrossSpace` mutation. */
export type DeleteLevelPublicGrossSpacePayload = {
  __typename?: 'DeleteLevelPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelPublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelPublicGrossSpace`. */
  level?: Maybe<Level>;
  /** The `LevelPublicGrossSpace` that was deleted by this mutation. */
  levelPublicGrossSpace?: Maybe<LevelPublicGrossSpace>;
  /** An edge for our `LevelPublicGrossSpace`. May be used by Relay 1. */
  levelPublicGrossSpaceEdge?: Maybe<LevelPublicGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelPublicGrossSpace` mutation. */
export type DeleteLevelPublicGrossSpacePayloadLevelPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelPublicGrossSpacesOrderBy>>;
};

/** All input for the `deleteLevelTypeAttr` mutation. */
export type DeleteLevelTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelTypeAttr` mutation. */
export type DeleteLevelTypeAttrPayload = {
  __typename?: 'DeleteLevelTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `LevelTypeAttr`. */
  level?: Maybe<Level>;
  /** Reads a single `LevelType` that is related to this `LevelTypeAttr`. */
  levelType?: Maybe<LevelType>;
  /** The `LevelTypeAttr` that was deleted by this mutation. */
  levelTypeAttr?: Maybe<LevelTypeAttr>;
  /** An edge for our `LevelTypeAttr`. May be used by Relay 1. */
  levelTypeAttrEdge?: Maybe<LevelTypeAttrsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelTypeAttr` mutation. */
export type DeleteLevelTypeAttrPayloadLevelTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelTypeAttrsOrderBy>>;
};

/** All input for the `deleteLevelTypeByName` mutation. */
export type DeleteLevelTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteLevelType` mutation. */
export type DeleteLevelTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `LevelType` mutation. */
export type DeleteLevelTypePayload = {
  __typename?: 'DeleteLevelTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLevelTypeNodeId?: Maybe<Scalars['ID']>;
  /** The `LevelType` that was deleted by this mutation. */
  levelType?: Maybe<LevelType>;
  /** An edge for our `LevelType`. May be used by Relay 1. */
  levelTypeEdge?: Maybe<LevelTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LevelType` mutation. */
export type DeleteLevelTypePayloadLevelTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelTypesOrderBy>>;
};

/** All input for the `deleteLink` mutation. */
export type DeleteLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Link` mutation. */
export type DeleteLinkPayload = {
  __typename?: 'DeleteLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLinkNodeId?: Maybe<Scalars['ID']>;
  /** The `Link` that was deleted by this mutation. */
  link?: Maybe<Link>;
  /** An edge for our `Link`. May be used by Relay 1. */
  linkEdge?: Maybe<LinksEdge>;
  /** Reads a single `Multilink` that is related to this `Link`. */
  multilink?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Link` mutation. */
export type DeleteLinkPayloadLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};

/** All input for the `deleteMultilink` mutation. */
export type DeleteMultilinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Multilink` mutation. */
export type DeleteMultilinkPayload = {
  __typename?: 'DeleteMultilinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMultilinkNodeId?: Maybe<Scalars['ID']>;
  /** The `Multilink` that was deleted by this mutation. */
  multilink?: Maybe<Multilink>;
  /** An edge for our `Multilink`. May be used by Relay 1. */
  multilinkEdge?: Maybe<MultilinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Multilink` mutation. */
export type DeleteMultilinkPayloadMultilinkEdgeArgs = {
  orderBy?: InputMaybe<Array<MultilinksOrderBy>>;
};

/** All input for the `deletePlotByExtId` mutation. */
export type DeletePlotByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deletePlotByNameShort` mutation. */
export type DeletePlotByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deletePlotCadGrossSpaceMin` mutation. */
export type DeletePlotCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotCadGrossSpaceMin` mutation. */
export type DeletePlotCadGrossSpaceMinPayload = {
  __typename?: 'DeletePlotCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotCadGrossSpaceMinNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotCadGrossSpaceMin`. */
  plot?: Maybe<Plot>;
  /** The `PlotCadGrossSpaceMin` that was deleted by this mutation. */
  plotCadGrossSpaceMin?: Maybe<PlotCadGrossSpaceMin>;
  /** An edge for our `PlotCadGrossSpaceMin`. May be used by Relay 1. */
  plotCadGrossSpaceMinEdge?: Maybe<PlotCadGrossSpaceMinsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotCadGrossSpaceMin` mutation. */
export type DeletePlotCadGrossSpaceMinPayloadPlotCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `deletePlotDescription` mutation. */
export type DeletePlotDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotDescription` mutation. */
export type DeletePlotDescriptionPayload = {
  __typename?: 'DeletePlotDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotDescription`. */
  plot?: Maybe<Plot>;
  /** The `PlotDescription` that was deleted by this mutation. */
  plotDescription?: Maybe<PlotDescription>;
  /** An edge for our `PlotDescription`. May be used by Relay 1. */
  plotDescriptionEdge?: Maybe<PlotDescriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotDescription` mutation. */
export type DeletePlotDescriptionPayloadPlotDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotDescriptionsOrderBy>>;
};

/** All input for the `deletePlot` mutation. */
export type DeletePlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deletePlotNameExtra` mutation. */
export type DeletePlotNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameExtra` mutation. */
export type DeletePlotNameExtraPayload = {
  __typename?: 'DeletePlotNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameExtra`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameExtra` that was deleted by this mutation. */
  plotNameExtra?: Maybe<PlotNameExtra>;
  /** An edge for our `PlotNameExtra`. May be used by Relay 1. */
  plotNameExtraEdge?: Maybe<PlotNameExtrasEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameExtra` mutation. */
export type DeletePlotNameExtraPayloadPlotNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameExtrasOrderBy>>;
};

/** All input for the `deletePlotNameKeyCad` mutation. */
export type DeletePlotNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameKeyCad` mutation. */
export type DeletePlotNameKeyCadPayload = {
  __typename?: 'DeletePlotNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyCad`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyCad` that was deleted by this mutation. */
  plotNameKeyCad?: Maybe<PlotNameKeyCad>;
  /** An edge for our `PlotNameKeyCad`. May be used by Relay 1. */
  plotNameKeyCadEdge?: Maybe<PlotNameKeyCadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameKeyCad` mutation. */
export type DeletePlotNameKeyCadPayloadPlotNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyCadsOrderBy>>;
};

/** All input for the `deletePlotNameKeyCafm` mutation. */
export type DeletePlotNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameKeyCafm` mutation. */
export type DeletePlotNameKeyCafmPayload = {
  __typename?: 'DeletePlotNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyCafm`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyCafm` that was deleted by this mutation. */
  plotNameKeyCafm?: Maybe<PlotNameKeyCafm>;
  /** An edge for our `PlotNameKeyCafm`. May be used by Relay 1. */
  plotNameKeyCafmEdge?: Maybe<PlotNameKeyCafmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameKeyCafm` mutation. */
export type DeletePlotNameKeyCafmPayloadPlotNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyCafmsOrderBy>>;
};

/** All input for the `deletePlotNameKeyEbm` mutation. */
export type DeletePlotNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameKeyEbm` mutation. */
export type DeletePlotNameKeyEbmPayload = {
  __typename?: 'DeletePlotNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyEbm`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyEbm` that was deleted by this mutation. */
  plotNameKeyEbm?: Maybe<PlotNameKeyEbm>;
  /** An edge for our `PlotNameKeyEbm`. May be used by Relay 1. */
  plotNameKeyEbmEdge?: Maybe<PlotNameKeyEbmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameKeyEbm` mutation. */
export type DeletePlotNameKeyEbmPayloadPlotNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyEbmsOrderBy>>;
};

/** All input for the `deletePlotNameKeyMarketing` mutation. */
export type DeletePlotNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameKeyMarketing` mutation. */
export type DeletePlotNameKeyMarketingPayload = {
  __typename?: 'DeletePlotNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyMarketing`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyMarketing` that was deleted by this mutation. */
  plotNameKeyMarketing?: Maybe<PlotNameKeyMarketing>;
  /** An edge for our `PlotNameKeyMarketing`. May be used by Relay 1. */
  plotNameKeyMarketingEdge?: Maybe<PlotNameKeyMarketingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameKeyMarketing` mutation. */
export type DeletePlotNameKeyMarketingPayloadPlotNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyMarketingsOrderBy>>;
};

/** All input for the `deletePlotNameLong` mutation. */
export type DeletePlotNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameLong` mutation. */
export type DeletePlotNameLongPayload = {
  __typename?: 'DeletePlotNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameLong`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameLong` that was deleted by this mutation. */
  plotNameLong?: Maybe<PlotNameLong>;
  /** An edge for our `PlotNameLong`. May be used by Relay 1. */
  plotNameLongEdge?: Maybe<PlotNameLongsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameLong` mutation. */
export type DeletePlotNameLongPayloadPlotNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameLongsOrderBy>>;
};

/** All input for the `deletePlotNameShort` mutation. */
export type DeletePlotNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotNameShort` mutation. */
export type DeletePlotNameShortPayload = {
  __typename?: 'DeletePlotNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotNameShort`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameShort` that was deleted by this mutation. */
  plotNameShort?: Maybe<PlotNameShort>;
  /** An edge for our `PlotNameShort`. May be used by Relay 1. */
  plotNameShortEdge?: Maybe<PlotNameShortsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotNameShort` mutation. */
export type DeletePlotNameShortPayloadPlotNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameShortsOrderBy>>;
};

/** The output of our delete `Plot` mutation. */
export type DeletePlotPayload = {
  __typename?: 'DeletePlotPayload';
  /** Reads a single `Area` that is related to this `Plot`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotNodeId?: Maybe<Scalars['ID']>;
  /** The `Plot` that was deleted by this mutation. */
  plot?: Maybe<Plot>;
  /** An edge for our `Plot`. May be used by Relay 1. */
  plotEdge?: Maybe<PlotsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PlotType` that is related to this `Plot`. */
  type?: Maybe<PlotType>;
};


/** The output of our delete `Plot` mutation. */
export type DeletePlotPayloadPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotsOrderBy>>;
};

/** All input for the `deletePlotPublicGrossSpace` mutation. */
export type DeletePlotPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotPublicGrossSpace` mutation. */
export type DeletePlotPublicGrossSpacePayload = {
  __typename?: 'DeletePlotPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotPublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotPublicGrossSpace`. */
  plot?: Maybe<Plot>;
  /** The `PlotPublicGrossSpace` that was deleted by this mutation. */
  plotPublicGrossSpace?: Maybe<PlotPublicGrossSpace>;
  /** An edge for our `PlotPublicGrossSpace`. May be used by Relay 1. */
  plotPublicGrossSpaceEdge?: Maybe<PlotPublicGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotPublicGrossSpace` mutation. */
export type DeletePlotPublicGrossSpacePayloadPlotPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotPublicGrossSpacesOrderBy>>;
};

/** All input for the `deletePlotTypeAttr` mutation. */
export type DeletePlotTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotTypeAttr` mutation. */
export type DeletePlotTypeAttrPayload = {
  __typename?: 'DeletePlotTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `PlotTypeAttr`. */
  plot?: Maybe<Plot>;
  /** Reads a single `PlotType` that is related to this `PlotTypeAttr`. */
  plotType?: Maybe<PlotType>;
  /** The `PlotTypeAttr` that was deleted by this mutation. */
  plotTypeAttr?: Maybe<PlotTypeAttr>;
  /** An edge for our `PlotTypeAttr`. May be used by Relay 1. */
  plotTypeAttrEdge?: Maybe<PlotTypeAttrsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotTypeAttr` mutation. */
export type DeletePlotTypeAttrPayloadPlotTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotTypeAttrsOrderBy>>;
};

/** All input for the `deletePlotTypeByName` mutation. */
export type DeletePlotTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deletePlotType` mutation. */
export type DeletePlotTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PlotType` mutation. */
export type DeletePlotTypePayload = {
  __typename?: 'DeletePlotTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPlotTypeNodeId?: Maybe<Scalars['ID']>;
  /** The `PlotType` that was deleted by this mutation. */
  plotType?: Maybe<PlotType>;
  /** An edge for our `PlotType`. May be used by Relay 1. */
  plotTypeEdge?: Maybe<PlotTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PlotType` mutation. */
export type DeletePlotTypePayloadPlotTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotTypesOrderBy>>;
};

/** All input for the `deleteProjectAllocationArea` mutation. */
export type DeleteProjectAllocationAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationArea` mutation. */
export type DeleteProjectAllocationAreaPayload = {
  __typename?: 'DeleteProjectAllocationAreaPayload';
  /** Reads a single `Area` that is related to this `ProjectAllocationArea`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationAreaNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectAllocationArea` that was deleted by this mutation. */
  projectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** An edge for our `ProjectAllocationArea`. May be used by Relay 1. */
  projectAllocationAreaEdge?: Maybe<ProjectAllocationAreasEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationArea`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectAllocationArea` mutation. */
export type DeleteProjectAllocationAreaPayloadProjectAllocationAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationAreasOrderBy>>;
};

/** All input for the `deleteProjectAllocationAreaPhase` mutation. */
export type DeleteProjectAllocationAreaPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationAreaPhase` mutation. */
export type DeleteProjectAllocationAreaPhasePayload = {
  __typename?: 'DeleteProjectAllocationAreaPhasePayload';
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectAllocationAreaPhase`. */
  allocation?: Maybe<ProjectAllocationArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationAreaPhaseNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectAllocationAreaPhase` that was deleted by this mutation. */
  projectAllocationAreaPhase?: Maybe<ProjectAllocationAreaPhase>;
  /** An edge for our `ProjectAllocationAreaPhase`. May be used by Relay 1. */
  projectAllocationAreaPhaseEdge?: Maybe<ProjectAllocationAreaPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationAreaPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our delete `ProjectAllocationAreaPhase` mutation. */
export type DeleteProjectAllocationAreaPhasePayloadProjectAllocationAreaPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationAreaPhasesOrderBy>>;
};

/** All input for the `deleteProjectAllocationPlot` mutation. */
export type DeleteProjectAllocationPlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationPlot` mutation. */
export type DeleteProjectAllocationPlotPayload = {
  __typename?: 'DeleteProjectAllocationPlotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationPlotNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Plot` that is related to this `ProjectAllocationPlot`. */
  plot?: Maybe<Plot>;
  /** The `ProjectAllocationPlot` that was deleted by this mutation. */
  projectAllocationPlot?: Maybe<ProjectAllocationPlot>;
  /** An edge for our `ProjectAllocationPlot`. May be used by Relay 1. */
  projectAllocationPlotEdge?: Maybe<ProjectAllocationPlotsEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationPlot`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectAllocationPlot` mutation. */
export type DeleteProjectAllocationPlotPayloadProjectAllocationPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationPlotsOrderBy>>;
};

/** All input for the `deleteProjectAllocationPlotPhase` mutation. */
export type DeleteProjectAllocationPlotPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationPlotPhase` mutation. */
export type DeleteProjectAllocationPlotPhasePayload = {
  __typename?: 'DeleteProjectAllocationPlotPhasePayload';
  /** Reads a single `ProjectAllocationPlot` that is related to this `ProjectAllocationPlotPhase`. */
  allocation?: Maybe<ProjectAllocationPlot>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationPlotPhaseNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectAllocationPlotPhase` that was deleted by this mutation. */
  projectAllocationPlotPhase?: Maybe<ProjectAllocationPlotPhase>;
  /** An edge for our `ProjectAllocationPlotPhase`. May be used by Relay 1. */
  projectAllocationPlotPhaseEdge?: Maybe<ProjectAllocationPlotPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationPlotPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our delete `ProjectAllocationPlotPhase` mutation. */
export type DeleteProjectAllocationPlotPhasePayloadProjectAllocationPlotPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationPlotPhasesOrderBy>>;
};

/** All input for the `deleteProjectAllocationRoom` mutation. */
export type DeleteProjectAllocationRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationRoom` mutation. */
export type DeleteProjectAllocationRoomPayload = {
  __typename?: 'DeleteProjectAllocationRoomPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationRoomNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectAllocationRoom` that was deleted by this mutation. */
  projectAllocationRoom?: Maybe<ProjectAllocationRoom>;
  /** An edge for our `ProjectAllocationRoom`. May be used by Relay 1. */
  projectAllocationRoomEdge?: Maybe<ProjectAllocationRoomsEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationRoom`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `ProjectAllocationRoom`. */
  room?: Maybe<Room>;
};


/** The output of our delete `ProjectAllocationRoom` mutation. */
export type DeleteProjectAllocationRoomPayloadProjectAllocationRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationRoomsOrderBy>>;
};

/** All input for the `deleteProjectAllocationRoomPhase` mutation. */
export type DeleteProjectAllocationRoomPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationRoomPhase` mutation. */
export type DeleteProjectAllocationRoomPhasePayload = {
  __typename?: 'DeleteProjectAllocationRoomPhasePayload';
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectAllocationRoomPhase`. */
  allocation?: Maybe<ProjectAllocationRoom>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationRoomPhaseNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectAllocationRoomPhase` that was deleted by this mutation. */
  projectAllocationRoomPhase?: Maybe<ProjectAllocationRoomPhase>;
  /** An edge for our `ProjectAllocationRoomPhase`. May be used by Relay 1. */
  projectAllocationRoomPhaseEdge?: Maybe<ProjectAllocationRoomPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationRoomPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our delete `ProjectAllocationRoomPhase` mutation. */
export type DeleteProjectAllocationRoomPhasePayloadProjectAllocationRoomPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationRoomPhasesOrderBy>>;
};

/** All input for the `deleteProjectAllocationUsageByName` mutation. */
export type DeleteProjectAllocationUsageByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteProjectAllocationUsageByNameShort` mutation. */
export type DeleteProjectAllocationUsageByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteProjectAllocationUsageByPosition` mutation. */
export type DeleteProjectAllocationUsageByPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
};

/** All input for the `deleteProjectAllocationUsageByType` mutation. */
export type DeleteProjectAllocationUsageByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  type: ProjectAllocationUsageType;
};

/** All input for the `deleteProjectAllocationUsage` mutation. */
export type DeleteProjectAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectAllocationUsage` mutation. */
export type DeleteProjectAllocationUsagePayload = {
  __typename?: 'DeleteProjectAllocationUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectAllocationUsageNodeId?: Maybe<Scalars['ID']>;
  /** The `ProjectAllocationUsage` that was deleted by this mutation. */
  projectAllocationUsage?: Maybe<ProjectAllocationUsage>;
  /** An edge for our `ProjectAllocationUsage`. May be used by Relay 1. */
  projectAllocationUsageEdge?: Maybe<ProjectAllocationUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProjectAllocationUsage` mutation. */
export type DeleteProjectAllocationUsagePayloadProjectAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationUsagesOrderBy>>;
};

/** All input for the `deleteProjectByNameShort` mutation. */
export type DeleteProjectByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteProject` mutation. */
export type DeleteProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherLinks?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherSystems?: Maybe<Multilink>;
  /** The `Project` that was deleted by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectSeries` that is related to this `Project`. */
  series?: Maybe<ProjectSeries>;
};


/** The output of our delete `Project` mutation. */
export type DeleteProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `deleteProjectSeriesByNameShort` mutation. */
export type DeleteProjectSeriesByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteProjectSeries` mutation. */
export type DeleteProjectSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectSeries` mutation. */
export type DeleteProjectSeriesPayload = {
  __typename?: 'DeleteProjectSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectSeriesNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherLinks?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherSystems?: Maybe<Multilink>;
  /** The `ProjectSeries` that was deleted by this mutation. */
  projectSeries?: Maybe<ProjectSeries>;
  /** An edge for our `ProjectSeries`. May be used by Relay 1. */
  projectSeriesEdge?: Maybe<ProjectSeriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our delete `ProjectSeries` mutation. */
export type DeleteProjectSeriesPayloadProjectSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};

/** All input for the `deleteProjectVariantByProjectIdAndIndex` mutation. */
export type DeleteProjectVariantByProjectIdAndIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  index: Scalars['Int'];
  projectId: Scalars['UUID'];
};

/** All input for the `deleteProjectVariant` mutation. */
export type DeleteProjectVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ProjectVariant` mutation. */
export type DeleteProjectVariantPayload = {
  __typename?: 'DeleteProjectVariantPayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProjectVariantNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  /** The `ProjectVariant` that was deleted by this mutation. */
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our delete `ProjectVariant` mutation. */
export type DeleteProjectVariantPayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** All input for the `deleteRoomAirChangeRate` mutation. */
export type DeleteRoomAirChangeRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomAirChangeRate` mutation. */
export type DeleteRoomAirChangeRatePayload = {
  __typename?: 'DeleteRoomAirChangeRatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomAirChangeRateNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomAirChangeRate`. */
  room?: Maybe<Room>;
  /** The `RoomAirChangeRate` that was deleted by this mutation. */
  roomAirChangeRate?: Maybe<RoomAirChangeRate>;
  /** An edge for our `RoomAirChangeRate`. May be used by Relay 1. */
  roomAirChangeRateEdge?: Maybe<RoomAirChangeRatesEdge>;
};


/** The output of our delete `RoomAirChangeRate` mutation. */
export type DeleteRoomAirChangeRatePayloadRoomAirChangeRateEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomAirChangeRatesOrderBy>>;
};

/** All input for the `deleteRoomAirConditioning` mutation. */
export type DeleteRoomAirConditioningInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomAirConditioning` mutation. */
export type DeleteRoomAirConditioningPayload = {
  __typename?: 'DeleteRoomAirConditioningPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomAirConditioningNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomAirConditioning`. */
  room?: Maybe<Room>;
  /** The `RoomAirConditioning` that was deleted by this mutation. */
  roomAirConditioning?: Maybe<RoomAirConditioning>;
  /** An edge for our `RoomAirConditioning`. May be used by Relay 1. */
  roomAirConditioningEdge?: Maybe<RoomAirConditioningsEdge>;
};


/** The output of our delete `RoomAirConditioning` mutation. */
export type DeleteRoomAirConditioningPayloadRoomAirConditioningEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomAirConditioningsOrderBy>>;
};

/** All input for the `deleteRoomByExtId` mutation. */
export type DeleteRoomByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteRoomByNameShort` mutation. */
export type DeleteRoomByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteRoomCadGrossSpaceMin` mutation. */
export type DeleteRoomCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadGrossSpaceMin` mutation. */
export type DeleteRoomCadGrossSpaceMinPayload = {
  __typename?: 'DeleteRoomCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadGrossSpaceMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadGrossSpaceMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadGrossSpaceMin` that was deleted by this mutation. */
  roomCadGrossSpaceMin?: Maybe<RoomCadGrossSpaceMin>;
  /** An edge for our `RoomCadGrossSpaceMin`. May be used by Relay 1. */
  roomCadGrossSpaceMinEdge?: Maybe<RoomCadGrossSpaceMinsEdge>;
};


/** The output of our delete `RoomCadGrossSpaceMin` mutation. */
export type DeleteRoomCadGrossSpaceMinPayloadRoomCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `deleteRoomCadHeightMax` mutation. */
export type DeleteRoomCadHeightMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadHeightMax` mutation. */
export type DeleteRoomCadHeightMaxPayload = {
  __typename?: 'DeleteRoomCadHeightMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadHeightMaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadHeightMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadHeightMax` that was deleted by this mutation. */
  roomCadHeightMax?: Maybe<RoomCadHeightMax>;
  /** An edge for our `RoomCadHeightMax`. May be used by Relay 1. */
  roomCadHeightMaxEdge?: Maybe<RoomCadHeightMaxesEdge>;
};


/** The output of our delete `RoomCadHeightMax` mutation. */
export type DeleteRoomCadHeightMaxPayloadRoomCadHeightMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadHeightMaxesOrderBy>>;
};

/** All input for the `deleteRoomCadHeightMin` mutation. */
export type DeleteRoomCadHeightMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadHeightMin` mutation. */
export type DeleteRoomCadHeightMinPayload = {
  __typename?: 'DeleteRoomCadHeightMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadHeightMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadHeightMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadHeightMin` that was deleted by this mutation. */
  roomCadHeightMin?: Maybe<RoomCadHeightMin>;
  /** An edge for our `RoomCadHeightMin`. May be used by Relay 1. */
  roomCadHeightMinEdge?: Maybe<RoomCadHeightMinsEdge>;
};


/** The output of our delete `RoomCadHeightMin` mutation. */
export type DeleteRoomCadHeightMinPayloadRoomCadHeightMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadHeightMinsOrderBy>>;
};

/** All input for the `deleteRoomCadLengthMax` mutation. */
export type DeleteRoomCadLengthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadLengthMax` mutation. */
export type DeleteRoomCadLengthMaxPayload = {
  __typename?: 'DeleteRoomCadLengthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadLengthMaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadLengthMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadLengthMax` that was deleted by this mutation. */
  roomCadLengthMax?: Maybe<RoomCadLengthMax>;
  /** An edge for our `RoomCadLengthMax`. May be used by Relay 1. */
  roomCadLengthMaxEdge?: Maybe<RoomCadLengthMaxesEdge>;
};


/** The output of our delete `RoomCadLengthMax` mutation. */
export type DeleteRoomCadLengthMaxPayloadRoomCadLengthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadLengthMaxesOrderBy>>;
};

/** All input for the `deleteRoomCadLengthMin` mutation. */
export type DeleteRoomCadLengthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadLengthMin` mutation. */
export type DeleteRoomCadLengthMinPayload = {
  __typename?: 'DeleteRoomCadLengthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadLengthMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadLengthMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadLengthMin` that was deleted by this mutation. */
  roomCadLengthMin?: Maybe<RoomCadLengthMin>;
  /** An edge for our `RoomCadLengthMin`. May be used by Relay 1. */
  roomCadLengthMinEdge?: Maybe<RoomCadLengthMinsEdge>;
};


/** The output of our delete `RoomCadLengthMin` mutation. */
export type DeleteRoomCadLengthMinPayloadRoomCadLengthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadLengthMinsOrderBy>>;
};

/** All input for the `deleteRoomCadWidthMax` mutation. */
export type DeleteRoomCadWidthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadWidthMax` mutation. */
export type DeleteRoomCadWidthMaxPayload = {
  __typename?: 'DeleteRoomCadWidthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadWidthMaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadWidthMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadWidthMax` that was deleted by this mutation. */
  roomCadWidthMax?: Maybe<RoomCadWidthMax>;
  /** An edge for our `RoomCadWidthMax`. May be used by Relay 1. */
  roomCadWidthMaxEdge?: Maybe<RoomCadWidthMaxesEdge>;
};


/** The output of our delete `RoomCadWidthMax` mutation. */
export type DeleteRoomCadWidthMaxPayloadRoomCadWidthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadWidthMaxesOrderBy>>;
};

/** All input for the `deleteRoomCadWidthMin` mutation. */
export type DeleteRoomCadWidthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCadWidthMin` mutation. */
export type DeleteRoomCadWidthMinPayload = {
  __typename?: 'DeleteRoomCadWidthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCadWidthMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadWidthMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadWidthMin` that was deleted by this mutation. */
  roomCadWidthMin?: Maybe<RoomCadWidthMin>;
  /** An edge for our `RoomCadWidthMin`. May be used by Relay 1. */
  roomCadWidthMinEdge?: Maybe<RoomCadWidthMinsEdge>;
};


/** The output of our delete `RoomCadWidthMin` mutation. */
export type DeleteRoomCadWidthMinPayloadRoomCadWidthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadWidthMinsOrderBy>>;
};

/** All input for the `deleteRoomCapacityCar` mutation. */
export type DeleteRoomCapacityCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCapacityCar` mutation. */
export type DeleteRoomCapacityCarPayload = {
  __typename?: 'DeleteRoomCapacityCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCapacityCarNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityCar`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityCar` that was deleted by this mutation. */
  roomCapacityCar?: Maybe<RoomCapacityCar>;
  /** An edge for our `RoomCapacityCar`. May be used by Relay 1. */
  roomCapacityCarEdge?: Maybe<RoomCapacityCarsEdge>;
};


/** The output of our delete `RoomCapacityCar` mutation. */
export type DeleteRoomCapacityCarPayloadRoomCapacityCarEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityCarsOrderBy>>;
};

/** All input for the `deleteRoomCapacityPax` mutation. */
export type DeleteRoomCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCapacityPax` mutation. */
export type DeleteRoomCapacityPaxPayload = {
  __typename?: 'DeleteRoomCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCapacityPaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityPax`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityPax` that was deleted by this mutation. */
  roomCapacityPax?: Maybe<RoomCapacityPax>;
  /** An edge for our `RoomCapacityPax`. May be used by Relay 1. */
  roomCapacityPaxEdge?: Maybe<RoomCapacityPaxesEdge>;
};


/** The output of our delete `RoomCapacityPax` mutation. */
export type DeleteRoomCapacityPaxPayloadRoomCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityPaxesOrderBy>>;
};

/** All input for the `deleteRoomCapacityTruck` mutation. */
export type DeleteRoomCapacityTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCapacityTruck` mutation. */
export type DeleteRoomCapacityTruckPayload = {
  __typename?: 'DeleteRoomCapacityTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCapacityTruckNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityTruck`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityTruck` that was deleted by this mutation. */
  roomCapacityTruck?: Maybe<RoomCapacityTruck>;
  /** An edge for our `RoomCapacityTruck`. May be used by Relay 1. */
  roomCapacityTruckEdge?: Maybe<RoomCapacityTrucksEdge>;
};


/** The output of our delete `RoomCapacityTruck` mutation. */
export type DeleteRoomCapacityTruckPayloadRoomCapacityTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityTrucksOrderBy>>;
};

/** All input for the `deleteRoomCleaningGrossSpace` mutation. */
export type DeleteRoomCleaningGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomCleaningGrossSpace` mutation. */
export type DeleteRoomCleaningGrossSpacePayload = {
  __typename?: 'DeleteRoomCleaningGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomCleaningGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCleaningGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomCleaningGrossSpace` that was deleted by this mutation. */
  roomCleaningGrossSpace?: Maybe<RoomCleaningGrossSpace>;
  /** An edge for our `RoomCleaningGrossSpace`. May be used by Relay 1. */
  roomCleaningGrossSpaceEdge?: Maybe<RoomCleaningGrossSpacesEdge>;
};


/** The output of our delete `RoomCleaningGrossSpace` mutation. */
export type DeleteRoomCleaningGrossSpacePayloadRoomCleaningGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCleaningGrossSpacesOrderBy>>;
};

/** All input for the `deleteRoomClearanceConstruction` mutation. */
export type DeleteRoomClearanceConstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomClearanceConstruction` mutation. */
export type DeleteRoomClearanceConstructionPayload = {
  __typename?: 'DeleteRoomClearanceConstructionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomClearanceConstructionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomClearanceConstruction`. */
  room?: Maybe<Room>;
  /** The `RoomClearanceConstruction` that was deleted by this mutation. */
  roomClearanceConstruction?: Maybe<RoomClearanceConstruction>;
  /** An edge for our `RoomClearanceConstruction`. May be used by Relay 1. */
  roomClearanceConstructionEdge?: Maybe<RoomClearanceConstructionsEdge>;
};


/** The output of our delete `RoomClearanceConstruction` mutation. */
export type DeleteRoomClearanceConstructionPayloadRoomClearanceConstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomClearanceConstructionsOrderBy>>;
};

/** All input for the `deleteRoomContactBooking` mutation. */
export type DeleteRoomContactBookingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomContactBooking` mutation. */
export type DeleteRoomContactBookingPayload = {
  __typename?: 'DeleteRoomContactBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomContactBookingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomContactBooking`. */
  room?: Maybe<Room>;
  /** The `RoomContactBooking` that was deleted by this mutation. */
  roomContactBooking?: Maybe<RoomContactBooking>;
  /** An edge for our `RoomContactBooking`. May be used by Relay 1. */
  roomContactBookingEdge?: Maybe<RoomContactBookingsEdge>;
};


/** The output of our delete `RoomContactBooking` mutation. */
export type DeleteRoomContactBookingPayloadRoomContactBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomContactBookingsOrderBy>>;
};

/** All input for the `deleteRoomDaylight` mutation. */
export type DeleteRoomDaylightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomDaylight` mutation. */
export type DeleteRoomDaylightPayload = {
  __typename?: 'DeleteRoomDaylightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomDaylightNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomDaylight`. */
  room?: Maybe<Room>;
  /** The `RoomDaylight` that was deleted by this mutation. */
  roomDaylight?: Maybe<RoomDaylight>;
  /** An edge for our `RoomDaylight`. May be used by Relay 1. */
  roomDaylightEdge?: Maybe<RoomDaylightsEdge>;
};


/** The output of our delete `RoomDaylight` mutation. */
export type DeleteRoomDaylightPayloadRoomDaylightEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomDaylightsOrderBy>>;
};

/** All input for the `deleteRoomDescription` mutation. */
export type DeleteRoomDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomDescription` mutation. */
export type DeleteRoomDescriptionPayload = {
  __typename?: 'DeleteRoomDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomDescription`. */
  room?: Maybe<Room>;
  /** The `RoomDescription` that was deleted by this mutation. */
  roomDescription?: Maybe<RoomDescription>;
  /** An edge for our `RoomDescription`. May be used by Relay 1. */
  roomDescriptionEdge?: Maybe<RoomDescriptionsEdge>;
};


/** The output of our delete `RoomDescription` mutation. */
export type DeleteRoomDescriptionPayloadRoomDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomDescriptionsOrderBy>>;
};

/** All input for the `deleteRoom` mutation. */
export type DeleteRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteRoomKeyIssuance` mutation. */
export type DeleteRoomKeyIssuanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteRoomKeyIssuanceNote` mutation. */
export type DeleteRoomKeyIssuanceNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomKeyIssuanceNote` mutation. */
export type DeleteRoomKeyIssuanceNotePayload = {
  __typename?: 'DeleteRoomKeyIssuanceNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomKeyIssuanceNoteNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomKeyIssuanceNote`. */
  room?: Maybe<Room>;
  /** The `RoomKeyIssuanceNote` that was deleted by this mutation. */
  roomKeyIssuanceNote?: Maybe<RoomKeyIssuanceNote>;
  /** An edge for our `RoomKeyIssuanceNote`. May be used by Relay 1. */
  roomKeyIssuanceNoteEdge?: Maybe<RoomKeyIssuanceNotesEdge>;
};


/** The output of our delete `RoomKeyIssuanceNote` mutation. */
export type DeleteRoomKeyIssuanceNotePayloadRoomKeyIssuanceNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomKeyIssuanceNotesOrderBy>>;
};

/** The output of our delete `RoomKeyIssuance` mutation. */
export type DeleteRoomKeyIssuancePayload = {
  __typename?: 'DeleteRoomKeyIssuancePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomKeyIssuanceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomKeyIssuance`. */
  room?: Maybe<Room>;
  /** The `RoomKeyIssuance` that was deleted by this mutation. */
  roomKeyIssuance?: Maybe<RoomKeyIssuance>;
  /** An edge for our `RoomKeyIssuance`. May be used by Relay 1. */
  roomKeyIssuanceEdge?: Maybe<RoomKeyIssuancesEdge>;
};


/** The output of our delete `RoomKeyIssuance` mutation. */
export type DeleteRoomKeyIssuancePayloadRoomKeyIssuanceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomKeyIssuancesOrderBy>>;
};

/** All input for the `deleteRoomLightShutter` mutation. */
export type DeleteRoomLightShutterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomLightShutter` mutation. */
export type DeleteRoomLightShutterPayload = {
  __typename?: 'DeleteRoomLightShutterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomLightShutterNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomLightShutter`. */
  room?: Maybe<Room>;
  /** The `RoomLightShutter` that was deleted by this mutation. */
  roomLightShutter?: Maybe<RoomLightShutter>;
  /** An edge for our `RoomLightShutter`. May be used by Relay 1. */
  roomLightShutterEdge?: Maybe<RoomLightShuttersEdge>;
};


/** The output of our delete `RoomLightShutter` mutation. */
export type DeleteRoomLightShutterPayloadRoomLightShutterEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomLightShuttersOrderBy>>;
};

/** All input for the `deleteRoomMaxLoadCeiling` mutation. */
export type DeleteRoomMaxLoadCeilingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomMaxLoadCeiling` mutation. */
export type DeleteRoomMaxLoadCeilingPayload = {
  __typename?: 'DeleteRoomMaxLoadCeilingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomMaxLoadCeilingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomMaxLoadCeiling`. */
  room?: Maybe<Room>;
  /** The `RoomMaxLoadCeiling` that was deleted by this mutation. */
  roomMaxLoadCeiling?: Maybe<RoomMaxLoadCeiling>;
  /** An edge for our `RoomMaxLoadCeiling`. May be used by Relay 1. */
  roomMaxLoadCeilingEdge?: Maybe<RoomMaxLoadCeilingsEdge>;
};


/** The output of our delete `RoomMaxLoadCeiling` mutation. */
export type DeleteRoomMaxLoadCeilingPayloadRoomMaxLoadCeilingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomMaxLoadCeilingsOrderBy>>;
};

/** All input for the `deleteRoomMaxLoadFloor` mutation. */
export type DeleteRoomMaxLoadFloorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomMaxLoadFloor` mutation. */
export type DeleteRoomMaxLoadFloorPayload = {
  __typename?: 'DeleteRoomMaxLoadFloorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomMaxLoadFloorNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomMaxLoadFloor`. */
  room?: Maybe<Room>;
  /** The `RoomMaxLoadFloor` that was deleted by this mutation. */
  roomMaxLoadFloor?: Maybe<RoomMaxLoadFloor>;
  /** An edge for our `RoomMaxLoadFloor`. May be used by Relay 1. */
  roomMaxLoadFloorEdge?: Maybe<RoomMaxLoadFloorsEdge>;
};


/** The output of our delete `RoomMaxLoadFloor` mutation. */
export type DeleteRoomMaxLoadFloorPayloadRoomMaxLoadFloorEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomMaxLoadFloorsOrderBy>>;
};

/** All input for the `deleteRoomNameExtra` mutation. */
export type DeleteRoomNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameExtra` mutation. */
export type DeleteRoomNameExtraPayload = {
  __typename?: 'DeleteRoomNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameExtra`. */
  room?: Maybe<Room>;
  /** The `RoomNameExtra` that was deleted by this mutation. */
  roomNameExtra?: Maybe<RoomNameExtra>;
  /** An edge for our `RoomNameExtra`. May be used by Relay 1. */
  roomNameExtraEdge?: Maybe<RoomNameExtrasEdge>;
};


/** The output of our delete `RoomNameExtra` mutation. */
export type DeleteRoomNameExtraPayloadRoomNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameExtrasOrderBy>>;
};

/** All input for the `deleteRoomNameKeyCad` mutation. */
export type DeleteRoomNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameKeyCad` mutation. */
export type DeleteRoomNameKeyCadPayload = {
  __typename?: 'DeleteRoomNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyCad`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyCad` that was deleted by this mutation. */
  roomNameKeyCad?: Maybe<RoomNameKeyCad>;
  /** An edge for our `RoomNameKeyCad`. May be used by Relay 1. */
  roomNameKeyCadEdge?: Maybe<RoomNameKeyCadsEdge>;
};


/** The output of our delete `RoomNameKeyCad` mutation. */
export type DeleteRoomNameKeyCadPayloadRoomNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyCadsOrderBy>>;
};

/** All input for the `deleteRoomNameKeyCafm` mutation. */
export type DeleteRoomNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameKeyCafm` mutation. */
export type DeleteRoomNameKeyCafmPayload = {
  __typename?: 'DeleteRoomNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyCafm`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyCafm` that was deleted by this mutation. */
  roomNameKeyCafm?: Maybe<RoomNameKeyCafm>;
  /** An edge for our `RoomNameKeyCafm`. May be used by Relay 1. */
  roomNameKeyCafmEdge?: Maybe<RoomNameKeyCafmsEdge>;
};


/** The output of our delete `RoomNameKeyCafm` mutation. */
export type DeleteRoomNameKeyCafmPayloadRoomNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteRoomNameKeyEbm` mutation. */
export type DeleteRoomNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameKeyEbm` mutation. */
export type DeleteRoomNameKeyEbmPayload = {
  __typename?: 'DeleteRoomNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyEbm`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyEbm` that was deleted by this mutation. */
  roomNameKeyEbm?: Maybe<RoomNameKeyEbm>;
  /** An edge for our `RoomNameKeyEbm`. May be used by Relay 1. */
  roomNameKeyEbmEdge?: Maybe<RoomNameKeyEbmsEdge>;
};


/** The output of our delete `RoomNameKeyEbm` mutation. */
export type DeleteRoomNameKeyEbmPayloadRoomNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteRoomNameKeyMarketing` mutation. */
export type DeleteRoomNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameKeyMarketing` mutation. */
export type DeleteRoomNameKeyMarketingPayload = {
  __typename?: 'DeleteRoomNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyMarketing`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyMarketing` that was deleted by this mutation. */
  roomNameKeyMarketing?: Maybe<RoomNameKeyMarketing>;
  /** An edge for our `RoomNameKeyMarketing`. May be used by Relay 1. */
  roomNameKeyMarketingEdge?: Maybe<RoomNameKeyMarketingsEdge>;
};


/** The output of our delete `RoomNameKeyMarketing` mutation. */
export type DeleteRoomNameKeyMarketingPayloadRoomNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteRoomNameLong` mutation. */
export type DeleteRoomNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameLong` mutation. */
export type DeleteRoomNameLongPayload = {
  __typename?: 'DeleteRoomNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameLong`. */
  room?: Maybe<Room>;
  /** The `RoomNameLong` that was deleted by this mutation. */
  roomNameLong?: Maybe<RoomNameLong>;
  /** An edge for our `RoomNameLong`. May be used by Relay 1. */
  roomNameLongEdge?: Maybe<RoomNameLongsEdge>;
};


/** The output of our delete `RoomNameLong` mutation. */
export type DeleteRoomNameLongPayloadRoomNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameLongsOrderBy>>;
};

/** All input for the `deleteRoomNameShort` mutation. */
export type DeleteRoomNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNameShort` mutation. */
export type DeleteRoomNameShortPayload = {
  __typename?: 'DeleteRoomNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameShort`. */
  room?: Maybe<Room>;
  /** The `RoomNameShort` that was deleted by this mutation. */
  roomNameShort?: Maybe<RoomNameShort>;
  /** An edge for our `RoomNameShort`. May be used by Relay 1. */
  roomNameShortEdge?: Maybe<RoomNameShortsEdge>;
};


/** The output of our delete `RoomNameShort` mutation. */
export type DeleteRoomNameShortPayloadRoomNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameShortsOrderBy>>;
};

/** All input for the `deleteRoomNoVehicle` mutation. */
export type DeleteRoomNoVehicleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomNoVehicle` mutation. */
export type DeleteRoomNoVehiclePayload = {
  __typename?: 'DeleteRoomNoVehiclePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNoVehicleNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNoVehicle`. */
  room?: Maybe<Room>;
  /** The `RoomNoVehicle` that was deleted by this mutation. */
  roomNoVehicle?: Maybe<RoomNoVehicle>;
  /** An edge for our `RoomNoVehicle`. May be used by Relay 1. */
  roomNoVehicleEdge?: Maybe<RoomNoVehiclesEdge>;
};


/** The output of our delete `RoomNoVehicle` mutation. */
export type DeleteRoomNoVehiclePayloadRoomNoVehicleEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNoVehiclesOrderBy>>;
};

/** All input for the `deleteRoomPartitionByExtId` mutation. */
export type DeleteRoomPartitionByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteRoomPartitionByNameShort` mutation. */
export type DeleteRoomPartitionByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteRoomPartitionCadGrossSpaceMin` mutation. */
export type DeleteRoomPartitionCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadGrossSpaceMin` mutation. */
export type DeleteRoomPartitionCadGrossSpaceMinPayload = {
  __typename?: 'DeleteRoomPartitionCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadGrossSpaceMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadGrossSpaceMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadGrossSpaceMin` that was deleted by this mutation. */
  roomPartitionCadGrossSpaceMin?: Maybe<RoomPartitionCadGrossSpaceMin>;
  /** An edge for our `RoomPartitionCadGrossSpaceMin`. May be used by Relay 1. */
  roomPartitionCadGrossSpaceMinEdge?: Maybe<RoomPartitionCadGrossSpaceMinsEdge>;
};


/** The output of our delete `RoomPartitionCadGrossSpaceMin` mutation. */
export type DeleteRoomPartitionCadGrossSpaceMinPayloadRoomPartitionCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `deleteRoomPartitionCadHeightMax` mutation. */
export type DeleteRoomPartitionCadHeightMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadHeightMax` mutation. */
export type DeleteRoomPartitionCadHeightMaxPayload = {
  __typename?: 'DeleteRoomPartitionCadHeightMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadHeightMaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadHeightMax` that was deleted by this mutation. */
  roomPartitionCadHeightMax?: Maybe<RoomPartitionCadHeightMax>;
  /** An edge for our `RoomPartitionCadHeightMax`. May be used by Relay 1. */
  roomPartitionCadHeightMaxEdge?: Maybe<RoomPartitionCadHeightMaxesEdge>;
};


/** The output of our delete `RoomPartitionCadHeightMax` mutation. */
export type DeleteRoomPartitionCadHeightMaxPayloadRoomPartitionCadHeightMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMaxesOrderBy>>;
};

/** All input for the `deleteRoomPartitionCadHeightMin` mutation. */
export type DeleteRoomPartitionCadHeightMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadHeightMin` mutation. */
export type DeleteRoomPartitionCadHeightMinPayload = {
  __typename?: 'DeleteRoomPartitionCadHeightMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadHeightMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadHeightMin` that was deleted by this mutation. */
  roomPartitionCadHeightMin?: Maybe<RoomPartitionCadHeightMin>;
  /** An edge for our `RoomPartitionCadHeightMin`. May be used by Relay 1. */
  roomPartitionCadHeightMinEdge?: Maybe<RoomPartitionCadHeightMinsEdge>;
};


/** The output of our delete `RoomPartitionCadHeightMin` mutation. */
export type DeleteRoomPartitionCadHeightMinPayloadRoomPartitionCadHeightMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMinsOrderBy>>;
};

/** All input for the `deleteRoomPartitionCadLengthMax` mutation. */
export type DeleteRoomPartitionCadLengthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadLengthMax` mutation. */
export type DeleteRoomPartitionCadLengthMaxPayload = {
  __typename?: 'DeleteRoomPartitionCadLengthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadLengthMaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadLengthMax` that was deleted by this mutation. */
  roomPartitionCadLengthMax?: Maybe<RoomPartitionCadLengthMax>;
  /** An edge for our `RoomPartitionCadLengthMax`. May be used by Relay 1. */
  roomPartitionCadLengthMaxEdge?: Maybe<RoomPartitionCadLengthMaxesEdge>;
};


/** The output of our delete `RoomPartitionCadLengthMax` mutation. */
export type DeleteRoomPartitionCadLengthMaxPayloadRoomPartitionCadLengthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMaxesOrderBy>>;
};

/** All input for the `deleteRoomPartitionCadLengthMin` mutation. */
export type DeleteRoomPartitionCadLengthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadLengthMin` mutation. */
export type DeleteRoomPartitionCadLengthMinPayload = {
  __typename?: 'DeleteRoomPartitionCadLengthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadLengthMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadLengthMin` that was deleted by this mutation. */
  roomPartitionCadLengthMin?: Maybe<RoomPartitionCadLengthMin>;
  /** An edge for our `RoomPartitionCadLengthMin`. May be used by Relay 1. */
  roomPartitionCadLengthMinEdge?: Maybe<RoomPartitionCadLengthMinsEdge>;
};


/** The output of our delete `RoomPartitionCadLengthMin` mutation. */
export type DeleteRoomPartitionCadLengthMinPayloadRoomPartitionCadLengthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMinsOrderBy>>;
};

/** All input for the `deleteRoomPartitionCadWidthMax` mutation. */
export type DeleteRoomPartitionCadWidthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadWidthMax` mutation. */
export type DeleteRoomPartitionCadWidthMaxPayload = {
  __typename?: 'DeleteRoomPartitionCadWidthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadWidthMaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadWidthMax` that was deleted by this mutation. */
  roomPartitionCadWidthMax?: Maybe<RoomPartitionCadWidthMax>;
  /** An edge for our `RoomPartitionCadWidthMax`. May be used by Relay 1. */
  roomPartitionCadWidthMaxEdge?: Maybe<RoomPartitionCadWidthMaxesEdge>;
};


/** The output of our delete `RoomPartitionCadWidthMax` mutation. */
export type DeleteRoomPartitionCadWidthMaxPayloadRoomPartitionCadWidthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMaxesOrderBy>>;
};

/** All input for the `deleteRoomPartitionCadWidthMin` mutation. */
export type DeleteRoomPartitionCadWidthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCadWidthMin` mutation. */
export type DeleteRoomPartitionCadWidthMinPayload = {
  __typename?: 'DeleteRoomPartitionCadWidthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCadWidthMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadWidthMin` that was deleted by this mutation. */
  roomPartitionCadWidthMin?: Maybe<RoomPartitionCadWidthMin>;
  /** An edge for our `RoomPartitionCadWidthMin`. May be used by Relay 1. */
  roomPartitionCadWidthMinEdge?: Maybe<RoomPartitionCadWidthMinsEdge>;
};


/** The output of our delete `RoomPartitionCadWidthMin` mutation. */
export type DeleteRoomPartitionCadWidthMinPayloadRoomPartitionCadWidthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMinsOrderBy>>;
};

/** All input for the `deleteRoomPartitionCapacityPax` mutation. */
export type DeleteRoomPartitionCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCapacityPax` mutation. */
export type DeleteRoomPartitionCapacityPaxPayload = {
  __typename?: 'DeleteRoomPartitionCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCapacityPaxNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCapacityPax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCapacityPax` that was deleted by this mutation. */
  roomPartitionCapacityPax?: Maybe<RoomPartitionCapacityPax>;
  /** An edge for our `RoomPartitionCapacityPax`. May be used by Relay 1. */
  roomPartitionCapacityPaxEdge?: Maybe<RoomPartitionCapacityPaxesEdge>;
};


/** The output of our delete `RoomPartitionCapacityPax` mutation. */
export type DeleteRoomPartitionCapacityPaxPayloadRoomPartitionCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCapacityPaxesOrderBy>>;
};

/** All input for the `deleteRoomPartitionCleaningGrossSpace` mutation. */
export type DeleteRoomPartitionCleaningGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionCleaningGrossSpace` mutation. */
export type DeleteRoomPartitionCleaningGrossSpacePayload = {
  __typename?: 'DeleteRoomPartitionCleaningGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionCleaningGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCleaningGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCleaningGrossSpace` that was deleted by this mutation. */
  roomPartitionCleaningGrossSpace?: Maybe<RoomPartitionCleaningGrossSpace>;
  /** An edge for our `RoomPartitionCleaningGrossSpace`. May be used by Relay 1. */
  roomPartitionCleaningGrossSpaceEdge?: Maybe<RoomPartitionCleaningGrossSpacesEdge>;
};


/** The output of our delete `RoomPartitionCleaningGrossSpace` mutation. */
export type DeleteRoomPartitionCleaningGrossSpacePayloadRoomPartitionCleaningGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCleaningGrossSpacesOrderBy>>;
};

/** All input for the `deleteRoomPartitionDescription` mutation. */
export type DeleteRoomPartitionDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionDescription` mutation. */
export type DeleteRoomPartitionDescriptionPayload = {
  __typename?: 'DeleteRoomPartitionDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionDescription`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionDescription` that was deleted by this mutation. */
  roomPartitionDescription?: Maybe<RoomPartitionDescription>;
  /** An edge for our `RoomPartitionDescription`. May be used by Relay 1. */
  roomPartitionDescriptionEdge?: Maybe<RoomPartitionDescriptionsEdge>;
};


/** The output of our delete `RoomPartitionDescription` mutation. */
export type DeleteRoomPartitionDescriptionPayloadRoomPartitionDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionDescriptionsOrderBy>>;
};

/** All input for the `deleteRoomPartition` mutation. */
export type DeleteRoomPartitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteRoomPartitionNameExtra` mutation. */
export type DeleteRoomPartitionNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameExtra` mutation. */
export type DeleteRoomPartitionNameExtraPayload = {
  __typename?: 'DeleteRoomPartitionNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameExtra`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameExtra` that was deleted by this mutation. */
  roomPartitionNameExtra?: Maybe<RoomPartitionNameExtra>;
  /** An edge for our `RoomPartitionNameExtra`. May be used by Relay 1. */
  roomPartitionNameExtraEdge?: Maybe<RoomPartitionNameExtrasEdge>;
};


/** The output of our delete `RoomPartitionNameExtra` mutation. */
export type DeleteRoomPartitionNameExtraPayloadRoomPartitionNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameExtrasOrderBy>>;
};

/** All input for the `deleteRoomPartitionNameKeyCad` mutation. */
export type DeleteRoomPartitionNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameKeyCad` mutation. */
export type DeleteRoomPartitionNameKeyCadPayload = {
  __typename?: 'DeleteRoomPartitionNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCad`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyCad` that was deleted by this mutation. */
  roomPartitionNameKeyCad?: Maybe<RoomPartitionNameKeyCad>;
  /** An edge for our `RoomPartitionNameKeyCad`. May be used by Relay 1. */
  roomPartitionNameKeyCadEdge?: Maybe<RoomPartitionNameKeyCadsEdge>;
};


/** The output of our delete `RoomPartitionNameKeyCad` mutation. */
export type DeleteRoomPartitionNameKeyCadPayloadRoomPartitionNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCadsOrderBy>>;
};

/** All input for the `deleteRoomPartitionNameKeyCafm` mutation. */
export type DeleteRoomPartitionNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameKeyCafm` mutation. */
export type DeleteRoomPartitionNameKeyCafmPayload = {
  __typename?: 'DeleteRoomPartitionNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCafm`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyCafm` that was deleted by this mutation. */
  roomPartitionNameKeyCafm?: Maybe<RoomPartitionNameKeyCafm>;
  /** An edge for our `RoomPartitionNameKeyCafm`. May be used by Relay 1. */
  roomPartitionNameKeyCafmEdge?: Maybe<RoomPartitionNameKeyCafmsEdge>;
};


/** The output of our delete `RoomPartitionNameKeyCafm` mutation. */
export type DeleteRoomPartitionNameKeyCafmPayloadRoomPartitionNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteRoomPartitionNameKeyEbm` mutation. */
export type DeleteRoomPartitionNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameKeyEbm` mutation. */
export type DeleteRoomPartitionNameKeyEbmPayload = {
  __typename?: 'DeleteRoomPartitionNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyEbm`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyEbm` that was deleted by this mutation. */
  roomPartitionNameKeyEbm?: Maybe<RoomPartitionNameKeyEbm>;
  /** An edge for our `RoomPartitionNameKeyEbm`. May be used by Relay 1. */
  roomPartitionNameKeyEbmEdge?: Maybe<RoomPartitionNameKeyEbmsEdge>;
};


/** The output of our delete `RoomPartitionNameKeyEbm` mutation. */
export type DeleteRoomPartitionNameKeyEbmPayloadRoomPartitionNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteRoomPartitionNameKeyMarketing` mutation. */
export type DeleteRoomPartitionNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameKeyMarketing` mutation. */
export type DeleteRoomPartitionNameKeyMarketingPayload = {
  __typename?: 'DeleteRoomPartitionNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyMarketing`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyMarketing` that was deleted by this mutation. */
  roomPartitionNameKeyMarketing?: Maybe<RoomPartitionNameKeyMarketing>;
  /** An edge for our `RoomPartitionNameKeyMarketing`. May be used by Relay 1. */
  roomPartitionNameKeyMarketingEdge?: Maybe<RoomPartitionNameKeyMarketingsEdge>;
};


/** The output of our delete `RoomPartitionNameKeyMarketing` mutation. */
export type DeleteRoomPartitionNameKeyMarketingPayloadRoomPartitionNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteRoomPartitionNameLong` mutation. */
export type DeleteRoomPartitionNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameLong` mutation. */
export type DeleteRoomPartitionNameLongPayload = {
  __typename?: 'DeleteRoomPartitionNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameLong`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameLong` that was deleted by this mutation. */
  roomPartitionNameLong?: Maybe<RoomPartitionNameLong>;
  /** An edge for our `RoomPartitionNameLong`. May be used by Relay 1. */
  roomPartitionNameLongEdge?: Maybe<RoomPartitionNameLongsEdge>;
};


/** The output of our delete `RoomPartitionNameLong` mutation. */
export type DeleteRoomPartitionNameLongPayloadRoomPartitionNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameLongsOrderBy>>;
};

/** All input for the `deleteRoomPartitionNameShort` mutation. */
export type DeleteRoomPartitionNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionNameShort` mutation. */
export type DeleteRoomPartitionNameShortPayload = {
  __typename?: 'DeleteRoomPartitionNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameShort`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameShort` that was deleted by this mutation. */
  roomPartitionNameShort?: Maybe<RoomPartitionNameShort>;
  /** An edge for our `RoomPartitionNameShort`. May be used by Relay 1. */
  roomPartitionNameShortEdge?: Maybe<RoomPartitionNameShortsEdge>;
};


/** The output of our delete `RoomPartitionNameShort` mutation. */
export type DeleteRoomPartitionNameShortPayloadRoomPartitionNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameShortsOrderBy>>;
};

/** The output of our delete `RoomPartition` mutation. */
export type DeleteRoomPartitionPayload = {
  __typename?: 'DeleteRoomPartitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPartition`. */
  room?: Maybe<Room>;
  /** The `RoomPartition` that was deleted by this mutation. */
  roomPartition?: Maybe<RoomPartition>;
  /** An edge for our `RoomPartition`. May be used by Relay 1. */
  roomPartitionEdge?: Maybe<RoomPartitionsEdge>;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartition`. */
  type?: Maybe<RoomPartitionType>;
};


/** The output of our delete `RoomPartition` mutation. */
export type DeleteRoomPartitionPayloadRoomPartitionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionsOrderBy>>;
};

/** All input for the `deleteRoomPartitionPublicGrossSpace` mutation. */
export type DeleteRoomPartitionPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionPublicGrossSpace` mutation. */
export type DeleteRoomPartitionPublicGrossSpacePayload = {
  __typename?: 'DeleteRoomPartitionPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionPublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionPublicGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionPublicGrossSpace` that was deleted by this mutation. */
  roomPartitionPublicGrossSpace?: Maybe<RoomPartitionPublicGrossSpace>;
  /** An edge for our `RoomPartitionPublicGrossSpace`. May be used by Relay 1. */
  roomPartitionPublicGrossSpaceEdge?: Maybe<RoomPartitionPublicGrossSpacesEdge>;
};


/** The output of our delete `RoomPartitionPublicGrossSpace` mutation. */
export type DeleteRoomPartitionPublicGrossSpacePayloadRoomPartitionPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionPublicGrossSpacesOrderBy>>;
};

/** All input for the `deleteRoomPartitionSbvGrossSpace` mutation. */
export type DeleteRoomPartitionSbvGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionSbvGrossSpace` mutation. */
export type DeleteRoomPartitionSbvGrossSpacePayload = {
  __typename?: 'DeleteRoomPartitionSbvGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionSbvGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionSbvGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionSbvGrossSpace` that was deleted by this mutation. */
  roomPartitionSbvGrossSpace?: Maybe<RoomPartitionSbvGrossSpace>;
  /** An edge for our `RoomPartitionSbvGrossSpace`. May be used by Relay 1. */
  roomPartitionSbvGrossSpaceEdge?: Maybe<RoomPartitionSbvGrossSpacesEdge>;
};


/** The output of our delete `RoomPartitionSbvGrossSpace` mutation. */
export type DeleteRoomPartitionSbvGrossSpacePayloadRoomPartitionSbvGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionSbvGrossSpacesOrderBy>>;
};

/** All input for the `deleteRoomPartitionTypeAttr` mutation. */
export type DeleteRoomPartitionTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionTypeAttr` mutation. */
export type DeleteRoomPartitionTypeAttrPayload = {
  __typename?: 'DeleteRoomPartitionTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionTypeAttr`. */
  roomPartition?: Maybe<RoomPartition>;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartitionTypeAttr`. */
  roomPartitionType?: Maybe<RoomPartitionType>;
  /** The `RoomPartitionTypeAttr` that was deleted by this mutation. */
  roomPartitionTypeAttr?: Maybe<RoomPartitionTypeAttr>;
  /** An edge for our `RoomPartitionTypeAttr`. May be used by Relay 1. */
  roomPartitionTypeAttrEdge?: Maybe<RoomPartitionTypeAttrsEdge>;
};


/** The output of our delete `RoomPartitionTypeAttr` mutation. */
export type DeleteRoomPartitionTypeAttrPayloadRoomPartitionTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionTypeAttrsOrderBy>>;
};

/** All input for the `deleteRoomPartitionTypeByName` mutation. */
export type DeleteRoomPartitionTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteRoomPartitionType` mutation. */
export type DeleteRoomPartitionTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPartitionType` mutation. */
export type DeleteRoomPartitionTypePayload = {
  __typename?: 'DeleteRoomPartitionTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPartitionTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoomPartitionType` that was deleted by this mutation. */
  roomPartitionType?: Maybe<RoomPartitionType>;
  /** An edge for our `RoomPartitionType`. May be used by Relay 1. */
  roomPartitionTypeEdge?: Maybe<RoomPartitionTypesEdge>;
};


/** The output of our delete `RoomPartitionType` mutation. */
export type DeleteRoomPartitionTypePayloadRoomPartitionTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionTypesOrderBy>>;
};

/** The output of our delete `Room` mutation. */
export type DeleteRoomPayload = {
  __typename?: 'DeleteRoomPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Level` that is related to this `Room`. */
  level?: Maybe<Level>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Room` that was deleted by this mutation. */
  room?: Maybe<Room>;
  /** An edge for our `Room`. May be used by Relay 1. */
  roomEdge?: Maybe<RoomsEdge>;
  /** Reads a single `RoomType` that is related to this `Room`. */
  type?: Maybe<RoomType>;
};


/** The output of our delete `Room` mutation. */
export type DeleteRoomPayloadRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomsOrderBy>>;
};

/** All input for the `deleteRoomPhoneNumber` mutation. */
export type DeleteRoomPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPhoneNumber` mutation. */
export type DeleteRoomPhoneNumberPayload = {
  __typename?: 'DeleteRoomPhoneNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPhoneNumberNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPhoneNumber`. */
  room?: Maybe<Room>;
  /** The `RoomPhoneNumber` that was deleted by this mutation. */
  roomPhoneNumber?: Maybe<RoomPhoneNumber>;
  /** An edge for our `RoomPhoneNumber`. May be used by Relay 1. */
  roomPhoneNumberEdge?: Maybe<RoomPhoneNumbersEdge>;
};


/** The output of our delete `RoomPhoneNumber` mutation. */
export type DeleteRoomPhoneNumberPayloadRoomPhoneNumberEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPhoneNumbersOrderBy>>;
};

/** All input for the `deleteRoomPublicGrossSpace` mutation. */
export type DeleteRoomPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomPublicGrossSpace` mutation. */
export type DeleteRoomPublicGrossSpacePayload = {
  __typename?: 'DeleteRoomPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomPublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPublicGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomPublicGrossSpace` that was deleted by this mutation. */
  roomPublicGrossSpace?: Maybe<RoomPublicGrossSpace>;
  /** An edge for our `RoomPublicGrossSpace`. May be used by Relay 1. */
  roomPublicGrossSpaceEdge?: Maybe<RoomPublicGrossSpacesEdge>;
};


/** The output of our delete `RoomPublicGrossSpace` mutation. */
export type DeleteRoomPublicGrossSpacePayloadRoomPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPublicGrossSpacesOrderBy>>;
};

/** All input for the `deleteRoomSbvGrossSpace` mutation. */
export type DeleteRoomSbvGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomSbvGrossSpace` mutation. */
export type DeleteRoomSbvGrossSpacePayload = {
  __typename?: 'DeleteRoomSbvGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomSbvGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomSbvGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomSbvGrossSpace` that was deleted by this mutation. */
  roomSbvGrossSpace?: Maybe<RoomSbvGrossSpace>;
  /** An edge for our `RoomSbvGrossSpace`. May be used by Relay 1. */
  roomSbvGrossSpaceEdge?: Maybe<RoomSbvGrossSpacesEdge>;
};


/** The output of our delete `RoomSbvGrossSpace` mutation. */
export type DeleteRoomSbvGrossSpacePayloadRoomSbvGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomSbvGrossSpacesOrderBy>>;
};

/** All input for the `deleteRoomTireLoadCar` mutation. */
export type DeleteRoomTireLoadCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomTireLoadCar` mutation. */
export type DeleteRoomTireLoadCarPayload = {
  __typename?: 'DeleteRoomTireLoadCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomTireLoadCarNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadCar`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadCar` that was deleted by this mutation. */
  roomTireLoadCar?: Maybe<RoomTireLoadCar>;
  /** An edge for our `RoomTireLoadCar`. May be used by Relay 1. */
  roomTireLoadCarEdge?: Maybe<RoomTireLoadCarsEdge>;
};


/** The output of our delete `RoomTireLoadCar` mutation. */
export type DeleteRoomTireLoadCarPayloadRoomTireLoadCarEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadCarsOrderBy>>;
};

/** All input for the `deleteRoomTireLoadForklift` mutation. */
export type DeleteRoomTireLoadForkliftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomTireLoadForklift` mutation. */
export type DeleteRoomTireLoadForkliftPayload = {
  __typename?: 'DeleteRoomTireLoadForkliftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomTireLoadForkliftNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadForklift`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadForklift` that was deleted by this mutation. */
  roomTireLoadForklift?: Maybe<RoomTireLoadForklift>;
  /** An edge for our `RoomTireLoadForklift`. May be used by Relay 1. */
  roomTireLoadForkliftEdge?: Maybe<RoomTireLoadForkliftsEdge>;
};


/** The output of our delete `RoomTireLoadForklift` mutation. */
export type DeleteRoomTireLoadForkliftPayloadRoomTireLoadForkliftEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadForkliftsOrderBy>>;
};

/** All input for the `deleteRoomTireLoadTruck` mutation. */
export type DeleteRoomTireLoadTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomTireLoadTruck` mutation. */
export type DeleteRoomTireLoadTruckPayload = {
  __typename?: 'DeleteRoomTireLoadTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomTireLoadTruckNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadTruck`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadTruck` that was deleted by this mutation. */
  roomTireLoadTruck?: Maybe<RoomTireLoadTruck>;
  /** An edge for our `RoomTireLoadTruck`. May be used by Relay 1. */
  roomTireLoadTruckEdge?: Maybe<RoomTireLoadTrucksEdge>;
};


/** The output of our delete `RoomTireLoadTruck` mutation. */
export type DeleteRoomTireLoadTruckPayloadRoomTireLoadTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadTrucksOrderBy>>;
};

/** All input for the `deleteRoomTypeAttr` mutation. */
export type DeleteRoomTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomTypeAttr` mutation. */
export type DeleteRoomTypeAttrPayload = {
  __typename?: 'DeleteRoomTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTypeAttr`. */
  room?: Maybe<Room>;
  /** Reads a single `RoomType` that is related to this `RoomTypeAttr`. */
  roomType?: Maybe<RoomType>;
  /** The `RoomTypeAttr` that was deleted by this mutation. */
  roomTypeAttr?: Maybe<RoomTypeAttr>;
  /** An edge for our `RoomTypeAttr`. May be used by Relay 1. */
  roomTypeAttrEdge?: Maybe<RoomTypeAttrsEdge>;
};


/** The output of our delete `RoomTypeAttr` mutation. */
export type DeleteRoomTypeAttrPayloadRoomTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTypeAttrsOrderBy>>;
};

/** All input for the `deleteRoomTypeByName` mutation. */
export type DeleteRoomTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteRoomType` mutation. */
export type DeleteRoomTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RoomType` mutation. */
export type DeleteRoomTypePayload = {
  __typename?: 'DeleteRoomTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoomTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoomType` that was deleted by this mutation. */
  roomType?: Maybe<RoomType>;
  /** An edge for our `RoomType`. May be used by Relay 1. */
  roomTypeEdge?: Maybe<RoomTypesEdge>;
};


/** The output of our delete `RoomType` mutation. */
export type DeleteRoomTypePayloadRoomTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTypesOrderBy>>;
};

/** All input for the `deleteScenarioByNameShort` mutation. */
export type DeleteScenarioByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteScenarioGroupByNameShort` mutation. */
export type DeleteScenarioGroupByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteScenarioGroup` mutation. */
export type DeleteScenarioGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ScenarioGroup` mutation. */
export type DeleteScenarioGroupPayload = {
  __typename?: 'DeleteScenarioGroupPayload';
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedScenarioGroupNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  organisationalChanges?: Maybe<Feed>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScenarioGroup` that was deleted by this mutation. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  /** An edge for our `ScenarioGroup`. May be used by Relay 1. */
  scenarioGroupEdge?: Maybe<ScenarioGroupsEdge>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our delete `ScenarioGroup` mutation. */
export type DeleteScenarioGroupPayloadScenarioGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};

/** All input for the `deleteScenario` mutation. */
export type DeleteScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Scenario` mutation. */
export type DeleteScenarioPayload = {
  __typename?: 'DeleteScenarioPayload';
  /** Reads a single `Feed` that is related to this `Scenario`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedScenarioNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Scenario` that was deleted by this mutation. */
  scenario?: Maybe<Scenario>;
  /** An edge for our `Scenario`. May be used by Relay 1. */
  scenarioEdge?: Maybe<ScenariosEdge>;
  /** Reads a single `ScenarioGroup` that is related to this `Scenario`. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our delete `Scenario` mutation. */
export type DeleteScenarioPayloadScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** All input for the `deleteScenarioSetting` mutation. */
export type DeleteScenarioSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  scenarioId: Scalars['UUID'];
};

/** The output of our delete `ScenarioSetting` mutation. */
export type DeleteScenarioSettingPayload = {
  __typename?: 'DeleteScenarioSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedScenarioSettingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Scenario` that is related to this `ScenarioSetting`. */
  scenario?: Maybe<Scenario>;
  /** The `ScenarioSetting` that was deleted by this mutation. */
  scenarioSetting?: Maybe<ScenarioSetting>;
  /** An edge for our `ScenarioSetting`. May be used by Relay 1. */
  scenarioSettingEdge?: Maybe<ScenarioSettingsEdge>;
};


/** The output of our delete `ScenarioSetting` mutation. */
export type DeleteScenarioSettingPayloadScenarioSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioSettingsOrderBy>>;
};

/** All input for the `deleteScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantType` mutation. */
export type DeleteScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
};

/** All input for the `deleteScenarioVariantVisibility` mutation. */
export type DeleteScenarioVariantVisibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ScenarioVariantVisibility` mutation. */
export type DeleteScenarioVariantVisibilityPayload = {
  __typename?: 'DeleteScenarioVariantVisibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedScenarioVariantVisibilityNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Scenario` that is related to this `ScenarioVariantVisibility`. */
  scenario?: Maybe<Scenario>;
  /** The `ScenarioVariantVisibility` that was deleted by this mutation. */
  scenarioVariantVisibility?: Maybe<ScenarioVariantVisibility>;
  /** An edge for our `ScenarioVariantVisibility`. May be used by Relay 1. */
  scenarioVariantVisibilityEdge?: Maybe<ScenarioVariantVisibilitiesEdge>;
};


/** The output of our delete `ScenarioVariantVisibility` mutation. */
export type DeleteScenarioVariantVisibilityPayloadScenarioVariantVisibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioVariantVisibilitiesOrderBy>>;
};

/** All input for the `deleteSiteByExtId` mutation. */
export type DeleteSiteByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteSiteByNameShort` mutation. */
export type DeleteSiteByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteSiteDescription` mutation. */
export type DeleteSiteDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteDescription` mutation. */
export type DeleteSiteDescriptionPayload = {
  __typename?: 'DeleteSiteDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteDescription`. */
  site?: Maybe<Site>;
  /** The `SiteDescription` that was deleted by this mutation. */
  siteDescription?: Maybe<SiteDescription>;
  /** An edge for our `SiteDescription`. May be used by Relay 1. */
  siteDescriptionEdge?: Maybe<SiteDescriptionsEdge>;
};


/** The output of our delete `SiteDescription` mutation. */
export type DeleteSiteDescriptionPayloadSiteDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteDescriptionsOrderBy>>;
};

/** All input for the `deleteSite` mutation. */
export type DeleteSiteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteSiteNameExtra` mutation. */
export type DeleteSiteNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameExtra` mutation. */
export type DeleteSiteNameExtraPayload = {
  __typename?: 'DeleteSiteNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameExtra`. */
  site?: Maybe<Site>;
  /** The `SiteNameExtra` that was deleted by this mutation. */
  siteNameExtra?: Maybe<SiteNameExtra>;
  /** An edge for our `SiteNameExtra`. May be used by Relay 1. */
  siteNameExtraEdge?: Maybe<SiteNameExtrasEdge>;
};


/** The output of our delete `SiteNameExtra` mutation. */
export type DeleteSiteNameExtraPayloadSiteNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameExtrasOrderBy>>;
};

/** All input for the `deleteSiteNameKeyCad` mutation. */
export type DeleteSiteNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameKeyCad` mutation. */
export type DeleteSiteNameKeyCadPayload = {
  __typename?: 'DeleteSiteNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyCad`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyCad` that was deleted by this mutation. */
  siteNameKeyCad?: Maybe<SiteNameKeyCad>;
  /** An edge for our `SiteNameKeyCad`. May be used by Relay 1. */
  siteNameKeyCadEdge?: Maybe<SiteNameKeyCadsEdge>;
};


/** The output of our delete `SiteNameKeyCad` mutation. */
export type DeleteSiteNameKeyCadPayloadSiteNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyCadsOrderBy>>;
};

/** All input for the `deleteSiteNameKeyCafm` mutation. */
export type DeleteSiteNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameKeyCafm` mutation. */
export type DeleteSiteNameKeyCafmPayload = {
  __typename?: 'DeleteSiteNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyCafm`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyCafm` that was deleted by this mutation. */
  siteNameKeyCafm?: Maybe<SiteNameKeyCafm>;
  /** An edge for our `SiteNameKeyCafm`. May be used by Relay 1. */
  siteNameKeyCafmEdge?: Maybe<SiteNameKeyCafmsEdge>;
};


/** The output of our delete `SiteNameKeyCafm` mutation. */
export type DeleteSiteNameKeyCafmPayloadSiteNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteSiteNameKeyEbm` mutation. */
export type DeleteSiteNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameKeyEbm` mutation. */
export type DeleteSiteNameKeyEbmPayload = {
  __typename?: 'DeleteSiteNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyEbm`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyEbm` that was deleted by this mutation. */
  siteNameKeyEbm?: Maybe<SiteNameKeyEbm>;
  /** An edge for our `SiteNameKeyEbm`. May be used by Relay 1. */
  siteNameKeyEbmEdge?: Maybe<SiteNameKeyEbmsEdge>;
};


/** The output of our delete `SiteNameKeyEbm` mutation. */
export type DeleteSiteNameKeyEbmPayloadSiteNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteSiteNameKeyMarketing` mutation. */
export type DeleteSiteNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameKeyMarketing` mutation. */
export type DeleteSiteNameKeyMarketingPayload = {
  __typename?: 'DeleteSiteNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyMarketing`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyMarketing` that was deleted by this mutation. */
  siteNameKeyMarketing?: Maybe<SiteNameKeyMarketing>;
  /** An edge for our `SiteNameKeyMarketing`. May be used by Relay 1. */
  siteNameKeyMarketingEdge?: Maybe<SiteNameKeyMarketingsEdge>;
};


/** The output of our delete `SiteNameKeyMarketing` mutation. */
export type DeleteSiteNameKeyMarketingPayloadSiteNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteSiteNameLong` mutation. */
export type DeleteSiteNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameLong` mutation. */
export type DeleteSiteNameLongPayload = {
  __typename?: 'DeleteSiteNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameLong`. */
  site?: Maybe<Site>;
  /** The `SiteNameLong` that was deleted by this mutation. */
  siteNameLong?: Maybe<SiteNameLong>;
  /** An edge for our `SiteNameLong`. May be used by Relay 1. */
  siteNameLongEdge?: Maybe<SiteNameLongsEdge>;
};


/** The output of our delete `SiteNameLong` mutation. */
export type DeleteSiteNameLongPayloadSiteNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameLongsOrderBy>>;
};

/** All input for the `deleteSiteNameShort` mutation. */
export type DeleteSiteNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SiteNameShort` mutation. */
export type DeleteSiteNameShortPayload = {
  __typename?: 'DeleteSiteNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameShort`. */
  site?: Maybe<Site>;
  /** The `SiteNameShort` that was deleted by this mutation. */
  siteNameShort?: Maybe<SiteNameShort>;
  /** An edge for our `SiteNameShort`. May be used by Relay 1. */
  siteNameShortEdge?: Maybe<SiteNameShortsEdge>;
};


/** The output of our delete `SiteNameShort` mutation. */
export type DeleteSiteNameShortPayloadSiteNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameShortsOrderBy>>;
};

/** The output of our delete `Site` mutation. */
export type DeleteSitePayload = {
  __typename?: 'DeleteSitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSiteNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Site` that was deleted by this mutation. */
  site?: Maybe<Site>;
  /** An edge for our `Site`. May be used by Relay 1. */
  siteEdge?: Maybe<SitesEdge>;
};


/** The output of our delete `Site` mutation. */
export type DeleteSitePayloadSiteEdgeArgs = {
  orderBy?: InputMaybe<Array<SitesOrderBy>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteUserPasswordLoginByEmail` mutation. */
export type DeleteUserPasswordLoginByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** All input for the `deleteUserPasswordLoginByUserId` mutation. */
export type DeleteUserPasswordLoginByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** All input for the `deleteUserPasswordLogin` mutation. */
export type DeleteUserPasswordLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `UserPasswordLogin` mutation. */
export type DeleteUserPasswordLoginPayload = {
  __typename?: 'DeleteUserPasswordLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserPasswordLoginNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserPasswordLogin`. */
  user?: Maybe<User>;
  /** The `UserPasswordLogin` that was deleted by this mutation. */
  userPasswordLogin?: Maybe<UserPasswordLogin>;
  /** An edge for our `UserPasswordLogin`. May be used by Relay 1. */
  userPasswordLoginEdge?: Maybe<UserPasswordLoginsEdge>;
};


/** The output of our delete `UserPasswordLogin` mutation. */
export type DeleteUserPasswordLoginPayloadUserPasswordLoginEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPasswordLoginsOrderBy>>;
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserSsoLoginByProviderAndOid` mutation. */
export type DeleteUserSsoLoginByProviderAndOidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  provider: SsoProvider;
};

/** All input for the `deleteUserSsoLoginByUserIdAndProvider` mutation. */
export type DeleteUserSsoLoginByUserIdAndProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  provider: SsoProvider;
  userId: Scalars['UUID'];
};

/** All input for the `deleteUserSsoLogin` mutation. */
export type DeleteUserSsoLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `UserSsoLogin` mutation. */
export type DeleteUserSsoLoginPayload = {
  __typename?: 'DeleteUserSsoLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserSsoLoginNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSsoLogin`. */
  user?: Maybe<User>;
  /** The `UserSsoLogin` that was deleted by this mutation. */
  userSsoLogin?: Maybe<UserSsoLogin>;
  /** An edge for our `UserSsoLogin`. May be used by Relay 1. */
  userSsoLoginEdge?: Maybe<UserSsoLoginsEdge>;
};


/** The output of our delete `UserSsoLogin` mutation. */
export type DeleteUserSsoLoginPayloadUserSsoLoginEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSsoLoginsOrderBy>>;
};

/** All input for the `deleteZoneByExtId` mutation. */
export type DeleteZoneByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
};

/** All input for the `deleteZoneByNameShort` mutation. */
export type DeleteZoneByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
};

/** All input for the `deleteZoneCadGrossSpaceMin` mutation. */
export type DeleteZoneCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneCadGrossSpaceMin` mutation. */
export type DeleteZoneCadGrossSpaceMinPayload = {
  __typename?: 'DeleteZoneCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneCadGrossSpaceMinNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCadGrossSpaceMin`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCadGrossSpaceMin` that was deleted by this mutation. */
  zoneCadGrossSpaceMin?: Maybe<ZoneCadGrossSpaceMin>;
  /** An edge for our `ZoneCadGrossSpaceMin`. May be used by Relay 1. */
  zoneCadGrossSpaceMinEdge?: Maybe<ZoneCadGrossSpaceMinsEdge>;
};


/** The output of our delete `ZoneCadGrossSpaceMin` mutation. */
export type DeleteZoneCadGrossSpaceMinPayloadZoneCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `deleteZoneCapacityCar` mutation. */
export type DeleteZoneCapacityCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneCapacityCar` mutation. */
export type DeleteZoneCapacityCarPayload = {
  __typename?: 'DeleteZoneCapacityCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneCapacityCarNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCapacityCar`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCapacityCar` that was deleted by this mutation. */
  zoneCapacityCar?: Maybe<ZoneCapacityCar>;
  /** An edge for our `ZoneCapacityCar`. May be used by Relay 1. */
  zoneCapacityCarEdge?: Maybe<ZoneCapacityCarsEdge>;
};


/** The output of our delete `ZoneCapacityCar` mutation. */
export type DeleteZoneCapacityCarPayloadZoneCapacityCarEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCapacityCarsOrderBy>>;
};

/** All input for the `deleteZoneCapacityTruck` mutation. */
export type DeleteZoneCapacityTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneCapacityTruck` mutation. */
export type DeleteZoneCapacityTruckPayload = {
  __typename?: 'DeleteZoneCapacityTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneCapacityTruckNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCapacityTruck`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCapacityTruck` that was deleted by this mutation. */
  zoneCapacityTruck?: Maybe<ZoneCapacityTruck>;
  /** An edge for our `ZoneCapacityTruck`. May be used by Relay 1. */
  zoneCapacityTruckEdge?: Maybe<ZoneCapacityTrucksEdge>;
};


/** The output of our delete `ZoneCapacityTruck` mutation. */
export type DeleteZoneCapacityTruckPayloadZoneCapacityTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCapacityTrucksOrderBy>>;
};

/** All input for the `deleteZoneDescription` mutation. */
export type DeleteZoneDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneDescription` mutation. */
export type DeleteZoneDescriptionPayload = {
  __typename?: 'DeleteZoneDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneDescriptionNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneDescription`. */
  zone?: Maybe<Zone>;
  /** The `ZoneDescription` that was deleted by this mutation. */
  zoneDescription?: Maybe<ZoneDescription>;
  /** An edge for our `ZoneDescription`. May be used by Relay 1. */
  zoneDescriptionEdge?: Maybe<ZoneDescriptionsEdge>;
};


/** The output of our delete `ZoneDescription` mutation. */
export type DeleteZoneDescriptionPayloadZoneDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneDescriptionsOrderBy>>;
};

/** All input for the `deleteZone` mutation. */
export type DeleteZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteZoneMaxLoadFloor` mutation. */
export type DeleteZoneMaxLoadFloorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneMaxLoadFloor` mutation. */
export type DeleteZoneMaxLoadFloorPayload = {
  __typename?: 'DeleteZoneMaxLoadFloorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneMaxLoadFloorNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneMaxLoadFloor`. */
  zone?: Maybe<Zone>;
  /** The `ZoneMaxLoadFloor` that was deleted by this mutation. */
  zoneMaxLoadFloor?: Maybe<ZoneMaxLoadFloor>;
  /** An edge for our `ZoneMaxLoadFloor`. May be used by Relay 1. */
  zoneMaxLoadFloorEdge?: Maybe<ZoneMaxLoadFloorsEdge>;
};


/** The output of our delete `ZoneMaxLoadFloor` mutation. */
export type DeleteZoneMaxLoadFloorPayloadZoneMaxLoadFloorEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneMaxLoadFloorsOrderBy>>;
};

/** All input for the `deleteZoneNameExtra` mutation. */
export type DeleteZoneNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameExtra` mutation. */
export type DeleteZoneNameExtraPayload = {
  __typename?: 'DeleteZoneNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameExtraNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameExtra`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameExtra` that was deleted by this mutation. */
  zoneNameExtra?: Maybe<ZoneNameExtra>;
  /** An edge for our `ZoneNameExtra`. May be used by Relay 1. */
  zoneNameExtraEdge?: Maybe<ZoneNameExtrasEdge>;
};


/** The output of our delete `ZoneNameExtra` mutation. */
export type DeleteZoneNameExtraPayloadZoneNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameExtrasOrderBy>>;
};

/** All input for the `deleteZoneNameKeyCad` mutation. */
export type DeleteZoneNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameKeyCad` mutation. */
export type DeleteZoneNameKeyCadPayload = {
  __typename?: 'DeleteZoneNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameKeyCadNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCad`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyCad` that was deleted by this mutation. */
  zoneNameKeyCad?: Maybe<ZoneNameKeyCad>;
  /** An edge for our `ZoneNameKeyCad`. May be used by Relay 1. */
  zoneNameKeyCadEdge?: Maybe<ZoneNameKeyCadsEdge>;
};


/** The output of our delete `ZoneNameKeyCad` mutation. */
export type DeleteZoneNameKeyCadPayloadZoneNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyCadsOrderBy>>;
};

/** All input for the `deleteZoneNameKeyCafm` mutation. */
export type DeleteZoneNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameKeyCafm` mutation. */
export type DeleteZoneNameKeyCafmPayload = {
  __typename?: 'DeleteZoneNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameKeyCafmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCafm`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyCafm` that was deleted by this mutation. */
  zoneNameKeyCafm?: Maybe<ZoneNameKeyCafm>;
  /** An edge for our `ZoneNameKeyCafm`. May be used by Relay 1. */
  zoneNameKeyCafmEdge?: Maybe<ZoneNameKeyCafmsEdge>;
};


/** The output of our delete `ZoneNameKeyCafm` mutation. */
export type DeleteZoneNameKeyCafmPayloadZoneNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyCafmsOrderBy>>;
};

/** All input for the `deleteZoneNameKeyEbm` mutation. */
export type DeleteZoneNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameKeyEbm` mutation. */
export type DeleteZoneNameKeyEbmPayload = {
  __typename?: 'DeleteZoneNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameKeyEbmNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyEbm`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyEbm` that was deleted by this mutation. */
  zoneNameKeyEbm?: Maybe<ZoneNameKeyEbm>;
  /** An edge for our `ZoneNameKeyEbm`. May be used by Relay 1. */
  zoneNameKeyEbmEdge?: Maybe<ZoneNameKeyEbmsEdge>;
};


/** The output of our delete `ZoneNameKeyEbm` mutation. */
export type DeleteZoneNameKeyEbmPayloadZoneNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyEbmsOrderBy>>;
};

/** All input for the `deleteZoneNameKeyMarketing` mutation. */
export type DeleteZoneNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameKeyMarketing` mutation. */
export type DeleteZoneNameKeyMarketingPayload = {
  __typename?: 'DeleteZoneNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameKeyMarketingNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyMarketing`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyMarketing` that was deleted by this mutation. */
  zoneNameKeyMarketing?: Maybe<ZoneNameKeyMarketing>;
  /** An edge for our `ZoneNameKeyMarketing`. May be used by Relay 1. */
  zoneNameKeyMarketingEdge?: Maybe<ZoneNameKeyMarketingsEdge>;
};


/** The output of our delete `ZoneNameKeyMarketing` mutation. */
export type DeleteZoneNameKeyMarketingPayloadZoneNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyMarketingsOrderBy>>;
};

/** All input for the `deleteZoneNameLong` mutation. */
export type DeleteZoneNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameLong` mutation. */
export type DeleteZoneNameLongPayload = {
  __typename?: 'DeleteZoneNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameLongNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameLong`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameLong` that was deleted by this mutation. */
  zoneNameLong?: Maybe<ZoneNameLong>;
  /** An edge for our `ZoneNameLong`. May be used by Relay 1. */
  zoneNameLongEdge?: Maybe<ZoneNameLongsEdge>;
};


/** The output of our delete `ZoneNameLong` mutation. */
export type DeleteZoneNameLongPayloadZoneNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameLongsOrderBy>>;
};

/** All input for the `deleteZoneNameShort` mutation. */
export type DeleteZoneNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNameShort` mutation. */
export type DeleteZoneNameShortPayload = {
  __typename?: 'DeleteZoneNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNameShortNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameShort`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameShort` that was deleted by this mutation. */
  zoneNameShort?: Maybe<ZoneNameShort>;
  /** An edge for our `ZoneNameShort`. May be used by Relay 1. */
  zoneNameShortEdge?: Maybe<ZoneNameShortsEdge>;
};


/** The output of our delete `ZoneNameShort` mutation. */
export type DeleteZoneNameShortPayloadZoneNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameShortsOrderBy>>;
};

/** All input for the `deleteZoneNoVehicle` mutation. */
export type DeleteZoneNoVehicleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneNoVehicle` mutation. */
export type DeleteZoneNoVehiclePayload = {
  __typename?: 'DeleteZoneNoVehiclePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNoVehicleNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNoVehicle`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNoVehicle` that was deleted by this mutation. */
  zoneNoVehicle?: Maybe<ZoneNoVehicle>;
  /** An edge for our `ZoneNoVehicle`. May be used by Relay 1. */
  zoneNoVehicleEdge?: Maybe<ZoneNoVehiclesEdge>;
};


/** The output of our delete `ZoneNoVehicle` mutation. */
export type DeleteZoneNoVehiclePayloadZoneNoVehicleEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNoVehiclesOrderBy>>;
};

/** The output of our delete `Zone` mutation. */
export type DeleteZonePayload = {
  __typename?: 'DeleteZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `Zone`. */
  site?: Maybe<Site>;
  /** Reads a single `ZoneType` that is related to this `Zone`. */
  type?: Maybe<ZoneType>;
  /** The `Zone` that was deleted by this mutation. */
  zone?: Maybe<Zone>;
  /** An edge for our `Zone`. May be used by Relay 1. */
  zoneEdge?: Maybe<ZonesEdge>;
};


/** The output of our delete `Zone` mutation. */
export type DeleteZonePayloadZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** All input for the `deleteZonePublicGrossSpace` mutation. */
export type DeleteZonePublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZonePublicGrossSpace` mutation. */
export type DeleteZonePublicGrossSpacePayload = {
  __typename?: 'DeleteZonePublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZonePublicGrossSpaceNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZonePublicGrossSpace`. */
  zone?: Maybe<Zone>;
  /** The `ZonePublicGrossSpace` that was deleted by this mutation. */
  zonePublicGrossSpace?: Maybe<ZonePublicGrossSpace>;
  /** An edge for our `ZonePublicGrossSpace`. May be used by Relay 1. */
  zonePublicGrossSpaceEdge?: Maybe<ZonePublicGrossSpacesEdge>;
};


/** The output of our delete `ZonePublicGrossSpace` mutation. */
export type DeleteZonePublicGrossSpacePayloadZonePublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonePublicGrossSpacesOrderBy>>;
};

/** All input for the `deleteZoneTireLoadCar` mutation. */
export type DeleteZoneTireLoadCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneTireLoadCar` mutation. */
export type DeleteZoneTireLoadCarPayload = {
  __typename?: 'DeleteZoneTireLoadCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneTireLoadCarNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadCar`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadCar` that was deleted by this mutation. */
  zoneTireLoadCar?: Maybe<ZoneTireLoadCar>;
  /** An edge for our `ZoneTireLoadCar`. May be used by Relay 1. */
  zoneTireLoadCarEdge?: Maybe<ZoneTireLoadCarsEdge>;
};


/** The output of our delete `ZoneTireLoadCar` mutation. */
export type DeleteZoneTireLoadCarPayloadZoneTireLoadCarEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadCarsOrderBy>>;
};

/** All input for the `deleteZoneTireLoadForklift` mutation. */
export type DeleteZoneTireLoadForkliftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneTireLoadForklift` mutation. */
export type DeleteZoneTireLoadForkliftPayload = {
  __typename?: 'DeleteZoneTireLoadForkliftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneTireLoadForkliftNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadForklift`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadForklift` that was deleted by this mutation. */
  zoneTireLoadForklift?: Maybe<ZoneTireLoadForklift>;
  /** An edge for our `ZoneTireLoadForklift`. May be used by Relay 1. */
  zoneTireLoadForkliftEdge?: Maybe<ZoneTireLoadForkliftsEdge>;
};


/** The output of our delete `ZoneTireLoadForklift` mutation. */
export type DeleteZoneTireLoadForkliftPayloadZoneTireLoadForkliftEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadForkliftsOrderBy>>;
};

/** All input for the `deleteZoneTireLoadTruck` mutation. */
export type DeleteZoneTireLoadTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneTireLoadTruck` mutation. */
export type DeleteZoneTireLoadTruckPayload = {
  __typename?: 'DeleteZoneTireLoadTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneTireLoadTruckNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadTruck`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadTruck` that was deleted by this mutation. */
  zoneTireLoadTruck?: Maybe<ZoneTireLoadTruck>;
  /** An edge for our `ZoneTireLoadTruck`. May be used by Relay 1. */
  zoneTireLoadTruckEdge?: Maybe<ZoneTireLoadTrucksEdge>;
};


/** The output of our delete `ZoneTireLoadTruck` mutation. */
export type DeleteZoneTireLoadTruckPayloadZoneTireLoadTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadTrucksOrderBy>>;
};

/** All input for the `deleteZoneTypeAttr` mutation. */
export type DeleteZoneTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneTypeAttr` mutation. */
export type DeleteZoneTypeAttrPayload = {
  __typename?: 'DeleteZoneTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneTypeAttrNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTypeAttr`. */
  zone?: Maybe<Zone>;
  /** Reads a single `ZoneType` that is related to this `ZoneTypeAttr`. */
  zoneType?: Maybe<ZoneType>;
  /** The `ZoneTypeAttr` that was deleted by this mutation. */
  zoneTypeAttr?: Maybe<ZoneTypeAttr>;
  /** An edge for our `ZoneTypeAttr`. May be used by Relay 1. */
  zoneTypeAttrEdge?: Maybe<ZoneTypeAttrsEdge>;
};


/** The output of our delete `ZoneTypeAttr` mutation. */
export type DeleteZoneTypeAttrPayloadZoneTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTypeAttrsOrderBy>>;
};

/** All input for the `deleteZoneTypeByName` mutation. */
export type DeleteZoneTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteZoneType` mutation. */
export type DeleteZoneTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ZoneType` mutation. */
export type DeleteZoneTypePayload = {
  __typename?: 'DeleteZoneTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedZoneTypeNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ZoneType` that was deleted by this mutation. */
  zoneType?: Maybe<ZoneType>;
  /** An edge for our `ZoneType`. May be used by Relay 1. */
  zoneTypeEdge?: Maybe<ZoneTypesEdge>;
};


/** The output of our delete `ZoneType` mutation. */
export type DeleteZoneTypePayloadZoneTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTypesOrderBy>>;
};

export type ElevationLevel = {
  __typename?: 'ElevationLevel';
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Level`. */
  levelsByElevationId: LevelsConnection;
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  value: Scalars['BigFloat'];
};


export type ElevationLevelLevelsByElevationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelCondition>;
  filter?: InputMaybe<LevelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};

/**
 * A condition to be used against `ElevationLevel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ElevationLevelCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `elevationLevel` to look up the row to connect. */
export type ElevationLevelElevationLevelPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `elevationLevel` to look up the row to delete. */
export type ElevationLevelElevationLevelPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `elevationLevel` to look up the row to connect. */
export type ElevationLevelElevationLevelValueKeyConnect = {
  value: Scalars['BigFloat'];
};

/** The fields on `elevationLevel` to look up the row to delete. */
export type ElevationLevelElevationLevelValueKeyDelete = {
  value: Scalars['BigFloat'];
};

/** A filter to be used against `ElevationLevel` object types. All fields are combined with a logical ‘and.’ */
export type ElevationLevelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ElevationLevelFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `levelsByElevationId` relation. */
  levelsByElevationId?: InputMaybe<ElevationLevelToManyLevelFilter>;
  /** Some related `levelsByElevationId` exist. */
  levelsByElevationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ElevationLevelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ElevationLevelFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `ElevationLevel` */
export type ElevationLevelInput = {
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelElevationIdKeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  value: Scalars['BigFloat'];
};

/** The fields on `elevationLevel` to look up the row to update. */
export type ElevationLevelOnLevelForLevelElevationIdKeyUsingElevationLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `elevationLevel` being updated. */
  patch: UpdateElevationLevelOnLevelForLevelElevationIdKeyPatch;
};

/** The fields on `elevationLevel` to look up the row to update. */
export type ElevationLevelOnLevelForLevelElevationIdKeyUsingElevationLevelValueKeyUpdate = {
  /** An object where the defined keys will be set on the `elevationLevel` being updated. */
  patch: UpdateElevationLevelOnLevelForLevelElevationIdKeyPatch;
  value: Scalars['BigFloat'];
};

/** Represents an update to a `ElevationLevel`. Fields that are set will be updated. */
export type ElevationLevelPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelElevationIdKeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against many `Level` object types. All fields are combined with a logical ‘and.’ */
export type ElevationLevelToManyLevelFilter = {
  /** Every related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelFilter>;
  /** No related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelFilter>;
  /** Some related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelFilter>;
};

/** A connection to a list of `ElevationLevel` values. */
export type ElevationLevelsConnection = {
  __typename?: 'ElevationLevelsConnection';
  /** A list of edges which contains the `ElevationLevel` and cursor to aid in pagination. */
  edges: Array<ElevationLevelsEdge>;
  /** A list of `ElevationLevel` objects. */
  nodes: Array<ElevationLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ElevationLevel` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ElevationLevel` edge in the connection. */
export type ElevationLevelsEdge = {
  __typename?: 'ElevationLevelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ElevationLevel` at the end of the edge. */
  node: ElevationLevel;
};

/** Methods to use when ordering `ElevationLevel`. */
export enum ElevationLevelsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelsByElevationIdCountAsc = 'LEVELS_BY_ELEVATION_ID__COUNT_ASC',
  LevelsByElevationIdCountDesc = 'LEVELS_BY_ELEVATION_ID__COUNT_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type EmailTaken = {
  __typename?: 'EmailTaken';
  message: Scalars['String'];
};

export type EntraMatch = {
  __typename?: 'EntraMatch';
  email: Scalars['String'];
  id: Scalars['String'];
  provider: SsoProvider;
};

export type EntraUserData = {
  __typename?: 'EntraUserData';
  avatarUrl?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  oid: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  annualSpecifics: Scalars['String'];
  assistant: Scalars['String'];
  businessDomain: Scalars['String'];
  companyGroup: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionInternational?: Maybe<Multilink>;
  competitionInternationalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionNational?: Maybe<Multilink>;
  competitionNationalId?: Maybe<Scalars['UUID']>;
  currentVersion: Scalars['Int'];
  department: Scalars['String'];
  description: Scalars['String'];
  /** Reads and enables pagination through a set of `EventVariant`. */
  eventVariants: EventVariantsConnection;
  executionYear: Scalars['Int'];
  /** Reads a single `Multilink` that is related to this `Event`. */
  externalData?: Maybe<Multilink>;
  externalDataId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraDocuments?: Maybe<Multilink>;
  extraDocumentsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraSystems?: Maybe<Multilink>;
  extraSystemsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  fairAbroadCooperationId?: Maybe<Scalars['UUID']>;
  fairAbroadId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  favoredParallelsExternalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  favoredParallelsInternalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `Event`. */
  icon?: Maybe<File>;
  iconId?: Maybe<Scalars['UUID']>;
  iconUpload: Scalars['String'];
  iconUploadStatus?: Maybe<UploadStatus>;
  id: Scalars['UUID'];
  /** Reads a single `Multilink` that is related to this `Event`. */
  internalData?: Maybe<Multilink>;
  internalDataId?: Maybe<Scalars['UUID']>;
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  otherCompetitionInternationalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionNational?: Maybe<Multilink>;
  otherCompetitionNationalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksExternal?: Maybe<Multilink>;
  otherLinksExternalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksInternal?: Maybe<Multilink>;
  otherLinksInternalId?: Maybe<Scalars['UUID']>;
  responsible: Scalars['String'];
  /** Reads a single `EventSeries` that is related to this `Event`. */
  series?: Maybe<EventSeries>;
  seriesId?: Maybe<Scalars['UUID']>;
  status: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsLocal?: Maybe<Multilink>;
  subeventsLocalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsOtherLocations?: Maybe<Multilink>;
  subeventsOtherLocationsId?: Maybe<Scalars['UUID']>;
  subtitle: Scalars['String'];
  teamChanges: Scalars['String'];
};


export type EventEventVariantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventVariantCondition>;
  filter?: InputMaybe<EventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** The `event` to be created by this mutation. */
export type EventCompetitionInternationalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventCompetitionInternationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventCompetitionInternationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventCompetitionInternationalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventCompetitionInternationalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventCompetitionInternationalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventCompetitionInternationalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventCompetitionInternationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventCompetitionNationalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventCompetitionNationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventCompetitionNationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventCompetitionNationalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventCompetitionNationalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventCompetitionNationalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventCompetitionNationalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventCompetitionNationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A condition to be used against `Event` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EventCondition = {
  /** Checks for equality with the object’s `annualSpecifics` field. */
  annualSpecifics?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `assistant` field. */
  assistant?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `competitionInternationalId` field. */
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competitionNationalId` field. */
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `currentVersion` field. */
  currentVersion?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `department` field. */
  department?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionYear` field. */
  executionYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `externalDataId` field. */
  externalDataId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `extraDocumentsId` field. */
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `extraSystemsId` field. */
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fairAbroadCooperationId` field. */
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fairAbroadId` field. */
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `favoredParallelsExternalId` field. */
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `favoredParallelsInternalId` field. */
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `iconId` field. */
  iconId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `iconUpload` field. */
  iconUpload?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `iconUploadStatus` field. */
  iconUploadStatus?: InputMaybe<UploadStatus>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `internalDataId` field. */
  internalDataId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `otherCompetitionInternationalId` field. */
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherCompetitionNationalId` field. */
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherLinksExternalId` field. */
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherLinksInternalId` field. */
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `responsible` field. */
  responsible?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `seriesId` field. */
  seriesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subeventsLocalId` field. */
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subeventsOtherLocationsId` field. */
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subtitle` field. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `teamChanges` field. */
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** The fields on `event` to look up the row to connect. */
export type EventEventNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `event` to look up the row to delete. */
export type EventEventNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `event` to look up the row to connect. */
export type EventEventPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `event` to look up the row to delete. */
export type EventEventPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `event` to be created by this mutation. */
export type EventExternalDataIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventExternalDataIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventExternalDataIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventExternalDataIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventExternalDataIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventExternalDataIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventExternalDataIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventExternalDataIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventExternalDataIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventExtraDocumentsIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventExtraDocumentsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventExtraDocumentsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventExtraDocumentsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventExtraDocumentsIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventExtraDocumentsIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventExtraDocumentsIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventExtraDocumentsIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventExtraDocumentsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventExtraSystemsIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventExtraSystemsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventExtraSystemsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventExtraSystemsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventExtraSystemsIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventExtraSystemsIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventExtraSystemsIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventExtraSystemsIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventExtraSystemsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventFairAbroadCooperationIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventFairAbroadCooperationIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventFairAbroadCooperationIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventFairAbroadCooperationIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventFairAbroadCooperationIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventFairAbroadCooperationIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventFairAbroadCooperationIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventFairAbroadCooperationIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventFairAbroadCooperationIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventFairAbroadIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventFairAbroadIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventFairAbroadIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventFairAbroadIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventFairAbroadIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventFairAbroadIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventFairAbroadIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventFairAbroadIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventFairAbroadIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventFavoredParallelsExternalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventFavoredParallelsExternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventFavoredParallelsExternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventFavoredParallelsExternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventFavoredParallelsExternalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventFavoredParallelsExternalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventFavoredParallelsExternalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventFavoredParallelsExternalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventFavoredParallelsExternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventFavoredParallelsInternalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventFavoredParallelsInternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventFavoredParallelsInternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventFavoredParallelsInternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventFavoredParallelsInternalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventFavoredParallelsInternalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventFavoredParallelsInternalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventFavoredParallelsInternalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventFavoredParallelsInternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A filter to be used against `Event` object types. All fields are combined with a logical ‘and.’ */
export type EventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `annualSpecifics` field. */
  annualSpecifics?: InputMaybe<StringFilter>;
  /** Filter by the object’s `assistant` field. */
  assistant?: InputMaybe<StringFilter>;
  /** Filter by the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `competitionInternational` relation. */
  competitionInternational?: InputMaybe<MultilinkFilter>;
  /** A related `competitionInternational` exists. */
  competitionInternationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competitionInternationalId` field. */
  competitionInternationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competitionNational` relation. */
  competitionNational?: InputMaybe<MultilinkFilter>;
  /** A related `competitionNational` exists. */
  competitionNationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competitionNationalId` field. */
  competitionNationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `currentVersion` field. */
  currentVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `department` field. */
  department?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventVariants` relation. */
  eventVariants?: InputMaybe<EventToManyEventVariantFilter>;
  /** Some related `eventVariants` exist. */
  eventVariantsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `executionYear` field. */
  executionYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `externalData` relation. */
  externalData?: InputMaybe<MultilinkFilter>;
  /** A related `externalData` exists. */
  externalDataExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalDataId` field. */
  externalDataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `extraDocuments` relation. */
  extraDocuments?: InputMaybe<MultilinkFilter>;
  /** A related `extraDocuments` exists. */
  extraDocumentsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `extraDocumentsId` field. */
  extraDocumentsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `extraSystems` relation. */
  extraSystems?: InputMaybe<MultilinkFilter>;
  /** A related `extraSystems` exists. */
  extraSystemsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `extraSystemsId` field. */
  extraSystemsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fairAbroad` relation. */
  fairAbroad?: InputMaybe<MultilinkFilter>;
  /** Filter by the object’s `fairAbroadCooperation` relation. */
  fairAbroadCooperation?: InputMaybe<MultilinkFilter>;
  /** A related `fairAbroadCooperation` exists. */
  fairAbroadCooperationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fairAbroadCooperationId` field. */
  fairAbroadCooperationId?: InputMaybe<UuidFilter>;
  /** A related `fairAbroad` exists. */
  fairAbroadExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fairAbroadId` field. */
  fairAbroadId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `favoredParallelsExternal` relation. */
  favoredParallelsExternal?: InputMaybe<MultilinkFilter>;
  /** A related `favoredParallelsExternal` exists. */
  favoredParallelsExternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `favoredParallelsExternalId` field. */
  favoredParallelsExternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `favoredParallelsInternal` relation. */
  favoredParallelsInternal?: InputMaybe<MultilinkFilter>;
  /** A related `favoredParallelsInternal` exists. */
  favoredParallelsInternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `favoredParallelsInternalId` field. */
  favoredParallelsInternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `icon` relation. */
  icon?: InputMaybe<FileFilter>;
  /** A related `icon` exists. */
  iconExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `iconId` field. */
  iconId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `iconUpload` field. */
  iconUpload?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iconUploadStatus` field. */
  iconUploadStatus?: InputMaybe<UploadStatusFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `internalData` relation. */
  internalData?: InputMaybe<MultilinkFilter>;
  /** A related `internalData` exists. */
  internalDataExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `internalDataId` field. */
  internalDataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `otherCompetitionInternational` relation. */
  otherCompetitionInternational?: InputMaybe<MultilinkFilter>;
  /** A related `otherCompetitionInternational` exists. */
  otherCompetitionInternationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherCompetitionInternationalId` field. */
  otherCompetitionInternationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherCompetitionNational` relation. */
  otherCompetitionNational?: InputMaybe<MultilinkFilter>;
  /** A related `otherCompetitionNational` exists. */
  otherCompetitionNationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherCompetitionNationalId` field. */
  otherCompetitionNationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherLinksExternal` relation. */
  otherLinksExternal?: InputMaybe<MultilinkFilter>;
  /** A related `otherLinksExternal` exists. */
  otherLinksExternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherLinksExternalId` field. */
  otherLinksExternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherLinksInternal` relation. */
  otherLinksInternal?: InputMaybe<MultilinkFilter>;
  /** A related `otherLinksInternal` exists. */
  otherLinksInternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherLinksInternalId` field. */
  otherLinksInternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `responsible` field. */
  responsible?: InputMaybe<StringFilter>;
  /** Filter by the object’s `series` relation. */
  series?: InputMaybe<EventSeriesFilter>;
  /** A related `series` exists. */
  seriesExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `seriesId` field. */
  seriesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subeventsLocal` relation. */
  subeventsLocal?: InputMaybe<MultilinkFilter>;
  /** A related `subeventsLocal` exists. */
  subeventsLocalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `subeventsLocalId` field. */
  subeventsLocalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subeventsOtherLocations` relation. */
  subeventsOtherLocations?: InputMaybe<MultilinkFilter>;
  /** A related `subeventsOtherLocations` exists. */
  subeventsOtherLocationsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `subeventsOtherLocationsId` field. */
  subeventsOtherLocationsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subtitle` field. */
  subtitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `teamChanges` field. */
  teamChanges?: InputMaybe<StringFilter>;
};

/** The `event` to be created by this mutation. */
export type EventIconIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `file` in the `EventInput` mutation. */
export type EventIconIdFkeyInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnEventForEventIconIdFkeyUsingFilePkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `FileInput` mutation. */
export type EventIconIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventIconIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventIconIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventIconIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** An input for mutations affecting `Event` */
export type EventInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** The `event` to be created by this mutation. */
export type EventInternalDataIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventInternalDataIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventInternalDataIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventInternalDataIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventInternalDataIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventInternalDataIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventInternalDataIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventInternalDataIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventInternalDataIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventCompetitionInternationalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventCompetitionInternationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventCompetitionInternationalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventCompetitionInternationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventCompetitionNationalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventCompetitionNationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventCompetitionNationalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventCompetitionNationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventExternalDataIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventExternalDataIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventExternalDataIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventExternalDataIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventExtraDocumentsIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventExtraDocumentsIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventExtraDocumentsIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventExtraDocumentsIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventExtraSystemsIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventExtraSystemsIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventExtraSystemsIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventExtraSystemsIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFairAbroadCooperationIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFairAbroadCooperationIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFairAbroadCooperationIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFairAbroadCooperationIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFairAbroadIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFairAbroadIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFairAbroadIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFairAbroadIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFavoredParallelsExternalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFavoredParallelsExternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFavoredParallelsExternalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFavoredParallelsExternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFavoredParallelsInternalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFavoredParallelsInternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventFavoredParallelsInternalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventFavoredParallelsInternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventIconIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventIconIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventIconIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventIconIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventInternalDataIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventInternalDataIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventInternalDataIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventInternalDataIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherCompetitionInternationalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherCompetitionInternationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherCompetitionInternationalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherCompetitionInternationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherCompetitionNationalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherCompetitionNationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherCompetitionNationalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherCompetitionNationalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherLinksExternalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherLinksExternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherLinksExternalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherLinksExternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherLinksInternalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherLinksInternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventOtherLinksInternalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventOtherLinksInternalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventSeriesIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventSeriesIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventSeriesIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventSeriesIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventSubeventsLocalIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventSubeventsLocalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventSubeventsLocalIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventSubeventsLocalIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventSubeventsOtherLocationsIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventSubeventsOtherLocationsIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventSubeventsOtherLocationsIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventSubeventsOtherLocationsIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventVariantForEventVariantEventIdFkeyUsingEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventVariantForEventVariantEventIdFkeyPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventVariantForEventVariantEventIdFkeyUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventVariantForEventVariantEventIdFkeyPatch;
};

/** The `event` to be created by this mutation. */
export type EventOtherCompetitionInternationalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventOtherCompetitionInternationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventOtherCompetitionInternationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventOtherCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventOtherCompetitionInternationalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventOtherCompetitionInternationalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventOtherCompetitionInternationalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventOtherCompetitionInternationalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventOtherCompetitionInternationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventOtherCompetitionNationalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventOtherCompetitionNationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventOtherCompetitionNationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventOtherCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventOtherCompetitionNationalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventOtherCompetitionNationalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventOtherCompetitionNationalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventOtherCompetitionNationalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventOtherCompetitionNationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventOtherLinksExternalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventOtherLinksExternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventOtherLinksExternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventOtherLinksExternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventOtherLinksExternalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventOtherLinksExternalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventOtherLinksExternalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventOtherLinksExternalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventOtherLinksExternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventOtherLinksInternalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventOtherLinksInternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventOtherLinksInternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventOtherLinksInternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventOtherLinksInternalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventOtherLinksInternalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventOtherLinksInternalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventOtherLinksInternalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventOtherLinksInternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** Represents an update to a `Event`. Fields that are set will be updated. */
export type EventPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

export type EventSeries = {
  __typename?: 'EventSeries';
  additionalPartners: Scalars['String'];
  allocationRules: Scalars['String'];
  appointmentHistory: Scalars['String'];
  businessDomain: Scalars['String'];
  category: Scalars['String'];
  companyGroup: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionInternational?: Maybe<Multilink>;
  competitionInternationalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionNational?: Maybe<Multilink>;
  competitionNationalId?: Maybe<Scalars['UUID']>;
  cycle: Scalars['String'];
  cycleChanges: Scalars['String'];
  department: Scalars['String'];
  description: Scalars['String'];
  /** Reads and enables pagination through a set of `Event`. */
  eventsBySeriesId: EventsConnection;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  executors?: Maybe<Multilink>;
  executorsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  externalData?: Maybe<Multilink>;
  externalDataId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraDocuments?: Maybe<Multilink>;
  extraDocumentsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraSystems?: Maybe<Multilink>;
  extraSystemsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  fairAbroadCooperationId?: Maybe<Scalars['UUID']>;
  fairAbroadId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  favoredParallelsExternalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  favoredParallelsInternalId?: Maybe<Scalars['UUID']>;
  foundationYear?: Maybe<Scalars['Int']>;
  /** Reads a single `File` that is related to this `EventSeries`. */
  icon?: Maybe<File>;
  iconId?: Maybe<Scalars['UUID']>;
  iconUpload: Scalars['String'];
  iconUploadStatus?: Maybe<UploadStatus>;
  id: Scalars['UUID'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  internalData?: Maybe<Multilink>;
  internalDataId?: Maybe<Scalars['UUID']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isTechnical?: Maybe<Scalars['Boolean']>;
  locationHistory: Scalars['String'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  notes: Scalars['String'];
  notesAppointmentRules: Scalars['String'];
  notesAreas: Scalars['String'];
  notesBoulevardSections: Scalars['String'];
  notesConferenceRooms: Scalars['String'];
  notesConstruction: Scalars['String'];
  notesDayOrder: Scalars['String'];
  notesDayOrderHistory: Scalars['String'];
  notesDismantling: Scalars['String'];
  notesEarlyConstructionExternal: Scalars['String'];
  notesEarlyConstructionInternal: Scalars['String'];
  notesEntrances: Scalars['String'];
  notesExecution: Scalars['String'];
  notesExtendedDismantlingExternal: Scalars['String'];
  notesExtendedDismantlingInternal: Scalars['String'];
  notesHallExhibitionAreas: Scalars['String'];
  notesHolidaysInternational: Scalars['String'];
  notesHolidaysNational: Scalars['String'];
  notesHolidaysNrw: Scalars['String'];
  notesMonths: Scalars['String'];
  notesOfficesExternal: Scalars['String'];
  notesOfficesInternal: Scalars['String'];
  notesParking: Scalars['String'];
  notesPassages: Scalars['String'];
  notesPublicHolidaysInternational: Scalars['String'];
  notesPublicHolidaysNational: Scalars['String'];
  notesPublicHolidaysNrw: Scalars['String'];
  notesServiceCenters: Scalars['String'];
  notesSetup: Scalars['String'];
  notesStorageExternal: Scalars['String'];
  notesStorageInternal: Scalars['String'];
  notesTechnicalDismantling: Scalars['String'];
  numberKapman: Scalars['String'];
  numberShort: Scalars['String'];
  organisationalChanges: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  organizers?: Maybe<Multilink>;
  organizersId?: Maybe<Scalars['UUID']>;
  otherAllocationNeeds: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  otherCompetitionInternationalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionNational?: Maybe<Multilink>;
  otherCompetitionNationalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksExternal?: Maybe<Multilink>;
  otherLinksExternalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksInternal?: Maybe<Multilink>;
  otherLinksInternalId?: Maybe<Scalars['UUID']>;
  otherNotesAppointmentRules: Scalars['String'];
  partnersOverviewLink: Scalars['String'];
  partnersOverviewName: Scalars['String'];
  singleEvent: Scalars['Boolean'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  sponsors?: Maybe<Multilink>;
  sponsorsId?: Maybe<Scalars['UUID']>;
  status: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsLocal?: Maybe<Multilink>;
  subeventsLocalId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsOtherLocations?: Maybe<Multilink>;
  subeventsOtherLocationsId?: Maybe<Scalars['UUID']>;
  subtitle: Scalars['String'];
  type: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  websites: Multilink;
  websitesId: Scalars['UUID'];
};


export type EventSeriesEventsBySeriesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesCompetitionInternationalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesCompetitionInternationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesCompetitionInternationalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesCompetitionInternationalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesCompetitionInternationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesCompetitionNationalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesCompetitionNationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesCompetitionNationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesCompetitionNationalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesCompetitionNationalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesCompetitionNationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/**
 * A condition to be used against `EventSeries` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EventSeriesCondition = {
  /** Checks for equality with the object’s `additionalPartners` field. */
  additionalPartners?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `allocationRules` field. */
  allocationRules?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `appointmentHistory` field. */
  appointmentHistory?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `competitionInternationalId` field. */
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competitionNationalId` field. */
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `cycle` field. */
  cycle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `cycleChanges` field. */
  cycleChanges?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `department` field. */
  department?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `executorsId` field. */
  executorsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `externalDataId` field. */
  externalDataId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `extraDocumentsId` field. */
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `extraSystemsId` field. */
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fairAbroadCooperationId` field. */
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fairAbroadId` field. */
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `favoredParallelsExternalId` field. */
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `favoredParallelsInternalId` field. */
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `foundationYear` field. */
  foundationYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `iconId` field. */
  iconId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `iconUpload` field. */
  iconUpload?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `iconUploadStatus` field. */
  iconUploadStatus?: InputMaybe<UploadStatus>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `internalDataId` field. */
  internalDataId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isPublic` field. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isTechnical` field. */
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `locationHistory` field. */
  locationHistory?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesAppointmentRules` field. */
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesAreas` field. */
  notesAreas?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesBoulevardSections` field. */
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesConferenceRooms` field. */
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesConstruction` field. */
  notesConstruction?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesDayOrder` field. */
  notesDayOrder?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesDayOrderHistory` field. */
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesDismantling` field. */
  notesDismantling?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesEarlyConstructionExternal` field. */
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesEarlyConstructionInternal` field. */
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesEntrances` field. */
  notesEntrances?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesExecution` field. */
  notesExecution?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesExtendedDismantlingExternal` field. */
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesExtendedDismantlingInternal` field. */
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesHallExhibitionAreas` field. */
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesHolidaysInternational` field. */
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesHolidaysNational` field. */
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesHolidaysNrw` field. */
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesMonths` field. */
  notesMonths?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesOfficesExternal` field. */
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesOfficesInternal` field. */
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesParking` field. */
  notesParking?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesPassages` field. */
  notesPassages?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesPublicHolidaysInternational` field. */
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesPublicHolidaysNational` field. */
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesPublicHolidaysNrw` field. */
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesServiceCenters` field. */
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesSetup` field. */
  notesSetup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesStorageExternal` field. */
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesStorageInternal` field. */
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesTechnicalDismantling` field. */
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `numberKapman` field. */
  numberKapman?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `numberShort` field. */
  numberShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organisationalChanges` field. */
  organisationalChanges?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizersId` field. */
  organizersId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherAllocationNeeds` field. */
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `otherCompetitionInternationalId` field. */
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherCompetitionNationalId` field. */
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherLinksExternalId` field. */
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherLinksInternalId` field. */
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherNotesAppointmentRules` field. */
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `partnersOverviewLink` field. */
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `partnersOverviewName` field. */
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `singleEvent` field. */
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `sponsorsId` field. */
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subeventsLocalId` field. */
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subeventsOtherLocationsId` field. */
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subtitle` field. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `websitesId` field. */
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `EventSeries` values. */
export type EventSeriesConnection = {
  __typename?: 'EventSeriesConnection';
  /** A list of edges which contains the `EventSeries` and cursor to aid in pagination. */
  edges: Array<EventSeriesEdge>;
  /** A list of `EventSeries` objects. */
  nodes: Array<EventSeries>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EventSeries` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EventSeries` edge in the connection. */
export type EventSeriesEdge = {
  __typename?: 'EventSeriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EventSeries` at the end of the edge. */
  node: EventSeries;
};

/** The fields on `eventSeries` to look up the row to connect. */
export type EventSeriesEventSeriesNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `eventSeries` to look up the row to delete. */
export type EventSeriesEventSeriesNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `eventSeries` to look up the row to connect. */
export type EventSeriesEventSeriesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `eventSeries` to look up the row to delete. */
export type EventSeriesEventSeriesPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesExecutorsIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesExecutorsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesExecutorsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesExecutorsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesExecutorsIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesExecutorsIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesExecutorsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesExternalDataIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesExternalDataIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesExternalDataIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesExternalDataIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesExternalDataIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesExternalDataIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesExternalDataIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesExtraDocumentsIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesExtraDocumentsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesExtraDocumentsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesExtraDocumentsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesExtraDocumentsIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesExtraDocumentsIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesExtraDocumentsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesExtraSystemsIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesExtraSystemsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesExtraSystemsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesExtraSystemsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesExtraSystemsIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesExtraSystemsIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesExtraSystemsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesFairAbroadCooperationIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesFairAbroadCooperationIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesFairAbroadCooperationIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesFairAbroadCooperationIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesFairAbroadCooperationIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesFairAbroadIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesFairAbroadIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesFairAbroadIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesFairAbroadIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesFairAbroadIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesFairAbroadIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesFairAbroadIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesFavoredParallelsExternalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesFavoredParallelsExternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesFavoredParallelsExternalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesFavoredParallelsExternalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesFavoredParallelsExternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesFavoredParallelsInternalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesFavoredParallelsInternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesFavoredParallelsInternalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesFavoredParallelsInternalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesFavoredParallelsInternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A filter to be used against `EventSeries` object types. All fields are combined with a logical ‘and.’ */
export type EventSeriesFilter = {
  /** Filter by the object’s `additionalPartners` field. */
  additionalPartners?: InputMaybe<StringFilter>;
  /** Filter by the object’s `allocationRules` field. */
  allocationRules?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventSeriesFilter>>;
  /** Filter by the object’s `appointmentHistory` field. */
  appointmentHistory?: InputMaybe<StringFilter>;
  /** Filter by the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `competitionInternational` relation. */
  competitionInternational?: InputMaybe<MultilinkFilter>;
  /** A related `competitionInternational` exists. */
  competitionInternationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competitionInternationalId` field. */
  competitionInternationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competitionNational` relation. */
  competitionNational?: InputMaybe<MultilinkFilter>;
  /** A related `competitionNational` exists. */
  competitionNationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competitionNationalId` field. */
  competitionNationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `cycle` field. */
  cycle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cycleChanges` field. */
  cycleChanges?: InputMaybe<StringFilter>;
  /** Filter by the object’s `department` field. */
  department?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventsBySeriesId` relation. */
  eventsBySeriesId?: InputMaybe<EventSeriesToManyEventFilter>;
  /** Some related `eventsBySeriesId` exist. */
  eventsBySeriesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `executors` relation. */
  executors?: InputMaybe<MultilinkFilter>;
  /** A related `executors` exists. */
  executorsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `executorsId` field. */
  executorsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `externalData` relation. */
  externalData?: InputMaybe<MultilinkFilter>;
  /** A related `externalData` exists. */
  externalDataExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalDataId` field. */
  externalDataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `extraDocuments` relation. */
  extraDocuments?: InputMaybe<MultilinkFilter>;
  /** A related `extraDocuments` exists. */
  extraDocumentsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `extraDocumentsId` field. */
  extraDocumentsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `extraSystems` relation. */
  extraSystems?: InputMaybe<MultilinkFilter>;
  /** A related `extraSystems` exists. */
  extraSystemsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `extraSystemsId` field. */
  extraSystemsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fairAbroad` relation. */
  fairAbroad?: InputMaybe<MultilinkFilter>;
  /** Filter by the object’s `fairAbroadCooperation` relation. */
  fairAbroadCooperation?: InputMaybe<MultilinkFilter>;
  /** A related `fairAbroadCooperation` exists. */
  fairAbroadCooperationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fairAbroadCooperationId` field. */
  fairAbroadCooperationId?: InputMaybe<UuidFilter>;
  /** A related `fairAbroad` exists. */
  fairAbroadExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fairAbroadId` field. */
  fairAbroadId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `favoredParallelsExternal` relation. */
  favoredParallelsExternal?: InputMaybe<MultilinkFilter>;
  /** A related `favoredParallelsExternal` exists. */
  favoredParallelsExternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `favoredParallelsExternalId` field. */
  favoredParallelsExternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `favoredParallelsInternal` relation. */
  favoredParallelsInternal?: InputMaybe<MultilinkFilter>;
  /** A related `favoredParallelsInternal` exists. */
  favoredParallelsInternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `favoredParallelsInternalId` field. */
  favoredParallelsInternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `foundationYear` field. */
  foundationYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `icon` relation. */
  icon?: InputMaybe<FileFilter>;
  /** A related `icon` exists. */
  iconExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `iconId` field. */
  iconId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `iconUpload` field. */
  iconUpload?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iconUploadStatus` field. */
  iconUploadStatus?: InputMaybe<UploadStatusFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `internalData` relation. */
  internalData?: InputMaybe<MultilinkFilter>;
  /** A related `internalData` exists. */
  internalDataExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `internalDataId` field. */
  internalDataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isPublic` field. */
  isPublic?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isTechnical` field. */
  isTechnical?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locationHistory` field. */
  locationHistory?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventSeriesFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesAppointmentRules` field. */
  notesAppointmentRules?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesAreas` field. */
  notesAreas?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesBoulevardSections` field. */
  notesBoulevardSections?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesConferenceRooms` field. */
  notesConferenceRooms?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesConstruction` field. */
  notesConstruction?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesDayOrder` field. */
  notesDayOrder?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesDayOrderHistory` field. */
  notesDayOrderHistory?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesDismantling` field. */
  notesDismantling?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesEarlyConstructionExternal` field. */
  notesEarlyConstructionExternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesEarlyConstructionInternal` field. */
  notesEarlyConstructionInternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesEntrances` field. */
  notesEntrances?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesExecution` field. */
  notesExecution?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesExtendedDismantlingExternal` field. */
  notesExtendedDismantlingExternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesExtendedDismantlingInternal` field. */
  notesExtendedDismantlingInternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesHallExhibitionAreas` field. */
  notesHallExhibitionAreas?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesHolidaysInternational` field. */
  notesHolidaysInternational?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesHolidaysNational` field. */
  notesHolidaysNational?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesHolidaysNrw` field. */
  notesHolidaysNrw?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesMonths` field. */
  notesMonths?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesOfficesExternal` field. */
  notesOfficesExternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesOfficesInternal` field. */
  notesOfficesInternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesParking` field. */
  notesParking?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesPassages` field. */
  notesPassages?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesPublicHolidaysInternational` field. */
  notesPublicHolidaysInternational?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesPublicHolidaysNational` field. */
  notesPublicHolidaysNational?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesPublicHolidaysNrw` field. */
  notesPublicHolidaysNrw?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesServiceCenters` field. */
  notesServiceCenters?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesSetup` field. */
  notesSetup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesStorageExternal` field. */
  notesStorageExternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesStorageInternal` field. */
  notesStorageInternal?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesTechnicalDismantling` field. */
  notesTechnicalDismantling?: InputMaybe<StringFilter>;
  /** Filter by the object’s `numberKapman` field. */
  numberKapman?: InputMaybe<StringFilter>;
  /** Filter by the object’s `numberShort` field. */
  numberShort?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventSeriesFilter>>;
  /** Filter by the object’s `organisationalChanges` field. */
  organisationalChanges?: InputMaybe<StringFilter>;
  /** Filter by the object’s `organizers` relation. */
  organizers?: InputMaybe<MultilinkFilter>;
  /** A related `organizers` exists. */
  organizersExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `organizersId` field. */
  organizersId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherAllocationNeeds` field. */
  otherAllocationNeeds?: InputMaybe<StringFilter>;
  /** Filter by the object’s `otherCompetitionInternational` relation. */
  otherCompetitionInternational?: InputMaybe<MultilinkFilter>;
  /** A related `otherCompetitionInternational` exists. */
  otherCompetitionInternationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherCompetitionInternationalId` field. */
  otherCompetitionInternationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherCompetitionNational` relation. */
  otherCompetitionNational?: InputMaybe<MultilinkFilter>;
  /** A related `otherCompetitionNational` exists. */
  otherCompetitionNationalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherCompetitionNationalId` field. */
  otherCompetitionNationalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherLinksExternal` relation. */
  otherLinksExternal?: InputMaybe<MultilinkFilter>;
  /** A related `otherLinksExternal` exists. */
  otherLinksExternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherLinksExternalId` field. */
  otherLinksExternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherLinksInternal` relation. */
  otherLinksInternal?: InputMaybe<MultilinkFilter>;
  /** A related `otherLinksInternal` exists. */
  otherLinksInternalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherLinksInternalId` field. */
  otherLinksInternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherNotesAppointmentRules` field. */
  otherNotesAppointmentRules?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partnersOverviewLink` field. */
  partnersOverviewLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partnersOverviewName` field. */
  partnersOverviewName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `singleEvent` field. */
  singleEvent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sponsors` relation. */
  sponsors?: InputMaybe<MultilinkFilter>;
  /** A related `sponsors` exists. */
  sponsorsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `sponsorsId` field. */
  sponsorsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subeventsLocal` relation. */
  subeventsLocal?: InputMaybe<MultilinkFilter>;
  /** A related `subeventsLocal` exists. */
  subeventsLocalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `subeventsLocalId` field. */
  subeventsLocalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subeventsOtherLocations` relation. */
  subeventsOtherLocations?: InputMaybe<MultilinkFilter>;
  /** A related `subeventsOtherLocations` exists. */
  subeventsOtherLocationsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `subeventsOtherLocationsId` field. */
  subeventsOtherLocationsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subtitle` field. */
  subtitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `websites` relation. */
  websites?: InputMaybe<MultilinkFilter>;
  /** Filter by the object’s `websitesId` field. */
  websitesId?: InputMaybe<UuidFilter>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesIconIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `file` in the `EventSeriesInput` mutation. */
export type EventSeriesIconIdFkeyInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnEventSeriesForEventSeriesIconIdFkeyUsingFilePkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `FileInput` mutation. */
export type EventSeriesIconIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesIconIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesIconIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesIconIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `event` to be created by this mutation. */
export type EventSeriesIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `eventSeries` in the `EventInput` mutation. */
export type EventSeriesIdFkeyInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<EventSeriesEventSeriesPkeyConnect>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<EventSeriesEventSeriesNameShortKeyConnect>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesIdFkeyEventSeriesCreateInput>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<EventSeriesEventSeriesPkeyDelete>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<EventSeriesEventSeriesNameShortKeyDelete>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<EventSeriesOnEventForEventSeriesIdFkeyUsingEventSeriesPkeyUpdate>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<EventSeriesOnEventForEventSeriesIdFkeyUsingEventSeriesNameShortKeyUpdate>;
};

/** Input for the nested mutation of `event` in the `EventSeriesInput` mutation. */
export type EventSeriesIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventSeriesIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventSeriesIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** An input for mutations affecting `EventSeries` */
export type EventSeriesInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesInternalDataIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesInternalDataIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesInternalDataIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesInternalDataIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesInternalDataIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesInternalDataIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesInternalDataIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventForEventSeriesIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventForEventSeriesIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventForEventSeriesIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventForEventSeriesIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesIconIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesIconIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesIconIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesIconIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkUsingEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkPatch;
};

/** The fields on `eventSeries` to look up the row to update. */
export type EventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkUsingEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventSeries` being updated. */
  patch: UpdateEventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkPatch;
};

/** Methods to use when ordering `EventSeries`. */
export enum EventSeriesOrderBy {
  AdditionalPartnersAsc = 'ADDITIONAL_PARTNERS_ASC',
  AdditionalPartnersDesc = 'ADDITIONAL_PARTNERS_DESC',
  AllocationRulesAsc = 'ALLOCATION_RULES_ASC',
  AllocationRulesDesc = 'ALLOCATION_RULES_DESC',
  AppointmentHistoryAsc = 'APPOINTMENT_HISTORY_ASC',
  AppointmentHistoryDesc = 'APPOINTMENT_HISTORY_DESC',
  BusinessDomainAsc = 'BUSINESS_DOMAIN_ASC',
  BusinessDomainDesc = 'BUSINESS_DOMAIN_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CompanyGroupAsc = 'COMPANY_GROUP_ASC',
  CompanyGroupDesc = 'COMPANY_GROUP_DESC',
  CompetitionInternationalIdAsc = 'COMPETITION_INTERNATIONAL_ID_ASC',
  CompetitionInternationalIdDesc = 'COMPETITION_INTERNATIONAL_ID_DESC',
  CompetitionNationalIdAsc = 'COMPETITION_NATIONAL_ID_ASC',
  CompetitionNationalIdDesc = 'COMPETITION_NATIONAL_ID_DESC',
  CycleAsc = 'CYCLE_ASC',
  CycleChangesAsc = 'CYCLE_CHANGES_ASC',
  CycleChangesDesc = 'CYCLE_CHANGES_DESC',
  CycleDesc = 'CYCLE_DESC',
  DepartmentAsc = 'DEPARTMENT_ASC',
  DepartmentDesc = 'DEPARTMENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EventsBySeriesIdCountAsc = 'EVENTS_BY_SERIES_ID__COUNT_ASC',
  EventsBySeriesIdCountDesc = 'EVENTS_BY_SERIES_ID__COUNT_DESC',
  ExecutorsIdAsc = 'EXECUTORS_ID_ASC',
  ExecutorsIdDesc = 'EXECUTORS_ID_DESC',
  ExternalDataIdAsc = 'EXTERNAL_DATA_ID_ASC',
  ExternalDataIdDesc = 'EXTERNAL_DATA_ID_DESC',
  ExtraDocumentsIdAsc = 'EXTRA_DOCUMENTS_ID_ASC',
  ExtraDocumentsIdDesc = 'EXTRA_DOCUMENTS_ID_DESC',
  ExtraSystemsIdAsc = 'EXTRA_SYSTEMS_ID_ASC',
  ExtraSystemsIdDesc = 'EXTRA_SYSTEMS_ID_DESC',
  FairAbroadCooperationIdAsc = 'FAIR_ABROAD_COOPERATION_ID_ASC',
  FairAbroadCooperationIdDesc = 'FAIR_ABROAD_COOPERATION_ID_DESC',
  FairAbroadIdAsc = 'FAIR_ABROAD_ID_ASC',
  FairAbroadIdDesc = 'FAIR_ABROAD_ID_DESC',
  FavoredParallelsExternalIdAsc = 'FAVORED_PARALLELS_EXTERNAL_ID_ASC',
  FavoredParallelsExternalIdDesc = 'FAVORED_PARALLELS_EXTERNAL_ID_DESC',
  FavoredParallelsInternalIdAsc = 'FAVORED_PARALLELS_INTERNAL_ID_ASC',
  FavoredParallelsInternalIdDesc = 'FAVORED_PARALLELS_INTERNAL_ID_DESC',
  FileByIconIdIdAsc = 'FILE_BY_ICON_ID__ID_ASC',
  FileByIconIdIdDesc = 'FILE_BY_ICON_ID__ID_DESC',
  FileByIconIdMimeTypeAsc = 'FILE_BY_ICON_ID__MIME_TYPE_ASC',
  FileByIconIdMimeTypeDesc = 'FILE_BY_ICON_ID__MIME_TYPE_DESC',
  FileByIconIdSizeAsc = 'FILE_BY_ICON_ID__SIZE_ASC',
  FileByIconIdSizeDesc = 'FILE_BY_ICON_ID__SIZE_DESC',
  FileByIconIdUrl128Asc = 'FILE_BY_ICON_ID__URL128_ASC',
  FileByIconIdUrl128Desc = 'FILE_BY_ICON_ID__URL128_DESC',
  FileByIconIdUrl512Asc = 'FILE_BY_ICON_ID__URL512_ASC',
  FileByIconIdUrl512Desc = 'FILE_BY_ICON_ID__URL512_DESC',
  FileByIconIdUrlAsc = 'FILE_BY_ICON_ID__URL_ASC',
  FileByIconIdUrlDesc = 'FILE_BY_ICON_ID__URL_DESC',
  FoundationYearAsc = 'FOUNDATION_YEAR_ASC',
  FoundationYearDesc = 'FOUNDATION_YEAR_DESC',
  IconIdAsc = 'ICON_ID_ASC',
  IconIdDesc = 'ICON_ID_DESC',
  IconUploadAsc = 'ICON_UPLOAD_ASC',
  IconUploadDesc = 'ICON_UPLOAD_DESC',
  IconUploadStatusAsc = 'ICON_UPLOAD_STATUS_ASC',
  IconUploadStatusDesc = 'ICON_UPLOAD_STATUS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InternalDataIdAsc = 'INTERNAL_DATA_ID_ASC',
  InternalDataIdDesc = 'INTERNAL_DATA_ID_DESC',
  IsPublicAsc = 'IS_PUBLIC_ASC',
  IsPublicDesc = 'IS_PUBLIC_DESC',
  IsTechnicalAsc = 'IS_TECHNICAL_ASC',
  IsTechnicalDesc = 'IS_TECHNICAL_DESC',
  LocationHistoryAsc = 'LOCATION_HISTORY_ASC',
  LocationHistoryDesc = 'LOCATION_HISTORY_DESC',
  MultilinkByCompetitionInternationalIdIdAsc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__ID_ASC',
  MultilinkByCompetitionInternationalIdIdDesc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__ID_DESC',
  MultilinkByCompetitionInternationalIdNameAsc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__NAME_ASC',
  MultilinkByCompetitionInternationalIdNameDesc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__NAME_DESC',
  MultilinkByCompetitionNationalIdIdAsc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__ID_ASC',
  MultilinkByCompetitionNationalIdIdDesc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__ID_DESC',
  MultilinkByCompetitionNationalIdNameAsc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__NAME_ASC',
  MultilinkByCompetitionNationalIdNameDesc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__NAME_DESC',
  MultilinkByExecutorsIdIdAsc = 'MULTILINK_BY_EXECUTORS_ID__ID_ASC',
  MultilinkByExecutorsIdIdDesc = 'MULTILINK_BY_EXECUTORS_ID__ID_DESC',
  MultilinkByExecutorsIdNameAsc = 'MULTILINK_BY_EXECUTORS_ID__NAME_ASC',
  MultilinkByExecutorsIdNameDesc = 'MULTILINK_BY_EXECUTORS_ID__NAME_DESC',
  MultilinkByExternalDataIdIdAsc = 'MULTILINK_BY_EXTERNAL_DATA_ID__ID_ASC',
  MultilinkByExternalDataIdIdDesc = 'MULTILINK_BY_EXTERNAL_DATA_ID__ID_DESC',
  MultilinkByExternalDataIdNameAsc = 'MULTILINK_BY_EXTERNAL_DATA_ID__NAME_ASC',
  MultilinkByExternalDataIdNameDesc = 'MULTILINK_BY_EXTERNAL_DATA_ID__NAME_DESC',
  MultilinkByExtraDocumentsIdIdAsc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__ID_ASC',
  MultilinkByExtraDocumentsIdIdDesc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__ID_DESC',
  MultilinkByExtraDocumentsIdNameAsc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__NAME_ASC',
  MultilinkByExtraDocumentsIdNameDesc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__NAME_DESC',
  MultilinkByExtraSystemsIdIdAsc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__ID_ASC',
  MultilinkByExtraSystemsIdIdDesc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__ID_DESC',
  MultilinkByExtraSystemsIdNameAsc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__NAME_ASC',
  MultilinkByExtraSystemsIdNameDesc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__NAME_DESC',
  MultilinkByFairAbroadCooperationIdIdAsc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__ID_ASC',
  MultilinkByFairAbroadCooperationIdIdDesc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__ID_DESC',
  MultilinkByFairAbroadCooperationIdNameAsc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__NAME_ASC',
  MultilinkByFairAbroadCooperationIdNameDesc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__NAME_DESC',
  MultilinkByFairAbroadIdIdAsc = 'MULTILINK_BY_FAIR_ABROAD_ID__ID_ASC',
  MultilinkByFairAbroadIdIdDesc = 'MULTILINK_BY_FAIR_ABROAD_ID__ID_DESC',
  MultilinkByFairAbroadIdNameAsc = 'MULTILINK_BY_FAIR_ABROAD_ID__NAME_ASC',
  MultilinkByFairAbroadIdNameDesc = 'MULTILINK_BY_FAIR_ABROAD_ID__NAME_DESC',
  MultilinkByFavoredParallelsExternalIdIdAsc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__ID_ASC',
  MultilinkByFavoredParallelsExternalIdIdDesc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__ID_DESC',
  MultilinkByFavoredParallelsExternalIdNameAsc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__NAME_ASC',
  MultilinkByFavoredParallelsExternalIdNameDesc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__NAME_DESC',
  MultilinkByFavoredParallelsInternalIdIdAsc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__ID_ASC',
  MultilinkByFavoredParallelsInternalIdIdDesc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__ID_DESC',
  MultilinkByFavoredParallelsInternalIdNameAsc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__NAME_ASC',
  MultilinkByFavoredParallelsInternalIdNameDesc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__NAME_DESC',
  MultilinkByInternalDataIdIdAsc = 'MULTILINK_BY_INTERNAL_DATA_ID__ID_ASC',
  MultilinkByInternalDataIdIdDesc = 'MULTILINK_BY_INTERNAL_DATA_ID__ID_DESC',
  MultilinkByInternalDataIdNameAsc = 'MULTILINK_BY_INTERNAL_DATA_ID__NAME_ASC',
  MultilinkByInternalDataIdNameDesc = 'MULTILINK_BY_INTERNAL_DATA_ID__NAME_DESC',
  MultilinkByOrganizersIdIdAsc = 'MULTILINK_BY_ORGANIZERS_ID__ID_ASC',
  MultilinkByOrganizersIdIdDesc = 'MULTILINK_BY_ORGANIZERS_ID__ID_DESC',
  MultilinkByOrganizersIdNameAsc = 'MULTILINK_BY_ORGANIZERS_ID__NAME_ASC',
  MultilinkByOrganizersIdNameDesc = 'MULTILINK_BY_ORGANIZERS_ID__NAME_DESC',
  MultilinkByOtherCompetitionInternationalIdIdAsc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__ID_ASC',
  MultilinkByOtherCompetitionInternationalIdIdDesc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__ID_DESC',
  MultilinkByOtherCompetitionInternationalIdNameAsc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__NAME_ASC',
  MultilinkByOtherCompetitionInternationalIdNameDesc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__NAME_DESC',
  MultilinkByOtherCompetitionNationalIdIdAsc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__ID_ASC',
  MultilinkByOtherCompetitionNationalIdIdDesc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__ID_DESC',
  MultilinkByOtherCompetitionNationalIdNameAsc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__NAME_ASC',
  MultilinkByOtherCompetitionNationalIdNameDesc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__NAME_DESC',
  MultilinkByOtherLinksExternalIdIdAsc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__ID_ASC',
  MultilinkByOtherLinksExternalIdIdDesc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__ID_DESC',
  MultilinkByOtherLinksExternalIdNameAsc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__NAME_ASC',
  MultilinkByOtherLinksExternalIdNameDesc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__NAME_DESC',
  MultilinkByOtherLinksInternalIdIdAsc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__ID_ASC',
  MultilinkByOtherLinksInternalIdIdDesc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__ID_DESC',
  MultilinkByOtherLinksInternalIdNameAsc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__NAME_ASC',
  MultilinkByOtherLinksInternalIdNameDesc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__NAME_DESC',
  MultilinkBySponsorsIdIdAsc = 'MULTILINK_BY_SPONSORS_ID__ID_ASC',
  MultilinkBySponsorsIdIdDesc = 'MULTILINK_BY_SPONSORS_ID__ID_DESC',
  MultilinkBySponsorsIdNameAsc = 'MULTILINK_BY_SPONSORS_ID__NAME_ASC',
  MultilinkBySponsorsIdNameDesc = 'MULTILINK_BY_SPONSORS_ID__NAME_DESC',
  MultilinkBySubeventsLocalIdIdAsc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__ID_ASC',
  MultilinkBySubeventsLocalIdIdDesc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__ID_DESC',
  MultilinkBySubeventsLocalIdNameAsc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__NAME_ASC',
  MultilinkBySubeventsLocalIdNameDesc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__NAME_DESC',
  MultilinkBySubeventsOtherLocationsIdIdAsc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__ID_ASC',
  MultilinkBySubeventsOtherLocationsIdIdDesc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__ID_DESC',
  MultilinkBySubeventsOtherLocationsIdNameAsc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__NAME_ASC',
  MultilinkBySubeventsOtherLocationsIdNameDesc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__NAME_DESC',
  MultilinkByWebsitesIdIdAsc = 'MULTILINK_BY_WEBSITES_ID__ID_ASC',
  MultilinkByWebsitesIdIdDesc = 'MULTILINK_BY_WEBSITES_ID__ID_DESC',
  MultilinkByWebsitesIdNameAsc = 'MULTILINK_BY_WEBSITES_ID__NAME_ASC',
  MultilinkByWebsitesIdNameDesc = 'MULTILINK_BY_WEBSITES_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  NotesAppointmentRulesAsc = 'NOTES_APPOINTMENT_RULES_ASC',
  NotesAppointmentRulesDesc = 'NOTES_APPOINTMENT_RULES_DESC',
  NotesAreasAsc = 'NOTES_AREAS_ASC',
  NotesAreasDesc = 'NOTES_AREAS_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesBoulevardSectionsAsc = 'NOTES_BOULEVARD_SECTIONS_ASC',
  NotesBoulevardSectionsDesc = 'NOTES_BOULEVARD_SECTIONS_DESC',
  NotesConferenceRoomsAsc = 'NOTES_CONFERENCE_ROOMS_ASC',
  NotesConferenceRoomsDesc = 'NOTES_CONFERENCE_ROOMS_DESC',
  NotesConstructionAsc = 'NOTES_CONSTRUCTION_ASC',
  NotesConstructionDesc = 'NOTES_CONSTRUCTION_DESC',
  NotesDayOrderAsc = 'NOTES_DAY_ORDER_ASC',
  NotesDayOrderDesc = 'NOTES_DAY_ORDER_DESC',
  NotesDayOrderHistoryAsc = 'NOTES_DAY_ORDER_HISTORY_ASC',
  NotesDayOrderHistoryDesc = 'NOTES_DAY_ORDER_HISTORY_DESC',
  NotesDesc = 'NOTES_DESC',
  NotesDismantlingAsc = 'NOTES_DISMANTLING_ASC',
  NotesDismantlingDesc = 'NOTES_DISMANTLING_DESC',
  NotesEarlyConstructionExternalAsc = 'NOTES_EARLY_CONSTRUCTION_EXTERNAL_ASC',
  NotesEarlyConstructionExternalDesc = 'NOTES_EARLY_CONSTRUCTION_EXTERNAL_DESC',
  NotesEarlyConstructionInternalAsc = 'NOTES_EARLY_CONSTRUCTION_INTERNAL_ASC',
  NotesEarlyConstructionInternalDesc = 'NOTES_EARLY_CONSTRUCTION_INTERNAL_DESC',
  NotesEntrancesAsc = 'NOTES_ENTRANCES_ASC',
  NotesEntrancesDesc = 'NOTES_ENTRANCES_DESC',
  NotesExecutionAsc = 'NOTES_EXECUTION_ASC',
  NotesExecutionDesc = 'NOTES_EXECUTION_DESC',
  NotesExtendedDismantlingExternalAsc = 'NOTES_EXTENDED_DISMANTLING_EXTERNAL_ASC',
  NotesExtendedDismantlingExternalDesc = 'NOTES_EXTENDED_DISMANTLING_EXTERNAL_DESC',
  NotesExtendedDismantlingInternalAsc = 'NOTES_EXTENDED_DISMANTLING_INTERNAL_ASC',
  NotesExtendedDismantlingInternalDesc = 'NOTES_EXTENDED_DISMANTLING_INTERNAL_DESC',
  NotesHallExhibitionAreasAsc = 'NOTES_HALL_EXHIBITION_AREAS_ASC',
  NotesHallExhibitionAreasDesc = 'NOTES_HALL_EXHIBITION_AREAS_DESC',
  NotesHolidaysInternationalAsc = 'NOTES_HOLIDAYS_INTERNATIONAL_ASC',
  NotesHolidaysInternationalDesc = 'NOTES_HOLIDAYS_INTERNATIONAL_DESC',
  NotesHolidaysNationalAsc = 'NOTES_HOLIDAYS_NATIONAL_ASC',
  NotesHolidaysNationalDesc = 'NOTES_HOLIDAYS_NATIONAL_DESC',
  NotesHolidaysNrwAsc = 'NOTES_HOLIDAYS_NRW_ASC',
  NotesHolidaysNrwDesc = 'NOTES_HOLIDAYS_NRW_DESC',
  NotesMonthsAsc = 'NOTES_MONTHS_ASC',
  NotesMonthsDesc = 'NOTES_MONTHS_DESC',
  NotesOfficesExternalAsc = 'NOTES_OFFICES_EXTERNAL_ASC',
  NotesOfficesExternalDesc = 'NOTES_OFFICES_EXTERNAL_DESC',
  NotesOfficesInternalAsc = 'NOTES_OFFICES_INTERNAL_ASC',
  NotesOfficesInternalDesc = 'NOTES_OFFICES_INTERNAL_DESC',
  NotesParkingAsc = 'NOTES_PARKING_ASC',
  NotesParkingDesc = 'NOTES_PARKING_DESC',
  NotesPassagesAsc = 'NOTES_PASSAGES_ASC',
  NotesPassagesDesc = 'NOTES_PASSAGES_DESC',
  NotesPublicHolidaysInternationalAsc = 'NOTES_PUBLIC_HOLIDAYS_INTERNATIONAL_ASC',
  NotesPublicHolidaysInternationalDesc = 'NOTES_PUBLIC_HOLIDAYS_INTERNATIONAL_DESC',
  NotesPublicHolidaysNationalAsc = 'NOTES_PUBLIC_HOLIDAYS_NATIONAL_ASC',
  NotesPublicHolidaysNationalDesc = 'NOTES_PUBLIC_HOLIDAYS_NATIONAL_DESC',
  NotesPublicHolidaysNrwAsc = 'NOTES_PUBLIC_HOLIDAYS_NRW_ASC',
  NotesPublicHolidaysNrwDesc = 'NOTES_PUBLIC_HOLIDAYS_NRW_DESC',
  NotesServiceCentersAsc = 'NOTES_SERVICE_CENTERS_ASC',
  NotesServiceCentersDesc = 'NOTES_SERVICE_CENTERS_DESC',
  NotesSetupAsc = 'NOTES_SETUP_ASC',
  NotesSetupDesc = 'NOTES_SETUP_DESC',
  NotesStorageExternalAsc = 'NOTES_STORAGE_EXTERNAL_ASC',
  NotesStorageExternalDesc = 'NOTES_STORAGE_EXTERNAL_DESC',
  NotesStorageInternalAsc = 'NOTES_STORAGE_INTERNAL_ASC',
  NotesStorageInternalDesc = 'NOTES_STORAGE_INTERNAL_DESC',
  NotesTechnicalDismantlingAsc = 'NOTES_TECHNICAL_DISMANTLING_ASC',
  NotesTechnicalDismantlingDesc = 'NOTES_TECHNICAL_DISMANTLING_DESC',
  NumberKapmanAsc = 'NUMBER_KAPMAN_ASC',
  NumberKapmanDesc = 'NUMBER_KAPMAN_DESC',
  NumberShortAsc = 'NUMBER_SHORT_ASC',
  NumberShortDesc = 'NUMBER_SHORT_DESC',
  OrganisationalChangesAsc = 'ORGANISATIONAL_CHANGES_ASC',
  OrganisationalChangesDesc = 'ORGANISATIONAL_CHANGES_DESC',
  OrganizersIdAsc = 'ORGANIZERS_ID_ASC',
  OrganizersIdDesc = 'ORGANIZERS_ID_DESC',
  OtherAllocationNeedsAsc = 'OTHER_ALLOCATION_NEEDS_ASC',
  OtherAllocationNeedsDesc = 'OTHER_ALLOCATION_NEEDS_DESC',
  OtherCompetitionInternationalIdAsc = 'OTHER_COMPETITION_INTERNATIONAL_ID_ASC',
  OtherCompetitionInternationalIdDesc = 'OTHER_COMPETITION_INTERNATIONAL_ID_DESC',
  OtherCompetitionNationalIdAsc = 'OTHER_COMPETITION_NATIONAL_ID_ASC',
  OtherCompetitionNationalIdDesc = 'OTHER_COMPETITION_NATIONAL_ID_DESC',
  OtherLinksExternalIdAsc = 'OTHER_LINKS_EXTERNAL_ID_ASC',
  OtherLinksExternalIdDesc = 'OTHER_LINKS_EXTERNAL_ID_DESC',
  OtherLinksInternalIdAsc = 'OTHER_LINKS_INTERNAL_ID_ASC',
  OtherLinksInternalIdDesc = 'OTHER_LINKS_INTERNAL_ID_DESC',
  OtherNotesAppointmentRulesAsc = 'OTHER_NOTES_APPOINTMENT_RULES_ASC',
  OtherNotesAppointmentRulesDesc = 'OTHER_NOTES_APPOINTMENT_RULES_DESC',
  PartnersOverviewLinkAsc = 'PARTNERS_OVERVIEW_LINK_ASC',
  PartnersOverviewLinkDesc = 'PARTNERS_OVERVIEW_LINK_DESC',
  PartnersOverviewNameAsc = 'PARTNERS_OVERVIEW_NAME_ASC',
  PartnersOverviewNameDesc = 'PARTNERS_OVERVIEW_NAME_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SingleEventAsc = 'SINGLE_EVENT_ASC',
  SingleEventDesc = 'SINGLE_EVENT_DESC',
  SponsorsIdAsc = 'SPONSORS_ID_ASC',
  SponsorsIdDesc = 'SPONSORS_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubeventsLocalIdAsc = 'SUBEVENTS_LOCAL_ID_ASC',
  SubeventsLocalIdDesc = 'SUBEVENTS_LOCAL_ID_DESC',
  SubeventsOtherLocationsIdAsc = 'SUBEVENTS_OTHER_LOCATIONS_ID_ASC',
  SubeventsOtherLocationsIdDesc = 'SUBEVENTS_OTHER_LOCATIONS_ID_DESC',
  SubtitleAsc = 'SUBTITLE_ASC',
  SubtitleDesc = 'SUBTITLE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  WebsitesIdAsc = 'WEBSITES_ID_ASC',
  WebsitesIdDesc = 'WEBSITES_ID_DESC'
}

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesOrganizersIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesOrganizersIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesOrganizersIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesOrganizersIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesOrganizersIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesOrganizersIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesOrganizersIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesOtherCompetitionInternationalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesOtherCompetitionInternationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesOtherCompetitionInternationalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesOtherCompetitionInternationalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesOtherCompetitionInternationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesOtherCompetitionNationalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesOtherCompetitionNationalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesOtherCompetitionNationalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesOtherCompetitionNationalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesOtherCompetitionNationalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesOtherLinksExternalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesOtherLinksExternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesOtherLinksExternalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesOtherLinksExternalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesOtherLinksExternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesOtherLinksInternalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesOtherLinksInternalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesOtherLinksInternalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesOtherLinksInternalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesOtherLinksInternalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** Represents an update to a `EventSeries`. Fields that are set will be updated. */
export type EventSeriesPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesSponsorsIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesSponsorsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesSponsorsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesSponsorsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesSponsorsIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesSponsorsIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesSponsorsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesSubeventsLocalIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesSubeventsLocalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesSubeventsLocalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesSubeventsLocalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesSubeventsLocalIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesSubeventsLocalIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesSubeventsLocalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesSubeventsOtherLocationsIdFkeyEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesSubeventsOtherLocationsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesSubeventsOtherLocationsIdFkeyInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesSubeventsOtherLocationsIdFkeyEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesSubeventsOtherLocationsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A filter to be used against many `Event` object types. All fields are combined with a logical ‘and.’ */
export type EventSeriesToManyEventFilter = {
  /** Every related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventFilter>;
  /** No related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventFilter>;
  /** Some related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventFilter>;
};

/** The `eventSeries` to be created by this mutation. */
export type EventSeriesWebsitesIdMultilinkIdFkEventSeriesCreateInput = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventSeriesInput` mutation. */
export type EventSeriesWebsitesIdMultilinkIdFkInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `eventSeries` in the `MultilinkInput` mutation. */
export type EventSeriesWebsitesIdMultilinkIdFkInverseInput = {
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventSeriesEventSeriesPkeyConnect>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyConnect>>;
  /** A `EventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSeriesWebsitesIdMultilinkIdFkEventSeriesCreateInput>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventSeriesEventSeriesPkeyDelete>>;
  /** The primary key(s) for `eventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventSeriesEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `eventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkUsingEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `eventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkUsingEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSeriesWebsitesIdMultilinkIdFkMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventSubeventsLocalIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventSubeventsLocalIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSubeventsLocalIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventSubeventsLocalIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventSubeventsLocalIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSubeventsLocalIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventSubeventsLocalIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventSubeventsLocalIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSubeventsLocalIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `event` to be created by this mutation. */
export type EventSubeventsOtherLocationsIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `EventInput` mutation. */
export type EventSubeventsOtherLocationsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventSubeventsOtherLocationsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnEventForEventSubeventsOtherLocationsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `MultilinkInput` mutation. */
export type EventSubeventsOtherLocationsIdFkeyInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<EventEventNameShortKeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventSubeventsOtherLocationsIdFkeyEventCreateInput>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventEventPkeyDelete>>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<EventEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `event` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventSubeventsOtherLocationsIdFkeyUsingEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<EventOnEventForEventSubeventsOtherLocationsIdFkeyUsingEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type EventSubeventsOtherLocationsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A filter to be used against many `EventVariant` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyEventVariantFilter = {
  /** Every related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventVariantFilter>;
  /** No related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventVariantFilter>;
  /** Some related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventVariantFilter>;
};

export type EventVariant = {
  __typename?: 'EventVariant';
  /** Reads and enables pagination through a set of `AllocationArea`. */
  allocationAreas: AllocationAreasConnection;
  /** Reads and enables pagination through a set of `AllocationPlot`. */
  allocationPlots: AllocationPlotsConnection;
  /** Reads and enables pagination through a set of `AllocationRoom`. */
  allocationRooms: AllocationRoomsConnection;
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes: Feed;
  changesId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  end?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event: Event;
  eventId: Scalars['UUID'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  referenceAllocationAreaId?: Maybe<Scalars['UUID']>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
  referenceAllocationRoomId?: Maybe<Scalars['UUID']>;
  start?: Maybe<Scalars['Datetime']>;
  status: Scalars['String'];
  version: Scalars['Int'];
};


export type EventVariantAllocationAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationAreaCondition>;
  filter?: InputMaybe<AllocationAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationAreasOrderBy>>;
};


export type EventVariantAllocationPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationPlotCondition>;
  filter?: InputMaybe<AllocationPlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationPlotsOrderBy>>;
};


export type EventVariantAllocationRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationRoomCondition>;
  filter?: InputMaybe<AllocationRoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationRoomsOrderBy>>;
};

/** The `eventVariant` to be created by this mutation. */
export type EventVariantChangesIdFkeyEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** The `feed` to be created by this mutation. */
export type EventVariantChangesIdFkeyFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** Input for the nested mutation of `feed` in the `EventVariantInput` mutation. */
export type EventVariantChangesIdFkeyInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventVariantChangesIdFkeyFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnEventVariantForEventVariantChangesIdFkeyUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `eventVariant` in the `FeedInput` mutation. */
export type EventVariantChangesIdFkeyInverseInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventVariantEventVariantPkeyConnect>>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventVariantChangesIdFkeyEventVariantCreateInput>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventVariantEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `eventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantChangesIdFkeyUsingEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantChangesIdFkeyUsingEventVariantPkeyUpdate>>;
};

/**
 * A condition to be used against `EventVariant` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EventVariantCondition = {
  /** Checks for equality with the object’s `changesId` field. */
  changesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isArchived` field. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `referenceAllocationAreaId` field. */
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referenceAllocationRoomId` field. */
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']>;
};

/** The `event` to be created by this mutation. */
export type EventVariantEventIdFkeyEventCreateInput = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear: Scalars['Int'];
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** The `eventVariant` to be created by this mutation. */
export type EventVariantEventIdFkeyEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `event` in the `EventVariantInput` mutation. */
export type EventVariantEventIdFkeyInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<EventEventPkeyConnect>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<EventEventNameShortKeyConnect>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventVariantEventIdFkeyEventCreateInput>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteById?: InputMaybe<EventEventPkeyDelete>;
  /** The primary key(s) for `event` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<EventEventNameShortKeyDelete>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<EventOnEventVariantForEventVariantEventIdFkeyUsingEventPkeyUpdate>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<EventOnEventVariantForEventVariantEventIdFkeyUsingEventNameShortKeyUpdate>;
};

/** Input for the nested mutation of `eventVariant` in the `EventInput` mutation. */
export type EventVariantEventIdFkeyInverseInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventVariantEventVariantPkeyConnect>>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventVariantEventIdFkeyEventVariantCreateInput>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventVariantEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `eventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantEventIdFkeyUsingEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantEventIdFkeyUsingEventVariantPkeyUpdate>>;
};

/** The fields on `eventVariant` to look up the row to connect. */
export type EventVariantEventVariantEventIdIndexKeyConnect = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};

/** The fields on `eventVariant` to look up the row to delete. */
export type EventVariantEventVariantEventIdIndexKeyDelete = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};

/** The fields on `eventVariant` to look up the row to connect. */
export type EventVariantEventVariantPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `eventVariant` to look up the row to delete. */
export type EventVariantEventVariantPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `EventVariant` object types. All fields are combined with a logical ‘and.’ */
export type EventVariantFilter = {
  /** Filter by the object’s `allocationAreas` relation. */
  allocationAreas?: InputMaybe<EventVariantToManyAllocationAreaFilter>;
  /** Some related `allocationAreas` exist. */
  allocationAreasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `allocationPlots` relation. */
  allocationPlots?: InputMaybe<EventVariantToManyAllocationPlotFilter>;
  /** Some related `allocationPlots` exist. */
  allocationPlotsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `allocationRooms` relation. */
  allocationRooms?: InputMaybe<EventVariantToManyAllocationRoomFilter>;
  /** Some related `allocationRooms` exist. */
  allocationRoomsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventVariantFilter>>;
  /** Filter by the object’s `changes` relation. */
  changes?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `changesId` field. */
  changesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `event` relation. */
  event?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isArchived` field. */
  isArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventVariantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventVariantFilter>>;
  /** Filter by the object’s `referenceAllocationArea` relation. */
  referenceAllocationArea?: InputMaybe<AllocationAreaFilter>;
  /** A related `referenceAllocationArea` exists. */
  referenceAllocationAreaExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceAllocationAreaId` field. */
  referenceAllocationAreaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `referenceAllocationRoom` relation. */
  referenceAllocationRoom?: InputMaybe<AllocationRoomFilter>;
  /** A related `referenceAllocationRoom` exists. */
  referenceAllocationRoomExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceAllocationRoomId` field. */
  referenceAllocationRoomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `EventVariant` */
export type EventVariantInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantChangesIdFkeyUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantChangesIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantChangesIdFkeyUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantChangesIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantEventIdFkeyUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantEventIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantEventIdFkeyUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantEventIdFkeyPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFUsingEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFPatch;
};

/** The fields on `eventVariant` to look up the row to update. */
export type EventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFUsingEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventVariant` being updated. */
  patch: UpdateEventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFPatch;
};

/** Represents an update to a `EventVariant`. Fields that are set will be updated. */
export type EventVariantPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** The `allocationArea` to be created by this mutation. */
export type EventVariantReferenceAllocationAreaIdAllocationAreaIdFAllocationAreaCreateInput = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
};

/** The `eventVariant` to be created by this mutation. */
export type EventVariantReferenceAllocationAreaIdAllocationAreaIdFEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `allocationArea` in the `EventVariantInput` mutation. */
export type EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput = {
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationAreaAllocationAreaPkeyConnect>;
  /** A `AllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFAllocationAreaCreateInput>;
  /** The primary key(s) for `allocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationAreaAllocationAreaPkeyDelete>;
  /** The primary key(s) and patch data for `allocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationAreaOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFUsingAllocationAreaPkeyUpdate>;
};

/** Input for the nested mutation of `eventVariant` in the `AllocationAreaInput` mutation. */
export type EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventVariantEventVariantPkeyConnect>>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventVariantReferenceAllocationAreaIdAllocationAreaIdFEventVariantCreateInput>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventVariantEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `eventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFUsingEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFUsingEventVariantPkeyUpdate>>;
};

/** The `allocationRoom` to be created by this mutation. */
export type EventVariantReferenceAllocationRoomIdAllocationRoomIdFAllocationRoomCreateInput = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end: Scalars['Datetime'];
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `eventVariant` to be created by this mutation. */
export type EventVariantReferenceAllocationRoomIdAllocationRoomIdFEventVariantCreateInput = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `allocationRoom` in the `EventVariantInput` mutation. */
export type EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput = {
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<AllocationRoomAllocationRoomPkeyConnect>;
  /** A `AllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFAllocationRoomCreateInput>;
  /** The primary key(s) for `allocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<AllocationRoomAllocationRoomPkeyDelete>;
  /** The primary key(s) and patch data for `allocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<AllocationRoomOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFUsingAllocationRoomPkeyUpdate>;
};

/** Input for the nested mutation of `eventVariant` in the `AllocationRoomInput` mutation. */
export type EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput = {
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventVariantEventVariantPkeyConnect>>;
  /** A `EventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventVariantReferenceAllocationRoomIdAllocationRoomIdFEventVariantCreateInput>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<EventVariantEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `eventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventVariantEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `eventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFUsingEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `eventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFUsingEventVariantPkeyUpdate>>;
};

/** A filter to be used against many `AllocationArea` object types. All fields are combined with a logical ‘and.’ */
export type EventVariantToManyAllocationAreaFilter = {
  /** Every related `AllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationAreaFilter>;
  /** No related `AllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationAreaFilter>;
  /** Some related `AllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationAreaFilter>;
};

/** A filter to be used against many `AllocationPlot` object types. All fields are combined with a logical ‘and.’ */
export type EventVariantToManyAllocationPlotFilter = {
  /** Every related `AllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationPlotFilter>;
  /** No related `AllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationPlotFilter>;
  /** Some related `AllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationPlotFilter>;
};

/** A filter to be used against many `AllocationRoom` object types. All fields are combined with a logical ‘and.’ */
export type EventVariantToManyAllocationRoomFilter = {
  /** Every related `AllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationRoomFilter>;
  /** No related `AllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationRoomFilter>;
  /** Some related `AllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationRoomFilter>;
};

/** A connection to a list of `EventVariant` values. */
export type EventVariantsConnection = {
  __typename?: 'EventVariantsConnection';
  /** A list of edges which contains the `EventVariant` and cursor to aid in pagination. */
  edges: Array<EventVariantsEdge>;
  /** A list of `EventVariant` objects. */
  nodes: Array<EventVariant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EventVariant` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EventVariant` edge in the connection. */
export type EventVariantsEdge = {
  __typename?: 'EventVariantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EventVariant` at the end of the edge. */
  node: EventVariant;
};

/** Methods to use when ordering `EventVariant`. */
export enum EventVariantsOrderBy {
  AllocationAreasByEventVariantIdCountAsc = 'ALLOCATION_AREAS_BY_EVENT_VARIANT_ID__COUNT_ASC',
  AllocationAreasByEventVariantIdCountDesc = 'ALLOCATION_AREAS_BY_EVENT_VARIANT_ID__COUNT_DESC',
  AllocationAreaByReferenceAllocationAreaIdAreaIdAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__AREA_ID_ASC',
  AllocationAreaByReferenceAllocationAreaIdAreaIdDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__AREA_ID_DESC',
  AllocationAreaByReferenceAllocationAreaIdConflictsAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__CONFLICTS_ASC',
  AllocationAreaByReferenceAllocationAreaIdConflictsDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__CONFLICTS_DESC',
  AllocationAreaByReferenceAllocationAreaIdEndAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__END_ASC',
  AllocationAreaByReferenceAllocationAreaIdEndDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__END_DESC',
  AllocationAreaByReferenceAllocationAreaIdEventVariantIdAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__EVENT_VARIANT_ID_ASC',
  AllocationAreaByReferenceAllocationAreaIdEventVariantIdDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__EVENT_VARIANT_ID_DESC',
  AllocationAreaByReferenceAllocationAreaIdIdAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__ID_ASC',
  AllocationAreaByReferenceAllocationAreaIdIdDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__ID_DESC',
  AllocationAreaByReferenceAllocationAreaIdIsOptionalAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__IS_OPTIONAL_ASC',
  AllocationAreaByReferenceAllocationAreaIdIsOptionalDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__IS_OPTIONAL_DESC',
  AllocationAreaByReferenceAllocationAreaIdStartAsc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__START_ASC',
  AllocationAreaByReferenceAllocationAreaIdStartDesc = 'ALLOCATION_AREA_BY_REFERENCE_ALLOCATION_AREA_ID__START_DESC',
  AllocationPlotsByEventVariantIdCountAsc = 'ALLOCATION_PLOTS_BY_EVENT_VARIANT_ID__COUNT_ASC',
  AllocationPlotsByEventVariantIdCountDesc = 'ALLOCATION_PLOTS_BY_EVENT_VARIANT_ID__COUNT_DESC',
  AllocationRoomsByEventVariantIdCountAsc = 'ALLOCATION_ROOMS_BY_EVENT_VARIANT_ID__COUNT_ASC',
  AllocationRoomsByEventVariantIdCountDesc = 'ALLOCATION_ROOMS_BY_EVENT_VARIANT_ID__COUNT_DESC',
  AllocationRoomByReferenceAllocationRoomIdConflictsAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__CONFLICTS_ASC',
  AllocationRoomByReferenceAllocationRoomIdConflictsDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__CONFLICTS_DESC',
  AllocationRoomByReferenceAllocationRoomIdEndAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__END_ASC',
  AllocationRoomByReferenceAllocationRoomIdEndDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__END_DESC',
  AllocationRoomByReferenceAllocationRoomIdEventVariantIdAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__EVENT_VARIANT_ID_ASC',
  AllocationRoomByReferenceAllocationRoomIdEventVariantIdDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__EVENT_VARIANT_ID_DESC',
  AllocationRoomByReferenceAllocationRoomIdIdAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__ID_ASC',
  AllocationRoomByReferenceAllocationRoomIdIdDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__ID_DESC',
  AllocationRoomByReferenceAllocationRoomIdIsOptionalAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__IS_OPTIONAL_ASC',
  AllocationRoomByReferenceAllocationRoomIdIsOptionalDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__IS_OPTIONAL_DESC',
  AllocationRoomByReferenceAllocationRoomIdRoomIdAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__ROOM_ID_ASC',
  AllocationRoomByReferenceAllocationRoomIdRoomIdDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__ROOM_ID_DESC',
  AllocationRoomByReferenceAllocationRoomIdStartAsc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__START_ASC',
  AllocationRoomByReferenceAllocationRoomIdStartDesc = 'ALLOCATION_ROOM_BY_REFERENCE_ALLOCATION_ROOM_ID__START_DESC',
  ChangesIdAsc = 'CHANGES_ID_ASC',
  ChangesIdDesc = 'CHANGES_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  EventByEventIdAnnualSpecificsAsc = 'EVENT_BY_EVENT_ID__ANNUAL_SPECIFICS_ASC',
  EventByEventIdAnnualSpecificsDesc = 'EVENT_BY_EVENT_ID__ANNUAL_SPECIFICS_DESC',
  EventByEventIdAssistantAsc = 'EVENT_BY_EVENT_ID__ASSISTANT_ASC',
  EventByEventIdAssistantDesc = 'EVENT_BY_EVENT_ID__ASSISTANT_DESC',
  EventByEventIdBusinessDomainAsc = 'EVENT_BY_EVENT_ID__BUSINESS_DOMAIN_ASC',
  EventByEventIdBusinessDomainDesc = 'EVENT_BY_EVENT_ID__BUSINESS_DOMAIN_DESC',
  EventByEventIdCompanyGroupAsc = 'EVENT_BY_EVENT_ID__COMPANY_GROUP_ASC',
  EventByEventIdCompanyGroupDesc = 'EVENT_BY_EVENT_ID__COMPANY_GROUP_DESC',
  EventByEventIdCompetitionInternationalIdAsc = 'EVENT_BY_EVENT_ID__COMPETITION_INTERNATIONAL_ID_ASC',
  EventByEventIdCompetitionInternationalIdDesc = 'EVENT_BY_EVENT_ID__COMPETITION_INTERNATIONAL_ID_DESC',
  EventByEventIdCompetitionNationalIdAsc = 'EVENT_BY_EVENT_ID__COMPETITION_NATIONAL_ID_ASC',
  EventByEventIdCompetitionNationalIdDesc = 'EVENT_BY_EVENT_ID__COMPETITION_NATIONAL_ID_DESC',
  EventByEventIdCurrentVersionAsc = 'EVENT_BY_EVENT_ID__CURRENT_VERSION_ASC',
  EventByEventIdCurrentVersionDesc = 'EVENT_BY_EVENT_ID__CURRENT_VERSION_DESC',
  EventByEventIdDepartmentAsc = 'EVENT_BY_EVENT_ID__DEPARTMENT_ASC',
  EventByEventIdDepartmentDesc = 'EVENT_BY_EVENT_ID__DEPARTMENT_DESC',
  EventByEventIdDescriptionAsc = 'EVENT_BY_EVENT_ID__DESCRIPTION_ASC',
  EventByEventIdDescriptionDesc = 'EVENT_BY_EVENT_ID__DESCRIPTION_DESC',
  EventByEventIdExecutionYearAsc = 'EVENT_BY_EVENT_ID__EXECUTION_YEAR_ASC',
  EventByEventIdExecutionYearDesc = 'EVENT_BY_EVENT_ID__EXECUTION_YEAR_DESC',
  EventByEventIdExternalDataIdAsc = 'EVENT_BY_EVENT_ID__EXTERNAL_DATA_ID_ASC',
  EventByEventIdExternalDataIdDesc = 'EVENT_BY_EVENT_ID__EXTERNAL_DATA_ID_DESC',
  EventByEventIdExtraDocumentsIdAsc = 'EVENT_BY_EVENT_ID__EXTRA_DOCUMENTS_ID_ASC',
  EventByEventIdExtraDocumentsIdDesc = 'EVENT_BY_EVENT_ID__EXTRA_DOCUMENTS_ID_DESC',
  EventByEventIdExtraSystemsIdAsc = 'EVENT_BY_EVENT_ID__EXTRA_SYSTEMS_ID_ASC',
  EventByEventIdExtraSystemsIdDesc = 'EVENT_BY_EVENT_ID__EXTRA_SYSTEMS_ID_DESC',
  EventByEventIdFairAbroadCooperationIdAsc = 'EVENT_BY_EVENT_ID__FAIR_ABROAD_COOPERATION_ID_ASC',
  EventByEventIdFairAbroadCooperationIdDesc = 'EVENT_BY_EVENT_ID__FAIR_ABROAD_COOPERATION_ID_DESC',
  EventByEventIdFairAbroadIdAsc = 'EVENT_BY_EVENT_ID__FAIR_ABROAD_ID_ASC',
  EventByEventIdFairAbroadIdDesc = 'EVENT_BY_EVENT_ID__FAIR_ABROAD_ID_DESC',
  EventByEventIdFavoredParallelsExternalIdAsc = 'EVENT_BY_EVENT_ID__FAVORED_PARALLELS_EXTERNAL_ID_ASC',
  EventByEventIdFavoredParallelsExternalIdDesc = 'EVENT_BY_EVENT_ID__FAVORED_PARALLELS_EXTERNAL_ID_DESC',
  EventByEventIdFavoredParallelsInternalIdAsc = 'EVENT_BY_EVENT_ID__FAVORED_PARALLELS_INTERNAL_ID_ASC',
  EventByEventIdFavoredParallelsInternalIdDesc = 'EVENT_BY_EVENT_ID__FAVORED_PARALLELS_INTERNAL_ID_DESC',
  EventByEventIdIconIdAsc = 'EVENT_BY_EVENT_ID__ICON_ID_ASC',
  EventByEventIdIconIdDesc = 'EVENT_BY_EVENT_ID__ICON_ID_DESC',
  EventByEventIdIconUploadAsc = 'EVENT_BY_EVENT_ID__ICON_UPLOAD_ASC',
  EventByEventIdIconUploadDesc = 'EVENT_BY_EVENT_ID__ICON_UPLOAD_DESC',
  EventByEventIdIconUploadStatusAsc = 'EVENT_BY_EVENT_ID__ICON_UPLOAD_STATUS_ASC',
  EventByEventIdIconUploadStatusDesc = 'EVENT_BY_EVENT_ID__ICON_UPLOAD_STATUS_DESC',
  EventByEventIdIdAsc = 'EVENT_BY_EVENT_ID__ID_ASC',
  EventByEventIdIdDesc = 'EVENT_BY_EVENT_ID__ID_DESC',
  EventByEventIdInternalDataIdAsc = 'EVENT_BY_EVENT_ID__INTERNAL_DATA_ID_ASC',
  EventByEventIdInternalDataIdDesc = 'EVENT_BY_EVENT_ID__INTERNAL_DATA_ID_DESC',
  EventByEventIdNameLongAsc = 'EVENT_BY_EVENT_ID__NAME_LONG_ASC',
  EventByEventIdNameLongDesc = 'EVENT_BY_EVENT_ID__NAME_LONG_DESC',
  EventByEventIdNameShortAsc = 'EVENT_BY_EVENT_ID__NAME_SHORT_ASC',
  EventByEventIdNameShortDesc = 'EVENT_BY_EVENT_ID__NAME_SHORT_DESC',
  EventByEventIdOtherCompetitionInternationalIdAsc = 'EVENT_BY_EVENT_ID__OTHER_COMPETITION_INTERNATIONAL_ID_ASC',
  EventByEventIdOtherCompetitionInternationalIdDesc = 'EVENT_BY_EVENT_ID__OTHER_COMPETITION_INTERNATIONAL_ID_DESC',
  EventByEventIdOtherCompetitionNationalIdAsc = 'EVENT_BY_EVENT_ID__OTHER_COMPETITION_NATIONAL_ID_ASC',
  EventByEventIdOtherCompetitionNationalIdDesc = 'EVENT_BY_EVENT_ID__OTHER_COMPETITION_NATIONAL_ID_DESC',
  EventByEventIdOtherLinksExternalIdAsc = 'EVENT_BY_EVENT_ID__OTHER_LINKS_EXTERNAL_ID_ASC',
  EventByEventIdOtherLinksExternalIdDesc = 'EVENT_BY_EVENT_ID__OTHER_LINKS_EXTERNAL_ID_DESC',
  EventByEventIdOtherLinksInternalIdAsc = 'EVENT_BY_EVENT_ID__OTHER_LINKS_INTERNAL_ID_ASC',
  EventByEventIdOtherLinksInternalIdDesc = 'EVENT_BY_EVENT_ID__OTHER_LINKS_INTERNAL_ID_DESC',
  EventByEventIdResponsibleAsc = 'EVENT_BY_EVENT_ID__RESPONSIBLE_ASC',
  EventByEventIdResponsibleDesc = 'EVENT_BY_EVENT_ID__RESPONSIBLE_DESC',
  EventByEventIdSeriesIdAsc = 'EVENT_BY_EVENT_ID__SERIES_ID_ASC',
  EventByEventIdSeriesIdDesc = 'EVENT_BY_EVENT_ID__SERIES_ID_DESC',
  EventByEventIdStatusAsc = 'EVENT_BY_EVENT_ID__STATUS_ASC',
  EventByEventIdStatusDesc = 'EVENT_BY_EVENT_ID__STATUS_DESC',
  EventByEventIdSubeventsLocalIdAsc = 'EVENT_BY_EVENT_ID__SUBEVENTS_LOCAL_ID_ASC',
  EventByEventIdSubeventsLocalIdDesc = 'EVENT_BY_EVENT_ID__SUBEVENTS_LOCAL_ID_DESC',
  EventByEventIdSubeventsOtherLocationsIdAsc = 'EVENT_BY_EVENT_ID__SUBEVENTS_OTHER_LOCATIONS_ID_ASC',
  EventByEventIdSubeventsOtherLocationsIdDesc = 'EVENT_BY_EVENT_ID__SUBEVENTS_OTHER_LOCATIONS_ID_DESC',
  EventByEventIdSubtitleAsc = 'EVENT_BY_EVENT_ID__SUBTITLE_ASC',
  EventByEventIdSubtitleDesc = 'EVENT_BY_EVENT_ID__SUBTITLE_DESC',
  EventByEventIdTeamChangesAsc = 'EVENT_BY_EVENT_ID__TEAM_CHANGES_ASC',
  EventByEventIdTeamChangesDesc = 'EVENT_BY_EVENT_ID__TEAM_CHANGES_DESC',
  EventIdAsc = 'EVENT_ID_ASC',
  EventIdDesc = 'EVENT_ID_DESC',
  FeedByChangesIdIdAsc = 'FEED_BY_CHANGES_ID__ID_ASC',
  FeedByChangesIdIdDesc = 'FEED_BY_CHANGES_ID__ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IsArchivedAsc = 'IS_ARCHIVED_ASC',
  IsArchivedDesc = 'IS_ARCHIVED_DESC',
  IsCurrentAsc = 'IS_CURRENT_ASC',
  IsCurrentDesc = 'IS_CURRENT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferenceAllocationAreaIdAsc = 'REFERENCE_ALLOCATION_AREA_ID_ASC',
  ReferenceAllocationAreaIdDesc = 'REFERENCE_ALLOCATION_AREA_ID_DESC',
  ReferenceAllocationRoomIdAsc = 'REFERENCE_ALLOCATION_ROOM_ID_ASC',
  ReferenceAllocationRoomIdDesc = 'REFERENCE_ALLOCATION_ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

/** A connection to a list of `Event` values. */
export type EventsConnection = {
  __typename?: 'EventsConnection';
  /** A list of edges which contains the `Event` and cursor to aid in pagination. */
  edges: Array<EventsEdge>;
  /** A list of `Event` objects. */
  nodes: Array<Event>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Event` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Event` edge in the connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Event` at the end of the edge. */
  node: Event;
};

/** Methods to use when ordering `Event`. */
export enum EventsOrderBy {
  AnnualSpecificsAsc = 'ANNUAL_SPECIFICS_ASC',
  AnnualSpecificsDesc = 'ANNUAL_SPECIFICS_DESC',
  AssistantAsc = 'ASSISTANT_ASC',
  AssistantDesc = 'ASSISTANT_DESC',
  BusinessDomainAsc = 'BUSINESS_DOMAIN_ASC',
  BusinessDomainDesc = 'BUSINESS_DOMAIN_DESC',
  CompanyGroupAsc = 'COMPANY_GROUP_ASC',
  CompanyGroupDesc = 'COMPANY_GROUP_DESC',
  CompetitionInternationalIdAsc = 'COMPETITION_INTERNATIONAL_ID_ASC',
  CompetitionInternationalIdDesc = 'COMPETITION_INTERNATIONAL_ID_DESC',
  CompetitionNationalIdAsc = 'COMPETITION_NATIONAL_ID_ASC',
  CompetitionNationalIdDesc = 'COMPETITION_NATIONAL_ID_DESC',
  CurrentVersionAsc = 'CURRENT_VERSION_ASC',
  CurrentVersionDesc = 'CURRENT_VERSION_DESC',
  DepartmentAsc = 'DEPARTMENT_ASC',
  DepartmentDesc = 'DEPARTMENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EventSeriesBySeriesIdAdditionalPartnersAsc = 'EVENT_SERIES_BY_SERIES_ID__ADDITIONAL_PARTNERS_ASC',
  EventSeriesBySeriesIdAdditionalPartnersDesc = 'EVENT_SERIES_BY_SERIES_ID__ADDITIONAL_PARTNERS_DESC',
  EventSeriesBySeriesIdAllocationRulesAsc = 'EVENT_SERIES_BY_SERIES_ID__ALLOCATION_RULES_ASC',
  EventSeriesBySeriesIdAllocationRulesDesc = 'EVENT_SERIES_BY_SERIES_ID__ALLOCATION_RULES_DESC',
  EventSeriesBySeriesIdAppointmentHistoryAsc = 'EVENT_SERIES_BY_SERIES_ID__APPOINTMENT_HISTORY_ASC',
  EventSeriesBySeriesIdAppointmentHistoryDesc = 'EVENT_SERIES_BY_SERIES_ID__APPOINTMENT_HISTORY_DESC',
  EventSeriesBySeriesIdBusinessDomainAsc = 'EVENT_SERIES_BY_SERIES_ID__BUSINESS_DOMAIN_ASC',
  EventSeriesBySeriesIdBusinessDomainDesc = 'EVENT_SERIES_BY_SERIES_ID__BUSINESS_DOMAIN_DESC',
  EventSeriesBySeriesIdCategoryAsc = 'EVENT_SERIES_BY_SERIES_ID__CATEGORY_ASC',
  EventSeriesBySeriesIdCategoryDesc = 'EVENT_SERIES_BY_SERIES_ID__CATEGORY_DESC',
  EventSeriesBySeriesIdCompanyGroupAsc = 'EVENT_SERIES_BY_SERIES_ID__COMPANY_GROUP_ASC',
  EventSeriesBySeriesIdCompanyGroupDesc = 'EVENT_SERIES_BY_SERIES_ID__COMPANY_GROUP_DESC',
  EventSeriesBySeriesIdCompetitionInternationalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__COMPETITION_INTERNATIONAL_ID_ASC',
  EventSeriesBySeriesIdCompetitionInternationalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__COMPETITION_INTERNATIONAL_ID_DESC',
  EventSeriesBySeriesIdCompetitionNationalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__COMPETITION_NATIONAL_ID_ASC',
  EventSeriesBySeriesIdCompetitionNationalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__COMPETITION_NATIONAL_ID_DESC',
  EventSeriesBySeriesIdCycleAsc = 'EVENT_SERIES_BY_SERIES_ID__CYCLE_ASC',
  EventSeriesBySeriesIdCycleChangesAsc = 'EVENT_SERIES_BY_SERIES_ID__CYCLE_CHANGES_ASC',
  EventSeriesBySeriesIdCycleChangesDesc = 'EVENT_SERIES_BY_SERIES_ID__CYCLE_CHANGES_DESC',
  EventSeriesBySeriesIdCycleDesc = 'EVENT_SERIES_BY_SERIES_ID__CYCLE_DESC',
  EventSeriesBySeriesIdDepartmentAsc = 'EVENT_SERIES_BY_SERIES_ID__DEPARTMENT_ASC',
  EventSeriesBySeriesIdDepartmentDesc = 'EVENT_SERIES_BY_SERIES_ID__DEPARTMENT_DESC',
  EventSeriesBySeriesIdDescriptionAsc = 'EVENT_SERIES_BY_SERIES_ID__DESCRIPTION_ASC',
  EventSeriesBySeriesIdDescriptionDesc = 'EVENT_SERIES_BY_SERIES_ID__DESCRIPTION_DESC',
  EventSeriesBySeriesIdExecutorsIdAsc = 'EVENT_SERIES_BY_SERIES_ID__EXECUTORS_ID_ASC',
  EventSeriesBySeriesIdExecutorsIdDesc = 'EVENT_SERIES_BY_SERIES_ID__EXECUTORS_ID_DESC',
  EventSeriesBySeriesIdExternalDataIdAsc = 'EVENT_SERIES_BY_SERIES_ID__EXTERNAL_DATA_ID_ASC',
  EventSeriesBySeriesIdExternalDataIdDesc = 'EVENT_SERIES_BY_SERIES_ID__EXTERNAL_DATA_ID_DESC',
  EventSeriesBySeriesIdExtraDocumentsIdAsc = 'EVENT_SERIES_BY_SERIES_ID__EXTRA_DOCUMENTS_ID_ASC',
  EventSeriesBySeriesIdExtraDocumentsIdDesc = 'EVENT_SERIES_BY_SERIES_ID__EXTRA_DOCUMENTS_ID_DESC',
  EventSeriesBySeriesIdExtraSystemsIdAsc = 'EVENT_SERIES_BY_SERIES_ID__EXTRA_SYSTEMS_ID_ASC',
  EventSeriesBySeriesIdExtraSystemsIdDesc = 'EVENT_SERIES_BY_SERIES_ID__EXTRA_SYSTEMS_ID_DESC',
  EventSeriesBySeriesIdFairAbroadCooperationIdAsc = 'EVENT_SERIES_BY_SERIES_ID__FAIR_ABROAD_COOPERATION_ID_ASC',
  EventSeriesBySeriesIdFairAbroadCooperationIdDesc = 'EVENT_SERIES_BY_SERIES_ID__FAIR_ABROAD_COOPERATION_ID_DESC',
  EventSeriesBySeriesIdFairAbroadIdAsc = 'EVENT_SERIES_BY_SERIES_ID__FAIR_ABROAD_ID_ASC',
  EventSeriesBySeriesIdFairAbroadIdDesc = 'EVENT_SERIES_BY_SERIES_ID__FAIR_ABROAD_ID_DESC',
  EventSeriesBySeriesIdFavoredParallelsExternalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__FAVORED_PARALLELS_EXTERNAL_ID_ASC',
  EventSeriesBySeriesIdFavoredParallelsExternalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__FAVORED_PARALLELS_EXTERNAL_ID_DESC',
  EventSeriesBySeriesIdFavoredParallelsInternalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__FAVORED_PARALLELS_INTERNAL_ID_ASC',
  EventSeriesBySeriesIdFavoredParallelsInternalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__FAVORED_PARALLELS_INTERNAL_ID_DESC',
  EventSeriesBySeriesIdFoundationYearAsc = 'EVENT_SERIES_BY_SERIES_ID__FOUNDATION_YEAR_ASC',
  EventSeriesBySeriesIdFoundationYearDesc = 'EVENT_SERIES_BY_SERIES_ID__FOUNDATION_YEAR_DESC',
  EventSeriesBySeriesIdIconIdAsc = 'EVENT_SERIES_BY_SERIES_ID__ICON_ID_ASC',
  EventSeriesBySeriesIdIconIdDesc = 'EVENT_SERIES_BY_SERIES_ID__ICON_ID_DESC',
  EventSeriesBySeriesIdIconUploadAsc = 'EVENT_SERIES_BY_SERIES_ID__ICON_UPLOAD_ASC',
  EventSeriesBySeriesIdIconUploadDesc = 'EVENT_SERIES_BY_SERIES_ID__ICON_UPLOAD_DESC',
  EventSeriesBySeriesIdIconUploadStatusAsc = 'EVENT_SERIES_BY_SERIES_ID__ICON_UPLOAD_STATUS_ASC',
  EventSeriesBySeriesIdIconUploadStatusDesc = 'EVENT_SERIES_BY_SERIES_ID__ICON_UPLOAD_STATUS_DESC',
  EventSeriesBySeriesIdIdAsc = 'EVENT_SERIES_BY_SERIES_ID__ID_ASC',
  EventSeriesBySeriesIdIdDesc = 'EVENT_SERIES_BY_SERIES_ID__ID_DESC',
  EventSeriesBySeriesIdInternalDataIdAsc = 'EVENT_SERIES_BY_SERIES_ID__INTERNAL_DATA_ID_ASC',
  EventSeriesBySeriesIdInternalDataIdDesc = 'EVENT_SERIES_BY_SERIES_ID__INTERNAL_DATA_ID_DESC',
  EventSeriesBySeriesIdIsPublicAsc = 'EVENT_SERIES_BY_SERIES_ID__IS_PUBLIC_ASC',
  EventSeriesBySeriesIdIsPublicDesc = 'EVENT_SERIES_BY_SERIES_ID__IS_PUBLIC_DESC',
  EventSeriesBySeriesIdIsTechnicalAsc = 'EVENT_SERIES_BY_SERIES_ID__IS_TECHNICAL_ASC',
  EventSeriesBySeriesIdIsTechnicalDesc = 'EVENT_SERIES_BY_SERIES_ID__IS_TECHNICAL_DESC',
  EventSeriesBySeriesIdLocationHistoryAsc = 'EVENT_SERIES_BY_SERIES_ID__LOCATION_HISTORY_ASC',
  EventSeriesBySeriesIdLocationHistoryDesc = 'EVENT_SERIES_BY_SERIES_ID__LOCATION_HISTORY_DESC',
  EventSeriesBySeriesIdNameLongAsc = 'EVENT_SERIES_BY_SERIES_ID__NAME_LONG_ASC',
  EventSeriesBySeriesIdNameLongDesc = 'EVENT_SERIES_BY_SERIES_ID__NAME_LONG_DESC',
  EventSeriesBySeriesIdNameShortAsc = 'EVENT_SERIES_BY_SERIES_ID__NAME_SHORT_ASC',
  EventSeriesBySeriesIdNameShortDesc = 'EVENT_SERIES_BY_SERIES_ID__NAME_SHORT_DESC',
  EventSeriesBySeriesIdNotesAppointmentRulesAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_APPOINTMENT_RULES_ASC',
  EventSeriesBySeriesIdNotesAppointmentRulesDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_APPOINTMENT_RULES_DESC',
  EventSeriesBySeriesIdNotesAreasAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_AREAS_ASC',
  EventSeriesBySeriesIdNotesAreasDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_AREAS_DESC',
  EventSeriesBySeriesIdNotesAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_ASC',
  EventSeriesBySeriesIdNotesBoulevardSectionsAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_BOULEVARD_SECTIONS_ASC',
  EventSeriesBySeriesIdNotesBoulevardSectionsDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_BOULEVARD_SECTIONS_DESC',
  EventSeriesBySeriesIdNotesConferenceRoomsAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_CONFERENCE_ROOMS_ASC',
  EventSeriesBySeriesIdNotesConferenceRoomsDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_CONFERENCE_ROOMS_DESC',
  EventSeriesBySeriesIdNotesConstructionAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_CONSTRUCTION_ASC',
  EventSeriesBySeriesIdNotesConstructionDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_CONSTRUCTION_DESC',
  EventSeriesBySeriesIdNotesDayOrderAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DAY_ORDER_ASC',
  EventSeriesBySeriesIdNotesDayOrderDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DAY_ORDER_DESC',
  EventSeriesBySeriesIdNotesDayOrderHistoryAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DAY_ORDER_HISTORY_ASC',
  EventSeriesBySeriesIdNotesDayOrderHistoryDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DAY_ORDER_HISTORY_DESC',
  EventSeriesBySeriesIdNotesDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DESC',
  EventSeriesBySeriesIdNotesDismantlingAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DISMANTLING_ASC',
  EventSeriesBySeriesIdNotesDismantlingDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_DISMANTLING_DESC',
  EventSeriesBySeriesIdNotesEarlyConstructionExternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EARLY_CONSTRUCTION_EXTERNAL_ASC',
  EventSeriesBySeriesIdNotesEarlyConstructionExternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EARLY_CONSTRUCTION_EXTERNAL_DESC',
  EventSeriesBySeriesIdNotesEarlyConstructionInternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EARLY_CONSTRUCTION_INTERNAL_ASC',
  EventSeriesBySeriesIdNotesEarlyConstructionInternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EARLY_CONSTRUCTION_INTERNAL_DESC',
  EventSeriesBySeriesIdNotesEntrancesAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_ENTRANCES_ASC',
  EventSeriesBySeriesIdNotesEntrancesDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_ENTRANCES_DESC',
  EventSeriesBySeriesIdNotesExecutionAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EXECUTION_ASC',
  EventSeriesBySeriesIdNotesExecutionDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EXECUTION_DESC',
  EventSeriesBySeriesIdNotesExtendedDismantlingExternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EXTENDED_DISMANTLING_EXTERNAL_ASC',
  EventSeriesBySeriesIdNotesExtendedDismantlingExternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EXTENDED_DISMANTLING_EXTERNAL_DESC',
  EventSeriesBySeriesIdNotesExtendedDismantlingInternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EXTENDED_DISMANTLING_INTERNAL_ASC',
  EventSeriesBySeriesIdNotesExtendedDismantlingInternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_EXTENDED_DISMANTLING_INTERNAL_DESC',
  EventSeriesBySeriesIdNotesHallExhibitionAreasAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HALL_EXHIBITION_AREAS_ASC',
  EventSeriesBySeriesIdNotesHallExhibitionAreasDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HALL_EXHIBITION_AREAS_DESC',
  EventSeriesBySeriesIdNotesHolidaysInternationalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HOLIDAYS_INTERNATIONAL_ASC',
  EventSeriesBySeriesIdNotesHolidaysInternationalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HOLIDAYS_INTERNATIONAL_DESC',
  EventSeriesBySeriesIdNotesHolidaysNationalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HOLIDAYS_NATIONAL_ASC',
  EventSeriesBySeriesIdNotesHolidaysNationalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HOLIDAYS_NATIONAL_DESC',
  EventSeriesBySeriesIdNotesHolidaysNrwAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HOLIDAYS_NRW_ASC',
  EventSeriesBySeriesIdNotesHolidaysNrwDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_HOLIDAYS_NRW_DESC',
  EventSeriesBySeriesIdNotesMonthsAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_MONTHS_ASC',
  EventSeriesBySeriesIdNotesMonthsDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_MONTHS_DESC',
  EventSeriesBySeriesIdNotesOfficesExternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_OFFICES_EXTERNAL_ASC',
  EventSeriesBySeriesIdNotesOfficesExternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_OFFICES_EXTERNAL_DESC',
  EventSeriesBySeriesIdNotesOfficesInternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_OFFICES_INTERNAL_ASC',
  EventSeriesBySeriesIdNotesOfficesInternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_OFFICES_INTERNAL_DESC',
  EventSeriesBySeriesIdNotesParkingAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PARKING_ASC',
  EventSeriesBySeriesIdNotesParkingDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PARKING_DESC',
  EventSeriesBySeriesIdNotesPassagesAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PASSAGES_ASC',
  EventSeriesBySeriesIdNotesPassagesDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PASSAGES_DESC',
  EventSeriesBySeriesIdNotesPublicHolidaysInternationalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PUBLIC_HOLIDAYS_INTERNATIONAL_ASC',
  EventSeriesBySeriesIdNotesPublicHolidaysInternationalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PUBLIC_HOLIDAYS_INTERNATIONAL_DESC',
  EventSeriesBySeriesIdNotesPublicHolidaysNationalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PUBLIC_HOLIDAYS_NATIONAL_ASC',
  EventSeriesBySeriesIdNotesPublicHolidaysNationalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PUBLIC_HOLIDAYS_NATIONAL_DESC',
  EventSeriesBySeriesIdNotesPublicHolidaysNrwAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PUBLIC_HOLIDAYS_NRW_ASC',
  EventSeriesBySeriesIdNotesPublicHolidaysNrwDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_PUBLIC_HOLIDAYS_NRW_DESC',
  EventSeriesBySeriesIdNotesServiceCentersAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_SERVICE_CENTERS_ASC',
  EventSeriesBySeriesIdNotesServiceCentersDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_SERVICE_CENTERS_DESC',
  EventSeriesBySeriesIdNotesSetupAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_SETUP_ASC',
  EventSeriesBySeriesIdNotesSetupDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_SETUP_DESC',
  EventSeriesBySeriesIdNotesStorageExternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_STORAGE_EXTERNAL_ASC',
  EventSeriesBySeriesIdNotesStorageExternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_STORAGE_EXTERNAL_DESC',
  EventSeriesBySeriesIdNotesStorageInternalAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_STORAGE_INTERNAL_ASC',
  EventSeriesBySeriesIdNotesStorageInternalDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_STORAGE_INTERNAL_DESC',
  EventSeriesBySeriesIdNotesTechnicalDismantlingAsc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_TECHNICAL_DISMANTLING_ASC',
  EventSeriesBySeriesIdNotesTechnicalDismantlingDesc = 'EVENT_SERIES_BY_SERIES_ID__NOTES_TECHNICAL_DISMANTLING_DESC',
  EventSeriesBySeriesIdNumberKapmanAsc = 'EVENT_SERIES_BY_SERIES_ID__NUMBER_KAPMAN_ASC',
  EventSeriesBySeriesIdNumberKapmanDesc = 'EVENT_SERIES_BY_SERIES_ID__NUMBER_KAPMAN_DESC',
  EventSeriesBySeriesIdNumberShortAsc = 'EVENT_SERIES_BY_SERIES_ID__NUMBER_SHORT_ASC',
  EventSeriesBySeriesIdNumberShortDesc = 'EVENT_SERIES_BY_SERIES_ID__NUMBER_SHORT_DESC',
  EventSeriesBySeriesIdOrganisationalChangesAsc = 'EVENT_SERIES_BY_SERIES_ID__ORGANISATIONAL_CHANGES_ASC',
  EventSeriesBySeriesIdOrganisationalChangesDesc = 'EVENT_SERIES_BY_SERIES_ID__ORGANISATIONAL_CHANGES_DESC',
  EventSeriesBySeriesIdOrganizersIdAsc = 'EVENT_SERIES_BY_SERIES_ID__ORGANIZERS_ID_ASC',
  EventSeriesBySeriesIdOrganizersIdDesc = 'EVENT_SERIES_BY_SERIES_ID__ORGANIZERS_ID_DESC',
  EventSeriesBySeriesIdOtherAllocationNeedsAsc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_ALLOCATION_NEEDS_ASC',
  EventSeriesBySeriesIdOtherAllocationNeedsDesc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_ALLOCATION_NEEDS_DESC',
  EventSeriesBySeriesIdOtherCompetitionInternationalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_COMPETITION_INTERNATIONAL_ID_ASC',
  EventSeriesBySeriesIdOtherCompetitionInternationalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_COMPETITION_INTERNATIONAL_ID_DESC',
  EventSeriesBySeriesIdOtherCompetitionNationalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_COMPETITION_NATIONAL_ID_ASC',
  EventSeriesBySeriesIdOtherCompetitionNationalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_COMPETITION_NATIONAL_ID_DESC',
  EventSeriesBySeriesIdOtherLinksExternalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_LINKS_EXTERNAL_ID_ASC',
  EventSeriesBySeriesIdOtherLinksExternalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_LINKS_EXTERNAL_ID_DESC',
  EventSeriesBySeriesIdOtherLinksInternalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_LINKS_INTERNAL_ID_ASC',
  EventSeriesBySeriesIdOtherLinksInternalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_LINKS_INTERNAL_ID_DESC',
  EventSeriesBySeriesIdOtherNotesAppointmentRulesAsc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_NOTES_APPOINTMENT_RULES_ASC',
  EventSeriesBySeriesIdOtherNotesAppointmentRulesDesc = 'EVENT_SERIES_BY_SERIES_ID__OTHER_NOTES_APPOINTMENT_RULES_DESC',
  EventSeriesBySeriesIdPartnersOverviewLinkAsc = 'EVENT_SERIES_BY_SERIES_ID__PARTNERS_OVERVIEW_LINK_ASC',
  EventSeriesBySeriesIdPartnersOverviewLinkDesc = 'EVENT_SERIES_BY_SERIES_ID__PARTNERS_OVERVIEW_LINK_DESC',
  EventSeriesBySeriesIdPartnersOverviewNameAsc = 'EVENT_SERIES_BY_SERIES_ID__PARTNERS_OVERVIEW_NAME_ASC',
  EventSeriesBySeriesIdPartnersOverviewNameDesc = 'EVENT_SERIES_BY_SERIES_ID__PARTNERS_OVERVIEW_NAME_DESC',
  EventSeriesBySeriesIdSingleEventAsc = 'EVENT_SERIES_BY_SERIES_ID__SINGLE_EVENT_ASC',
  EventSeriesBySeriesIdSingleEventDesc = 'EVENT_SERIES_BY_SERIES_ID__SINGLE_EVENT_DESC',
  EventSeriesBySeriesIdSponsorsIdAsc = 'EVENT_SERIES_BY_SERIES_ID__SPONSORS_ID_ASC',
  EventSeriesBySeriesIdSponsorsIdDesc = 'EVENT_SERIES_BY_SERIES_ID__SPONSORS_ID_DESC',
  EventSeriesBySeriesIdStatusAsc = 'EVENT_SERIES_BY_SERIES_ID__STATUS_ASC',
  EventSeriesBySeriesIdStatusDesc = 'EVENT_SERIES_BY_SERIES_ID__STATUS_DESC',
  EventSeriesBySeriesIdSubeventsLocalIdAsc = 'EVENT_SERIES_BY_SERIES_ID__SUBEVENTS_LOCAL_ID_ASC',
  EventSeriesBySeriesIdSubeventsLocalIdDesc = 'EVENT_SERIES_BY_SERIES_ID__SUBEVENTS_LOCAL_ID_DESC',
  EventSeriesBySeriesIdSubeventsOtherLocationsIdAsc = 'EVENT_SERIES_BY_SERIES_ID__SUBEVENTS_OTHER_LOCATIONS_ID_ASC',
  EventSeriesBySeriesIdSubeventsOtherLocationsIdDesc = 'EVENT_SERIES_BY_SERIES_ID__SUBEVENTS_OTHER_LOCATIONS_ID_DESC',
  EventSeriesBySeriesIdSubtitleAsc = 'EVENT_SERIES_BY_SERIES_ID__SUBTITLE_ASC',
  EventSeriesBySeriesIdSubtitleDesc = 'EVENT_SERIES_BY_SERIES_ID__SUBTITLE_DESC',
  EventSeriesBySeriesIdTypeAsc = 'EVENT_SERIES_BY_SERIES_ID__TYPE_ASC',
  EventSeriesBySeriesIdTypeDesc = 'EVENT_SERIES_BY_SERIES_ID__TYPE_DESC',
  EventSeriesBySeriesIdWebsitesIdAsc = 'EVENT_SERIES_BY_SERIES_ID__WEBSITES_ID_ASC',
  EventSeriesBySeriesIdWebsitesIdDesc = 'EVENT_SERIES_BY_SERIES_ID__WEBSITES_ID_DESC',
  EventVariantsByEventIdCountAsc = 'EVENT_VARIANTS_BY_EVENT_ID__COUNT_ASC',
  EventVariantsByEventIdCountDesc = 'EVENT_VARIANTS_BY_EVENT_ID__COUNT_DESC',
  ExecutionYearAsc = 'EXECUTION_YEAR_ASC',
  ExecutionYearDesc = 'EXECUTION_YEAR_DESC',
  ExternalDataIdAsc = 'EXTERNAL_DATA_ID_ASC',
  ExternalDataIdDesc = 'EXTERNAL_DATA_ID_DESC',
  ExtraDocumentsIdAsc = 'EXTRA_DOCUMENTS_ID_ASC',
  ExtraDocumentsIdDesc = 'EXTRA_DOCUMENTS_ID_DESC',
  ExtraSystemsIdAsc = 'EXTRA_SYSTEMS_ID_ASC',
  ExtraSystemsIdDesc = 'EXTRA_SYSTEMS_ID_DESC',
  FairAbroadCooperationIdAsc = 'FAIR_ABROAD_COOPERATION_ID_ASC',
  FairAbroadCooperationIdDesc = 'FAIR_ABROAD_COOPERATION_ID_DESC',
  FairAbroadIdAsc = 'FAIR_ABROAD_ID_ASC',
  FairAbroadIdDesc = 'FAIR_ABROAD_ID_DESC',
  FavoredParallelsExternalIdAsc = 'FAVORED_PARALLELS_EXTERNAL_ID_ASC',
  FavoredParallelsExternalIdDesc = 'FAVORED_PARALLELS_EXTERNAL_ID_DESC',
  FavoredParallelsInternalIdAsc = 'FAVORED_PARALLELS_INTERNAL_ID_ASC',
  FavoredParallelsInternalIdDesc = 'FAVORED_PARALLELS_INTERNAL_ID_DESC',
  FileByIconIdIdAsc = 'FILE_BY_ICON_ID__ID_ASC',
  FileByIconIdIdDesc = 'FILE_BY_ICON_ID__ID_DESC',
  FileByIconIdMimeTypeAsc = 'FILE_BY_ICON_ID__MIME_TYPE_ASC',
  FileByIconIdMimeTypeDesc = 'FILE_BY_ICON_ID__MIME_TYPE_DESC',
  FileByIconIdSizeAsc = 'FILE_BY_ICON_ID__SIZE_ASC',
  FileByIconIdSizeDesc = 'FILE_BY_ICON_ID__SIZE_DESC',
  FileByIconIdUrl128Asc = 'FILE_BY_ICON_ID__URL128_ASC',
  FileByIconIdUrl128Desc = 'FILE_BY_ICON_ID__URL128_DESC',
  FileByIconIdUrl512Asc = 'FILE_BY_ICON_ID__URL512_ASC',
  FileByIconIdUrl512Desc = 'FILE_BY_ICON_ID__URL512_DESC',
  FileByIconIdUrlAsc = 'FILE_BY_ICON_ID__URL_ASC',
  FileByIconIdUrlDesc = 'FILE_BY_ICON_ID__URL_DESC',
  IconIdAsc = 'ICON_ID_ASC',
  IconIdDesc = 'ICON_ID_DESC',
  IconUploadAsc = 'ICON_UPLOAD_ASC',
  IconUploadDesc = 'ICON_UPLOAD_DESC',
  IconUploadStatusAsc = 'ICON_UPLOAD_STATUS_ASC',
  IconUploadStatusDesc = 'ICON_UPLOAD_STATUS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InternalDataIdAsc = 'INTERNAL_DATA_ID_ASC',
  InternalDataIdDesc = 'INTERNAL_DATA_ID_DESC',
  MultilinkByCompetitionInternationalIdIdAsc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__ID_ASC',
  MultilinkByCompetitionInternationalIdIdDesc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__ID_DESC',
  MultilinkByCompetitionInternationalIdNameAsc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__NAME_ASC',
  MultilinkByCompetitionInternationalIdNameDesc = 'MULTILINK_BY_COMPETITION_INTERNATIONAL_ID__NAME_DESC',
  MultilinkByCompetitionNationalIdIdAsc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__ID_ASC',
  MultilinkByCompetitionNationalIdIdDesc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__ID_DESC',
  MultilinkByCompetitionNationalIdNameAsc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__NAME_ASC',
  MultilinkByCompetitionNationalIdNameDesc = 'MULTILINK_BY_COMPETITION_NATIONAL_ID__NAME_DESC',
  MultilinkByExternalDataIdIdAsc = 'MULTILINK_BY_EXTERNAL_DATA_ID__ID_ASC',
  MultilinkByExternalDataIdIdDesc = 'MULTILINK_BY_EXTERNAL_DATA_ID__ID_DESC',
  MultilinkByExternalDataIdNameAsc = 'MULTILINK_BY_EXTERNAL_DATA_ID__NAME_ASC',
  MultilinkByExternalDataIdNameDesc = 'MULTILINK_BY_EXTERNAL_DATA_ID__NAME_DESC',
  MultilinkByExtraDocumentsIdIdAsc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__ID_ASC',
  MultilinkByExtraDocumentsIdIdDesc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__ID_DESC',
  MultilinkByExtraDocumentsIdNameAsc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__NAME_ASC',
  MultilinkByExtraDocumentsIdNameDesc = 'MULTILINK_BY_EXTRA_DOCUMENTS_ID__NAME_DESC',
  MultilinkByExtraSystemsIdIdAsc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__ID_ASC',
  MultilinkByExtraSystemsIdIdDesc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__ID_DESC',
  MultilinkByExtraSystemsIdNameAsc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__NAME_ASC',
  MultilinkByExtraSystemsIdNameDesc = 'MULTILINK_BY_EXTRA_SYSTEMS_ID__NAME_DESC',
  MultilinkByFairAbroadCooperationIdIdAsc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__ID_ASC',
  MultilinkByFairAbroadCooperationIdIdDesc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__ID_DESC',
  MultilinkByFairAbroadCooperationIdNameAsc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__NAME_ASC',
  MultilinkByFairAbroadCooperationIdNameDesc = 'MULTILINK_BY_FAIR_ABROAD_COOPERATION_ID__NAME_DESC',
  MultilinkByFairAbroadIdIdAsc = 'MULTILINK_BY_FAIR_ABROAD_ID__ID_ASC',
  MultilinkByFairAbroadIdIdDesc = 'MULTILINK_BY_FAIR_ABROAD_ID__ID_DESC',
  MultilinkByFairAbroadIdNameAsc = 'MULTILINK_BY_FAIR_ABROAD_ID__NAME_ASC',
  MultilinkByFairAbroadIdNameDesc = 'MULTILINK_BY_FAIR_ABROAD_ID__NAME_DESC',
  MultilinkByFavoredParallelsExternalIdIdAsc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__ID_ASC',
  MultilinkByFavoredParallelsExternalIdIdDesc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__ID_DESC',
  MultilinkByFavoredParallelsExternalIdNameAsc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__NAME_ASC',
  MultilinkByFavoredParallelsExternalIdNameDesc = 'MULTILINK_BY_FAVORED_PARALLELS_EXTERNAL_ID__NAME_DESC',
  MultilinkByFavoredParallelsInternalIdIdAsc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__ID_ASC',
  MultilinkByFavoredParallelsInternalIdIdDesc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__ID_DESC',
  MultilinkByFavoredParallelsInternalIdNameAsc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__NAME_ASC',
  MultilinkByFavoredParallelsInternalIdNameDesc = 'MULTILINK_BY_FAVORED_PARALLELS_INTERNAL_ID__NAME_DESC',
  MultilinkByInternalDataIdIdAsc = 'MULTILINK_BY_INTERNAL_DATA_ID__ID_ASC',
  MultilinkByInternalDataIdIdDesc = 'MULTILINK_BY_INTERNAL_DATA_ID__ID_DESC',
  MultilinkByInternalDataIdNameAsc = 'MULTILINK_BY_INTERNAL_DATA_ID__NAME_ASC',
  MultilinkByInternalDataIdNameDesc = 'MULTILINK_BY_INTERNAL_DATA_ID__NAME_DESC',
  MultilinkByOtherCompetitionInternationalIdIdAsc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__ID_ASC',
  MultilinkByOtherCompetitionInternationalIdIdDesc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__ID_DESC',
  MultilinkByOtherCompetitionInternationalIdNameAsc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__NAME_ASC',
  MultilinkByOtherCompetitionInternationalIdNameDesc = 'MULTILINK_BY_OTHER_COMPETITION_INTERNATIONAL_ID__NAME_DESC',
  MultilinkByOtherCompetitionNationalIdIdAsc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__ID_ASC',
  MultilinkByOtherCompetitionNationalIdIdDesc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__ID_DESC',
  MultilinkByOtherCompetitionNationalIdNameAsc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__NAME_ASC',
  MultilinkByOtherCompetitionNationalIdNameDesc = 'MULTILINK_BY_OTHER_COMPETITION_NATIONAL_ID__NAME_DESC',
  MultilinkByOtherLinksExternalIdIdAsc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__ID_ASC',
  MultilinkByOtherLinksExternalIdIdDesc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__ID_DESC',
  MultilinkByOtherLinksExternalIdNameAsc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__NAME_ASC',
  MultilinkByOtherLinksExternalIdNameDesc = 'MULTILINK_BY_OTHER_LINKS_EXTERNAL_ID__NAME_DESC',
  MultilinkByOtherLinksInternalIdIdAsc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__ID_ASC',
  MultilinkByOtherLinksInternalIdIdDesc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__ID_DESC',
  MultilinkByOtherLinksInternalIdNameAsc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__NAME_ASC',
  MultilinkByOtherLinksInternalIdNameDesc = 'MULTILINK_BY_OTHER_LINKS_INTERNAL_ID__NAME_DESC',
  MultilinkBySubeventsLocalIdIdAsc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__ID_ASC',
  MultilinkBySubeventsLocalIdIdDesc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__ID_DESC',
  MultilinkBySubeventsLocalIdNameAsc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__NAME_ASC',
  MultilinkBySubeventsLocalIdNameDesc = 'MULTILINK_BY_SUBEVENTS_LOCAL_ID__NAME_DESC',
  MultilinkBySubeventsOtherLocationsIdIdAsc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__ID_ASC',
  MultilinkBySubeventsOtherLocationsIdIdDesc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__ID_DESC',
  MultilinkBySubeventsOtherLocationsIdNameAsc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__NAME_ASC',
  MultilinkBySubeventsOtherLocationsIdNameDesc = 'MULTILINK_BY_SUBEVENTS_OTHER_LOCATIONS_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  OtherCompetitionInternationalIdAsc = 'OTHER_COMPETITION_INTERNATIONAL_ID_ASC',
  OtherCompetitionInternationalIdDesc = 'OTHER_COMPETITION_INTERNATIONAL_ID_DESC',
  OtherCompetitionNationalIdAsc = 'OTHER_COMPETITION_NATIONAL_ID_ASC',
  OtherCompetitionNationalIdDesc = 'OTHER_COMPETITION_NATIONAL_ID_DESC',
  OtherLinksExternalIdAsc = 'OTHER_LINKS_EXTERNAL_ID_ASC',
  OtherLinksExternalIdDesc = 'OTHER_LINKS_EXTERNAL_ID_DESC',
  OtherLinksInternalIdAsc = 'OTHER_LINKS_INTERNAL_ID_ASC',
  OtherLinksInternalIdDesc = 'OTHER_LINKS_INTERNAL_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResponsibleAsc = 'RESPONSIBLE_ASC',
  ResponsibleDesc = 'RESPONSIBLE_DESC',
  SeriesIdAsc = 'SERIES_ID_ASC',
  SeriesIdDesc = 'SERIES_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubeventsLocalIdAsc = 'SUBEVENTS_LOCAL_ID_ASC',
  SubeventsLocalIdDesc = 'SUBEVENTS_LOCAL_ID_DESC',
  SubeventsOtherLocationsIdAsc = 'SUBEVENTS_OTHER_LOCATIONS_ID_ASC',
  SubeventsOtherLocationsIdDesc = 'SUBEVENTS_OTHER_LOCATIONS_ID_DESC',
  SubtitleAsc = 'SUBTITLE_ASC',
  SubtitleDesc = 'SUBTITLE_DESC',
  TeamChangesAsc = 'TEAM_CHANGES_ASC',
  TeamChangesDesc = 'TEAM_CHANGES_DESC'
}

export type ExternalEvent = {
  __typename?: 'ExternalEvent';
  contact: Scalars['String'];
  description: Scalars['String'];
  /** Reads and enables pagination through a set of `ExternalEventEventLocationVisibility`. */
  externalEventEventLocationVisibilitiesByEventId: ExternalEventEventLocationVisibilitiesConnection;
  /** Reads and enables pagination through a set of `ExternalEventVariant`. */
  externalEventVariantsByEventId: ExternalEventVariantsConnection;
  id: Scalars['UUID'];
  /** Reads a single `Multilink` that is related to this `ExternalEvent`. */
  links: Multilink;
  linksId: Scalars['UUID'];
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEvent`. */
  location?: Maybe<ExternalEventLocation>;
  locationId?: Maybe<Scalars['UUID']>;
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `ExternalEventSeries` that is related to this `ExternalEvent`. */
  series: ExternalEventSeries;
  seriesId: Scalars['UUID'];
  status: ExternalEventEventStatus;
  year: Scalars['Int'];
};


export type ExternalEventExternalEventEventLocationVisibilitiesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventEventLocationVisibilityCondition>;
  filter?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventEventLocationVisibilitiesOrderBy>>;
};


export type ExternalEventExternalEventVariantsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventVariantCondition>;
  filter?: InputMaybe<ExternalEventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

export type ExternalEventAllocation = {
  __typename?: 'ExternalEventAllocation';
  end: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `ExternalEventAllocationPhase`. */
  externalEventAllocationPhasesByAllocationId: ExternalEventAllocationPhasesConnection;
  /** Reads and enables pagination through a set of `ExternalEventVariant`. */
  externalEventVariantsByReferenceExternalEventAllocationId: ExternalEventVariantsConnection;
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventAllocation`. */
  location: ExternalEventLocation;
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  /** Reads a single `ExternalEventVariant` that is related to this `ExternalEventAllocation`. */
  variant: ExternalEventVariant;
  variantId: Scalars['UUID'];
};


export type ExternalEventAllocationExternalEventAllocationPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationPhaseCondition>;
  filter?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationPhasesOrderBy>>;
};


export type ExternalEventAllocationExternalEventVariantsByReferenceExternalEventAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventVariantCondition>;
  filter?: InputMaybe<ExternalEventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/**
 * A condition to be used against `ExternalEventAllocation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventAllocationCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `variantId` field. */
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `externalEventAllocationDuplicate` mutation. */
export type ExternalEventAllocationDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `externalEventAllocationDuplicate` mutation. */
export type ExternalEventAllocationDuplicatePayload = {
  __typename?: 'ExternalEventAllocationDuplicatePayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our `externalEventAllocationDuplicate` mutation. */
export type ExternalEventAllocationDuplicatePayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/** The fields on `externalEventAllocation` to look up the row to connect. */
export type ExternalEventAllocationExternalEventAllocationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventAllocation` to look up the row to delete. */
export type ExternalEventAllocationExternalEventAllocationPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEventAllocation` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventAllocationFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalEventAllocationPhasesByAllocationId` relation. */
  externalEventAllocationPhasesByAllocationId?: InputMaybe<ExternalEventAllocationToManyExternalEventAllocationPhaseFilter>;
  /** Some related `externalEventAllocationPhasesByAllocationId` exist. */
  externalEventAllocationPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventVariantsByReferenceExternalEventAllocationId` relation. */
  externalEventVariantsByReferenceExternalEventAllocationId?: InputMaybe<ExternalEventAllocationToManyExternalEventVariantFilter>;
  /** Some related `externalEventVariantsByReferenceExternalEventAllocationId` exist. */
  externalEventVariantsByReferenceExternalEventAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `location` relation. */
  location?: InputMaybe<ExternalEventLocationFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventAllocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventAllocationFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `variant` relation. */
  variant?: InputMaybe<ExternalEventVariantFilter>;
  /** Filter by the object’s `variantId` field. */
  variantId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ExternalEventAllocation` */
export type ExternalEventAllocationInput = {
  end: Scalars['Datetime'];
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start: Scalars['Datetime'];
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** The `externalEventAllocation` to be created by this mutation. */
export type ExternalEventAllocationLocationIdExternalEventLocationIExternalEventAllocationCreateInput = {
  end: Scalars['Datetime'];
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** The `externalEventLocation` to be created by this mutation. */
export type ExternalEventAllocationLocationIdExternalEventLocationIExternalEventLocationCreateInput = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index: Scalars['Int'];
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `externalEventLocation` in the `ExternalEventAllocationInput` mutation. */
export type ExternalEventAllocationLocationIdExternalEventLocationIInput = {
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventLocationExternalEventLocationPkeyConnect>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  connectByName?: InputMaybe<ExternalEventLocationExternalEventLocationNameKeyConnect>;
  /** A `ExternalEventLocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIExternalEventLocationCreateInput>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventLocationExternalEventLocationPkeyDelete>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  deleteByName?: InputMaybe<ExternalEventLocationExternalEventLocationNameKeyDelete>;
  /** The primary key(s) and patch data for `externalEventLocation` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIUsingExternalEventLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `externalEventLocation` for the far side of the relationship. */
  updateByName?: InputMaybe<ExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIUsingExternalEventLocationNameKeyUpdate>;
};

/** Input for the nested mutation of `externalEventAllocation` in the `ExternalEventLocationInput` mutation. */
export type ExternalEventAllocationLocationIdExternalEventLocationIInverseInput = {
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventAllocationExternalEventAllocationPkeyConnect>>;
  /** A `ExternalEventAllocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventAllocationLocationIdExternalEventLocationIExternalEventAllocationCreateInput>>;
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventAllocationExternalEventAllocationPkeyDelete>>;
  /** Flag indicating whether all other `externalEventAllocation` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventAllocation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIUsingExternalEventAllocationPkeyUpdate>>;
};

/** The fields on `externalEventAllocation` to look up the row to update. */
export type ExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIUsingExternalEventAllocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
  patch: UpdateExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIPatch;
};

/** The fields on `externalEventAllocation` to look up the row to update. */
export type ExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdUsingExternalEventAllocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
  patch: UpdateExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdPatch;
};

/** The fields on `externalEventAllocation` to look up the row to update. */
export type ExternalEventAllocationOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
  patch: UpdateExternalEventAllocationOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlPatch;
};

/** The fields on `externalEventAllocation` to look up the row to update. */
export type ExternalEventAllocationOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEUsingExternalEventAllocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
  patch: UpdateExternalEventAllocationOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEPatch;
};

/** Represents an update to a `ExternalEventAllocation`. Fields that are set will be updated. */
export type ExternalEventAllocationPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  variantId?: InputMaybe<Scalars['UUID']>;
};

export type ExternalEventAllocationPhase = {
  __typename?: 'ExternalEventAllocationPhase';
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventAllocationPhase`. */
  allocation: ExternalEventAllocation;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `ExternalEventAllocationUsage` that is related to this `ExternalEventAllocationPhase`. */
  usage: ExternalEventAllocationUsage;
  usageId: Scalars['UUID'];
};

/** The `externalEventAllocation` to be created by this mutation. */
export type ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationCreateInput = {
  end: Scalars['Datetime'];
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start: Scalars['Datetime'];
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** The `externalEventAllocationPhase` to be created by this mutation. */
export type ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput = {
  duration: IntervalInput;
  externalEventAllocationToAllocationId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInput>;
  externalEventAllocationUsageToUsageId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `externalEventAllocation` in the `ExternalEventAllocationPhaseInput` mutation. */
export type ExternalEventAllocationPhaseAllocationIdExternalEventAlInput = {
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventAllocationExternalEventAllocationPkeyConnect>;
  /** A `ExternalEventAllocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationCreateInput>;
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventAllocationExternalEventAllocationPkeyDelete>;
  /** The primary key(s) and patch data for `externalEventAllocation` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventAllocationOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPkeyUpdate>;
};

/** Input for the nested mutation of `externalEventAllocationPhase` in the `ExternalEventAllocationInput` mutation. */
export type ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput = {
  /** The primary key(s) for `externalEventAllocationPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyConnect>>;
  /** A `ExternalEventAllocationPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput>>;
  /** The primary key(s) for `externalEventAllocationPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyDelete>>;
  /** Flag indicating whether all other `externalEventAllocationPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventAllocationPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPhasePkeyUpdate>>;
};

/**
 * A condition to be used against `ExternalEventAllocationPhase` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventAllocationPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `externalEventAllocationPhase` to look up the row to connect. */
export type ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventAllocationPhase` to look up the row to delete. */
export type ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEventAllocationPhase` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<ExternalEventAllocationFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventAllocationPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventAllocationPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<ExternalEventAllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ExternalEventAllocationPhase` */
export type ExternalEventAllocationPhaseInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  externalEventAllocationToAllocationId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInput>;
  externalEventAllocationUsageToUsageId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `externalEventAllocationPhase` to look up the row to update. */
export type ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocationPhase` being updated. */
  patch: UpdateExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlPatch;
};

/** The fields on `externalEventAllocationPhase` to look up the row to update. */
export type ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocationPhase` being updated. */
  patch: UpdateExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch;
};

/** Represents an update to a `ExternalEventAllocationPhase`. Fields that are set will be updated. */
export type ExternalEventAllocationPhasePatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  externalEventAllocationToAllocationId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInput>;
  externalEventAllocationUsageToUsageId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The `externalEventAllocationPhase` to be created by this mutation. */
export type ExternalEventAllocationPhaseUsageIdExternalEventAllocatExternalEventAllocationPhaseCreateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  externalEventAllocationToAllocationId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInput>;
  externalEventAllocationUsageToUsageId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `externalEventAllocationUsage` to be created by this mutation. */
export type ExternalEventAllocationPhaseUsageIdExternalEventAllocatExternalEventAllocationUsageCreateInput = {
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: ExternalEventAllocationUsageType;
};

/** Input for the nested mutation of `externalEventAllocationUsage` in the `ExternalEventAllocationPhaseInput` mutation. */
export type ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput = {
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsagePkeyConnect>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsageTypeKeyConnect>;
  /** A `ExternalEventAllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatExternalEventAllocationUsageCreateInput>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsagePkeyDelete>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `externalEventAllocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<ExternalEventAllocationUsageExternalEventAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `externalEventAllocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `externalEventAllocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `externalEventAllocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `externalEventAllocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `externalEventAllocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `externalEventAllocationPhase` in the `ExternalEventAllocationUsageInput` mutation. */
export type ExternalEventAllocationPhaseUsageIdExternalEventAllocatInverseInput = {
  /** The primary key(s) for `externalEventAllocationPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyConnect>>;
  /** A `ExternalEventAllocationPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventAllocationPhaseUsageIdExternalEventAllocatExternalEventAllocationPhaseCreateInput>>;
  /** The primary key(s) for `externalEventAllocationPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyDelete>>;
  /** Flag indicating whether all other `externalEventAllocationPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventAllocationPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationPhasePkeyUpdate>>;
};

/** A connection to a list of `ExternalEventAllocationPhase` values. */
export type ExternalEventAllocationPhasesConnection = {
  __typename?: 'ExternalEventAllocationPhasesConnection';
  /** A list of edges which contains the `ExternalEventAllocationPhase` and cursor to aid in pagination. */
  edges: Array<ExternalEventAllocationPhasesEdge>;
  /** A list of `ExternalEventAllocationPhase` objects. */
  nodes: Array<ExternalEventAllocationPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventAllocationPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventAllocationPhase` edge in the connection. */
export type ExternalEventAllocationPhasesEdge = {
  __typename?: 'ExternalEventAllocationPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventAllocationPhase` at the end of the edge. */
  node: ExternalEventAllocationPhase;
};

/** Methods to use when ordering `ExternalEventAllocationPhase`. */
export enum ExternalEventAllocationPhasesOrderBy {
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  ExternalEventAllocationByAllocationIdEndAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__END_ASC',
  ExternalEventAllocationByAllocationIdEndDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__END_DESC',
  ExternalEventAllocationByAllocationIdIdAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__ID_ASC',
  ExternalEventAllocationByAllocationIdIdDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__ID_DESC',
  ExternalEventAllocationByAllocationIdIsOptionalAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  ExternalEventAllocationByAllocationIdIsOptionalDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  ExternalEventAllocationByAllocationIdLocationIdAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__LOCATION_ID_ASC',
  ExternalEventAllocationByAllocationIdLocationIdDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__LOCATION_ID_DESC',
  ExternalEventAllocationByAllocationIdStartAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__START_ASC',
  ExternalEventAllocationByAllocationIdStartDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__START_DESC',
  ExternalEventAllocationByAllocationIdVariantIdAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__VARIANT_ID_ASC',
  ExternalEventAllocationByAllocationIdVariantIdDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_ALLOCATION_ID__VARIANT_ID_DESC',
  ExternalEventAllocationUsageByUsageIdIdAsc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  ExternalEventAllocationUsageByUsageIdIdDesc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  ExternalEventAllocationUsageByUsageIdIsExecutionAsc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  ExternalEventAllocationUsageByUsageIdIsExecutionDesc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  ExternalEventAllocationUsageByUsageIdNameAsc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  ExternalEventAllocationUsageByUsageIdNameDesc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  ExternalEventAllocationUsageByUsageIdNameShortAsc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  ExternalEventAllocationUsageByUsageIdNameShortDesc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  ExternalEventAllocationUsageByUsageIdPositionAsc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  ExternalEventAllocationUsageByUsageIdPositionDesc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  ExternalEventAllocationUsageByUsageIdTypeAsc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  ExternalEventAllocationUsageByUsageIdTypeDesc = 'EXTERNAL_EVENT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** A filter to be used against many `ExternalEventAllocationPhase` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationToManyExternalEventAllocationPhaseFilter = {
  /** Every related `ExternalEventAllocationPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  /** No related `ExternalEventAllocationPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  /** Some related `ExternalEventAllocationPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventAllocationPhaseFilter>;
};

/** A filter to be used against many `ExternalEventVariant` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationToManyExternalEventVariantFilter = {
  /** Every related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventVariantFilter>;
  /** No related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventVariantFilter>;
  /** Some related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventVariantFilter>;
};

/** All input for the `externalEventAllocationUpdateAndDuplicate` mutation. */
export type ExternalEventAllocationUpdateAndDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  updateAllocation?: InputMaybe<AllocationUpdateInput>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>>>;
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `externalEventAllocationUpdateAndDuplicate` mutation. */
export type ExternalEventAllocationUpdateAndDuplicatePayload = {
  __typename?: 'ExternalEventAllocationUpdateAndDuplicatePayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our `externalEventAllocationUpdateAndDuplicate` mutation. */
export type ExternalEventAllocationUpdateAndDuplicatePayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

export type ExternalEventAllocationUsage = {
  __typename?: 'ExternalEventAllocationUsage';
  /** Reads and enables pagination through a set of `ExternalEventAllocationPhase`. */
  externalEventAllocationPhasesByUsageId: ExternalEventAllocationPhasesConnection;
  id: Scalars['UUID'];
  isExecution: Scalars['Boolean'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: ExternalEventAllocationUsageType;
};


export type ExternalEventAllocationUsageExternalEventAllocationPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationPhaseCondition>;
  filter?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationPhasesOrderBy>>;
};

/**
 * A condition to be used against `ExternalEventAllocationUsage` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventAllocationUsageCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isExecution` field. */
  isExecution?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ExternalEventAllocationUsageType>;
};

/** The fields on `externalEventAllocationUsage` to look up the row to connect. */
export type ExternalEventAllocationUsageExternalEventAllocationUsageNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to delete. */
export type ExternalEventAllocationUsageExternalEventAllocationUsageNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to connect. */
export type ExternalEventAllocationUsageExternalEventAllocationUsageNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to delete. */
export type ExternalEventAllocationUsageExternalEventAllocationUsageNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to connect. */
export type ExternalEventAllocationUsageExternalEventAllocationUsagePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to delete. */
export type ExternalEventAllocationUsageExternalEventAllocationUsagePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to connect. */
export type ExternalEventAllocationUsageExternalEventAllocationUsagePositionKeyConnect = {
  position: Scalars['Int'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to delete. */
export type ExternalEventAllocationUsageExternalEventAllocationUsagePositionKeyDelete = {
  position: Scalars['Int'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to connect. */
export type ExternalEventAllocationUsageExternalEventAllocationUsageTypeKeyConnect = {
  type: ExternalEventAllocationUsageType;
};

/** The fields on `externalEventAllocationUsage` to look up the row to delete. */
export type ExternalEventAllocationUsageExternalEventAllocationUsageTypeKeyDelete = {
  type: ExternalEventAllocationUsageType;
};

/** A filter to be used against `ExternalEventAllocationUsage` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventAllocationUsageFilter>>;
  /** Filter by the object’s `externalEventAllocationPhasesByUsageId` relation. */
  externalEventAllocationPhasesByUsageId?: InputMaybe<ExternalEventAllocationUsageToManyExternalEventAllocationPhaseFilter>;
  /** Some related `externalEventAllocationPhasesByUsageId` exist. */
  externalEventAllocationPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isExecution` field. */
  isExecution?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventAllocationUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventAllocationUsageFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<ExternalEventAllocationUsageTypeFilter>;
};

/** An input for mutations affecting `ExternalEventAllocationUsage` */
export type ExternalEventAllocationUsageInput = {
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  type: ExternalEventAllocationUsageType;
};

/** The fields on `externalEventAllocationUsage` to look up the row to update. */
export type ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventAllocationUsage` being updated. */
  patch: UpdateExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch;
};

/** The fields on `externalEventAllocationUsage` to look up the row to update. */
export type ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventAllocationUsage` being updated. */
  patch: UpdateExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch;
};

/** The fields on `externalEventAllocationUsage` to look up the row to update. */
export type ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventAllocationUsage` being updated. */
  patch: UpdateExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch;
};

/** The fields on `externalEventAllocationUsage` to look up the row to update. */
export type ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `externalEventAllocationUsage` being updated. */
  patch: UpdateExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch;
  position: Scalars['Int'];
};

/** The fields on `externalEventAllocationUsage` to look up the row to update. */
export type ExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatUsingExternalEventAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `externalEventAllocationUsage` being updated. */
  patch: UpdateExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch;
  type: ExternalEventAllocationUsageType;
};

/** Represents an update to a `ExternalEventAllocationUsage`. Fields that are set will be updated. */
export type ExternalEventAllocationUsagePatch = {
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ExternalEventAllocationUsageType>;
};

/** A filter to be used against many `ExternalEventAllocationPhase` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationUsageToManyExternalEventAllocationPhaseFilter = {
  /** Every related `ExternalEventAllocationPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  /** No related `ExternalEventAllocationPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  /** Some related `ExternalEventAllocationPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventAllocationPhaseFilter>;
};

export enum ExternalEventAllocationUsageType {
  ExternalEvent = 'External_Event',
  PostExternalEvent = 'Post_External_Event',
  PreExternalEvent = 'Pre_External_Event'
}

/** A filter to be used against ExternalEventAllocationUsageType fields. All fields are combined with a logical ‘and.’ */
export type ExternalEventAllocationUsageTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ExternalEventAllocationUsageType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ExternalEventAllocationUsageType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ExternalEventAllocationUsageType>>;
};

/** A connection to a list of `ExternalEventAllocationUsage` values. */
export type ExternalEventAllocationUsagesConnection = {
  __typename?: 'ExternalEventAllocationUsagesConnection';
  /** A list of edges which contains the `ExternalEventAllocationUsage` and cursor to aid in pagination. */
  edges: Array<ExternalEventAllocationUsagesEdge>;
  /** A list of `ExternalEventAllocationUsage` objects. */
  nodes: Array<ExternalEventAllocationUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventAllocationUsage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventAllocationUsage` edge in the connection. */
export type ExternalEventAllocationUsagesEdge = {
  __typename?: 'ExternalEventAllocationUsagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventAllocationUsage` at the end of the edge. */
  node: ExternalEventAllocationUsage;
};

/** Methods to use when ordering `ExternalEventAllocationUsage`. */
export enum ExternalEventAllocationUsagesOrderBy {
  ExternalEventAllocationPhasesByUsageIdCountAsc = 'EXTERNAL_EVENT_ALLOCATION_PHASES_BY_USAGE_ID__COUNT_ASC',
  ExternalEventAllocationPhasesByUsageIdCountDesc = 'EXTERNAL_EVENT_ALLOCATION_PHASES_BY_USAGE_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsExecutionAsc = 'IS_EXECUTION_ASC',
  IsExecutionDesc = 'IS_EXECUTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

/** The `externalEventAllocation` to be created by this mutation. */
export type ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventAllocationCreateInput = {
  end: Scalars['Datetime'];
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start: Scalars['Datetime'];
};

/** The `externalEventVariant` to be created by this mutation. */
export type ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** Input for the nested mutation of `externalEventVariant` in the `ExternalEventAllocationInput` mutation. */
export type ExternalEventAllocationVariantIdExternalEventVariantIdInput = {
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<ExternalEventVariantExternalEventVariantEventIdIndexKeyConnect>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventVariantExternalEventVariantPkeyConnect>;
  /** A `ExternalEventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventVariantCreateInput>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<ExternalEventVariantExternalEventVariantEventIdIndexKeyDelete>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventVariantExternalEventVariantPkeyDelete>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<ExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdUsingExternalEventVariantEventIdIndexKeyUpdate>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdUsingExternalEventVariantPkeyUpdate>;
};

/** Input for the nested mutation of `externalEventAllocation` in the `ExternalEventVariantInput` mutation. */
export type ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput = {
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventAllocationExternalEventAllocationPkeyConnect>>;
  /** A `ExternalEventAllocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventAllocationCreateInput>>;
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventAllocationExternalEventAllocationPkeyDelete>>;
  /** Flag indicating whether all other `externalEventAllocation` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventAllocation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdUsingExternalEventAllocationPkeyUpdate>>;
};

/** A connection to a list of `ExternalEventAllocation` values. */
export type ExternalEventAllocationsConnection = {
  __typename?: 'ExternalEventAllocationsConnection';
  /** A list of edges which contains the `ExternalEventAllocation` and cursor to aid in pagination. */
  edges: Array<ExternalEventAllocationsEdge>;
  /** A list of `ExternalEventAllocation` objects. */
  nodes: Array<ExternalEventAllocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventAllocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventAllocation` edge in the connection. */
export type ExternalEventAllocationsEdge = {
  __typename?: 'ExternalEventAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventAllocation` at the end of the edge. */
  node: ExternalEventAllocation;
};

/** Methods to use when ordering `ExternalEventAllocation`. */
export enum ExternalEventAllocationsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  ExternalEventAllocationPhasesByAllocationIdCountAsc = 'EXTERNAL_EVENT_ALLOCATION_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  ExternalEventAllocationPhasesByAllocationIdCountDesc = 'EXTERNAL_EVENT_ALLOCATION_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  ExternalEventLocationByLocationIdIdAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__ID_ASC',
  ExternalEventLocationByLocationIdIdDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__ID_DESC',
  ExternalEventLocationByLocationIdIndexAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__INDEX_ASC',
  ExternalEventLocationByLocationIdIndexDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__INDEX_DESC',
  ExternalEventLocationByLocationIdIsNationalDefaultAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__IS_NATIONAL_DEFAULT_ASC',
  ExternalEventLocationByLocationIdIsNationalDefaultDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__IS_NATIONAL_DEFAULT_DESC',
  ExternalEventLocationByLocationIdNameAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__NAME_ASC',
  ExternalEventLocationByLocationIdNameDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__NAME_DESC',
  ExternalEventVariantsByReferenceExternalEventAllocationIdCountAsc = 'EXTERNAL_EVENT_VARIANTS_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__COUNT_ASC',
  ExternalEventVariantsByReferenceExternalEventAllocationIdCountDesc = 'EXTERNAL_EVENT_VARIANTS_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__COUNT_DESC',
  ExternalEventVariantByVariantIdChangesIdAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__CHANGES_ID_ASC',
  ExternalEventVariantByVariantIdChangesIdDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__CHANGES_ID_DESC',
  ExternalEventVariantByVariantIdCreatedAtAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__CREATED_AT_ASC',
  ExternalEventVariantByVariantIdCreatedAtDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__CREATED_AT_DESC',
  ExternalEventVariantByVariantIdDescriptionAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__DESCRIPTION_ASC',
  ExternalEventVariantByVariantIdDescriptionDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__DESCRIPTION_DESC',
  ExternalEventVariantByVariantIdEventIdAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__EVENT_ID_ASC',
  ExternalEventVariantByVariantIdEventIdDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__EVENT_ID_DESC',
  ExternalEventVariantByVariantIdIdAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__ID_ASC',
  ExternalEventVariantByVariantIdIdDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__ID_DESC',
  ExternalEventVariantByVariantIdIndexAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__INDEX_ASC',
  ExternalEventVariantByVariantIdIndexDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__INDEX_DESC',
  ExternalEventVariantByVariantIdIsCurrentAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__IS_CURRENT_ASC',
  ExternalEventVariantByVariantIdIsCurrentDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__IS_CURRENT_DESC',
  ExternalEventVariantByVariantIdNameAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__NAME_ASC',
  ExternalEventVariantByVariantIdNameDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__NAME_DESC',
  ExternalEventVariantByVariantIdReferenceExternalEventAllocationIdAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID_ASC',
  ExternalEventVariantByVariantIdReferenceExternalEventAllocationIdDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID_DESC',
  ExternalEventVariantByVariantIdStatusAsc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__STATUS_ASC',
  ExternalEventVariantByVariantIdStatusDesc = 'EXTERNAL_EVENT_VARIANT_BY_VARIANT_ID__STATUS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  VariantIdAsc = 'VARIANT_ID_ASC',
  VariantIdDesc = 'VARIANT_ID_DESC'
}

/**
 * A condition to be used against `ExternalEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventCondition = {
  /** Checks for equality with the object’s `contact` field. */
  contact?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `linksId` field. */
  linksId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `seriesId` field. */
  seriesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ExternalEventEventStatus>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ExternalEventEventLocationVisibility` values. */
export type ExternalEventEventLocationVisibilitiesConnection = {
  __typename?: 'ExternalEventEventLocationVisibilitiesConnection';
  /** A list of edges which contains the `ExternalEventEventLocationVisibility` and cursor to aid in pagination. */
  edges: Array<ExternalEventEventLocationVisibilitiesEdge>;
  /** A list of `ExternalEventEventLocationVisibility` objects. */
  nodes: Array<ExternalEventEventLocationVisibility>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventEventLocationVisibility` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventEventLocationVisibility` edge in the connection. */
export type ExternalEventEventLocationVisibilitiesEdge = {
  __typename?: 'ExternalEventEventLocationVisibilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventEventLocationVisibility` at the end of the edge. */
  node: ExternalEventEventLocationVisibility;
};

/** Methods to use when ordering `ExternalEventEventLocationVisibility`. */
export enum ExternalEventEventLocationVisibilitiesOrderBy {
  EventIdAsc = 'EVENT_ID_ASC',
  EventIdDesc = 'EVENT_ID_DESC',
  ExternalEventByEventIdContactAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__CONTACT_ASC',
  ExternalEventByEventIdContactDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__CONTACT_DESC',
  ExternalEventByEventIdDescriptionAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__DESCRIPTION_ASC',
  ExternalEventByEventIdDescriptionDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__DESCRIPTION_DESC',
  ExternalEventByEventIdIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__ID_ASC',
  ExternalEventByEventIdIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__ID_DESC',
  ExternalEventByEventIdLinksIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__LINKS_ID_ASC',
  ExternalEventByEventIdLinksIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__LINKS_ID_DESC',
  ExternalEventByEventIdLocationIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__LOCATION_ID_ASC',
  ExternalEventByEventIdLocationIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__LOCATION_ID_DESC',
  ExternalEventByEventIdNameLongAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_LONG_ASC',
  ExternalEventByEventIdNameLongDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_LONG_DESC',
  ExternalEventByEventIdNameShortAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_SHORT_ASC',
  ExternalEventByEventIdNameShortDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_SHORT_DESC',
  ExternalEventByEventIdSeriesIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__SERIES_ID_ASC',
  ExternalEventByEventIdSeriesIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__SERIES_ID_DESC',
  ExternalEventByEventIdStatusAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__STATUS_ASC',
  ExternalEventByEventIdStatusDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__STATUS_DESC',
  ExternalEventByEventIdYearAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__YEAR_ASC',
  ExternalEventByEventIdYearDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__YEAR_DESC',
  ExternalEventLocationByLocationIdIdAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__ID_ASC',
  ExternalEventLocationByLocationIdIdDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__ID_DESC',
  ExternalEventLocationByLocationIdIndexAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__INDEX_ASC',
  ExternalEventLocationByLocationIdIndexDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__INDEX_DESC',
  ExternalEventLocationByLocationIdIsNationalDefaultAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__IS_NATIONAL_DEFAULT_ASC',
  ExternalEventLocationByLocationIdIsNationalDefaultDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__IS_NATIONAL_DEFAULT_DESC',
  ExternalEventLocationByLocationIdNameAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__NAME_ASC',
  ExternalEventLocationByLocationIdNameDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VisibilityAsc = 'VISIBILITY_ASC',
  VisibilityDesc = 'VISIBILITY_DESC'
}

export type ExternalEventEventLocationVisibility = {
  __typename?: 'ExternalEventEventLocationVisibility';
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventEventLocationVisibility`. */
  event: ExternalEvent;
  eventId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventEventLocationVisibility`. */
  location: ExternalEventLocation;
  locationId: Scalars['UUID'];
  visibility: ExternalEventLocationVisibility;
};

/**
 * A condition to be used against `ExternalEventEventLocationVisibility` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventEventLocationVisibilityCondition = {
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

/** The `externalEvent` to be created by this mutation. */
export type ExternalEventEventLocationVisibilityEventIdExternalEvenExternalEventCreateInput = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year: Scalars['Int'];
};

/** The `externalEventEventLocationVisibility` to be created by this mutation. */
export type ExternalEventEventLocationVisibilityEventIdExternalEvenExternalEventEventLocationVisibilityCreateInput = {
  externalEventLocationToLocationId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInput>;
  externalEventToEventId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInput>;
  id?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

/** Input for the nested mutation of `externalEvent` in the `ExternalEventEventLocationVisibilityInput` mutation. */
export type ExternalEventEventLocationVisibilityEventIdExternalEvenInput = {
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventExternalEventPkeyConnect>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ExternalEventExternalEventNameShortKeyConnect>;
  /** A `ExternalEventInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenExternalEventCreateInput>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventExternalEventPkeyDelete>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ExternalEventExternalEventNameShortKeyDelete>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventPkeyUpdate>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventNameShortKeyUpdate>;
};

/** Input for the nested mutation of `externalEventEventLocationVisibility` in the `ExternalEventInput` mutation. */
export type ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput = {
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  connectByEventIdAndLocationId?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityEventIdLocationIdKConnect>>;
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityPkeyConnect>>;
  /** A `ExternalEventEventLocationVisibilityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventEventLocationVisibilityEventIdExternalEvenExternalEventEventLocationVisibilityCreateInput>>;
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  deleteByEventIdAndLocationId?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityEventIdLocationIdKDelete>>;
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityPkeyDelete>>;
  /** Flag indicating whether all other `externalEventEventLocationVisibility` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventEventLocationVisibility` for the far side of the relationship. */
  updateByEventIdAndLocationId?: InputMaybe<Array<ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventEventLocationVisibilityEventIdLocationIdKUpdate>>;
  /** The primary key(s) and patch data for `externalEventEventLocationVisibility` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventEventLocationVisibilityPkeyUpdate>>;
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to connect. */
export type ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityEventIdLocationIdKConnect = {
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to delete. */
export type ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityEventIdLocationIdKDelete = {
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to connect. */
export type ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to delete. */
export type ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEventEventLocationVisibility` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventEventLocationVisibilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventEventLocationVisibilityFilter>>;
  /** Filter by the object’s `event` relation. */
  event?: InputMaybe<ExternalEventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `location` relation. */
  location?: InputMaybe<ExternalEventLocationFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventEventLocationVisibilityFilter>>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<ExternalEventLocationVisibilityFilter>;
};

/** An input for mutations affecting `ExternalEventEventLocationVisibility` */
export type ExternalEventEventLocationVisibilityInput = {
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInput>;
  externalEventToEventId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInput>;
  id?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

/** The `externalEventEventLocationVisibility` to be created by this mutation. */
export type ExternalEventEventLocationVisibilityLocationIdExternalEExternalEventEventLocationVisibilityCreateInput = {
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInput>;
  externalEventToEventId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInput>;
  id?: InputMaybe<Scalars['UUID']>;
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

/** The `externalEventLocation` to be created by this mutation. */
export type ExternalEventEventLocationVisibilityLocationIdExternalEExternalEventLocationCreateInput = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index: Scalars['Int'];
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `externalEventLocation` in the `ExternalEventEventLocationVisibilityInput` mutation. */
export type ExternalEventEventLocationVisibilityLocationIdExternalEInput = {
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventLocationExternalEventLocationPkeyConnect>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  connectByName?: InputMaybe<ExternalEventLocationExternalEventLocationNameKeyConnect>;
  /** A `ExternalEventLocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEExternalEventLocationCreateInput>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventLocationExternalEventLocationPkeyDelete>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  deleteByName?: InputMaybe<ExternalEventLocationExternalEventLocationNameKeyDelete>;
  /** The primary key(s) and patch data for `externalEventLocation` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `externalEventLocation` for the far side of the relationship. */
  updateByName?: InputMaybe<ExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventLocationNameKeyUpdate>;
};

/** Input for the nested mutation of `externalEventEventLocationVisibility` in the `ExternalEventLocationInput` mutation. */
export type ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput = {
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  connectByEventIdAndLocationId?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityEventIdLocationIdKConnect>>;
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityPkeyConnect>>;
  /** A `ExternalEventEventLocationVisibilityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventEventLocationVisibilityLocationIdExternalEExternalEventEventLocationVisibilityCreateInput>>;
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  deleteByEventIdAndLocationId?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityEventIdLocationIdKDelete>>;
  /** The primary key(s) for `externalEventEventLocationVisibility` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventEventLocationVisibilityExternalEventEventLocationVisibilityPkeyDelete>>;
  /** Flag indicating whether all other `externalEventEventLocationVisibility` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventEventLocationVisibility` for the far side of the relationship. */
  updateByEventIdAndLocationId?: InputMaybe<Array<ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventEventLocationVisibilityEventIdLocationIdKUpdate>>;
  /** The primary key(s) and patch data for `externalEventEventLocationVisibility` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventEventLocationVisibilityPkeyUpdate>>;
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to update. */
export type ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventEventLocationVisibilityEventIdLocationIdKUpdate = {
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventEventLocationVisibility` being updated. */
  patch: UpdateExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenPatch;
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to update. */
export type ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventEventLocationVisibilityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventEventLocationVisibility` being updated. */
  patch: UpdateExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenPatch;
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to update. */
export type ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventEventLocationVisibilityEventIdLocationIdKUpdate = {
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventEventLocationVisibility` being updated. */
  patch: UpdateExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEPatch;
};

/** The fields on `externalEventEventLocationVisibility` to look up the row to update. */
export type ExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventEventLocationVisibilityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventEventLocationVisibility` being updated. */
  patch: UpdateExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEPatch;
};

/** Represents an update to a `ExternalEventEventLocationVisibility`. Fields that are set will be updated. */
export type ExternalEventEventLocationVisibilityPatch = {
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInput>;
  externalEventToEventId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInput>;
  id?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

export enum ExternalEventEventStatus {
  Completed = 'completed',
  Discontinued = 'discontinued',
  Fix = 'fix',
  Option = 'option'
}

/** A filter to be used against ExternalEventEventStatus fields. All fields are combined with a logical ‘and.’ */
export type ExternalEventEventStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ExternalEventEventStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ExternalEventEventStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ExternalEventEventStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ExternalEventEventStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ExternalEventEventStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ExternalEventEventStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ExternalEventEventStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ExternalEventEventStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ExternalEventEventStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ExternalEventEventStatus>>;
};

/** The fields on `externalEvent` to look up the row to connect. */
export type ExternalEventExternalEventNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `externalEvent` to look up the row to delete. */
export type ExternalEventExternalEventNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `externalEvent` to look up the row to connect. */
export type ExternalEventExternalEventPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEvent` to look up the row to delete. */
export type ExternalEventExternalEventPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEvent` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventFilter>>;
  /** Filter by the object’s `contact` field. */
  contact?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalEventEventLocationVisibilitiesByEventId` relation. */
  externalEventEventLocationVisibilitiesByEventId?: InputMaybe<ExternalEventToManyExternalEventEventLocationVisibilityFilter>;
  /** Some related `externalEventEventLocationVisibilitiesByEventId` exist. */
  externalEventEventLocationVisibilitiesByEventIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventVariantsByEventId` relation. */
  externalEventVariantsByEventId?: InputMaybe<ExternalEventToManyExternalEventVariantFilter>;
  /** Some related `externalEventVariantsByEventId` exist. */
  externalEventVariantsByEventIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `links` relation. */
  links?: InputMaybe<MultilinkFilter>;
  /** Filter by the object’s `linksId` field. */
  linksId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `location` relation. */
  location?: InputMaybe<ExternalEventLocationFilter>;
  /** A related `location` exists. */
  locationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventFilter>>;
  /** Filter by the object’s `series` relation. */
  series?: InputMaybe<ExternalEventSeriesFilter>;
  /** Filter by the object’s `seriesId` field. */
  seriesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ExternalEventEventStatusFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ExternalEvent` */
export type ExternalEventInput = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year: Scalars['Int'];
};

/** The `externalEvent` to be created by this mutation. */
export type ExternalEventLinksIdMultilinkIdFkExternalEventCreateInput = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year: Scalars['Int'];
};

/** Input for the nested mutation of `multilink` in the `ExternalEventInput` mutation. */
export type ExternalEventLinksIdMultilinkIdFkInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventLinksIdMultilinkIdFkMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnExternalEventForExternalEventLinksIdMultilinkIdFkUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `externalEvent` in the `MultilinkInput` mutation. */
export type ExternalEventLinksIdMultilinkIdFkInverseInput = {
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventExternalEventPkeyConnect>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ExternalEventExternalEventNameShortKeyConnect>>;
  /** A `ExternalEventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventLinksIdMultilinkIdFkExternalEventCreateInput>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventExternalEventPkeyDelete>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ExternalEventExternalEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `externalEvent` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkUsingExternalEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkUsingExternalEventNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ExternalEventLinksIdMultilinkIdFkMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

export type ExternalEventLocation = {
  __typename?: 'ExternalEventLocation';
  /** Reads and enables pagination through a set of `ExternalEventAllocation`. */
  externalEventAllocationsByLocationId: ExternalEventAllocationsConnection;
  /** Reads and enables pagination through a set of `ExternalEventEventLocationVisibility`. */
  externalEventEventLocationVisibilitiesByLocationId: ExternalEventEventLocationVisibilitiesConnection;
  /** Reads and enables pagination through a set of `ExternalEvent`. */
  externalEventsByLocationId: ExternalEventsConnection;
  id: Scalars['UUID'];
  index: Scalars['Int'];
  isNationalDefault: Scalars['Boolean'];
  name: Scalars['String'];
};


export type ExternalEventLocationExternalEventAllocationsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationCondition>;
  filter?: InputMaybe<ExternalEventAllocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationsOrderBy>>;
};


export type ExternalEventLocationExternalEventEventLocationVisibilitiesByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventEventLocationVisibilityCondition>;
  filter?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventEventLocationVisibilitiesOrderBy>>;
};


export type ExternalEventLocationExternalEventsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventCondition>;
  filter?: InputMaybe<ExternalEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};

/**
 * A condition to be used against `ExternalEventLocation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventLocationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isNationalDefault` field. */
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** The fields on `externalEventLocation` to look up the row to connect. */
export type ExternalEventLocationExternalEventLocationNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `externalEventLocation` to look up the row to delete. */
export type ExternalEventLocationExternalEventLocationNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `externalEventLocation` to look up the row to connect. */
export type ExternalEventLocationExternalEventLocationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventLocation` to look up the row to delete. */
export type ExternalEventLocationExternalEventLocationPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEventLocation` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventLocationFilter>>;
  /** Filter by the object’s `externalEventAllocationsByLocationId` relation. */
  externalEventAllocationsByLocationId?: InputMaybe<ExternalEventLocationToManyExternalEventAllocationFilter>;
  /** Some related `externalEventAllocationsByLocationId` exist. */
  externalEventAllocationsByLocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventEventLocationVisibilitiesByLocationId` relation. */
  externalEventEventLocationVisibilitiesByLocationId?: InputMaybe<ExternalEventLocationToManyExternalEventEventLocationVisibilityFilter>;
  /** Some related `externalEventEventLocationVisibilitiesByLocationId` exist. */
  externalEventEventLocationVisibilitiesByLocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventsByLocationId` relation. */
  externalEventsByLocationId?: InputMaybe<ExternalEventLocationToManyExternalEventFilter>;
  /** Some related `externalEventsByLocationId` exist. */
  externalEventsByLocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isNationalDefault` field. */
  isNationalDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventLocationFilter>>;
};

/** The `externalEvent` to be created by this mutation. */
export type ExternalEventLocationIdExternalEventLocationIdFkExternalEventCreateInput = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year: Scalars['Int'];
};

/** The `externalEventLocation` to be created by this mutation. */
export type ExternalEventLocationIdExternalEventLocationIdFkExternalEventLocationCreateInput = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index: Scalars['Int'];
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `externalEventLocation` in the `ExternalEventInput` mutation. */
export type ExternalEventLocationIdExternalEventLocationIdFkInput = {
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventLocationExternalEventLocationPkeyConnect>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  connectByName?: InputMaybe<ExternalEventLocationExternalEventLocationNameKeyConnect>;
  /** A `ExternalEventLocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkExternalEventLocationCreateInput>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventLocationExternalEventLocationPkeyDelete>;
  /** The primary key(s) for `externalEventLocation` for the far side of the relationship. */
  deleteByName?: InputMaybe<ExternalEventLocationExternalEventLocationNameKeyDelete>;
  /** The primary key(s) and patch data for `externalEventLocation` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `externalEventLocation` for the far side of the relationship. */
  updateByName?: InputMaybe<ExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventLocationNameKeyUpdate>;
};

/** Input for the nested mutation of `externalEvent` in the `ExternalEventLocationInput` mutation. */
export type ExternalEventLocationIdExternalEventLocationIdFkInverseInput = {
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventExternalEventPkeyConnect>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ExternalEventExternalEventNameShortKeyConnect>>;
  /** A `ExternalEventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventLocationIdExternalEventLocationIdFkExternalEventCreateInput>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventExternalEventPkeyDelete>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ExternalEventExternalEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `externalEvent` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventNameShortKeyUpdate>>;
};

/** An input for mutations affecting `ExternalEventLocation` */
export type ExternalEventLocationInput = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index: Scalars['Int'];
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The fields on `externalEventLocation` to look up the row to update. */
export type ExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIUsingExternalEventLocationNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventLocation` being updated. */
  patch: UpdateExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIPatch;
};

/** The fields on `externalEventLocation` to look up the row to update. */
export type ExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIUsingExternalEventLocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventLocation` being updated. */
  patch: UpdateExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIPatch;
};

/** The fields on `externalEventLocation` to look up the row to update. */
export type ExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventLocationNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventLocation` being updated. */
  patch: UpdateExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEPatch;
};

/** The fields on `externalEventLocation` to look up the row to update. */
export type ExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEUsingExternalEventLocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventLocation` being updated. */
  patch: UpdateExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEPatch;
};

/** The fields on `externalEventLocation` to look up the row to update. */
export type ExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventLocationNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventLocation` being updated. */
  patch: UpdateExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkPatch;
};

/** The fields on `externalEventLocation` to look up the row to update. */
export type ExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventLocationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventLocation` being updated. */
  patch: UpdateExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkPatch;
};

/** Represents an update to a `ExternalEventLocation`. Fields that are set will be updated. */
export type ExternalEventLocationPatch = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ExternalEventAllocation` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventLocationToManyExternalEventAllocationFilter = {
  /** Every related `ExternalEventAllocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventAllocationFilter>;
  /** No related `ExternalEventAllocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventAllocationFilter>;
  /** Some related `ExternalEventAllocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventAllocationFilter>;
};

/** A filter to be used against many `ExternalEventEventLocationVisibility` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventLocationToManyExternalEventEventLocationVisibilityFilter = {
  /** Every related `ExternalEventEventLocationVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  /** No related `ExternalEventEventLocationVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  /** Some related `ExternalEventEventLocationVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
};

/** A filter to be used against many `ExternalEvent` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventLocationToManyExternalEventFilter = {
  /** Every related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventFilter>;
  /** No related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventFilter>;
  /** Some related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventFilter>;
};

export enum ExternalEventLocationVisibility {
  Full = 'full',
  Invisible = 'invisible',
  Less = 'less'
}

/** A filter to be used against ExternalEventLocationVisibility fields. All fields are combined with a logical ‘and.’ */
export type ExternalEventLocationVisibilityFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ExternalEventLocationVisibility>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ExternalEventLocationVisibility>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ExternalEventLocationVisibility>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ExternalEventLocationVisibility>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ExternalEventLocationVisibility>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ExternalEventLocationVisibility>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ExternalEventLocationVisibility>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ExternalEventLocationVisibility>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ExternalEventLocationVisibility>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ExternalEventLocationVisibility>>;
};

/** A connection to a list of `ExternalEventLocation` values. */
export type ExternalEventLocationsConnection = {
  __typename?: 'ExternalEventLocationsConnection';
  /** A list of edges which contains the `ExternalEventLocation` and cursor to aid in pagination. */
  edges: Array<ExternalEventLocationsEdge>;
  /** A list of `ExternalEventLocation` objects. */
  nodes: Array<ExternalEventLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventLocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventLocation` edge in the connection. */
export type ExternalEventLocationsEdge = {
  __typename?: 'ExternalEventLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventLocation` at the end of the edge. */
  node: ExternalEventLocation;
};

/** Methods to use when ordering `ExternalEventLocation`. */
export enum ExternalEventLocationsOrderBy {
  ExternalEventsByLocationIdCountAsc = 'EXTERNAL_EVENTS_BY_LOCATION_ID__COUNT_ASC',
  ExternalEventsByLocationIdCountDesc = 'EXTERNAL_EVENTS_BY_LOCATION_ID__COUNT_DESC',
  ExternalEventAllocationsByLocationIdCountAsc = 'EXTERNAL_EVENT_ALLOCATIONS_BY_LOCATION_ID__COUNT_ASC',
  ExternalEventAllocationsByLocationIdCountDesc = 'EXTERNAL_EVENT_ALLOCATIONS_BY_LOCATION_ID__COUNT_DESC',
  ExternalEventEventLocationVisibilitiesByLocationIdCountAsc = 'EXTERNAL_EVENT_EVENT_LOCATION_VISIBILITIES_BY_LOCATION_ID__COUNT_ASC',
  ExternalEventEventLocationVisibilitiesByLocationIdCountDesc = 'EXTERNAL_EVENT_EVENT_LOCATION_VISIBILITIES_BY_LOCATION_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IsNationalDefaultAsc = 'IS_NATIONAL_DEFAULT_ASC',
  IsNationalDefaultDesc = 'IS_NATIONAL_DEFAULT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenUsingExternalEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkUsingExternalEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkUsingExternalEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkUsingExternalEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkPatch;
};

/** The fields on `externalEvent` to look up the row to update. */
export type ExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEvent` being updated. */
  patch: UpdateExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkPatch;
};

/** Represents an update to a `ExternalEvent`. Fields that are set will be updated. */
export type ExternalEventPatch = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ExternalEventSeries = {
  __typename?: 'ExternalEventSeries';
  category: ExternalEventSeriesCategory;
  description: Scalars['String'];
  explanation: Scalars['String'];
  /** Reads and enables pagination through a set of `ExternalEvent`. */
  externalEventsBySeriesId: ExternalEventsConnection;
  id: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  national: Scalars['Boolean'];
  notes: Scalars['String'];
  silent: Scalars['Boolean'];
  status: ExternalEventSeriesStatus;
  /** Reads a single `Multilink` that is related to this `ExternalEventSeries`. */
  websites: Multilink;
  websitesId: Scalars['UUID'];
};


export type ExternalEventSeriesExternalEventsBySeriesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventCondition>;
  filter?: InputMaybe<ExternalEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};

export enum ExternalEventSeriesCategory {
  Competition = 'competition',
  ExternalConstruction = 'external_construction',
  Holiday = 'holiday',
  Other = 'other',
  Politics = 'politics',
  PublicHoliday = 'public_holiday',
  Social = 'social',
  Sport = 'sport',
  World = 'world'
}

/** A filter to be used against ExternalEventSeriesCategory fields. All fields are combined with a logical ‘and.’ */
export type ExternalEventSeriesCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ExternalEventSeriesCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ExternalEventSeriesCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ExternalEventSeriesCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ExternalEventSeriesCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ExternalEventSeriesCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ExternalEventSeriesCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ExternalEventSeriesCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ExternalEventSeriesCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ExternalEventSeriesCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ExternalEventSeriesCategory>>;
};

/**
 * A condition to be used against `ExternalEventSeries` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventSeriesCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<ExternalEventSeriesCategory>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `explanation` field. */
  explanation?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `national` field. */
  national?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `silent` field. */
  silent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ExternalEventSeriesStatus>;
  /** Checks for equality with the object’s `websitesId` field. */
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `ExternalEventSeries` values. */
export type ExternalEventSeriesConnection = {
  __typename?: 'ExternalEventSeriesConnection';
  /** A list of edges which contains the `ExternalEventSeries` and cursor to aid in pagination. */
  edges: Array<ExternalEventSeriesEdge>;
  /** A list of `ExternalEventSeries` objects. */
  nodes: Array<ExternalEventSeries>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventSeries` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventSeries` edge in the connection. */
export type ExternalEventSeriesEdge = {
  __typename?: 'ExternalEventSeriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventSeries` at the end of the edge. */
  node: ExternalEventSeries;
};

/** The fields on `externalEventSeries` to look up the row to connect. */
export type ExternalEventSeriesExternalEventSeriesNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `externalEventSeries` to look up the row to delete. */
export type ExternalEventSeriesExternalEventSeriesNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `externalEventSeries` to look up the row to connect. */
export type ExternalEventSeriesExternalEventSeriesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventSeries` to look up the row to delete. */
export type ExternalEventSeriesExternalEventSeriesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEventSeries` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventSeriesFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventSeriesFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<ExternalEventSeriesCategoryFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `explanation` field. */
  explanation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalEventsBySeriesId` relation. */
  externalEventsBySeriesId?: InputMaybe<ExternalEventSeriesToManyExternalEventFilter>;
  /** Some related `externalEventsBySeriesId` exist. */
  externalEventsBySeriesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Filter by the object’s `national` field. */
  national?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventSeriesFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventSeriesFilter>>;
  /** Filter by the object’s `silent` field. */
  silent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ExternalEventSeriesStatusFilter>;
  /** Filter by the object’s `websites` relation. */
  websites?: InputMaybe<MultilinkFilter>;
  /** Filter by the object’s `websitesId` field. */
  websitesId?: InputMaybe<UuidFilter>;
};

/** The `externalEvent` to be created by this mutation. */
export type ExternalEventSeriesIdExternalEventSeriesIdFkExternalEventCreateInput = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  status?: InputMaybe<ExternalEventEventStatus>;
  year: Scalars['Int'];
};

/** The `externalEventSeries` to be created by this mutation. */
export type ExternalEventSeriesIdExternalEventSeriesIdFkExternalEventSeriesCreateInput = {
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  explanation?: InputMaybe<Scalars['String']>;
  externalEventsUsingId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToWebsitesId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  national?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `externalEventSeries` in the `ExternalEventInput` mutation. */
export type ExternalEventSeriesIdExternalEventSeriesIdFkInput = {
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventSeriesExternalEventSeriesPkeyConnect>;
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ExternalEventSeriesExternalEventSeriesNameShortKeyConnect>;
  /** A `ExternalEventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkExternalEventSeriesCreateInput>;
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventSeriesExternalEventSeriesPkeyDelete>;
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ExternalEventSeriesExternalEventSeriesNameShortKeyDelete>;
  /** The primary key(s) and patch data for `externalEventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventSeriesPkeyUpdate>;
  /** The primary key(s) and patch data for `externalEventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventSeriesNameShortKeyUpdate>;
};

/** Input for the nested mutation of `externalEvent` in the `ExternalEventSeriesInput` mutation. */
export type ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput = {
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventExternalEventPkeyConnect>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ExternalEventExternalEventNameShortKeyConnect>>;
  /** A `ExternalEventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventSeriesIdExternalEventSeriesIdFkExternalEventCreateInput>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventExternalEventPkeyDelete>>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ExternalEventExternalEventNameShortKeyDelete>>;
  /** Flag indicating whether all other `externalEvent` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventPkeyUpdate>>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventNameShortKeyUpdate>>;
};

/** An input for mutations affecting `ExternalEventSeries` */
export type ExternalEventSeriesInput = {
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  explanation?: InputMaybe<Scalars['String']>;
  externalEventsUsingId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToWebsitesId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  national?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `externalEventSeries` to look up the row to update. */
export type ExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventSeries` being updated. */
  patch: UpdateExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkPatch;
};

/** The fields on `externalEventSeries` to look up the row to update. */
export type ExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkUsingExternalEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventSeries` being updated. */
  patch: UpdateExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkPatch;
};

/** The fields on `externalEventSeries` to look up the row to update. */
export type ExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkUsingExternalEventSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `externalEventSeries` being updated. */
  patch: UpdateExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkPatch;
};

/** The fields on `externalEventSeries` to look up the row to update. */
export type ExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkUsingExternalEventSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventSeries` being updated. */
  patch: UpdateExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkPatch;
};

/** Methods to use when ordering `ExternalEventSeries`. */
export enum ExternalEventSeriesOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExplanationAsc = 'EXPLANATION_ASC',
  ExplanationDesc = 'EXPLANATION_DESC',
  ExternalEventsBySeriesIdCountAsc = 'EXTERNAL_EVENTS_BY_SERIES_ID__COUNT_ASC',
  ExternalEventsBySeriesIdCountDesc = 'EXTERNAL_EVENTS_BY_SERIES_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MultilinkByWebsitesIdIdAsc = 'MULTILINK_BY_WEBSITES_ID__ID_ASC',
  MultilinkByWebsitesIdIdDesc = 'MULTILINK_BY_WEBSITES_ID__ID_DESC',
  MultilinkByWebsitesIdNameAsc = 'MULTILINK_BY_WEBSITES_ID__NAME_ASC',
  MultilinkByWebsitesIdNameDesc = 'MULTILINK_BY_WEBSITES_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  NationalAsc = 'NATIONAL_ASC',
  NationalDesc = 'NATIONAL_DESC',
  Natural = 'NATURAL',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SilentAsc = 'SILENT_ASC',
  SilentDesc = 'SILENT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  WebsitesIdAsc = 'WEBSITES_ID_ASC',
  WebsitesIdDesc = 'WEBSITES_ID_DESC'
}

/** Represents an update to a `ExternalEventSeries`. Fields that are set will be updated. */
export type ExternalEventSeriesPatch = {
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  explanation?: InputMaybe<Scalars['String']>;
  externalEventsUsingId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToWebsitesId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  national?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

export enum ExternalEventSeriesStatus {
  Active = 'active',
  Completed = 'completed',
  Discontinued = 'discontinued'
}

/** A filter to be used against ExternalEventSeriesStatus fields. All fields are combined with a logical ‘and.’ */
export type ExternalEventSeriesStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ExternalEventSeriesStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ExternalEventSeriesStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ExternalEventSeriesStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ExternalEventSeriesStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ExternalEventSeriesStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ExternalEventSeriesStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ExternalEventSeriesStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ExternalEventSeriesStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ExternalEventSeriesStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ExternalEventSeriesStatus>>;
};

/** A filter to be used against many `ExternalEvent` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventSeriesToManyExternalEventFilter = {
  /** Every related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventFilter>;
  /** No related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventFilter>;
  /** Some related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventFilter>;
};

/** The `externalEventSeries` to be created by this mutation. */
export type ExternalEventSeriesWebsitesIdMultilinkIdFkExternalEventSeriesCreateInput = {
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  explanation?: InputMaybe<Scalars['String']>;
  externalEventsUsingId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToWebsitesId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  national?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
};

/** Input for the nested mutation of `multilink` in the `ExternalEventSeriesInput` mutation. */
export type ExternalEventSeriesWebsitesIdMultilinkIdFkInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `externalEventSeries` in the `MultilinkInput` mutation. */
export type ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput = {
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventSeriesExternalEventSeriesPkeyConnect>>;
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ExternalEventSeriesExternalEventSeriesNameShortKeyConnect>>;
  /** A `ExternalEventSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventSeriesWebsitesIdMultilinkIdFkExternalEventSeriesCreateInput>>;
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventSeriesExternalEventSeriesPkeyDelete>>;
  /** The primary key(s) for `externalEventSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ExternalEventSeriesExternalEventSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `externalEventSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkUsingExternalEventSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `externalEventSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkUsingExternalEventSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ExternalEventSeriesWebsitesIdMultilinkIdFkMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A filter to be used against many `ExternalEventEventLocationVisibility` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventToManyExternalEventEventLocationVisibilityFilter = {
  /** Every related `ExternalEventEventLocationVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  /** No related `ExternalEventEventLocationVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  /** Some related `ExternalEventEventLocationVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
};

/** A filter to be used against many `ExternalEventVariant` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventToManyExternalEventVariantFilter = {
  /** Every related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventVariantFilter>;
  /** No related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventVariantFilter>;
  /** Some related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventVariantFilter>;
};

export type ExternalEventVariant = {
  __typename?: 'ExternalEventVariant';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes: Feed;
  changesId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event: ExternalEvent;
  eventId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ExternalEventAllocation`. */
  externalEventAllocationsByVariantId: ExternalEventAllocationsConnection;
  id: Scalars['UUID'];
  index: Scalars['Int'];
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
  referenceExternalEventAllocationId?: Maybe<Scalars['UUID']>;
  status: ExternalEventVariantStatus;
};


export type ExternalEventVariantExternalEventAllocationsByVariantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationCondition>;
  filter?: InputMaybe<ExternalEventAllocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationsOrderBy>>;
};

/** The `externalEventVariant` to be created by this mutation. */
export type ExternalEventVariantChangesIdFeedIdFkExternalEventVariantCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** The `feed` to be created by this mutation. */
export type ExternalEventVariantChangesIdFeedIdFkFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** Input for the nested mutation of `feed` in the `ExternalEventVariantInput` mutation. */
export type ExternalEventVariantChangesIdFeedIdFkInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `externalEventVariant` in the `FeedInput` mutation. */
export type ExternalEventVariantChangesIdFeedIdFkInverseInput = {
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantExternalEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventVariantExternalEventVariantPkeyConnect>>;
  /** A `ExternalEventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventVariantChangesIdFeedIdFkExternalEventVariantCreateInput>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantExternalEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventVariantExternalEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `externalEventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkUsingExternalEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkUsingExternalEventVariantPkeyUpdate>>;
};

/**
 * A condition to be used against `ExternalEventVariant` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ExternalEventVariantCondition = {
  /** Checks for equality with the object’s `changesId` field. */
  changesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `referenceExternalEventAllocationId` field. */
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** The `externalEvent` to be created by this mutation. */
export type ExternalEventVariantEventIdExternalEventIdFkExternalEventCreateInput = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year: Scalars['Int'];
};

/** The `externalEventVariant` to be created by this mutation. */
export type ExternalEventVariantEventIdExternalEventIdFkExternalEventVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** Input for the nested mutation of `externalEvent` in the `ExternalEventVariantInput` mutation. */
export type ExternalEventVariantEventIdExternalEventIdFkInput = {
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventExternalEventPkeyConnect>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ExternalEventExternalEventNameShortKeyConnect>;
  /** A `ExternalEventInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkExternalEventCreateInput>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventExternalEventPkeyDelete>;
  /** The primary key(s) for `externalEvent` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ExternalEventExternalEventNameShortKeyDelete>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventPkeyUpdate>;
  /** The primary key(s) and patch data for `externalEvent` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventNameShortKeyUpdate>;
};

/** Input for the nested mutation of `externalEventVariant` in the `ExternalEventInput` mutation. */
export type ExternalEventVariantEventIdExternalEventIdFkInverseInput = {
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantExternalEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventVariantExternalEventVariantPkeyConnect>>;
  /** A `ExternalEventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventVariantEventIdExternalEventIdFkExternalEventVariantCreateInput>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantExternalEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventVariantExternalEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `externalEventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventVariantPkeyUpdate>>;
};

/** The fields on `externalEventVariant` to look up the row to connect. */
export type ExternalEventVariantExternalEventVariantEventIdIndexKeyConnect = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};

/** The fields on `externalEventVariant` to look up the row to delete. */
export type ExternalEventVariantExternalEventVariantEventIdIndexKeyDelete = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};

/** The fields on `externalEventVariant` to look up the row to connect. */
export type ExternalEventVariantExternalEventVariantPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalEventVariant` to look up the row to delete. */
export type ExternalEventVariantExternalEventVariantPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ExternalEventVariant` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventVariantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalEventVariantFilter>>;
  /** Filter by the object’s `changes` relation. */
  changes?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `changesId` field. */
  changesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `event` relation. */
  event?: InputMaybe<ExternalEventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `externalEventAllocationsByVariantId` relation. */
  externalEventAllocationsByVariantId?: InputMaybe<ExternalEventVariantToManyExternalEventAllocationFilter>;
  /** Some related `externalEventAllocationsByVariantId` exist. */
  externalEventAllocationsByVariantIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalEventVariantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalEventVariantFilter>>;
  /** Filter by the object’s `referenceExternalEventAllocation` relation. */
  referenceExternalEventAllocation?: InputMaybe<ExternalEventAllocationFilter>;
  /** A related `referenceExternalEventAllocation` exists. */
  referenceExternalEventAllocationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceExternalEventAllocationId` field. */
  referenceExternalEventAllocationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ExternalEventVariantStatusFilter>;
};

/** An input for mutations affecting `ExternalEventVariant` */
export type ExternalEventVariantInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdUsingExternalEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdUsingExternalEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkUsingExternalEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkUsingExternalEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkUsingExternalEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEUsingExternalEventVariantEventIdIndexKeyUpdate = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEPatch;
};

/** The fields on `externalEventVariant` to look up the row to update. */
export type ExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEUsingExternalEventVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalEventVariant` being updated. */
  patch: UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEPatch;
};

/** Represents an update to a `ExternalEventVariant`. Fields that are set will be updated. */
export type ExternalEventVariantPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** The `externalEventAllocation` to be created by this mutation. */
export type ExternalEventVariantReferenceExternalEventAllocationIdEExternalEventAllocationCreateInput = {
  end: Scalars['Datetime'];
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start: Scalars['Datetime'];
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** The `externalEventVariant` to be created by this mutation. */
export type ExternalEventVariantReferenceExternalEventAllocationIdEExternalEventVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** Input for the nested mutation of `externalEventAllocation` in the `ExternalEventVariantInput` mutation. */
export type ExternalEventVariantReferenceExternalEventAllocationIdEInput = {
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalEventAllocationExternalEventAllocationPkeyConnect>;
  /** A `ExternalEventAllocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEExternalEventAllocationCreateInput>;
  /** The primary key(s) for `externalEventAllocation` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalEventAllocationExternalEventAllocationPkeyDelete>;
  /** The primary key(s) and patch data for `externalEventAllocation` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalEventAllocationOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEUsingExternalEventAllocationPkeyUpdate>;
};

/** Input for the nested mutation of `externalEventVariant` in the `ExternalEventAllocationInput` mutation. */
export type ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput = {
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantExternalEventVariantEventIdIndexKeyConnect>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalEventVariantExternalEventVariantPkeyConnect>>;
  /** A `ExternalEventVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalEventVariantReferenceExternalEventAllocationIdEExternalEventVariantCreateInput>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantExternalEventVariantEventIdIndexKeyDelete>>;
  /** The primary key(s) for `externalEventVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalEventVariantExternalEventVariantPkeyDelete>>;
  /** Flag indicating whether all other `externalEventVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateByEventIdAndIndex?: InputMaybe<Array<ExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEUsingExternalEventVariantEventIdIndexKeyUpdate>>;
  /** The primary key(s) and patch data for `externalEventVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEUsingExternalEventVariantPkeyUpdate>>;
};

export enum ExternalEventVariantStatus {
  Discontinued = 'discontinued',
  Fix = 'fix',
  Option = 'option'
}

/** A filter to be used against ExternalEventVariantStatus fields. All fields are combined with a logical ‘and.’ */
export type ExternalEventVariantStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ExternalEventVariantStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ExternalEventVariantStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ExternalEventVariantStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ExternalEventVariantStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ExternalEventVariantStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ExternalEventVariantStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ExternalEventVariantStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ExternalEventVariantStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ExternalEventVariantStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ExternalEventVariantStatus>>;
};

/** A filter to be used against many `ExternalEventAllocation` object types. All fields are combined with a logical ‘and.’ */
export type ExternalEventVariantToManyExternalEventAllocationFilter = {
  /** Every related `ExternalEventAllocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventAllocationFilter>;
  /** No related `ExternalEventAllocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventAllocationFilter>;
  /** Some related `ExternalEventAllocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventAllocationFilter>;
};

/** A connection to a list of `ExternalEventVariant` values. */
export type ExternalEventVariantsConnection = {
  __typename?: 'ExternalEventVariantsConnection';
  /** A list of edges which contains the `ExternalEventVariant` and cursor to aid in pagination. */
  edges: Array<ExternalEventVariantsEdge>;
  /** A list of `ExternalEventVariant` objects. */
  nodes: Array<ExternalEventVariant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEventVariant` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEventVariant` edge in the connection. */
export type ExternalEventVariantsEdge = {
  __typename?: 'ExternalEventVariantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEventVariant` at the end of the edge. */
  node: ExternalEventVariant;
};

/** Methods to use when ordering `ExternalEventVariant`. */
export enum ExternalEventVariantsOrderBy {
  ChangesIdAsc = 'CHANGES_ID_ASC',
  ChangesIdDesc = 'CHANGES_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EventIdAsc = 'EVENT_ID_ASC',
  EventIdDesc = 'EVENT_ID_DESC',
  ExternalEventAllocationsByVariantIdCountAsc = 'EXTERNAL_EVENT_ALLOCATIONS_BY_VARIANT_ID__COUNT_ASC',
  ExternalEventAllocationsByVariantIdCountDesc = 'EXTERNAL_EVENT_ALLOCATIONS_BY_VARIANT_ID__COUNT_DESC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdEndAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__END_ASC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdEndDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__END_DESC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdIdAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__ID_ASC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdIdDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__ID_DESC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdIsOptionalAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__IS_OPTIONAL_ASC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdIsOptionalDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__IS_OPTIONAL_DESC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdLocationIdAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__LOCATION_ID_ASC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdLocationIdDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__LOCATION_ID_DESC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdStartAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__START_ASC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdStartDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__START_DESC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdVariantIdAsc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__VARIANT_ID_ASC',
  ExternalEventAllocationByReferenceExternalEventAllocationIdVariantIdDesc = 'EXTERNAL_EVENT_ALLOCATION_BY_REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID__VARIANT_ID_DESC',
  ExternalEventByEventIdContactAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__CONTACT_ASC',
  ExternalEventByEventIdContactDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__CONTACT_DESC',
  ExternalEventByEventIdDescriptionAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__DESCRIPTION_ASC',
  ExternalEventByEventIdDescriptionDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__DESCRIPTION_DESC',
  ExternalEventByEventIdIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__ID_ASC',
  ExternalEventByEventIdIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__ID_DESC',
  ExternalEventByEventIdLinksIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__LINKS_ID_ASC',
  ExternalEventByEventIdLinksIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__LINKS_ID_DESC',
  ExternalEventByEventIdLocationIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__LOCATION_ID_ASC',
  ExternalEventByEventIdLocationIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__LOCATION_ID_DESC',
  ExternalEventByEventIdNameLongAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_LONG_ASC',
  ExternalEventByEventIdNameLongDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_LONG_DESC',
  ExternalEventByEventIdNameShortAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_SHORT_ASC',
  ExternalEventByEventIdNameShortDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__NAME_SHORT_DESC',
  ExternalEventByEventIdSeriesIdAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__SERIES_ID_ASC',
  ExternalEventByEventIdSeriesIdDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__SERIES_ID_DESC',
  ExternalEventByEventIdStatusAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__STATUS_ASC',
  ExternalEventByEventIdStatusDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__STATUS_DESC',
  ExternalEventByEventIdYearAsc = 'EXTERNAL_EVENT_BY_EVENT_ID__YEAR_ASC',
  ExternalEventByEventIdYearDesc = 'EXTERNAL_EVENT_BY_EVENT_ID__YEAR_DESC',
  FeedByChangesIdIdAsc = 'FEED_BY_CHANGES_ID__ID_ASC',
  FeedByChangesIdIdDesc = 'FEED_BY_CHANGES_ID__ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IsCurrentAsc = 'IS_CURRENT_ASC',
  IsCurrentDesc = 'IS_CURRENT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferenceExternalEventAllocationIdAsc = 'REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID_ASC',
  ReferenceExternalEventAllocationIdDesc = 'REFERENCE_EXTERNAL_EVENT_ALLOCATION_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** A connection to a list of `ExternalEvent` values. */
export type ExternalEventsConnection = {
  __typename?: 'ExternalEventsConnection';
  /** A list of edges which contains the `ExternalEvent` and cursor to aid in pagination. */
  edges: Array<ExternalEventsEdge>;
  /** A list of `ExternalEvent` objects. */
  nodes: Array<ExternalEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalEvent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalEvent` edge in the connection. */
export type ExternalEventsEdge = {
  __typename?: 'ExternalEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalEvent` at the end of the edge. */
  node: ExternalEvent;
};

/** Methods to use when ordering `ExternalEvent`. */
export enum ExternalEventsOrderBy {
  ContactAsc = 'CONTACT_ASC',
  ContactDesc = 'CONTACT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExternalEventEventLocationVisibilitiesByEventIdCountAsc = 'EXTERNAL_EVENT_EVENT_LOCATION_VISIBILITIES_BY_EVENT_ID__COUNT_ASC',
  ExternalEventEventLocationVisibilitiesByEventIdCountDesc = 'EXTERNAL_EVENT_EVENT_LOCATION_VISIBILITIES_BY_EVENT_ID__COUNT_DESC',
  ExternalEventLocationByLocationIdIdAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__ID_ASC',
  ExternalEventLocationByLocationIdIdDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__ID_DESC',
  ExternalEventLocationByLocationIdIndexAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__INDEX_ASC',
  ExternalEventLocationByLocationIdIndexDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__INDEX_DESC',
  ExternalEventLocationByLocationIdIsNationalDefaultAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__IS_NATIONAL_DEFAULT_ASC',
  ExternalEventLocationByLocationIdIsNationalDefaultDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__IS_NATIONAL_DEFAULT_DESC',
  ExternalEventLocationByLocationIdNameAsc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__NAME_ASC',
  ExternalEventLocationByLocationIdNameDesc = 'EXTERNAL_EVENT_LOCATION_BY_LOCATION_ID__NAME_DESC',
  ExternalEventSeriesBySeriesIdCategoryAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__CATEGORY_ASC',
  ExternalEventSeriesBySeriesIdCategoryDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__CATEGORY_DESC',
  ExternalEventSeriesBySeriesIdDescriptionAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__DESCRIPTION_ASC',
  ExternalEventSeriesBySeriesIdDescriptionDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__DESCRIPTION_DESC',
  ExternalEventSeriesBySeriesIdExplanationAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__EXPLANATION_ASC',
  ExternalEventSeriesBySeriesIdExplanationDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__EXPLANATION_DESC',
  ExternalEventSeriesBySeriesIdIdAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__ID_ASC',
  ExternalEventSeriesBySeriesIdIdDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__ID_DESC',
  ExternalEventSeriesBySeriesIdNameLongAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NAME_LONG_ASC',
  ExternalEventSeriesBySeriesIdNameLongDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NAME_LONG_DESC',
  ExternalEventSeriesBySeriesIdNameShortAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NAME_SHORT_ASC',
  ExternalEventSeriesBySeriesIdNameShortDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NAME_SHORT_DESC',
  ExternalEventSeriesBySeriesIdNationalAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NATIONAL_ASC',
  ExternalEventSeriesBySeriesIdNationalDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NATIONAL_DESC',
  ExternalEventSeriesBySeriesIdNotesAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NOTES_ASC',
  ExternalEventSeriesBySeriesIdNotesDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__NOTES_DESC',
  ExternalEventSeriesBySeriesIdSilentAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__SILENT_ASC',
  ExternalEventSeriesBySeriesIdSilentDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__SILENT_DESC',
  ExternalEventSeriesBySeriesIdStatusAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__STATUS_ASC',
  ExternalEventSeriesBySeriesIdStatusDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__STATUS_DESC',
  ExternalEventSeriesBySeriesIdWebsitesIdAsc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__WEBSITES_ID_ASC',
  ExternalEventSeriesBySeriesIdWebsitesIdDesc = 'EXTERNAL_EVENT_SERIES_BY_SERIES_ID__WEBSITES_ID_DESC',
  ExternalEventVariantsByEventIdCountAsc = 'EXTERNAL_EVENT_VARIANTS_BY_EVENT_ID__COUNT_ASC',
  ExternalEventVariantsByEventIdCountDesc = 'EXTERNAL_EVENT_VARIANTS_BY_EVENT_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinksIdAsc = 'LINKS_ID_ASC',
  LinksIdDesc = 'LINKS_ID_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  MultilinkByLinksIdIdAsc = 'MULTILINK_BY_LINKS_ID__ID_ASC',
  MultilinkByLinksIdIdDesc = 'MULTILINK_BY_LINKS_ID__ID_DESC',
  MultilinkByLinksIdNameAsc = 'MULTILINK_BY_LINKS_ID__NAME_ASC',
  MultilinkByLinksIdNameDesc = 'MULTILINK_BY_LINKS_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeriesIdAsc = 'SERIES_ID_ASC',
  SeriesIdDesc = 'SERIES_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type Feed = {
  __typename?: 'Feed';
  /** Reads and enables pagination through a set of `EventVariant`. */
  eventVariantsByChangesId: EventVariantsConnection;
  /** Reads and enables pagination through a set of `ExternalEventVariant`. */
  externalEventVariantsByChangesId: ExternalEventVariantsConnection;
  /** Reads and enables pagination through a set of `FeedEntry`. */
  feedEntries: FeedEntriesConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProjectVariant`. */
  projectVariantsByChangesId: ProjectVariantsConnection;
  /** Reads and enables pagination through a set of `ScenarioGroup`. */
  scenarioGroupsByChangesId: ScenarioGroupsConnection;
  /** Reads and enables pagination through a set of `ScenarioGroup`. */
  scenarioGroupsByOrganisationalChangesId: ScenarioGroupsConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByChangesId: ScenariosConnection;
};


export type FeedEventVariantsByChangesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventVariantCondition>;
  filter?: InputMaybe<EventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};


export type FeedExternalEventVariantsByChangesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventVariantCondition>;
  filter?: InputMaybe<ExternalEventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};


export type FeedFeedEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeedEntryCondition>;
  filter?: InputMaybe<FeedEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};


export type FeedProjectVariantsByChangesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectVariantCondition>;
  filter?: InputMaybe<ProjectVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};


export type FeedScenarioGroupsByChangesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioGroupCondition>;
  filter?: InputMaybe<ScenarioGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};


export type FeedScenarioGroupsByOrganisationalChangesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioGroupCondition>;
  filter?: InputMaybe<ScenarioGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};


export type FeedScenariosByChangesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** A condition to be used against `Feed` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FeedCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `FeedEntry` values. */
export type FeedEntriesConnection = {
  __typename?: 'FeedEntriesConnection';
  /** A list of edges which contains the `FeedEntry` and cursor to aid in pagination. */
  edges: Array<FeedEntriesEdge>;
  /** A list of `FeedEntry` objects. */
  nodes: Array<FeedEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeedEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FeedEntry` edge in the connection. */
export type FeedEntriesEdge = {
  __typename?: 'FeedEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FeedEntry` at the end of the edge. */
  node: FeedEntry;
};

/** Methods to use when ordering `FeedEntry`. */
export enum FeedEntriesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  CreatedByNameAsc = 'CREATED_BY_NAME_ASC',
  CreatedByNameDesc = 'CREATED_BY_NAME_DESC',
  FeedByFeedIdIdAsc = 'FEED_BY_FEED_ID__ID_ASC',
  FeedByFeedIdIdDesc = 'FEED_BY_FEED_ID__ID_DESC',
  FeedIdAsc = 'FEED_ID_ASC',
  FeedIdDesc = 'FEED_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MarkdownTextAsc = 'MARKDOWN_TEXT_ASC',
  MarkdownTextDesc = 'MARKDOWN_TEXT_DESC',
  Natural = 'NATURAL',
  NewMainVariantIdAsc = 'NEW_MAIN_VARIANT_ID_ASC',
  NewMainVariantIdDesc = 'NEW_MAIN_VARIANT_ID_DESC',
  NewMainVariantIndexAsc = 'NEW_MAIN_VARIANT_INDEX_ASC',
  NewMainVariantIndexDesc = 'NEW_MAIN_VARIANT_INDEX_DESC',
  NewStatusAsc = 'NEW_STATUS_ASC',
  NewStatusDesc = 'NEW_STATUS_DESC',
  ObjectCreatedAtAsc = 'OBJECT_CREATED_AT_ASC',
  ObjectCreatedAtDesc = 'OBJECT_CREATED_AT_DESC',
  OldMainVariantIdAsc = 'OLD_MAIN_VARIANT_ID_ASC',
  OldMainVariantIdDesc = 'OLD_MAIN_VARIANT_ID_DESC',
  OldMainVariantIndexAsc = 'OLD_MAIN_VARIANT_INDEX_ASC',
  OldMainVariantIndexDesc = 'OLD_MAIN_VARIANT_INDEX_DESC',
  OldStatusAsc = 'OLD_STATUS_ASC',
  OldStatusDesc = 'OLD_STATUS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TextAsc = 'TEXT_ASC',
  TextDesc = 'TEXT_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByIdAsc = 'UPDATED_BY_ID_ASC',
  UpdatedByIdDesc = 'UPDATED_BY_ID_DESC',
  UpdatedByNameAsc = 'UPDATED_BY_NAME_ASC',
  UpdatedByNameDesc = 'UPDATED_BY_NAME_DESC',
  UserByCreatedByIdActivatedAtAsc = 'USER_BY_CREATED_BY_ID__ACTIVATED_AT_ASC',
  UserByCreatedByIdActivatedAtDesc = 'USER_BY_CREATED_BY_ID__ACTIVATED_AT_DESC',
  UserByCreatedByIdCompanyAsc = 'USER_BY_CREATED_BY_ID__COMPANY_ASC',
  UserByCreatedByIdCompanyDesc = 'USER_BY_CREATED_BY_ID__COMPANY_DESC',
  UserByCreatedByIdCreatedAtAsc = 'USER_BY_CREATED_BY_ID__CREATED_AT_ASC',
  UserByCreatedByIdCreatedAtDesc = 'USER_BY_CREATED_BY_ID__CREATED_AT_DESC',
  UserByCreatedByIdDeactivatedAtAsc = 'USER_BY_CREATED_BY_ID__DEACTIVATED_AT_ASC',
  UserByCreatedByIdDeactivatedAtDesc = 'USER_BY_CREATED_BY_ID__DEACTIVATED_AT_DESC',
  UserByCreatedByIdFirstNameAsc = 'USER_BY_CREATED_BY_ID__FIRST_NAME_ASC',
  UserByCreatedByIdFirstNameDesc = 'USER_BY_CREATED_BY_ID__FIRST_NAME_DESC',
  UserByCreatedByIdIdAsc = 'USER_BY_CREATED_BY_ID__ID_ASC',
  UserByCreatedByIdIdDesc = 'USER_BY_CREATED_BY_ID__ID_DESC',
  UserByCreatedByIdIsActiveAsc = 'USER_BY_CREATED_BY_ID__IS_ACTIVE_ASC',
  UserByCreatedByIdIsActiveDesc = 'USER_BY_CREATED_BY_ID__IS_ACTIVE_DESC',
  UserByCreatedByIdIsAdminAsc = 'USER_BY_CREATED_BY_ID__IS_ADMIN_ASC',
  UserByCreatedByIdIsAdminDesc = 'USER_BY_CREATED_BY_ID__IS_ADMIN_DESC',
  UserByCreatedByIdLastNameAsc = 'USER_BY_CREATED_BY_ID__LAST_NAME_ASC',
  UserByCreatedByIdLastNameDesc = 'USER_BY_CREATED_BY_ID__LAST_NAME_DESC',
  UserByCreatedByIdNameAsc = 'USER_BY_CREATED_BY_ID__NAME_ASC',
  UserByCreatedByIdNameDesc = 'USER_BY_CREATED_BY_ID__NAME_DESC',
  UserByCreatedByIdNotesAsc = 'USER_BY_CREATED_BY_ID__NOTES_ASC',
  UserByCreatedByIdNotesDesc = 'USER_BY_CREATED_BY_ID__NOTES_DESC',
  UserByCreatedByIdPositionAsc = 'USER_BY_CREATED_BY_ID__POSITION_ASC',
  UserByCreatedByIdPositionDesc = 'USER_BY_CREATED_BY_ID__POSITION_DESC',
  UserByCreatedByIdUpdatedAtAsc = 'USER_BY_CREATED_BY_ID__UPDATED_AT_ASC',
  UserByCreatedByIdUpdatedAtDesc = 'USER_BY_CREATED_BY_ID__UPDATED_AT_DESC',
  UserByUpdatedByIdActivatedAtAsc = 'USER_BY_UPDATED_BY_ID__ACTIVATED_AT_ASC',
  UserByUpdatedByIdActivatedAtDesc = 'USER_BY_UPDATED_BY_ID__ACTIVATED_AT_DESC',
  UserByUpdatedByIdCompanyAsc = 'USER_BY_UPDATED_BY_ID__COMPANY_ASC',
  UserByUpdatedByIdCompanyDesc = 'USER_BY_UPDATED_BY_ID__COMPANY_DESC',
  UserByUpdatedByIdCreatedAtAsc = 'USER_BY_UPDATED_BY_ID__CREATED_AT_ASC',
  UserByUpdatedByIdCreatedAtDesc = 'USER_BY_UPDATED_BY_ID__CREATED_AT_DESC',
  UserByUpdatedByIdDeactivatedAtAsc = 'USER_BY_UPDATED_BY_ID__DEACTIVATED_AT_ASC',
  UserByUpdatedByIdDeactivatedAtDesc = 'USER_BY_UPDATED_BY_ID__DEACTIVATED_AT_DESC',
  UserByUpdatedByIdFirstNameAsc = 'USER_BY_UPDATED_BY_ID__FIRST_NAME_ASC',
  UserByUpdatedByIdFirstNameDesc = 'USER_BY_UPDATED_BY_ID__FIRST_NAME_DESC',
  UserByUpdatedByIdIdAsc = 'USER_BY_UPDATED_BY_ID__ID_ASC',
  UserByUpdatedByIdIdDesc = 'USER_BY_UPDATED_BY_ID__ID_DESC',
  UserByUpdatedByIdIsActiveAsc = 'USER_BY_UPDATED_BY_ID__IS_ACTIVE_ASC',
  UserByUpdatedByIdIsActiveDesc = 'USER_BY_UPDATED_BY_ID__IS_ACTIVE_DESC',
  UserByUpdatedByIdIsAdminAsc = 'USER_BY_UPDATED_BY_ID__IS_ADMIN_ASC',
  UserByUpdatedByIdIsAdminDesc = 'USER_BY_UPDATED_BY_ID__IS_ADMIN_DESC',
  UserByUpdatedByIdLastNameAsc = 'USER_BY_UPDATED_BY_ID__LAST_NAME_ASC',
  UserByUpdatedByIdLastNameDesc = 'USER_BY_UPDATED_BY_ID__LAST_NAME_DESC',
  UserByUpdatedByIdNameAsc = 'USER_BY_UPDATED_BY_ID__NAME_ASC',
  UserByUpdatedByIdNameDesc = 'USER_BY_UPDATED_BY_ID__NAME_DESC',
  UserByUpdatedByIdNotesAsc = 'USER_BY_UPDATED_BY_ID__NOTES_ASC',
  UserByUpdatedByIdNotesDesc = 'USER_BY_UPDATED_BY_ID__NOTES_DESC',
  UserByUpdatedByIdPositionAsc = 'USER_BY_UPDATED_BY_ID__POSITION_ASC',
  UserByUpdatedByIdPositionDesc = 'USER_BY_UPDATED_BY_ID__POSITION_DESC',
  UserByUpdatedByIdUpdatedAtAsc = 'USER_BY_UPDATED_BY_ID__UPDATED_AT_ASC',
  UserByUpdatedByIdUpdatedAtDesc = 'USER_BY_UPDATED_BY_ID__UPDATED_AT_DESC'
}

export type FeedEntry = {
  __typename?: 'FeedEntry';
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `FeedEntry`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  createdByName: Scalars['String'];
  /** Reads a single `Feed` that is related to this `FeedEntry`. */
  feed: Feed;
  feedId: Scalars['UUID'];
  id: Scalars['UUID'];
  markdownText: Scalars['String'];
  newMainVariantId?: Maybe<Scalars['UUID']>;
  newMainVariantIndex?: Maybe<Scalars['Int']>;
  newStatus: Scalars['String'];
  objectCreatedAt?: Maybe<Scalars['Datetime']>;
  oldMainVariantId?: Maybe<Scalars['UUID']>;
  oldMainVariantIndex?: Maybe<Scalars['Int']>;
  oldStatus: Scalars['String'];
  text: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `FeedEntry`. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['UUID']>;
  updatedByName: Scalars['String'];
};

/**
 * A condition to be used against `FeedEntry` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FeedEntryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdByName` field. */
  createdByName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `feedId` field. */
  feedId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `markdownText` field. */
  markdownText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `newMainVariantId` field. */
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `newMainVariantIndex` field. */
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `newStatus` field. */
  newStatus?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `objectCreatedAt` field. */
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `oldMainVariantId` field. */
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `oldMainVariantIndex` field. */
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `oldStatus` field. */
  oldStatus?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedById` field. */
  updatedById?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedByName` field. */
  updatedByName?: InputMaybe<Scalars['String']>;
};

/** The `feedEntry` to be created by this mutation. */
export type FeedEntryCreatedByIdFkeyFeedEntryCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['UUID']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedById?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `FeedEntryInput` mutation. */
export type FeedEntryCreatedByIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeedEntryCreatedByIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFeedEntryForFeedEntryCreatedByIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `feedEntry` in the `UserInput` mutation. */
export type FeedEntryCreatedByIdFkeyInverseInput = {
  /** The primary key(s) for `feedEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FeedEntryFeedEntryPkeyConnect>>;
  /** A `FeedEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FeedEntryCreatedByIdFkeyFeedEntryCreateInput>>;
  /** The primary key(s) for `feedEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeedEntryFeedEntryPkeyDelete>>;
  /** Flag indicating whether all other `feedEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `feedEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FeedEntryOnFeedEntryForFeedEntryCreatedByIdFkeyUsingFeedEntryPkeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FeedEntryCreatedByIdFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** The fields on `feedEntry` to look up the row to connect. */
export type FeedEntryFeedEntryPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `feedEntry` to look up the row to delete. */
export type FeedEntryFeedEntryPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `feed` to be created by this mutation. */
export type FeedEntryFeedIdFkeyFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** The `feedEntry` to be created by this mutation. */
export type FeedEntryFeedIdFkeyFeedEntryCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedById?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** Input for the nested mutation of `feed` in the `FeedEntryInput` mutation. */
export type FeedEntryFeedIdFkeyInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeedEntryFeedIdFkeyFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnFeedEntryForFeedEntryFeedIdFkeyUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `feedEntry` in the `FeedInput` mutation. */
export type FeedEntryFeedIdFkeyInverseInput = {
  /** The primary key(s) for `feedEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FeedEntryFeedEntryPkeyConnect>>;
  /** A `FeedEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FeedEntryFeedIdFkeyFeedEntryCreateInput>>;
  /** The primary key(s) for `feedEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeedEntryFeedEntryPkeyDelete>>;
  /** Flag indicating whether all other `feedEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `feedEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FeedEntryOnFeedEntryForFeedEntryFeedIdFkeyUsingFeedEntryPkeyUpdate>>;
};

/** A filter to be used against `FeedEntry` object types. All fields are combined with a logical ‘and.’ */
export type FeedEntryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeedEntryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` relation. */
  createdBy?: InputMaybe<UserFilter>;
  /** A related `createdBy` exists. */
  createdByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByName` field. */
  createdByName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `feed` relation. */
  feed?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `feedId` field. */
  feedId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `markdownText` field. */
  markdownText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `newMainVariantId` field. */
  newMainVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `newMainVariantIndex` field. */
  newMainVariantIndex?: InputMaybe<IntFilter>;
  /** Filter by the object’s `newStatus` field. */
  newStatus?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeedEntryFilter>;
  /** Filter by the object’s `objectCreatedAt` field. */
  objectCreatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `oldMainVariantId` field. */
  oldMainVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `oldMainVariantIndex` field. */
  oldMainVariantIndex?: InputMaybe<IntFilter>;
  /** Filter by the object’s `oldStatus` field. */
  oldStatus?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeedEntryFilter>>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` relation. */
  updatedBy?: InputMaybe<UserFilter>;
  /** A related `updatedBy` exists. */
  updatedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedById` field. */
  updatedById?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedByName` field. */
  updatedByName?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `FeedEntry` */
export type FeedEntryInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['UUID']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedById?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** The fields on `feedEntry` to look up the row to update. */
export type FeedEntryOnFeedEntryForFeedEntryCreatedByIdFkeyUsingFeedEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feedEntry` being updated. */
  patch: UpdateFeedEntryOnFeedEntryForFeedEntryCreatedByIdFkeyPatch;
};

/** The fields on `feedEntry` to look up the row to update. */
export type FeedEntryOnFeedEntryForFeedEntryFeedIdFkeyUsingFeedEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feedEntry` being updated. */
  patch: UpdateFeedEntryOnFeedEntryForFeedEntryFeedIdFkeyPatch;
};

/** The fields on `feedEntry` to look up the row to update. */
export type FeedEntryOnFeedEntryForFeedEntryUpdatedByIdFkeyUsingFeedEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feedEntry` being updated. */
  patch: UpdateFeedEntryOnFeedEntryForFeedEntryUpdatedByIdFkeyPatch;
};

/** Represents an update to a `FeedEntry`. Fields that are set will be updated. */
export type FeedEntryPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['UUID']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedById?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** The `feedEntry` to be created by this mutation. */
export type FeedEntryUpdatedByIdFkeyFeedEntryCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['UUID']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `FeedEntryInput` mutation. */
export type FeedEntryUpdatedByIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeedEntryUpdatedByIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFeedEntryForFeedEntryUpdatedByIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `feedEntry` in the `UserInput` mutation. */
export type FeedEntryUpdatedByIdFkeyInverseInput = {
  /** The primary key(s) for `feedEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FeedEntryFeedEntryPkeyConnect>>;
  /** A `FeedEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FeedEntryUpdatedByIdFkeyFeedEntryCreateInput>>;
  /** The primary key(s) for `feedEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeedEntryFeedEntryPkeyDelete>>;
  /** Flag indicating whether all other `feedEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `feedEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FeedEntryOnFeedEntryForFeedEntryUpdatedByIdFkeyUsingFeedEntryPkeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FeedEntryUpdatedByIdFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** The fields on `feed` to look up the row to connect. */
export type FeedFeedPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `feed` to look up the row to delete. */
export type FeedFeedPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `Feed` object types. All fields are combined with a logical ‘and.’ */
export type FeedFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeedFilter>>;
  /** Filter by the object’s `eventVariantsByChangesId` relation. */
  eventVariantsByChangesId?: InputMaybe<FeedToManyEventVariantFilter>;
  /** Some related `eventVariantsByChangesId` exist. */
  eventVariantsByChangesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventVariantsByChangesId` relation. */
  externalEventVariantsByChangesId?: InputMaybe<FeedToManyExternalEventVariantFilter>;
  /** Some related `externalEventVariantsByChangesId` exist. */
  externalEventVariantsByChangesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `feedEntries` relation. */
  feedEntries?: InputMaybe<FeedToManyFeedEntryFilter>;
  /** Some related `feedEntries` exist. */
  feedEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeedFilter>>;
  /** Filter by the object’s `projectVariantsByChangesId` relation. */
  projectVariantsByChangesId?: InputMaybe<FeedToManyProjectVariantFilter>;
  /** Some related `projectVariantsByChangesId` exist. */
  projectVariantsByChangesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenarioGroupsByChangesId` relation. */
  scenarioGroupsByChangesId?: InputMaybe<FeedToManyScenarioGroupFilter>;
  /** Some related `scenarioGroupsByChangesId` exist. */
  scenarioGroupsByChangesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenarioGroupsByOrganisationalChangesId` relation. */
  scenarioGroupsByOrganisationalChangesId?: InputMaybe<FeedToManyScenarioGroupFilter>;
  /** Some related `scenarioGroupsByOrganisationalChangesId` exist. */
  scenarioGroupsByOrganisationalChangesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenariosByChangesId` relation. */
  scenariosByChangesId?: InputMaybe<FeedToManyScenarioFilter>;
  /** Some related `scenariosByChangesId` exist. */
  scenariosByChangesIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Feed` */
export type FeedInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnEventVariantForEventVariantChangesIdFkeyUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnEventVariantForEventVariantChangesIdFkeyPatch;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkPatch;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnFeedEntryForFeedEntryFeedIdFkeyUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnFeedEntryForFeedEntryFeedIdFkeyPatch;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnProjectVariantForProjectVariantChangesIdFkeyUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnProjectVariantForProjectVariantChangesIdFkeyPatch;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnScenarioForScenarioChangesIdFkeyUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnScenarioForScenarioChangesIdFkeyPatch;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnScenarioGroupForScenarioGroupChangesIdFkeyUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnScenarioGroupForScenarioGroupChangesIdFkeyPatch;
};

/** The fields on `feed` to look up the row to update. */
export type FeedOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyUsingFeedPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `feed` being updated. */
  patch: UpdateFeedOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyPatch;
};

/** Represents an update to a `Feed`. Fields that are set will be updated. */
export type FeedPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** A filter to be used against many `EventVariant` object types. All fields are combined with a logical ‘and.’ */
export type FeedToManyEventVariantFilter = {
  /** Every related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventVariantFilter>;
  /** No related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventVariantFilter>;
  /** Some related `EventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventVariantFilter>;
};

/** A filter to be used against many `ExternalEventVariant` object types. All fields are combined with a logical ‘and.’ */
export type FeedToManyExternalEventVariantFilter = {
  /** Every related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventVariantFilter>;
  /** No related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventVariantFilter>;
  /** Some related `ExternalEventVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventVariantFilter>;
};

/** A filter to be used against many `FeedEntry` object types. All fields are combined with a logical ‘and.’ */
export type FeedToManyFeedEntryFilter = {
  /** Every related `FeedEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeedEntryFilter>;
  /** No related `FeedEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeedEntryFilter>;
  /** Some related `FeedEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeedEntryFilter>;
};

/** A filter to be used against many `ProjectVariant` object types. All fields are combined with a logical ‘and.’ */
export type FeedToManyProjectVariantFilter = {
  /** Every related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectVariantFilter>;
  /** No related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectVariantFilter>;
  /** Some related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectVariantFilter>;
};

/** A filter to be used against many `Scenario` object types. All fields are combined with a logical ‘and.’ */
export type FeedToManyScenarioFilter = {
  /** Every related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScenarioFilter>;
  /** No related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScenarioFilter>;
  /** Some related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScenarioFilter>;
};

/** A filter to be used against many `ScenarioGroup` object types. All fields are combined with a logical ‘and.’ */
export type FeedToManyScenarioGroupFilter = {
  /** Every related `ScenarioGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScenarioGroupFilter>;
  /** No related `ScenarioGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScenarioGroupFilter>;
  /** Some related `ScenarioGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScenarioGroupFilter>;
};

/** A connection to a list of `Feed` values. */
export type FeedsConnection = {
  __typename?: 'FeedsConnection';
  /** A list of edges which contains the `Feed` and cursor to aid in pagination. */
  edges: Array<FeedsEdge>;
  /** A list of `Feed` objects. */
  nodes: Array<Feed>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Feed` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Feed` edge in the connection. */
export type FeedsEdge = {
  __typename?: 'FeedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Feed` at the end of the edge. */
  node: Feed;
};

/** Methods to use when ordering `Feed`. */
export enum FeedsOrderBy {
  EventVariantsByChangesIdCountAsc = 'EVENT_VARIANTS_BY_CHANGES_ID__COUNT_ASC',
  EventVariantsByChangesIdCountDesc = 'EVENT_VARIANTS_BY_CHANGES_ID__COUNT_DESC',
  ExternalEventVariantsByChangesIdCountAsc = 'EXTERNAL_EVENT_VARIANTS_BY_CHANGES_ID__COUNT_ASC',
  ExternalEventVariantsByChangesIdCountDesc = 'EXTERNAL_EVENT_VARIANTS_BY_CHANGES_ID__COUNT_DESC',
  FeedEntriesByFeedIdCountAsc = 'FEED_ENTRIES_BY_FEED_ID__COUNT_ASC',
  FeedEntriesByFeedIdCountDesc = 'FEED_ENTRIES_BY_FEED_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectVariantsByChangesIdCountAsc = 'PROJECT_VARIANTS_BY_CHANGES_ID__COUNT_ASC',
  ProjectVariantsByChangesIdCountDesc = 'PROJECT_VARIANTS_BY_CHANGES_ID__COUNT_DESC',
  ScenariosByChangesIdCountAsc = 'SCENARIOS_BY_CHANGES_ID__COUNT_ASC',
  ScenariosByChangesIdCountDesc = 'SCENARIOS_BY_CHANGES_ID__COUNT_DESC',
  ScenarioGroupsByChangesIdCountAsc = 'SCENARIO_GROUPS_BY_CHANGES_ID__COUNT_ASC',
  ScenarioGroupsByChangesIdCountDesc = 'SCENARIO_GROUPS_BY_CHANGES_ID__COUNT_DESC',
  ScenarioGroupsByOrganisationalChangesIdCountAsc = 'SCENARIO_GROUPS_BY_ORGANISATIONAL_CHANGES_ID__COUNT_ASC',
  ScenarioGroupsByOrganisationalChangesIdCountDesc = 'SCENARIO_GROUPS_BY_ORGANISATIONAL_CHANGES_ID__COUNT_DESC'
}

export type File = {
  __typename?: 'File';
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByIconId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByIconId: EventsConnection;
  id: Scalars['UUID'];
  mimeType: Scalars['String'];
  size: Scalars['Int'];
  url: Scalars['String'];
  url128: Scalars['String'];
  url512: Scalars['String'];
};


export type FileEventSeriesByIconIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type FileEventsByIconIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** The fields on `file` to look up the row to connect. */
export type FileFilePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `File` object types. All fields are combined with a logical ‘and.’ */
export type FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `eventSeriesByIconId` relation. */
  eventSeriesByIconId?: InputMaybe<FileToManyEventSeriesFilter>;
  /** Some related `eventSeriesByIconId` exist. */
  eventSeriesByIconIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByIconId` relation. */
  eventsByIconId?: InputMaybe<FileToManyEventFilter>;
  /** Some related `eventsByIconId` exist. */
  eventsByIconIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mimeType` field. */
  mimeType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<IntFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `url128` field. */
  url128?: InputMaybe<StringFilter>;
  /** Filter by the object’s `url512` field. */
  url512?: InputMaybe<StringFilter>;
};

/** The fields on `file` to look up the row to update. */
export type FileOnEventForEventIconIdFkeyUsingFilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `file` being updated. */
  patch: UpdateFileOnEventForEventIconIdFkeyPatch;
};

/** The fields on `file` to look up the row to update. */
export type FileOnEventSeriesForEventSeriesIconIdFkeyUsingFilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `file` being updated. */
  patch: UpdateFileOnEventSeriesForEventSeriesIconIdFkeyPatch;
};

/** A filter to be used against many `Event` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyEventFilter = {
  /** Every related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventFilter>;
  /** No related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventFilter>;
  /** Some related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventFilter>;
};

/** A filter to be used against many `EventSeries` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyEventSeriesFilter = {
  /** Every related `EventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventSeriesFilter>;
  /** No related `EventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventSeriesFilter>;
  /** Some related `EventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventSeriesFilter>;
};

export type GetEntraUserDataResponse = {
  __typename?: 'GetEntraUserDataResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<EntraUserData>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']>;
};

export type InvalidCredentials = {
  __typename?: 'InvalidCredentials';
  message: Scalars['String'];
};

export type InvalidEntraToken = {
  __typename?: 'InvalidEntraToken';
  message: Scalars['String'];
};

export type InvalidOid = {
  __typename?: 'InvalidOid';
  message: Scalars['String'];
};

export type Level = {
  __typename?: 'Level';
  /** Reads a single `Building` that is related to this `Level`. */
  building: Building;
  buildingId: Scalars['UUID'];
  description: Scalars['String'];
  /** Reads a single `ElevationLevel` that is related to this `Level`. */
  elevation?: Maybe<ElevationLevel>;
  elevationId?: Maybe<Scalars['UUID']>;
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `LevelCapacityPax`. */
  levelCapacityPaxes: LevelCapacityPaxesConnection;
  /** Reads and enables pagination through a set of `LevelDescription`. */
  levelDescriptions: LevelDescriptionsConnection;
  /** Reads and enables pagination through a set of `LevelFkmGrossSpace`. */
  levelFkmGrossSpaces: LevelFkmGrossSpacesConnection;
  /** Reads and enables pagination through a set of `LevelNameExtra`. */
  levelNameExtras: LevelNameExtrasConnection;
  /** Reads and enables pagination through a set of `LevelNameKeyCad`. */
  levelNameKeyCads: LevelNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `LevelNameKeyCafm`. */
  levelNameKeyCafms: LevelNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `LevelNameKeyEbm`. */
  levelNameKeyEbms: LevelNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `LevelNameKeyMarketing`. */
  levelNameKeyMarketings: LevelNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `LevelNameLong`. */
  levelNameLongs: LevelNameLongsConnection;
  /** Reads and enables pagination through a set of `LevelNameShort`. */
  levelNameShorts: LevelNameShortsConnection;
  /** Reads and enables pagination through a set of `LevelPublicGrossSpace`. */
  levelPublicGrossSpaces: LevelPublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `LevelTypeAttr`. */
  levelTypeAttrs: LevelTypeAttrsConnection;
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads and enables pagination through a set of `Room`. */
  rooms: RoomsConnection;
  /** Reads a single `LevelType` that is related to this `Level`. */
  type?: Maybe<LevelType>;
  typeId?: Maybe<Scalars['UUID']>;
};


export type LevelLevelCapacityPaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelCapacityPaxCondition>;
  filter?: InputMaybe<LevelCapacityPaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelCapacityPaxesOrderBy>>;
};


export type LevelLevelDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelDescriptionCondition>;
  filter?: InputMaybe<LevelDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelDescriptionsOrderBy>>;
};


export type LevelLevelFkmGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelFkmGrossSpaceCondition>;
  filter?: InputMaybe<LevelFkmGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelFkmGrossSpacesOrderBy>>;
};


export type LevelLevelNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameExtraCondition>;
  filter?: InputMaybe<LevelNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameExtrasOrderBy>>;
};


export type LevelLevelNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyCadCondition>;
  filter?: InputMaybe<LevelNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyCadsOrderBy>>;
};


export type LevelLevelNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyCafmCondition>;
  filter?: InputMaybe<LevelNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyCafmsOrderBy>>;
};


export type LevelLevelNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyEbmCondition>;
  filter?: InputMaybe<LevelNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyEbmsOrderBy>>;
};


export type LevelLevelNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyMarketingCondition>;
  filter?: InputMaybe<LevelNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyMarketingsOrderBy>>;
};


export type LevelLevelNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameLongCondition>;
  filter?: InputMaybe<LevelNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameLongsOrderBy>>;
};


export type LevelLevelNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameShortCondition>;
  filter?: InputMaybe<LevelNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameShortsOrderBy>>;
};


export type LevelLevelPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelPublicGrossSpaceCondition>;
  filter?: InputMaybe<LevelPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelPublicGrossSpacesOrderBy>>;
};


export type LevelLevelTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelTypeAttrCondition>;
  filter?: InputMaybe<LevelTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelTypeAttrsOrderBy>>;
};


export type LevelRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCondition>;
  filter?: InputMaybe<RoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomsOrderBy>>;
};

/** The `building` to be created by this mutation. */
export type LevelBuildingIdFkeyBuildingCreateInput = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `building` in the `LevelInput` mutation. */
export type LevelBuildingIdFkeyInput = {
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByExtId?: InputMaybe<BuildingBuildingExtIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectById?: InputMaybe<BuildingBuildingPkeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyConnect>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<BuildingBuildingNameShortKeyConnect>;
  /** A `BuildingInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelBuildingIdFkeyBuildingCreateInput>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<BuildingBuildingExtIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteById?: InputMaybe<BuildingBuildingPkeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByIdAndSiteId?: InputMaybe<BuildingBuildingSiteIdIdKeyDelete>;
  /** The primary key(s) for `building` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<BuildingBuildingNameShortKeyDelete>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByExtId?: InputMaybe<BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateById?: InputMaybe<BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingPkeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByIdAndSiteId?: InputMaybe<BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingSiteIdIdKeyUpdate>;
  /** The primary key(s) and patch data for `building` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<BuildingOnLevelForLevelBuildingIdFkeyUsingBuildingNameShortKeyUpdate>;
};

/** Input for the nested mutation of `level` in the `BuildingInput` mutation. */
export type LevelBuildingIdFkeyInverseInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<LevelLevelExtIdKeyConnect>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelLevelPkeyConnect>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<LevelLevelNameShortKeyConnect>>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelBuildingIdFkeyLevelCreateInput>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<LevelLevelExtIdKeyDelete>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelLevelPkeyDelete>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<LevelLevelNameShortKeyDelete>>;
  /** Flag indicating whether all other `level` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<LevelOnLevelForLevelBuildingIdFkeyUsingLevelExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelOnLevelForLevelBuildingIdFkeyUsingLevelPkeyUpdate>>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<LevelOnLevelForLevelBuildingIdFkeyUsingLevelNameShortKeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelBuildingIdFkeyLevelCreateInput = {
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type LevelCapacityPax = {
  __typename?: 'LevelCapacityPax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelCapacityPax`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/**
 * A condition to be used against `LevelCapacityPax` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelCapacityPaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `LevelCapacityPax` object types. All fields are combined with a logical ‘and.’ */
export type LevelCapacityPaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelCapacityPaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelCapacityPaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelCapacityPaxFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `LevelCapacityPax` */
export type LevelCapacityPaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The fields on `levelCapacityPax` to look up the row to connect. */
export type LevelCapacityPaxLevelCapacityPaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelCapacityPax` to look up the row to delete. */
export type LevelCapacityPaxLevelCapacityPaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `level` in the `LevelCapacityPaxInput` mutation. */
export type LevelCapacityPaxLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelCapacityPaxLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelCapacityPax` in the `LevelInput` mutation. */
export type LevelCapacityPaxLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelCapacityPax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelCapacityPaxLevelCapacityPaxPkeyConnect>>;
  /** A `LevelCapacityPaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelCapacityPaxLevelIdFkeyLevelCapacityPaxCreateInput>>;
  /** The primary key(s) for `levelCapacityPax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelCapacityPaxLevelCapacityPaxPkeyDelete>>;
  /** Flag indicating whether all other `levelCapacityPax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelCapacityPax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelCapacityPaxOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelCapacityPaxPkeyUpdate>>;
};

/** The `levelCapacityPax` to be created by this mutation. */
export type LevelCapacityPaxLevelIdFkeyLevelCapacityPaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The `level` to be created by this mutation. */
export type LevelCapacityPaxLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `levelCapacityPax` to look up the row to update. */
export type LevelCapacityPaxOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelCapacityPaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelCapacityPax` being updated. */
  patch: UpdateLevelCapacityPaxOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyPatch;
};

/** Represents an update to a `LevelCapacityPax`. Fields that are set will be updated. */
export type LevelCapacityPaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `LevelCapacityPax` values. */
export type LevelCapacityPaxesConnection = {
  __typename?: 'LevelCapacityPaxesConnection';
  /** A list of edges which contains the `LevelCapacityPax` and cursor to aid in pagination. */
  edges: Array<LevelCapacityPaxesEdge>;
  /** A list of `LevelCapacityPax` objects. */
  nodes: Array<LevelCapacityPax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelCapacityPax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelCapacityPax` edge in the connection. */
export type LevelCapacityPaxesEdge = {
  __typename?: 'LevelCapacityPaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelCapacityPax` at the end of the edge. */
  node: LevelCapacityPax;
};

/** Methods to use when ordering `LevelCapacityPax`. */
export enum LevelCapacityPaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A condition to be used against `Level` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LevelCondition = {
  /** Checks for equality with the object’s `buildingId` field. */
  buildingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `elevationId` field. */
  elevationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type LevelDescription = {
  __typename?: 'LevelDescription';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelDescription`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelDescription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelDescriptionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelDescription` object types. All fields are combined with a logical ‘and.’ */
export type LevelDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelDescriptionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelDescriptionFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelDescription` */
export type LevelDescriptionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelDescriptionLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelDescription` to look up the row to connect. */
export type LevelDescriptionLevelDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelDescription` to look up the row to delete. */
export type LevelDescriptionLevelDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `level` in the `LevelDescriptionInput` mutation. */
export type LevelDescriptionLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelDescriptionLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelDescription` in the `LevelInput` mutation. */
export type LevelDescriptionLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelDescriptionLevelDescriptionPkeyConnect>>;
  /** A `LevelDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelDescriptionLevelIdFkeyLevelDescriptionCreateInput>>;
  /** The primary key(s) for `levelDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelDescriptionLevelDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `levelDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelDescriptionOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelDescriptionPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelDescriptionLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelDescription` to be created by this mutation. */
export type LevelDescriptionLevelIdFkeyLevelDescriptionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelDescriptionLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelDescription` to look up the row to update. */
export type LevelDescriptionOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelDescription` being updated. */
  patch: UpdateLevelDescriptionOnLevelDescriptionForLevelDescriptionLevelIdFkeyPatch;
};

/** Represents an update to a `LevelDescription`. Fields that are set will be updated. */
export type LevelDescriptionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelDescriptionLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelDescription` values. */
export type LevelDescriptionsConnection = {
  __typename?: 'LevelDescriptionsConnection';
  /** A list of edges which contains the `LevelDescription` and cursor to aid in pagination. */
  edges: Array<LevelDescriptionsEdge>;
  /** A list of `LevelDescription` objects. */
  nodes: Array<LevelDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelDescription` edge in the connection. */
export type LevelDescriptionsEdge = {
  __typename?: 'LevelDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelDescription` at the end of the edge. */
  node: LevelDescription;
};

/** Methods to use when ordering `LevelDescription`. */
export enum LevelDescriptionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The `elevationLevel` to be created by this mutation. */
export type LevelElevationIdKeyElevationLevelCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelElevationIdKeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  value: Scalars['BigFloat'];
};

/** Input for the nested mutation of `elevationLevel` in the `LevelInput` mutation. */
export type LevelElevationIdKeyInput = {
  /** The primary key(s) for `elevationLevel` for the far side of the relationship. */
  connectById?: InputMaybe<ElevationLevelElevationLevelPkeyConnect>;
  /** The primary key(s) for `elevationLevel` for the far side of the relationship. */
  connectByValue?: InputMaybe<ElevationLevelElevationLevelValueKeyConnect>;
  /** A `ElevationLevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelElevationIdKeyElevationLevelCreateInput>;
  /** The primary key(s) for `elevationLevel` for the far side of the relationship. */
  deleteById?: InputMaybe<ElevationLevelElevationLevelPkeyDelete>;
  /** The primary key(s) for `elevationLevel` for the far side of the relationship. */
  deleteByValue?: InputMaybe<ElevationLevelElevationLevelValueKeyDelete>;
  /** The primary key(s) and patch data for `elevationLevel` for the far side of the relationship. */
  updateById?: InputMaybe<ElevationLevelOnLevelForLevelElevationIdKeyUsingElevationLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `elevationLevel` for the far side of the relationship. */
  updateByValue?: InputMaybe<ElevationLevelOnLevelForLevelElevationIdKeyUsingElevationLevelValueKeyUpdate>;
};

/** Input for the nested mutation of `level` in the `ElevationLevelInput` mutation. */
export type LevelElevationIdKeyInverseInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<LevelLevelExtIdKeyConnect>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelLevelPkeyConnect>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<LevelLevelNameShortKeyConnect>>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelElevationIdKeyLevelCreateInput>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<LevelLevelExtIdKeyDelete>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelLevelPkeyDelete>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<LevelLevelNameShortKeyDelete>>;
  /** Flag indicating whether all other `level` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<LevelOnLevelForLevelElevationIdKeyUsingLevelExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelOnLevelForLevelElevationIdKeyUsingLevelPkeyUpdate>>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<LevelOnLevelForLevelElevationIdKeyUsingLevelNameShortKeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelElevationIdKeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `Level` object types. All fields are combined with a logical ‘and.’ */
export type LevelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelFilter>>;
  /** Filter by the object’s `building` relation. */
  building?: InputMaybe<BuildingFilter>;
  /** Filter by the object’s `buildingId` field. */
  buildingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `elevation` relation. */
  elevation?: InputMaybe<ElevationLevelFilter>;
  /** A related `elevation` exists. */
  elevationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `elevationId` field. */
  elevationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `levelCapacityPaxes` relation. */
  levelCapacityPaxes?: InputMaybe<LevelToManyLevelCapacityPaxFilter>;
  /** Some related `levelCapacityPaxes` exist. */
  levelCapacityPaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelDescriptions` relation. */
  levelDescriptions?: InputMaybe<LevelToManyLevelDescriptionFilter>;
  /** Some related `levelDescriptions` exist. */
  levelDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelFkmGrossSpaces` relation. */
  levelFkmGrossSpaces?: InputMaybe<LevelToManyLevelFkmGrossSpaceFilter>;
  /** Some related `levelFkmGrossSpaces` exist. */
  levelFkmGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameExtras` relation. */
  levelNameExtras?: InputMaybe<LevelToManyLevelNameExtraFilter>;
  /** Some related `levelNameExtras` exist. */
  levelNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameKeyCads` relation. */
  levelNameKeyCads?: InputMaybe<LevelToManyLevelNameKeyCadFilter>;
  /** Some related `levelNameKeyCads` exist. */
  levelNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameKeyCafms` relation. */
  levelNameKeyCafms?: InputMaybe<LevelToManyLevelNameKeyCafmFilter>;
  /** Some related `levelNameKeyCafms` exist. */
  levelNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameKeyEbms` relation. */
  levelNameKeyEbms?: InputMaybe<LevelToManyLevelNameKeyEbmFilter>;
  /** Some related `levelNameKeyEbms` exist. */
  levelNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameKeyMarketings` relation. */
  levelNameKeyMarketings?: InputMaybe<LevelToManyLevelNameKeyMarketingFilter>;
  /** Some related `levelNameKeyMarketings` exist. */
  levelNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameLongs` relation. */
  levelNameLongs?: InputMaybe<LevelToManyLevelNameLongFilter>;
  /** Some related `levelNameLongs` exist. */
  levelNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelNameShorts` relation. */
  levelNameShorts?: InputMaybe<LevelToManyLevelNameShortFilter>;
  /** Some related `levelNameShorts` exist. */
  levelNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelPublicGrossSpaces` relation. */
  levelPublicGrossSpaces?: InputMaybe<LevelToManyLevelPublicGrossSpaceFilter>;
  /** Some related `levelPublicGrossSpaces` exist. */
  levelPublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelTypeAttrs` relation. */
  levelTypeAttrs?: InputMaybe<LevelToManyLevelTypeAttrFilter>;
  /** Some related `levelTypeAttrs` exist. */
  levelTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelFilter>>;
  /** Filter by the object’s `rooms` relation. */
  rooms?: InputMaybe<LevelToManyRoomFilter>;
  /** Some related `rooms` exist. */
  roomsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<LevelTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
};

export type LevelFkmGrossSpace = {
  __typename?: 'LevelFkmGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelFkmGrossSpace`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `LevelFkmGrossSpace` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelFkmGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `LevelFkmGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type LevelFkmGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelFkmGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelFkmGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelFkmGrossSpaceFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `LevelFkmGrossSpace` */
export type LevelFkmGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `levelFkmGrossSpace` to look up the row to connect. */
export type LevelFkmGrossSpaceLevelFkmGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelFkmGrossSpace` to look up the row to delete. */
export type LevelFkmGrossSpaceLevelFkmGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `level` in the `LevelFkmGrossSpaceInput` mutation. */
export type LevelFkmGrossSpaceLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelFkmGrossSpace` in the `LevelInput` mutation. */
export type LevelFkmGrossSpaceLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelFkmGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelFkmGrossSpaceLevelFkmGrossSpacePkeyConnect>>;
  /** A `LevelFkmGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelFkmGrossSpaceLevelIdFkeyLevelFkmGrossSpaceCreateInput>>;
  /** The primary key(s) for `levelFkmGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelFkmGrossSpaceLevelFkmGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `levelFkmGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelFkmGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelFkmGrossSpaceOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelFkmGrossSpacePkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelFkmGrossSpaceLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelFkmGrossSpace` to be created by this mutation. */
export type LevelFkmGrossSpaceLevelIdFkeyLevelFkmGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `levelFkmGrossSpace` to look up the row to update. */
export type LevelFkmGrossSpaceOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelFkmGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelFkmGrossSpace` being updated. */
  patch: UpdateLevelFkmGrossSpaceOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyPatch;
};

/** Represents an update to a `LevelFkmGrossSpace`. Fields that are set will be updated. */
export type LevelFkmGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `LevelFkmGrossSpace` values. */
export type LevelFkmGrossSpacesConnection = {
  __typename?: 'LevelFkmGrossSpacesConnection';
  /** A list of edges which contains the `LevelFkmGrossSpace` and cursor to aid in pagination. */
  edges: Array<LevelFkmGrossSpacesEdge>;
  /** A list of `LevelFkmGrossSpace` objects. */
  nodes: Array<LevelFkmGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelFkmGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelFkmGrossSpace` edge in the connection. */
export type LevelFkmGrossSpacesEdge = {
  __typename?: 'LevelFkmGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelFkmGrossSpace` at the end of the edge. */
  node: LevelFkmGrossSpace;
};

/** Methods to use when ordering `LevelFkmGrossSpace`. */
export enum LevelFkmGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** An input for mutations affecting `Level` */
export type LevelInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `level` to look up the row to connect. */
export type LevelLevelExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `level` to look up the row to delete. */
export type LevelLevelExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `level` to look up the row to connect. */
export type LevelLevelNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `level` to look up the row to delete. */
export type LevelLevelNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `level` to look up the row to connect. */
export type LevelLevelPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `level` to look up the row to delete. */
export type LevelLevelPkeyDelete = {
  id: Scalars['UUID'];
};

export type LevelNameExtra = {
  __typename?: 'LevelNameExtra';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameExtra`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelNameExtraCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameExtraFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameExtraFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameExtra` */
export type LevelNameExtraInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameExtraLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `level` in the `LevelNameExtraInput` mutation. */
export type LevelNameExtraLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameExtraLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameExtra` in the `LevelInput` mutation. */
export type LevelNameExtraLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameExtraLevelNameExtraPkeyConnect>>;
  /** A `LevelNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameExtraLevelIdFkeyLevelNameExtraCreateInput>>;
  /** The primary key(s) for `levelNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameExtraLevelNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `levelNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameExtraOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelNameExtraPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameExtraLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameExtra` to be created by this mutation. */
export type LevelNameExtraLevelIdFkeyLevelNameExtraCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameExtraLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameExtra` to look up the row to connect. */
export type LevelNameExtraLevelNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameExtra` to look up the row to delete. */
export type LevelNameExtraLevelNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameExtra` to look up the row to update. */
export type LevelNameExtraOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameExtra` being updated. */
  patch: UpdateLevelNameExtraOnLevelNameExtraForLevelNameExtraLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameExtra`. Fields that are set will be updated. */
export type LevelNameExtraPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameExtraLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameExtra` values. */
export type LevelNameExtrasConnection = {
  __typename?: 'LevelNameExtrasConnection';
  /** A list of edges which contains the `LevelNameExtra` and cursor to aid in pagination. */
  edges: Array<LevelNameExtrasEdge>;
  /** A list of `LevelNameExtra` objects. */
  nodes: Array<LevelNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameExtra` edge in the connection. */
export type LevelNameExtrasEdge = {
  __typename?: 'LevelNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameExtra` at the end of the edge. */
  node: LevelNameExtra;
};

/** Methods to use when ordering `LevelNameExtra`. */
export enum LevelNameExtrasOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type LevelNameKeyCad = {
  __typename?: 'LevelNameKeyCad';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameKeyCad`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelNameKeyCadCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameKeyCadFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameKeyCadFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameKeyCad` */
export type LevelNameKeyCadInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `level` in the `LevelNameKeyCadInput` mutation. */
export type LevelNameKeyCadLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameKeyCadLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameKeyCad` in the `LevelInput` mutation. */
export type LevelNameKeyCadLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameKeyCadLevelNameKeyCadPkeyConnect>>;
  /** A `LevelNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameKeyCadLevelIdFkeyLevelNameKeyCadCreateInput>>;
  /** The primary key(s) for `levelNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameKeyCadLevelNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `levelNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameKeyCadOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelNameKeyCadPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameKeyCadLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameKeyCad` to be created by this mutation. */
export type LevelNameKeyCadLevelIdFkeyLevelNameKeyCadCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameKeyCad` to look up the row to connect. */
export type LevelNameKeyCadLevelNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyCad` to look up the row to delete. */
export type LevelNameKeyCadLevelNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyCad` to look up the row to update. */
export type LevelNameKeyCadOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameKeyCad` being updated. */
  patch: UpdateLevelNameKeyCadOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameKeyCad`. Fields that are set will be updated. */
export type LevelNameKeyCadPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameKeyCad` values. */
export type LevelNameKeyCadsConnection = {
  __typename?: 'LevelNameKeyCadsConnection';
  /** A list of edges which contains the `LevelNameKeyCad` and cursor to aid in pagination. */
  edges: Array<LevelNameKeyCadsEdge>;
  /** A list of `LevelNameKeyCad` objects. */
  nodes: Array<LevelNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameKeyCad` edge in the connection. */
export type LevelNameKeyCadsEdge = {
  __typename?: 'LevelNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameKeyCad` at the end of the edge. */
  node: LevelNameKeyCad;
};

/** Methods to use when ordering `LevelNameKeyCad`. */
export enum LevelNameKeyCadsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type LevelNameKeyCafm = {
  __typename?: 'LevelNameKeyCafm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameKeyCafm`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameKeyCafm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelNameKeyCafmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameKeyCafmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameKeyCafmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameKeyCafm` */
export type LevelNameKeyCafmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `level` in the `LevelNameKeyCafmInput` mutation. */
export type LevelNameKeyCafmLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameKeyCafmLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameKeyCafm` in the `LevelInput` mutation. */
export type LevelNameKeyCafmLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameKeyCafmLevelNameKeyCafmPkeyConnect>>;
  /** A `LevelNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameKeyCafmLevelIdFkeyLevelNameKeyCafmCreateInput>>;
  /** The primary key(s) for `levelNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameKeyCafmLevelNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `levelNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameKeyCafmOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelNameKeyCafmPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameKeyCafmLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameKeyCafm` to be created by this mutation. */
export type LevelNameKeyCafmLevelIdFkeyLevelNameKeyCafmCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameKeyCafm` to look up the row to connect. */
export type LevelNameKeyCafmLevelNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyCafm` to look up the row to delete. */
export type LevelNameKeyCafmLevelNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyCafm` to look up the row to update. */
export type LevelNameKeyCafmOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameKeyCafm` being updated. */
  patch: UpdateLevelNameKeyCafmOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameKeyCafm`. Fields that are set will be updated. */
export type LevelNameKeyCafmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameKeyCafm` values. */
export type LevelNameKeyCafmsConnection = {
  __typename?: 'LevelNameKeyCafmsConnection';
  /** A list of edges which contains the `LevelNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<LevelNameKeyCafmsEdge>;
  /** A list of `LevelNameKeyCafm` objects. */
  nodes: Array<LevelNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameKeyCafm` edge in the connection. */
export type LevelNameKeyCafmsEdge = {
  __typename?: 'LevelNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameKeyCafm` at the end of the edge. */
  node: LevelNameKeyCafm;
};

/** Methods to use when ordering `LevelNameKeyCafm`. */
export enum LevelNameKeyCafmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type LevelNameKeyEbm = {
  __typename?: 'LevelNameKeyEbm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameKeyEbm`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelNameKeyEbmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameKeyEbmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameKeyEbmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameKeyEbm` */
export type LevelNameKeyEbmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameKeyEbm` to look up the row to connect. */
export type LevelNameKeyEbmLevelNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyEbm` to look up the row to delete. */
export type LevelNameKeyEbmLevelNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyEbm` to look up the row to update. */
export type LevelNameKeyEbmOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameKeyEbm` being updated. */
  patch: UpdateLevelNameKeyEbmOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameKeyEbm`. Fields that are set will be updated. */
export type LevelNameKeyEbmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameKeyEbm` values. */
export type LevelNameKeyEbmsConnection = {
  __typename?: 'LevelNameKeyEbmsConnection';
  /** A list of edges which contains the `LevelNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<LevelNameKeyEbmsEdge>;
  /** A list of `LevelNameKeyEbm` objects. */
  nodes: Array<LevelNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameKeyEbm` edge in the connection. */
export type LevelNameKeyEbmsEdge = {
  __typename?: 'LevelNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameKeyEbm` at the end of the edge. */
  node: LevelNameKeyEbm;
};

/** Input for the nested mutation of `level` in the `LevelNameKeyEbmInput` mutation. */
export type LevelNameKeyEbmsLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameKeyEbm` in the `LevelInput` mutation. */
export type LevelNameKeyEbmsLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameKeyEbmLevelNameKeyEbmsPkeyConnect>>;
  /** A `LevelNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameKeyEbmsLevelIdFkeyLevelNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `levelNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameKeyEbmLevelNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `levelNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameKeyEbmOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelNameKeyEbmsPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameKeyEbmsLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameKeyEbm` to be created by this mutation. */
export type LevelNameKeyEbmsLevelIdFkeyLevelNameKeyEbmsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Methods to use when ordering `LevelNameKeyEbm`. */
export enum LevelNameKeyEbmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type LevelNameKeyMarketing = {
  __typename?: 'LevelNameKeyMarketing';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameKeyMarketing`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameKeyMarketing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LevelNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameKeyMarketingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameKeyMarketingFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameKeyMarketing` */
export type LevelNameKeyMarketingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `level` in the `LevelNameKeyMarketingInput` mutation. */
export type LevelNameKeyMarketingLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameKeyMarketing` in the `LevelInput` mutation. */
export type LevelNameKeyMarketingLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameKeyMarketingLevelNameKeyMarketingPkeyConnect>>;
  /** A `LevelNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameKeyMarketingLevelIdFkeyLevelNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `levelNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameKeyMarketingLevelNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `levelNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameKeyMarketingOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelNameKeyMarketingPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameKeyMarketingLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameKeyMarketing` to be created by this mutation. */
export type LevelNameKeyMarketingLevelIdFkeyLevelNameKeyMarketingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameKeyMarketing` to look up the row to connect. */
export type LevelNameKeyMarketingLevelNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyMarketing` to look up the row to delete. */
export type LevelNameKeyMarketingLevelNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameKeyMarketing` to look up the row to update. */
export type LevelNameKeyMarketingOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameKeyMarketing` being updated. */
  patch: UpdateLevelNameKeyMarketingOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameKeyMarketing`. Fields that are set will be updated. */
export type LevelNameKeyMarketingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameKeyMarketing` values. */
export type LevelNameKeyMarketingsConnection = {
  __typename?: 'LevelNameKeyMarketingsConnection';
  /** A list of edges which contains the `LevelNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<LevelNameKeyMarketingsEdge>;
  /** A list of `LevelNameKeyMarketing` objects. */
  nodes: Array<LevelNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameKeyMarketing` edge in the connection. */
export type LevelNameKeyMarketingsEdge = {
  __typename?: 'LevelNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameKeyMarketing` at the end of the edge. */
  node: LevelNameKeyMarketing;
};

/** Methods to use when ordering `LevelNameKeyMarketing`. */
export enum LevelNameKeyMarketingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type LevelNameLong = {
  __typename?: 'LevelNameLong';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameLong`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelNameLongCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameLong` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameLongFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameLongFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameLong` */
export type LevelNameLongInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameLongLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `level` in the `LevelNameLongInput` mutation. */
export type LevelNameLongLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameLongLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameLong` in the `LevelInput` mutation. */
export type LevelNameLongLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameLongLevelNameLongPkeyConnect>>;
  /** A `LevelNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameLongLevelIdFkeyLevelNameLongCreateInput>>;
  /** The primary key(s) for `levelNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameLongLevelNameLongPkeyDelete>>;
  /** Flag indicating whether all other `levelNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameLongOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelNameLongPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameLongLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameLong` to be created by this mutation. */
export type LevelNameLongLevelIdFkeyLevelNameLongCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameLongLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameLong` to look up the row to connect. */
export type LevelNameLongLevelNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameLong` to look up the row to delete. */
export type LevelNameLongLevelNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameLong` to look up the row to update. */
export type LevelNameLongOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameLong` being updated. */
  patch: UpdateLevelNameLongOnLevelNameLongForLevelNameLongLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameLong`. Fields that are set will be updated. */
export type LevelNameLongPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameLongLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameLong` values. */
export type LevelNameLongsConnection = {
  __typename?: 'LevelNameLongsConnection';
  /** A list of edges which contains the `LevelNameLong` and cursor to aid in pagination. */
  edges: Array<LevelNameLongsEdge>;
  /** A list of `LevelNameLong` objects. */
  nodes: Array<LevelNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameLong` edge in the connection. */
export type LevelNameLongsEdge = {
  __typename?: 'LevelNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameLong` at the end of the edge. */
  node: LevelNameLong;
};

/** Methods to use when ordering `LevelNameLong`. */
export enum LevelNameLongsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type LevelNameShort = {
  __typename?: 'LevelNameShort';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelNameShort`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `LevelNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelNameShortCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelNameShort` object types. All fields are combined with a logical ‘and.’ */
export type LevelNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelNameShortFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelNameShortFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LevelNameShort` */
export type LevelNameShortInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameShortLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `level` in the `LevelNameShortInput` mutation. */
export type LevelNameShortLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelNameShortLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelNameShort` in the `LevelInput` mutation. */
export type LevelNameShortLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelNameShortLevelNameShortPkeyConnect>>;
  /** A `LevelNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelNameShortLevelIdFkeyLevelNameShortCreateInput>>;
  /** The primary key(s) for `levelNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelNameShortLevelNameShortPkeyDelete>>;
  /** Flag indicating whether all other `levelNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelNameShortOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelNameShortPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelNameShortLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelNameShort` to be created by this mutation. */
export type LevelNameShortLevelIdFkeyLevelNameShortCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameShortLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `levelNameShort` to look up the row to connect. */
export type LevelNameShortLevelNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameShort` to look up the row to delete. */
export type LevelNameShortLevelNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelNameShort` to look up the row to update. */
export type LevelNameShortOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelNameShort` being updated. */
  patch: UpdateLevelNameShortOnLevelNameShortForLevelNameShortLevelIdFkeyPatch;
};

/** Represents an update to a `LevelNameShort`. Fields that are set will be updated. */
export type LevelNameShortPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameShortLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LevelNameShort` values. */
export type LevelNameShortsConnection = {
  __typename?: 'LevelNameShortsConnection';
  /** A list of edges which contains the `LevelNameShort` and cursor to aid in pagination. */
  edges: Array<LevelNameShortsEdge>;
  /** A list of `LevelNameShort` objects. */
  nodes: Array<LevelNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelNameShort` edge in the connection. */
export type LevelNameShortsEdge = {
  __typename?: 'LevelNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelNameShort` at the end of the edge. */
  node: LevelNameShort;
};

/** Methods to use when ordering `LevelNameShort`. */
export enum LevelNameShortsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelBuildingIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelBuildingIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelBuildingIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelBuildingIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelBuildingIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelBuildingIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelElevationIdKeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelElevationIdKeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelElevationIdKeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelElevationIdKeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelElevationIdKeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelElevationIdKeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelTypeIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelTypeIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelTypeIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelTypeIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelForLevelTypeIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelForLevelTypeIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameLongForLevelNameLongLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameLongForLevelNameLongLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameLongForLevelNameLongLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameLongForLevelNameLongLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameShortForLevelNameShortLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameShortForLevelNameShortLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelNameShortForLevelNameShortLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelNameShortForLevelNameShortLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnRoomForRoomLevelIdFkeyUsingLevelExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnRoomForRoomLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnRoomForRoomLevelIdFkeyUsingLevelNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnRoomForRoomLevelIdFkeyPatch;
};

/** The fields on `level` to look up the row to update. */
export type LevelOnRoomForRoomLevelIdFkeyUsingLevelPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `level` being updated. */
  patch: UpdateLevelOnRoomForRoomLevelIdFkeyPatch;
};

/** Represents an update to a `Level`. Fields that are set will be updated. */
export type LevelPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type LevelPublicGrossSpace = {
  __typename?: 'LevelPublicGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelPublicGrossSpace`. */
  level: Level;
  levelId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `LevelPublicGrossSpace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LevelPublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `LevelPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type LevelPublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelPublicGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelPublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelPublicGrossSpaceFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `LevelPublicGrossSpace` */
export type LevelPublicGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** Input for the nested mutation of `level` in the `LevelPublicGrossSpaceInput` mutation. */
export type LevelPublicGrossSpaceLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelPublicGrossSpace` in the `LevelInput` mutation. */
export type LevelPublicGrossSpaceLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelPublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelPublicGrossSpaceLevelPublicGrossSpacePkeyConnect>>;
  /** A `LevelPublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelPublicGrossSpaceLevelIdFkeyLevelPublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `levelPublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelPublicGrossSpaceLevelPublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `levelPublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelPublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelPublicGrossSpaceOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelPublicGrossSpacePkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelPublicGrossSpaceLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelPublicGrossSpace` to be created by this mutation. */
export type LevelPublicGrossSpaceLevelIdFkeyLevelPublicGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `levelPublicGrossSpace` to look up the row to connect. */
export type LevelPublicGrossSpaceLevelPublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelPublicGrossSpace` to look up the row to delete. */
export type LevelPublicGrossSpaceLevelPublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelPublicGrossSpace` to look up the row to update. */
export type LevelPublicGrossSpaceOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyUsingLevelPublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelPublicGrossSpace` being updated. */
  patch: UpdateLevelPublicGrossSpaceOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyPatch;
};

/** Represents an update to a `LevelPublicGrossSpace`. Fields that are set will be updated. */
export type LevelPublicGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `LevelPublicGrossSpace` values. */
export type LevelPublicGrossSpacesConnection = {
  __typename?: 'LevelPublicGrossSpacesConnection';
  /** A list of edges which contains the `LevelPublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<LevelPublicGrossSpacesEdge>;
  /** A list of `LevelPublicGrossSpace` objects. */
  nodes: Array<LevelPublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelPublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelPublicGrossSpace` edge in the connection. */
export type LevelPublicGrossSpacesEdge = {
  __typename?: 'LevelPublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelPublicGrossSpace` at the end of the edge. */
  node: LevelPublicGrossSpace;
};

/** Methods to use when ordering `LevelPublicGrossSpace`. */
export enum LevelPublicGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against many `LevelCapacityPax` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelCapacityPaxFilter = {
  /** Every related `LevelCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelCapacityPaxFilter>;
  /** No related `LevelCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelCapacityPaxFilter>;
  /** Some related `LevelCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelCapacityPaxFilter>;
};

/** A filter to be used against many `LevelDescription` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelDescriptionFilter = {
  /** Every related `LevelDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelDescriptionFilter>;
  /** No related `LevelDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelDescriptionFilter>;
  /** Some related `LevelDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelDescriptionFilter>;
};

/** A filter to be used against many `LevelFkmGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelFkmGrossSpaceFilter = {
  /** Every related `LevelFkmGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelFkmGrossSpaceFilter>;
  /** No related `LevelFkmGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelFkmGrossSpaceFilter>;
  /** Some related `LevelFkmGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelFkmGrossSpaceFilter>;
};

/** A filter to be used against many `LevelNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameExtraFilter = {
  /** Every related `LevelNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameExtraFilter>;
  /** No related `LevelNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameExtraFilter>;
  /** Some related `LevelNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameExtraFilter>;
};

/** A filter to be used against many `LevelNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameKeyCadFilter = {
  /** Every related `LevelNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameKeyCadFilter>;
  /** No related `LevelNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameKeyCadFilter>;
  /** Some related `LevelNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameKeyCadFilter>;
};

/** A filter to be used against many `LevelNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameKeyCafmFilter = {
  /** Every related `LevelNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameKeyCafmFilter>;
  /** No related `LevelNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameKeyCafmFilter>;
  /** Some related `LevelNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameKeyCafmFilter>;
};

/** A filter to be used against many `LevelNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameKeyEbmFilter = {
  /** Every related `LevelNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameKeyEbmFilter>;
  /** No related `LevelNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameKeyEbmFilter>;
  /** Some related `LevelNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameKeyEbmFilter>;
};

/** A filter to be used against many `LevelNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameKeyMarketingFilter = {
  /** Every related `LevelNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameKeyMarketingFilter>;
  /** No related `LevelNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameKeyMarketingFilter>;
  /** Some related `LevelNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameKeyMarketingFilter>;
};

/** A filter to be used against many `LevelNameLong` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameLongFilter = {
  /** Every related `LevelNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameLongFilter>;
  /** No related `LevelNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameLongFilter>;
  /** Some related `LevelNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameLongFilter>;
};

/** A filter to be used against many `LevelNameShort` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelNameShortFilter = {
  /** Every related `LevelNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelNameShortFilter>;
  /** No related `LevelNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelNameShortFilter>;
  /** Some related `LevelNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelNameShortFilter>;
};

/** A filter to be used against many `LevelPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelPublicGrossSpaceFilter = {
  /** Every related `LevelPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelPublicGrossSpaceFilter>;
  /** No related `LevelPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelPublicGrossSpaceFilter>;
  /** Some related `LevelPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelPublicGrossSpaceFilter>;
};

/** A filter to be used against many `LevelTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyLevelTypeAttrFilter = {
  /** Every related `LevelTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelTypeAttrFilter>;
  /** No related `LevelTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelTypeAttrFilter>;
  /** Some related `LevelTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelTypeAttrFilter>;
};

/** A filter to be used against many `Room` object types. All fields are combined with a logical ‘and.’ */
export type LevelToManyRoomFilter = {
  /** Every related `Room` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomFilter>;
  /** No related `Room` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomFilter>;
  /** Some related `Room` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomFilter>;
};

export type LevelType = {
  __typename?: 'LevelType';
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  /** Reads and enables pagination through a set of `LevelTypeAttr`. */
  levelTypeAttrs: LevelTypeAttrsConnection;
  /** Reads and enables pagination through a set of `Level`. */
  levelsByTypeId: LevelsConnection;
  name: Scalars['String'];
};


export type LevelTypeLevelTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelTypeAttrCondition>;
  filter?: InputMaybe<LevelTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelTypeAttrsOrderBy>>;
};


export type LevelTypeLevelsByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelCondition>;
  filter?: InputMaybe<LevelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};

export type LevelTypeAttr = {
  __typename?: 'LevelTypeAttr';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `LevelTypeAttr`. */
  level: Level;
  levelId: Scalars['UUID'];
  /** Reads a single `LevelType` that is related to this `LevelTypeAttr`. */
  levelType: LevelType;
  levelTypeId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `LevelTypeAttr` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LevelTypeAttrCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelTypeId` field. */
  levelTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `LevelTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type LevelTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelTypeAttrFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `levelType` relation. */
  levelType?: InputMaybe<LevelTypeFilter>;
  /** Filter by the object’s `levelTypeId` field. */
  levelTypeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelTypeAttrFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LevelTypeAttr` */
export type LevelTypeAttrInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelTypeAttrLevelIdFkeyInput>;
  levelTypeId?: InputMaybe<Scalars['UUID']>;
  levelTypeToLevelTypeId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `level` in the `LevelTypeAttrInput` mutation. */
export type LevelTypeAttrLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelTypeAttrLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `levelTypeAttr` in the `LevelInput` mutation. */
export type LevelTypeAttrLevelIdFkeyInverseInput = {
  /** The primary key(s) for `levelTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelTypeAttrLevelTypeAttrPkeyConnect>>;
  /** A `LevelTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelTypeAttrLevelIdFkeyLevelTypeAttrCreateInput>>;
  /** The primary key(s) for `levelTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelTypeAttrLevelTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `levelTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelTypeAttrPkeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelTypeAttrLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `levelTypeAttr` to be created by this mutation. */
export type LevelTypeAttrLevelIdFkeyLevelTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelTypeAttrLevelIdFkeyInput>;
  levelTypeId?: InputMaybe<Scalars['UUID']>;
  levelTypeToLevelTypeId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `levelTypeAttr` to look up the row to connect. */
export type LevelTypeAttrLevelTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelTypeAttr` to look up the row to delete. */
export type LevelTypeAttrLevelTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `levelType` in the `LevelTypeAttrInput` mutation. */
export type LevelTypeAttrLevelTypeIdFkeyInput = {
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  connectById?: InputMaybe<LevelTypeLevelTypePkeyConnect>;
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  connectByName?: InputMaybe<LevelTypeLevelTypeNameKeyConnect>;
  /** A `LevelTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyLevelTypeCreateInput>;
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelTypeLevelTypePkeyDelete>;
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  deleteByName?: InputMaybe<LevelTypeLevelTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `levelType` for the far side of the relationship. */
  updateById?: InputMaybe<LevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyUsingLevelTypePkeyUpdate>;
  /** The primary key(s) and patch data for `levelType` for the far side of the relationship. */
  updateByName?: InputMaybe<LevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyUsingLevelTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `levelTypeAttr` in the `LevelTypeInput` mutation. */
export type LevelTypeAttrLevelTypeIdFkeyInverseInput = {
  /** The primary key(s) for `levelTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelTypeAttrLevelTypeAttrPkeyConnect>>;
  /** A `LevelTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelTypeAttrLevelTypeIdFkeyLevelTypeAttrCreateInput>>;
  /** The primary key(s) for `levelTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelTypeAttrLevelTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `levelTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `levelTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyUsingLevelTypeAttrPkeyUpdate>>;
};

/** The `levelTypeAttr` to be created by this mutation. */
export type LevelTypeAttrLevelTypeIdFkeyLevelTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelTypeAttrLevelIdFkeyInput>;
  levelTypeToLevelTypeId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `levelType` to be created by this mutation. */
export type LevelTypeAttrLevelTypeIdFkeyLevelTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInverseInput>;
  levelsUsingId?: InputMaybe<LevelTypeIdFkeyInverseInput>;
  name: Scalars['String'];
};

/** The fields on `levelTypeAttr` to look up the row to update. */
export type LevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyUsingLevelTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelTypeAttr` being updated. */
  patch: UpdateLevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyPatch;
};

/** The fields on `levelTypeAttr` to look up the row to update. */
export type LevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyUsingLevelTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelTypeAttr` being updated. */
  patch: UpdateLevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyPatch;
};

/** Represents an update to a `LevelTypeAttr`. Fields that are set will be updated. */
export type LevelTypeAttrPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelTypeAttrLevelIdFkeyInput>;
  levelTypeId?: InputMaybe<Scalars['UUID']>;
  levelTypeToLevelTypeId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `LevelTypeAttr` values. */
export type LevelTypeAttrsConnection = {
  __typename?: 'LevelTypeAttrsConnection';
  /** A list of edges which contains the `LevelTypeAttr` and cursor to aid in pagination. */
  edges: Array<LevelTypeAttrsEdge>;
  /** A list of `LevelTypeAttr` objects. */
  nodes: Array<LevelTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelTypeAttr` edge in the connection. */
export type LevelTypeAttrsEdge = {
  __typename?: 'LevelTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelTypeAttr` at the end of the edge. */
  node: LevelTypeAttr;
};

/** Methods to use when ordering `LevelTypeAttr`. */
export enum LevelTypeAttrsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  LevelTypeByLevelTypeIdDescriptionAsc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__DESCRIPTION_ASC',
  LevelTypeByLevelTypeIdDescriptionDesc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__DESCRIPTION_DESC',
  LevelTypeByLevelTypeIdIdAsc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__ID_ASC',
  LevelTypeByLevelTypeIdIdDesc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__ID_DESC',
  LevelTypeByLevelTypeIdIndexAsc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__INDEX_ASC',
  LevelTypeByLevelTypeIdIndexDesc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__INDEX_DESC',
  LevelTypeByLevelTypeIdNameAsc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__NAME_ASC',
  LevelTypeByLevelTypeIdNameDesc = 'LEVEL_TYPE_BY_LEVEL_TYPE_ID__NAME_DESC',
  LevelTypeIdAsc = 'LEVEL_TYPE_ID_ASC',
  LevelTypeIdDesc = 'LEVEL_TYPE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/**
 * A condition to be used against `LevelType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LevelTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `LevelType` object types. All fields are combined with a logical ‘and.’ */
export type LevelTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LevelTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `levelTypeAttrs` relation. */
  levelTypeAttrs?: InputMaybe<LevelTypeToManyLevelTypeAttrFilter>;
  /** Some related `levelTypeAttrs` exist. */
  levelTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `levelsByTypeId` relation. */
  levelsByTypeId?: InputMaybe<LevelTypeToManyLevelFilter>;
  /** Some related `levelsByTypeId` exist. */
  levelsByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LevelTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LevelTypeFilter>>;
};

/** Input for the nested mutation of `levelType` in the `LevelInput` mutation. */
export type LevelTypeIdFkeyInput = {
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  connectById?: InputMaybe<LevelTypeLevelTypePkeyConnect>;
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  connectByName?: InputMaybe<LevelTypeLevelTypeNameKeyConnect>;
  /** A `LevelTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<LevelTypeIdFkeyLevelTypeCreateInput>;
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelTypeLevelTypePkeyDelete>;
  /** The primary key(s) for `levelType` for the far side of the relationship. */
  deleteByName?: InputMaybe<LevelTypeLevelTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `levelType` for the far side of the relationship. */
  updateById?: InputMaybe<LevelTypeOnLevelForLevelTypeIdFkeyUsingLevelTypePkeyUpdate>;
  /** The primary key(s) and patch data for `levelType` for the far side of the relationship. */
  updateByName?: InputMaybe<LevelTypeOnLevelForLevelTypeIdFkeyUsingLevelTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `level` in the `LevelTypeInput` mutation. */
export type LevelTypeIdFkeyInverseInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<LevelLevelExtIdKeyConnect>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LevelLevelPkeyConnect>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<LevelLevelNameShortKeyConnect>>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LevelTypeIdFkeyLevelCreateInput>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<LevelLevelExtIdKeyDelete>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LevelLevelPkeyDelete>>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<LevelLevelNameShortKeyDelete>>;
  /** Flag indicating whether all other `level` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<LevelOnLevelForLevelTypeIdFkeyUsingLevelExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LevelOnLevelForLevelTypeIdFkeyUsingLevelPkeyUpdate>>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<LevelOnLevelForLevelTypeIdFkeyUsingLevelNameShortKeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type LevelTypeIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
};

/** The `levelType` to be created by this mutation. */
export type LevelTypeIdFkeyLevelTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInverseInput>;
  levelsUsingId?: InputMaybe<LevelTypeIdFkeyInverseInput>;
  name: Scalars['String'];
};

/** An input for mutations affecting `LevelType` */
export type LevelTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInverseInput>;
  levelsUsingId?: InputMaybe<LevelTypeIdFkeyInverseInput>;
  name: Scalars['String'];
};

/** The fields on `levelType` to look up the row to connect. */
export type LevelTypeLevelTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `levelType` to look up the row to delete. */
export type LevelTypeLevelTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `levelType` to look up the row to connect. */
export type LevelTypeLevelTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `levelType` to look up the row to delete. */
export type LevelTypeLevelTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `levelType` to look up the row to update. */
export type LevelTypeOnLevelForLevelTypeIdFkeyUsingLevelTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `levelType` being updated. */
  patch: UpdateLevelTypeOnLevelForLevelTypeIdFkeyPatch;
};

/** The fields on `levelType` to look up the row to update. */
export type LevelTypeOnLevelForLevelTypeIdFkeyUsingLevelTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelType` being updated. */
  patch: UpdateLevelTypeOnLevelForLevelTypeIdFkeyPatch;
};

/** The fields on `levelType` to look up the row to update. */
export type LevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyUsingLevelTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `levelType` being updated. */
  patch: UpdateLevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyPatch;
};

/** The fields on `levelType` to look up the row to update. */
export type LevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyUsingLevelTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `levelType` being updated. */
  patch: UpdateLevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyPatch;
};

/** Represents an update to a `LevelType`. Fields that are set will be updated. */
export type LevelTypePatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInverseInput>;
  levelsUsingId?: InputMaybe<LevelTypeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `Level` object types. All fields are combined with a logical ‘and.’ */
export type LevelTypeToManyLevelFilter = {
  /** Every related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelFilter>;
  /** No related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelFilter>;
  /** Some related `Level` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelFilter>;
};

/** A filter to be used against many `LevelTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type LevelTypeToManyLevelTypeAttrFilter = {
  /** Every related `LevelTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LevelTypeAttrFilter>;
  /** No related `LevelTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LevelTypeAttrFilter>;
  /** Some related `LevelTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LevelTypeAttrFilter>;
};

/** A connection to a list of `LevelType` values. */
export type LevelTypesConnection = {
  __typename?: 'LevelTypesConnection';
  /** A list of edges which contains the `LevelType` and cursor to aid in pagination. */
  edges: Array<LevelTypesEdge>;
  /** A list of `LevelType` objects. */
  nodes: Array<LevelType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LevelType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LevelType` edge in the connection. */
export type LevelTypesEdge = {
  __typename?: 'LevelTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LevelType` at the end of the edge. */
  node: LevelType;
};

/** Methods to use when ordering `LevelType`. */
export enum LevelTypesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  LevelsByTypeIdCountAsc = 'LEVELS_BY_TYPE_ID__COUNT_ASC',
  LevelsByTypeIdCountDesc = 'LEVELS_BY_TYPE_ID__COUNT_DESC',
  LevelTypeAttrsByLevelTypeIdCountAsc = 'LEVEL_TYPE_ATTRS_BY_LEVEL_TYPE_ID__COUNT_ASC',
  LevelTypeAttrsByLevelTypeIdCountDesc = 'LEVEL_TYPE_ATTRS_BY_LEVEL_TYPE_ID__COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Level` values. */
export type LevelsConnection = {
  __typename?: 'LevelsConnection';
  /** A list of edges which contains the `Level` and cursor to aid in pagination. */
  edges: Array<LevelsEdge>;
  /** A list of `Level` objects. */
  nodes: Array<Level>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Level` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Level` edge in the connection. */
export type LevelsEdge = {
  __typename?: 'LevelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Level` at the end of the edge. */
  node: Level;
};

/** Methods to use when ordering `Level`. */
export enum LevelsOrderBy {
  BuildingByBuildingIdDescriptionAsc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_ASC',
  BuildingByBuildingIdDescriptionDesc = 'BUILDING_BY_BUILDING_ID__DESCRIPTION_DESC',
  BuildingByBuildingIdExtIdAsc = 'BUILDING_BY_BUILDING_ID__EXT_ID_ASC',
  BuildingByBuildingIdExtIdDesc = 'BUILDING_BY_BUILDING_ID__EXT_ID_DESC',
  BuildingByBuildingIdIdAsc = 'BUILDING_BY_BUILDING_ID__ID_ASC',
  BuildingByBuildingIdIdDesc = 'BUILDING_BY_BUILDING_ID__ID_DESC',
  BuildingByBuildingIdNameLongAsc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_ASC',
  BuildingByBuildingIdNameLongDesc = 'BUILDING_BY_BUILDING_ID__NAME_LONG_DESC',
  BuildingByBuildingIdNameShortAsc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_ASC',
  BuildingByBuildingIdNameShortDesc = 'BUILDING_BY_BUILDING_ID__NAME_SHORT_DESC',
  BuildingByBuildingIdSiteIdAsc = 'BUILDING_BY_BUILDING_ID__SITE_ID_ASC',
  BuildingByBuildingIdSiteIdDesc = 'BUILDING_BY_BUILDING_ID__SITE_ID_DESC',
  BuildingByBuildingIdTypeIdAsc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_ASC',
  BuildingByBuildingIdTypeIdDesc = 'BUILDING_BY_BUILDING_ID__TYPE_ID_DESC',
  BuildingIdAsc = 'BUILDING_ID_ASC',
  BuildingIdDesc = 'BUILDING_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ElevationIdAsc = 'ELEVATION_ID_ASC',
  ElevationIdDesc = 'ELEVATION_ID_DESC',
  ElevationLevelByElevationIdIdAsc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__ID_ASC',
  ElevationLevelByElevationIdIdDesc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__ID_DESC',
  ElevationLevelByElevationIdNameLongAsc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__NAME_LONG_ASC',
  ElevationLevelByElevationIdNameLongDesc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__NAME_LONG_DESC',
  ElevationLevelByElevationIdNameShortAsc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__NAME_SHORT_ASC',
  ElevationLevelByElevationIdNameShortDesc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__NAME_SHORT_DESC',
  ElevationLevelByElevationIdValueAsc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__VALUE_ASC',
  ElevationLevelByElevationIdValueDesc = 'ELEVATION_LEVEL_BY_ELEVATION_ID__VALUE_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelCapacityPaxesByLevelIdCountAsc = 'LEVEL_CAPACITY_PAXES_BY_LEVEL_ID__COUNT_ASC',
  LevelCapacityPaxesByLevelIdCountDesc = 'LEVEL_CAPACITY_PAXES_BY_LEVEL_ID__COUNT_DESC',
  LevelDescriptionsByLevelIdCountAsc = 'LEVEL_DESCRIPTIONS_BY_LEVEL_ID__COUNT_ASC',
  LevelDescriptionsByLevelIdCountDesc = 'LEVEL_DESCRIPTIONS_BY_LEVEL_ID__COUNT_DESC',
  LevelFkmGrossSpacesByLevelIdCountAsc = 'LEVEL_FKM_GROSS_SPACES_BY_LEVEL_ID__COUNT_ASC',
  LevelFkmGrossSpacesByLevelIdCountDesc = 'LEVEL_FKM_GROSS_SPACES_BY_LEVEL_ID__COUNT_DESC',
  LevelNameExtrasByLevelIdCountAsc = 'LEVEL_NAME_EXTRAS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameExtrasByLevelIdCountDesc = 'LEVEL_NAME_EXTRAS_BY_LEVEL_ID__COUNT_DESC',
  LevelNameKeyCadsByLevelIdCountAsc = 'LEVEL_NAME_KEY_CADS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameKeyCadsByLevelIdCountDesc = 'LEVEL_NAME_KEY_CADS_BY_LEVEL_ID__COUNT_DESC',
  LevelNameKeyCafmsByLevelIdCountAsc = 'LEVEL_NAME_KEY_CAFMS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameKeyCafmsByLevelIdCountDesc = 'LEVEL_NAME_KEY_CAFMS_BY_LEVEL_ID__COUNT_DESC',
  LevelNameKeyEbmsByLevelIdCountAsc = 'LEVEL_NAME_KEY_EBMS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameKeyEbmsByLevelIdCountDesc = 'LEVEL_NAME_KEY_EBMS_BY_LEVEL_ID__COUNT_DESC',
  LevelNameKeyMarketingsByLevelIdCountAsc = 'LEVEL_NAME_KEY_MARKETINGS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameKeyMarketingsByLevelIdCountDesc = 'LEVEL_NAME_KEY_MARKETINGS_BY_LEVEL_ID__COUNT_DESC',
  LevelNameLongsByLevelIdCountAsc = 'LEVEL_NAME_LONGS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameLongsByLevelIdCountDesc = 'LEVEL_NAME_LONGS_BY_LEVEL_ID__COUNT_DESC',
  LevelNameShortsByLevelIdCountAsc = 'LEVEL_NAME_SHORTS_BY_LEVEL_ID__COUNT_ASC',
  LevelNameShortsByLevelIdCountDesc = 'LEVEL_NAME_SHORTS_BY_LEVEL_ID__COUNT_DESC',
  LevelPublicGrossSpacesByLevelIdCountAsc = 'LEVEL_PUBLIC_GROSS_SPACES_BY_LEVEL_ID__COUNT_ASC',
  LevelPublicGrossSpacesByLevelIdCountDesc = 'LEVEL_PUBLIC_GROSS_SPACES_BY_LEVEL_ID__COUNT_DESC',
  LevelTypeAttrsByLevelIdCountAsc = 'LEVEL_TYPE_ATTRS_BY_LEVEL_ID__COUNT_ASC',
  LevelTypeAttrsByLevelIdCountDesc = 'LEVEL_TYPE_ATTRS_BY_LEVEL_ID__COUNT_DESC',
  LevelTypeByTypeIdDescriptionAsc = 'LEVEL_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  LevelTypeByTypeIdDescriptionDesc = 'LEVEL_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  LevelTypeByTypeIdIdAsc = 'LEVEL_TYPE_BY_TYPE_ID__ID_ASC',
  LevelTypeByTypeIdIdDesc = 'LEVEL_TYPE_BY_TYPE_ID__ID_DESC',
  LevelTypeByTypeIdIndexAsc = 'LEVEL_TYPE_BY_TYPE_ID__INDEX_ASC',
  LevelTypeByTypeIdIndexDesc = 'LEVEL_TYPE_BY_TYPE_ID__INDEX_DESC',
  LevelTypeByTypeIdNameAsc = 'LEVEL_TYPE_BY_TYPE_ID__NAME_ASC',
  LevelTypeByTypeIdNameDesc = 'LEVEL_TYPE_BY_TYPE_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomsByLevelIdCountAsc = 'ROOMS_BY_LEVEL_ID__COUNT_ASC',
  RoomsByLevelIdCountDesc = 'ROOMS_BY_LEVEL_ID__COUNT_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

export type Link = {
  __typename?: 'Link';
  description: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads a single `Multilink` that is related to this `Link`. */
  multilink?: Maybe<Multilink>;
  multilinkId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  to: Scalars['String'];
};

/** A condition to be used against `Link` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LinkCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `multilinkId` field. */
  multilinkId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `to` field. */
  to?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Link` object types. All fields are combined with a logical ‘and.’ */
export type LinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LinkFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `multilink` relation. */
  multilink?: InputMaybe<MultilinkFilter>;
  /** A related `multilink` exists. */
  multilinkExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `multilinkId` field. */
  multilinkId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LinkFilter>>;
  /** Filter by the object’s `to` field. */
  to?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Link` */
export type LinkInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkId?: InputMaybe<Scalars['UUID']>;
  multilinkToMultilinkId?: InputMaybe<LinkMultilinkIdFkeyInput>;
  name?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** The fields on `link` to look up the row to connect. */
export type LinkLinkPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `link` to look up the row to delete. */
export type LinkLinkPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `multilink` in the `LinkInput` mutation. */
export type LinkMultilinkIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<LinkMultilinkIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnLinkForLinkMultilinkIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `link` in the `MultilinkInput` mutation. */
export type LinkMultilinkIdFkeyInverseInput = {
  /** The primary key(s) for `link` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LinkLinkPkeyConnect>>;
  /** A `LinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LinkMultilinkIdFkeyLinkCreateInput>>;
  /** The primary key(s) for `link` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LinkLinkPkeyDelete>>;
  /** Flag indicating whether all other `link` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `link` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LinkOnLinkForLinkMultilinkIdFkeyUsingLinkPkeyUpdate>>;
};

/** The `link` to be created by this mutation. */
export type LinkMultilinkIdFkeyLinkCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToMultilinkId?: InputMaybe<LinkMultilinkIdFkeyInput>;
  name?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** The `multilink` to be created by this mutation. */
export type LinkMultilinkIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The fields on `link` to look up the row to update. */
export type LinkOnLinkForLinkMultilinkIdFkeyUsingLinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `link` being updated. */
  patch: UpdateLinkOnLinkForLinkMultilinkIdFkeyPatch;
};

/** Represents an update to a `Link`. Fields that are set will be updated. */
export type LinkPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkId?: InputMaybe<Scalars['UUID']>;
  multilinkToMultilinkId?: InputMaybe<LinkMultilinkIdFkeyInput>;
  name?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Link` values. */
export type LinksConnection = {
  __typename?: 'LinksConnection';
  /** A list of edges which contains the `Link` and cursor to aid in pagination. */
  edges: Array<LinksEdge>;
  /** A list of `Link` objects. */
  nodes: Array<Link>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Link` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Link` edge in the connection. */
export type LinksEdge = {
  __typename?: 'LinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Link` at the end of the edge. */
  node: Link;
};

/** Methods to use when ordering `Link`. */
export enum LinksOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MultilinkByMultilinkIdIdAsc = 'MULTILINK_BY_MULTILINK_ID__ID_ASC',
  MultilinkByMultilinkIdIdDesc = 'MULTILINK_BY_MULTILINK_ID__ID_DESC',
  MultilinkByMultilinkIdNameAsc = 'MULTILINK_BY_MULTILINK_ID__NAME_ASC',
  MultilinkByMultilinkIdNameDesc = 'MULTILINK_BY_MULTILINK_ID__NAME_DESC',
  MultilinkIdAsc = 'MULTILINK_ID_ASC',
  MultilinkIdDesc = 'MULTILINK_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ToAsc = 'TO_ASC',
  ToDesc = 'TO_DESC'
}

export type LoginResponse = InvalidCredentials | Session;

export type Multilink = {
  __typename?: 'Multilink';
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByCompetitionInternationalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByCompetitionNationalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByExecutorsId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByExternalDataId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByExtraDocumentsId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByExtraSystemsId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByFairAbroadCooperationId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByFairAbroadId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByFavoredParallelsExternalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByFavoredParallelsInternalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByInternalDataId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByOrganizersId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByOtherCompetitionInternationalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByOtherCompetitionNationalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByOtherLinksExternalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByOtherLinksInternalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesBySponsorsId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesBySubeventsLocalId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesBySubeventsOtherLocationsId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSeriesByWebsitesId: EventSeriesConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByCompetitionInternationalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByCompetitionNationalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByExternalDataId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByExtraDocumentsId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByExtraSystemsId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByFairAbroadCooperationId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByFairAbroadId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByFavoredParallelsExternalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByFavoredParallelsInternalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByInternalDataId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByOtherCompetitionInternationalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByOtherCompetitionNationalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByOtherLinksExternalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByOtherLinksInternalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsBySubeventsLocalId: EventsConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsBySubeventsOtherLocationsId: EventsConnection;
  /** Reads and enables pagination through a set of `ExternalEventSeries`. */
  externalEventSeriesByWebsitesId: ExternalEventSeriesConnection;
  /** Reads and enables pagination through a set of `ExternalEvent`. */
  externalEventsByLinksId: ExternalEventsConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Link`. */
  links: LinksConnection;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `ProjectSeries`. */
  projectSeriesByOtherDocumentsId: ProjectSeriesConnection;
  /** Reads and enables pagination through a set of `ProjectSeries`. */
  projectSeriesByOtherLinksId: ProjectSeriesConnection;
  /** Reads and enables pagination through a set of `ProjectSeries`. */
  projectSeriesByOtherSystemsId: ProjectSeriesConnection;
  /** Reads and enables pagination through a set of `ProjectSeries`. */
  projectSeriesByWebsitesId: ProjectSeriesConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByOtherDocumentsId: ProjectsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByOtherLinksId: ProjectsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByOtherSystemsId: ProjectsConnection;
};


export type MultilinkEventSeriesByCompetitionInternationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByCompetitionNationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByExecutorsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByExternalDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByExtraDocumentsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByExtraSystemsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByFairAbroadCooperationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByFairAbroadIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByFavoredParallelsExternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByFavoredParallelsInternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByInternalDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByOrganizersIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByOtherCompetitionInternationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByOtherCompetitionNationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByOtherLinksExternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByOtherLinksInternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesBySponsorsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesBySubeventsLocalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesBySubeventsOtherLocationsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventSeriesByWebsitesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


export type MultilinkEventsByCompetitionInternationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByCompetitionNationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByExternalDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByExtraDocumentsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByExtraSystemsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByFairAbroadCooperationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByFairAbroadIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByFavoredParallelsExternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByFavoredParallelsInternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByInternalDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByOtherCompetitionInternationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByOtherCompetitionNationalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByOtherLinksExternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsByOtherLinksInternalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsBySubeventsLocalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkEventsBySubeventsOtherLocationsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MultilinkExternalEventSeriesByWebsitesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventSeriesCondition>;
  filter?: InputMaybe<ExternalEventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventSeriesOrderBy>>;
};


export type MultilinkExternalEventsByLinksIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventCondition>;
  filter?: InputMaybe<ExternalEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};


export type MultilinkLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LinkCondition>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};


export type MultilinkProjectSeriesByOtherDocumentsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectSeriesCondition>;
  filter?: InputMaybe<ProjectSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};


export type MultilinkProjectSeriesByOtherLinksIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectSeriesCondition>;
  filter?: InputMaybe<ProjectSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};


export type MultilinkProjectSeriesByOtherSystemsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectSeriesCondition>;
  filter?: InputMaybe<ProjectSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};


export type MultilinkProjectSeriesByWebsitesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectSeriesCondition>;
  filter?: InputMaybe<ProjectSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};


export type MultilinkProjectsByOtherDocumentsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type MultilinkProjectsByOtherLinksIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type MultilinkProjectsByOtherSystemsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/**
 * A condition to be used against `Multilink` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MultilinkCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Multilink` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MultilinkFilter>>;
  /** Filter by the object’s `eventSeriesByCompetitionInternationalId` relation. */
  eventSeriesByCompetitionInternationalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByCompetitionInternationalId` exist. */
  eventSeriesByCompetitionInternationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByCompetitionNationalId` relation. */
  eventSeriesByCompetitionNationalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByCompetitionNationalId` exist. */
  eventSeriesByCompetitionNationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByExecutorsId` relation. */
  eventSeriesByExecutorsId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByExecutorsId` exist. */
  eventSeriesByExecutorsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByExternalDataId` relation. */
  eventSeriesByExternalDataId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByExternalDataId` exist. */
  eventSeriesByExternalDataIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByExtraDocumentsId` relation. */
  eventSeriesByExtraDocumentsId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByExtraDocumentsId` exist. */
  eventSeriesByExtraDocumentsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByExtraSystemsId` relation. */
  eventSeriesByExtraSystemsId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByExtraSystemsId` exist. */
  eventSeriesByExtraSystemsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByFairAbroadCooperationId` relation. */
  eventSeriesByFairAbroadCooperationId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByFairAbroadCooperationId` exist. */
  eventSeriesByFairAbroadCooperationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByFairAbroadId` relation. */
  eventSeriesByFairAbroadId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByFairAbroadId` exist. */
  eventSeriesByFairAbroadIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByFavoredParallelsExternalId` relation. */
  eventSeriesByFavoredParallelsExternalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByFavoredParallelsExternalId` exist. */
  eventSeriesByFavoredParallelsExternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByFavoredParallelsInternalId` relation. */
  eventSeriesByFavoredParallelsInternalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByFavoredParallelsInternalId` exist. */
  eventSeriesByFavoredParallelsInternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByInternalDataId` relation. */
  eventSeriesByInternalDataId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByInternalDataId` exist. */
  eventSeriesByInternalDataIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByOrganizersId` relation. */
  eventSeriesByOrganizersId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByOrganizersId` exist. */
  eventSeriesByOrganizersIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByOtherCompetitionInternationalId` relation. */
  eventSeriesByOtherCompetitionInternationalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByOtherCompetitionInternationalId` exist. */
  eventSeriesByOtherCompetitionInternationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByOtherCompetitionNationalId` relation. */
  eventSeriesByOtherCompetitionNationalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByOtherCompetitionNationalId` exist. */
  eventSeriesByOtherCompetitionNationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByOtherLinksExternalId` relation. */
  eventSeriesByOtherLinksExternalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByOtherLinksExternalId` exist. */
  eventSeriesByOtherLinksExternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByOtherLinksInternalId` relation. */
  eventSeriesByOtherLinksInternalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByOtherLinksInternalId` exist. */
  eventSeriesByOtherLinksInternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesBySponsorsId` relation. */
  eventSeriesBySponsorsId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesBySponsorsId` exist. */
  eventSeriesBySponsorsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesBySubeventsLocalId` relation. */
  eventSeriesBySubeventsLocalId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesBySubeventsLocalId` exist. */
  eventSeriesBySubeventsLocalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesBySubeventsOtherLocationsId` relation. */
  eventSeriesBySubeventsOtherLocationsId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesBySubeventsOtherLocationsId` exist. */
  eventSeriesBySubeventsOtherLocationsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventSeriesByWebsitesId` relation. */
  eventSeriesByWebsitesId?: InputMaybe<MultilinkToManyEventSeriesFilter>;
  /** Some related `eventSeriesByWebsitesId` exist. */
  eventSeriesByWebsitesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByCompetitionInternationalId` relation. */
  eventsByCompetitionInternationalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByCompetitionInternationalId` exist. */
  eventsByCompetitionInternationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByCompetitionNationalId` relation. */
  eventsByCompetitionNationalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByCompetitionNationalId` exist. */
  eventsByCompetitionNationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByExternalDataId` relation. */
  eventsByExternalDataId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByExternalDataId` exist. */
  eventsByExternalDataIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByExtraDocumentsId` relation. */
  eventsByExtraDocumentsId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByExtraDocumentsId` exist. */
  eventsByExtraDocumentsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByExtraSystemsId` relation. */
  eventsByExtraSystemsId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByExtraSystemsId` exist. */
  eventsByExtraSystemsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByFairAbroadCooperationId` relation. */
  eventsByFairAbroadCooperationId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByFairAbroadCooperationId` exist. */
  eventsByFairAbroadCooperationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByFairAbroadId` relation. */
  eventsByFairAbroadId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByFairAbroadId` exist. */
  eventsByFairAbroadIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByFavoredParallelsExternalId` relation. */
  eventsByFavoredParallelsExternalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByFavoredParallelsExternalId` exist. */
  eventsByFavoredParallelsExternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByFavoredParallelsInternalId` relation. */
  eventsByFavoredParallelsInternalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByFavoredParallelsInternalId` exist. */
  eventsByFavoredParallelsInternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByInternalDataId` relation. */
  eventsByInternalDataId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByInternalDataId` exist. */
  eventsByInternalDataIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByOtherCompetitionInternationalId` relation. */
  eventsByOtherCompetitionInternationalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByOtherCompetitionInternationalId` exist. */
  eventsByOtherCompetitionInternationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByOtherCompetitionNationalId` relation. */
  eventsByOtherCompetitionNationalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByOtherCompetitionNationalId` exist. */
  eventsByOtherCompetitionNationalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByOtherLinksExternalId` relation. */
  eventsByOtherLinksExternalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByOtherLinksExternalId` exist. */
  eventsByOtherLinksExternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsByOtherLinksInternalId` relation. */
  eventsByOtherLinksInternalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsByOtherLinksInternalId` exist. */
  eventsByOtherLinksInternalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsBySubeventsLocalId` relation. */
  eventsBySubeventsLocalId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsBySubeventsLocalId` exist. */
  eventsBySubeventsLocalIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventsBySubeventsOtherLocationsId` relation. */
  eventsBySubeventsOtherLocationsId?: InputMaybe<MultilinkToManyEventFilter>;
  /** Some related `eventsBySubeventsOtherLocationsId` exist. */
  eventsBySubeventsOtherLocationsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventSeriesByWebsitesId` relation. */
  externalEventSeriesByWebsitesId?: InputMaybe<MultilinkToManyExternalEventSeriesFilter>;
  /** Some related `externalEventSeriesByWebsitesId` exist. */
  externalEventSeriesByWebsitesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalEventsByLinksId` relation. */
  externalEventsByLinksId?: InputMaybe<MultilinkToManyExternalEventFilter>;
  /** Some related `externalEventsByLinksId` exist. */
  externalEventsByLinksIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `links` relation. */
  links?: InputMaybe<MultilinkToManyLinkFilter>;
  /** Some related `links` exist. */
  linksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MultilinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MultilinkFilter>>;
  /** Filter by the object’s `projectSeriesByOtherDocumentsId` relation. */
  projectSeriesByOtherDocumentsId?: InputMaybe<MultilinkToManyProjectSeriesFilter>;
  /** Some related `projectSeriesByOtherDocumentsId` exist. */
  projectSeriesByOtherDocumentsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectSeriesByOtherLinksId` relation. */
  projectSeriesByOtherLinksId?: InputMaybe<MultilinkToManyProjectSeriesFilter>;
  /** Some related `projectSeriesByOtherLinksId` exist. */
  projectSeriesByOtherLinksIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectSeriesByOtherSystemsId` relation. */
  projectSeriesByOtherSystemsId?: InputMaybe<MultilinkToManyProjectSeriesFilter>;
  /** Some related `projectSeriesByOtherSystemsId` exist. */
  projectSeriesByOtherSystemsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectSeriesByWebsitesId` relation. */
  projectSeriesByWebsitesId?: InputMaybe<MultilinkToManyProjectSeriesFilter>;
  /** Some related `projectSeriesByWebsitesId` exist. */
  projectSeriesByWebsitesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectsByOtherDocumentsId` relation. */
  projectsByOtherDocumentsId?: InputMaybe<MultilinkToManyProjectFilter>;
  /** Some related `projectsByOtherDocumentsId` exist. */
  projectsByOtherDocumentsIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectsByOtherLinksId` relation. */
  projectsByOtherLinksId?: InputMaybe<MultilinkToManyProjectFilter>;
  /** Some related `projectsByOtherLinksId` exist. */
  projectsByOtherLinksIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectsByOtherSystemsId` relation. */
  projectsByOtherSystemsId?: InputMaybe<MultilinkToManyProjectFilter>;
  /** Some related `projectsByOtherSystemsId` exist. */
  projectsByOtherSystemsIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Multilink` */
export type MultilinkInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The fields on `multilink` to look up the row to connect. */
export type MultilinkMultilinkPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `multilink` to look up the row to delete. */
export type MultilinkMultilinkPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventCompetitionInternationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventCompetitionNationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventExternalDataIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventExternalDataIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventExtraDocumentsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventExtraDocumentsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventExtraSystemsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventExtraSystemsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventFairAbroadCooperationIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventFairAbroadCooperationIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventFairAbroadIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventFairAbroadIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventFavoredParallelsExternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventFavoredParallelsExternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventFavoredParallelsInternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventFavoredParallelsInternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventInternalDataIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventInternalDataIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventOtherCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventOtherCompetitionInternationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventOtherCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventOtherCompetitionNationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventOtherLinksExternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventOtherLinksExternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventOtherLinksInternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventOtherLinksInternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventSubeventsLocalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventSubeventsLocalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventForEventSubeventsOtherLocationsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventForEventSubeventsOtherLocationsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesCompetitionNationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesExecutorsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesExecutorsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesExternalDataIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesExternalDataIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesExtraDocumentsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesExtraDocumentsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesExtraSystemsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesExtraSystemsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesFairAbroadIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesFairAbroadIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesInternalDataIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesInternalDataIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesOrganizersIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesOrganizersIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesSponsorsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesSponsorsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesSubeventsLocalIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesSubeventsLocalIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnExternalEventForExternalEventLinksIdMultilinkIdFkUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnExternalEventForExternalEventLinksIdMultilinkIdFkPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnLinkForLinkMultilinkIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnLinkForLinkMultilinkIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectForProjectOtherDocumentsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectForProjectOtherDocumentsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectForProjectOtherLinksIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectForProjectOtherLinksIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectForProjectOtherSystemsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectForProjectOtherSystemsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectSeriesForProjectSeriesOtherLinksIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectSeriesForProjectSeriesOtherLinksIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyPatch;
};

/** The fields on `multilink` to look up the row to update. */
export type MultilinkOnProjectSeriesForProjectSeriesWebsitesIdFkeyUsingMultilinkPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `multilink` being updated. */
  patch: UpdateMultilinkOnProjectSeriesForProjectSeriesWebsitesIdFkeyPatch;
};

/** Represents an update to a `Multilink`. Fields that are set will be updated. */
export type MultilinkPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** A filter to be used against many `Event` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyEventFilter = {
  /** Every related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventFilter>;
  /** No related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventFilter>;
  /** Some related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventFilter>;
};

/** A filter to be used against many `EventSeries` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyEventSeriesFilter = {
  /** Every related `EventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventSeriesFilter>;
  /** No related `EventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventSeriesFilter>;
  /** Some related `EventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventSeriesFilter>;
};

/** A filter to be used against many `ExternalEvent` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyExternalEventFilter = {
  /** Every related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventFilter>;
  /** No related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventFilter>;
  /** Some related `ExternalEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventFilter>;
};

/** A filter to be used against many `ExternalEventSeries` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyExternalEventSeriesFilter = {
  /** Every related `ExternalEventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalEventSeriesFilter>;
  /** No related `ExternalEventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalEventSeriesFilter>;
  /** Some related `ExternalEventSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalEventSeriesFilter>;
};

/** A filter to be used against many `Link` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyLinkFilter = {
  /** Every related `Link` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LinkFilter>;
  /** No related `Link` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LinkFilter>;
  /** Some related `Link` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LinkFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectSeries` object types. All fields are combined with a logical ‘and.’ */
export type MultilinkToManyProjectSeriesFilter = {
  /** Every related `ProjectSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectSeriesFilter>;
  /** No related `ProjectSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectSeriesFilter>;
  /** Some related `ProjectSeries` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectSeriesFilter>;
};

/** A connection to a list of `Multilink` values. */
export type MultilinksConnection = {
  __typename?: 'MultilinksConnection';
  /** A list of edges which contains the `Multilink` and cursor to aid in pagination. */
  edges: Array<MultilinksEdge>;
  /** A list of `Multilink` objects. */
  nodes: Array<Multilink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Multilink` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Multilink` edge in the connection. */
export type MultilinksEdge = {
  __typename?: 'MultilinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Multilink` at the end of the edge. */
  node: Multilink;
};

/** Methods to use when ordering `Multilink`. */
export enum MultilinksOrderBy {
  EventsByCompetitionInternationalIdCountAsc = 'EVENTS_BY_COMPETITION_INTERNATIONAL_ID__COUNT_ASC',
  EventsByCompetitionInternationalIdCountDesc = 'EVENTS_BY_COMPETITION_INTERNATIONAL_ID__COUNT_DESC',
  EventsByCompetitionNationalIdCountAsc = 'EVENTS_BY_COMPETITION_NATIONAL_ID__COUNT_ASC',
  EventsByCompetitionNationalIdCountDesc = 'EVENTS_BY_COMPETITION_NATIONAL_ID__COUNT_DESC',
  EventsByExternalDataIdCountAsc = 'EVENTS_BY_EXTERNAL_DATA_ID__COUNT_ASC',
  EventsByExternalDataIdCountDesc = 'EVENTS_BY_EXTERNAL_DATA_ID__COUNT_DESC',
  EventsByExtraDocumentsIdCountAsc = 'EVENTS_BY_EXTRA_DOCUMENTS_ID__COUNT_ASC',
  EventsByExtraDocumentsIdCountDesc = 'EVENTS_BY_EXTRA_DOCUMENTS_ID__COUNT_DESC',
  EventsByExtraSystemsIdCountAsc = 'EVENTS_BY_EXTRA_SYSTEMS_ID__COUNT_ASC',
  EventsByExtraSystemsIdCountDesc = 'EVENTS_BY_EXTRA_SYSTEMS_ID__COUNT_DESC',
  EventsByFairAbroadCooperationIdCountAsc = 'EVENTS_BY_FAIR_ABROAD_COOPERATION_ID__COUNT_ASC',
  EventsByFairAbroadCooperationIdCountDesc = 'EVENTS_BY_FAIR_ABROAD_COOPERATION_ID__COUNT_DESC',
  EventsByFairAbroadIdCountAsc = 'EVENTS_BY_FAIR_ABROAD_ID__COUNT_ASC',
  EventsByFairAbroadIdCountDesc = 'EVENTS_BY_FAIR_ABROAD_ID__COUNT_DESC',
  EventsByFavoredParallelsExternalIdCountAsc = 'EVENTS_BY_FAVORED_PARALLELS_EXTERNAL_ID__COUNT_ASC',
  EventsByFavoredParallelsExternalIdCountDesc = 'EVENTS_BY_FAVORED_PARALLELS_EXTERNAL_ID__COUNT_DESC',
  EventsByFavoredParallelsInternalIdCountAsc = 'EVENTS_BY_FAVORED_PARALLELS_INTERNAL_ID__COUNT_ASC',
  EventsByFavoredParallelsInternalIdCountDesc = 'EVENTS_BY_FAVORED_PARALLELS_INTERNAL_ID__COUNT_DESC',
  EventsByInternalDataIdCountAsc = 'EVENTS_BY_INTERNAL_DATA_ID__COUNT_ASC',
  EventsByInternalDataIdCountDesc = 'EVENTS_BY_INTERNAL_DATA_ID__COUNT_DESC',
  EventsByOtherCompetitionInternationalIdCountAsc = 'EVENTS_BY_OTHER_COMPETITION_INTERNATIONAL_ID__COUNT_ASC',
  EventsByOtherCompetitionInternationalIdCountDesc = 'EVENTS_BY_OTHER_COMPETITION_INTERNATIONAL_ID__COUNT_DESC',
  EventsByOtherCompetitionNationalIdCountAsc = 'EVENTS_BY_OTHER_COMPETITION_NATIONAL_ID__COUNT_ASC',
  EventsByOtherCompetitionNationalIdCountDesc = 'EVENTS_BY_OTHER_COMPETITION_NATIONAL_ID__COUNT_DESC',
  EventsByOtherLinksExternalIdCountAsc = 'EVENTS_BY_OTHER_LINKS_EXTERNAL_ID__COUNT_ASC',
  EventsByOtherLinksExternalIdCountDesc = 'EVENTS_BY_OTHER_LINKS_EXTERNAL_ID__COUNT_DESC',
  EventsByOtherLinksInternalIdCountAsc = 'EVENTS_BY_OTHER_LINKS_INTERNAL_ID__COUNT_ASC',
  EventsByOtherLinksInternalIdCountDesc = 'EVENTS_BY_OTHER_LINKS_INTERNAL_ID__COUNT_DESC',
  EventsBySubeventsLocalIdCountAsc = 'EVENTS_BY_SUBEVENTS_LOCAL_ID__COUNT_ASC',
  EventsBySubeventsLocalIdCountDesc = 'EVENTS_BY_SUBEVENTS_LOCAL_ID__COUNT_DESC',
  EventsBySubeventsOtherLocationsIdCountAsc = 'EVENTS_BY_SUBEVENTS_OTHER_LOCATIONS_ID__COUNT_ASC',
  EventsBySubeventsOtherLocationsIdCountDesc = 'EVENTS_BY_SUBEVENTS_OTHER_LOCATIONS_ID__COUNT_DESC',
  EventSeriesByCompetitionInternationalIdCountAsc = 'EVENT_SERIES_BY_COMPETITION_INTERNATIONAL_ID__COUNT_ASC',
  EventSeriesByCompetitionInternationalIdCountDesc = 'EVENT_SERIES_BY_COMPETITION_INTERNATIONAL_ID__COUNT_DESC',
  EventSeriesByCompetitionNationalIdCountAsc = 'EVENT_SERIES_BY_COMPETITION_NATIONAL_ID__COUNT_ASC',
  EventSeriesByCompetitionNationalIdCountDesc = 'EVENT_SERIES_BY_COMPETITION_NATIONAL_ID__COUNT_DESC',
  EventSeriesByExecutorsIdCountAsc = 'EVENT_SERIES_BY_EXECUTORS_ID__COUNT_ASC',
  EventSeriesByExecutorsIdCountDesc = 'EVENT_SERIES_BY_EXECUTORS_ID__COUNT_DESC',
  EventSeriesByExternalDataIdCountAsc = 'EVENT_SERIES_BY_EXTERNAL_DATA_ID__COUNT_ASC',
  EventSeriesByExternalDataIdCountDesc = 'EVENT_SERIES_BY_EXTERNAL_DATA_ID__COUNT_DESC',
  EventSeriesByExtraDocumentsIdCountAsc = 'EVENT_SERIES_BY_EXTRA_DOCUMENTS_ID__COUNT_ASC',
  EventSeriesByExtraDocumentsIdCountDesc = 'EVENT_SERIES_BY_EXTRA_DOCUMENTS_ID__COUNT_DESC',
  EventSeriesByExtraSystemsIdCountAsc = 'EVENT_SERIES_BY_EXTRA_SYSTEMS_ID__COUNT_ASC',
  EventSeriesByExtraSystemsIdCountDesc = 'EVENT_SERIES_BY_EXTRA_SYSTEMS_ID__COUNT_DESC',
  EventSeriesByFairAbroadCooperationIdCountAsc = 'EVENT_SERIES_BY_FAIR_ABROAD_COOPERATION_ID__COUNT_ASC',
  EventSeriesByFairAbroadCooperationIdCountDesc = 'EVENT_SERIES_BY_FAIR_ABROAD_COOPERATION_ID__COUNT_DESC',
  EventSeriesByFairAbroadIdCountAsc = 'EVENT_SERIES_BY_FAIR_ABROAD_ID__COUNT_ASC',
  EventSeriesByFairAbroadIdCountDesc = 'EVENT_SERIES_BY_FAIR_ABROAD_ID__COUNT_DESC',
  EventSeriesByFavoredParallelsExternalIdCountAsc = 'EVENT_SERIES_BY_FAVORED_PARALLELS_EXTERNAL_ID__COUNT_ASC',
  EventSeriesByFavoredParallelsExternalIdCountDesc = 'EVENT_SERIES_BY_FAVORED_PARALLELS_EXTERNAL_ID__COUNT_DESC',
  EventSeriesByFavoredParallelsInternalIdCountAsc = 'EVENT_SERIES_BY_FAVORED_PARALLELS_INTERNAL_ID__COUNT_ASC',
  EventSeriesByFavoredParallelsInternalIdCountDesc = 'EVENT_SERIES_BY_FAVORED_PARALLELS_INTERNAL_ID__COUNT_DESC',
  EventSeriesByInternalDataIdCountAsc = 'EVENT_SERIES_BY_INTERNAL_DATA_ID__COUNT_ASC',
  EventSeriesByInternalDataIdCountDesc = 'EVENT_SERIES_BY_INTERNAL_DATA_ID__COUNT_DESC',
  EventSeriesByOrganizersIdCountAsc = 'EVENT_SERIES_BY_ORGANIZERS_ID__COUNT_ASC',
  EventSeriesByOrganizersIdCountDesc = 'EVENT_SERIES_BY_ORGANIZERS_ID__COUNT_DESC',
  EventSeriesByOtherCompetitionInternationalIdCountAsc = 'EVENT_SERIES_BY_OTHER_COMPETITION_INTERNATIONAL_ID__COUNT_ASC',
  EventSeriesByOtherCompetitionInternationalIdCountDesc = 'EVENT_SERIES_BY_OTHER_COMPETITION_INTERNATIONAL_ID__COUNT_DESC',
  EventSeriesByOtherCompetitionNationalIdCountAsc = 'EVENT_SERIES_BY_OTHER_COMPETITION_NATIONAL_ID__COUNT_ASC',
  EventSeriesByOtherCompetitionNationalIdCountDesc = 'EVENT_SERIES_BY_OTHER_COMPETITION_NATIONAL_ID__COUNT_DESC',
  EventSeriesByOtherLinksExternalIdCountAsc = 'EVENT_SERIES_BY_OTHER_LINKS_EXTERNAL_ID__COUNT_ASC',
  EventSeriesByOtherLinksExternalIdCountDesc = 'EVENT_SERIES_BY_OTHER_LINKS_EXTERNAL_ID__COUNT_DESC',
  EventSeriesByOtherLinksInternalIdCountAsc = 'EVENT_SERIES_BY_OTHER_LINKS_INTERNAL_ID__COUNT_ASC',
  EventSeriesByOtherLinksInternalIdCountDesc = 'EVENT_SERIES_BY_OTHER_LINKS_INTERNAL_ID__COUNT_DESC',
  EventSeriesBySponsorsIdCountAsc = 'EVENT_SERIES_BY_SPONSORS_ID__COUNT_ASC',
  EventSeriesBySponsorsIdCountDesc = 'EVENT_SERIES_BY_SPONSORS_ID__COUNT_DESC',
  EventSeriesBySubeventsLocalIdCountAsc = 'EVENT_SERIES_BY_SUBEVENTS_LOCAL_ID__COUNT_ASC',
  EventSeriesBySubeventsLocalIdCountDesc = 'EVENT_SERIES_BY_SUBEVENTS_LOCAL_ID__COUNT_DESC',
  EventSeriesBySubeventsOtherLocationsIdCountAsc = 'EVENT_SERIES_BY_SUBEVENTS_OTHER_LOCATIONS_ID__COUNT_ASC',
  EventSeriesBySubeventsOtherLocationsIdCountDesc = 'EVENT_SERIES_BY_SUBEVENTS_OTHER_LOCATIONS_ID__COUNT_DESC',
  EventSeriesByWebsitesIdCountAsc = 'EVENT_SERIES_BY_WEBSITES_ID__COUNT_ASC',
  EventSeriesByWebsitesIdCountDesc = 'EVENT_SERIES_BY_WEBSITES_ID__COUNT_DESC',
  ExternalEventsByLinksIdCountAsc = 'EXTERNAL_EVENTS_BY_LINKS_ID__COUNT_ASC',
  ExternalEventsByLinksIdCountDesc = 'EXTERNAL_EVENTS_BY_LINKS_ID__COUNT_DESC',
  ExternalEventSeriesByWebsitesIdCountAsc = 'EXTERNAL_EVENT_SERIES_BY_WEBSITES_ID__COUNT_ASC',
  ExternalEventSeriesByWebsitesIdCountDesc = 'EXTERNAL_EVENT_SERIES_BY_WEBSITES_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinksByMultilinkIdCountAsc = 'LINKS_BY_MULTILINK_ID__COUNT_ASC',
  LinksByMultilinkIdCountDesc = 'LINKS_BY_MULTILINK_ID__COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectsByOtherDocumentsIdCountAsc = 'PROJECTS_BY_OTHER_DOCUMENTS_ID__COUNT_ASC',
  ProjectsByOtherDocumentsIdCountDesc = 'PROJECTS_BY_OTHER_DOCUMENTS_ID__COUNT_DESC',
  ProjectsByOtherLinksIdCountAsc = 'PROJECTS_BY_OTHER_LINKS_ID__COUNT_ASC',
  ProjectsByOtherLinksIdCountDesc = 'PROJECTS_BY_OTHER_LINKS_ID__COUNT_DESC',
  ProjectsByOtherSystemsIdCountAsc = 'PROJECTS_BY_OTHER_SYSTEMS_ID__COUNT_ASC',
  ProjectsByOtherSystemsIdCountDesc = 'PROJECTS_BY_OTHER_SYSTEMS_ID__COUNT_DESC',
  ProjectSeriesByOtherDocumentsIdCountAsc = 'PROJECT_SERIES_BY_OTHER_DOCUMENTS_ID__COUNT_ASC',
  ProjectSeriesByOtherDocumentsIdCountDesc = 'PROJECT_SERIES_BY_OTHER_DOCUMENTS_ID__COUNT_DESC',
  ProjectSeriesByOtherLinksIdCountAsc = 'PROJECT_SERIES_BY_OTHER_LINKS_ID__COUNT_ASC',
  ProjectSeriesByOtherLinksIdCountDesc = 'PROJECT_SERIES_BY_OTHER_LINKS_ID__COUNT_DESC',
  ProjectSeriesByOtherSystemsIdCountAsc = 'PROJECT_SERIES_BY_OTHER_SYSTEMS_ID__COUNT_ASC',
  ProjectSeriesByOtherSystemsIdCountDesc = 'PROJECT_SERIES_BY_OTHER_SYSTEMS_ID__COUNT_DESC',
  ProjectSeriesByWebsitesIdCountAsc = 'PROJECT_SERIES_BY_WEBSITES_ID__COUNT_ASC',
  ProjectSeriesByWebsitesIdCountDesc = 'PROJECT_SERIES_BY_WEBSITES_ID__COUNT_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  activateEntraUser: ActivateEntraUserResponse;
  activateSsoLogin: ActivateSsoLoginResponse;
  allocationAreaDuplicate?: Maybe<AllocationAreaDuplicatePayload>;
  allocationAreaUpdateAndDuplicate?: Maybe<AllocationAreaUpdateAndDuplicatePayload>;
  allocationRoomDuplicate?: Maybe<AllocationRoomDuplicatePayload>;
  allocationRoomUpdateAndDuplicate?: Maybe<AllocationRoomUpdateAndDuplicatePayload>;
  copyEventVariantAllocations?: Maybe<CopyEventVariantAllocationsPayload>;
  copyExternalEventVariantAllocations?: Maybe<CopyExternalEventVariantAllocationsPayload>;
  copyProjectVariantAllocations?: Maybe<CopyProjectVariantAllocationsPayload>;
  /** Creates a single `AllocationArea`. */
  createAllocationArea?: Maybe<CreateAllocationAreaPayload>;
  /** Creates a single `AllocationAreaPhase`. */
  createAllocationAreaPhase?: Maybe<CreateAllocationAreaPhasePayload>;
  /** Creates a single `AllocationPlot`. */
  createAllocationPlot?: Maybe<CreateAllocationPlotPayload>;
  /** Creates a single `AllocationPlotPhase`. */
  createAllocationPlotPhase?: Maybe<CreateAllocationPlotPhasePayload>;
  /** Creates a single `AllocationRoom`. */
  createAllocationRoom?: Maybe<CreateAllocationRoomPayload>;
  /** Creates a single `AllocationRoomPhase`. */
  createAllocationRoomPhase?: Maybe<CreateAllocationRoomPhasePayload>;
  /** Creates a single `AllocationUsage`. */
  createAllocationUsage?: Maybe<CreateAllocationUsagePayload>;
  /** Creates a single `Area`. */
  createArea?: Maybe<CreateAreaPayload>;
  /** Creates a single `AreaCadGrossSpaceMin`. */
  createAreaCadGrossSpaceMin?: Maybe<CreateAreaCadGrossSpaceMinPayload>;
  /** Creates a single `AreaClearanceConstruction`. */
  createAreaClearanceConstruction?: Maybe<CreateAreaClearanceConstructionPayload>;
  /** Creates a single `AreaContactBooking`. */
  createAreaContactBooking?: Maybe<CreateAreaContactBookingPayload>;
  /** Creates a single `AreaDescription`. */
  createAreaDescription?: Maybe<CreateAreaDescriptionPayload>;
  /** Creates a single `AreaKeyIssuance`. */
  createAreaKeyIssuance?: Maybe<CreateAreaKeyIssuancePayload>;
  /** Creates a single `AreaKeyIssuanceNote`. */
  createAreaKeyIssuanceNote?: Maybe<CreateAreaKeyIssuanceNotePayload>;
  /** Creates a single `AreaNameExtra`. */
  createAreaNameExtra?: Maybe<CreateAreaNameExtraPayload>;
  /** Creates a single `AreaNameKeyCad`. */
  createAreaNameKeyCad?: Maybe<CreateAreaNameKeyCadPayload>;
  /** Creates a single `AreaNameKeyCafm`. */
  createAreaNameKeyCafm?: Maybe<CreateAreaNameKeyCafmPayload>;
  /** Creates a single `AreaNameKeyEbm`. */
  createAreaNameKeyEbm?: Maybe<CreateAreaNameKeyEbmPayload>;
  /** Creates a single `AreaNameKeyMarketing`. */
  createAreaNameKeyMarketing?: Maybe<CreateAreaNameKeyMarketingPayload>;
  /** Creates a single `AreaNameLong`. */
  createAreaNameLong?: Maybe<CreateAreaNameLongPayload>;
  /** Creates a single `AreaNameShort`. */
  createAreaNameShort?: Maybe<CreateAreaNameShortPayload>;
  /** Creates a single `AreaPublicGrossSpace`. */
  createAreaPublicGrossSpace?: Maybe<CreateAreaPublicGrossSpacePayload>;
  /** Creates a single `AreaType`. */
  createAreaType?: Maybe<CreateAreaTypePayload>;
  /** Creates a single `AreaTypeAttr`. */
  createAreaTypeAttr?: Maybe<CreateAreaTypeAttrPayload>;
  /** Creates a single `Building`. */
  createBuilding?: Maybe<CreateBuildingPayload>;
  /** Creates a single `BuildingDescription`. */
  createBuildingDescription?: Maybe<CreateBuildingDescriptionPayload>;
  /** Creates a single `BuildingNameExtra`. */
  createBuildingNameExtra?: Maybe<CreateBuildingNameExtraPayload>;
  /** Creates a single `BuildingNameKeyCad`. */
  createBuildingNameKeyCad?: Maybe<CreateBuildingNameKeyCadPayload>;
  /** Creates a single `BuildingNameKeyCafm`. */
  createBuildingNameKeyCafm?: Maybe<CreateBuildingNameKeyCafmPayload>;
  /** Creates a single `BuildingNameKeyEbm`. */
  createBuildingNameKeyEbm?: Maybe<CreateBuildingNameKeyEbmPayload>;
  /** Creates a single `BuildingNameKeyMarketing`. */
  createBuildingNameKeyMarketing?: Maybe<CreateBuildingNameKeyMarketingPayload>;
  /** Creates a single `BuildingNameLong`. */
  createBuildingNameLong?: Maybe<CreateBuildingNameLongPayload>;
  /** Creates a single `BuildingNameShort`. */
  createBuildingNameShort?: Maybe<CreateBuildingNameShortPayload>;
  /** Creates a single `BuildingPublicGrossSpace`. */
  createBuildingPublicGrossSpace?: Maybe<CreateBuildingPublicGrossSpacePayload>;
  /** Creates a single `BuildingType`. */
  createBuildingType?: Maybe<CreateBuildingTypePayload>;
  /** Creates a single `BuildingTypeAttr`. */
  createBuildingTypeAttr?: Maybe<CreateBuildingTypeAttrPayload>;
  /** Creates a single `ElevationLevel`. */
  createElevationLevel?: Maybe<CreateElevationLevelPayload>;
  /** Creates a single `Event`. */
  createEvent?: Maybe<CreateEventPayload>;
  /** Creates a single `EventSeries`. */
  createEventSeries?: Maybe<CreateEventSeriesPayload>;
  /** Creates a single `EventVariant`. */
  createEventVariant?: Maybe<CreateEventVariantPayload>;
  createEventVariantWithAllocationsFrom?: Maybe<CreateEventVariantWithAllocationsFromPayload>;
  /** Creates a single `ExternalEvent`. */
  createExternalEvent?: Maybe<CreateExternalEventPayload>;
  /** Creates a single `ExternalEventAllocation`. */
  createExternalEventAllocation?: Maybe<CreateExternalEventAllocationPayload>;
  /** Creates a single `ExternalEventAllocationPhase`. */
  createExternalEventAllocationPhase?: Maybe<CreateExternalEventAllocationPhasePayload>;
  /** Creates a single `ExternalEventAllocationUsage`. */
  createExternalEventAllocationUsage?: Maybe<CreateExternalEventAllocationUsagePayload>;
  /** Creates a single `ExternalEventEventLocationVisibility`. */
  createExternalEventEventLocationVisibility?: Maybe<CreateExternalEventEventLocationVisibilityPayload>;
  /** Creates a single `ExternalEventLocation`. */
  createExternalEventLocation?: Maybe<CreateExternalEventLocationPayload>;
  /** Creates a single `ExternalEventSeries`. */
  createExternalEventSeries?: Maybe<CreateExternalEventSeriesPayload>;
  /** Creates a single `ExternalEventVariant`. */
  createExternalEventVariant?: Maybe<CreateExternalEventVariantPayload>;
  createExternalEventVariantWithAllocationsFrom?: Maybe<CreateExternalEventVariantWithAllocationsFromPayload>;
  /** Creates a single `Feed`. */
  createFeed?: Maybe<CreateFeedPayload>;
  /** Creates a single `FeedEntry`. */
  createFeedEntry?: Maybe<CreateFeedEntryPayload>;
  /** Creates a single `Level`. */
  createLevel?: Maybe<CreateLevelPayload>;
  /** Creates a single `LevelCapacityPax`. */
  createLevelCapacityPax?: Maybe<CreateLevelCapacityPaxPayload>;
  /** Creates a single `LevelDescription`. */
  createLevelDescription?: Maybe<CreateLevelDescriptionPayload>;
  /** Creates a single `LevelFkmGrossSpace`. */
  createLevelFkmGrossSpace?: Maybe<CreateLevelFkmGrossSpacePayload>;
  /** Creates a single `LevelNameExtra`. */
  createLevelNameExtra?: Maybe<CreateLevelNameExtraPayload>;
  /** Creates a single `LevelNameKeyCad`. */
  createLevelNameKeyCad?: Maybe<CreateLevelNameKeyCadPayload>;
  /** Creates a single `LevelNameKeyCafm`. */
  createLevelNameKeyCafm?: Maybe<CreateLevelNameKeyCafmPayload>;
  /** Creates a single `LevelNameKeyEbm`. */
  createLevelNameKeyEbm?: Maybe<CreateLevelNameKeyEbmPayload>;
  /** Creates a single `LevelNameKeyMarketing`. */
  createLevelNameKeyMarketing?: Maybe<CreateLevelNameKeyMarketingPayload>;
  /** Creates a single `LevelNameLong`. */
  createLevelNameLong?: Maybe<CreateLevelNameLongPayload>;
  /** Creates a single `LevelNameShort`. */
  createLevelNameShort?: Maybe<CreateLevelNameShortPayload>;
  /** Creates a single `LevelPublicGrossSpace`. */
  createLevelPublicGrossSpace?: Maybe<CreateLevelPublicGrossSpacePayload>;
  /** Creates a single `LevelType`. */
  createLevelType?: Maybe<CreateLevelTypePayload>;
  /** Creates a single `LevelTypeAttr`. */
  createLevelTypeAttr?: Maybe<CreateLevelTypeAttrPayload>;
  /** Creates a single `Link`. */
  createLink?: Maybe<CreateLinkPayload>;
  /** Creates a single `Multilink`. */
  createMultilink?: Maybe<CreateMultilinkPayload>;
  createPasswordLogin: CreatePasswordLoginResponse;
  /** Creates a single `Plot`. */
  createPlot?: Maybe<CreatePlotPayload>;
  /** Creates a single `PlotCadGrossSpaceMin`. */
  createPlotCadGrossSpaceMin?: Maybe<CreatePlotCadGrossSpaceMinPayload>;
  /** Creates a single `PlotDescription`. */
  createPlotDescription?: Maybe<CreatePlotDescriptionPayload>;
  /** Creates a single `PlotNameExtra`. */
  createPlotNameExtra?: Maybe<CreatePlotNameExtraPayload>;
  /** Creates a single `PlotNameKeyCad`. */
  createPlotNameKeyCad?: Maybe<CreatePlotNameKeyCadPayload>;
  /** Creates a single `PlotNameKeyCafm`. */
  createPlotNameKeyCafm?: Maybe<CreatePlotNameKeyCafmPayload>;
  /** Creates a single `PlotNameKeyEbm`. */
  createPlotNameKeyEbm?: Maybe<CreatePlotNameKeyEbmPayload>;
  /** Creates a single `PlotNameKeyMarketing`. */
  createPlotNameKeyMarketing?: Maybe<CreatePlotNameKeyMarketingPayload>;
  /** Creates a single `PlotNameLong`. */
  createPlotNameLong?: Maybe<CreatePlotNameLongPayload>;
  /** Creates a single `PlotNameShort`. */
  createPlotNameShort?: Maybe<CreatePlotNameShortPayload>;
  /** Creates a single `PlotPublicGrossSpace`. */
  createPlotPublicGrossSpace?: Maybe<CreatePlotPublicGrossSpacePayload>;
  /** Creates a single `PlotType`. */
  createPlotType?: Maybe<CreatePlotTypePayload>;
  /** Creates a single `PlotTypeAttr`. */
  createPlotTypeAttr?: Maybe<CreatePlotTypeAttrPayload>;
  /** Creates a single `Project`. */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a single `ProjectAllocationArea`. */
  createProjectAllocationArea?: Maybe<CreateProjectAllocationAreaPayload>;
  /** Creates a single `ProjectAllocationAreaPhase`. */
  createProjectAllocationAreaPhase?: Maybe<CreateProjectAllocationAreaPhasePayload>;
  /** Creates a single `ProjectAllocationPlot`. */
  createProjectAllocationPlot?: Maybe<CreateProjectAllocationPlotPayload>;
  /** Creates a single `ProjectAllocationPlotPhase`. */
  createProjectAllocationPlotPhase?: Maybe<CreateProjectAllocationPlotPhasePayload>;
  /** Creates a single `ProjectAllocationRoom`. */
  createProjectAllocationRoom?: Maybe<CreateProjectAllocationRoomPayload>;
  /** Creates a single `ProjectAllocationRoomPhase`. */
  createProjectAllocationRoomPhase?: Maybe<CreateProjectAllocationRoomPhasePayload>;
  /** Creates a single `ProjectAllocationUsage`. */
  createProjectAllocationUsage?: Maybe<CreateProjectAllocationUsagePayload>;
  /** Creates a single `ProjectSeries`. */
  createProjectSeries?: Maybe<CreateProjectSeriesPayload>;
  /** Creates a single `ProjectVariant`. */
  createProjectVariant?: Maybe<CreateProjectVariantPayload>;
  createProjectVariantWithAllocationsFrom?: Maybe<CreateProjectVariantWithAllocationsFromPayload>;
  /** Creates a single `Room`. */
  createRoom?: Maybe<CreateRoomPayload>;
  /** Creates a single `RoomAirChangeRate`. */
  createRoomAirChangeRate?: Maybe<CreateRoomAirChangeRatePayload>;
  /** Creates a single `RoomAirConditioning`. */
  createRoomAirConditioning?: Maybe<CreateRoomAirConditioningPayload>;
  /** Creates a single `RoomCadGrossSpaceMin`. */
  createRoomCadGrossSpaceMin?: Maybe<CreateRoomCadGrossSpaceMinPayload>;
  /** Creates a single `RoomCadHeightMax`. */
  createRoomCadHeightMax?: Maybe<CreateRoomCadHeightMaxPayload>;
  /** Creates a single `RoomCadHeightMin`. */
  createRoomCadHeightMin?: Maybe<CreateRoomCadHeightMinPayload>;
  /** Creates a single `RoomCadLengthMax`. */
  createRoomCadLengthMax?: Maybe<CreateRoomCadLengthMaxPayload>;
  /** Creates a single `RoomCadLengthMin`. */
  createRoomCadLengthMin?: Maybe<CreateRoomCadLengthMinPayload>;
  /** Creates a single `RoomCadWidthMax`. */
  createRoomCadWidthMax?: Maybe<CreateRoomCadWidthMaxPayload>;
  /** Creates a single `RoomCadWidthMin`. */
  createRoomCadWidthMin?: Maybe<CreateRoomCadWidthMinPayload>;
  /** Creates a single `RoomCapacityCar`. */
  createRoomCapacityCar?: Maybe<CreateRoomCapacityCarPayload>;
  /** Creates a single `RoomCapacityPax`. */
  createRoomCapacityPax?: Maybe<CreateRoomCapacityPaxPayload>;
  /** Creates a single `RoomCapacityTruck`. */
  createRoomCapacityTruck?: Maybe<CreateRoomCapacityTruckPayload>;
  /** Creates a single `RoomCleaningGrossSpace`. */
  createRoomCleaningGrossSpace?: Maybe<CreateRoomCleaningGrossSpacePayload>;
  /** Creates a single `RoomClearanceConstruction`. */
  createRoomClearanceConstruction?: Maybe<CreateRoomClearanceConstructionPayload>;
  /** Creates a single `RoomContactBooking`. */
  createRoomContactBooking?: Maybe<CreateRoomContactBookingPayload>;
  /** Creates a single `RoomDaylight`. */
  createRoomDaylight?: Maybe<CreateRoomDaylightPayload>;
  /** Creates a single `RoomDescription`. */
  createRoomDescription?: Maybe<CreateRoomDescriptionPayload>;
  /** Creates a single `RoomKeyIssuance`. */
  createRoomKeyIssuance?: Maybe<CreateRoomKeyIssuancePayload>;
  /** Creates a single `RoomKeyIssuanceNote`. */
  createRoomKeyIssuanceNote?: Maybe<CreateRoomKeyIssuanceNotePayload>;
  /** Creates a single `RoomLightShutter`. */
  createRoomLightShutter?: Maybe<CreateRoomLightShutterPayload>;
  /** Creates a single `RoomMaxLoadCeiling`. */
  createRoomMaxLoadCeiling?: Maybe<CreateRoomMaxLoadCeilingPayload>;
  /** Creates a single `RoomMaxLoadFloor`. */
  createRoomMaxLoadFloor?: Maybe<CreateRoomMaxLoadFloorPayload>;
  /** Creates a single `RoomNameExtra`. */
  createRoomNameExtra?: Maybe<CreateRoomNameExtraPayload>;
  /** Creates a single `RoomNameKeyCad`. */
  createRoomNameKeyCad?: Maybe<CreateRoomNameKeyCadPayload>;
  /** Creates a single `RoomNameKeyCafm`. */
  createRoomNameKeyCafm?: Maybe<CreateRoomNameKeyCafmPayload>;
  /** Creates a single `RoomNameKeyEbm`. */
  createRoomNameKeyEbm?: Maybe<CreateRoomNameKeyEbmPayload>;
  /** Creates a single `RoomNameKeyMarketing`. */
  createRoomNameKeyMarketing?: Maybe<CreateRoomNameKeyMarketingPayload>;
  /** Creates a single `RoomNameLong`. */
  createRoomNameLong?: Maybe<CreateRoomNameLongPayload>;
  /** Creates a single `RoomNameShort`. */
  createRoomNameShort?: Maybe<CreateRoomNameShortPayload>;
  /** Creates a single `RoomNoVehicle`. */
  createRoomNoVehicle?: Maybe<CreateRoomNoVehiclePayload>;
  /** Creates a single `RoomPartition`. */
  createRoomPartition?: Maybe<CreateRoomPartitionPayload>;
  /** Creates a single `RoomPartitionCadGrossSpaceMin`. */
  createRoomPartitionCadGrossSpaceMin?: Maybe<CreateRoomPartitionCadGrossSpaceMinPayload>;
  /** Creates a single `RoomPartitionCadHeightMax`. */
  createRoomPartitionCadHeightMax?: Maybe<CreateRoomPartitionCadHeightMaxPayload>;
  /** Creates a single `RoomPartitionCadHeightMin`. */
  createRoomPartitionCadHeightMin?: Maybe<CreateRoomPartitionCadHeightMinPayload>;
  /** Creates a single `RoomPartitionCadLengthMax`. */
  createRoomPartitionCadLengthMax?: Maybe<CreateRoomPartitionCadLengthMaxPayload>;
  /** Creates a single `RoomPartitionCadLengthMin`. */
  createRoomPartitionCadLengthMin?: Maybe<CreateRoomPartitionCadLengthMinPayload>;
  /** Creates a single `RoomPartitionCadWidthMax`. */
  createRoomPartitionCadWidthMax?: Maybe<CreateRoomPartitionCadWidthMaxPayload>;
  /** Creates a single `RoomPartitionCadWidthMin`. */
  createRoomPartitionCadWidthMin?: Maybe<CreateRoomPartitionCadWidthMinPayload>;
  /** Creates a single `RoomPartitionCapacityPax`. */
  createRoomPartitionCapacityPax?: Maybe<CreateRoomPartitionCapacityPaxPayload>;
  /** Creates a single `RoomPartitionCleaningGrossSpace`. */
  createRoomPartitionCleaningGrossSpace?: Maybe<CreateRoomPartitionCleaningGrossSpacePayload>;
  /** Creates a single `RoomPartitionDescription`. */
  createRoomPartitionDescription?: Maybe<CreateRoomPartitionDescriptionPayload>;
  /** Creates a single `RoomPartitionNameExtra`. */
  createRoomPartitionNameExtra?: Maybe<CreateRoomPartitionNameExtraPayload>;
  /** Creates a single `RoomPartitionNameKeyCad`. */
  createRoomPartitionNameKeyCad?: Maybe<CreateRoomPartitionNameKeyCadPayload>;
  /** Creates a single `RoomPartitionNameKeyCafm`. */
  createRoomPartitionNameKeyCafm?: Maybe<CreateRoomPartitionNameKeyCafmPayload>;
  /** Creates a single `RoomPartitionNameKeyEbm`. */
  createRoomPartitionNameKeyEbm?: Maybe<CreateRoomPartitionNameKeyEbmPayload>;
  /** Creates a single `RoomPartitionNameKeyMarketing`. */
  createRoomPartitionNameKeyMarketing?: Maybe<CreateRoomPartitionNameKeyMarketingPayload>;
  /** Creates a single `RoomPartitionNameLong`. */
  createRoomPartitionNameLong?: Maybe<CreateRoomPartitionNameLongPayload>;
  /** Creates a single `RoomPartitionNameShort`. */
  createRoomPartitionNameShort?: Maybe<CreateRoomPartitionNameShortPayload>;
  /** Creates a single `RoomPartitionPublicGrossSpace`. */
  createRoomPartitionPublicGrossSpace?: Maybe<CreateRoomPartitionPublicGrossSpacePayload>;
  /** Creates a single `RoomPartitionSbvGrossSpace`. */
  createRoomPartitionSbvGrossSpace?: Maybe<CreateRoomPartitionSbvGrossSpacePayload>;
  /** Creates a single `RoomPartitionType`. */
  createRoomPartitionType?: Maybe<CreateRoomPartitionTypePayload>;
  /** Creates a single `RoomPartitionTypeAttr`. */
  createRoomPartitionTypeAttr?: Maybe<CreateRoomPartitionTypeAttrPayload>;
  /** Creates a single `RoomPhoneNumber`. */
  createRoomPhoneNumber?: Maybe<CreateRoomPhoneNumberPayload>;
  /** Creates a single `RoomPublicGrossSpace`. */
  createRoomPublicGrossSpace?: Maybe<CreateRoomPublicGrossSpacePayload>;
  /** Creates a single `RoomSbvGrossSpace`. */
  createRoomSbvGrossSpace?: Maybe<CreateRoomSbvGrossSpacePayload>;
  /** Creates a single `RoomTireLoadCar`. */
  createRoomTireLoadCar?: Maybe<CreateRoomTireLoadCarPayload>;
  /** Creates a single `RoomTireLoadForklift`. */
  createRoomTireLoadForklift?: Maybe<CreateRoomTireLoadForkliftPayload>;
  /** Creates a single `RoomTireLoadTruck`. */
  createRoomTireLoadTruck?: Maybe<CreateRoomTireLoadTruckPayload>;
  /** Creates a single `RoomType`. */
  createRoomType?: Maybe<CreateRoomTypePayload>;
  /** Creates a single `RoomTypeAttr`. */
  createRoomTypeAttr?: Maybe<CreateRoomTypeAttrPayload>;
  /** Creates a single `Scenario`. */
  createScenario?: Maybe<CreateScenarioPayload>;
  /** Creates a single `ScenarioGroup`. */
  createScenarioGroup?: Maybe<CreateScenarioGroupPayload>;
  /** Creates a single `ScenarioSetting`. */
  createScenarioSetting?: Maybe<CreateScenarioSettingPayload>;
  /** Creates a single `ScenarioVariantVisibility`. */
  createScenarioVariantVisibility?: Maybe<CreateScenarioVariantVisibilityPayload>;
  /** Creates a single `Site`. */
  createSite?: Maybe<CreateSitePayload>;
  /** Creates a single `SiteDescription`. */
  createSiteDescription?: Maybe<CreateSiteDescriptionPayload>;
  /** Creates a single `SiteNameExtra`. */
  createSiteNameExtra?: Maybe<CreateSiteNameExtraPayload>;
  /** Creates a single `SiteNameKeyCad`. */
  createSiteNameKeyCad?: Maybe<CreateSiteNameKeyCadPayload>;
  /** Creates a single `SiteNameKeyCafm`. */
  createSiteNameKeyCafm?: Maybe<CreateSiteNameKeyCafmPayload>;
  /** Creates a single `SiteNameKeyEbm`. */
  createSiteNameKeyEbm?: Maybe<CreateSiteNameKeyEbmPayload>;
  /** Creates a single `SiteNameKeyMarketing`. */
  createSiteNameKeyMarketing?: Maybe<CreateSiteNameKeyMarketingPayload>;
  /** Creates a single `SiteNameLong`. */
  createSiteNameLong?: Maybe<CreateSiteNameLongPayload>;
  /** Creates a single `SiteNameShort`. */
  createSiteNameShort?: Maybe<CreateSiteNameShortPayload>;
  createUploadUrl: CreateUploadUrlResponse;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserPasswordLogin`. */
  createUserPasswordLogin?: Maybe<CreateUserPasswordLoginPayload>;
  /** Creates a single `UserSsoLogin`. */
  createUserSsoLogin?: Maybe<CreateUserSsoLoginPayload>;
  createUserWithPasswordLogin: CreateUserWithPasswordLoginResponse;
  /** Creates a single `Zone`. */
  createZone?: Maybe<CreateZonePayload>;
  /** Creates a single `ZoneCadGrossSpaceMin`. */
  createZoneCadGrossSpaceMin?: Maybe<CreateZoneCadGrossSpaceMinPayload>;
  /** Creates a single `ZoneCapacityCar`. */
  createZoneCapacityCar?: Maybe<CreateZoneCapacityCarPayload>;
  /** Creates a single `ZoneCapacityTruck`. */
  createZoneCapacityTruck?: Maybe<CreateZoneCapacityTruckPayload>;
  /** Creates a single `ZoneDescription`. */
  createZoneDescription?: Maybe<CreateZoneDescriptionPayload>;
  /** Creates a single `ZoneMaxLoadFloor`. */
  createZoneMaxLoadFloor?: Maybe<CreateZoneMaxLoadFloorPayload>;
  /** Creates a single `ZoneNameExtra`. */
  createZoneNameExtra?: Maybe<CreateZoneNameExtraPayload>;
  /** Creates a single `ZoneNameKeyCad`. */
  createZoneNameKeyCad?: Maybe<CreateZoneNameKeyCadPayload>;
  /** Creates a single `ZoneNameKeyCafm`. */
  createZoneNameKeyCafm?: Maybe<CreateZoneNameKeyCafmPayload>;
  /** Creates a single `ZoneNameKeyEbm`. */
  createZoneNameKeyEbm?: Maybe<CreateZoneNameKeyEbmPayload>;
  /** Creates a single `ZoneNameKeyMarketing`. */
  createZoneNameKeyMarketing?: Maybe<CreateZoneNameKeyMarketingPayload>;
  /** Creates a single `ZoneNameLong`. */
  createZoneNameLong?: Maybe<CreateZoneNameLongPayload>;
  /** Creates a single `ZoneNameShort`. */
  createZoneNameShort?: Maybe<CreateZoneNameShortPayload>;
  /** Creates a single `ZoneNoVehicle`. */
  createZoneNoVehicle?: Maybe<CreateZoneNoVehiclePayload>;
  /** Creates a single `ZonePublicGrossSpace`. */
  createZonePublicGrossSpace?: Maybe<CreateZonePublicGrossSpacePayload>;
  /** Creates a single `ZoneTireLoadCar`. */
  createZoneTireLoadCar?: Maybe<CreateZoneTireLoadCarPayload>;
  /** Creates a single `ZoneTireLoadForklift`. */
  createZoneTireLoadForklift?: Maybe<CreateZoneTireLoadForkliftPayload>;
  /** Creates a single `ZoneTireLoadTruck`. */
  createZoneTireLoadTruck?: Maybe<CreateZoneTireLoadTruckPayload>;
  /** Creates a single `ZoneType`. */
  createZoneType?: Maybe<CreateZoneTypePayload>;
  /** Creates a single `ZoneTypeAttr`. */
  createZoneTypeAttr?: Maybe<CreateZoneTypeAttrPayload>;
  deactivatePasswordLogin: DeactivatePasswordLoginResponse;
  deactivateSsoLogin: DeactivateSsoLoginResponse;
  deactivateUser?: Maybe<DeactivateUserResponse>;
  /** Deletes a single `AllocationArea` using a unique key. */
  deleteAllocationArea?: Maybe<DeleteAllocationAreaPayload>;
  /** Deletes a single `AllocationAreaPhase` using a unique key. */
  deleteAllocationAreaPhase?: Maybe<DeleteAllocationAreaPhasePayload>;
  /** Deletes a single `AllocationPlot` using a unique key. */
  deleteAllocationPlot?: Maybe<DeleteAllocationPlotPayload>;
  /** Deletes a single `AllocationPlotPhase` using a unique key. */
  deleteAllocationPlotPhase?: Maybe<DeleteAllocationPlotPhasePayload>;
  /** Deletes a single `AllocationRoom` using a unique key. */
  deleteAllocationRoom?: Maybe<DeleteAllocationRoomPayload>;
  /** Deletes a single `AllocationRoomPhase` using a unique key. */
  deleteAllocationRoomPhase?: Maybe<DeleteAllocationRoomPhasePayload>;
  /** Deletes a single `AllocationUsage` using a unique key. */
  deleteAllocationUsage?: Maybe<DeleteAllocationUsagePayload>;
  /** Deletes a single `AllocationUsage` using a unique key. */
  deleteAllocationUsageByName?: Maybe<DeleteAllocationUsagePayload>;
  /** Deletes a single `AllocationUsage` using a unique key. */
  deleteAllocationUsageByNameShort?: Maybe<DeleteAllocationUsagePayload>;
  /** Deletes a single `AllocationUsage` using a unique key. */
  deleteAllocationUsageByPosition?: Maybe<DeleteAllocationUsagePayload>;
  /** Deletes a single `AllocationUsage` using a unique key. */
  deleteAllocationUsageByType?: Maybe<DeleteAllocationUsagePayload>;
  /** Deletes a single `Area` using a unique key. */
  deleteArea?: Maybe<DeleteAreaPayload>;
  /** Deletes a single `Area` using a unique key. */
  deleteAreaByExtId?: Maybe<DeleteAreaPayload>;
  /** Deletes a single `Area` using a unique key. */
  deleteAreaByNameShort?: Maybe<DeleteAreaPayload>;
  /** Deletes a single `AreaCadGrossSpaceMin` using a unique key. */
  deleteAreaCadGrossSpaceMin?: Maybe<DeleteAreaCadGrossSpaceMinPayload>;
  /** Deletes a single `AreaClearanceConstruction` using a unique key. */
  deleteAreaClearanceConstruction?: Maybe<DeleteAreaClearanceConstructionPayload>;
  /** Deletes a single `AreaContactBooking` using a unique key. */
  deleteAreaContactBooking?: Maybe<DeleteAreaContactBookingPayload>;
  /** Deletes a single `AreaDescription` using a unique key. */
  deleteAreaDescription?: Maybe<DeleteAreaDescriptionPayload>;
  /** Deletes a single `AreaKeyIssuance` using a unique key. */
  deleteAreaKeyIssuance?: Maybe<DeleteAreaKeyIssuancePayload>;
  /** Deletes a single `AreaKeyIssuanceNote` using a unique key. */
  deleteAreaKeyIssuanceNote?: Maybe<DeleteAreaKeyIssuanceNotePayload>;
  /** Deletes a single `AreaNameExtra` using a unique key. */
  deleteAreaNameExtra?: Maybe<DeleteAreaNameExtraPayload>;
  /** Deletes a single `AreaNameKeyCad` using a unique key. */
  deleteAreaNameKeyCad?: Maybe<DeleteAreaNameKeyCadPayload>;
  /** Deletes a single `AreaNameKeyCafm` using a unique key. */
  deleteAreaNameKeyCafm?: Maybe<DeleteAreaNameKeyCafmPayload>;
  /** Deletes a single `AreaNameKeyEbm` using a unique key. */
  deleteAreaNameKeyEbm?: Maybe<DeleteAreaNameKeyEbmPayload>;
  /** Deletes a single `AreaNameKeyMarketing` using a unique key. */
  deleteAreaNameKeyMarketing?: Maybe<DeleteAreaNameKeyMarketingPayload>;
  /** Deletes a single `AreaNameLong` using a unique key. */
  deleteAreaNameLong?: Maybe<DeleteAreaNameLongPayload>;
  /** Deletes a single `AreaNameShort` using a unique key. */
  deleteAreaNameShort?: Maybe<DeleteAreaNameShortPayload>;
  /** Deletes a single `AreaPublicGrossSpace` using a unique key. */
  deleteAreaPublicGrossSpace?: Maybe<DeleteAreaPublicGrossSpacePayload>;
  /** Deletes a single `AreaType` using a unique key. */
  deleteAreaType?: Maybe<DeleteAreaTypePayload>;
  /** Deletes a single `AreaTypeAttr` using a unique key. */
  deleteAreaTypeAttr?: Maybe<DeleteAreaTypeAttrPayload>;
  /** Deletes a single `AreaType` using a unique key. */
  deleteAreaTypeByName?: Maybe<DeleteAreaTypePayload>;
  /** Deletes a single `Building` using a unique key. */
  deleteBuilding?: Maybe<DeleteBuildingPayload>;
  /** Deletes a single `Building` using a unique key. */
  deleteBuildingByExtId?: Maybe<DeleteBuildingPayload>;
  /** Deletes a single `Building` using a unique key. */
  deleteBuildingByIdAndSiteId?: Maybe<DeleteBuildingPayload>;
  /** Deletes a single `Building` using a unique key. */
  deleteBuildingByNameShort?: Maybe<DeleteBuildingPayload>;
  /** Deletes a single `BuildingDescription` using a unique key. */
  deleteBuildingDescription?: Maybe<DeleteBuildingDescriptionPayload>;
  /** Deletes a single `BuildingNameExtra` using a unique key. */
  deleteBuildingNameExtra?: Maybe<DeleteBuildingNameExtraPayload>;
  /** Deletes a single `BuildingNameKeyCad` using a unique key. */
  deleteBuildingNameKeyCad?: Maybe<DeleteBuildingNameKeyCadPayload>;
  /** Deletes a single `BuildingNameKeyCafm` using a unique key. */
  deleteBuildingNameKeyCafm?: Maybe<DeleteBuildingNameKeyCafmPayload>;
  /** Deletes a single `BuildingNameKeyEbm` using a unique key. */
  deleteBuildingNameKeyEbm?: Maybe<DeleteBuildingNameKeyEbmPayload>;
  /** Deletes a single `BuildingNameKeyMarketing` using a unique key. */
  deleteBuildingNameKeyMarketing?: Maybe<DeleteBuildingNameKeyMarketingPayload>;
  /** Deletes a single `BuildingNameLong` using a unique key. */
  deleteBuildingNameLong?: Maybe<DeleteBuildingNameLongPayload>;
  /** Deletes a single `BuildingNameShort` using a unique key. */
  deleteBuildingNameShort?: Maybe<DeleteBuildingNameShortPayload>;
  /** Deletes a single `BuildingPublicGrossSpace` using a unique key. */
  deleteBuildingPublicGrossSpace?: Maybe<DeleteBuildingPublicGrossSpacePayload>;
  /** Deletes a single `BuildingType` using a unique key. */
  deleteBuildingType?: Maybe<DeleteBuildingTypePayload>;
  /** Deletes a single `BuildingTypeAttr` using a unique key. */
  deleteBuildingTypeAttr?: Maybe<DeleteBuildingTypeAttrPayload>;
  /** Deletes a single `BuildingType` using a unique key. */
  deleteBuildingTypeByName?: Maybe<DeleteBuildingTypePayload>;
  /** Deletes a single `ElevationLevel` using a unique key. */
  deleteElevationLevel?: Maybe<DeleteElevationLevelPayload>;
  /** Deletes a single `ElevationLevel` using a unique key. */
  deleteElevationLevelByValue?: Maybe<DeleteElevationLevelPayload>;
  /** Deletes a single `Event` using a unique key. */
  deleteEvent?: Maybe<DeleteEventPayload>;
  /** Deletes a single `Event` using a unique key. */
  deleteEventByNameShort?: Maybe<DeleteEventPayload>;
  /** Deletes a single `EventSeries` using a unique key. */
  deleteEventSeries?: Maybe<DeleteEventSeriesPayload>;
  /** Deletes a single `EventSeries` using a unique key. */
  deleteEventSeriesByNameShort?: Maybe<DeleteEventSeriesPayload>;
  /** Deletes a single `EventVariant` using a unique key. */
  deleteEventVariant?: Maybe<DeleteEventVariantPayload>;
  /** Deletes a single `EventVariant` using a unique key. */
  deleteEventVariantByEventIdAndIndex?: Maybe<DeleteEventVariantPayload>;
  /** Deletes a single `ExternalEvent` using a unique key. */
  deleteExternalEvent?: Maybe<DeleteExternalEventPayload>;
  /** Deletes a single `ExternalEventAllocation` using a unique key. */
  deleteExternalEventAllocation?: Maybe<DeleteExternalEventAllocationPayload>;
  /** Deletes a single `ExternalEventAllocationPhase` using a unique key. */
  deleteExternalEventAllocationPhase?: Maybe<DeleteExternalEventAllocationPhasePayload>;
  /** Deletes a single `ExternalEventAllocationUsage` using a unique key. */
  deleteExternalEventAllocationUsage?: Maybe<DeleteExternalEventAllocationUsagePayload>;
  /** Deletes a single `ExternalEventAllocationUsage` using a unique key. */
  deleteExternalEventAllocationUsageByName?: Maybe<DeleteExternalEventAllocationUsagePayload>;
  /** Deletes a single `ExternalEventAllocationUsage` using a unique key. */
  deleteExternalEventAllocationUsageByNameShort?: Maybe<DeleteExternalEventAllocationUsagePayload>;
  /** Deletes a single `ExternalEventAllocationUsage` using a unique key. */
  deleteExternalEventAllocationUsageByPosition?: Maybe<DeleteExternalEventAllocationUsagePayload>;
  /** Deletes a single `ExternalEventAllocationUsage` using a unique key. */
  deleteExternalEventAllocationUsageByType?: Maybe<DeleteExternalEventAllocationUsagePayload>;
  /** Deletes a single `ExternalEvent` using a unique key. */
  deleteExternalEventByNameShort?: Maybe<DeleteExternalEventPayload>;
  /** Deletes a single `ExternalEventEventLocationVisibility` using a unique key. */
  deleteExternalEventEventLocationVisibility?: Maybe<DeleteExternalEventEventLocationVisibilityPayload>;
  /** Deletes a single `ExternalEventEventLocationVisibility` using a unique key. */
  deleteExternalEventEventLocationVisibilityByEventIdAndLocationId?: Maybe<DeleteExternalEventEventLocationVisibilityPayload>;
  /** Deletes a single `ExternalEventLocation` using a unique key. */
  deleteExternalEventLocation?: Maybe<DeleteExternalEventLocationPayload>;
  /** Deletes a single `ExternalEventLocation` using a unique key. */
  deleteExternalEventLocationByName?: Maybe<DeleteExternalEventLocationPayload>;
  /** Deletes a single `ExternalEventSeries` using a unique key. */
  deleteExternalEventSeries?: Maybe<DeleteExternalEventSeriesPayload>;
  /** Deletes a single `ExternalEventSeries` using a unique key. */
  deleteExternalEventSeriesByNameShort?: Maybe<DeleteExternalEventSeriesPayload>;
  /** Deletes a single `ExternalEventVariant` using a unique key. */
  deleteExternalEventVariant?: Maybe<DeleteExternalEventVariantPayload>;
  /** Deletes a single `ExternalEventVariant` using a unique key. */
  deleteExternalEventVariantByEventIdAndIndex?: Maybe<DeleteExternalEventVariantPayload>;
  /** Deletes a single `Feed` using a unique key. */
  deleteFeed?: Maybe<DeleteFeedPayload>;
  /** Deletes a single `FeedEntry` using a unique key. */
  deleteFeedEntry?: Maybe<DeleteFeedEntryPayload>;
  /** Deletes a single `Level` using a unique key. */
  deleteLevel?: Maybe<DeleteLevelPayload>;
  /** Deletes a single `Level` using a unique key. */
  deleteLevelByExtId?: Maybe<DeleteLevelPayload>;
  /** Deletes a single `Level` using a unique key. */
  deleteLevelByNameShort?: Maybe<DeleteLevelPayload>;
  /** Deletes a single `LevelCapacityPax` using a unique key. */
  deleteLevelCapacityPax?: Maybe<DeleteLevelCapacityPaxPayload>;
  /** Deletes a single `LevelDescription` using a unique key. */
  deleteLevelDescription?: Maybe<DeleteLevelDescriptionPayload>;
  /** Deletes a single `LevelFkmGrossSpace` using a unique key. */
  deleteLevelFkmGrossSpace?: Maybe<DeleteLevelFkmGrossSpacePayload>;
  /** Deletes a single `LevelNameExtra` using a unique key. */
  deleteLevelNameExtra?: Maybe<DeleteLevelNameExtraPayload>;
  /** Deletes a single `LevelNameKeyCad` using a unique key. */
  deleteLevelNameKeyCad?: Maybe<DeleteLevelNameKeyCadPayload>;
  /** Deletes a single `LevelNameKeyCafm` using a unique key. */
  deleteLevelNameKeyCafm?: Maybe<DeleteLevelNameKeyCafmPayload>;
  /** Deletes a single `LevelNameKeyEbm` using a unique key. */
  deleteLevelNameKeyEbm?: Maybe<DeleteLevelNameKeyEbmPayload>;
  /** Deletes a single `LevelNameKeyMarketing` using a unique key. */
  deleteLevelNameKeyMarketing?: Maybe<DeleteLevelNameKeyMarketingPayload>;
  /** Deletes a single `LevelNameLong` using a unique key. */
  deleteLevelNameLong?: Maybe<DeleteLevelNameLongPayload>;
  /** Deletes a single `LevelNameShort` using a unique key. */
  deleteLevelNameShort?: Maybe<DeleteLevelNameShortPayload>;
  /** Deletes a single `LevelPublicGrossSpace` using a unique key. */
  deleteLevelPublicGrossSpace?: Maybe<DeleteLevelPublicGrossSpacePayload>;
  /** Deletes a single `LevelType` using a unique key. */
  deleteLevelType?: Maybe<DeleteLevelTypePayload>;
  /** Deletes a single `LevelTypeAttr` using a unique key. */
  deleteLevelTypeAttr?: Maybe<DeleteLevelTypeAttrPayload>;
  /** Deletes a single `LevelType` using a unique key. */
  deleteLevelTypeByName?: Maybe<DeleteLevelTypePayload>;
  /** Deletes a single `Link` using a unique key. */
  deleteLink?: Maybe<DeleteLinkPayload>;
  /** Deletes a single `Multilink` using a unique key. */
  deleteMultilink?: Maybe<DeleteMultilinkPayload>;
  /** Deletes a single `Plot` using a unique key. */
  deletePlot?: Maybe<DeletePlotPayload>;
  /** Deletes a single `Plot` using a unique key. */
  deletePlotByExtId?: Maybe<DeletePlotPayload>;
  /** Deletes a single `Plot` using a unique key. */
  deletePlotByNameShort?: Maybe<DeletePlotPayload>;
  /** Deletes a single `PlotCadGrossSpaceMin` using a unique key. */
  deletePlotCadGrossSpaceMin?: Maybe<DeletePlotCadGrossSpaceMinPayload>;
  /** Deletes a single `PlotDescription` using a unique key. */
  deletePlotDescription?: Maybe<DeletePlotDescriptionPayload>;
  /** Deletes a single `PlotNameExtra` using a unique key. */
  deletePlotNameExtra?: Maybe<DeletePlotNameExtraPayload>;
  /** Deletes a single `PlotNameKeyCad` using a unique key. */
  deletePlotNameKeyCad?: Maybe<DeletePlotNameKeyCadPayload>;
  /** Deletes a single `PlotNameKeyCafm` using a unique key. */
  deletePlotNameKeyCafm?: Maybe<DeletePlotNameKeyCafmPayload>;
  /** Deletes a single `PlotNameKeyEbm` using a unique key. */
  deletePlotNameKeyEbm?: Maybe<DeletePlotNameKeyEbmPayload>;
  /** Deletes a single `PlotNameKeyMarketing` using a unique key. */
  deletePlotNameKeyMarketing?: Maybe<DeletePlotNameKeyMarketingPayload>;
  /** Deletes a single `PlotNameLong` using a unique key. */
  deletePlotNameLong?: Maybe<DeletePlotNameLongPayload>;
  /** Deletes a single `PlotNameShort` using a unique key. */
  deletePlotNameShort?: Maybe<DeletePlotNameShortPayload>;
  /** Deletes a single `PlotPublicGrossSpace` using a unique key. */
  deletePlotPublicGrossSpace?: Maybe<DeletePlotPublicGrossSpacePayload>;
  /** Deletes a single `PlotType` using a unique key. */
  deletePlotType?: Maybe<DeletePlotTypePayload>;
  /** Deletes a single `PlotTypeAttr` using a unique key. */
  deletePlotTypeAttr?: Maybe<DeletePlotTypeAttrPayload>;
  /** Deletes a single `PlotType` using a unique key. */
  deletePlotTypeByName?: Maybe<DeletePlotTypePayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProject?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `ProjectAllocationArea` using a unique key. */
  deleteProjectAllocationArea?: Maybe<DeleteProjectAllocationAreaPayload>;
  /** Deletes a single `ProjectAllocationAreaPhase` using a unique key. */
  deleteProjectAllocationAreaPhase?: Maybe<DeleteProjectAllocationAreaPhasePayload>;
  /** Deletes a single `ProjectAllocationPlot` using a unique key. */
  deleteProjectAllocationPlot?: Maybe<DeleteProjectAllocationPlotPayload>;
  /** Deletes a single `ProjectAllocationPlotPhase` using a unique key. */
  deleteProjectAllocationPlotPhase?: Maybe<DeleteProjectAllocationPlotPhasePayload>;
  /** Deletes a single `ProjectAllocationRoom` using a unique key. */
  deleteProjectAllocationRoom?: Maybe<DeleteProjectAllocationRoomPayload>;
  /** Deletes a single `ProjectAllocationRoomPhase` using a unique key. */
  deleteProjectAllocationRoomPhase?: Maybe<DeleteProjectAllocationRoomPhasePayload>;
  /** Deletes a single `ProjectAllocationUsage` using a unique key. */
  deleteProjectAllocationUsage?: Maybe<DeleteProjectAllocationUsagePayload>;
  /** Deletes a single `ProjectAllocationUsage` using a unique key. */
  deleteProjectAllocationUsageByName?: Maybe<DeleteProjectAllocationUsagePayload>;
  /** Deletes a single `ProjectAllocationUsage` using a unique key. */
  deleteProjectAllocationUsageByNameShort?: Maybe<DeleteProjectAllocationUsagePayload>;
  /** Deletes a single `ProjectAllocationUsage` using a unique key. */
  deleteProjectAllocationUsageByPosition?: Maybe<DeleteProjectAllocationUsagePayload>;
  /** Deletes a single `ProjectAllocationUsage` using a unique key. */
  deleteProjectAllocationUsageByType?: Maybe<DeleteProjectAllocationUsagePayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProjectByNameShort?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `ProjectSeries` using a unique key. */
  deleteProjectSeries?: Maybe<DeleteProjectSeriesPayload>;
  /** Deletes a single `ProjectSeries` using a unique key. */
  deleteProjectSeriesByNameShort?: Maybe<DeleteProjectSeriesPayload>;
  /** Deletes a single `ProjectVariant` using a unique key. */
  deleteProjectVariant?: Maybe<DeleteProjectVariantPayload>;
  /** Deletes a single `ProjectVariant` using a unique key. */
  deleteProjectVariantByProjectIdAndIndex?: Maybe<DeleteProjectVariantPayload>;
  /** Deletes a single `Room` using a unique key. */
  deleteRoom?: Maybe<DeleteRoomPayload>;
  /** Deletes a single `RoomAirChangeRate` using a unique key. */
  deleteRoomAirChangeRate?: Maybe<DeleteRoomAirChangeRatePayload>;
  /** Deletes a single `RoomAirConditioning` using a unique key. */
  deleteRoomAirConditioning?: Maybe<DeleteRoomAirConditioningPayload>;
  /** Deletes a single `Room` using a unique key. */
  deleteRoomByExtId?: Maybe<DeleteRoomPayload>;
  /** Deletes a single `Room` using a unique key. */
  deleteRoomByNameShort?: Maybe<DeleteRoomPayload>;
  /** Deletes a single `RoomCadGrossSpaceMin` using a unique key. */
  deleteRoomCadGrossSpaceMin?: Maybe<DeleteRoomCadGrossSpaceMinPayload>;
  /** Deletes a single `RoomCadHeightMax` using a unique key. */
  deleteRoomCadHeightMax?: Maybe<DeleteRoomCadHeightMaxPayload>;
  /** Deletes a single `RoomCadHeightMin` using a unique key. */
  deleteRoomCadHeightMin?: Maybe<DeleteRoomCadHeightMinPayload>;
  /** Deletes a single `RoomCadLengthMax` using a unique key. */
  deleteRoomCadLengthMax?: Maybe<DeleteRoomCadLengthMaxPayload>;
  /** Deletes a single `RoomCadLengthMin` using a unique key. */
  deleteRoomCadLengthMin?: Maybe<DeleteRoomCadLengthMinPayload>;
  /** Deletes a single `RoomCadWidthMax` using a unique key. */
  deleteRoomCadWidthMax?: Maybe<DeleteRoomCadWidthMaxPayload>;
  /** Deletes a single `RoomCadWidthMin` using a unique key. */
  deleteRoomCadWidthMin?: Maybe<DeleteRoomCadWidthMinPayload>;
  /** Deletes a single `RoomCapacityCar` using a unique key. */
  deleteRoomCapacityCar?: Maybe<DeleteRoomCapacityCarPayload>;
  /** Deletes a single `RoomCapacityPax` using a unique key. */
  deleteRoomCapacityPax?: Maybe<DeleteRoomCapacityPaxPayload>;
  /** Deletes a single `RoomCapacityTruck` using a unique key. */
  deleteRoomCapacityTruck?: Maybe<DeleteRoomCapacityTruckPayload>;
  /** Deletes a single `RoomCleaningGrossSpace` using a unique key. */
  deleteRoomCleaningGrossSpace?: Maybe<DeleteRoomCleaningGrossSpacePayload>;
  /** Deletes a single `RoomClearanceConstruction` using a unique key. */
  deleteRoomClearanceConstruction?: Maybe<DeleteRoomClearanceConstructionPayload>;
  /** Deletes a single `RoomContactBooking` using a unique key. */
  deleteRoomContactBooking?: Maybe<DeleteRoomContactBookingPayload>;
  /** Deletes a single `RoomDaylight` using a unique key. */
  deleteRoomDaylight?: Maybe<DeleteRoomDaylightPayload>;
  /** Deletes a single `RoomDescription` using a unique key. */
  deleteRoomDescription?: Maybe<DeleteRoomDescriptionPayload>;
  /** Deletes a single `RoomKeyIssuance` using a unique key. */
  deleteRoomKeyIssuance?: Maybe<DeleteRoomKeyIssuancePayload>;
  /** Deletes a single `RoomKeyIssuanceNote` using a unique key. */
  deleteRoomKeyIssuanceNote?: Maybe<DeleteRoomKeyIssuanceNotePayload>;
  /** Deletes a single `RoomLightShutter` using a unique key. */
  deleteRoomLightShutter?: Maybe<DeleteRoomLightShutterPayload>;
  /** Deletes a single `RoomMaxLoadCeiling` using a unique key. */
  deleteRoomMaxLoadCeiling?: Maybe<DeleteRoomMaxLoadCeilingPayload>;
  /** Deletes a single `RoomMaxLoadFloor` using a unique key. */
  deleteRoomMaxLoadFloor?: Maybe<DeleteRoomMaxLoadFloorPayload>;
  /** Deletes a single `RoomNameExtra` using a unique key. */
  deleteRoomNameExtra?: Maybe<DeleteRoomNameExtraPayload>;
  /** Deletes a single `RoomNameKeyCad` using a unique key. */
  deleteRoomNameKeyCad?: Maybe<DeleteRoomNameKeyCadPayload>;
  /** Deletes a single `RoomNameKeyCafm` using a unique key. */
  deleteRoomNameKeyCafm?: Maybe<DeleteRoomNameKeyCafmPayload>;
  /** Deletes a single `RoomNameKeyEbm` using a unique key. */
  deleteRoomNameKeyEbm?: Maybe<DeleteRoomNameKeyEbmPayload>;
  /** Deletes a single `RoomNameKeyMarketing` using a unique key. */
  deleteRoomNameKeyMarketing?: Maybe<DeleteRoomNameKeyMarketingPayload>;
  /** Deletes a single `RoomNameLong` using a unique key. */
  deleteRoomNameLong?: Maybe<DeleteRoomNameLongPayload>;
  /** Deletes a single `RoomNameShort` using a unique key. */
  deleteRoomNameShort?: Maybe<DeleteRoomNameShortPayload>;
  /** Deletes a single `RoomNoVehicle` using a unique key. */
  deleteRoomNoVehicle?: Maybe<DeleteRoomNoVehiclePayload>;
  /** Deletes a single `RoomPartition` using a unique key. */
  deleteRoomPartition?: Maybe<DeleteRoomPartitionPayload>;
  /** Deletes a single `RoomPartition` using a unique key. */
  deleteRoomPartitionByExtId?: Maybe<DeleteRoomPartitionPayload>;
  /** Deletes a single `RoomPartition` using a unique key. */
  deleteRoomPartitionByNameShort?: Maybe<DeleteRoomPartitionPayload>;
  /** Deletes a single `RoomPartitionCadGrossSpaceMin` using a unique key. */
  deleteRoomPartitionCadGrossSpaceMin?: Maybe<DeleteRoomPartitionCadGrossSpaceMinPayload>;
  /** Deletes a single `RoomPartitionCadHeightMax` using a unique key. */
  deleteRoomPartitionCadHeightMax?: Maybe<DeleteRoomPartitionCadHeightMaxPayload>;
  /** Deletes a single `RoomPartitionCadHeightMin` using a unique key. */
  deleteRoomPartitionCadHeightMin?: Maybe<DeleteRoomPartitionCadHeightMinPayload>;
  /** Deletes a single `RoomPartitionCadLengthMax` using a unique key. */
  deleteRoomPartitionCadLengthMax?: Maybe<DeleteRoomPartitionCadLengthMaxPayload>;
  /** Deletes a single `RoomPartitionCadLengthMin` using a unique key. */
  deleteRoomPartitionCadLengthMin?: Maybe<DeleteRoomPartitionCadLengthMinPayload>;
  /** Deletes a single `RoomPartitionCadWidthMax` using a unique key. */
  deleteRoomPartitionCadWidthMax?: Maybe<DeleteRoomPartitionCadWidthMaxPayload>;
  /** Deletes a single `RoomPartitionCadWidthMin` using a unique key. */
  deleteRoomPartitionCadWidthMin?: Maybe<DeleteRoomPartitionCadWidthMinPayload>;
  /** Deletes a single `RoomPartitionCapacityPax` using a unique key. */
  deleteRoomPartitionCapacityPax?: Maybe<DeleteRoomPartitionCapacityPaxPayload>;
  /** Deletes a single `RoomPartitionCleaningGrossSpace` using a unique key. */
  deleteRoomPartitionCleaningGrossSpace?: Maybe<DeleteRoomPartitionCleaningGrossSpacePayload>;
  /** Deletes a single `RoomPartitionDescription` using a unique key. */
  deleteRoomPartitionDescription?: Maybe<DeleteRoomPartitionDescriptionPayload>;
  /** Deletes a single `RoomPartitionNameExtra` using a unique key. */
  deleteRoomPartitionNameExtra?: Maybe<DeleteRoomPartitionNameExtraPayload>;
  /** Deletes a single `RoomPartitionNameKeyCad` using a unique key. */
  deleteRoomPartitionNameKeyCad?: Maybe<DeleteRoomPartitionNameKeyCadPayload>;
  /** Deletes a single `RoomPartitionNameKeyCafm` using a unique key. */
  deleteRoomPartitionNameKeyCafm?: Maybe<DeleteRoomPartitionNameKeyCafmPayload>;
  /** Deletes a single `RoomPartitionNameKeyEbm` using a unique key. */
  deleteRoomPartitionNameKeyEbm?: Maybe<DeleteRoomPartitionNameKeyEbmPayload>;
  /** Deletes a single `RoomPartitionNameKeyMarketing` using a unique key. */
  deleteRoomPartitionNameKeyMarketing?: Maybe<DeleteRoomPartitionNameKeyMarketingPayload>;
  /** Deletes a single `RoomPartitionNameLong` using a unique key. */
  deleteRoomPartitionNameLong?: Maybe<DeleteRoomPartitionNameLongPayload>;
  /** Deletes a single `RoomPartitionNameShort` using a unique key. */
  deleteRoomPartitionNameShort?: Maybe<DeleteRoomPartitionNameShortPayload>;
  /** Deletes a single `RoomPartitionPublicGrossSpace` using a unique key. */
  deleteRoomPartitionPublicGrossSpace?: Maybe<DeleteRoomPartitionPublicGrossSpacePayload>;
  /** Deletes a single `RoomPartitionSbvGrossSpace` using a unique key. */
  deleteRoomPartitionSbvGrossSpace?: Maybe<DeleteRoomPartitionSbvGrossSpacePayload>;
  /** Deletes a single `RoomPartitionType` using a unique key. */
  deleteRoomPartitionType?: Maybe<DeleteRoomPartitionTypePayload>;
  /** Deletes a single `RoomPartitionTypeAttr` using a unique key. */
  deleteRoomPartitionTypeAttr?: Maybe<DeleteRoomPartitionTypeAttrPayload>;
  /** Deletes a single `RoomPartitionType` using a unique key. */
  deleteRoomPartitionTypeByName?: Maybe<DeleteRoomPartitionTypePayload>;
  /** Deletes a single `RoomPhoneNumber` using a unique key. */
  deleteRoomPhoneNumber?: Maybe<DeleteRoomPhoneNumberPayload>;
  /** Deletes a single `RoomPublicGrossSpace` using a unique key. */
  deleteRoomPublicGrossSpace?: Maybe<DeleteRoomPublicGrossSpacePayload>;
  /** Deletes a single `RoomSbvGrossSpace` using a unique key. */
  deleteRoomSbvGrossSpace?: Maybe<DeleteRoomSbvGrossSpacePayload>;
  /** Deletes a single `RoomTireLoadCar` using a unique key. */
  deleteRoomTireLoadCar?: Maybe<DeleteRoomTireLoadCarPayload>;
  /** Deletes a single `RoomTireLoadForklift` using a unique key. */
  deleteRoomTireLoadForklift?: Maybe<DeleteRoomTireLoadForkliftPayload>;
  /** Deletes a single `RoomTireLoadTruck` using a unique key. */
  deleteRoomTireLoadTruck?: Maybe<DeleteRoomTireLoadTruckPayload>;
  /** Deletes a single `RoomType` using a unique key. */
  deleteRoomType?: Maybe<DeleteRoomTypePayload>;
  /** Deletes a single `RoomTypeAttr` using a unique key. */
  deleteRoomTypeAttr?: Maybe<DeleteRoomTypeAttrPayload>;
  /** Deletes a single `RoomType` using a unique key. */
  deleteRoomTypeByName?: Maybe<DeleteRoomTypePayload>;
  /** Deletes a single `Scenario` using a unique key. */
  deleteScenario?: Maybe<DeleteScenarioPayload>;
  /** Deletes a single `Scenario` using a unique key. */
  deleteScenarioByNameShort?: Maybe<DeleteScenarioPayload>;
  /** Deletes a single `ScenarioGroup` using a unique key. */
  deleteScenarioGroup?: Maybe<DeleteScenarioGroupPayload>;
  /** Deletes a single `ScenarioGroup` using a unique key. */
  deleteScenarioGroupByNameShort?: Maybe<DeleteScenarioGroupPayload>;
  /** Deletes a single `ScenarioSetting` using a unique key. */
  deleteScenarioSetting?: Maybe<DeleteScenarioSettingPayload>;
  /** Deletes a single `ScenarioVariantVisibility` using a unique key. */
  deleteScenarioVariantVisibility?: Maybe<DeleteScenarioVariantVisibilityPayload>;
  /** Deletes a single `ScenarioVariantVisibility` using a unique key. */
  deleteScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantType?: Maybe<DeleteScenarioVariantVisibilityPayload>;
  /** Deletes a single `Site` using a unique key. */
  deleteSite?: Maybe<DeleteSitePayload>;
  /** Deletes a single `Site` using a unique key. */
  deleteSiteByExtId?: Maybe<DeleteSitePayload>;
  /** Deletes a single `Site` using a unique key. */
  deleteSiteByNameShort?: Maybe<DeleteSitePayload>;
  /** Deletes a single `SiteDescription` using a unique key. */
  deleteSiteDescription?: Maybe<DeleteSiteDescriptionPayload>;
  /** Deletes a single `SiteNameExtra` using a unique key. */
  deleteSiteNameExtra?: Maybe<DeleteSiteNameExtraPayload>;
  /** Deletes a single `SiteNameKeyCad` using a unique key. */
  deleteSiteNameKeyCad?: Maybe<DeleteSiteNameKeyCadPayload>;
  /** Deletes a single `SiteNameKeyCafm` using a unique key. */
  deleteSiteNameKeyCafm?: Maybe<DeleteSiteNameKeyCafmPayload>;
  /** Deletes a single `SiteNameKeyEbm` using a unique key. */
  deleteSiteNameKeyEbm?: Maybe<DeleteSiteNameKeyEbmPayload>;
  /** Deletes a single `SiteNameKeyMarketing` using a unique key. */
  deleteSiteNameKeyMarketing?: Maybe<DeleteSiteNameKeyMarketingPayload>;
  /** Deletes a single `SiteNameLong` using a unique key. */
  deleteSiteNameLong?: Maybe<DeleteSiteNameLongPayload>;
  /** Deletes a single `SiteNameShort` using a unique key. */
  deleteSiteNameShort?: Maybe<DeleteSiteNameShortPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserPasswordLogin` using a unique key. */
  deleteUserPasswordLogin?: Maybe<DeleteUserPasswordLoginPayload>;
  /** Deletes a single `UserPasswordLogin` using a unique key. */
  deleteUserPasswordLoginByEmail?: Maybe<DeleteUserPasswordLoginPayload>;
  /** Deletes a single `UserPasswordLogin` using a unique key. */
  deleteUserPasswordLoginByUserId?: Maybe<DeleteUserPasswordLoginPayload>;
  /** Deletes a single `UserSsoLogin` using a unique key. */
  deleteUserSsoLogin?: Maybe<DeleteUserSsoLoginPayload>;
  /** Deletes a single `UserSsoLogin` using a unique key. */
  deleteUserSsoLoginByProviderAndOid?: Maybe<DeleteUserSsoLoginPayload>;
  /** Deletes a single `UserSsoLogin` using a unique key. */
  deleteUserSsoLoginByUserIdAndProvider?: Maybe<DeleteUserSsoLoginPayload>;
  /** Deletes a single `Zone` using a unique key. */
  deleteZone?: Maybe<DeleteZonePayload>;
  /** Deletes a single `Zone` using a unique key. */
  deleteZoneByExtId?: Maybe<DeleteZonePayload>;
  /** Deletes a single `Zone` using a unique key. */
  deleteZoneByNameShort?: Maybe<DeleteZonePayload>;
  /** Deletes a single `ZoneCadGrossSpaceMin` using a unique key. */
  deleteZoneCadGrossSpaceMin?: Maybe<DeleteZoneCadGrossSpaceMinPayload>;
  /** Deletes a single `ZoneCapacityCar` using a unique key. */
  deleteZoneCapacityCar?: Maybe<DeleteZoneCapacityCarPayload>;
  /** Deletes a single `ZoneCapacityTruck` using a unique key. */
  deleteZoneCapacityTruck?: Maybe<DeleteZoneCapacityTruckPayload>;
  /** Deletes a single `ZoneDescription` using a unique key. */
  deleteZoneDescription?: Maybe<DeleteZoneDescriptionPayload>;
  /** Deletes a single `ZoneMaxLoadFloor` using a unique key. */
  deleteZoneMaxLoadFloor?: Maybe<DeleteZoneMaxLoadFloorPayload>;
  /** Deletes a single `ZoneNameExtra` using a unique key. */
  deleteZoneNameExtra?: Maybe<DeleteZoneNameExtraPayload>;
  /** Deletes a single `ZoneNameKeyCad` using a unique key. */
  deleteZoneNameKeyCad?: Maybe<DeleteZoneNameKeyCadPayload>;
  /** Deletes a single `ZoneNameKeyCafm` using a unique key. */
  deleteZoneNameKeyCafm?: Maybe<DeleteZoneNameKeyCafmPayload>;
  /** Deletes a single `ZoneNameKeyEbm` using a unique key. */
  deleteZoneNameKeyEbm?: Maybe<DeleteZoneNameKeyEbmPayload>;
  /** Deletes a single `ZoneNameKeyMarketing` using a unique key. */
  deleteZoneNameKeyMarketing?: Maybe<DeleteZoneNameKeyMarketingPayload>;
  /** Deletes a single `ZoneNameLong` using a unique key. */
  deleteZoneNameLong?: Maybe<DeleteZoneNameLongPayload>;
  /** Deletes a single `ZoneNameShort` using a unique key. */
  deleteZoneNameShort?: Maybe<DeleteZoneNameShortPayload>;
  /** Deletes a single `ZoneNoVehicle` using a unique key. */
  deleteZoneNoVehicle?: Maybe<DeleteZoneNoVehiclePayload>;
  /** Deletes a single `ZonePublicGrossSpace` using a unique key. */
  deleteZonePublicGrossSpace?: Maybe<DeleteZonePublicGrossSpacePayload>;
  /** Deletes a single `ZoneTireLoadCar` using a unique key. */
  deleteZoneTireLoadCar?: Maybe<DeleteZoneTireLoadCarPayload>;
  /** Deletes a single `ZoneTireLoadForklift` using a unique key. */
  deleteZoneTireLoadForklift?: Maybe<DeleteZoneTireLoadForkliftPayload>;
  /** Deletes a single `ZoneTireLoadTruck` using a unique key. */
  deleteZoneTireLoadTruck?: Maybe<DeleteZoneTireLoadTruckPayload>;
  /** Deletes a single `ZoneType` using a unique key. */
  deleteZoneType?: Maybe<DeleteZoneTypePayload>;
  /** Deletes a single `ZoneTypeAttr` using a unique key. */
  deleteZoneTypeAttr?: Maybe<DeleteZoneTypeAttrPayload>;
  /** Deletes a single `ZoneType` using a unique key. */
  deleteZoneTypeByName?: Maybe<DeleteZoneTypePayload>;
  entraLogin: LoginResponse;
  externalEventAllocationDuplicate?: Maybe<ExternalEventAllocationDuplicatePayload>;
  externalEventAllocationUpdateAndDuplicate?: Maybe<ExternalEventAllocationUpdateAndDuplicatePayload>;
  login: LoginResponse;
  projectAllocationAreaDuplicate?: Maybe<ProjectAllocationAreaDuplicatePayload>;
  projectAllocationAreaUpdateAndDuplicate?: Maybe<ProjectAllocationAreaUpdateAndDuplicatePayload>;
  projectAllocationRoomDuplicate?: Maybe<ProjectAllocationRoomDuplicatePayload>;
  projectAllocationRoomUpdateAndDuplicate?: Maybe<ProjectAllocationRoomUpdateAndDuplicatePayload>;
  refreshJwt: RefreshJwtResponse;
  setPassword: SetPasswordResponse;
  /** Updates a single `AllocationArea` using a unique key and a patch. */
  updateAllocationArea?: Maybe<UpdateAllocationAreaPayload>;
  /** Updates a single `AllocationAreaPhase` using a unique key and a patch. */
  updateAllocationAreaPhase?: Maybe<UpdateAllocationAreaPhasePayload>;
  /** Updates a single `AllocationPlot` using a unique key and a patch. */
  updateAllocationPlot?: Maybe<UpdateAllocationPlotPayload>;
  /** Updates a single `AllocationPlotPhase` using a unique key and a patch. */
  updateAllocationPlotPhase?: Maybe<UpdateAllocationPlotPhasePayload>;
  /** Updates a single `AllocationRoom` using a unique key and a patch. */
  updateAllocationRoom?: Maybe<UpdateAllocationRoomPayload>;
  /** Updates a single `AllocationRoomPhase` using a unique key and a patch. */
  updateAllocationRoomPhase?: Maybe<UpdateAllocationRoomPhasePayload>;
  /** Updates a single `AllocationUsage` using a unique key and a patch. */
  updateAllocationUsage?: Maybe<UpdateAllocationUsagePayload>;
  /** Updates a single `AllocationUsage` using a unique key and a patch. */
  updateAllocationUsageByName?: Maybe<UpdateAllocationUsagePayload>;
  /** Updates a single `AllocationUsage` using a unique key and a patch. */
  updateAllocationUsageByNameShort?: Maybe<UpdateAllocationUsagePayload>;
  /** Updates a single `AllocationUsage` using a unique key and a patch. */
  updateAllocationUsageByPosition?: Maybe<UpdateAllocationUsagePayload>;
  /** Updates a single `AllocationUsage` using a unique key and a patch. */
  updateAllocationUsageByType?: Maybe<UpdateAllocationUsagePayload>;
  /** Updates a single `Area` using a unique key and a patch. */
  updateArea?: Maybe<UpdateAreaPayload>;
  /** Updates a single `Area` using a unique key and a patch. */
  updateAreaByExtId?: Maybe<UpdateAreaPayload>;
  /** Updates a single `Area` using a unique key and a patch. */
  updateAreaByNameShort?: Maybe<UpdateAreaPayload>;
  /** Updates a single `AreaCadGrossSpaceMin` using a unique key and a patch. */
  updateAreaCadGrossSpaceMin?: Maybe<UpdateAreaCadGrossSpaceMinPayload>;
  /** Updates a single `AreaClearanceConstruction` using a unique key and a patch. */
  updateAreaClearanceConstruction?: Maybe<UpdateAreaClearanceConstructionPayload>;
  /** Updates a single `AreaContactBooking` using a unique key and a patch. */
  updateAreaContactBooking?: Maybe<UpdateAreaContactBookingPayload>;
  /** Updates a single `AreaDescription` using a unique key and a patch. */
  updateAreaDescription?: Maybe<UpdateAreaDescriptionPayload>;
  /** Updates a single `AreaKeyIssuance` using a unique key and a patch. */
  updateAreaKeyIssuance?: Maybe<UpdateAreaKeyIssuancePayload>;
  /** Updates a single `AreaKeyIssuanceNote` using a unique key and a patch. */
  updateAreaKeyIssuanceNote?: Maybe<UpdateAreaKeyIssuanceNotePayload>;
  /** Updates a single `AreaNameExtra` using a unique key and a patch. */
  updateAreaNameExtra?: Maybe<UpdateAreaNameExtraPayload>;
  /** Updates a single `AreaNameKeyCad` using a unique key and a patch. */
  updateAreaNameKeyCad?: Maybe<UpdateAreaNameKeyCadPayload>;
  /** Updates a single `AreaNameKeyCafm` using a unique key and a patch. */
  updateAreaNameKeyCafm?: Maybe<UpdateAreaNameKeyCafmPayload>;
  /** Updates a single `AreaNameKeyEbm` using a unique key and a patch. */
  updateAreaNameKeyEbm?: Maybe<UpdateAreaNameKeyEbmPayload>;
  /** Updates a single `AreaNameKeyMarketing` using a unique key and a patch. */
  updateAreaNameKeyMarketing?: Maybe<UpdateAreaNameKeyMarketingPayload>;
  /** Updates a single `AreaNameLong` using a unique key and a patch. */
  updateAreaNameLong?: Maybe<UpdateAreaNameLongPayload>;
  /** Updates a single `AreaNameShort` using a unique key and a patch. */
  updateAreaNameShort?: Maybe<UpdateAreaNameShortPayload>;
  /** Updates a single `AreaPublicGrossSpace` using a unique key and a patch. */
  updateAreaPublicGrossSpace?: Maybe<UpdateAreaPublicGrossSpacePayload>;
  /** Updates a single `AreaType` using a unique key and a patch. */
  updateAreaType?: Maybe<UpdateAreaTypePayload>;
  /** Updates a single `AreaTypeAttr` using a unique key and a patch. */
  updateAreaTypeAttr?: Maybe<UpdateAreaTypeAttrPayload>;
  /** Updates a single `AreaType` using a unique key and a patch. */
  updateAreaTypeByName?: Maybe<UpdateAreaTypePayload>;
  /** Updates a single `Building` using a unique key and a patch. */
  updateBuilding?: Maybe<UpdateBuildingPayload>;
  /** Updates a single `Building` using a unique key and a patch. */
  updateBuildingByExtId?: Maybe<UpdateBuildingPayload>;
  /** Updates a single `Building` using a unique key and a patch. */
  updateBuildingByIdAndSiteId?: Maybe<UpdateBuildingPayload>;
  /** Updates a single `Building` using a unique key and a patch. */
  updateBuildingByNameShort?: Maybe<UpdateBuildingPayload>;
  /** Updates a single `BuildingDescription` using a unique key and a patch. */
  updateBuildingDescription?: Maybe<UpdateBuildingDescriptionPayload>;
  /** Updates a single `BuildingNameExtra` using a unique key and a patch. */
  updateBuildingNameExtra?: Maybe<UpdateBuildingNameExtraPayload>;
  /** Updates a single `BuildingNameKeyCad` using a unique key and a patch. */
  updateBuildingNameKeyCad?: Maybe<UpdateBuildingNameKeyCadPayload>;
  /** Updates a single `BuildingNameKeyCafm` using a unique key and a patch. */
  updateBuildingNameKeyCafm?: Maybe<UpdateBuildingNameKeyCafmPayload>;
  /** Updates a single `BuildingNameKeyEbm` using a unique key and a patch. */
  updateBuildingNameKeyEbm?: Maybe<UpdateBuildingNameKeyEbmPayload>;
  /** Updates a single `BuildingNameKeyMarketing` using a unique key and a patch. */
  updateBuildingNameKeyMarketing?: Maybe<UpdateBuildingNameKeyMarketingPayload>;
  /** Updates a single `BuildingNameLong` using a unique key and a patch. */
  updateBuildingNameLong?: Maybe<UpdateBuildingNameLongPayload>;
  /** Updates a single `BuildingNameShort` using a unique key and a patch. */
  updateBuildingNameShort?: Maybe<UpdateBuildingNameShortPayload>;
  /** Updates a single `BuildingPublicGrossSpace` using a unique key and a patch. */
  updateBuildingPublicGrossSpace?: Maybe<UpdateBuildingPublicGrossSpacePayload>;
  /** Updates a single `BuildingType` using a unique key and a patch. */
  updateBuildingType?: Maybe<UpdateBuildingTypePayload>;
  /** Updates a single `BuildingTypeAttr` using a unique key and a patch. */
  updateBuildingTypeAttr?: Maybe<UpdateBuildingTypeAttrPayload>;
  /** Updates a single `BuildingType` using a unique key and a patch. */
  updateBuildingTypeByName?: Maybe<UpdateBuildingTypePayload>;
  /** Updates a single `ElevationLevel` using a unique key and a patch. */
  updateElevationLevel?: Maybe<UpdateElevationLevelPayload>;
  /** Updates a single `ElevationLevel` using a unique key and a patch. */
  updateElevationLevelByValue?: Maybe<UpdateElevationLevelPayload>;
  /** Updates a single `Event` using a unique key and a patch. */
  updateEvent?: Maybe<UpdateEventPayload>;
  /** Updates a single `Event` using a unique key and a patch. */
  updateEventByNameShort?: Maybe<UpdateEventPayload>;
  /** Updates a single `EventSeries` using a unique key and a patch. */
  updateEventSeries?: Maybe<UpdateEventSeriesPayload>;
  /** Updates a single `EventSeries` using a unique key and a patch. */
  updateEventSeriesByNameShort?: Maybe<UpdateEventSeriesPayload>;
  /** Updates a single `EventVariant` using a unique key and a patch. */
  updateEventVariant?: Maybe<UpdateEventVariantPayload>;
  /** Updates a single `EventVariant` using a unique key and a patch. */
  updateEventVariantByEventIdAndIndex?: Maybe<UpdateEventVariantPayload>;
  /** Updates a single `ExternalEvent` using a unique key and a patch. */
  updateExternalEvent?: Maybe<UpdateExternalEventPayload>;
  /** Updates a single `ExternalEventAllocation` using a unique key and a patch. */
  updateExternalEventAllocation?: Maybe<UpdateExternalEventAllocationPayload>;
  /** Updates a single `ExternalEventAllocationPhase` using a unique key and a patch. */
  updateExternalEventAllocationPhase?: Maybe<UpdateExternalEventAllocationPhasePayload>;
  /** Updates a single `ExternalEventAllocationUsage` using a unique key and a patch. */
  updateExternalEventAllocationUsage?: Maybe<UpdateExternalEventAllocationUsagePayload>;
  /** Updates a single `ExternalEventAllocationUsage` using a unique key and a patch. */
  updateExternalEventAllocationUsageByName?: Maybe<UpdateExternalEventAllocationUsagePayload>;
  /** Updates a single `ExternalEventAllocationUsage` using a unique key and a patch. */
  updateExternalEventAllocationUsageByNameShort?: Maybe<UpdateExternalEventAllocationUsagePayload>;
  /** Updates a single `ExternalEventAllocationUsage` using a unique key and a patch. */
  updateExternalEventAllocationUsageByPosition?: Maybe<UpdateExternalEventAllocationUsagePayload>;
  /** Updates a single `ExternalEventAllocationUsage` using a unique key and a patch. */
  updateExternalEventAllocationUsageByType?: Maybe<UpdateExternalEventAllocationUsagePayload>;
  /** Updates a single `ExternalEvent` using a unique key and a patch. */
  updateExternalEventByNameShort?: Maybe<UpdateExternalEventPayload>;
  /** Updates a single `ExternalEventEventLocationVisibility` using a unique key and a patch. */
  updateExternalEventEventLocationVisibility?: Maybe<UpdateExternalEventEventLocationVisibilityPayload>;
  /** Updates a single `ExternalEventEventLocationVisibility` using a unique key and a patch. */
  updateExternalEventEventLocationVisibilityByEventIdAndLocationId?: Maybe<UpdateExternalEventEventLocationVisibilityPayload>;
  /** Updates a single `ExternalEventLocation` using a unique key and a patch. */
  updateExternalEventLocation?: Maybe<UpdateExternalEventLocationPayload>;
  /** Updates a single `ExternalEventLocation` using a unique key and a patch. */
  updateExternalEventLocationByName?: Maybe<UpdateExternalEventLocationPayload>;
  /** Updates a single `ExternalEventSeries` using a unique key and a patch. */
  updateExternalEventSeries?: Maybe<UpdateExternalEventSeriesPayload>;
  /** Updates a single `ExternalEventSeries` using a unique key and a patch. */
  updateExternalEventSeriesByNameShort?: Maybe<UpdateExternalEventSeriesPayload>;
  /** Updates a single `ExternalEventVariant` using a unique key and a patch. */
  updateExternalEventVariant?: Maybe<UpdateExternalEventVariantPayload>;
  /** Updates a single `ExternalEventVariant` using a unique key and a patch. */
  updateExternalEventVariantByEventIdAndIndex?: Maybe<UpdateExternalEventVariantPayload>;
  /** Updates a single `Feed` using a unique key and a patch. */
  updateFeed?: Maybe<UpdateFeedPayload>;
  /** Updates a single `FeedEntry` using a unique key and a patch. */
  updateFeedEntry?: Maybe<UpdateFeedEntryPayload>;
  /** Updates a single `Level` using a unique key and a patch. */
  updateLevel?: Maybe<UpdateLevelPayload>;
  /** Updates a single `Level` using a unique key and a patch. */
  updateLevelByExtId?: Maybe<UpdateLevelPayload>;
  /** Updates a single `Level` using a unique key and a patch. */
  updateLevelByNameShort?: Maybe<UpdateLevelPayload>;
  /** Updates a single `LevelCapacityPax` using a unique key and a patch. */
  updateLevelCapacityPax?: Maybe<UpdateLevelCapacityPaxPayload>;
  /** Updates a single `LevelDescription` using a unique key and a patch. */
  updateLevelDescription?: Maybe<UpdateLevelDescriptionPayload>;
  /** Updates a single `LevelFkmGrossSpace` using a unique key and a patch. */
  updateLevelFkmGrossSpace?: Maybe<UpdateLevelFkmGrossSpacePayload>;
  /** Updates a single `LevelNameExtra` using a unique key and a patch. */
  updateLevelNameExtra?: Maybe<UpdateLevelNameExtraPayload>;
  /** Updates a single `LevelNameKeyCad` using a unique key and a patch. */
  updateLevelNameKeyCad?: Maybe<UpdateLevelNameKeyCadPayload>;
  /** Updates a single `LevelNameKeyCafm` using a unique key and a patch. */
  updateLevelNameKeyCafm?: Maybe<UpdateLevelNameKeyCafmPayload>;
  /** Updates a single `LevelNameKeyEbm` using a unique key and a patch. */
  updateLevelNameKeyEbm?: Maybe<UpdateLevelNameKeyEbmPayload>;
  /** Updates a single `LevelNameKeyMarketing` using a unique key and a patch. */
  updateLevelNameKeyMarketing?: Maybe<UpdateLevelNameKeyMarketingPayload>;
  /** Updates a single `LevelNameLong` using a unique key and a patch. */
  updateLevelNameLong?: Maybe<UpdateLevelNameLongPayload>;
  /** Updates a single `LevelNameShort` using a unique key and a patch. */
  updateLevelNameShort?: Maybe<UpdateLevelNameShortPayload>;
  /** Updates a single `LevelPublicGrossSpace` using a unique key and a patch. */
  updateLevelPublicGrossSpace?: Maybe<UpdateLevelPublicGrossSpacePayload>;
  /** Updates a single `LevelType` using a unique key and a patch. */
  updateLevelType?: Maybe<UpdateLevelTypePayload>;
  /** Updates a single `LevelTypeAttr` using a unique key and a patch. */
  updateLevelTypeAttr?: Maybe<UpdateLevelTypeAttrPayload>;
  /** Updates a single `LevelType` using a unique key and a patch. */
  updateLevelTypeByName?: Maybe<UpdateLevelTypePayload>;
  /** Updates a single `Link` using a unique key and a patch. */
  updateLink?: Maybe<UpdateLinkPayload>;
  /** Updates a single `Multilink` using a unique key and a patch. */
  updateMultilink?: Maybe<UpdateMultilinkPayload>;
  updatePassword: UpdatePasswordResponse;
  /** Updates a single `Plot` using a unique key and a patch. */
  updatePlot?: Maybe<UpdatePlotPayload>;
  /** Updates a single `Plot` using a unique key and a patch. */
  updatePlotByExtId?: Maybe<UpdatePlotPayload>;
  /** Updates a single `Plot` using a unique key and a patch. */
  updatePlotByNameShort?: Maybe<UpdatePlotPayload>;
  /** Updates a single `PlotCadGrossSpaceMin` using a unique key and a patch. */
  updatePlotCadGrossSpaceMin?: Maybe<UpdatePlotCadGrossSpaceMinPayload>;
  /** Updates a single `PlotDescription` using a unique key and a patch. */
  updatePlotDescription?: Maybe<UpdatePlotDescriptionPayload>;
  /** Updates a single `PlotNameExtra` using a unique key and a patch. */
  updatePlotNameExtra?: Maybe<UpdatePlotNameExtraPayload>;
  /** Updates a single `PlotNameKeyCad` using a unique key and a patch. */
  updatePlotNameKeyCad?: Maybe<UpdatePlotNameKeyCadPayload>;
  /** Updates a single `PlotNameKeyCafm` using a unique key and a patch. */
  updatePlotNameKeyCafm?: Maybe<UpdatePlotNameKeyCafmPayload>;
  /** Updates a single `PlotNameKeyEbm` using a unique key and a patch. */
  updatePlotNameKeyEbm?: Maybe<UpdatePlotNameKeyEbmPayload>;
  /** Updates a single `PlotNameKeyMarketing` using a unique key and a patch. */
  updatePlotNameKeyMarketing?: Maybe<UpdatePlotNameKeyMarketingPayload>;
  /** Updates a single `PlotNameLong` using a unique key and a patch. */
  updatePlotNameLong?: Maybe<UpdatePlotNameLongPayload>;
  /** Updates a single `PlotNameShort` using a unique key and a patch. */
  updatePlotNameShort?: Maybe<UpdatePlotNameShortPayload>;
  /** Updates a single `PlotPublicGrossSpace` using a unique key and a patch. */
  updatePlotPublicGrossSpace?: Maybe<UpdatePlotPublicGrossSpacePayload>;
  /** Updates a single `PlotType` using a unique key and a patch. */
  updatePlotType?: Maybe<UpdatePlotTypePayload>;
  /** Updates a single `PlotTypeAttr` using a unique key and a patch. */
  updatePlotTypeAttr?: Maybe<UpdatePlotTypeAttrPayload>;
  /** Updates a single `PlotType` using a unique key and a patch. */
  updatePlotTypeByName?: Maybe<UpdatePlotTypePayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Updates a single `ProjectAllocationArea` using a unique key and a patch. */
  updateProjectAllocationArea?: Maybe<UpdateProjectAllocationAreaPayload>;
  /** Updates a single `ProjectAllocationAreaPhase` using a unique key and a patch. */
  updateProjectAllocationAreaPhase?: Maybe<UpdateProjectAllocationAreaPhasePayload>;
  /** Updates a single `ProjectAllocationPlot` using a unique key and a patch. */
  updateProjectAllocationPlot?: Maybe<UpdateProjectAllocationPlotPayload>;
  /** Updates a single `ProjectAllocationPlotPhase` using a unique key and a patch. */
  updateProjectAllocationPlotPhase?: Maybe<UpdateProjectAllocationPlotPhasePayload>;
  /** Updates a single `ProjectAllocationRoom` using a unique key and a patch. */
  updateProjectAllocationRoom?: Maybe<UpdateProjectAllocationRoomPayload>;
  /** Updates a single `ProjectAllocationRoomPhase` using a unique key and a patch. */
  updateProjectAllocationRoomPhase?: Maybe<UpdateProjectAllocationRoomPhasePayload>;
  /** Updates a single `ProjectAllocationUsage` using a unique key and a patch. */
  updateProjectAllocationUsage?: Maybe<UpdateProjectAllocationUsagePayload>;
  /** Updates a single `ProjectAllocationUsage` using a unique key and a patch. */
  updateProjectAllocationUsageByName?: Maybe<UpdateProjectAllocationUsagePayload>;
  /** Updates a single `ProjectAllocationUsage` using a unique key and a patch. */
  updateProjectAllocationUsageByNameShort?: Maybe<UpdateProjectAllocationUsagePayload>;
  /** Updates a single `ProjectAllocationUsage` using a unique key and a patch. */
  updateProjectAllocationUsageByPosition?: Maybe<UpdateProjectAllocationUsagePayload>;
  /** Updates a single `ProjectAllocationUsage` using a unique key and a patch. */
  updateProjectAllocationUsageByType?: Maybe<UpdateProjectAllocationUsagePayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProjectByNameShort?: Maybe<UpdateProjectPayload>;
  /** Updates a single `ProjectSeries` using a unique key and a patch. */
  updateProjectSeries?: Maybe<UpdateProjectSeriesPayload>;
  /** Updates a single `ProjectSeries` using a unique key and a patch. */
  updateProjectSeriesByNameShort?: Maybe<UpdateProjectSeriesPayload>;
  /** Updates a single `ProjectVariant` using a unique key and a patch. */
  updateProjectVariant?: Maybe<UpdateProjectVariantPayload>;
  /** Updates a single `ProjectVariant` using a unique key and a patch. */
  updateProjectVariantByProjectIdAndIndex?: Maybe<UpdateProjectVariantPayload>;
  /** Updates a single `Room` using a unique key and a patch. */
  updateRoom?: Maybe<UpdateRoomPayload>;
  /** Updates a single `RoomAirChangeRate` using a unique key and a patch. */
  updateRoomAirChangeRate?: Maybe<UpdateRoomAirChangeRatePayload>;
  /** Updates a single `RoomAirConditioning` using a unique key and a patch. */
  updateRoomAirConditioning?: Maybe<UpdateRoomAirConditioningPayload>;
  /** Updates a single `Room` using a unique key and a patch. */
  updateRoomByExtId?: Maybe<UpdateRoomPayload>;
  /** Updates a single `Room` using a unique key and a patch. */
  updateRoomByNameShort?: Maybe<UpdateRoomPayload>;
  /** Updates a single `RoomCadGrossSpaceMin` using a unique key and a patch. */
  updateRoomCadGrossSpaceMin?: Maybe<UpdateRoomCadGrossSpaceMinPayload>;
  /** Updates a single `RoomCadHeightMax` using a unique key and a patch. */
  updateRoomCadHeightMax?: Maybe<UpdateRoomCadHeightMaxPayload>;
  /** Updates a single `RoomCadHeightMin` using a unique key and a patch. */
  updateRoomCadHeightMin?: Maybe<UpdateRoomCadHeightMinPayload>;
  /** Updates a single `RoomCadLengthMax` using a unique key and a patch. */
  updateRoomCadLengthMax?: Maybe<UpdateRoomCadLengthMaxPayload>;
  /** Updates a single `RoomCadLengthMin` using a unique key and a patch. */
  updateRoomCadLengthMin?: Maybe<UpdateRoomCadLengthMinPayload>;
  /** Updates a single `RoomCadWidthMax` using a unique key and a patch. */
  updateRoomCadWidthMax?: Maybe<UpdateRoomCadWidthMaxPayload>;
  /** Updates a single `RoomCadWidthMin` using a unique key and a patch. */
  updateRoomCadWidthMin?: Maybe<UpdateRoomCadWidthMinPayload>;
  /** Updates a single `RoomCapacityCar` using a unique key and a patch. */
  updateRoomCapacityCar?: Maybe<UpdateRoomCapacityCarPayload>;
  /** Updates a single `RoomCapacityPax` using a unique key and a patch. */
  updateRoomCapacityPax?: Maybe<UpdateRoomCapacityPaxPayload>;
  /** Updates a single `RoomCapacityTruck` using a unique key and a patch. */
  updateRoomCapacityTruck?: Maybe<UpdateRoomCapacityTruckPayload>;
  /** Updates a single `RoomCleaningGrossSpace` using a unique key and a patch. */
  updateRoomCleaningGrossSpace?: Maybe<UpdateRoomCleaningGrossSpacePayload>;
  /** Updates a single `RoomClearanceConstruction` using a unique key and a patch. */
  updateRoomClearanceConstruction?: Maybe<UpdateRoomClearanceConstructionPayload>;
  /** Updates a single `RoomContactBooking` using a unique key and a patch. */
  updateRoomContactBooking?: Maybe<UpdateRoomContactBookingPayload>;
  /** Updates a single `RoomDaylight` using a unique key and a patch. */
  updateRoomDaylight?: Maybe<UpdateRoomDaylightPayload>;
  /** Updates a single `RoomDescription` using a unique key and a patch. */
  updateRoomDescription?: Maybe<UpdateRoomDescriptionPayload>;
  /** Updates a single `RoomKeyIssuance` using a unique key and a patch. */
  updateRoomKeyIssuance?: Maybe<UpdateRoomKeyIssuancePayload>;
  /** Updates a single `RoomKeyIssuanceNote` using a unique key and a patch. */
  updateRoomKeyIssuanceNote?: Maybe<UpdateRoomKeyIssuanceNotePayload>;
  /** Updates a single `RoomLightShutter` using a unique key and a patch. */
  updateRoomLightShutter?: Maybe<UpdateRoomLightShutterPayload>;
  /** Updates a single `RoomMaxLoadCeiling` using a unique key and a patch. */
  updateRoomMaxLoadCeiling?: Maybe<UpdateRoomMaxLoadCeilingPayload>;
  /** Updates a single `RoomMaxLoadFloor` using a unique key and a patch. */
  updateRoomMaxLoadFloor?: Maybe<UpdateRoomMaxLoadFloorPayload>;
  /** Updates a single `RoomNameExtra` using a unique key and a patch. */
  updateRoomNameExtra?: Maybe<UpdateRoomNameExtraPayload>;
  /** Updates a single `RoomNameKeyCad` using a unique key and a patch. */
  updateRoomNameKeyCad?: Maybe<UpdateRoomNameKeyCadPayload>;
  /** Updates a single `RoomNameKeyCafm` using a unique key and a patch. */
  updateRoomNameKeyCafm?: Maybe<UpdateRoomNameKeyCafmPayload>;
  /** Updates a single `RoomNameKeyEbm` using a unique key and a patch. */
  updateRoomNameKeyEbm?: Maybe<UpdateRoomNameKeyEbmPayload>;
  /** Updates a single `RoomNameKeyMarketing` using a unique key and a patch. */
  updateRoomNameKeyMarketing?: Maybe<UpdateRoomNameKeyMarketingPayload>;
  /** Updates a single `RoomNameLong` using a unique key and a patch. */
  updateRoomNameLong?: Maybe<UpdateRoomNameLongPayload>;
  /** Updates a single `RoomNameShort` using a unique key and a patch. */
  updateRoomNameShort?: Maybe<UpdateRoomNameShortPayload>;
  /** Updates a single `RoomNoVehicle` using a unique key and a patch. */
  updateRoomNoVehicle?: Maybe<UpdateRoomNoVehiclePayload>;
  /** Updates a single `RoomPartition` using a unique key and a patch. */
  updateRoomPartition?: Maybe<UpdateRoomPartitionPayload>;
  /** Updates a single `RoomPartition` using a unique key and a patch. */
  updateRoomPartitionByExtId?: Maybe<UpdateRoomPartitionPayload>;
  /** Updates a single `RoomPartition` using a unique key and a patch. */
  updateRoomPartitionByNameShort?: Maybe<UpdateRoomPartitionPayload>;
  /** Updates a single `RoomPartitionCadGrossSpaceMin` using a unique key and a patch. */
  updateRoomPartitionCadGrossSpaceMin?: Maybe<UpdateRoomPartitionCadGrossSpaceMinPayload>;
  /** Updates a single `RoomPartitionCadHeightMax` using a unique key and a patch. */
  updateRoomPartitionCadHeightMax?: Maybe<UpdateRoomPartitionCadHeightMaxPayload>;
  /** Updates a single `RoomPartitionCadHeightMin` using a unique key and a patch. */
  updateRoomPartitionCadHeightMin?: Maybe<UpdateRoomPartitionCadHeightMinPayload>;
  /** Updates a single `RoomPartitionCadLengthMax` using a unique key and a patch. */
  updateRoomPartitionCadLengthMax?: Maybe<UpdateRoomPartitionCadLengthMaxPayload>;
  /** Updates a single `RoomPartitionCadLengthMin` using a unique key and a patch. */
  updateRoomPartitionCadLengthMin?: Maybe<UpdateRoomPartitionCadLengthMinPayload>;
  /** Updates a single `RoomPartitionCadWidthMax` using a unique key and a patch. */
  updateRoomPartitionCadWidthMax?: Maybe<UpdateRoomPartitionCadWidthMaxPayload>;
  /** Updates a single `RoomPartitionCadWidthMin` using a unique key and a patch. */
  updateRoomPartitionCadWidthMin?: Maybe<UpdateRoomPartitionCadWidthMinPayload>;
  /** Updates a single `RoomPartitionCapacityPax` using a unique key and a patch. */
  updateRoomPartitionCapacityPax?: Maybe<UpdateRoomPartitionCapacityPaxPayload>;
  /** Updates a single `RoomPartitionCleaningGrossSpace` using a unique key and a patch. */
  updateRoomPartitionCleaningGrossSpace?: Maybe<UpdateRoomPartitionCleaningGrossSpacePayload>;
  /** Updates a single `RoomPartitionDescription` using a unique key and a patch. */
  updateRoomPartitionDescription?: Maybe<UpdateRoomPartitionDescriptionPayload>;
  /** Updates a single `RoomPartitionNameExtra` using a unique key and a patch. */
  updateRoomPartitionNameExtra?: Maybe<UpdateRoomPartitionNameExtraPayload>;
  /** Updates a single `RoomPartitionNameKeyCad` using a unique key and a patch. */
  updateRoomPartitionNameKeyCad?: Maybe<UpdateRoomPartitionNameKeyCadPayload>;
  /** Updates a single `RoomPartitionNameKeyCafm` using a unique key and a patch. */
  updateRoomPartitionNameKeyCafm?: Maybe<UpdateRoomPartitionNameKeyCafmPayload>;
  /** Updates a single `RoomPartitionNameKeyEbm` using a unique key and a patch. */
  updateRoomPartitionNameKeyEbm?: Maybe<UpdateRoomPartitionNameKeyEbmPayload>;
  /** Updates a single `RoomPartitionNameKeyMarketing` using a unique key and a patch. */
  updateRoomPartitionNameKeyMarketing?: Maybe<UpdateRoomPartitionNameKeyMarketingPayload>;
  /** Updates a single `RoomPartitionNameLong` using a unique key and a patch. */
  updateRoomPartitionNameLong?: Maybe<UpdateRoomPartitionNameLongPayload>;
  /** Updates a single `RoomPartitionNameShort` using a unique key and a patch. */
  updateRoomPartitionNameShort?: Maybe<UpdateRoomPartitionNameShortPayload>;
  /** Updates a single `RoomPartitionPublicGrossSpace` using a unique key and a patch. */
  updateRoomPartitionPublicGrossSpace?: Maybe<UpdateRoomPartitionPublicGrossSpacePayload>;
  /** Updates a single `RoomPartitionSbvGrossSpace` using a unique key and a patch. */
  updateRoomPartitionSbvGrossSpace?: Maybe<UpdateRoomPartitionSbvGrossSpacePayload>;
  /** Updates a single `RoomPartitionType` using a unique key and a patch. */
  updateRoomPartitionType?: Maybe<UpdateRoomPartitionTypePayload>;
  /** Updates a single `RoomPartitionTypeAttr` using a unique key and a patch. */
  updateRoomPartitionTypeAttr?: Maybe<UpdateRoomPartitionTypeAttrPayload>;
  /** Updates a single `RoomPartitionType` using a unique key and a patch. */
  updateRoomPartitionTypeByName?: Maybe<UpdateRoomPartitionTypePayload>;
  /** Updates a single `RoomPhoneNumber` using a unique key and a patch. */
  updateRoomPhoneNumber?: Maybe<UpdateRoomPhoneNumberPayload>;
  /** Updates a single `RoomPublicGrossSpace` using a unique key and a patch. */
  updateRoomPublicGrossSpace?: Maybe<UpdateRoomPublicGrossSpacePayload>;
  /** Updates a single `RoomSbvGrossSpace` using a unique key and a patch. */
  updateRoomSbvGrossSpace?: Maybe<UpdateRoomSbvGrossSpacePayload>;
  /** Updates a single `RoomTireLoadCar` using a unique key and a patch. */
  updateRoomTireLoadCar?: Maybe<UpdateRoomTireLoadCarPayload>;
  /** Updates a single `RoomTireLoadForklift` using a unique key and a patch. */
  updateRoomTireLoadForklift?: Maybe<UpdateRoomTireLoadForkliftPayload>;
  /** Updates a single `RoomTireLoadTruck` using a unique key and a patch. */
  updateRoomTireLoadTruck?: Maybe<UpdateRoomTireLoadTruckPayload>;
  /** Updates a single `RoomType` using a unique key and a patch. */
  updateRoomType?: Maybe<UpdateRoomTypePayload>;
  /** Updates a single `RoomTypeAttr` using a unique key and a patch. */
  updateRoomTypeAttr?: Maybe<UpdateRoomTypeAttrPayload>;
  /** Updates a single `RoomType` using a unique key and a patch. */
  updateRoomTypeByName?: Maybe<UpdateRoomTypePayload>;
  /** Updates a single `Scenario` using a unique key and a patch. */
  updateScenario?: Maybe<UpdateScenarioPayload>;
  /** Updates a single `Scenario` using a unique key and a patch. */
  updateScenarioByNameShort?: Maybe<UpdateScenarioPayload>;
  /** Updates a single `ScenarioGroup` using a unique key and a patch. */
  updateScenarioGroup?: Maybe<UpdateScenarioGroupPayload>;
  /** Updates a single `ScenarioGroup` using a unique key and a patch. */
  updateScenarioGroupByNameShort?: Maybe<UpdateScenarioGroupPayload>;
  /** Updates a single `ScenarioSetting` using a unique key and a patch. */
  updateScenarioSetting?: Maybe<UpdateScenarioSettingPayload>;
  /** Updates a single `ScenarioVariantVisibility` using a unique key and a patch. */
  updateScenarioVariantVisibility?: Maybe<UpdateScenarioVariantVisibilityPayload>;
  /** Updates a single `ScenarioVariantVisibility` using a unique key and a patch. */
  updateScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantType?: Maybe<UpdateScenarioVariantVisibilityPayload>;
  /** Updates a single `Site` using a unique key and a patch. */
  updateSite?: Maybe<UpdateSitePayload>;
  /** Updates a single `Site` using a unique key and a patch. */
  updateSiteByExtId?: Maybe<UpdateSitePayload>;
  /** Updates a single `Site` using a unique key and a patch. */
  updateSiteByNameShort?: Maybe<UpdateSitePayload>;
  /** Updates a single `SiteDescription` using a unique key and a patch. */
  updateSiteDescription?: Maybe<UpdateSiteDescriptionPayload>;
  /** Updates a single `SiteNameExtra` using a unique key and a patch. */
  updateSiteNameExtra?: Maybe<UpdateSiteNameExtraPayload>;
  /** Updates a single `SiteNameKeyCad` using a unique key and a patch. */
  updateSiteNameKeyCad?: Maybe<UpdateSiteNameKeyCadPayload>;
  /** Updates a single `SiteNameKeyCafm` using a unique key and a patch. */
  updateSiteNameKeyCafm?: Maybe<UpdateSiteNameKeyCafmPayload>;
  /** Updates a single `SiteNameKeyEbm` using a unique key and a patch. */
  updateSiteNameKeyEbm?: Maybe<UpdateSiteNameKeyEbmPayload>;
  /** Updates a single `SiteNameKeyMarketing` using a unique key and a patch. */
  updateSiteNameKeyMarketing?: Maybe<UpdateSiteNameKeyMarketingPayload>;
  /** Updates a single `SiteNameLong` using a unique key and a patch. */
  updateSiteNameLong?: Maybe<UpdateSiteNameLongPayload>;
  /** Updates a single `SiteNameShort` using a unique key and a patch. */
  updateSiteNameShort?: Maybe<UpdateSiteNameShortPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserPasswordLogin` using a unique key and a patch. */
  updateUserPasswordLogin?: Maybe<UpdateUserPasswordLoginPayload>;
  /** Updates a single `UserPasswordLogin` using a unique key and a patch. */
  updateUserPasswordLoginByEmail?: Maybe<UpdateUserPasswordLoginPayload>;
  /** Updates a single `UserPasswordLogin` using a unique key and a patch. */
  updateUserPasswordLoginByUserId?: Maybe<UpdateUserPasswordLoginPayload>;
  /** Updates a single `UserSsoLogin` using a unique key and a patch. */
  updateUserSsoLogin?: Maybe<UpdateUserSsoLoginPayload>;
  /** Updates a single `UserSsoLogin` using a unique key and a patch. */
  updateUserSsoLoginByProviderAndOid?: Maybe<UpdateUserSsoLoginPayload>;
  /** Updates a single `UserSsoLogin` using a unique key and a patch. */
  updateUserSsoLoginByUserIdAndProvider?: Maybe<UpdateUserSsoLoginPayload>;
  /** Updates a single `Zone` using a unique key and a patch. */
  updateZone?: Maybe<UpdateZonePayload>;
  /** Updates a single `Zone` using a unique key and a patch. */
  updateZoneByExtId?: Maybe<UpdateZonePayload>;
  /** Updates a single `Zone` using a unique key and a patch. */
  updateZoneByNameShort?: Maybe<UpdateZonePayload>;
  /** Updates a single `ZoneCadGrossSpaceMin` using a unique key and a patch. */
  updateZoneCadGrossSpaceMin?: Maybe<UpdateZoneCadGrossSpaceMinPayload>;
  /** Updates a single `ZoneCapacityCar` using a unique key and a patch. */
  updateZoneCapacityCar?: Maybe<UpdateZoneCapacityCarPayload>;
  /** Updates a single `ZoneCapacityTruck` using a unique key and a patch. */
  updateZoneCapacityTruck?: Maybe<UpdateZoneCapacityTruckPayload>;
  /** Updates a single `ZoneDescription` using a unique key and a patch. */
  updateZoneDescription?: Maybe<UpdateZoneDescriptionPayload>;
  /** Updates a single `ZoneMaxLoadFloor` using a unique key and a patch. */
  updateZoneMaxLoadFloor?: Maybe<UpdateZoneMaxLoadFloorPayload>;
  /** Updates a single `ZoneNameExtra` using a unique key and a patch. */
  updateZoneNameExtra?: Maybe<UpdateZoneNameExtraPayload>;
  /** Updates a single `ZoneNameKeyCad` using a unique key and a patch. */
  updateZoneNameKeyCad?: Maybe<UpdateZoneNameKeyCadPayload>;
  /** Updates a single `ZoneNameKeyCafm` using a unique key and a patch. */
  updateZoneNameKeyCafm?: Maybe<UpdateZoneNameKeyCafmPayload>;
  /** Updates a single `ZoneNameKeyEbm` using a unique key and a patch. */
  updateZoneNameKeyEbm?: Maybe<UpdateZoneNameKeyEbmPayload>;
  /** Updates a single `ZoneNameKeyMarketing` using a unique key and a patch. */
  updateZoneNameKeyMarketing?: Maybe<UpdateZoneNameKeyMarketingPayload>;
  /** Updates a single `ZoneNameLong` using a unique key and a patch. */
  updateZoneNameLong?: Maybe<UpdateZoneNameLongPayload>;
  /** Updates a single `ZoneNameShort` using a unique key and a patch. */
  updateZoneNameShort?: Maybe<UpdateZoneNameShortPayload>;
  /** Updates a single `ZoneNoVehicle` using a unique key and a patch. */
  updateZoneNoVehicle?: Maybe<UpdateZoneNoVehiclePayload>;
  /** Updates a single `ZonePublicGrossSpace` using a unique key and a patch. */
  updateZonePublicGrossSpace?: Maybe<UpdateZonePublicGrossSpacePayload>;
  /** Updates a single `ZoneTireLoadCar` using a unique key and a patch. */
  updateZoneTireLoadCar?: Maybe<UpdateZoneTireLoadCarPayload>;
  /** Updates a single `ZoneTireLoadForklift` using a unique key and a patch. */
  updateZoneTireLoadForklift?: Maybe<UpdateZoneTireLoadForkliftPayload>;
  /** Updates a single `ZoneTireLoadTruck` using a unique key and a patch. */
  updateZoneTireLoadTruck?: Maybe<UpdateZoneTireLoadTruckPayload>;
  /** Updates a single `ZoneType` using a unique key and a patch. */
  updateZoneType?: Maybe<UpdateZoneTypePayload>;
  /** Updates a single `ZoneTypeAttr` using a unique key and a patch. */
  updateZoneTypeAttr?: Maybe<UpdateZoneTypeAttrPayload>;
  /** Updates a single `ZoneType` using a unique key and a patch. */
  updateZoneTypeByName?: Maybe<UpdateZoneTypePayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationActivateEntraUserArgs = {
  company?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  position?: InputMaybe<Scalars['String']>;
  provider: SsoProvider;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationActivateSsoLoginArgs = {
  oid: Scalars['String'];
  provider: SsoProvider;
  userId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAllocationAreaDuplicateArgs = {
  input: AllocationAreaDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAllocationAreaUpdateAndDuplicateArgs = {
  input: AllocationAreaUpdateAndDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAllocationRoomDuplicateArgs = {
  input: AllocationRoomDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAllocationRoomUpdateAndDuplicateArgs = {
  input: AllocationRoomUpdateAndDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyEventVariantAllocationsArgs = {
  input: CopyEventVariantAllocationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyExternalEventVariantAllocationsArgs = {
  input: CopyExternalEventVariantAllocationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyProjectVariantAllocationsArgs = {
  input: CopyProjectVariantAllocationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationAreaArgs = {
  input: CreateAllocationAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationAreaPhaseArgs = {
  input: CreateAllocationAreaPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationPlotArgs = {
  input: CreateAllocationPlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationPlotPhaseArgs = {
  input: CreateAllocationPlotPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationRoomArgs = {
  input: CreateAllocationRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationRoomPhaseArgs = {
  input: CreateAllocationRoomPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAllocationUsageArgs = {
  input: CreateAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaArgs = {
  input: CreateAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaCadGrossSpaceMinArgs = {
  input: CreateAreaCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaClearanceConstructionArgs = {
  input: CreateAreaClearanceConstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaContactBookingArgs = {
  input: CreateAreaContactBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaDescriptionArgs = {
  input: CreateAreaDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaKeyIssuanceArgs = {
  input: CreateAreaKeyIssuanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaKeyIssuanceNoteArgs = {
  input: CreateAreaKeyIssuanceNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameExtraArgs = {
  input: CreateAreaNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameKeyCadArgs = {
  input: CreateAreaNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameKeyCafmArgs = {
  input: CreateAreaNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameKeyEbmArgs = {
  input: CreateAreaNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameKeyMarketingArgs = {
  input: CreateAreaNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameLongArgs = {
  input: CreateAreaNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaNameShortArgs = {
  input: CreateAreaNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaPublicGrossSpaceArgs = {
  input: CreateAreaPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaTypeArgs = {
  input: CreateAreaTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAreaTypeAttrArgs = {
  input: CreateAreaTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingArgs = {
  input: CreateBuildingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingDescriptionArgs = {
  input: CreateBuildingDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameExtraArgs = {
  input: CreateBuildingNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameKeyCadArgs = {
  input: CreateBuildingNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameKeyCafmArgs = {
  input: CreateBuildingNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameKeyEbmArgs = {
  input: CreateBuildingNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameKeyMarketingArgs = {
  input: CreateBuildingNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameLongArgs = {
  input: CreateBuildingNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingNameShortArgs = {
  input: CreateBuildingNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingPublicGrossSpaceArgs = {
  input: CreateBuildingPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingTypeArgs = {
  input: CreateBuildingTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingTypeAttrArgs = {
  input: CreateBuildingTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateElevationLevelArgs = {
  input: CreateElevationLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventSeriesArgs = {
  input: CreateEventSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventVariantArgs = {
  input: CreateEventVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventVariantWithAllocationsFromArgs = {
  input: CreateEventVariantWithAllocationsFromInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventArgs = {
  input: CreateExternalEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventAllocationArgs = {
  input: CreateExternalEventAllocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventAllocationPhaseArgs = {
  input: CreateExternalEventAllocationPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventAllocationUsageArgs = {
  input: CreateExternalEventAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventEventLocationVisibilityArgs = {
  input: CreateExternalEventEventLocationVisibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventLocationArgs = {
  input: CreateExternalEventLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventSeriesArgs = {
  input: CreateExternalEventSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventVariantArgs = {
  input: CreateExternalEventVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalEventVariantWithAllocationsFromArgs = {
  input: CreateExternalEventVariantWithAllocationsFromInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeedArgs = {
  input: CreateFeedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeedEntryArgs = {
  input: CreateFeedEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelArgs = {
  input: CreateLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelCapacityPaxArgs = {
  input: CreateLevelCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelDescriptionArgs = {
  input: CreateLevelDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelFkmGrossSpaceArgs = {
  input: CreateLevelFkmGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameExtraArgs = {
  input: CreateLevelNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameKeyCadArgs = {
  input: CreateLevelNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameKeyCafmArgs = {
  input: CreateLevelNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameKeyEbmArgs = {
  input: CreateLevelNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameKeyMarketingArgs = {
  input: CreateLevelNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameLongArgs = {
  input: CreateLevelNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelNameShortArgs = {
  input: CreateLevelNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelPublicGrossSpaceArgs = {
  input: CreateLevelPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelTypeArgs = {
  input: CreateLevelTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLevelTypeAttrArgs = {
  input: CreateLevelTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLinkArgs = {
  input: CreateLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMultilinkArgs = {
  input: CreateMultilinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePasswordLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotArgs = {
  input: CreatePlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotCadGrossSpaceMinArgs = {
  input: CreatePlotCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotDescriptionArgs = {
  input: CreatePlotDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameExtraArgs = {
  input: CreatePlotNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameKeyCadArgs = {
  input: CreatePlotNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameKeyCafmArgs = {
  input: CreatePlotNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameKeyEbmArgs = {
  input: CreatePlotNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameKeyMarketingArgs = {
  input: CreatePlotNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameLongArgs = {
  input: CreatePlotNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotNameShortArgs = {
  input: CreatePlotNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotPublicGrossSpaceArgs = {
  input: CreatePlotPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotTypeArgs = {
  input: CreatePlotTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlotTypeAttrArgs = {
  input: CreatePlotTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationAreaArgs = {
  input: CreateProjectAllocationAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationAreaPhaseArgs = {
  input: CreateProjectAllocationAreaPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationPlotArgs = {
  input: CreateProjectAllocationPlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationPlotPhaseArgs = {
  input: CreateProjectAllocationPlotPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationRoomArgs = {
  input: CreateProjectAllocationRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationRoomPhaseArgs = {
  input: CreateProjectAllocationRoomPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectAllocationUsageArgs = {
  input: CreateProjectAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectSeriesArgs = {
  input: CreateProjectSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectVariantArgs = {
  input: CreateProjectVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectVariantWithAllocationsFromArgs = {
  input: CreateProjectVariantWithAllocationsFromInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomArgs = {
  input: CreateRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomAirChangeRateArgs = {
  input: CreateRoomAirChangeRateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomAirConditioningArgs = {
  input: CreateRoomAirConditioningInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadGrossSpaceMinArgs = {
  input: CreateRoomCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadHeightMaxArgs = {
  input: CreateRoomCadHeightMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadHeightMinArgs = {
  input: CreateRoomCadHeightMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadLengthMaxArgs = {
  input: CreateRoomCadLengthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadLengthMinArgs = {
  input: CreateRoomCadLengthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadWidthMaxArgs = {
  input: CreateRoomCadWidthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCadWidthMinArgs = {
  input: CreateRoomCadWidthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCapacityCarArgs = {
  input: CreateRoomCapacityCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCapacityPaxArgs = {
  input: CreateRoomCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCapacityTruckArgs = {
  input: CreateRoomCapacityTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomCleaningGrossSpaceArgs = {
  input: CreateRoomCleaningGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomClearanceConstructionArgs = {
  input: CreateRoomClearanceConstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomContactBookingArgs = {
  input: CreateRoomContactBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomDaylightArgs = {
  input: CreateRoomDaylightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomDescriptionArgs = {
  input: CreateRoomDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomKeyIssuanceArgs = {
  input: CreateRoomKeyIssuanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomKeyIssuanceNoteArgs = {
  input: CreateRoomKeyIssuanceNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomLightShutterArgs = {
  input: CreateRoomLightShutterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomMaxLoadCeilingArgs = {
  input: CreateRoomMaxLoadCeilingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomMaxLoadFloorArgs = {
  input: CreateRoomMaxLoadFloorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameExtraArgs = {
  input: CreateRoomNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameKeyCadArgs = {
  input: CreateRoomNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameKeyCafmArgs = {
  input: CreateRoomNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameKeyEbmArgs = {
  input: CreateRoomNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameKeyMarketingArgs = {
  input: CreateRoomNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameLongArgs = {
  input: CreateRoomNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNameShortArgs = {
  input: CreateRoomNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomNoVehicleArgs = {
  input: CreateRoomNoVehicleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionArgs = {
  input: CreateRoomPartitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadGrossSpaceMinArgs = {
  input: CreateRoomPartitionCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadHeightMaxArgs = {
  input: CreateRoomPartitionCadHeightMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadHeightMinArgs = {
  input: CreateRoomPartitionCadHeightMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadLengthMaxArgs = {
  input: CreateRoomPartitionCadLengthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadLengthMinArgs = {
  input: CreateRoomPartitionCadLengthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadWidthMaxArgs = {
  input: CreateRoomPartitionCadWidthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCadWidthMinArgs = {
  input: CreateRoomPartitionCadWidthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCapacityPaxArgs = {
  input: CreateRoomPartitionCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionCleaningGrossSpaceArgs = {
  input: CreateRoomPartitionCleaningGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionDescriptionArgs = {
  input: CreateRoomPartitionDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameExtraArgs = {
  input: CreateRoomPartitionNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameKeyCadArgs = {
  input: CreateRoomPartitionNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameKeyCafmArgs = {
  input: CreateRoomPartitionNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameKeyEbmArgs = {
  input: CreateRoomPartitionNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameKeyMarketingArgs = {
  input: CreateRoomPartitionNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameLongArgs = {
  input: CreateRoomPartitionNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionNameShortArgs = {
  input: CreateRoomPartitionNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionPublicGrossSpaceArgs = {
  input: CreateRoomPartitionPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionSbvGrossSpaceArgs = {
  input: CreateRoomPartitionSbvGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionTypeArgs = {
  input: CreateRoomPartitionTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPartitionTypeAttrArgs = {
  input: CreateRoomPartitionTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPhoneNumberArgs = {
  input: CreateRoomPhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomPublicGrossSpaceArgs = {
  input: CreateRoomPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomSbvGrossSpaceArgs = {
  input: CreateRoomSbvGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomTireLoadCarArgs = {
  input: CreateRoomTireLoadCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomTireLoadForkliftArgs = {
  input: CreateRoomTireLoadForkliftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomTireLoadTruckArgs = {
  input: CreateRoomTireLoadTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomTypeArgs = {
  input: CreateRoomTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoomTypeAttrArgs = {
  input: CreateRoomTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScenarioGroupArgs = {
  input: CreateScenarioGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScenarioSettingArgs = {
  input: CreateScenarioSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScenarioVariantVisibilityArgs = {
  input: CreateScenarioVariantVisibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteArgs = {
  input: CreateSiteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteDescriptionArgs = {
  input: CreateSiteDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameExtraArgs = {
  input: CreateSiteNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameKeyCadArgs = {
  input: CreateSiteNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameKeyCafmArgs = {
  input: CreateSiteNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameKeyEbmArgs = {
  input: CreateSiteNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameKeyMarketingArgs = {
  input: CreateSiteNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameLongArgs = {
  input: CreateSiteNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSiteNameShortArgs = {
  input: CreateSiteNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserPasswordLoginArgs = {
  input: CreateUserPasswordLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserSsoLoginArgs = {
  input: CreateUserSsoLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserWithPasswordLoginArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneArgs = {
  input: CreateZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneCadGrossSpaceMinArgs = {
  input: CreateZoneCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneCapacityCarArgs = {
  input: CreateZoneCapacityCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneCapacityTruckArgs = {
  input: CreateZoneCapacityTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneDescriptionArgs = {
  input: CreateZoneDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneMaxLoadFloorArgs = {
  input: CreateZoneMaxLoadFloorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameExtraArgs = {
  input: CreateZoneNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameKeyCadArgs = {
  input: CreateZoneNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameKeyCafmArgs = {
  input: CreateZoneNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameKeyEbmArgs = {
  input: CreateZoneNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameKeyMarketingArgs = {
  input: CreateZoneNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameLongArgs = {
  input: CreateZoneNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNameShortArgs = {
  input: CreateZoneNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneNoVehicleArgs = {
  input: CreateZoneNoVehicleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZonePublicGrossSpaceArgs = {
  input: CreateZonePublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneTireLoadCarArgs = {
  input: CreateZoneTireLoadCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneTireLoadForkliftArgs = {
  input: CreateZoneTireLoadForkliftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneTireLoadTruckArgs = {
  input: CreateZoneTireLoadTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneTypeArgs = {
  input: CreateZoneTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneTypeAttrArgs = {
  input: CreateZoneTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeactivatePasswordLoginArgs = {
  userId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeactivateSsoLoginArgs = {
  oid: Scalars['String'];
  provider: SsoProvider;
  userId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeactivateUserArgs = {
  id: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationAreaArgs = {
  input: DeleteAllocationAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationAreaPhaseArgs = {
  input: DeleteAllocationAreaPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationPlotArgs = {
  input: DeleteAllocationPlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationPlotPhaseArgs = {
  input: DeleteAllocationPlotPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationRoomArgs = {
  input: DeleteAllocationRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationRoomPhaseArgs = {
  input: DeleteAllocationRoomPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationUsageArgs = {
  input: DeleteAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationUsageByNameArgs = {
  input: DeleteAllocationUsageByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationUsageByNameShortArgs = {
  input: DeleteAllocationUsageByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationUsageByPositionArgs = {
  input: DeleteAllocationUsageByPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllocationUsageByTypeArgs = {
  input: DeleteAllocationUsageByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaArgs = {
  input: DeleteAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaByExtIdArgs = {
  input: DeleteAreaByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaByNameShortArgs = {
  input: DeleteAreaByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaCadGrossSpaceMinArgs = {
  input: DeleteAreaCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaClearanceConstructionArgs = {
  input: DeleteAreaClearanceConstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaContactBookingArgs = {
  input: DeleteAreaContactBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaDescriptionArgs = {
  input: DeleteAreaDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaKeyIssuanceArgs = {
  input: DeleteAreaKeyIssuanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaKeyIssuanceNoteArgs = {
  input: DeleteAreaKeyIssuanceNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameExtraArgs = {
  input: DeleteAreaNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameKeyCadArgs = {
  input: DeleteAreaNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameKeyCafmArgs = {
  input: DeleteAreaNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameKeyEbmArgs = {
  input: DeleteAreaNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameKeyMarketingArgs = {
  input: DeleteAreaNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameLongArgs = {
  input: DeleteAreaNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaNameShortArgs = {
  input: DeleteAreaNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaPublicGrossSpaceArgs = {
  input: DeleteAreaPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaTypeArgs = {
  input: DeleteAreaTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaTypeAttrArgs = {
  input: DeleteAreaTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAreaTypeByNameArgs = {
  input: DeleteAreaTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingArgs = {
  input: DeleteBuildingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingByExtIdArgs = {
  input: DeleteBuildingByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingByIdAndSiteIdArgs = {
  input: DeleteBuildingByIdAndSiteIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingByNameShortArgs = {
  input: DeleteBuildingByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingDescriptionArgs = {
  input: DeleteBuildingDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameExtraArgs = {
  input: DeleteBuildingNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameKeyCadArgs = {
  input: DeleteBuildingNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameKeyCafmArgs = {
  input: DeleteBuildingNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameKeyEbmArgs = {
  input: DeleteBuildingNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameKeyMarketingArgs = {
  input: DeleteBuildingNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameLongArgs = {
  input: DeleteBuildingNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingNameShortArgs = {
  input: DeleteBuildingNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingPublicGrossSpaceArgs = {
  input: DeleteBuildingPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingTypeArgs = {
  input: DeleteBuildingTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingTypeAttrArgs = {
  input: DeleteBuildingTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingTypeByNameArgs = {
  input: DeleteBuildingTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteElevationLevelArgs = {
  input: DeleteElevationLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteElevationLevelByValueArgs = {
  input: DeleteElevationLevelByValueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventArgs = {
  input: DeleteEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventByNameShortArgs = {
  input: DeleteEventByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventSeriesArgs = {
  input: DeleteEventSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventSeriesByNameShortArgs = {
  input: DeleteEventSeriesByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventVariantArgs = {
  input: DeleteEventVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventVariantByEventIdAndIndexArgs = {
  input: DeleteEventVariantByEventIdAndIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventArgs = {
  input: DeleteExternalEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationArgs = {
  input: DeleteExternalEventAllocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationPhaseArgs = {
  input: DeleteExternalEventAllocationPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationUsageArgs = {
  input: DeleteExternalEventAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationUsageByNameArgs = {
  input: DeleteExternalEventAllocationUsageByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationUsageByNameShortArgs = {
  input: DeleteExternalEventAllocationUsageByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationUsageByPositionArgs = {
  input: DeleteExternalEventAllocationUsageByPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventAllocationUsageByTypeArgs = {
  input: DeleteExternalEventAllocationUsageByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventByNameShortArgs = {
  input: DeleteExternalEventByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventEventLocationVisibilityArgs = {
  input: DeleteExternalEventEventLocationVisibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventEventLocationVisibilityByEventIdAndLocationIdArgs = {
  input: DeleteExternalEventEventLocationVisibilityByEventIdAndLocationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventLocationArgs = {
  input: DeleteExternalEventLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventLocationByNameArgs = {
  input: DeleteExternalEventLocationByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventSeriesArgs = {
  input: DeleteExternalEventSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventSeriesByNameShortArgs = {
  input: DeleteExternalEventSeriesByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventVariantArgs = {
  input: DeleteExternalEventVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalEventVariantByEventIdAndIndexArgs = {
  input: DeleteExternalEventVariantByEventIdAndIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeedArgs = {
  input: DeleteFeedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeedEntryArgs = {
  input: DeleteFeedEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelArgs = {
  input: DeleteLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelByExtIdArgs = {
  input: DeleteLevelByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelByNameShortArgs = {
  input: DeleteLevelByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelCapacityPaxArgs = {
  input: DeleteLevelCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelDescriptionArgs = {
  input: DeleteLevelDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelFkmGrossSpaceArgs = {
  input: DeleteLevelFkmGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameExtraArgs = {
  input: DeleteLevelNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameKeyCadArgs = {
  input: DeleteLevelNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameKeyCafmArgs = {
  input: DeleteLevelNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameKeyEbmArgs = {
  input: DeleteLevelNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameKeyMarketingArgs = {
  input: DeleteLevelNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameLongArgs = {
  input: DeleteLevelNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelNameShortArgs = {
  input: DeleteLevelNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelPublicGrossSpaceArgs = {
  input: DeleteLevelPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelTypeArgs = {
  input: DeleteLevelTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelTypeAttrArgs = {
  input: DeleteLevelTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLevelTypeByNameArgs = {
  input: DeleteLevelTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLinkArgs = {
  input: DeleteLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMultilinkArgs = {
  input: DeleteMultilinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotArgs = {
  input: DeletePlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotByExtIdArgs = {
  input: DeletePlotByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotByNameShortArgs = {
  input: DeletePlotByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotCadGrossSpaceMinArgs = {
  input: DeletePlotCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotDescriptionArgs = {
  input: DeletePlotDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameExtraArgs = {
  input: DeletePlotNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameKeyCadArgs = {
  input: DeletePlotNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameKeyCafmArgs = {
  input: DeletePlotNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameKeyEbmArgs = {
  input: DeletePlotNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameKeyMarketingArgs = {
  input: DeletePlotNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameLongArgs = {
  input: DeletePlotNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotNameShortArgs = {
  input: DeletePlotNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotPublicGrossSpaceArgs = {
  input: DeletePlotPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotTypeArgs = {
  input: DeletePlotTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotTypeAttrArgs = {
  input: DeletePlotTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlotTypeByNameArgs = {
  input: DeletePlotTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationAreaArgs = {
  input: DeleteProjectAllocationAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationAreaPhaseArgs = {
  input: DeleteProjectAllocationAreaPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationPlotArgs = {
  input: DeleteProjectAllocationPlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationPlotPhaseArgs = {
  input: DeleteProjectAllocationPlotPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationRoomArgs = {
  input: DeleteProjectAllocationRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationRoomPhaseArgs = {
  input: DeleteProjectAllocationRoomPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationUsageArgs = {
  input: DeleteProjectAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationUsageByNameArgs = {
  input: DeleteProjectAllocationUsageByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationUsageByNameShortArgs = {
  input: DeleteProjectAllocationUsageByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationUsageByPositionArgs = {
  input: DeleteProjectAllocationUsageByPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectAllocationUsageByTypeArgs = {
  input: DeleteProjectAllocationUsageByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectByNameShortArgs = {
  input: DeleteProjectByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectSeriesArgs = {
  input: DeleteProjectSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectSeriesByNameShortArgs = {
  input: DeleteProjectSeriesByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectVariantArgs = {
  input: DeleteProjectVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectVariantByProjectIdAndIndexArgs = {
  input: DeleteProjectVariantByProjectIdAndIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomArgs = {
  input: DeleteRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomAirChangeRateArgs = {
  input: DeleteRoomAirChangeRateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomAirConditioningArgs = {
  input: DeleteRoomAirConditioningInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomByExtIdArgs = {
  input: DeleteRoomByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomByNameShortArgs = {
  input: DeleteRoomByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadGrossSpaceMinArgs = {
  input: DeleteRoomCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadHeightMaxArgs = {
  input: DeleteRoomCadHeightMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadHeightMinArgs = {
  input: DeleteRoomCadHeightMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadLengthMaxArgs = {
  input: DeleteRoomCadLengthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadLengthMinArgs = {
  input: DeleteRoomCadLengthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadWidthMaxArgs = {
  input: DeleteRoomCadWidthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCadWidthMinArgs = {
  input: DeleteRoomCadWidthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCapacityCarArgs = {
  input: DeleteRoomCapacityCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCapacityPaxArgs = {
  input: DeleteRoomCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCapacityTruckArgs = {
  input: DeleteRoomCapacityTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomCleaningGrossSpaceArgs = {
  input: DeleteRoomCleaningGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomClearanceConstructionArgs = {
  input: DeleteRoomClearanceConstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomContactBookingArgs = {
  input: DeleteRoomContactBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomDaylightArgs = {
  input: DeleteRoomDaylightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomDescriptionArgs = {
  input: DeleteRoomDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomKeyIssuanceArgs = {
  input: DeleteRoomKeyIssuanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomKeyIssuanceNoteArgs = {
  input: DeleteRoomKeyIssuanceNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomLightShutterArgs = {
  input: DeleteRoomLightShutterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomMaxLoadCeilingArgs = {
  input: DeleteRoomMaxLoadCeilingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomMaxLoadFloorArgs = {
  input: DeleteRoomMaxLoadFloorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameExtraArgs = {
  input: DeleteRoomNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameKeyCadArgs = {
  input: DeleteRoomNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameKeyCafmArgs = {
  input: DeleteRoomNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameKeyEbmArgs = {
  input: DeleteRoomNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameKeyMarketingArgs = {
  input: DeleteRoomNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameLongArgs = {
  input: DeleteRoomNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNameShortArgs = {
  input: DeleteRoomNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomNoVehicleArgs = {
  input: DeleteRoomNoVehicleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionArgs = {
  input: DeleteRoomPartitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionByExtIdArgs = {
  input: DeleteRoomPartitionByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionByNameShortArgs = {
  input: DeleteRoomPartitionByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadGrossSpaceMinArgs = {
  input: DeleteRoomPartitionCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadHeightMaxArgs = {
  input: DeleteRoomPartitionCadHeightMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadHeightMinArgs = {
  input: DeleteRoomPartitionCadHeightMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadLengthMaxArgs = {
  input: DeleteRoomPartitionCadLengthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadLengthMinArgs = {
  input: DeleteRoomPartitionCadLengthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadWidthMaxArgs = {
  input: DeleteRoomPartitionCadWidthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCadWidthMinArgs = {
  input: DeleteRoomPartitionCadWidthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCapacityPaxArgs = {
  input: DeleteRoomPartitionCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionCleaningGrossSpaceArgs = {
  input: DeleteRoomPartitionCleaningGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionDescriptionArgs = {
  input: DeleteRoomPartitionDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameExtraArgs = {
  input: DeleteRoomPartitionNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameKeyCadArgs = {
  input: DeleteRoomPartitionNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameKeyCafmArgs = {
  input: DeleteRoomPartitionNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameKeyEbmArgs = {
  input: DeleteRoomPartitionNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameKeyMarketingArgs = {
  input: DeleteRoomPartitionNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameLongArgs = {
  input: DeleteRoomPartitionNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionNameShortArgs = {
  input: DeleteRoomPartitionNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionPublicGrossSpaceArgs = {
  input: DeleteRoomPartitionPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionSbvGrossSpaceArgs = {
  input: DeleteRoomPartitionSbvGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionTypeArgs = {
  input: DeleteRoomPartitionTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionTypeAttrArgs = {
  input: DeleteRoomPartitionTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPartitionTypeByNameArgs = {
  input: DeleteRoomPartitionTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPhoneNumberArgs = {
  input: DeleteRoomPhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomPublicGrossSpaceArgs = {
  input: DeleteRoomPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomSbvGrossSpaceArgs = {
  input: DeleteRoomSbvGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomTireLoadCarArgs = {
  input: DeleteRoomTireLoadCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomTireLoadForkliftArgs = {
  input: DeleteRoomTireLoadForkliftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomTireLoadTruckArgs = {
  input: DeleteRoomTireLoadTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomTypeArgs = {
  input: DeleteRoomTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomTypeAttrArgs = {
  input: DeleteRoomTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoomTypeByNameArgs = {
  input: DeleteRoomTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioArgs = {
  input: DeleteScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioByNameShortArgs = {
  input: DeleteScenarioByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioGroupArgs = {
  input: DeleteScenarioGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioGroupByNameShortArgs = {
  input: DeleteScenarioGroupByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioSettingArgs = {
  input: DeleteScenarioSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioVariantVisibilityArgs = {
  input: DeleteScenarioVariantVisibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeArgs = {
  input: DeleteScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteArgs = {
  input: DeleteSiteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteByExtIdArgs = {
  input: DeleteSiteByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteByNameShortArgs = {
  input: DeleteSiteByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteDescriptionArgs = {
  input: DeleteSiteDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameExtraArgs = {
  input: DeleteSiteNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameKeyCadArgs = {
  input: DeleteSiteNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameKeyCafmArgs = {
  input: DeleteSiteNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameKeyEbmArgs = {
  input: DeleteSiteNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameKeyMarketingArgs = {
  input: DeleteSiteNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameLongArgs = {
  input: DeleteSiteNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSiteNameShortArgs = {
  input: DeleteSiteNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPasswordLoginArgs = {
  input: DeleteUserPasswordLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPasswordLoginByEmailArgs = {
  input: DeleteUserPasswordLoginByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPasswordLoginByUserIdArgs = {
  input: DeleteUserPasswordLoginByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSsoLoginArgs = {
  input: DeleteUserSsoLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSsoLoginByProviderAndOidArgs = {
  input: DeleteUserSsoLoginByProviderAndOidInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSsoLoginByUserIdAndProviderArgs = {
  input: DeleteUserSsoLoginByUserIdAndProviderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneArgs = {
  input: DeleteZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneByExtIdArgs = {
  input: DeleteZoneByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneByNameShortArgs = {
  input: DeleteZoneByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneCadGrossSpaceMinArgs = {
  input: DeleteZoneCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneCapacityCarArgs = {
  input: DeleteZoneCapacityCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneCapacityTruckArgs = {
  input: DeleteZoneCapacityTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneDescriptionArgs = {
  input: DeleteZoneDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneMaxLoadFloorArgs = {
  input: DeleteZoneMaxLoadFloorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameExtraArgs = {
  input: DeleteZoneNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameKeyCadArgs = {
  input: DeleteZoneNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameKeyCafmArgs = {
  input: DeleteZoneNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameKeyEbmArgs = {
  input: DeleteZoneNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameKeyMarketingArgs = {
  input: DeleteZoneNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameLongArgs = {
  input: DeleteZoneNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNameShortArgs = {
  input: DeleteZoneNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneNoVehicleArgs = {
  input: DeleteZoneNoVehicleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZonePublicGrossSpaceArgs = {
  input: DeleteZonePublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneTireLoadCarArgs = {
  input: DeleteZoneTireLoadCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneTireLoadForkliftArgs = {
  input: DeleteZoneTireLoadForkliftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneTireLoadTruckArgs = {
  input: DeleteZoneTireLoadTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneTypeArgs = {
  input: DeleteZoneTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneTypeAttrArgs = {
  input: DeleteZoneTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneTypeByNameArgs = {
  input: DeleteZoneTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEntraLoginArgs = {
  idToken: Scalars['String'];
  provider: SsoProvider;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExternalEventAllocationDuplicateArgs = {
  input: ExternalEventAllocationDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExternalEventAllocationUpdateAndDuplicateArgs = {
  input: ExternalEventAllocationUpdateAndDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationProjectAllocationAreaDuplicateArgs = {
  input: ProjectAllocationAreaDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationProjectAllocationAreaUpdateAndDuplicateArgs = {
  input: ProjectAllocationAreaUpdateAndDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationProjectAllocationRoomDuplicateArgs = {
  input: ProjectAllocationRoomDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationProjectAllocationRoomUpdateAndDuplicateArgs = {
  input: ProjectAllocationRoomUpdateAndDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRefreshJwtArgs = {
  provider: SessionProvider;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetPasswordArgs = {
  password: Scalars['String'];
  userId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationAreaArgs = {
  input: UpdateAllocationAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationAreaPhaseArgs = {
  input: UpdateAllocationAreaPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationPlotArgs = {
  input: UpdateAllocationPlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationPlotPhaseArgs = {
  input: UpdateAllocationPlotPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationRoomArgs = {
  input: UpdateAllocationRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationRoomPhaseArgs = {
  input: UpdateAllocationRoomPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationUsageArgs = {
  input: UpdateAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationUsageByNameArgs = {
  input: UpdateAllocationUsageByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationUsageByNameShortArgs = {
  input: UpdateAllocationUsageByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationUsageByPositionArgs = {
  input: UpdateAllocationUsageByPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllocationUsageByTypeArgs = {
  input: UpdateAllocationUsageByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaArgs = {
  input: UpdateAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaByExtIdArgs = {
  input: UpdateAreaByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaByNameShortArgs = {
  input: UpdateAreaByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaCadGrossSpaceMinArgs = {
  input: UpdateAreaCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaClearanceConstructionArgs = {
  input: UpdateAreaClearanceConstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaContactBookingArgs = {
  input: UpdateAreaContactBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaDescriptionArgs = {
  input: UpdateAreaDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaKeyIssuanceArgs = {
  input: UpdateAreaKeyIssuanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaKeyIssuanceNoteArgs = {
  input: UpdateAreaKeyIssuanceNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameExtraArgs = {
  input: UpdateAreaNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameKeyCadArgs = {
  input: UpdateAreaNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameKeyCafmArgs = {
  input: UpdateAreaNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameKeyEbmArgs = {
  input: UpdateAreaNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameKeyMarketingArgs = {
  input: UpdateAreaNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameLongArgs = {
  input: UpdateAreaNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaNameShortArgs = {
  input: UpdateAreaNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaPublicGrossSpaceArgs = {
  input: UpdateAreaPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaTypeArgs = {
  input: UpdateAreaTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaTypeAttrArgs = {
  input: UpdateAreaTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAreaTypeByNameArgs = {
  input: UpdateAreaTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingArgs = {
  input: UpdateBuildingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingByExtIdArgs = {
  input: UpdateBuildingByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingByIdAndSiteIdArgs = {
  input: UpdateBuildingByIdAndSiteIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingByNameShortArgs = {
  input: UpdateBuildingByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingDescriptionArgs = {
  input: UpdateBuildingDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameExtraArgs = {
  input: UpdateBuildingNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameKeyCadArgs = {
  input: UpdateBuildingNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameKeyCafmArgs = {
  input: UpdateBuildingNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameKeyEbmArgs = {
  input: UpdateBuildingNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameKeyMarketingArgs = {
  input: UpdateBuildingNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameLongArgs = {
  input: UpdateBuildingNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingNameShortArgs = {
  input: UpdateBuildingNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingPublicGrossSpaceArgs = {
  input: UpdateBuildingPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingTypeArgs = {
  input: UpdateBuildingTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingTypeAttrArgs = {
  input: UpdateBuildingTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingTypeByNameArgs = {
  input: UpdateBuildingTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateElevationLevelArgs = {
  input: UpdateElevationLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateElevationLevelByValueArgs = {
  input: UpdateElevationLevelByValueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventByNameShortArgs = {
  input: UpdateEventByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventSeriesArgs = {
  input: UpdateEventSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventSeriesByNameShortArgs = {
  input: UpdateEventSeriesByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventVariantArgs = {
  input: UpdateEventVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventVariantByEventIdAndIndexArgs = {
  input: UpdateEventVariantByEventIdAndIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventArgs = {
  input: UpdateExternalEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationArgs = {
  input: UpdateExternalEventAllocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationPhaseArgs = {
  input: UpdateExternalEventAllocationPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationUsageArgs = {
  input: UpdateExternalEventAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationUsageByNameArgs = {
  input: UpdateExternalEventAllocationUsageByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationUsageByNameShortArgs = {
  input: UpdateExternalEventAllocationUsageByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationUsageByPositionArgs = {
  input: UpdateExternalEventAllocationUsageByPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventAllocationUsageByTypeArgs = {
  input: UpdateExternalEventAllocationUsageByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventByNameShortArgs = {
  input: UpdateExternalEventByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventEventLocationVisibilityArgs = {
  input: UpdateExternalEventEventLocationVisibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventEventLocationVisibilityByEventIdAndLocationIdArgs = {
  input: UpdateExternalEventEventLocationVisibilityByEventIdAndLocationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventLocationArgs = {
  input: UpdateExternalEventLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventLocationByNameArgs = {
  input: UpdateExternalEventLocationByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventSeriesArgs = {
  input: UpdateExternalEventSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventSeriesByNameShortArgs = {
  input: UpdateExternalEventSeriesByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventVariantArgs = {
  input: UpdateExternalEventVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalEventVariantByEventIdAndIndexArgs = {
  input: UpdateExternalEventVariantByEventIdAndIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeedArgs = {
  input: UpdateFeedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeedEntryArgs = {
  input: UpdateFeedEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelArgs = {
  input: UpdateLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelByExtIdArgs = {
  input: UpdateLevelByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelByNameShortArgs = {
  input: UpdateLevelByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelCapacityPaxArgs = {
  input: UpdateLevelCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelDescriptionArgs = {
  input: UpdateLevelDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelFkmGrossSpaceArgs = {
  input: UpdateLevelFkmGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameExtraArgs = {
  input: UpdateLevelNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameKeyCadArgs = {
  input: UpdateLevelNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameKeyCafmArgs = {
  input: UpdateLevelNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameKeyEbmArgs = {
  input: UpdateLevelNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameKeyMarketingArgs = {
  input: UpdateLevelNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameLongArgs = {
  input: UpdateLevelNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelNameShortArgs = {
  input: UpdateLevelNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelPublicGrossSpaceArgs = {
  input: UpdateLevelPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelTypeArgs = {
  input: UpdateLevelTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelTypeAttrArgs = {
  input: UpdateLevelTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLevelTypeByNameArgs = {
  input: UpdateLevelTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLinkArgs = {
  input: UpdateLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMultilinkArgs = {
  input: UpdateMultilinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  userId: Scalars['UUID'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotArgs = {
  input: UpdatePlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotByExtIdArgs = {
  input: UpdatePlotByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotByNameShortArgs = {
  input: UpdatePlotByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotCadGrossSpaceMinArgs = {
  input: UpdatePlotCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotDescriptionArgs = {
  input: UpdatePlotDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameExtraArgs = {
  input: UpdatePlotNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameKeyCadArgs = {
  input: UpdatePlotNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameKeyCafmArgs = {
  input: UpdatePlotNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameKeyEbmArgs = {
  input: UpdatePlotNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameKeyMarketingArgs = {
  input: UpdatePlotNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameLongArgs = {
  input: UpdatePlotNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotNameShortArgs = {
  input: UpdatePlotNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotPublicGrossSpaceArgs = {
  input: UpdatePlotPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotTypeArgs = {
  input: UpdatePlotTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotTypeAttrArgs = {
  input: UpdatePlotTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlotTypeByNameArgs = {
  input: UpdatePlotTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationAreaArgs = {
  input: UpdateProjectAllocationAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationAreaPhaseArgs = {
  input: UpdateProjectAllocationAreaPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationPlotArgs = {
  input: UpdateProjectAllocationPlotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationPlotPhaseArgs = {
  input: UpdateProjectAllocationPlotPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationRoomArgs = {
  input: UpdateProjectAllocationRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationRoomPhaseArgs = {
  input: UpdateProjectAllocationRoomPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationUsageArgs = {
  input: UpdateProjectAllocationUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationUsageByNameArgs = {
  input: UpdateProjectAllocationUsageByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationUsageByNameShortArgs = {
  input: UpdateProjectAllocationUsageByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationUsageByPositionArgs = {
  input: UpdateProjectAllocationUsageByPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectAllocationUsageByTypeArgs = {
  input: UpdateProjectAllocationUsageByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectByNameShortArgs = {
  input: UpdateProjectByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectSeriesArgs = {
  input: UpdateProjectSeriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectSeriesByNameShortArgs = {
  input: UpdateProjectSeriesByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectVariantArgs = {
  input: UpdateProjectVariantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectVariantByProjectIdAndIndexArgs = {
  input: UpdateProjectVariantByProjectIdAndIndexInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomArgs = {
  input: UpdateRoomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomAirChangeRateArgs = {
  input: UpdateRoomAirChangeRateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomAirConditioningArgs = {
  input: UpdateRoomAirConditioningInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomByExtIdArgs = {
  input: UpdateRoomByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomByNameShortArgs = {
  input: UpdateRoomByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadGrossSpaceMinArgs = {
  input: UpdateRoomCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadHeightMaxArgs = {
  input: UpdateRoomCadHeightMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadHeightMinArgs = {
  input: UpdateRoomCadHeightMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadLengthMaxArgs = {
  input: UpdateRoomCadLengthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadLengthMinArgs = {
  input: UpdateRoomCadLengthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadWidthMaxArgs = {
  input: UpdateRoomCadWidthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCadWidthMinArgs = {
  input: UpdateRoomCadWidthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCapacityCarArgs = {
  input: UpdateRoomCapacityCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCapacityPaxArgs = {
  input: UpdateRoomCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCapacityTruckArgs = {
  input: UpdateRoomCapacityTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomCleaningGrossSpaceArgs = {
  input: UpdateRoomCleaningGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomClearanceConstructionArgs = {
  input: UpdateRoomClearanceConstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomContactBookingArgs = {
  input: UpdateRoomContactBookingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomDaylightArgs = {
  input: UpdateRoomDaylightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomDescriptionArgs = {
  input: UpdateRoomDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomKeyIssuanceArgs = {
  input: UpdateRoomKeyIssuanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomKeyIssuanceNoteArgs = {
  input: UpdateRoomKeyIssuanceNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomLightShutterArgs = {
  input: UpdateRoomLightShutterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomMaxLoadCeilingArgs = {
  input: UpdateRoomMaxLoadCeilingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomMaxLoadFloorArgs = {
  input: UpdateRoomMaxLoadFloorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameExtraArgs = {
  input: UpdateRoomNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameKeyCadArgs = {
  input: UpdateRoomNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameKeyCafmArgs = {
  input: UpdateRoomNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameKeyEbmArgs = {
  input: UpdateRoomNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameKeyMarketingArgs = {
  input: UpdateRoomNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameLongArgs = {
  input: UpdateRoomNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNameShortArgs = {
  input: UpdateRoomNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomNoVehicleArgs = {
  input: UpdateRoomNoVehicleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionArgs = {
  input: UpdateRoomPartitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionByExtIdArgs = {
  input: UpdateRoomPartitionByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionByNameShortArgs = {
  input: UpdateRoomPartitionByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadGrossSpaceMinArgs = {
  input: UpdateRoomPartitionCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadHeightMaxArgs = {
  input: UpdateRoomPartitionCadHeightMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadHeightMinArgs = {
  input: UpdateRoomPartitionCadHeightMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadLengthMaxArgs = {
  input: UpdateRoomPartitionCadLengthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadLengthMinArgs = {
  input: UpdateRoomPartitionCadLengthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadWidthMaxArgs = {
  input: UpdateRoomPartitionCadWidthMaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCadWidthMinArgs = {
  input: UpdateRoomPartitionCadWidthMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCapacityPaxArgs = {
  input: UpdateRoomPartitionCapacityPaxInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionCleaningGrossSpaceArgs = {
  input: UpdateRoomPartitionCleaningGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionDescriptionArgs = {
  input: UpdateRoomPartitionDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameExtraArgs = {
  input: UpdateRoomPartitionNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameKeyCadArgs = {
  input: UpdateRoomPartitionNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameKeyCafmArgs = {
  input: UpdateRoomPartitionNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameKeyEbmArgs = {
  input: UpdateRoomPartitionNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameKeyMarketingArgs = {
  input: UpdateRoomPartitionNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameLongArgs = {
  input: UpdateRoomPartitionNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionNameShortArgs = {
  input: UpdateRoomPartitionNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionPublicGrossSpaceArgs = {
  input: UpdateRoomPartitionPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionSbvGrossSpaceArgs = {
  input: UpdateRoomPartitionSbvGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionTypeArgs = {
  input: UpdateRoomPartitionTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionTypeAttrArgs = {
  input: UpdateRoomPartitionTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPartitionTypeByNameArgs = {
  input: UpdateRoomPartitionTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPhoneNumberArgs = {
  input: UpdateRoomPhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomPublicGrossSpaceArgs = {
  input: UpdateRoomPublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomSbvGrossSpaceArgs = {
  input: UpdateRoomSbvGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomTireLoadCarArgs = {
  input: UpdateRoomTireLoadCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomTireLoadForkliftArgs = {
  input: UpdateRoomTireLoadForkliftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomTireLoadTruckArgs = {
  input: UpdateRoomTireLoadTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomTypeArgs = {
  input: UpdateRoomTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomTypeAttrArgs = {
  input: UpdateRoomTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoomTypeByNameArgs = {
  input: UpdateRoomTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioArgs = {
  input: UpdateScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioByNameShortArgs = {
  input: UpdateScenarioByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioGroupArgs = {
  input: UpdateScenarioGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioGroupByNameShortArgs = {
  input: UpdateScenarioGroupByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioSettingArgs = {
  input: UpdateScenarioSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioVariantVisibilityArgs = {
  input: UpdateScenarioVariantVisibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeArgs = {
  input: UpdateScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteArgs = {
  input: UpdateSiteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteByExtIdArgs = {
  input: UpdateSiteByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteByNameShortArgs = {
  input: UpdateSiteByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteDescriptionArgs = {
  input: UpdateSiteDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameExtraArgs = {
  input: UpdateSiteNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameKeyCadArgs = {
  input: UpdateSiteNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameKeyCafmArgs = {
  input: UpdateSiteNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameKeyEbmArgs = {
  input: UpdateSiteNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameKeyMarketingArgs = {
  input: UpdateSiteNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameLongArgs = {
  input: UpdateSiteNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSiteNameShortArgs = {
  input: UpdateSiteNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPasswordLoginArgs = {
  input: UpdateUserPasswordLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPasswordLoginByEmailArgs = {
  input: UpdateUserPasswordLoginByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPasswordLoginByUserIdArgs = {
  input: UpdateUserPasswordLoginByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSsoLoginArgs = {
  input: UpdateUserSsoLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSsoLoginByProviderAndOidArgs = {
  input: UpdateUserSsoLoginByProviderAndOidInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSsoLoginByUserIdAndProviderArgs = {
  input: UpdateUserSsoLoginByUserIdAndProviderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneArgs = {
  input: UpdateZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneByExtIdArgs = {
  input: UpdateZoneByExtIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneByNameShortArgs = {
  input: UpdateZoneByNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneCadGrossSpaceMinArgs = {
  input: UpdateZoneCadGrossSpaceMinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneCapacityCarArgs = {
  input: UpdateZoneCapacityCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneCapacityTruckArgs = {
  input: UpdateZoneCapacityTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneDescriptionArgs = {
  input: UpdateZoneDescriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneMaxLoadFloorArgs = {
  input: UpdateZoneMaxLoadFloorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameExtraArgs = {
  input: UpdateZoneNameExtraInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameKeyCadArgs = {
  input: UpdateZoneNameKeyCadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameKeyCafmArgs = {
  input: UpdateZoneNameKeyCafmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameKeyEbmArgs = {
  input: UpdateZoneNameKeyEbmInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameKeyMarketingArgs = {
  input: UpdateZoneNameKeyMarketingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameLongArgs = {
  input: UpdateZoneNameLongInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNameShortArgs = {
  input: UpdateZoneNameShortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneNoVehicleArgs = {
  input: UpdateZoneNoVehicleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZonePublicGrossSpaceArgs = {
  input: UpdateZonePublicGrossSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneTireLoadCarArgs = {
  input: UpdateZoneTireLoadCarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneTireLoadForkliftArgs = {
  input: UpdateZoneTireLoadForkliftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneTireLoadTruckArgs = {
  input: UpdateZoneTireLoadTruckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneTypeArgs = {
  input: UpdateZoneTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneTypeAttrArgs = {
  input: UpdateZoneTypeAttrInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneTypeByNameArgs = {
  input: UpdateZoneTypeByNameInput;
};

export type NotFound = {
  __typename?: 'NotFound';
  message: Scalars['String'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type PasswordLoginData = {
  __typename?: 'PasswordLoginData';
  activatedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};

export type Plot = {
  __typename?: 'Plot';
  /** Reads and enables pagination through a set of `AllocationPlot`. */
  allocationPlots: AllocationPlotsConnection;
  /** Reads a single `Area` that is related to this `Plot`. */
  area: Area;
  areaId: Scalars['UUID'];
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads and enables pagination through a set of `PlotCadGrossSpaceMin`. */
  plotCadGrossSpaceMins: PlotCadGrossSpaceMinsConnection;
  /** Reads and enables pagination through a set of `PlotDescription`. */
  plotDescriptions: PlotDescriptionsConnection;
  /** Reads and enables pagination through a set of `PlotNameExtra`. */
  plotNameExtras: PlotNameExtrasConnection;
  /** Reads and enables pagination through a set of `PlotNameKeyCad`. */
  plotNameKeyCads: PlotNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `PlotNameKeyCafm`. */
  plotNameKeyCafms: PlotNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `PlotNameKeyEbm`. */
  plotNameKeyEbms: PlotNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `PlotNameKeyMarketing`. */
  plotNameKeyMarketings: PlotNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `PlotNameLong`. */
  plotNameLongs: PlotNameLongsConnection;
  /** Reads and enables pagination through a set of `PlotNameShort`. */
  plotNameShorts: PlotNameShortsConnection;
  /** Reads and enables pagination through a set of `PlotPublicGrossSpace`. */
  plotPublicGrossSpaces: PlotPublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `PlotTypeAttr`. */
  plotTypeAttrs: PlotTypeAttrsConnection;
  /** Reads and enables pagination through a set of `ProjectAllocationPlot`. */
  projectAllocationPlots: ProjectAllocationPlotsConnection;
  /** Reads a single `PlotType` that is related to this `Plot`. */
  type?: Maybe<PlotType>;
  typeId?: Maybe<Scalars['UUID']>;
};


export type PlotAllocationPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationPlotCondition>;
  filter?: InputMaybe<AllocationPlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationPlotsOrderBy>>;
};


export type PlotPlotCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotCadGrossSpaceMinCondition>;
  filter?: InputMaybe<PlotCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotCadGrossSpaceMinsOrderBy>>;
};


export type PlotPlotDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotDescriptionCondition>;
  filter?: InputMaybe<PlotDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotDescriptionsOrderBy>>;
};


export type PlotPlotNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameExtraCondition>;
  filter?: InputMaybe<PlotNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameExtrasOrderBy>>;
};


export type PlotPlotNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyCadCondition>;
  filter?: InputMaybe<PlotNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyCadsOrderBy>>;
};


export type PlotPlotNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyCafmCondition>;
  filter?: InputMaybe<PlotNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyCafmsOrderBy>>;
};


export type PlotPlotNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyEbmCondition>;
  filter?: InputMaybe<PlotNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyEbmsOrderBy>>;
};


export type PlotPlotNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyMarketingCondition>;
  filter?: InputMaybe<PlotNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyMarketingsOrderBy>>;
};


export type PlotPlotNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameLongCondition>;
  filter?: InputMaybe<PlotNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameLongsOrderBy>>;
};


export type PlotPlotNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameShortCondition>;
  filter?: InputMaybe<PlotNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameShortsOrderBy>>;
};


export type PlotPlotPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotPublicGrossSpaceCondition>;
  filter?: InputMaybe<PlotPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotPublicGrossSpacesOrderBy>>;
};


export type PlotPlotTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotTypeAttrCondition>;
  filter?: InputMaybe<PlotTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotTypeAttrsOrderBy>>;
};


export type PlotProjectAllocationPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationPlotCondition>;
  filter?: InputMaybe<ProjectAllocationPlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationPlotsOrderBy>>;
};

/** The `area` to be created by this mutation. */
export type PlotAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `area` in the `PlotInput` mutation. */
export type PlotAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnPlotForPlotAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnPlotForPlotAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnPlotForPlotAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plot` in the `AreaInput` mutation. */
export type PlotAreaIdFkeyInverseInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<PlotPlotExtIdKeyConnect>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotPlotPkeyConnect>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<PlotPlotNameShortKeyConnect>>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotAreaIdFkeyPlotCreateInput>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<PlotPlotExtIdKeyDelete>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotPlotPkeyDelete>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<PlotPlotNameShortKeyDelete>>;
  /** Flag indicating whether all other `plot` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<PlotOnPlotForPlotAreaIdFkeyUsingPlotExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotOnPlotForPlotAreaIdFkeyUsingPlotPkeyUpdate>>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<PlotOnPlotForPlotAreaIdFkeyUsingPlotNameShortKeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotAreaIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type PlotCadGrossSpaceMin = {
  __typename?: 'PlotCadGrossSpaceMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotCadGrossSpaceMin`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `PlotCadGrossSpaceMin` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PlotCadGrossSpaceMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `PlotCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type PlotCadGrossSpaceMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotCadGrossSpaceMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `PlotCadGrossSpaceMin` */
export type PlotCadGrossSpaceMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `plotCadGrossSpaceMin` to look up the row to update. */
export type PlotCadGrossSpaceMinOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotCadGrossSpaceMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotCadGrossSpaceMin` being updated. */
  patch: UpdatePlotCadGrossSpaceMinOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyPatch;
};

/** Represents an update to a `PlotCadGrossSpaceMin`. Fields that are set will be updated. */
export type PlotCadGrossSpaceMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `plotCadGrossSpaceMin` to look up the row to connect. */
export type PlotCadGrossSpaceMinPlotCadGrossSpaceMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotCadGrossSpaceMin` to look up the row to delete. */
export type PlotCadGrossSpaceMinPlotCadGrossSpaceMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `plot` in the `PlotCadGrossSpaceMinInput` mutation. */
export type PlotCadGrossSpaceMinPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotCadGrossSpaceMin` in the `PlotInput` mutation. */
export type PlotCadGrossSpaceMinPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotCadGrossSpaceMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotCadGrossSpaceMinPlotCadGrossSpaceMinPkeyConnect>>;
  /** A `PlotCadGrossSpaceMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotCadGrossSpaceMinPlotIdFkeyPlotCadGrossSpaceMinCreateInput>>;
  /** The primary key(s) for `plotCadGrossSpaceMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotCadGrossSpaceMinPlotCadGrossSpaceMinPkeyDelete>>;
  /** Flag indicating whether all other `plotCadGrossSpaceMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotCadGrossSpaceMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotCadGrossSpaceMinOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotCadGrossSpaceMinPkeyUpdate>>;
};

/** The `plotCadGrossSpaceMin` to be created by this mutation. */
export type PlotCadGrossSpaceMinPlotIdFkeyPlotCadGrossSpaceMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `plot` to be created by this mutation. */
export type PlotCadGrossSpaceMinPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `PlotCadGrossSpaceMin` values. */
export type PlotCadGrossSpaceMinsConnection = {
  __typename?: 'PlotCadGrossSpaceMinsConnection';
  /** A list of edges which contains the `PlotCadGrossSpaceMin` and cursor to aid in pagination. */
  edges: Array<PlotCadGrossSpaceMinsEdge>;
  /** A list of `PlotCadGrossSpaceMin` objects. */
  nodes: Array<PlotCadGrossSpaceMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotCadGrossSpaceMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotCadGrossSpaceMin` edge in the connection. */
export type PlotCadGrossSpaceMinsEdge = {
  __typename?: 'PlotCadGrossSpaceMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotCadGrossSpaceMin` at the end of the edge. */
  node: PlotCadGrossSpaceMin;
};

/** Methods to use when ordering `PlotCadGrossSpaceMin`. */
export enum PlotCadGrossSpaceMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A condition to be used against `Plot` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PlotCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type PlotDescription = {
  __typename?: 'PlotDescription';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotDescription`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotDescription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotDescriptionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotDescription` object types. All fields are combined with a logical ‘and.’ */
export type PlotDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotDescriptionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotDescriptionFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotDescription` */
export type PlotDescriptionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotDescriptionPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotDescription` to look up the row to update. */
export type PlotDescriptionOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotDescription` being updated. */
  patch: UpdatePlotDescriptionOnPlotDescriptionForPlotDescriptionPlotIdFkeyPatch;
};

/** Represents an update to a `PlotDescription`. Fields that are set will be updated. */
export type PlotDescriptionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotDescriptionPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `plotDescription` to look up the row to connect. */
export type PlotDescriptionPlotDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotDescription` to look up the row to delete. */
export type PlotDescriptionPlotDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `plot` in the `PlotDescriptionInput` mutation. */
export type PlotDescriptionPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotDescriptionPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotDescription` in the `PlotInput` mutation. */
export type PlotDescriptionPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotDescriptionPlotDescriptionPkeyConnect>>;
  /** A `PlotDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotDescriptionPlotIdFkeyPlotDescriptionCreateInput>>;
  /** The primary key(s) for `plotDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotDescriptionPlotDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `plotDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotDescriptionOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotDescriptionPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotDescriptionPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotDescription` to be created by this mutation. */
export type PlotDescriptionPlotIdFkeyPlotDescriptionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotDescriptionPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** A connection to a list of `PlotDescription` values. */
export type PlotDescriptionsConnection = {
  __typename?: 'PlotDescriptionsConnection';
  /** A list of edges which contains the `PlotDescription` and cursor to aid in pagination. */
  edges: Array<PlotDescriptionsEdge>;
  /** A list of `PlotDescription` objects. */
  nodes: Array<PlotDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotDescription` edge in the connection. */
export type PlotDescriptionsEdge = {
  __typename?: 'PlotDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotDescription` at the end of the edge. */
  node: PlotDescription;
};

/** Methods to use when ordering `PlotDescription`. */
export enum PlotDescriptionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against `Plot` object types. All fields are combined with a logical ‘and.’ */
export type PlotFilter = {
  /** Filter by the object’s `allocationPlots` relation. */
  allocationPlots?: InputMaybe<PlotToManyAllocationPlotFilter>;
  /** Some related `allocationPlots` exist. */
  allocationPlotsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotFilter>>;
  /** Filter by the object’s `plotCadGrossSpaceMins` relation. */
  plotCadGrossSpaceMins?: InputMaybe<PlotToManyPlotCadGrossSpaceMinFilter>;
  /** Some related `plotCadGrossSpaceMins` exist. */
  plotCadGrossSpaceMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotDescriptions` relation. */
  plotDescriptions?: InputMaybe<PlotToManyPlotDescriptionFilter>;
  /** Some related `plotDescriptions` exist. */
  plotDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameExtras` relation. */
  plotNameExtras?: InputMaybe<PlotToManyPlotNameExtraFilter>;
  /** Some related `plotNameExtras` exist. */
  plotNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameKeyCads` relation. */
  plotNameKeyCads?: InputMaybe<PlotToManyPlotNameKeyCadFilter>;
  /** Some related `plotNameKeyCads` exist. */
  plotNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameKeyCafms` relation. */
  plotNameKeyCafms?: InputMaybe<PlotToManyPlotNameKeyCafmFilter>;
  /** Some related `plotNameKeyCafms` exist. */
  plotNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameKeyEbms` relation. */
  plotNameKeyEbms?: InputMaybe<PlotToManyPlotNameKeyEbmFilter>;
  /** Some related `plotNameKeyEbms` exist. */
  plotNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameKeyMarketings` relation. */
  plotNameKeyMarketings?: InputMaybe<PlotToManyPlotNameKeyMarketingFilter>;
  /** Some related `plotNameKeyMarketings` exist. */
  plotNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameLongs` relation. */
  plotNameLongs?: InputMaybe<PlotToManyPlotNameLongFilter>;
  /** Some related `plotNameLongs` exist. */
  plotNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotNameShorts` relation. */
  plotNameShorts?: InputMaybe<PlotToManyPlotNameShortFilter>;
  /** Some related `plotNameShorts` exist. */
  plotNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotPublicGrossSpaces` relation. */
  plotPublicGrossSpaces?: InputMaybe<PlotToManyPlotPublicGrossSpaceFilter>;
  /** Some related `plotPublicGrossSpaces` exist. */
  plotPublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotTypeAttrs` relation. */
  plotTypeAttrs?: InputMaybe<PlotToManyPlotTypeAttrFilter>;
  /** Some related `plotTypeAttrs` exist. */
  plotTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectAllocationPlots` relation. */
  projectAllocationPlots?: InputMaybe<PlotToManyProjectAllocationPlotFilter>;
  /** Some related `projectAllocationPlots` exist. */
  projectAllocationPlotsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<PlotTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Plot` */
export type PlotInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type PlotNameExtra = {
  __typename?: 'PlotNameExtra';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameExtra`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotNameExtraCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameExtraFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameExtraFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameExtra` */
export type PlotNameExtraInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameExtraPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameExtra` to look up the row to update. */
export type PlotNameExtraOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameExtra` being updated. */
  patch: UpdatePlotNameExtraOnPlotNameExtraForPlotNameExtraPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameExtra`. Fields that are set will be updated. */
export type PlotNameExtraPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameExtraPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `plot` in the `PlotNameExtraInput` mutation. */
export type PlotNameExtraPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameExtraPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameExtra` in the `PlotInput` mutation. */
export type PlotNameExtraPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameExtraPlotNameExtraPkeyConnect>>;
  /** A `PlotNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameExtraPlotIdFkeyPlotNameExtraCreateInput>>;
  /** The primary key(s) for `plotNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameExtraPlotNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `plotNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameExtraOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotNameExtraPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameExtraPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameExtra` to be created by this mutation. */
export type PlotNameExtraPlotIdFkeyPlotNameExtraCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameExtraPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameExtra` to look up the row to connect. */
export type PlotNameExtraPlotNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameExtra` to look up the row to delete. */
export type PlotNameExtraPlotNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameExtra` values. */
export type PlotNameExtrasConnection = {
  __typename?: 'PlotNameExtrasConnection';
  /** A list of edges which contains the `PlotNameExtra` and cursor to aid in pagination. */
  edges: Array<PlotNameExtrasEdge>;
  /** A list of `PlotNameExtra` objects. */
  nodes: Array<PlotNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameExtra` edge in the connection. */
export type PlotNameExtrasEdge = {
  __typename?: 'PlotNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameExtra` at the end of the edge. */
  node: PlotNameExtra;
};

/** Methods to use when ordering `PlotNameExtra`. */
export enum PlotNameExtrasOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type PlotNameKeyCad = {
  __typename?: 'PlotNameKeyCad';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameKeyCad`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotNameKeyCadCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameKeyCadFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameKeyCadFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameKeyCad` */
export type PlotNameKeyCadInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyCad` to look up the row to update. */
export type PlotNameKeyCadOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameKeyCad` being updated. */
  patch: UpdatePlotNameKeyCadOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameKeyCad`. Fields that are set will be updated. */
export type PlotNameKeyCadPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `plot` in the `PlotNameKeyCadInput` mutation. */
export type PlotNameKeyCadPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameKeyCadPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameKeyCad` in the `PlotInput` mutation. */
export type PlotNameKeyCadPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameKeyCadPlotNameKeyCadPkeyConnect>>;
  /** A `PlotNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameKeyCadPlotIdFkeyPlotNameKeyCadCreateInput>>;
  /** The primary key(s) for `plotNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameKeyCadPlotNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `plotNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameKeyCadOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotNameKeyCadPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameKeyCadPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameKeyCad` to be created by this mutation. */
export type PlotNameKeyCadPlotIdFkeyPlotNameKeyCadCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyCad` to look up the row to connect. */
export type PlotNameKeyCadPlotNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameKeyCad` to look up the row to delete. */
export type PlotNameKeyCadPlotNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameKeyCad` values. */
export type PlotNameKeyCadsConnection = {
  __typename?: 'PlotNameKeyCadsConnection';
  /** A list of edges which contains the `PlotNameKeyCad` and cursor to aid in pagination. */
  edges: Array<PlotNameKeyCadsEdge>;
  /** A list of `PlotNameKeyCad` objects. */
  nodes: Array<PlotNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameKeyCad` edge in the connection. */
export type PlotNameKeyCadsEdge = {
  __typename?: 'PlotNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameKeyCad` at the end of the edge. */
  node: PlotNameKeyCad;
};

/** Methods to use when ordering `PlotNameKeyCad`. */
export enum PlotNameKeyCadsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type PlotNameKeyCafm = {
  __typename?: 'PlotNameKeyCafm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameKeyCafm`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameKeyCafm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotNameKeyCafmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameKeyCafmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameKeyCafmFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameKeyCafm` */
export type PlotNameKeyCafmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyCafm` to look up the row to update. */
export type PlotNameKeyCafmOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameKeyCafm` being updated. */
  patch: UpdatePlotNameKeyCafmOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameKeyCafm`. Fields that are set will be updated. */
export type PlotNameKeyCafmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `plot` in the `PlotNameKeyCafmInput` mutation. */
export type PlotNameKeyCafmPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameKeyCafmPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameKeyCafm` in the `PlotInput` mutation. */
export type PlotNameKeyCafmPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameKeyCafmPlotNameKeyCafmPkeyConnect>>;
  /** A `PlotNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameKeyCafmPlotIdFkeyPlotNameKeyCafmCreateInput>>;
  /** The primary key(s) for `plotNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameKeyCafmPlotNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `plotNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameKeyCafmOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotNameKeyCafmPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameKeyCafmPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameKeyCafm` to be created by this mutation. */
export type PlotNameKeyCafmPlotIdFkeyPlotNameKeyCafmCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyCafm` to look up the row to connect. */
export type PlotNameKeyCafmPlotNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameKeyCafm` to look up the row to delete. */
export type PlotNameKeyCafmPlotNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameKeyCafm` values. */
export type PlotNameKeyCafmsConnection = {
  __typename?: 'PlotNameKeyCafmsConnection';
  /** A list of edges which contains the `PlotNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<PlotNameKeyCafmsEdge>;
  /** A list of `PlotNameKeyCafm` objects. */
  nodes: Array<PlotNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameKeyCafm` edge in the connection. */
export type PlotNameKeyCafmsEdge = {
  __typename?: 'PlotNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameKeyCafm` at the end of the edge. */
  node: PlotNameKeyCafm;
};

/** Methods to use when ordering `PlotNameKeyCafm`. */
export enum PlotNameKeyCafmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type PlotNameKeyEbm = {
  __typename?: 'PlotNameKeyEbm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameKeyEbm`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotNameKeyEbmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameKeyEbmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameKeyEbmFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameKeyEbm` */
export type PlotNameKeyEbmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyEbm` to look up the row to update. */
export type PlotNameKeyEbmOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameKeyEbm` being updated. */
  patch: UpdatePlotNameKeyEbmOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameKeyEbm`. Fields that are set will be updated. */
export type PlotNameKeyEbmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `plotNameKeyEbm` to look up the row to connect. */
export type PlotNameKeyEbmPlotNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameKeyEbm` to look up the row to delete. */
export type PlotNameKeyEbmPlotNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameKeyEbm` values. */
export type PlotNameKeyEbmsConnection = {
  __typename?: 'PlotNameKeyEbmsConnection';
  /** A list of edges which contains the `PlotNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<PlotNameKeyEbmsEdge>;
  /** A list of `PlotNameKeyEbm` objects. */
  nodes: Array<PlotNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameKeyEbm` edge in the connection. */
export type PlotNameKeyEbmsEdge = {
  __typename?: 'PlotNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameKeyEbm` at the end of the edge. */
  node: PlotNameKeyEbm;
};

/** Methods to use when ordering `PlotNameKeyEbm`. */
export enum PlotNameKeyEbmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `plot` in the `PlotNameKeyEbmInput` mutation. */
export type PlotNameKeyEbmsPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameKeyEbm` in the `PlotInput` mutation. */
export type PlotNameKeyEbmsPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameKeyEbmPlotNameKeyEbmsPkeyConnect>>;
  /** A `PlotNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameKeyEbmsPlotIdFkeyPlotNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `plotNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameKeyEbmPlotNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `plotNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameKeyEbmOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotNameKeyEbmsPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameKeyEbmsPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameKeyEbm` to be created by this mutation. */
export type PlotNameKeyEbmsPlotIdFkeyPlotNameKeyEbmsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type PlotNameKeyMarketing = {
  __typename?: 'PlotNameKeyMarketing';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameKeyMarketing`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameKeyMarketing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PlotNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameKeyMarketingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameKeyMarketingFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameKeyMarketing` */
export type PlotNameKeyMarketingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyMarketing` to look up the row to update. */
export type PlotNameKeyMarketingOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameKeyMarketing` being updated. */
  patch: UpdatePlotNameKeyMarketingOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameKeyMarketing`. Fields that are set will be updated. */
export type PlotNameKeyMarketingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `plot` in the `PlotNameKeyMarketingInput` mutation. */
export type PlotNameKeyMarketingPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameKeyMarketing` in the `PlotInput` mutation. */
export type PlotNameKeyMarketingPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameKeyMarketingPlotNameKeyMarketingPkeyConnect>>;
  /** A `PlotNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameKeyMarketingPlotIdFkeyPlotNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `plotNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameKeyMarketingPlotNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `plotNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameKeyMarketingOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotNameKeyMarketingPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameKeyMarketingPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameKeyMarketing` to be created by this mutation. */
export type PlotNameKeyMarketingPlotIdFkeyPlotNameKeyMarketingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameKeyMarketing` to look up the row to connect. */
export type PlotNameKeyMarketingPlotNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameKeyMarketing` to look up the row to delete. */
export type PlotNameKeyMarketingPlotNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameKeyMarketing` values. */
export type PlotNameKeyMarketingsConnection = {
  __typename?: 'PlotNameKeyMarketingsConnection';
  /** A list of edges which contains the `PlotNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<PlotNameKeyMarketingsEdge>;
  /** A list of `PlotNameKeyMarketing` objects. */
  nodes: Array<PlotNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameKeyMarketing` edge in the connection. */
export type PlotNameKeyMarketingsEdge = {
  __typename?: 'PlotNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameKeyMarketing` at the end of the edge. */
  node: PlotNameKeyMarketing;
};

/** Methods to use when ordering `PlotNameKeyMarketing`. */
export enum PlotNameKeyMarketingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type PlotNameLong = {
  __typename?: 'PlotNameLong';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameLong`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotNameLongCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameLong` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameLongFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameLongFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameLong` */
export type PlotNameLongInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameLongPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameLong` to look up the row to update. */
export type PlotNameLongOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameLong` being updated. */
  patch: UpdatePlotNameLongOnPlotNameLongForPlotNameLongPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameLong`. Fields that are set will be updated. */
export type PlotNameLongPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameLongPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `plot` in the `PlotNameLongInput` mutation. */
export type PlotNameLongPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameLongPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameLong` in the `PlotInput` mutation. */
export type PlotNameLongPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameLongPlotNameLongPkeyConnect>>;
  /** A `PlotNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameLongPlotIdFkeyPlotNameLongCreateInput>>;
  /** The primary key(s) for `plotNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameLongPlotNameLongPkeyDelete>>;
  /** Flag indicating whether all other `plotNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameLongOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotNameLongPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameLongPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameLong` to be created by this mutation. */
export type PlotNameLongPlotIdFkeyPlotNameLongCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameLongPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameLong` to look up the row to connect. */
export type PlotNameLongPlotNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameLong` to look up the row to delete. */
export type PlotNameLongPlotNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameLong` values. */
export type PlotNameLongsConnection = {
  __typename?: 'PlotNameLongsConnection';
  /** A list of edges which contains the `PlotNameLong` and cursor to aid in pagination. */
  edges: Array<PlotNameLongsEdge>;
  /** A list of `PlotNameLong` objects. */
  nodes: Array<PlotNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameLong` edge in the connection. */
export type PlotNameLongsEdge = {
  __typename?: 'PlotNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameLong` at the end of the edge. */
  node: PlotNameLong;
};

/** Methods to use when ordering `PlotNameLong`. */
export enum PlotNameLongsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type PlotNameShort = {
  __typename?: 'PlotNameShort';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotNameShort`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `PlotNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotNameShortCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotNameShort` object types. All fields are combined with a logical ‘and.’ */
export type PlotNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotNameShortFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotNameShortFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PlotNameShort` */
export type PlotNameShortInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameShortPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameShort` to look up the row to update. */
export type PlotNameShortOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotNameShort` being updated. */
  patch: UpdatePlotNameShortOnPlotNameShortForPlotNameShortPlotIdFkeyPatch;
};

/** Represents an update to a `PlotNameShort`. Fields that are set will be updated. */
export type PlotNameShortPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameShortPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `plot` in the `PlotNameShortInput` mutation. */
export type PlotNameShortPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotNameShortPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotNameShort` in the `PlotInput` mutation. */
export type PlotNameShortPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotNameShortPlotNameShortPkeyConnect>>;
  /** A `PlotNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotNameShortPlotIdFkeyPlotNameShortCreateInput>>;
  /** The primary key(s) for `plotNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotNameShortPlotNameShortPkeyDelete>>;
  /** Flag indicating whether all other `plotNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotNameShortOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotNameShortPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotNameShortPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotNameShort` to be created by this mutation. */
export type PlotNameShortPlotIdFkeyPlotNameShortCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameShortPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `plotNameShort` to look up the row to connect. */
export type PlotNameShortPlotNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotNameShort` to look up the row to delete. */
export type PlotNameShortPlotNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotNameShort` values. */
export type PlotNameShortsConnection = {
  __typename?: 'PlotNameShortsConnection';
  /** A list of edges which contains the `PlotNameShort` and cursor to aid in pagination. */
  edges: Array<PlotNameShortsEdge>;
  /** A list of `PlotNameShort` objects. */
  nodes: Array<PlotNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotNameShort` edge in the connection. */
export type PlotNameShortsEdge = {
  __typename?: 'PlotNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotNameShort` at the end of the edge. */
  node: PlotNameShort;
};

/** Methods to use when ordering `PlotNameShort`. */
export enum PlotNameShortsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `plot` to look up the row to update. */
export type PlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnAllocationPlotForAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnAllocationPlotForAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnAllocationPlotForAllocationPlotPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnAllocationPlotForAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotForPlotAreaIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotForPlotAreaIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotForPlotAreaIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotForPlotAreaIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotForPlotAreaIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotForPlotAreaIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotForPlotTypeIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotForPlotTypeIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotForPlotTypeIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotForPlotTypeIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotForPlotTypeIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotForPlotTypeIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameLongForPlotNameLongPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameLongForPlotNameLongPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameLongForPlotNameLongPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameLongForPlotNameLongPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameShortForPlotNameShortPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameShortForPlotNameShortPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotNameShortForPlotNameShortPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotNameShortForPlotNameShortPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingPlotExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingPlotNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `plot` to look up the row to update. */
export type PlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plot` being updated. */
  patch: UpdatePlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyPatch;
};

/** Represents an update to a `Plot`. Fields that are set will be updated. */
export type PlotPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `plot` to look up the row to connect. */
export type PlotPlotExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `plot` to look up the row to delete. */
export type PlotPlotExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `plot` to look up the row to connect. */
export type PlotPlotNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `plot` to look up the row to delete. */
export type PlotPlotNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `plot` to look up the row to connect. */
export type PlotPlotPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plot` to look up the row to delete. */
export type PlotPlotPkeyDelete = {
  id: Scalars['UUID'];
};

export type PlotPublicGrossSpace = {
  __typename?: 'PlotPublicGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotPublicGrossSpace`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `PlotPublicGrossSpace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PlotPublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `PlotPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type PlotPublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotPublicGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotPublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotPublicGrossSpaceFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `PlotPublicGrossSpace` */
export type PlotPublicGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `plotPublicGrossSpace` to look up the row to update. */
export type PlotPublicGrossSpaceOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotPublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotPublicGrossSpace` being updated. */
  patch: UpdatePlotPublicGrossSpaceOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyPatch;
};

/** Represents an update to a `PlotPublicGrossSpace`. Fields that are set will be updated. */
export type PlotPublicGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `plot` in the `PlotPublicGrossSpaceInput` mutation. */
export type PlotPublicGrossSpacePlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotPublicGrossSpace` in the `PlotInput` mutation. */
export type PlotPublicGrossSpacePlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotPublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotPublicGrossSpacePlotPublicGrossSpacePkeyConnect>>;
  /** A `PlotPublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotPublicGrossSpacePlotIdFkeyPlotPublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `plotPublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotPublicGrossSpacePlotPublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `plotPublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotPublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotPublicGrossSpaceOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyUsingPlotPublicGrossSpacePkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotPublicGrossSpacePlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotPublicGrossSpace` to be created by this mutation. */
export type PlotPublicGrossSpacePlotIdFkeyPlotPublicGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `plotPublicGrossSpace` to look up the row to connect. */
export type PlotPublicGrossSpacePlotPublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotPublicGrossSpace` to look up the row to delete. */
export type PlotPublicGrossSpacePlotPublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PlotPublicGrossSpace` values. */
export type PlotPublicGrossSpacesConnection = {
  __typename?: 'PlotPublicGrossSpacesConnection';
  /** A list of edges which contains the `PlotPublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<PlotPublicGrossSpacesEdge>;
  /** A list of `PlotPublicGrossSpace` objects. */
  nodes: Array<PlotPublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotPublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotPublicGrossSpace` edge in the connection. */
export type PlotPublicGrossSpacesEdge = {
  __typename?: 'PlotPublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotPublicGrossSpace` at the end of the edge. */
  node: PlotPublicGrossSpace;
};

/** Methods to use when ordering `PlotPublicGrossSpace`. */
export enum PlotPublicGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against many `AllocationPlot` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyAllocationPlotFilter = {
  /** Every related `AllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationPlotFilter>;
  /** No related `AllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationPlotFilter>;
  /** Some related `AllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationPlotFilter>;
};

/** A filter to be used against many `PlotCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotCadGrossSpaceMinFilter = {
  /** Every related `PlotCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotCadGrossSpaceMinFilter>;
  /** No related `PlotCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotCadGrossSpaceMinFilter>;
  /** Some related `PlotCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotCadGrossSpaceMinFilter>;
};

/** A filter to be used against many `PlotDescription` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotDescriptionFilter = {
  /** Every related `PlotDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotDescriptionFilter>;
  /** No related `PlotDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotDescriptionFilter>;
  /** Some related `PlotDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotDescriptionFilter>;
};

/** A filter to be used against many `PlotNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameExtraFilter = {
  /** Every related `PlotNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameExtraFilter>;
  /** No related `PlotNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameExtraFilter>;
  /** Some related `PlotNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameExtraFilter>;
};

/** A filter to be used against many `PlotNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameKeyCadFilter = {
  /** Every related `PlotNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameKeyCadFilter>;
  /** No related `PlotNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameKeyCadFilter>;
  /** Some related `PlotNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameKeyCadFilter>;
};

/** A filter to be used against many `PlotNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameKeyCafmFilter = {
  /** Every related `PlotNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameKeyCafmFilter>;
  /** No related `PlotNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameKeyCafmFilter>;
  /** Some related `PlotNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameKeyCafmFilter>;
};

/** A filter to be used against many `PlotNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameKeyEbmFilter = {
  /** Every related `PlotNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameKeyEbmFilter>;
  /** No related `PlotNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameKeyEbmFilter>;
  /** Some related `PlotNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameKeyEbmFilter>;
};

/** A filter to be used against many `PlotNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameKeyMarketingFilter = {
  /** Every related `PlotNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameKeyMarketingFilter>;
  /** No related `PlotNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameKeyMarketingFilter>;
  /** Some related `PlotNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameKeyMarketingFilter>;
};

/** A filter to be used against many `PlotNameLong` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameLongFilter = {
  /** Every related `PlotNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameLongFilter>;
  /** No related `PlotNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameLongFilter>;
  /** Some related `PlotNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameLongFilter>;
};

/** A filter to be used against many `PlotNameShort` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotNameShortFilter = {
  /** Every related `PlotNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotNameShortFilter>;
  /** No related `PlotNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotNameShortFilter>;
  /** Some related `PlotNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotNameShortFilter>;
};

/** A filter to be used against many `PlotPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotPublicGrossSpaceFilter = {
  /** Every related `PlotPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotPublicGrossSpaceFilter>;
  /** No related `PlotPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotPublicGrossSpaceFilter>;
  /** Some related `PlotPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotPublicGrossSpaceFilter>;
};

/** A filter to be used against many `PlotTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyPlotTypeAttrFilter = {
  /** Every related `PlotTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotTypeAttrFilter>;
  /** No related `PlotTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotTypeAttrFilter>;
  /** Some related `PlotTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotTypeAttrFilter>;
};

/** A filter to be used against many `ProjectAllocationPlot` object types. All fields are combined with a logical ‘and.’ */
export type PlotToManyProjectAllocationPlotFilter = {
  /** Every related `ProjectAllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationPlotFilter>;
  /** No related `ProjectAllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationPlotFilter>;
  /** Some related `ProjectAllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationPlotFilter>;
};

export type PlotType = {
  __typename?: 'PlotType';
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `PlotTypeAttr`. */
  plotTypeAttrs: PlotTypeAttrsConnection;
  /** Reads and enables pagination through a set of `Plot`. */
  plotsByTypeId: PlotsConnection;
};


export type PlotTypePlotTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotTypeAttrCondition>;
  filter?: InputMaybe<PlotTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotTypeAttrsOrderBy>>;
};


export type PlotTypePlotsByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotCondition>;
  filter?: InputMaybe<PlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotsOrderBy>>;
};

export type PlotTypeAttr = {
  __typename?: 'PlotTypeAttr';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Plot` that is related to this `PlotTypeAttr`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  /** Reads a single `PlotType` that is related to this `PlotTypeAttr`. */
  plotType: PlotType;
  plotTypeId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `PlotTypeAttr` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PlotTypeAttrCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `plotTypeId` field. */
  plotTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `PlotTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type PlotTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotTypeAttrFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotTypeAttrFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `plotType` relation. */
  plotType?: InputMaybe<PlotTypeFilter>;
  /** Filter by the object’s `plotTypeId` field. */
  plotTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PlotTypeAttr` */
export type PlotTypeAttrInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotTypeAttrPlotIdFkeyInput>;
  plotTypeId?: InputMaybe<Scalars['UUID']>;
  plotTypeToPlotTypeId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `plotTypeAttr` to look up the row to update. */
export type PlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotTypeAttr` being updated. */
  patch: UpdatePlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyPatch;
};

/** The fields on `plotTypeAttr` to look up the row to update. */
export type PlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyUsingPlotTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotTypeAttr` being updated. */
  patch: UpdatePlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyPatch;
};

/** Represents an update to a `PlotTypeAttr`. Fields that are set will be updated. */
export type PlotTypeAttrPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotTypeAttrPlotIdFkeyInput>;
  plotTypeId?: InputMaybe<Scalars['UUID']>;
  plotTypeToPlotTypeId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `plot` in the `PlotTypeAttrInput` mutation. */
export type PlotTypeAttrPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotTypeAttrPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `plotTypeAttr` in the `PlotInput` mutation. */
export type PlotTypeAttrPlotIdFkeyInverseInput = {
  /** The primary key(s) for `plotTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotTypeAttrPlotTypeAttrPkeyConnect>>;
  /** A `PlotTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotTypeAttrPlotIdFkeyPlotTypeAttrCreateInput>>;
  /** The primary key(s) for `plotTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotTypeAttrPlotTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `plotTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyUsingPlotTypeAttrPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotTypeAttrPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `plotTypeAttr` to be created by this mutation. */
export type PlotTypeAttrPlotIdFkeyPlotTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotTypeAttrPlotIdFkeyInput>;
  plotTypeId?: InputMaybe<Scalars['UUID']>;
  plotTypeToPlotTypeId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `plotTypeAttr` to look up the row to connect. */
export type PlotTypeAttrPlotTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotTypeAttr` to look up the row to delete. */
export type PlotTypeAttrPlotTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `plotType` in the `PlotTypeAttrInput` mutation. */
export type PlotTypeAttrPlotTypeIdFkeyInput = {
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  connectById?: InputMaybe<PlotTypePlotTypePkeyConnect>;
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  connectByName?: InputMaybe<PlotTypePlotTypeNameKeyConnect>;
  /** A `PlotTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyPlotTypeCreateInput>;
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotTypePlotTypePkeyDelete>;
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  deleteByName?: InputMaybe<PlotTypePlotTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `plotType` for the far side of the relationship. */
  updateById?: InputMaybe<PlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyUsingPlotTypePkeyUpdate>;
  /** The primary key(s) and patch data for `plotType` for the far side of the relationship. */
  updateByName?: InputMaybe<PlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyUsingPlotTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `plotTypeAttr` in the `PlotTypeInput` mutation. */
export type PlotTypeAttrPlotTypeIdFkeyInverseInput = {
  /** The primary key(s) for `plotTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotTypeAttrPlotTypeAttrPkeyConnect>>;
  /** A `PlotTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotTypeAttrPlotTypeIdFkeyPlotTypeAttrCreateInput>>;
  /** The primary key(s) for `plotTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotTypeAttrPlotTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `plotTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plotTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyUsingPlotTypeAttrPkeyUpdate>>;
};

/** The `plotTypeAttr` to be created by this mutation. */
export type PlotTypeAttrPlotTypeIdFkeyPlotTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotTypeAttrPlotIdFkeyInput>;
  plotTypeToPlotTypeId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `plotType` to be created by this mutation. */
export type PlotTypeAttrPlotTypeIdFkeyPlotTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInverseInput>;
  plotsUsingId?: InputMaybe<PlotTypeIdFkeyInverseInput>;
};

/** A connection to a list of `PlotTypeAttr` values. */
export type PlotTypeAttrsConnection = {
  __typename?: 'PlotTypeAttrsConnection';
  /** A list of edges which contains the `PlotTypeAttr` and cursor to aid in pagination. */
  edges: Array<PlotTypeAttrsEdge>;
  /** A list of `PlotTypeAttr` objects. */
  nodes: Array<PlotTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotTypeAttr` edge in the connection. */
export type PlotTypeAttrsEdge = {
  __typename?: 'PlotTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotTypeAttr` at the end of the edge. */
  node: PlotTypeAttr;
};

/** Methods to use when ordering `PlotTypeAttr`. */
export enum PlotTypeAttrsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PlotTypeByPlotTypeIdDescriptionAsc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__DESCRIPTION_ASC',
  PlotTypeByPlotTypeIdDescriptionDesc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__DESCRIPTION_DESC',
  PlotTypeByPlotTypeIdIdAsc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__ID_ASC',
  PlotTypeByPlotTypeIdIdDesc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__ID_DESC',
  PlotTypeByPlotTypeIdIndexAsc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__INDEX_ASC',
  PlotTypeByPlotTypeIdIndexDesc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__INDEX_DESC',
  PlotTypeByPlotTypeIdNameAsc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__NAME_ASC',
  PlotTypeByPlotTypeIdNameDesc = 'PLOT_TYPE_BY_PLOT_TYPE_ID__NAME_DESC',
  PlotTypeIdAsc = 'PLOT_TYPE_ID_ASC',
  PlotTypeIdDesc = 'PLOT_TYPE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/**
 * A condition to be used against `PlotType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PlotTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PlotType` object types. All fields are combined with a logical ‘and.’ */
export type PlotTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlotTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlotTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlotTypeFilter>>;
  /** Filter by the object’s `plotTypeAttrs` relation. */
  plotTypeAttrs?: InputMaybe<PlotTypeToManyPlotTypeAttrFilter>;
  /** Some related `plotTypeAttrs` exist. */
  plotTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `plotsByTypeId` relation. */
  plotsByTypeId?: InputMaybe<PlotTypeToManyPlotFilter>;
  /** Some related `plotsByTypeId` exist. */
  plotsByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `plotType` in the `PlotInput` mutation. */
export type PlotTypeIdFkeyInput = {
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  connectById?: InputMaybe<PlotTypePlotTypePkeyConnect>;
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  connectByName?: InputMaybe<PlotTypePlotTypeNameKeyConnect>;
  /** A `PlotTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PlotTypeIdFkeyPlotTypeCreateInput>;
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotTypePlotTypePkeyDelete>;
  /** The primary key(s) for `plotType` for the far side of the relationship. */
  deleteByName?: InputMaybe<PlotTypePlotTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `plotType` for the far side of the relationship. */
  updateById?: InputMaybe<PlotTypeOnPlotForPlotTypeIdFkeyUsingPlotTypePkeyUpdate>;
  /** The primary key(s) and patch data for `plotType` for the far side of the relationship. */
  updateByName?: InputMaybe<PlotTypeOnPlotForPlotTypeIdFkeyUsingPlotTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `plot` in the `PlotTypeInput` mutation. */
export type PlotTypeIdFkeyInverseInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<PlotPlotExtIdKeyConnect>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PlotPlotPkeyConnect>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<PlotPlotNameShortKeyConnect>>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PlotTypeIdFkeyPlotCreateInput>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<PlotPlotExtIdKeyDelete>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PlotPlotPkeyDelete>>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<PlotPlotNameShortKeyDelete>>;
  /** Flag indicating whether all other `plot` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<PlotOnPlotForPlotTypeIdFkeyUsingPlotExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PlotOnPlotForPlotTypeIdFkeyUsingPlotPkeyUpdate>>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<PlotOnPlotForPlotTypeIdFkeyUsingPlotNameShortKeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type PlotTypeIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
};

/** The `plotType` to be created by this mutation. */
export type PlotTypeIdFkeyPlotTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInverseInput>;
  plotsUsingId?: InputMaybe<PlotTypeIdFkeyInverseInput>;
};

/** An input for mutations affecting `PlotType` */
export type PlotTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInverseInput>;
  plotsUsingId?: InputMaybe<PlotTypeIdFkeyInverseInput>;
};

/** The fields on `plotType` to look up the row to update. */
export type PlotTypeOnPlotForPlotTypeIdFkeyUsingPlotTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `plotType` being updated. */
  patch: UpdatePlotTypeOnPlotForPlotTypeIdFkeyPatch;
};

/** The fields on `plotType` to look up the row to update. */
export type PlotTypeOnPlotForPlotTypeIdFkeyUsingPlotTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotType` being updated. */
  patch: UpdatePlotTypeOnPlotForPlotTypeIdFkeyPatch;
};

/** The fields on `plotType` to look up the row to update. */
export type PlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyUsingPlotTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `plotType` being updated. */
  patch: UpdatePlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyPatch;
};

/** The fields on `plotType` to look up the row to update. */
export type PlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyUsingPlotTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `plotType` being updated. */
  patch: UpdatePlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyPatch;
};

/** Represents an update to a `PlotType`. Fields that are set will be updated. */
export type PlotTypePatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInverseInput>;
  plotsUsingId?: InputMaybe<PlotTypeIdFkeyInverseInput>;
};

/** The fields on `plotType` to look up the row to connect. */
export type PlotTypePlotTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `plotType` to look up the row to delete. */
export type PlotTypePlotTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `plotType` to look up the row to connect. */
export type PlotTypePlotTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `plotType` to look up the row to delete. */
export type PlotTypePlotTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Plot` object types. All fields are combined with a logical ‘and.’ */
export type PlotTypeToManyPlotFilter = {
  /** Every related `Plot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotFilter>;
  /** No related `Plot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotFilter>;
  /** Some related `Plot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotFilter>;
};

/** A filter to be used against many `PlotTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type PlotTypeToManyPlotTypeAttrFilter = {
  /** Every related `PlotTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlotTypeAttrFilter>;
  /** No related `PlotTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlotTypeAttrFilter>;
  /** Some related `PlotTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlotTypeAttrFilter>;
};

/** A connection to a list of `PlotType` values. */
export type PlotTypesConnection = {
  __typename?: 'PlotTypesConnection';
  /** A list of edges which contains the `PlotType` and cursor to aid in pagination. */
  edges: Array<PlotTypesEdge>;
  /** A list of `PlotType` objects. */
  nodes: Array<PlotType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlotType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PlotType` edge in the connection. */
export type PlotTypesEdge = {
  __typename?: 'PlotTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PlotType` at the end of the edge. */
  node: PlotType;
};

/** Methods to use when ordering `PlotType`. */
export enum PlotTypesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PlotsByTypeIdCountAsc = 'PLOTS_BY_TYPE_ID__COUNT_ASC',
  PlotsByTypeIdCountDesc = 'PLOTS_BY_TYPE_ID__COUNT_DESC',
  PlotTypeAttrsByPlotTypeIdCountAsc = 'PLOT_TYPE_ATTRS_BY_PLOT_TYPE_ID__COUNT_ASC',
  PlotTypeAttrsByPlotTypeIdCountDesc = 'PLOT_TYPE_ATTRS_BY_PLOT_TYPE_ID__COUNT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Plot` values. */
export type PlotsConnection = {
  __typename?: 'PlotsConnection';
  /** A list of edges which contains the `Plot` and cursor to aid in pagination. */
  edges: Array<PlotsEdge>;
  /** A list of `Plot` objects. */
  nodes: Array<Plot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Plot` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Plot` edge in the connection. */
export type PlotsEdge = {
  __typename?: 'PlotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Plot` at the end of the edge. */
  node: Plot;
};

/** Methods to use when ordering `Plot`. */
export enum PlotsOrderBy {
  AllocationPlotsByPlotIdCountAsc = 'ALLOCATION_PLOTS_BY_PLOT_ID__COUNT_ASC',
  AllocationPlotsByPlotIdCountDesc = 'ALLOCATION_PLOTS_BY_PLOT_ID__COUNT_DESC',
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PlotCadGrossSpaceMinsByPlotIdCountAsc = 'PLOT_CAD_GROSS_SPACE_MINS_BY_PLOT_ID__COUNT_ASC',
  PlotCadGrossSpaceMinsByPlotIdCountDesc = 'PLOT_CAD_GROSS_SPACE_MINS_BY_PLOT_ID__COUNT_DESC',
  PlotDescriptionsByPlotIdCountAsc = 'PLOT_DESCRIPTIONS_BY_PLOT_ID__COUNT_ASC',
  PlotDescriptionsByPlotIdCountDesc = 'PLOT_DESCRIPTIONS_BY_PLOT_ID__COUNT_DESC',
  PlotNameExtrasByPlotIdCountAsc = 'PLOT_NAME_EXTRAS_BY_PLOT_ID__COUNT_ASC',
  PlotNameExtrasByPlotIdCountDesc = 'PLOT_NAME_EXTRAS_BY_PLOT_ID__COUNT_DESC',
  PlotNameKeyCadsByPlotIdCountAsc = 'PLOT_NAME_KEY_CADS_BY_PLOT_ID__COUNT_ASC',
  PlotNameKeyCadsByPlotIdCountDesc = 'PLOT_NAME_KEY_CADS_BY_PLOT_ID__COUNT_DESC',
  PlotNameKeyCafmsByPlotIdCountAsc = 'PLOT_NAME_KEY_CAFMS_BY_PLOT_ID__COUNT_ASC',
  PlotNameKeyCafmsByPlotIdCountDesc = 'PLOT_NAME_KEY_CAFMS_BY_PLOT_ID__COUNT_DESC',
  PlotNameKeyEbmsByPlotIdCountAsc = 'PLOT_NAME_KEY_EBMS_BY_PLOT_ID__COUNT_ASC',
  PlotNameKeyEbmsByPlotIdCountDesc = 'PLOT_NAME_KEY_EBMS_BY_PLOT_ID__COUNT_DESC',
  PlotNameKeyMarketingsByPlotIdCountAsc = 'PLOT_NAME_KEY_MARKETINGS_BY_PLOT_ID__COUNT_ASC',
  PlotNameKeyMarketingsByPlotIdCountDesc = 'PLOT_NAME_KEY_MARKETINGS_BY_PLOT_ID__COUNT_DESC',
  PlotNameLongsByPlotIdCountAsc = 'PLOT_NAME_LONGS_BY_PLOT_ID__COUNT_ASC',
  PlotNameLongsByPlotIdCountDesc = 'PLOT_NAME_LONGS_BY_PLOT_ID__COUNT_DESC',
  PlotNameShortsByPlotIdCountAsc = 'PLOT_NAME_SHORTS_BY_PLOT_ID__COUNT_ASC',
  PlotNameShortsByPlotIdCountDesc = 'PLOT_NAME_SHORTS_BY_PLOT_ID__COUNT_DESC',
  PlotPublicGrossSpacesByPlotIdCountAsc = 'PLOT_PUBLIC_GROSS_SPACES_BY_PLOT_ID__COUNT_ASC',
  PlotPublicGrossSpacesByPlotIdCountDesc = 'PLOT_PUBLIC_GROSS_SPACES_BY_PLOT_ID__COUNT_DESC',
  PlotTypeAttrsByPlotIdCountAsc = 'PLOT_TYPE_ATTRS_BY_PLOT_ID__COUNT_ASC',
  PlotTypeAttrsByPlotIdCountDesc = 'PLOT_TYPE_ATTRS_BY_PLOT_ID__COUNT_DESC',
  PlotTypeByTypeIdDescriptionAsc = 'PLOT_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  PlotTypeByTypeIdDescriptionDesc = 'PLOT_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  PlotTypeByTypeIdIdAsc = 'PLOT_TYPE_BY_TYPE_ID__ID_ASC',
  PlotTypeByTypeIdIdDesc = 'PLOT_TYPE_BY_TYPE_ID__ID_DESC',
  PlotTypeByTypeIdIndexAsc = 'PLOT_TYPE_BY_TYPE_ID__INDEX_ASC',
  PlotTypeByTypeIdIndexDesc = 'PLOT_TYPE_BY_TYPE_ID__INDEX_DESC',
  PlotTypeByTypeIdNameAsc = 'PLOT_TYPE_BY_TYPE_ID__NAME_ASC',
  PlotTypeByTypeIdNameDesc = 'PLOT_TYPE_BY_TYPE_ID__NAME_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationPlotsByPlotIdCountAsc = 'PROJECT_ALLOCATION_PLOTS_BY_PLOT_ID__COUNT_ASC',
  ProjectAllocationPlotsByPlotIdCountDesc = 'PROJECT_ALLOCATION_PLOTS_BY_PLOT_ID__COUNT_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

export type Project = {
  __typename?: 'Project';
  allocationHints: Scalars['String'];
  businessDomain: Scalars['String'];
  category: Scalars['String'];
  companyGroup: Scalars['String'];
  department: Scalars['String'];
  description: Scalars['String'];
  disturbanceDust: Scalars['String'];
  disturbanceNoise: Scalars['String'];
  disturbanceOther: Scalars['String'];
  executionYear: Scalars['Int'];
  id: Scalars['UUID'];
  locationRequirements: Scalars['String'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  notesAppointment: Scalars['String'];
  notesDayOrder: Scalars['String'];
  organisationalChanges: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherDocuments?: Maybe<Multilink>;
  otherDocumentsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherLinks?: Maybe<Multilink>;
  otherLinksId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherSystems?: Maybe<Multilink>;
  otherSystemsId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ProjectVariant`. */
  projectVariants: ProjectVariantsConnection;
  /** Reads a single `ProjectSeries` that is related to this `Project`. */
  series?: Maybe<ProjectSeries>;
  seriesId?: Maybe<Scalars['UUID']>;
  status: Scalars['String'];
  subtitle: Scalars['String'];
  type: Scalars['String'];
};


export type ProjectProjectVariantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectVariantCondition>;
  filter?: InputMaybe<ProjectVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

export type ProjectAllocationArea = {
  __typename?: 'ProjectAllocationArea';
  /** Reads a single `Area` that is related to this `ProjectAllocationArea`. */
  area: Area;
  areaId: Scalars['UUID'];
  conflicts: Scalars['Int'];
  end: Scalars['Datetime'];
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `ProjectAllocationAreaPhase`. */
  projectAllocationAreaPhasesByAllocationId: ProjectAllocationAreaPhasesConnection;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationArea`. */
  projectVariant: ProjectVariant;
  projectVariantId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProjectVariant`. */
  projectVariantsByReferenceProjectAllocationAreaId: ProjectVariantsConnection;
  start: Scalars['Datetime'];
};


export type ProjectAllocationAreaProjectAllocationAreaPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationAreaPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationAreaPhasesOrderBy>>;
};


export type ProjectAllocationAreaProjectVariantsByReferenceProjectAllocationAreaIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectVariantCondition>;
  filter?: InputMaybe<ProjectVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** The `area` to be created by this mutation. */
export type ProjectAllocationAreaAreaIdFkeyAreaCreateInput = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** Input for the nested mutation of `area` in the `ProjectAllocationAreaInput` mutation. */
export type ProjectAllocationAreaAreaIdFkeyInput = {
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByExtId?: InputMaybe<AreaAreaExtIdKeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectById?: InputMaybe<AreaAreaPkeyConnect>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<AreaAreaNameShortKeyConnect>;
  /** A `AreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationAreaAreaIdFkeyAreaCreateInput>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<AreaAreaExtIdKeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteById?: InputMaybe<AreaAreaPkeyDelete>;
  /** The primary key(s) for `area` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<AreaAreaNameShortKeyDelete>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByExtId?: InputMaybe<AreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingAreaExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateById?: InputMaybe<AreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingAreaPkeyUpdate>;
  /** The primary key(s) and patch data for `area` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<AreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingAreaNameShortKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationArea` in the `AreaInput` mutation. */
export type ProjectAllocationAreaAreaIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationAreaProjectAllocationAreaPkeyConnect>>;
  /** A `ProjectAllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationAreaAreaIdFkeyProjectAllocationAreaCreateInput>>;
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationAreaProjectAllocationAreaPkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationArea` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingProjectAllocationAreaPkeyUpdate>>;
};

/** The `projectAllocationArea` to be created by this mutation. */
export type ProjectAllocationAreaAreaIdFkeyProjectAllocationAreaCreateInput = {
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start: Scalars['Datetime'];
};

/**
 * A condition to be used against `ProjectAllocationArea` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationAreaCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `conflicts` field. */
  conflicts?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `projectVariantId` field. */
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** All input for the `projectAllocationAreaDuplicate` mutation. */
export type ProjectAllocationAreaDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The output of our `projectAllocationAreaDuplicate` mutation. */
export type ProjectAllocationAreaDuplicatePayload = {
  __typename?: 'ProjectAllocationAreaDuplicatePayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our `projectAllocationAreaDuplicate` mutation. */
export type ProjectAllocationAreaDuplicatePayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** A filter to be used against `ProjectAllocationArea` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationAreaFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationAreaFilter>>;
  /** Filter by the object’s `area` relation. */
  area?: InputMaybe<AreaFilter>;
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `conflicts` field. */
  conflicts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationAreaFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationAreaFilter>>;
  /** Filter by the object’s `projectAllocationAreaPhasesByAllocationId` relation. */
  projectAllocationAreaPhasesByAllocationId?: InputMaybe<ProjectAllocationAreaToManyProjectAllocationAreaPhaseFilter>;
  /** Some related `projectAllocationAreaPhasesByAllocationId` exist. */
  projectAllocationAreaPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectVariant` relation. */
  projectVariant?: InputMaybe<ProjectVariantFilter>;
  /** Filter by the object’s `projectVariantId` field. */
  projectVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectVariantsByReferenceProjectAllocationAreaId` relation. */
  projectVariantsByReferenceProjectAllocationAreaId?: InputMaybe<ProjectAllocationAreaToManyProjectVariantFilter>;
  /** Some related `projectVariantsByReferenceProjectAllocationAreaId` exist. */
  projectVariantsByReferenceProjectAllocationAreaIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectAllocationArea` */
export type ProjectAllocationAreaInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start: Scalars['Datetime'];
};

/** The fields on `projectAllocationArea` to look up the row to update. */
export type ProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyUsingProjectAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
  patch: UpdateProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyPatch;
};

/** The fields on `projectAllocationArea` to look up the row to update. */
export type ProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyUsingProjectAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
  patch: UpdateProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyPatch;
};

/** The fields on `projectAllocationArea` to look up the row to update. */
export type ProjectAllocationAreaOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
  patch: UpdateProjectAllocationAreaOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyPatch;
};

/** The fields on `projectAllocationArea` to look up the row to update. */
export type ProjectAllocationAreaOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlUsingProjectAllocationAreaPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
  patch: UpdateProjectAllocationAreaOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlPatch;
};

/** Represents an update to a `ProjectAllocationArea`. Fields that are set will be updated. */
export type ProjectAllocationAreaPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type ProjectAllocationAreaPhase = {
  __typename?: 'ProjectAllocationAreaPhase';
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectAllocationAreaPhase`. */
  allocation: ProjectAllocationArea;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationAreaPhase`. */
  usage: ProjectAllocationUsage;
  usageId: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationArea` in the `ProjectAllocationAreaPhaseInput` mutation. */
export type ProjectAllocationAreaPhaseAllocationIdFkeyInput = {
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationAreaProjectAllocationAreaPkeyConnect>;
  /** A `ProjectAllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaCreateInput>;
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationAreaProjectAllocationAreaPkeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationAreaOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPkeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationAreaPhase` in the `ProjectAllocationAreaInput` mutation. */
export type ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationAreaPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyConnect>>;
  /** A `ProjectAllocationAreaPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput>>;
  /** The primary key(s) for `projectAllocationAreaPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationAreaPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationAreaPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate>>;
};

/** The `projectAllocationArea` to be created by this mutation. */
export type ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaCreateInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start: Scalars['Datetime'];
};

/** The `projectAllocationAreaPhase` to be created by this mutation. */
export type ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput = {
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationAreaToAllocationId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `ProjectAllocationAreaPhase` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationAreaPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ProjectAllocationAreaPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationAreaPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<ProjectAllocationAreaFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationAreaPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationAreaPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<ProjectAllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProjectAllocationAreaPhase` */
export type ProjectAllocationAreaPhaseInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationAreaToAllocationId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectAllocationAreaPhase` to look up the row to update. */
export type ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationAreaPhase` being updated. */
  patch: UpdateProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyPatch;
};

/** The fields on `projectAllocationAreaPhase` to look up the row to update. */
export type ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationAreaPhase` being updated. */
  patch: UpdateProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch;
};

/** Represents an update to a `ProjectAllocationAreaPhase`. Fields that are set will be updated. */
export type ProjectAllocationAreaPhasePatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationAreaToAllocationId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectAllocationAreaPhase` to look up the row to connect. */
export type ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationAreaPhase` to look up the row to delete. */
export type ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationUsage` in the `ProjectAllocationAreaPhaseInput` mutation. */
export type ProjectAllocationAreaPhaseUsageIdFkeyInput = {
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePkeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageTypeKeyConnect>;
  /** A `ProjectAllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyProjectAllocationUsageCreateInput>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePkeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationAreaPhase` in the `ProjectAllocationUsageInput` mutation. */
export type ProjectAllocationAreaPhaseUsageIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationAreaPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyConnect>>;
  /** A `ProjectAllocationAreaPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationAreaPhaseUsageIdFkeyProjectAllocationAreaPhaseCreateInput>>;
  /** The primary key(s) for `projectAllocationAreaPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationAreaPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationAreaPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate>>;
};

/** The `projectAllocationAreaPhase` to be created by this mutation. */
export type ProjectAllocationAreaPhaseUsageIdFkeyProjectAllocationAreaPhaseCreateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationAreaToAllocationId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `projectAllocationUsage` to be created by this mutation. */
export type ProjectAllocationAreaPhaseUsageIdFkeyProjectAllocationUsageCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type: ProjectAllocationUsageType;
};

/** A connection to a list of `ProjectAllocationAreaPhase` values. */
export type ProjectAllocationAreaPhasesConnection = {
  __typename?: 'ProjectAllocationAreaPhasesConnection';
  /** A list of edges which contains the `ProjectAllocationAreaPhase` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationAreaPhasesEdge>;
  /** A list of `ProjectAllocationAreaPhase` objects. */
  nodes: Array<ProjectAllocationAreaPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationAreaPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationAreaPhase` edge in the connection. */
export type ProjectAllocationAreaPhasesEdge = {
  __typename?: 'ProjectAllocationAreaPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationAreaPhase` at the end of the edge. */
  node: ProjectAllocationAreaPhase;
};

/** Methods to use when ordering `ProjectAllocationAreaPhase`. */
export enum ProjectAllocationAreaPhasesOrderBy {
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationAreaByAllocationIdAreaIdAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__AREA_ID_ASC',
  ProjectAllocationAreaByAllocationIdAreaIdDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__AREA_ID_DESC',
  ProjectAllocationAreaByAllocationIdConflictsAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__CONFLICTS_ASC',
  ProjectAllocationAreaByAllocationIdConflictsDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__CONFLICTS_DESC',
  ProjectAllocationAreaByAllocationIdEndAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__END_ASC',
  ProjectAllocationAreaByAllocationIdEndDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__END_DESC',
  ProjectAllocationAreaByAllocationIdIdAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__ID_ASC',
  ProjectAllocationAreaByAllocationIdIdDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__ID_DESC',
  ProjectAllocationAreaByAllocationIdIsOptionalAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  ProjectAllocationAreaByAllocationIdIsOptionalDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  ProjectAllocationAreaByAllocationIdProjectVariantIdAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__PROJECT_VARIANT_ID_ASC',
  ProjectAllocationAreaByAllocationIdProjectVariantIdDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__PROJECT_VARIANT_ID_DESC',
  ProjectAllocationAreaByAllocationIdStartAsc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__START_ASC',
  ProjectAllocationAreaByAllocationIdStartDesc = 'PROJECT_ALLOCATION_AREA_BY_ALLOCATION_ID__START_DESC',
  ProjectAllocationUsageByUsageIdIdAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  ProjectAllocationUsageByUsageIdIdDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  ProjectAllocationUsageByUsageIdIsExecutionAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  ProjectAllocationUsageByUsageIdIsExecutionDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  ProjectAllocationUsageByUsageIdNameAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  ProjectAllocationUsageByUsageIdNameDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  ProjectAllocationUsageByUsageIdNameShortAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  ProjectAllocationUsageByUsageIdNameShortDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  ProjectAllocationUsageByUsageIdPositionAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  ProjectAllocationUsageByUsageIdPositionDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  ProjectAllocationUsageByUsageIdTypeAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  ProjectAllocationUsageByUsageIdTypeDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** The fields on `projectAllocationArea` to look up the row to connect. */
export type ProjectAllocationAreaProjectAllocationAreaPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationArea` to look up the row to delete. */
export type ProjectAllocationAreaProjectAllocationAreaPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `projectVariant` in the `ProjectAllocationAreaInput` mutation. */
export type ProjectAllocationAreaProjectVariantIdFkeyInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectVariantProjectVariantPkeyConnect>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<ProjectVariantProjectVariantProjectIdIndexKeyConnect>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyProjectVariantCreateInput>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectVariantProjectVariantPkeyDelete>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<ProjectVariantProjectVariantProjectIdIndexKeyDelete>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyUsingProjectVariantPkeyUpdate>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<ProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationArea` in the `ProjectVariantInput` mutation. */
export type ProjectAllocationAreaProjectVariantIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationAreaProjectAllocationAreaPkeyConnect>>;
  /** A `ProjectAllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationAreaProjectVariantIdFkeyProjectAllocationAreaCreateInput>>;
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationAreaProjectAllocationAreaPkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationArea` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyUsingProjectAllocationAreaPkeyUpdate>>;
};

/** The `projectAllocationArea` to be created by this mutation. */
export type ProjectAllocationAreaProjectVariantIdFkeyProjectAllocationAreaCreateInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start: Scalars['Datetime'];
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectAllocationAreaProjectVariantIdFkeyProjectVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ProjectAllocationAreaPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationAreaToManyProjectAllocationAreaPhaseFilter = {
  /** Every related `ProjectAllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  /** No related `ProjectAllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  /** Some related `ProjectAllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
};

/** A filter to be used against many `ProjectVariant` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationAreaToManyProjectVariantFilter = {
  /** Every related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectVariantFilter>;
  /** No related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectVariantFilter>;
  /** Some related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectVariantFilter>;
};

/** All input for the `projectAllocationAreaUpdateAndDuplicate` mutation. */
export type ProjectAllocationAreaUpdateAndDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  updateAllocation?: InputMaybe<AllocationUpdateInput>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>>>;
};

/** The output of our `projectAllocationAreaUpdateAndDuplicate` mutation. */
export type ProjectAllocationAreaUpdateAndDuplicatePayload = {
  __typename?: 'ProjectAllocationAreaUpdateAndDuplicatePayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our `projectAllocationAreaUpdateAndDuplicate` mutation. */
export type ProjectAllocationAreaUpdateAndDuplicatePayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** A connection to a list of `ProjectAllocationArea` values. */
export type ProjectAllocationAreasConnection = {
  __typename?: 'ProjectAllocationAreasConnection';
  /** A list of edges which contains the `ProjectAllocationArea` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationAreasEdge>;
  /** A list of `ProjectAllocationArea` objects. */
  nodes: Array<ProjectAllocationArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationArea` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationArea` edge in the connection. */
export type ProjectAllocationAreasEdge = {
  __typename?: 'ProjectAllocationAreasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationArea` at the end of the edge. */
  node: ProjectAllocationArea;
};

/** Methods to use when ordering `ProjectAllocationArea`. */
export enum ProjectAllocationAreasOrderBy {
  AreaByAreaIdDescriptionAsc = 'AREA_BY_AREA_ID__DESCRIPTION_ASC',
  AreaByAreaIdDescriptionDesc = 'AREA_BY_AREA_ID__DESCRIPTION_DESC',
  AreaByAreaIdExtIdAsc = 'AREA_BY_AREA_ID__EXT_ID_ASC',
  AreaByAreaIdExtIdDesc = 'AREA_BY_AREA_ID__EXT_ID_DESC',
  AreaByAreaIdIdAsc = 'AREA_BY_AREA_ID__ID_ASC',
  AreaByAreaIdIdDesc = 'AREA_BY_AREA_ID__ID_DESC',
  AreaByAreaIdNameLongAsc = 'AREA_BY_AREA_ID__NAME_LONG_ASC',
  AreaByAreaIdNameLongDesc = 'AREA_BY_AREA_ID__NAME_LONG_DESC',
  AreaByAreaIdNameShortAsc = 'AREA_BY_AREA_ID__NAME_SHORT_ASC',
  AreaByAreaIdNameShortDesc = 'AREA_BY_AREA_ID__NAME_SHORT_DESC',
  AreaByAreaIdTypeIdAsc = 'AREA_BY_AREA_ID__TYPE_ID_ASC',
  AreaByAreaIdTypeIdDesc = 'AREA_BY_AREA_ID__TYPE_ID_DESC',
  AreaByAreaIdZoneIdAsc = 'AREA_BY_AREA_ID__ZONE_ID_ASC',
  AreaByAreaIdZoneIdDesc = 'AREA_BY_AREA_ID__ZONE_ID_DESC',
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  ConflictsAsc = 'CONFLICTS_ASC',
  ConflictsDesc = 'CONFLICTS_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationAreaPhasesByAllocationIdCountAsc = 'PROJECT_ALLOCATION_AREA_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  ProjectAllocationAreaPhasesByAllocationIdCountDesc = 'PROJECT_ALLOCATION_AREA_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  ProjectVariantsByReferenceProjectAllocationAreaIdCountAsc = 'PROJECT_VARIANTS_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__COUNT_ASC',
  ProjectVariantsByReferenceProjectAllocationAreaIdCountDesc = 'PROJECT_VARIANTS_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__COUNT_DESC',
  ProjectVariantByProjectVariantIdChangesIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CHANGES_ID_ASC',
  ProjectVariantByProjectVariantIdChangesIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CHANGES_ID_DESC',
  ProjectVariantByProjectVariantIdCreatedAtAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CREATED_AT_ASC',
  ProjectVariantByProjectVariantIdCreatedAtDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CREATED_AT_DESC',
  ProjectVariantByProjectVariantIdDescriptionAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__DESCRIPTION_ASC',
  ProjectVariantByProjectVariantIdDescriptionDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__DESCRIPTION_DESC',
  ProjectVariantByProjectVariantIdEndAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__END_ASC',
  ProjectVariantByProjectVariantIdEndDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__END_DESC',
  ProjectVariantByProjectVariantIdIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__ID_ASC',
  ProjectVariantByProjectVariantIdIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__ID_DESC',
  ProjectVariantByProjectVariantIdIndexAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__INDEX_ASC',
  ProjectVariantByProjectVariantIdIndexDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__INDEX_DESC',
  ProjectVariantByProjectVariantIdIsArchivedAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_ARCHIVED_ASC',
  ProjectVariantByProjectVariantIdIsArchivedDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_ARCHIVED_DESC',
  ProjectVariantByProjectVariantIdIsCurrentAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_CURRENT_ASC',
  ProjectVariantByProjectVariantIdIsCurrentDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_CURRENT_DESC',
  ProjectVariantByProjectVariantIdNameAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__NAME_ASC',
  ProjectVariantByProjectVariantIdNameDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__NAME_DESC',
  ProjectVariantByProjectVariantIdProjectIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__PROJECT_ID_ASC',
  ProjectVariantByProjectVariantIdProjectIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__PROJECT_ID_DESC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationAreaIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_AREA_ID_ASC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationAreaIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_AREA_ID_DESC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationRoomIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_ROOM_ID_ASC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationRoomIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_ROOM_ID_DESC',
  ProjectVariantByProjectVariantIdStartAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__START_ASC',
  ProjectVariantByProjectVariantIdStartDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__START_DESC',
  ProjectVariantByProjectVariantIdStatusAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__STATUS_ASC',
  ProjectVariantByProjectVariantIdStatusDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__STATUS_DESC',
  ProjectVariantIdAsc = 'PROJECT_VARIANT_ID_ASC',
  ProjectVariantIdDesc = 'PROJECT_VARIANT_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

export type ProjectAllocationPlot = {
  __typename?: 'ProjectAllocationPlot';
  conflicts: Scalars['Int'];
  end: Scalars['Datetime'];
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  /** Reads a single `Plot` that is related to this `ProjectAllocationPlot`. */
  plot: Plot;
  plotId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProjectAllocationPlotPhase`. */
  projectAllocationPlotPhasesByAllocationId: ProjectAllocationPlotPhasesConnection;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationPlot`. */
  projectVariant: ProjectVariant;
  projectVariantId: Scalars['UUID'];
  start: Scalars['Datetime'];
};


export type ProjectAllocationPlotProjectAllocationPlotPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationPlotPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationPlotPhasesOrderBy>>;
};

/**
 * A condition to be used against `ProjectAllocationPlot` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationPlotCondition = {
  /** Checks for equality with the object’s `conflicts` field. */
  conflicts?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `plotId` field. */
  plotId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectVariantId` field. */
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProjectAllocationPlot` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationPlotFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationPlotFilter>>;
  /** Filter by the object’s `conflicts` field. */
  conflicts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationPlotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationPlotFilter>>;
  /** Filter by the object’s `plot` relation. */
  plot?: InputMaybe<PlotFilter>;
  /** Filter by the object’s `plotId` field. */
  plotId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectAllocationPlotPhasesByAllocationId` relation. */
  projectAllocationPlotPhasesByAllocationId?: InputMaybe<ProjectAllocationPlotToManyProjectAllocationPlotPhaseFilter>;
  /** Some related `projectAllocationPlotPhasesByAllocationId` exist. */
  projectAllocationPlotPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectVariant` relation. */
  projectVariant?: InputMaybe<ProjectVariantFilter>;
  /** Filter by the object’s `projectVariantId` field. */
  projectVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectAllocationPlot` */
export type ProjectAllocationPlotInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The fields on `projectAllocationPlot` to look up the row to update. */
export type ProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingProjectAllocationPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationPlot` being updated. */
  patch: UpdateProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyPatch;
};

/** The fields on `projectAllocationPlot` to look up the row to update. */
export type ProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyUsingProjectAllocationPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationPlot` being updated. */
  patch: UpdateProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyPatch;
};

/** The fields on `projectAllocationPlot` to look up the row to update. */
export type ProjectAllocationPlotOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyUsingProjectAllocationPlotPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationPlot` being updated. */
  patch: UpdateProjectAllocationPlotOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyPatch;
};

/** Represents an update to a `ProjectAllocationPlot`. Fields that are set will be updated. */
export type ProjectAllocationPlotPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type ProjectAllocationPlotPhase = {
  __typename?: 'ProjectAllocationPlotPhase';
  /** Reads a single `ProjectAllocationPlot` that is related to this `ProjectAllocationPlotPhase`. */
  allocation: ProjectAllocationPlot;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationPlotPhase`. */
  usage: ProjectAllocationUsage;
  usageId: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationPlot` in the `ProjectAllocationPlotPhaseInput` mutation. */
export type ProjectAllocationPlotPhaseAllocationIdFkeyInput = {
  /** The primary key(s) for `projectAllocationPlot` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationPlotProjectAllocationPlotPkeyConnect>;
  /** A `ProjectAllocationPlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyProjectAllocationPlotCreateInput>;
  /** The primary key(s) for `projectAllocationPlot` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationPlotProjectAllocationPlotPkeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationPlot` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationPlotOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyUsingProjectAllocationPlotPkeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationPlotPhase` in the `ProjectAllocationPlotInput` mutation. */
export type ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationPlotPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationPlotPhaseProjectAllocationPlotPhasePkeyConnect>>;
  /** A `ProjectAllocationPlotPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationPlotPhaseAllocationIdFkeyProjectAllocationPlotPhaseCreateInput>>;
  /** The primary key(s) for `projectAllocationPlotPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationPlotPhaseProjectAllocationPlotPhasePkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationPlotPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationPlotPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyUsingProjectAllocationPlotPhasePkeyUpdate>>;
};

/** The `projectAllocationPlot` to be created by this mutation. */
export type ProjectAllocationPlotPhaseAllocationIdFkeyProjectAllocationPlotCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `projectAllocationPlotPhase` to be created by this mutation. */
export type ProjectAllocationPlotPhaseAllocationIdFkeyProjectAllocationPlotPhaseCreateInput = {
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationPlotToAllocationId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `ProjectAllocationPlotPhase` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationPlotPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ProjectAllocationPlotPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationPlotPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<ProjectAllocationPlotFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationPlotPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationPlotPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<ProjectAllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProjectAllocationPlotPhase` */
export type ProjectAllocationPlotPhaseInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationPlotToAllocationId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectAllocationPlotPhase` to look up the row to update. */
export type ProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyUsingProjectAllocationPlotPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationPlotPhase` being updated. */
  patch: UpdateProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyPatch;
};

/** The fields on `projectAllocationPlotPhase` to look up the row to update. */
export type ProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationPlotPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationPlotPhase` being updated. */
  patch: UpdateProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch;
};

/** Represents an update to a `ProjectAllocationPlotPhase`. Fields that are set will be updated. */
export type ProjectAllocationPlotPhasePatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationPlotToAllocationId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectAllocationPlotPhase` to look up the row to connect. */
export type ProjectAllocationPlotPhaseProjectAllocationPlotPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationPlotPhase` to look up the row to delete. */
export type ProjectAllocationPlotPhaseProjectAllocationPlotPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationUsage` in the `ProjectAllocationPlotPhaseInput` mutation. */
export type ProjectAllocationPlotPhaseUsageIdFkeyInput = {
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePkeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageTypeKeyConnect>;
  /** A `ProjectAllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyProjectAllocationUsageCreateInput>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePkeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationPlotPhase` in the `ProjectAllocationUsageInput` mutation. */
export type ProjectAllocationPlotPhaseUsageIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationPlotPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationPlotPhaseProjectAllocationPlotPhasePkeyConnect>>;
  /** A `ProjectAllocationPlotPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationPlotPhaseUsageIdFkeyProjectAllocationPlotPhaseCreateInput>>;
  /** The primary key(s) for `projectAllocationPlotPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationPlotPhaseProjectAllocationPlotPhasePkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationPlotPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationPlotPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationPlotPhasePkeyUpdate>>;
};

/** The `projectAllocationPlotPhase` to be created by this mutation. */
export type ProjectAllocationPlotPhaseUsageIdFkeyProjectAllocationPlotPhaseCreateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationPlotToAllocationId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `projectAllocationUsage` to be created by this mutation. */
export type ProjectAllocationPlotPhaseUsageIdFkeyProjectAllocationUsageCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type: ProjectAllocationUsageType;
};

/** A connection to a list of `ProjectAllocationPlotPhase` values. */
export type ProjectAllocationPlotPhasesConnection = {
  __typename?: 'ProjectAllocationPlotPhasesConnection';
  /** A list of edges which contains the `ProjectAllocationPlotPhase` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationPlotPhasesEdge>;
  /** A list of `ProjectAllocationPlotPhase` objects. */
  nodes: Array<ProjectAllocationPlotPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationPlotPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationPlotPhase` edge in the connection. */
export type ProjectAllocationPlotPhasesEdge = {
  __typename?: 'ProjectAllocationPlotPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationPlotPhase` at the end of the edge. */
  node: ProjectAllocationPlotPhase;
};

/** Methods to use when ordering `ProjectAllocationPlotPhase`. */
export enum ProjectAllocationPlotPhasesOrderBy {
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationPlotByAllocationIdConflictsAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__CONFLICTS_ASC',
  ProjectAllocationPlotByAllocationIdConflictsDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__CONFLICTS_DESC',
  ProjectAllocationPlotByAllocationIdEndAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__END_ASC',
  ProjectAllocationPlotByAllocationIdEndDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__END_DESC',
  ProjectAllocationPlotByAllocationIdIdAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__ID_ASC',
  ProjectAllocationPlotByAllocationIdIdDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__ID_DESC',
  ProjectAllocationPlotByAllocationIdIsOptionalAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  ProjectAllocationPlotByAllocationIdIsOptionalDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  ProjectAllocationPlotByAllocationIdPlotIdAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__PLOT_ID_ASC',
  ProjectAllocationPlotByAllocationIdPlotIdDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__PLOT_ID_DESC',
  ProjectAllocationPlotByAllocationIdProjectVariantIdAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__PROJECT_VARIANT_ID_ASC',
  ProjectAllocationPlotByAllocationIdProjectVariantIdDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__PROJECT_VARIANT_ID_DESC',
  ProjectAllocationPlotByAllocationIdStartAsc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__START_ASC',
  ProjectAllocationPlotByAllocationIdStartDesc = 'PROJECT_ALLOCATION_PLOT_BY_ALLOCATION_ID__START_DESC',
  ProjectAllocationUsageByUsageIdIdAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  ProjectAllocationUsageByUsageIdIdDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  ProjectAllocationUsageByUsageIdIsExecutionAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  ProjectAllocationUsageByUsageIdIsExecutionDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  ProjectAllocationUsageByUsageIdNameAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  ProjectAllocationUsageByUsageIdNameDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  ProjectAllocationUsageByUsageIdNameShortAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  ProjectAllocationUsageByUsageIdNameShortDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  ProjectAllocationUsageByUsageIdPositionAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  ProjectAllocationUsageByUsageIdPositionDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  ProjectAllocationUsageByUsageIdTypeAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  ProjectAllocationUsageByUsageIdTypeDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** Input for the nested mutation of `plot` in the `ProjectAllocationPlotInput` mutation. */
export type ProjectAllocationPlotPlotIdFkeyInput = {
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByExtId?: InputMaybe<PlotPlotExtIdKeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectById?: InputMaybe<PlotPlotPkeyConnect>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<PlotPlotNameShortKeyConnect>;
  /** A `PlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationPlotPlotIdFkeyPlotCreateInput>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<PlotPlotExtIdKeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteById?: InputMaybe<PlotPlotPkeyDelete>;
  /** The primary key(s) for `plot` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<PlotPlotNameShortKeyDelete>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByExtId?: InputMaybe<PlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingPlotExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateById?: InputMaybe<PlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingPlotPkeyUpdate>;
  /** The primary key(s) and patch data for `plot` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<PlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingPlotNameShortKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationPlot` in the `PlotInput` mutation. */
export type ProjectAllocationPlotPlotIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationPlot` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationPlotProjectAllocationPlotPkeyConnect>>;
  /** A `ProjectAllocationPlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationPlotPlotIdFkeyProjectAllocationPlotCreateInput>>;
  /** The primary key(s) for `projectAllocationPlot` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationPlotProjectAllocationPlotPkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationPlot` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationPlot` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyUsingProjectAllocationPlotPkeyUpdate>>;
};

/** The `plot` to be created by this mutation. */
export type ProjectAllocationPlotPlotIdFkeyPlotCreateInput = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `projectAllocationPlot` to be created by this mutation. */
export type ProjectAllocationPlotPlotIdFkeyProjectAllocationPlotCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The fields on `projectAllocationPlot` to look up the row to connect. */
export type ProjectAllocationPlotProjectAllocationPlotPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationPlot` to look up the row to delete. */
export type ProjectAllocationPlotProjectAllocationPlotPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `projectVariant` in the `ProjectAllocationPlotInput` mutation. */
export type ProjectAllocationPlotProjectVariantIdFkeyInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectVariantProjectVariantPkeyConnect>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<ProjectVariantProjectVariantProjectIdIndexKeyConnect>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyProjectVariantCreateInput>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectVariantProjectVariantPkeyDelete>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<ProjectVariantProjectVariantProjectIdIndexKeyDelete>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyUsingProjectVariantPkeyUpdate>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<ProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationPlot` in the `ProjectVariantInput` mutation. */
export type ProjectAllocationPlotProjectVariantIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationPlot` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationPlotProjectAllocationPlotPkeyConnect>>;
  /** A `ProjectAllocationPlotInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationPlotProjectVariantIdFkeyProjectAllocationPlotCreateInput>>;
  /** The primary key(s) for `projectAllocationPlot` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationPlotProjectAllocationPlotPkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationPlot` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationPlot` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyUsingProjectAllocationPlotPkeyUpdate>>;
};

/** The `projectAllocationPlot` to be created by this mutation. */
export type ProjectAllocationPlotProjectVariantIdFkeyProjectAllocationPlotCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectAllocationPlotProjectVariantIdFkeyProjectVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ProjectAllocationPlotPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationPlotToManyProjectAllocationPlotPhaseFilter = {
  /** Every related `ProjectAllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  /** No related `ProjectAllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  /** Some related `ProjectAllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
};

/** A connection to a list of `ProjectAllocationPlot` values. */
export type ProjectAllocationPlotsConnection = {
  __typename?: 'ProjectAllocationPlotsConnection';
  /** A list of edges which contains the `ProjectAllocationPlot` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationPlotsEdge>;
  /** A list of `ProjectAllocationPlot` objects. */
  nodes: Array<ProjectAllocationPlot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationPlot` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationPlot` edge in the connection. */
export type ProjectAllocationPlotsEdge = {
  __typename?: 'ProjectAllocationPlotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationPlot` at the end of the edge. */
  node: ProjectAllocationPlot;
};

/** Methods to use when ordering `ProjectAllocationPlot`. */
export enum ProjectAllocationPlotsOrderBy {
  ConflictsAsc = 'CONFLICTS_ASC',
  ConflictsDesc = 'CONFLICTS_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  Natural = 'NATURAL',
  PlotByPlotIdAreaIdAsc = 'PLOT_BY_PLOT_ID__AREA_ID_ASC',
  PlotByPlotIdAreaIdDesc = 'PLOT_BY_PLOT_ID__AREA_ID_DESC',
  PlotByPlotIdDescriptionAsc = 'PLOT_BY_PLOT_ID__DESCRIPTION_ASC',
  PlotByPlotIdDescriptionDesc = 'PLOT_BY_PLOT_ID__DESCRIPTION_DESC',
  PlotByPlotIdExtIdAsc = 'PLOT_BY_PLOT_ID__EXT_ID_ASC',
  PlotByPlotIdExtIdDesc = 'PLOT_BY_PLOT_ID__EXT_ID_DESC',
  PlotByPlotIdIdAsc = 'PLOT_BY_PLOT_ID__ID_ASC',
  PlotByPlotIdIdDesc = 'PLOT_BY_PLOT_ID__ID_DESC',
  PlotByPlotIdNameLongAsc = 'PLOT_BY_PLOT_ID__NAME_LONG_ASC',
  PlotByPlotIdNameLongDesc = 'PLOT_BY_PLOT_ID__NAME_LONG_DESC',
  PlotByPlotIdNameShortAsc = 'PLOT_BY_PLOT_ID__NAME_SHORT_ASC',
  PlotByPlotIdNameShortDesc = 'PLOT_BY_PLOT_ID__NAME_SHORT_DESC',
  PlotByPlotIdTypeIdAsc = 'PLOT_BY_PLOT_ID__TYPE_ID_ASC',
  PlotByPlotIdTypeIdDesc = 'PLOT_BY_PLOT_ID__TYPE_ID_DESC',
  PlotIdAsc = 'PLOT_ID_ASC',
  PlotIdDesc = 'PLOT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationPlotPhasesByAllocationIdCountAsc = 'PROJECT_ALLOCATION_PLOT_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  ProjectAllocationPlotPhasesByAllocationIdCountDesc = 'PROJECT_ALLOCATION_PLOT_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  ProjectVariantByProjectVariantIdChangesIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CHANGES_ID_ASC',
  ProjectVariantByProjectVariantIdChangesIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CHANGES_ID_DESC',
  ProjectVariantByProjectVariantIdCreatedAtAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CREATED_AT_ASC',
  ProjectVariantByProjectVariantIdCreatedAtDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CREATED_AT_DESC',
  ProjectVariantByProjectVariantIdDescriptionAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__DESCRIPTION_ASC',
  ProjectVariantByProjectVariantIdDescriptionDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__DESCRIPTION_DESC',
  ProjectVariantByProjectVariantIdEndAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__END_ASC',
  ProjectVariantByProjectVariantIdEndDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__END_DESC',
  ProjectVariantByProjectVariantIdIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__ID_ASC',
  ProjectVariantByProjectVariantIdIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__ID_DESC',
  ProjectVariantByProjectVariantIdIndexAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__INDEX_ASC',
  ProjectVariantByProjectVariantIdIndexDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__INDEX_DESC',
  ProjectVariantByProjectVariantIdIsArchivedAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_ARCHIVED_ASC',
  ProjectVariantByProjectVariantIdIsArchivedDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_ARCHIVED_DESC',
  ProjectVariantByProjectVariantIdIsCurrentAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_CURRENT_ASC',
  ProjectVariantByProjectVariantIdIsCurrentDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_CURRENT_DESC',
  ProjectVariantByProjectVariantIdNameAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__NAME_ASC',
  ProjectVariantByProjectVariantIdNameDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__NAME_DESC',
  ProjectVariantByProjectVariantIdProjectIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__PROJECT_ID_ASC',
  ProjectVariantByProjectVariantIdProjectIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__PROJECT_ID_DESC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationAreaIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_AREA_ID_ASC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationAreaIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_AREA_ID_DESC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationRoomIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_ROOM_ID_ASC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationRoomIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_ROOM_ID_DESC',
  ProjectVariantByProjectVariantIdStartAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__START_ASC',
  ProjectVariantByProjectVariantIdStartDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__START_DESC',
  ProjectVariantByProjectVariantIdStatusAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__STATUS_ASC',
  ProjectVariantByProjectVariantIdStatusDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__STATUS_DESC',
  ProjectVariantIdAsc = 'PROJECT_VARIANT_ID_ASC',
  ProjectVariantIdDesc = 'PROJECT_VARIANT_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

export type ProjectAllocationRoom = {
  __typename?: 'ProjectAllocationRoom';
  conflicts: Scalars['Int'];
  end: Scalars['Datetime'];
  id: Scalars['UUID'];
  isOptional: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `ProjectAllocationRoomPhase`. */
  projectAllocationRoomPhasesByAllocationId: ProjectAllocationRoomPhasesConnection;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationRoom`. */
  projectVariant: ProjectVariant;
  projectVariantId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProjectVariant`. */
  projectVariantsByReferenceProjectAllocationRoomId: ProjectVariantsConnection;
  /** Reads a single `Room` that is related to this `ProjectAllocationRoom`. */
  room: Room;
  roomId: Scalars['UUID'];
  start: Scalars['Datetime'];
};


export type ProjectAllocationRoomProjectAllocationRoomPhasesByAllocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationRoomPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationRoomPhasesOrderBy>>;
};


export type ProjectAllocationRoomProjectVariantsByReferenceProjectAllocationRoomIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectVariantCondition>;
  filter?: InputMaybe<ProjectVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/**
 * A condition to be used against `ProjectAllocationRoom` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationRoomCondition = {
  /** Checks for equality with the object’s `conflicts` field. */
  conflicts?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOptional` field. */
  isOptional?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `projectVariantId` field. */
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** All input for the `projectAllocationRoomDuplicate` mutation. */
export type ProjectAllocationRoomDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The output of our `projectAllocationRoomDuplicate` mutation. */
export type ProjectAllocationRoomDuplicatePayload = {
  __typename?: 'ProjectAllocationRoomDuplicatePayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our `projectAllocationRoomDuplicate` mutation. */
export type ProjectAllocationRoomDuplicatePayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** A filter to be used against `ProjectAllocationRoom` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationRoomFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationRoomFilter>>;
  /** Filter by the object’s `conflicts` field. */
  conflicts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOptional` field. */
  isOptional?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationRoomFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationRoomFilter>>;
  /** Filter by the object’s `projectAllocationRoomPhasesByAllocationId` relation. */
  projectAllocationRoomPhasesByAllocationId?: InputMaybe<ProjectAllocationRoomToManyProjectAllocationRoomPhaseFilter>;
  /** Some related `projectAllocationRoomPhasesByAllocationId` exist. */
  projectAllocationRoomPhasesByAllocationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectVariant` relation. */
  projectVariant?: InputMaybe<ProjectVariantFilter>;
  /** Filter by the object’s `projectVariantId` field. */
  projectVariantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectVariantsByReferenceProjectAllocationRoomId` relation. */
  projectVariantsByReferenceProjectAllocationRoomId?: InputMaybe<ProjectAllocationRoomToManyProjectVariantFilter>;
  /** Some related `projectVariantsByReferenceProjectAllocationRoomId` exist. */
  projectVariantsByReferenceProjectAllocationRoomIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectAllocationRoom` */
export type ProjectAllocationRoomInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The fields on `projectAllocationRoom` to look up the row to update. */
export type ProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyUsingProjectAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
  patch: UpdateProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyPatch;
};

/** The fields on `projectAllocationRoom` to look up the row to update. */
export type ProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingProjectAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
  patch: UpdateProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `projectAllocationRoom` to look up the row to update. */
export type ProjectAllocationRoomOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
  patch: UpdateProjectAllocationRoomOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyPatch;
};

/** The fields on `projectAllocationRoom` to look up the row to update. */
export type ProjectAllocationRoomOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlUsingProjectAllocationRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
  patch: UpdateProjectAllocationRoomOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlPatch;
};

/** Represents an update to a `ProjectAllocationRoom`. Fields that are set will be updated. */
export type ProjectAllocationRoomPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

export type ProjectAllocationRoomPhase = {
  __typename?: 'ProjectAllocationRoomPhase';
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectAllocationRoomPhase`. */
  allocation: ProjectAllocationRoom;
  allocationId: Scalars['UUID'];
  duration: Interval;
  id: Scalars['UUID'];
  offset: Interval;
  specializationType: Scalars['String'];
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationRoomPhase`. */
  usage: ProjectAllocationUsage;
  usageId: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationRoom` in the `ProjectAllocationRoomPhaseInput` mutation. */
export type ProjectAllocationRoomPhaseAllocationIdFkeyInput = {
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationRoomProjectAllocationRoomPkeyConnect>;
  /** A `ProjectAllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomCreateInput>;
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationRoomProjectAllocationRoomPkeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationRoomOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPkeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationRoomPhase` in the `ProjectAllocationRoomInput` mutation. */
export type ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationRoomPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyConnect>>;
  /** A `ProjectAllocationRoomPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput>>;
  /** The primary key(s) for `projectAllocationRoomPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationRoomPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationRoomPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate>>;
};

/** The `projectAllocationRoom` to be created by this mutation. */
export type ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `projectAllocationRoomPhase` to be created by this mutation. */
export type ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput = {
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationRoomToAllocationId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `ProjectAllocationRoomPhase` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationRoomPhaseCondition = {
  /** Checks for equality with the object’s `allocationId` field. */
  allocationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `offset` field. */
  offset?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `specializationType` field. */
  specializationType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `usageId` field. */
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ProjectAllocationRoomPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationRoomPhaseFilter = {
  /** Filter by the object’s `allocation` relation. */
  allocation?: InputMaybe<ProjectAllocationRoomFilter>;
  /** Filter by the object’s `allocationId` field. */
  allocationId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationRoomPhaseFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  /** Filter by the object’s `offset` field. */
  offset?: InputMaybe<IntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationRoomPhaseFilter>>;
  /** Filter by the object’s `specializationType` field. */
  specializationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usage` relation. */
  usage?: InputMaybe<ProjectAllocationUsageFilter>;
  /** Filter by the object’s `usageId` field. */
  usageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProjectAllocationRoomPhase` */
export type ProjectAllocationRoomPhaseInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationRoomToAllocationId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectAllocationRoomPhase` to look up the row to update. */
export type ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationRoomPhase` being updated. */
  patch: UpdateProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyPatch;
};

/** The fields on `projectAllocationRoomPhase` to look up the row to update. */
export type ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationRoomPhase` being updated. */
  patch: UpdateProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch;
};

/** Represents an update to a `ProjectAllocationRoomPhase`. Fields that are set will be updated. */
export type ProjectAllocationRoomPhasePatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationRoomToAllocationId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectAllocationRoomPhase` to look up the row to connect. */
export type ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationRoomPhase` to look up the row to delete. */
export type ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationUsage` in the `ProjectAllocationRoomPhaseInput` mutation. */
export type ProjectAllocationRoomPhaseUsageIdFkeyInput = {
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePkeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByName?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameShortKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByPosition?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePositionKeyConnect>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  connectByType?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageTypeKeyConnect>;
  /** A `ProjectAllocationUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyProjectAllocationUsageCreateInput>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePkeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByName?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageNameShortKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByPosition?: InputMaybe<ProjectAllocationUsageProjectAllocationUsagePositionKeyDelete>;
  /** The primary key(s) for `projectAllocationUsage` for the far side of the relationship. */
  deleteByType?: InputMaybe<ProjectAllocationUsageProjectAllocationUsageTypeKeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByName?: InputMaybe<ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsageNameKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsageNameShortKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByPosition?: InputMaybe<ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsagePositionKeyUpdate>;
  /** The primary key(s) and patch data for `projectAllocationUsage` for the far side of the relationship. */
  updateByType?: InputMaybe<ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsageTypeKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationRoomPhase` in the `ProjectAllocationUsageInput` mutation. */
export type ProjectAllocationRoomPhaseUsageIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationRoomPhase` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyConnect>>;
  /** A `ProjectAllocationRoomPhaseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationRoomPhaseUsageIdFkeyProjectAllocationRoomPhaseCreateInput>>;
  /** The primary key(s) for `projectAllocationRoomPhase` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationRoomPhase` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationRoomPhase` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate>>;
};

/** The `projectAllocationRoomPhase` to be created by this mutation. */
export type ProjectAllocationRoomPhaseUsageIdFkeyProjectAllocationRoomPhaseCreateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars['UUID']>;
  offset: IntervalInput;
  projectAllocationRoomToAllocationId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** The `projectAllocationUsage` to be created by this mutation. */
export type ProjectAllocationRoomPhaseUsageIdFkeyProjectAllocationUsageCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type: ProjectAllocationUsageType;
};

/** A connection to a list of `ProjectAllocationRoomPhase` values. */
export type ProjectAllocationRoomPhasesConnection = {
  __typename?: 'ProjectAllocationRoomPhasesConnection';
  /** A list of edges which contains the `ProjectAllocationRoomPhase` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationRoomPhasesEdge>;
  /** A list of `ProjectAllocationRoomPhase` objects. */
  nodes: Array<ProjectAllocationRoomPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationRoomPhase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationRoomPhase` edge in the connection. */
export type ProjectAllocationRoomPhasesEdge = {
  __typename?: 'ProjectAllocationRoomPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationRoomPhase` at the end of the edge. */
  node: ProjectAllocationRoomPhase;
};

/** Methods to use when ordering `ProjectAllocationRoomPhase`. */
export enum ProjectAllocationRoomPhasesOrderBy {
  AllocationIdAsc = 'ALLOCATION_ID_ASC',
  AllocationIdDesc = 'ALLOCATION_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OffsetAsc = 'OFFSET_ASC',
  OffsetDesc = 'OFFSET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationRoomByAllocationIdConflictsAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__CONFLICTS_ASC',
  ProjectAllocationRoomByAllocationIdConflictsDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__CONFLICTS_DESC',
  ProjectAllocationRoomByAllocationIdEndAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__END_ASC',
  ProjectAllocationRoomByAllocationIdEndDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__END_DESC',
  ProjectAllocationRoomByAllocationIdIdAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__ID_ASC',
  ProjectAllocationRoomByAllocationIdIdDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__ID_DESC',
  ProjectAllocationRoomByAllocationIdIsOptionalAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__IS_OPTIONAL_ASC',
  ProjectAllocationRoomByAllocationIdIsOptionalDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__IS_OPTIONAL_DESC',
  ProjectAllocationRoomByAllocationIdProjectVariantIdAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__PROJECT_VARIANT_ID_ASC',
  ProjectAllocationRoomByAllocationIdProjectVariantIdDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__PROJECT_VARIANT_ID_DESC',
  ProjectAllocationRoomByAllocationIdRoomIdAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__ROOM_ID_ASC',
  ProjectAllocationRoomByAllocationIdRoomIdDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__ROOM_ID_DESC',
  ProjectAllocationRoomByAllocationIdStartAsc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__START_ASC',
  ProjectAllocationRoomByAllocationIdStartDesc = 'PROJECT_ALLOCATION_ROOM_BY_ALLOCATION_ID__START_DESC',
  ProjectAllocationUsageByUsageIdIdAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__ID_ASC',
  ProjectAllocationUsageByUsageIdIdDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__ID_DESC',
  ProjectAllocationUsageByUsageIdIsExecutionAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_ASC',
  ProjectAllocationUsageByUsageIdIsExecutionDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__IS_EXECUTION_DESC',
  ProjectAllocationUsageByUsageIdNameAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_ASC',
  ProjectAllocationUsageByUsageIdNameDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_DESC',
  ProjectAllocationUsageByUsageIdNameShortAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_ASC',
  ProjectAllocationUsageByUsageIdNameShortDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__NAME_SHORT_DESC',
  ProjectAllocationUsageByUsageIdPositionAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_ASC',
  ProjectAllocationUsageByUsageIdPositionDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__POSITION_DESC',
  ProjectAllocationUsageByUsageIdTypeAsc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_ASC',
  ProjectAllocationUsageByUsageIdTypeDesc = 'PROJECT_ALLOCATION_USAGE_BY_USAGE_ID__TYPE_DESC',
  SpecializationTypeAsc = 'SPECIALIZATION_TYPE_ASC',
  SpecializationTypeDesc = 'SPECIALIZATION_TYPE_DESC',
  UsageIdAsc = 'USAGE_ID_ASC',
  UsageIdDesc = 'USAGE_ID_DESC'
}

/** The fields on `projectAllocationRoom` to look up the row to connect. */
export type ProjectAllocationRoomProjectAllocationRoomPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationRoom` to look up the row to delete. */
export type ProjectAllocationRoomProjectAllocationRoomPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `projectVariant` in the `ProjectAllocationRoomInput` mutation. */
export type ProjectAllocationRoomProjectVariantIdFkeyInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectVariantProjectVariantPkeyConnect>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<ProjectVariantProjectVariantProjectIdIndexKeyConnect>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyProjectVariantCreateInput>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectVariantProjectVariantPkeyDelete>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<ProjectVariantProjectVariantProjectIdIndexKeyDelete>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyUsingProjectVariantPkeyUpdate>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<ProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationRoom` in the `ProjectVariantInput` mutation. */
export type ProjectAllocationRoomProjectVariantIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationRoomProjectAllocationRoomPkeyConnect>>;
  /** A `ProjectAllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationRoomProjectVariantIdFkeyProjectAllocationRoomCreateInput>>;
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationRoomProjectAllocationRoomPkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationRoom` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyUsingProjectAllocationRoomPkeyUpdate>>;
};

/** The `projectAllocationRoom` to be created by this mutation. */
export type ProjectAllocationRoomProjectVariantIdFkeyProjectAllocationRoomCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectAllocationRoomProjectVariantIdFkeyProjectVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `ProjectAllocationRoomInput` mutation. */
export type ProjectAllocationRoomRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectAllocationRoomRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `projectAllocationRoom` in the `RoomInput` mutation. */
export type ProjectAllocationRoomRoomIdFkeyInverseInput = {
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectAllocationRoomProjectAllocationRoomPkeyConnect>>;
  /** A `ProjectAllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAllocationRoomRoomIdFkeyProjectAllocationRoomCreateInput>>;
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectAllocationRoomProjectAllocationRoomPkeyDelete>>;
  /** Flag indicating whether all other `projectAllocationRoom` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectAllocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingProjectAllocationRoomPkeyUpdate>>;
};

/** The `projectAllocationRoom` to be created by this mutation. */
export type ProjectAllocationRoomRoomIdFkeyProjectAllocationRoomCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `room` to be created by this mutation. */
export type ProjectAllocationRoomRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `ProjectAllocationRoomPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationRoomToManyProjectAllocationRoomPhaseFilter = {
  /** Every related `ProjectAllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  /** No related `ProjectAllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  /** Some related `ProjectAllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
};

/** A filter to be used against many `ProjectVariant` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationRoomToManyProjectVariantFilter = {
  /** Every related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectVariantFilter>;
  /** No related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectVariantFilter>;
  /** Some related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectVariantFilter>;
};

/** All input for the `projectAllocationRoomUpdateAndDuplicate` mutation. */
export type ProjectAllocationRoomUpdateAndDuplicateInput = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  updateAllocation?: InputMaybe<AllocationUpdateInput>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>>>;
};

/** The output of our `projectAllocationRoomUpdateAndDuplicate` mutation. */
export type ProjectAllocationRoomUpdateAndDuplicatePayload = {
  __typename?: 'ProjectAllocationRoomUpdateAndDuplicatePayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our `projectAllocationRoomUpdateAndDuplicate` mutation. */
export type ProjectAllocationRoomUpdateAndDuplicatePayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** A connection to a list of `ProjectAllocationRoom` values. */
export type ProjectAllocationRoomsConnection = {
  __typename?: 'ProjectAllocationRoomsConnection';
  /** A list of edges which contains the `ProjectAllocationRoom` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationRoomsEdge>;
  /** A list of `ProjectAllocationRoom` objects. */
  nodes: Array<ProjectAllocationRoom>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationRoom` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationRoom` edge in the connection. */
export type ProjectAllocationRoomsEdge = {
  __typename?: 'ProjectAllocationRoomsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationRoom` at the end of the edge. */
  node: ProjectAllocationRoom;
};

/** Methods to use when ordering `ProjectAllocationRoom`. */
export enum ProjectAllocationRoomsOrderBy {
  ConflictsAsc = 'CONFLICTS_ASC',
  ConflictsDesc = 'CONFLICTS_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOptionalAsc = 'IS_OPTIONAL_ASC',
  IsOptionalDesc = 'IS_OPTIONAL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationRoomPhasesByAllocationIdCountAsc = 'PROJECT_ALLOCATION_ROOM_PHASES_BY_ALLOCATION_ID__COUNT_ASC',
  ProjectAllocationRoomPhasesByAllocationIdCountDesc = 'PROJECT_ALLOCATION_ROOM_PHASES_BY_ALLOCATION_ID__COUNT_DESC',
  ProjectVariantsByReferenceProjectAllocationRoomIdCountAsc = 'PROJECT_VARIANTS_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__COUNT_ASC',
  ProjectVariantsByReferenceProjectAllocationRoomIdCountDesc = 'PROJECT_VARIANTS_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__COUNT_DESC',
  ProjectVariantByProjectVariantIdChangesIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CHANGES_ID_ASC',
  ProjectVariantByProjectVariantIdChangesIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CHANGES_ID_DESC',
  ProjectVariantByProjectVariantIdCreatedAtAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CREATED_AT_ASC',
  ProjectVariantByProjectVariantIdCreatedAtDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__CREATED_AT_DESC',
  ProjectVariantByProjectVariantIdDescriptionAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__DESCRIPTION_ASC',
  ProjectVariantByProjectVariantIdDescriptionDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__DESCRIPTION_DESC',
  ProjectVariantByProjectVariantIdEndAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__END_ASC',
  ProjectVariantByProjectVariantIdEndDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__END_DESC',
  ProjectVariantByProjectVariantIdIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__ID_ASC',
  ProjectVariantByProjectVariantIdIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__ID_DESC',
  ProjectVariantByProjectVariantIdIndexAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__INDEX_ASC',
  ProjectVariantByProjectVariantIdIndexDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__INDEX_DESC',
  ProjectVariantByProjectVariantIdIsArchivedAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_ARCHIVED_ASC',
  ProjectVariantByProjectVariantIdIsArchivedDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_ARCHIVED_DESC',
  ProjectVariantByProjectVariantIdIsCurrentAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_CURRENT_ASC',
  ProjectVariantByProjectVariantIdIsCurrentDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__IS_CURRENT_DESC',
  ProjectVariantByProjectVariantIdNameAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__NAME_ASC',
  ProjectVariantByProjectVariantIdNameDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__NAME_DESC',
  ProjectVariantByProjectVariantIdProjectIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__PROJECT_ID_ASC',
  ProjectVariantByProjectVariantIdProjectIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__PROJECT_ID_DESC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationAreaIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_AREA_ID_ASC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationAreaIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_AREA_ID_DESC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationRoomIdAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_ROOM_ID_ASC',
  ProjectVariantByProjectVariantIdReferenceProjectAllocationRoomIdDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__REFERENCE_PROJECT_ALLOCATION_ROOM_ID_DESC',
  ProjectVariantByProjectVariantIdStartAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__START_ASC',
  ProjectVariantByProjectVariantIdStartDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__START_DESC',
  ProjectVariantByProjectVariantIdStatusAsc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__STATUS_ASC',
  ProjectVariantByProjectVariantIdStatusDesc = 'PROJECT_VARIANT_BY_PROJECT_VARIANT_ID__STATUS_DESC',
  ProjectVariantIdAsc = 'PROJECT_VARIANT_ID_ASC',
  ProjectVariantIdDesc = 'PROJECT_VARIANT_ID_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

export type ProjectAllocationUsage = {
  __typename?: 'ProjectAllocationUsage';
  id: Scalars['UUID'];
  isExecution: Scalars['Boolean'];
  name: Scalars['String'];
  nameShort: Scalars['String'];
  position: Scalars['Int'];
  /** Reads and enables pagination through a set of `ProjectAllocationAreaPhase`. */
  projectAllocationAreaPhasesByUsageId: ProjectAllocationAreaPhasesConnection;
  /** Reads and enables pagination through a set of `ProjectAllocationPlotPhase`. */
  projectAllocationPlotPhasesByUsageId: ProjectAllocationPlotPhasesConnection;
  /** Reads and enables pagination through a set of `ProjectAllocationRoomPhase`. */
  projectAllocationRoomPhasesByUsageId: ProjectAllocationRoomPhasesConnection;
  type: ProjectAllocationUsageType;
};


export type ProjectAllocationUsageProjectAllocationAreaPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationAreaPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationAreaPhasesOrderBy>>;
};


export type ProjectAllocationUsageProjectAllocationPlotPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationPlotPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationPlotPhasesOrderBy>>;
};


export type ProjectAllocationUsageProjectAllocationRoomPhasesByUsageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationRoomPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationRoomPhasesOrderBy>>;
};

/**
 * A condition to be used against `ProjectAllocationUsage` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProjectAllocationUsageCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isExecution` field. */
  isExecution?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ProjectAllocationUsageType>;
};

/** A filter to be used against `ProjectAllocationUsage` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectAllocationUsageFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isExecution` field. */
  isExecution?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectAllocationUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectAllocationUsageFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectAllocationAreaPhasesByUsageId` relation. */
  projectAllocationAreaPhasesByUsageId?: InputMaybe<ProjectAllocationUsageToManyProjectAllocationAreaPhaseFilter>;
  /** Some related `projectAllocationAreaPhasesByUsageId` exist. */
  projectAllocationAreaPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectAllocationPlotPhasesByUsageId` relation. */
  projectAllocationPlotPhasesByUsageId?: InputMaybe<ProjectAllocationUsageToManyProjectAllocationPlotPhaseFilter>;
  /** Some related `projectAllocationPlotPhasesByUsageId` exist. */
  projectAllocationPlotPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectAllocationRoomPhasesByUsageId` relation. */
  projectAllocationRoomPhasesByUsageId?: InputMaybe<ProjectAllocationUsageToManyProjectAllocationRoomPhaseFilter>;
  /** Some related `projectAllocationRoomPhasesByUsageId` exist. */
  projectAllocationRoomPhasesByUsageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<ProjectAllocationUsageTypeFilter>;
};

/** An input for mutations affecting `ProjectAllocationUsage` */
export type ProjectAllocationUsageInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type: ProjectAllocationUsageType;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch;
  position: Scalars['Int'];
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyUsingProjectAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch;
  type: ProjectAllocationUsageType;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch;
  position: Scalars['Int'];
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyUsingProjectAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch;
  type: ProjectAllocationUsageType;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsageNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsageNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch;
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsagePositionKeyUpdate = {
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch;
  position: Scalars['Int'];
};

/** The fields on `projectAllocationUsage` to look up the row to update. */
export type ProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyUsingProjectAllocationUsageTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
  patch: UpdateProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch;
  type: ProjectAllocationUsageType;
};

/** Represents an update to a `ProjectAllocationUsage`. Fields that are set will be updated. */
export type ProjectAllocationUsagePatch = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type?: InputMaybe<ProjectAllocationUsageType>;
};

/** The fields on `projectAllocationUsage` to look up the row to connect. */
export type ProjectAllocationUsageProjectAllocationUsageNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `projectAllocationUsage` to look up the row to delete. */
export type ProjectAllocationUsageProjectAllocationUsageNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `projectAllocationUsage` to look up the row to connect. */
export type ProjectAllocationUsageProjectAllocationUsageNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `projectAllocationUsage` to look up the row to delete. */
export type ProjectAllocationUsageProjectAllocationUsageNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `projectAllocationUsage` to look up the row to connect. */
export type ProjectAllocationUsageProjectAllocationUsagePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationUsage` to look up the row to delete. */
export type ProjectAllocationUsageProjectAllocationUsagePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `projectAllocationUsage` to look up the row to connect. */
export type ProjectAllocationUsageProjectAllocationUsagePositionKeyConnect = {
  position: Scalars['Int'];
};

/** The fields on `projectAllocationUsage` to look up the row to delete. */
export type ProjectAllocationUsageProjectAllocationUsagePositionKeyDelete = {
  position: Scalars['Int'];
};

/** The fields on `projectAllocationUsage` to look up the row to connect. */
export type ProjectAllocationUsageProjectAllocationUsageTypeKeyConnect = {
  type: ProjectAllocationUsageType;
};

/** The fields on `projectAllocationUsage` to look up the row to delete. */
export type ProjectAllocationUsageProjectAllocationUsageTypeKeyDelete = {
  type: ProjectAllocationUsageType;
};

/** A filter to be used against many `ProjectAllocationAreaPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationUsageToManyProjectAllocationAreaPhaseFilter = {
  /** Every related `ProjectAllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  /** No related `ProjectAllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  /** Some related `ProjectAllocationAreaPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
};

/** A filter to be used against many `ProjectAllocationPlotPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationUsageToManyProjectAllocationPlotPhaseFilter = {
  /** Every related `ProjectAllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  /** No related `ProjectAllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  /** Some related `ProjectAllocationPlotPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
};

/** A filter to be used against many `ProjectAllocationRoomPhase` object types. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationUsageToManyProjectAllocationRoomPhaseFilter = {
  /** Every related `ProjectAllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  /** No related `ProjectAllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  /** Some related `ProjectAllocationRoomPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
};

export enum ProjectAllocationUsageType {
  Project = 'Project',
  ProjectBreakdown = 'Project_Breakdown',
  ProjectSetUp = 'Project_Set_Up'
}

/** A filter to be used against ProjectAllocationUsageType fields. All fields are combined with a logical ‘and.’ */
export type ProjectAllocationUsageTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProjectAllocationUsageType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProjectAllocationUsageType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProjectAllocationUsageType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProjectAllocationUsageType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProjectAllocationUsageType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProjectAllocationUsageType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProjectAllocationUsageType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProjectAllocationUsageType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProjectAllocationUsageType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProjectAllocationUsageType>>;
};

/** A connection to a list of `ProjectAllocationUsage` values. */
export type ProjectAllocationUsagesConnection = {
  __typename?: 'ProjectAllocationUsagesConnection';
  /** A list of edges which contains the `ProjectAllocationUsage` and cursor to aid in pagination. */
  edges: Array<ProjectAllocationUsagesEdge>;
  /** A list of `ProjectAllocationUsage` objects. */
  nodes: Array<ProjectAllocationUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectAllocationUsage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectAllocationUsage` edge in the connection. */
export type ProjectAllocationUsagesEdge = {
  __typename?: 'ProjectAllocationUsagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectAllocationUsage` at the end of the edge. */
  node: ProjectAllocationUsage;
};

/** Methods to use when ordering `ProjectAllocationUsage`. */
export enum ProjectAllocationUsagesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsExecutionAsc = 'IS_EXECUTION_ASC',
  IsExecutionDesc = 'IS_EXECUTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationAreaPhasesByUsageIdCountAsc = 'PROJECT_ALLOCATION_AREA_PHASES_BY_USAGE_ID__COUNT_ASC',
  ProjectAllocationAreaPhasesByUsageIdCountDesc = 'PROJECT_ALLOCATION_AREA_PHASES_BY_USAGE_ID__COUNT_DESC',
  ProjectAllocationPlotPhasesByUsageIdCountAsc = 'PROJECT_ALLOCATION_PLOT_PHASES_BY_USAGE_ID__COUNT_ASC',
  ProjectAllocationPlotPhasesByUsageIdCountDesc = 'PROJECT_ALLOCATION_PLOT_PHASES_BY_USAGE_ID__COUNT_DESC',
  ProjectAllocationRoomPhasesByUsageIdCountAsc = 'PROJECT_ALLOCATION_ROOM_PHASES_BY_USAGE_ID__COUNT_ASC',
  ProjectAllocationRoomPhasesByUsageIdCountDesc = 'PROJECT_ALLOCATION_ROOM_PHASES_BY_USAGE_ID__COUNT_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `allocationHints` field. */
  allocationHints?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `department` field. */
  department?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `disturbanceDust` field. */
  disturbanceDust?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `disturbanceNoise` field. */
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `disturbanceOther` field. */
  disturbanceOther?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `executionYear` field. */
  executionYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locationRequirements` field. */
  locationRequirements?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesAppointment` field. */
  notesAppointment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesDayOrder` field. */
  notesDayOrder?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organisationalChanges` field. */
  organisationalChanges?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `otherDocumentsId` field. */
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherLinksId` field. */
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherSystemsId` field. */
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `seriesId` field. */
  seriesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subtitle` field. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Filter by the object’s `allocationHints` field. */
  allocationHints?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `department` field. */
  department?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `disturbanceDust` field. */
  disturbanceDust?: InputMaybe<StringFilter>;
  /** Filter by the object’s `disturbanceNoise` field. */
  disturbanceNoise?: InputMaybe<StringFilter>;
  /** Filter by the object’s `disturbanceOther` field. */
  disturbanceOther?: InputMaybe<StringFilter>;
  /** Filter by the object’s `executionYear` field. */
  executionYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `locationRequirements` field. */
  locationRequirements?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `notesAppointment` field. */
  notesAppointment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesDayOrder` field. */
  notesDayOrder?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `organisationalChanges` field. */
  organisationalChanges?: InputMaybe<StringFilter>;
  /** Filter by the object’s `otherDocuments` relation. */
  otherDocuments?: InputMaybe<MultilinkFilter>;
  /** A related `otherDocuments` exists. */
  otherDocumentsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherDocumentsId` field. */
  otherDocumentsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherLinks` relation. */
  otherLinks?: InputMaybe<MultilinkFilter>;
  /** A related `otherLinks` exists. */
  otherLinksExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherLinksId` field. */
  otherLinksId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherSystems` relation. */
  otherSystems?: InputMaybe<MultilinkFilter>;
  /** A related `otherSystems` exists. */
  otherSystemsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherSystemsId` field. */
  otherSystemsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectVariants` relation. */
  projectVariants?: InputMaybe<ProjectToManyProjectVariantFilter>;
  /** Some related `projectVariants` exist. */
  projectVariantsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `series` relation. */
  series?: InputMaybe<ProjectSeriesFilter>;
  /** A related `series` exists. */
  seriesExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `seriesId` field. */
  seriesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subtitle` field. */
  subtitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Project` */
export type ProjectInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectOtherDocumentsIdFkeyUsingProjectNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectOtherDocumentsIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectOtherDocumentsIdFkeyUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectOtherDocumentsIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectOtherLinksIdFkeyUsingProjectNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectOtherLinksIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectOtherLinksIdFkeyUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectOtherLinksIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectOtherSystemsIdFkeyUsingProjectNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectOtherSystemsIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectOtherSystemsIdFkeyUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectOtherSystemsIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectSeriesIdFkeyUsingProjectNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectSeriesIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectSeriesIdFkeyUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectSeriesIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectVariantForProjectVariantProjectIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectVariantForProjectVariantProjectIdFkeyPatch;
};

/** Input for the nested mutation of `multilink` in the `ProjectInput` mutation. */
export type ProjectOtherDocumentsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectOtherDocumentsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectForProjectOtherDocumentsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `MultilinkInput` mutation. */
export type ProjectOtherDocumentsIdFkeyInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectOtherDocumentsIdFkeyProjectCreateInput>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectProjectPkeyDelete>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyDelete>>;
  /** Flag indicating whether all other `project` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectOtherDocumentsIdFkeyUsingProjectPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectOnProjectForProjectOtherDocumentsIdFkeyUsingProjectNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectOtherDocumentsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `project` to be created by this mutation. */
export type ProjectOtherDocumentsIdFkeyProjectCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `ProjectInput` mutation. */
export type ProjectOtherLinksIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectOtherLinksIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectForProjectOtherLinksIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `MultilinkInput` mutation. */
export type ProjectOtherLinksIdFkeyInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectOtherLinksIdFkeyProjectCreateInput>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectProjectPkeyDelete>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyDelete>>;
  /** Flag indicating whether all other `project` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectOtherLinksIdFkeyUsingProjectPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectOnProjectForProjectOtherLinksIdFkeyUsingProjectNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectOtherLinksIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `project` to be created by this mutation. */
export type ProjectOtherLinksIdFkeyProjectCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `multilink` in the `ProjectInput` mutation. */
export type ProjectOtherSystemsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectOtherSystemsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectForProjectOtherSystemsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `MultilinkInput` mutation. */
export type ProjectOtherSystemsIdFkeyInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectOtherSystemsIdFkeyProjectCreateInput>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectProjectPkeyDelete>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyDelete>>;
  /** Flag indicating whether all other `project` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectOtherSystemsIdFkeyUsingProjectPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectOnProjectForProjectOtherSystemsIdFkeyUsingProjectNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectOtherSystemsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `project` to be created by this mutation. */
export type ProjectOtherSystemsIdFkeyProjectCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Project`. Fields that are set will be updated. */
export type ProjectPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `project` to look up the row to delete. */
export type ProjectProjectNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `project` to look up the row to delete. */
export type ProjectProjectPkeyDelete = {
  id: Scalars['UUID'];
};

export type ProjectSeries = {
  __typename?: 'ProjectSeries';
  allocationHints: Scalars['String'];
  businessDomain: Scalars['String'];
  category: Scalars['String'];
  companyGroup: Scalars['String'];
  cycle: Scalars['String'];
  department: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  locationRequirements: Scalars['String'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  notes: Scalars['String'];
  notesAppointment: Scalars['String'];
  notesCycle: Scalars['String'];
  notesDayOrder: Scalars['String'];
  organisationalChanges: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherDocuments?: Maybe<Multilink>;
  otherDocumentsId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherLinks?: Maybe<Multilink>;
  otherLinksId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherSystems?: Maybe<Multilink>;
  otherSystemsId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Project`. */
  projectsBySeriesId: ProjectsConnection;
  singleProject: Scalars['Boolean'];
  type: Scalars['String'];
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  websites?: Maybe<Multilink>;
  websitesId?: Maybe<Scalars['UUID']>;
};


export type ProjectSeriesProjectsBySeriesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/**
 * A condition to be used against `ProjectSeries` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectSeriesCondition = {
  /** Checks for equality with the object’s `allocationHints` field. */
  allocationHints?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `cycle` field. */
  cycle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `department` field. */
  department?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locationRequirements` field. */
  locationRequirements?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesAppointment` field. */
  notesAppointment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesCycle` field. */
  notesCycle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notesDayOrder` field. */
  notesDayOrder?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organisationalChanges` field. */
  organisationalChanges?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `otherDocumentsId` field. */
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherLinksId` field. */
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `otherSystemsId` field. */
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `singleProject` field. */
  singleProject?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `websitesId` field. */
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `ProjectSeries` values. */
export type ProjectSeriesConnection = {
  __typename?: 'ProjectSeriesConnection';
  /** A list of edges which contains the `ProjectSeries` and cursor to aid in pagination. */
  edges: Array<ProjectSeriesEdge>;
  /** A list of `ProjectSeries` objects. */
  nodes: Array<ProjectSeries>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectSeries` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectSeries` edge in the connection. */
export type ProjectSeriesEdge = {
  __typename?: 'ProjectSeriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectSeries` at the end of the edge. */
  node: ProjectSeries;
};

/** A filter to be used against `ProjectSeries` object types. All fields are combined with a logical ‘and.’ */
export type ProjectSeriesFilter = {
  /** Filter by the object’s `allocationHints` field. */
  allocationHints?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectSeriesFilter>>;
  /** Filter by the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cycle` field. */
  cycle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `department` field. */
  department?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `locationRequirements` field. */
  locationRequirements?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectSeriesFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesAppointment` field. */
  notesAppointment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesCycle` field. */
  notesCycle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notesDayOrder` field. */
  notesDayOrder?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectSeriesFilter>>;
  /** Filter by the object’s `organisationalChanges` field. */
  organisationalChanges?: InputMaybe<StringFilter>;
  /** Filter by the object’s `otherDocuments` relation. */
  otherDocuments?: InputMaybe<MultilinkFilter>;
  /** A related `otherDocuments` exists. */
  otherDocumentsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherDocumentsId` field. */
  otherDocumentsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherLinks` relation. */
  otherLinks?: InputMaybe<MultilinkFilter>;
  /** A related `otherLinks` exists. */
  otherLinksExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherLinksId` field. */
  otherLinksId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `otherSystems` relation. */
  otherSystems?: InputMaybe<MultilinkFilter>;
  /** A related `otherSystems` exists. */
  otherSystemsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `otherSystemsId` field. */
  otherSystemsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectsBySeriesId` relation. */
  projectsBySeriesId?: InputMaybe<ProjectSeriesToManyProjectFilter>;
  /** Some related `projectsBySeriesId` exist. */
  projectsBySeriesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `singleProject` field. */
  singleProject?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `websites` relation. */
  websites?: InputMaybe<MultilinkFilter>;
  /** A related `websites` exists. */
  websitesExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `websitesId` field. */
  websitesId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `projectSeries` in the `ProjectInput` mutation. */
export type ProjectSeriesIdFkeyInput = {
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectSeriesProjectSeriesPkeyConnect>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ProjectSeriesProjectSeriesNameShortKeyConnect>;
  /** A `ProjectSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSeriesIdFkeyProjectSeriesCreateInput>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectSeriesProjectSeriesPkeyDelete>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ProjectSeriesProjectSeriesNameShortKeyDelete>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectSeriesOnProjectForProjectSeriesIdFkeyUsingProjectSeriesPkeyUpdate>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ProjectSeriesOnProjectForProjectSeriesIdFkeyUsingProjectSeriesNameShortKeyUpdate>;
};

/** Input for the nested mutation of `project` in the `ProjectSeriesInput` mutation. */
export type ProjectSeriesIdFkeyInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectSeriesIdFkeyProjectCreateInput>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectProjectPkeyDelete>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectProjectNameShortKeyDelete>>;
  /** Flag indicating whether all other `project` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectSeriesIdFkeyUsingProjectPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectOnProjectForProjectSeriesIdFkeyUsingProjectNameShortKeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ProjectSeriesIdFkeyProjectCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The `projectSeries` to be created by this mutation. */
export type ProjectSeriesIdFkeyProjectSeriesCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `ProjectSeries` */
export type ProjectSeriesInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectForProjectSeriesIdFkeyUsingProjectSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectForProjectSeriesIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectForProjectSeriesIdFkeyUsingProjectSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectForProjectSeriesIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyUsingProjectSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyUsingProjectSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyUsingProjectSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyUsingProjectSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyUsingProjectSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyUsingProjectSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyUsingProjectSeriesNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyPatch;
};

/** The fields on `projectSeries` to look up the row to update. */
export type ProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyUsingProjectSeriesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectSeries` being updated. */
  patch: UpdateProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyPatch;
};

/** Methods to use when ordering `ProjectSeries`. */
export enum ProjectSeriesOrderBy {
  AllocationHintsAsc = 'ALLOCATION_HINTS_ASC',
  AllocationHintsDesc = 'ALLOCATION_HINTS_DESC',
  BusinessDomainAsc = 'BUSINESS_DOMAIN_ASC',
  BusinessDomainDesc = 'BUSINESS_DOMAIN_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CompanyGroupAsc = 'COMPANY_GROUP_ASC',
  CompanyGroupDesc = 'COMPANY_GROUP_DESC',
  CycleAsc = 'CYCLE_ASC',
  CycleDesc = 'CYCLE_DESC',
  DepartmentAsc = 'DEPARTMENT_ASC',
  DepartmentDesc = 'DEPARTMENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LocationRequirementsAsc = 'LOCATION_REQUIREMENTS_ASC',
  LocationRequirementsDesc = 'LOCATION_REQUIREMENTS_DESC',
  MultilinkByOtherDocumentsIdIdAsc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__ID_ASC',
  MultilinkByOtherDocumentsIdIdDesc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__ID_DESC',
  MultilinkByOtherDocumentsIdNameAsc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__NAME_ASC',
  MultilinkByOtherDocumentsIdNameDesc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__NAME_DESC',
  MultilinkByOtherLinksIdIdAsc = 'MULTILINK_BY_OTHER_LINKS_ID__ID_ASC',
  MultilinkByOtherLinksIdIdDesc = 'MULTILINK_BY_OTHER_LINKS_ID__ID_DESC',
  MultilinkByOtherLinksIdNameAsc = 'MULTILINK_BY_OTHER_LINKS_ID__NAME_ASC',
  MultilinkByOtherLinksIdNameDesc = 'MULTILINK_BY_OTHER_LINKS_ID__NAME_DESC',
  MultilinkByOtherSystemsIdIdAsc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__ID_ASC',
  MultilinkByOtherSystemsIdIdDesc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__ID_DESC',
  MultilinkByOtherSystemsIdNameAsc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__NAME_ASC',
  MultilinkByOtherSystemsIdNameDesc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__NAME_DESC',
  MultilinkByWebsitesIdIdAsc = 'MULTILINK_BY_WEBSITES_ID__ID_ASC',
  MultilinkByWebsitesIdIdDesc = 'MULTILINK_BY_WEBSITES_ID__ID_DESC',
  MultilinkByWebsitesIdNameAsc = 'MULTILINK_BY_WEBSITES_ID__NAME_ASC',
  MultilinkByWebsitesIdNameDesc = 'MULTILINK_BY_WEBSITES_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  NotesAppointmentAsc = 'NOTES_APPOINTMENT_ASC',
  NotesAppointmentDesc = 'NOTES_APPOINTMENT_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesCycleAsc = 'NOTES_CYCLE_ASC',
  NotesCycleDesc = 'NOTES_CYCLE_DESC',
  NotesDayOrderAsc = 'NOTES_DAY_ORDER_ASC',
  NotesDayOrderDesc = 'NOTES_DAY_ORDER_DESC',
  NotesDesc = 'NOTES_DESC',
  OrganisationalChangesAsc = 'ORGANISATIONAL_CHANGES_ASC',
  OrganisationalChangesDesc = 'ORGANISATIONAL_CHANGES_DESC',
  OtherDocumentsIdAsc = 'OTHER_DOCUMENTS_ID_ASC',
  OtherDocumentsIdDesc = 'OTHER_DOCUMENTS_ID_DESC',
  OtherLinksIdAsc = 'OTHER_LINKS_ID_ASC',
  OtherLinksIdDesc = 'OTHER_LINKS_ID_DESC',
  OtherSystemsIdAsc = 'OTHER_SYSTEMS_ID_ASC',
  OtherSystemsIdDesc = 'OTHER_SYSTEMS_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectsBySeriesIdCountAsc = 'PROJECTS_BY_SERIES_ID__COUNT_ASC',
  ProjectsBySeriesIdCountDesc = 'PROJECTS_BY_SERIES_ID__COUNT_DESC',
  SingleProjectAsc = 'SINGLE_PROJECT_ASC',
  SingleProjectDesc = 'SINGLE_PROJECT_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  WebsitesIdAsc = 'WEBSITES_ID_ASC',
  WebsitesIdDesc = 'WEBSITES_ID_DESC'
}

/** Input for the nested mutation of `multilink` in the `ProjectSeriesInput` mutation. */
export type ProjectSeriesOtherDocumentsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `projectSeries` in the `MultilinkInput` mutation. */
export type ProjectSeriesOtherDocumentsIdFkeyInverseInput = {
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyConnect>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyConnect>>;
  /** A `ProjectSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectSeriesOtherDocumentsIdFkeyProjectSeriesCreateInput>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyDelete>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `projectSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyUsingProjectSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyUsingProjectSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectSeriesOtherDocumentsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `projectSeries` to be created by this mutation. */
export type ProjectSeriesOtherDocumentsIdFkeyProjectSeriesCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `ProjectSeriesInput` mutation. */
export type ProjectSeriesOtherLinksIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSeriesOtherLinksIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectSeriesForProjectSeriesOtherLinksIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `projectSeries` in the `MultilinkInput` mutation. */
export type ProjectSeriesOtherLinksIdFkeyInverseInput = {
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyConnect>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyConnect>>;
  /** A `ProjectSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectSeriesOtherLinksIdFkeyProjectSeriesCreateInput>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyDelete>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `projectSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyUsingProjectSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyUsingProjectSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectSeriesOtherLinksIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `projectSeries` to be created by this mutation. */
export type ProjectSeriesOtherLinksIdFkeyProjectSeriesCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `multilink` in the `ProjectSeriesInput` mutation. */
export type ProjectSeriesOtherSystemsIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `projectSeries` in the `MultilinkInput` mutation. */
export type ProjectSeriesOtherSystemsIdFkeyInverseInput = {
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyConnect>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyConnect>>;
  /** A `ProjectSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectSeriesOtherSystemsIdFkeyProjectSeriesCreateInput>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyDelete>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `projectSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyUsingProjectSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyUsingProjectSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectSeriesOtherSystemsIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `projectSeries` to be created by this mutation. */
export type ProjectSeriesOtherSystemsIdFkeyProjectSeriesCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `ProjectSeries`. Fields that are set will be updated. */
export type ProjectSeriesPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `projectSeries` to look up the row to connect. */
export type ProjectSeriesProjectSeriesNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `projectSeries` to look up the row to delete. */
export type ProjectSeriesProjectSeriesNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `projectSeries` to look up the row to connect. */
export type ProjectSeriesProjectSeriesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectSeries` to look up the row to delete. */
export type ProjectSeriesProjectSeriesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectSeriesToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** Input for the nested mutation of `multilink` in the `ProjectSeriesInput` mutation. */
export type ProjectSeriesWebsitesIdFkeyInput = {
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  connectById?: InputMaybe<MultilinkMultilinkPkeyConnect>;
  /** A `MultilinkInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSeriesWebsitesIdFkeyMultilinkCreateInput>;
  /** The primary key(s) for `multilink` for the far side of the relationship. */
  deleteById?: InputMaybe<MultilinkMultilinkPkeyDelete>;
  /** The primary key(s) and patch data for `multilink` for the far side of the relationship. */
  updateById?: InputMaybe<MultilinkOnProjectSeriesForProjectSeriesWebsitesIdFkeyUsingMultilinkPkeyUpdate>;
};

/** Input for the nested mutation of `projectSeries` in the `MultilinkInput` mutation. */
export type ProjectSeriesWebsitesIdFkeyInverseInput = {
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyConnect>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyConnect>>;
  /** A `ProjectSeriesInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectSeriesWebsitesIdFkeyProjectSeriesCreateInput>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectSeriesProjectSeriesPkeyDelete>>;
  /** The primary key(s) for `projectSeries` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ProjectSeriesProjectSeriesNameShortKeyDelete>>;
  /** Flag indicating whether all other `projectSeries` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyUsingProjectSeriesPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectSeries` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyUsingProjectSeriesNameShortKeyUpdate>>;
};

/** The `multilink` to be created by this mutation. */
export type ProjectSeriesWebsitesIdFkeyMultilinkCreateInput = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** The `projectSeries` to be created by this mutation. */
export type ProjectSeriesWebsitesIdFkeyProjectSeriesCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ProjectVariant` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectVariantFilter = {
  /** Every related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectVariantFilter>;
  /** No related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectVariantFilter>;
  /** Some related `ProjectVariant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectVariantFilter>;
};

export type ProjectVariant = {
  __typename?: 'ProjectVariant';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes: Feed;
  changesId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  index: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project: Project;
  /** Reads and enables pagination through a set of `ProjectAllocationArea`. */
  projectAllocationAreas: ProjectAllocationAreasConnection;
  /** Reads and enables pagination through a set of `ProjectAllocationPlot`. */
  projectAllocationPlots: ProjectAllocationPlotsConnection;
  /** Reads and enables pagination through a set of `ProjectAllocationRoom`. */
  projectAllocationRooms: ProjectAllocationRoomsConnection;
  projectId: Scalars['UUID'];
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  referenceProjectAllocationAreaId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
  referenceProjectAllocationRoomId?: Maybe<Scalars['UUID']>;
  start?: Maybe<Scalars['Datetime']>;
  status: Scalars['String'];
};


export type ProjectVariantProjectAllocationAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationAreaCondition>;
  filter?: InputMaybe<ProjectAllocationAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationAreasOrderBy>>;
};


export type ProjectVariantProjectAllocationPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationPlotCondition>;
  filter?: InputMaybe<ProjectAllocationPlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationPlotsOrderBy>>;
};


export type ProjectVariantProjectAllocationRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationRoomCondition>;
  filter?: InputMaybe<ProjectAllocationRoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationRoomsOrderBy>>;
};

/** The `feed` to be created by this mutation. */
export type ProjectVariantChangesIdFkeyFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** Input for the nested mutation of `feed` in the `ProjectVariantInput` mutation. */
export type ProjectVariantChangesIdFkeyInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectVariantChangesIdFkeyFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnProjectVariantForProjectVariantChangesIdFkeyUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `projectVariant` in the `FeedInput` mutation. */
export type ProjectVariantChangesIdFkeyInverseInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyConnect>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyConnect>>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectVariantChangesIdFkeyProjectVariantCreateInput>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyDelete>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyDelete>>;
  /** Flag indicating whether all other `projectVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyUsingProjectVariantPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate>>;
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectVariantChangesIdFkeyProjectVariantCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/**
 * A condition to be used against `ProjectVariant` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectVariantCondition = {
  /** Checks for equality with the object’s `changesId` field. */
  changesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isArchived` field. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referenceProjectAllocationAreaId` field. */
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referenceProjectAllocationRoomId` field. */
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ProjectVariant` object types. All fields are combined with a logical ‘and.’ */
export type ProjectVariantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectVariantFilter>>;
  /** Filter by the object’s `changes` relation. */
  changes?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `changesId` field. */
  changesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isArchived` field. */
  isArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectVariantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectVariantFilter>>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectAllocationAreas` relation. */
  projectAllocationAreas?: InputMaybe<ProjectVariantToManyProjectAllocationAreaFilter>;
  /** Some related `projectAllocationAreas` exist. */
  projectAllocationAreasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectAllocationPlots` relation. */
  projectAllocationPlots?: InputMaybe<ProjectVariantToManyProjectAllocationPlotFilter>;
  /** Some related `projectAllocationPlots` exist. */
  projectAllocationPlotsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectAllocationRooms` relation. */
  projectAllocationRooms?: InputMaybe<ProjectVariantToManyProjectAllocationRoomFilter>;
  /** Some related `projectAllocationRooms` exist. */
  projectAllocationRoomsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `referenceProjectAllocationArea` relation. */
  referenceProjectAllocationArea?: InputMaybe<ProjectAllocationAreaFilter>;
  /** A related `referenceProjectAllocationArea` exists. */
  referenceProjectAllocationAreaExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceProjectAllocationAreaId` field. */
  referenceProjectAllocationAreaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `referenceProjectAllocationRoom` relation. */
  referenceProjectAllocationRoom?: InputMaybe<ProjectAllocationRoomFilter>;
  /** A related `referenceProjectAllocationRoom` exists. */
  referenceProjectAllocationRoomExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceProjectAllocationRoomId` field. */
  referenceProjectAllocationRoomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ProjectVariant` */
export type ProjectVariantInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlPatch;
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlUsingProjectVariantPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlPatch;
};

/** The fields on `projectVariant` to look up the row to update. */
export type ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlUsingProjectVariantProjectIdIndexKeyUpdate = {
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `projectVariant` being updated. */
  patch: UpdateProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlPatch;
  projectId: Scalars['UUID'];
};

/** Represents an update to a `ProjectVariant`. Fields that are set will be updated. */
export type ProjectVariantPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `project` in the `ProjectVariantInput` mutation. */
export type ProjectVariantProjectIdFkeyInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ProjectProjectNameShortKeyConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectVariantProjectIdFkeyProjectCreateInput>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectProjectPkeyDelete>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ProjectProjectNameShortKeyDelete>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ProjectOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectNameShortKeyUpdate>;
};

/** Input for the nested mutation of `projectVariant` in the `ProjectInput` mutation. */
export type ProjectVariantProjectIdFkeyInverseInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyConnect>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyConnect>>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectVariantProjectIdFkeyProjectVariantCreateInput>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyDelete>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyDelete>>;
  /** Flag indicating whether all other `projectVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectVariantPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyUsingProjectVariantProjectIdIndexKeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ProjectVariantProjectIdFkeyProjectCreateInput = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectVariantProjectIdFkeyProjectVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** The fields on `projectVariant` to look up the row to connect. */
export type ProjectVariantProjectVariantPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to delete. */
export type ProjectVariantProjectVariantPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to connect. */
export type ProjectVariantProjectVariantProjectIdIndexKeyConnect = {
  index: Scalars['Int'];
  projectId: Scalars['UUID'];
};

/** The fields on `projectVariant` to look up the row to delete. */
export type ProjectVariantProjectVariantProjectIdIndexKeyDelete = {
  index: Scalars['Int'];
  projectId: Scalars['UUID'];
};

/** Input for the nested mutation of `projectAllocationArea` in the `ProjectVariantInput` mutation. */
export type ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput = {
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationAreaProjectAllocationAreaPkeyConnect>;
  /** A `ProjectAllocationAreaInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlProjectAllocationAreaCreateInput>;
  /** The primary key(s) for `projectAllocationArea` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationAreaProjectAllocationAreaPkeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationArea` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationAreaOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlUsingProjectAllocationAreaPkeyUpdate>;
};

/** Input for the nested mutation of `projectVariant` in the `ProjectAllocationAreaInput` mutation. */
export type ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyConnect>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyConnect>>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectVariantReferenceProjectAllocationAreaIdProjectAlProjectVariantCreateInput>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyDelete>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyDelete>>;
  /** Flag indicating whether all other `projectVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlUsingProjectVariantPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlUsingProjectVariantProjectIdIndexKeyUpdate>>;
};

/** The `projectAllocationArea` to be created by this mutation. */
export type ProjectVariantReferenceProjectAllocationAreaIdProjectAlProjectAllocationAreaCreateInput = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start: Scalars['Datetime'];
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectVariantReferenceProjectAllocationAreaIdProjectAlProjectVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `projectAllocationRoom` in the `ProjectVariantInput` mutation. */
export type ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput = {
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectAllocationRoomProjectAllocationRoomPkeyConnect>;
  /** A `ProjectAllocationRoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlProjectAllocationRoomCreateInput>;
  /** The primary key(s) for `projectAllocationRoom` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectAllocationRoomProjectAllocationRoomPkeyDelete>;
  /** The primary key(s) and patch data for `projectAllocationRoom` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectAllocationRoomOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlUsingProjectAllocationRoomPkeyUpdate>;
};

/** Input for the nested mutation of `projectVariant` in the `ProjectAllocationRoomInput` mutation. */
export type ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput = {
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyConnect>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  connectByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyConnect>>;
  /** A `ProjectVariantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectVariantReferenceProjectAllocationRoomIdProjectAlProjectVariantCreateInput>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectVariantProjectVariantPkeyDelete>>;
  /** The primary key(s) for `projectVariant` for the far side of the relationship. */
  deleteByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantProjectVariantProjectIdIndexKeyDelete>>;
  /** Flag indicating whether all other `projectVariant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlUsingProjectVariantPkeyUpdate>>;
  /** The primary key(s) and patch data for `projectVariant` for the far side of the relationship. */
  updateByProjectIdAndIndex?: InputMaybe<Array<ProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlUsingProjectVariantProjectIdIndexKeyUpdate>>;
};

/** The `projectAllocationRoom` to be created by this mutation. */
export type ProjectVariantReferenceProjectAllocationRoomIdProjectAlProjectAllocationRoomCreateInput = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start: Scalars['Datetime'];
};

/** The `projectVariant` to be created by this mutation. */
export type ProjectVariantReferenceProjectAllocationRoomIdProjectAlProjectVariantCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ProjectAllocationArea` object types. All fields are combined with a logical ‘and.’ */
export type ProjectVariantToManyProjectAllocationAreaFilter = {
  /** Every related `ProjectAllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationAreaFilter>;
  /** No related `ProjectAllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationAreaFilter>;
  /** Some related `ProjectAllocationArea` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationAreaFilter>;
};

/** A filter to be used against many `ProjectAllocationPlot` object types. All fields are combined with a logical ‘and.’ */
export type ProjectVariantToManyProjectAllocationPlotFilter = {
  /** Every related `ProjectAllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationPlotFilter>;
  /** No related `ProjectAllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationPlotFilter>;
  /** Some related `ProjectAllocationPlot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationPlotFilter>;
};

/** A filter to be used against many `ProjectAllocationRoom` object types. All fields are combined with a logical ‘and.’ */
export type ProjectVariantToManyProjectAllocationRoomFilter = {
  /** Every related `ProjectAllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationRoomFilter>;
  /** No related `ProjectAllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationRoomFilter>;
  /** Some related `ProjectAllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationRoomFilter>;
};

/** A connection to a list of `ProjectVariant` values. */
export type ProjectVariantsConnection = {
  __typename?: 'ProjectVariantsConnection';
  /** A list of edges which contains the `ProjectVariant` and cursor to aid in pagination. */
  edges: Array<ProjectVariantsEdge>;
  /** A list of `ProjectVariant` objects. */
  nodes: Array<ProjectVariant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectVariant` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectVariant` edge in the connection. */
export type ProjectVariantsEdge = {
  __typename?: 'ProjectVariantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectVariant` at the end of the edge. */
  node: ProjectVariant;
};

/** Methods to use when ordering `ProjectVariant`. */
export enum ProjectVariantsOrderBy {
  ChangesIdAsc = 'CHANGES_ID_ASC',
  ChangesIdDesc = 'CHANGES_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  FeedByChangesIdIdAsc = 'FEED_BY_CHANGES_ID__ID_ASC',
  FeedByChangesIdIdDesc = 'FEED_BY_CHANGES_ID__ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IsArchivedAsc = 'IS_ARCHIVED_ASC',
  IsArchivedDesc = 'IS_ARCHIVED_DESC',
  IsCurrentAsc = 'IS_CURRENT_ASC',
  IsCurrentDesc = 'IS_CURRENT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationAreasByProjectVariantIdCountAsc = 'PROJECT_ALLOCATION_AREAS_BY_PROJECT_VARIANT_ID__COUNT_ASC',
  ProjectAllocationAreasByProjectVariantIdCountDesc = 'PROJECT_ALLOCATION_AREAS_BY_PROJECT_VARIANT_ID__COUNT_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdAreaIdAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__AREA_ID_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdAreaIdDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__AREA_ID_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdConflictsAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__CONFLICTS_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdConflictsDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__CONFLICTS_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdEndAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__END_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdEndDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__END_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdIdAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__ID_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdIdDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__ID_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdIsOptionalAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__IS_OPTIONAL_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdIsOptionalDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__IS_OPTIONAL_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdProjectVariantIdAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__PROJECT_VARIANT_ID_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdProjectVariantIdDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__PROJECT_VARIANT_ID_DESC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdStartAsc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__START_ASC',
  ProjectAllocationAreaByReferenceProjectAllocationAreaIdStartDesc = 'PROJECT_ALLOCATION_AREA_BY_REFERENCE_PROJECT_ALLOCATION_AREA_ID__START_DESC',
  ProjectAllocationPlotsByProjectVariantIdCountAsc = 'PROJECT_ALLOCATION_PLOTS_BY_PROJECT_VARIANT_ID__COUNT_ASC',
  ProjectAllocationPlotsByProjectVariantIdCountDesc = 'PROJECT_ALLOCATION_PLOTS_BY_PROJECT_VARIANT_ID__COUNT_DESC',
  ProjectAllocationRoomsByProjectVariantIdCountAsc = 'PROJECT_ALLOCATION_ROOMS_BY_PROJECT_VARIANT_ID__COUNT_ASC',
  ProjectAllocationRoomsByProjectVariantIdCountDesc = 'PROJECT_ALLOCATION_ROOMS_BY_PROJECT_VARIANT_ID__COUNT_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdConflictsAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__CONFLICTS_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdConflictsDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__CONFLICTS_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdEndAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__END_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdEndDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__END_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdIdAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__ID_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdIdDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__ID_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdIsOptionalAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__IS_OPTIONAL_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdIsOptionalDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__IS_OPTIONAL_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdProjectVariantIdAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__PROJECT_VARIANT_ID_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdProjectVariantIdDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__PROJECT_VARIANT_ID_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdRoomIdAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__ROOM_ID_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdRoomIdDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__ROOM_ID_DESC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdStartAsc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__START_ASC',
  ProjectAllocationRoomByReferenceProjectAllocationRoomIdStartDesc = 'PROJECT_ALLOCATION_ROOM_BY_REFERENCE_PROJECT_ALLOCATION_ROOM_ID__START_DESC',
  ProjectByProjectIdAllocationHintsAsc = 'PROJECT_BY_PROJECT_ID__ALLOCATION_HINTS_ASC',
  ProjectByProjectIdAllocationHintsDesc = 'PROJECT_BY_PROJECT_ID__ALLOCATION_HINTS_DESC',
  ProjectByProjectIdBusinessDomainAsc = 'PROJECT_BY_PROJECT_ID__BUSINESS_DOMAIN_ASC',
  ProjectByProjectIdBusinessDomainDesc = 'PROJECT_BY_PROJECT_ID__BUSINESS_DOMAIN_DESC',
  ProjectByProjectIdCategoryAsc = 'PROJECT_BY_PROJECT_ID__CATEGORY_ASC',
  ProjectByProjectIdCategoryDesc = 'PROJECT_BY_PROJECT_ID__CATEGORY_DESC',
  ProjectByProjectIdCompanyGroupAsc = 'PROJECT_BY_PROJECT_ID__COMPANY_GROUP_ASC',
  ProjectByProjectIdCompanyGroupDesc = 'PROJECT_BY_PROJECT_ID__COMPANY_GROUP_DESC',
  ProjectByProjectIdDepartmentAsc = 'PROJECT_BY_PROJECT_ID__DEPARTMENT_ASC',
  ProjectByProjectIdDepartmentDesc = 'PROJECT_BY_PROJECT_ID__DEPARTMENT_DESC',
  ProjectByProjectIdDescriptionAsc = 'PROJECT_BY_PROJECT_ID__DESCRIPTION_ASC',
  ProjectByProjectIdDescriptionDesc = 'PROJECT_BY_PROJECT_ID__DESCRIPTION_DESC',
  ProjectByProjectIdDisturbanceDustAsc = 'PROJECT_BY_PROJECT_ID__DISTURBANCE_DUST_ASC',
  ProjectByProjectIdDisturbanceDustDesc = 'PROJECT_BY_PROJECT_ID__DISTURBANCE_DUST_DESC',
  ProjectByProjectIdDisturbanceNoiseAsc = 'PROJECT_BY_PROJECT_ID__DISTURBANCE_NOISE_ASC',
  ProjectByProjectIdDisturbanceNoiseDesc = 'PROJECT_BY_PROJECT_ID__DISTURBANCE_NOISE_DESC',
  ProjectByProjectIdDisturbanceOtherAsc = 'PROJECT_BY_PROJECT_ID__DISTURBANCE_OTHER_ASC',
  ProjectByProjectIdDisturbanceOtherDesc = 'PROJECT_BY_PROJECT_ID__DISTURBANCE_OTHER_DESC',
  ProjectByProjectIdExecutionYearAsc = 'PROJECT_BY_PROJECT_ID__EXECUTION_YEAR_ASC',
  ProjectByProjectIdExecutionYearDesc = 'PROJECT_BY_PROJECT_ID__EXECUTION_YEAR_DESC',
  ProjectByProjectIdIdAsc = 'PROJECT_BY_PROJECT_ID__ID_ASC',
  ProjectByProjectIdIdDesc = 'PROJECT_BY_PROJECT_ID__ID_DESC',
  ProjectByProjectIdLocationRequirementsAsc = 'PROJECT_BY_PROJECT_ID__LOCATION_REQUIREMENTS_ASC',
  ProjectByProjectIdLocationRequirementsDesc = 'PROJECT_BY_PROJECT_ID__LOCATION_REQUIREMENTS_DESC',
  ProjectByProjectIdNameLongAsc = 'PROJECT_BY_PROJECT_ID__NAME_LONG_ASC',
  ProjectByProjectIdNameLongDesc = 'PROJECT_BY_PROJECT_ID__NAME_LONG_DESC',
  ProjectByProjectIdNameShortAsc = 'PROJECT_BY_PROJECT_ID__NAME_SHORT_ASC',
  ProjectByProjectIdNameShortDesc = 'PROJECT_BY_PROJECT_ID__NAME_SHORT_DESC',
  ProjectByProjectIdNotesAppointmentAsc = 'PROJECT_BY_PROJECT_ID__NOTES_APPOINTMENT_ASC',
  ProjectByProjectIdNotesAppointmentDesc = 'PROJECT_BY_PROJECT_ID__NOTES_APPOINTMENT_DESC',
  ProjectByProjectIdNotesDayOrderAsc = 'PROJECT_BY_PROJECT_ID__NOTES_DAY_ORDER_ASC',
  ProjectByProjectIdNotesDayOrderDesc = 'PROJECT_BY_PROJECT_ID__NOTES_DAY_ORDER_DESC',
  ProjectByProjectIdOrganisationalChangesAsc = 'PROJECT_BY_PROJECT_ID__ORGANISATIONAL_CHANGES_ASC',
  ProjectByProjectIdOrganisationalChangesDesc = 'PROJECT_BY_PROJECT_ID__ORGANISATIONAL_CHANGES_DESC',
  ProjectByProjectIdOtherDocumentsIdAsc = 'PROJECT_BY_PROJECT_ID__OTHER_DOCUMENTS_ID_ASC',
  ProjectByProjectIdOtherDocumentsIdDesc = 'PROJECT_BY_PROJECT_ID__OTHER_DOCUMENTS_ID_DESC',
  ProjectByProjectIdOtherLinksIdAsc = 'PROJECT_BY_PROJECT_ID__OTHER_LINKS_ID_ASC',
  ProjectByProjectIdOtherLinksIdDesc = 'PROJECT_BY_PROJECT_ID__OTHER_LINKS_ID_DESC',
  ProjectByProjectIdOtherSystemsIdAsc = 'PROJECT_BY_PROJECT_ID__OTHER_SYSTEMS_ID_ASC',
  ProjectByProjectIdOtherSystemsIdDesc = 'PROJECT_BY_PROJECT_ID__OTHER_SYSTEMS_ID_DESC',
  ProjectByProjectIdSeriesIdAsc = 'PROJECT_BY_PROJECT_ID__SERIES_ID_ASC',
  ProjectByProjectIdSeriesIdDesc = 'PROJECT_BY_PROJECT_ID__SERIES_ID_DESC',
  ProjectByProjectIdStatusAsc = 'PROJECT_BY_PROJECT_ID__STATUS_ASC',
  ProjectByProjectIdStatusDesc = 'PROJECT_BY_PROJECT_ID__STATUS_DESC',
  ProjectByProjectIdSubtitleAsc = 'PROJECT_BY_PROJECT_ID__SUBTITLE_ASC',
  ProjectByProjectIdSubtitleDesc = 'PROJECT_BY_PROJECT_ID__SUBTITLE_DESC',
  ProjectByProjectIdTypeAsc = 'PROJECT_BY_PROJECT_ID__TYPE_ASC',
  ProjectByProjectIdTypeDesc = 'PROJECT_BY_PROJECT_ID__TYPE_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ReferenceProjectAllocationAreaIdAsc = 'REFERENCE_PROJECT_ALLOCATION_AREA_ID_ASC',
  ReferenceProjectAllocationAreaIdDesc = 'REFERENCE_PROJECT_ALLOCATION_AREA_ID_DESC',
  ReferenceProjectAllocationRoomIdAsc = 'REFERENCE_PROJECT_ALLOCATION_ROOM_ID_ASC',
  ReferenceProjectAllocationRoomIdDesc = 'REFERENCE_PROJECT_ALLOCATION_ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename?: 'ProjectsConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Project>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename?: 'ProjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Project` at the end of the edge. */
  node: Project;
};

/** Methods to use when ordering `Project`. */
export enum ProjectsOrderBy {
  AllocationHintsAsc = 'ALLOCATION_HINTS_ASC',
  AllocationHintsDesc = 'ALLOCATION_HINTS_DESC',
  BusinessDomainAsc = 'BUSINESS_DOMAIN_ASC',
  BusinessDomainDesc = 'BUSINESS_DOMAIN_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CompanyGroupAsc = 'COMPANY_GROUP_ASC',
  CompanyGroupDesc = 'COMPANY_GROUP_DESC',
  DepartmentAsc = 'DEPARTMENT_ASC',
  DepartmentDesc = 'DEPARTMENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DisturbanceDustAsc = 'DISTURBANCE_DUST_ASC',
  DisturbanceDustDesc = 'DISTURBANCE_DUST_DESC',
  DisturbanceNoiseAsc = 'DISTURBANCE_NOISE_ASC',
  DisturbanceNoiseDesc = 'DISTURBANCE_NOISE_DESC',
  DisturbanceOtherAsc = 'DISTURBANCE_OTHER_ASC',
  DisturbanceOtherDesc = 'DISTURBANCE_OTHER_DESC',
  ExecutionYearAsc = 'EXECUTION_YEAR_ASC',
  ExecutionYearDesc = 'EXECUTION_YEAR_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LocationRequirementsAsc = 'LOCATION_REQUIREMENTS_ASC',
  LocationRequirementsDesc = 'LOCATION_REQUIREMENTS_DESC',
  MultilinkByOtherDocumentsIdIdAsc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__ID_ASC',
  MultilinkByOtherDocumentsIdIdDesc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__ID_DESC',
  MultilinkByOtherDocumentsIdNameAsc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__NAME_ASC',
  MultilinkByOtherDocumentsIdNameDesc = 'MULTILINK_BY_OTHER_DOCUMENTS_ID__NAME_DESC',
  MultilinkByOtherLinksIdIdAsc = 'MULTILINK_BY_OTHER_LINKS_ID__ID_ASC',
  MultilinkByOtherLinksIdIdDesc = 'MULTILINK_BY_OTHER_LINKS_ID__ID_DESC',
  MultilinkByOtherLinksIdNameAsc = 'MULTILINK_BY_OTHER_LINKS_ID__NAME_ASC',
  MultilinkByOtherLinksIdNameDesc = 'MULTILINK_BY_OTHER_LINKS_ID__NAME_DESC',
  MultilinkByOtherSystemsIdIdAsc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__ID_ASC',
  MultilinkByOtherSystemsIdIdDesc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__ID_DESC',
  MultilinkByOtherSystemsIdNameAsc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__NAME_ASC',
  MultilinkByOtherSystemsIdNameDesc = 'MULTILINK_BY_OTHER_SYSTEMS_ID__NAME_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  NotesAppointmentAsc = 'NOTES_APPOINTMENT_ASC',
  NotesAppointmentDesc = 'NOTES_APPOINTMENT_DESC',
  NotesDayOrderAsc = 'NOTES_DAY_ORDER_ASC',
  NotesDayOrderDesc = 'NOTES_DAY_ORDER_DESC',
  OrganisationalChangesAsc = 'ORGANISATIONAL_CHANGES_ASC',
  OrganisationalChangesDesc = 'ORGANISATIONAL_CHANGES_DESC',
  OtherDocumentsIdAsc = 'OTHER_DOCUMENTS_ID_ASC',
  OtherDocumentsIdDesc = 'OTHER_DOCUMENTS_ID_DESC',
  OtherLinksIdAsc = 'OTHER_LINKS_ID_ASC',
  OtherLinksIdDesc = 'OTHER_LINKS_ID_DESC',
  OtherSystemsIdAsc = 'OTHER_SYSTEMS_ID_ASC',
  OtherSystemsIdDesc = 'OTHER_SYSTEMS_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectSeriesBySeriesIdAllocationHintsAsc = 'PROJECT_SERIES_BY_SERIES_ID__ALLOCATION_HINTS_ASC',
  ProjectSeriesBySeriesIdAllocationHintsDesc = 'PROJECT_SERIES_BY_SERIES_ID__ALLOCATION_HINTS_DESC',
  ProjectSeriesBySeriesIdBusinessDomainAsc = 'PROJECT_SERIES_BY_SERIES_ID__BUSINESS_DOMAIN_ASC',
  ProjectSeriesBySeriesIdBusinessDomainDesc = 'PROJECT_SERIES_BY_SERIES_ID__BUSINESS_DOMAIN_DESC',
  ProjectSeriesBySeriesIdCategoryAsc = 'PROJECT_SERIES_BY_SERIES_ID__CATEGORY_ASC',
  ProjectSeriesBySeriesIdCategoryDesc = 'PROJECT_SERIES_BY_SERIES_ID__CATEGORY_DESC',
  ProjectSeriesBySeriesIdCompanyGroupAsc = 'PROJECT_SERIES_BY_SERIES_ID__COMPANY_GROUP_ASC',
  ProjectSeriesBySeriesIdCompanyGroupDesc = 'PROJECT_SERIES_BY_SERIES_ID__COMPANY_GROUP_DESC',
  ProjectSeriesBySeriesIdCycleAsc = 'PROJECT_SERIES_BY_SERIES_ID__CYCLE_ASC',
  ProjectSeriesBySeriesIdCycleDesc = 'PROJECT_SERIES_BY_SERIES_ID__CYCLE_DESC',
  ProjectSeriesBySeriesIdDepartmentAsc = 'PROJECT_SERIES_BY_SERIES_ID__DEPARTMENT_ASC',
  ProjectSeriesBySeriesIdDepartmentDesc = 'PROJECT_SERIES_BY_SERIES_ID__DEPARTMENT_DESC',
  ProjectSeriesBySeriesIdDescriptionAsc = 'PROJECT_SERIES_BY_SERIES_ID__DESCRIPTION_ASC',
  ProjectSeriesBySeriesIdDescriptionDesc = 'PROJECT_SERIES_BY_SERIES_ID__DESCRIPTION_DESC',
  ProjectSeriesBySeriesIdIdAsc = 'PROJECT_SERIES_BY_SERIES_ID__ID_ASC',
  ProjectSeriesBySeriesIdIdDesc = 'PROJECT_SERIES_BY_SERIES_ID__ID_DESC',
  ProjectSeriesBySeriesIdLocationRequirementsAsc = 'PROJECT_SERIES_BY_SERIES_ID__LOCATION_REQUIREMENTS_ASC',
  ProjectSeriesBySeriesIdLocationRequirementsDesc = 'PROJECT_SERIES_BY_SERIES_ID__LOCATION_REQUIREMENTS_DESC',
  ProjectSeriesBySeriesIdNameLongAsc = 'PROJECT_SERIES_BY_SERIES_ID__NAME_LONG_ASC',
  ProjectSeriesBySeriesIdNameLongDesc = 'PROJECT_SERIES_BY_SERIES_ID__NAME_LONG_DESC',
  ProjectSeriesBySeriesIdNameShortAsc = 'PROJECT_SERIES_BY_SERIES_ID__NAME_SHORT_ASC',
  ProjectSeriesBySeriesIdNameShortDesc = 'PROJECT_SERIES_BY_SERIES_ID__NAME_SHORT_DESC',
  ProjectSeriesBySeriesIdNotesAppointmentAsc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_APPOINTMENT_ASC',
  ProjectSeriesBySeriesIdNotesAppointmentDesc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_APPOINTMENT_DESC',
  ProjectSeriesBySeriesIdNotesAsc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_ASC',
  ProjectSeriesBySeriesIdNotesCycleAsc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_CYCLE_ASC',
  ProjectSeriesBySeriesIdNotesCycleDesc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_CYCLE_DESC',
  ProjectSeriesBySeriesIdNotesDayOrderAsc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_DAY_ORDER_ASC',
  ProjectSeriesBySeriesIdNotesDayOrderDesc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_DAY_ORDER_DESC',
  ProjectSeriesBySeriesIdNotesDesc = 'PROJECT_SERIES_BY_SERIES_ID__NOTES_DESC',
  ProjectSeriesBySeriesIdOrganisationalChangesAsc = 'PROJECT_SERIES_BY_SERIES_ID__ORGANISATIONAL_CHANGES_ASC',
  ProjectSeriesBySeriesIdOrganisationalChangesDesc = 'PROJECT_SERIES_BY_SERIES_ID__ORGANISATIONAL_CHANGES_DESC',
  ProjectSeriesBySeriesIdOtherDocumentsIdAsc = 'PROJECT_SERIES_BY_SERIES_ID__OTHER_DOCUMENTS_ID_ASC',
  ProjectSeriesBySeriesIdOtherDocumentsIdDesc = 'PROJECT_SERIES_BY_SERIES_ID__OTHER_DOCUMENTS_ID_DESC',
  ProjectSeriesBySeriesIdOtherLinksIdAsc = 'PROJECT_SERIES_BY_SERIES_ID__OTHER_LINKS_ID_ASC',
  ProjectSeriesBySeriesIdOtherLinksIdDesc = 'PROJECT_SERIES_BY_SERIES_ID__OTHER_LINKS_ID_DESC',
  ProjectSeriesBySeriesIdOtherSystemsIdAsc = 'PROJECT_SERIES_BY_SERIES_ID__OTHER_SYSTEMS_ID_ASC',
  ProjectSeriesBySeriesIdOtherSystemsIdDesc = 'PROJECT_SERIES_BY_SERIES_ID__OTHER_SYSTEMS_ID_DESC',
  ProjectSeriesBySeriesIdSingleProjectAsc = 'PROJECT_SERIES_BY_SERIES_ID__SINGLE_PROJECT_ASC',
  ProjectSeriesBySeriesIdSingleProjectDesc = 'PROJECT_SERIES_BY_SERIES_ID__SINGLE_PROJECT_DESC',
  ProjectSeriesBySeriesIdTypeAsc = 'PROJECT_SERIES_BY_SERIES_ID__TYPE_ASC',
  ProjectSeriesBySeriesIdTypeDesc = 'PROJECT_SERIES_BY_SERIES_ID__TYPE_DESC',
  ProjectSeriesBySeriesIdWebsitesIdAsc = 'PROJECT_SERIES_BY_SERIES_ID__WEBSITES_ID_ASC',
  ProjectSeriesBySeriesIdWebsitesIdDesc = 'PROJECT_SERIES_BY_SERIES_ID__WEBSITES_ID_DESC',
  ProjectVariantsByProjectIdCountAsc = 'PROJECT_VARIANTS_BY_PROJECT_ID__COUNT_ASC',
  ProjectVariantsByProjectIdCountDesc = 'PROJECT_VARIANTS_BY_PROJECT_ID__COUNT_DESC',
  SeriesIdAsc = 'SERIES_ID_ASC',
  SeriesIdDesc = 'SERIES_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubtitleAsc = 'SUBTITLE_ASC',
  SubtitleDesc = 'SUBTITLE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  allocationArea?: Maybe<AllocationArea>;
  allocationAreaPhase?: Maybe<AllocationAreaPhase>;
  /** Reads and enables pagination through a set of `AllocationAreaPhase`. */
  allocationAreaPhases?: Maybe<AllocationAreaPhasesConnection>;
  /** Reads and enables pagination through a set of `AllocationArea`. */
  allocationAreas?: Maybe<AllocationAreasConnection>;
  allocationPlot?: Maybe<AllocationPlot>;
  allocationPlotPhase?: Maybe<AllocationPlotPhase>;
  /** Reads and enables pagination through a set of `AllocationPlotPhase`. */
  allocationPlotPhases?: Maybe<AllocationPlotPhasesConnection>;
  /** Reads and enables pagination through a set of `AllocationPlot`. */
  allocationPlots?: Maybe<AllocationPlotsConnection>;
  allocationRoom?: Maybe<AllocationRoom>;
  allocationRoomPhase?: Maybe<AllocationRoomPhase>;
  /** Reads and enables pagination through a set of `AllocationRoomPhase`. */
  allocationRoomPhases?: Maybe<AllocationRoomPhasesConnection>;
  /** Reads and enables pagination through a set of `AllocationRoom`. */
  allocationRooms?: Maybe<AllocationRoomsConnection>;
  allocationUsage?: Maybe<AllocationUsage>;
  allocationUsageByName?: Maybe<AllocationUsage>;
  allocationUsageByNameShort?: Maybe<AllocationUsage>;
  allocationUsageByPosition?: Maybe<AllocationUsage>;
  allocationUsageByType?: Maybe<AllocationUsage>;
  /** Reads and enables pagination through a set of `AllocationUsage`. */
  allocationUsages?: Maybe<AllocationUsagesConnection>;
  area?: Maybe<Area>;
  areaByExtId?: Maybe<Area>;
  areaByNameShort?: Maybe<Area>;
  areaCadGrossSpaceMin?: Maybe<AreaCadGrossSpaceMin>;
  /** Reads and enables pagination through a set of `AreaCadGrossSpaceMin`. */
  areaCadGrossSpaceMins?: Maybe<AreaCadGrossSpaceMinsConnection>;
  areaClearanceConstruction?: Maybe<AreaClearanceConstruction>;
  /** Reads and enables pagination through a set of `AreaClearanceConstruction`. */
  areaClearanceConstructions?: Maybe<AreaClearanceConstructionsConnection>;
  areaContactBooking?: Maybe<AreaContactBooking>;
  /** Reads and enables pagination through a set of `AreaContactBooking`. */
  areaContactBookings?: Maybe<AreaContactBookingsConnection>;
  areaDescription?: Maybe<AreaDescription>;
  /** Reads and enables pagination through a set of `AreaDescription`. */
  areaDescriptions?: Maybe<AreaDescriptionsConnection>;
  areaKeyIssuance?: Maybe<AreaKeyIssuance>;
  areaKeyIssuanceNote?: Maybe<AreaKeyIssuanceNote>;
  /** Reads and enables pagination through a set of `AreaKeyIssuanceNote`. */
  areaKeyIssuanceNotes?: Maybe<AreaKeyIssuanceNotesConnection>;
  /** Reads and enables pagination through a set of `AreaKeyIssuance`. */
  areaKeyIssuances?: Maybe<AreaKeyIssuancesConnection>;
  areaNameExtra?: Maybe<AreaNameExtra>;
  /** Reads and enables pagination through a set of `AreaNameExtra`. */
  areaNameExtras?: Maybe<AreaNameExtrasConnection>;
  areaNameKeyCad?: Maybe<AreaNameKeyCad>;
  /** Reads and enables pagination through a set of `AreaNameKeyCad`. */
  areaNameKeyCads?: Maybe<AreaNameKeyCadsConnection>;
  areaNameKeyCafm?: Maybe<AreaNameKeyCafm>;
  /** Reads and enables pagination through a set of `AreaNameKeyCafm`. */
  areaNameKeyCafms?: Maybe<AreaNameKeyCafmsConnection>;
  areaNameKeyEbm?: Maybe<AreaNameKeyEbm>;
  /** Reads and enables pagination through a set of `AreaNameKeyEbm`. */
  areaNameKeyEbms?: Maybe<AreaNameKeyEbmsConnection>;
  areaNameKeyMarketing?: Maybe<AreaNameKeyMarketing>;
  /** Reads and enables pagination through a set of `AreaNameKeyMarketing`. */
  areaNameKeyMarketings?: Maybe<AreaNameKeyMarketingsConnection>;
  areaNameLong?: Maybe<AreaNameLong>;
  /** Reads and enables pagination through a set of `AreaNameLong`. */
  areaNameLongs?: Maybe<AreaNameLongsConnection>;
  areaNameShort?: Maybe<AreaNameShort>;
  /** Reads and enables pagination through a set of `AreaNameShort`. */
  areaNameShorts?: Maybe<AreaNameShortsConnection>;
  areaPublicGrossSpace?: Maybe<AreaPublicGrossSpace>;
  /** Reads and enables pagination through a set of `AreaPublicGrossSpace`. */
  areaPublicGrossSpaces?: Maybe<AreaPublicGrossSpacesConnection>;
  areaType?: Maybe<AreaType>;
  areaTypeAttr?: Maybe<AreaTypeAttr>;
  /** Reads and enables pagination through a set of `AreaTypeAttr`. */
  areaTypeAttrs?: Maybe<AreaTypeAttrsConnection>;
  areaTypeByName?: Maybe<AreaType>;
  /** Reads and enables pagination through a set of `AreaType`. */
  areaTypes?: Maybe<AreaTypesConnection>;
  /** Reads and enables pagination through a set of `Area`. */
  areas?: Maybe<AreasConnection>;
  building?: Maybe<Building>;
  buildingByExtId?: Maybe<Building>;
  buildingByIdAndSiteId?: Maybe<Building>;
  buildingByNameShort?: Maybe<Building>;
  buildingDescription?: Maybe<BuildingDescription>;
  /** Reads and enables pagination through a set of `BuildingDescription`. */
  buildingDescriptions?: Maybe<BuildingDescriptionsConnection>;
  buildingNameExtra?: Maybe<BuildingNameExtra>;
  /** Reads and enables pagination through a set of `BuildingNameExtra`. */
  buildingNameExtras?: Maybe<BuildingNameExtrasConnection>;
  buildingNameKeyCad?: Maybe<BuildingNameKeyCad>;
  /** Reads and enables pagination through a set of `BuildingNameKeyCad`. */
  buildingNameKeyCads?: Maybe<BuildingNameKeyCadsConnection>;
  buildingNameKeyCafm?: Maybe<BuildingNameKeyCafm>;
  /** Reads and enables pagination through a set of `BuildingNameKeyCafm`. */
  buildingNameKeyCafms?: Maybe<BuildingNameKeyCafmsConnection>;
  buildingNameKeyEbm?: Maybe<BuildingNameKeyEbm>;
  /** Reads and enables pagination through a set of `BuildingNameKeyEbm`. */
  buildingNameKeyEbms?: Maybe<BuildingNameKeyEbmsConnection>;
  buildingNameKeyMarketing?: Maybe<BuildingNameKeyMarketing>;
  /** Reads and enables pagination through a set of `BuildingNameKeyMarketing`. */
  buildingNameKeyMarketings?: Maybe<BuildingNameKeyMarketingsConnection>;
  buildingNameLong?: Maybe<BuildingNameLong>;
  /** Reads and enables pagination through a set of `BuildingNameLong`. */
  buildingNameLongs?: Maybe<BuildingNameLongsConnection>;
  buildingNameShort?: Maybe<BuildingNameShort>;
  /** Reads and enables pagination through a set of `BuildingNameShort`. */
  buildingNameShorts?: Maybe<BuildingNameShortsConnection>;
  buildingPublicGrossSpace?: Maybe<BuildingPublicGrossSpace>;
  /** Reads and enables pagination through a set of `BuildingPublicGrossSpace`. */
  buildingPublicGrossSpaces?: Maybe<BuildingPublicGrossSpacesConnection>;
  buildingType?: Maybe<BuildingType>;
  buildingTypeAttr?: Maybe<BuildingTypeAttr>;
  /** Reads and enables pagination through a set of `BuildingTypeAttr`. */
  buildingTypeAttrs?: Maybe<BuildingTypeAttrsConnection>;
  buildingTypeByName?: Maybe<BuildingType>;
  /** Reads and enables pagination through a set of `BuildingType`. */
  buildingTypes?: Maybe<BuildingTypesConnection>;
  /** Reads and enables pagination through a set of `Building`. */
  buildings?: Maybe<BuildingsConnection>;
  elevationLevel?: Maybe<ElevationLevel>;
  elevationLevelByValue?: Maybe<ElevationLevel>;
  /** Reads and enables pagination through a set of `ElevationLevel`. */
  elevationLevels?: Maybe<ElevationLevelsConnection>;
  event?: Maybe<Event>;
  eventByNameShort?: Maybe<Event>;
  eventSeries?: Maybe<EventSeries>;
  eventSeriesByNameShort?: Maybe<EventSeries>;
  /** Reads and enables pagination through a set of `EventSeries`. */
  eventSerieses?: Maybe<EventSeriesConnection>;
  eventVariant?: Maybe<EventVariant>;
  eventVariantByEventIdAndIndex?: Maybe<EventVariant>;
  /** Reads and enables pagination through a set of `EventVariant`. */
  eventVariants?: Maybe<EventVariantsConnection>;
  /** Reads and enables pagination through a set of `Event`. */
  events?: Maybe<EventsConnection>;
  externalEvent?: Maybe<ExternalEvent>;
  externalEventAllocation?: Maybe<ExternalEventAllocation>;
  externalEventAllocationPhase?: Maybe<ExternalEventAllocationPhase>;
  /** Reads and enables pagination through a set of `ExternalEventAllocationPhase`. */
  externalEventAllocationPhases?: Maybe<ExternalEventAllocationPhasesConnection>;
  externalEventAllocationUsage?: Maybe<ExternalEventAllocationUsage>;
  externalEventAllocationUsageByName?: Maybe<ExternalEventAllocationUsage>;
  externalEventAllocationUsageByNameShort?: Maybe<ExternalEventAllocationUsage>;
  externalEventAllocationUsageByPosition?: Maybe<ExternalEventAllocationUsage>;
  externalEventAllocationUsageByType?: Maybe<ExternalEventAllocationUsage>;
  /** Reads and enables pagination through a set of `ExternalEventAllocationUsage`. */
  externalEventAllocationUsages?: Maybe<ExternalEventAllocationUsagesConnection>;
  /** Reads and enables pagination through a set of `ExternalEventAllocation`. */
  externalEventAllocations?: Maybe<ExternalEventAllocationsConnection>;
  externalEventByNameShort?: Maybe<ExternalEvent>;
  /** Reads and enables pagination through a set of `ExternalEventEventLocationVisibility`. */
  externalEventEventLocationVisibilities?: Maybe<ExternalEventEventLocationVisibilitiesConnection>;
  externalEventEventLocationVisibility?: Maybe<ExternalEventEventLocationVisibility>;
  externalEventEventLocationVisibilityByEventIdAndLocationId?: Maybe<ExternalEventEventLocationVisibility>;
  externalEventLocation?: Maybe<ExternalEventLocation>;
  externalEventLocationByName?: Maybe<ExternalEventLocation>;
  /** Reads and enables pagination through a set of `ExternalEventLocation`. */
  externalEventLocations?: Maybe<ExternalEventLocationsConnection>;
  externalEventSeries?: Maybe<ExternalEventSeries>;
  externalEventSeriesByNameShort?: Maybe<ExternalEventSeries>;
  /** Reads and enables pagination through a set of `ExternalEventSeries`. */
  externalEventSerieses?: Maybe<ExternalEventSeriesConnection>;
  externalEventVariant?: Maybe<ExternalEventVariant>;
  externalEventVariantByEventIdAndIndex?: Maybe<ExternalEventVariant>;
  /** Reads and enables pagination through a set of `ExternalEventVariant`. */
  externalEventVariants?: Maybe<ExternalEventVariantsConnection>;
  /** Reads and enables pagination through a set of `ExternalEvent`. */
  externalEvents?: Maybe<ExternalEventsConnection>;
  feed?: Maybe<Feed>;
  /** Reads and enables pagination through a set of `FeedEntry`. */
  feedEntries?: Maybe<FeedEntriesConnection>;
  feedEntry?: Maybe<FeedEntry>;
  /** Reads and enables pagination through a set of `Feed`. */
  feeds?: Maybe<FeedsConnection>;
  file?: Maybe<File>;
  getEntraUserData?: Maybe<GetEntraUserDataResponse>;
  level?: Maybe<Level>;
  levelByExtId?: Maybe<Level>;
  levelByNameShort?: Maybe<Level>;
  levelCapacityPax?: Maybe<LevelCapacityPax>;
  /** Reads and enables pagination through a set of `LevelCapacityPax`. */
  levelCapacityPaxes?: Maybe<LevelCapacityPaxesConnection>;
  levelDescription?: Maybe<LevelDescription>;
  /** Reads and enables pagination through a set of `LevelDescription`. */
  levelDescriptions?: Maybe<LevelDescriptionsConnection>;
  levelFkmGrossSpace?: Maybe<LevelFkmGrossSpace>;
  /** Reads and enables pagination through a set of `LevelFkmGrossSpace`. */
  levelFkmGrossSpaces?: Maybe<LevelFkmGrossSpacesConnection>;
  levelNameExtra?: Maybe<LevelNameExtra>;
  /** Reads and enables pagination through a set of `LevelNameExtra`. */
  levelNameExtras?: Maybe<LevelNameExtrasConnection>;
  levelNameKeyCad?: Maybe<LevelNameKeyCad>;
  /** Reads and enables pagination through a set of `LevelNameKeyCad`. */
  levelNameKeyCads?: Maybe<LevelNameKeyCadsConnection>;
  levelNameKeyCafm?: Maybe<LevelNameKeyCafm>;
  /** Reads and enables pagination through a set of `LevelNameKeyCafm`. */
  levelNameKeyCafms?: Maybe<LevelNameKeyCafmsConnection>;
  levelNameKeyEbm?: Maybe<LevelNameKeyEbm>;
  /** Reads and enables pagination through a set of `LevelNameKeyEbm`. */
  levelNameKeyEbms?: Maybe<LevelNameKeyEbmsConnection>;
  levelNameKeyMarketing?: Maybe<LevelNameKeyMarketing>;
  /** Reads and enables pagination through a set of `LevelNameKeyMarketing`. */
  levelNameKeyMarketings?: Maybe<LevelNameKeyMarketingsConnection>;
  levelNameLong?: Maybe<LevelNameLong>;
  /** Reads and enables pagination through a set of `LevelNameLong`. */
  levelNameLongs?: Maybe<LevelNameLongsConnection>;
  levelNameShort?: Maybe<LevelNameShort>;
  /** Reads and enables pagination through a set of `LevelNameShort`. */
  levelNameShorts?: Maybe<LevelNameShortsConnection>;
  levelPublicGrossSpace?: Maybe<LevelPublicGrossSpace>;
  /** Reads and enables pagination through a set of `LevelPublicGrossSpace`. */
  levelPublicGrossSpaces?: Maybe<LevelPublicGrossSpacesConnection>;
  levelType?: Maybe<LevelType>;
  levelTypeAttr?: Maybe<LevelTypeAttr>;
  /** Reads and enables pagination through a set of `LevelTypeAttr`. */
  levelTypeAttrs?: Maybe<LevelTypeAttrsConnection>;
  levelTypeByName?: Maybe<LevelType>;
  /** Reads and enables pagination through a set of `LevelType`. */
  levelTypes?: Maybe<LevelTypesConnection>;
  /** Reads and enables pagination through a set of `Level`. */
  levels?: Maybe<LevelsConnection>;
  link?: Maybe<Link>;
  /** Reads and enables pagination through a set of `Link`. */
  links?: Maybe<LinksConnection>;
  multilink?: Maybe<Multilink>;
  /** Reads and enables pagination through a set of `Multilink`. */
  multilinks?: Maybe<MultilinksConnection>;
  myUser?: Maybe<User>;
  plot?: Maybe<Plot>;
  plotByExtId?: Maybe<Plot>;
  plotByNameShort?: Maybe<Plot>;
  plotCadGrossSpaceMin?: Maybe<PlotCadGrossSpaceMin>;
  /** Reads and enables pagination through a set of `PlotCadGrossSpaceMin`. */
  plotCadGrossSpaceMins?: Maybe<PlotCadGrossSpaceMinsConnection>;
  plotDescription?: Maybe<PlotDescription>;
  /** Reads and enables pagination through a set of `PlotDescription`. */
  plotDescriptions?: Maybe<PlotDescriptionsConnection>;
  plotNameExtra?: Maybe<PlotNameExtra>;
  /** Reads and enables pagination through a set of `PlotNameExtra`. */
  plotNameExtras?: Maybe<PlotNameExtrasConnection>;
  plotNameKeyCad?: Maybe<PlotNameKeyCad>;
  /** Reads and enables pagination through a set of `PlotNameKeyCad`. */
  plotNameKeyCads?: Maybe<PlotNameKeyCadsConnection>;
  plotNameKeyCafm?: Maybe<PlotNameKeyCafm>;
  /** Reads and enables pagination through a set of `PlotNameKeyCafm`. */
  plotNameKeyCafms?: Maybe<PlotNameKeyCafmsConnection>;
  plotNameKeyEbm?: Maybe<PlotNameKeyEbm>;
  /** Reads and enables pagination through a set of `PlotNameKeyEbm`. */
  plotNameKeyEbms?: Maybe<PlotNameKeyEbmsConnection>;
  plotNameKeyMarketing?: Maybe<PlotNameKeyMarketing>;
  /** Reads and enables pagination through a set of `PlotNameKeyMarketing`. */
  plotNameKeyMarketings?: Maybe<PlotNameKeyMarketingsConnection>;
  plotNameLong?: Maybe<PlotNameLong>;
  /** Reads and enables pagination through a set of `PlotNameLong`. */
  plotNameLongs?: Maybe<PlotNameLongsConnection>;
  plotNameShort?: Maybe<PlotNameShort>;
  /** Reads and enables pagination through a set of `PlotNameShort`. */
  plotNameShorts?: Maybe<PlotNameShortsConnection>;
  plotPublicGrossSpace?: Maybe<PlotPublicGrossSpace>;
  /** Reads and enables pagination through a set of `PlotPublicGrossSpace`. */
  plotPublicGrossSpaces?: Maybe<PlotPublicGrossSpacesConnection>;
  plotType?: Maybe<PlotType>;
  plotTypeAttr?: Maybe<PlotTypeAttr>;
  /** Reads and enables pagination through a set of `PlotTypeAttr`. */
  plotTypeAttrs?: Maybe<PlotTypeAttrsConnection>;
  plotTypeByName?: Maybe<PlotType>;
  /** Reads and enables pagination through a set of `PlotType`. */
  plotTypes?: Maybe<PlotTypesConnection>;
  /** Reads and enables pagination through a set of `Plot`. */
  plots?: Maybe<PlotsConnection>;
  project?: Maybe<Project>;
  projectAllocationArea?: Maybe<ProjectAllocationArea>;
  projectAllocationAreaPhase?: Maybe<ProjectAllocationAreaPhase>;
  /** Reads and enables pagination through a set of `ProjectAllocationAreaPhase`. */
  projectAllocationAreaPhases?: Maybe<ProjectAllocationAreaPhasesConnection>;
  /** Reads and enables pagination through a set of `ProjectAllocationArea`. */
  projectAllocationAreas?: Maybe<ProjectAllocationAreasConnection>;
  projectAllocationPlot?: Maybe<ProjectAllocationPlot>;
  projectAllocationPlotPhase?: Maybe<ProjectAllocationPlotPhase>;
  /** Reads and enables pagination through a set of `ProjectAllocationPlotPhase`. */
  projectAllocationPlotPhases?: Maybe<ProjectAllocationPlotPhasesConnection>;
  /** Reads and enables pagination through a set of `ProjectAllocationPlot`. */
  projectAllocationPlots?: Maybe<ProjectAllocationPlotsConnection>;
  projectAllocationRoom?: Maybe<ProjectAllocationRoom>;
  projectAllocationRoomPhase?: Maybe<ProjectAllocationRoomPhase>;
  /** Reads and enables pagination through a set of `ProjectAllocationRoomPhase`. */
  projectAllocationRoomPhases?: Maybe<ProjectAllocationRoomPhasesConnection>;
  /** Reads and enables pagination through a set of `ProjectAllocationRoom`. */
  projectAllocationRooms?: Maybe<ProjectAllocationRoomsConnection>;
  projectAllocationUsage?: Maybe<ProjectAllocationUsage>;
  projectAllocationUsageByName?: Maybe<ProjectAllocationUsage>;
  projectAllocationUsageByNameShort?: Maybe<ProjectAllocationUsage>;
  projectAllocationUsageByPosition?: Maybe<ProjectAllocationUsage>;
  projectAllocationUsageByType?: Maybe<ProjectAllocationUsage>;
  /** Reads and enables pagination through a set of `ProjectAllocationUsage`. */
  projectAllocationUsages?: Maybe<ProjectAllocationUsagesConnection>;
  projectByNameShort?: Maybe<Project>;
  projectSeries?: Maybe<ProjectSeries>;
  projectSeriesByNameShort?: Maybe<ProjectSeries>;
  /** Reads and enables pagination through a set of `ProjectSeries`. */
  projectSerieses?: Maybe<ProjectSeriesConnection>;
  projectVariant?: Maybe<ProjectVariant>;
  projectVariantByProjectIdAndIndex?: Maybe<ProjectVariant>;
  /** Reads and enables pagination through a set of `ProjectVariant`. */
  projectVariants?: Maybe<ProjectVariantsConnection>;
  /** Reads and enables pagination through a set of `Project`. */
  projects?: Maybe<ProjectsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  room?: Maybe<Room>;
  roomAirChangeRate?: Maybe<RoomAirChangeRate>;
  /** Reads and enables pagination through a set of `RoomAirChangeRate`. */
  roomAirChangeRates?: Maybe<RoomAirChangeRatesConnection>;
  roomAirConditioning?: Maybe<RoomAirConditioning>;
  /** Reads and enables pagination through a set of `RoomAirConditioning`. */
  roomAirConditionings?: Maybe<RoomAirConditioningsConnection>;
  roomByExtId?: Maybe<Room>;
  roomByNameShort?: Maybe<Room>;
  roomCadGrossSpaceMin?: Maybe<RoomCadGrossSpaceMin>;
  /** Reads and enables pagination through a set of `RoomCadGrossSpaceMin`. */
  roomCadGrossSpaceMins?: Maybe<RoomCadGrossSpaceMinsConnection>;
  roomCadHeightMax?: Maybe<RoomCadHeightMax>;
  /** Reads and enables pagination through a set of `RoomCadHeightMax`. */
  roomCadHeightMaxes?: Maybe<RoomCadHeightMaxesConnection>;
  roomCadHeightMin?: Maybe<RoomCadHeightMin>;
  /** Reads and enables pagination through a set of `RoomCadHeightMin`. */
  roomCadHeightMins?: Maybe<RoomCadHeightMinsConnection>;
  roomCadLengthMax?: Maybe<RoomCadLengthMax>;
  /** Reads and enables pagination through a set of `RoomCadLengthMax`. */
  roomCadLengthMaxes?: Maybe<RoomCadLengthMaxesConnection>;
  roomCadLengthMin?: Maybe<RoomCadLengthMin>;
  /** Reads and enables pagination through a set of `RoomCadLengthMin`. */
  roomCadLengthMins?: Maybe<RoomCadLengthMinsConnection>;
  roomCadWidthMax?: Maybe<RoomCadWidthMax>;
  /** Reads and enables pagination through a set of `RoomCadWidthMax`. */
  roomCadWidthMaxes?: Maybe<RoomCadWidthMaxesConnection>;
  roomCadWidthMin?: Maybe<RoomCadWidthMin>;
  /** Reads and enables pagination through a set of `RoomCadWidthMin`. */
  roomCadWidthMins?: Maybe<RoomCadWidthMinsConnection>;
  roomCapacityCar?: Maybe<RoomCapacityCar>;
  /** Reads and enables pagination through a set of `RoomCapacityCar`. */
  roomCapacityCars?: Maybe<RoomCapacityCarsConnection>;
  roomCapacityPax?: Maybe<RoomCapacityPax>;
  /** Reads and enables pagination through a set of `RoomCapacityPax`. */
  roomCapacityPaxes?: Maybe<RoomCapacityPaxesConnection>;
  roomCapacityTruck?: Maybe<RoomCapacityTruck>;
  /** Reads and enables pagination through a set of `RoomCapacityTruck`. */
  roomCapacityTrucks?: Maybe<RoomCapacityTrucksConnection>;
  roomCleaningGrossSpace?: Maybe<RoomCleaningGrossSpace>;
  /** Reads and enables pagination through a set of `RoomCleaningGrossSpace`. */
  roomCleaningGrossSpaces?: Maybe<RoomCleaningGrossSpacesConnection>;
  roomClearanceConstruction?: Maybe<RoomClearanceConstruction>;
  /** Reads and enables pagination through a set of `RoomClearanceConstruction`. */
  roomClearanceConstructions?: Maybe<RoomClearanceConstructionsConnection>;
  roomContactBooking?: Maybe<RoomContactBooking>;
  /** Reads and enables pagination through a set of `RoomContactBooking`. */
  roomContactBookings?: Maybe<RoomContactBookingsConnection>;
  roomDaylight?: Maybe<RoomDaylight>;
  /** Reads and enables pagination through a set of `RoomDaylight`. */
  roomDaylights?: Maybe<RoomDaylightsConnection>;
  roomDescription?: Maybe<RoomDescription>;
  /** Reads and enables pagination through a set of `RoomDescription`. */
  roomDescriptions?: Maybe<RoomDescriptionsConnection>;
  roomKeyIssuance?: Maybe<RoomKeyIssuance>;
  roomKeyIssuanceNote?: Maybe<RoomKeyIssuanceNote>;
  /** Reads and enables pagination through a set of `RoomKeyIssuanceNote`. */
  roomKeyIssuanceNotes?: Maybe<RoomKeyIssuanceNotesConnection>;
  /** Reads and enables pagination through a set of `RoomKeyIssuance`. */
  roomKeyIssuances?: Maybe<RoomKeyIssuancesConnection>;
  roomLightShutter?: Maybe<RoomLightShutter>;
  /** Reads and enables pagination through a set of `RoomLightShutter`. */
  roomLightShutters?: Maybe<RoomLightShuttersConnection>;
  roomMaxLoadCeiling?: Maybe<RoomMaxLoadCeiling>;
  /** Reads and enables pagination through a set of `RoomMaxLoadCeiling`. */
  roomMaxLoadCeilings?: Maybe<RoomMaxLoadCeilingsConnection>;
  roomMaxLoadFloor?: Maybe<RoomMaxLoadFloor>;
  /** Reads and enables pagination through a set of `RoomMaxLoadFloor`. */
  roomMaxLoadFloors?: Maybe<RoomMaxLoadFloorsConnection>;
  roomNameExtra?: Maybe<RoomNameExtra>;
  /** Reads and enables pagination through a set of `RoomNameExtra`. */
  roomNameExtras?: Maybe<RoomNameExtrasConnection>;
  roomNameKeyCad?: Maybe<RoomNameKeyCad>;
  /** Reads and enables pagination through a set of `RoomNameKeyCad`. */
  roomNameKeyCads?: Maybe<RoomNameKeyCadsConnection>;
  roomNameKeyCafm?: Maybe<RoomNameKeyCafm>;
  /** Reads and enables pagination through a set of `RoomNameKeyCafm`. */
  roomNameKeyCafms?: Maybe<RoomNameKeyCafmsConnection>;
  roomNameKeyEbm?: Maybe<RoomNameKeyEbm>;
  /** Reads and enables pagination through a set of `RoomNameKeyEbm`. */
  roomNameKeyEbms?: Maybe<RoomNameKeyEbmsConnection>;
  roomNameKeyMarketing?: Maybe<RoomNameKeyMarketing>;
  /** Reads and enables pagination through a set of `RoomNameKeyMarketing`. */
  roomNameKeyMarketings?: Maybe<RoomNameKeyMarketingsConnection>;
  roomNameLong?: Maybe<RoomNameLong>;
  /** Reads and enables pagination through a set of `RoomNameLong`. */
  roomNameLongs?: Maybe<RoomNameLongsConnection>;
  roomNameShort?: Maybe<RoomNameShort>;
  /** Reads and enables pagination through a set of `RoomNameShort`. */
  roomNameShorts?: Maybe<RoomNameShortsConnection>;
  roomNoVehicle?: Maybe<RoomNoVehicle>;
  /** Reads and enables pagination through a set of `RoomNoVehicle`. */
  roomNoVehicles?: Maybe<RoomNoVehiclesConnection>;
  roomPartition?: Maybe<RoomPartition>;
  roomPartitionByExtId?: Maybe<RoomPartition>;
  roomPartitionByNameShort?: Maybe<RoomPartition>;
  roomPartitionCadGrossSpaceMin?: Maybe<RoomPartitionCadGrossSpaceMin>;
  /** Reads and enables pagination through a set of `RoomPartitionCadGrossSpaceMin`. */
  roomPartitionCadGrossSpaceMins?: Maybe<RoomPartitionCadGrossSpaceMinsConnection>;
  roomPartitionCadHeightMax?: Maybe<RoomPartitionCadHeightMax>;
  /** Reads and enables pagination through a set of `RoomPartitionCadHeightMax`. */
  roomPartitionCadHeightMaxes?: Maybe<RoomPartitionCadHeightMaxesConnection>;
  roomPartitionCadHeightMin?: Maybe<RoomPartitionCadHeightMin>;
  /** Reads and enables pagination through a set of `RoomPartitionCadHeightMin`. */
  roomPartitionCadHeightMins?: Maybe<RoomPartitionCadHeightMinsConnection>;
  roomPartitionCadLengthMax?: Maybe<RoomPartitionCadLengthMax>;
  /** Reads and enables pagination through a set of `RoomPartitionCadLengthMax`. */
  roomPartitionCadLengthMaxes?: Maybe<RoomPartitionCadLengthMaxesConnection>;
  roomPartitionCadLengthMin?: Maybe<RoomPartitionCadLengthMin>;
  /** Reads and enables pagination through a set of `RoomPartitionCadLengthMin`. */
  roomPartitionCadLengthMins?: Maybe<RoomPartitionCadLengthMinsConnection>;
  roomPartitionCadWidthMax?: Maybe<RoomPartitionCadWidthMax>;
  /** Reads and enables pagination through a set of `RoomPartitionCadWidthMax`. */
  roomPartitionCadWidthMaxes?: Maybe<RoomPartitionCadWidthMaxesConnection>;
  roomPartitionCadWidthMin?: Maybe<RoomPartitionCadWidthMin>;
  /** Reads and enables pagination through a set of `RoomPartitionCadWidthMin`. */
  roomPartitionCadWidthMins?: Maybe<RoomPartitionCadWidthMinsConnection>;
  roomPartitionCapacityPax?: Maybe<RoomPartitionCapacityPax>;
  /** Reads and enables pagination through a set of `RoomPartitionCapacityPax`. */
  roomPartitionCapacityPaxes?: Maybe<RoomPartitionCapacityPaxesConnection>;
  roomPartitionCleaningGrossSpace?: Maybe<RoomPartitionCleaningGrossSpace>;
  /** Reads and enables pagination through a set of `RoomPartitionCleaningGrossSpace`. */
  roomPartitionCleaningGrossSpaces?: Maybe<RoomPartitionCleaningGrossSpacesConnection>;
  roomPartitionDescription?: Maybe<RoomPartitionDescription>;
  /** Reads and enables pagination through a set of `RoomPartitionDescription`. */
  roomPartitionDescriptions?: Maybe<RoomPartitionDescriptionsConnection>;
  roomPartitionNameExtra?: Maybe<RoomPartitionNameExtra>;
  /** Reads and enables pagination through a set of `RoomPartitionNameExtra`. */
  roomPartitionNameExtras?: Maybe<RoomPartitionNameExtrasConnection>;
  roomPartitionNameKeyCad?: Maybe<RoomPartitionNameKeyCad>;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyCad`. */
  roomPartitionNameKeyCads?: Maybe<RoomPartitionNameKeyCadsConnection>;
  roomPartitionNameKeyCafm?: Maybe<RoomPartitionNameKeyCafm>;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyCafm`. */
  roomPartitionNameKeyCafms?: Maybe<RoomPartitionNameKeyCafmsConnection>;
  roomPartitionNameKeyEbm?: Maybe<RoomPartitionNameKeyEbm>;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyEbm`. */
  roomPartitionNameKeyEbms?: Maybe<RoomPartitionNameKeyEbmsConnection>;
  roomPartitionNameKeyMarketing?: Maybe<RoomPartitionNameKeyMarketing>;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyMarketing`. */
  roomPartitionNameKeyMarketings?: Maybe<RoomPartitionNameKeyMarketingsConnection>;
  roomPartitionNameLong?: Maybe<RoomPartitionNameLong>;
  /** Reads and enables pagination through a set of `RoomPartitionNameLong`. */
  roomPartitionNameLongs?: Maybe<RoomPartitionNameLongsConnection>;
  roomPartitionNameShort?: Maybe<RoomPartitionNameShort>;
  /** Reads and enables pagination through a set of `RoomPartitionNameShort`. */
  roomPartitionNameShorts?: Maybe<RoomPartitionNameShortsConnection>;
  roomPartitionPublicGrossSpace?: Maybe<RoomPartitionPublicGrossSpace>;
  /** Reads and enables pagination through a set of `RoomPartitionPublicGrossSpace`. */
  roomPartitionPublicGrossSpaces?: Maybe<RoomPartitionPublicGrossSpacesConnection>;
  roomPartitionSbvGrossSpace?: Maybe<RoomPartitionSbvGrossSpace>;
  /** Reads and enables pagination through a set of `RoomPartitionSbvGrossSpace`. */
  roomPartitionSbvGrossSpaces?: Maybe<RoomPartitionSbvGrossSpacesConnection>;
  roomPartitionType?: Maybe<RoomPartitionType>;
  roomPartitionTypeAttr?: Maybe<RoomPartitionTypeAttr>;
  /** Reads and enables pagination through a set of `RoomPartitionTypeAttr`. */
  roomPartitionTypeAttrs?: Maybe<RoomPartitionTypeAttrsConnection>;
  roomPartitionTypeByName?: Maybe<RoomPartitionType>;
  /** Reads and enables pagination through a set of `RoomPartitionType`. */
  roomPartitionTypes?: Maybe<RoomPartitionTypesConnection>;
  /** Reads and enables pagination through a set of `RoomPartition`. */
  roomPartitions?: Maybe<RoomPartitionsConnection>;
  roomPhoneNumber?: Maybe<RoomPhoneNumber>;
  /** Reads and enables pagination through a set of `RoomPhoneNumber`. */
  roomPhoneNumbers?: Maybe<RoomPhoneNumbersConnection>;
  roomPublicGrossSpace?: Maybe<RoomPublicGrossSpace>;
  /** Reads and enables pagination through a set of `RoomPublicGrossSpace`. */
  roomPublicGrossSpaces?: Maybe<RoomPublicGrossSpacesConnection>;
  roomSbvGrossSpace?: Maybe<RoomSbvGrossSpace>;
  /** Reads and enables pagination through a set of `RoomSbvGrossSpace`. */
  roomSbvGrossSpaces?: Maybe<RoomSbvGrossSpacesConnection>;
  roomTireLoadCar?: Maybe<RoomTireLoadCar>;
  /** Reads and enables pagination through a set of `RoomTireLoadCar`. */
  roomTireLoadCars?: Maybe<RoomTireLoadCarsConnection>;
  roomTireLoadForklift?: Maybe<RoomTireLoadForklift>;
  /** Reads and enables pagination through a set of `RoomTireLoadForklift`. */
  roomTireLoadForklifts?: Maybe<RoomTireLoadForkliftsConnection>;
  roomTireLoadTruck?: Maybe<RoomTireLoadTruck>;
  /** Reads and enables pagination through a set of `RoomTireLoadTruck`. */
  roomTireLoadTrucks?: Maybe<RoomTireLoadTrucksConnection>;
  roomType?: Maybe<RoomType>;
  roomTypeAttr?: Maybe<RoomTypeAttr>;
  /** Reads and enables pagination through a set of `RoomTypeAttr`. */
  roomTypeAttrs?: Maybe<RoomTypeAttrsConnection>;
  roomTypeByName?: Maybe<RoomType>;
  /** Reads and enables pagination through a set of `RoomType`. */
  roomTypes?: Maybe<RoomTypesConnection>;
  /** Reads and enables pagination through a set of `Room`. */
  rooms?: Maybe<RoomsConnection>;
  scenario?: Maybe<Scenario>;
  scenarioByNameShort?: Maybe<Scenario>;
  scenarioGroup?: Maybe<ScenarioGroup>;
  scenarioGroupByNameShort?: Maybe<ScenarioGroup>;
  /** Reads and enables pagination through a set of `ScenarioGroup`. */
  scenarioGroups?: Maybe<ScenarioGroupsConnection>;
  scenarioSetting?: Maybe<ScenarioSetting>;
  /** Reads and enables pagination through a set of `ScenarioSetting`. */
  scenarioSettings?: Maybe<ScenarioSettingsConnection>;
  /** Reads and enables pagination through a set of `ScenarioVariantVisibility`. */
  scenarioVariantVisibilities?: Maybe<ScenarioVariantVisibilitiesConnection>;
  scenarioVariantVisibility?: Maybe<ScenarioVariantVisibility>;
  scenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantType?: Maybe<ScenarioVariantVisibility>;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenarios?: Maybe<ScenariosConnection>;
  site?: Maybe<Site>;
  siteByExtId?: Maybe<Site>;
  siteByNameShort?: Maybe<Site>;
  siteDescription?: Maybe<SiteDescription>;
  /** Reads and enables pagination through a set of `SiteDescription`. */
  siteDescriptions?: Maybe<SiteDescriptionsConnection>;
  siteNameExtra?: Maybe<SiteNameExtra>;
  /** Reads and enables pagination through a set of `SiteNameExtra`. */
  siteNameExtras?: Maybe<SiteNameExtrasConnection>;
  siteNameKeyCad?: Maybe<SiteNameKeyCad>;
  /** Reads and enables pagination through a set of `SiteNameKeyCad`. */
  siteNameKeyCads?: Maybe<SiteNameKeyCadsConnection>;
  siteNameKeyCafm?: Maybe<SiteNameKeyCafm>;
  /** Reads and enables pagination through a set of `SiteNameKeyCafm`. */
  siteNameKeyCafms?: Maybe<SiteNameKeyCafmsConnection>;
  siteNameKeyEbm?: Maybe<SiteNameKeyEbm>;
  /** Reads and enables pagination through a set of `SiteNameKeyEbm`. */
  siteNameKeyEbms?: Maybe<SiteNameKeyEbmsConnection>;
  siteNameKeyMarketing?: Maybe<SiteNameKeyMarketing>;
  /** Reads and enables pagination through a set of `SiteNameKeyMarketing`. */
  siteNameKeyMarketings?: Maybe<SiteNameKeyMarketingsConnection>;
  siteNameLong?: Maybe<SiteNameLong>;
  /** Reads and enables pagination through a set of `SiteNameLong`. */
  siteNameLongs?: Maybe<SiteNameLongsConnection>;
  siteNameShort?: Maybe<SiteNameShort>;
  /** Reads and enables pagination through a set of `SiteNameShort`. */
  siteNameShorts?: Maybe<SiteNameShortsConnection>;
  /** Reads and enables pagination through a set of `Site`. */
  sites?: Maybe<SitesConnection>;
  user?: Maybe<User>;
  userPasswordLogin?: Maybe<UserPasswordLogin>;
  userPasswordLoginByEmail?: Maybe<UserPasswordLogin>;
  userPasswordLoginByUserId?: Maybe<UserPasswordLogin>;
  /** Reads and enables pagination through a set of `UserPasswordLogin`. */
  userPasswordLogins?: Maybe<UserPasswordLoginsConnection>;
  userSsoLogin?: Maybe<UserSsoLogin>;
  userSsoLoginByProviderAndOid?: Maybe<UserSsoLogin>;
  userSsoLoginByUserIdAndProvider?: Maybe<UserSsoLogin>;
  /** Reads and enables pagination through a set of `UserSsoLogin`. */
  userSsoLogins?: Maybe<UserSsoLoginsConnection>;
  userWithLoginData?: Maybe<UserWithLoginData>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  usersWithLoginData: Array<UserWithLoginData>;
  zone?: Maybe<Zone>;
  zoneByExtId?: Maybe<Zone>;
  zoneByNameShort?: Maybe<Zone>;
  zoneCadGrossSpaceMin?: Maybe<ZoneCadGrossSpaceMin>;
  /** Reads and enables pagination through a set of `ZoneCadGrossSpaceMin`. */
  zoneCadGrossSpaceMins?: Maybe<ZoneCadGrossSpaceMinsConnection>;
  zoneCapacityCar?: Maybe<ZoneCapacityCar>;
  /** Reads and enables pagination through a set of `ZoneCapacityCar`. */
  zoneCapacityCars?: Maybe<ZoneCapacityCarsConnection>;
  zoneCapacityTruck?: Maybe<ZoneCapacityTruck>;
  /** Reads and enables pagination through a set of `ZoneCapacityTruck`. */
  zoneCapacityTrucks?: Maybe<ZoneCapacityTrucksConnection>;
  zoneDescription?: Maybe<ZoneDescription>;
  /** Reads and enables pagination through a set of `ZoneDescription`. */
  zoneDescriptions?: Maybe<ZoneDescriptionsConnection>;
  zoneMaxLoadFloor?: Maybe<ZoneMaxLoadFloor>;
  /** Reads and enables pagination through a set of `ZoneMaxLoadFloor`. */
  zoneMaxLoadFloors?: Maybe<ZoneMaxLoadFloorsConnection>;
  zoneNameExtra?: Maybe<ZoneNameExtra>;
  /** Reads and enables pagination through a set of `ZoneNameExtra`. */
  zoneNameExtras?: Maybe<ZoneNameExtrasConnection>;
  zoneNameKeyCad?: Maybe<ZoneNameKeyCad>;
  /** Reads and enables pagination through a set of `ZoneNameKeyCad`. */
  zoneNameKeyCads?: Maybe<ZoneNameKeyCadsConnection>;
  zoneNameKeyCafm?: Maybe<ZoneNameKeyCafm>;
  /** Reads and enables pagination through a set of `ZoneNameKeyCafm`. */
  zoneNameKeyCafms?: Maybe<ZoneNameKeyCafmsConnection>;
  zoneNameKeyEbm?: Maybe<ZoneNameKeyEbm>;
  /** Reads and enables pagination through a set of `ZoneNameKeyEbm`. */
  zoneNameKeyEbms?: Maybe<ZoneNameKeyEbmsConnection>;
  zoneNameKeyMarketing?: Maybe<ZoneNameKeyMarketing>;
  /** Reads and enables pagination through a set of `ZoneNameKeyMarketing`. */
  zoneNameKeyMarketings?: Maybe<ZoneNameKeyMarketingsConnection>;
  zoneNameLong?: Maybe<ZoneNameLong>;
  /** Reads and enables pagination through a set of `ZoneNameLong`. */
  zoneNameLongs?: Maybe<ZoneNameLongsConnection>;
  zoneNameShort?: Maybe<ZoneNameShort>;
  /** Reads and enables pagination through a set of `ZoneNameShort`. */
  zoneNameShorts?: Maybe<ZoneNameShortsConnection>;
  zoneNoVehicle?: Maybe<ZoneNoVehicle>;
  /** Reads and enables pagination through a set of `ZoneNoVehicle`. */
  zoneNoVehicles?: Maybe<ZoneNoVehiclesConnection>;
  zonePublicGrossSpace?: Maybe<ZonePublicGrossSpace>;
  /** Reads and enables pagination through a set of `ZonePublicGrossSpace`. */
  zonePublicGrossSpaces?: Maybe<ZonePublicGrossSpacesConnection>;
  zoneTireLoadCar?: Maybe<ZoneTireLoadCar>;
  /** Reads and enables pagination through a set of `ZoneTireLoadCar`. */
  zoneTireLoadCars?: Maybe<ZoneTireLoadCarsConnection>;
  zoneTireLoadForklift?: Maybe<ZoneTireLoadForklift>;
  /** Reads and enables pagination through a set of `ZoneTireLoadForklift`. */
  zoneTireLoadForklifts?: Maybe<ZoneTireLoadForkliftsConnection>;
  zoneTireLoadTruck?: Maybe<ZoneTireLoadTruck>;
  /** Reads and enables pagination through a set of `ZoneTireLoadTruck`. */
  zoneTireLoadTrucks?: Maybe<ZoneTireLoadTrucksConnection>;
  zoneType?: Maybe<ZoneType>;
  zoneTypeAttr?: Maybe<ZoneTypeAttr>;
  /** Reads and enables pagination through a set of `ZoneTypeAttr`. */
  zoneTypeAttrs?: Maybe<ZoneTypeAttrsConnection>;
  zoneTypeByName?: Maybe<ZoneType>;
  /** Reads and enables pagination through a set of `ZoneType`. */
  zoneTypes?: Maybe<ZoneTypesConnection>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones?: Maybe<ZonesConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationAreaArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationAreaPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationAreaPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationAreaPhaseCondition>;
  filter?: InputMaybe<AllocationAreaPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationAreaPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationAreaCondition>;
  filter?: InputMaybe<AllocationAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationAreasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationPlotArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationPlotPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationPlotPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationPlotPhaseCondition>;
  filter?: InputMaybe<AllocationPlotPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationPlotPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationPlotCondition>;
  filter?: InputMaybe<AllocationPlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationPlotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationRoomArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationRoomPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationRoomPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationRoomPhaseCondition>;
  filter?: InputMaybe<AllocationRoomPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationRoomPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationRoomCondition>;
  filter?: InputMaybe<AllocationRoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationRoomsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationUsageArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationUsageByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationUsageByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationUsageByPositionArgs = {
  position: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationUsageByTypeArgs = {
  type: AllocationUsageType;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationUsageCondition>;
  filter?: InputMaybe<AllocationUsageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationUsagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaCadGrossSpaceMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaCadGrossSpaceMinCondition>;
  filter?: InputMaybe<AreaCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaCadGrossSpaceMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaClearanceConstructionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaClearanceConstructionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaClearanceConstructionCondition>;
  filter?: InputMaybe<AreaClearanceConstructionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaClearanceConstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaContactBookingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaContactBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaContactBookingCondition>;
  filter?: InputMaybe<AreaContactBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaContactBookingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaDescriptionCondition>;
  filter?: InputMaybe<AreaDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaKeyIssuanceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaKeyIssuanceNoteArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaKeyIssuanceNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaKeyIssuanceNoteCondition>;
  filter?: InputMaybe<AreaKeyIssuanceNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaKeyIssuanceNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaKeyIssuancesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaKeyIssuanceCondition>;
  filter?: InputMaybe<AreaKeyIssuanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaKeyIssuancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameExtraCondition>;
  filter?: InputMaybe<AreaNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyCadCondition>;
  filter?: InputMaybe<AreaNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyCafmCondition>;
  filter?: InputMaybe<AreaNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyEbmCondition>;
  filter?: InputMaybe<AreaNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameKeyMarketingCondition>;
  filter?: InputMaybe<AreaNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameLongCondition>;
  filter?: InputMaybe<AreaNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaNameShortCondition>;
  filter?: InputMaybe<AreaNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaPublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaPublicGrossSpaceCondition>;
  filter?: InputMaybe<AreaPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaPublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaTypeAttrCondition>;
  filter?: InputMaybe<AreaTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaTypeCondition>;
  filter?: InputMaybe<AreaTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreaTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaCondition>;
  filter?: InputMaybe<AreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingByIdAndSiteIdArgs = {
  id: Scalars['UUID'];
  siteId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingDescriptionCondition>;
  filter?: InputMaybe<BuildingDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameExtraCondition>;
  filter?: InputMaybe<BuildingNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyCadCondition>;
  filter?: InputMaybe<BuildingNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyCafmCondition>;
  filter?: InputMaybe<BuildingNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyEbmCondition>;
  filter?: InputMaybe<BuildingNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameKeyMarketingCondition>;
  filter?: InputMaybe<BuildingNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameLongCondition>;
  filter?: InputMaybe<BuildingNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingNameShortCondition>;
  filter?: InputMaybe<BuildingNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingPublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingPublicGrossSpaceCondition>;
  filter?: InputMaybe<BuildingPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingPublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingTypeAttrCondition>;
  filter?: InputMaybe<BuildingTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingTypeCondition>;
  filter?: InputMaybe<BuildingTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingCondition>;
  filter?: InputMaybe<BuildingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryElevationLevelArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryElevationLevelByValueArgs = {
  value: Scalars['BigFloat'];
};


/** The root query type which gives access points into the data universe. */
export type QueryElevationLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ElevationLevelCondition>;
  filter?: InputMaybe<ElevationLevelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ElevationLevelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventSeriesArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventSeriesByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventSeriesesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventSeriesCondition>;
  filter?: InputMaybe<EventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventVariantArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventVariantByEventIdAndIndexArgs = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventVariantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventVariantCondition>;
  filter?: InputMaybe<EventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationPhaseCondition>;
  filter?: InputMaybe<ExternalEventAllocationPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationUsageArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationUsageByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationUsageByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationUsageByPositionArgs = {
  position: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationUsageByTypeArgs = {
  type: ExternalEventAllocationUsageType;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationUsageCondition>;
  filter?: InputMaybe<ExternalEventAllocationUsageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationUsagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventAllocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventAllocationCondition>;
  filter?: InputMaybe<ExternalEventAllocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventAllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventEventLocationVisibilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventEventLocationVisibilityCondition>;
  filter?: InputMaybe<ExternalEventEventLocationVisibilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventEventLocationVisibilitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventEventLocationVisibilityArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventEventLocationVisibilityByEventIdAndLocationIdArgs = {
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventLocationArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventLocationByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventLocationCondition>;
  filter?: InputMaybe<ExternalEventLocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventLocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventSeriesArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventSeriesByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventSeriesesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventSeriesCondition>;
  filter?: InputMaybe<ExternalEventSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventSeriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventVariantArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventVariantByEventIdAndIndexArgs = {
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventVariantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventVariantCondition>;
  filter?: InputMaybe<ExternalEventVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalEventCondition>;
  filter?: InputMaybe<ExternalEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeedEntryCondition>;
  filter?: InputMaybe<FeedEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedEntryArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeedCondition>;
  filter?: InputMaybe<FeedFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFileArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEntraUserDataArgs = {
  oid: Scalars['String'];
  provider?: InputMaybe<SsoProvider>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelCapacityPaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelCapacityPaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelCapacityPaxCondition>;
  filter?: InputMaybe<LevelCapacityPaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelCapacityPaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelDescriptionCondition>;
  filter?: InputMaybe<LevelDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelFkmGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelFkmGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelFkmGrossSpaceCondition>;
  filter?: InputMaybe<LevelFkmGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelFkmGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameExtraCondition>;
  filter?: InputMaybe<LevelNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyCadCondition>;
  filter?: InputMaybe<LevelNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyCafmCondition>;
  filter?: InputMaybe<LevelNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyEbmCondition>;
  filter?: InputMaybe<LevelNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameKeyMarketingCondition>;
  filter?: InputMaybe<LevelNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameLongCondition>;
  filter?: InputMaybe<LevelNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelNameShortCondition>;
  filter?: InputMaybe<LevelNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelPublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelPublicGrossSpaceCondition>;
  filter?: InputMaybe<LevelPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelPublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelTypeAttrCondition>;
  filter?: InputMaybe<LevelTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelTypeCondition>;
  filter?: InputMaybe<LevelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LevelCondition>;
  filter?: InputMaybe<LevelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLinkArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LinkCondition>;
  filter?: InputMaybe<LinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMultilinkArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMultilinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MultilinkCondition>;
  filter?: InputMaybe<MultilinkFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MultilinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotCadGrossSpaceMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotCadGrossSpaceMinCondition>;
  filter?: InputMaybe<PlotCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotCadGrossSpaceMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotDescriptionCondition>;
  filter?: InputMaybe<PlotDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameExtraCondition>;
  filter?: InputMaybe<PlotNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyCadCondition>;
  filter?: InputMaybe<PlotNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyCafmCondition>;
  filter?: InputMaybe<PlotNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyEbmCondition>;
  filter?: InputMaybe<PlotNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameKeyMarketingCondition>;
  filter?: InputMaybe<PlotNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameLongCondition>;
  filter?: InputMaybe<PlotNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotNameShortCondition>;
  filter?: InputMaybe<PlotNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotPublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotPublicGrossSpaceCondition>;
  filter?: InputMaybe<PlotPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotPublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotTypeAttrCondition>;
  filter?: InputMaybe<PlotTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotTypeCondition>;
  filter?: InputMaybe<PlotTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PlotCondition>;
  filter?: InputMaybe<PlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationAreaArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationAreaPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationAreaPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationAreaPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationAreaPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationAreaPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationAreaCondition>;
  filter?: InputMaybe<ProjectAllocationAreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationAreasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationPlotArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationPlotPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationPlotPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationPlotPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationPlotPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationPlotPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationPlotsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationPlotCondition>;
  filter?: InputMaybe<ProjectAllocationPlotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationPlotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationRoomArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationRoomPhaseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationRoomPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationRoomPhaseCondition>;
  filter?: InputMaybe<ProjectAllocationRoomPhaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationRoomPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationRoomCondition>;
  filter?: InputMaybe<ProjectAllocationRoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationRoomsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationUsageArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationUsageByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationUsageByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationUsageByPositionArgs = {
  position: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationUsageByTypeArgs = {
  type: ProjectAllocationUsageType;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectAllocationUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationUsageCondition>;
  filter?: InputMaybe<ProjectAllocationUsageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationUsagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectSeriesArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectSeriesByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectSeriesesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectSeriesCondition>;
  filter?: InputMaybe<ProjectSeriesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectVariantArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectVariantByProjectIdAndIndexArgs = {
  index: Scalars['Int'];
  projectId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectVariantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectVariantCondition>;
  filter?: InputMaybe<ProjectVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomAirChangeRateArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomAirChangeRatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomAirChangeRateCondition>;
  filter?: InputMaybe<RoomAirChangeRateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomAirChangeRatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomAirConditioningArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomAirConditioningsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomAirConditioningCondition>;
  filter?: InputMaybe<RoomAirConditioningFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomAirConditioningsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadGrossSpaceMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadGrossSpaceMinCondition>;
  filter?: InputMaybe<RoomCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadGrossSpaceMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadHeightMaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadHeightMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadHeightMaxCondition>;
  filter?: InputMaybe<RoomCadHeightMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadHeightMaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadHeightMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadHeightMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadHeightMinCondition>;
  filter?: InputMaybe<RoomCadHeightMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadHeightMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadLengthMaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadLengthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadLengthMaxCondition>;
  filter?: InputMaybe<RoomCadLengthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadLengthMaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadLengthMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadLengthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadLengthMinCondition>;
  filter?: InputMaybe<RoomCadLengthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadLengthMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadWidthMaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadWidthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadWidthMaxCondition>;
  filter?: InputMaybe<RoomCadWidthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadWidthMaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadWidthMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCadWidthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadWidthMinCondition>;
  filter?: InputMaybe<RoomCadWidthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadWidthMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCapacityCarArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCapacityCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCapacityCarCondition>;
  filter?: InputMaybe<RoomCapacityCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCapacityCarsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCapacityPaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCapacityPaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCapacityPaxCondition>;
  filter?: InputMaybe<RoomCapacityPaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCapacityPaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCapacityTruckArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCapacityTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCapacityTruckCondition>;
  filter?: InputMaybe<RoomCapacityTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCapacityTrucksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCleaningGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomCleaningGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCleaningGrossSpaceCondition>;
  filter?: InputMaybe<RoomCleaningGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCleaningGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomClearanceConstructionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomClearanceConstructionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomClearanceConstructionCondition>;
  filter?: InputMaybe<RoomClearanceConstructionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomClearanceConstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomContactBookingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomContactBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomContactBookingCondition>;
  filter?: InputMaybe<RoomContactBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomContactBookingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomDaylightArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomDaylightsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomDaylightCondition>;
  filter?: InputMaybe<RoomDaylightFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomDaylightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomDescriptionCondition>;
  filter?: InputMaybe<RoomDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomKeyIssuanceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomKeyIssuanceNoteArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomKeyIssuanceNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomKeyIssuanceNoteCondition>;
  filter?: InputMaybe<RoomKeyIssuanceNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomKeyIssuanceNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomKeyIssuancesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomKeyIssuanceCondition>;
  filter?: InputMaybe<RoomKeyIssuanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomKeyIssuancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomLightShutterArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomLightShuttersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomLightShutterCondition>;
  filter?: InputMaybe<RoomLightShutterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomLightShuttersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomMaxLoadCeilingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomMaxLoadCeilingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomMaxLoadCeilingCondition>;
  filter?: InputMaybe<RoomMaxLoadCeilingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomMaxLoadCeilingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomMaxLoadFloorArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomMaxLoadFloorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomMaxLoadFloorCondition>;
  filter?: InputMaybe<RoomMaxLoadFloorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomMaxLoadFloorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameExtraCondition>;
  filter?: InputMaybe<RoomNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyCadCondition>;
  filter?: InputMaybe<RoomNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyCafmCondition>;
  filter?: InputMaybe<RoomNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyEbmCondition>;
  filter?: InputMaybe<RoomNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyMarketingCondition>;
  filter?: InputMaybe<RoomNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameLongCondition>;
  filter?: InputMaybe<RoomNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameShortCondition>;
  filter?: InputMaybe<RoomNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNoVehicleArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomNoVehiclesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNoVehicleCondition>;
  filter?: InputMaybe<RoomNoVehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNoVehiclesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadGrossSpaceMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadGrossSpaceMinCondition>;
  filter?: InputMaybe<RoomPartitionCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadHeightMaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadHeightMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadHeightMaxCondition>;
  filter?: InputMaybe<RoomPartitionCadHeightMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadHeightMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadHeightMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadHeightMinCondition>;
  filter?: InputMaybe<RoomPartitionCadHeightMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadLengthMaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadLengthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadLengthMaxCondition>;
  filter?: InputMaybe<RoomPartitionCadLengthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadLengthMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadLengthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadLengthMinCondition>;
  filter?: InputMaybe<RoomPartitionCadLengthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadWidthMaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadWidthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadWidthMaxCondition>;
  filter?: InputMaybe<RoomPartitionCadWidthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadWidthMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCadWidthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadWidthMinCondition>;
  filter?: InputMaybe<RoomPartitionCadWidthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCapacityPaxArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCapacityPaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCapacityPaxCondition>;
  filter?: InputMaybe<RoomPartitionCapacityPaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCapacityPaxesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCleaningGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionCleaningGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCleaningGrossSpaceCondition>;
  filter?: InputMaybe<RoomPartitionCleaningGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCleaningGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionDescriptionCondition>;
  filter?: InputMaybe<RoomPartitionDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameExtraCondition>;
  filter?: InputMaybe<RoomPartitionNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyCadCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyCafmCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyEbmCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyMarketingCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameLongCondition>;
  filter?: InputMaybe<RoomPartitionNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameShortCondition>;
  filter?: InputMaybe<RoomPartitionNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionPublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionPublicGrossSpaceCondition>;
  filter?: InputMaybe<RoomPartitionPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionPublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionSbvGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionSbvGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionSbvGrossSpaceCondition>;
  filter?: InputMaybe<RoomPartitionSbvGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionSbvGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionTypeAttrCondition>;
  filter?: InputMaybe<RoomPartitionTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionTypeCondition>;
  filter?: InputMaybe<RoomPartitionTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPartitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCondition>;
  filter?: InputMaybe<RoomPartitionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPhoneNumberArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPhoneNumberCondition>;
  filter?: InputMaybe<RoomPhoneNumberFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPhoneNumbersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPublicGrossSpaceCondition>;
  filter?: InputMaybe<RoomPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomSbvGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomSbvGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomSbvGrossSpaceCondition>;
  filter?: InputMaybe<RoomSbvGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomSbvGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTireLoadCarArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTireLoadCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTireLoadCarCondition>;
  filter?: InputMaybe<RoomTireLoadCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTireLoadCarsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTireLoadForkliftArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTireLoadForkliftsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTireLoadForkliftCondition>;
  filter?: InputMaybe<RoomTireLoadForkliftFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTireLoadForkliftsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTireLoadTruckArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTireLoadTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTireLoadTruckCondition>;
  filter?: InputMaybe<RoomTireLoadTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTireLoadTrucksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTypeAttrCondition>;
  filter?: InputMaybe<RoomTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTypeCondition>;
  filter?: InputMaybe<RoomTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCondition>;
  filter?: InputMaybe<RoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioGroupArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioGroupByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioGroupCondition>;
  filter?: InputMaybe<ScenarioGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioSettingArgs = {
  scenarioId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioSettingCondition>;
  filter?: InputMaybe<ScenarioSettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioVariantVisibilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioVariantVisibilityCondition>;
  filter?: InputMaybe<ScenarioVariantVisibilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioVariantVisibilitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioVariantVisibilityArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeArgs = {
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
};


/** The root query type which gives access points into the data universe. */
export type QueryScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteDescriptionCondition>;
  filter?: InputMaybe<SiteDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameExtraCondition>;
  filter?: InputMaybe<SiteNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyCadCondition>;
  filter?: InputMaybe<SiteNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyCafmCondition>;
  filter?: InputMaybe<SiteNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyEbmCondition>;
  filter?: InputMaybe<SiteNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyMarketingCondition>;
  filter?: InputMaybe<SiteNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameLongCondition>;
  filter?: InputMaybe<SiteNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySiteNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameShortCondition>;
  filter?: InputMaybe<SiteNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySitesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteCondition>;
  filter?: InputMaybe<SiteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SitesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPasswordLoginArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPasswordLoginByEmailArgs = {
  email: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPasswordLoginByUserIdArgs = {
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPasswordLoginsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserPasswordLoginCondition>;
  filter?: InputMaybe<UserPasswordLoginFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPasswordLoginsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSsoLoginArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSsoLoginByProviderAndOidArgs = {
  oid: Scalars['String'];
  provider: SsoProvider;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSsoLoginByUserIdAndProviderArgs = {
  provider: SsoProvider;
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSsoLoginsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSsoLoginCondition>;
  filter?: InputMaybe<UserSsoLoginFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSsoLoginsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserWithLoginDataArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneByExtIdArgs = {
  extId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneByNameShortArgs = {
  nameShort: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneCadGrossSpaceMinArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCadGrossSpaceMinCondition>;
  filter?: InputMaybe<ZoneCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneCadGrossSpaceMinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneCapacityCarArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneCapacityCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCapacityCarCondition>;
  filter?: InputMaybe<ZoneCapacityCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneCapacityCarsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneCapacityTruckArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneCapacityTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCapacityTruckCondition>;
  filter?: InputMaybe<ZoneCapacityTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneCapacityTrucksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneDescriptionArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneDescriptionCondition>;
  filter?: InputMaybe<ZoneDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneDescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneMaxLoadFloorArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneMaxLoadFloorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneMaxLoadFloorCondition>;
  filter?: InputMaybe<ZoneMaxLoadFloorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneMaxLoadFloorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameExtraArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameExtraCondition>;
  filter?: InputMaybe<ZoneNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameExtrasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyCadArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyCadCondition>;
  filter?: InputMaybe<ZoneNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyCadsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyCafmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyCafmCondition>;
  filter?: InputMaybe<ZoneNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyCafmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyEbmArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyEbmCondition>;
  filter?: InputMaybe<ZoneNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyEbmsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyMarketingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyMarketingCondition>;
  filter?: InputMaybe<ZoneNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyMarketingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameLongArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameLongCondition>;
  filter?: InputMaybe<ZoneNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameLongsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameShortArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameShortCondition>;
  filter?: InputMaybe<ZoneNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameShortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNoVehicleArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneNoVehiclesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNoVehicleCondition>;
  filter?: InputMaybe<ZoneNoVehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNoVehiclesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZonePublicGrossSpaceArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZonePublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZonePublicGrossSpaceCondition>;
  filter?: InputMaybe<ZonePublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonePublicGrossSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTireLoadCarArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTireLoadCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTireLoadCarCondition>;
  filter?: InputMaybe<ZoneTireLoadCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTireLoadCarsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTireLoadForkliftArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTireLoadForkliftsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTireLoadForkliftCondition>;
  filter?: InputMaybe<ZoneTireLoadForkliftFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTireLoadForkliftsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTireLoadTruckArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTireLoadTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTireLoadTruckCondition>;
  filter?: InputMaybe<ZoneTireLoadTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTireLoadTrucksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTypeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTypeAttrArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTypeAttrCondition>;
  filter?: InputMaybe<ZoneTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTypeAttrsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTypeCondition>;
  filter?: InputMaybe<ZoneTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCondition>;
  filter?: InputMaybe<ZoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

export type RefreshJwtResponse = Session;

export type Room = {
  __typename?: 'Room';
  /** Reads and enables pagination through a set of `AllocationRoom`. */
  allocationRooms: AllocationRoomsConnection;
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `Level` that is related to this `Room`. */
  level: Level;
  levelId: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads and enables pagination through a set of `ProjectAllocationRoom`. */
  projectAllocationRooms: ProjectAllocationRoomsConnection;
  /** Reads and enables pagination through a set of `RoomAirChangeRate`. */
  roomAirChangeRates: RoomAirChangeRatesConnection;
  /** Reads and enables pagination through a set of `RoomAirConditioning`. */
  roomAirConditionings: RoomAirConditioningsConnection;
  /** Reads and enables pagination through a set of `RoomCadGrossSpaceMin`. */
  roomCadGrossSpaceMins: RoomCadGrossSpaceMinsConnection;
  /** Reads and enables pagination through a set of `RoomCadHeightMax`. */
  roomCadHeightMaxes: RoomCadHeightMaxesConnection;
  /** Reads and enables pagination through a set of `RoomCadHeightMin`. */
  roomCadHeightMins: RoomCadHeightMinsConnection;
  /** Reads and enables pagination through a set of `RoomCadLengthMax`. */
  roomCadLengthMaxes: RoomCadLengthMaxesConnection;
  /** Reads and enables pagination through a set of `RoomCadLengthMin`. */
  roomCadLengthMins: RoomCadLengthMinsConnection;
  /** Reads and enables pagination through a set of `RoomCadWidthMax`. */
  roomCadWidthMaxes: RoomCadWidthMaxesConnection;
  /** Reads and enables pagination through a set of `RoomCadWidthMin`. */
  roomCadWidthMins: RoomCadWidthMinsConnection;
  /** Reads and enables pagination through a set of `RoomCapacityCar`. */
  roomCapacityCars: RoomCapacityCarsConnection;
  /** Reads and enables pagination through a set of `RoomCapacityPax`. */
  roomCapacityPaxes: RoomCapacityPaxesConnection;
  /** Reads and enables pagination through a set of `RoomCapacityTruck`. */
  roomCapacityTrucks: RoomCapacityTrucksConnection;
  /** Reads and enables pagination through a set of `RoomCleaningGrossSpace`. */
  roomCleaningGrossSpaces: RoomCleaningGrossSpacesConnection;
  /** Reads and enables pagination through a set of `RoomClearanceConstruction`. */
  roomClearanceConstructions: RoomClearanceConstructionsConnection;
  /** Reads and enables pagination through a set of `RoomContactBooking`. */
  roomContactBookings: RoomContactBookingsConnection;
  /** Reads and enables pagination through a set of `RoomDaylight`. */
  roomDaylights: RoomDaylightsConnection;
  /** Reads and enables pagination through a set of `RoomDescription`. */
  roomDescriptions: RoomDescriptionsConnection;
  /** Reads and enables pagination through a set of `RoomKeyIssuanceNote`. */
  roomKeyIssuanceNotes: RoomKeyIssuanceNotesConnection;
  /** Reads and enables pagination through a set of `RoomKeyIssuance`. */
  roomKeyIssuances: RoomKeyIssuancesConnection;
  /** Reads and enables pagination through a set of `RoomLightShutter`. */
  roomLightShutters: RoomLightShuttersConnection;
  /** Reads and enables pagination through a set of `RoomMaxLoadCeiling`. */
  roomMaxLoadCeilings: RoomMaxLoadCeilingsConnection;
  /** Reads and enables pagination through a set of `RoomMaxLoadFloor`. */
  roomMaxLoadFloors: RoomMaxLoadFloorsConnection;
  /** Reads and enables pagination through a set of `RoomNameExtra`. */
  roomNameExtras: RoomNameExtrasConnection;
  /** Reads and enables pagination through a set of `RoomNameKeyCad`. */
  roomNameKeyCads: RoomNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `RoomNameKeyCafm`. */
  roomNameKeyCafms: RoomNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `RoomNameKeyEbm`. */
  roomNameKeyEbms: RoomNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `RoomNameKeyMarketing`. */
  roomNameKeyMarketings: RoomNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `RoomNameLong`. */
  roomNameLongs: RoomNameLongsConnection;
  /** Reads and enables pagination through a set of `RoomNameShort`. */
  roomNameShorts: RoomNameShortsConnection;
  /** Reads and enables pagination through a set of `RoomNoVehicle`. */
  roomNoVehicles: RoomNoVehiclesConnection;
  /** Reads and enables pagination through a set of `RoomPartition`. */
  roomPartitions: RoomPartitionsConnection;
  /** Reads and enables pagination through a set of `RoomPhoneNumber`. */
  roomPhoneNumbers: RoomPhoneNumbersConnection;
  /** Reads and enables pagination through a set of `RoomPublicGrossSpace`. */
  roomPublicGrossSpaces: RoomPublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `RoomSbvGrossSpace`. */
  roomSbvGrossSpaces: RoomSbvGrossSpacesConnection;
  /** Reads and enables pagination through a set of `RoomTireLoadCar`. */
  roomTireLoadCars: RoomTireLoadCarsConnection;
  /** Reads and enables pagination through a set of `RoomTireLoadForklift`. */
  roomTireLoadForklifts: RoomTireLoadForkliftsConnection;
  /** Reads and enables pagination through a set of `RoomTireLoadTruck`. */
  roomTireLoadTrucks: RoomTireLoadTrucksConnection;
  /** Reads and enables pagination through a set of `RoomTypeAttr`. */
  roomTypeAttrs: RoomTypeAttrsConnection;
  /** Reads a single `RoomType` that is related to this `Room`. */
  type?: Maybe<RoomType>;
  typeId?: Maybe<Scalars['UUID']>;
};


export type RoomAllocationRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationRoomCondition>;
  filter?: InputMaybe<AllocationRoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationRoomsOrderBy>>;
};


export type RoomProjectAllocationRoomsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectAllocationRoomCondition>;
  filter?: InputMaybe<ProjectAllocationRoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectAllocationRoomsOrderBy>>;
};


export type RoomRoomAirChangeRatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomAirChangeRateCondition>;
  filter?: InputMaybe<RoomAirChangeRateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomAirChangeRatesOrderBy>>;
};


export type RoomRoomAirConditioningsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomAirConditioningCondition>;
  filter?: InputMaybe<RoomAirConditioningFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomAirConditioningsOrderBy>>;
};


export type RoomRoomCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadGrossSpaceMinCondition>;
  filter?: InputMaybe<RoomCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadGrossSpaceMinsOrderBy>>;
};


export type RoomRoomCadHeightMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadHeightMaxCondition>;
  filter?: InputMaybe<RoomCadHeightMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadHeightMaxesOrderBy>>;
};


export type RoomRoomCadHeightMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadHeightMinCondition>;
  filter?: InputMaybe<RoomCadHeightMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadHeightMinsOrderBy>>;
};


export type RoomRoomCadLengthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadLengthMaxCondition>;
  filter?: InputMaybe<RoomCadLengthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadLengthMaxesOrderBy>>;
};


export type RoomRoomCadLengthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadLengthMinCondition>;
  filter?: InputMaybe<RoomCadLengthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadLengthMinsOrderBy>>;
};


export type RoomRoomCadWidthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadWidthMaxCondition>;
  filter?: InputMaybe<RoomCadWidthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadWidthMaxesOrderBy>>;
};


export type RoomRoomCadWidthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCadWidthMinCondition>;
  filter?: InputMaybe<RoomCadWidthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCadWidthMinsOrderBy>>;
};


export type RoomRoomCapacityCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCapacityCarCondition>;
  filter?: InputMaybe<RoomCapacityCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCapacityCarsOrderBy>>;
};


export type RoomRoomCapacityPaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCapacityPaxCondition>;
  filter?: InputMaybe<RoomCapacityPaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCapacityPaxesOrderBy>>;
};


export type RoomRoomCapacityTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCapacityTruckCondition>;
  filter?: InputMaybe<RoomCapacityTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCapacityTrucksOrderBy>>;
};


export type RoomRoomCleaningGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCleaningGrossSpaceCondition>;
  filter?: InputMaybe<RoomCleaningGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomCleaningGrossSpacesOrderBy>>;
};


export type RoomRoomClearanceConstructionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomClearanceConstructionCondition>;
  filter?: InputMaybe<RoomClearanceConstructionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomClearanceConstructionsOrderBy>>;
};


export type RoomRoomContactBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomContactBookingCondition>;
  filter?: InputMaybe<RoomContactBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomContactBookingsOrderBy>>;
};


export type RoomRoomDaylightsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomDaylightCondition>;
  filter?: InputMaybe<RoomDaylightFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomDaylightsOrderBy>>;
};


export type RoomRoomDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomDescriptionCondition>;
  filter?: InputMaybe<RoomDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomDescriptionsOrderBy>>;
};


export type RoomRoomKeyIssuanceNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomKeyIssuanceNoteCondition>;
  filter?: InputMaybe<RoomKeyIssuanceNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomKeyIssuanceNotesOrderBy>>;
};


export type RoomRoomKeyIssuancesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomKeyIssuanceCondition>;
  filter?: InputMaybe<RoomKeyIssuanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomKeyIssuancesOrderBy>>;
};


export type RoomRoomLightShuttersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomLightShutterCondition>;
  filter?: InputMaybe<RoomLightShutterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomLightShuttersOrderBy>>;
};


export type RoomRoomMaxLoadCeilingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomMaxLoadCeilingCondition>;
  filter?: InputMaybe<RoomMaxLoadCeilingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomMaxLoadCeilingsOrderBy>>;
};


export type RoomRoomMaxLoadFloorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomMaxLoadFloorCondition>;
  filter?: InputMaybe<RoomMaxLoadFloorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomMaxLoadFloorsOrderBy>>;
};


export type RoomRoomNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameExtraCondition>;
  filter?: InputMaybe<RoomNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameExtrasOrderBy>>;
};


export type RoomRoomNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyCadCondition>;
  filter?: InputMaybe<RoomNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyCadsOrderBy>>;
};


export type RoomRoomNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyCafmCondition>;
  filter?: InputMaybe<RoomNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyCafmsOrderBy>>;
};


export type RoomRoomNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyEbmCondition>;
  filter?: InputMaybe<RoomNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyEbmsOrderBy>>;
};


export type RoomRoomNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameKeyMarketingCondition>;
  filter?: InputMaybe<RoomNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameKeyMarketingsOrderBy>>;
};


export type RoomRoomNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameLongCondition>;
  filter?: InputMaybe<RoomNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameLongsOrderBy>>;
};


export type RoomRoomNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNameShortCondition>;
  filter?: InputMaybe<RoomNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNameShortsOrderBy>>;
};


export type RoomRoomNoVehiclesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomNoVehicleCondition>;
  filter?: InputMaybe<RoomNoVehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomNoVehiclesOrderBy>>;
};


export type RoomRoomPartitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCondition>;
  filter?: InputMaybe<RoomPartitionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionsOrderBy>>;
};


export type RoomRoomPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPhoneNumberCondition>;
  filter?: InputMaybe<RoomPhoneNumberFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPhoneNumbersOrderBy>>;
};


export type RoomRoomPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPublicGrossSpaceCondition>;
  filter?: InputMaybe<RoomPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPublicGrossSpacesOrderBy>>;
};


export type RoomRoomSbvGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomSbvGrossSpaceCondition>;
  filter?: InputMaybe<RoomSbvGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomSbvGrossSpacesOrderBy>>;
};


export type RoomRoomTireLoadCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTireLoadCarCondition>;
  filter?: InputMaybe<RoomTireLoadCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTireLoadCarsOrderBy>>;
};


export type RoomRoomTireLoadForkliftsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTireLoadForkliftCondition>;
  filter?: InputMaybe<RoomTireLoadForkliftFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTireLoadForkliftsOrderBy>>;
};


export type RoomRoomTireLoadTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTireLoadTruckCondition>;
  filter?: InputMaybe<RoomTireLoadTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTireLoadTrucksOrderBy>>;
};


export type RoomRoomTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTypeAttrCondition>;
  filter?: InputMaybe<RoomTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTypeAttrsOrderBy>>;
};

export type RoomAirChangeRate = {
  __typename?: 'RoomAirChangeRate';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomAirChangeRate`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomAirChangeRate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomAirChangeRateCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomAirChangeRate` object types. All fields are combined with a logical ‘and.’ */
export type RoomAirChangeRateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomAirChangeRateFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomAirChangeRateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomAirChangeRateFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomAirChangeRate` */
export type RoomAirChangeRateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomAirChangeRate` to look up the row to update. */
export type RoomAirChangeRateOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomAirChangeRatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomAirChangeRate` being updated. */
  patch: UpdateRoomAirChangeRateOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyPatch;
};

/** Represents an update to a `RoomAirChangeRate`. Fields that are set will be updated. */
export type RoomAirChangeRatePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomAirChangeRate` to look up the row to connect. */
export type RoomAirChangeRateRoomAirChangeRatePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomAirChangeRate` to look up the row to delete. */
export type RoomAirChangeRateRoomAirChangeRatePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomAirChangeRateInput` mutation. */
export type RoomAirChangeRateRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomAirChangeRateRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomAirChangeRate` in the `RoomInput` mutation. */
export type RoomAirChangeRateRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomAirChangeRate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomAirChangeRateRoomAirChangeRatePkeyConnect>>;
  /** A `RoomAirChangeRateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomAirChangeRateRoomIdFkeyRoomAirChangeRateCreateInput>>;
  /** The primary key(s) for `roomAirChangeRate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomAirChangeRateRoomAirChangeRatePkeyDelete>>;
  /** Flag indicating whether all other `roomAirChangeRate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomAirChangeRate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomAirChangeRateOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomAirChangeRatePkeyUpdate>>;
};

/** The `roomAirChangeRate` to be created by this mutation. */
export type RoomAirChangeRateRoomIdFkeyRoomAirChangeRateCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomAirChangeRateRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomAirChangeRate` values. */
export type RoomAirChangeRatesConnection = {
  __typename?: 'RoomAirChangeRatesConnection';
  /** A list of edges which contains the `RoomAirChangeRate` and cursor to aid in pagination. */
  edges: Array<RoomAirChangeRatesEdge>;
  /** A list of `RoomAirChangeRate` objects. */
  nodes: Array<RoomAirChangeRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomAirChangeRate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomAirChangeRate` edge in the connection. */
export type RoomAirChangeRatesEdge = {
  __typename?: 'RoomAirChangeRatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomAirChangeRate` at the end of the edge. */
  node: RoomAirChangeRate;
};

/** Methods to use when ordering `RoomAirChangeRate`. */
export enum RoomAirChangeRatesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomAirConditioning = {
  __typename?: 'RoomAirConditioning';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomAirConditioning`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['Boolean']>;
};

/**
 * A condition to be used against `RoomAirConditioning` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomAirConditioningCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `RoomAirConditioning` object types. All fields are combined with a logical ‘and.’ */
export type RoomAirConditioningFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomAirConditioningFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomAirConditioningFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomAirConditioningFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `RoomAirConditioning` */
export type RoomAirConditioningInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirConditioningRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomAirConditioning` to look up the row to update. */
export type RoomAirConditioningOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomAirConditioningPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomAirConditioning` being updated. */
  patch: UpdateRoomAirConditioningOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyPatch;
};

/** Represents an update to a `RoomAirConditioning`. Fields that are set will be updated. */
export type RoomAirConditioningPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirConditioningRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomAirConditioning` to look up the row to connect. */
export type RoomAirConditioningRoomAirConditioningPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomAirConditioning` to look up the row to delete. */
export type RoomAirConditioningRoomAirConditioningPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomAirConditioningInput` mutation. */
export type RoomAirConditioningRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomAirConditioningRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomAirConditioning` in the `RoomInput` mutation. */
export type RoomAirConditioningRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomAirConditioning` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomAirConditioningRoomAirConditioningPkeyConnect>>;
  /** A `RoomAirConditioningInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomAirConditioningRoomIdFkeyRoomAirConditioningCreateInput>>;
  /** The primary key(s) for `roomAirConditioning` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomAirConditioningRoomAirConditioningPkeyDelete>>;
  /** Flag indicating whether all other `roomAirConditioning` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomAirConditioning` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomAirConditioningOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomAirConditioningPkeyUpdate>>;
};

/** The `roomAirConditioning` to be created by this mutation. */
export type RoomAirConditioningRoomIdFkeyRoomAirConditioningCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirConditioningRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The `room` to be created by this mutation. */
export type RoomAirConditioningRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomAirConditioning` values. */
export type RoomAirConditioningsConnection = {
  __typename?: 'RoomAirConditioningsConnection';
  /** A list of edges which contains the `RoomAirConditioning` and cursor to aid in pagination. */
  edges: Array<RoomAirConditioningsEdge>;
  /** A list of `RoomAirConditioning` objects. */
  nodes: Array<RoomAirConditioning>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomAirConditioning` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomAirConditioning` edge in the connection. */
export type RoomAirConditioningsEdge = {
  __typename?: 'RoomAirConditioningsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomAirConditioning` at the end of the edge. */
  node: RoomAirConditioning;
};

/** Methods to use when ordering `RoomAirConditioning`. */
export enum RoomAirConditioningsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadGrossSpaceMin = {
  __typename?: 'RoomCadGrossSpaceMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadGrossSpaceMin`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadGrossSpaceMin` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomCadGrossSpaceMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadGrossSpaceMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadGrossSpaceMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadGrossSpaceMin` */
export type RoomCadGrossSpaceMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadGrossSpaceMin` to look up the row to update. */
export type RoomCadGrossSpaceMinOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomCadGrossSpaceMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadGrossSpaceMin` being updated. */
  patch: UpdateRoomCadGrossSpaceMinOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadGrossSpaceMin`. Fields that are set will be updated. */
export type RoomCadGrossSpaceMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadGrossSpaceMin` to look up the row to connect. */
export type RoomCadGrossSpaceMinRoomCadGrossSpaceMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadGrossSpaceMin` to look up the row to delete. */
export type RoomCadGrossSpaceMinRoomCadGrossSpaceMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadGrossSpaceMinInput` mutation. */
export type RoomCadGrossSpaceMinRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadGrossSpaceMin` in the `RoomInput` mutation. */
export type RoomCadGrossSpaceMinRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadGrossSpaceMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadGrossSpaceMinRoomCadGrossSpaceMinPkeyConnect>>;
  /** A `RoomCadGrossSpaceMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadGrossSpaceMinRoomIdFkeyRoomCadGrossSpaceMinCreateInput>>;
  /** The primary key(s) for `roomCadGrossSpaceMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadGrossSpaceMinRoomCadGrossSpaceMinPkeyDelete>>;
  /** Flag indicating whether all other `roomCadGrossSpaceMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadGrossSpaceMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadGrossSpaceMinOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomCadGrossSpaceMinPkeyUpdate>>;
};

/** The `roomCadGrossSpaceMin` to be created by this mutation. */
export type RoomCadGrossSpaceMinRoomIdFkeyRoomCadGrossSpaceMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadGrossSpaceMinRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadGrossSpaceMin` values. */
export type RoomCadGrossSpaceMinsConnection = {
  __typename?: 'RoomCadGrossSpaceMinsConnection';
  /** A list of edges which contains the `RoomCadGrossSpaceMin` and cursor to aid in pagination. */
  edges: Array<RoomCadGrossSpaceMinsEdge>;
  /** A list of `RoomCadGrossSpaceMin` objects. */
  nodes: Array<RoomCadGrossSpaceMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadGrossSpaceMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadGrossSpaceMin` edge in the connection. */
export type RoomCadGrossSpaceMinsEdge = {
  __typename?: 'RoomCadGrossSpaceMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadGrossSpaceMin` at the end of the edge. */
  node: RoomCadGrossSpaceMin;
};

/** Methods to use when ordering `RoomCadGrossSpaceMin`. */
export enum RoomCadGrossSpaceMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadHeightMax = {
  __typename?: 'RoomCadHeightMax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadHeightMax`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadHeightMax` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCadHeightMaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadHeightMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadHeightMaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadHeightMaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadHeightMaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadHeightMaxFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadHeightMax` */
export type RoomCadHeightMaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadHeightMax` to look up the row to update. */
export type RoomCadHeightMaxOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomCadHeightMaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadHeightMax` being updated. */
  patch: UpdateRoomCadHeightMaxOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadHeightMax`. Fields that are set will be updated. */
export type RoomCadHeightMaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadHeightMax` to look up the row to connect. */
export type RoomCadHeightMaxRoomCadHeightMaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadHeightMax` to look up the row to delete. */
export type RoomCadHeightMaxRoomCadHeightMaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadHeightMaxInput` mutation. */
export type RoomCadHeightMaxRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadHeightMaxRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadHeightMax` in the `RoomInput` mutation. */
export type RoomCadHeightMaxRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadHeightMax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadHeightMaxRoomCadHeightMaxPkeyConnect>>;
  /** A `RoomCadHeightMaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadHeightMaxRoomIdFkeyRoomCadHeightMaxCreateInput>>;
  /** The primary key(s) for `roomCadHeightMax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadHeightMaxRoomCadHeightMaxPkeyDelete>>;
  /** Flag indicating whether all other `roomCadHeightMax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadHeightMax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadHeightMaxOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomCadHeightMaxPkeyUpdate>>;
};

/** The `roomCadHeightMax` to be created by this mutation. */
export type RoomCadHeightMaxRoomIdFkeyRoomCadHeightMaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadHeightMaxRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadHeightMax` values. */
export type RoomCadHeightMaxesConnection = {
  __typename?: 'RoomCadHeightMaxesConnection';
  /** A list of edges which contains the `RoomCadHeightMax` and cursor to aid in pagination. */
  edges: Array<RoomCadHeightMaxesEdge>;
  /** A list of `RoomCadHeightMax` objects. */
  nodes: Array<RoomCadHeightMax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadHeightMax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadHeightMax` edge in the connection. */
export type RoomCadHeightMaxesEdge = {
  __typename?: 'RoomCadHeightMaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadHeightMax` at the end of the edge. */
  node: RoomCadHeightMax;
};

/** Methods to use when ordering `RoomCadHeightMax`. */
export enum RoomCadHeightMaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadHeightMin = {
  __typename?: 'RoomCadHeightMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadHeightMin`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadHeightMin` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCadHeightMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadHeightMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadHeightMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadHeightMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadHeightMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadHeightMinFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadHeightMin` */
export type RoomCadHeightMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadHeightMin` to look up the row to update. */
export type RoomCadHeightMinOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomCadHeightMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadHeightMin` being updated. */
  patch: UpdateRoomCadHeightMinOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadHeightMin`. Fields that are set will be updated. */
export type RoomCadHeightMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadHeightMin` to look up the row to connect. */
export type RoomCadHeightMinRoomCadHeightMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadHeightMin` to look up the row to delete. */
export type RoomCadHeightMinRoomCadHeightMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadHeightMinInput` mutation. */
export type RoomCadHeightMinRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadHeightMinRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadHeightMin` in the `RoomInput` mutation. */
export type RoomCadHeightMinRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadHeightMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadHeightMinRoomCadHeightMinPkeyConnect>>;
  /** A `RoomCadHeightMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadHeightMinRoomIdFkeyRoomCadHeightMinCreateInput>>;
  /** The primary key(s) for `roomCadHeightMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadHeightMinRoomCadHeightMinPkeyDelete>>;
  /** Flag indicating whether all other `roomCadHeightMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadHeightMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadHeightMinOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomCadHeightMinPkeyUpdate>>;
};

/** The `roomCadHeightMin` to be created by this mutation. */
export type RoomCadHeightMinRoomIdFkeyRoomCadHeightMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadHeightMinRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadHeightMin` values. */
export type RoomCadHeightMinsConnection = {
  __typename?: 'RoomCadHeightMinsConnection';
  /** A list of edges which contains the `RoomCadHeightMin` and cursor to aid in pagination. */
  edges: Array<RoomCadHeightMinsEdge>;
  /** A list of `RoomCadHeightMin` objects. */
  nodes: Array<RoomCadHeightMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadHeightMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadHeightMin` edge in the connection. */
export type RoomCadHeightMinsEdge = {
  __typename?: 'RoomCadHeightMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadHeightMin` at the end of the edge. */
  node: RoomCadHeightMin;
};

/** Methods to use when ordering `RoomCadHeightMin`. */
export enum RoomCadHeightMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadLengthMax = {
  __typename?: 'RoomCadLengthMax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadLengthMax`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadLengthMax` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCadLengthMaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadLengthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadLengthMaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadLengthMaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadLengthMaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadLengthMaxFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadLengthMax` */
export type RoomCadLengthMaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadLengthMax` to look up the row to update. */
export type RoomCadLengthMaxOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomCadLengthMaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadLengthMax` being updated. */
  patch: UpdateRoomCadLengthMaxOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadLengthMax`. Fields that are set will be updated. */
export type RoomCadLengthMaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadLengthMax` to look up the row to connect. */
export type RoomCadLengthMaxRoomCadLengthMaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadLengthMax` to look up the row to delete. */
export type RoomCadLengthMaxRoomCadLengthMaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadLengthMaxInput` mutation. */
export type RoomCadLengthMaxRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadLengthMaxRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadLengthMax` in the `RoomInput` mutation. */
export type RoomCadLengthMaxRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadLengthMax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadLengthMaxRoomCadLengthMaxPkeyConnect>>;
  /** A `RoomCadLengthMaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadLengthMaxRoomIdFkeyRoomCadLengthMaxCreateInput>>;
  /** The primary key(s) for `roomCadLengthMax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadLengthMaxRoomCadLengthMaxPkeyDelete>>;
  /** Flag indicating whether all other `roomCadLengthMax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadLengthMax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadLengthMaxOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomCadLengthMaxPkeyUpdate>>;
};

/** The `roomCadLengthMax` to be created by this mutation. */
export type RoomCadLengthMaxRoomIdFkeyRoomCadLengthMaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadLengthMaxRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadLengthMax` values. */
export type RoomCadLengthMaxesConnection = {
  __typename?: 'RoomCadLengthMaxesConnection';
  /** A list of edges which contains the `RoomCadLengthMax` and cursor to aid in pagination. */
  edges: Array<RoomCadLengthMaxesEdge>;
  /** A list of `RoomCadLengthMax` objects. */
  nodes: Array<RoomCadLengthMax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadLengthMax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadLengthMax` edge in the connection. */
export type RoomCadLengthMaxesEdge = {
  __typename?: 'RoomCadLengthMaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadLengthMax` at the end of the edge. */
  node: RoomCadLengthMax;
};

/** Methods to use when ordering `RoomCadLengthMax`. */
export enum RoomCadLengthMaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadLengthMin = {
  __typename?: 'RoomCadLengthMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadLengthMin`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadLengthMin` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCadLengthMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadLengthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadLengthMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadLengthMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadLengthMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadLengthMinFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadLengthMin` */
export type RoomCadLengthMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadLengthMin` to look up the row to update. */
export type RoomCadLengthMinOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomCadLengthMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadLengthMin` being updated. */
  patch: UpdateRoomCadLengthMinOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadLengthMin`. Fields that are set will be updated. */
export type RoomCadLengthMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadLengthMin` to look up the row to connect. */
export type RoomCadLengthMinRoomCadLengthMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadLengthMin` to look up the row to delete. */
export type RoomCadLengthMinRoomCadLengthMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadLengthMinInput` mutation. */
export type RoomCadLengthMinRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadLengthMinRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadLengthMin` in the `RoomInput` mutation. */
export type RoomCadLengthMinRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadLengthMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadLengthMinRoomCadLengthMinPkeyConnect>>;
  /** A `RoomCadLengthMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadLengthMinRoomIdFkeyRoomCadLengthMinCreateInput>>;
  /** The primary key(s) for `roomCadLengthMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadLengthMinRoomCadLengthMinPkeyDelete>>;
  /** Flag indicating whether all other `roomCadLengthMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadLengthMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadLengthMinOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomCadLengthMinPkeyUpdate>>;
};

/** The `roomCadLengthMin` to be created by this mutation. */
export type RoomCadLengthMinRoomIdFkeyRoomCadLengthMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadLengthMinRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadLengthMin` values. */
export type RoomCadLengthMinsConnection = {
  __typename?: 'RoomCadLengthMinsConnection';
  /** A list of edges which contains the `RoomCadLengthMin` and cursor to aid in pagination. */
  edges: Array<RoomCadLengthMinsEdge>;
  /** A list of `RoomCadLengthMin` objects. */
  nodes: Array<RoomCadLengthMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadLengthMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadLengthMin` edge in the connection. */
export type RoomCadLengthMinsEdge = {
  __typename?: 'RoomCadLengthMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadLengthMin` at the end of the edge. */
  node: RoomCadLengthMin;
};

/** Methods to use when ordering `RoomCadLengthMin`. */
export enum RoomCadLengthMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadWidthMax = {
  __typename?: 'RoomCadWidthMax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadWidthMax`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadWidthMax` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCadWidthMaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadWidthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadWidthMaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadWidthMaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadWidthMaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadWidthMaxFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadWidthMax` */
export type RoomCadWidthMaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadWidthMax` to look up the row to update. */
export type RoomCadWidthMaxOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomCadWidthMaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadWidthMax` being updated. */
  patch: UpdateRoomCadWidthMaxOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadWidthMax`. Fields that are set will be updated. */
export type RoomCadWidthMaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadWidthMax` to look up the row to connect. */
export type RoomCadWidthMaxRoomCadWidthMaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadWidthMax` to look up the row to delete. */
export type RoomCadWidthMaxRoomCadWidthMaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadWidthMaxInput` mutation. */
export type RoomCadWidthMaxRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadWidthMaxRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadWidthMax` in the `RoomInput` mutation. */
export type RoomCadWidthMaxRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadWidthMax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadWidthMaxRoomCadWidthMaxPkeyConnect>>;
  /** A `RoomCadWidthMaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadWidthMaxRoomIdFkeyRoomCadWidthMaxCreateInput>>;
  /** The primary key(s) for `roomCadWidthMax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadWidthMaxRoomCadWidthMaxPkeyDelete>>;
  /** Flag indicating whether all other `roomCadWidthMax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadWidthMax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadWidthMaxOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomCadWidthMaxPkeyUpdate>>;
};

/** The `roomCadWidthMax` to be created by this mutation. */
export type RoomCadWidthMaxRoomIdFkeyRoomCadWidthMaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadWidthMaxRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadWidthMax` values. */
export type RoomCadWidthMaxesConnection = {
  __typename?: 'RoomCadWidthMaxesConnection';
  /** A list of edges which contains the `RoomCadWidthMax` and cursor to aid in pagination. */
  edges: Array<RoomCadWidthMaxesEdge>;
  /** A list of `RoomCadWidthMax` objects. */
  nodes: Array<RoomCadWidthMax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadWidthMax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadWidthMax` edge in the connection. */
export type RoomCadWidthMaxesEdge = {
  __typename?: 'RoomCadWidthMaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadWidthMax` at the end of the edge. */
  node: RoomCadWidthMax;
};

/** Methods to use when ordering `RoomCadWidthMax`. */
export enum RoomCadWidthMaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCadWidthMin = {
  __typename?: 'RoomCadWidthMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCadWidthMin`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCadWidthMin` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCadWidthMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCadWidthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomCadWidthMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCadWidthMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCadWidthMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCadWidthMinFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCadWidthMin` */
export type RoomCadWidthMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCadWidthMin` to look up the row to update. */
export type RoomCadWidthMinOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomCadWidthMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCadWidthMin` being updated. */
  patch: UpdateRoomCadWidthMinOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCadWidthMin`. Fields that are set will be updated. */
export type RoomCadWidthMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCadWidthMin` to look up the row to connect. */
export type RoomCadWidthMinRoomCadWidthMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCadWidthMin` to look up the row to delete. */
export type RoomCadWidthMinRoomCadWidthMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCadWidthMinInput` mutation. */
export type RoomCadWidthMinRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCadWidthMinRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCadWidthMin` in the `RoomInput` mutation. */
export type RoomCadWidthMinRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCadWidthMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCadWidthMinRoomCadWidthMinPkeyConnect>>;
  /** A `RoomCadWidthMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCadWidthMinRoomIdFkeyRoomCadWidthMinCreateInput>>;
  /** The primary key(s) for `roomCadWidthMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCadWidthMinRoomCadWidthMinPkeyDelete>>;
  /** Flag indicating whether all other `roomCadWidthMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCadWidthMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCadWidthMinOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomCadWidthMinPkeyUpdate>>;
};

/** The `roomCadWidthMin` to be created by this mutation. */
export type RoomCadWidthMinRoomIdFkeyRoomCadWidthMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCadWidthMinRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCadWidthMin` values. */
export type RoomCadWidthMinsConnection = {
  __typename?: 'RoomCadWidthMinsConnection';
  /** A list of edges which contains the `RoomCadWidthMin` and cursor to aid in pagination. */
  edges: Array<RoomCadWidthMinsEdge>;
  /** A list of `RoomCadWidthMin` objects. */
  nodes: Array<RoomCadWidthMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCadWidthMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCadWidthMin` edge in the connection. */
export type RoomCadWidthMinsEdge = {
  __typename?: 'RoomCadWidthMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCadWidthMin` at the end of the edge. */
  node: RoomCadWidthMin;
};

/** Methods to use when ordering `RoomCadWidthMin`. */
export enum RoomCadWidthMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCapacityCar = {
  __typename?: 'RoomCapacityCar';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCapacityCar`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/**
 * A condition to be used against `RoomCapacityCar` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCapacityCarCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `RoomCapacityCar` object types. All fields are combined with a logical ‘and.’ */
export type RoomCapacityCarFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCapacityCarFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCapacityCarFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCapacityCarFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `RoomCapacityCar` */
export type RoomCapacityCarInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The fields on `roomCapacityCar` to look up the row to update. */
export type RoomCapacityCarOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomCapacityCarsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCapacityCar` being updated. */
  patch: UpdateRoomCapacityCarOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCapacityCar`. Fields that are set will be updated. */
export type RoomCapacityCarPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** The fields on `roomCapacityCar` to look up the row to connect. */
export type RoomCapacityCarRoomCapacityCarsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCapacityCar` to look up the row to delete. */
export type RoomCapacityCarRoomCapacityCarsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomCapacityCar` values. */
export type RoomCapacityCarsConnection = {
  __typename?: 'RoomCapacityCarsConnection';
  /** A list of edges which contains the `RoomCapacityCar` and cursor to aid in pagination. */
  edges: Array<RoomCapacityCarsEdge>;
  /** A list of `RoomCapacityCar` objects. */
  nodes: Array<RoomCapacityCar>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCapacityCar` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCapacityCar` edge in the connection. */
export type RoomCapacityCarsEdge = {
  __typename?: 'RoomCapacityCarsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCapacityCar` at the end of the edge. */
  node: RoomCapacityCar;
};

/** Methods to use when ordering `RoomCapacityCar`. */
export enum RoomCapacityCarsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomCapacityCarInput` mutation. */
export type RoomCapacityCarsRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCapacityCarsRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCapacityCar` in the `RoomInput` mutation. */
export type RoomCapacityCarsRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCapacityCar` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCapacityCarRoomCapacityCarsPkeyConnect>>;
  /** A `RoomCapacityCarInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCapacityCarsRoomIdFkeyRoomCapacityCarsCreateInput>>;
  /** The primary key(s) for `roomCapacityCar` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCapacityCarRoomCapacityCarsPkeyDelete>>;
  /** Flag indicating whether all other `roomCapacityCar` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCapacityCar` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCapacityCarOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomCapacityCarsPkeyUpdate>>;
};

/** The `roomCapacityCar` to be created by this mutation. */
export type RoomCapacityCarsRoomIdFkeyRoomCapacityCarsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The `room` to be created by this mutation. */
export type RoomCapacityCarsRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomCapacityPax = {
  __typename?: 'RoomCapacityPax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCapacityPax`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/**
 * A condition to be used against `RoomCapacityPax` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCapacityPaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `RoomCapacityPax` object types. All fields are combined with a logical ‘and.’ */
export type RoomCapacityPaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCapacityPaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCapacityPaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCapacityPaxFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `RoomCapacityPax` */
export type RoomCapacityPaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The fields on `roomCapacityPax` to look up the row to update. */
export type RoomCapacityPaxOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomCapacityPaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCapacityPax` being updated. */
  patch: UpdateRoomCapacityPaxOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCapacityPax`. Fields that are set will be updated. */
export type RoomCapacityPaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** The fields on `roomCapacityPax` to look up the row to connect. */
export type RoomCapacityPaxRoomCapacityPaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCapacityPax` to look up the row to delete. */
export type RoomCapacityPaxRoomCapacityPaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCapacityPaxInput` mutation. */
export type RoomCapacityPaxRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCapacityPaxRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCapacityPax` in the `RoomInput` mutation. */
export type RoomCapacityPaxRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCapacityPax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCapacityPaxRoomCapacityPaxPkeyConnect>>;
  /** A `RoomCapacityPaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCapacityPaxRoomIdFkeyRoomCapacityPaxCreateInput>>;
  /** The primary key(s) for `roomCapacityPax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCapacityPaxRoomCapacityPaxPkeyDelete>>;
  /** Flag indicating whether all other `roomCapacityPax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCapacityPax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCapacityPaxOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomCapacityPaxPkeyUpdate>>;
};

/** The `roomCapacityPax` to be created by this mutation. */
export type RoomCapacityPaxRoomIdFkeyRoomCapacityPaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The `room` to be created by this mutation. */
export type RoomCapacityPaxRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCapacityPax` values. */
export type RoomCapacityPaxesConnection = {
  __typename?: 'RoomCapacityPaxesConnection';
  /** A list of edges which contains the `RoomCapacityPax` and cursor to aid in pagination. */
  edges: Array<RoomCapacityPaxesEdge>;
  /** A list of `RoomCapacityPax` objects. */
  nodes: Array<RoomCapacityPax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCapacityPax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCapacityPax` edge in the connection. */
export type RoomCapacityPaxesEdge = {
  __typename?: 'RoomCapacityPaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCapacityPax` at the end of the edge. */
  node: RoomCapacityPax;
};

/** Methods to use when ordering `RoomCapacityPax`. */
export enum RoomCapacityPaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomCapacityTruck = {
  __typename?: 'RoomCapacityTruck';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCapacityTruck`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/**
 * A condition to be used against `RoomCapacityTruck` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomCapacityTruckCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `RoomCapacityTruck` object types. All fields are combined with a logical ‘and.’ */
export type RoomCapacityTruckFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCapacityTruckFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCapacityTruckFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCapacityTruckFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `RoomCapacityTruck` */
export type RoomCapacityTruckInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The fields on `roomCapacityTruck` to look up the row to update. */
export type RoomCapacityTruckOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomCapacityTrucksPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCapacityTruck` being updated. */
  patch: UpdateRoomCapacityTruckOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCapacityTruck`. Fields that are set will be updated. */
export type RoomCapacityTruckPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** The fields on `roomCapacityTruck` to look up the row to connect. */
export type RoomCapacityTruckRoomCapacityTrucksPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCapacityTruck` to look up the row to delete. */
export type RoomCapacityTruckRoomCapacityTrucksPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomCapacityTruck` values. */
export type RoomCapacityTrucksConnection = {
  __typename?: 'RoomCapacityTrucksConnection';
  /** A list of edges which contains the `RoomCapacityTruck` and cursor to aid in pagination. */
  edges: Array<RoomCapacityTrucksEdge>;
  /** A list of `RoomCapacityTruck` objects. */
  nodes: Array<RoomCapacityTruck>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCapacityTruck` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCapacityTruck` edge in the connection. */
export type RoomCapacityTrucksEdge = {
  __typename?: 'RoomCapacityTrucksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCapacityTruck` at the end of the edge. */
  node: RoomCapacityTruck;
};

/** Methods to use when ordering `RoomCapacityTruck`. */
export enum RoomCapacityTrucksOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomCapacityTruckInput` mutation. */
export type RoomCapacityTrucksRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCapacityTrucksRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCapacityTruck` in the `RoomInput` mutation. */
export type RoomCapacityTrucksRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCapacityTruck` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCapacityTruckRoomCapacityTrucksPkeyConnect>>;
  /** A `RoomCapacityTruckInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCapacityTrucksRoomIdFkeyRoomCapacityTrucksCreateInput>>;
  /** The primary key(s) for `roomCapacityTruck` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCapacityTruckRoomCapacityTrucksPkeyDelete>>;
  /** Flag indicating whether all other `roomCapacityTruck` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCapacityTruck` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCapacityTruckOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomCapacityTrucksPkeyUpdate>>;
};

/** The `roomCapacityTruck` to be created by this mutation. */
export type RoomCapacityTrucksRoomIdFkeyRoomCapacityTrucksCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The `room` to be created by this mutation. */
export type RoomCapacityTrucksRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomCleaningGrossSpace = {
  __typename?: 'RoomCleaningGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomCleaningGrossSpace`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomCleaningGrossSpace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomCleaningGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomCleaningGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomCleaningGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomCleaningGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomCleaningGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomCleaningGrossSpaceFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomCleaningGrossSpace` */
export type RoomCleaningGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomCleaningGrossSpace` to look up the row to update. */
export type RoomCleaningGrossSpaceOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomCleaningGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomCleaningGrossSpace` being updated. */
  patch: UpdateRoomCleaningGrossSpaceOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyPatch;
};

/** Represents an update to a `RoomCleaningGrossSpace`. Fields that are set will be updated. */
export type RoomCleaningGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomCleaningGrossSpace` to look up the row to connect. */
export type RoomCleaningGrossSpaceRoomCleaningGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomCleaningGrossSpace` to look up the row to delete. */
export type RoomCleaningGrossSpaceRoomCleaningGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomCleaningGrossSpaceInput` mutation. */
export type RoomCleaningGrossSpaceRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomCleaningGrossSpace` in the `RoomInput` mutation. */
export type RoomCleaningGrossSpaceRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomCleaningGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomCleaningGrossSpaceRoomCleaningGrossSpacePkeyConnect>>;
  /** A `RoomCleaningGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomCleaningGrossSpaceRoomIdFkeyRoomCleaningGrossSpaceCreateInput>>;
  /** The primary key(s) for `roomCleaningGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomCleaningGrossSpaceRoomCleaningGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `roomCleaningGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomCleaningGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomCleaningGrossSpaceOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomCleaningGrossSpacePkeyUpdate>>;
};

/** The `roomCleaningGrossSpace` to be created by this mutation. */
export type RoomCleaningGrossSpaceRoomIdFkeyRoomCleaningGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `room` to be created by this mutation. */
export type RoomCleaningGrossSpaceRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomCleaningGrossSpace` values. */
export type RoomCleaningGrossSpacesConnection = {
  __typename?: 'RoomCleaningGrossSpacesConnection';
  /** A list of edges which contains the `RoomCleaningGrossSpace` and cursor to aid in pagination. */
  edges: Array<RoomCleaningGrossSpacesEdge>;
  /** A list of `RoomCleaningGrossSpace` objects. */
  nodes: Array<RoomCleaningGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomCleaningGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomCleaningGrossSpace` edge in the connection. */
export type RoomCleaningGrossSpacesEdge = {
  __typename?: 'RoomCleaningGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomCleaningGrossSpace` at the end of the edge. */
  node: RoomCleaningGrossSpace;
};

/** Methods to use when ordering `RoomCleaningGrossSpace`. */
export enum RoomCleaningGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomClearanceConstruction = {
  __typename?: 'RoomClearanceConstruction';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomClearanceConstruction`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomClearanceConstruction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomClearanceConstructionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomClearanceConstruction` object types. All fields are combined with a logical ‘and.’ */
export type RoomClearanceConstructionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomClearanceConstructionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomClearanceConstructionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomClearanceConstructionFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomClearanceConstruction` */
export type RoomClearanceConstructionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomClearanceConstruction` to look up the row to update. */
export type RoomClearanceConstructionOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomClearanceConstructionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomClearanceConstruction` being updated. */
  patch: UpdateRoomClearanceConstructionOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyPatch;
};

/** Represents an update to a `RoomClearanceConstruction`. Fields that are set will be updated. */
export type RoomClearanceConstructionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomClearanceConstruction` to look up the row to connect. */
export type RoomClearanceConstructionRoomClearanceConstructionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomClearanceConstruction` to look up the row to delete. */
export type RoomClearanceConstructionRoomClearanceConstructionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomClearanceConstructionInput` mutation. */
export type RoomClearanceConstructionRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomClearanceConstructionRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomClearanceConstruction` in the `RoomInput` mutation. */
export type RoomClearanceConstructionRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomClearanceConstruction` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomClearanceConstructionRoomClearanceConstructionPkeyConnect>>;
  /** A `RoomClearanceConstructionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomClearanceConstructionRoomIdFkeyRoomClearanceConstructionCreateInput>>;
  /** The primary key(s) for `roomClearanceConstruction` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomClearanceConstructionRoomClearanceConstructionPkeyDelete>>;
  /** Flag indicating whether all other `roomClearanceConstruction` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomClearanceConstruction` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomClearanceConstructionOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomClearanceConstructionPkeyUpdate>>;
};

/** The `roomClearanceConstruction` to be created by this mutation. */
export type RoomClearanceConstructionRoomIdFkeyRoomClearanceConstructionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `room` to be created by this mutation. */
export type RoomClearanceConstructionRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomClearanceConstruction` values. */
export type RoomClearanceConstructionsConnection = {
  __typename?: 'RoomClearanceConstructionsConnection';
  /** A list of edges which contains the `RoomClearanceConstruction` and cursor to aid in pagination. */
  edges: Array<RoomClearanceConstructionsEdge>;
  /** A list of `RoomClearanceConstruction` objects. */
  nodes: Array<RoomClearanceConstruction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomClearanceConstruction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomClearanceConstruction` edge in the connection. */
export type RoomClearanceConstructionsEdge = {
  __typename?: 'RoomClearanceConstructionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomClearanceConstruction` at the end of the edge. */
  node: RoomClearanceConstruction;
};

/** Methods to use when ordering `RoomClearanceConstruction`. */
export enum RoomClearanceConstructionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A condition to be used against `Room` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RoomCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomContactBooking = {
  __typename?: 'RoomContactBooking';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomContactBooking`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomContactBooking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomContactBookingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomContactBooking` object types. All fields are combined with a logical ‘and.’ */
export type RoomContactBookingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomContactBookingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomContactBookingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomContactBookingFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomContactBooking` */
export type RoomContactBookingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomContactBookingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomContactBooking` to look up the row to update. */
export type RoomContactBookingOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomContactBookingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomContactBooking` being updated. */
  patch: UpdateRoomContactBookingOnRoomContactBookingForRoomContactBookingRoomIdFkeyPatch;
};

/** Represents an update to a `RoomContactBooking`. Fields that are set will be updated. */
export type RoomContactBookingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomContactBookingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomContactBooking` to look up the row to connect. */
export type RoomContactBookingRoomContactBookingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomContactBooking` to look up the row to delete. */
export type RoomContactBookingRoomContactBookingPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomContactBookingInput` mutation. */
export type RoomContactBookingRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomContactBookingRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomContactBooking` in the `RoomInput` mutation. */
export type RoomContactBookingRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomContactBooking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomContactBookingRoomContactBookingPkeyConnect>>;
  /** A `RoomContactBookingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomContactBookingRoomIdFkeyRoomContactBookingCreateInput>>;
  /** The primary key(s) for `roomContactBooking` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomContactBookingRoomContactBookingPkeyDelete>>;
  /** Flag indicating whether all other `roomContactBooking` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomContactBooking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomContactBookingOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomContactBookingPkeyUpdate>>;
};

/** The `roomContactBooking` to be created by this mutation. */
export type RoomContactBookingRoomIdFkeyRoomContactBookingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomContactBookingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The `room` to be created by this mutation. */
export type RoomContactBookingRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomContactBooking` values. */
export type RoomContactBookingsConnection = {
  __typename?: 'RoomContactBookingsConnection';
  /** A list of edges which contains the `RoomContactBooking` and cursor to aid in pagination. */
  edges: Array<RoomContactBookingsEdge>;
  /** A list of `RoomContactBooking` objects. */
  nodes: Array<RoomContactBooking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomContactBooking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomContactBooking` edge in the connection. */
export type RoomContactBookingsEdge = {
  __typename?: 'RoomContactBookingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomContactBooking` at the end of the edge. */
  node: RoomContactBooking;
};

/** Methods to use when ordering `RoomContactBooking`. */
export enum RoomContactBookingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomDaylight = {
  __typename?: 'RoomDaylight';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomDaylight`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['Boolean']>;
};

/**
 * A condition to be used against `RoomDaylight` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomDaylightCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `RoomDaylight` object types. All fields are combined with a logical ‘and.’ */
export type RoomDaylightFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomDaylightFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomDaylightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomDaylightFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `RoomDaylight` */
export type RoomDaylightInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDaylightRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomDaylight` to look up the row to update. */
export type RoomDaylightOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomDaylightPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomDaylight` being updated. */
  patch: UpdateRoomDaylightOnRoomDaylightForRoomDaylightRoomIdFkeyPatch;
};

/** Represents an update to a `RoomDaylight`. Fields that are set will be updated. */
export type RoomDaylightPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDaylightRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomDaylight` to look up the row to connect. */
export type RoomDaylightRoomDaylightPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomDaylight` to look up the row to delete. */
export type RoomDaylightRoomDaylightPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomDaylightInput` mutation. */
export type RoomDaylightRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomDaylightRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomDaylight` in the `RoomInput` mutation. */
export type RoomDaylightRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomDaylight` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomDaylightRoomDaylightPkeyConnect>>;
  /** A `RoomDaylightInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomDaylightRoomIdFkeyRoomDaylightCreateInput>>;
  /** The primary key(s) for `roomDaylight` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomDaylightRoomDaylightPkeyDelete>>;
  /** Flag indicating whether all other `roomDaylight` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomDaylight` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomDaylightOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomDaylightPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomDaylightRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomDaylight` to be created by this mutation. */
export type RoomDaylightRoomIdFkeyRoomDaylightCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDaylightRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `RoomDaylight` values. */
export type RoomDaylightsConnection = {
  __typename?: 'RoomDaylightsConnection';
  /** A list of edges which contains the `RoomDaylight` and cursor to aid in pagination. */
  edges: Array<RoomDaylightsEdge>;
  /** A list of `RoomDaylight` objects. */
  nodes: Array<RoomDaylight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomDaylight` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomDaylight` edge in the connection. */
export type RoomDaylightsEdge = {
  __typename?: 'RoomDaylightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomDaylight` at the end of the edge. */
  node: RoomDaylight;
};

/** Methods to use when ordering `RoomDaylight`. */
export enum RoomDaylightsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomDescription = {
  __typename?: 'RoomDescription';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomDescription`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomDescription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomDescriptionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomDescription` object types. All fields are combined with a logical ‘and.’ */
export type RoomDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomDescriptionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomDescriptionFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomDescription` */
export type RoomDescriptionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDescriptionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomDescription` to look up the row to update. */
export type RoomDescriptionOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomDescription` being updated. */
  patch: UpdateRoomDescriptionOnRoomDescriptionForRoomDescriptionRoomIdFkeyPatch;
};

/** Represents an update to a `RoomDescription`. Fields that are set will be updated. */
export type RoomDescriptionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDescriptionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomDescription` to look up the row to connect. */
export type RoomDescriptionRoomDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomDescription` to look up the row to delete. */
export type RoomDescriptionRoomDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `room` in the `RoomDescriptionInput` mutation. */
export type RoomDescriptionRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomDescriptionRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomDescription` in the `RoomInput` mutation. */
export type RoomDescriptionRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomDescriptionRoomDescriptionPkeyConnect>>;
  /** A `RoomDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomDescriptionRoomIdFkeyRoomDescriptionCreateInput>>;
  /** The primary key(s) for `roomDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomDescriptionRoomDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `roomDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomDescriptionOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomDescriptionPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomDescriptionRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomDescription` to be created by this mutation. */
export type RoomDescriptionRoomIdFkeyRoomDescriptionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDescriptionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** A connection to a list of `RoomDescription` values. */
export type RoomDescriptionsConnection = {
  __typename?: 'RoomDescriptionsConnection';
  /** A list of edges which contains the `RoomDescription` and cursor to aid in pagination. */
  edges: Array<RoomDescriptionsEdge>;
  /** A list of `RoomDescription` objects. */
  nodes: Array<RoomDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomDescription` edge in the connection. */
export type RoomDescriptionsEdge = {
  __typename?: 'RoomDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomDescription` at the end of the edge. */
  node: RoomDescription;
};

/** Methods to use when ordering `RoomDescription`. */
export enum RoomDescriptionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against `Room` object types. All fields are combined with a logical ‘and.’ */
export type RoomFilter = {
  /** Filter by the object’s `allocationRooms` relation. */
  allocationRooms?: InputMaybe<RoomToManyAllocationRoomFilter>;
  /** Some related `allocationRooms` exist. */
  allocationRoomsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `level` relation. */
  level?: InputMaybe<LevelFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomFilter>>;
  /** Filter by the object’s `projectAllocationRooms` relation. */
  projectAllocationRooms?: InputMaybe<RoomToManyProjectAllocationRoomFilter>;
  /** Some related `projectAllocationRooms` exist. */
  projectAllocationRoomsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomAirChangeRates` relation. */
  roomAirChangeRates?: InputMaybe<RoomToManyRoomAirChangeRateFilter>;
  /** Some related `roomAirChangeRates` exist. */
  roomAirChangeRatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomAirConditionings` relation. */
  roomAirConditionings?: InputMaybe<RoomToManyRoomAirConditioningFilter>;
  /** Some related `roomAirConditionings` exist. */
  roomAirConditioningsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadGrossSpaceMins` relation. */
  roomCadGrossSpaceMins?: InputMaybe<RoomToManyRoomCadGrossSpaceMinFilter>;
  /** Some related `roomCadGrossSpaceMins` exist. */
  roomCadGrossSpaceMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadHeightMaxes` relation. */
  roomCadHeightMaxes?: InputMaybe<RoomToManyRoomCadHeightMaxFilter>;
  /** Some related `roomCadHeightMaxes` exist. */
  roomCadHeightMaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadHeightMins` relation. */
  roomCadHeightMins?: InputMaybe<RoomToManyRoomCadHeightMinFilter>;
  /** Some related `roomCadHeightMins` exist. */
  roomCadHeightMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadLengthMaxes` relation. */
  roomCadLengthMaxes?: InputMaybe<RoomToManyRoomCadLengthMaxFilter>;
  /** Some related `roomCadLengthMaxes` exist. */
  roomCadLengthMaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadLengthMins` relation. */
  roomCadLengthMins?: InputMaybe<RoomToManyRoomCadLengthMinFilter>;
  /** Some related `roomCadLengthMins` exist. */
  roomCadLengthMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadWidthMaxes` relation. */
  roomCadWidthMaxes?: InputMaybe<RoomToManyRoomCadWidthMaxFilter>;
  /** Some related `roomCadWidthMaxes` exist. */
  roomCadWidthMaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCadWidthMins` relation. */
  roomCadWidthMins?: InputMaybe<RoomToManyRoomCadWidthMinFilter>;
  /** Some related `roomCadWidthMins` exist. */
  roomCadWidthMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCapacityCars` relation. */
  roomCapacityCars?: InputMaybe<RoomToManyRoomCapacityCarFilter>;
  /** Some related `roomCapacityCars` exist. */
  roomCapacityCarsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCapacityPaxes` relation. */
  roomCapacityPaxes?: InputMaybe<RoomToManyRoomCapacityPaxFilter>;
  /** Some related `roomCapacityPaxes` exist. */
  roomCapacityPaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCapacityTrucks` relation. */
  roomCapacityTrucks?: InputMaybe<RoomToManyRoomCapacityTruckFilter>;
  /** Some related `roomCapacityTrucks` exist. */
  roomCapacityTrucksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomCleaningGrossSpaces` relation. */
  roomCleaningGrossSpaces?: InputMaybe<RoomToManyRoomCleaningGrossSpaceFilter>;
  /** Some related `roomCleaningGrossSpaces` exist. */
  roomCleaningGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomClearanceConstructions` relation. */
  roomClearanceConstructions?: InputMaybe<RoomToManyRoomClearanceConstructionFilter>;
  /** Some related `roomClearanceConstructions` exist. */
  roomClearanceConstructionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomContactBookings` relation. */
  roomContactBookings?: InputMaybe<RoomToManyRoomContactBookingFilter>;
  /** Some related `roomContactBookings` exist. */
  roomContactBookingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomDaylights` relation. */
  roomDaylights?: InputMaybe<RoomToManyRoomDaylightFilter>;
  /** Some related `roomDaylights` exist. */
  roomDaylightsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomDescriptions` relation. */
  roomDescriptions?: InputMaybe<RoomToManyRoomDescriptionFilter>;
  /** Some related `roomDescriptions` exist. */
  roomDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomKeyIssuanceNotes` relation. */
  roomKeyIssuanceNotes?: InputMaybe<RoomToManyRoomKeyIssuanceNoteFilter>;
  /** Some related `roomKeyIssuanceNotes` exist. */
  roomKeyIssuanceNotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomKeyIssuances` relation. */
  roomKeyIssuances?: InputMaybe<RoomToManyRoomKeyIssuanceFilter>;
  /** Some related `roomKeyIssuances` exist. */
  roomKeyIssuancesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomLightShutters` relation. */
  roomLightShutters?: InputMaybe<RoomToManyRoomLightShutterFilter>;
  /** Some related `roomLightShutters` exist. */
  roomLightShuttersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomMaxLoadCeilings` relation. */
  roomMaxLoadCeilings?: InputMaybe<RoomToManyRoomMaxLoadCeilingFilter>;
  /** Some related `roomMaxLoadCeilings` exist. */
  roomMaxLoadCeilingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomMaxLoadFloors` relation. */
  roomMaxLoadFloors?: InputMaybe<RoomToManyRoomMaxLoadFloorFilter>;
  /** Some related `roomMaxLoadFloors` exist. */
  roomMaxLoadFloorsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameExtras` relation. */
  roomNameExtras?: InputMaybe<RoomToManyRoomNameExtraFilter>;
  /** Some related `roomNameExtras` exist. */
  roomNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameKeyCads` relation. */
  roomNameKeyCads?: InputMaybe<RoomToManyRoomNameKeyCadFilter>;
  /** Some related `roomNameKeyCads` exist. */
  roomNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameKeyCafms` relation. */
  roomNameKeyCafms?: InputMaybe<RoomToManyRoomNameKeyCafmFilter>;
  /** Some related `roomNameKeyCafms` exist. */
  roomNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameKeyEbms` relation. */
  roomNameKeyEbms?: InputMaybe<RoomToManyRoomNameKeyEbmFilter>;
  /** Some related `roomNameKeyEbms` exist. */
  roomNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameKeyMarketings` relation. */
  roomNameKeyMarketings?: InputMaybe<RoomToManyRoomNameKeyMarketingFilter>;
  /** Some related `roomNameKeyMarketings` exist. */
  roomNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameLongs` relation. */
  roomNameLongs?: InputMaybe<RoomToManyRoomNameLongFilter>;
  /** Some related `roomNameLongs` exist. */
  roomNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNameShorts` relation. */
  roomNameShorts?: InputMaybe<RoomToManyRoomNameShortFilter>;
  /** Some related `roomNameShorts` exist. */
  roomNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomNoVehicles` relation. */
  roomNoVehicles?: InputMaybe<RoomToManyRoomNoVehicleFilter>;
  /** Some related `roomNoVehicles` exist. */
  roomNoVehiclesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitions` relation. */
  roomPartitions?: InputMaybe<RoomToManyRoomPartitionFilter>;
  /** Some related `roomPartitions` exist. */
  roomPartitionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPhoneNumbers` relation. */
  roomPhoneNumbers?: InputMaybe<RoomToManyRoomPhoneNumberFilter>;
  /** Some related `roomPhoneNumbers` exist. */
  roomPhoneNumbersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPublicGrossSpaces` relation. */
  roomPublicGrossSpaces?: InputMaybe<RoomToManyRoomPublicGrossSpaceFilter>;
  /** Some related `roomPublicGrossSpaces` exist. */
  roomPublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomSbvGrossSpaces` relation. */
  roomSbvGrossSpaces?: InputMaybe<RoomToManyRoomSbvGrossSpaceFilter>;
  /** Some related `roomSbvGrossSpaces` exist. */
  roomSbvGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomTireLoadCars` relation. */
  roomTireLoadCars?: InputMaybe<RoomToManyRoomTireLoadCarFilter>;
  /** Some related `roomTireLoadCars` exist. */
  roomTireLoadCarsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomTireLoadForklifts` relation. */
  roomTireLoadForklifts?: InputMaybe<RoomToManyRoomTireLoadForkliftFilter>;
  /** Some related `roomTireLoadForklifts` exist. */
  roomTireLoadForkliftsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomTireLoadTrucks` relation. */
  roomTireLoadTrucks?: InputMaybe<RoomToManyRoomTireLoadTruckFilter>;
  /** Some related `roomTireLoadTrucks` exist. */
  roomTireLoadTrucksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomTypeAttrs` relation. */
  roomTypeAttrs?: InputMaybe<RoomToManyRoomTypeAttrFilter>;
  /** Some related `roomTypeAttrs` exist. */
  roomTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<RoomTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Room` */
export type RoomInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomKeyIssuance = {
  __typename?: 'RoomKeyIssuance';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomKeyIssuance`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomKeyIssuance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomKeyIssuanceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomKeyIssuance` object types. All fields are combined with a logical ‘and.’ */
export type RoomKeyIssuanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomKeyIssuanceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomKeyIssuanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomKeyIssuanceFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomKeyIssuance` */
export type RoomKeyIssuanceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type RoomKeyIssuanceNote = {
  __typename?: 'RoomKeyIssuanceNote';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomKeyIssuanceNote`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomKeyIssuanceNote` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomKeyIssuanceNoteCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomKeyIssuanceNote` object types. All fields are combined with a logical ‘and.’ */
export type RoomKeyIssuanceNoteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomKeyIssuanceNoteFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomKeyIssuanceNoteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomKeyIssuanceNoteFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomKeyIssuanceNote` */
export type RoomKeyIssuanceNoteInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomKeyIssuanceNote` to look up the row to update. */
export type RoomKeyIssuanceNoteOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomKeyIssuanceNotesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomKeyIssuanceNote` being updated. */
  patch: UpdateRoomKeyIssuanceNoteOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyPatch;
};

/** Represents an update to a `RoomKeyIssuanceNote`. Fields that are set will be updated. */
export type RoomKeyIssuanceNotePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomKeyIssuanceNote` to look up the row to connect. */
export type RoomKeyIssuanceNoteRoomKeyIssuanceNotesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomKeyIssuanceNote` to look up the row to delete. */
export type RoomKeyIssuanceNoteRoomKeyIssuanceNotesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomKeyIssuanceNote` values. */
export type RoomKeyIssuanceNotesConnection = {
  __typename?: 'RoomKeyIssuanceNotesConnection';
  /** A list of edges which contains the `RoomKeyIssuanceNote` and cursor to aid in pagination. */
  edges: Array<RoomKeyIssuanceNotesEdge>;
  /** A list of `RoomKeyIssuanceNote` objects. */
  nodes: Array<RoomKeyIssuanceNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomKeyIssuanceNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomKeyIssuanceNote` edge in the connection. */
export type RoomKeyIssuanceNotesEdge = {
  __typename?: 'RoomKeyIssuanceNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomKeyIssuanceNote` at the end of the edge. */
  node: RoomKeyIssuanceNote;
};

/** Methods to use when ordering `RoomKeyIssuanceNote`. */
export enum RoomKeyIssuanceNotesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomKeyIssuanceNoteInput` mutation. */
export type RoomKeyIssuanceNotesRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomKeyIssuanceNote` in the `RoomInput` mutation. */
export type RoomKeyIssuanceNotesRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomKeyIssuanceNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomKeyIssuanceNoteRoomKeyIssuanceNotesPkeyConnect>>;
  /** A `RoomKeyIssuanceNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomKeyIssuanceNotesRoomIdFkeyRoomKeyIssuanceNotesCreateInput>>;
  /** The primary key(s) for `roomKeyIssuanceNote` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomKeyIssuanceNoteRoomKeyIssuanceNotesPkeyDelete>>;
  /** Flag indicating whether all other `roomKeyIssuanceNote` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomKeyIssuanceNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomKeyIssuanceNoteOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomKeyIssuanceNotesPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomKeyIssuanceNotesRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomKeyIssuanceNote` to be created by this mutation. */
export type RoomKeyIssuanceNotesRoomIdFkeyRoomKeyIssuanceNotesCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomKeyIssuance` to look up the row to update. */
export type RoomKeyIssuanceOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomKeyIssuancePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomKeyIssuance` being updated. */
  patch: UpdateRoomKeyIssuanceOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyPatch;
};

/** Represents an update to a `RoomKeyIssuance`. Fields that are set will be updated. */
export type RoomKeyIssuancePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomKeyIssuanceInput` mutation. */
export type RoomKeyIssuanceRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomKeyIssuanceRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomKeyIssuance` in the `RoomInput` mutation. */
export type RoomKeyIssuanceRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomKeyIssuance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomKeyIssuanceRoomKeyIssuancePkeyConnect>>;
  /** A `RoomKeyIssuanceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomKeyIssuanceRoomIdFkeyRoomKeyIssuanceCreateInput>>;
  /** The primary key(s) for `roomKeyIssuance` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomKeyIssuanceRoomKeyIssuancePkeyDelete>>;
  /** Flag indicating whether all other `roomKeyIssuance` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomKeyIssuance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomKeyIssuanceOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomKeyIssuancePkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomKeyIssuanceRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomKeyIssuance` to be created by this mutation. */
export type RoomKeyIssuanceRoomIdFkeyRoomKeyIssuanceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomKeyIssuance` to look up the row to connect. */
export type RoomKeyIssuanceRoomKeyIssuancePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomKeyIssuance` to look up the row to delete. */
export type RoomKeyIssuanceRoomKeyIssuancePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomKeyIssuance` values. */
export type RoomKeyIssuancesConnection = {
  __typename?: 'RoomKeyIssuancesConnection';
  /** A list of edges which contains the `RoomKeyIssuance` and cursor to aid in pagination. */
  edges: Array<RoomKeyIssuancesEdge>;
  /** A list of `RoomKeyIssuance` objects. */
  nodes: Array<RoomKeyIssuance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomKeyIssuance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomKeyIssuance` edge in the connection. */
export type RoomKeyIssuancesEdge = {
  __typename?: 'RoomKeyIssuancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomKeyIssuance` at the end of the edge. */
  node: RoomKeyIssuance;
};

/** Methods to use when ordering `RoomKeyIssuance`. */
export enum RoomKeyIssuancesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `level` in the `RoomInput` mutation. */
export type RoomLevelIdFkeyInput = {
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByExtId?: InputMaybe<LevelLevelExtIdKeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectById?: InputMaybe<LevelLevelPkeyConnect>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<LevelLevelNameShortKeyConnect>;
  /** A `LevelInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomLevelIdFkeyLevelCreateInput>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<LevelLevelExtIdKeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteById?: InputMaybe<LevelLevelPkeyDelete>;
  /** The primary key(s) for `level` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<LevelLevelNameShortKeyDelete>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByExtId?: InputMaybe<LevelOnRoomForRoomLevelIdFkeyUsingLevelExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateById?: InputMaybe<LevelOnRoomForRoomLevelIdFkeyUsingLevelPkeyUpdate>;
  /** The primary key(s) and patch data for `level` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<LevelOnRoomForRoomLevelIdFkeyUsingLevelNameShortKeyUpdate>;
};

/** Input for the nested mutation of `room` in the `LevelInput` mutation. */
export type RoomLevelIdFkeyInverseInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<RoomRoomExtIdKeyConnect>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomRoomPkeyConnect>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<RoomRoomNameShortKeyConnect>>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomLevelIdFkeyRoomCreateInput>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<RoomRoomExtIdKeyDelete>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomRoomPkeyDelete>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<RoomRoomNameShortKeyDelete>>;
  /** Flag indicating whether all other `room` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<RoomOnRoomForRoomLevelIdFkeyUsingRoomExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomOnRoomForRoomLevelIdFkeyUsingRoomPkeyUpdate>>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<RoomOnRoomForRoomLevelIdFkeyUsingRoomNameShortKeyUpdate>>;
};

/** The `level` to be created by this mutation. */
export type RoomLevelIdFkeyLevelCreateInput = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `room` to be created by this mutation. */
export type RoomLevelIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomLightShutter = {
  __typename?: 'RoomLightShutter';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomLightShutter`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['Boolean']>;
};

/**
 * A condition to be used against `RoomLightShutter` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomLightShutterCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `RoomLightShutter` object types. All fields are combined with a logical ‘and.’ */
export type RoomLightShutterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomLightShutterFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomLightShutterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomLightShutterFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `RoomLightShutter` */
export type RoomLightShutterInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomLightShuttersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomLightShutter` to look up the row to update. */
export type RoomLightShutterOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomLightShuttersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomLightShutter` being updated. */
  patch: UpdateRoomLightShutterOnRoomLightShutterForRoomLightShuttersRoomIdFkeyPatch;
};

/** Represents an update to a `RoomLightShutter`. Fields that are set will be updated. */
export type RoomLightShutterPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomLightShuttersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomLightShutter` to look up the row to connect. */
export type RoomLightShutterRoomLightShuttersPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomLightShutter` to look up the row to delete. */
export type RoomLightShutterRoomLightShuttersPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomLightShutter` values. */
export type RoomLightShuttersConnection = {
  __typename?: 'RoomLightShuttersConnection';
  /** A list of edges which contains the `RoomLightShutter` and cursor to aid in pagination. */
  edges: Array<RoomLightShuttersEdge>;
  /** A list of `RoomLightShutter` objects. */
  nodes: Array<RoomLightShutter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomLightShutter` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomLightShutter` edge in the connection. */
export type RoomLightShuttersEdge = {
  __typename?: 'RoomLightShuttersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomLightShutter` at the end of the edge. */
  node: RoomLightShutter;
};

/** Methods to use when ordering `RoomLightShutter`. */
export enum RoomLightShuttersOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomLightShutterInput` mutation. */
export type RoomLightShuttersRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomLightShuttersRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomLightShutter` in the `RoomInput` mutation. */
export type RoomLightShuttersRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomLightShutter` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomLightShutterRoomLightShuttersPkeyConnect>>;
  /** A `RoomLightShutterInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomLightShuttersRoomIdFkeyRoomLightShuttersCreateInput>>;
  /** The primary key(s) for `roomLightShutter` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomLightShutterRoomLightShuttersPkeyDelete>>;
  /** Flag indicating whether all other `roomLightShutter` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomLightShutter` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomLightShutterOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomLightShuttersPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomLightShuttersRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomLightShutter` to be created by this mutation. */
export type RoomLightShuttersRoomIdFkeyRoomLightShuttersCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomLightShuttersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type RoomMaxLoadCeiling = {
  __typename?: 'RoomMaxLoadCeiling';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomMaxLoadCeiling`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomMaxLoadCeiling` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomMaxLoadCeilingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomMaxLoadCeiling` object types. All fields are combined with a logical ‘and.’ */
export type RoomMaxLoadCeilingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomMaxLoadCeilingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomMaxLoadCeilingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomMaxLoadCeilingFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomMaxLoadCeiling` */
export type RoomMaxLoadCeilingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomMaxLoadCeiling` to look up the row to update. */
export type RoomMaxLoadCeilingOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomMaxLoadCeilingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomMaxLoadCeiling` being updated. */
  patch: UpdateRoomMaxLoadCeilingOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyPatch;
};

/** Represents an update to a `RoomMaxLoadCeiling`. Fields that are set will be updated. */
export type RoomMaxLoadCeilingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomMaxLoadCeilingInput` mutation. */
export type RoomMaxLoadCeilingRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomMaxLoadCeiling` in the `RoomInput` mutation. */
export type RoomMaxLoadCeilingRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomMaxLoadCeiling` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomMaxLoadCeilingRoomMaxLoadCeilingPkeyConnect>>;
  /** A `RoomMaxLoadCeilingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomMaxLoadCeilingRoomIdFkeyRoomMaxLoadCeilingCreateInput>>;
  /** The primary key(s) for `roomMaxLoadCeiling` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomMaxLoadCeilingRoomMaxLoadCeilingPkeyDelete>>;
  /** Flag indicating whether all other `roomMaxLoadCeiling` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomMaxLoadCeiling` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomMaxLoadCeilingOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomMaxLoadCeilingPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomMaxLoadCeilingRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomMaxLoadCeiling` to be created by this mutation. */
export type RoomMaxLoadCeilingRoomIdFkeyRoomMaxLoadCeilingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomMaxLoadCeiling` to look up the row to connect. */
export type RoomMaxLoadCeilingRoomMaxLoadCeilingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomMaxLoadCeiling` to look up the row to delete. */
export type RoomMaxLoadCeilingRoomMaxLoadCeilingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomMaxLoadCeiling` values. */
export type RoomMaxLoadCeilingsConnection = {
  __typename?: 'RoomMaxLoadCeilingsConnection';
  /** A list of edges which contains the `RoomMaxLoadCeiling` and cursor to aid in pagination. */
  edges: Array<RoomMaxLoadCeilingsEdge>;
  /** A list of `RoomMaxLoadCeiling` objects. */
  nodes: Array<RoomMaxLoadCeiling>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomMaxLoadCeiling` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomMaxLoadCeiling` edge in the connection. */
export type RoomMaxLoadCeilingsEdge = {
  __typename?: 'RoomMaxLoadCeilingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomMaxLoadCeiling` at the end of the edge. */
  node: RoomMaxLoadCeiling;
};

/** Methods to use when ordering `RoomMaxLoadCeiling`. */
export enum RoomMaxLoadCeilingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomMaxLoadFloor = {
  __typename?: 'RoomMaxLoadFloor';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomMaxLoadFloor`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomMaxLoadFloor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomMaxLoadFloorCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomMaxLoadFloor` object types. All fields are combined with a logical ‘and.’ */
export type RoomMaxLoadFloorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomMaxLoadFloorFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomMaxLoadFloorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomMaxLoadFloorFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomMaxLoadFloor` */
export type RoomMaxLoadFloorInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomMaxLoadFloor` to look up the row to update. */
export type RoomMaxLoadFloorOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomMaxLoadFloorPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomMaxLoadFloor` being updated. */
  patch: UpdateRoomMaxLoadFloorOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyPatch;
};

/** Represents an update to a `RoomMaxLoadFloor`. Fields that are set will be updated. */
export type RoomMaxLoadFloorPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomMaxLoadFloorInput` mutation. */
export type RoomMaxLoadFloorRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomMaxLoadFloor` in the `RoomInput` mutation. */
export type RoomMaxLoadFloorRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomMaxLoadFloor` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomMaxLoadFloorRoomMaxLoadFloorPkeyConnect>>;
  /** A `RoomMaxLoadFloorInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomMaxLoadFloorRoomIdFkeyRoomMaxLoadFloorCreateInput>>;
  /** The primary key(s) for `roomMaxLoadFloor` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomMaxLoadFloorRoomMaxLoadFloorPkeyDelete>>;
  /** Flag indicating whether all other `roomMaxLoadFloor` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomMaxLoadFloor` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomMaxLoadFloorOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomMaxLoadFloorPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomMaxLoadFloorRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomMaxLoadFloor` to be created by this mutation. */
export type RoomMaxLoadFloorRoomIdFkeyRoomMaxLoadFloorCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomMaxLoadFloor` to look up the row to connect. */
export type RoomMaxLoadFloorRoomMaxLoadFloorPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomMaxLoadFloor` to look up the row to delete. */
export type RoomMaxLoadFloorRoomMaxLoadFloorPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomMaxLoadFloor` values. */
export type RoomMaxLoadFloorsConnection = {
  __typename?: 'RoomMaxLoadFloorsConnection';
  /** A list of edges which contains the `RoomMaxLoadFloor` and cursor to aid in pagination. */
  edges: Array<RoomMaxLoadFloorsEdge>;
  /** A list of `RoomMaxLoadFloor` objects. */
  nodes: Array<RoomMaxLoadFloor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomMaxLoadFloor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomMaxLoadFloor` edge in the connection. */
export type RoomMaxLoadFloorsEdge = {
  __typename?: 'RoomMaxLoadFloorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomMaxLoadFloor` at the end of the edge. */
  node: RoomMaxLoadFloor;
};

/** Methods to use when ordering `RoomMaxLoadFloor`. */
export enum RoomMaxLoadFloorsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNameExtra = {
  __typename?: 'RoomNameExtra';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameExtra`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNameExtraCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameExtraFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameExtraFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameExtra` */
export type RoomNameExtraInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameExtraRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameExtra` to look up the row to update. */
export type RoomNameExtraOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameExtra` being updated. */
  patch: UpdateRoomNameExtraOnRoomNameExtraForRoomNameExtraRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameExtra`. Fields that are set will be updated. */
export type RoomNameExtraPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameExtraRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomNameExtraInput` mutation. */
export type RoomNameExtraRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameExtraRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameExtra` in the `RoomInput` mutation. */
export type RoomNameExtraRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameExtraRoomNameExtraPkeyConnect>>;
  /** A `RoomNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameExtraRoomIdFkeyRoomNameExtraCreateInput>>;
  /** The primary key(s) for `roomNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameExtraRoomNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `roomNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameExtraOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomNameExtraPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameExtraRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameExtra` to be created by this mutation. */
export type RoomNameExtraRoomIdFkeyRoomNameExtraCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameExtraRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameExtra` to look up the row to connect. */
export type RoomNameExtraRoomNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameExtra` to look up the row to delete. */
export type RoomNameExtraRoomNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameExtra` values. */
export type RoomNameExtrasConnection = {
  __typename?: 'RoomNameExtrasConnection';
  /** A list of edges which contains the `RoomNameExtra` and cursor to aid in pagination. */
  edges: Array<RoomNameExtrasEdge>;
  /** A list of `RoomNameExtra` objects. */
  nodes: Array<RoomNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameExtra` edge in the connection. */
export type RoomNameExtrasEdge = {
  __typename?: 'RoomNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameExtra` at the end of the edge. */
  node: RoomNameExtra;
};

/** Methods to use when ordering `RoomNameExtra`. */
export enum RoomNameExtrasOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNameKeyCad = {
  __typename?: 'RoomNameKeyCad';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameKeyCad`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNameKeyCadCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameKeyCadFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameKeyCadFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameKeyCad` */
export type RoomNameKeyCadInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyCad` to look up the row to update. */
export type RoomNameKeyCadOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameKeyCad` being updated. */
  patch: UpdateRoomNameKeyCadOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameKeyCad`. Fields that are set will be updated. */
export type RoomNameKeyCadPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomNameKeyCadInput` mutation. */
export type RoomNameKeyCadRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameKeyCadRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameKeyCad` in the `RoomInput` mutation. */
export type RoomNameKeyCadRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameKeyCadRoomNameKeyCadPkeyConnect>>;
  /** A `RoomNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameKeyCadRoomIdFkeyRoomNameKeyCadCreateInput>>;
  /** The primary key(s) for `roomNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameKeyCadRoomNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `roomNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameKeyCadOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomNameKeyCadPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameKeyCadRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameKeyCad` to be created by this mutation. */
export type RoomNameKeyCadRoomIdFkeyRoomNameKeyCadCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyCad` to look up the row to connect. */
export type RoomNameKeyCadRoomNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameKeyCad` to look up the row to delete. */
export type RoomNameKeyCadRoomNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameKeyCad` values. */
export type RoomNameKeyCadsConnection = {
  __typename?: 'RoomNameKeyCadsConnection';
  /** A list of edges which contains the `RoomNameKeyCad` and cursor to aid in pagination. */
  edges: Array<RoomNameKeyCadsEdge>;
  /** A list of `RoomNameKeyCad` objects. */
  nodes: Array<RoomNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameKeyCad` edge in the connection. */
export type RoomNameKeyCadsEdge = {
  __typename?: 'RoomNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameKeyCad` at the end of the edge. */
  node: RoomNameKeyCad;
};

/** Methods to use when ordering `RoomNameKeyCad`. */
export enum RoomNameKeyCadsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNameKeyCafm = {
  __typename?: 'RoomNameKeyCafm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameKeyCafm`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameKeyCafm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNameKeyCafmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameKeyCafmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameKeyCafmFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameKeyCafm` */
export type RoomNameKeyCafmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyCafm` to look up the row to update. */
export type RoomNameKeyCafmOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameKeyCafm` being updated. */
  patch: UpdateRoomNameKeyCafmOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameKeyCafm`. Fields that are set will be updated. */
export type RoomNameKeyCafmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomNameKeyCafmInput` mutation. */
export type RoomNameKeyCafmRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameKeyCafmRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameKeyCafm` in the `RoomInput` mutation. */
export type RoomNameKeyCafmRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameKeyCafmRoomNameKeyCafmPkeyConnect>>;
  /** A `RoomNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameKeyCafmRoomIdFkeyRoomNameKeyCafmCreateInput>>;
  /** The primary key(s) for `roomNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameKeyCafmRoomNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `roomNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameKeyCafmOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomNameKeyCafmPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameKeyCafmRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameKeyCafm` to be created by this mutation. */
export type RoomNameKeyCafmRoomIdFkeyRoomNameKeyCafmCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyCafm` to look up the row to connect. */
export type RoomNameKeyCafmRoomNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameKeyCafm` to look up the row to delete. */
export type RoomNameKeyCafmRoomNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameKeyCafm` values. */
export type RoomNameKeyCafmsConnection = {
  __typename?: 'RoomNameKeyCafmsConnection';
  /** A list of edges which contains the `RoomNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<RoomNameKeyCafmsEdge>;
  /** A list of `RoomNameKeyCafm` objects. */
  nodes: Array<RoomNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameKeyCafm` edge in the connection. */
export type RoomNameKeyCafmsEdge = {
  __typename?: 'RoomNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameKeyCafm` at the end of the edge. */
  node: RoomNameKeyCafm;
};

/** Methods to use when ordering `RoomNameKeyCafm`. */
export enum RoomNameKeyCafmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNameKeyEbm = {
  __typename?: 'RoomNameKeyEbm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameKeyEbm`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNameKeyEbmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameKeyEbmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameKeyEbmFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameKeyEbm` */
export type RoomNameKeyEbmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyEbm` to look up the row to update. */
export type RoomNameKeyEbmOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameKeyEbm` being updated. */
  patch: UpdateRoomNameKeyEbmOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameKeyEbm`. Fields that are set will be updated. */
export type RoomNameKeyEbmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomNameKeyEbm` to look up the row to connect. */
export type RoomNameKeyEbmRoomNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameKeyEbm` to look up the row to delete. */
export type RoomNameKeyEbmRoomNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameKeyEbm` values. */
export type RoomNameKeyEbmsConnection = {
  __typename?: 'RoomNameKeyEbmsConnection';
  /** A list of edges which contains the `RoomNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<RoomNameKeyEbmsEdge>;
  /** A list of `RoomNameKeyEbm` objects. */
  nodes: Array<RoomNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameKeyEbm` edge in the connection. */
export type RoomNameKeyEbmsEdge = {
  __typename?: 'RoomNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameKeyEbm` at the end of the edge. */
  node: RoomNameKeyEbm;
};

/** Methods to use when ordering `RoomNameKeyEbm`. */
export enum RoomNameKeyEbmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomNameKeyEbmInput` mutation. */
export type RoomNameKeyEbmsRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameKeyEbm` in the `RoomInput` mutation. */
export type RoomNameKeyEbmsRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameKeyEbmRoomNameKeyEbmsPkeyConnect>>;
  /** A `RoomNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameKeyEbmsRoomIdFkeyRoomNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `roomNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameKeyEbmRoomNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `roomNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameKeyEbmOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomNameKeyEbmsPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameKeyEbmsRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameKeyEbm` to be created by this mutation. */
export type RoomNameKeyEbmsRoomIdFkeyRoomNameKeyEbmsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type RoomNameKeyMarketing = {
  __typename?: 'RoomNameKeyMarketing';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameKeyMarketing`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameKeyMarketing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameKeyMarketingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameKeyMarketingFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameKeyMarketing` */
export type RoomNameKeyMarketingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyMarketing` to look up the row to update. */
export type RoomNameKeyMarketingOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameKeyMarketing` being updated. */
  patch: UpdateRoomNameKeyMarketingOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameKeyMarketing`. Fields that are set will be updated. */
export type RoomNameKeyMarketingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomNameKeyMarketingInput` mutation. */
export type RoomNameKeyMarketingRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameKeyMarketing` in the `RoomInput` mutation. */
export type RoomNameKeyMarketingRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameKeyMarketingRoomNameKeyMarketingPkeyConnect>>;
  /** A `RoomNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameKeyMarketingRoomIdFkeyRoomNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `roomNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameKeyMarketingRoomNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `roomNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameKeyMarketingOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomNameKeyMarketingPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameKeyMarketingRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameKeyMarketing` to be created by this mutation. */
export type RoomNameKeyMarketingRoomIdFkeyRoomNameKeyMarketingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameKeyMarketing` to look up the row to connect. */
export type RoomNameKeyMarketingRoomNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameKeyMarketing` to look up the row to delete. */
export type RoomNameKeyMarketingRoomNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameKeyMarketing` values. */
export type RoomNameKeyMarketingsConnection = {
  __typename?: 'RoomNameKeyMarketingsConnection';
  /** A list of edges which contains the `RoomNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<RoomNameKeyMarketingsEdge>;
  /** A list of `RoomNameKeyMarketing` objects. */
  nodes: Array<RoomNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameKeyMarketing` edge in the connection. */
export type RoomNameKeyMarketingsEdge = {
  __typename?: 'RoomNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameKeyMarketing` at the end of the edge. */
  node: RoomNameKeyMarketing;
};

/** Methods to use when ordering `RoomNameKeyMarketing`. */
export enum RoomNameKeyMarketingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNameLong = {
  __typename?: 'RoomNameLong';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameLong`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNameLongCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameLong` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameLongFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameLongFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameLong` */
export type RoomNameLongInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameLongRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameLong` to look up the row to update. */
export type RoomNameLongOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameLong` being updated. */
  patch: UpdateRoomNameLongOnRoomNameLongForRoomNameLongRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameLong`. Fields that are set will be updated. */
export type RoomNameLongPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameLongRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomNameLongInput` mutation. */
export type RoomNameLongRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameLongRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameLong` in the `RoomInput` mutation. */
export type RoomNameLongRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameLongRoomNameLongPkeyConnect>>;
  /** A `RoomNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameLongRoomIdFkeyRoomNameLongCreateInput>>;
  /** The primary key(s) for `roomNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameLongRoomNameLongPkeyDelete>>;
  /** Flag indicating whether all other `roomNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameLongOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomNameLongPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameLongRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameLong` to be created by this mutation. */
export type RoomNameLongRoomIdFkeyRoomNameLongCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameLongRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameLong` to look up the row to connect. */
export type RoomNameLongRoomNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameLong` to look up the row to delete. */
export type RoomNameLongRoomNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameLong` values. */
export type RoomNameLongsConnection = {
  __typename?: 'RoomNameLongsConnection';
  /** A list of edges which contains the `RoomNameLong` and cursor to aid in pagination. */
  edges: Array<RoomNameLongsEdge>;
  /** A list of `RoomNameLong` objects. */
  nodes: Array<RoomNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameLong` edge in the connection. */
export type RoomNameLongsEdge = {
  __typename?: 'RoomNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameLong` at the end of the edge. */
  node: RoomNameLong;
};

/** Methods to use when ordering `RoomNameLong`. */
export enum RoomNameLongsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNameShort = {
  __typename?: 'RoomNameShort';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNameShort`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNameShortCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomNameShort` object types. All fields are combined with a logical ‘and.’ */
export type RoomNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNameShortFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNameShortFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomNameShort` */
export type RoomNameShortInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameShortRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameShort` to look up the row to update. */
export type RoomNameShortOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNameShort` being updated. */
  patch: UpdateRoomNameShortOnRoomNameShortForRoomNameShortRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNameShort`. Fields that are set will be updated. */
export type RoomNameShortPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameShortRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `room` in the `RoomNameShortInput` mutation. */
export type RoomNameShortRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNameShortRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNameShort` in the `RoomInput` mutation. */
export type RoomNameShortRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNameShortRoomNameShortPkeyConnect>>;
  /** A `RoomNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNameShortRoomIdFkeyRoomNameShortCreateInput>>;
  /** The primary key(s) for `roomNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNameShortRoomNameShortPkeyDelete>>;
  /** Flag indicating whether all other `roomNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNameShortOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomNameShortPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNameShortRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNameShort` to be created by this mutation. */
export type RoomNameShortRoomIdFkeyRoomNameShortCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameShortRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomNameShort` to look up the row to connect. */
export type RoomNameShortRoomNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNameShort` to look up the row to delete. */
export type RoomNameShortRoomNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNameShort` values. */
export type RoomNameShortsConnection = {
  __typename?: 'RoomNameShortsConnection';
  /** A list of edges which contains the `RoomNameShort` and cursor to aid in pagination. */
  edges: Array<RoomNameShortsEdge>;
  /** A list of `RoomNameShort` objects. */
  nodes: Array<RoomNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNameShort` edge in the connection. */
export type RoomNameShortsEdge = {
  __typename?: 'RoomNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNameShort` at the end of the edge. */
  node: RoomNameShort;
};

/** Methods to use when ordering `RoomNameShort`. */
export enum RoomNameShortsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomNoVehicle = {
  __typename?: 'RoomNoVehicle';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomNoVehicle`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['Boolean']>;
};

/**
 * A condition to be used against `RoomNoVehicle` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomNoVehicleCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `RoomNoVehicle` object types. All fields are combined with a logical ‘and.’ */
export type RoomNoVehicleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomNoVehicleFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomNoVehicleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomNoVehicleFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `RoomNoVehicle` */
export type RoomNoVehicleInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomNoVehicle` to look up the row to update. */
export type RoomNoVehicleOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomNoVehiclesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomNoVehicle` being updated. */
  patch: UpdateRoomNoVehicleOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyPatch;
};

/** Represents an update to a `RoomNoVehicle`. Fields that are set will be updated. */
export type RoomNoVehiclePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `roomNoVehicle` to look up the row to connect. */
export type RoomNoVehicleRoomNoVehiclesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomNoVehicle` to look up the row to delete. */
export type RoomNoVehicleRoomNoVehiclesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomNoVehicle` values. */
export type RoomNoVehiclesConnection = {
  __typename?: 'RoomNoVehiclesConnection';
  /** A list of edges which contains the `RoomNoVehicle` and cursor to aid in pagination. */
  edges: Array<RoomNoVehiclesEdge>;
  /** A list of `RoomNoVehicle` objects. */
  nodes: Array<RoomNoVehicle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomNoVehicle` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomNoVehicle` edge in the connection. */
export type RoomNoVehiclesEdge = {
  __typename?: 'RoomNoVehiclesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomNoVehicle` at the end of the edge. */
  node: RoomNoVehicle;
};

/** Methods to use when ordering `RoomNoVehicle`. */
export enum RoomNoVehiclesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomNoVehicleInput` mutation. */
export type RoomNoVehiclesRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomNoVehiclesRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomNoVehicle` in the `RoomInput` mutation. */
export type RoomNoVehiclesRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomNoVehicle` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomNoVehicleRoomNoVehiclesPkeyConnect>>;
  /** A `RoomNoVehicleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomNoVehiclesRoomIdFkeyRoomNoVehiclesCreateInput>>;
  /** The primary key(s) for `roomNoVehicle` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomNoVehicleRoomNoVehiclesPkeyDelete>>;
  /** Flag indicating whether all other `roomNoVehicle` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomNoVehicle` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomNoVehicleOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomNoVehiclesPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomNoVehiclesRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomNoVehicle` to be created by this mutation. */
export type RoomNoVehiclesRoomIdFkeyRoomNoVehiclesCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnAllocationRoomForAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnAllocationRoomForAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnAllocationRoomForAllocationRoomRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnAllocationRoomForAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomDaylightForRoomDaylightRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomDaylightForRoomDaylightRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomDaylightForRoomDaylightRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomDaylightForRoomDaylightRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomForRoomLevelIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomForRoomLevelIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomForRoomLevelIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomForRoomLevelIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomForRoomLevelIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomForRoomLevelIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomForRoomTypeIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomForRoomTypeIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomForRoomTypeIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomForRoomTypeIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomForRoomTypeIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomForRoomTypeIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameLongForRoomNameLongRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameLongForRoomNameLongRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameLongForRoomNameLongRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameLongForRoomNameLongRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameShortForRoomNameShortRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameShortForRoomNameShortRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNameShortForRoomNameShortRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNameShortForRoomNameShortRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPartitionForRoomPartitionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPartitionForRoomPartitionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPartitionForRoomPartitionRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyPatch;
};

/** The fields on `room` to look up the row to update. */
export type RoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `room` being updated. */
  patch: UpdateRoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyPatch;
};

export type RoomPartition = {
  __typename?: 'RoomPartition';
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `Room` that is related to this `RoomPartition`. */
  room: Room;
  roomId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `RoomPartitionCadGrossSpaceMin`. */
  roomPartitionCadGrossSpaceMins: RoomPartitionCadGrossSpaceMinsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCadHeightMax`. */
  roomPartitionCadHeightMaxes: RoomPartitionCadHeightMaxesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCadHeightMin`. */
  roomPartitionCadHeightMins: RoomPartitionCadHeightMinsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCadLengthMax`. */
  roomPartitionCadLengthMaxes: RoomPartitionCadLengthMaxesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCadLengthMin`. */
  roomPartitionCadLengthMins: RoomPartitionCadLengthMinsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCadWidthMax`. */
  roomPartitionCadWidthMaxes: RoomPartitionCadWidthMaxesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCadWidthMin`. */
  roomPartitionCadWidthMins: RoomPartitionCadWidthMinsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCapacityPax`. */
  roomPartitionCapacityPaxes: RoomPartitionCapacityPaxesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionCleaningGrossSpace`. */
  roomPartitionCleaningGrossSpaces: RoomPartitionCleaningGrossSpacesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionDescription`. */
  roomPartitionDescriptions: RoomPartitionDescriptionsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameExtra`. */
  roomPartitionNameExtras: RoomPartitionNameExtrasConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyCad`. */
  roomPartitionNameKeyCads: RoomPartitionNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyCafm`. */
  roomPartitionNameKeyCafms: RoomPartitionNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyEbm`. */
  roomPartitionNameKeyEbms: RoomPartitionNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameKeyMarketing`. */
  roomPartitionNameKeyMarketings: RoomPartitionNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameLong`. */
  roomPartitionNameLongs: RoomPartitionNameLongsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionNameShort`. */
  roomPartitionNameShorts: RoomPartitionNameShortsConnection;
  /** Reads and enables pagination through a set of `RoomPartitionPublicGrossSpace`. */
  roomPartitionPublicGrossSpaces: RoomPartitionPublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionSbvGrossSpace`. */
  roomPartitionSbvGrossSpaces: RoomPartitionSbvGrossSpacesConnection;
  /** Reads and enables pagination through a set of `RoomPartitionTypeAttr`. */
  roomPartitionTypeAttrs: RoomPartitionTypeAttrsConnection;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartition`. */
  type?: Maybe<RoomPartitionType>;
  typeId?: Maybe<Scalars['UUID']>;
};


export type RoomPartitionRoomPartitionCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadGrossSpaceMinCondition>;
  filter?: InputMaybe<RoomPartitionCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinsOrderBy>>;
};


export type RoomPartitionRoomPartitionCadHeightMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadHeightMaxCondition>;
  filter?: InputMaybe<RoomPartitionCadHeightMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMaxesOrderBy>>;
};


export type RoomPartitionRoomPartitionCadHeightMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadHeightMinCondition>;
  filter?: InputMaybe<RoomPartitionCadHeightMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMinsOrderBy>>;
};


export type RoomPartitionRoomPartitionCadLengthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadLengthMaxCondition>;
  filter?: InputMaybe<RoomPartitionCadLengthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMaxesOrderBy>>;
};


export type RoomPartitionRoomPartitionCadLengthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadLengthMinCondition>;
  filter?: InputMaybe<RoomPartitionCadLengthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMinsOrderBy>>;
};


export type RoomPartitionRoomPartitionCadWidthMaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadWidthMaxCondition>;
  filter?: InputMaybe<RoomPartitionCadWidthMaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMaxesOrderBy>>;
};


export type RoomPartitionRoomPartitionCadWidthMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCadWidthMinCondition>;
  filter?: InputMaybe<RoomPartitionCadWidthMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMinsOrderBy>>;
};


export type RoomPartitionRoomPartitionCapacityPaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCapacityPaxCondition>;
  filter?: InputMaybe<RoomPartitionCapacityPaxFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCapacityPaxesOrderBy>>;
};


export type RoomPartitionRoomPartitionCleaningGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCleaningGrossSpaceCondition>;
  filter?: InputMaybe<RoomPartitionCleaningGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionCleaningGrossSpacesOrderBy>>;
};


export type RoomPartitionRoomPartitionDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionDescriptionCondition>;
  filter?: InputMaybe<RoomPartitionDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionDescriptionsOrderBy>>;
};


export type RoomPartitionRoomPartitionNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameExtraCondition>;
  filter?: InputMaybe<RoomPartitionNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameExtrasOrderBy>>;
};


export type RoomPartitionRoomPartitionNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyCadCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCadsOrderBy>>;
};


export type RoomPartitionRoomPartitionNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyCafmCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCafmsOrderBy>>;
};


export type RoomPartitionRoomPartitionNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyEbmCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyEbmsOrderBy>>;
};


export type RoomPartitionRoomPartitionNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameKeyMarketingCondition>;
  filter?: InputMaybe<RoomPartitionNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyMarketingsOrderBy>>;
};


export type RoomPartitionRoomPartitionNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameLongCondition>;
  filter?: InputMaybe<RoomPartitionNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameLongsOrderBy>>;
};


export type RoomPartitionRoomPartitionNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionNameShortCondition>;
  filter?: InputMaybe<RoomPartitionNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionNameShortsOrderBy>>;
};


export type RoomPartitionRoomPartitionPublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionPublicGrossSpaceCondition>;
  filter?: InputMaybe<RoomPartitionPublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionPublicGrossSpacesOrderBy>>;
};


export type RoomPartitionRoomPartitionSbvGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionSbvGrossSpaceCondition>;
  filter?: InputMaybe<RoomPartitionSbvGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionSbvGrossSpacesOrderBy>>;
};


export type RoomPartitionRoomPartitionTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionTypeAttrCondition>;
  filter?: InputMaybe<RoomPartitionTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionTypeAttrsOrderBy>>;
};

export type RoomPartitionCadGrossSpaceMin = {
  __typename?: 'RoomPartitionCadGrossSpaceMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadGrossSpaceMin`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadGrossSpaceMin` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadGrossSpaceMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadGrossSpaceMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadGrossSpaceMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadGrossSpaceMin` */
export type RoomPartitionCadGrossSpaceMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadGrossSpaceMin` to look up the row to update. */
export type RoomPartitionCadGrossSpaceMinOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionCadGrossSpaceMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadGrossSpaceMin` being updated. */
  patch: UpdateRoomPartitionCadGrossSpaceMinOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadGrossSpaceMin`. Fields that are set will be updated. */
export type RoomPartitionCadGrossSpaceMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadGrossSpaceMin` to look up the row to connect. */
export type RoomPartitionCadGrossSpaceMinRoomPartitionCadGrossSpaceMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadGrossSpaceMin` to look up the row to delete. */
export type RoomPartitionCadGrossSpaceMinRoomPartitionCadGrossSpaceMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadGrossSpaceMinInput` mutation. */
export type RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadGrossSpaceMin` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadGrossSpaceMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinRoomPartitionCadGrossSpaceMinPkeyConnect>>;
  /** A `RoomPartitionCadGrossSpaceMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyRoomPartitionCadGrossSpaceMinCreateInput>>;
  /** The primary key(s) for `roomPartitionCadGrossSpaceMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinRoomPartitionCadGrossSpaceMinPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadGrossSpaceMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadGrossSpaceMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionCadGrossSpaceMinPkeyUpdate>>;
};

/** The `roomPartitionCadGrossSpaceMin` to be created by this mutation. */
export type RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyRoomPartitionCadGrossSpaceMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadGrossSpaceMin` values. */
export type RoomPartitionCadGrossSpaceMinsConnection = {
  __typename?: 'RoomPartitionCadGrossSpaceMinsConnection';
  /** A list of edges which contains the `RoomPartitionCadGrossSpaceMin` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadGrossSpaceMinsEdge>;
  /** A list of `RoomPartitionCadGrossSpaceMin` objects. */
  nodes: Array<RoomPartitionCadGrossSpaceMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadGrossSpaceMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadGrossSpaceMin` edge in the connection. */
export type RoomPartitionCadGrossSpaceMinsEdge = {
  __typename?: 'RoomPartitionCadGrossSpaceMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadGrossSpaceMin` at the end of the edge. */
  node: RoomPartitionCadGrossSpaceMin;
};

/** Methods to use when ordering `RoomPartitionCadGrossSpaceMin`. */
export enum RoomPartitionCadGrossSpaceMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCadHeightMax = {
  __typename?: 'RoomPartitionCadHeightMax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMax`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadHeightMax` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadHeightMaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadHeightMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadHeightMaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadHeightMaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadHeightMaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadHeightMaxFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadHeightMax` */
export type RoomPartitionCadHeightMaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadHeightMax` to look up the row to update. */
export type RoomPartitionCadHeightMaxOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionCadHeightMaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadHeightMax` being updated. */
  patch: UpdateRoomPartitionCadHeightMaxOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadHeightMax`. Fields that are set will be updated. */
export type RoomPartitionCadHeightMaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadHeightMax` to look up the row to connect. */
export type RoomPartitionCadHeightMaxRoomPartitionCadHeightMaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadHeightMax` to look up the row to delete. */
export type RoomPartitionCadHeightMaxRoomPartitionCadHeightMaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadHeightMaxInput` mutation. */
export type RoomPartitionCadHeightMaxRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadHeightMax` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadHeightMax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadHeightMaxRoomPartitionCadHeightMaxPkeyConnect>>;
  /** A `RoomPartitionCadHeightMaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadHeightMaxRoomPartitionIdFkeyRoomPartitionCadHeightMaxCreateInput>>;
  /** The primary key(s) for `roomPartitionCadHeightMax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadHeightMaxRoomPartitionCadHeightMaxPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadHeightMax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadHeightMax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadHeightMaxOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionCadHeightMaxPkeyUpdate>>;
};

/** The `roomPartitionCadHeightMax` to be created by this mutation. */
export type RoomPartitionCadHeightMaxRoomPartitionIdFkeyRoomPartitionCadHeightMaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadHeightMaxRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadHeightMax` values. */
export type RoomPartitionCadHeightMaxesConnection = {
  __typename?: 'RoomPartitionCadHeightMaxesConnection';
  /** A list of edges which contains the `RoomPartitionCadHeightMax` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadHeightMaxesEdge>;
  /** A list of `RoomPartitionCadHeightMax` objects. */
  nodes: Array<RoomPartitionCadHeightMax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadHeightMax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadHeightMax` edge in the connection. */
export type RoomPartitionCadHeightMaxesEdge = {
  __typename?: 'RoomPartitionCadHeightMaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadHeightMax` at the end of the edge. */
  node: RoomPartitionCadHeightMax;
};

/** Methods to use when ordering `RoomPartitionCadHeightMax`. */
export enum RoomPartitionCadHeightMaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCadHeightMin = {
  __typename?: 'RoomPartitionCadHeightMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMin`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadHeightMin` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadHeightMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadHeightMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadHeightMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadHeightMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadHeightMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadHeightMinFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadHeightMin` */
export type RoomPartitionCadHeightMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadHeightMin` to look up the row to update. */
export type RoomPartitionCadHeightMinOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionCadHeightMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadHeightMin` being updated. */
  patch: UpdateRoomPartitionCadHeightMinOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadHeightMin`. Fields that are set will be updated. */
export type RoomPartitionCadHeightMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadHeightMin` to look up the row to connect. */
export type RoomPartitionCadHeightMinRoomPartitionCadHeightMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadHeightMin` to look up the row to delete. */
export type RoomPartitionCadHeightMinRoomPartitionCadHeightMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadHeightMinInput` mutation. */
export type RoomPartitionCadHeightMinRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadHeightMin` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadHeightMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadHeightMinRoomPartitionCadHeightMinPkeyConnect>>;
  /** A `RoomPartitionCadHeightMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadHeightMinRoomPartitionIdFkeyRoomPartitionCadHeightMinCreateInput>>;
  /** The primary key(s) for `roomPartitionCadHeightMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadHeightMinRoomPartitionCadHeightMinPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadHeightMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadHeightMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadHeightMinOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionCadHeightMinPkeyUpdate>>;
};

/** The `roomPartitionCadHeightMin` to be created by this mutation. */
export type RoomPartitionCadHeightMinRoomPartitionIdFkeyRoomPartitionCadHeightMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadHeightMinRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadHeightMin` values. */
export type RoomPartitionCadHeightMinsConnection = {
  __typename?: 'RoomPartitionCadHeightMinsConnection';
  /** A list of edges which contains the `RoomPartitionCadHeightMin` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadHeightMinsEdge>;
  /** A list of `RoomPartitionCadHeightMin` objects. */
  nodes: Array<RoomPartitionCadHeightMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadHeightMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadHeightMin` edge in the connection. */
export type RoomPartitionCadHeightMinsEdge = {
  __typename?: 'RoomPartitionCadHeightMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadHeightMin` at the end of the edge. */
  node: RoomPartitionCadHeightMin;
};

/** Methods to use when ordering `RoomPartitionCadHeightMin`. */
export enum RoomPartitionCadHeightMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCadLengthMax = {
  __typename?: 'RoomPartitionCadLengthMax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMax`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadLengthMax` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadLengthMaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadLengthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadLengthMaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadLengthMaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadLengthMaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadLengthMaxFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadLengthMax` */
export type RoomPartitionCadLengthMaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadLengthMax` to look up the row to update. */
export type RoomPartitionCadLengthMaxOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionCadLengthMaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadLengthMax` being updated. */
  patch: UpdateRoomPartitionCadLengthMaxOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadLengthMax`. Fields that are set will be updated. */
export type RoomPartitionCadLengthMaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadLengthMax` to look up the row to connect. */
export type RoomPartitionCadLengthMaxRoomPartitionCadLengthMaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadLengthMax` to look up the row to delete. */
export type RoomPartitionCadLengthMaxRoomPartitionCadLengthMaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadLengthMaxInput` mutation. */
export type RoomPartitionCadLengthMaxRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadLengthMax` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadLengthMax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadLengthMaxRoomPartitionCadLengthMaxPkeyConnect>>;
  /** A `RoomPartitionCadLengthMaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadLengthMaxRoomPartitionIdFkeyRoomPartitionCadLengthMaxCreateInput>>;
  /** The primary key(s) for `roomPartitionCadLengthMax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadLengthMaxRoomPartitionCadLengthMaxPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadLengthMax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadLengthMax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadLengthMaxOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionCadLengthMaxPkeyUpdate>>;
};

/** The `roomPartitionCadLengthMax` to be created by this mutation. */
export type RoomPartitionCadLengthMaxRoomPartitionIdFkeyRoomPartitionCadLengthMaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadLengthMaxRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadLengthMax` values. */
export type RoomPartitionCadLengthMaxesConnection = {
  __typename?: 'RoomPartitionCadLengthMaxesConnection';
  /** A list of edges which contains the `RoomPartitionCadLengthMax` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadLengthMaxesEdge>;
  /** A list of `RoomPartitionCadLengthMax` objects. */
  nodes: Array<RoomPartitionCadLengthMax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadLengthMax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadLengthMax` edge in the connection. */
export type RoomPartitionCadLengthMaxesEdge = {
  __typename?: 'RoomPartitionCadLengthMaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadLengthMax` at the end of the edge. */
  node: RoomPartitionCadLengthMax;
};

/** Methods to use when ordering `RoomPartitionCadLengthMax`. */
export enum RoomPartitionCadLengthMaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCadLengthMin = {
  __typename?: 'RoomPartitionCadLengthMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMin`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadLengthMin` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadLengthMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadLengthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadLengthMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadLengthMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadLengthMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadLengthMinFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadLengthMin` */
export type RoomPartitionCadLengthMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadLengthMin` to look up the row to update. */
export type RoomPartitionCadLengthMinOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionCadLengthMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadLengthMin` being updated. */
  patch: UpdateRoomPartitionCadLengthMinOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadLengthMin`. Fields that are set will be updated. */
export type RoomPartitionCadLengthMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadLengthMin` to look up the row to connect. */
export type RoomPartitionCadLengthMinRoomPartitionCadLengthMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadLengthMin` to look up the row to delete. */
export type RoomPartitionCadLengthMinRoomPartitionCadLengthMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadLengthMinInput` mutation. */
export type RoomPartitionCadLengthMinRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadLengthMin` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadLengthMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadLengthMinRoomPartitionCadLengthMinPkeyConnect>>;
  /** A `RoomPartitionCadLengthMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadLengthMinRoomPartitionIdFkeyRoomPartitionCadLengthMinCreateInput>>;
  /** The primary key(s) for `roomPartitionCadLengthMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadLengthMinRoomPartitionCadLengthMinPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadLengthMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadLengthMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadLengthMinOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionCadLengthMinPkeyUpdate>>;
};

/** The `roomPartitionCadLengthMin` to be created by this mutation. */
export type RoomPartitionCadLengthMinRoomPartitionIdFkeyRoomPartitionCadLengthMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadLengthMinRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadLengthMin` values. */
export type RoomPartitionCadLengthMinsConnection = {
  __typename?: 'RoomPartitionCadLengthMinsConnection';
  /** A list of edges which contains the `RoomPartitionCadLengthMin` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadLengthMinsEdge>;
  /** A list of `RoomPartitionCadLengthMin` objects. */
  nodes: Array<RoomPartitionCadLengthMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadLengthMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadLengthMin` edge in the connection. */
export type RoomPartitionCadLengthMinsEdge = {
  __typename?: 'RoomPartitionCadLengthMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadLengthMin` at the end of the edge. */
  node: RoomPartitionCadLengthMin;
};

/** Methods to use when ordering `RoomPartitionCadLengthMin`. */
export enum RoomPartitionCadLengthMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCadWidthMax = {
  __typename?: 'RoomPartitionCadWidthMax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMax`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadWidthMax` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadWidthMaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadWidthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadWidthMaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadWidthMaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadWidthMaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadWidthMaxFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadWidthMax` */
export type RoomPartitionCadWidthMaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadWidthMax` to look up the row to update. */
export type RoomPartitionCadWidthMaxOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionCadWidthMaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadWidthMax` being updated. */
  patch: UpdateRoomPartitionCadWidthMaxOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadWidthMax`. Fields that are set will be updated. */
export type RoomPartitionCadWidthMaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadWidthMax` to look up the row to connect. */
export type RoomPartitionCadWidthMaxRoomPartitionCadWidthMaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadWidthMax` to look up the row to delete. */
export type RoomPartitionCadWidthMaxRoomPartitionCadWidthMaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadWidthMaxInput` mutation. */
export type RoomPartitionCadWidthMaxRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadWidthMax` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadWidthMax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadWidthMaxRoomPartitionCadWidthMaxPkeyConnect>>;
  /** A `RoomPartitionCadWidthMaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadWidthMaxRoomPartitionIdFkeyRoomPartitionCadWidthMaxCreateInput>>;
  /** The primary key(s) for `roomPartitionCadWidthMax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadWidthMaxRoomPartitionCadWidthMaxPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadWidthMax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadWidthMax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadWidthMaxOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionCadWidthMaxPkeyUpdate>>;
};

/** The `roomPartitionCadWidthMax` to be created by this mutation. */
export type RoomPartitionCadWidthMaxRoomPartitionIdFkeyRoomPartitionCadWidthMaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadWidthMaxRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadWidthMax` values. */
export type RoomPartitionCadWidthMaxesConnection = {
  __typename?: 'RoomPartitionCadWidthMaxesConnection';
  /** A list of edges which contains the `RoomPartitionCadWidthMax` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadWidthMaxesEdge>;
  /** A list of `RoomPartitionCadWidthMax` objects. */
  nodes: Array<RoomPartitionCadWidthMax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadWidthMax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadWidthMax` edge in the connection. */
export type RoomPartitionCadWidthMaxesEdge = {
  __typename?: 'RoomPartitionCadWidthMaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadWidthMax` at the end of the edge. */
  node: RoomPartitionCadWidthMax;
};

/** Methods to use when ordering `RoomPartitionCadWidthMax`. */
export enum RoomPartitionCadWidthMaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCadWidthMin = {
  __typename?: 'RoomPartitionCadWidthMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMin`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCadWidthMin` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCadWidthMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCadWidthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCadWidthMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCadWidthMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCadWidthMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCadWidthMinFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCadWidthMin` */
export type RoomPartitionCadWidthMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCadWidthMin` to look up the row to update. */
export type RoomPartitionCadWidthMinOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionCadWidthMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCadWidthMin` being updated. */
  patch: UpdateRoomPartitionCadWidthMinOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCadWidthMin`. Fields that are set will be updated. */
export type RoomPartitionCadWidthMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCadWidthMin` to look up the row to connect. */
export type RoomPartitionCadWidthMinRoomPartitionCadWidthMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCadWidthMin` to look up the row to delete. */
export type RoomPartitionCadWidthMinRoomPartitionCadWidthMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCadWidthMinInput` mutation. */
export type RoomPartitionCadWidthMinRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCadWidthMin` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCadWidthMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCadWidthMinRoomPartitionCadWidthMinPkeyConnect>>;
  /** A `RoomPartitionCadWidthMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCadWidthMinRoomPartitionIdFkeyRoomPartitionCadWidthMinCreateInput>>;
  /** The primary key(s) for `roomPartitionCadWidthMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCadWidthMinRoomPartitionCadWidthMinPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCadWidthMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCadWidthMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCadWidthMinOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionCadWidthMinPkeyUpdate>>;
};

/** The `roomPartitionCadWidthMin` to be created by this mutation. */
export type RoomPartitionCadWidthMinRoomPartitionIdFkeyRoomPartitionCadWidthMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCadWidthMinRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCadWidthMin` values. */
export type RoomPartitionCadWidthMinsConnection = {
  __typename?: 'RoomPartitionCadWidthMinsConnection';
  /** A list of edges which contains the `RoomPartitionCadWidthMin` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCadWidthMinsEdge>;
  /** A list of `RoomPartitionCadWidthMin` objects. */
  nodes: Array<RoomPartitionCadWidthMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCadWidthMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCadWidthMin` edge in the connection. */
export type RoomPartitionCadWidthMinsEdge = {
  __typename?: 'RoomPartitionCadWidthMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCadWidthMin` at the end of the edge. */
  node: RoomPartitionCadWidthMin;
};

/** Methods to use when ordering `RoomPartitionCadWidthMin`. */
export enum RoomPartitionCadWidthMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCapacityPax = {
  __typename?: 'RoomPartitionCapacityPax';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCapacityPax`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/**
 * A condition to be used against `RoomPartitionCapacityPax` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCapacityPaxCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `RoomPartitionCapacityPax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCapacityPaxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCapacityPaxFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCapacityPaxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCapacityPaxFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `RoomPartitionCapacityPax` */
export type RoomPartitionCapacityPaxInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The fields on `roomPartitionCapacityPax` to look up the row to update. */
export type RoomPartitionCapacityPaxOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionCapacityPaxPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCapacityPax` being updated. */
  patch: UpdateRoomPartitionCapacityPaxOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCapacityPax`. Fields that are set will be updated. */
export type RoomPartitionCapacityPaxPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** The fields on `roomPartitionCapacityPax` to look up the row to connect. */
export type RoomPartitionCapacityPaxRoomPartitionCapacityPaxPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCapacityPax` to look up the row to delete. */
export type RoomPartitionCapacityPaxRoomPartitionCapacityPaxPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCapacityPaxInput` mutation. */
export type RoomPartitionCapacityPaxRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCapacityPax` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCapacityPax` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCapacityPaxRoomPartitionCapacityPaxPkeyConnect>>;
  /** A `RoomPartitionCapacityPaxInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCapacityPaxRoomPartitionIdFkeyRoomPartitionCapacityPaxCreateInput>>;
  /** The primary key(s) for `roomPartitionCapacityPax` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCapacityPaxRoomPartitionCapacityPaxPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCapacityPax` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCapacityPax` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCapacityPaxOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionCapacityPaxPkeyUpdate>>;
};

/** The `roomPartitionCapacityPax` to be created by this mutation. */
export type RoomPartitionCapacityPaxRoomPartitionIdFkeyRoomPartitionCapacityPaxCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCapacityPaxRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCapacityPax` values. */
export type RoomPartitionCapacityPaxesConnection = {
  __typename?: 'RoomPartitionCapacityPaxesConnection';
  /** A list of edges which contains the `RoomPartitionCapacityPax` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCapacityPaxesEdge>;
  /** A list of `RoomPartitionCapacityPax` objects. */
  nodes: Array<RoomPartitionCapacityPax>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCapacityPax` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCapacityPax` edge in the connection. */
export type RoomPartitionCapacityPaxesEdge = {
  __typename?: 'RoomPartitionCapacityPaxesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCapacityPax` at the end of the edge. */
  node: RoomPartitionCapacityPax;
};

/** Methods to use when ordering `RoomPartitionCapacityPax`. */
export enum RoomPartitionCapacityPaxesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionCleaningGrossSpace = {
  __typename?: 'RoomPartitionCleaningGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCleaningGrossSpace`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionCleaningGrossSpace` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCleaningGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionCleaningGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionCleaningGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionCleaningGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionCleaningGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionCleaningGrossSpaceFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionCleaningGrossSpace` */
export type RoomPartitionCleaningGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionCleaningGrossSpace` to look up the row to update. */
export type RoomPartitionCleaningGrossSpaceOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionCleaningGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionCleaningGrossSpace` being updated. */
  patch: UpdateRoomPartitionCleaningGrossSpaceOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionCleaningGrossSpace`. Fields that are set will be updated. */
export type RoomPartitionCleaningGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** The fields on `roomPartitionCleaningGrossSpace` to look up the row to connect. */
export type RoomPartitionCleaningGrossSpaceRoomPartitionCleaningGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionCleaningGrossSpace` to look up the row to delete. */
export type RoomPartitionCleaningGrossSpaceRoomPartitionCleaningGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionCleaningGrossSpaceInput` mutation. */
export type RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionCleaningGrossSpace` in the `RoomPartitionInput` mutation. */
export type RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionCleaningGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionCleaningGrossSpaceRoomPartitionCleaningGrossSpacePkeyConnect>>;
  /** A `RoomPartitionCleaningGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyRoomPartitionCleaningGrossSpaceCreateInput>>;
  /** The primary key(s) for `roomPartitionCleaningGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionCleaningGrossSpaceRoomPartitionCleaningGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionCleaningGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionCleaningGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionCleaningGrossSpaceOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionCleaningGrossSpacePkeyUpdate>>;
};

/** The `roomPartitionCleaningGrossSpace` to be created by this mutation. */
export type RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyRoomPartitionCleaningGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoomPartitionCleaningGrossSpace` values. */
export type RoomPartitionCleaningGrossSpacesConnection = {
  __typename?: 'RoomPartitionCleaningGrossSpacesConnection';
  /** A list of edges which contains the `RoomPartitionCleaningGrossSpace` and cursor to aid in pagination. */
  edges: Array<RoomPartitionCleaningGrossSpacesEdge>;
  /** A list of `RoomPartitionCleaningGrossSpace` objects. */
  nodes: Array<RoomPartitionCleaningGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionCleaningGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionCleaningGrossSpace` edge in the connection. */
export type RoomPartitionCleaningGrossSpacesEdge = {
  __typename?: 'RoomPartitionCleaningGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionCleaningGrossSpace` at the end of the edge. */
  node: RoomPartitionCleaningGrossSpace;
};

/** Methods to use when ordering `RoomPartitionCleaningGrossSpace`. */
export enum RoomPartitionCleaningGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/**
 * A condition to be used against `RoomPartition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomPartitionDescription = {
  __typename?: 'RoomPartitionDescription';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionDescription`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionDescription` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionDescriptionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionDescription` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionDescriptionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionDescriptionFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionDescription` */
export type RoomPartitionDescriptionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionDescription` to look up the row to update. */
export type RoomPartitionDescriptionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionDescription` being updated. */
  patch: UpdateRoomPartitionDescriptionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionDescription`. Fields that are set will be updated. */
export type RoomPartitionDescriptionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomPartitionDescription` to look up the row to connect. */
export type RoomPartitionDescriptionRoomPartitionDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionDescription` to look up the row to delete. */
export type RoomPartitionDescriptionRoomPartitionDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionDescriptionInput` mutation. */
export type RoomPartitionDescriptionRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionDescription` in the `RoomPartitionInput` mutation. */
export type RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionDescriptionRoomPartitionDescriptionPkeyConnect>>;
  /** A `RoomPartitionDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionDescriptionRoomPartitionIdFkeyRoomPartitionDescriptionCreateInput>>;
  /** The primary key(s) for `roomPartitionDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionDescriptionRoomPartitionDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionDescriptionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionDescriptionPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionDescriptionRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionDescription` to be created by this mutation. */
export type RoomPartitionDescriptionRoomPartitionIdFkeyRoomPartitionDescriptionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** A connection to a list of `RoomPartitionDescription` values. */
export type RoomPartitionDescriptionsConnection = {
  __typename?: 'RoomPartitionDescriptionsConnection';
  /** A list of edges which contains the `RoomPartitionDescription` and cursor to aid in pagination. */
  edges: Array<RoomPartitionDescriptionsEdge>;
  /** A list of `RoomPartitionDescription` objects. */
  nodes: Array<RoomPartitionDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionDescription` edge in the connection. */
export type RoomPartitionDescriptionsEdge = {
  __typename?: 'RoomPartitionDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionDescription` at the end of the edge. */
  node: RoomPartitionDescription;
};

/** Methods to use when ordering `RoomPartitionDescription`. */
export enum RoomPartitionDescriptionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against `RoomPartition` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `roomPartitionCadGrossSpaceMins` relation. */
  roomPartitionCadGrossSpaceMins?: InputMaybe<RoomPartitionToManyRoomPartitionCadGrossSpaceMinFilter>;
  /** Some related `roomPartitionCadGrossSpaceMins` exist. */
  roomPartitionCadGrossSpaceMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCadHeightMaxes` relation. */
  roomPartitionCadHeightMaxes?: InputMaybe<RoomPartitionToManyRoomPartitionCadHeightMaxFilter>;
  /** Some related `roomPartitionCadHeightMaxes` exist. */
  roomPartitionCadHeightMaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCadHeightMins` relation. */
  roomPartitionCadHeightMins?: InputMaybe<RoomPartitionToManyRoomPartitionCadHeightMinFilter>;
  /** Some related `roomPartitionCadHeightMins` exist. */
  roomPartitionCadHeightMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCadLengthMaxes` relation. */
  roomPartitionCadLengthMaxes?: InputMaybe<RoomPartitionToManyRoomPartitionCadLengthMaxFilter>;
  /** Some related `roomPartitionCadLengthMaxes` exist. */
  roomPartitionCadLengthMaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCadLengthMins` relation. */
  roomPartitionCadLengthMins?: InputMaybe<RoomPartitionToManyRoomPartitionCadLengthMinFilter>;
  /** Some related `roomPartitionCadLengthMins` exist. */
  roomPartitionCadLengthMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCadWidthMaxes` relation. */
  roomPartitionCadWidthMaxes?: InputMaybe<RoomPartitionToManyRoomPartitionCadWidthMaxFilter>;
  /** Some related `roomPartitionCadWidthMaxes` exist. */
  roomPartitionCadWidthMaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCadWidthMins` relation. */
  roomPartitionCadWidthMins?: InputMaybe<RoomPartitionToManyRoomPartitionCadWidthMinFilter>;
  /** Some related `roomPartitionCadWidthMins` exist. */
  roomPartitionCadWidthMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCapacityPaxes` relation. */
  roomPartitionCapacityPaxes?: InputMaybe<RoomPartitionToManyRoomPartitionCapacityPaxFilter>;
  /** Some related `roomPartitionCapacityPaxes` exist. */
  roomPartitionCapacityPaxesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionCleaningGrossSpaces` relation. */
  roomPartitionCleaningGrossSpaces?: InputMaybe<RoomPartitionToManyRoomPartitionCleaningGrossSpaceFilter>;
  /** Some related `roomPartitionCleaningGrossSpaces` exist. */
  roomPartitionCleaningGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionDescriptions` relation. */
  roomPartitionDescriptions?: InputMaybe<RoomPartitionToManyRoomPartitionDescriptionFilter>;
  /** Some related `roomPartitionDescriptions` exist. */
  roomPartitionDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameExtras` relation. */
  roomPartitionNameExtras?: InputMaybe<RoomPartitionToManyRoomPartitionNameExtraFilter>;
  /** Some related `roomPartitionNameExtras` exist. */
  roomPartitionNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameKeyCads` relation. */
  roomPartitionNameKeyCads?: InputMaybe<RoomPartitionToManyRoomPartitionNameKeyCadFilter>;
  /** Some related `roomPartitionNameKeyCads` exist. */
  roomPartitionNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameKeyCafms` relation. */
  roomPartitionNameKeyCafms?: InputMaybe<RoomPartitionToManyRoomPartitionNameKeyCafmFilter>;
  /** Some related `roomPartitionNameKeyCafms` exist. */
  roomPartitionNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameKeyEbms` relation. */
  roomPartitionNameKeyEbms?: InputMaybe<RoomPartitionToManyRoomPartitionNameKeyEbmFilter>;
  /** Some related `roomPartitionNameKeyEbms` exist. */
  roomPartitionNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameKeyMarketings` relation. */
  roomPartitionNameKeyMarketings?: InputMaybe<RoomPartitionToManyRoomPartitionNameKeyMarketingFilter>;
  /** Some related `roomPartitionNameKeyMarketings` exist. */
  roomPartitionNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameLongs` relation. */
  roomPartitionNameLongs?: InputMaybe<RoomPartitionToManyRoomPartitionNameLongFilter>;
  /** Some related `roomPartitionNameLongs` exist. */
  roomPartitionNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionNameShorts` relation. */
  roomPartitionNameShorts?: InputMaybe<RoomPartitionToManyRoomPartitionNameShortFilter>;
  /** Some related `roomPartitionNameShorts` exist. */
  roomPartitionNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionPublicGrossSpaces` relation. */
  roomPartitionPublicGrossSpaces?: InputMaybe<RoomPartitionToManyRoomPartitionPublicGrossSpaceFilter>;
  /** Some related `roomPartitionPublicGrossSpaces` exist. */
  roomPartitionPublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionSbvGrossSpaces` relation. */
  roomPartitionSbvGrossSpaces?: InputMaybe<RoomPartitionToManyRoomPartitionSbvGrossSpaceFilter>;
  /** Some related `roomPartitionSbvGrossSpaces` exist. */
  roomPartitionSbvGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionTypeAttrs` relation. */
  roomPartitionTypeAttrs?: InputMaybe<RoomPartitionToManyRoomPartitionTypeAttrFilter>;
  /** Some related `roomPartitionTypeAttrs` exist. */
  roomPartitionTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<RoomPartitionTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `RoomPartition` */
export type RoomPartitionInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomPartitionNameExtra = {
  __typename?: 'RoomPartitionNameExtra';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameExtra`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameExtra` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameExtraCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameExtraFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameExtraFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameExtra` */
export type RoomPartitionNameExtraInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameExtra` to look up the row to update. */
export type RoomPartitionNameExtraOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameExtra` being updated. */
  patch: UpdateRoomPartitionNameExtraOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameExtra`. Fields that are set will be updated. */
export type RoomPartitionNameExtraPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameExtraInput` mutation. */
export type RoomPartitionNameExtraRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameExtra` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameExtraRoomPartitionNameExtraPkeyConnect>>;
  /** A `RoomPartitionNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameExtraRoomPartitionIdFkeyRoomPartitionNameExtraCreateInput>>;
  /** The primary key(s) for `roomPartitionNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameExtraRoomPartitionNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameExtraOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionNameExtraPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameExtraRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameExtra` to be created by this mutation. */
export type RoomPartitionNameExtraRoomPartitionIdFkeyRoomPartitionNameExtraCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameExtra` to look up the row to connect. */
export type RoomPartitionNameExtraRoomPartitionNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameExtra` to look up the row to delete. */
export type RoomPartitionNameExtraRoomPartitionNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameExtra` values. */
export type RoomPartitionNameExtrasConnection = {
  __typename?: 'RoomPartitionNameExtrasConnection';
  /** A list of edges which contains the `RoomPartitionNameExtra` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameExtrasEdge>;
  /** A list of `RoomPartitionNameExtra` objects. */
  nodes: Array<RoomPartitionNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameExtra` edge in the connection. */
export type RoomPartitionNameExtrasEdge = {
  __typename?: 'RoomPartitionNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameExtra` at the end of the edge. */
  node: RoomPartitionNameExtra;
};

/** Methods to use when ordering `RoomPartitionNameExtra`. */
export enum RoomPartitionNameExtrasOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionNameKeyCad = {
  __typename?: 'RoomPartitionNameKeyCad';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCad`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameKeyCad` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameKeyCadCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameKeyCadFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameKeyCadFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameKeyCad` */
export type RoomPartitionNameKeyCadInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyCad` to look up the row to update. */
export type RoomPartitionNameKeyCadOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameKeyCad` being updated. */
  patch: UpdateRoomPartitionNameKeyCadOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameKeyCad`. Fields that are set will be updated. */
export type RoomPartitionNameKeyCadPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameKeyCadInput` mutation. */
export type RoomPartitionNameKeyCadRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameKeyCad` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameKeyCadRoomPartitionNameKeyCadPkeyConnect>>;
  /** A `RoomPartitionNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameKeyCadRoomPartitionIdFkeyRoomPartitionNameKeyCadCreateInput>>;
  /** The primary key(s) for `roomPartitionNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameKeyCadRoomPartitionNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameKeyCadOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionNameKeyCadPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameKeyCadRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameKeyCad` to be created by this mutation. */
export type RoomPartitionNameKeyCadRoomPartitionIdFkeyRoomPartitionNameKeyCadCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyCad` to look up the row to connect. */
export type RoomPartitionNameKeyCadRoomPartitionNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameKeyCad` to look up the row to delete. */
export type RoomPartitionNameKeyCadRoomPartitionNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameKeyCad` values. */
export type RoomPartitionNameKeyCadsConnection = {
  __typename?: 'RoomPartitionNameKeyCadsConnection';
  /** A list of edges which contains the `RoomPartitionNameKeyCad` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameKeyCadsEdge>;
  /** A list of `RoomPartitionNameKeyCad` objects. */
  nodes: Array<RoomPartitionNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameKeyCad` edge in the connection. */
export type RoomPartitionNameKeyCadsEdge = {
  __typename?: 'RoomPartitionNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameKeyCad` at the end of the edge. */
  node: RoomPartitionNameKeyCad;
};

/** Methods to use when ordering `RoomPartitionNameKeyCad`. */
export enum RoomPartitionNameKeyCadsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionNameKeyCafm = {
  __typename?: 'RoomPartitionNameKeyCafm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCafm`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameKeyCafm` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameKeyCafmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameKeyCafmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameKeyCafmFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameKeyCafm` */
export type RoomPartitionNameKeyCafmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyCafm` to look up the row to update. */
export type RoomPartitionNameKeyCafmOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameKeyCafm` being updated. */
  patch: UpdateRoomPartitionNameKeyCafmOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameKeyCafm`. Fields that are set will be updated. */
export type RoomPartitionNameKeyCafmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameKeyCafmInput` mutation. */
export type RoomPartitionNameKeyCafmRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameKeyCafm` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameKeyCafmRoomPartitionNameKeyCafmPkeyConnect>>;
  /** A `RoomPartitionNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameKeyCafmRoomPartitionIdFkeyRoomPartitionNameKeyCafmCreateInput>>;
  /** The primary key(s) for `roomPartitionNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameKeyCafmRoomPartitionNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameKeyCafmOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionNameKeyCafmPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameKeyCafmRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameKeyCafm` to be created by this mutation. */
export type RoomPartitionNameKeyCafmRoomPartitionIdFkeyRoomPartitionNameKeyCafmCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyCafm` to look up the row to connect. */
export type RoomPartitionNameKeyCafmRoomPartitionNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameKeyCafm` to look up the row to delete. */
export type RoomPartitionNameKeyCafmRoomPartitionNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameKeyCafm` values. */
export type RoomPartitionNameKeyCafmsConnection = {
  __typename?: 'RoomPartitionNameKeyCafmsConnection';
  /** A list of edges which contains the `RoomPartitionNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameKeyCafmsEdge>;
  /** A list of `RoomPartitionNameKeyCafm` objects. */
  nodes: Array<RoomPartitionNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameKeyCafm` edge in the connection. */
export type RoomPartitionNameKeyCafmsEdge = {
  __typename?: 'RoomPartitionNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameKeyCafm` at the end of the edge. */
  node: RoomPartitionNameKeyCafm;
};

/** Methods to use when ordering `RoomPartitionNameKeyCafm`. */
export enum RoomPartitionNameKeyCafmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionNameKeyEbm = {
  __typename?: 'RoomPartitionNameKeyEbm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyEbm`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameKeyEbm` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameKeyEbmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameKeyEbmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameKeyEbmFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameKeyEbm` */
export type RoomPartitionNameKeyEbmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyEbm` to look up the row to update. */
export type RoomPartitionNameKeyEbmOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameKeyEbm` being updated. */
  patch: UpdateRoomPartitionNameKeyEbmOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameKeyEbm`. Fields that are set will be updated. */
export type RoomPartitionNameKeyEbmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomPartitionNameKeyEbm` to look up the row to connect. */
export type RoomPartitionNameKeyEbmRoomPartitionNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameKeyEbm` to look up the row to delete. */
export type RoomPartitionNameKeyEbmRoomPartitionNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameKeyEbm` values. */
export type RoomPartitionNameKeyEbmsConnection = {
  __typename?: 'RoomPartitionNameKeyEbmsConnection';
  /** A list of edges which contains the `RoomPartitionNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameKeyEbmsEdge>;
  /** A list of `RoomPartitionNameKeyEbm` objects. */
  nodes: Array<RoomPartitionNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameKeyEbm` edge in the connection. */
export type RoomPartitionNameKeyEbmsEdge = {
  __typename?: 'RoomPartitionNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameKeyEbm` at the end of the edge. */
  node: RoomPartitionNameKeyEbm;
};

/** Methods to use when ordering `RoomPartitionNameKeyEbm`. */
export enum RoomPartitionNameKeyEbmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameKeyEbmInput` mutation. */
export type RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameKeyEbm` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameKeyEbmRoomPartitionNameKeyEbmsPkeyConnect>>;
  /** A `RoomPartitionNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyRoomPartitionNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `roomPartitionNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameKeyEbmRoomPartitionNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameKeyEbmOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionNameKeyEbmsPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameKeyEbmsRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameKeyEbm` to be created by this mutation. */
export type RoomPartitionNameKeyEbmsRoomPartitionIdFkeyRoomPartitionNameKeyEbmsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type RoomPartitionNameKeyMarketing = {
  __typename?: 'RoomPartitionNameKeyMarketing';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyMarketing`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameKeyMarketing` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameKeyMarketingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameKeyMarketingFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameKeyMarketing` */
export type RoomPartitionNameKeyMarketingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyMarketing` to look up the row to update. */
export type RoomPartitionNameKeyMarketingOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameKeyMarketing` being updated. */
  patch: UpdateRoomPartitionNameKeyMarketingOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameKeyMarketing`. Fields that are set will be updated. */
export type RoomPartitionNameKeyMarketingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameKeyMarketingInput` mutation. */
export type RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameKeyMarketing` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameKeyMarketingRoomPartitionNameKeyMarketingPkeyConnect>>;
  /** A `RoomPartitionNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyRoomPartitionNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `roomPartitionNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameKeyMarketingRoomPartitionNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameKeyMarketingOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionNameKeyMarketingPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameKeyMarketingRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameKeyMarketing` to be created by this mutation. */
export type RoomPartitionNameKeyMarketingRoomPartitionIdFkeyRoomPartitionNameKeyMarketingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameKeyMarketing` to look up the row to connect. */
export type RoomPartitionNameKeyMarketingRoomPartitionNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameKeyMarketing` to look up the row to delete. */
export type RoomPartitionNameKeyMarketingRoomPartitionNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameKeyMarketing` values. */
export type RoomPartitionNameKeyMarketingsConnection = {
  __typename?: 'RoomPartitionNameKeyMarketingsConnection';
  /** A list of edges which contains the `RoomPartitionNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameKeyMarketingsEdge>;
  /** A list of `RoomPartitionNameKeyMarketing` objects. */
  nodes: Array<RoomPartitionNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameKeyMarketing` edge in the connection. */
export type RoomPartitionNameKeyMarketingsEdge = {
  __typename?: 'RoomPartitionNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameKeyMarketing` at the end of the edge. */
  node: RoomPartitionNameKeyMarketing;
};

/** Methods to use when ordering `RoomPartitionNameKeyMarketing`. */
export enum RoomPartitionNameKeyMarketingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionNameLong = {
  __typename?: 'RoomPartitionNameLong';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameLong`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameLong` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameLongCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameLong` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameLongFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameLongFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameLong` */
export type RoomPartitionNameLongInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameLong` to look up the row to update. */
export type RoomPartitionNameLongOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameLong` being updated. */
  patch: UpdateRoomPartitionNameLongOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameLong`. Fields that are set will be updated. */
export type RoomPartitionNameLongPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameLongInput` mutation. */
export type RoomPartitionNameLongRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameLong` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameLongRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameLongRoomPartitionNameLongPkeyConnect>>;
  /** A `RoomPartitionNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameLongRoomPartitionIdFkeyRoomPartitionNameLongCreateInput>>;
  /** The primary key(s) for `roomPartitionNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameLongRoomPartitionNameLongPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameLongOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionNameLongPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameLongRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameLong` to be created by this mutation. */
export type RoomPartitionNameLongRoomPartitionIdFkeyRoomPartitionNameLongCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameLong` to look up the row to connect. */
export type RoomPartitionNameLongRoomPartitionNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameLong` to look up the row to delete. */
export type RoomPartitionNameLongRoomPartitionNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameLong` values. */
export type RoomPartitionNameLongsConnection = {
  __typename?: 'RoomPartitionNameLongsConnection';
  /** A list of edges which contains the `RoomPartitionNameLong` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameLongsEdge>;
  /** A list of `RoomPartitionNameLong` objects. */
  nodes: Array<RoomPartitionNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameLong` edge in the connection. */
export type RoomPartitionNameLongsEdge = {
  __typename?: 'RoomPartitionNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameLong` at the end of the edge. */
  node: RoomPartitionNameLong;
};

/** Methods to use when ordering `RoomPartitionNameLong`. */
export enum RoomPartitionNameLongsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomPartitionNameShort = {
  __typename?: 'RoomPartitionNameShort';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameShort`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPartitionNameShort` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionNameShortCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionNameShort` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionNameShortFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionNameShortFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPartitionNameShort` */
export type RoomPartitionNameShortInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameShort` to look up the row to update. */
export type RoomPartitionNameShortOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionNameShort` being updated. */
  patch: UpdateRoomPartitionNameShortOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionNameShort`. Fields that are set will be updated. */
export type RoomPartitionNameShortPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionNameShortInput` mutation. */
export type RoomPartitionNameShortRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionNameShort` in the `RoomPartitionInput` mutation. */
export type RoomPartitionNameShortRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionNameShortRoomPartitionNameShortPkeyConnect>>;
  /** A `RoomPartitionNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionNameShortRoomPartitionIdFkeyRoomPartitionNameShortCreateInput>>;
  /** The primary key(s) for `roomPartitionNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionNameShortRoomPartitionNameShortPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionNameShortOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionNameShortPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionNameShortRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionNameShort` to be created by this mutation. */
export type RoomPartitionNameShortRoomPartitionIdFkeyRoomPartitionNameShortCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPartitionNameShort` to look up the row to connect. */
export type RoomPartitionNameShortRoomPartitionNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionNameShort` to look up the row to delete. */
export type RoomPartitionNameShortRoomPartitionNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionNameShort` values. */
export type RoomPartitionNameShortsConnection = {
  __typename?: 'RoomPartitionNameShortsConnection';
  /** A list of edges which contains the `RoomPartitionNameShort` and cursor to aid in pagination. */
  edges: Array<RoomPartitionNameShortsEdge>;
  /** A list of `RoomPartitionNameShort` objects. */
  nodes: Array<RoomPartitionNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionNameShort` edge in the connection. */
export type RoomPartitionNameShortsEdge = {
  __typename?: 'RoomPartitionNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionNameShort` at the end of the edge. */
  node: RoomPartitionNameShort;
};

/** Methods to use when ordering `RoomPartitionNameShort`. */
export enum RoomPartitionNameShortsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartition` to look up the row to update. */
export type RoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartition` being updated. */
  patch: UpdateRoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartition`. Fields that are set will be updated. */
export type RoomPartitionPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomPartitionPublicGrossSpace = {
  __typename?: 'RoomPartitionPublicGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionPublicGrossSpace`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionPublicGrossSpace` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionPublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionPublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionPublicGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionPublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionPublicGrossSpaceFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionPublicGrossSpace` */
export type RoomPartitionPublicGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionPublicGrossSpace` to look up the row to update. */
export type RoomPartitionPublicGrossSpaceOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionPublicGrossSpace` being updated. */
  patch: UpdateRoomPartitionPublicGrossSpaceOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionPublicGrossSpace`. Fields that are set will be updated. */
export type RoomPartitionPublicGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionPublicGrossSpaceInput` mutation. */
export type RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionPublicGrossSpace` in the `RoomPartitionInput` mutation. */
export type RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionPublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionPublicGrossSpaceRoomPartitionPublicGrossSpacePkeyConnect>>;
  /** A `RoomPartitionPublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyRoomPartitionPublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `roomPartitionPublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionPublicGrossSpaceRoomPartitionPublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionPublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionPublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionPublicGrossSpaceOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPublicGrossSpacePkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionPublicGrossSpace` to be created by this mutation. */
export type RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyRoomPartitionPublicGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionPublicGrossSpace` to look up the row to connect. */
export type RoomPartitionPublicGrossSpaceRoomPartitionPublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionPublicGrossSpace` to look up the row to delete. */
export type RoomPartitionPublicGrossSpaceRoomPartitionPublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionPublicGrossSpace` values. */
export type RoomPartitionPublicGrossSpacesConnection = {
  __typename?: 'RoomPartitionPublicGrossSpacesConnection';
  /** A list of edges which contains the `RoomPartitionPublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<RoomPartitionPublicGrossSpacesEdge>;
  /** A list of `RoomPartitionPublicGrossSpace` objects. */
  nodes: Array<RoomPartitionPublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionPublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionPublicGrossSpace` edge in the connection. */
export type RoomPartitionPublicGrossSpacesEdge = {
  __typename?: 'RoomPartitionPublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionPublicGrossSpace` at the end of the edge. */
  node: RoomPartitionPublicGrossSpace;
};

/** Methods to use when ordering `RoomPartitionPublicGrossSpace`. */
export enum RoomPartitionPublicGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomPartitionInput` mutation. */
export type RoomPartitionRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomInput` mutation. */
export type RoomPartitionRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<RoomPartitionRoomPartitionExtIdKeyConnect>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionRoomPartitionPkeyConnect>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<RoomPartitionRoomPartitionNameShortKeyConnect>>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionRoomIdFkeyRoomPartitionCreateInput>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<RoomPartitionRoomPartitionExtIdKeyDelete>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionRoomPartitionPkeyDelete>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<RoomPartitionRoomPartitionNameShortKeyDelete>>;
  /** Flag indicating whether all other `roomPartition` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<RoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPartitionExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPartitionPkeyUpdate>>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<RoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyUsingRoomPartitionNameShortKeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomPartitionRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionRoomIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `roomPartition` to look up the row to connect. */
export type RoomPartitionRoomPartitionExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `roomPartition` to look up the row to delete. */
export type RoomPartitionRoomPartitionExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `roomPartition` to look up the row to connect. */
export type RoomPartitionRoomPartitionNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `roomPartition` to look up the row to delete. */
export type RoomPartitionRoomPartitionNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `roomPartition` to look up the row to connect. */
export type RoomPartitionRoomPartitionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartition` to look up the row to delete. */
export type RoomPartitionRoomPartitionPkeyDelete = {
  id: Scalars['UUID'];
};

export type RoomPartitionSbvGrossSpace = {
  __typename?: 'RoomPartitionSbvGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionSbvGrossSpace`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPartitionSbvGrossSpace` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionSbvGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPartitionSbvGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionSbvGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionSbvGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionSbvGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionSbvGrossSpaceFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPartitionSbvGrossSpace` */
export type RoomPartitionSbvGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionSbvGrossSpace` to look up the row to update. */
export type RoomPartitionSbvGrossSpaceOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionSbvGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionSbvGrossSpace` being updated. */
  patch: UpdateRoomPartitionSbvGrossSpaceOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionSbvGrossSpace`. Fields that are set will be updated. */
export type RoomPartitionSbvGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionSbvGrossSpaceInput` mutation. */
export type RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionSbvGrossSpace` in the `RoomPartitionInput` mutation. */
export type RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionSbvGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionSbvGrossSpaceRoomPartitionSbvGrossSpacePkeyConnect>>;
  /** A `RoomPartitionSbvGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyRoomPartitionSbvGrossSpaceCreateInput>>;
  /** The primary key(s) for `roomPartitionSbvGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionSbvGrossSpaceRoomPartitionSbvGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionSbvGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionSbvGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionSbvGrossSpaceOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyUsingRoomPartitionSbvGrossSpacePkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionSbvGrossSpace` to be created by this mutation. */
export type RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyRoomPartitionSbvGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPartitionSbvGrossSpace` to look up the row to connect. */
export type RoomPartitionSbvGrossSpaceRoomPartitionSbvGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionSbvGrossSpace` to look up the row to delete. */
export type RoomPartitionSbvGrossSpaceRoomPartitionSbvGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPartitionSbvGrossSpace` values. */
export type RoomPartitionSbvGrossSpacesConnection = {
  __typename?: 'RoomPartitionSbvGrossSpacesConnection';
  /** A list of edges which contains the `RoomPartitionSbvGrossSpace` and cursor to aid in pagination. */
  edges: Array<RoomPartitionSbvGrossSpacesEdge>;
  /** A list of `RoomPartitionSbvGrossSpace` objects. */
  nodes: Array<RoomPartitionSbvGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionSbvGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionSbvGrossSpace` edge in the connection. */
export type RoomPartitionSbvGrossSpacesEdge = {
  __typename?: 'RoomPartitionSbvGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionSbvGrossSpace` at the end of the edge. */
  node: RoomPartitionSbvGrossSpace;
};

/** Methods to use when ordering `RoomPartitionSbvGrossSpace`. */
export enum RoomPartitionSbvGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against many `RoomPartitionCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadGrossSpaceMinFilter = {
  /** Every related `RoomPartitionCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadGrossSpaceMinFilter>;
  /** No related `RoomPartitionCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadGrossSpaceMinFilter>;
  /** Some related `RoomPartitionCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadGrossSpaceMinFilter>;
};

/** A filter to be used against many `RoomPartitionCadHeightMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadHeightMaxFilter = {
  /** Every related `RoomPartitionCadHeightMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadHeightMaxFilter>;
  /** No related `RoomPartitionCadHeightMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadHeightMaxFilter>;
  /** Some related `RoomPartitionCadHeightMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadHeightMaxFilter>;
};

/** A filter to be used against many `RoomPartitionCadHeightMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadHeightMinFilter = {
  /** Every related `RoomPartitionCadHeightMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadHeightMinFilter>;
  /** No related `RoomPartitionCadHeightMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadHeightMinFilter>;
  /** Some related `RoomPartitionCadHeightMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadHeightMinFilter>;
};

/** A filter to be used against many `RoomPartitionCadLengthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadLengthMaxFilter = {
  /** Every related `RoomPartitionCadLengthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadLengthMaxFilter>;
  /** No related `RoomPartitionCadLengthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadLengthMaxFilter>;
  /** Some related `RoomPartitionCadLengthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadLengthMaxFilter>;
};

/** A filter to be used against many `RoomPartitionCadLengthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadLengthMinFilter = {
  /** Every related `RoomPartitionCadLengthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadLengthMinFilter>;
  /** No related `RoomPartitionCadLengthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadLengthMinFilter>;
  /** Some related `RoomPartitionCadLengthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadLengthMinFilter>;
};

/** A filter to be used against many `RoomPartitionCadWidthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadWidthMaxFilter = {
  /** Every related `RoomPartitionCadWidthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadWidthMaxFilter>;
  /** No related `RoomPartitionCadWidthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadWidthMaxFilter>;
  /** Some related `RoomPartitionCadWidthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadWidthMaxFilter>;
};

/** A filter to be used against many `RoomPartitionCadWidthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCadWidthMinFilter = {
  /** Every related `RoomPartitionCadWidthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCadWidthMinFilter>;
  /** No related `RoomPartitionCadWidthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCadWidthMinFilter>;
  /** Some related `RoomPartitionCadWidthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCadWidthMinFilter>;
};

/** A filter to be used against many `RoomPartitionCapacityPax` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCapacityPaxFilter = {
  /** Every related `RoomPartitionCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCapacityPaxFilter>;
  /** No related `RoomPartitionCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCapacityPaxFilter>;
  /** Some related `RoomPartitionCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCapacityPaxFilter>;
};

/** A filter to be used against many `RoomPartitionCleaningGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionCleaningGrossSpaceFilter = {
  /** Every related `RoomPartitionCleaningGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionCleaningGrossSpaceFilter>;
  /** No related `RoomPartitionCleaningGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionCleaningGrossSpaceFilter>;
  /** Some related `RoomPartitionCleaningGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionCleaningGrossSpaceFilter>;
};

/** A filter to be used against many `RoomPartitionDescription` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionDescriptionFilter = {
  /** Every related `RoomPartitionDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionDescriptionFilter>;
  /** No related `RoomPartitionDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionDescriptionFilter>;
  /** Some related `RoomPartitionDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionDescriptionFilter>;
};

/** A filter to be used against many `RoomPartitionNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameExtraFilter = {
  /** Every related `RoomPartitionNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameExtraFilter>;
  /** No related `RoomPartitionNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameExtraFilter>;
  /** Some related `RoomPartitionNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameExtraFilter>;
};

/** A filter to be used against many `RoomPartitionNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameKeyCadFilter = {
  /** Every related `RoomPartitionNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameKeyCadFilter>;
  /** No related `RoomPartitionNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameKeyCadFilter>;
  /** Some related `RoomPartitionNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameKeyCadFilter>;
};

/** A filter to be used against many `RoomPartitionNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameKeyCafmFilter = {
  /** Every related `RoomPartitionNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameKeyCafmFilter>;
  /** No related `RoomPartitionNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameKeyCafmFilter>;
  /** Some related `RoomPartitionNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameKeyCafmFilter>;
};

/** A filter to be used against many `RoomPartitionNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameKeyEbmFilter = {
  /** Every related `RoomPartitionNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameKeyEbmFilter>;
  /** No related `RoomPartitionNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameKeyEbmFilter>;
  /** Some related `RoomPartitionNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameKeyEbmFilter>;
};

/** A filter to be used against many `RoomPartitionNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameKeyMarketingFilter = {
  /** Every related `RoomPartitionNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameKeyMarketingFilter>;
  /** No related `RoomPartitionNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameKeyMarketingFilter>;
  /** Some related `RoomPartitionNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameKeyMarketingFilter>;
};

/** A filter to be used against many `RoomPartitionNameLong` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameLongFilter = {
  /** Every related `RoomPartitionNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameLongFilter>;
  /** No related `RoomPartitionNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameLongFilter>;
  /** Some related `RoomPartitionNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameLongFilter>;
};

/** A filter to be used against many `RoomPartitionNameShort` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionNameShortFilter = {
  /** Every related `RoomPartitionNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionNameShortFilter>;
  /** No related `RoomPartitionNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionNameShortFilter>;
  /** Some related `RoomPartitionNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionNameShortFilter>;
};

/** A filter to be used against many `RoomPartitionPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionPublicGrossSpaceFilter = {
  /** Every related `RoomPartitionPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionPublicGrossSpaceFilter>;
  /** No related `RoomPartitionPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionPublicGrossSpaceFilter>;
  /** Some related `RoomPartitionPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionPublicGrossSpaceFilter>;
};

/** A filter to be used against many `RoomPartitionSbvGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionSbvGrossSpaceFilter = {
  /** Every related `RoomPartitionSbvGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionSbvGrossSpaceFilter>;
  /** No related `RoomPartitionSbvGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionSbvGrossSpaceFilter>;
  /** Some related `RoomPartitionSbvGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionSbvGrossSpaceFilter>;
};

/** A filter to be used against many `RoomPartitionTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionToManyRoomPartitionTypeAttrFilter = {
  /** Every related `RoomPartitionTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionTypeAttrFilter>;
  /** No related `RoomPartitionTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionTypeAttrFilter>;
  /** Some related `RoomPartitionTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionTypeAttrFilter>;
};

export type RoomPartitionType = {
  __typename?: 'RoomPartitionType';
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `RoomPartitionTypeAttr`. */
  roomPartitionTypeAttrs: RoomPartitionTypeAttrsConnection;
  /** Reads and enables pagination through a set of `RoomPartition`. */
  roomPartitionsByTypeId: RoomPartitionsConnection;
};


export type RoomPartitionTypeRoomPartitionTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionTypeAttrCondition>;
  filter?: InputMaybe<RoomPartitionTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionTypeAttrsOrderBy>>;
};


export type RoomPartitionTypeRoomPartitionsByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomPartitionCondition>;
  filter?: InputMaybe<RoomPartitionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomPartitionsOrderBy>>;
};

export type RoomPartitionTypeAttr = {
  __typename?: 'RoomPartitionTypeAttr';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionTypeAttr`. */
  roomPartition: RoomPartition;
  roomPartitionId: Scalars['UUID'];
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartitionTypeAttr`. */
  roomPartitionType: RoomPartitionType;
  roomPartitionTypeId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `RoomPartitionTypeAttr` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionTypeAttrCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomPartitionTypeId` field. */
  roomPartitionTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `RoomPartitionTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionTypeAttrFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionTypeAttrFilter>>;
  /** Filter by the object’s `roomPartition` relation. */
  roomPartition?: InputMaybe<RoomPartitionFilter>;
  /** Filter by the object’s `roomPartitionId` field. */
  roomPartitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `roomPartitionType` relation. */
  roomPartitionType?: InputMaybe<RoomPartitionTypeFilter>;
  /** Filter by the object’s `roomPartitionTypeId` field. */
  roomPartitionTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `RoomPartitionTypeAttr` */
export type RoomPartitionTypeAttrInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInput>;
  roomPartitionTypeId?: InputMaybe<Scalars['UUID']>;
  roomPartitionTypeToRoomPartitionTypeId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `roomPartitionTypeAttr` to look up the row to update. */
export type RoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionTypeAttr` being updated. */
  patch: UpdateRoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyPatch;
};

/** The fields on `roomPartitionTypeAttr` to look up the row to update. */
export type RoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyUsingRoomPartitionTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionTypeAttr` being updated. */
  patch: UpdateRoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionTypeAttr`. Fields that are set will be updated. */
export type RoomPartitionTypeAttrPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInput>;
  roomPartitionTypeId?: InputMaybe<Scalars['UUID']>;
  roomPartitionTypeToRoomPartitionTypeId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionTypeAttrInput` mutation. */
export type RoomPartitionTypeAttrRoomPartitionIdFkeyInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionRoomPartitionPkeyConnect>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyConnect>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyRoomPartitionCreateInput>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomPartitionRoomPartitionExtIdKeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionRoomPartitionPkeyDelete>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomPartitionRoomPartitionNameShortKeyDelete>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionPkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionTypeAttr` in the `RoomPartitionInput` mutation. */
export type RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionTypeAttrRoomPartitionTypeAttrPkeyConnect>>;
  /** A `RoomPartitionTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionTypeAttrRoomPartitionIdFkeyRoomPartitionTypeAttrCreateInput>>;
  /** The primary key(s) for `roomPartitionTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionTypeAttrRoomPartitionTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyUsingRoomPartitionTypeAttrPkeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionTypeAttrRoomPartitionIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPartitionTypeAttr` to be created by this mutation. */
export type RoomPartitionTypeAttrRoomPartitionIdFkeyRoomPartitionTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInput>;
  roomPartitionTypeId?: InputMaybe<Scalars['UUID']>;
  roomPartitionTypeToRoomPartitionTypeId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `roomPartitionTypeAttr` to look up the row to connect. */
export type RoomPartitionTypeAttrRoomPartitionTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionTypeAttr` to look up the row to delete. */
export type RoomPartitionTypeAttrRoomPartitionTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomPartitionType` in the `RoomPartitionTypeAttrInput` mutation. */
export type RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput = {
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionTypeRoomPartitionTypePkeyConnect>;
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  connectByName?: InputMaybe<RoomPartitionTypeRoomPartitionTypeNameKeyConnect>;
  /** A `RoomPartitionTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyRoomPartitionTypeCreateInput>;
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionTypeRoomPartitionTypePkeyDelete>;
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  deleteByName?: InputMaybe<RoomPartitionTypeRoomPartitionTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `roomPartitionType` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyUsingRoomPartitionTypePkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartitionType` for the far side of the relationship. */
  updateByName?: InputMaybe<RoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyUsingRoomPartitionTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `roomPartitionTypeAttr` in the `RoomPartitionTypeInput` mutation. */
export type RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartitionTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionTypeAttrRoomPartitionTypeAttrPkeyConnect>>;
  /** A `RoomPartitionTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyRoomPartitionTypeAttrCreateInput>>;
  /** The primary key(s) for `roomPartitionTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionTypeAttrRoomPartitionTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `roomPartitionTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartitionTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyUsingRoomPartitionTypeAttrPkeyUpdate>>;
};

/** The `roomPartitionTypeAttr` to be created by this mutation. */
export type RoomPartitionTypeAttrRoomPartitionTypeIdFkeyRoomPartitionTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInput>;
  roomPartitionTypeToRoomPartitionTypeId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `roomPartitionType` to be created by this mutation. */
export type RoomPartitionTypeAttrRoomPartitionTypeIdFkeyRoomPartitionTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionTypeIdFkeyInverseInput>;
};

/** A connection to a list of `RoomPartitionTypeAttr` values. */
export type RoomPartitionTypeAttrsConnection = {
  __typename?: 'RoomPartitionTypeAttrsConnection';
  /** A list of edges which contains the `RoomPartitionTypeAttr` and cursor to aid in pagination. */
  edges: Array<RoomPartitionTypeAttrsEdge>;
  /** A list of `RoomPartitionTypeAttr` objects. */
  nodes: Array<RoomPartitionTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionTypeAttr` edge in the connection. */
export type RoomPartitionTypeAttrsEdge = {
  __typename?: 'RoomPartitionTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionTypeAttr` at the end of the edge. */
  node: RoomPartitionTypeAttr;
};

/** Methods to use when ordering `RoomPartitionTypeAttr`. */
export enum RoomPartitionTypeAttrsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionByRoomPartitionIdDescriptionAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_ASC',
  RoomPartitionByRoomPartitionIdDescriptionDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__DESCRIPTION_DESC',
  RoomPartitionByRoomPartitionIdExtIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_ASC',
  RoomPartitionByRoomPartitionIdExtIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__EXT_ID_DESC',
  RoomPartitionByRoomPartitionIdIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_ASC',
  RoomPartitionByRoomPartitionIdIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ID_DESC',
  RoomPartitionByRoomPartitionIdNameLongAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_ASC',
  RoomPartitionByRoomPartitionIdNameLongDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_LONG_DESC',
  RoomPartitionByRoomPartitionIdNameShortAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_ASC',
  RoomPartitionByRoomPartitionIdNameShortDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__NAME_SHORT_DESC',
  RoomPartitionByRoomPartitionIdRoomIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_ASC',
  RoomPartitionByRoomPartitionIdRoomIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__ROOM_ID_DESC',
  RoomPartitionByRoomPartitionIdTypeIdAsc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_ASC',
  RoomPartitionByRoomPartitionIdTypeIdDesc = 'ROOM_PARTITION_BY_ROOM_PARTITION_ID__TYPE_ID_DESC',
  RoomPartitionIdAsc = 'ROOM_PARTITION_ID_ASC',
  RoomPartitionIdDesc = 'ROOM_PARTITION_ID_DESC',
  RoomPartitionTypeByRoomPartitionTypeIdDescriptionAsc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__DESCRIPTION_ASC',
  RoomPartitionTypeByRoomPartitionTypeIdDescriptionDesc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__DESCRIPTION_DESC',
  RoomPartitionTypeByRoomPartitionTypeIdIdAsc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__ID_ASC',
  RoomPartitionTypeByRoomPartitionTypeIdIdDesc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__ID_DESC',
  RoomPartitionTypeByRoomPartitionTypeIdIndexAsc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__INDEX_ASC',
  RoomPartitionTypeByRoomPartitionTypeIdIndexDesc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__INDEX_DESC',
  RoomPartitionTypeByRoomPartitionTypeIdNameAsc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__NAME_ASC',
  RoomPartitionTypeByRoomPartitionTypeIdNameDesc = 'ROOM_PARTITION_TYPE_BY_ROOM_PARTITION_TYPE_ID__NAME_DESC',
  RoomPartitionTypeIdAsc = 'ROOM_PARTITION_TYPE_ID_ASC',
  RoomPartitionTypeIdDesc = 'ROOM_PARTITION_TYPE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/**
 * A condition to be used against `RoomPartitionType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomPartitionTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPartitionType` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPartitionTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPartitionTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPartitionTypeFilter>>;
  /** Filter by the object’s `roomPartitionTypeAttrs` relation. */
  roomPartitionTypeAttrs?: InputMaybe<RoomPartitionTypeToManyRoomPartitionTypeAttrFilter>;
  /** Some related `roomPartitionTypeAttrs` exist. */
  roomPartitionTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomPartitionsByTypeId` relation. */
  roomPartitionsByTypeId?: InputMaybe<RoomPartitionTypeToManyRoomPartitionFilter>;
  /** Some related `roomPartitionsByTypeId` exist. */
  roomPartitionsByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `roomPartitionType` in the `RoomPartitionInput` mutation. */
export type RoomPartitionTypeIdFkeyInput = {
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  connectById?: InputMaybe<RoomPartitionTypeRoomPartitionTypePkeyConnect>;
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  connectByName?: InputMaybe<RoomPartitionTypeRoomPartitionTypeNameKeyConnect>;
  /** A `RoomPartitionTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPartitionTypeIdFkeyRoomPartitionTypeCreateInput>;
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomPartitionTypeRoomPartitionTypePkeyDelete>;
  /** The primary key(s) for `roomPartitionType` for the far side of the relationship. */
  deleteByName?: InputMaybe<RoomPartitionTypeRoomPartitionTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `roomPartitionType` for the far side of the relationship. */
  updateById?: InputMaybe<RoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionTypePkeyUpdate>;
  /** The primary key(s) and patch data for `roomPartitionType` for the far side of the relationship. */
  updateByName?: InputMaybe<RoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `roomPartition` in the `RoomPartitionTypeInput` mutation. */
export type RoomPartitionTypeIdFkeyInverseInput = {
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<RoomPartitionRoomPartitionExtIdKeyConnect>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPartitionRoomPartitionPkeyConnect>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<RoomPartitionRoomPartitionNameShortKeyConnect>>;
  /** A `RoomPartitionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPartitionTypeIdFkeyRoomPartitionCreateInput>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<RoomPartitionRoomPartitionExtIdKeyDelete>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPartitionRoomPartitionPkeyDelete>>;
  /** The primary key(s) for `roomPartition` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<RoomPartitionRoomPartitionNameShortKeyDelete>>;
  /** Flag indicating whether all other `roomPartition` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<RoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionPkeyUpdate>>;
  /** The primary key(s) and patch data for `roomPartition` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<RoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionNameShortKeyUpdate>>;
};

/** The `roomPartition` to be created by this mutation. */
export type RoomPartitionTypeIdFkeyRoomPartitionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
};

/** The `roomPartitionType` to be created by this mutation. */
export type RoomPartitionTypeIdFkeyRoomPartitionTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionTypeIdFkeyInverseInput>;
};

/** An input for mutations affecting `RoomPartitionType` */
export type RoomPartitionTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionTypeIdFkeyInverseInput>;
};

/** The fields on `roomPartitionType` to look up the row to update. */
export type RoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartitionType` being updated. */
  patch: UpdateRoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyPatch;
};

/** The fields on `roomPartitionType` to look up the row to update. */
export type RoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyUsingRoomPartitionTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionType` being updated. */
  patch: UpdateRoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyPatch;
};

/** The fields on `roomPartitionType` to look up the row to update. */
export type RoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyUsingRoomPartitionTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `roomPartitionType` being updated. */
  patch: UpdateRoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyPatch;
};

/** The fields on `roomPartitionType` to look up the row to update. */
export type RoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyUsingRoomPartitionTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPartitionType` being updated. */
  patch: UpdateRoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyPatch;
};

/** Represents an update to a `RoomPartitionType`. Fields that are set will be updated. */
export type RoomPartitionTypePatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionTypeIdFkeyInverseInput>;
};

/** The fields on `roomPartitionType` to look up the row to connect. */
export type RoomPartitionTypeRoomPartitionTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `roomPartitionType` to look up the row to delete. */
export type RoomPartitionTypeRoomPartitionTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `roomPartitionType` to look up the row to connect. */
export type RoomPartitionTypeRoomPartitionTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPartitionType` to look up the row to delete. */
export type RoomPartitionTypeRoomPartitionTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `RoomPartition` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionTypeToManyRoomPartitionFilter = {
  /** Every related `RoomPartition` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionFilter>;
  /** No related `RoomPartition` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionFilter>;
  /** Some related `RoomPartition` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionFilter>;
};

/** A filter to be used against many `RoomPartitionTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type RoomPartitionTypeToManyRoomPartitionTypeAttrFilter = {
  /** Every related `RoomPartitionTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionTypeAttrFilter>;
  /** No related `RoomPartitionTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionTypeAttrFilter>;
  /** Some related `RoomPartitionTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionTypeAttrFilter>;
};

/** A connection to a list of `RoomPartitionType` values. */
export type RoomPartitionTypesConnection = {
  __typename?: 'RoomPartitionTypesConnection';
  /** A list of edges which contains the `RoomPartitionType` and cursor to aid in pagination. */
  edges: Array<RoomPartitionTypesEdge>;
  /** A list of `RoomPartitionType` objects. */
  nodes: Array<RoomPartitionType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartitionType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartitionType` edge in the connection. */
export type RoomPartitionTypesEdge = {
  __typename?: 'RoomPartitionTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartitionType` at the end of the edge. */
  node: RoomPartitionType;
};

/** Methods to use when ordering `RoomPartitionType`. */
export enum RoomPartitionTypesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomPartitionsByTypeIdCountAsc = 'ROOM_PARTITIONS_BY_TYPE_ID__COUNT_ASC',
  RoomPartitionsByTypeIdCountDesc = 'ROOM_PARTITIONS_BY_TYPE_ID__COUNT_DESC',
  RoomPartitionTypeAttrsByRoomPartitionTypeIdCountAsc = 'ROOM_PARTITION_TYPE_ATTRS_BY_ROOM_PARTITION_TYPE_ID__COUNT_ASC',
  RoomPartitionTypeAttrsByRoomPartitionTypeIdCountDesc = 'ROOM_PARTITION_TYPE_ATTRS_BY_ROOM_PARTITION_TYPE_ID__COUNT_DESC'
}

/** A connection to a list of `RoomPartition` values. */
export type RoomPartitionsConnection = {
  __typename?: 'RoomPartitionsConnection';
  /** A list of edges which contains the `RoomPartition` and cursor to aid in pagination. */
  edges: Array<RoomPartitionsEdge>;
  /** A list of `RoomPartition` objects. */
  nodes: Array<RoomPartition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPartition` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPartition` edge in the connection. */
export type RoomPartitionsEdge = {
  __typename?: 'RoomPartitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPartition` at the end of the edge. */
  node: RoomPartition;
};

/** Methods to use when ordering `RoomPartition`. */
export enum RoomPartitionsOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  RoomPartitionCadGrossSpaceMinsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_GROSS_SPACE_MINS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadGrossSpaceMinsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_GROSS_SPACE_MINS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCadHeightMaxesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_HEIGHT_MAXES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadHeightMaxesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_HEIGHT_MAXES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCadHeightMinsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_HEIGHT_MINS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadHeightMinsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_HEIGHT_MINS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCadLengthMaxesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_LENGTH_MAXES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadLengthMaxesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_LENGTH_MAXES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCadLengthMinsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_LENGTH_MINS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadLengthMinsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_LENGTH_MINS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCadWidthMaxesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_WIDTH_MAXES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadWidthMaxesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_WIDTH_MAXES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCadWidthMinsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAD_WIDTH_MINS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCadWidthMinsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAD_WIDTH_MINS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCapacityPaxesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CAPACITY_PAXES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCapacityPaxesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CAPACITY_PAXES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionCleaningGrossSpacesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_CLEANING_GROSS_SPACES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionCleaningGrossSpacesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_CLEANING_GROSS_SPACES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionDescriptionsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_DESCRIPTIONS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionDescriptionsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_DESCRIPTIONS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameExtrasByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_EXTRAS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameExtrasByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_EXTRAS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameKeyCadsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_KEY_CADS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameKeyCadsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_KEY_CADS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameKeyCafmsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_KEY_CAFMS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameKeyCafmsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_KEY_CAFMS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameKeyEbmsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_KEY_EBMS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameKeyEbmsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_KEY_EBMS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameKeyMarketingsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_KEY_MARKETINGS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameKeyMarketingsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_KEY_MARKETINGS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameLongsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_LONGS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameLongsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_LONGS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionNameShortsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_NAME_SHORTS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionNameShortsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_NAME_SHORTS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionPublicGrossSpacesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_PUBLIC_GROSS_SPACES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionPublicGrossSpacesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_PUBLIC_GROSS_SPACES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionSbvGrossSpacesByRoomPartitionIdCountAsc = 'ROOM_PARTITION_SBV_GROSS_SPACES_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionSbvGrossSpacesByRoomPartitionIdCountDesc = 'ROOM_PARTITION_SBV_GROSS_SPACES_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionTypeAttrsByRoomPartitionIdCountAsc = 'ROOM_PARTITION_TYPE_ATTRS_BY_ROOM_PARTITION_ID__COUNT_ASC',
  RoomPartitionTypeAttrsByRoomPartitionIdCountDesc = 'ROOM_PARTITION_TYPE_ATTRS_BY_ROOM_PARTITION_ID__COUNT_DESC',
  RoomPartitionTypeByTypeIdDescriptionAsc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  RoomPartitionTypeByTypeIdDescriptionDesc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  RoomPartitionTypeByTypeIdIdAsc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__ID_ASC',
  RoomPartitionTypeByTypeIdIdDesc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__ID_DESC',
  RoomPartitionTypeByTypeIdIndexAsc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__INDEX_ASC',
  RoomPartitionTypeByTypeIdIndexDesc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__INDEX_DESC',
  RoomPartitionTypeByTypeIdNameAsc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__NAME_ASC',
  RoomPartitionTypeByTypeIdNameDesc = 'ROOM_PARTITION_TYPE_BY_TYPE_ID__NAME_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

/** Represents an update to a `Room`. Fields that are set will be updated. */
export type RoomPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type RoomPhoneNumber = {
  __typename?: 'RoomPhoneNumber';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomPhoneNumber`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `RoomPhoneNumber` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomPhoneNumberCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomPhoneNumber` object types. All fields are combined with a logical ‘and.’ */
export type RoomPhoneNumberFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPhoneNumberFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPhoneNumberFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPhoneNumberFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoomPhoneNumber` */
export type RoomPhoneNumberInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `roomPhoneNumber` to look up the row to update. */
export type RoomPhoneNumberOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomPhoneNumbersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPhoneNumber` being updated. */
  patch: UpdateRoomPhoneNumberOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyPatch;
};

/** Represents an update to a `RoomPhoneNumber`. Fields that are set will be updated. */
export type RoomPhoneNumberPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `roomPhoneNumber` to look up the row to connect. */
export type RoomPhoneNumberRoomPhoneNumbersPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPhoneNumber` to look up the row to delete. */
export type RoomPhoneNumberRoomPhoneNumbersPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPhoneNumber` values. */
export type RoomPhoneNumbersConnection = {
  __typename?: 'RoomPhoneNumbersConnection';
  /** A list of edges which contains the `RoomPhoneNumber` and cursor to aid in pagination. */
  edges: Array<RoomPhoneNumbersEdge>;
  /** A list of `RoomPhoneNumber` objects. */
  nodes: Array<RoomPhoneNumber>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPhoneNumber` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPhoneNumber` edge in the connection. */
export type RoomPhoneNumbersEdge = {
  __typename?: 'RoomPhoneNumbersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPhoneNumber` at the end of the edge. */
  node: RoomPhoneNumber;
};

/** Methods to use when ordering `RoomPhoneNumber`. */
export enum RoomPhoneNumbersOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `room` in the `RoomPhoneNumberInput` mutation. */
export type RoomPhoneNumbersRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPhoneNumbersRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPhoneNumber` in the `RoomInput` mutation. */
export type RoomPhoneNumbersRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomPhoneNumber` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPhoneNumberRoomPhoneNumbersPkeyConnect>>;
  /** A `RoomPhoneNumberInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPhoneNumbersRoomIdFkeyRoomPhoneNumbersCreateInput>>;
  /** The primary key(s) for `roomPhoneNumber` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPhoneNumberRoomPhoneNumbersPkeyDelete>>;
  /** Flag indicating whether all other `roomPhoneNumber` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPhoneNumber` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPhoneNumberOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyUsingRoomPhoneNumbersPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomPhoneNumbersRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPhoneNumber` to be created by this mutation. */
export type RoomPhoneNumbersRoomIdFkeyRoomPhoneNumbersCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type RoomPublicGrossSpace = {
  __typename?: 'RoomPublicGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomPublicGrossSpace`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomPublicGrossSpace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomPublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomPublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomPublicGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomPublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomPublicGrossSpaceFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomPublicGrossSpace` */
export type RoomPublicGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPublicGrossSpace` to look up the row to update. */
export type RoomPublicGrossSpaceOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomPublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomPublicGrossSpace` being updated. */
  patch: UpdateRoomPublicGrossSpaceOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyPatch;
};

/** Represents an update to a `RoomPublicGrossSpace`. Fields that are set will be updated. */
export type RoomPublicGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomPublicGrossSpaceInput` mutation. */
export type RoomPublicGrossSpaceRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomPublicGrossSpace` in the `RoomInput` mutation. */
export type RoomPublicGrossSpaceRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomPublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomPublicGrossSpaceRoomPublicGrossSpacePkeyConnect>>;
  /** A `RoomPublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomPublicGrossSpaceRoomIdFkeyRoomPublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `roomPublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomPublicGrossSpaceRoomPublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `roomPublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomPublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomPublicGrossSpaceOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyUsingRoomPublicGrossSpacePkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomPublicGrossSpaceRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomPublicGrossSpace` to be created by this mutation. */
export type RoomPublicGrossSpaceRoomIdFkeyRoomPublicGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomPublicGrossSpace` to look up the row to connect. */
export type RoomPublicGrossSpaceRoomPublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomPublicGrossSpace` to look up the row to delete. */
export type RoomPublicGrossSpaceRoomPublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomPublicGrossSpace` values. */
export type RoomPublicGrossSpacesConnection = {
  __typename?: 'RoomPublicGrossSpacesConnection';
  /** A list of edges which contains the `RoomPublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<RoomPublicGrossSpacesEdge>;
  /** A list of `RoomPublicGrossSpace` objects. */
  nodes: Array<RoomPublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomPublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomPublicGrossSpace` edge in the connection. */
export type RoomPublicGrossSpacesEdge = {
  __typename?: 'RoomPublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomPublicGrossSpace` at the end of the edge. */
  node: RoomPublicGrossSpace;
};

/** Methods to use when ordering `RoomPublicGrossSpace`. */
export enum RoomPublicGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `room` to look up the row to connect. */
export type RoomRoomExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `room` to look up the row to delete. */
export type RoomRoomExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `room` to look up the row to connect. */
export type RoomRoomNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `room` to look up the row to delete. */
export type RoomRoomNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `room` to look up the row to connect. */
export type RoomRoomPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `room` to look up the row to delete. */
export type RoomRoomPkeyDelete = {
  id: Scalars['UUID'];
};

export type RoomSbvGrossSpace = {
  __typename?: 'RoomSbvGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomSbvGrossSpace`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomSbvGrossSpace` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomSbvGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomSbvGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomSbvGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomSbvGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomSbvGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomSbvGrossSpaceFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomSbvGrossSpace` */
export type RoomSbvGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomSbvGrossSpace` to look up the row to update. */
export type RoomSbvGrossSpaceOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomSbvGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomSbvGrossSpace` being updated. */
  patch: UpdateRoomSbvGrossSpaceOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyPatch;
};

/** Represents an update to a `RoomSbvGrossSpace`. Fields that are set will be updated. */
export type RoomSbvGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomSbvGrossSpaceInput` mutation. */
export type RoomSbvGrossSpaceRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomSbvGrossSpace` in the `RoomInput` mutation. */
export type RoomSbvGrossSpaceRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomSbvGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomSbvGrossSpaceRoomSbvGrossSpacePkeyConnect>>;
  /** A `RoomSbvGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomSbvGrossSpaceRoomIdFkeyRoomSbvGrossSpaceCreateInput>>;
  /** The primary key(s) for `roomSbvGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomSbvGrossSpaceRoomSbvGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `roomSbvGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomSbvGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomSbvGrossSpaceOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyUsingRoomSbvGrossSpacePkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomSbvGrossSpaceRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomSbvGrossSpace` to be created by this mutation. */
export type RoomSbvGrossSpaceRoomIdFkeyRoomSbvGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomSbvGrossSpace` to look up the row to connect. */
export type RoomSbvGrossSpaceRoomSbvGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomSbvGrossSpace` to look up the row to delete. */
export type RoomSbvGrossSpaceRoomSbvGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomSbvGrossSpace` values. */
export type RoomSbvGrossSpacesConnection = {
  __typename?: 'RoomSbvGrossSpacesConnection';
  /** A list of edges which contains the `RoomSbvGrossSpace` and cursor to aid in pagination. */
  edges: Array<RoomSbvGrossSpacesEdge>;
  /** A list of `RoomSbvGrossSpace` objects. */
  nodes: Array<RoomSbvGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomSbvGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomSbvGrossSpace` edge in the connection. */
export type RoomSbvGrossSpacesEdge = {
  __typename?: 'RoomSbvGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomSbvGrossSpace` at the end of the edge. */
  node: RoomSbvGrossSpace;
};

/** Methods to use when ordering `RoomSbvGrossSpace`. */
export enum RoomSbvGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomTireLoadCar = {
  __typename?: 'RoomTireLoadCar';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomTireLoadCar`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomTireLoadCar` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomTireLoadCarCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomTireLoadCar` object types. All fields are combined with a logical ‘and.’ */
export type RoomTireLoadCarFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomTireLoadCarFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomTireLoadCarFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomTireLoadCarFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomTireLoadCar` */
export type RoomTireLoadCarInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomTireLoadCar` to look up the row to update. */
export type RoomTireLoadCarOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomTireLoadCarPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomTireLoadCar` being updated. */
  patch: UpdateRoomTireLoadCarOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyPatch;
};

/** Represents an update to a `RoomTireLoadCar`. Fields that are set will be updated. */
export type RoomTireLoadCarPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomTireLoadCarInput` mutation. */
export type RoomTireLoadCarRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomTireLoadCarRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomTireLoadCar` in the `RoomInput` mutation. */
export type RoomTireLoadCarRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomTireLoadCar` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomTireLoadCarRoomTireLoadCarPkeyConnect>>;
  /** A `RoomTireLoadCarInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomTireLoadCarRoomIdFkeyRoomTireLoadCarCreateInput>>;
  /** The primary key(s) for `roomTireLoadCar` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomTireLoadCarRoomTireLoadCarPkeyDelete>>;
  /** Flag indicating whether all other `roomTireLoadCar` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomTireLoadCar` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomTireLoadCarOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyUsingRoomTireLoadCarPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomTireLoadCarRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomTireLoadCar` to be created by this mutation. */
export type RoomTireLoadCarRoomIdFkeyRoomTireLoadCarCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomTireLoadCar` to look up the row to connect. */
export type RoomTireLoadCarRoomTireLoadCarPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomTireLoadCar` to look up the row to delete. */
export type RoomTireLoadCarRoomTireLoadCarPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomTireLoadCar` values. */
export type RoomTireLoadCarsConnection = {
  __typename?: 'RoomTireLoadCarsConnection';
  /** A list of edges which contains the `RoomTireLoadCar` and cursor to aid in pagination. */
  edges: Array<RoomTireLoadCarsEdge>;
  /** A list of `RoomTireLoadCar` objects. */
  nodes: Array<RoomTireLoadCar>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomTireLoadCar` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomTireLoadCar` edge in the connection. */
export type RoomTireLoadCarsEdge = {
  __typename?: 'RoomTireLoadCarsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomTireLoadCar` at the end of the edge. */
  node: RoomTireLoadCar;
};

/** Methods to use when ordering `RoomTireLoadCar`. */
export enum RoomTireLoadCarsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomTireLoadForklift = {
  __typename?: 'RoomTireLoadForklift';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomTireLoadForklift`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomTireLoadForklift` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoomTireLoadForkliftCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomTireLoadForklift` object types. All fields are combined with a logical ‘and.’ */
export type RoomTireLoadForkliftFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomTireLoadForkliftFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomTireLoadForkliftFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomTireLoadForkliftFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomTireLoadForklift` */
export type RoomTireLoadForkliftInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomTireLoadForklift` to look up the row to update. */
export type RoomTireLoadForkliftOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomTireLoadForkliftPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomTireLoadForklift` being updated. */
  patch: UpdateRoomTireLoadForkliftOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyPatch;
};

/** Represents an update to a `RoomTireLoadForklift`. Fields that are set will be updated. */
export type RoomTireLoadForkliftPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomTireLoadForkliftInput` mutation. */
export type RoomTireLoadForkliftRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomTireLoadForklift` in the `RoomInput` mutation. */
export type RoomTireLoadForkliftRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomTireLoadForklift` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomTireLoadForkliftRoomTireLoadForkliftPkeyConnect>>;
  /** A `RoomTireLoadForkliftInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomTireLoadForkliftRoomIdFkeyRoomTireLoadForkliftCreateInput>>;
  /** The primary key(s) for `roomTireLoadForklift` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomTireLoadForkliftRoomTireLoadForkliftPkeyDelete>>;
  /** Flag indicating whether all other `roomTireLoadForklift` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomTireLoadForklift` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomTireLoadForkliftOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyUsingRoomTireLoadForkliftPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomTireLoadForkliftRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomTireLoadForklift` to be created by this mutation. */
export type RoomTireLoadForkliftRoomIdFkeyRoomTireLoadForkliftCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomTireLoadForklift` to look up the row to connect. */
export type RoomTireLoadForkliftRoomTireLoadForkliftPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomTireLoadForklift` to look up the row to delete. */
export type RoomTireLoadForkliftRoomTireLoadForkliftPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomTireLoadForklift` values. */
export type RoomTireLoadForkliftsConnection = {
  __typename?: 'RoomTireLoadForkliftsConnection';
  /** A list of edges which contains the `RoomTireLoadForklift` and cursor to aid in pagination. */
  edges: Array<RoomTireLoadForkliftsEdge>;
  /** A list of `RoomTireLoadForklift` objects. */
  nodes: Array<RoomTireLoadForklift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomTireLoadForklift` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomTireLoadForklift` edge in the connection. */
export type RoomTireLoadForkliftsEdge = {
  __typename?: 'RoomTireLoadForkliftsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomTireLoadForklift` at the end of the edge. */
  node: RoomTireLoadForklift;
};

/** Methods to use when ordering `RoomTireLoadForklift`. */
export enum RoomTireLoadForkliftsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type RoomTireLoadTruck = {
  __typename?: 'RoomTireLoadTruck';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomTireLoadTruck`. */
  room: Room;
  roomId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/**
 * A condition to be used against `RoomTireLoadTruck` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomTireLoadTruckCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** A filter to be used against `RoomTireLoadTruck` object types. All fields are combined with a logical ‘and.’ */
export type RoomTireLoadTruckFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomTireLoadTruckFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomTireLoadTruckFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomTireLoadTruckFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `RoomTireLoadTruck` */
export type RoomTireLoadTruckInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomTireLoadTruck` to look up the row to update. */
export type RoomTireLoadTruckOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomTireLoadTruckPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomTireLoadTruck` being updated. */
  patch: UpdateRoomTireLoadTruckOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyPatch;
};

/** Represents an update to a `RoomTireLoadTruck`. Fields that are set will be updated. */
export type RoomTireLoadTruckPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** Input for the nested mutation of `room` in the `RoomTireLoadTruckInput` mutation. */
export type RoomTireLoadTruckRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomTireLoadTruckRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomTireLoadTruck` in the `RoomInput` mutation. */
export type RoomTireLoadTruckRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomTireLoadTruck` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomTireLoadTruckRoomTireLoadTruckPkeyConnect>>;
  /** A `RoomTireLoadTruckInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomTireLoadTruckRoomIdFkeyRoomTireLoadTruckCreateInput>>;
  /** The primary key(s) for `roomTireLoadTruck` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomTireLoadTruckRoomTireLoadTruckPkeyDelete>>;
  /** Flag indicating whether all other `roomTireLoadTruck` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomTireLoadTruck` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomTireLoadTruckOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyUsingRoomTireLoadTruckPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomTireLoadTruckRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomTireLoadTruck` to be created by this mutation. */
export type RoomTireLoadTruckRoomIdFkeyRoomTireLoadTruckCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
};

/** The fields on `roomTireLoadTruck` to look up the row to connect. */
export type RoomTireLoadTruckRoomTireLoadTruckPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomTireLoadTruck` to look up the row to delete. */
export type RoomTireLoadTruckRoomTireLoadTruckPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `RoomTireLoadTruck` values. */
export type RoomTireLoadTrucksConnection = {
  __typename?: 'RoomTireLoadTrucksConnection';
  /** A list of edges which contains the `RoomTireLoadTruck` and cursor to aid in pagination. */
  edges: Array<RoomTireLoadTrucksEdge>;
  /** A list of `RoomTireLoadTruck` objects. */
  nodes: Array<RoomTireLoadTruck>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomTireLoadTruck` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomTireLoadTruck` edge in the connection. */
export type RoomTireLoadTrucksEdge = {
  __typename?: 'RoomTireLoadTrucksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomTireLoadTruck` at the end of the edge. */
  node: RoomTireLoadTruck;
};

/** Methods to use when ordering `RoomTireLoadTruck`. */
export enum RoomTireLoadTrucksOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against many `AllocationRoom` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyAllocationRoomFilter = {
  /** Every related `AllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AllocationRoomFilter>;
  /** No related `AllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AllocationRoomFilter>;
  /** Some related `AllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AllocationRoomFilter>;
};

/** A filter to be used against many `ProjectAllocationRoom` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyProjectAllocationRoomFilter = {
  /** Every related `ProjectAllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectAllocationRoomFilter>;
  /** No related `ProjectAllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectAllocationRoomFilter>;
  /** Some related `ProjectAllocationRoom` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectAllocationRoomFilter>;
};

/** A filter to be used against many `RoomAirChangeRate` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomAirChangeRateFilter = {
  /** Every related `RoomAirChangeRate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomAirChangeRateFilter>;
  /** No related `RoomAirChangeRate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomAirChangeRateFilter>;
  /** Some related `RoomAirChangeRate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomAirChangeRateFilter>;
};

/** A filter to be used against many `RoomAirConditioning` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomAirConditioningFilter = {
  /** Every related `RoomAirConditioning` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomAirConditioningFilter>;
  /** No related `RoomAirConditioning` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomAirConditioningFilter>;
  /** Some related `RoomAirConditioning` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomAirConditioningFilter>;
};

/** A filter to be used against many `RoomCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadGrossSpaceMinFilter = {
  /** Every related `RoomCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadGrossSpaceMinFilter>;
  /** No related `RoomCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadGrossSpaceMinFilter>;
  /** Some related `RoomCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadGrossSpaceMinFilter>;
};

/** A filter to be used against many `RoomCadHeightMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadHeightMaxFilter = {
  /** Every related `RoomCadHeightMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadHeightMaxFilter>;
  /** No related `RoomCadHeightMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadHeightMaxFilter>;
  /** Some related `RoomCadHeightMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadHeightMaxFilter>;
};

/** A filter to be used against many `RoomCadHeightMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadHeightMinFilter = {
  /** Every related `RoomCadHeightMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadHeightMinFilter>;
  /** No related `RoomCadHeightMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadHeightMinFilter>;
  /** Some related `RoomCadHeightMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadHeightMinFilter>;
};

/** A filter to be used against many `RoomCadLengthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadLengthMaxFilter = {
  /** Every related `RoomCadLengthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadLengthMaxFilter>;
  /** No related `RoomCadLengthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadLengthMaxFilter>;
  /** Some related `RoomCadLengthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadLengthMaxFilter>;
};

/** A filter to be used against many `RoomCadLengthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadLengthMinFilter = {
  /** Every related `RoomCadLengthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadLengthMinFilter>;
  /** No related `RoomCadLengthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadLengthMinFilter>;
  /** Some related `RoomCadLengthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadLengthMinFilter>;
};

/** A filter to be used against many `RoomCadWidthMax` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadWidthMaxFilter = {
  /** Every related `RoomCadWidthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadWidthMaxFilter>;
  /** No related `RoomCadWidthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadWidthMaxFilter>;
  /** Some related `RoomCadWidthMax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadWidthMaxFilter>;
};

/** A filter to be used against many `RoomCadWidthMin` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCadWidthMinFilter = {
  /** Every related `RoomCadWidthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCadWidthMinFilter>;
  /** No related `RoomCadWidthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCadWidthMinFilter>;
  /** Some related `RoomCadWidthMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCadWidthMinFilter>;
};

/** A filter to be used against many `RoomCapacityCar` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCapacityCarFilter = {
  /** Every related `RoomCapacityCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCapacityCarFilter>;
  /** No related `RoomCapacityCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCapacityCarFilter>;
  /** Some related `RoomCapacityCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCapacityCarFilter>;
};

/** A filter to be used against many `RoomCapacityPax` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCapacityPaxFilter = {
  /** Every related `RoomCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCapacityPaxFilter>;
  /** No related `RoomCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCapacityPaxFilter>;
  /** Some related `RoomCapacityPax` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCapacityPaxFilter>;
};

/** A filter to be used against many `RoomCapacityTruck` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCapacityTruckFilter = {
  /** Every related `RoomCapacityTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCapacityTruckFilter>;
  /** No related `RoomCapacityTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCapacityTruckFilter>;
  /** Some related `RoomCapacityTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCapacityTruckFilter>;
};

/** A filter to be used against many `RoomCleaningGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomCleaningGrossSpaceFilter = {
  /** Every related `RoomCleaningGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomCleaningGrossSpaceFilter>;
  /** No related `RoomCleaningGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomCleaningGrossSpaceFilter>;
  /** Some related `RoomCleaningGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomCleaningGrossSpaceFilter>;
};

/** A filter to be used against many `RoomClearanceConstruction` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomClearanceConstructionFilter = {
  /** Every related `RoomClearanceConstruction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomClearanceConstructionFilter>;
  /** No related `RoomClearanceConstruction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomClearanceConstructionFilter>;
  /** Some related `RoomClearanceConstruction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomClearanceConstructionFilter>;
};

/** A filter to be used against many `RoomContactBooking` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomContactBookingFilter = {
  /** Every related `RoomContactBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomContactBookingFilter>;
  /** No related `RoomContactBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomContactBookingFilter>;
  /** Some related `RoomContactBooking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomContactBookingFilter>;
};

/** A filter to be used against many `RoomDaylight` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomDaylightFilter = {
  /** Every related `RoomDaylight` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomDaylightFilter>;
  /** No related `RoomDaylight` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomDaylightFilter>;
  /** Some related `RoomDaylight` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomDaylightFilter>;
};

/** A filter to be used against many `RoomDescription` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomDescriptionFilter = {
  /** Every related `RoomDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomDescriptionFilter>;
  /** No related `RoomDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomDescriptionFilter>;
  /** Some related `RoomDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomDescriptionFilter>;
};

/** A filter to be used against many `RoomKeyIssuance` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomKeyIssuanceFilter = {
  /** Every related `RoomKeyIssuance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomKeyIssuanceFilter>;
  /** No related `RoomKeyIssuance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomKeyIssuanceFilter>;
  /** Some related `RoomKeyIssuance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomKeyIssuanceFilter>;
};

/** A filter to be used against many `RoomKeyIssuanceNote` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomKeyIssuanceNoteFilter = {
  /** Every related `RoomKeyIssuanceNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomKeyIssuanceNoteFilter>;
  /** No related `RoomKeyIssuanceNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomKeyIssuanceNoteFilter>;
  /** Some related `RoomKeyIssuanceNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomKeyIssuanceNoteFilter>;
};

/** A filter to be used against many `RoomLightShutter` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomLightShutterFilter = {
  /** Every related `RoomLightShutter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomLightShutterFilter>;
  /** No related `RoomLightShutter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomLightShutterFilter>;
  /** Some related `RoomLightShutter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomLightShutterFilter>;
};

/** A filter to be used against many `RoomMaxLoadCeiling` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomMaxLoadCeilingFilter = {
  /** Every related `RoomMaxLoadCeiling` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomMaxLoadCeilingFilter>;
  /** No related `RoomMaxLoadCeiling` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomMaxLoadCeilingFilter>;
  /** Some related `RoomMaxLoadCeiling` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomMaxLoadCeilingFilter>;
};

/** A filter to be used against many `RoomMaxLoadFloor` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomMaxLoadFloorFilter = {
  /** Every related `RoomMaxLoadFloor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomMaxLoadFloorFilter>;
  /** No related `RoomMaxLoadFloor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomMaxLoadFloorFilter>;
  /** Some related `RoomMaxLoadFloor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomMaxLoadFloorFilter>;
};

/** A filter to be used against many `RoomNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameExtraFilter = {
  /** Every related `RoomNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameExtraFilter>;
  /** No related `RoomNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameExtraFilter>;
  /** Some related `RoomNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameExtraFilter>;
};

/** A filter to be used against many `RoomNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameKeyCadFilter = {
  /** Every related `RoomNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameKeyCadFilter>;
  /** No related `RoomNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameKeyCadFilter>;
  /** Some related `RoomNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameKeyCadFilter>;
};

/** A filter to be used against many `RoomNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameKeyCafmFilter = {
  /** Every related `RoomNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameKeyCafmFilter>;
  /** No related `RoomNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameKeyCafmFilter>;
  /** Some related `RoomNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameKeyCafmFilter>;
};

/** A filter to be used against many `RoomNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameKeyEbmFilter = {
  /** Every related `RoomNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameKeyEbmFilter>;
  /** No related `RoomNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameKeyEbmFilter>;
  /** Some related `RoomNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameKeyEbmFilter>;
};

/** A filter to be used against many `RoomNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameKeyMarketingFilter = {
  /** Every related `RoomNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameKeyMarketingFilter>;
  /** No related `RoomNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameKeyMarketingFilter>;
  /** Some related `RoomNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameKeyMarketingFilter>;
};

/** A filter to be used against many `RoomNameLong` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameLongFilter = {
  /** Every related `RoomNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameLongFilter>;
  /** No related `RoomNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameLongFilter>;
  /** Some related `RoomNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameLongFilter>;
};

/** A filter to be used against many `RoomNameShort` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNameShortFilter = {
  /** Every related `RoomNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNameShortFilter>;
  /** No related `RoomNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNameShortFilter>;
  /** Some related `RoomNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNameShortFilter>;
};

/** A filter to be used against many `RoomNoVehicle` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomNoVehicleFilter = {
  /** Every related `RoomNoVehicle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomNoVehicleFilter>;
  /** No related `RoomNoVehicle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomNoVehicleFilter>;
  /** Some related `RoomNoVehicle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomNoVehicleFilter>;
};

/** A filter to be used against many `RoomPartition` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomPartitionFilter = {
  /** Every related `RoomPartition` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPartitionFilter>;
  /** No related `RoomPartition` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPartitionFilter>;
  /** Some related `RoomPartition` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPartitionFilter>;
};

/** A filter to be used against many `RoomPhoneNumber` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomPhoneNumberFilter = {
  /** Every related `RoomPhoneNumber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPhoneNumberFilter>;
  /** No related `RoomPhoneNumber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPhoneNumberFilter>;
  /** Some related `RoomPhoneNumber` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPhoneNumberFilter>;
};

/** A filter to be used against many `RoomPublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomPublicGrossSpaceFilter = {
  /** Every related `RoomPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomPublicGrossSpaceFilter>;
  /** No related `RoomPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomPublicGrossSpaceFilter>;
  /** Some related `RoomPublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomPublicGrossSpaceFilter>;
};

/** A filter to be used against many `RoomSbvGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomSbvGrossSpaceFilter = {
  /** Every related `RoomSbvGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomSbvGrossSpaceFilter>;
  /** No related `RoomSbvGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomSbvGrossSpaceFilter>;
  /** Some related `RoomSbvGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomSbvGrossSpaceFilter>;
};

/** A filter to be used against many `RoomTireLoadCar` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomTireLoadCarFilter = {
  /** Every related `RoomTireLoadCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomTireLoadCarFilter>;
  /** No related `RoomTireLoadCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomTireLoadCarFilter>;
  /** Some related `RoomTireLoadCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomTireLoadCarFilter>;
};

/** A filter to be used against many `RoomTireLoadForklift` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomTireLoadForkliftFilter = {
  /** Every related `RoomTireLoadForklift` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomTireLoadForkliftFilter>;
  /** No related `RoomTireLoadForklift` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomTireLoadForkliftFilter>;
  /** Some related `RoomTireLoadForklift` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomTireLoadForkliftFilter>;
};

/** A filter to be used against many `RoomTireLoadTruck` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomTireLoadTruckFilter = {
  /** Every related `RoomTireLoadTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomTireLoadTruckFilter>;
  /** No related `RoomTireLoadTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomTireLoadTruckFilter>;
  /** Some related `RoomTireLoadTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomTireLoadTruckFilter>;
};

/** A filter to be used against many `RoomTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type RoomToManyRoomTypeAttrFilter = {
  /** Every related `RoomTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomTypeAttrFilter>;
  /** No related `RoomTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomTypeAttrFilter>;
  /** Some related `RoomTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomTypeAttrFilter>;
};

export type RoomType = {
  __typename?: 'RoomType';
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `RoomTypeAttr`. */
  roomTypeAttrs: RoomTypeAttrsConnection;
  /** Reads and enables pagination through a set of `Room`. */
  roomsByTypeId: RoomsConnection;
};


export type RoomTypeRoomTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomTypeAttrCondition>;
  filter?: InputMaybe<RoomTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomTypeAttrsOrderBy>>;
};


export type RoomTypeRoomsByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoomCondition>;
  filter?: InputMaybe<RoomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoomsOrderBy>>;
};

export type RoomTypeAttr = {
  __typename?: 'RoomTypeAttr';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Room` that is related to this `RoomTypeAttr`. */
  room: Room;
  roomId: Scalars['UUID'];
  /** Reads a single `RoomType` that is related to this `RoomTypeAttr`. */
  roomType: RoomType;
  roomTypeId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `RoomTypeAttr` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoomTypeAttrCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomId` field. */
  roomId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roomTypeId` field. */
  roomTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `RoomTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type RoomTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomTypeAttrFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomTypeAttrFilter>>;
  /** Filter by the object’s `room` relation. */
  room?: InputMaybe<RoomFilter>;
  /** Filter by the object’s `roomId` field. */
  roomId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `roomType` relation. */
  roomType?: InputMaybe<RoomTypeFilter>;
  /** Filter by the object’s `roomTypeId` field. */
  roomTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `RoomTypeAttr` */
export type RoomTypeAttrInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTypeAttrRoomIdFkeyInput>;
  roomTypeId?: InputMaybe<Scalars['UUID']>;
  roomTypeToRoomTypeId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `roomTypeAttr` to look up the row to update. */
export type RoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomTypeAttr` being updated. */
  patch: UpdateRoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyPatch;
};

/** The fields on `roomTypeAttr` to look up the row to update. */
export type RoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyUsingRoomTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomTypeAttr` being updated. */
  patch: UpdateRoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyPatch;
};

/** Represents an update to a `RoomTypeAttr`. Fields that are set will be updated. */
export type RoomTypeAttrPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTypeAttrRoomIdFkeyInput>;
  roomTypeId?: InputMaybe<Scalars['UUID']>;
  roomTypeToRoomTypeId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `room` in the `RoomTypeAttrInput` mutation. */
export type RoomTypeAttrRoomIdFkeyInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<RoomRoomExtIdKeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<RoomRoomPkeyConnect>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<RoomRoomNameShortKeyConnect>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomTypeAttrRoomIdFkeyRoomCreateInput>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<RoomRoomExtIdKeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomRoomPkeyDelete>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<RoomRoomNameShortKeyDelete>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<RoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<RoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomPkeyUpdate>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<RoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomNameShortKeyUpdate>;
};

/** Input for the nested mutation of `roomTypeAttr` in the `RoomInput` mutation. */
export type RoomTypeAttrRoomIdFkeyInverseInput = {
  /** The primary key(s) for `roomTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomTypeAttrRoomTypeAttrPkeyConnect>>;
  /** A `RoomTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomTypeAttrRoomIdFkeyRoomTypeAttrCreateInput>>;
  /** The primary key(s) for `roomTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomTypeAttrRoomTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `roomTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyUsingRoomTypeAttrPkeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomTypeAttrRoomIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** The `roomTypeAttr` to be created by this mutation. */
export type RoomTypeAttrRoomIdFkeyRoomTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTypeAttrRoomIdFkeyInput>;
  roomTypeId?: InputMaybe<Scalars['UUID']>;
  roomTypeToRoomTypeId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `roomTypeAttr` to look up the row to connect. */
export type RoomTypeAttrRoomTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomTypeAttr` to look up the row to delete. */
export type RoomTypeAttrRoomTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `roomType` in the `RoomTypeAttrInput` mutation. */
export type RoomTypeAttrRoomTypeIdFkeyInput = {
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  connectById?: InputMaybe<RoomTypeRoomTypePkeyConnect>;
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  connectByName?: InputMaybe<RoomTypeRoomTypeNameKeyConnect>;
  /** A `RoomTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyRoomTypeCreateInput>;
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomTypeRoomTypePkeyDelete>;
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  deleteByName?: InputMaybe<RoomTypeRoomTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `roomType` for the far side of the relationship. */
  updateById?: InputMaybe<RoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyUsingRoomTypePkeyUpdate>;
  /** The primary key(s) and patch data for `roomType` for the far side of the relationship. */
  updateByName?: InputMaybe<RoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyUsingRoomTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `roomTypeAttr` in the `RoomTypeInput` mutation. */
export type RoomTypeAttrRoomTypeIdFkeyInverseInput = {
  /** The primary key(s) for `roomTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomTypeAttrRoomTypeAttrPkeyConnect>>;
  /** A `RoomTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomTypeAttrRoomTypeIdFkeyRoomTypeAttrCreateInput>>;
  /** The primary key(s) for `roomTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomTypeAttrRoomTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `roomTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roomTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyUsingRoomTypeAttrPkeyUpdate>>;
};

/** The `roomTypeAttr` to be created by this mutation. */
export type RoomTypeAttrRoomTypeIdFkeyRoomTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTypeAttrRoomIdFkeyInput>;
  roomTypeToRoomTypeId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** The `roomType` to be created by this mutation. */
export type RoomTypeAttrRoomTypeIdFkeyRoomTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInverseInput>;
  roomsUsingId?: InputMaybe<RoomTypeIdFkeyInverseInput>;
};

/** A connection to a list of `RoomTypeAttr` values. */
export type RoomTypeAttrsConnection = {
  __typename?: 'RoomTypeAttrsConnection';
  /** A list of edges which contains the `RoomTypeAttr` and cursor to aid in pagination. */
  edges: Array<RoomTypeAttrsEdge>;
  /** A list of `RoomTypeAttr` objects. */
  nodes: Array<RoomTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomTypeAttr` edge in the connection. */
export type RoomTypeAttrsEdge = {
  __typename?: 'RoomTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomTypeAttr` at the end of the edge. */
  node: RoomTypeAttr;
};

/** Methods to use when ordering `RoomTypeAttr`. */
export enum RoomTypeAttrsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomByRoomIdDescriptionAsc = 'ROOM_BY_ROOM_ID__DESCRIPTION_ASC',
  RoomByRoomIdDescriptionDesc = 'ROOM_BY_ROOM_ID__DESCRIPTION_DESC',
  RoomByRoomIdExtIdAsc = 'ROOM_BY_ROOM_ID__EXT_ID_ASC',
  RoomByRoomIdExtIdDesc = 'ROOM_BY_ROOM_ID__EXT_ID_DESC',
  RoomByRoomIdIdAsc = 'ROOM_BY_ROOM_ID__ID_ASC',
  RoomByRoomIdIdDesc = 'ROOM_BY_ROOM_ID__ID_DESC',
  RoomByRoomIdLevelIdAsc = 'ROOM_BY_ROOM_ID__LEVEL_ID_ASC',
  RoomByRoomIdLevelIdDesc = 'ROOM_BY_ROOM_ID__LEVEL_ID_DESC',
  RoomByRoomIdNameLongAsc = 'ROOM_BY_ROOM_ID__NAME_LONG_ASC',
  RoomByRoomIdNameLongDesc = 'ROOM_BY_ROOM_ID__NAME_LONG_DESC',
  RoomByRoomIdNameShortAsc = 'ROOM_BY_ROOM_ID__NAME_SHORT_ASC',
  RoomByRoomIdNameShortDesc = 'ROOM_BY_ROOM_ID__NAME_SHORT_DESC',
  RoomByRoomIdTypeIdAsc = 'ROOM_BY_ROOM_ID__TYPE_ID_ASC',
  RoomByRoomIdTypeIdDesc = 'ROOM_BY_ROOM_ID__TYPE_ID_DESC',
  RoomIdAsc = 'ROOM_ID_ASC',
  RoomIdDesc = 'ROOM_ID_DESC',
  RoomTypeByRoomTypeIdDescriptionAsc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__DESCRIPTION_ASC',
  RoomTypeByRoomTypeIdDescriptionDesc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__DESCRIPTION_DESC',
  RoomTypeByRoomTypeIdIdAsc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__ID_ASC',
  RoomTypeByRoomTypeIdIdDesc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__ID_DESC',
  RoomTypeByRoomTypeIdIndexAsc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__INDEX_ASC',
  RoomTypeByRoomTypeIdIndexDesc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__INDEX_DESC',
  RoomTypeByRoomTypeIdNameAsc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__NAME_ASC',
  RoomTypeByRoomTypeIdNameDesc = 'ROOM_TYPE_BY_ROOM_TYPE_ID__NAME_DESC',
  RoomTypeIdAsc = 'ROOM_TYPE_ID_ASC',
  RoomTypeIdDesc = 'ROOM_TYPE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

/**
 * A condition to be used against `RoomType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RoomTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoomType` object types. All fields are combined with a logical ‘and.’ */
export type RoomTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoomTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoomTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoomTypeFilter>>;
  /** Filter by the object’s `roomTypeAttrs` relation. */
  roomTypeAttrs?: InputMaybe<RoomTypeToManyRoomTypeAttrFilter>;
  /** Some related `roomTypeAttrs` exist. */
  roomTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roomsByTypeId` relation. */
  roomsByTypeId?: InputMaybe<RoomTypeToManyRoomFilter>;
  /** Some related `roomsByTypeId` exist. */
  roomsByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `roomType` in the `RoomInput` mutation. */
export type RoomTypeIdFkeyInput = {
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  connectById?: InputMaybe<RoomTypeRoomTypePkeyConnect>;
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  connectByName?: InputMaybe<RoomTypeRoomTypeNameKeyConnect>;
  /** A `RoomTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoomTypeIdFkeyRoomTypeCreateInput>;
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  deleteById?: InputMaybe<RoomTypeRoomTypePkeyDelete>;
  /** The primary key(s) for `roomType` for the far side of the relationship. */
  deleteByName?: InputMaybe<RoomTypeRoomTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `roomType` for the far side of the relationship. */
  updateById?: InputMaybe<RoomTypeOnRoomForRoomTypeIdFkeyUsingRoomTypePkeyUpdate>;
  /** The primary key(s) and patch data for `roomType` for the far side of the relationship. */
  updateByName?: InputMaybe<RoomTypeOnRoomForRoomTypeIdFkeyUsingRoomTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `room` in the `RoomTypeInput` mutation. */
export type RoomTypeIdFkeyInverseInput = {
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<RoomRoomExtIdKeyConnect>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoomRoomPkeyConnect>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<RoomRoomNameShortKeyConnect>>;
  /** A `RoomInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoomTypeIdFkeyRoomCreateInput>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<RoomRoomExtIdKeyDelete>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoomRoomPkeyDelete>>;
  /** The primary key(s) for `room` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<RoomRoomNameShortKeyDelete>>;
  /** Flag indicating whether all other `room` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<RoomOnRoomForRoomTypeIdFkeyUsingRoomExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoomOnRoomForRoomTypeIdFkeyUsingRoomPkeyUpdate>>;
  /** The primary key(s) and patch data for `room` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<RoomOnRoomForRoomTypeIdFkeyUsingRoomNameShortKeyUpdate>>;
};

/** The `room` to be created by this mutation. */
export type RoomTypeIdFkeyRoomCreateInput = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
};

/** The `roomType` to be created by this mutation. */
export type RoomTypeIdFkeyRoomTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInverseInput>;
  roomsUsingId?: InputMaybe<RoomTypeIdFkeyInverseInput>;
};

/** An input for mutations affecting `RoomType` */
export type RoomTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInverseInput>;
  roomsUsingId?: InputMaybe<RoomTypeIdFkeyInverseInput>;
};

/** The fields on `roomType` to look up the row to update. */
export type RoomTypeOnRoomForRoomTypeIdFkeyUsingRoomTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `roomType` being updated. */
  patch: UpdateRoomTypeOnRoomForRoomTypeIdFkeyPatch;
};

/** The fields on `roomType` to look up the row to update. */
export type RoomTypeOnRoomForRoomTypeIdFkeyUsingRoomTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomType` being updated. */
  patch: UpdateRoomTypeOnRoomForRoomTypeIdFkeyPatch;
};

/** The fields on `roomType` to look up the row to update. */
export type RoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyUsingRoomTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `roomType` being updated. */
  patch: UpdateRoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyPatch;
};

/** The fields on `roomType` to look up the row to update. */
export type RoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyUsingRoomTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roomType` being updated. */
  patch: UpdateRoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyPatch;
};

/** Represents an update to a `RoomType`. Fields that are set will be updated. */
export type RoomTypePatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInverseInput>;
  roomsUsingId?: InputMaybe<RoomTypeIdFkeyInverseInput>;
};

/** The fields on `roomType` to look up the row to connect. */
export type RoomTypeRoomTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `roomType` to look up the row to delete. */
export type RoomTypeRoomTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `roomType` to look up the row to connect. */
export type RoomTypeRoomTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roomType` to look up the row to delete. */
export type RoomTypeRoomTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Room` object types. All fields are combined with a logical ‘and.’ */
export type RoomTypeToManyRoomFilter = {
  /** Every related `Room` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomFilter>;
  /** No related `Room` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomFilter>;
  /** Some related `Room` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomFilter>;
};

/** A filter to be used against many `RoomTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type RoomTypeToManyRoomTypeAttrFilter = {
  /** Every related `RoomTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoomTypeAttrFilter>;
  /** No related `RoomTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoomTypeAttrFilter>;
  /** Some related `RoomTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoomTypeAttrFilter>;
};

/** A connection to a list of `RoomType` values. */
export type RoomTypesConnection = {
  __typename?: 'RoomTypesConnection';
  /** A list of edges which contains the `RoomType` and cursor to aid in pagination. */
  edges: Array<RoomTypesEdge>;
  /** A list of `RoomType` objects. */
  nodes: Array<RoomType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoomType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoomType` edge in the connection. */
export type RoomTypesEdge = {
  __typename?: 'RoomTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoomType` at the end of the edge. */
  node: RoomType;
};

/** Methods to use when ordering `RoomType`. */
export enum RoomTypesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoomsByTypeIdCountAsc = 'ROOMS_BY_TYPE_ID__COUNT_ASC',
  RoomsByTypeIdCountDesc = 'ROOMS_BY_TYPE_ID__COUNT_DESC',
  RoomTypeAttrsByRoomTypeIdCountAsc = 'ROOM_TYPE_ATTRS_BY_ROOM_TYPE_ID__COUNT_ASC',
  RoomTypeAttrsByRoomTypeIdCountDesc = 'ROOM_TYPE_ATTRS_BY_ROOM_TYPE_ID__COUNT_DESC'
}

/** A connection to a list of `Room` values. */
export type RoomsConnection = {
  __typename?: 'RoomsConnection';
  /** A list of edges which contains the `Room` and cursor to aid in pagination. */
  edges: Array<RoomsEdge>;
  /** A list of `Room` objects. */
  nodes: Array<Room>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Room` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Room` edge in the connection. */
export type RoomsEdge = {
  __typename?: 'RoomsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Room` at the end of the edge. */
  node: Room;
};

/** Methods to use when ordering `Room`. */
export enum RoomsOrderBy {
  AllocationRoomsByRoomIdCountAsc = 'ALLOCATION_ROOMS_BY_ROOM_ID__COUNT_ASC',
  AllocationRoomsByRoomIdCountDesc = 'ALLOCATION_ROOMS_BY_ROOM_ID__COUNT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevelByLevelIdBuildingIdAsc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_ASC',
  LevelByLevelIdBuildingIdDesc = 'LEVEL_BY_LEVEL_ID__BUILDING_ID_DESC',
  LevelByLevelIdDescriptionAsc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_ASC',
  LevelByLevelIdDescriptionDesc = 'LEVEL_BY_LEVEL_ID__DESCRIPTION_DESC',
  LevelByLevelIdElevationIdAsc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_ASC',
  LevelByLevelIdElevationIdDesc = 'LEVEL_BY_LEVEL_ID__ELEVATION_ID_DESC',
  LevelByLevelIdExtIdAsc = 'LEVEL_BY_LEVEL_ID__EXT_ID_ASC',
  LevelByLevelIdExtIdDesc = 'LEVEL_BY_LEVEL_ID__EXT_ID_DESC',
  LevelByLevelIdIdAsc = 'LEVEL_BY_LEVEL_ID__ID_ASC',
  LevelByLevelIdIdDesc = 'LEVEL_BY_LEVEL_ID__ID_DESC',
  LevelByLevelIdNameLongAsc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_ASC',
  LevelByLevelIdNameLongDesc = 'LEVEL_BY_LEVEL_ID__NAME_LONG_DESC',
  LevelByLevelIdNameShortAsc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_ASC',
  LevelByLevelIdNameShortDesc = 'LEVEL_BY_LEVEL_ID__NAME_SHORT_DESC',
  LevelByLevelIdTypeIdAsc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_ASC',
  LevelByLevelIdTypeIdDesc = 'LEVEL_BY_LEVEL_ID__TYPE_ID_DESC',
  LevelIdAsc = 'LEVEL_ID_ASC',
  LevelIdDesc = 'LEVEL_ID_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAllocationRoomsByRoomIdCountAsc = 'PROJECT_ALLOCATION_ROOMS_BY_ROOM_ID__COUNT_ASC',
  ProjectAllocationRoomsByRoomIdCountDesc = 'PROJECT_ALLOCATION_ROOMS_BY_ROOM_ID__COUNT_DESC',
  RoomAirChangeRatesByRoomIdCountAsc = 'ROOM_AIR_CHANGE_RATES_BY_ROOM_ID__COUNT_ASC',
  RoomAirChangeRatesByRoomIdCountDesc = 'ROOM_AIR_CHANGE_RATES_BY_ROOM_ID__COUNT_DESC',
  RoomAirConditioningsByRoomIdCountAsc = 'ROOM_AIR_CONDITIONINGS_BY_ROOM_ID__COUNT_ASC',
  RoomAirConditioningsByRoomIdCountDesc = 'ROOM_AIR_CONDITIONINGS_BY_ROOM_ID__COUNT_DESC',
  RoomCadGrossSpaceMinsByRoomIdCountAsc = 'ROOM_CAD_GROSS_SPACE_MINS_BY_ROOM_ID__COUNT_ASC',
  RoomCadGrossSpaceMinsByRoomIdCountDesc = 'ROOM_CAD_GROSS_SPACE_MINS_BY_ROOM_ID__COUNT_DESC',
  RoomCadHeightMaxesByRoomIdCountAsc = 'ROOM_CAD_HEIGHT_MAXES_BY_ROOM_ID__COUNT_ASC',
  RoomCadHeightMaxesByRoomIdCountDesc = 'ROOM_CAD_HEIGHT_MAXES_BY_ROOM_ID__COUNT_DESC',
  RoomCadHeightMinsByRoomIdCountAsc = 'ROOM_CAD_HEIGHT_MINS_BY_ROOM_ID__COUNT_ASC',
  RoomCadHeightMinsByRoomIdCountDesc = 'ROOM_CAD_HEIGHT_MINS_BY_ROOM_ID__COUNT_DESC',
  RoomCadLengthMaxesByRoomIdCountAsc = 'ROOM_CAD_LENGTH_MAXES_BY_ROOM_ID__COUNT_ASC',
  RoomCadLengthMaxesByRoomIdCountDesc = 'ROOM_CAD_LENGTH_MAXES_BY_ROOM_ID__COUNT_DESC',
  RoomCadLengthMinsByRoomIdCountAsc = 'ROOM_CAD_LENGTH_MINS_BY_ROOM_ID__COUNT_ASC',
  RoomCadLengthMinsByRoomIdCountDesc = 'ROOM_CAD_LENGTH_MINS_BY_ROOM_ID__COUNT_DESC',
  RoomCadWidthMaxesByRoomIdCountAsc = 'ROOM_CAD_WIDTH_MAXES_BY_ROOM_ID__COUNT_ASC',
  RoomCadWidthMaxesByRoomIdCountDesc = 'ROOM_CAD_WIDTH_MAXES_BY_ROOM_ID__COUNT_DESC',
  RoomCadWidthMinsByRoomIdCountAsc = 'ROOM_CAD_WIDTH_MINS_BY_ROOM_ID__COUNT_ASC',
  RoomCadWidthMinsByRoomIdCountDesc = 'ROOM_CAD_WIDTH_MINS_BY_ROOM_ID__COUNT_DESC',
  RoomCapacityCarsByRoomIdCountAsc = 'ROOM_CAPACITY_CARS_BY_ROOM_ID__COUNT_ASC',
  RoomCapacityCarsByRoomIdCountDesc = 'ROOM_CAPACITY_CARS_BY_ROOM_ID__COUNT_DESC',
  RoomCapacityPaxesByRoomIdCountAsc = 'ROOM_CAPACITY_PAXES_BY_ROOM_ID__COUNT_ASC',
  RoomCapacityPaxesByRoomIdCountDesc = 'ROOM_CAPACITY_PAXES_BY_ROOM_ID__COUNT_DESC',
  RoomCapacityTrucksByRoomIdCountAsc = 'ROOM_CAPACITY_TRUCKS_BY_ROOM_ID__COUNT_ASC',
  RoomCapacityTrucksByRoomIdCountDesc = 'ROOM_CAPACITY_TRUCKS_BY_ROOM_ID__COUNT_DESC',
  RoomCleaningGrossSpacesByRoomIdCountAsc = 'ROOM_CLEANING_GROSS_SPACES_BY_ROOM_ID__COUNT_ASC',
  RoomCleaningGrossSpacesByRoomIdCountDesc = 'ROOM_CLEANING_GROSS_SPACES_BY_ROOM_ID__COUNT_DESC',
  RoomClearanceConstructionsByRoomIdCountAsc = 'ROOM_CLEARANCE_CONSTRUCTIONS_BY_ROOM_ID__COUNT_ASC',
  RoomClearanceConstructionsByRoomIdCountDesc = 'ROOM_CLEARANCE_CONSTRUCTIONS_BY_ROOM_ID__COUNT_DESC',
  RoomContactBookingsByRoomIdCountAsc = 'ROOM_CONTACT_BOOKINGS_BY_ROOM_ID__COUNT_ASC',
  RoomContactBookingsByRoomIdCountDesc = 'ROOM_CONTACT_BOOKINGS_BY_ROOM_ID__COUNT_DESC',
  RoomDaylightsByRoomIdCountAsc = 'ROOM_DAYLIGHTS_BY_ROOM_ID__COUNT_ASC',
  RoomDaylightsByRoomIdCountDesc = 'ROOM_DAYLIGHTS_BY_ROOM_ID__COUNT_DESC',
  RoomDescriptionsByRoomIdCountAsc = 'ROOM_DESCRIPTIONS_BY_ROOM_ID__COUNT_ASC',
  RoomDescriptionsByRoomIdCountDesc = 'ROOM_DESCRIPTIONS_BY_ROOM_ID__COUNT_DESC',
  RoomKeyIssuancesByRoomIdCountAsc = 'ROOM_KEY_ISSUANCES_BY_ROOM_ID__COUNT_ASC',
  RoomKeyIssuancesByRoomIdCountDesc = 'ROOM_KEY_ISSUANCES_BY_ROOM_ID__COUNT_DESC',
  RoomKeyIssuanceNotesByRoomIdCountAsc = 'ROOM_KEY_ISSUANCE_NOTES_BY_ROOM_ID__COUNT_ASC',
  RoomKeyIssuanceNotesByRoomIdCountDesc = 'ROOM_KEY_ISSUANCE_NOTES_BY_ROOM_ID__COUNT_DESC',
  RoomLightShuttersByRoomIdCountAsc = 'ROOM_LIGHT_SHUTTERS_BY_ROOM_ID__COUNT_ASC',
  RoomLightShuttersByRoomIdCountDesc = 'ROOM_LIGHT_SHUTTERS_BY_ROOM_ID__COUNT_DESC',
  RoomMaxLoadCeilingsByRoomIdCountAsc = 'ROOM_MAX_LOAD_CEILINGS_BY_ROOM_ID__COUNT_ASC',
  RoomMaxLoadCeilingsByRoomIdCountDesc = 'ROOM_MAX_LOAD_CEILINGS_BY_ROOM_ID__COUNT_DESC',
  RoomMaxLoadFloorsByRoomIdCountAsc = 'ROOM_MAX_LOAD_FLOORS_BY_ROOM_ID__COUNT_ASC',
  RoomMaxLoadFloorsByRoomIdCountDesc = 'ROOM_MAX_LOAD_FLOORS_BY_ROOM_ID__COUNT_DESC',
  RoomNameExtrasByRoomIdCountAsc = 'ROOM_NAME_EXTRAS_BY_ROOM_ID__COUNT_ASC',
  RoomNameExtrasByRoomIdCountDesc = 'ROOM_NAME_EXTRAS_BY_ROOM_ID__COUNT_DESC',
  RoomNameKeyCadsByRoomIdCountAsc = 'ROOM_NAME_KEY_CADS_BY_ROOM_ID__COUNT_ASC',
  RoomNameKeyCadsByRoomIdCountDesc = 'ROOM_NAME_KEY_CADS_BY_ROOM_ID__COUNT_DESC',
  RoomNameKeyCafmsByRoomIdCountAsc = 'ROOM_NAME_KEY_CAFMS_BY_ROOM_ID__COUNT_ASC',
  RoomNameKeyCafmsByRoomIdCountDesc = 'ROOM_NAME_KEY_CAFMS_BY_ROOM_ID__COUNT_DESC',
  RoomNameKeyEbmsByRoomIdCountAsc = 'ROOM_NAME_KEY_EBMS_BY_ROOM_ID__COUNT_ASC',
  RoomNameKeyEbmsByRoomIdCountDesc = 'ROOM_NAME_KEY_EBMS_BY_ROOM_ID__COUNT_DESC',
  RoomNameKeyMarketingsByRoomIdCountAsc = 'ROOM_NAME_KEY_MARKETINGS_BY_ROOM_ID__COUNT_ASC',
  RoomNameKeyMarketingsByRoomIdCountDesc = 'ROOM_NAME_KEY_MARKETINGS_BY_ROOM_ID__COUNT_DESC',
  RoomNameLongsByRoomIdCountAsc = 'ROOM_NAME_LONGS_BY_ROOM_ID__COUNT_ASC',
  RoomNameLongsByRoomIdCountDesc = 'ROOM_NAME_LONGS_BY_ROOM_ID__COUNT_DESC',
  RoomNameShortsByRoomIdCountAsc = 'ROOM_NAME_SHORTS_BY_ROOM_ID__COUNT_ASC',
  RoomNameShortsByRoomIdCountDesc = 'ROOM_NAME_SHORTS_BY_ROOM_ID__COUNT_DESC',
  RoomNoVehiclesByRoomIdCountAsc = 'ROOM_NO_VEHICLES_BY_ROOM_ID__COUNT_ASC',
  RoomNoVehiclesByRoomIdCountDesc = 'ROOM_NO_VEHICLES_BY_ROOM_ID__COUNT_DESC',
  RoomPartitionsByRoomIdCountAsc = 'ROOM_PARTITIONS_BY_ROOM_ID__COUNT_ASC',
  RoomPartitionsByRoomIdCountDesc = 'ROOM_PARTITIONS_BY_ROOM_ID__COUNT_DESC',
  RoomPhoneNumbersByRoomIdCountAsc = 'ROOM_PHONE_NUMBERS_BY_ROOM_ID__COUNT_ASC',
  RoomPhoneNumbersByRoomIdCountDesc = 'ROOM_PHONE_NUMBERS_BY_ROOM_ID__COUNT_DESC',
  RoomPublicGrossSpacesByRoomIdCountAsc = 'ROOM_PUBLIC_GROSS_SPACES_BY_ROOM_ID__COUNT_ASC',
  RoomPublicGrossSpacesByRoomIdCountDesc = 'ROOM_PUBLIC_GROSS_SPACES_BY_ROOM_ID__COUNT_DESC',
  RoomSbvGrossSpacesByRoomIdCountAsc = 'ROOM_SBV_GROSS_SPACES_BY_ROOM_ID__COUNT_ASC',
  RoomSbvGrossSpacesByRoomIdCountDesc = 'ROOM_SBV_GROSS_SPACES_BY_ROOM_ID__COUNT_DESC',
  RoomTireLoadCarsByRoomIdCountAsc = 'ROOM_TIRE_LOAD_CARS_BY_ROOM_ID__COUNT_ASC',
  RoomTireLoadCarsByRoomIdCountDesc = 'ROOM_TIRE_LOAD_CARS_BY_ROOM_ID__COUNT_DESC',
  RoomTireLoadForkliftsByRoomIdCountAsc = 'ROOM_TIRE_LOAD_FORKLIFTS_BY_ROOM_ID__COUNT_ASC',
  RoomTireLoadForkliftsByRoomIdCountDesc = 'ROOM_TIRE_LOAD_FORKLIFTS_BY_ROOM_ID__COUNT_DESC',
  RoomTireLoadTrucksByRoomIdCountAsc = 'ROOM_TIRE_LOAD_TRUCKS_BY_ROOM_ID__COUNT_ASC',
  RoomTireLoadTrucksByRoomIdCountDesc = 'ROOM_TIRE_LOAD_TRUCKS_BY_ROOM_ID__COUNT_DESC',
  RoomTypeAttrsByRoomIdCountAsc = 'ROOM_TYPE_ATTRS_BY_ROOM_ID__COUNT_ASC',
  RoomTypeAttrsByRoomIdCountDesc = 'ROOM_TYPE_ATTRS_BY_ROOM_ID__COUNT_DESC',
  RoomTypeByTypeIdDescriptionAsc = 'ROOM_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  RoomTypeByTypeIdDescriptionDesc = 'ROOM_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  RoomTypeByTypeIdIdAsc = 'ROOM_TYPE_BY_TYPE_ID__ID_ASC',
  RoomTypeByTypeIdIdDesc = 'ROOM_TYPE_BY_TYPE_ID__ID_DESC',
  RoomTypeByTypeIdIndexAsc = 'ROOM_TYPE_BY_TYPE_ID__INDEX_ASC',
  RoomTypeByTypeIdIndexDesc = 'ROOM_TYPE_BY_TYPE_ID__INDEX_DESC',
  RoomTypeByTypeIdNameAsc = 'ROOM_TYPE_BY_TYPE_ID__NAME_ASC',
  RoomTypeByTypeIdNameDesc = 'ROOM_TYPE_BY_TYPE_ID__NAME_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

export type Scenario = {
  __typename?: 'Scenario';
  /** Reads a single `Feed` that is related to this `Scenario`. */
  changes: Feed;
  changesId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['UUID']>;
  createdByName: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  intention: Scalars['String'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `ScenarioGroup` that is related to this `Scenario`. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  scenarioGroupId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ScenarioSetting` that is related to this `Scenario`. */
  scenarioSetting?: Maybe<ScenarioSetting>;
  /** Reads and enables pagination through a set of `ScenarioVariantVisibility`. */
  scenarioVariantVisibilities: ScenarioVariantVisibilitiesConnection;
  status: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['UUID']>;
  updatedByName: Scalars['String'];
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
  year: Scalars['Int'];
};


export type ScenarioScenarioVariantVisibilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioVariantVisibilityCondition>;
  filter?: InputMaybe<ScenarioVariantVisibilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioVariantVisibilitiesOrderBy>>;
};

/** The `feed` to be created by this mutation. */
export type ScenarioChangesIdFkeyFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** Input for the nested mutation of `feed` in the `ScenarioInput` mutation. */
export type ScenarioChangesIdFkeyInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioChangesIdFkeyFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnScenarioForScenarioChangesIdFkeyUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `scenario` in the `FeedInput` mutation. */
export type ScenarioChangesIdFkeyInverseInput = {
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioScenarioPkeyConnect>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyConnect>>;
  /** A `ScenarioInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioChangesIdFkeyScenarioCreateInput>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioScenarioPkeyDelete>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenario` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioOnScenarioForScenarioChangesIdFkeyUsingScenarioPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioOnScenarioForScenarioChangesIdFkeyUsingScenarioNameShortKeyUpdate>>;
};

/** The `scenario` to be created by this mutation. */
export type ScenarioChangesIdFkeyScenarioCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/**
 * A condition to be used against `Scenario` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ScenarioCondition = {
  /** Checks for equality with the object’s `changesId` field. */
  changesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdByName` field. */
  createdByName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `intention` field. */
  intention?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `scenarioGroupId` field. */
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedByName` field. */
  updatedByName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `user` in the `ScenarioInput` mutation. */
export type ScenarioCreatedByFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioCreatedByFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnScenarioForScenarioCreatedByFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `scenario` in the `UserInput` mutation. */
export type ScenarioCreatedByFkeyInverseInput = {
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioScenarioPkeyConnect>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyConnect>>;
  /** A `ScenarioInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioCreatedByFkeyScenarioCreateInput>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioScenarioPkeyDelete>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenario` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioOnScenarioForScenarioCreatedByFkeyUsingScenarioPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioOnScenarioForScenarioCreatedByFkeyUsingScenarioNameShortKeyUpdate>>;
};

/** The `scenario` to be created by this mutation. */
export type ScenarioCreatedByFkeyScenarioCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/** The `user` to be created by this mutation. */
export type ScenarioCreatedByFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** A filter to be used against `Scenario` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScenarioFilter>>;
  /** Filter by the object’s `changes` relation. */
  changes?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `changesId` field. */
  changesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByName` field. */
  createdByName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `intention` field. */
  intention?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScenarioFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScenarioFilter>>;
  /** Filter by the object’s `scenarioGroup` relation. */
  scenarioGroup?: InputMaybe<ScenarioGroupFilter>;
  /** A related `scenarioGroup` exists. */
  scenarioGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenarioGroupId` field. */
  scenarioGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scenarioSetting` relation. */
  scenarioSetting?: InputMaybe<ScenarioSettingFilter>;
  /** A related `scenarioSetting` exists. */
  scenarioSettingExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenarioVariantVisibilities` relation. */
  scenarioVariantVisibilities?: InputMaybe<ScenarioToManyScenarioVariantVisibilityFilter>;
  /** Some related `scenarioVariantVisibilities` exist. */
  scenarioVariantVisibilitiesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedByName` field. */
  updatedByName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userByCreatedBy` relation. */
  userByCreatedBy?: InputMaybe<UserFilter>;
  /** A related `userByCreatedBy` exists. */
  userByCreatedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userByUpdatedBy` relation. */
  userByUpdatedBy?: InputMaybe<UserFilter>;
  /** A related `userByUpdatedBy` exists. */
  userByUpdatedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

export type ScenarioGroup = {
  __typename?: 'ScenarioGroup';
  businessDomain: Scalars['String'];
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  changes: Feed;
  changesId: Scalars['UUID'];
  companyGroup: Scalars['String'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['UUID']>;
  createdByName: Scalars['String'];
  department: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  intention: Scalars['String'];
  kapmanNumber: Scalars['String'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  organisationalChanges: Feed;
  organisationalChangesId: Scalars['UUID'];
  responsible: Scalars['String'];
  /** Reads and enables pagination through a set of `Scenario`. */
  scenarios: ScenariosConnection;
  status: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['UUID']>;
  updatedByName: Scalars['String'];
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByUpdatedBy?: Maybe<User>;
};


export type ScenarioGroupScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** The `feed` to be created by this mutation. */
export type ScenarioGroupChangesIdFkeyFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** Input for the nested mutation of `feed` in the `ScenarioGroupInput` mutation. */
export type ScenarioGroupChangesIdFkeyInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioGroupChangesIdFkeyFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnScenarioGroupForScenarioGroupChangesIdFkeyUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `scenarioGroup` in the `FeedInput` mutation. */
export type ScenarioGroupChangesIdFkeyInverseInput = {
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyConnect>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyConnect>>;
  /** A `ScenarioGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioGroupChangesIdFkeyScenarioGroupCreateInput>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyDelete>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenarioGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyUsingScenarioGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyUsingScenarioGroupNameShortKeyUpdate>>;
};

/** The `scenarioGroup` to be created by this mutation. */
export type ScenarioGroupChangesIdFkeyScenarioGroupCreateInput = {
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/**
 * A condition to be used against `ScenarioGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ScenarioGroupCondition = {
  /** Checks for equality with the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `changesId` field. */
  changesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdByName` field. */
  createdByName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `department` field. */
  department?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `intention` field. */
  intention?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `kapmanNumber` field. */
  kapmanNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organisationalChangesId` field. */
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `responsible` field. */
  responsible?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedByName` field. */
  updatedByName?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `user` in the `ScenarioGroupInput` mutation. */
export type ScenarioGroupCreatedByFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioGroupCreatedByFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnScenarioGroupForScenarioGroupCreatedByFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `scenarioGroup` in the `UserInput` mutation. */
export type ScenarioGroupCreatedByFkeyInverseInput = {
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyConnect>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyConnect>>;
  /** A `ScenarioGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioGroupCreatedByFkeyScenarioGroupCreateInput>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyDelete>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenarioGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyUsingScenarioGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyUsingScenarioGroupNameShortKeyUpdate>>;
};

/** The `scenarioGroup` to be created by this mutation. */
export type ScenarioGroupCreatedByFkeyScenarioGroupCreateInput = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type ScenarioGroupCreatedByFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** A filter to be used against `ScenarioGroup` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScenarioGroupFilter>>;
  /** Filter by the object’s `businessDomain` field. */
  businessDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `changes` relation. */
  changes?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `changesId` field. */
  changesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companyGroup` field. */
  companyGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByName` field. */
  createdByName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `department` field. */
  department?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `intention` field. */
  intention?: InputMaybe<StringFilter>;
  /** Filter by the object’s `kapmanNumber` field. */
  kapmanNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScenarioGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScenarioGroupFilter>>;
  /** Filter by the object’s `organisationalChanges` relation. */
  organisationalChanges?: InputMaybe<FeedFilter>;
  /** Filter by the object’s `organisationalChangesId` field. */
  organisationalChangesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `responsible` field. */
  responsible?: InputMaybe<StringFilter>;
  /** Filter by the object’s `scenarios` relation. */
  scenarios?: InputMaybe<ScenarioGroupToManyScenarioFilter>;
  /** Some related `scenarios` exist. */
  scenariosExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedByName` field. */
  updatedByName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userByCreatedBy` relation. */
  userByCreatedBy?: InputMaybe<UserFilter>;
  /** A related `userByCreatedBy` exists. */
  userByCreatedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userByUpdatedBy` relation. */
  userByUpdatedBy?: InputMaybe<UserFilter>;
  /** A related `userByUpdatedBy` exists. */
  userByUpdatedByExists?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `ScenarioGroup` */
export type ScenarioGroupInput = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioGroupNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyUsingScenarioGroupNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyUsingScenarioGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyUsingScenarioGroupNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyUsingScenarioGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyUsingScenarioGroupNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyUsingScenarioGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyUsingScenarioGroupNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyPatch;
};

/** The fields on `scenarioGroup` to look up the row to update. */
export type ScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyUsingScenarioGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenarioGroup` being updated. */
  patch: UpdateScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyPatch;
};

/** The `feed` to be created by this mutation. */
export type ScenarioGroupOrganisationalChangesIdFkeyFeedCreateInput = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** Input for the nested mutation of `feed` in the `ScenarioGroupInput` mutation. */
export type ScenarioGroupOrganisationalChangesIdFkeyInput = {
  /** The primary key(s) for `feed` for the far side of the relationship. */
  connectById?: InputMaybe<FeedFeedPkeyConnect>;
  /** A `FeedInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyFeedCreateInput>;
  /** The primary key(s) for `feed` for the far side of the relationship. */
  deleteById?: InputMaybe<FeedFeedPkeyDelete>;
  /** The primary key(s) and patch data for `feed` for the far side of the relationship. */
  updateById?: InputMaybe<FeedOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyUsingFeedPkeyUpdate>;
};

/** Input for the nested mutation of `scenarioGroup` in the `FeedInput` mutation. */
export type ScenarioGroupOrganisationalChangesIdFkeyInverseInput = {
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyConnect>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyConnect>>;
  /** A `ScenarioGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioGroupOrganisationalChangesIdFkeyScenarioGroupCreateInput>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyDelete>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenarioGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyUsingScenarioGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyUsingScenarioGroupNameShortKeyUpdate>>;
};

/** The `scenarioGroup` to be created by this mutation. */
export type ScenarioGroupOrganisationalChangesIdFkeyScenarioGroupCreateInput = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** Represents an update to a `ScenarioGroup`. Fields that are set will be updated. */
export type ScenarioGroupPatch = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** The fields on `scenarioGroup` to look up the row to connect. */
export type ScenarioGroupScenarioGroupNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `scenarioGroup` to look up the row to delete. */
export type ScenarioGroupScenarioGroupNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `scenarioGroup` to look up the row to connect. */
export type ScenarioGroupScenarioGroupPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `scenarioGroup` to look up the row to delete. */
export type ScenarioGroupScenarioGroupPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Scenario` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioGroupToManyScenarioFilter = {
  /** Every related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScenarioFilter>;
  /** No related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScenarioFilter>;
  /** Some related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScenarioFilter>;
};

/** Input for the nested mutation of `user` in the `ScenarioGroupInput` mutation. */
export type ScenarioGroupUpdatedByFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioGroupUpdatedByFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnScenarioGroupForScenarioGroupUpdatedByFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `scenarioGroup` in the `UserInput` mutation. */
export type ScenarioGroupUpdatedByFkeyInverseInput = {
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyConnect>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyConnect>>;
  /** A `ScenarioGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioGroupUpdatedByFkeyScenarioGroupCreateInput>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioGroupScenarioGroupPkeyDelete>>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioGroupScenarioGroupNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenarioGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyUsingScenarioGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyUsingScenarioGroupNameShortKeyUpdate>>;
};

/** The `scenarioGroup` to be created by this mutation. */
export type ScenarioGroupUpdatedByFkeyScenarioGroupCreateInput = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type ScenarioGroupUpdatedByFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** A connection to a list of `ScenarioGroup` values. */
export type ScenarioGroupsConnection = {
  __typename?: 'ScenarioGroupsConnection';
  /** A list of edges which contains the `ScenarioGroup` and cursor to aid in pagination. */
  edges: Array<ScenarioGroupsEdge>;
  /** A list of `ScenarioGroup` objects. */
  nodes: Array<ScenarioGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScenarioGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScenarioGroup` edge in the connection. */
export type ScenarioGroupsEdge = {
  __typename?: 'ScenarioGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScenarioGroup` at the end of the edge. */
  node: ScenarioGroup;
};

/** Methods to use when ordering `ScenarioGroup`. */
export enum ScenarioGroupsOrderBy {
  BusinessDomainAsc = 'BUSINESS_DOMAIN_ASC',
  BusinessDomainDesc = 'BUSINESS_DOMAIN_DESC',
  ChangesIdAsc = 'CHANGES_ID_ASC',
  ChangesIdDesc = 'CHANGES_ID_DESC',
  CompanyGroupAsc = 'COMPANY_GROUP_ASC',
  CompanyGroupDesc = 'COMPANY_GROUP_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  CreatedByNameAsc = 'CREATED_BY_NAME_ASC',
  CreatedByNameDesc = 'CREATED_BY_NAME_DESC',
  DepartmentAsc = 'DEPARTMENT_ASC',
  DepartmentDesc = 'DEPARTMENT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FeedByChangesIdIdAsc = 'FEED_BY_CHANGES_ID__ID_ASC',
  FeedByChangesIdIdDesc = 'FEED_BY_CHANGES_ID__ID_DESC',
  FeedByOrganisationalChangesIdIdAsc = 'FEED_BY_ORGANISATIONAL_CHANGES_ID__ID_ASC',
  FeedByOrganisationalChangesIdIdDesc = 'FEED_BY_ORGANISATIONAL_CHANGES_ID__ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IntentionAsc = 'INTENTION_ASC',
  IntentionDesc = 'INTENTION_DESC',
  KapmanNumberAsc = 'KAPMAN_NUMBER_ASC',
  KapmanNumberDesc = 'KAPMAN_NUMBER_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  OrganisationalChangesIdAsc = 'ORGANISATIONAL_CHANGES_ID_ASC',
  OrganisationalChangesIdDesc = 'ORGANISATIONAL_CHANGES_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResponsibleAsc = 'RESPONSIBLE_ASC',
  ResponsibleDesc = 'RESPONSIBLE_DESC',
  ScenariosByScenarioGroupIdCountAsc = 'SCENARIOS_BY_SCENARIO_GROUP_ID__COUNT_ASC',
  ScenariosByScenarioGroupIdCountDesc = 'SCENARIOS_BY_SCENARIO_GROUP_ID__COUNT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UpdatedByNameAsc = 'UPDATED_BY_NAME_ASC',
  UpdatedByNameDesc = 'UPDATED_BY_NAME_DESC',
  UserByCreatedByActivatedAtAsc = 'USER_BY_CREATED_BY__ACTIVATED_AT_ASC',
  UserByCreatedByActivatedAtDesc = 'USER_BY_CREATED_BY__ACTIVATED_AT_DESC',
  UserByCreatedByCompanyAsc = 'USER_BY_CREATED_BY__COMPANY_ASC',
  UserByCreatedByCompanyDesc = 'USER_BY_CREATED_BY__COMPANY_DESC',
  UserByCreatedByCreatedAtAsc = 'USER_BY_CREATED_BY__CREATED_AT_ASC',
  UserByCreatedByCreatedAtDesc = 'USER_BY_CREATED_BY__CREATED_AT_DESC',
  UserByCreatedByDeactivatedAtAsc = 'USER_BY_CREATED_BY__DEACTIVATED_AT_ASC',
  UserByCreatedByDeactivatedAtDesc = 'USER_BY_CREATED_BY__DEACTIVATED_AT_DESC',
  UserByCreatedByFirstNameAsc = 'USER_BY_CREATED_BY__FIRST_NAME_ASC',
  UserByCreatedByFirstNameDesc = 'USER_BY_CREATED_BY__FIRST_NAME_DESC',
  UserByCreatedByIdAsc = 'USER_BY_CREATED_BY__ID_ASC',
  UserByCreatedByIdDesc = 'USER_BY_CREATED_BY__ID_DESC',
  UserByCreatedByIsActiveAsc = 'USER_BY_CREATED_BY__IS_ACTIVE_ASC',
  UserByCreatedByIsActiveDesc = 'USER_BY_CREATED_BY__IS_ACTIVE_DESC',
  UserByCreatedByIsAdminAsc = 'USER_BY_CREATED_BY__IS_ADMIN_ASC',
  UserByCreatedByIsAdminDesc = 'USER_BY_CREATED_BY__IS_ADMIN_DESC',
  UserByCreatedByLastNameAsc = 'USER_BY_CREATED_BY__LAST_NAME_ASC',
  UserByCreatedByLastNameDesc = 'USER_BY_CREATED_BY__LAST_NAME_DESC',
  UserByCreatedByNameAsc = 'USER_BY_CREATED_BY__NAME_ASC',
  UserByCreatedByNameDesc = 'USER_BY_CREATED_BY__NAME_DESC',
  UserByCreatedByNotesAsc = 'USER_BY_CREATED_BY__NOTES_ASC',
  UserByCreatedByNotesDesc = 'USER_BY_CREATED_BY__NOTES_DESC',
  UserByCreatedByPositionAsc = 'USER_BY_CREATED_BY__POSITION_ASC',
  UserByCreatedByPositionDesc = 'USER_BY_CREATED_BY__POSITION_DESC',
  UserByCreatedByUpdatedAtAsc = 'USER_BY_CREATED_BY__UPDATED_AT_ASC',
  UserByCreatedByUpdatedAtDesc = 'USER_BY_CREATED_BY__UPDATED_AT_DESC',
  UserByUpdatedByActivatedAtAsc = 'USER_BY_UPDATED_BY__ACTIVATED_AT_ASC',
  UserByUpdatedByActivatedAtDesc = 'USER_BY_UPDATED_BY__ACTIVATED_AT_DESC',
  UserByUpdatedByCompanyAsc = 'USER_BY_UPDATED_BY__COMPANY_ASC',
  UserByUpdatedByCompanyDesc = 'USER_BY_UPDATED_BY__COMPANY_DESC',
  UserByUpdatedByCreatedAtAsc = 'USER_BY_UPDATED_BY__CREATED_AT_ASC',
  UserByUpdatedByCreatedAtDesc = 'USER_BY_UPDATED_BY__CREATED_AT_DESC',
  UserByUpdatedByDeactivatedAtAsc = 'USER_BY_UPDATED_BY__DEACTIVATED_AT_ASC',
  UserByUpdatedByDeactivatedAtDesc = 'USER_BY_UPDATED_BY__DEACTIVATED_AT_DESC',
  UserByUpdatedByFirstNameAsc = 'USER_BY_UPDATED_BY__FIRST_NAME_ASC',
  UserByUpdatedByFirstNameDesc = 'USER_BY_UPDATED_BY__FIRST_NAME_DESC',
  UserByUpdatedByIdAsc = 'USER_BY_UPDATED_BY__ID_ASC',
  UserByUpdatedByIdDesc = 'USER_BY_UPDATED_BY__ID_DESC',
  UserByUpdatedByIsActiveAsc = 'USER_BY_UPDATED_BY__IS_ACTIVE_ASC',
  UserByUpdatedByIsActiveDesc = 'USER_BY_UPDATED_BY__IS_ACTIVE_DESC',
  UserByUpdatedByIsAdminAsc = 'USER_BY_UPDATED_BY__IS_ADMIN_ASC',
  UserByUpdatedByIsAdminDesc = 'USER_BY_UPDATED_BY__IS_ADMIN_DESC',
  UserByUpdatedByLastNameAsc = 'USER_BY_UPDATED_BY__LAST_NAME_ASC',
  UserByUpdatedByLastNameDesc = 'USER_BY_UPDATED_BY__LAST_NAME_DESC',
  UserByUpdatedByNameAsc = 'USER_BY_UPDATED_BY__NAME_ASC',
  UserByUpdatedByNameDesc = 'USER_BY_UPDATED_BY__NAME_DESC',
  UserByUpdatedByNotesAsc = 'USER_BY_UPDATED_BY__NOTES_ASC',
  UserByUpdatedByNotesDesc = 'USER_BY_UPDATED_BY__NOTES_DESC',
  UserByUpdatedByPositionAsc = 'USER_BY_UPDATED_BY__POSITION_ASC',
  UserByUpdatedByPositionDesc = 'USER_BY_UPDATED_BY__POSITION_DESC',
  UserByUpdatedByUpdatedAtAsc = 'USER_BY_UPDATED_BY__UPDATED_AT_ASC',
  UserByUpdatedByUpdatedAtDesc = 'USER_BY_UPDATED_BY__UPDATED_AT_DESC'
}

/** An input for mutations affecting `Scenario` */
export type ScenarioInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioChangesIdFkeyUsingScenarioNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioChangesIdFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioChangesIdFkeyUsingScenarioPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioChangesIdFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioCreatedByFkeyUsingScenarioNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioCreatedByFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioCreatedByFkeyUsingScenarioPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioCreatedByFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioScenarioGroupIdFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioScenarioGroupIdFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioUpdatedByFkeyUsingScenarioNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioUpdatedByFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioForScenarioUpdatedByFkeyUsingScenarioPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioForScenarioUpdatedByFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyUsingScenarioNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyUsingScenarioPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkPatch;
};

/** The fields on `scenario` to look up the row to update. */
export type ScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenario` being updated. */
  patch: UpdateScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkPatch;
};

/** Represents an update to a `Scenario`. Fields that are set will be updated. */
export type ScenarioPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `scenarioGroup` in the `ScenarioInput` mutation. */
export type ScenarioScenarioGroupIdFkeyInput = {
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectById?: InputMaybe<ScenarioGroupScenarioGroupPkeyConnect>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ScenarioGroupScenarioGroupNameShortKeyConnect>;
  /** A `ScenarioGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioScenarioGroupIdFkeyScenarioGroupCreateInput>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<ScenarioGroupScenarioGroupPkeyDelete>;
  /** The primary key(s) for `scenarioGroup` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ScenarioGroupScenarioGroupNameShortKeyDelete>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateById?: InputMaybe<ScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `scenarioGroup` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioGroupNameShortKeyUpdate>;
};

/** Input for the nested mutation of `scenario` in the `ScenarioGroupInput` mutation. */
export type ScenarioScenarioGroupIdFkeyInverseInput = {
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioScenarioPkeyConnect>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyConnect>>;
  /** A `ScenarioInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioScenarioGroupIdFkeyScenarioCreateInput>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioScenarioPkeyDelete>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenario` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioOnScenarioForScenarioScenarioGroupIdFkeyUsingScenarioNameShortKeyUpdate>>;
};

/** The `scenario` to be created by this mutation. */
export type ScenarioScenarioGroupIdFkeyScenarioCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/** The `scenarioGroup` to be created by this mutation. */
export type ScenarioScenarioGroupIdFkeyScenarioGroupCreateInput = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** The fields on `scenario` to look up the row to connect. */
export type ScenarioScenarioNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `scenario` to look up the row to delete. */
export type ScenarioScenarioNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `scenario` to look up the row to connect. */
export type ScenarioScenarioPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `scenario` to look up the row to delete. */
export type ScenarioScenarioPkeyDelete = {
  id: Scalars['UUID'];
};

export type ScenarioSetting = {
  __typename?: 'ScenarioSetting';
  end: Scalars['Datetime'];
  monthsAfter: Scalars['Int'];
  monthsBefore: Scalars['Int'];
  quarter: Scalars['Int'];
  /** Reads a single `Scenario` that is related to this `ScenarioSetting`. */
  scenario: Scenario;
  scenarioId: Scalars['UUID'];
  showSections: Scalars['Boolean'];
  start: Scalars['Datetime'];
  year: Scalars['Int'];
};

/**
 * A condition to be used against `ScenarioSetting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ScenarioSettingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `monthsAfter` field. */
  monthsAfter?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `monthsBefore` field. */
  monthsBefore?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `quarter` field. */
  quarter?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scenarioId` field. */
  scenarioId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `showSections` field. */
  showSections?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ScenarioSetting` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioSettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScenarioSettingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `monthsAfter` field. */
  monthsAfter?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monthsBefore` field. */
  monthsBefore?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScenarioSettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScenarioSettingFilter>>;
  /** Filter by the object’s `quarter` field. */
  quarter?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scenario` relation. */
  scenario?: InputMaybe<ScenarioFilter>;
  /** Filter by the object’s `scenarioId` field. */
  scenarioId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `showSections` field. */
  showSections?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ScenarioSetting` */
export type ScenarioSettingInput = {
  end: Scalars['Datetime'];
  monthsAfter: Scalars['Int'];
  monthsBefore: Scalars['Int'];
  quarter: Scalars['Int'];
  scenarioId?: InputMaybe<Scalars['UUID']>;
  scenarioToScenarioId?: InputMaybe<ScenarioSettingScenarioIdFkeyInput>;
  showSections?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
  year: Scalars['Int'];
};

/** The fields on `scenarioSetting` to look up the row to update. */
export type ScenarioSettingOnScenarioSettingForScenarioSettingScenarioIdFkeyUsingScenarioSettingPkeyUpdate = {
  /** An object where the defined keys will be set on the `scenarioSetting` being updated. */
  patch: UpdateScenarioSettingOnScenarioSettingForScenarioSettingScenarioIdFkeyPatch;
  scenarioId: Scalars['UUID'];
};

/** Represents an update to a `ScenarioSetting`. Fields that are set will be updated. */
export type ScenarioSettingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  monthsAfter?: InputMaybe<Scalars['Int']>;
  monthsBefore?: InputMaybe<Scalars['Int']>;
  quarter?: InputMaybe<Scalars['Int']>;
  scenarioId?: InputMaybe<Scalars['UUID']>;
  scenarioToScenarioId?: InputMaybe<ScenarioSettingScenarioIdFkeyInput>;
  showSections?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `scenario` in the `ScenarioSettingInput` mutation. */
export type ScenarioSettingScenarioIdFkeyInput = {
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectById?: InputMaybe<ScenarioScenarioPkeyConnect>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ScenarioScenarioNameShortKeyConnect>;
  /** A `ScenarioInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioSettingScenarioIdFkeyScenarioCreateInput>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteById?: InputMaybe<ScenarioScenarioPkeyDelete>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ScenarioScenarioNameShortKeyDelete>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateById?: InputMaybe<ScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyUsingScenarioPkeyUpdate>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyUsingScenarioNameShortKeyUpdate>;
};

/** Input for the nested mutation of `scenarioSetting` in the `ScenarioInput` mutation. */
export type ScenarioSettingScenarioIdFkeyInverseInput = {
  /** The primary key(s) for `scenarioSetting` for the far side of the relationship. */
  connectByScenarioId?: InputMaybe<ScenarioSettingScenarioSettingPkeyConnect>;
  /** A `ScenarioSettingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioSettingScenarioIdFkeyScenarioSettingCreateInput>>;
  /** The primary key(s) for `scenarioSetting` for the far side of the relationship. */
  deleteByScenarioId?: InputMaybe<ScenarioSettingScenarioSettingPkeyDelete>;
  /** Flag indicating whether all other `scenarioSetting` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenarioSetting` for the far side of the relationship. */
  updateByScenarioId?: InputMaybe<ScenarioSettingOnScenarioSettingForScenarioSettingScenarioIdFkeyUsingScenarioSettingPkeyUpdate>;
};

/** The `scenario` to be created by this mutation. */
export type ScenarioSettingScenarioIdFkeyScenarioCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/** The `scenarioSetting` to be created by this mutation. */
export type ScenarioSettingScenarioIdFkeyScenarioSettingCreateInput = {
  end: Scalars['Datetime'];
  monthsAfter: Scalars['Int'];
  monthsBefore: Scalars['Int'];
  quarter: Scalars['Int'];
  scenarioToScenarioId?: InputMaybe<ScenarioSettingScenarioIdFkeyInput>;
  showSections?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Datetime'];
  year: Scalars['Int'];
};

/** The fields on `scenarioSetting` to look up the row to connect. */
export type ScenarioSettingScenarioSettingPkeyConnect = {
  scenarioId: Scalars['UUID'];
};

/** The fields on `scenarioSetting` to look up the row to delete. */
export type ScenarioSettingScenarioSettingPkeyDelete = {
  scenarioId: Scalars['UUID'];
};

/** A connection to a list of `ScenarioSetting` values. */
export type ScenarioSettingsConnection = {
  __typename?: 'ScenarioSettingsConnection';
  /** A list of edges which contains the `ScenarioSetting` and cursor to aid in pagination. */
  edges: Array<ScenarioSettingsEdge>;
  /** A list of `ScenarioSetting` objects. */
  nodes: Array<ScenarioSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScenarioSetting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScenarioSetting` edge in the connection. */
export type ScenarioSettingsEdge = {
  __typename?: 'ScenarioSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScenarioSetting` at the end of the edge. */
  node: ScenarioSetting;
};

/** Methods to use when ordering `ScenarioSetting`. */
export enum ScenarioSettingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  MonthsAfterAsc = 'MONTHS_AFTER_ASC',
  MonthsAfterDesc = 'MONTHS_AFTER_DESC',
  MonthsBeforeAsc = 'MONTHS_BEFORE_ASC',
  MonthsBeforeDesc = 'MONTHS_BEFORE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuarterAsc = 'QUARTER_ASC',
  QuarterDesc = 'QUARTER_DESC',
  ScenarioByScenarioIdChangesIdAsc = 'SCENARIO_BY_SCENARIO_ID__CHANGES_ID_ASC',
  ScenarioByScenarioIdChangesIdDesc = 'SCENARIO_BY_SCENARIO_ID__CHANGES_ID_DESC',
  ScenarioByScenarioIdCreatedAtAsc = 'SCENARIO_BY_SCENARIO_ID__CREATED_AT_ASC',
  ScenarioByScenarioIdCreatedAtDesc = 'SCENARIO_BY_SCENARIO_ID__CREATED_AT_DESC',
  ScenarioByScenarioIdCreatedByAsc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_ASC',
  ScenarioByScenarioIdCreatedByDesc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_DESC',
  ScenarioByScenarioIdCreatedByNameAsc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_NAME_ASC',
  ScenarioByScenarioIdCreatedByNameDesc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_NAME_DESC',
  ScenarioByScenarioIdDescriptionAsc = 'SCENARIO_BY_SCENARIO_ID__DESCRIPTION_ASC',
  ScenarioByScenarioIdDescriptionDesc = 'SCENARIO_BY_SCENARIO_ID__DESCRIPTION_DESC',
  ScenarioByScenarioIdIdAsc = 'SCENARIO_BY_SCENARIO_ID__ID_ASC',
  ScenarioByScenarioIdIdDesc = 'SCENARIO_BY_SCENARIO_ID__ID_DESC',
  ScenarioByScenarioIdIndexAsc = 'SCENARIO_BY_SCENARIO_ID__INDEX_ASC',
  ScenarioByScenarioIdIndexDesc = 'SCENARIO_BY_SCENARIO_ID__INDEX_DESC',
  ScenarioByScenarioIdIntentionAsc = 'SCENARIO_BY_SCENARIO_ID__INTENTION_ASC',
  ScenarioByScenarioIdIntentionDesc = 'SCENARIO_BY_SCENARIO_ID__INTENTION_DESC',
  ScenarioByScenarioIdNameLongAsc = 'SCENARIO_BY_SCENARIO_ID__NAME_LONG_ASC',
  ScenarioByScenarioIdNameLongDesc = 'SCENARIO_BY_SCENARIO_ID__NAME_LONG_DESC',
  ScenarioByScenarioIdNameShortAsc = 'SCENARIO_BY_SCENARIO_ID__NAME_SHORT_ASC',
  ScenarioByScenarioIdNameShortDesc = 'SCENARIO_BY_SCENARIO_ID__NAME_SHORT_DESC',
  ScenarioByScenarioIdScenarioGroupIdAsc = 'SCENARIO_BY_SCENARIO_ID__SCENARIO_GROUP_ID_ASC',
  ScenarioByScenarioIdScenarioGroupIdDesc = 'SCENARIO_BY_SCENARIO_ID__SCENARIO_GROUP_ID_DESC',
  ScenarioByScenarioIdStatusAsc = 'SCENARIO_BY_SCENARIO_ID__STATUS_ASC',
  ScenarioByScenarioIdStatusDesc = 'SCENARIO_BY_SCENARIO_ID__STATUS_DESC',
  ScenarioByScenarioIdUpdatedAtAsc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_AT_ASC',
  ScenarioByScenarioIdUpdatedAtDesc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_AT_DESC',
  ScenarioByScenarioIdUpdatedByAsc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_ASC',
  ScenarioByScenarioIdUpdatedByDesc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_DESC',
  ScenarioByScenarioIdUpdatedByNameAsc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_NAME_ASC',
  ScenarioByScenarioIdUpdatedByNameDesc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_NAME_DESC',
  ScenarioByScenarioIdYearAsc = 'SCENARIO_BY_SCENARIO_ID__YEAR_ASC',
  ScenarioByScenarioIdYearDesc = 'SCENARIO_BY_SCENARIO_ID__YEAR_DESC',
  ScenarioIdAsc = 'SCENARIO_ID_ASC',
  ScenarioIdDesc = 'SCENARIO_ID_DESC',
  ShowSectionsAsc = 'SHOW_SECTIONS_ASC',
  ShowSectionsDesc = 'SHOW_SECTIONS_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

/** A filter to be used against many `ScenarioVariantVisibility` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioToManyScenarioVariantVisibilityFilter = {
  /** Every related `ScenarioVariantVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScenarioVariantVisibilityFilter>;
  /** No related `ScenarioVariantVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScenarioVariantVisibilityFilter>;
  /** Some related `ScenarioVariantVisibility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScenarioVariantVisibilityFilter>;
};

/** Input for the nested mutation of `user` in the `ScenarioInput` mutation. */
export type ScenarioUpdatedByFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioUpdatedByFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnScenarioForScenarioUpdatedByFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `scenario` in the `UserInput` mutation. */
export type ScenarioUpdatedByFkeyInverseInput = {
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioScenarioPkeyConnect>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyConnect>>;
  /** A `ScenarioInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioUpdatedByFkeyScenarioCreateInput>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioScenarioPkeyDelete>>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ScenarioScenarioNameShortKeyDelete>>;
  /** Flag indicating whether all other `scenario` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioOnScenarioForScenarioUpdatedByFkeyUsingScenarioPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ScenarioOnScenarioForScenarioUpdatedByFkeyUsingScenarioNameShortKeyUpdate>>;
};

/** The `scenario` to be created by this mutation. */
export type ScenarioUpdatedByFkeyScenarioCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/** The `user` to be created by this mutation. */
export type ScenarioUpdatedByFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** A connection to a list of `ScenarioVariantVisibility` values. */
export type ScenarioVariantVisibilitiesConnection = {
  __typename?: 'ScenarioVariantVisibilitiesConnection';
  /** A list of edges which contains the `ScenarioVariantVisibility` and cursor to aid in pagination. */
  edges: Array<ScenarioVariantVisibilitiesEdge>;
  /** A list of `ScenarioVariantVisibility` objects. */
  nodes: Array<ScenarioVariantVisibility>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScenarioVariantVisibility` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScenarioVariantVisibility` edge in the connection. */
export type ScenarioVariantVisibilitiesEdge = {
  __typename?: 'ScenarioVariantVisibilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScenarioVariantVisibility` at the end of the edge. */
  node: ScenarioVariantVisibility;
};

/** Methods to use when ordering `ScenarioVariantVisibility`. */
export enum ScenarioVariantVisibilitiesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScenarioByScenarioIdChangesIdAsc = 'SCENARIO_BY_SCENARIO_ID__CHANGES_ID_ASC',
  ScenarioByScenarioIdChangesIdDesc = 'SCENARIO_BY_SCENARIO_ID__CHANGES_ID_DESC',
  ScenarioByScenarioIdCreatedAtAsc = 'SCENARIO_BY_SCENARIO_ID__CREATED_AT_ASC',
  ScenarioByScenarioIdCreatedAtDesc = 'SCENARIO_BY_SCENARIO_ID__CREATED_AT_DESC',
  ScenarioByScenarioIdCreatedByAsc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_ASC',
  ScenarioByScenarioIdCreatedByDesc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_DESC',
  ScenarioByScenarioIdCreatedByNameAsc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_NAME_ASC',
  ScenarioByScenarioIdCreatedByNameDesc = 'SCENARIO_BY_SCENARIO_ID__CREATED_BY_NAME_DESC',
  ScenarioByScenarioIdDescriptionAsc = 'SCENARIO_BY_SCENARIO_ID__DESCRIPTION_ASC',
  ScenarioByScenarioIdDescriptionDesc = 'SCENARIO_BY_SCENARIO_ID__DESCRIPTION_DESC',
  ScenarioByScenarioIdIdAsc = 'SCENARIO_BY_SCENARIO_ID__ID_ASC',
  ScenarioByScenarioIdIdDesc = 'SCENARIO_BY_SCENARIO_ID__ID_DESC',
  ScenarioByScenarioIdIndexAsc = 'SCENARIO_BY_SCENARIO_ID__INDEX_ASC',
  ScenarioByScenarioIdIndexDesc = 'SCENARIO_BY_SCENARIO_ID__INDEX_DESC',
  ScenarioByScenarioIdIntentionAsc = 'SCENARIO_BY_SCENARIO_ID__INTENTION_ASC',
  ScenarioByScenarioIdIntentionDesc = 'SCENARIO_BY_SCENARIO_ID__INTENTION_DESC',
  ScenarioByScenarioIdNameLongAsc = 'SCENARIO_BY_SCENARIO_ID__NAME_LONG_ASC',
  ScenarioByScenarioIdNameLongDesc = 'SCENARIO_BY_SCENARIO_ID__NAME_LONG_DESC',
  ScenarioByScenarioIdNameShortAsc = 'SCENARIO_BY_SCENARIO_ID__NAME_SHORT_ASC',
  ScenarioByScenarioIdNameShortDesc = 'SCENARIO_BY_SCENARIO_ID__NAME_SHORT_DESC',
  ScenarioByScenarioIdScenarioGroupIdAsc = 'SCENARIO_BY_SCENARIO_ID__SCENARIO_GROUP_ID_ASC',
  ScenarioByScenarioIdScenarioGroupIdDesc = 'SCENARIO_BY_SCENARIO_ID__SCENARIO_GROUP_ID_DESC',
  ScenarioByScenarioIdStatusAsc = 'SCENARIO_BY_SCENARIO_ID__STATUS_ASC',
  ScenarioByScenarioIdStatusDesc = 'SCENARIO_BY_SCENARIO_ID__STATUS_DESC',
  ScenarioByScenarioIdUpdatedAtAsc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_AT_ASC',
  ScenarioByScenarioIdUpdatedAtDesc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_AT_DESC',
  ScenarioByScenarioIdUpdatedByAsc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_ASC',
  ScenarioByScenarioIdUpdatedByDesc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_DESC',
  ScenarioByScenarioIdUpdatedByNameAsc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_NAME_ASC',
  ScenarioByScenarioIdUpdatedByNameDesc = 'SCENARIO_BY_SCENARIO_ID__UPDATED_BY_NAME_DESC',
  ScenarioByScenarioIdYearAsc = 'SCENARIO_BY_SCENARIO_ID__YEAR_ASC',
  ScenarioByScenarioIdYearDesc = 'SCENARIO_BY_SCENARIO_ID__YEAR_DESC',
  ScenarioIdAsc = 'SCENARIO_ID_ASC',
  ScenarioIdDesc = 'SCENARIO_ID_DESC',
  VariantIdAsc = 'VARIANT_ID_ASC',
  VariantIdDesc = 'VARIANT_ID_DESC',
  VariantTypeAsc = 'VARIANT_TYPE_ASC',
  VariantTypeDesc = 'VARIANT_TYPE_DESC',
  VisibilityAsc = 'VISIBILITY_ASC',
  VisibilityDesc = 'VISIBILITY_DESC'
}

export type ScenarioVariantVisibility = {
  __typename?: 'ScenarioVariantVisibility';
  id: Scalars['UUID'];
  /** Reads a single `Scenario` that is related to this `ScenarioVariantVisibility`. */
  scenario: Scenario;
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
  visibility: Scalars['String'];
};

/**
 * A condition to be used against `ScenarioVariantVisibility` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ScenarioVariantVisibilityCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `scenarioId` field. */
  scenarioId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `variantId` field. */
  variantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `variantType` field. */
  variantType?: InputMaybe<VariantType>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ScenarioVariantVisibility` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioVariantVisibilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScenarioVariantVisibilityFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScenarioVariantVisibilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScenarioVariantVisibilityFilter>>;
  /** Filter by the object’s `scenario` relation. */
  scenario?: InputMaybe<ScenarioFilter>;
  /** Filter by the object’s `scenarioId` field. */
  scenarioId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `variantId` field. */
  variantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `variantType` field. */
  variantType?: InputMaybe<VariantTypeFilter>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ScenarioVariantVisibility` */
export type ScenarioVariantVisibilityInput = {
  id?: InputMaybe<Scalars['UUID']>;
  scenarioId?: InputMaybe<Scalars['UUID']>;
  scenarioToScenarioId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInput>;
  variantId: Scalars['UUID'];
  variantType: VariantType;
  visibility: Scalars['String'];
};

/** The fields on `scenarioVariantVisibility` to look up the row to update. */
export type ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scenarioVariantVisibility` being updated. */
  patch: UpdateScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkPatch;
};

/** The fields on `scenarioVariantVisibility` to look up the row to update. */
export type ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityScenarioIdVariantIdVariantTypeUpdate = {
  /** An object where the defined keys will be set on the `scenarioVariantVisibility` being updated. */
  patch: UpdateScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkPatch;
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
};

/** Represents an update to a `ScenarioVariantVisibility`. Fields that are set will be updated. */
export type ScenarioVariantVisibilityPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  scenarioId?: InputMaybe<Scalars['UUID']>;
  scenarioToScenarioId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInput>;
  variantId?: InputMaybe<Scalars['UUID']>;
  variantType?: InputMaybe<VariantType>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `scenario` in the `ScenarioVariantVisibilityInput` mutation. */
export type ScenarioVariantVisibilityScenarioIdScenarioIdFkInput = {
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectById?: InputMaybe<ScenarioScenarioPkeyConnect>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ScenarioScenarioNameShortKeyConnect>;
  /** A `ScenarioInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioCreateInput>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteById?: InputMaybe<ScenarioScenarioPkeyDelete>;
  /** The primary key(s) for `scenario` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ScenarioScenarioNameShortKeyDelete>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateById?: InputMaybe<ScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioPkeyUpdate>;
  /** The primary key(s) and patch data for `scenario` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioNameShortKeyUpdate>;
};

/** Input for the nested mutation of `scenarioVariantVisibility` in the `ScenarioInput` mutation. */
export type ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput = {
  /** The primary key(s) for `scenarioVariantVisibility` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScenarioVariantVisibilityScenarioVariantVisibilityPkeyConnect>>;
  /** The primary key(s) for `scenarioVariantVisibility` for the far side of the relationship. */
  connectByScenarioIdAndVariantIdAndVariantType?: InputMaybe<Array<ScenarioVariantVisibilityScenarioVariantVisibilityScenarioIdVariantIdVariantTypeConnect>>;
  /** A `ScenarioVariantVisibilityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioVariantVisibilityCreateInput>>;
  /** The primary key(s) for `scenarioVariantVisibility` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ScenarioVariantVisibilityScenarioVariantVisibilityPkeyDelete>>;
  /** The primary key(s) for `scenarioVariantVisibility` for the far side of the relationship. */
  deleteByScenarioIdAndVariantIdAndVariantType?: InputMaybe<Array<ScenarioVariantVisibilityScenarioVariantVisibilityScenarioIdVariantIdVariantTypeDelete>>;
  /** Flag indicating whether all other `scenarioVariantVisibility` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scenarioVariantVisibility` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityPkeyUpdate>>;
  /** The primary key(s) and patch data for `scenarioVariantVisibility` for the far side of the relationship. */
  updateByScenarioIdAndVariantIdAndVariantType?: InputMaybe<Array<ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityScenarioIdVariantIdVariantTypeUpdate>>;
};

/** The `scenario` to be created by this mutation. */
export type ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioCreateInput = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year: Scalars['Int'];
};

/** The `scenarioVariantVisibility` to be created by this mutation. */
export type ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioVariantVisibilityCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  scenarioToScenarioId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInput>;
  variantId: Scalars['UUID'];
  variantType: VariantType;
  visibility: Scalars['String'];
};

/** The fields on `scenarioVariantVisibility` to look up the row to connect. */
export type ScenarioVariantVisibilityScenarioVariantVisibilityPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `scenarioVariantVisibility` to look up the row to delete. */
export type ScenarioVariantVisibilityScenarioVariantVisibilityPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `scenarioVariantVisibility` to look up the row to connect. */
export type ScenarioVariantVisibilityScenarioVariantVisibilityScenarioIdVariantIdVariantTypeConnect = {
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
};

/** The fields on `scenarioVariantVisibility` to look up the row to delete. */
export type ScenarioVariantVisibilityScenarioVariantVisibilityScenarioIdVariantIdVariantTypeDelete = {
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
};

/** A connection to a list of `Scenario` values. */
export type ScenariosConnection = {
  __typename?: 'ScenariosConnection';
  /** A list of edges which contains the `Scenario` and cursor to aid in pagination. */
  edges: Array<ScenariosEdge>;
  /** A list of `Scenario` objects. */
  nodes: Array<Scenario>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Scenario` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Scenario` edge in the connection. */
export type ScenariosEdge = {
  __typename?: 'ScenariosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Scenario` at the end of the edge. */
  node: Scenario;
};

/** Methods to use when ordering `Scenario`. */
export enum ScenariosOrderBy {
  ChangesIdAsc = 'CHANGES_ID_ASC',
  ChangesIdDesc = 'CHANGES_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  CreatedByNameAsc = 'CREATED_BY_NAME_ASC',
  CreatedByNameDesc = 'CREATED_BY_NAME_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FeedByChangesIdIdAsc = 'FEED_BY_CHANGES_ID__ID_ASC',
  FeedByChangesIdIdDesc = 'FEED_BY_CHANGES_ID__ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IntentionAsc = 'INTENTION_ASC',
  IntentionDesc = 'INTENTION_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScenarioGroupByScenarioGroupIdBusinessDomainAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__BUSINESS_DOMAIN_ASC',
  ScenarioGroupByScenarioGroupIdBusinessDomainDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__BUSINESS_DOMAIN_DESC',
  ScenarioGroupByScenarioGroupIdChangesIdAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CHANGES_ID_ASC',
  ScenarioGroupByScenarioGroupIdChangesIdDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CHANGES_ID_DESC',
  ScenarioGroupByScenarioGroupIdCompanyGroupAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__COMPANY_GROUP_ASC',
  ScenarioGroupByScenarioGroupIdCompanyGroupDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__COMPANY_GROUP_DESC',
  ScenarioGroupByScenarioGroupIdCreatedAtAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CREATED_AT_ASC',
  ScenarioGroupByScenarioGroupIdCreatedAtDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CREATED_AT_DESC',
  ScenarioGroupByScenarioGroupIdCreatedByAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CREATED_BY_ASC',
  ScenarioGroupByScenarioGroupIdCreatedByDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CREATED_BY_DESC',
  ScenarioGroupByScenarioGroupIdCreatedByNameAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CREATED_BY_NAME_ASC',
  ScenarioGroupByScenarioGroupIdCreatedByNameDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__CREATED_BY_NAME_DESC',
  ScenarioGroupByScenarioGroupIdDepartmentAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__DEPARTMENT_ASC',
  ScenarioGroupByScenarioGroupIdDepartmentDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__DEPARTMENT_DESC',
  ScenarioGroupByScenarioGroupIdDescriptionAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__DESCRIPTION_ASC',
  ScenarioGroupByScenarioGroupIdDescriptionDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__DESCRIPTION_DESC',
  ScenarioGroupByScenarioGroupIdIdAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__ID_ASC',
  ScenarioGroupByScenarioGroupIdIdDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__ID_DESC',
  ScenarioGroupByScenarioGroupIdIndexAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__INDEX_ASC',
  ScenarioGroupByScenarioGroupIdIndexDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__INDEX_DESC',
  ScenarioGroupByScenarioGroupIdIntentionAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__INTENTION_ASC',
  ScenarioGroupByScenarioGroupIdIntentionDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__INTENTION_DESC',
  ScenarioGroupByScenarioGroupIdKapmanNumberAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__KAPMAN_NUMBER_ASC',
  ScenarioGroupByScenarioGroupIdKapmanNumberDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__KAPMAN_NUMBER_DESC',
  ScenarioGroupByScenarioGroupIdNameLongAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__NAME_LONG_ASC',
  ScenarioGroupByScenarioGroupIdNameLongDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__NAME_LONG_DESC',
  ScenarioGroupByScenarioGroupIdNameShortAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__NAME_SHORT_ASC',
  ScenarioGroupByScenarioGroupIdNameShortDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__NAME_SHORT_DESC',
  ScenarioGroupByScenarioGroupIdOrganisationalChangesIdAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__ORGANISATIONAL_CHANGES_ID_ASC',
  ScenarioGroupByScenarioGroupIdOrganisationalChangesIdDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__ORGANISATIONAL_CHANGES_ID_DESC',
  ScenarioGroupByScenarioGroupIdResponsibleAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__RESPONSIBLE_ASC',
  ScenarioGroupByScenarioGroupIdResponsibleDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__RESPONSIBLE_DESC',
  ScenarioGroupByScenarioGroupIdStatusAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__STATUS_ASC',
  ScenarioGroupByScenarioGroupIdStatusDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__STATUS_DESC',
  ScenarioGroupByScenarioGroupIdUpdatedAtAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__UPDATED_AT_ASC',
  ScenarioGroupByScenarioGroupIdUpdatedAtDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__UPDATED_AT_DESC',
  ScenarioGroupByScenarioGroupIdUpdatedByAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__UPDATED_BY_ASC',
  ScenarioGroupByScenarioGroupIdUpdatedByDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__UPDATED_BY_DESC',
  ScenarioGroupByScenarioGroupIdUpdatedByNameAsc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__UPDATED_BY_NAME_ASC',
  ScenarioGroupByScenarioGroupIdUpdatedByNameDesc = 'SCENARIO_GROUP_BY_SCENARIO_GROUP_ID__UPDATED_BY_NAME_DESC',
  ScenarioGroupIdAsc = 'SCENARIO_GROUP_ID_ASC',
  ScenarioGroupIdDesc = 'SCENARIO_GROUP_ID_DESC',
  ScenarioSettingByScenarioIdEndAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__END_ASC',
  ScenarioSettingByScenarioIdEndDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__END_DESC',
  ScenarioSettingByScenarioIdMonthsAfterAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__MONTHS_AFTER_ASC',
  ScenarioSettingByScenarioIdMonthsAfterDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__MONTHS_AFTER_DESC',
  ScenarioSettingByScenarioIdMonthsBeforeAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__MONTHS_BEFORE_ASC',
  ScenarioSettingByScenarioIdMonthsBeforeDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__MONTHS_BEFORE_DESC',
  ScenarioSettingByScenarioIdQuarterAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__QUARTER_ASC',
  ScenarioSettingByScenarioIdQuarterDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__QUARTER_DESC',
  ScenarioSettingByScenarioIdScenarioIdAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__SCENARIO_ID_ASC',
  ScenarioSettingByScenarioIdScenarioIdDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__SCENARIO_ID_DESC',
  ScenarioSettingByScenarioIdShowSectionsAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__SHOW_SECTIONS_ASC',
  ScenarioSettingByScenarioIdShowSectionsDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__SHOW_SECTIONS_DESC',
  ScenarioSettingByScenarioIdStartAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__START_ASC',
  ScenarioSettingByScenarioIdStartDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__START_DESC',
  ScenarioSettingByScenarioIdYearAsc = 'SCENARIO_SETTING_BY_SCENARIO_ID__YEAR_ASC',
  ScenarioSettingByScenarioIdYearDesc = 'SCENARIO_SETTING_BY_SCENARIO_ID__YEAR_DESC',
  ScenarioVariantVisibilitiesByScenarioIdCountAsc = 'SCENARIO_VARIANT_VISIBILITIES_BY_SCENARIO_ID__COUNT_ASC',
  ScenarioVariantVisibilitiesByScenarioIdCountDesc = 'SCENARIO_VARIANT_VISIBILITIES_BY_SCENARIO_ID__COUNT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UpdatedByNameAsc = 'UPDATED_BY_NAME_ASC',
  UpdatedByNameDesc = 'UPDATED_BY_NAME_DESC',
  UserByCreatedByActivatedAtAsc = 'USER_BY_CREATED_BY__ACTIVATED_AT_ASC',
  UserByCreatedByActivatedAtDesc = 'USER_BY_CREATED_BY__ACTIVATED_AT_DESC',
  UserByCreatedByCompanyAsc = 'USER_BY_CREATED_BY__COMPANY_ASC',
  UserByCreatedByCompanyDesc = 'USER_BY_CREATED_BY__COMPANY_DESC',
  UserByCreatedByCreatedAtAsc = 'USER_BY_CREATED_BY__CREATED_AT_ASC',
  UserByCreatedByCreatedAtDesc = 'USER_BY_CREATED_BY__CREATED_AT_DESC',
  UserByCreatedByDeactivatedAtAsc = 'USER_BY_CREATED_BY__DEACTIVATED_AT_ASC',
  UserByCreatedByDeactivatedAtDesc = 'USER_BY_CREATED_BY__DEACTIVATED_AT_DESC',
  UserByCreatedByFirstNameAsc = 'USER_BY_CREATED_BY__FIRST_NAME_ASC',
  UserByCreatedByFirstNameDesc = 'USER_BY_CREATED_BY__FIRST_NAME_DESC',
  UserByCreatedByIdAsc = 'USER_BY_CREATED_BY__ID_ASC',
  UserByCreatedByIdDesc = 'USER_BY_CREATED_BY__ID_DESC',
  UserByCreatedByIsActiveAsc = 'USER_BY_CREATED_BY__IS_ACTIVE_ASC',
  UserByCreatedByIsActiveDesc = 'USER_BY_CREATED_BY__IS_ACTIVE_DESC',
  UserByCreatedByIsAdminAsc = 'USER_BY_CREATED_BY__IS_ADMIN_ASC',
  UserByCreatedByIsAdminDesc = 'USER_BY_CREATED_BY__IS_ADMIN_DESC',
  UserByCreatedByLastNameAsc = 'USER_BY_CREATED_BY__LAST_NAME_ASC',
  UserByCreatedByLastNameDesc = 'USER_BY_CREATED_BY__LAST_NAME_DESC',
  UserByCreatedByNameAsc = 'USER_BY_CREATED_BY__NAME_ASC',
  UserByCreatedByNameDesc = 'USER_BY_CREATED_BY__NAME_DESC',
  UserByCreatedByNotesAsc = 'USER_BY_CREATED_BY__NOTES_ASC',
  UserByCreatedByNotesDesc = 'USER_BY_CREATED_BY__NOTES_DESC',
  UserByCreatedByPositionAsc = 'USER_BY_CREATED_BY__POSITION_ASC',
  UserByCreatedByPositionDesc = 'USER_BY_CREATED_BY__POSITION_DESC',
  UserByCreatedByUpdatedAtAsc = 'USER_BY_CREATED_BY__UPDATED_AT_ASC',
  UserByCreatedByUpdatedAtDesc = 'USER_BY_CREATED_BY__UPDATED_AT_DESC',
  UserByUpdatedByActivatedAtAsc = 'USER_BY_UPDATED_BY__ACTIVATED_AT_ASC',
  UserByUpdatedByActivatedAtDesc = 'USER_BY_UPDATED_BY__ACTIVATED_AT_DESC',
  UserByUpdatedByCompanyAsc = 'USER_BY_UPDATED_BY__COMPANY_ASC',
  UserByUpdatedByCompanyDesc = 'USER_BY_UPDATED_BY__COMPANY_DESC',
  UserByUpdatedByCreatedAtAsc = 'USER_BY_UPDATED_BY__CREATED_AT_ASC',
  UserByUpdatedByCreatedAtDesc = 'USER_BY_UPDATED_BY__CREATED_AT_DESC',
  UserByUpdatedByDeactivatedAtAsc = 'USER_BY_UPDATED_BY__DEACTIVATED_AT_ASC',
  UserByUpdatedByDeactivatedAtDesc = 'USER_BY_UPDATED_BY__DEACTIVATED_AT_DESC',
  UserByUpdatedByFirstNameAsc = 'USER_BY_UPDATED_BY__FIRST_NAME_ASC',
  UserByUpdatedByFirstNameDesc = 'USER_BY_UPDATED_BY__FIRST_NAME_DESC',
  UserByUpdatedByIdAsc = 'USER_BY_UPDATED_BY__ID_ASC',
  UserByUpdatedByIdDesc = 'USER_BY_UPDATED_BY__ID_DESC',
  UserByUpdatedByIsActiveAsc = 'USER_BY_UPDATED_BY__IS_ACTIVE_ASC',
  UserByUpdatedByIsActiveDesc = 'USER_BY_UPDATED_BY__IS_ACTIVE_DESC',
  UserByUpdatedByIsAdminAsc = 'USER_BY_UPDATED_BY__IS_ADMIN_ASC',
  UserByUpdatedByIsAdminDesc = 'USER_BY_UPDATED_BY__IS_ADMIN_DESC',
  UserByUpdatedByLastNameAsc = 'USER_BY_UPDATED_BY__LAST_NAME_ASC',
  UserByUpdatedByLastNameDesc = 'USER_BY_UPDATED_BY__LAST_NAME_DESC',
  UserByUpdatedByNameAsc = 'USER_BY_UPDATED_BY__NAME_ASC',
  UserByUpdatedByNameDesc = 'USER_BY_UPDATED_BY__NAME_DESC',
  UserByUpdatedByNotesAsc = 'USER_BY_UPDATED_BY__NOTES_ASC',
  UserByUpdatedByNotesDesc = 'USER_BY_UPDATED_BY__NOTES_DESC',
  UserByUpdatedByPositionAsc = 'USER_BY_UPDATED_BY__POSITION_ASC',
  UserByUpdatedByPositionDesc = 'USER_BY_UPDATED_BY__POSITION_DESC',
  UserByUpdatedByUpdatedAtAsc = 'USER_BY_UPDATED_BY__UPDATED_AT_ASC',
  UserByUpdatedByUpdatedAtDesc = 'USER_BY_UPDATED_BY__UPDATED_AT_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type Session = {
  __typename?: 'Session';
  jwt: Scalars['String'];
  user: SessionUser;
};

export enum SessionProvider {
  Password = 'password',
  SsoKm = 'sso_km',
  SsoLdt = 'sso_ldt'
}

export type SessionUser = {
  __typename?: 'SessionUser';
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  provider: SessionProvider;
};

export type SetPasswordResponse = Success;

export type Site = {
  __typename?: 'Site';
  /** Reads and enables pagination through a set of `Building`. */
  buildings: BuildingsConnection;
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads and enables pagination through a set of `SiteDescription`. */
  siteDescriptions: SiteDescriptionsConnection;
  /** Reads and enables pagination through a set of `SiteNameExtra`. */
  siteNameExtras: SiteNameExtrasConnection;
  /** Reads and enables pagination through a set of `SiteNameKeyCad`. */
  siteNameKeyCads: SiteNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `SiteNameKeyCafm`. */
  siteNameKeyCafms: SiteNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `SiteNameKeyEbm`. */
  siteNameKeyEbms: SiteNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `SiteNameKeyMarketing`. */
  siteNameKeyMarketings: SiteNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `SiteNameLong`. */
  siteNameLongs: SiteNameLongsConnection;
  /** Reads and enables pagination through a set of `SiteNameShort`. */
  siteNameShorts: SiteNameShortsConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zones: ZonesConnection;
};


export type SiteBuildingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BuildingCondition>;
  filter?: InputMaybe<BuildingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildingsOrderBy>>;
};


export type SiteSiteDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteDescriptionCondition>;
  filter?: InputMaybe<SiteDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteDescriptionsOrderBy>>;
};


export type SiteSiteNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameExtraCondition>;
  filter?: InputMaybe<SiteNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameExtrasOrderBy>>;
};


export type SiteSiteNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyCadCondition>;
  filter?: InputMaybe<SiteNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyCadsOrderBy>>;
};


export type SiteSiteNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyCafmCondition>;
  filter?: InputMaybe<SiteNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyCafmsOrderBy>>;
};


export type SiteSiteNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyEbmCondition>;
  filter?: InputMaybe<SiteNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyEbmsOrderBy>>;
};


export type SiteSiteNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameKeyMarketingCondition>;
  filter?: InputMaybe<SiteNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameKeyMarketingsOrderBy>>;
};


export type SiteSiteNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameLongCondition>;
  filter?: InputMaybe<SiteNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameLongsOrderBy>>;
};


export type SiteSiteNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SiteNameShortCondition>;
  filter?: InputMaybe<SiteNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SiteNameShortsOrderBy>>;
};


export type SiteZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCondition>;
  filter?: InputMaybe<ZoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** A condition to be used against `Site` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SiteCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
};

export type SiteDescription = {
  __typename?: 'SiteDescription';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteDescription`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteDescription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteDescriptionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteDescription` object types. All fields are combined with a logical ‘and.’ */
export type SiteDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteDescriptionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteDescriptionFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteDescription` */
export type SiteDescriptionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteDescriptionSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteDescription` to look up the row to update. */
export type SiteDescriptionOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSiteDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteDescription` being updated. */
  patch: UpdateSiteDescriptionOnSiteDescriptionForSiteDescriptionSiteIdFkeyPatch;
};

/** Represents an update to a `SiteDescription`. Fields that are set will be updated. */
export type SiteDescriptionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteDescriptionSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `siteDescription` to look up the row to connect. */
export type SiteDescriptionSiteDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteDescription` to look up the row to delete. */
export type SiteDescriptionSiteDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `site` in the `SiteDescriptionInput` mutation. */
export type SiteDescriptionSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteDescriptionSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteDescription` in the `SiteInput` mutation. */
export type SiteDescriptionSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteDescriptionSiteDescriptionPkeyConnect>>;
  /** A `SiteDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteDescriptionSiteIdFkeySiteDescriptionCreateInput>>;
  /** The primary key(s) for `siteDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteDescriptionSiteDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `siteDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteDescriptionOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSiteDescriptionPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteDescriptionSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteDescription` to be created by this mutation. */
export type SiteDescriptionSiteIdFkeySiteDescriptionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteDescriptionSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** A connection to a list of `SiteDescription` values. */
export type SiteDescriptionsConnection = {
  __typename?: 'SiteDescriptionsConnection';
  /** A list of edges which contains the `SiteDescription` and cursor to aid in pagination. */
  edges: Array<SiteDescriptionsEdge>;
  /** A list of `SiteDescription` objects. */
  nodes: Array<SiteDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteDescription` edge in the connection. */
export type SiteDescriptionsEdge = {
  __typename?: 'SiteDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteDescription` at the end of the edge. */
  node: SiteDescription;
};

/** Methods to use when ordering `SiteDescription`. */
export enum SiteDescriptionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against `Site` object types. All fields are combined with a logical ‘and.’ */
export type SiteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteFilter>>;
  /** Filter by the object’s `buildings` relation. */
  buildings?: InputMaybe<SiteToManyBuildingFilter>;
  /** Some related `buildings` exist. */
  buildingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteFilter>>;
  /** Filter by the object’s `siteDescriptions` relation. */
  siteDescriptions?: InputMaybe<SiteToManySiteDescriptionFilter>;
  /** Some related `siteDescriptions` exist. */
  siteDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameExtras` relation. */
  siteNameExtras?: InputMaybe<SiteToManySiteNameExtraFilter>;
  /** Some related `siteNameExtras` exist. */
  siteNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameKeyCads` relation. */
  siteNameKeyCads?: InputMaybe<SiteToManySiteNameKeyCadFilter>;
  /** Some related `siteNameKeyCads` exist. */
  siteNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameKeyCafms` relation. */
  siteNameKeyCafms?: InputMaybe<SiteToManySiteNameKeyCafmFilter>;
  /** Some related `siteNameKeyCafms` exist. */
  siteNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameKeyEbms` relation. */
  siteNameKeyEbms?: InputMaybe<SiteToManySiteNameKeyEbmFilter>;
  /** Some related `siteNameKeyEbms` exist. */
  siteNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameKeyMarketings` relation. */
  siteNameKeyMarketings?: InputMaybe<SiteToManySiteNameKeyMarketingFilter>;
  /** Some related `siteNameKeyMarketings` exist. */
  siteNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameLongs` relation. */
  siteNameLongs?: InputMaybe<SiteToManySiteNameLongFilter>;
  /** Some related `siteNameLongs` exist. */
  siteNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `siteNameShorts` relation. */
  siteNameShorts?: InputMaybe<SiteToManySiteNameShortFilter>;
  /** Some related `siteNameShorts` exist. */
  siteNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zones` relation. */
  zones?: InputMaybe<SiteToManyZoneFilter>;
  /** Some related `zones` exist. */
  zonesExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Site` */
export type SiteInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

export type SiteNameExtra = {
  __typename?: 'SiteNameExtra';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameExtra`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteNameExtraCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameExtraFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameExtraFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameExtra` */
export type SiteNameExtraInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameExtraSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameExtra` to look up the row to update. */
export type SiteNameExtraOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSiteNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameExtra` being updated. */
  patch: UpdateSiteNameExtraOnSiteNameExtraForSiteNameExtraSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameExtra`. Fields that are set will be updated. */
export type SiteNameExtraPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameExtraSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `site` in the `SiteNameExtraInput` mutation. */
export type SiteNameExtraSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameExtraSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameExtra` in the `SiteInput` mutation. */
export type SiteNameExtraSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameExtraSiteNameExtraPkeyConnect>>;
  /** A `SiteNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameExtraSiteIdFkeySiteNameExtraCreateInput>>;
  /** The primary key(s) for `siteNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameExtraSiteNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `siteNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameExtraOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSiteNameExtraPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameExtraSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameExtra` to be created by this mutation. */
export type SiteNameExtraSiteIdFkeySiteNameExtraCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameExtraSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameExtra` to look up the row to connect. */
export type SiteNameExtraSiteNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameExtra` to look up the row to delete. */
export type SiteNameExtraSiteNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameExtra` values. */
export type SiteNameExtrasConnection = {
  __typename?: 'SiteNameExtrasConnection';
  /** A list of edges which contains the `SiteNameExtra` and cursor to aid in pagination. */
  edges: Array<SiteNameExtrasEdge>;
  /** A list of `SiteNameExtra` objects. */
  nodes: Array<SiteNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameExtra` edge in the connection. */
export type SiteNameExtrasEdge = {
  __typename?: 'SiteNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameExtra` at the end of the edge. */
  node: SiteNameExtra;
};

/** Methods to use when ordering `SiteNameExtra`. */
export enum SiteNameExtrasOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type SiteNameKeyCad = {
  __typename?: 'SiteNameKeyCad';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameKeyCad`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteNameKeyCadCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameKeyCadFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameKeyCadFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameKeyCad` */
export type SiteNameKeyCadInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyCad` to look up the row to update. */
export type SiteNameKeyCadOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSiteNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameKeyCad` being updated. */
  patch: UpdateSiteNameKeyCadOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameKeyCad`. Fields that are set will be updated. */
export type SiteNameKeyCadPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `site` in the `SiteNameKeyCadInput` mutation. */
export type SiteNameKeyCadSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameKeyCadSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameKeyCad` in the `SiteInput` mutation. */
export type SiteNameKeyCadSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameKeyCadSiteNameKeyCadPkeyConnect>>;
  /** A `SiteNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameKeyCadSiteIdFkeySiteNameKeyCadCreateInput>>;
  /** The primary key(s) for `siteNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameKeyCadSiteNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `siteNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameKeyCadOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSiteNameKeyCadPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameKeyCadSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameKeyCad` to be created by this mutation. */
export type SiteNameKeyCadSiteIdFkeySiteNameKeyCadCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyCad` to look up the row to connect. */
export type SiteNameKeyCadSiteNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameKeyCad` to look up the row to delete. */
export type SiteNameKeyCadSiteNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameKeyCad` values. */
export type SiteNameKeyCadsConnection = {
  __typename?: 'SiteNameKeyCadsConnection';
  /** A list of edges which contains the `SiteNameKeyCad` and cursor to aid in pagination. */
  edges: Array<SiteNameKeyCadsEdge>;
  /** A list of `SiteNameKeyCad` objects. */
  nodes: Array<SiteNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameKeyCad` edge in the connection. */
export type SiteNameKeyCadsEdge = {
  __typename?: 'SiteNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameKeyCad` at the end of the edge. */
  node: SiteNameKeyCad;
};

/** Methods to use when ordering `SiteNameKeyCad`. */
export enum SiteNameKeyCadsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type SiteNameKeyCafm = {
  __typename?: 'SiteNameKeyCafm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameKeyCafm`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameKeyCafm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteNameKeyCafmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameKeyCafmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameKeyCafmFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameKeyCafm` */
export type SiteNameKeyCafmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyCafm` to look up the row to update. */
export type SiteNameKeyCafmOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSiteNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameKeyCafm` being updated. */
  patch: UpdateSiteNameKeyCafmOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameKeyCafm`. Fields that are set will be updated. */
export type SiteNameKeyCafmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `site` in the `SiteNameKeyCafmInput` mutation. */
export type SiteNameKeyCafmSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameKeyCafmSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameKeyCafm` in the `SiteInput` mutation. */
export type SiteNameKeyCafmSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameKeyCafmSiteNameKeyCafmPkeyConnect>>;
  /** A `SiteNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameKeyCafmSiteIdFkeySiteNameKeyCafmCreateInput>>;
  /** The primary key(s) for `siteNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameKeyCafmSiteNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `siteNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameKeyCafmOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSiteNameKeyCafmPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameKeyCafmSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameKeyCafm` to be created by this mutation. */
export type SiteNameKeyCafmSiteIdFkeySiteNameKeyCafmCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyCafm` to look up the row to connect. */
export type SiteNameKeyCafmSiteNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameKeyCafm` to look up the row to delete. */
export type SiteNameKeyCafmSiteNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameKeyCafm` values. */
export type SiteNameKeyCafmsConnection = {
  __typename?: 'SiteNameKeyCafmsConnection';
  /** A list of edges which contains the `SiteNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<SiteNameKeyCafmsEdge>;
  /** A list of `SiteNameKeyCafm` objects. */
  nodes: Array<SiteNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameKeyCafm` edge in the connection. */
export type SiteNameKeyCafmsEdge = {
  __typename?: 'SiteNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameKeyCafm` at the end of the edge. */
  node: SiteNameKeyCafm;
};

/** Methods to use when ordering `SiteNameKeyCafm`. */
export enum SiteNameKeyCafmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type SiteNameKeyEbm = {
  __typename?: 'SiteNameKeyEbm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameKeyEbm`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteNameKeyEbmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameKeyEbmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameKeyEbmFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameKeyEbm` */
export type SiteNameKeyEbmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyEbm` to look up the row to update. */
export type SiteNameKeyEbmOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSiteNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameKeyEbm` being updated. */
  patch: UpdateSiteNameKeyEbmOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameKeyEbm`. Fields that are set will be updated. */
export type SiteNameKeyEbmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `siteNameKeyEbm` to look up the row to connect. */
export type SiteNameKeyEbmSiteNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameKeyEbm` to look up the row to delete. */
export type SiteNameKeyEbmSiteNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameKeyEbm` values. */
export type SiteNameKeyEbmsConnection = {
  __typename?: 'SiteNameKeyEbmsConnection';
  /** A list of edges which contains the `SiteNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<SiteNameKeyEbmsEdge>;
  /** A list of `SiteNameKeyEbm` objects. */
  nodes: Array<SiteNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameKeyEbm` edge in the connection. */
export type SiteNameKeyEbmsEdge = {
  __typename?: 'SiteNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameKeyEbm` at the end of the edge. */
  node: SiteNameKeyEbm;
};

/** Methods to use when ordering `SiteNameKeyEbm`. */
export enum SiteNameKeyEbmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Input for the nested mutation of `site` in the `SiteNameKeyEbmInput` mutation. */
export type SiteNameKeyEbmsSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameKeyEbmsSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameKeyEbm` in the `SiteInput` mutation. */
export type SiteNameKeyEbmsSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameKeyEbmSiteNameKeyEbmsPkeyConnect>>;
  /** A `SiteNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameKeyEbmsSiteIdFkeySiteNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `siteNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameKeyEbmSiteNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `siteNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameKeyEbmOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSiteNameKeyEbmsPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameKeyEbmsSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameKeyEbm` to be created by this mutation. */
export type SiteNameKeyEbmsSiteIdFkeySiteNameKeyEbmsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

export type SiteNameKeyMarketing = {
  __typename?: 'SiteNameKeyMarketing';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameKeyMarketing`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameKeyMarketing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SiteNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameKeyMarketingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameKeyMarketingFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameKeyMarketing` */
export type SiteNameKeyMarketingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyMarketing` to look up the row to update. */
export type SiteNameKeyMarketingOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSiteNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameKeyMarketing` being updated. */
  patch: UpdateSiteNameKeyMarketingOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameKeyMarketing`. Fields that are set will be updated. */
export type SiteNameKeyMarketingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `site` in the `SiteNameKeyMarketingInput` mutation. */
export type SiteNameKeyMarketingSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameKeyMarketingSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameKeyMarketing` in the `SiteInput` mutation. */
export type SiteNameKeyMarketingSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameKeyMarketingSiteNameKeyMarketingPkeyConnect>>;
  /** A `SiteNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameKeyMarketingSiteIdFkeySiteNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `siteNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameKeyMarketingSiteNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `siteNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameKeyMarketingOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSiteNameKeyMarketingPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameKeyMarketingSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameKeyMarketing` to be created by this mutation. */
export type SiteNameKeyMarketingSiteIdFkeySiteNameKeyMarketingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameKeyMarketing` to look up the row to connect. */
export type SiteNameKeyMarketingSiteNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameKeyMarketing` to look up the row to delete. */
export type SiteNameKeyMarketingSiteNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameKeyMarketing` values. */
export type SiteNameKeyMarketingsConnection = {
  __typename?: 'SiteNameKeyMarketingsConnection';
  /** A list of edges which contains the `SiteNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<SiteNameKeyMarketingsEdge>;
  /** A list of `SiteNameKeyMarketing` objects. */
  nodes: Array<SiteNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameKeyMarketing` edge in the connection. */
export type SiteNameKeyMarketingsEdge = {
  __typename?: 'SiteNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameKeyMarketing` at the end of the edge. */
  node: SiteNameKeyMarketing;
};

/** Methods to use when ordering `SiteNameKeyMarketing`. */
export enum SiteNameKeyMarketingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type SiteNameLong = {
  __typename?: 'SiteNameLong';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameLong`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteNameLongCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameLong` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameLongFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameLongFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameLong` */
export type SiteNameLongInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameLongSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameLong` to look up the row to update. */
export type SiteNameLongOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSiteNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameLong` being updated. */
  patch: UpdateSiteNameLongOnSiteNameLongForSiteNameLongSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameLong`. Fields that are set will be updated. */
export type SiteNameLongPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameLongSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `site` in the `SiteNameLongInput` mutation. */
export type SiteNameLongSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameLongSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameLong` in the `SiteInput` mutation. */
export type SiteNameLongSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameLongSiteNameLongPkeyConnect>>;
  /** A `SiteNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameLongSiteIdFkeySiteNameLongCreateInput>>;
  /** The primary key(s) for `siteNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameLongSiteNameLongPkeyDelete>>;
  /** Flag indicating whether all other `siteNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameLongOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSiteNameLongPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameLongSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameLong` to be created by this mutation. */
export type SiteNameLongSiteIdFkeySiteNameLongCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameLongSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameLong` to look up the row to connect. */
export type SiteNameLongSiteNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameLong` to look up the row to delete. */
export type SiteNameLongSiteNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameLong` values. */
export type SiteNameLongsConnection = {
  __typename?: 'SiteNameLongsConnection';
  /** A list of edges which contains the `SiteNameLong` and cursor to aid in pagination. */
  edges: Array<SiteNameLongsEdge>;
  /** A list of `SiteNameLong` objects. */
  nodes: Array<SiteNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameLong` edge in the connection. */
export type SiteNameLongsEdge = {
  __typename?: 'SiteNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameLong` at the end of the edge. */
  node: SiteNameLong;
};

/** Methods to use when ordering `SiteNameLong`. */
export enum SiteNameLongsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type SiteNameShort = {
  __typename?: 'SiteNameShort';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Site` that is related to this `SiteNameShort`. */
  site: Site;
  siteId: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/**
 * A condition to be used against `SiteNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SiteNameShortCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SiteNameShort` object types. All fields are combined with a logical ‘and.’ */
export type SiteNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SiteNameShortFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SiteNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SiteNameShortFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SiteNameShort` */
export type SiteNameShortInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameShortSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameShort` to look up the row to update. */
export type SiteNameShortOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSiteNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `siteNameShort` being updated. */
  patch: UpdateSiteNameShortOnSiteNameShortForSiteNameShortSiteIdFkeyPatch;
};

/** Represents an update to a `SiteNameShort`. Fields that are set will be updated. */
export type SiteNameShortPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameShortSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `site` in the `SiteNameShortInput` mutation. */
export type SiteNameShortSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<SiteNameShortSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `siteNameShort` in the `SiteInput` mutation. */
export type SiteNameShortSiteIdFkeyInverseInput = {
  /** The primary key(s) for `siteNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SiteNameShortSiteNameShortPkeyConnect>>;
  /** A `SiteNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SiteNameShortSiteIdFkeySiteNameShortCreateInput>>;
  /** The primary key(s) for `siteNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SiteNameShortSiteNameShortPkeyDelete>>;
  /** Flag indicating whether all other `siteNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `siteNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SiteNameShortOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSiteNameShortPkeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type SiteNameShortSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `siteNameShort` to be created by this mutation. */
export type SiteNameShortSiteIdFkeySiteNameShortCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameShortSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `siteNameShort` to look up the row to connect. */
export type SiteNameShortSiteNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `siteNameShort` to look up the row to delete. */
export type SiteNameShortSiteNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `SiteNameShort` values. */
export type SiteNameShortsConnection = {
  __typename?: 'SiteNameShortsConnection';
  /** A list of edges which contains the `SiteNameShort` and cursor to aid in pagination. */
  edges: Array<SiteNameShortsEdge>;
  /** A list of `SiteNameShort` objects. */
  nodes: Array<SiteNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SiteNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SiteNameShort` edge in the connection. */
export type SiteNameShortsEdge = {
  __typename?: 'SiteNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SiteNameShort` at the end of the edge. */
  node: SiteNameShort;
};

/** Methods to use when ordering `SiteNameShort`. */
export enum SiteNameShortsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** The fields on `site` to look up the row to update. */
export type SiteOnBuildingForBuildingSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnBuildingForBuildingSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnBuildingForBuildingSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnBuildingForBuildingSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnBuildingForBuildingSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnBuildingForBuildingSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameLongForSiteNameLongSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameLongForSiteNameLongSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameLongForSiteNameLongSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameLongForSiteNameLongSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameShortForSiteNameShortSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameShortForSiteNameShortSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnSiteNameShortForSiteNameShortSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnSiteNameShortForSiteNameShortSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnZoneForZoneSiteIdFkeyUsingSiteExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnZoneForZoneSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnZoneForZoneSiteIdFkeyUsingSiteNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnZoneForZoneSiteIdFkeyPatch;
};

/** The fields on `site` to look up the row to update. */
export type SiteOnZoneForZoneSiteIdFkeyUsingSitePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `site` being updated. */
  patch: UpdateSiteOnZoneForZoneSiteIdFkeyPatch;
};

/** Represents an update to a `Site`. Fields that are set will be updated. */
export type SitePatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The fields on `site` to look up the row to connect. */
export type SiteSiteExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `site` to look up the row to delete. */
export type SiteSiteExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `site` to look up the row to connect. */
export type SiteSiteNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `site` to look up the row to delete. */
export type SiteSiteNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `site` to look up the row to connect. */
export type SiteSitePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `site` to look up the row to delete. */
export type SiteSitePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Building` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManyBuildingFilter = {
  /** Every related `Building` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BuildingFilter>;
  /** No related `Building` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BuildingFilter>;
  /** Some related `Building` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BuildingFilter>;
};

/** A filter to be used against many `SiteDescription` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteDescriptionFilter = {
  /** Every related `SiteDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteDescriptionFilter>;
  /** No related `SiteDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteDescriptionFilter>;
  /** Some related `SiteDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteDescriptionFilter>;
};

/** A filter to be used against many `SiteNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameExtraFilter = {
  /** Every related `SiteNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameExtraFilter>;
  /** No related `SiteNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameExtraFilter>;
  /** Some related `SiteNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameExtraFilter>;
};

/** A filter to be used against many `SiteNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameKeyCadFilter = {
  /** Every related `SiteNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameKeyCadFilter>;
  /** No related `SiteNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameKeyCadFilter>;
  /** Some related `SiteNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameKeyCadFilter>;
};

/** A filter to be used against many `SiteNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameKeyCafmFilter = {
  /** Every related `SiteNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameKeyCafmFilter>;
  /** No related `SiteNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameKeyCafmFilter>;
  /** Some related `SiteNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameKeyCafmFilter>;
};

/** A filter to be used against many `SiteNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameKeyEbmFilter = {
  /** Every related `SiteNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameKeyEbmFilter>;
  /** No related `SiteNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameKeyEbmFilter>;
  /** Some related `SiteNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameKeyEbmFilter>;
};

/** A filter to be used against many `SiteNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameKeyMarketingFilter = {
  /** Every related `SiteNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameKeyMarketingFilter>;
  /** No related `SiteNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameKeyMarketingFilter>;
  /** Some related `SiteNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameKeyMarketingFilter>;
};

/** A filter to be used against many `SiteNameLong` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameLongFilter = {
  /** Every related `SiteNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameLongFilter>;
  /** No related `SiteNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameLongFilter>;
  /** Some related `SiteNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameLongFilter>;
};

/** A filter to be used against many `SiteNameShort` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManySiteNameShortFilter = {
  /** Every related `SiteNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SiteNameShortFilter>;
  /** No related `SiteNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SiteNameShortFilter>;
  /** Some related `SiteNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SiteNameShortFilter>;
};

/** A filter to be used against many `Zone` object types. All fields are combined with a logical ‘and.’ */
export type SiteToManyZoneFilter = {
  /** Every related `Zone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneFilter>;
  /** No related `Zone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneFilter>;
  /** Some related `Zone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneFilter>;
};

/** A connection to a list of `Site` values. */
export type SitesConnection = {
  __typename?: 'SitesConnection';
  /** A list of edges which contains the `Site` and cursor to aid in pagination. */
  edges: Array<SitesEdge>;
  /** A list of `Site` objects. */
  nodes: Array<Site>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Site` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Site` edge in the connection. */
export type SitesEdge = {
  __typename?: 'SitesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Site` at the end of the edge. */
  node: Site;
};

/** Methods to use when ordering `Site`. */
export enum SitesOrderBy {
  BuildingsBySiteIdCountAsc = 'BUILDINGS_BY_SITE_ID__COUNT_ASC',
  BuildingsBySiteIdCountDesc = 'BUILDINGS_BY_SITE_ID__COUNT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteDescriptionsBySiteIdCountAsc = 'SITE_DESCRIPTIONS_BY_SITE_ID__COUNT_ASC',
  SiteDescriptionsBySiteIdCountDesc = 'SITE_DESCRIPTIONS_BY_SITE_ID__COUNT_DESC',
  SiteNameExtrasBySiteIdCountAsc = 'SITE_NAME_EXTRAS_BY_SITE_ID__COUNT_ASC',
  SiteNameExtrasBySiteIdCountDesc = 'SITE_NAME_EXTRAS_BY_SITE_ID__COUNT_DESC',
  SiteNameKeyCadsBySiteIdCountAsc = 'SITE_NAME_KEY_CADS_BY_SITE_ID__COUNT_ASC',
  SiteNameKeyCadsBySiteIdCountDesc = 'SITE_NAME_KEY_CADS_BY_SITE_ID__COUNT_DESC',
  SiteNameKeyCafmsBySiteIdCountAsc = 'SITE_NAME_KEY_CAFMS_BY_SITE_ID__COUNT_ASC',
  SiteNameKeyCafmsBySiteIdCountDesc = 'SITE_NAME_KEY_CAFMS_BY_SITE_ID__COUNT_DESC',
  SiteNameKeyEbmsBySiteIdCountAsc = 'SITE_NAME_KEY_EBMS_BY_SITE_ID__COUNT_ASC',
  SiteNameKeyEbmsBySiteIdCountDesc = 'SITE_NAME_KEY_EBMS_BY_SITE_ID__COUNT_DESC',
  SiteNameKeyMarketingsBySiteIdCountAsc = 'SITE_NAME_KEY_MARKETINGS_BY_SITE_ID__COUNT_ASC',
  SiteNameKeyMarketingsBySiteIdCountDesc = 'SITE_NAME_KEY_MARKETINGS_BY_SITE_ID__COUNT_DESC',
  SiteNameLongsBySiteIdCountAsc = 'SITE_NAME_LONGS_BY_SITE_ID__COUNT_ASC',
  SiteNameLongsBySiteIdCountDesc = 'SITE_NAME_LONGS_BY_SITE_ID__COUNT_DESC',
  SiteNameShortsBySiteIdCountAsc = 'SITE_NAME_SHORTS_BY_SITE_ID__COUNT_ASC',
  SiteNameShortsBySiteIdCountDesc = 'SITE_NAME_SHORTS_BY_SITE_ID__COUNT_DESC',
  ZonesBySiteIdCountAsc = 'ZONES_BY_SITE_ID__COUNT_ASC',
  ZonesBySiteIdCountDesc = 'ZONES_BY_SITE_ID__COUNT_DESC'
}

export type SsoLoginData = {
  __typename?: 'SsoLoginData';
  activatedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  oid: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  provider: SsoProvider;
  room?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export enum SsoProvider {
  SsoKm = 'sso_km',
  SsoLdt = 'sso_ldt'
}

/** A filter to be used against SsoProvider fields. All fields are combined with a logical ‘and.’ */
export type SsoProviderFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SsoProvider>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SsoProvider>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SsoProvider>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SsoProvider>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SsoProvider>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SsoProvider>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SsoProvider>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SsoProvider>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SsoProvider>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SsoProvider>>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

export type Success = {
  __typename?: 'Success';
  message: Scalars['String'];
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** All input for the `updateAllocationArea` mutation. */
export type UpdateAllocationAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationArea` being updated. */
  patch: AllocationAreaPatch;
};

/** The output of our update `AllocationArea` mutation. */
export type UpdateAllocationAreaPayload = {
  __typename?: 'UpdateAllocationAreaPayload';
  /** The `AllocationArea` that was updated by this mutation. */
  allocationArea?: Maybe<AllocationArea>;
  /** An edge for our `AllocationArea`. May be used by Relay 1. */
  allocationAreaEdge?: Maybe<AllocationAreasEdge>;
  /** Reads a single `Area` that is related to this `AllocationArea`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EventVariant` that is related to this `AllocationArea`. */
  eventVariant?: Maybe<EventVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AllocationArea` mutation. */
export type UpdateAllocationAreaPayloadAllocationAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationAreasOrderBy>>;
};

/** All input for the `updateAllocationAreaPhase` mutation. */
export type UpdateAllocationAreaPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationAreaPhase` being updated. */
  patch: AllocationAreaPhasePatch;
};

/** The output of our update `AllocationAreaPhase` mutation. */
export type UpdateAllocationAreaPhasePayload = {
  __typename?: 'UpdateAllocationAreaPhasePayload';
  /** Reads a single `AllocationArea` that is related to this `AllocationAreaPhase`. */
  allocation?: Maybe<AllocationArea>;
  /** The `AllocationAreaPhase` that was updated by this mutation. */
  allocationAreaPhase?: Maybe<AllocationAreaPhase>;
  /** An edge for our `AllocationAreaPhase`. May be used by Relay 1. */
  allocationAreaPhaseEdge?: Maybe<AllocationAreaPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationAreaPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our update `AllocationAreaPhase` mutation. */
export type UpdateAllocationAreaPhasePayloadAllocationAreaPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationAreaPhasesOrderBy>>;
};

/** All input for the `updateAllocationPlot` mutation. */
export type UpdateAllocationPlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationPlot` being updated. */
  patch: AllocationPlotPatch;
};

/** The output of our update `AllocationPlot` mutation. */
export type UpdateAllocationPlotPayload = {
  __typename?: 'UpdateAllocationPlotPayload';
  /** The `AllocationPlot` that was updated by this mutation. */
  allocationPlot?: Maybe<AllocationPlot>;
  /** An edge for our `AllocationPlot`. May be used by Relay 1. */
  allocationPlotEdge?: Maybe<AllocationPlotsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EventVariant` that is related to this `AllocationPlot`. */
  eventVariant?: Maybe<EventVariant>;
  /** Reads a single `Plot` that is related to this `AllocationPlot`. */
  plot?: Maybe<Plot>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AllocationPlot` mutation. */
export type UpdateAllocationPlotPayloadAllocationPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationPlotsOrderBy>>;
};

/** All input for the `updateAllocationPlotPhase` mutation. */
export type UpdateAllocationPlotPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationPlotPhase` being updated. */
  patch: AllocationPlotPhasePatch;
};

/** The output of our update `AllocationPlotPhase` mutation. */
export type UpdateAllocationPlotPhasePayload = {
  __typename?: 'UpdateAllocationPlotPhasePayload';
  /** Reads a single `AllocationPlot` that is related to this `AllocationPlotPhase`. */
  allocation?: Maybe<AllocationPlot>;
  /** The `AllocationPlotPhase` that was updated by this mutation. */
  allocationPlotPhase?: Maybe<AllocationPlotPhase>;
  /** An edge for our `AllocationPlotPhase`. May be used by Relay 1. */
  allocationPlotPhaseEdge?: Maybe<AllocationPlotPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationPlotPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our update `AllocationPlotPhase` mutation. */
export type UpdateAllocationPlotPhasePayloadAllocationPlotPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationPlotPhasesOrderBy>>;
};

/** All input for the `updateAllocationRoom` mutation. */
export type UpdateAllocationRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationRoom` being updated. */
  patch: AllocationRoomPatch;
};

/** The output of our update `AllocationRoom` mutation. */
export type UpdateAllocationRoomPayload = {
  __typename?: 'UpdateAllocationRoomPayload';
  /** The `AllocationRoom` that was updated by this mutation. */
  allocationRoom?: Maybe<AllocationRoom>;
  /** An edge for our `AllocationRoom`. May be used by Relay 1. */
  allocationRoomEdge?: Maybe<AllocationRoomsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EventVariant` that is related to this `AllocationRoom`. */
  eventVariant?: Maybe<EventVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `AllocationRoom`. */
  room?: Maybe<Room>;
};


/** The output of our update `AllocationRoom` mutation. */
export type UpdateAllocationRoomPayloadAllocationRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationRoomsOrderBy>>;
};

/** All input for the `updateAllocationRoomPhase` mutation. */
export type UpdateAllocationRoomPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationRoomPhase` being updated. */
  patch: AllocationRoomPhasePatch;
};

/** The output of our update `AllocationRoomPhase` mutation. */
export type UpdateAllocationRoomPhasePayload = {
  __typename?: 'UpdateAllocationRoomPhasePayload';
  /** Reads a single `AllocationRoom` that is related to this `AllocationRoomPhase`. */
  allocation?: Maybe<AllocationRoom>;
  /** The `AllocationRoomPhase` that was updated by this mutation. */
  allocationRoomPhase?: Maybe<AllocationRoomPhase>;
  /** An edge for our `AllocationRoomPhase`. May be used by Relay 1. */
  allocationRoomPhaseEdge?: Maybe<AllocationRoomPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationUsage` that is related to this `AllocationRoomPhase`. */
  usage?: Maybe<AllocationUsage>;
};


/** The output of our update `AllocationRoomPhase` mutation. */
export type UpdateAllocationRoomPhasePayloadAllocationRoomPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationRoomPhasesOrderBy>>;
};

/** All input for the `updateAllocationUsageByName` mutation. */
export type UpdateAllocationUsageByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `AllocationUsage` being updated. */
  patch: AllocationUsagePatch;
};

/** All input for the `updateAllocationUsageByNameShort` mutation. */
export type UpdateAllocationUsageByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `AllocationUsage` being updated. */
  patch: AllocationUsagePatch;
};

/** All input for the `updateAllocationUsageByPosition` mutation. */
export type UpdateAllocationUsageByPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AllocationUsage` being updated. */
  patch: AllocationUsagePatch;
  position: Scalars['Int'];
};

/** All input for the `updateAllocationUsageByType` mutation. */
export type UpdateAllocationUsageByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AllocationUsage` being updated. */
  patch: AllocationUsagePatch;
  type: AllocationUsageType;
};

/** All input for the `updateAllocationUsage` mutation. */
export type UpdateAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AllocationUsage` being updated. */
  patch: AllocationUsagePatch;
};

/** The output of our update `AllocationUsage` mutation. */
export type UpdateAllocationUsagePayload = {
  __typename?: 'UpdateAllocationUsagePayload';
  /** The `AllocationUsage` that was updated by this mutation. */
  allocationUsage?: Maybe<AllocationUsage>;
  /** An edge for our `AllocationUsage`. May be used by Relay 1. */
  allocationUsageEdge?: Maybe<AllocationUsagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AllocationUsage` mutation. */
export type UpdateAllocationUsagePayloadAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<AllocationUsagesOrderBy>>;
};

/** All input for the `updateAreaByExtId` mutation. */
export type UpdateAreaByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Area` being updated. */
  patch: AreaPatch;
};

/** All input for the `updateAreaByNameShort` mutation. */
export type UpdateAreaByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Area` being updated. */
  patch: AreaPatch;
};

/** All input for the `updateAreaCadGrossSpaceMin` mutation. */
export type UpdateAreaCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaCadGrossSpaceMin` being updated. */
  patch: AreaCadGrossSpaceMinPatch;
};

/** The output of our update `AreaCadGrossSpaceMin` mutation. */
export type UpdateAreaCadGrossSpaceMinPayload = {
  __typename?: 'UpdateAreaCadGrossSpaceMinPayload';
  /** Reads a single `Area` that is related to this `AreaCadGrossSpaceMin`. */
  area?: Maybe<Area>;
  /** The `AreaCadGrossSpaceMin` that was updated by this mutation. */
  areaCadGrossSpaceMin?: Maybe<AreaCadGrossSpaceMin>;
  /** An edge for our `AreaCadGrossSpaceMin`. May be used by Relay 1. */
  areaCadGrossSpaceMinEdge?: Maybe<AreaCadGrossSpaceMinsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaCadGrossSpaceMin` mutation. */
export type UpdateAreaCadGrossSpaceMinPayloadAreaCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `updateAreaClearanceConstruction` mutation. */
export type UpdateAreaClearanceConstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaClearanceConstruction` being updated. */
  patch: AreaClearanceConstructionPatch;
};

/** The output of our update `AreaClearanceConstruction` mutation. */
export type UpdateAreaClearanceConstructionPayload = {
  __typename?: 'UpdateAreaClearanceConstructionPayload';
  /** Reads a single `Area` that is related to this `AreaClearanceConstruction`. */
  area?: Maybe<Area>;
  /** The `AreaClearanceConstruction` that was updated by this mutation. */
  areaClearanceConstruction?: Maybe<AreaClearanceConstruction>;
  /** An edge for our `AreaClearanceConstruction`. May be used by Relay 1. */
  areaClearanceConstructionEdge?: Maybe<AreaClearanceConstructionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaClearanceConstruction` mutation. */
export type UpdateAreaClearanceConstructionPayloadAreaClearanceConstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaClearanceConstructionsOrderBy>>;
};

/** All input for the `updateAreaContactBooking` mutation. */
export type UpdateAreaContactBookingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaContactBooking` being updated. */
  patch: AreaContactBookingPatch;
};

/** The output of our update `AreaContactBooking` mutation. */
export type UpdateAreaContactBookingPayload = {
  __typename?: 'UpdateAreaContactBookingPayload';
  /** Reads a single `Area` that is related to this `AreaContactBooking`. */
  area?: Maybe<Area>;
  /** The `AreaContactBooking` that was updated by this mutation. */
  areaContactBooking?: Maybe<AreaContactBooking>;
  /** An edge for our `AreaContactBooking`. May be used by Relay 1. */
  areaContactBookingEdge?: Maybe<AreaContactBookingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaContactBooking` mutation. */
export type UpdateAreaContactBookingPayloadAreaContactBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaContactBookingsOrderBy>>;
};

/** All input for the `updateAreaDescription` mutation. */
export type UpdateAreaDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaDescription` being updated. */
  patch: AreaDescriptionPatch;
};

/** The output of our update `AreaDescription` mutation. */
export type UpdateAreaDescriptionPayload = {
  __typename?: 'UpdateAreaDescriptionPayload';
  /** Reads a single `Area` that is related to this `AreaDescription`. */
  area?: Maybe<Area>;
  /** The `AreaDescription` that was updated by this mutation. */
  areaDescription?: Maybe<AreaDescription>;
  /** An edge for our `AreaDescription`. May be used by Relay 1. */
  areaDescriptionEdge?: Maybe<AreaDescriptionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaDescription` mutation. */
export type UpdateAreaDescriptionPayloadAreaDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaDescriptionsOrderBy>>;
};

/** All input for the `updateArea` mutation. */
export type UpdateAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Area` being updated. */
  patch: AreaPatch;
};

/** All input for the `updateAreaKeyIssuance` mutation. */
export type UpdateAreaKeyIssuanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaKeyIssuance` being updated. */
  patch: AreaKeyIssuancePatch;
};

/** All input for the `updateAreaKeyIssuanceNote` mutation. */
export type UpdateAreaKeyIssuanceNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaKeyIssuanceNote` being updated. */
  patch: AreaKeyIssuanceNotePatch;
};

/** The output of our update `AreaKeyIssuanceNote` mutation. */
export type UpdateAreaKeyIssuanceNotePayload = {
  __typename?: 'UpdateAreaKeyIssuanceNotePayload';
  /** Reads a single `Area` that is related to this `AreaKeyIssuanceNote`. */
  area?: Maybe<Area>;
  /** The `AreaKeyIssuanceNote` that was updated by this mutation. */
  areaKeyIssuanceNote?: Maybe<AreaKeyIssuanceNote>;
  /** An edge for our `AreaKeyIssuanceNote`. May be used by Relay 1. */
  areaKeyIssuanceNoteEdge?: Maybe<AreaKeyIssuanceNotesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaKeyIssuanceNote` mutation. */
export type UpdateAreaKeyIssuanceNotePayloadAreaKeyIssuanceNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaKeyIssuanceNotesOrderBy>>;
};

/** The output of our update `AreaKeyIssuance` mutation. */
export type UpdateAreaKeyIssuancePayload = {
  __typename?: 'UpdateAreaKeyIssuancePayload';
  /** Reads a single `Area` that is related to this `AreaKeyIssuance`. */
  area?: Maybe<Area>;
  /** The `AreaKeyIssuance` that was updated by this mutation. */
  areaKeyIssuance?: Maybe<AreaKeyIssuance>;
  /** An edge for our `AreaKeyIssuance`. May be used by Relay 1. */
  areaKeyIssuanceEdge?: Maybe<AreaKeyIssuancesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaKeyIssuance` mutation. */
export type UpdateAreaKeyIssuancePayloadAreaKeyIssuanceEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaKeyIssuancesOrderBy>>;
};

/** All input for the `updateAreaNameExtra` mutation. */
export type UpdateAreaNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameExtra` being updated. */
  patch: AreaNameExtraPatch;
};

/** The output of our update `AreaNameExtra` mutation. */
export type UpdateAreaNameExtraPayload = {
  __typename?: 'UpdateAreaNameExtraPayload';
  /** Reads a single `Area` that is related to this `AreaNameExtra`. */
  area?: Maybe<Area>;
  /** The `AreaNameExtra` that was updated by this mutation. */
  areaNameExtra?: Maybe<AreaNameExtra>;
  /** An edge for our `AreaNameExtra`. May be used by Relay 1. */
  areaNameExtraEdge?: Maybe<AreaNameExtrasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameExtra` mutation. */
export type UpdateAreaNameExtraPayloadAreaNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameExtrasOrderBy>>;
};

/** All input for the `updateAreaNameKeyCad` mutation. */
export type UpdateAreaNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameKeyCad` being updated. */
  patch: AreaNameKeyCadPatch;
};

/** The output of our update `AreaNameKeyCad` mutation. */
export type UpdateAreaNameKeyCadPayload = {
  __typename?: 'UpdateAreaNameKeyCadPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyCad`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyCad` that was updated by this mutation. */
  areaNameKeyCad?: Maybe<AreaNameKeyCad>;
  /** An edge for our `AreaNameKeyCad`. May be used by Relay 1. */
  areaNameKeyCadEdge?: Maybe<AreaNameKeyCadsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameKeyCad` mutation. */
export type UpdateAreaNameKeyCadPayloadAreaNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyCadsOrderBy>>;
};

/** All input for the `updateAreaNameKeyCafm` mutation. */
export type UpdateAreaNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameKeyCafm` being updated. */
  patch: AreaNameKeyCafmPatch;
};

/** The output of our update `AreaNameKeyCafm` mutation. */
export type UpdateAreaNameKeyCafmPayload = {
  __typename?: 'UpdateAreaNameKeyCafmPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyCafm`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyCafm` that was updated by this mutation. */
  areaNameKeyCafm?: Maybe<AreaNameKeyCafm>;
  /** An edge for our `AreaNameKeyCafm`. May be used by Relay 1. */
  areaNameKeyCafmEdge?: Maybe<AreaNameKeyCafmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameKeyCafm` mutation. */
export type UpdateAreaNameKeyCafmPayloadAreaNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyCafmsOrderBy>>;
};

/** All input for the `updateAreaNameKeyEbm` mutation. */
export type UpdateAreaNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameKeyEbm` being updated. */
  patch: AreaNameKeyEbmPatch;
};

/** The output of our update `AreaNameKeyEbm` mutation. */
export type UpdateAreaNameKeyEbmPayload = {
  __typename?: 'UpdateAreaNameKeyEbmPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyEbm`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyEbm` that was updated by this mutation. */
  areaNameKeyEbm?: Maybe<AreaNameKeyEbm>;
  /** An edge for our `AreaNameKeyEbm`. May be used by Relay 1. */
  areaNameKeyEbmEdge?: Maybe<AreaNameKeyEbmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameKeyEbm` mutation. */
export type UpdateAreaNameKeyEbmPayloadAreaNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyEbmsOrderBy>>;
};

/** All input for the `updateAreaNameKeyMarketing` mutation. */
export type UpdateAreaNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameKeyMarketing` being updated. */
  patch: AreaNameKeyMarketingPatch;
};

/** The output of our update `AreaNameKeyMarketing` mutation. */
export type UpdateAreaNameKeyMarketingPayload = {
  __typename?: 'UpdateAreaNameKeyMarketingPayload';
  /** Reads a single `Area` that is related to this `AreaNameKeyMarketing`. */
  area?: Maybe<Area>;
  /** The `AreaNameKeyMarketing` that was updated by this mutation. */
  areaNameKeyMarketing?: Maybe<AreaNameKeyMarketing>;
  /** An edge for our `AreaNameKeyMarketing`. May be used by Relay 1. */
  areaNameKeyMarketingEdge?: Maybe<AreaNameKeyMarketingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameKeyMarketing` mutation. */
export type UpdateAreaNameKeyMarketingPayloadAreaNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateAreaNameLong` mutation. */
export type UpdateAreaNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameLong` being updated. */
  patch: AreaNameLongPatch;
};

/** The output of our update `AreaNameLong` mutation. */
export type UpdateAreaNameLongPayload = {
  __typename?: 'UpdateAreaNameLongPayload';
  /** Reads a single `Area` that is related to this `AreaNameLong`. */
  area?: Maybe<Area>;
  /** The `AreaNameLong` that was updated by this mutation. */
  areaNameLong?: Maybe<AreaNameLong>;
  /** An edge for our `AreaNameLong`. May be used by Relay 1. */
  areaNameLongEdge?: Maybe<AreaNameLongsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameLong` mutation. */
export type UpdateAreaNameLongPayloadAreaNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameLongsOrderBy>>;
};

/** All input for the `updateAreaNameShort` mutation. */
export type UpdateAreaNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaNameShort` being updated. */
  patch: AreaNameShortPatch;
};

/** The output of our update `AreaNameShort` mutation. */
export type UpdateAreaNameShortPayload = {
  __typename?: 'UpdateAreaNameShortPayload';
  /** Reads a single `Area` that is related to this `AreaNameShort`. */
  area?: Maybe<Area>;
  /** The `AreaNameShort` that was updated by this mutation. */
  areaNameShort?: Maybe<AreaNameShort>;
  /** An edge for our `AreaNameShort`. May be used by Relay 1. */
  areaNameShortEdge?: Maybe<AreaNameShortsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaNameShort` mutation. */
export type UpdateAreaNameShortPayloadAreaNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaNameShortsOrderBy>>;
};

/** The output of our update `Area` mutation. */
export type UpdateAreaPayload = {
  __typename?: 'UpdateAreaPayload';
  /** The `Area` that was updated by this mutation. */
  area?: Maybe<Area>;
  /** An edge for our `Area`. May be used by Relay 1. */
  areaEdge?: Maybe<AreasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AreaType` that is related to this `Area`. */
  type?: Maybe<AreaType>;
  /** Reads a single `Zone` that is related to this `Area`. */
  zone?: Maybe<Zone>;
};


/** The output of our update `Area` mutation. */
export type UpdateAreaPayloadAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<AreasOrderBy>>;
};

/** All input for the `updateAreaPublicGrossSpace` mutation. */
export type UpdateAreaPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaPublicGrossSpace` being updated. */
  patch: AreaPublicGrossSpacePatch;
};

/** The output of our update `AreaPublicGrossSpace` mutation. */
export type UpdateAreaPublicGrossSpacePayload = {
  __typename?: 'UpdateAreaPublicGrossSpacePayload';
  /** Reads a single `Area` that is related to this `AreaPublicGrossSpace`. */
  area?: Maybe<Area>;
  /** The `AreaPublicGrossSpace` that was updated by this mutation. */
  areaPublicGrossSpace?: Maybe<AreaPublicGrossSpace>;
  /** An edge for our `AreaPublicGrossSpace`. May be used by Relay 1. */
  areaPublicGrossSpaceEdge?: Maybe<AreaPublicGrossSpacesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaPublicGrossSpace` mutation. */
export type UpdateAreaPublicGrossSpacePayloadAreaPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaPublicGrossSpacesOrderBy>>;
};

/** All input for the `updateAreaTypeAttr` mutation. */
export type UpdateAreaTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaTypeAttr` being updated. */
  patch: AreaTypeAttrPatch;
};

/** The output of our update `AreaTypeAttr` mutation. */
export type UpdateAreaTypeAttrPayload = {
  __typename?: 'UpdateAreaTypeAttrPayload';
  /** Reads a single `Area` that is related to this `AreaTypeAttr`. */
  area?: Maybe<Area>;
  /** Reads a single `AreaType` that is related to this `AreaTypeAttr`. */
  areaType?: Maybe<AreaType>;
  /** The `AreaTypeAttr` that was updated by this mutation. */
  areaTypeAttr?: Maybe<AreaTypeAttr>;
  /** An edge for our `AreaTypeAttr`. May be used by Relay 1. */
  areaTypeAttrEdge?: Maybe<AreaTypeAttrsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaTypeAttr` mutation. */
export type UpdateAreaTypeAttrPayloadAreaTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaTypeAttrsOrderBy>>;
};

/** All input for the `updateAreaTypeByName` mutation. */
export type UpdateAreaTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `AreaType` being updated. */
  patch: AreaTypePatch;
};

/** All input for the `updateAreaType` mutation. */
export type UpdateAreaTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AreaType` being updated. */
  patch: AreaTypePatch;
};

/** The output of our update `AreaType` mutation. */
export type UpdateAreaTypePayload = {
  __typename?: 'UpdateAreaTypePayload';
  /** The `AreaType` that was updated by this mutation. */
  areaType?: Maybe<AreaType>;
  /** An edge for our `AreaType`. May be used by Relay 1. */
  areaTypeEdge?: Maybe<AreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AreaType` mutation. */
export type UpdateAreaTypePayloadAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AreaTypesOrderBy>>;
};

/** All input for the `updateBuildingByExtId` mutation. */
export type UpdateBuildingByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Building` being updated. */
  patch: BuildingPatch;
};

/** All input for the `updateBuildingByIdAndSiteId` mutation. */
export type UpdateBuildingByIdAndSiteIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Building` being updated. */
  patch: BuildingPatch;
  siteId: Scalars['UUID'];
};

/** All input for the `updateBuildingByNameShort` mutation. */
export type UpdateBuildingByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Building` being updated. */
  patch: BuildingPatch;
};

/** All input for the `updateBuildingDescription` mutation. */
export type UpdateBuildingDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingDescription` being updated. */
  patch: BuildingDescriptionPatch;
};

/** The output of our update `BuildingDescription` mutation. */
export type UpdateBuildingDescriptionPayload = {
  __typename?: 'UpdateBuildingDescriptionPayload';
  /** Reads a single `Building` that is related to this `BuildingDescription`. */
  building?: Maybe<Building>;
  /** The `BuildingDescription` that was updated by this mutation. */
  buildingDescription?: Maybe<BuildingDescription>;
  /** An edge for our `BuildingDescription`. May be used by Relay 1. */
  buildingDescriptionEdge?: Maybe<BuildingDescriptionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingDescription` mutation. */
export type UpdateBuildingDescriptionPayloadBuildingDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingDescriptionsOrderBy>>;
};

/** All input for the `updateBuilding` mutation. */
export type UpdateBuildingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Building` being updated. */
  patch: BuildingPatch;
};

/** All input for the `updateBuildingNameExtra` mutation. */
export type UpdateBuildingNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameExtra` being updated. */
  patch: BuildingNameExtraPatch;
};

/** The output of our update `BuildingNameExtra` mutation. */
export type UpdateBuildingNameExtraPayload = {
  __typename?: 'UpdateBuildingNameExtraPayload';
  /** Reads a single `Building` that is related to this `BuildingNameExtra`. */
  building?: Maybe<Building>;
  /** The `BuildingNameExtra` that was updated by this mutation. */
  buildingNameExtra?: Maybe<BuildingNameExtra>;
  /** An edge for our `BuildingNameExtra`. May be used by Relay 1. */
  buildingNameExtraEdge?: Maybe<BuildingNameExtrasEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameExtra` mutation. */
export type UpdateBuildingNameExtraPayloadBuildingNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameExtrasOrderBy>>;
};

/** All input for the `updateBuildingNameKeyCad` mutation. */
export type UpdateBuildingNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameKeyCad` being updated. */
  patch: BuildingNameKeyCadPatch;
};

/** The output of our update `BuildingNameKeyCad` mutation. */
export type UpdateBuildingNameKeyCadPayload = {
  __typename?: 'UpdateBuildingNameKeyCadPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCad`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyCad` that was updated by this mutation. */
  buildingNameKeyCad?: Maybe<BuildingNameKeyCad>;
  /** An edge for our `BuildingNameKeyCad`. May be used by Relay 1. */
  buildingNameKeyCadEdge?: Maybe<BuildingNameKeyCadsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameKeyCad` mutation. */
export type UpdateBuildingNameKeyCadPayloadBuildingNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyCadsOrderBy>>;
};

/** All input for the `updateBuildingNameKeyCafm` mutation. */
export type UpdateBuildingNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameKeyCafm` being updated. */
  patch: BuildingNameKeyCafmPatch;
};

/** The output of our update `BuildingNameKeyCafm` mutation. */
export type UpdateBuildingNameKeyCafmPayload = {
  __typename?: 'UpdateBuildingNameKeyCafmPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyCafm`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyCafm` that was updated by this mutation. */
  buildingNameKeyCafm?: Maybe<BuildingNameKeyCafm>;
  /** An edge for our `BuildingNameKeyCafm`. May be used by Relay 1. */
  buildingNameKeyCafmEdge?: Maybe<BuildingNameKeyCafmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameKeyCafm` mutation. */
export type UpdateBuildingNameKeyCafmPayloadBuildingNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyCafmsOrderBy>>;
};

/** All input for the `updateBuildingNameKeyEbm` mutation. */
export type UpdateBuildingNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameKeyEbm` being updated. */
  patch: BuildingNameKeyEbmPatch;
};

/** The output of our update `BuildingNameKeyEbm` mutation. */
export type UpdateBuildingNameKeyEbmPayload = {
  __typename?: 'UpdateBuildingNameKeyEbmPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyEbm`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyEbm` that was updated by this mutation. */
  buildingNameKeyEbm?: Maybe<BuildingNameKeyEbm>;
  /** An edge for our `BuildingNameKeyEbm`. May be used by Relay 1. */
  buildingNameKeyEbmEdge?: Maybe<BuildingNameKeyEbmsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameKeyEbm` mutation. */
export type UpdateBuildingNameKeyEbmPayloadBuildingNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyEbmsOrderBy>>;
};

/** All input for the `updateBuildingNameKeyMarketing` mutation. */
export type UpdateBuildingNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameKeyMarketing` being updated. */
  patch: BuildingNameKeyMarketingPatch;
};

/** The output of our update `BuildingNameKeyMarketing` mutation. */
export type UpdateBuildingNameKeyMarketingPayload = {
  __typename?: 'UpdateBuildingNameKeyMarketingPayload';
  /** Reads a single `Building` that is related to this `BuildingNameKeyMarketing`. */
  building?: Maybe<Building>;
  /** The `BuildingNameKeyMarketing` that was updated by this mutation. */
  buildingNameKeyMarketing?: Maybe<BuildingNameKeyMarketing>;
  /** An edge for our `BuildingNameKeyMarketing`. May be used by Relay 1. */
  buildingNameKeyMarketingEdge?: Maybe<BuildingNameKeyMarketingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameKeyMarketing` mutation. */
export type UpdateBuildingNameKeyMarketingPayloadBuildingNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateBuildingNameLong` mutation. */
export type UpdateBuildingNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameLong` being updated. */
  patch: BuildingNameLongPatch;
};

/** The output of our update `BuildingNameLong` mutation. */
export type UpdateBuildingNameLongPayload = {
  __typename?: 'UpdateBuildingNameLongPayload';
  /** Reads a single `Building` that is related to this `BuildingNameLong`. */
  building?: Maybe<Building>;
  /** The `BuildingNameLong` that was updated by this mutation. */
  buildingNameLong?: Maybe<BuildingNameLong>;
  /** An edge for our `BuildingNameLong`. May be used by Relay 1. */
  buildingNameLongEdge?: Maybe<BuildingNameLongsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameLong` mutation. */
export type UpdateBuildingNameLongPayloadBuildingNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameLongsOrderBy>>;
};

/** All input for the `updateBuildingNameShort` mutation. */
export type UpdateBuildingNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingNameShort` being updated. */
  patch: BuildingNameShortPatch;
};

/** The output of our update `BuildingNameShort` mutation. */
export type UpdateBuildingNameShortPayload = {
  __typename?: 'UpdateBuildingNameShortPayload';
  /** Reads a single `Building` that is related to this `BuildingNameShort`. */
  building?: Maybe<Building>;
  /** The `BuildingNameShort` that was updated by this mutation. */
  buildingNameShort?: Maybe<BuildingNameShort>;
  /** An edge for our `BuildingNameShort`. May be used by Relay 1. */
  buildingNameShortEdge?: Maybe<BuildingNameShortsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingNameShort` mutation. */
export type UpdateBuildingNameShortPayloadBuildingNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingNameShortsOrderBy>>;
};

/** The output of our update `Building` mutation. */
export type UpdateBuildingPayload = {
  __typename?: 'UpdateBuildingPayload';
  /** The `Building` that was updated by this mutation. */
  building?: Maybe<Building>;
  /** An edge for our `Building`. May be used by Relay 1. */
  buildingEdge?: Maybe<BuildingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `Building`. */
  site?: Maybe<Site>;
  /** Reads a single `BuildingType` that is related to this `Building`. */
  type?: Maybe<BuildingType>;
};


/** The output of our update `Building` mutation. */
export type UpdateBuildingPayloadBuildingEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingsOrderBy>>;
};

/** All input for the `updateBuildingPublicGrossSpace` mutation. */
export type UpdateBuildingPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingPublicGrossSpace` being updated. */
  patch: BuildingPublicGrossSpacePatch;
};

/** The output of our update `BuildingPublicGrossSpace` mutation. */
export type UpdateBuildingPublicGrossSpacePayload = {
  __typename?: 'UpdateBuildingPublicGrossSpacePayload';
  /** Reads a single `Building` that is related to this `BuildingPublicGrossSpace`. */
  building?: Maybe<Building>;
  /** The `BuildingPublicGrossSpace` that was updated by this mutation. */
  buildingPublicGrossSpace?: Maybe<BuildingPublicGrossSpace>;
  /** An edge for our `BuildingPublicGrossSpace`. May be used by Relay 1. */
  buildingPublicGrossSpaceEdge?: Maybe<BuildingPublicGrossSpacesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingPublicGrossSpace` mutation. */
export type UpdateBuildingPublicGrossSpacePayloadBuildingPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingPublicGrossSpacesOrderBy>>;
};

/** All input for the `updateBuildingTypeAttr` mutation. */
export type UpdateBuildingTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingTypeAttr` being updated. */
  patch: BuildingTypeAttrPatch;
};

/** The output of our update `BuildingTypeAttr` mutation. */
export type UpdateBuildingTypeAttrPayload = {
  __typename?: 'UpdateBuildingTypeAttrPayload';
  /** Reads a single `Building` that is related to this `BuildingTypeAttr`. */
  building?: Maybe<Building>;
  /** Reads a single `BuildingType` that is related to this `BuildingTypeAttr`. */
  buildingType?: Maybe<BuildingType>;
  /** The `BuildingTypeAttr` that was updated by this mutation. */
  buildingTypeAttr?: Maybe<BuildingTypeAttr>;
  /** An edge for our `BuildingTypeAttr`. May be used by Relay 1. */
  buildingTypeAttrEdge?: Maybe<BuildingTypeAttrsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingTypeAttr` mutation. */
export type UpdateBuildingTypeAttrPayloadBuildingTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingTypeAttrsOrderBy>>;
};

/** All input for the `updateBuildingTypeByName` mutation. */
export type UpdateBuildingTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `BuildingType` being updated. */
  patch: BuildingTypePatch;
};

/** All input for the `updateBuildingType` mutation. */
export type UpdateBuildingTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `BuildingType` being updated. */
  patch: BuildingTypePatch;
};

/** The output of our update `BuildingType` mutation. */
export type UpdateBuildingTypePayload = {
  __typename?: 'UpdateBuildingTypePayload';
  /** The `BuildingType` that was updated by this mutation. */
  buildingType?: Maybe<BuildingType>;
  /** An edge for our `BuildingType`. May be used by Relay 1. */
  buildingTypeEdge?: Maybe<BuildingTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BuildingType` mutation. */
export type UpdateBuildingTypePayloadBuildingTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingTypesOrderBy>>;
};

/** All input for the `updateElevationLevelByValue` mutation. */
export type UpdateElevationLevelByValueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ElevationLevel` being updated. */
  patch: ElevationLevelPatch;
  value: Scalars['BigFloat'];
};

/** All input for the `updateElevationLevel` mutation. */
export type UpdateElevationLevelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ElevationLevel` being updated. */
  patch: ElevationLevelPatch;
};

/** The output of our update `ElevationLevel` mutation. */
export type UpdateElevationLevelPayload = {
  __typename?: 'UpdateElevationLevelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ElevationLevel` that was updated by this mutation. */
  elevationLevel?: Maybe<ElevationLevel>;
  /** An edge for our `ElevationLevel`. May be used by Relay 1. */
  elevationLevelEdge?: Maybe<ElevationLevelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ElevationLevel` mutation. */
export type UpdateElevationLevelPayloadElevationLevelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElevationLevelsOrderBy>>;
};

/** All input for the `updateEventByNameShort` mutation. */
export type UpdateEventByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Event` being updated. */
  patch: EventPatch;
};

/** All input for the `updateEvent` mutation. */
export type UpdateEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Event` being updated. */
  patch: EventPatch;
};

/** The output of our update `Event` mutation. */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  competitionNational?: Maybe<Multilink>;
  /** The `Event` that was updated by this mutation. */
  event?: Maybe<Event>;
  /** An edge for our `Event`. May be used by Relay 1. */
  eventEdge?: Maybe<EventsEdge>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  externalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  extraSystems?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  /** Reads a single `File` that is related to this `Event`. */
  icon?: Maybe<File>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  internalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherCompetitionNational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  otherLinksInternal?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `EventSeries` that is related to this `Event`. */
  series?: Maybe<EventSeries>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsLocal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Event`. */
  subeventsOtherLocations?: Maybe<Multilink>;
};


/** The output of our update `Event` mutation. */
export type UpdateEventPayloadEventEdgeArgs = {
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** All input for the `updateEventSeriesByNameShort` mutation. */
export type UpdateEventSeriesByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `EventSeries` being updated. */
  patch: EventSeriesPatch;
};

/** All input for the `updateEventSeries` mutation. */
export type UpdateEventSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EventSeries` being updated. */
  patch: EventSeriesPatch;
};

/** The output of our update `EventSeries` mutation. */
export type UpdateEventSeriesPayload = {
  __typename?: 'UpdateEventSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  competitionNational?: Maybe<Multilink>;
  /** The `EventSeries` that was updated by this mutation. */
  eventSeries?: Maybe<EventSeries>;
  /** An edge for our `EventSeries`. May be used by Relay 1. */
  eventSeriesEdge?: Maybe<EventSeriesEdge>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  executors?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  externalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  extraSystems?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroad?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  fairAbroadCooperation?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  favoredParallelsInternal?: Maybe<Multilink>;
  /** Reads a single `File` that is related to this `EventSeries`. */
  icon?: Maybe<File>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  internalData?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  organizers?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionInternational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherCompetitionNational?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksExternal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  otherLinksInternal?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  sponsors?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsLocal?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  subeventsOtherLocations?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `EventSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our update `EventSeries` mutation. */
export type UpdateEventSeriesPayloadEventSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<EventSeriesOrderBy>>;
};

/** All input for the `updateEventVariantByEventIdAndIndex` mutation. */
export type UpdateEventVariantByEventIdAndIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `EventVariant` being updated. */
  patch: EventVariantPatch;
};

/** All input for the `updateEventVariant` mutation. */
export type UpdateEventVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EventVariant` being updated. */
  patch: EventVariantPatch;
};

/** The output of our update `EventVariant` mutation. */
export type UpdateEventVariantPayload = {
  __typename?: 'UpdateEventVariantPayload';
  /** Reads a single `Feed` that is related to this `EventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Event` that is related to this `EventVariant`. */
  event?: Maybe<Event>;
  /** The `EventVariant` that was updated by this mutation. */
  eventVariant?: Maybe<EventVariant>;
  /** An edge for our `EventVariant`. May be used by Relay 1. */
  eventVariantEdge?: Maybe<EventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AllocationArea` that is related to this `EventVariant`. */
  referenceAllocationArea?: Maybe<AllocationArea>;
  /** Reads a single `AllocationRoom` that is related to this `EventVariant`. */
  referenceAllocationRoom?: Maybe<AllocationRoom>;
};


/** The output of our update `EventVariant` mutation. */
export type UpdateEventVariantPayloadEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<EventVariantsOrderBy>>;
};

/** All input for the `updateExternalEventAllocation` mutation. */
export type UpdateExternalEventAllocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventAllocation` being updated. */
  patch: ExternalEventAllocationPatch;
};

/** The output of our update `ExternalEventAllocation` mutation. */
export type UpdateExternalEventAllocationPayload = {
  __typename?: 'UpdateExternalEventAllocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventAllocation` that was updated by this mutation. */
  externalEventAllocation?: Maybe<ExternalEventAllocation>;
  /** An edge for our `ExternalEventAllocation`. May be used by Relay 1. */
  externalEventAllocationEdge?: Maybe<ExternalEventAllocationsEdge>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventAllocation`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventVariant` that is related to this `ExternalEventAllocation`. */
  variant?: Maybe<ExternalEventVariant>;
};


/** The output of our update `ExternalEventAllocation` mutation. */
export type UpdateExternalEventAllocationPayloadExternalEventAllocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationsOrderBy>>;
};

/** All input for the `updateExternalEventAllocationPhase` mutation. */
export type UpdateExternalEventAllocationPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventAllocationPhase` being updated. */
  patch: ExternalEventAllocationPhasePatch;
};

/** The output of our update `ExternalEventAllocationPhase` mutation. */
export type UpdateExternalEventAllocationPhasePayload = {
  __typename?: 'UpdateExternalEventAllocationPhasePayload';
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventAllocationPhase`. */
  allocation?: Maybe<ExternalEventAllocation>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventAllocationPhase` that was updated by this mutation. */
  externalEventAllocationPhase?: Maybe<ExternalEventAllocationPhase>;
  /** An edge for our `ExternalEventAllocationPhase`. May be used by Relay 1. */
  externalEventAllocationPhaseEdge?: Maybe<ExternalEventAllocationPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocationUsage` that is related to this `ExternalEventAllocationPhase`. */
  usage?: Maybe<ExternalEventAllocationUsage>;
};


/** The output of our update `ExternalEventAllocationPhase` mutation. */
export type UpdateExternalEventAllocationPhasePayloadExternalEventAllocationPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationPhasesOrderBy>>;
};

/** All input for the `updateExternalEventAllocationUsageByName` mutation. */
export type UpdateExternalEventAllocationUsageByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ExternalEventAllocationUsage` being updated. */
  patch: ExternalEventAllocationUsagePatch;
};

/** All input for the `updateExternalEventAllocationUsageByNameShort` mutation. */
export type UpdateExternalEventAllocationUsageByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `ExternalEventAllocationUsage` being updated. */
  patch: ExternalEventAllocationUsagePatch;
};

/** All input for the `updateExternalEventAllocationUsageByPosition` mutation. */
export type UpdateExternalEventAllocationUsageByPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ExternalEventAllocationUsage` being updated. */
  patch: ExternalEventAllocationUsagePatch;
  position: Scalars['Int'];
};

/** All input for the `updateExternalEventAllocationUsageByType` mutation. */
export type UpdateExternalEventAllocationUsageByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ExternalEventAllocationUsage` being updated. */
  patch: ExternalEventAllocationUsagePatch;
  type: ExternalEventAllocationUsageType;
};

/** All input for the `updateExternalEventAllocationUsage` mutation. */
export type UpdateExternalEventAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventAllocationUsage` being updated. */
  patch: ExternalEventAllocationUsagePatch;
};

/** The output of our update `ExternalEventAllocationUsage` mutation. */
export type UpdateExternalEventAllocationUsagePayload = {
  __typename?: 'UpdateExternalEventAllocationUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventAllocationUsage` that was updated by this mutation. */
  externalEventAllocationUsage?: Maybe<ExternalEventAllocationUsage>;
  /** An edge for our `ExternalEventAllocationUsage`. May be used by Relay 1. */
  externalEventAllocationUsageEdge?: Maybe<ExternalEventAllocationUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ExternalEventAllocationUsage` mutation. */
export type UpdateExternalEventAllocationUsagePayloadExternalEventAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventAllocationUsagesOrderBy>>;
};

/** All input for the `updateExternalEventByNameShort` mutation. */
export type UpdateExternalEventByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `ExternalEvent` being updated. */
  patch: ExternalEventPatch;
};

/** All input for the `updateExternalEventEventLocationVisibilityByEventIdAndLocationId` mutation. */
export type UpdateExternalEventEventLocationVisibilityByEventIdAndLocationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventEventLocationVisibility` being updated. */
  patch: ExternalEventEventLocationVisibilityPatch;
};

/** All input for the `updateExternalEventEventLocationVisibility` mutation. */
export type UpdateExternalEventEventLocationVisibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventEventLocationVisibility` being updated. */
  patch: ExternalEventEventLocationVisibilityPatch;
};

/** The output of our update `ExternalEventEventLocationVisibility` mutation. */
export type UpdateExternalEventEventLocationVisibilityPayload = {
  __typename?: 'UpdateExternalEventEventLocationVisibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventEventLocationVisibility`. */
  event?: Maybe<ExternalEvent>;
  /** The `ExternalEventEventLocationVisibility` that was updated by this mutation. */
  externalEventEventLocationVisibility?: Maybe<ExternalEventEventLocationVisibility>;
  /** An edge for our `ExternalEventEventLocationVisibility`. May be used by Relay 1. */
  externalEventEventLocationVisibilityEdge?: Maybe<ExternalEventEventLocationVisibilitiesEdge>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEventEventLocationVisibility`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ExternalEventEventLocationVisibility` mutation. */
export type UpdateExternalEventEventLocationVisibilityPayloadExternalEventEventLocationVisibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventEventLocationVisibilitiesOrderBy>>;
};

/** All input for the `updateExternalEvent` mutation. */
export type UpdateExternalEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEvent` being updated. */
  patch: ExternalEventPatch;
};

/** All input for the `updateExternalEventLocationByName` mutation. */
export type UpdateExternalEventLocationByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ExternalEventLocation` being updated. */
  patch: ExternalEventLocationPatch;
};

/** All input for the `updateExternalEventLocation` mutation. */
export type UpdateExternalEventLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventLocation` being updated. */
  patch: ExternalEventLocationPatch;
};

/** The output of our update `ExternalEventLocation` mutation. */
export type UpdateExternalEventLocationPayload = {
  __typename?: 'UpdateExternalEventLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventLocation` that was updated by this mutation. */
  externalEventLocation?: Maybe<ExternalEventLocation>;
  /** An edge for our `ExternalEventLocation`. May be used by Relay 1. */
  externalEventLocationEdge?: Maybe<ExternalEventLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ExternalEventLocation` mutation. */
export type UpdateExternalEventLocationPayloadExternalEventLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventLocationsOrderBy>>;
};

/** The output of our update `ExternalEvent` mutation. */
export type UpdateExternalEventPayload = {
  __typename?: 'UpdateExternalEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEvent` that was updated by this mutation. */
  externalEvent?: Maybe<ExternalEvent>;
  /** An edge for our `ExternalEvent`. May be used by Relay 1. */
  externalEventEdge?: Maybe<ExternalEventsEdge>;
  /** Reads a single `Multilink` that is related to this `ExternalEvent`. */
  links?: Maybe<Multilink>;
  /** Reads a single `ExternalEventLocation` that is related to this `ExternalEvent`. */
  location?: Maybe<ExternalEventLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventSeries` that is related to this `ExternalEvent`. */
  series?: Maybe<ExternalEventSeries>;
};


/** The output of our update `ExternalEvent` mutation. */
export type UpdateExternalEventPayloadExternalEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventsOrderBy>>;
};

/** All input for the `updateExternalEventSeriesByNameShort` mutation. */
export type UpdateExternalEventSeriesByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `ExternalEventSeries` being updated. */
  patch: ExternalEventSeriesPatch;
};

/** All input for the `updateExternalEventSeries` mutation. */
export type UpdateExternalEventSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventSeries` being updated. */
  patch: ExternalEventSeriesPatch;
};

/** The output of our update `ExternalEventSeries` mutation. */
export type UpdateExternalEventSeriesPayload = {
  __typename?: 'UpdateExternalEventSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalEventSeries` that was updated by this mutation. */
  externalEventSeries?: Maybe<ExternalEventSeries>;
  /** An edge for our `ExternalEventSeries`. May be used by Relay 1. */
  externalEventSeriesEdge?: Maybe<ExternalEventSeriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `ExternalEventSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our update `ExternalEventSeries` mutation. */
export type UpdateExternalEventSeriesPayloadExternalEventSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventSeriesOrderBy>>;
};

/** All input for the `updateExternalEventVariantByEventIdAndIndex` mutation. */
export type UpdateExternalEventVariantByEventIdAndIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `ExternalEventVariant` being updated. */
  patch: ExternalEventVariantPatch;
};

/** All input for the `updateExternalEventVariant` mutation. */
export type UpdateExternalEventVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalEventVariant` being updated. */
  patch: ExternalEventVariantPatch;
};

/** The output of our update `ExternalEventVariant` mutation. */
export type UpdateExternalEventVariantPayload = {
  __typename?: 'UpdateExternalEventVariantPayload';
  /** Reads a single `Feed` that is related to this `ExternalEventVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalEvent` that is related to this `ExternalEventVariant`. */
  event?: Maybe<ExternalEvent>;
  /** The `ExternalEventVariant` that was updated by this mutation. */
  externalEventVariant?: Maybe<ExternalEventVariant>;
  /** An edge for our `ExternalEventVariant`. May be used by Relay 1. */
  externalEventVariantEdge?: Maybe<ExternalEventVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalEventAllocation` that is related to this `ExternalEventVariant`. */
  referenceExternalEventAllocation?: Maybe<ExternalEventAllocation>;
};


/** The output of our update `ExternalEventVariant` mutation. */
export type UpdateExternalEventVariantPayloadExternalEventVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalEventVariantsOrderBy>>;
};

/** All input for the `updateFeedEntry` mutation. */
export type UpdateFeedEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FeedEntry` being updated. */
  patch: FeedEntryPatch;
};

/** The output of our update `FeedEntry` mutation. */
export type UpdateFeedEntryPayload = {
  __typename?: 'UpdateFeedEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `FeedEntry`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Feed` that is related to this `FeedEntry`. */
  feed?: Maybe<Feed>;
  /** The `FeedEntry` that was updated by this mutation. */
  feedEntry?: Maybe<FeedEntry>;
  /** An edge for our `FeedEntry`. May be used by Relay 1. */
  feedEntryEdge?: Maybe<FeedEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FeedEntry`. */
  updatedBy?: Maybe<User>;
};


/** The output of our update `FeedEntry` mutation. */
export type UpdateFeedEntryPayloadFeedEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};

/** All input for the `updateFeed` mutation. */
export type UpdateFeedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Feed` being updated. */
  patch: FeedPatch;
};

/** The output of our update `Feed` mutation. */
export type UpdateFeedPayload = {
  __typename?: 'UpdateFeedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Feed` that was updated by this mutation. */
  feed?: Maybe<Feed>;
  /** An edge for our `Feed`. May be used by Relay 1. */
  feedEdge?: Maybe<FeedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Feed` mutation. */
export type UpdateFeedPayloadFeedEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedsOrderBy>>;
};

/** All input for the `updateLevelByExtId` mutation. */
export type UpdateLevelByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Level` being updated. */
  patch: LevelPatch;
};

/** All input for the `updateLevelByNameShort` mutation. */
export type UpdateLevelByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Level` being updated. */
  patch: LevelPatch;
};

/** All input for the `updateLevelCapacityPax` mutation. */
export type UpdateLevelCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelCapacityPax` being updated. */
  patch: LevelCapacityPaxPatch;
};

/** The output of our update `LevelCapacityPax` mutation. */
export type UpdateLevelCapacityPaxPayload = {
  __typename?: 'UpdateLevelCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelCapacityPax`. */
  level?: Maybe<Level>;
  /** The `LevelCapacityPax` that was updated by this mutation. */
  levelCapacityPax?: Maybe<LevelCapacityPax>;
  /** An edge for our `LevelCapacityPax`. May be used by Relay 1. */
  levelCapacityPaxEdge?: Maybe<LevelCapacityPaxesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelCapacityPax` mutation. */
export type UpdateLevelCapacityPaxPayloadLevelCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelCapacityPaxesOrderBy>>;
};

/** All input for the `updateLevelDescription` mutation. */
export type UpdateLevelDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelDescription` being updated. */
  patch: LevelDescriptionPatch;
};

/** The output of our update `LevelDescription` mutation. */
export type UpdateLevelDescriptionPayload = {
  __typename?: 'UpdateLevelDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelDescription`. */
  level?: Maybe<Level>;
  /** The `LevelDescription` that was updated by this mutation. */
  levelDescription?: Maybe<LevelDescription>;
  /** An edge for our `LevelDescription`. May be used by Relay 1. */
  levelDescriptionEdge?: Maybe<LevelDescriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelDescription` mutation. */
export type UpdateLevelDescriptionPayloadLevelDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelDescriptionsOrderBy>>;
};

/** All input for the `updateLevelFkmGrossSpace` mutation. */
export type UpdateLevelFkmGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelFkmGrossSpace` being updated. */
  patch: LevelFkmGrossSpacePatch;
};

/** The output of our update `LevelFkmGrossSpace` mutation. */
export type UpdateLevelFkmGrossSpacePayload = {
  __typename?: 'UpdateLevelFkmGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelFkmGrossSpace`. */
  level?: Maybe<Level>;
  /** The `LevelFkmGrossSpace` that was updated by this mutation. */
  levelFkmGrossSpace?: Maybe<LevelFkmGrossSpace>;
  /** An edge for our `LevelFkmGrossSpace`. May be used by Relay 1. */
  levelFkmGrossSpaceEdge?: Maybe<LevelFkmGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelFkmGrossSpace` mutation. */
export type UpdateLevelFkmGrossSpacePayloadLevelFkmGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelFkmGrossSpacesOrderBy>>;
};

/** All input for the `updateLevel` mutation. */
export type UpdateLevelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Level` being updated. */
  patch: LevelPatch;
};

/** All input for the `updateLevelNameExtra` mutation. */
export type UpdateLevelNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameExtra` being updated. */
  patch: LevelNameExtraPatch;
};

/** The output of our update `LevelNameExtra` mutation. */
export type UpdateLevelNameExtraPayload = {
  __typename?: 'UpdateLevelNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameExtra`. */
  level?: Maybe<Level>;
  /** The `LevelNameExtra` that was updated by this mutation. */
  levelNameExtra?: Maybe<LevelNameExtra>;
  /** An edge for our `LevelNameExtra`. May be used by Relay 1. */
  levelNameExtraEdge?: Maybe<LevelNameExtrasEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameExtra` mutation. */
export type UpdateLevelNameExtraPayloadLevelNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameExtrasOrderBy>>;
};

/** All input for the `updateLevelNameKeyCad` mutation. */
export type UpdateLevelNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameKeyCad` being updated. */
  patch: LevelNameKeyCadPatch;
};

/** The output of our update `LevelNameKeyCad` mutation. */
export type UpdateLevelNameKeyCadPayload = {
  __typename?: 'UpdateLevelNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyCad`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyCad` that was updated by this mutation. */
  levelNameKeyCad?: Maybe<LevelNameKeyCad>;
  /** An edge for our `LevelNameKeyCad`. May be used by Relay 1. */
  levelNameKeyCadEdge?: Maybe<LevelNameKeyCadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameKeyCad` mutation. */
export type UpdateLevelNameKeyCadPayloadLevelNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyCadsOrderBy>>;
};

/** All input for the `updateLevelNameKeyCafm` mutation. */
export type UpdateLevelNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameKeyCafm` being updated. */
  patch: LevelNameKeyCafmPatch;
};

/** The output of our update `LevelNameKeyCafm` mutation. */
export type UpdateLevelNameKeyCafmPayload = {
  __typename?: 'UpdateLevelNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyCafm`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyCafm` that was updated by this mutation. */
  levelNameKeyCafm?: Maybe<LevelNameKeyCafm>;
  /** An edge for our `LevelNameKeyCafm`. May be used by Relay 1. */
  levelNameKeyCafmEdge?: Maybe<LevelNameKeyCafmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameKeyCafm` mutation. */
export type UpdateLevelNameKeyCafmPayloadLevelNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyCafmsOrderBy>>;
};

/** All input for the `updateLevelNameKeyEbm` mutation. */
export type UpdateLevelNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameKeyEbm` being updated. */
  patch: LevelNameKeyEbmPatch;
};

/** The output of our update `LevelNameKeyEbm` mutation. */
export type UpdateLevelNameKeyEbmPayload = {
  __typename?: 'UpdateLevelNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyEbm`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyEbm` that was updated by this mutation. */
  levelNameKeyEbm?: Maybe<LevelNameKeyEbm>;
  /** An edge for our `LevelNameKeyEbm`. May be used by Relay 1. */
  levelNameKeyEbmEdge?: Maybe<LevelNameKeyEbmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameKeyEbm` mutation. */
export type UpdateLevelNameKeyEbmPayloadLevelNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyEbmsOrderBy>>;
};

/** All input for the `updateLevelNameKeyMarketing` mutation. */
export type UpdateLevelNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameKeyMarketing` being updated. */
  patch: LevelNameKeyMarketingPatch;
};

/** The output of our update `LevelNameKeyMarketing` mutation. */
export type UpdateLevelNameKeyMarketingPayload = {
  __typename?: 'UpdateLevelNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameKeyMarketing`. */
  level?: Maybe<Level>;
  /** The `LevelNameKeyMarketing` that was updated by this mutation. */
  levelNameKeyMarketing?: Maybe<LevelNameKeyMarketing>;
  /** An edge for our `LevelNameKeyMarketing`. May be used by Relay 1. */
  levelNameKeyMarketingEdge?: Maybe<LevelNameKeyMarketingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameKeyMarketing` mutation. */
export type UpdateLevelNameKeyMarketingPayloadLevelNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateLevelNameLong` mutation. */
export type UpdateLevelNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameLong` being updated. */
  patch: LevelNameLongPatch;
};

/** The output of our update `LevelNameLong` mutation. */
export type UpdateLevelNameLongPayload = {
  __typename?: 'UpdateLevelNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameLong`. */
  level?: Maybe<Level>;
  /** The `LevelNameLong` that was updated by this mutation. */
  levelNameLong?: Maybe<LevelNameLong>;
  /** An edge for our `LevelNameLong`. May be used by Relay 1. */
  levelNameLongEdge?: Maybe<LevelNameLongsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameLong` mutation. */
export type UpdateLevelNameLongPayloadLevelNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameLongsOrderBy>>;
};

/** All input for the `updateLevelNameShort` mutation. */
export type UpdateLevelNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelNameShort` being updated. */
  patch: LevelNameShortPatch;
};

/** The output of our update `LevelNameShort` mutation. */
export type UpdateLevelNameShortPayload = {
  __typename?: 'UpdateLevelNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelNameShort`. */
  level?: Maybe<Level>;
  /** The `LevelNameShort` that was updated by this mutation. */
  levelNameShort?: Maybe<LevelNameShort>;
  /** An edge for our `LevelNameShort`. May be used by Relay 1. */
  levelNameShortEdge?: Maybe<LevelNameShortsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelNameShort` mutation. */
export type UpdateLevelNameShortPayloadLevelNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelNameShortsOrderBy>>;
};

/** The output of our update `Level` mutation. */
export type UpdateLevelPayload = {
  __typename?: 'UpdateLevelPayload';
  /** Reads a single `Building` that is related to this `Level`. */
  building?: Maybe<Building>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ElevationLevel` that is related to this `Level`. */
  elevation?: Maybe<ElevationLevel>;
  /** The `Level` that was updated by this mutation. */
  level?: Maybe<Level>;
  /** An edge for our `Level`. May be used by Relay 1. */
  levelEdge?: Maybe<LevelsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `LevelType` that is related to this `Level`. */
  type?: Maybe<LevelType>;
};


/** The output of our update `Level` mutation. */
export type UpdateLevelPayloadLevelEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelsOrderBy>>;
};

/** All input for the `updateLevelPublicGrossSpace` mutation. */
export type UpdateLevelPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelPublicGrossSpace` being updated. */
  patch: LevelPublicGrossSpacePatch;
};

/** The output of our update `LevelPublicGrossSpace` mutation. */
export type UpdateLevelPublicGrossSpacePayload = {
  __typename?: 'UpdateLevelPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelPublicGrossSpace`. */
  level?: Maybe<Level>;
  /** The `LevelPublicGrossSpace` that was updated by this mutation. */
  levelPublicGrossSpace?: Maybe<LevelPublicGrossSpace>;
  /** An edge for our `LevelPublicGrossSpace`. May be used by Relay 1. */
  levelPublicGrossSpaceEdge?: Maybe<LevelPublicGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelPublicGrossSpace` mutation. */
export type UpdateLevelPublicGrossSpacePayloadLevelPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelPublicGrossSpacesOrderBy>>;
};

/** All input for the `updateLevelTypeAttr` mutation. */
export type UpdateLevelTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelTypeAttr` being updated. */
  patch: LevelTypeAttrPatch;
};

/** The output of our update `LevelTypeAttr` mutation. */
export type UpdateLevelTypeAttrPayload = {
  __typename?: 'UpdateLevelTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `LevelTypeAttr`. */
  level?: Maybe<Level>;
  /** Reads a single `LevelType` that is related to this `LevelTypeAttr`. */
  levelType?: Maybe<LevelType>;
  /** The `LevelTypeAttr` that was updated by this mutation. */
  levelTypeAttr?: Maybe<LevelTypeAttr>;
  /** An edge for our `LevelTypeAttr`. May be used by Relay 1. */
  levelTypeAttrEdge?: Maybe<LevelTypeAttrsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelTypeAttr` mutation. */
export type UpdateLevelTypeAttrPayloadLevelTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelTypeAttrsOrderBy>>;
};

/** All input for the `updateLevelTypeByName` mutation. */
export type UpdateLevelTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `LevelType` being updated. */
  patch: LevelTypePatch;
};

/** All input for the `updateLevelType` mutation. */
export type UpdateLevelTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LevelType` being updated. */
  patch: LevelTypePatch;
};

/** The output of our update `LevelType` mutation. */
export type UpdateLevelTypePayload = {
  __typename?: 'UpdateLevelTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LevelType` that was updated by this mutation. */
  levelType?: Maybe<LevelType>;
  /** An edge for our `LevelType`. May be used by Relay 1. */
  levelTypeEdge?: Maybe<LevelTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LevelType` mutation. */
export type UpdateLevelTypePayloadLevelTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<LevelTypesOrderBy>>;
};

/** All input for the `updateLink` mutation. */
export type UpdateLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Link` being updated. */
  patch: LinkPatch;
};

/** The output of our update `Link` mutation. */
export type UpdateLinkPayload = {
  __typename?: 'UpdateLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Link` that was updated by this mutation. */
  link?: Maybe<Link>;
  /** An edge for our `Link`. May be used by Relay 1. */
  linkEdge?: Maybe<LinksEdge>;
  /** Reads a single `Multilink` that is related to this `Link`. */
  multilink?: Maybe<Multilink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Link` mutation. */
export type UpdateLinkPayloadLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};

/** All input for the `updateMultilink` mutation. */
export type UpdateMultilinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Multilink` being updated. */
  patch: MultilinkPatch;
};

/** The output of our update `Multilink` mutation. */
export type UpdateMultilinkPayload = {
  __typename?: 'UpdateMultilinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Multilink` that was updated by this mutation. */
  multilink?: Maybe<Multilink>;
  /** An edge for our `Multilink`. May be used by Relay 1. */
  multilinkEdge?: Maybe<MultilinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Multilink` mutation. */
export type UpdateMultilinkPayloadMultilinkEdgeArgs = {
  orderBy?: InputMaybe<Array<MultilinksOrderBy>>;
};

export type UpdatePasswordResponse = InvalidCredentials | Success;

/** All input for the `updatePlotByExtId` mutation. */
export type UpdatePlotByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Plot` being updated. */
  patch: PlotPatch;
};

/** All input for the `updatePlotByNameShort` mutation. */
export type UpdatePlotByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Plot` being updated. */
  patch: PlotPatch;
};

/** All input for the `updatePlotCadGrossSpaceMin` mutation. */
export type UpdatePlotCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotCadGrossSpaceMin` being updated. */
  patch: PlotCadGrossSpaceMinPatch;
};

/** The output of our update `PlotCadGrossSpaceMin` mutation. */
export type UpdatePlotCadGrossSpaceMinPayload = {
  __typename?: 'UpdatePlotCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotCadGrossSpaceMin`. */
  plot?: Maybe<Plot>;
  /** The `PlotCadGrossSpaceMin` that was updated by this mutation. */
  plotCadGrossSpaceMin?: Maybe<PlotCadGrossSpaceMin>;
  /** An edge for our `PlotCadGrossSpaceMin`. May be used by Relay 1. */
  plotCadGrossSpaceMinEdge?: Maybe<PlotCadGrossSpaceMinsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotCadGrossSpaceMin` mutation. */
export type UpdatePlotCadGrossSpaceMinPayloadPlotCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `updatePlotDescription` mutation. */
export type UpdatePlotDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotDescription` being updated. */
  patch: PlotDescriptionPatch;
};

/** The output of our update `PlotDescription` mutation. */
export type UpdatePlotDescriptionPayload = {
  __typename?: 'UpdatePlotDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotDescription`. */
  plot?: Maybe<Plot>;
  /** The `PlotDescription` that was updated by this mutation. */
  plotDescription?: Maybe<PlotDescription>;
  /** An edge for our `PlotDescription`. May be used by Relay 1. */
  plotDescriptionEdge?: Maybe<PlotDescriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotDescription` mutation. */
export type UpdatePlotDescriptionPayloadPlotDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotDescriptionsOrderBy>>;
};

/** All input for the `updatePlot` mutation. */
export type UpdatePlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Plot` being updated. */
  patch: PlotPatch;
};

/** All input for the `updatePlotNameExtra` mutation. */
export type UpdatePlotNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameExtra` being updated. */
  patch: PlotNameExtraPatch;
};

/** The output of our update `PlotNameExtra` mutation. */
export type UpdatePlotNameExtraPayload = {
  __typename?: 'UpdatePlotNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameExtra`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameExtra` that was updated by this mutation. */
  plotNameExtra?: Maybe<PlotNameExtra>;
  /** An edge for our `PlotNameExtra`. May be used by Relay 1. */
  plotNameExtraEdge?: Maybe<PlotNameExtrasEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameExtra` mutation. */
export type UpdatePlotNameExtraPayloadPlotNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameExtrasOrderBy>>;
};

/** All input for the `updatePlotNameKeyCad` mutation. */
export type UpdatePlotNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameKeyCad` being updated. */
  patch: PlotNameKeyCadPatch;
};

/** The output of our update `PlotNameKeyCad` mutation. */
export type UpdatePlotNameKeyCadPayload = {
  __typename?: 'UpdatePlotNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyCad`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyCad` that was updated by this mutation. */
  plotNameKeyCad?: Maybe<PlotNameKeyCad>;
  /** An edge for our `PlotNameKeyCad`. May be used by Relay 1. */
  plotNameKeyCadEdge?: Maybe<PlotNameKeyCadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameKeyCad` mutation. */
export type UpdatePlotNameKeyCadPayloadPlotNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyCadsOrderBy>>;
};

/** All input for the `updatePlotNameKeyCafm` mutation. */
export type UpdatePlotNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameKeyCafm` being updated. */
  patch: PlotNameKeyCafmPatch;
};

/** The output of our update `PlotNameKeyCafm` mutation. */
export type UpdatePlotNameKeyCafmPayload = {
  __typename?: 'UpdatePlotNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyCafm`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyCafm` that was updated by this mutation. */
  plotNameKeyCafm?: Maybe<PlotNameKeyCafm>;
  /** An edge for our `PlotNameKeyCafm`. May be used by Relay 1. */
  plotNameKeyCafmEdge?: Maybe<PlotNameKeyCafmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameKeyCafm` mutation. */
export type UpdatePlotNameKeyCafmPayloadPlotNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyCafmsOrderBy>>;
};

/** All input for the `updatePlotNameKeyEbm` mutation. */
export type UpdatePlotNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameKeyEbm` being updated. */
  patch: PlotNameKeyEbmPatch;
};

/** The output of our update `PlotNameKeyEbm` mutation. */
export type UpdatePlotNameKeyEbmPayload = {
  __typename?: 'UpdatePlotNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyEbm`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyEbm` that was updated by this mutation. */
  plotNameKeyEbm?: Maybe<PlotNameKeyEbm>;
  /** An edge for our `PlotNameKeyEbm`. May be used by Relay 1. */
  plotNameKeyEbmEdge?: Maybe<PlotNameKeyEbmsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameKeyEbm` mutation. */
export type UpdatePlotNameKeyEbmPayloadPlotNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyEbmsOrderBy>>;
};

/** All input for the `updatePlotNameKeyMarketing` mutation. */
export type UpdatePlotNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameKeyMarketing` being updated. */
  patch: PlotNameKeyMarketingPatch;
};

/** The output of our update `PlotNameKeyMarketing` mutation. */
export type UpdatePlotNameKeyMarketingPayload = {
  __typename?: 'UpdatePlotNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameKeyMarketing`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameKeyMarketing` that was updated by this mutation. */
  plotNameKeyMarketing?: Maybe<PlotNameKeyMarketing>;
  /** An edge for our `PlotNameKeyMarketing`. May be used by Relay 1. */
  plotNameKeyMarketingEdge?: Maybe<PlotNameKeyMarketingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameKeyMarketing` mutation. */
export type UpdatePlotNameKeyMarketingPayloadPlotNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameKeyMarketingsOrderBy>>;
};

/** All input for the `updatePlotNameLong` mutation. */
export type UpdatePlotNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameLong` being updated. */
  patch: PlotNameLongPatch;
};

/** The output of our update `PlotNameLong` mutation. */
export type UpdatePlotNameLongPayload = {
  __typename?: 'UpdatePlotNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameLong`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameLong` that was updated by this mutation. */
  plotNameLong?: Maybe<PlotNameLong>;
  /** An edge for our `PlotNameLong`. May be used by Relay 1. */
  plotNameLongEdge?: Maybe<PlotNameLongsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameLong` mutation. */
export type UpdatePlotNameLongPayloadPlotNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameLongsOrderBy>>;
};

/** All input for the `updatePlotNameShort` mutation. */
export type UpdatePlotNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotNameShort` being updated. */
  patch: PlotNameShortPatch;
};

/** The output of our update `PlotNameShort` mutation. */
export type UpdatePlotNameShortPayload = {
  __typename?: 'UpdatePlotNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotNameShort`. */
  plot?: Maybe<Plot>;
  /** The `PlotNameShort` that was updated by this mutation. */
  plotNameShort?: Maybe<PlotNameShort>;
  /** An edge for our `PlotNameShort`. May be used by Relay 1. */
  plotNameShortEdge?: Maybe<PlotNameShortsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotNameShort` mutation. */
export type UpdatePlotNameShortPayloadPlotNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotNameShortsOrderBy>>;
};

/** The output of our update `Plot` mutation. */
export type UpdatePlotPayload = {
  __typename?: 'UpdatePlotPayload';
  /** Reads a single `Area` that is related to this `Plot`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Plot` that was updated by this mutation. */
  plot?: Maybe<Plot>;
  /** An edge for our `Plot`. May be used by Relay 1. */
  plotEdge?: Maybe<PlotsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `PlotType` that is related to this `Plot`. */
  type?: Maybe<PlotType>;
};


/** The output of our update `Plot` mutation. */
export type UpdatePlotPayloadPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotsOrderBy>>;
};

/** All input for the `updatePlotPublicGrossSpace` mutation. */
export type UpdatePlotPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotPublicGrossSpace` being updated. */
  patch: PlotPublicGrossSpacePatch;
};

/** The output of our update `PlotPublicGrossSpace` mutation. */
export type UpdatePlotPublicGrossSpacePayload = {
  __typename?: 'UpdatePlotPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotPublicGrossSpace`. */
  plot?: Maybe<Plot>;
  /** The `PlotPublicGrossSpace` that was updated by this mutation. */
  plotPublicGrossSpace?: Maybe<PlotPublicGrossSpace>;
  /** An edge for our `PlotPublicGrossSpace`. May be used by Relay 1. */
  plotPublicGrossSpaceEdge?: Maybe<PlotPublicGrossSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotPublicGrossSpace` mutation. */
export type UpdatePlotPublicGrossSpacePayloadPlotPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotPublicGrossSpacesOrderBy>>;
};

/** All input for the `updatePlotTypeAttr` mutation. */
export type UpdatePlotTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotTypeAttr` being updated. */
  patch: PlotTypeAttrPatch;
};

/** The output of our update `PlotTypeAttr` mutation. */
export type UpdatePlotTypeAttrPayload = {
  __typename?: 'UpdatePlotTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `PlotTypeAttr`. */
  plot?: Maybe<Plot>;
  /** Reads a single `PlotType` that is related to this `PlotTypeAttr`. */
  plotType?: Maybe<PlotType>;
  /** The `PlotTypeAttr` that was updated by this mutation. */
  plotTypeAttr?: Maybe<PlotTypeAttr>;
  /** An edge for our `PlotTypeAttr`. May be used by Relay 1. */
  plotTypeAttrEdge?: Maybe<PlotTypeAttrsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotTypeAttr` mutation. */
export type UpdatePlotTypeAttrPayloadPlotTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotTypeAttrsOrderBy>>;
};

/** All input for the `updatePlotTypeByName` mutation. */
export type UpdatePlotTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `PlotType` being updated. */
  patch: PlotTypePatch;
};

/** All input for the `updatePlotType` mutation. */
export type UpdatePlotTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PlotType` being updated. */
  patch: PlotTypePatch;
};

/** The output of our update `PlotType` mutation. */
export type UpdatePlotTypePayload = {
  __typename?: 'UpdatePlotTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PlotType` that was updated by this mutation. */
  plotType?: Maybe<PlotType>;
  /** An edge for our `PlotType`. May be used by Relay 1. */
  plotTypeEdge?: Maybe<PlotTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PlotType` mutation. */
export type UpdatePlotTypePayloadPlotTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PlotTypesOrderBy>>;
};

/** All input for the `updateProjectAllocationArea` mutation. */
export type UpdateProjectAllocationAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationArea` being updated. */
  patch: ProjectAllocationAreaPatch;
};

/** The output of our update `ProjectAllocationArea` mutation. */
export type UpdateProjectAllocationAreaPayload = {
  __typename?: 'UpdateProjectAllocationAreaPayload';
  /** Reads a single `Area` that is related to this `ProjectAllocationArea`. */
  area?: Maybe<Area>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationArea` that was updated by this mutation. */
  projectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** An edge for our `ProjectAllocationArea`. May be used by Relay 1. */
  projectAllocationAreaEdge?: Maybe<ProjectAllocationAreasEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationArea`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectAllocationArea` mutation. */
export type UpdateProjectAllocationAreaPayloadProjectAllocationAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationAreasOrderBy>>;
};

/** All input for the `updateProjectAllocationAreaPhase` mutation. */
export type UpdateProjectAllocationAreaPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationAreaPhase` being updated. */
  patch: ProjectAllocationAreaPhasePatch;
};

/** The output of our update `ProjectAllocationAreaPhase` mutation. */
export type UpdateProjectAllocationAreaPhasePayload = {
  __typename?: 'UpdateProjectAllocationAreaPhasePayload';
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectAllocationAreaPhase`. */
  allocation?: Maybe<ProjectAllocationArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationAreaPhase` that was updated by this mutation. */
  projectAllocationAreaPhase?: Maybe<ProjectAllocationAreaPhase>;
  /** An edge for our `ProjectAllocationAreaPhase`. May be used by Relay 1. */
  projectAllocationAreaPhaseEdge?: Maybe<ProjectAllocationAreaPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationAreaPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our update `ProjectAllocationAreaPhase` mutation. */
export type UpdateProjectAllocationAreaPhasePayloadProjectAllocationAreaPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationAreaPhasesOrderBy>>;
};

/** All input for the `updateProjectAllocationPlot` mutation. */
export type UpdateProjectAllocationPlotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationPlot` being updated. */
  patch: ProjectAllocationPlotPatch;
};

/** The output of our update `ProjectAllocationPlot` mutation. */
export type UpdateProjectAllocationPlotPayload = {
  __typename?: 'UpdateProjectAllocationPlotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Plot` that is related to this `ProjectAllocationPlot`. */
  plot?: Maybe<Plot>;
  /** The `ProjectAllocationPlot` that was updated by this mutation. */
  projectAllocationPlot?: Maybe<ProjectAllocationPlot>;
  /** An edge for our `ProjectAllocationPlot`. May be used by Relay 1. */
  projectAllocationPlotEdge?: Maybe<ProjectAllocationPlotsEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationPlot`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectAllocationPlot` mutation. */
export type UpdateProjectAllocationPlotPayloadProjectAllocationPlotEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationPlotsOrderBy>>;
};

/** All input for the `updateProjectAllocationPlotPhase` mutation. */
export type UpdateProjectAllocationPlotPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationPlotPhase` being updated. */
  patch: ProjectAllocationPlotPhasePatch;
};

/** The output of our update `ProjectAllocationPlotPhase` mutation. */
export type UpdateProjectAllocationPlotPhasePayload = {
  __typename?: 'UpdateProjectAllocationPlotPhasePayload';
  /** Reads a single `ProjectAllocationPlot` that is related to this `ProjectAllocationPlotPhase`. */
  allocation?: Maybe<ProjectAllocationPlot>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationPlotPhase` that was updated by this mutation. */
  projectAllocationPlotPhase?: Maybe<ProjectAllocationPlotPhase>;
  /** An edge for our `ProjectAllocationPlotPhase`. May be used by Relay 1. */
  projectAllocationPlotPhaseEdge?: Maybe<ProjectAllocationPlotPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationPlotPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our update `ProjectAllocationPlotPhase` mutation. */
export type UpdateProjectAllocationPlotPhasePayloadProjectAllocationPlotPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationPlotPhasesOrderBy>>;
};

/** All input for the `updateProjectAllocationRoom` mutation. */
export type UpdateProjectAllocationRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationRoom` being updated. */
  patch: ProjectAllocationRoomPatch;
};

/** The output of our update `ProjectAllocationRoom` mutation. */
export type UpdateProjectAllocationRoomPayload = {
  __typename?: 'UpdateProjectAllocationRoomPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationRoom` that was updated by this mutation. */
  projectAllocationRoom?: Maybe<ProjectAllocationRoom>;
  /** An edge for our `ProjectAllocationRoom`. May be used by Relay 1. */
  projectAllocationRoomEdge?: Maybe<ProjectAllocationRoomsEdge>;
  /** Reads a single `ProjectVariant` that is related to this `ProjectAllocationRoom`. */
  projectVariant?: Maybe<ProjectVariant>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `ProjectAllocationRoom`. */
  room?: Maybe<Room>;
};


/** The output of our update `ProjectAllocationRoom` mutation. */
export type UpdateProjectAllocationRoomPayloadProjectAllocationRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationRoomsOrderBy>>;
};

/** All input for the `updateProjectAllocationRoomPhase` mutation. */
export type UpdateProjectAllocationRoomPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationRoomPhase` being updated. */
  patch: ProjectAllocationRoomPhasePatch;
};

/** The output of our update `ProjectAllocationRoomPhase` mutation. */
export type UpdateProjectAllocationRoomPhasePayload = {
  __typename?: 'UpdateProjectAllocationRoomPhasePayload';
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectAllocationRoomPhase`. */
  allocation?: Maybe<ProjectAllocationRoom>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationRoomPhase` that was updated by this mutation. */
  projectAllocationRoomPhase?: Maybe<ProjectAllocationRoomPhase>;
  /** An edge for our `ProjectAllocationRoomPhase`. May be used by Relay 1. */
  projectAllocationRoomPhaseEdge?: Maybe<ProjectAllocationRoomPhasesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationUsage` that is related to this `ProjectAllocationRoomPhase`. */
  usage?: Maybe<ProjectAllocationUsage>;
};


/** The output of our update `ProjectAllocationRoomPhase` mutation. */
export type UpdateProjectAllocationRoomPhasePayloadProjectAllocationRoomPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationRoomPhasesOrderBy>>;
};

/** All input for the `updateProjectAllocationUsageByName` mutation. */
export type UpdateProjectAllocationUsageByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ProjectAllocationUsage` being updated. */
  patch: ProjectAllocationUsagePatch;
};

/** All input for the `updateProjectAllocationUsageByNameShort` mutation. */
export type UpdateProjectAllocationUsageByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `ProjectAllocationUsage` being updated. */
  patch: ProjectAllocationUsagePatch;
};

/** All input for the `updateProjectAllocationUsageByPosition` mutation. */
export type UpdateProjectAllocationUsageByPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProjectAllocationUsage` being updated. */
  patch: ProjectAllocationUsagePatch;
  position: Scalars['Int'];
};

/** All input for the `updateProjectAllocationUsageByType` mutation. */
export type UpdateProjectAllocationUsageByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProjectAllocationUsage` being updated. */
  patch: ProjectAllocationUsagePatch;
  type: ProjectAllocationUsageType;
};

/** All input for the `updateProjectAllocationUsage` mutation. */
export type UpdateProjectAllocationUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectAllocationUsage` being updated. */
  patch: ProjectAllocationUsagePatch;
};

/** The output of our update `ProjectAllocationUsage` mutation. */
export type UpdateProjectAllocationUsagePayload = {
  __typename?: 'UpdateProjectAllocationUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProjectAllocationUsage` that was updated by this mutation. */
  projectAllocationUsage?: Maybe<ProjectAllocationUsage>;
  /** An edge for our `ProjectAllocationUsage`. May be used by Relay 1. */
  projectAllocationUsageEdge?: Maybe<ProjectAllocationUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectAllocationUsage` mutation. */
export type UpdateProjectAllocationUsagePayloadProjectAllocationUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectAllocationUsagesOrderBy>>;
};

/** All input for the `updateProjectByNameShort` mutation. */
export type UpdateProjectByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** All input for the `updateProject` mutation. */
export type UpdateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherLinks?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `Project`. */
  otherSystems?: Maybe<Multilink>;
  /** The `Project` that was updated by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectSeries` that is related to this `Project`. */
  series?: Maybe<ProjectSeries>;
};


/** The output of our update `Project` mutation. */
export type UpdateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `updateProjectSeriesByNameShort` mutation. */
export type UpdateProjectSeriesByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `ProjectSeries` being updated. */
  patch: ProjectSeriesPatch;
};

/** All input for the `updateProjectSeries` mutation. */
export type UpdateProjectSeriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectSeries` being updated. */
  patch: ProjectSeriesPatch;
};

/** The output of our update `ProjectSeries` mutation. */
export type UpdateProjectSeriesPayload = {
  __typename?: 'UpdateProjectSeriesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherDocuments?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherLinks?: Maybe<Multilink>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  otherSystems?: Maybe<Multilink>;
  /** The `ProjectSeries` that was updated by this mutation. */
  projectSeries?: Maybe<ProjectSeries>;
  /** An edge for our `ProjectSeries`. May be used by Relay 1. */
  projectSeriesEdge?: Maybe<ProjectSeriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Multilink` that is related to this `ProjectSeries`. */
  websites?: Maybe<Multilink>;
};


/** The output of our update `ProjectSeries` mutation. */
export type UpdateProjectSeriesPayloadProjectSeriesEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectSeriesOrderBy>>;
};

/** All input for the `updateProjectVariantByProjectIdAndIndex` mutation. */
export type UpdateProjectVariantByProjectIdAndIndexInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  index: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProjectVariant` being updated. */
  patch: ProjectVariantPatch;
  projectId: Scalars['UUID'];
};

/** All input for the `updateProjectVariant` mutation. */
export type UpdateProjectVariantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectVariant` being updated. */
  patch: ProjectVariantPatch;
};

/** The output of our update `ProjectVariant` mutation. */
export type UpdateProjectVariantPayload = {
  __typename?: 'UpdateProjectVariantPayload';
  /** Reads a single `Feed` that is related to this `ProjectVariant`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Project` that is related to this `ProjectVariant`. */
  project?: Maybe<Project>;
  /** The `ProjectVariant` that was updated by this mutation. */
  projectVariant?: Maybe<ProjectVariant>;
  /** An edge for our `ProjectVariant`. May be used by Relay 1. */
  projectVariantEdge?: Maybe<ProjectVariantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ProjectAllocationArea` that is related to this `ProjectVariant`. */
  referenceProjectAllocationArea?: Maybe<ProjectAllocationArea>;
  /** Reads a single `ProjectAllocationRoom` that is related to this `ProjectVariant`. */
  referenceProjectAllocationRoom?: Maybe<ProjectAllocationRoom>;
};


/** The output of our update `ProjectVariant` mutation. */
export type UpdateProjectVariantPayloadProjectVariantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectVariantsOrderBy>>;
};

/** All input for the `updateRoomAirChangeRate` mutation. */
export type UpdateRoomAirChangeRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomAirChangeRate` being updated. */
  patch: RoomAirChangeRatePatch;
};

/** The output of our update `RoomAirChangeRate` mutation. */
export type UpdateRoomAirChangeRatePayload = {
  __typename?: 'UpdateRoomAirChangeRatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomAirChangeRate`. */
  room?: Maybe<Room>;
  /** The `RoomAirChangeRate` that was updated by this mutation. */
  roomAirChangeRate?: Maybe<RoomAirChangeRate>;
  /** An edge for our `RoomAirChangeRate`. May be used by Relay 1. */
  roomAirChangeRateEdge?: Maybe<RoomAirChangeRatesEdge>;
};


/** The output of our update `RoomAirChangeRate` mutation. */
export type UpdateRoomAirChangeRatePayloadRoomAirChangeRateEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomAirChangeRatesOrderBy>>;
};

/** All input for the `updateRoomAirConditioning` mutation. */
export type UpdateRoomAirConditioningInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomAirConditioning` being updated. */
  patch: RoomAirConditioningPatch;
};

/** The output of our update `RoomAirConditioning` mutation. */
export type UpdateRoomAirConditioningPayload = {
  __typename?: 'UpdateRoomAirConditioningPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomAirConditioning`. */
  room?: Maybe<Room>;
  /** The `RoomAirConditioning` that was updated by this mutation. */
  roomAirConditioning?: Maybe<RoomAirConditioning>;
  /** An edge for our `RoomAirConditioning`. May be used by Relay 1. */
  roomAirConditioningEdge?: Maybe<RoomAirConditioningsEdge>;
};


/** The output of our update `RoomAirConditioning` mutation. */
export type UpdateRoomAirConditioningPayloadRoomAirConditioningEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomAirConditioningsOrderBy>>;
};

/** All input for the `updateRoomByExtId` mutation. */
export type UpdateRoomByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Room` being updated. */
  patch: RoomPatch;
};

/** All input for the `updateRoomByNameShort` mutation. */
export type UpdateRoomByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Room` being updated. */
  patch: RoomPatch;
};

/** All input for the `updateRoomCadGrossSpaceMin` mutation. */
export type UpdateRoomCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadGrossSpaceMin` being updated. */
  patch: RoomCadGrossSpaceMinPatch;
};

/** The output of our update `RoomCadGrossSpaceMin` mutation. */
export type UpdateRoomCadGrossSpaceMinPayload = {
  __typename?: 'UpdateRoomCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadGrossSpaceMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadGrossSpaceMin` that was updated by this mutation. */
  roomCadGrossSpaceMin?: Maybe<RoomCadGrossSpaceMin>;
  /** An edge for our `RoomCadGrossSpaceMin`. May be used by Relay 1. */
  roomCadGrossSpaceMinEdge?: Maybe<RoomCadGrossSpaceMinsEdge>;
};


/** The output of our update `RoomCadGrossSpaceMin` mutation. */
export type UpdateRoomCadGrossSpaceMinPayloadRoomCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `updateRoomCadHeightMax` mutation. */
export type UpdateRoomCadHeightMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadHeightMax` being updated. */
  patch: RoomCadHeightMaxPatch;
};

/** The output of our update `RoomCadHeightMax` mutation. */
export type UpdateRoomCadHeightMaxPayload = {
  __typename?: 'UpdateRoomCadHeightMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadHeightMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadHeightMax` that was updated by this mutation. */
  roomCadHeightMax?: Maybe<RoomCadHeightMax>;
  /** An edge for our `RoomCadHeightMax`. May be used by Relay 1. */
  roomCadHeightMaxEdge?: Maybe<RoomCadHeightMaxesEdge>;
};


/** The output of our update `RoomCadHeightMax` mutation. */
export type UpdateRoomCadHeightMaxPayloadRoomCadHeightMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadHeightMaxesOrderBy>>;
};

/** All input for the `updateRoomCadHeightMin` mutation. */
export type UpdateRoomCadHeightMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadHeightMin` being updated. */
  patch: RoomCadHeightMinPatch;
};

/** The output of our update `RoomCadHeightMin` mutation. */
export type UpdateRoomCadHeightMinPayload = {
  __typename?: 'UpdateRoomCadHeightMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadHeightMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadHeightMin` that was updated by this mutation. */
  roomCadHeightMin?: Maybe<RoomCadHeightMin>;
  /** An edge for our `RoomCadHeightMin`. May be used by Relay 1. */
  roomCadHeightMinEdge?: Maybe<RoomCadHeightMinsEdge>;
};


/** The output of our update `RoomCadHeightMin` mutation. */
export type UpdateRoomCadHeightMinPayloadRoomCadHeightMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadHeightMinsOrderBy>>;
};

/** All input for the `updateRoomCadLengthMax` mutation. */
export type UpdateRoomCadLengthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadLengthMax` being updated. */
  patch: RoomCadLengthMaxPatch;
};

/** The output of our update `RoomCadLengthMax` mutation. */
export type UpdateRoomCadLengthMaxPayload = {
  __typename?: 'UpdateRoomCadLengthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadLengthMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadLengthMax` that was updated by this mutation. */
  roomCadLengthMax?: Maybe<RoomCadLengthMax>;
  /** An edge for our `RoomCadLengthMax`. May be used by Relay 1. */
  roomCadLengthMaxEdge?: Maybe<RoomCadLengthMaxesEdge>;
};


/** The output of our update `RoomCadLengthMax` mutation. */
export type UpdateRoomCadLengthMaxPayloadRoomCadLengthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadLengthMaxesOrderBy>>;
};

/** All input for the `updateRoomCadLengthMin` mutation. */
export type UpdateRoomCadLengthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadLengthMin` being updated. */
  patch: RoomCadLengthMinPatch;
};

/** The output of our update `RoomCadLengthMin` mutation. */
export type UpdateRoomCadLengthMinPayload = {
  __typename?: 'UpdateRoomCadLengthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadLengthMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadLengthMin` that was updated by this mutation. */
  roomCadLengthMin?: Maybe<RoomCadLengthMin>;
  /** An edge for our `RoomCadLengthMin`. May be used by Relay 1. */
  roomCadLengthMinEdge?: Maybe<RoomCadLengthMinsEdge>;
};


/** The output of our update `RoomCadLengthMin` mutation. */
export type UpdateRoomCadLengthMinPayloadRoomCadLengthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadLengthMinsOrderBy>>;
};

/** All input for the `updateRoomCadWidthMax` mutation. */
export type UpdateRoomCadWidthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadWidthMax` being updated. */
  patch: RoomCadWidthMaxPatch;
};

/** The output of our update `RoomCadWidthMax` mutation. */
export type UpdateRoomCadWidthMaxPayload = {
  __typename?: 'UpdateRoomCadWidthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadWidthMax`. */
  room?: Maybe<Room>;
  /** The `RoomCadWidthMax` that was updated by this mutation. */
  roomCadWidthMax?: Maybe<RoomCadWidthMax>;
  /** An edge for our `RoomCadWidthMax`. May be used by Relay 1. */
  roomCadWidthMaxEdge?: Maybe<RoomCadWidthMaxesEdge>;
};


/** The output of our update `RoomCadWidthMax` mutation. */
export type UpdateRoomCadWidthMaxPayloadRoomCadWidthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadWidthMaxesOrderBy>>;
};

/** All input for the `updateRoomCadWidthMin` mutation. */
export type UpdateRoomCadWidthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCadWidthMin` being updated. */
  patch: RoomCadWidthMinPatch;
};

/** The output of our update `RoomCadWidthMin` mutation. */
export type UpdateRoomCadWidthMinPayload = {
  __typename?: 'UpdateRoomCadWidthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCadWidthMin`. */
  room?: Maybe<Room>;
  /** The `RoomCadWidthMin` that was updated by this mutation. */
  roomCadWidthMin?: Maybe<RoomCadWidthMin>;
  /** An edge for our `RoomCadWidthMin`. May be used by Relay 1. */
  roomCadWidthMinEdge?: Maybe<RoomCadWidthMinsEdge>;
};


/** The output of our update `RoomCadWidthMin` mutation. */
export type UpdateRoomCadWidthMinPayloadRoomCadWidthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCadWidthMinsOrderBy>>;
};

/** All input for the `updateRoomCapacityCar` mutation. */
export type UpdateRoomCapacityCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCapacityCar` being updated. */
  patch: RoomCapacityCarPatch;
};

/** The output of our update `RoomCapacityCar` mutation. */
export type UpdateRoomCapacityCarPayload = {
  __typename?: 'UpdateRoomCapacityCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityCar`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityCar` that was updated by this mutation. */
  roomCapacityCar?: Maybe<RoomCapacityCar>;
  /** An edge for our `RoomCapacityCar`. May be used by Relay 1. */
  roomCapacityCarEdge?: Maybe<RoomCapacityCarsEdge>;
};


/** The output of our update `RoomCapacityCar` mutation. */
export type UpdateRoomCapacityCarPayloadRoomCapacityCarEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityCarsOrderBy>>;
};

/** All input for the `updateRoomCapacityPax` mutation. */
export type UpdateRoomCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCapacityPax` being updated. */
  patch: RoomCapacityPaxPatch;
};

/** The output of our update `RoomCapacityPax` mutation. */
export type UpdateRoomCapacityPaxPayload = {
  __typename?: 'UpdateRoomCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityPax`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityPax` that was updated by this mutation. */
  roomCapacityPax?: Maybe<RoomCapacityPax>;
  /** An edge for our `RoomCapacityPax`. May be used by Relay 1. */
  roomCapacityPaxEdge?: Maybe<RoomCapacityPaxesEdge>;
};


/** The output of our update `RoomCapacityPax` mutation. */
export type UpdateRoomCapacityPaxPayloadRoomCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityPaxesOrderBy>>;
};

/** All input for the `updateRoomCapacityTruck` mutation. */
export type UpdateRoomCapacityTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCapacityTruck` being updated. */
  patch: RoomCapacityTruckPatch;
};

/** The output of our update `RoomCapacityTruck` mutation. */
export type UpdateRoomCapacityTruckPayload = {
  __typename?: 'UpdateRoomCapacityTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCapacityTruck`. */
  room?: Maybe<Room>;
  /** The `RoomCapacityTruck` that was updated by this mutation. */
  roomCapacityTruck?: Maybe<RoomCapacityTruck>;
  /** An edge for our `RoomCapacityTruck`. May be used by Relay 1. */
  roomCapacityTruckEdge?: Maybe<RoomCapacityTrucksEdge>;
};


/** The output of our update `RoomCapacityTruck` mutation. */
export type UpdateRoomCapacityTruckPayloadRoomCapacityTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCapacityTrucksOrderBy>>;
};

/** All input for the `updateRoomCleaningGrossSpace` mutation. */
export type UpdateRoomCleaningGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomCleaningGrossSpace` being updated. */
  patch: RoomCleaningGrossSpacePatch;
};

/** The output of our update `RoomCleaningGrossSpace` mutation. */
export type UpdateRoomCleaningGrossSpacePayload = {
  __typename?: 'UpdateRoomCleaningGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomCleaningGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomCleaningGrossSpace` that was updated by this mutation. */
  roomCleaningGrossSpace?: Maybe<RoomCleaningGrossSpace>;
  /** An edge for our `RoomCleaningGrossSpace`. May be used by Relay 1. */
  roomCleaningGrossSpaceEdge?: Maybe<RoomCleaningGrossSpacesEdge>;
};


/** The output of our update `RoomCleaningGrossSpace` mutation. */
export type UpdateRoomCleaningGrossSpacePayloadRoomCleaningGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomCleaningGrossSpacesOrderBy>>;
};

/** All input for the `updateRoomClearanceConstruction` mutation. */
export type UpdateRoomClearanceConstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomClearanceConstruction` being updated. */
  patch: RoomClearanceConstructionPatch;
};

/** The output of our update `RoomClearanceConstruction` mutation. */
export type UpdateRoomClearanceConstructionPayload = {
  __typename?: 'UpdateRoomClearanceConstructionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomClearanceConstruction`. */
  room?: Maybe<Room>;
  /** The `RoomClearanceConstruction` that was updated by this mutation. */
  roomClearanceConstruction?: Maybe<RoomClearanceConstruction>;
  /** An edge for our `RoomClearanceConstruction`. May be used by Relay 1. */
  roomClearanceConstructionEdge?: Maybe<RoomClearanceConstructionsEdge>;
};


/** The output of our update `RoomClearanceConstruction` mutation. */
export type UpdateRoomClearanceConstructionPayloadRoomClearanceConstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomClearanceConstructionsOrderBy>>;
};

/** All input for the `updateRoomContactBooking` mutation. */
export type UpdateRoomContactBookingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomContactBooking` being updated. */
  patch: RoomContactBookingPatch;
};

/** The output of our update `RoomContactBooking` mutation. */
export type UpdateRoomContactBookingPayload = {
  __typename?: 'UpdateRoomContactBookingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomContactBooking`. */
  room?: Maybe<Room>;
  /** The `RoomContactBooking` that was updated by this mutation. */
  roomContactBooking?: Maybe<RoomContactBooking>;
  /** An edge for our `RoomContactBooking`. May be used by Relay 1. */
  roomContactBookingEdge?: Maybe<RoomContactBookingsEdge>;
};


/** The output of our update `RoomContactBooking` mutation. */
export type UpdateRoomContactBookingPayloadRoomContactBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomContactBookingsOrderBy>>;
};

/** All input for the `updateRoomDaylight` mutation. */
export type UpdateRoomDaylightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomDaylight` being updated. */
  patch: RoomDaylightPatch;
};

/** The output of our update `RoomDaylight` mutation. */
export type UpdateRoomDaylightPayload = {
  __typename?: 'UpdateRoomDaylightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomDaylight`. */
  room?: Maybe<Room>;
  /** The `RoomDaylight` that was updated by this mutation. */
  roomDaylight?: Maybe<RoomDaylight>;
  /** An edge for our `RoomDaylight`. May be used by Relay 1. */
  roomDaylightEdge?: Maybe<RoomDaylightsEdge>;
};


/** The output of our update `RoomDaylight` mutation. */
export type UpdateRoomDaylightPayloadRoomDaylightEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomDaylightsOrderBy>>;
};

/** All input for the `updateRoomDescription` mutation. */
export type UpdateRoomDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomDescription` being updated. */
  patch: RoomDescriptionPatch;
};

/** The output of our update `RoomDescription` mutation. */
export type UpdateRoomDescriptionPayload = {
  __typename?: 'UpdateRoomDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomDescription`. */
  room?: Maybe<Room>;
  /** The `RoomDescription` that was updated by this mutation. */
  roomDescription?: Maybe<RoomDescription>;
  /** An edge for our `RoomDescription`. May be used by Relay 1. */
  roomDescriptionEdge?: Maybe<RoomDescriptionsEdge>;
};


/** The output of our update `RoomDescription` mutation. */
export type UpdateRoomDescriptionPayloadRoomDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomDescriptionsOrderBy>>;
};

/** All input for the `updateRoom` mutation. */
export type UpdateRoomInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Room` being updated. */
  patch: RoomPatch;
};

/** All input for the `updateRoomKeyIssuance` mutation. */
export type UpdateRoomKeyIssuanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomKeyIssuance` being updated. */
  patch: RoomKeyIssuancePatch;
};

/** All input for the `updateRoomKeyIssuanceNote` mutation. */
export type UpdateRoomKeyIssuanceNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomKeyIssuanceNote` being updated. */
  patch: RoomKeyIssuanceNotePatch;
};

/** The output of our update `RoomKeyIssuanceNote` mutation. */
export type UpdateRoomKeyIssuanceNotePayload = {
  __typename?: 'UpdateRoomKeyIssuanceNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomKeyIssuanceNote`. */
  room?: Maybe<Room>;
  /** The `RoomKeyIssuanceNote` that was updated by this mutation. */
  roomKeyIssuanceNote?: Maybe<RoomKeyIssuanceNote>;
  /** An edge for our `RoomKeyIssuanceNote`. May be used by Relay 1. */
  roomKeyIssuanceNoteEdge?: Maybe<RoomKeyIssuanceNotesEdge>;
};


/** The output of our update `RoomKeyIssuanceNote` mutation. */
export type UpdateRoomKeyIssuanceNotePayloadRoomKeyIssuanceNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomKeyIssuanceNotesOrderBy>>;
};

/** The output of our update `RoomKeyIssuance` mutation. */
export type UpdateRoomKeyIssuancePayload = {
  __typename?: 'UpdateRoomKeyIssuancePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomKeyIssuance`. */
  room?: Maybe<Room>;
  /** The `RoomKeyIssuance` that was updated by this mutation. */
  roomKeyIssuance?: Maybe<RoomKeyIssuance>;
  /** An edge for our `RoomKeyIssuance`. May be used by Relay 1. */
  roomKeyIssuanceEdge?: Maybe<RoomKeyIssuancesEdge>;
};


/** The output of our update `RoomKeyIssuance` mutation. */
export type UpdateRoomKeyIssuancePayloadRoomKeyIssuanceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomKeyIssuancesOrderBy>>;
};

/** All input for the `updateRoomLightShutter` mutation. */
export type UpdateRoomLightShutterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomLightShutter` being updated. */
  patch: RoomLightShutterPatch;
};

/** The output of our update `RoomLightShutter` mutation. */
export type UpdateRoomLightShutterPayload = {
  __typename?: 'UpdateRoomLightShutterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomLightShutter`. */
  room?: Maybe<Room>;
  /** The `RoomLightShutter` that was updated by this mutation. */
  roomLightShutter?: Maybe<RoomLightShutter>;
  /** An edge for our `RoomLightShutter`. May be used by Relay 1. */
  roomLightShutterEdge?: Maybe<RoomLightShuttersEdge>;
};


/** The output of our update `RoomLightShutter` mutation. */
export type UpdateRoomLightShutterPayloadRoomLightShutterEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomLightShuttersOrderBy>>;
};

/** All input for the `updateRoomMaxLoadCeiling` mutation. */
export type UpdateRoomMaxLoadCeilingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomMaxLoadCeiling` being updated. */
  patch: RoomMaxLoadCeilingPatch;
};

/** The output of our update `RoomMaxLoadCeiling` mutation. */
export type UpdateRoomMaxLoadCeilingPayload = {
  __typename?: 'UpdateRoomMaxLoadCeilingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomMaxLoadCeiling`. */
  room?: Maybe<Room>;
  /** The `RoomMaxLoadCeiling` that was updated by this mutation. */
  roomMaxLoadCeiling?: Maybe<RoomMaxLoadCeiling>;
  /** An edge for our `RoomMaxLoadCeiling`. May be used by Relay 1. */
  roomMaxLoadCeilingEdge?: Maybe<RoomMaxLoadCeilingsEdge>;
};


/** The output of our update `RoomMaxLoadCeiling` mutation. */
export type UpdateRoomMaxLoadCeilingPayloadRoomMaxLoadCeilingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomMaxLoadCeilingsOrderBy>>;
};

/** All input for the `updateRoomMaxLoadFloor` mutation. */
export type UpdateRoomMaxLoadFloorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomMaxLoadFloor` being updated. */
  patch: RoomMaxLoadFloorPatch;
};

/** The output of our update `RoomMaxLoadFloor` mutation. */
export type UpdateRoomMaxLoadFloorPayload = {
  __typename?: 'UpdateRoomMaxLoadFloorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomMaxLoadFloor`. */
  room?: Maybe<Room>;
  /** The `RoomMaxLoadFloor` that was updated by this mutation. */
  roomMaxLoadFloor?: Maybe<RoomMaxLoadFloor>;
  /** An edge for our `RoomMaxLoadFloor`. May be used by Relay 1. */
  roomMaxLoadFloorEdge?: Maybe<RoomMaxLoadFloorsEdge>;
};


/** The output of our update `RoomMaxLoadFloor` mutation. */
export type UpdateRoomMaxLoadFloorPayloadRoomMaxLoadFloorEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomMaxLoadFloorsOrderBy>>;
};

/** All input for the `updateRoomNameExtra` mutation. */
export type UpdateRoomNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameExtra` being updated. */
  patch: RoomNameExtraPatch;
};

/** The output of our update `RoomNameExtra` mutation. */
export type UpdateRoomNameExtraPayload = {
  __typename?: 'UpdateRoomNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameExtra`. */
  room?: Maybe<Room>;
  /** The `RoomNameExtra` that was updated by this mutation. */
  roomNameExtra?: Maybe<RoomNameExtra>;
  /** An edge for our `RoomNameExtra`. May be used by Relay 1. */
  roomNameExtraEdge?: Maybe<RoomNameExtrasEdge>;
};


/** The output of our update `RoomNameExtra` mutation. */
export type UpdateRoomNameExtraPayloadRoomNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameExtrasOrderBy>>;
};

/** All input for the `updateRoomNameKeyCad` mutation. */
export type UpdateRoomNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameKeyCad` being updated. */
  patch: RoomNameKeyCadPatch;
};

/** The output of our update `RoomNameKeyCad` mutation. */
export type UpdateRoomNameKeyCadPayload = {
  __typename?: 'UpdateRoomNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyCad`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyCad` that was updated by this mutation. */
  roomNameKeyCad?: Maybe<RoomNameKeyCad>;
  /** An edge for our `RoomNameKeyCad`. May be used by Relay 1. */
  roomNameKeyCadEdge?: Maybe<RoomNameKeyCadsEdge>;
};


/** The output of our update `RoomNameKeyCad` mutation. */
export type UpdateRoomNameKeyCadPayloadRoomNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyCadsOrderBy>>;
};

/** All input for the `updateRoomNameKeyCafm` mutation. */
export type UpdateRoomNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameKeyCafm` being updated. */
  patch: RoomNameKeyCafmPatch;
};

/** The output of our update `RoomNameKeyCafm` mutation. */
export type UpdateRoomNameKeyCafmPayload = {
  __typename?: 'UpdateRoomNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyCafm`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyCafm` that was updated by this mutation. */
  roomNameKeyCafm?: Maybe<RoomNameKeyCafm>;
  /** An edge for our `RoomNameKeyCafm`. May be used by Relay 1. */
  roomNameKeyCafmEdge?: Maybe<RoomNameKeyCafmsEdge>;
};


/** The output of our update `RoomNameKeyCafm` mutation. */
export type UpdateRoomNameKeyCafmPayloadRoomNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyCafmsOrderBy>>;
};

/** All input for the `updateRoomNameKeyEbm` mutation. */
export type UpdateRoomNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameKeyEbm` being updated. */
  patch: RoomNameKeyEbmPatch;
};

/** The output of our update `RoomNameKeyEbm` mutation. */
export type UpdateRoomNameKeyEbmPayload = {
  __typename?: 'UpdateRoomNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyEbm`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyEbm` that was updated by this mutation. */
  roomNameKeyEbm?: Maybe<RoomNameKeyEbm>;
  /** An edge for our `RoomNameKeyEbm`. May be used by Relay 1. */
  roomNameKeyEbmEdge?: Maybe<RoomNameKeyEbmsEdge>;
};


/** The output of our update `RoomNameKeyEbm` mutation. */
export type UpdateRoomNameKeyEbmPayloadRoomNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyEbmsOrderBy>>;
};

/** All input for the `updateRoomNameKeyMarketing` mutation. */
export type UpdateRoomNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameKeyMarketing` being updated. */
  patch: RoomNameKeyMarketingPatch;
};

/** The output of our update `RoomNameKeyMarketing` mutation. */
export type UpdateRoomNameKeyMarketingPayload = {
  __typename?: 'UpdateRoomNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameKeyMarketing`. */
  room?: Maybe<Room>;
  /** The `RoomNameKeyMarketing` that was updated by this mutation. */
  roomNameKeyMarketing?: Maybe<RoomNameKeyMarketing>;
  /** An edge for our `RoomNameKeyMarketing`. May be used by Relay 1. */
  roomNameKeyMarketingEdge?: Maybe<RoomNameKeyMarketingsEdge>;
};


/** The output of our update `RoomNameKeyMarketing` mutation. */
export type UpdateRoomNameKeyMarketingPayloadRoomNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateRoomNameLong` mutation. */
export type UpdateRoomNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameLong` being updated. */
  patch: RoomNameLongPatch;
};

/** The output of our update `RoomNameLong` mutation. */
export type UpdateRoomNameLongPayload = {
  __typename?: 'UpdateRoomNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameLong`. */
  room?: Maybe<Room>;
  /** The `RoomNameLong` that was updated by this mutation. */
  roomNameLong?: Maybe<RoomNameLong>;
  /** An edge for our `RoomNameLong`. May be used by Relay 1. */
  roomNameLongEdge?: Maybe<RoomNameLongsEdge>;
};


/** The output of our update `RoomNameLong` mutation. */
export type UpdateRoomNameLongPayloadRoomNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameLongsOrderBy>>;
};

/** All input for the `updateRoomNameShort` mutation. */
export type UpdateRoomNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNameShort` being updated. */
  patch: RoomNameShortPatch;
};

/** The output of our update `RoomNameShort` mutation. */
export type UpdateRoomNameShortPayload = {
  __typename?: 'UpdateRoomNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNameShort`. */
  room?: Maybe<Room>;
  /** The `RoomNameShort` that was updated by this mutation. */
  roomNameShort?: Maybe<RoomNameShort>;
  /** An edge for our `RoomNameShort`. May be used by Relay 1. */
  roomNameShortEdge?: Maybe<RoomNameShortsEdge>;
};


/** The output of our update `RoomNameShort` mutation. */
export type UpdateRoomNameShortPayloadRoomNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNameShortsOrderBy>>;
};

/** All input for the `updateRoomNoVehicle` mutation. */
export type UpdateRoomNoVehicleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomNoVehicle` being updated. */
  patch: RoomNoVehiclePatch;
};

/** The output of our update `RoomNoVehicle` mutation. */
export type UpdateRoomNoVehiclePayload = {
  __typename?: 'UpdateRoomNoVehiclePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomNoVehicle`. */
  room?: Maybe<Room>;
  /** The `RoomNoVehicle` that was updated by this mutation. */
  roomNoVehicle?: Maybe<RoomNoVehicle>;
  /** An edge for our `RoomNoVehicle`. May be used by Relay 1. */
  roomNoVehicleEdge?: Maybe<RoomNoVehiclesEdge>;
};


/** The output of our update `RoomNoVehicle` mutation. */
export type UpdateRoomNoVehiclePayloadRoomNoVehicleEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomNoVehiclesOrderBy>>;
};

/** All input for the `updateRoomPartitionByExtId` mutation. */
export type UpdateRoomPartitionByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartition` being updated. */
  patch: RoomPartitionPatch;
};

/** All input for the `updateRoomPartitionByNameShort` mutation. */
export type UpdateRoomPartitionByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `RoomPartition` being updated. */
  patch: RoomPartitionPatch;
};

/** All input for the `updateRoomPartitionCadGrossSpaceMin` mutation. */
export type UpdateRoomPartitionCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadGrossSpaceMin` being updated. */
  patch: RoomPartitionCadGrossSpaceMinPatch;
};

/** The output of our update `RoomPartitionCadGrossSpaceMin` mutation. */
export type UpdateRoomPartitionCadGrossSpaceMinPayload = {
  __typename?: 'UpdateRoomPartitionCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadGrossSpaceMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadGrossSpaceMin` that was updated by this mutation. */
  roomPartitionCadGrossSpaceMin?: Maybe<RoomPartitionCadGrossSpaceMin>;
  /** An edge for our `RoomPartitionCadGrossSpaceMin`. May be used by Relay 1. */
  roomPartitionCadGrossSpaceMinEdge?: Maybe<RoomPartitionCadGrossSpaceMinsEdge>;
};


/** The output of our update `RoomPartitionCadGrossSpaceMin` mutation. */
export type UpdateRoomPartitionCadGrossSpaceMinPayloadRoomPartitionCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `updateRoomPartitionCadHeightMax` mutation. */
export type UpdateRoomPartitionCadHeightMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadHeightMax` being updated. */
  patch: RoomPartitionCadHeightMaxPatch;
};

/** The output of our update `RoomPartitionCadHeightMax` mutation. */
export type UpdateRoomPartitionCadHeightMaxPayload = {
  __typename?: 'UpdateRoomPartitionCadHeightMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadHeightMax` that was updated by this mutation. */
  roomPartitionCadHeightMax?: Maybe<RoomPartitionCadHeightMax>;
  /** An edge for our `RoomPartitionCadHeightMax`. May be used by Relay 1. */
  roomPartitionCadHeightMaxEdge?: Maybe<RoomPartitionCadHeightMaxesEdge>;
};


/** The output of our update `RoomPartitionCadHeightMax` mutation. */
export type UpdateRoomPartitionCadHeightMaxPayloadRoomPartitionCadHeightMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMaxesOrderBy>>;
};

/** All input for the `updateRoomPartitionCadHeightMin` mutation. */
export type UpdateRoomPartitionCadHeightMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadHeightMin` being updated. */
  patch: RoomPartitionCadHeightMinPatch;
};

/** The output of our update `RoomPartitionCadHeightMin` mutation. */
export type UpdateRoomPartitionCadHeightMinPayload = {
  __typename?: 'UpdateRoomPartitionCadHeightMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadHeightMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadHeightMin` that was updated by this mutation. */
  roomPartitionCadHeightMin?: Maybe<RoomPartitionCadHeightMin>;
  /** An edge for our `RoomPartitionCadHeightMin`. May be used by Relay 1. */
  roomPartitionCadHeightMinEdge?: Maybe<RoomPartitionCadHeightMinsEdge>;
};


/** The output of our update `RoomPartitionCadHeightMin` mutation. */
export type UpdateRoomPartitionCadHeightMinPayloadRoomPartitionCadHeightMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadHeightMinsOrderBy>>;
};

/** All input for the `updateRoomPartitionCadLengthMax` mutation. */
export type UpdateRoomPartitionCadLengthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadLengthMax` being updated. */
  patch: RoomPartitionCadLengthMaxPatch;
};

/** The output of our update `RoomPartitionCadLengthMax` mutation. */
export type UpdateRoomPartitionCadLengthMaxPayload = {
  __typename?: 'UpdateRoomPartitionCadLengthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadLengthMax` that was updated by this mutation. */
  roomPartitionCadLengthMax?: Maybe<RoomPartitionCadLengthMax>;
  /** An edge for our `RoomPartitionCadLengthMax`. May be used by Relay 1. */
  roomPartitionCadLengthMaxEdge?: Maybe<RoomPartitionCadLengthMaxesEdge>;
};


/** The output of our update `RoomPartitionCadLengthMax` mutation. */
export type UpdateRoomPartitionCadLengthMaxPayloadRoomPartitionCadLengthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMaxesOrderBy>>;
};

/** All input for the `updateRoomPartitionCadLengthMin` mutation. */
export type UpdateRoomPartitionCadLengthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadLengthMin` being updated. */
  patch: RoomPartitionCadLengthMinPatch;
};

/** The output of our update `RoomPartitionCadLengthMin` mutation. */
export type UpdateRoomPartitionCadLengthMinPayload = {
  __typename?: 'UpdateRoomPartitionCadLengthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadLengthMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadLengthMin` that was updated by this mutation. */
  roomPartitionCadLengthMin?: Maybe<RoomPartitionCadLengthMin>;
  /** An edge for our `RoomPartitionCadLengthMin`. May be used by Relay 1. */
  roomPartitionCadLengthMinEdge?: Maybe<RoomPartitionCadLengthMinsEdge>;
};


/** The output of our update `RoomPartitionCadLengthMin` mutation. */
export type UpdateRoomPartitionCadLengthMinPayloadRoomPartitionCadLengthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadLengthMinsOrderBy>>;
};

/** All input for the `updateRoomPartitionCadWidthMax` mutation. */
export type UpdateRoomPartitionCadWidthMaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadWidthMax` being updated. */
  patch: RoomPartitionCadWidthMaxPatch;
};

/** The output of our update `RoomPartitionCadWidthMax` mutation. */
export type UpdateRoomPartitionCadWidthMaxPayload = {
  __typename?: 'UpdateRoomPartitionCadWidthMaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadWidthMax` that was updated by this mutation. */
  roomPartitionCadWidthMax?: Maybe<RoomPartitionCadWidthMax>;
  /** An edge for our `RoomPartitionCadWidthMax`. May be used by Relay 1. */
  roomPartitionCadWidthMaxEdge?: Maybe<RoomPartitionCadWidthMaxesEdge>;
};


/** The output of our update `RoomPartitionCadWidthMax` mutation. */
export type UpdateRoomPartitionCadWidthMaxPayloadRoomPartitionCadWidthMaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMaxesOrderBy>>;
};

/** All input for the `updateRoomPartitionCadWidthMin` mutation. */
export type UpdateRoomPartitionCadWidthMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCadWidthMin` being updated. */
  patch: RoomPartitionCadWidthMinPatch;
};

/** The output of our update `RoomPartitionCadWidthMin` mutation. */
export type UpdateRoomPartitionCadWidthMinPayload = {
  __typename?: 'UpdateRoomPartitionCadWidthMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCadWidthMin`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCadWidthMin` that was updated by this mutation. */
  roomPartitionCadWidthMin?: Maybe<RoomPartitionCadWidthMin>;
  /** An edge for our `RoomPartitionCadWidthMin`. May be used by Relay 1. */
  roomPartitionCadWidthMinEdge?: Maybe<RoomPartitionCadWidthMinsEdge>;
};


/** The output of our update `RoomPartitionCadWidthMin` mutation. */
export type UpdateRoomPartitionCadWidthMinPayloadRoomPartitionCadWidthMinEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCadWidthMinsOrderBy>>;
};

/** All input for the `updateRoomPartitionCapacityPax` mutation. */
export type UpdateRoomPartitionCapacityPaxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCapacityPax` being updated. */
  patch: RoomPartitionCapacityPaxPatch;
};

/** The output of our update `RoomPartitionCapacityPax` mutation. */
export type UpdateRoomPartitionCapacityPaxPayload = {
  __typename?: 'UpdateRoomPartitionCapacityPaxPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCapacityPax`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCapacityPax` that was updated by this mutation. */
  roomPartitionCapacityPax?: Maybe<RoomPartitionCapacityPax>;
  /** An edge for our `RoomPartitionCapacityPax`. May be used by Relay 1. */
  roomPartitionCapacityPaxEdge?: Maybe<RoomPartitionCapacityPaxesEdge>;
};


/** The output of our update `RoomPartitionCapacityPax` mutation. */
export type UpdateRoomPartitionCapacityPaxPayloadRoomPartitionCapacityPaxEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCapacityPaxesOrderBy>>;
};

/** All input for the `updateRoomPartitionCleaningGrossSpace` mutation. */
export type UpdateRoomPartitionCleaningGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionCleaningGrossSpace` being updated. */
  patch: RoomPartitionCleaningGrossSpacePatch;
};

/** The output of our update `RoomPartitionCleaningGrossSpace` mutation. */
export type UpdateRoomPartitionCleaningGrossSpacePayload = {
  __typename?: 'UpdateRoomPartitionCleaningGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionCleaningGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionCleaningGrossSpace` that was updated by this mutation. */
  roomPartitionCleaningGrossSpace?: Maybe<RoomPartitionCleaningGrossSpace>;
  /** An edge for our `RoomPartitionCleaningGrossSpace`. May be used by Relay 1. */
  roomPartitionCleaningGrossSpaceEdge?: Maybe<RoomPartitionCleaningGrossSpacesEdge>;
};


/** The output of our update `RoomPartitionCleaningGrossSpace` mutation. */
export type UpdateRoomPartitionCleaningGrossSpacePayloadRoomPartitionCleaningGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionCleaningGrossSpacesOrderBy>>;
};

/** All input for the `updateRoomPartitionDescription` mutation. */
export type UpdateRoomPartitionDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionDescription` being updated. */
  patch: RoomPartitionDescriptionPatch;
};

/** The output of our update `RoomPartitionDescription` mutation. */
export type UpdateRoomPartitionDescriptionPayload = {
  __typename?: 'UpdateRoomPartitionDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionDescription`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionDescription` that was updated by this mutation. */
  roomPartitionDescription?: Maybe<RoomPartitionDescription>;
  /** An edge for our `RoomPartitionDescription`. May be used by Relay 1. */
  roomPartitionDescriptionEdge?: Maybe<RoomPartitionDescriptionsEdge>;
};


/** The output of our update `RoomPartitionDescription` mutation. */
export type UpdateRoomPartitionDescriptionPayloadRoomPartitionDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionDescriptionsOrderBy>>;
};

/** All input for the `updateRoomPartition` mutation. */
export type UpdateRoomPartitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartition` being updated. */
  patch: RoomPartitionPatch;
};

/** All input for the `updateRoomPartitionNameExtra` mutation. */
export type UpdateRoomPartitionNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameExtra` being updated. */
  patch: RoomPartitionNameExtraPatch;
};

/** The output of our update `RoomPartitionNameExtra` mutation. */
export type UpdateRoomPartitionNameExtraPayload = {
  __typename?: 'UpdateRoomPartitionNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameExtra`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameExtra` that was updated by this mutation. */
  roomPartitionNameExtra?: Maybe<RoomPartitionNameExtra>;
  /** An edge for our `RoomPartitionNameExtra`. May be used by Relay 1. */
  roomPartitionNameExtraEdge?: Maybe<RoomPartitionNameExtrasEdge>;
};


/** The output of our update `RoomPartitionNameExtra` mutation. */
export type UpdateRoomPartitionNameExtraPayloadRoomPartitionNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameExtrasOrderBy>>;
};

/** All input for the `updateRoomPartitionNameKeyCad` mutation. */
export type UpdateRoomPartitionNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameKeyCad` being updated. */
  patch: RoomPartitionNameKeyCadPatch;
};

/** The output of our update `RoomPartitionNameKeyCad` mutation. */
export type UpdateRoomPartitionNameKeyCadPayload = {
  __typename?: 'UpdateRoomPartitionNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCad`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyCad` that was updated by this mutation. */
  roomPartitionNameKeyCad?: Maybe<RoomPartitionNameKeyCad>;
  /** An edge for our `RoomPartitionNameKeyCad`. May be used by Relay 1. */
  roomPartitionNameKeyCadEdge?: Maybe<RoomPartitionNameKeyCadsEdge>;
};


/** The output of our update `RoomPartitionNameKeyCad` mutation. */
export type UpdateRoomPartitionNameKeyCadPayloadRoomPartitionNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCadsOrderBy>>;
};

/** All input for the `updateRoomPartitionNameKeyCafm` mutation. */
export type UpdateRoomPartitionNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameKeyCafm` being updated. */
  patch: RoomPartitionNameKeyCafmPatch;
};

/** The output of our update `RoomPartitionNameKeyCafm` mutation. */
export type UpdateRoomPartitionNameKeyCafmPayload = {
  __typename?: 'UpdateRoomPartitionNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyCafm`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyCafm` that was updated by this mutation. */
  roomPartitionNameKeyCafm?: Maybe<RoomPartitionNameKeyCafm>;
  /** An edge for our `RoomPartitionNameKeyCafm`. May be used by Relay 1. */
  roomPartitionNameKeyCafmEdge?: Maybe<RoomPartitionNameKeyCafmsEdge>;
};


/** The output of our update `RoomPartitionNameKeyCafm` mutation. */
export type UpdateRoomPartitionNameKeyCafmPayloadRoomPartitionNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyCafmsOrderBy>>;
};

/** All input for the `updateRoomPartitionNameKeyEbm` mutation. */
export type UpdateRoomPartitionNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameKeyEbm` being updated. */
  patch: RoomPartitionNameKeyEbmPatch;
};

/** The output of our update `RoomPartitionNameKeyEbm` mutation. */
export type UpdateRoomPartitionNameKeyEbmPayload = {
  __typename?: 'UpdateRoomPartitionNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyEbm`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyEbm` that was updated by this mutation. */
  roomPartitionNameKeyEbm?: Maybe<RoomPartitionNameKeyEbm>;
  /** An edge for our `RoomPartitionNameKeyEbm`. May be used by Relay 1. */
  roomPartitionNameKeyEbmEdge?: Maybe<RoomPartitionNameKeyEbmsEdge>;
};


/** The output of our update `RoomPartitionNameKeyEbm` mutation. */
export type UpdateRoomPartitionNameKeyEbmPayloadRoomPartitionNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyEbmsOrderBy>>;
};

/** All input for the `updateRoomPartitionNameKeyMarketing` mutation. */
export type UpdateRoomPartitionNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameKeyMarketing` being updated. */
  patch: RoomPartitionNameKeyMarketingPatch;
};

/** The output of our update `RoomPartitionNameKeyMarketing` mutation. */
export type UpdateRoomPartitionNameKeyMarketingPayload = {
  __typename?: 'UpdateRoomPartitionNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameKeyMarketing`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameKeyMarketing` that was updated by this mutation. */
  roomPartitionNameKeyMarketing?: Maybe<RoomPartitionNameKeyMarketing>;
  /** An edge for our `RoomPartitionNameKeyMarketing`. May be used by Relay 1. */
  roomPartitionNameKeyMarketingEdge?: Maybe<RoomPartitionNameKeyMarketingsEdge>;
};


/** The output of our update `RoomPartitionNameKeyMarketing` mutation. */
export type UpdateRoomPartitionNameKeyMarketingPayloadRoomPartitionNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateRoomPartitionNameLong` mutation. */
export type UpdateRoomPartitionNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameLong` being updated. */
  patch: RoomPartitionNameLongPatch;
};

/** The output of our update `RoomPartitionNameLong` mutation. */
export type UpdateRoomPartitionNameLongPayload = {
  __typename?: 'UpdateRoomPartitionNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameLong`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameLong` that was updated by this mutation. */
  roomPartitionNameLong?: Maybe<RoomPartitionNameLong>;
  /** An edge for our `RoomPartitionNameLong`. May be used by Relay 1. */
  roomPartitionNameLongEdge?: Maybe<RoomPartitionNameLongsEdge>;
};


/** The output of our update `RoomPartitionNameLong` mutation. */
export type UpdateRoomPartitionNameLongPayloadRoomPartitionNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameLongsOrderBy>>;
};

/** All input for the `updateRoomPartitionNameShort` mutation. */
export type UpdateRoomPartitionNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionNameShort` being updated. */
  patch: RoomPartitionNameShortPatch;
};

/** The output of our update `RoomPartitionNameShort` mutation. */
export type UpdateRoomPartitionNameShortPayload = {
  __typename?: 'UpdateRoomPartitionNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionNameShort`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionNameShort` that was updated by this mutation. */
  roomPartitionNameShort?: Maybe<RoomPartitionNameShort>;
  /** An edge for our `RoomPartitionNameShort`. May be used by Relay 1. */
  roomPartitionNameShortEdge?: Maybe<RoomPartitionNameShortsEdge>;
};


/** The output of our update `RoomPartitionNameShort` mutation. */
export type UpdateRoomPartitionNameShortPayloadRoomPartitionNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionNameShortsOrderBy>>;
};

/** The output of our update `RoomPartition` mutation. */
export type UpdateRoomPartitionPayload = {
  __typename?: 'UpdateRoomPartitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPartition`. */
  room?: Maybe<Room>;
  /** The `RoomPartition` that was updated by this mutation. */
  roomPartition?: Maybe<RoomPartition>;
  /** An edge for our `RoomPartition`. May be used by Relay 1. */
  roomPartitionEdge?: Maybe<RoomPartitionsEdge>;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartition`. */
  type?: Maybe<RoomPartitionType>;
};


/** The output of our update `RoomPartition` mutation. */
export type UpdateRoomPartitionPayloadRoomPartitionEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionsOrderBy>>;
};

/** All input for the `updateRoomPartitionPublicGrossSpace` mutation. */
export type UpdateRoomPartitionPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionPublicGrossSpace` being updated. */
  patch: RoomPartitionPublicGrossSpacePatch;
};

/** The output of our update `RoomPartitionPublicGrossSpace` mutation. */
export type UpdateRoomPartitionPublicGrossSpacePayload = {
  __typename?: 'UpdateRoomPartitionPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionPublicGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionPublicGrossSpace` that was updated by this mutation. */
  roomPartitionPublicGrossSpace?: Maybe<RoomPartitionPublicGrossSpace>;
  /** An edge for our `RoomPartitionPublicGrossSpace`. May be used by Relay 1. */
  roomPartitionPublicGrossSpaceEdge?: Maybe<RoomPartitionPublicGrossSpacesEdge>;
};


/** The output of our update `RoomPartitionPublicGrossSpace` mutation. */
export type UpdateRoomPartitionPublicGrossSpacePayloadRoomPartitionPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionPublicGrossSpacesOrderBy>>;
};

/** All input for the `updateRoomPartitionSbvGrossSpace` mutation. */
export type UpdateRoomPartitionSbvGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionSbvGrossSpace` being updated. */
  patch: RoomPartitionSbvGrossSpacePatch;
};

/** The output of our update `RoomPartitionSbvGrossSpace` mutation. */
export type UpdateRoomPartitionSbvGrossSpacePayload = {
  __typename?: 'UpdateRoomPartitionSbvGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionSbvGrossSpace`. */
  roomPartition?: Maybe<RoomPartition>;
  /** The `RoomPartitionSbvGrossSpace` that was updated by this mutation. */
  roomPartitionSbvGrossSpace?: Maybe<RoomPartitionSbvGrossSpace>;
  /** An edge for our `RoomPartitionSbvGrossSpace`. May be used by Relay 1. */
  roomPartitionSbvGrossSpaceEdge?: Maybe<RoomPartitionSbvGrossSpacesEdge>;
};


/** The output of our update `RoomPartitionSbvGrossSpace` mutation. */
export type UpdateRoomPartitionSbvGrossSpacePayloadRoomPartitionSbvGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionSbvGrossSpacesOrderBy>>;
};

/** All input for the `updateRoomPartitionTypeAttr` mutation. */
export type UpdateRoomPartitionTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionTypeAttr` being updated. */
  patch: RoomPartitionTypeAttrPatch;
};

/** The output of our update `RoomPartitionTypeAttr` mutation. */
export type UpdateRoomPartitionTypeAttrPayload = {
  __typename?: 'UpdateRoomPartitionTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoomPartition` that is related to this `RoomPartitionTypeAttr`. */
  roomPartition?: Maybe<RoomPartition>;
  /** Reads a single `RoomPartitionType` that is related to this `RoomPartitionTypeAttr`. */
  roomPartitionType?: Maybe<RoomPartitionType>;
  /** The `RoomPartitionTypeAttr` that was updated by this mutation. */
  roomPartitionTypeAttr?: Maybe<RoomPartitionTypeAttr>;
  /** An edge for our `RoomPartitionTypeAttr`. May be used by Relay 1. */
  roomPartitionTypeAttrEdge?: Maybe<RoomPartitionTypeAttrsEdge>;
};


/** The output of our update `RoomPartitionTypeAttr` mutation. */
export type UpdateRoomPartitionTypeAttrPayloadRoomPartitionTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionTypeAttrsOrderBy>>;
};

/** All input for the `updateRoomPartitionTypeByName` mutation. */
export type UpdateRoomPartitionTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `RoomPartitionType` being updated. */
  patch: RoomPartitionTypePatch;
};

/** All input for the `updateRoomPartitionType` mutation. */
export type UpdateRoomPartitionTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPartitionType` being updated. */
  patch: RoomPartitionTypePatch;
};

/** The output of our update `RoomPartitionType` mutation. */
export type UpdateRoomPartitionTypePayload = {
  __typename?: 'UpdateRoomPartitionTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoomPartitionType` that was updated by this mutation. */
  roomPartitionType?: Maybe<RoomPartitionType>;
  /** An edge for our `RoomPartitionType`. May be used by Relay 1. */
  roomPartitionTypeEdge?: Maybe<RoomPartitionTypesEdge>;
};


/** The output of our update `RoomPartitionType` mutation. */
export type UpdateRoomPartitionTypePayloadRoomPartitionTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPartitionTypesOrderBy>>;
};

/** The output of our update `Room` mutation. */
export type UpdateRoomPayload = {
  __typename?: 'UpdateRoomPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Level` that is related to this `Room`. */
  level?: Maybe<Level>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Room` that was updated by this mutation. */
  room?: Maybe<Room>;
  /** An edge for our `Room`. May be used by Relay 1. */
  roomEdge?: Maybe<RoomsEdge>;
  /** Reads a single `RoomType` that is related to this `Room`. */
  type?: Maybe<RoomType>;
};


/** The output of our update `Room` mutation. */
export type UpdateRoomPayloadRoomEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomsOrderBy>>;
};

/** All input for the `updateRoomPhoneNumber` mutation. */
export type UpdateRoomPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPhoneNumber` being updated. */
  patch: RoomPhoneNumberPatch;
};

/** The output of our update `RoomPhoneNumber` mutation. */
export type UpdateRoomPhoneNumberPayload = {
  __typename?: 'UpdateRoomPhoneNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPhoneNumber`. */
  room?: Maybe<Room>;
  /** The `RoomPhoneNumber` that was updated by this mutation. */
  roomPhoneNumber?: Maybe<RoomPhoneNumber>;
  /** An edge for our `RoomPhoneNumber`. May be used by Relay 1. */
  roomPhoneNumberEdge?: Maybe<RoomPhoneNumbersEdge>;
};


/** The output of our update `RoomPhoneNumber` mutation. */
export type UpdateRoomPhoneNumberPayloadRoomPhoneNumberEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPhoneNumbersOrderBy>>;
};

/** All input for the `updateRoomPublicGrossSpace` mutation. */
export type UpdateRoomPublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomPublicGrossSpace` being updated. */
  patch: RoomPublicGrossSpacePatch;
};

/** The output of our update `RoomPublicGrossSpace` mutation. */
export type UpdateRoomPublicGrossSpacePayload = {
  __typename?: 'UpdateRoomPublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomPublicGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomPublicGrossSpace` that was updated by this mutation. */
  roomPublicGrossSpace?: Maybe<RoomPublicGrossSpace>;
  /** An edge for our `RoomPublicGrossSpace`. May be used by Relay 1. */
  roomPublicGrossSpaceEdge?: Maybe<RoomPublicGrossSpacesEdge>;
};


/** The output of our update `RoomPublicGrossSpace` mutation. */
export type UpdateRoomPublicGrossSpacePayloadRoomPublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomPublicGrossSpacesOrderBy>>;
};

/** All input for the `updateRoomSbvGrossSpace` mutation. */
export type UpdateRoomSbvGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomSbvGrossSpace` being updated. */
  patch: RoomSbvGrossSpacePatch;
};

/** The output of our update `RoomSbvGrossSpace` mutation. */
export type UpdateRoomSbvGrossSpacePayload = {
  __typename?: 'UpdateRoomSbvGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomSbvGrossSpace`. */
  room?: Maybe<Room>;
  /** The `RoomSbvGrossSpace` that was updated by this mutation. */
  roomSbvGrossSpace?: Maybe<RoomSbvGrossSpace>;
  /** An edge for our `RoomSbvGrossSpace`. May be used by Relay 1. */
  roomSbvGrossSpaceEdge?: Maybe<RoomSbvGrossSpacesEdge>;
};


/** The output of our update `RoomSbvGrossSpace` mutation. */
export type UpdateRoomSbvGrossSpacePayloadRoomSbvGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomSbvGrossSpacesOrderBy>>;
};

/** All input for the `updateRoomTireLoadCar` mutation. */
export type UpdateRoomTireLoadCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomTireLoadCar` being updated. */
  patch: RoomTireLoadCarPatch;
};

/** The output of our update `RoomTireLoadCar` mutation. */
export type UpdateRoomTireLoadCarPayload = {
  __typename?: 'UpdateRoomTireLoadCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadCar`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadCar` that was updated by this mutation. */
  roomTireLoadCar?: Maybe<RoomTireLoadCar>;
  /** An edge for our `RoomTireLoadCar`. May be used by Relay 1. */
  roomTireLoadCarEdge?: Maybe<RoomTireLoadCarsEdge>;
};


/** The output of our update `RoomTireLoadCar` mutation. */
export type UpdateRoomTireLoadCarPayloadRoomTireLoadCarEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadCarsOrderBy>>;
};

/** All input for the `updateRoomTireLoadForklift` mutation. */
export type UpdateRoomTireLoadForkliftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomTireLoadForklift` being updated. */
  patch: RoomTireLoadForkliftPatch;
};

/** The output of our update `RoomTireLoadForklift` mutation. */
export type UpdateRoomTireLoadForkliftPayload = {
  __typename?: 'UpdateRoomTireLoadForkliftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadForklift`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadForklift` that was updated by this mutation. */
  roomTireLoadForklift?: Maybe<RoomTireLoadForklift>;
  /** An edge for our `RoomTireLoadForklift`. May be used by Relay 1. */
  roomTireLoadForkliftEdge?: Maybe<RoomTireLoadForkliftsEdge>;
};


/** The output of our update `RoomTireLoadForklift` mutation. */
export type UpdateRoomTireLoadForkliftPayloadRoomTireLoadForkliftEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadForkliftsOrderBy>>;
};

/** All input for the `updateRoomTireLoadTruck` mutation. */
export type UpdateRoomTireLoadTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomTireLoadTruck` being updated. */
  patch: RoomTireLoadTruckPatch;
};

/** The output of our update `RoomTireLoadTruck` mutation. */
export type UpdateRoomTireLoadTruckPayload = {
  __typename?: 'UpdateRoomTireLoadTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTireLoadTruck`. */
  room?: Maybe<Room>;
  /** The `RoomTireLoadTruck` that was updated by this mutation. */
  roomTireLoadTruck?: Maybe<RoomTireLoadTruck>;
  /** An edge for our `RoomTireLoadTruck`. May be used by Relay 1. */
  roomTireLoadTruckEdge?: Maybe<RoomTireLoadTrucksEdge>;
};


/** The output of our update `RoomTireLoadTruck` mutation. */
export type UpdateRoomTireLoadTruckPayloadRoomTireLoadTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTireLoadTrucksOrderBy>>;
};

/** All input for the `updateRoomTypeAttr` mutation. */
export type UpdateRoomTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomTypeAttr` being updated. */
  patch: RoomTypeAttrPatch;
};

/** The output of our update `RoomTypeAttr` mutation. */
export type UpdateRoomTypeAttrPayload = {
  __typename?: 'UpdateRoomTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Room` that is related to this `RoomTypeAttr`. */
  room?: Maybe<Room>;
  /** Reads a single `RoomType` that is related to this `RoomTypeAttr`. */
  roomType?: Maybe<RoomType>;
  /** The `RoomTypeAttr` that was updated by this mutation. */
  roomTypeAttr?: Maybe<RoomTypeAttr>;
  /** An edge for our `RoomTypeAttr`. May be used by Relay 1. */
  roomTypeAttrEdge?: Maybe<RoomTypeAttrsEdge>;
};


/** The output of our update `RoomTypeAttr` mutation. */
export type UpdateRoomTypeAttrPayloadRoomTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTypeAttrsOrderBy>>;
};

/** All input for the `updateRoomTypeByName` mutation. */
export type UpdateRoomTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `RoomType` being updated. */
  patch: RoomTypePatch;
};

/** All input for the `updateRoomType` mutation. */
export type UpdateRoomTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoomType` being updated. */
  patch: RoomTypePatch;
};

/** The output of our update `RoomType` mutation. */
export type UpdateRoomTypePayload = {
  __typename?: 'UpdateRoomTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoomType` that was updated by this mutation. */
  roomType?: Maybe<RoomType>;
  /** An edge for our `RoomType`. May be used by Relay 1. */
  roomTypeEdge?: Maybe<RoomTypesEdge>;
};


/** The output of our update `RoomType` mutation. */
export type UpdateRoomTypePayloadRoomTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<RoomTypesOrderBy>>;
};

/** All input for the `updateScenarioByNameShort` mutation. */
export type UpdateScenarioByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Scenario` being updated. */
  patch: ScenarioPatch;
};

/** All input for the `updateScenarioGroupByNameShort` mutation. */
export type UpdateScenarioGroupByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `ScenarioGroup` being updated. */
  patch: ScenarioGroupPatch;
};

/** All input for the `updateScenarioGroup` mutation. */
export type UpdateScenarioGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ScenarioGroup` being updated. */
  patch: ScenarioGroupPatch;
};

/** The output of our update `ScenarioGroup` mutation. */
export type UpdateScenarioGroupPayload = {
  __typename?: 'UpdateScenarioGroupPayload';
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Feed` that is related to this `ScenarioGroup`. */
  organisationalChanges?: Maybe<Feed>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScenarioGroup` that was updated by this mutation. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  /** An edge for our `ScenarioGroup`. May be used by Relay 1. */
  scenarioGroupEdge?: Maybe<ScenarioGroupsEdge>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScenarioGroup`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our update `ScenarioGroup` mutation. */
export type UpdateScenarioGroupPayloadScenarioGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};

/** All input for the `updateScenario` mutation. */
export type UpdateScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Scenario` being updated. */
  patch: ScenarioPatch;
};

/** The output of our update `Scenario` mutation. */
export type UpdateScenarioPayload = {
  __typename?: 'UpdateScenarioPayload';
  /** Reads a single `Feed` that is related to this `Scenario`. */
  changes?: Maybe<Feed>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Scenario` that was updated by this mutation. */
  scenario?: Maybe<Scenario>;
  /** An edge for our `Scenario`. May be used by Relay 1. */
  scenarioEdge?: Maybe<ScenariosEdge>;
  /** Reads a single `ScenarioGroup` that is related to this `Scenario`. */
  scenarioGroup?: Maybe<ScenarioGroup>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our update `Scenario` mutation. */
export type UpdateScenarioPayloadScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** All input for the `updateScenarioSetting` mutation. */
export type UpdateScenarioSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ScenarioSetting` being updated. */
  patch: ScenarioSettingPatch;
  scenarioId: Scalars['UUID'];
};

/** The output of our update `ScenarioSetting` mutation. */
export type UpdateScenarioSettingPayload = {
  __typename?: 'UpdateScenarioSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Scenario` that is related to this `ScenarioSetting`. */
  scenario?: Maybe<Scenario>;
  /** The `ScenarioSetting` that was updated by this mutation. */
  scenarioSetting?: Maybe<ScenarioSetting>;
  /** An edge for our `ScenarioSetting`. May be used by Relay 1. */
  scenarioSettingEdge?: Maybe<ScenarioSettingsEdge>;
};


/** The output of our update `ScenarioSetting` mutation. */
export type UpdateScenarioSettingPayloadScenarioSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioSettingsOrderBy>>;
};

/** All input for the `updateScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantType` mutation. */
export type UpdateScenarioVariantVisibilityByScenarioIdAndVariantIdAndVariantTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ScenarioVariantVisibility` being updated. */
  patch: ScenarioVariantVisibilityPatch;
  scenarioId: Scalars['UUID'];
  variantId: Scalars['UUID'];
  variantType: VariantType;
};

/** All input for the `updateScenarioVariantVisibility` mutation. */
export type UpdateScenarioVariantVisibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ScenarioVariantVisibility` being updated. */
  patch: ScenarioVariantVisibilityPatch;
};

/** The output of our update `ScenarioVariantVisibility` mutation. */
export type UpdateScenarioVariantVisibilityPayload = {
  __typename?: 'UpdateScenarioVariantVisibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Scenario` that is related to this `ScenarioVariantVisibility`. */
  scenario?: Maybe<Scenario>;
  /** The `ScenarioVariantVisibility` that was updated by this mutation. */
  scenarioVariantVisibility?: Maybe<ScenarioVariantVisibility>;
  /** An edge for our `ScenarioVariantVisibility`. May be used by Relay 1. */
  scenarioVariantVisibilityEdge?: Maybe<ScenarioVariantVisibilitiesEdge>;
};


/** The output of our update `ScenarioVariantVisibility` mutation. */
export type UpdateScenarioVariantVisibilityPayloadScenarioVariantVisibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenarioVariantVisibilitiesOrderBy>>;
};

/** All input for the `updateSiteByExtId` mutation. */
export type UpdateSiteByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Site` being updated. */
  patch: SitePatch;
};

/** All input for the `updateSiteByNameShort` mutation. */
export type UpdateSiteByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Site` being updated. */
  patch: SitePatch;
};

/** All input for the `updateSiteDescription` mutation. */
export type UpdateSiteDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteDescription` being updated. */
  patch: SiteDescriptionPatch;
};

/** The output of our update `SiteDescription` mutation. */
export type UpdateSiteDescriptionPayload = {
  __typename?: 'UpdateSiteDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteDescription`. */
  site?: Maybe<Site>;
  /** The `SiteDescription` that was updated by this mutation. */
  siteDescription?: Maybe<SiteDescription>;
  /** An edge for our `SiteDescription`. May be used by Relay 1. */
  siteDescriptionEdge?: Maybe<SiteDescriptionsEdge>;
};


/** The output of our update `SiteDescription` mutation. */
export type UpdateSiteDescriptionPayloadSiteDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteDescriptionsOrderBy>>;
};

/** All input for the `updateSite` mutation. */
export type UpdateSiteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Site` being updated. */
  patch: SitePatch;
};

/** All input for the `updateSiteNameExtra` mutation. */
export type UpdateSiteNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameExtra` being updated. */
  patch: SiteNameExtraPatch;
};

/** The output of our update `SiteNameExtra` mutation. */
export type UpdateSiteNameExtraPayload = {
  __typename?: 'UpdateSiteNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameExtra`. */
  site?: Maybe<Site>;
  /** The `SiteNameExtra` that was updated by this mutation. */
  siteNameExtra?: Maybe<SiteNameExtra>;
  /** An edge for our `SiteNameExtra`. May be used by Relay 1. */
  siteNameExtraEdge?: Maybe<SiteNameExtrasEdge>;
};


/** The output of our update `SiteNameExtra` mutation. */
export type UpdateSiteNameExtraPayloadSiteNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameExtrasOrderBy>>;
};

/** All input for the `updateSiteNameKeyCad` mutation. */
export type UpdateSiteNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameKeyCad` being updated. */
  patch: SiteNameKeyCadPatch;
};

/** The output of our update `SiteNameKeyCad` mutation. */
export type UpdateSiteNameKeyCadPayload = {
  __typename?: 'UpdateSiteNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyCad`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyCad` that was updated by this mutation. */
  siteNameKeyCad?: Maybe<SiteNameKeyCad>;
  /** An edge for our `SiteNameKeyCad`. May be used by Relay 1. */
  siteNameKeyCadEdge?: Maybe<SiteNameKeyCadsEdge>;
};


/** The output of our update `SiteNameKeyCad` mutation. */
export type UpdateSiteNameKeyCadPayloadSiteNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyCadsOrderBy>>;
};

/** All input for the `updateSiteNameKeyCafm` mutation. */
export type UpdateSiteNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameKeyCafm` being updated. */
  patch: SiteNameKeyCafmPatch;
};

/** The output of our update `SiteNameKeyCafm` mutation. */
export type UpdateSiteNameKeyCafmPayload = {
  __typename?: 'UpdateSiteNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyCafm`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyCafm` that was updated by this mutation. */
  siteNameKeyCafm?: Maybe<SiteNameKeyCafm>;
  /** An edge for our `SiteNameKeyCafm`. May be used by Relay 1. */
  siteNameKeyCafmEdge?: Maybe<SiteNameKeyCafmsEdge>;
};


/** The output of our update `SiteNameKeyCafm` mutation. */
export type UpdateSiteNameKeyCafmPayloadSiteNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyCafmsOrderBy>>;
};

/** All input for the `updateSiteNameKeyEbm` mutation. */
export type UpdateSiteNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameKeyEbm` being updated. */
  patch: SiteNameKeyEbmPatch;
};

/** The output of our update `SiteNameKeyEbm` mutation. */
export type UpdateSiteNameKeyEbmPayload = {
  __typename?: 'UpdateSiteNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyEbm`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyEbm` that was updated by this mutation. */
  siteNameKeyEbm?: Maybe<SiteNameKeyEbm>;
  /** An edge for our `SiteNameKeyEbm`. May be used by Relay 1. */
  siteNameKeyEbmEdge?: Maybe<SiteNameKeyEbmsEdge>;
};


/** The output of our update `SiteNameKeyEbm` mutation. */
export type UpdateSiteNameKeyEbmPayloadSiteNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyEbmsOrderBy>>;
};

/** All input for the `updateSiteNameKeyMarketing` mutation. */
export type UpdateSiteNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameKeyMarketing` being updated. */
  patch: SiteNameKeyMarketingPatch;
};

/** The output of our update `SiteNameKeyMarketing` mutation. */
export type UpdateSiteNameKeyMarketingPayload = {
  __typename?: 'UpdateSiteNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameKeyMarketing`. */
  site?: Maybe<Site>;
  /** The `SiteNameKeyMarketing` that was updated by this mutation. */
  siteNameKeyMarketing?: Maybe<SiteNameKeyMarketing>;
  /** An edge for our `SiteNameKeyMarketing`. May be used by Relay 1. */
  siteNameKeyMarketingEdge?: Maybe<SiteNameKeyMarketingsEdge>;
};


/** The output of our update `SiteNameKeyMarketing` mutation. */
export type UpdateSiteNameKeyMarketingPayloadSiteNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateSiteNameLong` mutation. */
export type UpdateSiteNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameLong` being updated. */
  patch: SiteNameLongPatch;
};

/** The output of our update `SiteNameLong` mutation. */
export type UpdateSiteNameLongPayload = {
  __typename?: 'UpdateSiteNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameLong`. */
  site?: Maybe<Site>;
  /** The `SiteNameLong` that was updated by this mutation. */
  siteNameLong?: Maybe<SiteNameLong>;
  /** An edge for our `SiteNameLong`. May be used by Relay 1. */
  siteNameLongEdge?: Maybe<SiteNameLongsEdge>;
};


/** The output of our update `SiteNameLong` mutation. */
export type UpdateSiteNameLongPayloadSiteNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameLongsOrderBy>>;
};

/** All input for the `updateSiteNameShort` mutation. */
export type UpdateSiteNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SiteNameShort` being updated. */
  patch: SiteNameShortPatch;
};

/** The output of our update `SiteNameShort` mutation. */
export type UpdateSiteNameShortPayload = {
  __typename?: 'UpdateSiteNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `SiteNameShort`. */
  site?: Maybe<Site>;
  /** The `SiteNameShort` that was updated by this mutation. */
  siteNameShort?: Maybe<SiteNameShort>;
  /** An edge for our `SiteNameShort`. May be used by Relay 1. */
  siteNameShortEdge?: Maybe<SiteNameShortsEdge>;
};


/** The output of our update `SiteNameShort` mutation. */
export type UpdateSiteNameShortPayloadSiteNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<SiteNameShortsOrderBy>>;
};

/** The output of our update `Site` mutation. */
export type UpdateSitePayload = {
  __typename?: 'UpdateSitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Site` that was updated by this mutation. */
  site?: Maybe<Site>;
  /** An edge for our `Site`. May be used by Relay 1. */
  siteEdge?: Maybe<SitesEdge>;
};


/** The output of our update `Site` mutation. */
export type UpdateSitePayloadSiteEdgeArgs = {
  orderBy?: InputMaybe<Array<SitesOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserPasswordLoginByEmail` mutation. */
export type UpdateUserPasswordLoginByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `UserPasswordLogin` being updated. */
  patch: UserPasswordLoginPatch;
};

/** All input for the `updateUserPasswordLoginByUserId` mutation. */
export type UpdateUserPasswordLoginByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UserPasswordLogin` being updated. */
  patch: UserPasswordLoginPatch;
  userId: Scalars['UUID'];
};

/** All input for the `updateUserPasswordLogin` mutation. */
export type UpdateUserPasswordLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserPasswordLogin` being updated. */
  patch: UserPasswordLoginPatch;
};

/** The output of our update `UserPasswordLogin` mutation. */
export type UpdateUserPasswordLoginPayload = {
  __typename?: 'UpdateUserPasswordLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserPasswordLogin`. */
  user?: Maybe<User>;
  /** The `UserPasswordLogin` that was updated by this mutation. */
  userPasswordLogin?: Maybe<UserPasswordLogin>;
  /** An edge for our `UserPasswordLogin`. May be used by Relay 1. */
  userPasswordLoginEdge?: Maybe<UserPasswordLoginsEdge>;
};


/** The output of our update `UserPasswordLogin` mutation. */
export type UpdateUserPasswordLoginPayloadUserPasswordLoginEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPasswordLoginsOrderBy>>;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserSsoLoginByProviderAndOid` mutation. */
export type UpdateUserSsoLoginByProviderAndOidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  /** An object where the defined keys will be set on the `UserSsoLogin` being updated. */
  patch: UserSsoLoginPatch;
  provider: SsoProvider;
};

/** All input for the `updateUserSsoLoginByUserIdAndProvider` mutation. */
export type UpdateUserSsoLoginByUserIdAndProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UserSsoLogin` being updated. */
  patch: UserSsoLoginPatch;
  provider: SsoProvider;
  userId: Scalars['UUID'];
};

/** All input for the `updateUserSsoLogin` mutation. */
export type UpdateUserSsoLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserSsoLogin` being updated. */
  patch: UserSsoLoginPatch;
};

/** The output of our update `UserSsoLogin` mutation. */
export type UpdateUserSsoLoginPayload = {
  __typename?: 'UpdateUserSsoLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSsoLogin`. */
  user?: Maybe<User>;
  /** The `UserSsoLogin` that was updated by this mutation. */
  userSsoLogin?: Maybe<UserSsoLogin>;
  /** An edge for our `UserSsoLogin`. May be used by Relay 1. */
  userSsoLoginEdge?: Maybe<UserSsoLoginsEdge>;
};


/** The output of our update `UserSsoLogin` mutation. */
export type UpdateUserSsoLoginPayloadUserSsoLoginEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSsoLoginsOrderBy>>;
};

/** All input for the `updateZoneByExtId` mutation. */
export type UpdateZoneByExtIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Zone` being updated. */
  patch: ZonePatch;
};

/** All input for the `updateZoneByNameShort` mutation. */
export type UpdateZoneByNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `Zone` being updated. */
  patch: ZonePatch;
};

/** All input for the `updateZoneCadGrossSpaceMin` mutation. */
export type UpdateZoneCadGrossSpaceMinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneCadGrossSpaceMin` being updated. */
  patch: ZoneCadGrossSpaceMinPatch;
};

/** The output of our update `ZoneCadGrossSpaceMin` mutation. */
export type UpdateZoneCadGrossSpaceMinPayload = {
  __typename?: 'UpdateZoneCadGrossSpaceMinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCadGrossSpaceMin`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCadGrossSpaceMin` that was updated by this mutation. */
  zoneCadGrossSpaceMin?: Maybe<ZoneCadGrossSpaceMin>;
  /** An edge for our `ZoneCadGrossSpaceMin`. May be used by Relay 1. */
  zoneCadGrossSpaceMinEdge?: Maybe<ZoneCadGrossSpaceMinsEdge>;
};


/** The output of our update `ZoneCadGrossSpaceMin` mutation. */
export type UpdateZoneCadGrossSpaceMinPayloadZoneCadGrossSpaceMinEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCadGrossSpaceMinsOrderBy>>;
};

/** All input for the `updateZoneCapacityCar` mutation. */
export type UpdateZoneCapacityCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneCapacityCar` being updated. */
  patch: ZoneCapacityCarPatch;
};

/** The output of our update `ZoneCapacityCar` mutation. */
export type UpdateZoneCapacityCarPayload = {
  __typename?: 'UpdateZoneCapacityCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCapacityCar`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCapacityCar` that was updated by this mutation. */
  zoneCapacityCar?: Maybe<ZoneCapacityCar>;
  /** An edge for our `ZoneCapacityCar`. May be used by Relay 1. */
  zoneCapacityCarEdge?: Maybe<ZoneCapacityCarsEdge>;
};


/** The output of our update `ZoneCapacityCar` mutation. */
export type UpdateZoneCapacityCarPayloadZoneCapacityCarEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCapacityCarsOrderBy>>;
};

/** All input for the `updateZoneCapacityTruck` mutation. */
export type UpdateZoneCapacityTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneCapacityTruck` being updated. */
  patch: ZoneCapacityTruckPatch;
};

/** The output of our update `ZoneCapacityTruck` mutation. */
export type UpdateZoneCapacityTruckPayload = {
  __typename?: 'UpdateZoneCapacityTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneCapacityTruck`. */
  zone?: Maybe<Zone>;
  /** The `ZoneCapacityTruck` that was updated by this mutation. */
  zoneCapacityTruck?: Maybe<ZoneCapacityTruck>;
  /** An edge for our `ZoneCapacityTruck`. May be used by Relay 1. */
  zoneCapacityTruckEdge?: Maybe<ZoneCapacityTrucksEdge>;
};


/** The output of our update `ZoneCapacityTruck` mutation. */
export type UpdateZoneCapacityTruckPayloadZoneCapacityTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneCapacityTrucksOrderBy>>;
};

/** All input for the `updateZoneDescription` mutation. */
export type UpdateZoneDescriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneDescription` being updated. */
  patch: ZoneDescriptionPatch;
};

/** The output of our update `ZoneDescription` mutation. */
export type UpdateZoneDescriptionPayload = {
  __typename?: 'UpdateZoneDescriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneDescription`. */
  zone?: Maybe<Zone>;
  /** The `ZoneDescription` that was updated by this mutation. */
  zoneDescription?: Maybe<ZoneDescription>;
  /** An edge for our `ZoneDescription`. May be used by Relay 1. */
  zoneDescriptionEdge?: Maybe<ZoneDescriptionsEdge>;
};


/** The output of our update `ZoneDescription` mutation. */
export type UpdateZoneDescriptionPayloadZoneDescriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneDescriptionsOrderBy>>;
};

/** All input for the `updateZone` mutation. */
export type UpdateZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Zone` being updated. */
  patch: ZonePatch;
};

/** All input for the `updateZoneMaxLoadFloor` mutation. */
export type UpdateZoneMaxLoadFloorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneMaxLoadFloor` being updated. */
  patch: ZoneMaxLoadFloorPatch;
};

/** The output of our update `ZoneMaxLoadFloor` mutation. */
export type UpdateZoneMaxLoadFloorPayload = {
  __typename?: 'UpdateZoneMaxLoadFloorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneMaxLoadFloor`. */
  zone?: Maybe<Zone>;
  /** The `ZoneMaxLoadFloor` that was updated by this mutation. */
  zoneMaxLoadFloor?: Maybe<ZoneMaxLoadFloor>;
  /** An edge for our `ZoneMaxLoadFloor`. May be used by Relay 1. */
  zoneMaxLoadFloorEdge?: Maybe<ZoneMaxLoadFloorsEdge>;
};


/** The output of our update `ZoneMaxLoadFloor` mutation. */
export type UpdateZoneMaxLoadFloorPayloadZoneMaxLoadFloorEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneMaxLoadFloorsOrderBy>>;
};

/** All input for the `updateZoneNameExtra` mutation. */
export type UpdateZoneNameExtraInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameExtra` being updated. */
  patch: ZoneNameExtraPatch;
};

/** The output of our update `ZoneNameExtra` mutation. */
export type UpdateZoneNameExtraPayload = {
  __typename?: 'UpdateZoneNameExtraPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameExtra`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameExtra` that was updated by this mutation. */
  zoneNameExtra?: Maybe<ZoneNameExtra>;
  /** An edge for our `ZoneNameExtra`. May be used by Relay 1. */
  zoneNameExtraEdge?: Maybe<ZoneNameExtrasEdge>;
};


/** The output of our update `ZoneNameExtra` mutation. */
export type UpdateZoneNameExtraPayloadZoneNameExtraEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameExtrasOrderBy>>;
};

/** All input for the `updateZoneNameKeyCad` mutation. */
export type UpdateZoneNameKeyCadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameKeyCad` being updated. */
  patch: ZoneNameKeyCadPatch;
};

/** The output of our update `ZoneNameKeyCad` mutation. */
export type UpdateZoneNameKeyCadPayload = {
  __typename?: 'UpdateZoneNameKeyCadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCad`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyCad` that was updated by this mutation. */
  zoneNameKeyCad?: Maybe<ZoneNameKeyCad>;
  /** An edge for our `ZoneNameKeyCad`. May be used by Relay 1. */
  zoneNameKeyCadEdge?: Maybe<ZoneNameKeyCadsEdge>;
};


/** The output of our update `ZoneNameKeyCad` mutation. */
export type UpdateZoneNameKeyCadPayloadZoneNameKeyCadEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyCadsOrderBy>>;
};

/** All input for the `updateZoneNameKeyCafm` mutation. */
export type UpdateZoneNameKeyCafmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameKeyCafm` being updated. */
  patch: ZoneNameKeyCafmPatch;
};

/** The output of our update `ZoneNameKeyCafm` mutation. */
export type UpdateZoneNameKeyCafmPayload = {
  __typename?: 'UpdateZoneNameKeyCafmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCafm`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyCafm` that was updated by this mutation. */
  zoneNameKeyCafm?: Maybe<ZoneNameKeyCafm>;
  /** An edge for our `ZoneNameKeyCafm`. May be used by Relay 1. */
  zoneNameKeyCafmEdge?: Maybe<ZoneNameKeyCafmsEdge>;
};


/** The output of our update `ZoneNameKeyCafm` mutation. */
export type UpdateZoneNameKeyCafmPayloadZoneNameKeyCafmEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyCafmsOrderBy>>;
};

/** All input for the `updateZoneNameKeyEbm` mutation. */
export type UpdateZoneNameKeyEbmInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameKeyEbm` being updated. */
  patch: ZoneNameKeyEbmPatch;
};

/** The output of our update `ZoneNameKeyEbm` mutation. */
export type UpdateZoneNameKeyEbmPayload = {
  __typename?: 'UpdateZoneNameKeyEbmPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyEbm`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyEbm` that was updated by this mutation. */
  zoneNameKeyEbm?: Maybe<ZoneNameKeyEbm>;
  /** An edge for our `ZoneNameKeyEbm`. May be used by Relay 1. */
  zoneNameKeyEbmEdge?: Maybe<ZoneNameKeyEbmsEdge>;
};


/** The output of our update `ZoneNameKeyEbm` mutation. */
export type UpdateZoneNameKeyEbmPayloadZoneNameKeyEbmEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyEbmsOrderBy>>;
};

/** All input for the `updateZoneNameKeyMarketing` mutation. */
export type UpdateZoneNameKeyMarketingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameKeyMarketing` being updated. */
  patch: ZoneNameKeyMarketingPatch;
};

/** The output of our update `ZoneNameKeyMarketing` mutation. */
export type UpdateZoneNameKeyMarketingPayload = {
  __typename?: 'UpdateZoneNameKeyMarketingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameKeyMarketing`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameKeyMarketing` that was updated by this mutation. */
  zoneNameKeyMarketing?: Maybe<ZoneNameKeyMarketing>;
  /** An edge for our `ZoneNameKeyMarketing`. May be used by Relay 1. */
  zoneNameKeyMarketingEdge?: Maybe<ZoneNameKeyMarketingsEdge>;
};


/** The output of our update `ZoneNameKeyMarketing` mutation. */
export type UpdateZoneNameKeyMarketingPayloadZoneNameKeyMarketingEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameKeyMarketingsOrderBy>>;
};

/** All input for the `updateZoneNameLong` mutation. */
export type UpdateZoneNameLongInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameLong` being updated. */
  patch: ZoneNameLongPatch;
};

/** The output of our update `ZoneNameLong` mutation. */
export type UpdateZoneNameLongPayload = {
  __typename?: 'UpdateZoneNameLongPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameLong`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameLong` that was updated by this mutation. */
  zoneNameLong?: Maybe<ZoneNameLong>;
  /** An edge for our `ZoneNameLong`. May be used by Relay 1. */
  zoneNameLongEdge?: Maybe<ZoneNameLongsEdge>;
};


/** The output of our update `ZoneNameLong` mutation. */
export type UpdateZoneNameLongPayloadZoneNameLongEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameLongsOrderBy>>;
};

/** All input for the `updateZoneNameShort` mutation. */
export type UpdateZoneNameShortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNameShort` being updated. */
  patch: ZoneNameShortPatch;
};

/** The output of our update `ZoneNameShort` mutation. */
export type UpdateZoneNameShortPayload = {
  __typename?: 'UpdateZoneNameShortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNameShort`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNameShort` that was updated by this mutation. */
  zoneNameShort?: Maybe<ZoneNameShort>;
  /** An edge for our `ZoneNameShort`. May be used by Relay 1. */
  zoneNameShortEdge?: Maybe<ZoneNameShortsEdge>;
};


/** The output of our update `ZoneNameShort` mutation. */
export type UpdateZoneNameShortPayloadZoneNameShortEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNameShortsOrderBy>>;
};

/** All input for the `updateZoneNoVehicle` mutation. */
export type UpdateZoneNoVehicleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneNoVehicle` being updated. */
  patch: ZoneNoVehiclePatch;
};

/** The output of our update `ZoneNoVehicle` mutation. */
export type UpdateZoneNoVehiclePayload = {
  __typename?: 'UpdateZoneNoVehiclePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneNoVehicle`. */
  zone?: Maybe<Zone>;
  /** The `ZoneNoVehicle` that was updated by this mutation. */
  zoneNoVehicle?: Maybe<ZoneNoVehicle>;
  /** An edge for our `ZoneNoVehicle`. May be used by Relay 1. */
  zoneNoVehicleEdge?: Maybe<ZoneNoVehiclesEdge>;
};


/** The output of our update `ZoneNoVehicle` mutation. */
export type UpdateZoneNoVehiclePayloadZoneNoVehicleEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneNoVehiclesOrderBy>>;
};

/** The output of our update `Zone` mutation. */
export type UpdateZonePayload = {
  __typename?: 'UpdateZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Site` that is related to this `Zone`. */
  site?: Maybe<Site>;
  /** Reads a single `ZoneType` that is related to this `Zone`. */
  type?: Maybe<ZoneType>;
  /** The `Zone` that was updated by this mutation. */
  zone?: Maybe<Zone>;
  /** An edge for our `Zone`. May be used by Relay 1. */
  zoneEdge?: Maybe<ZonesEdge>;
};


/** The output of our update `Zone` mutation. */
export type UpdateZonePayloadZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** All input for the `updateZonePublicGrossSpace` mutation. */
export type UpdateZonePublicGrossSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZonePublicGrossSpace` being updated. */
  patch: ZonePublicGrossSpacePatch;
};

/** The output of our update `ZonePublicGrossSpace` mutation. */
export type UpdateZonePublicGrossSpacePayload = {
  __typename?: 'UpdateZonePublicGrossSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZonePublicGrossSpace`. */
  zone?: Maybe<Zone>;
  /** The `ZonePublicGrossSpace` that was updated by this mutation. */
  zonePublicGrossSpace?: Maybe<ZonePublicGrossSpace>;
  /** An edge for our `ZonePublicGrossSpace`. May be used by Relay 1. */
  zonePublicGrossSpaceEdge?: Maybe<ZonePublicGrossSpacesEdge>;
};


/** The output of our update `ZonePublicGrossSpace` mutation. */
export type UpdateZonePublicGrossSpacePayloadZonePublicGrossSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonePublicGrossSpacesOrderBy>>;
};

/** All input for the `updateZoneTireLoadCar` mutation. */
export type UpdateZoneTireLoadCarInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneTireLoadCar` being updated. */
  patch: ZoneTireLoadCarPatch;
};

/** The output of our update `ZoneTireLoadCar` mutation. */
export type UpdateZoneTireLoadCarPayload = {
  __typename?: 'UpdateZoneTireLoadCarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadCar`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadCar` that was updated by this mutation. */
  zoneTireLoadCar?: Maybe<ZoneTireLoadCar>;
  /** An edge for our `ZoneTireLoadCar`. May be used by Relay 1. */
  zoneTireLoadCarEdge?: Maybe<ZoneTireLoadCarsEdge>;
};


/** The output of our update `ZoneTireLoadCar` mutation. */
export type UpdateZoneTireLoadCarPayloadZoneTireLoadCarEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadCarsOrderBy>>;
};

/** All input for the `updateZoneTireLoadForklift` mutation. */
export type UpdateZoneTireLoadForkliftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneTireLoadForklift` being updated. */
  patch: ZoneTireLoadForkliftPatch;
};

/** The output of our update `ZoneTireLoadForklift` mutation. */
export type UpdateZoneTireLoadForkliftPayload = {
  __typename?: 'UpdateZoneTireLoadForkliftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadForklift`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadForklift` that was updated by this mutation. */
  zoneTireLoadForklift?: Maybe<ZoneTireLoadForklift>;
  /** An edge for our `ZoneTireLoadForklift`. May be used by Relay 1. */
  zoneTireLoadForkliftEdge?: Maybe<ZoneTireLoadForkliftsEdge>;
};


/** The output of our update `ZoneTireLoadForklift` mutation. */
export type UpdateZoneTireLoadForkliftPayloadZoneTireLoadForkliftEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadForkliftsOrderBy>>;
};

/** All input for the `updateZoneTireLoadTruck` mutation. */
export type UpdateZoneTireLoadTruckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneTireLoadTruck` being updated. */
  patch: ZoneTireLoadTruckPatch;
};

/** The output of our update `ZoneTireLoadTruck` mutation. */
export type UpdateZoneTireLoadTruckPayload = {
  __typename?: 'UpdateZoneTireLoadTruckPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTireLoadTruck`. */
  zone?: Maybe<Zone>;
  /** The `ZoneTireLoadTruck` that was updated by this mutation. */
  zoneTireLoadTruck?: Maybe<ZoneTireLoadTruck>;
  /** An edge for our `ZoneTireLoadTruck`. May be used by Relay 1. */
  zoneTireLoadTruckEdge?: Maybe<ZoneTireLoadTrucksEdge>;
};


/** The output of our update `ZoneTireLoadTruck` mutation. */
export type UpdateZoneTireLoadTruckPayloadZoneTireLoadTruckEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTireLoadTrucksOrderBy>>;
};

/** All input for the `updateZoneTypeAttr` mutation. */
export type UpdateZoneTypeAttrInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneTypeAttr` being updated. */
  patch: ZoneTypeAttrPatch;
};

/** The output of our update `ZoneTypeAttr` mutation. */
export type UpdateZoneTypeAttrPayload = {
  __typename?: 'UpdateZoneTypeAttrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneTypeAttr`. */
  zone?: Maybe<Zone>;
  /** Reads a single `ZoneType` that is related to this `ZoneTypeAttr`. */
  zoneType?: Maybe<ZoneType>;
  /** The `ZoneTypeAttr` that was updated by this mutation. */
  zoneTypeAttr?: Maybe<ZoneTypeAttr>;
  /** An edge for our `ZoneTypeAttr`. May be used by Relay 1. */
  zoneTypeAttrEdge?: Maybe<ZoneTypeAttrsEdge>;
};


/** The output of our update `ZoneTypeAttr` mutation. */
export type UpdateZoneTypeAttrPayloadZoneTypeAttrEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTypeAttrsOrderBy>>;
};

/** All input for the `updateZoneTypeByName` mutation. */
export type UpdateZoneTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ZoneType` being updated. */
  patch: ZoneTypePatch;
};

/** All input for the `updateZoneType` mutation. */
export type UpdateZoneTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ZoneType` being updated. */
  patch: ZoneTypePatch;
};

/** The output of our update `ZoneType` mutation. */
export type UpdateZoneTypePayload = {
  __typename?: 'UpdateZoneTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ZoneType` that was updated by this mutation. */
  zoneType?: Maybe<ZoneType>;
  /** An edge for our `ZoneType`. May be used by Relay 1. */
  zoneTypeEdge?: Maybe<ZoneTypesEdge>;
};


/** The output of our update `ZoneType` mutation. */
export type UpdateZoneTypePayloadZoneTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneTypesOrderBy>>;
};

export enum UploadStatus {
  Failed = 'failed',
  Pending = 'pending'
}

/** A filter to be used against UploadStatus fields. All fields are combined with a logical ‘and.’ */
export type UploadStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UploadStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UploadStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UploadStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UploadStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UploadStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UploadStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UploadStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UploadStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UploadStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UploadStatus>>;
};

export type User = {
  __typename?: 'User';
  activatedAt?: Maybe<Scalars['Datetime']>;
  company: Scalars['String'];
  createdAt: Scalars['Datetime'];
  deactivatedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `FeedEntry`. */
  feedEntriesByCreatedById: FeedEntriesConnection;
  /** Reads and enables pagination through a set of `FeedEntry`. */
  feedEntriesByUpdatedById: FeedEntriesConnection;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  position: Scalars['String'];
  /** Reads and enables pagination through a set of `ScenarioGroup`. */
  scenarioGroupsByCreatedBy: ScenarioGroupsConnection;
  /** Reads and enables pagination through a set of `ScenarioGroup`. */
  scenarioGroupsByUpdatedBy: ScenarioGroupsConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByCreatedBy: ScenariosConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByUpdatedBy: ScenariosConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `UserPasswordLogin` that is related to this `User`. */
  userPasswordLogin?: Maybe<UserPasswordLogin>;
  /** Reads and enables pagination through a set of `UserSsoLogin`. */
  userSsoLogins: UserSsoLoginsConnection;
};


export type UserFeedEntriesByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeedEntryCondition>;
  filter?: InputMaybe<FeedEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};


export type UserFeedEntriesByUpdatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeedEntryCondition>;
  filter?: InputMaybe<FeedEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedEntriesOrderBy>>;
};


export type UserScenarioGroupsByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioGroupCondition>;
  filter?: InputMaybe<ScenarioGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};


export type UserScenarioGroupsByUpdatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioGroupCondition>;
  filter?: InputMaybe<ScenarioGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenarioGroupsOrderBy>>;
};


export type UserScenariosByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type UserScenariosByUpdatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type UserUserSsoLoginsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSsoLoginCondition>;
  filter?: InputMaybe<UserSsoLoginFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSsoLoginsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `company` field. */
  company?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deactivatedAt` field. */
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isAdmin` field. */
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Filter by the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `company` field. */
  company?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deactivatedAt` field. */
  deactivatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `feedEntriesByCreatedById` relation. */
  feedEntriesByCreatedById?: InputMaybe<UserToManyFeedEntryFilter>;
  /** Some related `feedEntriesByCreatedById` exist. */
  feedEntriesByCreatedByIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `feedEntriesByUpdatedById` relation. */
  feedEntriesByUpdatedById?: InputMaybe<UserToManyFeedEntryFilter>;
  /** Some related `feedEntriesByUpdatedById` exist. */
  feedEntriesByUpdatedByIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isAdmin` field. */
  isAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<StringFilter>;
  /** Filter by the object’s `scenarioGroupsByCreatedBy` relation. */
  scenarioGroupsByCreatedBy?: InputMaybe<UserToManyScenarioGroupFilter>;
  /** Some related `scenarioGroupsByCreatedBy` exist. */
  scenarioGroupsByCreatedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenarioGroupsByUpdatedBy` relation. */
  scenarioGroupsByUpdatedBy?: InputMaybe<UserToManyScenarioGroupFilter>;
  /** Some related `scenarioGroupsByUpdatedBy` exist. */
  scenarioGroupsByUpdatedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenariosByCreatedBy` relation. */
  scenariosByCreatedBy?: InputMaybe<UserToManyScenarioFilter>;
  /** Some related `scenariosByCreatedBy` exist. */
  scenariosByCreatedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scenariosByUpdatedBy` relation. */
  scenariosByUpdatedBy?: InputMaybe<UserToManyScenarioFilter>;
  /** Some related `scenariosByUpdatedBy` exist. */
  scenariosByUpdatedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userPasswordLogin` relation. */
  userPasswordLogin?: InputMaybe<UserPasswordLoginFilter>;
  /** A related `userPasswordLogin` exists. */
  userPasswordLoginExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userSsoLogins` relation. */
  userSsoLogins?: InputMaybe<UserToManyUserSsoLoginFilter>;
  /** Some related `userSsoLogins` exist. */
  userSsoLoginsExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFeedEntryForFeedEntryCreatedByIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFeedEntryForFeedEntryCreatedByIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFeedEntryForFeedEntryUpdatedByIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFeedEntryForFeedEntryUpdatedByIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnScenarioForScenarioCreatedByFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnScenarioForScenarioCreatedByFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnScenarioForScenarioUpdatedByFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnScenarioForScenarioUpdatedByFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnScenarioGroupForScenarioGroupCreatedByFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnScenarioGroupForScenarioGroupCreatedByFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnScenarioGroupForScenarioGroupUpdatedByFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnScenarioGroupForScenarioGroupUpdatedByFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPasswordLoginForUserPasswordLoginUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserSsoLoginForUserSsoLoginUserIdFkeyPatch;
};

export type UserPasswordLogin = {
  __typename?: 'UserPasswordLogin';
  activatedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  deactivatedAt?: Maybe<Scalars['Datetime']>;
  email: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  password: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserPasswordLogin`. */
  user: User;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `UserPasswordLogin` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserPasswordLoginCondition = {
  /** Checks for equality with the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deactivatedAt` field. */
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `password` field. */
  password?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserPasswordLogin` object types. All fields are combined with a logical ‘and.’ */
export type UserPasswordLoginFilter = {
  /** Filter by the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPasswordLoginFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deactivatedAt` field. */
  deactivatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserPasswordLoginFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPasswordLoginFilter>>;
  /** Filter by the object’s `password` field. */
  password?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserPasswordLogin` */
export type UserPasswordLoginInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userToUserId?: InputMaybe<UserPasswordLoginUserIdFkeyInput>;
};

/** The fields on `userPasswordLogin` to look up the row to update. */
export type UserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPasswordLoginEmailKeyUpdate = {
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `userPasswordLogin` being updated. */
  patch: UpdateUserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyPatch;
};

/** The fields on `userPasswordLogin` to look up the row to update. */
export type UserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPasswordLoginPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userPasswordLogin` being updated. */
  patch: UpdateUserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyPatch;
};

/** The fields on `userPasswordLogin` to look up the row to update. */
export type UserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPasswordLoginUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `userPasswordLogin` being updated. */
  patch: UpdateUserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserPasswordLogin`. Fields that are set will be updated. */
export type UserPasswordLoginPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userToUserId?: InputMaybe<UserPasswordLoginUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `UserPasswordLoginInput` mutation. */
export type UserPasswordLoginUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPasswordLoginUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userPasswordLogin` in the `UserInput` mutation. */
export type UserPasswordLoginUserIdFkeyInverseInput = {
  /** The primary key(s) for `userPasswordLogin` for the far side of the relationship. */
  connectByEmail?: InputMaybe<UserPasswordLoginUserPasswordLoginEmailKeyConnect>;
  /** The primary key(s) for `userPasswordLogin` for the far side of the relationship. */
  connectById?: InputMaybe<UserPasswordLoginUserPasswordLoginPkeyConnect>;
  /** The primary key(s) for `userPasswordLogin` for the far side of the relationship. */
  connectByUserId?: InputMaybe<UserPasswordLoginUserPasswordLoginUserIdKeyConnect>;
  /** A `UserPasswordLoginInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserPasswordLoginUserIdFkeyUserPasswordLoginCreateInput>>;
  /** The primary key(s) for `userPasswordLogin` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<UserPasswordLoginUserPasswordLoginEmailKeyDelete>;
  /** The primary key(s) for `userPasswordLogin` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPasswordLoginUserPasswordLoginPkeyDelete>;
  /** The primary key(s) for `userPasswordLogin` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<UserPasswordLoginUserPasswordLoginUserIdKeyDelete>;
  /** Flag indicating whether all other `userPasswordLogin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userPasswordLogin` for the far side of the relationship. */
  updateByEmail?: InputMaybe<UserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPasswordLoginEmailKeyUpdate>;
  /** The primary key(s) and patch data for `userPasswordLogin` for the far side of the relationship. */
  updateById?: InputMaybe<UserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPasswordLoginPkeyUpdate>;
  /** The primary key(s) and patch data for `userPasswordLogin` for the far side of the relationship. */
  updateByUserId?: InputMaybe<UserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyUsingUserPasswordLoginUserIdKeyUpdate>;
};

/** The `user` to be created by this mutation. */
export type UserPasswordLoginUserIdFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** The `userPasswordLogin` to be created by this mutation. */
export type UserPasswordLoginUserIdFkeyUserPasswordLoginCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<UserPasswordLoginUserIdFkeyInput>;
};

/** The fields on `userPasswordLogin` to look up the row to connect. */
export type UserPasswordLoginUserPasswordLoginEmailKeyConnect = {
  email: Scalars['String'];
};

/** The fields on `userPasswordLogin` to look up the row to delete. */
export type UserPasswordLoginUserPasswordLoginEmailKeyDelete = {
  email: Scalars['String'];
};

/** The fields on `userPasswordLogin` to look up the row to connect. */
export type UserPasswordLoginUserPasswordLoginPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `userPasswordLogin` to look up the row to delete. */
export type UserPasswordLoginUserPasswordLoginPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `userPasswordLogin` to look up the row to connect. */
export type UserPasswordLoginUserPasswordLoginUserIdKeyConnect = {
  userId: Scalars['UUID'];
};

/** The fields on `userPasswordLogin` to look up the row to delete. */
export type UserPasswordLoginUserPasswordLoginUserIdKeyDelete = {
  userId: Scalars['UUID'];
};

/** A connection to a list of `UserPasswordLogin` values. */
export type UserPasswordLoginsConnection = {
  __typename?: 'UserPasswordLoginsConnection';
  /** A list of edges which contains the `UserPasswordLogin` and cursor to aid in pagination. */
  edges: Array<UserPasswordLoginsEdge>;
  /** A list of `UserPasswordLogin` objects. */
  nodes: Array<UserPasswordLogin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserPasswordLogin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserPasswordLogin` edge in the connection. */
export type UserPasswordLoginsEdge = {
  __typename?: 'UserPasswordLoginsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserPasswordLogin` at the end of the edge. */
  node: UserPasswordLogin;
};

/** Methods to use when ordering `UserPasswordLogin`. */
export enum UserPasswordLoginsOrderBy {
  ActivatedAtAsc = 'ACTIVATED_AT_ASC',
  ActivatedAtDesc = 'ACTIVATED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeactivatedAtAsc = 'DEACTIVATED_AT_ASC',
  DeactivatedAtDesc = 'DEACTIVATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  Natural = 'NATURAL',
  PasswordAsc = 'PASSWORD_ASC',
  PasswordDesc = 'PASSWORD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdActivatedAtAsc = 'USER_BY_USER_ID__ACTIVATED_AT_ASC',
  UserByUserIdActivatedAtDesc = 'USER_BY_USER_ID__ACTIVATED_AT_DESC',
  UserByUserIdCompanyAsc = 'USER_BY_USER_ID__COMPANY_ASC',
  UserByUserIdCompanyDesc = 'USER_BY_USER_ID__COMPANY_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdDeactivatedAtAsc = 'USER_BY_USER_ID__DEACTIVATED_AT_ASC',
  UserByUserIdDeactivatedAtDesc = 'USER_BY_USER_ID__DEACTIVATED_AT_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsActiveAsc = 'USER_BY_USER_ID__IS_ACTIVE_ASC',
  UserByUserIdIsActiveDesc = 'USER_BY_USER_ID__IS_ACTIVE_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdNameAsc = 'USER_BY_USER_ID__NAME_ASC',
  UserByUserIdNameDesc = 'USER_BY_USER_ID__NAME_DESC',
  UserByUserIdNotesAsc = 'USER_BY_USER_ID__NOTES_ASC',
  UserByUserIdNotesDesc = 'USER_BY_USER_ID__NOTES_DESC',
  UserByUserIdPositionAsc = 'USER_BY_USER_ID__POSITION_ASC',
  UserByUserIdPositionDesc = 'USER_BY_USER_ID__POSITION_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

export type UserSsoLogin = {
  __typename?: 'UserSsoLogin';
  activatedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  deactivatedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  oid: Scalars['String'];
  provider: SsoProvider;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserSsoLogin`. */
  user: User;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `UserSsoLogin` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserSsoLoginCondition = {
  /** Checks for equality with the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deactivatedAt` field. */
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `oid` field. */
  oid?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<SsoProvider>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserSsoLogin` object types. All fields are combined with a logical ‘and.’ */
export type UserSsoLoginFilter = {
  /** Filter by the object’s `activatedAt` field. */
  activatedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSsoLoginFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deactivatedAt` field. */
  deactivatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSsoLoginFilter>;
  /** Filter by the object’s `oid` field. */
  oid?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSsoLoginFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<SsoProviderFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserSsoLogin` */
export type UserSsoLoginInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  oid: Scalars['String'];
  provider: SsoProvider;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userToUserId?: InputMaybe<UserSsoLoginUserIdFkeyInput>;
};

/** The fields on `userSsoLogin` to look up the row to update. */
export type UserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserSsoLoginPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userSsoLogin` being updated. */
  patch: UpdateUserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyPatch;
};

/** The fields on `userSsoLogin` to look up the row to update. */
export type UserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserSsoLoginProviderOidKeyUpdate = {
  oid: Scalars['String'];
  /** An object where the defined keys will be set on the `userSsoLogin` being updated. */
  patch: UpdateUserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyPatch;
  provider: SsoProvider;
};

/** The fields on `userSsoLogin` to look up the row to update. */
export type UserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserSsoLoginUserIdProviderKeyUpdate = {
  /** An object where the defined keys will be set on the `userSsoLogin` being updated. */
  patch: UpdateUserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyPatch;
  provider: SsoProvider;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserSsoLogin`. Fields that are set will be updated. */
export type UserSsoLoginPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  oid?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<SsoProvider>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userToUserId?: InputMaybe<UserSsoLoginUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `UserSsoLoginInput` mutation. */
export type UserSsoLoginUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserSsoLoginUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userSsoLogin` in the `UserInput` mutation. */
export type UserSsoLoginUserIdFkeyInverseInput = {
  /** The primary key(s) for `userSsoLogin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserSsoLoginUserSsoLoginPkeyConnect>>;
  /** The primary key(s) for `userSsoLogin` for the far side of the relationship. */
  connectByProviderAndOid?: InputMaybe<Array<UserSsoLoginUserSsoLoginProviderOidKeyConnect>>;
  /** The primary key(s) for `userSsoLogin` for the far side of the relationship. */
  connectByUserIdAndProvider?: InputMaybe<Array<UserSsoLoginUserSsoLoginUserIdProviderKeyConnect>>;
  /** A `UserSsoLoginInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserSsoLoginUserIdFkeyUserSsoLoginCreateInput>>;
  /** The primary key(s) for `userSsoLogin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserSsoLoginUserSsoLoginPkeyDelete>>;
  /** The primary key(s) for `userSsoLogin` for the far side of the relationship. */
  deleteByProviderAndOid?: InputMaybe<Array<UserSsoLoginUserSsoLoginProviderOidKeyDelete>>;
  /** The primary key(s) for `userSsoLogin` for the far side of the relationship. */
  deleteByUserIdAndProvider?: InputMaybe<Array<UserSsoLoginUserSsoLoginUserIdProviderKeyDelete>>;
  /** Flag indicating whether all other `userSsoLogin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userSsoLogin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserSsoLoginPkeyUpdate>>;
  /** The primary key(s) and patch data for `userSsoLogin` for the far side of the relationship. */
  updateByProviderAndOid?: InputMaybe<Array<UserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserSsoLoginProviderOidKeyUpdate>>;
  /** The primary key(s) and patch data for `userSsoLogin` for the far side of the relationship. */
  updateByUserIdAndProvider?: InputMaybe<Array<UserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyUsingUserSsoLoginUserIdProviderKeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type UserSsoLoginUserIdFkeyUserCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** The `userSsoLogin` to be created by this mutation. */
export type UserSsoLoginUserIdFkeyUserSsoLoginCreateInput = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  oid: Scalars['String'];
  provider: SsoProvider;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<UserSsoLoginUserIdFkeyInput>;
};

/** The fields on `userSsoLogin` to look up the row to connect. */
export type UserSsoLoginUserSsoLoginPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `userSsoLogin` to look up the row to delete. */
export type UserSsoLoginUserSsoLoginPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `userSsoLogin` to look up the row to connect. */
export type UserSsoLoginUserSsoLoginProviderOidKeyConnect = {
  oid: Scalars['String'];
  provider: SsoProvider;
};

/** The fields on `userSsoLogin` to look up the row to delete. */
export type UserSsoLoginUserSsoLoginProviderOidKeyDelete = {
  oid: Scalars['String'];
  provider: SsoProvider;
};

/** The fields on `userSsoLogin` to look up the row to connect. */
export type UserSsoLoginUserSsoLoginUserIdProviderKeyConnect = {
  provider: SsoProvider;
  userId: Scalars['UUID'];
};

/** The fields on `userSsoLogin` to look up the row to delete. */
export type UserSsoLoginUserSsoLoginUserIdProviderKeyDelete = {
  provider: SsoProvider;
  userId: Scalars['UUID'];
};

/** A connection to a list of `UserSsoLogin` values. */
export type UserSsoLoginsConnection = {
  __typename?: 'UserSsoLoginsConnection';
  /** A list of edges which contains the `UserSsoLogin` and cursor to aid in pagination. */
  edges: Array<UserSsoLoginsEdge>;
  /** A list of `UserSsoLogin` objects. */
  nodes: Array<UserSsoLogin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSsoLogin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserSsoLogin` edge in the connection. */
export type UserSsoLoginsEdge = {
  __typename?: 'UserSsoLoginsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserSsoLogin` at the end of the edge. */
  node: UserSsoLogin;
};

/** Methods to use when ordering `UserSsoLogin`. */
export enum UserSsoLoginsOrderBy {
  ActivatedAtAsc = 'ACTIVATED_AT_ASC',
  ActivatedAtDesc = 'ACTIVATED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeactivatedAtAsc = 'DEACTIVATED_AT_ASC',
  DeactivatedAtDesc = 'DEACTIVATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  Natural = 'NATURAL',
  OidAsc = 'OID_ASC',
  OidDesc = 'OID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdActivatedAtAsc = 'USER_BY_USER_ID__ACTIVATED_AT_ASC',
  UserByUserIdActivatedAtDesc = 'USER_BY_USER_ID__ACTIVATED_AT_DESC',
  UserByUserIdCompanyAsc = 'USER_BY_USER_ID__COMPANY_ASC',
  UserByUserIdCompanyDesc = 'USER_BY_USER_ID__COMPANY_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdDeactivatedAtAsc = 'USER_BY_USER_ID__DEACTIVATED_AT_ASC',
  UserByUserIdDeactivatedAtDesc = 'USER_BY_USER_ID__DEACTIVATED_AT_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsActiveAsc = 'USER_BY_USER_ID__IS_ACTIVE_ASC',
  UserByUserIdIsActiveDesc = 'USER_BY_USER_ID__IS_ACTIVE_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdNameAsc = 'USER_BY_USER_ID__NAME_ASC',
  UserByUserIdNameDesc = 'USER_BY_USER_ID__NAME_DESC',
  UserByUserIdNotesAsc = 'USER_BY_USER_ID__NOTES_ASC',
  UserByUserIdNotesDesc = 'USER_BY_USER_ID__NOTES_DESC',
  UserByUserIdPositionAsc = 'USER_BY_USER_ID__POSITION_ASC',
  UserByUserIdPositionDesc = 'USER_BY_USER_ID__POSITION_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against many `FeedEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFeedEntryFilter = {
  /** Every related `FeedEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeedEntryFilter>;
  /** No related `FeedEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeedEntryFilter>;
  /** Some related `FeedEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeedEntryFilter>;
};

/** A filter to be used against many `Scenario` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyScenarioFilter = {
  /** Every related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScenarioFilter>;
  /** No related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScenarioFilter>;
  /** Some related `Scenario` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScenarioFilter>;
};

/** A filter to be used against many `ScenarioGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyScenarioGroupFilter = {
  /** Every related `ScenarioGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScenarioGroupFilter>;
  /** No related `ScenarioGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScenarioGroupFilter>;
  /** Some related `ScenarioGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScenarioGroupFilter>;
};

/** A filter to be used against many `UserSsoLogin` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserSsoLoginFilter = {
  /** Every related `UserSsoLogin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSsoLoginFilter>;
  /** No related `UserSsoLogin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSsoLoginFilter>;
  /** Some related `UserSsoLogin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSsoLoginFilter>;
};

/** The fields on `user` to look up the row to connect. */
export type UserUserPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `user` to look up the row to delete. */
export type UserUserPkeyDelete = {
  id: Scalars['UUID'];
};

export type UserWithLoginData = {
  __typename?: 'UserWithLoginData';
  activatedAt?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  matchingEntraUsers: Array<EntraMatch>;
  passwordLogin?: Maybe<PasswordLoginData>;
  provider?: Maybe<SsoProvider>;
  ssoLogins: Array<SsoLoginData>;
  updatedAt: Scalars['String'];
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  ActivatedAtAsc = 'ACTIVATED_AT_ASC',
  ActivatedAtDesc = 'ACTIVATED_AT_DESC',
  CompanyAsc = 'COMPANY_ASC',
  CompanyDesc = 'COMPANY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeactivatedAtAsc = 'DEACTIVATED_AT_ASC',
  DeactivatedAtDesc = 'DEACTIVATED_AT_DESC',
  FeedEntriesByCreatedByIdCountAsc = 'FEED_ENTRIES_BY_CREATED_BY_ID__COUNT_ASC',
  FeedEntriesByCreatedByIdCountDesc = 'FEED_ENTRIES_BY_CREATED_BY_ID__COUNT_DESC',
  FeedEntriesByUpdatedByIdCountAsc = 'FEED_ENTRIES_BY_UPDATED_BY_ID__COUNT_ASC',
  FeedEntriesByUpdatedByIdCountDesc = 'FEED_ENTRIES_BY_UPDATED_BY_ID__COUNT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  IsAdminAsc = 'IS_ADMIN_ASC',
  IsAdminDesc = 'IS_ADMIN_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScenariosByCreatedByCountAsc = 'SCENARIOS_BY_CREATED_BY__COUNT_ASC',
  ScenariosByCreatedByCountDesc = 'SCENARIOS_BY_CREATED_BY__COUNT_DESC',
  ScenariosByUpdatedByCountAsc = 'SCENARIOS_BY_UPDATED_BY__COUNT_ASC',
  ScenariosByUpdatedByCountDesc = 'SCENARIOS_BY_UPDATED_BY__COUNT_DESC',
  ScenarioGroupsByCreatedByCountAsc = 'SCENARIO_GROUPS_BY_CREATED_BY__COUNT_ASC',
  ScenarioGroupsByCreatedByCountDesc = 'SCENARIO_GROUPS_BY_CREATED_BY__COUNT_DESC',
  ScenarioGroupsByUpdatedByCountAsc = 'SCENARIO_GROUPS_BY_UPDATED_BY__COUNT_ASC',
  ScenarioGroupsByUpdatedByCountDesc = 'SCENARIO_GROUPS_BY_UPDATED_BY__COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserPasswordLoginByUserIdActivatedAtAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__ACTIVATED_AT_ASC',
  UserPasswordLoginByUserIdActivatedAtDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__ACTIVATED_AT_DESC',
  UserPasswordLoginByUserIdCreatedAtAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__CREATED_AT_ASC',
  UserPasswordLoginByUserIdCreatedAtDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__CREATED_AT_DESC',
  UserPasswordLoginByUserIdDeactivatedAtAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__DEACTIVATED_AT_ASC',
  UserPasswordLoginByUserIdDeactivatedAtDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__DEACTIVATED_AT_DESC',
  UserPasswordLoginByUserIdEmailAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__EMAIL_ASC',
  UserPasswordLoginByUserIdEmailDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__EMAIL_DESC',
  UserPasswordLoginByUserIdIdAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__ID_ASC',
  UserPasswordLoginByUserIdIdDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__ID_DESC',
  UserPasswordLoginByUserIdIsActiveAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__IS_ACTIVE_ASC',
  UserPasswordLoginByUserIdIsActiveDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__IS_ACTIVE_DESC',
  UserPasswordLoginByUserIdPasswordAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__PASSWORD_ASC',
  UserPasswordLoginByUserIdPasswordDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__PASSWORD_DESC',
  UserPasswordLoginByUserIdUpdatedAtAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__UPDATED_AT_ASC',
  UserPasswordLoginByUserIdUpdatedAtDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__UPDATED_AT_DESC',
  UserPasswordLoginByUserIdUserIdAsc = 'USER_PASSWORD_LOGIN_BY_USER_ID__USER_ID_ASC',
  UserPasswordLoginByUserIdUserIdDesc = 'USER_PASSWORD_LOGIN_BY_USER_ID__USER_ID_DESC',
  UserSsoLoginsByUserIdCountAsc = 'USER_SSO_LOGINS_BY_USER_ID__COUNT_ASC',
  UserSsoLoginsByUserIdCountDesc = 'USER_SSO_LOGINS_BY_USER_ID__COUNT_DESC'
}

export enum VariantType {
  Event = 'event',
  ExternalEvent = 'external_event',
  Project = 'project'
}

/** A filter to be used against VariantType fields. All fields are combined with a logical ‘and.’ */
export type VariantTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VariantType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VariantType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VariantType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VariantType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VariantType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VariantType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VariantType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VariantType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VariantType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VariantType>>;
};

export type Zone = {
  __typename?: 'Zone';
  /** Reads and enables pagination through a set of `Area`. */
  areas: AreasConnection;
  description: Scalars['String'];
  extId: Scalars['UUID'];
  id: Scalars['UUID'];
  nameLong: Scalars['String'];
  nameShort: Scalars['String'];
  /** Reads a single `Site` that is related to this `Zone`. */
  site: Site;
  siteId: Scalars['UUID'];
  /** Reads a single `ZoneType` that is related to this `Zone`. */
  type?: Maybe<ZoneType>;
  typeId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ZoneCadGrossSpaceMin`. */
  zoneCadGrossSpaceMins: ZoneCadGrossSpaceMinsConnection;
  /** Reads and enables pagination through a set of `ZoneCapacityCar`. */
  zoneCapacityCars: ZoneCapacityCarsConnection;
  /** Reads and enables pagination through a set of `ZoneCapacityTruck`. */
  zoneCapacityTrucks: ZoneCapacityTrucksConnection;
  /** Reads and enables pagination through a set of `ZoneDescription`. */
  zoneDescriptions: ZoneDescriptionsConnection;
  /** Reads and enables pagination through a set of `ZoneMaxLoadFloor`. */
  zoneMaxLoadFloors: ZoneMaxLoadFloorsConnection;
  /** Reads and enables pagination through a set of `ZoneNameExtra`. */
  zoneNameExtras: ZoneNameExtrasConnection;
  /** Reads and enables pagination through a set of `ZoneNameKeyCad`. */
  zoneNameKeyCads: ZoneNameKeyCadsConnection;
  /** Reads and enables pagination through a set of `ZoneNameKeyCafm`. */
  zoneNameKeyCafms: ZoneNameKeyCafmsConnection;
  /** Reads and enables pagination through a set of `ZoneNameKeyEbm`. */
  zoneNameKeyEbms: ZoneNameKeyEbmsConnection;
  /** Reads and enables pagination through a set of `ZoneNameKeyMarketing`. */
  zoneNameKeyMarketings: ZoneNameKeyMarketingsConnection;
  /** Reads and enables pagination through a set of `ZoneNameLong`. */
  zoneNameLongs: ZoneNameLongsConnection;
  /** Reads and enables pagination through a set of `ZoneNameShort`. */
  zoneNameShorts: ZoneNameShortsConnection;
  /** Reads and enables pagination through a set of `ZoneNoVehicle`. */
  zoneNoVehicles: ZoneNoVehiclesConnection;
  /** Reads and enables pagination through a set of `ZonePublicGrossSpace`. */
  zonePublicGrossSpaces: ZonePublicGrossSpacesConnection;
  /** Reads and enables pagination through a set of `ZoneTireLoadCar`. */
  zoneTireLoadCars: ZoneTireLoadCarsConnection;
  /** Reads and enables pagination through a set of `ZoneTireLoadForklift`. */
  zoneTireLoadForklifts: ZoneTireLoadForkliftsConnection;
  /** Reads and enables pagination through a set of `ZoneTireLoadTruck`. */
  zoneTireLoadTrucks: ZoneTireLoadTrucksConnection;
  /** Reads and enables pagination through a set of `ZoneTypeAttr`. */
  zoneTypeAttrs: ZoneTypeAttrsConnection;
};


export type ZoneAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AreaCondition>;
  filter?: InputMaybe<AreaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AreasOrderBy>>;
};


export type ZoneZoneCadGrossSpaceMinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCadGrossSpaceMinCondition>;
  filter?: InputMaybe<ZoneCadGrossSpaceMinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneCadGrossSpaceMinsOrderBy>>;
};


export type ZoneZoneCapacityCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCapacityCarCondition>;
  filter?: InputMaybe<ZoneCapacityCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneCapacityCarsOrderBy>>;
};


export type ZoneZoneCapacityTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCapacityTruckCondition>;
  filter?: InputMaybe<ZoneCapacityTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneCapacityTrucksOrderBy>>;
};


export type ZoneZoneDescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneDescriptionCondition>;
  filter?: InputMaybe<ZoneDescriptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneDescriptionsOrderBy>>;
};


export type ZoneZoneMaxLoadFloorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneMaxLoadFloorCondition>;
  filter?: InputMaybe<ZoneMaxLoadFloorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneMaxLoadFloorsOrderBy>>;
};


export type ZoneZoneNameExtrasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameExtraCondition>;
  filter?: InputMaybe<ZoneNameExtraFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameExtrasOrderBy>>;
};


export type ZoneZoneNameKeyCadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyCadCondition>;
  filter?: InputMaybe<ZoneNameKeyCadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyCadsOrderBy>>;
};


export type ZoneZoneNameKeyCafmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyCafmCondition>;
  filter?: InputMaybe<ZoneNameKeyCafmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyCafmsOrderBy>>;
};


export type ZoneZoneNameKeyEbmsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyEbmCondition>;
  filter?: InputMaybe<ZoneNameKeyEbmFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyEbmsOrderBy>>;
};


export type ZoneZoneNameKeyMarketingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameKeyMarketingCondition>;
  filter?: InputMaybe<ZoneNameKeyMarketingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameKeyMarketingsOrderBy>>;
};


export type ZoneZoneNameLongsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameLongCondition>;
  filter?: InputMaybe<ZoneNameLongFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameLongsOrderBy>>;
};


export type ZoneZoneNameShortsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNameShortCondition>;
  filter?: InputMaybe<ZoneNameShortFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNameShortsOrderBy>>;
};


export type ZoneZoneNoVehiclesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneNoVehicleCondition>;
  filter?: InputMaybe<ZoneNoVehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneNoVehiclesOrderBy>>;
};


export type ZoneZonePublicGrossSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZonePublicGrossSpaceCondition>;
  filter?: InputMaybe<ZonePublicGrossSpaceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonePublicGrossSpacesOrderBy>>;
};


export type ZoneZoneTireLoadCarsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTireLoadCarCondition>;
  filter?: InputMaybe<ZoneTireLoadCarFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTireLoadCarsOrderBy>>;
};


export type ZoneZoneTireLoadForkliftsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTireLoadForkliftCondition>;
  filter?: InputMaybe<ZoneTireLoadForkliftFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTireLoadForkliftsOrderBy>>;
};


export type ZoneZoneTireLoadTrucksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTireLoadTruckCondition>;
  filter?: InputMaybe<ZoneTireLoadTruckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTireLoadTrucksOrderBy>>;
};


export type ZoneZoneTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTypeAttrCondition>;
  filter?: InputMaybe<ZoneTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTypeAttrsOrderBy>>;
};

export type ZoneCadGrossSpaceMin = {
  __typename?: 'ZoneCadGrossSpaceMin';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  /** Reads a single `Zone` that is related to this `ZoneCadGrossSpaceMin`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneCadGrossSpaceMin` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ZoneCadGrossSpaceMinCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type ZoneCadGrossSpaceMinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneCadGrossSpaceMinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneCadGrossSpaceMinFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneCadGrossSpaceMin` */
export type ZoneCadGrossSpaceMinInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInput>;
};

/** The fields on `zoneCadGrossSpaceMin` to look up the row to update. */
export type ZoneCadGrossSpaceMinOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZoneCadGrossSpaceMinPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneCadGrossSpaceMin` being updated. */
  patch: UpdateZoneCadGrossSpaceMinOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneCadGrossSpaceMin`. Fields that are set will be updated. */
export type ZoneCadGrossSpaceMinPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInput>;
};

/** The fields on `zoneCadGrossSpaceMin` to look up the row to connect. */
export type ZoneCadGrossSpaceMinZoneCadGrossSpaceMinPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneCadGrossSpaceMin` to look up the row to delete. */
export type ZoneCadGrossSpaceMinZoneCadGrossSpaceMinPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `zone` in the `ZoneCadGrossSpaceMinInput` mutation. */
export type ZoneCadGrossSpaceMinZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneCadGrossSpaceMin` in the `ZoneInput` mutation. */
export type ZoneCadGrossSpaceMinZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneCadGrossSpaceMin` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneCadGrossSpaceMinZoneCadGrossSpaceMinPkeyConnect>>;
  /** A `ZoneCadGrossSpaceMinInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneCadGrossSpaceMinZoneIdFkeyZoneCadGrossSpaceMinCreateInput>>;
  /** The primary key(s) for `zoneCadGrossSpaceMin` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneCadGrossSpaceMinZoneCadGrossSpaceMinPkeyDelete>>;
  /** Flag indicating whether all other `zoneCadGrossSpaceMin` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneCadGrossSpaceMin` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneCadGrossSpaceMinOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZoneCadGrossSpaceMinPkeyUpdate>>;
};

/** The `zoneCadGrossSpaceMin` to be created by this mutation. */
export type ZoneCadGrossSpaceMinZoneIdFkeyZoneCadGrossSpaceMinCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneToZoneId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInput>;
};

/** The `zone` to be created by this mutation. */
export type ZoneCadGrossSpaceMinZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** A connection to a list of `ZoneCadGrossSpaceMin` values. */
export type ZoneCadGrossSpaceMinsConnection = {
  __typename?: 'ZoneCadGrossSpaceMinsConnection';
  /** A list of edges which contains the `ZoneCadGrossSpaceMin` and cursor to aid in pagination. */
  edges: Array<ZoneCadGrossSpaceMinsEdge>;
  /** A list of `ZoneCadGrossSpaceMin` objects. */
  nodes: Array<ZoneCadGrossSpaceMin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneCadGrossSpaceMin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneCadGrossSpaceMin` edge in the connection. */
export type ZoneCadGrossSpaceMinsEdge = {
  __typename?: 'ZoneCadGrossSpaceMinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneCadGrossSpaceMin` at the end of the edge. */
  node: ZoneCadGrossSpaceMin;
};

/** Methods to use when ordering `ZoneCadGrossSpaceMin`. */
export enum ZoneCadGrossSpaceMinsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneCapacityCar = {
  __typename?: 'ZoneCapacityCar';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
  /** Reads a single `Zone` that is related to this `ZoneCapacityCar`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneCapacityCar` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneCapacityCarCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneCapacityCar` object types. All fields are combined with a logical ‘and.’ */
export type ZoneCapacityCarFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneCapacityCarFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneCapacityCarFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneCapacityCarFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneCapacityCar` */
export type ZoneCapacityCarInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInput>;
};

/** The fields on `zoneCapacityCar` to look up the row to update. */
export type ZoneCapacityCarOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZoneCapacityCarsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneCapacityCar` being updated. */
  patch: UpdateZoneCapacityCarOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneCapacityCar`. Fields that are set will be updated. */
export type ZoneCapacityCarPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInput>;
};

/** The fields on `zoneCapacityCar` to look up the row to connect. */
export type ZoneCapacityCarZoneCapacityCarsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneCapacityCar` to look up the row to delete. */
export type ZoneCapacityCarZoneCapacityCarsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneCapacityCar` values. */
export type ZoneCapacityCarsConnection = {
  __typename?: 'ZoneCapacityCarsConnection';
  /** A list of edges which contains the `ZoneCapacityCar` and cursor to aid in pagination. */
  edges: Array<ZoneCapacityCarsEdge>;
  /** A list of `ZoneCapacityCar` objects. */
  nodes: Array<ZoneCapacityCar>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneCapacityCar` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneCapacityCar` edge in the connection. */
export type ZoneCapacityCarsEdge = {
  __typename?: 'ZoneCapacityCarsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneCapacityCar` at the end of the edge. */
  node: ZoneCapacityCar;
};

/** Methods to use when ordering `ZoneCapacityCar`. */
export enum ZoneCapacityCarsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** Input for the nested mutation of `zone` in the `ZoneCapacityCarInput` mutation. */
export type ZoneCapacityCarsZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneCapacityCarsZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneCapacityCar` in the `ZoneInput` mutation. */
export type ZoneCapacityCarsZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneCapacityCar` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneCapacityCarZoneCapacityCarsPkeyConnect>>;
  /** A `ZoneCapacityCarInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneCapacityCarsZoneIdFkeyZoneCapacityCarsCreateInput>>;
  /** The primary key(s) for `zoneCapacityCar` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneCapacityCarZoneCapacityCarsPkeyDelete>>;
  /** Flag indicating whether all other `zoneCapacityCar` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneCapacityCar` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneCapacityCarOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZoneCapacityCarsPkeyUpdate>>;
};

/** The `zoneCapacityCar` to be created by this mutation. */
export type ZoneCapacityCarsZoneIdFkeyZoneCapacityCarsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
  zoneToZoneId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInput>;
};

/** The `zone` to be created by this mutation. */
export type ZoneCapacityCarsZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

export type ZoneCapacityTruck = {
  __typename?: 'ZoneCapacityTruck';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['Int'];
  /** Reads a single `Zone` that is related to this `ZoneCapacityTruck`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneCapacityTruck` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneCapacityTruckCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneCapacityTruck` object types. All fields are combined with a logical ‘and.’ */
export type ZoneCapacityTruckFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneCapacityTruckFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneCapacityTruckFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneCapacityTruckFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneCapacityTruck` */
export type ZoneCapacityTruckInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInput>;
};

/** The fields on `zoneCapacityTruck` to look up the row to update. */
export type ZoneCapacityTruckOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZoneCapacityTrucksPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneCapacityTruck` being updated. */
  patch: UpdateZoneCapacityTruckOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneCapacityTruck`. Fields that are set will be updated. */
export type ZoneCapacityTruckPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInput>;
};

/** The fields on `zoneCapacityTruck` to look up the row to connect. */
export type ZoneCapacityTruckZoneCapacityTrucksPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneCapacityTruck` to look up the row to delete. */
export type ZoneCapacityTruckZoneCapacityTrucksPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneCapacityTruck` values. */
export type ZoneCapacityTrucksConnection = {
  __typename?: 'ZoneCapacityTrucksConnection';
  /** A list of edges which contains the `ZoneCapacityTruck` and cursor to aid in pagination. */
  edges: Array<ZoneCapacityTrucksEdge>;
  /** A list of `ZoneCapacityTruck` objects. */
  nodes: Array<ZoneCapacityTruck>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneCapacityTruck` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneCapacityTruck` edge in the connection. */
export type ZoneCapacityTrucksEdge = {
  __typename?: 'ZoneCapacityTrucksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneCapacityTruck` at the end of the edge. */
  node: ZoneCapacityTruck;
};

/** Methods to use when ordering `ZoneCapacityTruck`. */
export enum ZoneCapacityTrucksOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** Input for the nested mutation of `zone` in the `ZoneCapacityTruckInput` mutation. */
export type ZoneCapacityTrucksZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneCapacityTruck` in the `ZoneInput` mutation. */
export type ZoneCapacityTrucksZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneCapacityTruck` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneCapacityTruckZoneCapacityTrucksPkeyConnect>>;
  /** A `ZoneCapacityTruckInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneCapacityTrucksZoneIdFkeyZoneCapacityTrucksCreateInput>>;
  /** The primary key(s) for `zoneCapacityTruck` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneCapacityTruckZoneCapacityTrucksPkeyDelete>>;
  /** Flag indicating whether all other `zoneCapacityTruck` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneCapacityTruck` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneCapacityTruckOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZoneCapacityTrucksPkeyUpdate>>;
};

/** The `zoneCapacityTruck` to be created by this mutation. */
export type ZoneCapacityTrucksZoneIdFkeyZoneCapacityTrucksCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['Int'];
  zoneToZoneId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInput>;
};

/** The `zone` to be created by this mutation. */
export type ZoneCapacityTrucksZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** A condition to be used against `Zone` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ZoneCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `extId` field. */
  extId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameLong` field. */
  nameLong?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nameShort` field. */
  nameShort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `siteId` field. */
  siteId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']>;
};

export type ZoneDescription = {
  __typename?: 'ZoneDescription';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneDescription`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneDescription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneDescriptionCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneDescription` object types. All fields are combined with a logical ‘and.’ */
export type ZoneDescriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneDescriptionFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneDescriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneDescriptionFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneDescription` */
export type ZoneDescriptionInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneDescriptionZoneIdFkeyInput>;
};

/** The fields on `zoneDescription` to look up the row to update. */
export type ZoneDescriptionOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZoneDescriptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneDescription` being updated. */
  patch: UpdateZoneDescriptionOnZoneDescriptionForZoneDescriptionZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneDescription`. Fields that are set will be updated. */
export type ZoneDescriptionPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneDescriptionZoneIdFkeyInput>;
};

/** The fields on `zoneDescription` to look up the row to connect. */
export type ZoneDescriptionZoneDescriptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneDescription` to look up the row to delete. */
export type ZoneDescriptionZoneDescriptionPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `zone` in the `ZoneDescriptionInput` mutation. */
export type ZoneDescriptionZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneDescriptionZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneDescription` in the `ZoneInput` mutation. */
export type ZoneDescriptionZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneDescription` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneDescriptionZoneDescriptionPkeyConnect>>;
  /** A `ZoneDescriptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneDescriptionZoneIdFkeyZoneDescriptionCreateInput>>;
  /** The primary key(s) for `zoneDescription` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneDescriptionZoneDescriptionPkeyDelete>>;
  /** Flag indicating whether all other `zoneDescription` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneDescription` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneDescriptionOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZoneDescriptionPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneDescriptionZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneDescription` to be created by this mutation. */
export type ZoneDescriptionZoneIdFkeyZoneDescriptionCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneDescriptionZoneIdFkeyInput>;
};

/** A connection to a list of `ZoneDescription` values. */
export type ZoneDescriptionsConnection = {
  __typename?: 'ZoneDescriptionsConnection';
  /** A list of edges which contains the `ZoneDescription` and cursor to aid in pagination. */
  edges: Array<ZoneDescriptionsEdge>;
  /** A list of `ZoneDescription` objects. */
  nodes: Array<ZoneDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneDescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneDescription` edge in the connection. */
export type ZoneDescriptionsEdge = {
  __typename?: 'ZoneDescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneDescription` at the end of the edge. */
  node: ZoneDescription;
};

/** Methods to use when ordering `ZoneDescription`. */
export enum ZoneDescriptionsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** A filter to be used against `Zone` object types. All fields are combined with a logical ‘and.’ */
export type ZoneFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneFilter>>;
  /** Filter by the object’s `areas` relation. */
  areas?: InputMaybe<ZoneToManyAreaFilter>;
  /** Some related `areas` exist. */
  areasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extId` field. */
  extId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nameLong` field. */
  nameLong?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameShort` field. */
  nameShort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneFilter>>;
  /** Filter by the object’s `site` relation. */
  site?: InputMaybe<SiteFilter>;
  /** Filter by the object’s `siteId` field. */
  siteId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<ZoneTypeFilter>;
  /** A related `type` exists. */
  typeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `zoneCadGrossSpaceMins` relation. */
  zoneCadGrossSpaceMins?: InputMaybe<ZoneToManyZoneCadGrossSpaceMinFilter>;
  /** Some related `zoneCadGrossSpaceMins` exist. */
  zoneCadGrossSpaceMinsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneCapacityCars` relation. */
  zoneCapacityCars?: InputMaybe<ZoneToManyZoneCapacityCarFilter>;
  /** Some related `zoneCapacityCars` exist. */
  zoneCapacityCarsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneCapacityTrucks` relation. */
  zoneCapacityTrucks?: InputMaybe<ZoneToManyZoneCapacityTruckFilter>;
  /** Some related `zoneCapacityTrucks` exist. */
  zoneCapacityTrucksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneDescriptions` relation. */
  zoneDescriptions?: InputMaybe<ZoneToManyZoneDescriptionFilter>;
  /** Some related `zoneDescriptions` exist. */
  zoneDescriptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneMaxLoadFloors` relation. */
  zoneMaxLoadFloors?: InputMaybe<ZoneToManyZoneMaxLoadFloorFilter>;
  /** Some related `zoneMaxLoadFloors` exist. */
  zoneMaxLoadFloorsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameExtras` relation. */
  zoneNameExtras?: InputMaybe<ZoneToManyZoneNameExtraFilter>;
  /** Some related `zoneNameExtras` exist. */
  zoneNameExtrasExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameKeyCads` relation. */
  zoneNameKeyCads?: InputMaybe<ZoneToManyZoneNameKeyCadFilter>;
  /** Some related `zoneNameKeyCads` exist. */
  zoneNameKeyCadsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameKeyCafms` relation. */
  zoneNameKeyCafms?: InputMaybe<ZoneToManyZoneNameKeyCafmFilter>;
  /** Some related `zoneNameKeyCafms` exist. */
  zoneNameKeyCafmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameKeyEbms` relation. */
  zoneNameKeyEbms?: InputMaybe<ZoneToManyZoneNameKeyEbmFilter>;
  /** Some related `zoneNameKeyEbms` exist. */
  zoneNameKeyEbmsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameKeyMarketings` relation. */
  zoneNameKeyMarketings?: InputMaybe<ZoneToManyZoneNameKeyMarketingFilter>;
  /** Some related `zoneNameKeyMarketings` exist. */
  zoneNameKeyMarketingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameLongs` relation. */
  zoneNameLongs?: InputMaybe<ZoneToManyZoneNameLongFilter>;
  /** Some related `zoneNameLongs` exist. */
  zoneNameLongsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNameShorts` relation. */
  zoneNameShorts?: InputMaybe<ZoneToManyZoneNameShortFilter>;
  /** Some related `zoneNameShorts` exist. */
  zoneNameShortsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneNoVehicles` relation. */
  zoneNoVehicles?: InputMaybe<ZoneToManyZoneNoVehicleFilter>;
  /** Some related `zoneNoVehicles` exist. */
  zoneNoVehiclesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zonePublicGrossSpaces` relation. */
  zonePublicGrossSpaces?: InputMaybe<ZoneToManyZonePublicGrossSpaceFilter>;
  /** Some related `zonePublicGrossSpaces` exist. */
  zonePublicGrossSpacesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneTireLoadCars` relation. */
  zoneTireLoadCars?: InputMaybe<ZoneToManyZoneTireLoadCarFilter>;
  /** Some related `zoneTireLoadCars` exist. */
  zoneTireLoadCarsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneTireLoadForklifts` relation. */
  zoneTireLoadForklifts?: InputMaybe<ZoneToManyZoneTireLoadForkliftFilter>;
  /** Some related `zoneTireLoadForklifts` exist. */
  zoneTireLoadForkliftsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneTireLoadTrucks` relation. */
  zoneTireLoadTrucks?: InputMaybe<ZoneToManyZoneTireLoadTruckFilter>;
  /** Some related `zoneTireLoadTrucks` exist. */
  zoneTireLoadTrucksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zoneTypeAttrs` relation. */
  zoneTypeAttrs?: InputMaybe<ZoneToManyZoneTypeAttrFilter>;
  /** Some related `zoneTypeAttrs` exist. */
  zoneTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Zone` */
export type ZoneInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

export type ZoneMaxLoadFloor = {
  __typename?: 'ZoneMaxLoadFloor';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  /** Reads a single `Zone` that is related to this `ZoneMaxLoadFloor`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneMaxLoadFloor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneMaxLoadFloorCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneMaxLoadFloor` object types. All fields are combined with a logical ‘and.’ */
export type ZoneMaxLoadFloorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneMaxLoadFloorFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneMaxLoadFloorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneMaxLoadFloorFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneMaxLoadFloor` */
export type ZoneMaxLoadFloorInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInput>;
};

/** The fields on `zoneMaxLoadFloor` to look up the row to update. */
export type ZoneMaxLoadFloorOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZoneMaxLoadFloorPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneMaxLoadFloor` being updated. */
  patch: UpdateZoneMaxLoadFloorOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneMaxLoadFloor`. Fields that are set will be updated. */
export type ZoneMaxLoadFloorPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneMaxLoadFloorInput` mutation. */
export type ZoneMaxLoadFloorZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneMaxLoadFloor` in the `ZoneInput` mutation. */
export type ZoneMaxLoadFloorZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneMaxLoadFloor` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneMaxLoadFloorZoneMaxLoadFloorPkeyConnect>>;
  /** A `ZoneMaxLoadFloorInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneMaxLoadFloorZoneIdFkeyZoneMaxLoadFloorCreateInput>>;
  /** The primary key(s) for `zoneMaxLoadFloor` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneMaxLoadFloorZoneMaxLoadFloorPkeyDelete>>;
  /** Flag indicating whether all other `zoneMaxLoadFloor` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneMaxLoadFloor` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneMaxLoadFloorOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZoneMaxLoadFloorPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneMaxLoadFloorZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneMaxLoadFloor` to be created by this mutation. */
export type ZoneMaxLoadFloorZoneIdFkeyZoneMaxLoadFloorCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneToZoneId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInput>;
};

/** The fields on `zoneMaxLoadFloor` to look up the row to connect. */
export type ZoneMaxLoadFloorZoneMaxLoadFloorPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneMaxLoadFloor` to look up the row to delete. */
export type ZoneMaxLoadFloorZoneMaxLoadFloorPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneMaxLoadFloor` values. */
export type ZoneMaxLoadFloorsConnection = {
  __typename?: 'ZoneMaxLoadFloorsConnection';
  /** A list of edges which contains the `ZoneMaxLoadFloor` and cursor to aid in pagination. */
  edges: Array<ZoneMaxLoadFloorsEdge>;
  /** A list of `ZoneMaxLoadFloor` objects. */
  nodes: Array<ZoneMaxLoadFloor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneMaxLoadFloor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneMaxLoadFloor` edge in the connection. */
export type ZoneMaxLoadFloorsEdge = {
  __typename?: 'ZoneMaxLoadFloorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneMaxLoadFloor` at the end of the edge. */
  node: ZoneMaxLoadFloor;
};

/** Methods to use when ordering `ZoneMaxLoadFloor`. */
export enum ZoneMaxLoadFloorsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNameExtra = {
  __typename?: 'ZoneNameExtra';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameExtra`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameExtra` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameExtraCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameExtraFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameExtraFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameExtraFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameExtraFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameExtra` */
export type ZoneNameExtraInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameExtraZoneIdFkeyInput>;
};

/** The fields on `zoneNameExtra` to look up the row to update. */
export type ZoneNameExtraOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZoneNameExtraPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameExtra` being updated. */
  patch: UpdateZoneNameExtraOnZoneNameExtraForZoneNameExtraZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameExtra`. Fields that are set will be updated. */
export type ZoneNameExtraPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameExtraZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneNameExtraInput` mutation. */
export type ZoneNameExtraZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameExtraZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameExtra` in the `ZoneInput` mutation. */
export type ZoneNameExtraZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameExtra` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameExtraZoneNameExtraPkeyConnect>>;
  /** A `ZoneNameExtraInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameExtraZoneIdFkeyZoneNameExtraCreateInput>>;
  /** The primary key(s) for `zoneNameExtra` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameExtraZoneNameExtraPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameExtra` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameExtra` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameExtraOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZoneNameExtraPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameExtraZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameExtra` to be created by this mutation. */
export type ZoneNameExtraZoneIdFkeyZoneNameExtraCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameExtraZoneIdFkeyInput>;
};

/** The fields on `zoneNameExtra` to look up the row to connect. */
export type ZoneNameExtraZoneNameExtraPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameExtra` to look up the row to delete. */
export type ZoneNameExtraZoneNameExtraPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameExtra` values. */
export type ZoneNameExtrasConnection = {
  __typename?: 'ZoneNameExtrasConnection';
  /** A list of edges which contains the `ZoneNameExtra` and cursor to aid in pagination. */
  edges: Array<ZoneNameExtrasEdge>;
  /** A list of `ZoneNameExtra` objects. */
  nodes: Array<ZoneNameExtra>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameExtra` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameExtra` edge in the connection. */
export type ZoneNameExtrasEdge = {
  __typename?: 'ZoneNameExtrasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameExtra` at the end of the edge. */
  node: ZoneNameExtra;
};

/** Methods to use when ordering `ZoneNameExtra`. */
export enum ZoneNameExtrasOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNameKeyCad = {
  __typename?: 'ZoneNameKeyCad';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCad`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameKeyCad` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameKeyCadCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameKeyCadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameKeyCadFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameKeyCadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameKeyCadFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameKeyCad` */
export type ZoneNameKeyCadInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyCad` to look up the row to update. */
export type ZoneNameKeyCadOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZoneNameKeyCadPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameKeyCad` being updated. */
  patch: UpdateZoneNameKeyCadOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameKeyCad`. Fields that are set will be updated. */
export type ZoneNameKeyCadPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneNameKeyCadInput` mutation. */
export type ZoneNameKeyCadZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameKeyCadZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameKeyCad` in the `ZoneInput` mutation. */
export type ZoneNameKeyCadZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameKeyCad` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameKeyCadZoneNameKeyCadPkeyConnect>>;
  /** A `ZoneNameKeyCadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameKeyCadZoneIdFkeyZoneNameKeyCadCreateInput>>;
  /** The primary key(s) for `zoneNameKeyCad` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameKeyCadZoneNameKeyCadPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameKeyCad` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameKeyCad` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameKeyCadOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZoneNameKeyCadPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameKeyCadZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameKeyCad` to be created by this mutation. */
export type ZoneNameKeyCadZoneIdFkeyZoneNameKeyCadCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyCad` to look up the row to connect. */
export type ZoneNameKeyCadZoneNameKeyCadPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameKeyCad` to look up the row to delete. */
export type ZoneNameKeyCadZoneNameKeyCadPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameKeyCad` values. */
export type ZoneNameKeyCadsConnection = {
  __typename?: 'ZoneNameKeyCadsConnection';
  /** A list of edges which contains the `ZoneNameKeyCad` and cursor to aid in pagination. */
  edges: Array<ZoneNameKeyCadsEdge>;
  /** A list of `ZoneNameKeyCad` objects. */
  nodes: Array<ZoneNameKeyCad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameKeyCad` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameKeyCad` edge in the connection. */
export type ZoneNameKeyCadsEdge = {
  __typename?: 'ZoneNameKeyCadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameKeyCad` at the end of the edge. */
  node: ZoneNameKeyCad;
};

/** Methods to use when ordering `ZoneNameKeyCad`. */
export enum ZoneNameKeyCadsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNameKeyCafm = {
  __typename?: 'ZoneNameKeyCafm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameKeyCafm`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameKeyCafm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameKeyCafmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameKeyCafmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameKeyCafmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameKeyCafmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameKeyCafmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameKeyCafm` */
export type ZoneNameKeyCafmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyCafm` to look up the row to update. */
export type ZoneNameKeyCafmOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZoneNameKeyCafmPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameKeyCafm` being updated. */
  patch: UpdateZoneNameKeyCafmOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameKeyCafm`. Fields that are set will be updated. */
export type ZoneNameKeyCafmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneNameKeyCafmInput` mutation. */
export type ZoneNameKeyCafmZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameKeyCafm` in the `ZoneInput` mutation. */
export type ZoneNameKeyCafmZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameKeyCafm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameKeyCafmZoneNameKeyCafmPkeyConnect>>;
  /** A `ZoneNameKeyCafmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameKeyCafmZoneIdFkeyZoneNameKeyCafmCreateInput>>;
  /** The primary key(s) for `zoneNameKeyCafm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameKeyCafmZoneNameKeyCafmPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameKeyCafm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameKeyCafm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameKeyCafmOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZoneNameKeyCafmPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameKeyCafmZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameKeyCafm` to be created by this mutation. */
export type ZoneNameKeyCafmZoneIdFkeyZoneNameKeyCafmCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyCafm` to look up the row to connect. */
export type ZoneNameKeyCafmZoneNameKeyCafmPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameKeyCafm` to look up the row to delete. */
export type ZoneNameKeyCafmZoneNameKeyCafmPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameKeyCafm` values. */
export type ZoneNameKeyCafmsConnection = {
  __typename?: 'ZoneNameKeyCafmsConnection';
  /** A list of edges which contains the `ZoneNameKeyCafm` and cursor to aid in pagination. */
  edges: Array<ZoneNameKeyCafmsEdge>;
  /** A list of `ZoneNameKeyCafm` objects. */
  nodes: Array<ZoneNameKeyCafm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameKeyCafm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameKeyCafm` edge in the connection. */
export type ZoneNameKeyCafmsEdge = {
  __typename?: 'ZoneNameKeyCafmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameKeyCafm` at the end of the edge. */
  node: ZoneNameKeyCafm;
};

/** Methods to use when ordering `ZoneNameKeyCafm`. */
export enum ZoneNameKeyCafmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNameKeyEbm = {
  __typename?: 'ZoneNameKeyEbm';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameKeyEbm`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameKeyEbm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameKeyEbmCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameKeyEbmFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameKeyEbmFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameKeyEbmFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameKeyEbmFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameKeyEbm` */
export type ZoneNameKeyEbmInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyEbm` to look up the row to update. */
export type ZoneNameKeyEbmOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZoneNameKeyEbmsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameKeyEbm` being updated. */
  patch: UpdateZoneNameKeyEbmOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameKeyEbm`. Fields that are set will be updated. */
export type ZoneNameKeyEbmPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyEbm` to look up the row to connect. */
export type ZoneNameKeyEbmZoneNameKeyEbmsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameKeyEbm` to look up the row to delete. */
export type ZoneNameKeyEbmZoneNameKeyEbmsPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameKeyEbm` values. */
export type ZoneNameKeyEbmsConnection = {
  __typename?: 'ZoneNameKeyEbmsConnection';
  /** A list of edges which contains the `ZoneNameKeyEbm` and cursor to aid in pagination. */
  edges: Array<ZoneNameKeyEbmsEdge>;
  /** A list of `ZoneNameKeyEbm` objects. */
  nodes: Array<ZoneNameKeyEbm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameKeyEbm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameKeyEbm` edge in the connection. */
export type ZoneNameKeyEbmsEdge = {
  __typename?: 'ZoneNameKeyEbmsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameKeyEbm` at the end of the edge. */
  node: ZoneNameKeyEbm;
};

/** Methods to use when ordering `ZoneNameKeyEbm`. */
export enum ZoneNameKeyEbmsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** Input for the nested mutation of `zone` in the `ZoneNameKeyEbmInput` mutation. */
export type ZoneNameKeyEbmsZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameKeyEbm` in the `ZoneInput` mutation. */
export type ZoneNameKeyEbmsZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameKeyEbm` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameKeyEbmZoneNameKeyEbmsPkeyConnect>>;
  /** A `ZoneNameKeyEbmInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameKeyEbmsZoneIdFkeyZoneNameKeyEbmsCreateInput>>;
  /** The primary key(s) for `zoneNameKeyEbm` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameKeyEbmZoneNameKeyEbmsPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameKeyEbm` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameKeyEbm` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameKeyEbmOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZoneNameKeyEbmsPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameKeyEbmsZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameKeyEbm` to be created by this mutation. */
export type ZoneNameKeyEbmsZoneIdFkeyZoneNameKeyEbmsCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInput>;
};

export type ZoneNameKeyMarketing = {
  __typename?: 'ZoneNameKeyMarketing';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameKeyMarketing`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameKeyMarketing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameKeyMarketingCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameKeyMarketingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameKeyMarketingFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameKeyMarketingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameKeyMarketingFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameKeyMarketing` */
export type ZoneNameKeyMarketingInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyMarketing` to look up the row to update. */
export type ZoneNameKeyMarketingOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZoneNameKeyMarketingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameKeyMarketing` being updated. */
  patch: UpdateZoneNameKeyMarketingOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameKeyMarketing`. Fields that are set will be updated. */
export type ZoneNameKeyMarketingPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneNameKeyMarketingInput` mutation. */
export type ZoneNameKeyMarketingZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameKeyMarketing` in the `ZoneInput` mutation. */
export type ZoneNameKeyMarketingZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameKeyMarketing` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameKeyMarketingZoneNameKeyMarketingPkeyConnect>>;
  /** A `ZoneNameKeyMarketingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameKeyMarketingZoneIdFkeyZoneNameKeyMarketingCreateInput>>;
  /** The primary key(s) for `zoneNameKeyMarketing` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameKeyMarketingZoneNameKeyMarketingPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameKeyMarketing` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameKeyMarketing` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameKeyMarketingOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZoneNameKeyMarketingPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameKeyMarketingZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameKeyMarketing` to be created by this mutation. */
export type ZoneNameKeyMarketingZoneIdFkeyZoneNameKeyMarketingCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInput>;
};

/** The fields on `zoneNameKeyMarketing` to look up the row to connect. */
export type ZoneNameKeyMarketingZoneNameKeyMarketingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameKeyMarketing` to look up the row to delete. */
export type ZoneNameKeyMarketingZoneNameKeyMarketingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameKeyMarketing` values. */
export type ZoneNameKeyMarketingsConnection = {
  __typename?: 'ZoneNameKeyMarketingsConnection';
  /** A list of edges which contains the `ZoneNameKeyMarketing` and cursor to aid in pagination. */
  edges: Array<ZoneNameKeyMarketingsEdge>;
  /** A list of `ZoneNameKeyMarketing` objects. */
  nodes: Array<ZoneNameKeyMarketing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameKeyMarketing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameKeyMarketing` edge in the connection. */
export type ZoneNameKeyMarketingsEdge = {
  __typename?: 'ZoneNameKeyMarketingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameKeyMarketing` at the end of the edge. */
  node: ZoneNameKeyMarketing;
};

/** Methods to use when ordering `ZoneNameKeyMarketing`. */
export enum ZoneNameKeyMarketingsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNameLong = {
  __typename?: 'ZoneNameLong';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameLong`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameLong` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameLongCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameLong` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameLongFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameLongFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameLongFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameLongFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameLong` */
export type ZoneNameLongInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameLongZoneIdFkeyInput>;
};

/** The fields on `zoneNameLong` to look up the row to update. */
export type ZoneNameLongOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZoneNameLongPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameLong` being updated. */
  patch: UpdateZoneNameLongOnZoneNameLongForZoneNameLongZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameLong`. Fields that are set will be updated. */
export type ZoneNameLongPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameLongZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneNameLongInput` mutation. */
export type ZoneNameLongZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameLongZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameLong` in the `ZoneInput` mutation. */
export type ZoneNameLongZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameLong` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameLongZoneNameLongPkeyConnect>>;
  /** A `ZoneNameLongInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameLongZoneIdFkeyZoneNameLongCreateInput>>;
  /** The primary key(s) for `zoneNameLong` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameLongZoneNameLongPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameLong` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameLong` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameLongOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZoneNameLongPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameLongZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameLong` to be created by this mutation. */
export type ZoneNameLongZoneIdFkeyZoneNameLongCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameLongZoneIdFkeyInput>;
};

/** The fields on `zoneNameLong` to look up the row to connect. */
export type ZoneNameLongZoneNameLongPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameLong` to look up the row to delete. */
export type ZoneNameLongZoneNameLongPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameLong` values. */
export type ZoneNameLongsConnection = {
  __typename?: 'ZoneNameLongsConnection';
  /** A list of edges which contains the `ZoneNameLong` and cursor to aid in pagination. */
  edges: Array<ZoneNameLongsEdge>;
  /** A list of `ZoneNameLong` objects. */
  nodes: Array<ZoneNameLong>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameLong` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameLong` edge in the connection. */
export type ZoneNameLongsEdge = {
  __typename?: 'ZoneNameLongsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameLong` at the end of the edge. */
  node: ZoneNameLong;
};

/** Methods to use when ordering `ZoneNameLong`. */
export enum ZoneNameLongsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNameShort = {
  __typename?: 'ZoneNameShort';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['String'];
  /** Reads a single `Zone` that is related to this `ZoneNameShort`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNameShort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNameShortCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNameShort` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNameShortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNameShortFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNameShortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNameShortFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNameShort` */
export type ZoneNameShortInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameShortZoneIdFkeyInput>;
};

/** The fields on `zoneNameShort` to look up the row to update. */
export type ZoneNameShortOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZoneNameShortPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNameShort` being updated. */
  patch: UpdateZoneNameShortOnZoneNameShortForZoneNameShortZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNameShort`. Fields that are set will be updated. */
export type ZoneNameShortPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNameShortZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneNameShortInput` mutation. */
export type ZoneNameShortZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNameShortZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNameShort` in the `ZoneInput` mutation. */
export type ZoneNameShortZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNameShort` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNameShortZoneNameShortPkeyConnect>>;
  /** A `ZoneNameShortInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNameShortZoneIdFkeyZoneNameShortCreateInput>>;
  /** The primary key(s) for `zoneNameShort` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNameShortZoneNameShortPkeyDelete>>;
  /** Flag indicating whether all other `zoneNameShort` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNameShort` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNameShortOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZoneNameShortPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNameShortZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNameShort` to be created by this mutation. */
export type ZoneNameShortZoneIdFkeyZoneNameShortCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
  zoneToZoneId?: InputMaybe<ZoneNameShortZoneIdFkeyInput>;
};

/** The fields on `zoneNameShort` to look up the row to connect. */
export type ZoneNameShortZoneNameShortPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNameShort` to look up the row to delete. */
export type ZoneNameShortZoneNameShortPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNameShort` values. */
export type ZoneNameShortsConnection = {
  __typename?: 'ZoneNameShortsConnection';
  /** A list of edges which contains the `ZoneNameShort` and cursor to aid in pagination. */
  edges: Array<ZoneNameShortsEdge>;
  /** A list of `ZoneNameShort` objects. */
  nodes: Array<ZoneNameShort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNameShort` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNameShort` edge in the connection. */
export type ZoneNameShortsEdge = {
  __typename?: 'ZoneNameShortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNameShort` at the end of the edge. */
  node: ZoneNameShort;
};

/** Methods to use when ordering `ZoneNameShort`. */
export enum ZoneNameShortsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneNoVehicle = {
  __typename?: 'ZoneNoVehicle';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Zone` that is related to this `ZoneNoVehicle`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneNoVehicle` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneNoVehicleCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneNoVehicle` object types. All fields are combined with a logical ‘and.’ */
export type ZoneNoVehicleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneNoVehicleFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneNoVehicleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneNoVehicleFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneNoVehicle` */
export type ZoneNoVehicleInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInput>;
};

/** The fields on `zoneNoVehicle` to look up the row to update. */
export type ZoneNoVehicleOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZoneNoVehiclesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneNoVehicle` being updated. */
  patch: UpdateZoneNoVehicleOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneNoVehicle`. Fields that are set will be updated. */
export type ZoneNoVehiclePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInput>;
};

/** The fields on `zoneNoVehicle` to look up the row to connect. */
export type ZoneNoVehicleZoneNoVehiclesPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneNoVehicle` to look up the row to delete. */
export type ZoneNoVehicleZoneNoVehiclesPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneNoVehicle` values. */
export type ZoneNoVehiclesConnection = {
  __typename?: 'ZoneNoVehiclesConnection';
  /** A list of edges which contains the `ZoneNoVehicle` and cursor to aid in pagination. */
  edges: Array<ZoneNoVehiclesEdge>;
  /** A list of `ZoneNoVehicle` objects. */
  nodes: Array<ZoneNoVehicle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneNoVehicle` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneNoVehicle` edge in the connection. */
export type ZoneNoVehiclesEdge = {
  __typename?: 'ZoneNoVehiclesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneNoVehicle` at the end of the edge. */
  node: ZoneNoVehicle;
};

/** Methods to use when ordering `ZoneNoVehicle`. */
export enum ZoneNoVehiclesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** Input for the nested mutation of `zone` in the `ZoneNoVehicleInput` mutation. */
export type ZoneNoVehiclesZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneNoVehiclesZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneNoVehicle` in the `ZoneInput` mutation. */
export type ZoneNoVehiclesZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneNoVehicle` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneNoVehicleZoneNoVehiclesPkeyConnect>>;
  /** A `ZoneNoVehicleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneNoVehiclesZoneIdFkeyZoneNoVehiclesCreateInput>>;
  /** The primary key(s) for `zoneNoVehicle` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneNoVehicleZoneNoVehiclesPkeyDelete>>;
  /** Flag indicating whether all other `zoneNoVehicle` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneNoVehicle` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneNoVehicleOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZoneNoVehiclesPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneNoVehiclesZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneNoVehicle` to be created by this mutation. */
export type ZoneNoVehiclesZoneIdFkeyZoneNoVehiclesCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
  zoneToZoneId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInput>;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnAreaForAreaZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnAreaForAreaZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnAreaForAreaZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnAreaForAreaZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnAreaForAreaZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnAreaForAreaZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneForZoneSiteIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneForZoneSiteIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneForZoneSiteIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneForZoneSiteIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneForZoneSiteIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneForZoneSiteIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneForZoneTypeIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneForZoneTypeIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneForZoneTypeIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneForZoneTypeIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneForZoneTypeIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneForZoneTypeIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameLongForZoneNameLongZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameLongForZoneNameLongZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameLongForZoneNameLongZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameLongForZoneNameLongZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameShortForZoneNameShortZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameShortForZoneNameShortZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNameShortForZoneNameShortZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNameShortForZoneNameShortZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZoneExtIdKeyUpdate = {
  extId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZoneNameShortKeyUpdate = {
  nameShort: Scalars['String'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyPatch;
};

/** The fields on `zone` to look up the row to update. */
export type ZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZonePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zone` being updated. */
  patch: UpdateZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyPatch;
};

/** Represents an update to a `Zone`. Fields that are set will be updated. */
export type ZonePatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

export type ZonePublicGrossSpace = {
  __typename?: 'ZonePublicGrossSpace';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  /** Reads a single `Zone` that is related to this `ZonePublicGrossSpace`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZonePublicGrossSpace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ZonePublicGrossSpaceCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZonePublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type ZonePublicGrossSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZonePublicGrossSpaceFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZonePublicGrossSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZonePublicGrossSpaceFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZonePublicGrossSpace` */
export type ZonePublicGrossSpaceInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInput>;
};

/** The fields on `zonePublicGrossSpace` to look up the row to update. */
export type ZonePublicGrossSpaceOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZonePublicGrossSpacePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zonePublicGrossSpace` being updated. */
  patch: UpdateZonePublicGrossSpaceOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyPatch;
};

/** Represents an update to a `ZonePublicGrossSpace`. Fields that are set will be updated. */
export type ZonePublicGrossSpacePatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZonePublicGrossSpaceInput` mutation. */
export type ZonePublicGrossSpaceZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zonePublicGrossSpace` in the `ZoneInput` mutation. */
export type ZonePublicGrossSpaceZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zonePublicGrossSpace` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZonePublicGrossSpaceZonePublicGrossSpacePkeyConnect>>;
  /** A `ZonePublicGrossSpaceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZonePublicGrossSpaceZoneIdFkeyZonePublicGrossSpaceCreateInput>>;
  /** The primary key(s) for `zonePublicGrossSpace` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZonePublicGrossSpaceZonePublicGrossSpacePkeyDelete>>;
  /** Flag indicating whether all other `zonePublicGrossSpace` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zonePublicGrossSpace` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZonePublicGrossSpaceOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyUsingZonePublicGrossSpacePkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZonePublicGrossSpaceZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zonePublicGrossSpace` to be created by this mutation. */
export type ZonePublicGrossSpaceZoneIdFkeyZonePublicGrossSpaceCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneToZoneId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInput>;
};

/** The fields on `zonePublicGrossSpace` to look up the row to connect. */
export type ZonePublicGrossSpaceZonePublicGrossSpacePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zonePublicGrossSpace` to look up the row to delete. */
export type ZonePublicGrossSpaceZonePublicGrossSpacePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZonePublicGrossSpace` values. */
export type ZonePublicGrossSpacesConnection = {
  __typename?: 'ZonePublicGrossSpacesConnection';
  /** A list of edges which contains the `ZonePublicGrossSpace` and cursor to aid in pagination. */
  edges: Array<ZonePublicGrossSpacesEdge>;
  /** A list of `ZonePublicGrossSpace` objects. */
  nodes: Array<ZonePublicGrossSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZonePublicGrossSpace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZonePublicGrossSpace` edge in the connection. */
export type ZonePublicGrossSpacesEdge = {
  __typename?: 'ZonePublicGrossSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZonePublicGrossSpace` at the end of the edge. */
  node: ZonePublicGrossSpace;
};

/** Methods to use when ordering `ZonePublicGrossSpace`. */
export enum ZonePublicGrossSpacesOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** Input for the nested mutation of `site` in the `ZoneInput` mutation. */
export type ZoneSiteIdFkeyInput = {
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByExtId?: InputMaybe<SiteSiteExtIdKeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectById?: InputMaybe<SiteSitePkeyConnect>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<SiteSiteNameShortKeyConnect>;
  /** A `SiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneSiteIdFkeySiteCreateInput>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<SiteSiteExtIdKeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteById?: InputMaybe<SiteSitePkeyDelete>;
  /** The primary key(s) for `site` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<SiteSiteNameShortKeyDelete>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByExtId?: InputMaybe<SiteOnZoneForZoneSiteIdFkeyUsingSiteExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateById?: InputMaybe<SiteOnZoneForZoneSiteIdFkeyUsingSitePkeyUpdate>;
  /** The primary key(s) and patch data for `site` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<SiteOnZoneForZoneSiteIdFkeyUsingSiteNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zone` in the `SiteInput` mutation. */
export type ZoneSiteIdFkeyInverseInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<ZoneZoneExtIdKeyConnect>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneZonePkeyConnect>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ZoneZoneNameShortKeyConnect>>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneSiteIdFkeyZoneCreateInput>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<ZoneZoneExtIdKeyDelete>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneZonePkeyDelete>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ZoneZoneNameShortKeyDelete>>;
  /** Flag indicating whether all other `zone` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<ZoneOnZoneForZoneSiteIdFkeyUsingZoneExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneOnZoneForZoneSiteIdFkeyUsingZonePkeyUpdate>>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ZoneOnZoneForZoneSiteIdFkeyUsingZoneNameShortKeyUpdate>>;
};

/** The `site` to be created by this mutation. */
export type ZoneSiteIdFkeySiteCreateInput = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** The `zone` to be created by this mutation. */
export type ZoneSiteIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

export type ZoneTireLoadCar = {
  __typename?: 'ZoneTireLoadCar';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  /** Reads a single `Zone` that is related to this `ZoneTireLoadCar`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneTireLoadCar` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneTireLoadCarCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneTireLoadCar` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTireLoadCarFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneTireLoadCarFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneTireLoadCarFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneTireLoadCarFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneTireLoadCar` */
export type ZoneTireLoadCarInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInput>;
};

/** The fields on `zoneTireLoadCar` to look up the row to update. */
export type ZoneTireLoadCarOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZoneTireLoadCarPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneTireLoadCar` being updated. */
  patch: UpdateZoneTireLoadCarOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneTireLoadCar`. Fields that are set will be updated. */
export type ZoneTireLoadCarPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneTireLoadCarInput` mutation. */
export type ZoneTireLoadCarZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneTireLoadCarZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneTireLoadCar` in the `ZoneInput` mutation. */
export type ZoneTireLoadCarZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneTireLoadCar` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneTireLoadCarZoneTireLoadCarPkeyConnect>>;
  /** A `ZoneTireLoadCarInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneTireLoadCarZoneIdFkeyZoneTireLoadCarCreateInput>>;
  /** The primary key(s) for `zoneTireLoadCar` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneTireLoadCarZoneTireLoadCarPkeyDelete>>;
  /** Flag indicating whether all other `zoneTireLoadCar` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneTireLoadCar` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneTireLoadCarOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyUsingZoneTireLoadCarPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneTireLoadCarZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneTireLoadCar` to be created by this mutation. */
export type ZoneTireLoadCarZoneIdFkeyZoneTireLoadCarCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneToZoneId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInput>;
};

/** The fields on `zoneTireLoadCar` to look up the row to connect. */
export type ZoneTireLoadCarZoneTireLoadCarPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneTireLoadCar` to look up the row to delete. */
export type ZoneTireLoadCarZoneTireLoadCarPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneTireLoadCar` values. */
export type ZoneTireLoadCarsConnection = {
  __typename?: 'ZoneTireLoadCarsConnection';
  /** A list of edges which contains the `ZoneTireLoadCar` and cursor to aid in pagination. */
  edges: Array<ZoneTireLoadCarsEdge>;
  /** A list of `ZoneTireLoadCar` objects. */
  nodes: Array<ZoneTireLoadCar>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneTireLoadCar` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneTireLoadCar` edge in the connection. */
export type ZoneTireLoadCarsEdge = {
  __typename?: 'ZoneTireLoadCarsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneTireLoadCar` at the end of the edge. */
  node: ZoneTireLoadCar;
};

/** Methods to use when ordering `ZoneTireLoadCar`. */
export enum ZoneTireLoadCarsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneTireLoadForklift = {
  __typename?: 'ZoneTireLoadForklift';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  /** Reads a single `Zone` that is related to this `ZoneTireLoadForklift`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneTireLoadForklift` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ZoneTireLoadForkliftCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneTireLoadForklift` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTireLoadForkliftFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneTireLoadForkliftFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneTireLoadForkliftFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneTireLoadForkliftFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneTireLoadForklift` */
export type ZoneTireLoadForkliftInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInput>;
};

/** The fields on `zoneTireLoadForklift` to look up the row to update. */
export type ZoneTireLoadForkliftOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZoneTireLoadForkliftPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneTireLoadForklift` being updated. */
  patch: UpdateZoneTireLoadForkliftOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneTireLoadForklift`. Fields that are set will be updated. */
export type ZoneTireLoadForkliftPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneTireLoadForkliftInput` mutation. */
export type ZoneTireLoadForkliftZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneTireLoadForklift` in the `ZoneInput` mutation. */
export type ZoneTireLoadForkliftZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneTireLoadForklift` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneTireLoadForkliftZoneTireLoadForkliftPkeyConnect>>;
  /** A `ZoneTireLoadForkliftInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneTireLoadForkliftZoneIdFkeyZoneTireLoadForkliftCreateInput>>;
  /** The primary key(s) for `zoneTireLoadForklift` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneTireLoadForkliftZoneTireLoadForkliftPkeyDelete>>;
  /** Flag indicating whether all other `zoneTireLoadForklift` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneTireLoadForklift` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneTireLoadForkliftOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyUsingZoneTireLoadForkliftPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneTireLoadForkliftZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneTireLoadForklift` to be created by this mutation. */
export type ZoneTireLoadForkliftZoneIdFkeyZoneTireLoadForkliftCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneToZoneId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInput>;
};

/** The fields on `zoneTireLoadForklift` to look up the row to connect. */
export type ZoneTireLoadForkliftZoneTireLoadForkliftPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneTireLoadForklift` to look up the row to delete. */
export type ZoneTireLoadForkliftZoneTireLoadForkliftPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneTireLoadForklift` values. */
export type ZoneTireLoadForkliftsConnection = {
  __typename?: 'ZoneTireLoadForkliftsConnection';
  /** A list of edges which contains the `ZoneTireLoadForklift` and cursor to aid in pagination. */
  edges: Array<ZoneTireLoadForkliftsEdge>;
  /** A list of `ZoneTireLoadForklift` objects. */
  nodes: Array<ZoneTireLoadForklift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneTireLoadForklift` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneTireLoadForklift` edge in the connection. */
export type ZoneTireLoadForkliftsEdge = {
  __typename?: 'ZoneTireLoadForkliftsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneTireLoadForklift` at the end of the edge. */
  node: ZoneTireLoadForklift;
};

/** Methods to use when ordering `ZoneTireLoadForklift`. */
export enum ZoneTireLoadForkliftsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type ZoneTireLoadTruck = {
  __typename?: 'ZoneTireLoadTruck';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  /** Reads a single `Zone` that is related to this `ZoneTireLoadTruck`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneTireLoadTruck` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneTireLoadTruckCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneTireLoadTruck` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTireLoadTruckFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneTireLoadTruckFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneTireLoadTruckFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneTireLoadTruckFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneTireLoadTruck` */
export type ZoneTireLoadTruckInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInput>;
};

/** The fields on `zoneTireLoadTruck` to look up the row to update. */
export type ZoneTireLoadTruckOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZoneTireLoadTruckPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneTireLoadTruck` being updated. */
  patch: UpdateZoneTireLoadTruckOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyPatch;
};

/** Represents an update to a `ZoneTireLoadTruck`. Fields that are set will be updated. */
export type ZoneTireLoadTruckPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneTireLoadTruckInput` mutation. */
export type ZoneTireLoadTruckZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneTireLoadTruck` in the `ZoneInput` mutation. */
export type ZoneTireLoadTruckZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneTireLoadTruck` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneTireLoadTruckZoneTireLoadTruckPkeyConnect>>;
  /** A `ZoneTireLoadTruckInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneTireLoadTruckZoneIdFkeyZoneTireLoadTruckCreateInput>>;
  /** The primary key(s) for `zoneTireLoadTruck` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneTireLoadTruckZoneTireLoadTruckPkeyDelete>>;
  /** Flag indicating whether all other `zoneTireLoadTruck` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneTireLoadTruck` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneTireLoadTruckOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyUsingZoneTireLoadTruckPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneTireLoadTruckZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneTireLoadTruck` to be created by this mutation. */
export type ZoneTireLoadTruckZoneIdFkeyZoneTireLoadTruckCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['BigFloat'];
  zoneToZoneId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInput>;
};

/** The fields on `zoneTireLoadTruck` to look up the row to connect. */
export type ZoneTireLoadTruckZoneTireLoadTruckPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneTireLoadTruck` to look up the row to delete. */
export type ZoneTireLoadTruckZoneTireLoadTruckPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneTireLoadTruck` values. */
export type ZoneTireLoadTrucksConnection = {
  __typename?: 'ZoneTireLoadTrucksConnection';
  /** A list of edges which contains the `ZoneTireLoadTruck` and cursor to aid in pagination. */
  edges: Array<ZoneTireLoadTrucksEdge>;
  /** A list of `ZoneTireLoadTruck` objects. */
  nodes: Array<ZoneTireLoadTruck>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneTireLoadTruck` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneTireLoadTruck` edge in the connection. */
export type ZoneTireLoadTrucksEdge = {
  __typename?: 'ZoneTireLoadTrucksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneTireLoadTruck` at the end of the edge. */
  node: ZoneTireLoadTruck;
};

/** Methods to use when ordering `ZoneTireLoadTruck`. */
export enum ZoneTireLoadTrucksOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** A filter to be used against many `Area` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyAreaFilter = {
  /** Every related `Area` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AreaFilter>;
  /** No related `Area` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AreaFilter>;
  /** Some related `Area` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AreaFilter>;
};

/** A filter to be used against many `ZoneCadGrossSpaceMin` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneCadGrossSpaceMinFilter = {
  /** Every related `ZoneCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneCadGrossSpaceMinFilter>;
  /** No related `ZoneCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneCadGrossSpaceMinFilter>;
  /** Some related `ZoneCadGrossSpaceMin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneCadGrossSpaceMinFilter>;
};

/** A filter to be used against many `ZoneCapacityCar` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneCapacityCarFilter = {
  /** Every related `ZoneCapacityCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneCapacityCarFilter>;
  /** No related `ZoneCapacityCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneCapacityCarFilter>;
  /** Some related `ZoneCapacityCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneCapacityCarFilter>;
};

/** A filter to be used against many `ZoneCapacityTruck` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneCapacityTruckFilter = {
  /** Every related `ZoneCapacityTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneCapacityTruckFilter>;
  /** No related `ZoneCapacityTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneCapacityTruckFilter>;
  /** Some related `ZoneCapacityTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneCapacityTruckFilter>;
};

/** A filter to be used against many `ZoneDescription` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneDescriptionFilter = {
  /** Every related `ZoneDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneDescriptionFilter>;
  /** No related `ZoneDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneDescriptionFilter>;
  /** Some related `ZoneDescription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneDescriptionFilter>;
};

/** A filter to be used against many `ZoneMaxLoadFloor` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneMaxLoadFloorFilter = {
  /** Every related `ZoneMaxLoadFloor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneMaxLoadFloorFilter>;
  /** No related `ZoneMaxLoadFloor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneMaxLoadFloorFilter>;
  /** Some related `ZoneMaxLoadFloor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneMaxLoadFloorFilter>;
};

/** A filter to be used against many `ZoneNameExtra` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameExtraFilter = {
  /** Every related `ZoneNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameExtraFilter>;
  /** No related `ZoneNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameExtraFilter>;
  /** Some related `ZoneNameExtra` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameExtraFilter>;
};

/** A filter to be used against many `ZoneNameKeyCad` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameKeyCadFilter = {
  /** Every related `ZoneNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameKeyCadFilter>;
  /** No related `ZoneNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameKeyCadFilter>;
  /** Some related `ZoneNameKeyCad` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameKeyCadFilter>;
};

/** A filter to be used against many `ZoneNameKeyCafm` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameKeyCafmFilter = {
  /** Every related `ZoneNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameKeyCafmFilter>;
  /** No related `ZoneNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameKeyCafmFilter>;
  /** Some related `ZoneNameKeyCafm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameKeyCafmFilter>;
};

/** A filter to be used against many `ZoneNameKeyEbm` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameKeyEbmFilter = {
  /** Every related `ZoneNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameKeyEbmFilter>;
  /** No related `ZoneNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameKeyEbmFilter>;
  /** Some related `ZoneNameKeyEbm` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameKeyEbmFilter>;
};

/** A filter to be used against many `ZoneNameKeyMarketing` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameKeyMarketingFilter = {
  /** Every related `ZoneNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameKeyMarketingFilter>;
  /** No related `ZoneNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameKeyMarketingFilter>;
  /** Some related `ZoneNameKeyMarketing` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameKeyMarketingFilter>;
};

/** A filter to be used against many `ZoneNameLong` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameLongFilter = {
  /** Every related `ZoneNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameLongFilter>;
  /** No related `ZoneNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameLongFilter>;
  /** Some related `ZoneNameLong` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameLongFilter>;
};

/** A filter to be used against many `ZoneNameShort` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNameShortFilter = {
  /** Every related `ZoneNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNameShortFilter>;
  /** No related `ZoneNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNameShortFilter>;
  /** Some related `ZoneNameShort` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNameShortFilter>;
};

/** A filter to be used against many `ZoneNoVehicle` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneNoVehicleFilter = {
  /** Every related `ZoneNoVehicle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneNoVehicleFilter>;
  /** No related `ZoneNoVehicle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneNoVehicleFilter>;
  /** Some related `ZoneNoVehicle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneNoVehicleFilter>;
};

/** A filter to be used against many `ZonePublicGrossSpace` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZonePublicGrossSpaceFilter = {
  /** Every related `ZonePublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZonePublicGrossSpaceFilter>;
  /** No related `ZonePublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZonePublicGrossSpaceFilter>;
  /** Some related `ZonePublicGrossSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZonePublicGrossSpaceFilter>;
};

/** A filter to be used against many `ZoneTireLoadCar` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneTireLoadCarFilter = {
  /** Every related `ZoneTireLoadCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneTireLoadCarFilter>;
  /** No related `ZoneTireLoadCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneTireLoadCarFilter>;
  /** Some related `ZoneTireLoadCar` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneTireLoadCarFilter>;
};

/** A filter to be used against many `ZoneTireLoadForklift` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneTireLoadForkliftFilter = {
  /** Every related `ZoneTireLoadForklift` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneTireLoadForkliftFilter>;
  /** No related `ZoneTireLoadForklift` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneTireLoadForkliftFilter>;
  /** Some related `ZoneTireLoadForklift` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneTireLoadForkliftFilter>;
};

/** A filter to be used against many `ZoneTireLoadTruck` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneTireLoadTruckFilter = {
  /** Every related `ZoneTireLoadTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneTireLoadTruckFilter>;
  /** No related `ZoneTireLoadTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneTireLoadTruckFilter>;
  /** Some related `ZoneTireLoadTruck` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneTireLoadTruckFilter>;
};

/** A filter to be used against many `ZoneTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type ZoneToManyZoneTypeAttrFilter = {
  /** Every related `ZoneTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneTypeAttrFilter>;
  /** No related `ZoneTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneTypeAttrFilter>;
  /** Some related `ZoneTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneTypeAttrFilter>;
};

export type ZoneType = {
  __typename?: 'ZoneType';
  description: Scalars['String'];
  id: Scalars['UUID'];
  index: Scalars['Int'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `ZoneTypeAttr`. */
  zoneTypeAttrs: ZoneTypeAttrsConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zonesByTypeId: ZonesConnection;
};


export type ZoneTypeZoneTypeAttrsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneTypeAttrCondition>;
  filter?: InputMaybe<ZoneTypeAttrFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneTypeAttrsOrderBy>>;
};


export type ZoneTypeZonesByTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCondition>;
  filter?: InputMaybe<ZoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

export type ZoneTypeAttr = {
  __typename?: 'ZoneTypeAttr';
  end?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  start?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Zone` that is related to this `ZoneTypeAttr`. */
  zone: Zone;
  zoneId: Scalars['UUID'];
  /** Reads a single `ZoneType` that is related to this `ZoneTypeAttr`. */
  zoneType: ZoneType;
  zoneTypeId: Scalars['UUID'];
};

/**
 * A condition to be used against `ZoneTypeAttr` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneTypeAttrCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `zoneTypeId` field. */
  zoneTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ZoneTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTypeAttrFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneTypeAttrFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneTypeAttrFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneTypeAttrFilter>>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `zone` relation. */
  zone?: InputMaybe<ZoneFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `zoneType` relation. */
  zoneType?: InputMaybe<ZoneTypeFilter>;
  /** Filter by the object’s `zoneTypeId` field. */
  zoneTypeId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ZoneTypeAttr` */
export type ZoneTypeAttrInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInput>;
  zoneTypeId?: InputMaybe<Scalars['UUID']>;
  zoneTypeToZoneTypeId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInput>;
};

/** The fields on `zoneTypeAttr` to look up the row to update. */
export type ZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZoneTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneTypeAttr` being updated. */
  patch: UpdateZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyPatch;
};

/** The fields on `zoneTypeAttr` to look up the row to update. */
export type ZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyUsingZoneTypeAttrPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneTypeAttr` being updated. */
  patch: UpdateZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyPatch;
};

/** Represents an update to a `ZoneTypeAttr`. Fields that are set will be updated. */
export type ZoneTypeAttrPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInput>;
  zoneTypeId?: InputMaybe<Scalars['UUID']>;
  zoneTypeToZoneTypeId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInput>;
};

/** Input for the nested mutation of `zone` in the `ZoneTypeAttrInput` mutation. */
export type ZoneTypeAttrZoneIdFkeyInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<ZoneZoneExtIdKeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneZonePkeyConnect>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<ZoneZoneNameShortKeyConnect>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneTypeAttrZoneIdFkeyZoneCreateInput>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<ZoneZoneExtIdKeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneZonePkeyDelete>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<ZoneZoneNameShortKeyDelete>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<ZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZoneExtIdKeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZonePkeyUpdate>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<ZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZoneNameShortKeyUpdate>;
};

/** Input for the nested mutation of `zoneTypeAttr` in the `ZoneInput` mutation. */
export type ZoneTypeAttrZoneIdFkeyInverseInput = {
  /** The primary key(s) for `zoneTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneTypeAttrZoneTypeAttrPkeyConnect>>;
  /** A `ZoneTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneTypeAttrZoneIdFkeyZoneTypeAttrCreateInput>>;
  /** The primary key(s) for `zoneTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneTypeAttrZoneTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `zoneTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyUsingZoneTypeAttrPkeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneTypeAttrZoneIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneTypeAttr` to be created by this mutation. */
export type ZoneTypeAttrZoneIdFkeyZoneTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  zoneToZoneId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInput>;
  zoneTypeId?: InputMaybe<Scalars['UUID']>;
  zoneTypeToZoneTypeId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInput>;
};

/** The fields on `zoneTypeAttr` to look up the row to connect. */
export type ZoneTypeAttrZoneTypeAttrPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneTypeAttr` to look up the row to delete. */
export type ZoneTypeAttrZoneTypeAttrPkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `zoneType` in the `ZoneTypeAttrInput` mutation. */
export type ZoneTypeAttrZoneTypeIdFkeyInput = {
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneTypeZoneTypePkeyConnect>;
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  connectByName?: InputMaybe<ZoneTypeZoneTypeNameKeyConnect>;
  /** A `ZoneTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyZoneTypeCreateInput>;
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneTypeZoneTypePkeyDelete>;
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  deleteByName?: InputMaybe<ZoneTypeZoneTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `zoneType` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyUsingZoneTypePkeyUpdate>;
  /** The primary key(s) and patch data for `zoneType` for the far side of the relationship. */
  updateByName?: InputMaybe<ZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyUsingZoneTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `zoneTypeAttr` in the `ZoneTypeInput` mutation. */
export type ZoneTypeAttrZoneTypeIdFkeyInverseInput = {
  /** The primary key(s) for `zoneTypeAttr` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneTypeAttrZoneTypeAttrPkeyConnect>>;
  /** A `ZoneTypeAttrInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneTypeAttrZoneTypeIdFkeyZoneTypeAttrCreateInput>>;
  /** The primary key(s) for `zoneTypeAttr` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneTypeAttrZoneTypeAttrPkeyDelete>>;
  /** Flag indicating whether all other `zoneTypeAttr` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zoneTypeAttr` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyUsingZoneTypeAttrPkeyUpdate>>;
};

/** The `zoneTypeAttr` to be created by this mutation. */
export type ZoneTypeAttrZoneTypeIdFkeyZoneTypeAttrCreateInput = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInput>;
  zoneTypeToZoneTypeId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInput>;
};

/** The `zoneType` to be created by this mutation. */
export type ZoneTypeAttrZoneTypeIdFkeyZoneTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneTypeIdFkeyInverseInput>;
};

/** A connection to a list of `ZoneTypeAttr` values. */
export type ZoneTypeAttrsConnection = {
  __typename?: 'ZoneTypeAttrsConnection';
  /** A list of edges which contains the `ZoneTypeAttr` and cursor to aid in pagination. */
  edges: Array<ZoneTypeAttrsEdge>;
  /** A list of `ZoneTypeAttr` objects. */
  nodes: Array<ZoneTypeAttr>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneTypeAttr` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneTypeAttr` edge in the connection. */
export type ZoneTypeAttrsEdge = {
  __typename?: 'ZoneTypeAttrsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneTypeAttr` at the end of the edge. */
  node: ZoneTypeAttr;
};

/** Methods to use when ordering `ZoneTypeAttr`. */
export enum ZoneTypeAttrsOrderBy {
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  ZoneByZoneIdDescriptionAsc = 'ZONE_BY_ZONE_ID__DESCRIPTION_ASC',
  ZoneByZoneIdDescriptionDesc = 'ZONE_BY_ZONE_ID__DESCRIPTION_DESC',
  ZoneByZoneIdExtIdAsc = 'ZONE_BY_ZONE_ID__EXT_ID_ASC',
  ZoneByZoneIdExtIdDesc = 'ZONE_BY_ZONE_ID__EXT_ID_DESC',
  ZoneByZoneIdIdAsc = 'ZONE_BY_ZONE_ID__ID_ASC',
  ZoneByZoneIdIdDesc = 'ZONE_BY_ZONE_ID__ID_DESC',
  ZoneByZoneIdNameLongAsc = 'ZONE_BY_ZONE_ID__NAME_LONG_ASC',
  ZoneByZoneIdNameLongDesc = 'ZONE_BY_ZONE_ID__NAME_LONG_DESC',
  ZoneByZoneIdNameShortAsc = 'ZONE_BY_ZONE_ID__NAME_SHORT_ASC',
  ZoneByZoneIdNameShortDesc = 'ZONE_BY_ZONE_ID__NAME_SHORT_DESC',
  ZoneByZoneIdSiteIdAsc = 'ZONE_BY_ZONE_ID__SITE_ID_ASC',
  ZoneByZoneIdSiteIdDesc = 'ZONE_BY_ZONE_ID__SITE_ID_DESC',
  ZoneByZoneIdTypeIdAsc = 'ZONE_BY_ZONE_ID__TYPE_ID_ASC',
  ZoneByZoneIdTypeIdDesc = 'ZONE_BY_ZONE_ID__TYPE_ID_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC',
  ZoneTypeByZoneTypeIdDescriptionAsc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__DESCRIPTION_ASC',
  ZoneTypeByZoneTypeIdDescriptionDesc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__DESCRIPTION_DESC',
  ZoneTypeByZoneTypeIdIdAsc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__ID_ASC',
  ZoneTypeByZoneTypeIdIdDesc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__ID_DESC',
  ZoneTypeByZoneTypeIdIndexAsc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__INDEX_ASC',
  ZoneTypeByZoneTypeIdIndexDesc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__INDEX_DESC',
  ZoneTypeByZoneTypeIdNameAsc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__NAME_ASC',
  ZoneTypeByZoneTypeIdNameDesc = 'ZONE_TYPE_BY_ZONE_TYPE_ID__NAME_DESC',
  ZoneTypeIdAsc = 'ZONE_TYPE_ID_ASC',
  ZoneTypeIdDesc = 'ZONE_TYPE_ID_DESC'
}

/**
 * A condition to be used against `ZoneType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ZoneTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ZoneType` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneTypeFilter>>;
  /** Filter by the object’s `zoneTypeAttrs` relation. */
  zoneTypeAttrs?: InputMaybe<ZoneTypeToManyZoneTypeAttrFilter>;
  /** Some related `zoneTypeAttrs` exist. */
  zoneTypeAttrsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `zonesByTypeId` relation. */
  zonesByTypeId?: InputMaybe<ZoneTypeToManyZoneFilter>;
  /** Some related `zonesByTypeId` exist. */
  zonesByTypeIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `zoneType` in the `ZoneInput` mutation. */
export type ZoneTypeIdFkeyInput = {
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  connectById?: InputMaybe<ZoneTypeZoneTypePkeyConnect>;
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  connectByName?: InputMaybe<ZoneTypeZoneTypeNameKeyConnect>;
  /** A `ZoneTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ZoneTypeIdFkeyZoneTypeCreateInput>;
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  deleteById?: InputMaybe<ZoneTypeZoneTypePkeyDelete>;
  /** The primary key(s) for `zoneType` for the far side of the relationship. */
  deleteByName?: InputMaybe<ZoneTypeZoneTypeNameKeyDelete>;
  /** The primary key(s) and patch data for `zoneType` for the far side of the relationship. */
  updateById?: InputMaybe<ZoneTypeOnZoneForZoneTypeIdFkeyUsingZoneTypePkeyUpdate>;
  /** The primary key(s) and patch data for `zoneType` for the far side of the relationship. */
  updateByName?: InputMaybe<ZoneTypeOnZoneForZoneTypeIdFkeyUsingZoneTypeNameKeyUpdate>;
};

/** Input for the nested mutation of `zone` in the `ZoneTypeInput` mutation. */
export type ZoneTypeIdFkeyInverseInput = {
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByExtId?: InputMaybe<Array<ZoneZoneExtIdKeyConnect>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ZoneZonePkeyConnect>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  connectByNameShort?: InputMaybe<Array<ZoneZoneNameShortKeyConnect>>;
  /** A `ZoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ZoneTypeIdFkeyZoneCreateInput>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByExtId?: InputMaybe<Array<ZoneZoneExtIdKeyDelete>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ZoneZonePkeyDelete>>;
  /** The primary key(s) for `zone` for the far side of the relationship. */
  deleteByNameShort?: InputMaybe<Array<ZoneZoneNameShortKeyDelete>>;
  /** Flag indicating whether all other `zone` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByExtId?: InputMaybe<Array<ZoneOnZoneForZoneTypeIdFkeyUsingZoneExtIdKeyUpdate>>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ZoneOnZoneForZoneTypeIdFkeyUsingZonePkeyUpdate>>;
  /** The primary key(s) and patch data for `zone` for the far side of the relationship. */
  updateByNameShort?: InputMaybe<Array<ZoneOnZoneForZoneTypeIdFkeyUsingZoneNameShortKeyUpdate>>;
};

/** The `zone` to be created by this mutation. */
export type ZoneTypeIdFkeyZoneCreateInput = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  extId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort: Scalars['String'];
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** The `zoneType` to be created by this mutation. */
export type ZoneTypeIdFkeyZoneTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneTypeIdFkeyInverseInput>;
};

/** An input for mutations affecting `ZoneType` */
export type ZoneTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneTypeIdFkeyInverseInput>;
};

/** The fields on `zoneType` to look up the row to update. */
export type ZoneTypeOnZoneForZoneTypeIdFkeyUsingZoneTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `zoneType` being updated. */
  patch: UpdateZoneTypeOnZoneForZoneTypeIdFkeyPatch;
};

/** The fields on `zoneType` to look up the row to update. */
export type ZoneTypeOnZoneForZoneTypeIdFkeyUsingZoneTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneType` being updated. */
  patch: UpdateZoneTypeOnZoneForZoneTypeIdFkeyPatch;
};

/** The fields on `zoneType` to look up the row to update. */
export type ZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyUsingZoneTypeNameKeyUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `zoneType` being updated. */
  patch: UpdateZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyPatch;
};

/** The fields on `zoneType` to look up the row to update. */
export type ZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyUsingZoneTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `zoneType` being updated. */
  patch: UpdateZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyPatch;
};

/** Represents an update to a `ZoneType`. Fields that are set will be updated. */
export type ZoneTypePatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneTypeIdFkeyInverseInput>;
};

/** A filter to be used against many `Zone` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTypeToManyZoneFilter = {
  /** Every related `Zone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneFilter>;
  /** No related `Zone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneFilter>;
  /** Some related `Zone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneFilter>;
};

/** A filter to be used against many `ZoneTypeAttr` object types. All fields are combined with a logical ‘and.’ */
export type ZoneTypeToManyZoneTypeAttrFilter = {
  /** Every related `ZoneTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ZoneTypeAttrFilter>;
  /** No related `ZoneTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ZoneTypeAttrFilter>;
  /** Some related `ZoneTypeAttr` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ZoneTypeAttrFilter>;
};

/** The fields on `zoneType` to look up the row to connect. */
export type ZoneTypeZoneTypeNameKeyConnect = {
  name: Scalars['String'];
};

/** The fields on `zoneType` to look up the row to delete. */
export type ZoneTypeZoneTypeNameKeyDelete = {
  name: Scalars['String'];
};

/** The fields on `zoneType` to look up the row to connect. */
export type ZoneTypeZoneTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zoneType` to look up the row to delete. */
export type ZoneTypeZoneTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `ZoneType` values. */
export type ZoneTypesConnection = {
  __typename?: 'ZoneTypesConnection';
  /** A list of edges which contains the `ZoneType` and cursor to aid in pagination. */
  edges: Array<ZoneTypesEdge>;
  /** A list of `ZoneType` objects. */
  nodes: Array<ZoneType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneType` edge in the connection. */
export type ZoneTypesEdge = {
  __typename?: 'ZoneTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneType` at the end of the edge. */
  node: ZoneType;
};

/** Methods to use when ordering `ZoneType`. */
export enum ZoneTypesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ZonesByTypeIdCountAsc = 'ZONES_BY_TYPE_ID__COUNT_ASC',
  ZonesByTypeIdCountDesc = 'ZONES_BY_TYPE_ID__COUNT_DESC',
  ZoneTypeAttrsByZoneTypeIdCountAsc = 'ZONE_TYPE_ATTRS_BY_ZONE_TYPE_ID__COUNT_ASC',
  ZoneTypeAttrsByZoneTypeIdCountDesc = 'ZONE_TYPE_ATTRS_BY_ZONE_TYPE_ID__COUNT_DESC'
}

/** The fields on `zone` to look up the row to connect. */
export type ZoneZoneExtIdKeyConnect = {
  extId: Scalars['UUID'];
};

/** The fields on `zone` to look up the row to delete. */
export type ZoneZoneExtIdKeyDelete = {
  extId: Scalars['UUID'];
};

/** The fields on `zone` to look up the row to connect. */
export type ZoneZoneNameShortKeyConnect = {
  nameShort: Scalars['String'];
};

/** The fields on `zone` to look up the row to delete. */
export type ZoneZoneNameShortKeyDelete = {
  nameShort: Scalars['String'];
};

/** The fields on `zone` to look up the row to connect. */
export type ZoneZonePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `zone` to look up the row to delete. */
export type ZoneZonePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `Zone` values. */
export type ZonesConnection = {
  __typename?: 'ZonesConnection';
  /** A list of edges which contains the `Zone` and cursor to aid in pagination. */
  edges: Array<ZonesEdge>;
  /** A list of `Zone` objects. */
  nodes: Array<Zone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zone` edge in the connection. */
export type ZonesEdge = {
  __typename?: 'ZonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zone` at the end of the edge. */
  node: Zone;
};

/** Methods to use when ordering `Zone`. */
export enum ZonesOrderBy {
  AreasByZoneIdCountAsc = 'AREAS_BY_ZONE_ID__COUNT_ASC',
  AreasByZoneIdCountDesc = 'AREAS_BY_ZONE_ID__COUNT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExtIdAsc = 'EXT_ID_ASC',
  ExtIdDesc = 'EXT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameLongAsc = 'NAME_LONG_ASC',
  NameLongDesc = 'NAME_LONG_DESC',
  NameShortAsc = 'NAME_SHORT_ASC',
  NameShortDesc = 'NAME_SHORT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SiteBySiteIdDescriptionAsc = 'SITE_BY_SITE_ID__DESCRIPTION_ASC',
  SiteBySiteIdDescriptionDesc = 'SITE_BY_SITE_ID__DESCRIPTION_DESC',
  SiteBySiteIdExtIdAsc = 'SITE_BY_SITE_ID__EXT_ID_ASC',
  SiteBySiteIdExtIdDesc = 'SITE_BY_SITE_ID__EXT_ID_DESC',
  SiteBySiteIdIdAsc = 'SITE_BY_SITE_ID__ID_ASC',
  SiteBySiteIdIdDesc = 'SITE_BY_SITE_ID__ID_DESC',
  SiteBySiteIdNameLongAsc = 'SITE_BY_SITE_ID__NAME_LONG_ASC',
  SiteBySiteIdNameLongDesc = 'SITE_BY_SITE_ID__NAME_LONG_DESC',
  SiteBySiteIdNameShortAsc = 'SITE_BY_SITE_ID__NAME_SHORT_ASC',
  SiteBySiteIdNameShortDesc = 'SITE_BY_SITE_ID__NAME_SHORT_DESC',
  SiteIdAsc = 'SITE_ID_ASC',
  SiteIdDesc = 'SITE_ID_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC',
  ZoneCadGrossSpaceMinsByZoneIdCountAsc = 'ZONE_CAD_GROSS_SPACE_MINS_BY_ZONE_ID__COUNT_ASC',
  ZoneCadGrossSpaceMinsByZoneIdCountDesc = 'ZONE_CAD_GROSS_SPACE_MINS_BY_ZONE_ID__COUNT_DESC',
  ZoneCapacityCarsByZoneIdCountAsc = 'ZONE_CAPACITY_CARS_BY_ZONE_ID__COUNT_ASC',
  ZoneCapacityCarsByZoneIdCountDesc = 'ZONE_CAPACITY_CARS_BY_ZONE_ID__COUNT_DESC',
  ZoneCapacityTrucksByZoneIdCountAsc = 'ZONE_CAPACITY_TRUCKS_BY_ZONE_ID__COUNT_ASC',
  ZoneCapacityTrucksByZoneIdCountDesc = 'ZONE_CAPACITY_TRUCKS_BY_ZONE_ID__COUNT_DESC',
  ZoneDescriptionsByZoneIdCountAsc = 'ZONE_DESCRIPTIONS_BY_ZONE_ID__COUNT_ASC',
  ZoneDescriptionsByZoneIdCountDesc = 'ZONE_DESCRIPTIONS_BY_ZONE_ID__COUNT_DESC',
  ZoneMaxLoadFloorsByZoneIdCountAsc = 'ZONE_MAX_LOAD_FLOORS_BY_ZONE_ID__COUNT_ASC',
  ZoneMaxLoadFloorsByZoneIdCountDesc = 'ZONE_MAX_LOAD_FLOORS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameExtrasByZoneIdCountAsc = 'ZONE_NAME_EXTRAS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameExtrasByZoneIdCountDesc = 'ZONE_NAME_EXTRAS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameKeyCadsByZoneIdCountAsc = 'ZONE_NAME_KEY_CADS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameKeyCadsByZoneIdCountDesc = 'ZONE_NAME_KEY_CADS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameKeyCafmsByZoneIdCountAsc = 'ZONE_NAME_KEY_CAFMS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameKeyCafmsByZoneIdCountDesc = 'ZONE_NAME_KEY_CAFMS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameKeyEbmsByZoneIdCountAsc = 'ZONE_NAME_KEY_EBMS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameKeyEbmsByZoneIdCountDesc = 'ZONE_NAME_KEY_EBMS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameKeyMarketingsByZoneIdCountAsc = 'ZONE_NAME_KEY_MARKETINGS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameKeyMarketingsByZoneIdCountDesc = 'ZONE_NAME_KEY_MARKETINGS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameLongsByZoneIdCountAsc = 'ZONE_NAME_LONGS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameLongsByZoneIdCountDesc = 'ZONE_NAME_LONGS_BY_ZONE_ID__COUNT_DESC',
  ZoneNameShortsByZoneIdCountAsc = 'ZONE_NAME_SHORTS_BY_ZONE_ID__COUNT_ASC',
  ZoneNameShortsByZoneIdCountDesc = 'ZONE_NAME_SHORTS_BY_ZONE_ID__COUNT_DESC',
  ZoneNoVehiclesByZoneIdCountAsc = 'ZONE_NO_VEHICLES_BY_ZONE_ID__COUNT_ASC',
  ZoneNoVehiclesByZoneIdCountDesc = 'ZONE_NO_VEHICLES_BY_ZONE_ID__COUNT_DESC',
  ZonePublicGrossSpacesByZoneIdCountAsc = 'ZONE_PUBLIC_GROSS_SPACES_BY_ZONE_ID__COUNT_ASC',
  ZonePublicGrossSpacesByZoneIdCountDesc = 'ZONE_PUBLIC_GROSS_SPACES_BY_ZONE_ID__COUNT_DESC',
  ZoneTireLoadCarsByZoneIdCountAsc = 'ZONE_TIRE_LOAD_CARS_BY_ZONE_ID__COUNT_ASC',
  ZoneTireLoadCarsByZoneIdCountDesc = 'ZONE_TIRE_LOAD_CARS_BY_ZONE_ID__COUNT_DESC',
  ZoneTireLoadForkliftsByZoneIdCountAsc = 'ZONE_TIRE_LOAD_FORKLIFTS_BY_ZONE_ID__COUNT_ASC',
  ZoneTireLoadForkliftsByZoneIdCountDesc = 'ZONE_TIRE_LOAD_FORKLIFTS_BY_ZONE_ID__COUNT_DESC',
  ZoneTireLoadTrucksByZoneIdCountAsc = 'ZONE_TIRE_LOAD_TRUCKS_BY_ZONE_ID__COUNT_ASC',
  ZoneTireLoadTrucksByZoneIdCountDesc = 'ZONE_TIRE_LOAD_TRUCKS_BY_ZONE_ID__COUNT_DESC',
  ZoneTypeAttrsByZoneIdCountAsc = 'ZONE_TYPE_ATTRS_BY_ZONE_ID__COUNT_ASC',
  ZoneTypeAttrsByZoneIdCountDesc = 'ZONE_TYPE_ATTRS_BY_ZONE_ID__COUNT_DESC',
  ZoneTypeByTypeIdDescriptionAsc = 'ZONE_TYPE_BY_TYPE_ID__DESCRIPTION_ASC',
  ZoneTypeByTypeIdDescriptionDesc = 'ZONE_TYPE_BY_TYPE_ID__DESCRIPTION_DESC',
  ZoneTypeByTypeIdIdAsc = 'ZONE_TYPE_BY_TYPE_ID__ID_ASC',
  ZoneTypeByTypeIdIdDesc = 'ZONE_TYPE_BY_TYPE_ID__ID_DESC',
  ZoneTypeByTypeIdIndexAsc = 'ZONE_TYPE_BY_TYPE_ID__INDEX_ASC',
  ZoneTypeByTypeIdIndexDesc = 'ZONE_TYPE_BY_TYPE_ID__INDEX_DESC',
  ZoneTypeByTypeIdNameAsc = 'ZONE_TYPE_BY_TYPE_ID__NAME_ASC',
  ZoneTypeByTypeIdNameDesc = 'ZONE_TYPE_BY_TYPE_ID__NAME_DESC'
}

/** An object where the defined keys will be set on the `allocationArea` being updated. */
export type UpdateAllocationAreaOnAllocationAreaForAllocationAreaAreaIdFkeyPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationArea` being updated. */
export type UpdateAllocationAreaOnAllocationAreaForAllocationAreaEventVariantIdFkeyPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationArea` being updated. */
export type UpdateAllocationAreaOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationArea` being updated. */
export type UpdateAllocationAreaOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationAreaEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationAreaPhase` being updated. */
export type UpdateAllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyPatch = {
  allocationAreaToAllocationId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `allocationAreaPhase` being updated. */
export type UpdateAllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch = {
  allocationAreaToAllocationId?: InputMaybe<AllocationAreaPhaseAllocationIdFkeyInput>;
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationUsageToUsageId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `allocationPlot` being updated. */
export type UpdateAllocationPlotOnAllocationPlotForAllocationPlotEventVariantIdFkeyPatch = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationPlot` being updated. */
export type UpdateAllocationPlotOnAllocationPlotForAllocationPlotPlotIdFkeyPatch = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationPlot` being updated. */
export type UpdateAllocationPlotOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyPatch = {
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationPlotEventVariantIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<AllocationPlotPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationPlotPhase` being updated. */
export type UpdateAllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseAllocationIdFkeyPatch = {
  allocationPlotToAllocationId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `allocationPlotPhase` being updated. */
export type UpdateAllocationPlotPhaseOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationPlotToAllocationId?: InputMaybe<AllocationPlotPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `allocationRoom` being updated. */
export type UpdateAllocationRoomOnAllocationRoomForAllocationRoomEventVariantIdFkeyPatch = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationRoom` being updated. */
export type UpdateAllocationRoomOnAllocationRoomForAllocationRoomRoomIdFkeyPatch = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationRoom` being updated. */
export type UpdateAllocationRoomOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyPatch = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationRoom` being updated. */
export type UpdateAllocationRoomOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFPatch = {
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInverseInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventVariantId?: InputMaybe<Scalars['UUID']>;
  eventVariantToEventVariantId?: InputMaybe<AllocationRoomEventVariantIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<AllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `allocationRoomPhase` being updated. */
export type UpdateAllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyPatch = {
  allocationRoomToAllocationId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `allocationRoomPhase` being updated. */
export type UpdateAllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  allocationRoomToAllocationId?: InputMaybe<AllocationRoomPhaseAllocationIdFkeyInput>;
  allocationUsageToUsageId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInput>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `allocationUsage` being updated. */
export type UpdateAllocationUsageOnAllocationAreaPhaseForAllocationAreaPhaseUsageIdFkeyPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AllocationUsageType>;
};

/** An object where the defined keys will be set on the `allocationUsage` being updated. */
export type UpdateAllocationUsageOnAllocationPlotPhaseForAllocationPlotPhaseUsageIdFkeyPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AllocationUsageType>;
};

/** An object where the defined keys will be set on the `allocationUsage` being updated. */
export type UpdateAllocationUsageOnAllocationRoomPhaseForAllocationRoomPhaseUsageIdFkeyPatch = {
  allocationAreaPhasesUsingId?: InputMaybe<AllocationAreaPhaseUsageIdFkeyInverseInput>;
  allocationPlotPhasesUsingId?: InputMaybe<AllocationPlotPhaseUsageIdFkeyInverseInput>;
  allocationRoomPhasesUsingId?: InputMaybe<AllocationRoomPhaseUsageIdFkeyInverseInput>;
  color?: InputMaybe<Scalars['String']>;
  defaultDays?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AllocationUsageType>;
};

/** An object where the defined keys will be set on the `areaCadGrossSpaceMin` being updated. */
export type UpdateAreaCadGrossSpaceMinOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `areaClearanceConstruction` being updated. */
export type UpdateAreaClearanceConstructionOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaContactBooking` being updated. */
export type UpdateAreaContactBookingOnAreaContactBookingForAreaContactBookingAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaContactBookingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaDescription` being updated. */
export type UpdateAreaDescriptionOnAreaDescriptionForAreaDescriptionAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaDescriptionAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaKeyIssuanceNote` being updated. */
export type UpdateAreaKeyIssuanceNoteOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaKeyIssuance` being updated. */
export type UpdateAreaKeyIssuanceOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameExtra` being updated. */
export type UpdateAreaNameExtraOnAreaNameExtraForAreaNameExtraAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameExtraAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameKeyCad` being updated. */
export type UpdateAreaNameKeyCadOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameKeyCafm` being updated. */
export type UpdateAreaNameKeyCafmOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameKeyEbm` being updated. */
export type UpdateAreaNameKeyEbmOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameKeyMarketing` being updated. */
export type UpdateAreaNameKeyMarketingOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameLong` being updated. */
export type UpdateAreaNameLongOnAreaNameLongForAreaNameLongAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameLongAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaNameShort` being updated. */
export type UpdateAreaNameShortOnAreaNameShortForAreaNameShortAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaNameShortAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAllocationAreaForAllocationAreaAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaCadGrossSpaceMinForAreaCadGrossSpaceMinAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaClearanceConstructionForAreaClearanceConstructionAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaContactBookingForAreaContactBookingAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaDescriptionForAreaDescriptionAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaForAreaTypeIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaForAreaZoneIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaKeyIssuanceForAreaKeyIssuanceAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaKeyIssuanceNoteForAreaKeyIssuanceNotesAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameExtraForAreaNameExtraAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameKeyCadForAreaNameKeyCadAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameKeyCafmForAreaNameKeyCafmAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameKeyEbmForAreaNameKeyEbmsAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameKeyMarketingForAreaNameKeyMarketingAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameLongForAreaNameLongAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaNameShortForAreaNameShortAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnPlotForPlotAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `area` being updated. */
export type UpdateAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyPatch = {
  allocationAreasUsingId?: InputMaybe<AllocationAreaAreaIdFkeyInverseInput>;
  areaCadGrossSpaceMinsUsingId?: InputMaybe<AreaCadGrossSpaceMinAreaIdFkeyInverseInput>;
  areaClearanceConstructionsUsingId?: InputMaybe<AreaClearanceConstructionAreaIdFkeyInverseInput>;
  areaContactBookingsUsingId?: InputMaybe<AreaContactBookingAreaIdFkeyInverseInput>;
  areaDescriptionsUsingId?: InputMaybe<AreaDescriptionAreaIdFkeyInverseInput>;
  areaKeyIssuanceNotesUsingId?: InputMaybe<AreaKeyIssuanceNotesAreaIdFkeyInverseInput>;
  areaKeyIssuancesUsingId?: InputMaybe<AreaKeyIssuanceAreaIdFkeyInverseInput>;
  areaNameExtrasUsingId?: InputMaybe<AreaNameExtraAreaIdFkeyInverseInput>;
  areaNameKeyCadsUsingId?: InputMaybe<AreaNameKeyCadAreaIdFkeyInverseInput>;
  areaNameKeyCafmsUsingId?: InputMaybe<AreaNameKeyCafmAreaIdFkeyInverseInput>;
  areaNameKeyEbmsUsingId?: InputMaybe<AreaNameKeyEbmsAreaIdFkeyInverseInput>;
  areaNameKeyMarketingsUsingId?: InputMaybe<AreaNameKeyMarketingAreaIdFkeyInverseInput>;
  areaNameLongsUsingId?: InputMaybe<AreaNameLongAreaIdFkeyInverseInput>;
  areaNameShortsUsingId?: InputMaybe<AreaNameShortAreaIdFkeyInverseInput>;
  areaPublicGrossSpacesUsingId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInverseInput>;
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaIdFkeyInverseInput>;
  areaTypeToTypeId?: InputMaybe<AreaTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotsUsingId?: InputMaybe<PlotAreaIdFkeyInverseInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<AreaZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `areaPublicGrossSpace` being updated. */
export type UpdateAreaPublicGrossSpaceOnAreaPublicGrossSpaceForAreaPublicGrossSpaceAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaPublicGrossSpaceAreaIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `areaTypeAttr` being updated. */
export type UpdateAreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<AreaTypeAttrAreaIdFkeyInput>;
  areaTypeId?: InputMaybe<Scalars['UUID']>;
  areaTypeToAreaTypeId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `areaTypeAttr` being updated. */
export type UpdateAreaTypeAttrOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<AreaTypeAttrAreaIdFkeyInput>;
  areaTypeToAreaTypeId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `areaType` being updated. */
export type UpdateAreaTypeOnAreaForAreaTypeIdFkeyPatch = {
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInverseInput>;
  areasUsingId?: InputMaybe<AreaTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `areaType` being updated. */
export type UpdateAreaTypeOnAreaTypeAttrForAreaTypeAttrAreaTypeIdFkeyPatch = {
  areaTypeAttrsUsingId?: InputMaybe<AreaTypeAttrAreaTypeIdFkeyInverseInput>;
  areasUsingId?: InputMaybe<AreaTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingDescription` being updated. */
export type UpdateBuildingDescriptionOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameExtra` being updated. */
export type UpdateBuildingNameExtraOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameKeyCad` being updated. */
export type UpdateBuildingNameKeyCadOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameKeyCafm` being updated. */
export type UpdateBuildingNameKeyCafmOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameKeyEbm` being updated. */
export type UpdateBuildingNameKeyEbmOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameKeyMarketing` being updated. */
export type UpdateBuildingNameKeyMarketingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameLong` being updated. */
export type UpdateBuildingNameLongOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingNameShort` being updated. */
export type UpdateBuildingNameShortOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingDescriptionForBuildingDescriptionBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingForBuildingSiteIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingForBuildingTypeIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameExtraForBuildingNameExtraBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameKeyCadForBuildingNameKeyCadBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameKeyCafmForBuildingNameKeyCafmBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameKeyEbmForBuildingNameKeyEbmsBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameKeyMarketingForBuildingNameKeyMarketingBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameLongForBuildingNameLongBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingNameShortForBuildingNameShortBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `building` being updated. */
export type UpdateBuildingOnLevelForLevelBuildingIdFkeyPatch = {
  buildingDescriptionsUsingId?: InputMaybe<BuildingDescriptionBuildingIdFkeyInverseInput>;
  buildingNameExtrasUsingId?: InputMaybe<BuildingNameExtraBuildingIdFkeyInverseInput>;
  buildingNameKeyCadsUsingId?: InputMaybe<BuildingNameKeyCadBuildingIdFkeyInverseInput>;
  buildingNameKeyCafmsUsingId?: InputMaybe<BuildingNameKeyCafmBuildingIdFkeyInverseInput>;
  buildingNameKeyEbmsUsingId?: InputMaybe<BuildingNameKeyEbmsBuildingIdFkeyInverseInput>;
  buildingNameKeyMarketingsUsingId?: InputMaybe<BuildingNameKeyMarketingBuildingIdFkeyInverseInput>;
  buildingNameLongsUsingId?: InputMaybe<BuildingNameLongBuildingIdFkeyInverseInput>;
  buildingNameShortsUsingId?: InputMaybe<BuildingNameShortBuildingIdFkeyInverseInput>;
  buildingPublicGrossSpacesUsingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInverseInput>;
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInverseInput>;
  buildingTypeToTypeId?: InputMaybe<BuildingTypeIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelBuildingIdFkeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<BuildingSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `buildingPublicGrossSpace` being updated. */
export type UpdateBuildingPublicGrossSpaceOnBuildingPublicGrossSpaceForBuildingPublicGrossSpaceBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingPublicGrossSpaceBuildingIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `buildingTypeAttr` being updated. */
export type UpdateBuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInput>;
  buildingTypeId?: InputMaybe<Scalars['UUID']>;
  buildingTypeToBuildingTypeId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `buildingTypeAttr` being updated. */
export type UpdateBuildingTypeAttrOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<BuildingTypeAttrBuildingIdFkeyInput>;
  buildingTypeToBuildingTypeId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInput>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `buildingType` being updated. */
export type UpdateBuildingTypeOnBuildingForBuildingTypeIdFkeyPatch = {
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInverseInput>;
  buildingsUsingId?: InputMaybe<BuildingTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `buildingType` being updated. */
export type UpdateBuildingTypeOnBuildingTypeAttrForBuildingTypeAttrBuildingTypeIdFkeyPatch = {
  buildingTypeAttrsUsingId?: InputMaybe<BuildingTypeAttrBuildingTypeIdFkeyInverseInput>;
  buildingsUsingId?: InputMaybe<BuildingTypeIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `elevationLevel` being updated. */
export type UpdateElevationLevelOnLevelForLevelElevationIdKeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  levelsUsingId?: InputMaybe<LevelElevationIdKeyInverseInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventCompetitionInternationalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventCompetitionNationalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventExternalDataIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventExtraDocumentsIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventExtraSystemsIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventFairAbroadCooperationIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventFairAbroadIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventFavoredParallelsExternalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventFavoredParallelsInternalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventIconIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventInternalDataIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventOtherCompetitionInternationalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventOtherCompetitionNationalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventOtherLinksExternalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventOtherLinksInternalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventSeriesIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventSubeventsLocalIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventSubeventsOtherLocationsIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventVariantForEventVariantEventIdFkeyPatch = {
  annualSpecifics?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventSeriesToSeriesId?: InputMaybe<EventSeriesIdFkeyInput>;
  eventVariantsUsingId?: InputMaybe<EventVariantEventIdFkeyInverseInput>;
  executionYear?: InputMaybe<Scalars['Int']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventIconIdFkeyInput>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventCompetitionNationalIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventInternalDataIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventOtherLinksInternalIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventForEventSeriesIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesCompetitionNationalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesExecutorsIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesExternalDataIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesExtraDocumentsIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesExtraSystemsIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesFairAbroadIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesIconIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesInternalDataIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesOrganizersIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesSponsorsIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesSubeventsLocalIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventSeries` being updated. */
export type UpdateEventSeriesOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkPatch = {
  additionalPartners?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventsUsingId?: InputMaybe<EventSeriesIdFkeyInverseInput>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  fileToIconId?: InputMaybe<EventSeriesIconIdFkeyInput>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  multilinkToCompetitionInternationalId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInput>;
  multilinkToCompetitionNationalId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInput>;
  multilinkToExecutorsId?: InputMaybe<EventSeriesExecutorsIdFkeyInput>;
  multilinkToExternalDataId?: InputMaybe<EventSeriesExternalDataIdFkeyInput>;
  multilinkToExtraDocumentsId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInput>;
  multilinkToExtraSystemsId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInput>;
  multilinkToFairAbroadCooperationId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInput>;
  multilinkToFairAbroadId?: InputMaybe<EventSeriesFairAbroadIdFkeyInput>;
  multilinkToFavoredParallelsExternalId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInput>;
  multilinkToFavoredParallelsInternalId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInput>;
  multilinkToInternalDataId?: InputMaybe<EventSeriesInternalDataIdFkeyInput>;
  multilinkToOrganizersId?: InputMaybe<EventSeriesOrganizersIdFkeyInput>;
  multilinkToOtherCompetitionInternationalId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInput>;
  multilinkToOtherCompetitionNationalId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInput>;
  multilinkToOtherLinksExternalId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInput>;
  multilinkToOtherLinksInternalId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInput>;
  multilinkToSponsorsId?: InputMaybe<EventSeriesSponsorsIdFkeyInput>;
  multilinkToSubeventsLocalId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInput>;
  multilinkToSubeventsOtherLocationsId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  organizersId?: InputMaybe<Scalars['UUID']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnAllocationAreaForAllocationAreaEventVariantIdFkeyPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnAllocationPlotForAllocationPlotEventVariantIdFkeyPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnAllocationRoomForAllocationRoomEventVariantIdFkeyPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnEventVariantForEventVariantChangesIdFkeyPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnEventVariantForEventVariantEventIdFkeyPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnEventVariantForEventVariantReferenceAllocationAreaIdAllocationAreaIdFPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `eventVariant` being updated. */
export type UpdateEventVariantOnEventVariantForEventVariantReferenceAllocationRoomIdAllocationRoomIdFPatch = {
  allocationAreaToReferenceAllocationAreaId?: InputMaybe<EventVariantReferenceAllocationAreaIdAllocationAreaIdFInput>;
  allocationAreasUsingId?: InputMaybe<AllocationAreaEventVariantIdFkeyInverseInput>;
  allocationPlotsUsingId?: InputMaybe<AllocationPlotEventVariantIdFkeyInverseInput>;
  allocationRoomToReferenceAllocationRoomId?: InputMaybe<EventVariantReferenceAllocationRoomIdAllocationRoomIdFInput>;
  allocationRoomsUsingId?: InputMaybe<AllocationRoomEventVariantIdFkeyInverseInput>;
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  eventToEventId?: InputMaybe<EventVariantEventIdFkeyInput>;
  feedToChangesId?: InputMaybe<EventVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
export type UpdateExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
export type UpdateExternalEventAllocationOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
export type UpdateExternalEventAllocationOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `externalEventAllocation` being updated. */
export type UpdateExternalEventAllocationOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInput>;
  externalEventVariantToVariantId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  variantId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `externalEventAllocationPhase` being updated. */
export type UpdateExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlPatch = {
  duration?: InputMaybe<IntervalInput>;
  externalEventAllocationToAllocationId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInput>;
  externalEventAllocationUsageToUsageId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `externalEventAllocationPhase` being updated. */
export type UpdateExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  externalEventAllocationToAllocationId?: InputMaybe<ExternalEventAllocationPhaseAllocationIdExternalEventAlInput>;
  externalEventAllocationUsageToUsageId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `externalEventAllocationUsage` being updated. */
export type UpdateExternalEventAllocationUsageOnExternalEventAllocationPhaseForExternalEventAllocationPhaseUsageIdExternalEventAllocatPatch = {
  externalEventAllocationPhasesUsingId?: InputMaybe<ExternalEventAllocationPhaseUsageIdExternalEventAllocatInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ExternalEventAllocationUsageType>;
};

/** An object where the defined keys will be set on the `externalEventEventLocationVisibility` being updated. */
export type UpdateExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenPatch = {
  externalEventLocationToLocationId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInput>;
  externalEventToEventId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInput>;
  id?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

/** An object where the defined keys will be set on the `externalEventEventLocationVisibility` being updated. */
export type UpdateExternalEventEventLocationVisibilityOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEPatch = {
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInput>;
  externalEventToEventId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInput>;
  id?: InputMaybe<Scalars['UUID']>;
  visibility?: InputMaybe<ExternalEventLocationVisibility>;
};

/** An object where the defined keys will be set on the `externalEventLocation` being updated. */
export type UpdateExternalEventLocationOnExternalEventAllocationForExternalEventAllocationLocationIdExternalEventLocationIPatch = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `externalEventLocation` being updated. */
export type UpdateExternalEventLocationOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityLocationIdExternalEPatch = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `externalEventLocation` being updated. */
export type UpdateExternalEventLocationOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkPatch = {
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationLocationIdExternalEventLocationIInverseInput>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityLocationIdExternalEInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isNationalDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `externalEvent` being updated. */
export type UpdateExternalEventOnExternalEventEventLocationVisibilityForExternalEventEventLocationVisibilityEventIdExternalEvenPatch = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `externalEvent` being updated. */
export type UpdateExternalEventOnExternalEventForExternalEventLinksIdMultilinkIdFkPatch = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `externalEvent` being updated. */
export type UpdateExternalEventOnExternalEventForExternalEventLocationIdExternalEventLocationIdFkPatch = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `externalEvent` being updated. */
export type UpdateExternalEventOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkPatch = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `externalEvent` being updated. */
export type UpdateExternalEventOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkPatch = {
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventEventLocationVisibilitiesUsingId?: InputMaybe<ExternalEventEventLocationVisibilityEventIdExternalEvenInverseInput>;
  externalEventLocationToLocationId?: InputMaybe<ExternalEventLocationIdExternalEventLocationIdFkInput>;
  externalEventSeriesToSeriesId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksId?: InputMaybe<Scalars['UUID']>;
  locationId?: InputMaybe<Scalars['UUID']>;
  multilinkToLinksId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventEventStatus>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `externalEventSeries` being updated. */
export type UpdateExternalEventSeriesOnExternalEventForExternalEventSeriesIdExternalEventSeriesIdFkPatch = {
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  explanation?: InputMaybe<Scalars['String']>;
  externalEventsUsingId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToWebsitesId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  national?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `externalEventSeries` being updated. */
export type UpdateExternalEventSeriesOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkPatch = {
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  explanation?: InputMaybe<Scalars['String']>;
  externalEventsUsingId?: InputMaybe<ExternalEventSeriesIdExternalEventSeriesIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToWebsitesId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  national?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
};

/** An object where the defined keys will be set on the `externalEventVariant` being updated. */
export type UpdateExternalEventVariantOnExternalEventAllocationForExternalEventAllocationVariantIdExternalEventVariantIdPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** An object where the defined keys will be set on the `externalEventVariant` being updated. */
export type UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** An object where the defined keys will be set on the `externalEventVariant` being updated. */
export type UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantEventIdExternalEventIdFkPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceExternalEventAllocationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** An object where the defined keys will be set on the `externalEventVariant` being updated. */
export type UpdateExternalEventVariantOnExternalEventVariantForExternalEventVariantReferenceExternalEventAllocationIdEPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  externalEventAllocationToReferenceExternalEventAllocationId?: InputMaybe<ExternalEventVariantReferenceExternalEventAllocationIdEInput>;
  externalEventAllocationsUsingId?: InputMaybe<ExternalEventAllocationVariantIdExternalEventVariantIdInverseInput>;
  externalEventToEventId?: InputMaybe<ExternalEventVariantEventIdExternalEventIdFkInput>;
  feedToChangesId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
};

/** An object where the defined keys will be set on the `feedEntry` being updated. */
export type UpdateFeedEntryOnFeedEntryForFeedEntryCreatedByIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['UUID']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedById?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** An object where the defined keys will be set on the `feedEntry` being updated. */
export type UpdateFeedEntryOnFeedEntryForFeedEntryFeedIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedById?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** An object where the defined keys will be set on the `feedEntry` being updated. */
export type UpdateFeedEntryOnFeedEntryForFeedEntryUpdatedByIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  feedId?: InputMaybe<Scalars['UUID']>;
  feedToFeedId?: InputMaybe<FeedEntryFeedIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  markdownText?: InputMaybe<Scalars['String']>;
  newMainVariantId?: InputMaybe<Scalars['UUID']>;
  newMainVariantIndex?: InputMaybe<Scalars['Int']>;
  newStatus?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
  oldMainVariantId?: InputMaybe<Scalars['UUID']>;
  oldMainVariantIndex?: InputMaybe<Scalars['Int']>;
  oldStatus?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<FeedEntryCreatedByIdFkeyInput>;
  userToUpdatedById?: InputMaybe<FeedEntryUpdatedByIdFkeyInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnEventVariantForEventVariantChangesIdFkeyPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnExternalEventVariantForExternalEventVariantChangesIdFeedIdFkPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnFeedEntryForFeedEntryFeedIdFkeyPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnProjectVariantForProjectVariantChangesIdFkeyPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnScenarioForScenarioChangesIdFkeyPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnScenarioGroupForScenarioGroupChangesIdFkeyPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `feed` being updated. */
export type UpdateFeedOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyPatch = {
  eventVariantsUsingId?: InputMaybe<EventVariantChangesIdFkeyInverseInput>;
  externalEventVariantsUsingId?: InputMaybe<ExternalEventVariantChangesIdFeedIdFkInverseInput>;
  feedEntriesUsingId?: InputMaybe<FeedEntryFeedIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantChangesIdFkeyInverseInput>;
  scenarioGroupsToChangesIdUsingId?: InputMaybe<ScenarioGroupChangesIdFkeyInverseInput>;
  scenarioGroupsToOrganisationalChangesIdUsingId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInverseInput>;
  scenariosUsingId?: InputMaybe<ScenarioChangesIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnEventForEventIconIdFkeyPatch = {
  eventSeriesUsingId?: InputMaybe<EventSeriesIconIdFkeyInverseInput>;
  eventsUsingId?: InputMaybe<EventIconIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  url128?: InputMaybe<Scalars['String']>;
  url512?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnEventSeriesForEventSeriesIconIdFkeyPatch = {
  eventSeriesUsingId?: InputMaybe<EventSeriesIconIdFkeyInverseInput>;
  eventsUsingId?: InputMaybe<EventIconIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  url128?: InputMaybe<Scalars['String']>;
  url512?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelCapacityPax` being updated. */
export type UpdateLevelCapacityPaxOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `levelDescription` being updated. */
export type UpdateLevelDescriptionOnLevelDescriptionForLevelDescriptionLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelDescriptionLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelFkmGrossSpace` being updated. */
export type UpdateLevelFkmGrossSpaceOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `levelNameExtra` being updated. */
export type UpdateLevelNameExtraOnLevelNameExtraForLevelNameExtraLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameExtraLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelNameKeyCad` being updated. */
export type UpdateLevelNameKeyCadOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelNameKeyCafm` being updated. */
export type UpdateLevelNameKeyCafmOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelNameKeyEbm` being updated. */
export type UpdateLevelNameKeyEbmOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelNameKeyMarketing` being updated. */
export type UpdateLevelNameKeyMarketingOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelNameLong` being updated. */
export type UpdateLevelNameLongOnLevelNameLongForLevelNameLongLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameLongLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelNameShort` being updated. */
export type UpdateLevelNameShortOnLevelNameShortForLevelNameShortLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelNameShortLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelCapacityPaxForLevelCapacityPaxLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelDescriptionForLevelDescriptionLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelFkmGrossSpaceForLevelFkmGrossSpaceLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelForLevelBuildingIdFkeyPatch = {
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelForLevelElevationIdKeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelForLevelTypeIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameExtraForLevelNameExtraLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameKeyCadForLevelNameKeyCadLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameKeyCafmForLevelNameKeyCafmLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameKeyEbmForLevelNameKeyEbmsLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameKeyMarketingForLevelNameKeyMarketingLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameLongForLevelNameLongLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelNameShortForLevelNameShortLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `level` being updated. */
export type UpdateLevelOnRoomForRoomLevelIdFkeyPatch = {
  buildingId?: InputMaybe<Scalars['UUID']>;
  buildingToBuildingId?: InputMaybe<LevelBuildingIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['UUID']>;
  elevationLevelToElevationId?: InputMaybe<LevelElevationIdKeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  levelCapacityPaxesUsingId?: InputMaybe<LevelCapacityPaxLevelIdFkeyInverseInput>;
  levelDescriptionsUsingId?: InputMaybe<LevelDescriptionLevelIdFkeyInverseInput>;
  levelFkmGrossSpacesUsingId?: InputMaybe<LevelFkmGrossSpaceLevelIdFkeyInverseInput>;
  levelNameExtrasUsingId?: InputMaybe<LevelNameExtraLevelIdFkeyInverseInput>;
  levelNameKeyCadsUsingId?: InputMaybe<LevelNameKeyCadLevelIdFkeyInverseInput>;
  levelNameKeyCafmsUsingId?: InputMaybe<LevelNameKeyCafmLevelIdFkeyInverseInput>;
  levelNameKeyEbmsUsingId?: InputMaybe<LevelNameKeyEbmsLevelIdFkeyInverseInput>;
  levelNameKeyMarketingsUsingId?: InputMaybe<LevelNameKeyMarketingLevelIdFkeyInverseInput>;
  levelNameLongsUsingId?: InputMaybe<LevelNameLongLevelIdFkeyInverseInput>;
  levelNameShortsUsingId?: InputMaybe<LevelNameShortLevelIdFkeyInverseInput>;
  levelPublicGrossSpacesUsingId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInverseInput>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelIdFkeyInverseInput>;
  levelTypeToTypeId?: InputMaybe<LevelTypeIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomsUsingId?: InputMaybe<RoomLevelIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `levelPublicGrossSpace` being updated. */
export type UpdateLevelPublicGrossSpaceOnLevelPublicGrossSpaceForLevelPublicGrossSpaceLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelPublicGrossSpaceLevelIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `levelTypeAttr` being updated. */
export type UpdateLevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelTypeAttrLevelIdFkeyInput>;
  levelTypeId?: InputMaybe<Scalars['UUID']>;
  levelTypeToLevelTypeId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `levelTypeAttr` being updated. */
export type UpdateLevelTypeAttrOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<LevelTypeAttrLevelIdFkeyInput>;
  levelTypeToLevelTypeId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `levelType` being updated. */
export type UpdateLevelTypeOnLevelForLevelTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInverseInput>;
  levelsUsingId?: InputMaybe<LevelTypeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `levelType` being updated. */
export type UpdateLevelTypeOnLevelTypeAttrForLevelTypeAttrLevelTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  levelTypeAttrsUsingId?: InputMaybe<LevelTypeAttrLevelTypeIdFkeyInverseInput>;
  levelsUsingId?: InputMaybe<LevelTypeIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `link` being updated. */
export type UpdateLinkOnLinkForLinkMultilinkIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  multilinkToMultilinkId?: InputMaybe<LinkMultilinkIdFkeyInput>;
  name?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventCompetitionInternationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventCompetitionNationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventExternalDataIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventExtraDocumentsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventExtraSystemsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventFairAbroadCooperationIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventFairAbroadIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventFavoredParallelsExternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventFavoredParallelsInternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventInternalDataIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventOtherCompetitionInternationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventOtherCompetitionNationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventOtherLinksExternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventOtherLinksInternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventSubeventsLocalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventForEventSubeventsOtherLocationsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesCompetitionInternationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesCompetitionNationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesExecutorsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesExternalDataIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesExtraDocumentsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesExtraSystemsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesFairAbroadCooperationIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesFairAbroadIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesFavoredParallelsExternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesFavoredParallelsInternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesInternalDataIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesOrganizersIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesOtherCompetitionInternationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesOtherCompetitionNationalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesOtherLinksExternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesOtherLinksInternalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesSponsorsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesSubeventsLocalIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesSubeventsOtherLocationsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnEventSeriesForEventSeriesWebsitesIdMultilinkIdFkPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnExternalEventForExternalEventLinksIdMultilinkIdFkPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnExternalEventSeriesForExternalEventSeriesWebsitesIdMultilinkIdFkPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnLinkForLinkMultilinkIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectForProjectOtherDocumentsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectForProjectOtherLinksIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectForProjectOtherSystemsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectSeriesForProjectSeriesOtherLinksIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `multilink` being updated. */
export type UpdateMultilinkOnProjectSeriesForProjectSeriesWebsitesIdFkeyPatch = {
  eventSeriesToCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToCompetitionNationalIdUsingId?: InputMaybe<EventSeriesCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToExecutorsIdUsingId?: InputMaybe<EventSeriesExecutorsIdFkeyInverseInput>;
  eventSeriesToExternalDataIdUsingId?: InputMaybe<EventSeriesExternalDataIdFkeyInverseInput>;
  eventSeriesToExtraDocumentsIdUsingId?: InputMaybe<EventSeriesExtraDocumentsIdFkeyInverseInput>;
  eventSeriesToExtraSystemsIdUsingId?: InputMaybe<EventSeriesExtraSystemsIdFkeyInverseInput>;
  eventSeriesToFairAbroadCooperationIdUsingId?: InputMaybe<EventSeriesFairAbroadCooperationIdFkeyInverseInput>;
  eventSeriesToFairAbroadIdUsingId?: InputMaybe<EventSeriesFairAbroadIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsExternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsExternalIdFkeyInverseInput>;
  eventSeriesToFavoredParallelsInternalIdUsingId?: InputMaybe<EventSeriesFavoredParallelsInternalIdFkeyInverseInput>;
  eventSeriesToInternalDataIdUsingId?: InputMaybe<EventSeriesInternalDataIdFkeyInverseInput>;
  eventSeriesToOrganizersIdUsingId?: InputMaybe<EventSeriesOrganizersIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionInternationalIdFkeyInverseInput>;
  eventSeriesToOtherCompetitionNationalIdUsingId?: InputMaybe<EventSeriesOtherCompetitionNationalIdFkeyInverseInput>;
  eventSeriesToOtherLinksExternalIdUsingId?: InputMaybe<EventSeriesOtherLinksExternalIdFkeyInverseInput>;
  eventSeriesToOtherLinksInternalIdUsingId?: InputMaybe<EventSeriesOtherLinksInternalIdFkeyInverseInput>;
  eventSeriesToSponsorsIdUsingId?: InputMaybe<EventSeriesSponsorsIdFkeyInverseInput>;
  eventSeriesToSubeventsLocalIdUsingId?: InputMaybe<EventSeriesSubeventsLocalIdFkeyInverseInput>;
  eventSeriesToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSeriesSubeventsOtherLocationsIdFkeyInverseInput>;
  eventSeriesToWebsitesIdUsingId?: InputMaybe<EventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  eventsToCompetitionInternationalIdUsingId?: InputMaybe<EventCompetitionInternationalIdFkeyInverseInput>;
  eventsToCompetitionNationalIdUsingId?: InputMaybe<EventCompetitionNationalIdFkeyInverseInput>;
  eventsToExternalDataIdUsingId?: InputMaybe<EventExternalDataIdFkeyInverseInput>;
  eventsToExtraDocumentsIdUsingId?: InputMaybe<EventExtraDocumentsIdFkeyInverseInput>;
  eventsToExtraSystemsIdUsingId?: InputMaybe<EventExtraSystemsIdFkeyInverseInput>;
  eventsToFairAbroadCooperationIdUsingId?: InputMaybe<EventFairAbroadCooperationIdFkeyInverseInput>;
  eventsToFairAbroadIdUsingId?: InputMaybe<EventFairAbroadIdFkeyInverseInput>;
  eventsToFavoredParallelsExternalIdUsingId?: InputMaybe<EventFavoredParallelsExternalIdFkeyInverseInput>;
  eventsToFavoredParallelsInternalIdUsingId?: InputMaybe<EventFavoredParallelsInternalIdFkeyInverseInput>;
  eventsToInternalDataIdUsingId?: InputMaybe<EventInternalDataIdFkeyInverseInput>;
  eventsToOtherCompetitionInternationalIdUsingId?: InputMaybe<EventOtherCompetitionInternationalIdFkeyInverseInput>;
  eventsToOtherCompetitionNationalIdUsingId?: InputMaybe<EventOtherCompetitionNationalIdFkeyInverseInput>;
  eventsToOtherLinksExternalIdUsingId?: InputMaybe<EventOtherLinksExternalIdFkeyInverseInput>;
  eventsToOtherLinksInternalIdUsingId?: InputMaybe<EventOtherLinksInternalIdFkeyInverseInput>;
  eventsToSubeventsLocalIdUsingId?: InputMaybe<EventSubeventsLocalIdFkeyInverseInput>;
  eventsToSubeventsOtherLocationsIdUsingId?: InputMaybe<EventSubeventsOtherLocationsIdFkeyInverseInput>;
  externalEventSeriesUsingId?: InputMaybe<ExternalEventSeriesWebsitesIdMultilinkIdFkInverseInput>;
  externalEventsUsingId?: InputMaybe<ExternalEventLinksIdMultilinkIdFkInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  linksUsingId?: InputMaybe<LinkMultilinkIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  projectSeriesToOtherDocumentsIdUsingId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInverseInput>;
  projectSeriesToOtherLinksIdUsingId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInverseInput>;
  projectSeriesToOtherSystemsIdUsingId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInverseInput>;
  projectSeriesToWebsitesIdUsingId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInverseInput>;
  projectsToOtherDocumentsIdUsingId?: InputMaybe<ProjectOtherDocumentsIdFkeyInverseInput>;
  projectsToOtherLinksIdUsingId?: InputMaybe<ProjectOtherLinksIdFkeyInverseInput>;
  projectsToOtherSystemsIdUsingId?: InputMaybe<ProjectOtherSystemsIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `plotCadGrossSpaceMin` being updated. */
export type UpdatePlotCadGrossSpaceMinOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `plotDescription` being updated. */
export type UpdatePlotDescriptionOnPlotDescriptionForPlotDescriptionPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotDescriptionPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameExtra` being updated. */
export type UpdatePlotNameExtraOnPlotNameExtraForPlotNameExtraPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameExtraPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameKeyCad` being updated. */
export type UpdatePlotNameKeyCadOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameKeyCafm` being updated. */
export type UpdatePlotNameKeyCafmOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameKeyEbm` being updated. */
export type UpdatePlotNameKeyEbmOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameKeyMarketing` being updated. */
export type UpdatePlotNameKeyMarketingOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameLong` being updated. */
export type UpdatePlotNameLongOnPlotNameLongForPlotNameLongPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameLongPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plotNameShort` being updated. */
export type UpdatePlotNameShortOnPlotNameShortForPlotNameShortPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotNameShortPlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnAllocationPlotForAllocationPlotPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotCadGrossSpaceMinForPlotCadGrossSpaceMinPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotDescriptionForPlotDescriptionPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotForPlotAreaIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotForPlotTypeIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameExtraForPlotNameExtraPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameKeyCadForPlotNameKeyCadPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameKeyCafmForPlotNameKeyCafmPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameKeyEbmForPlotNameKeyEbmsPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameKeyMarketingForPlotNameKeyMarketingPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameLongForPlotNameLongPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotNameShortForPlotNameShortPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plot` being updated. */
export type UpdatePlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyPatch = {
  allocationPlotsUsingId?: InputMaybe<AllocationPlotPlotIdFkeyInverseInput>;
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<PlotAreaIdFkeyInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  plotCadGrossSpaceMinsUsingId?: InputMaybe<PlotCadGrossSpaceMinPlotIdFkeyInverseInput>;
  plotDescriptionsUsingId?: InputMaybe<PlotDescriptionPlotIdFkeyInverseInput>;
  plotNameExtrasUsingId?: InputMaybe<PlotNameExtraPlotIdFkeyInverseInput>;
  plotNameKeyCadsUsingId?: InputMaybe<PlotNameKeyCadPlotIdFkeyInverseInput>;
  plotNameKeyCafmsUsingId?: InputMaybe<PlotNameKeyCafmPlotIdFkeyInverseInput>;
  plotNameKeyEbmsUsingId?: InputMaybe<PlotNameKeyEbmsPlotIdFkeyInverseInput>;
  plotNameKeyMarketingsUsingId?: InputMaybe<PlotNameKeyMarketingPlotIdFkeyInverseInput>;
  plotNameLongsUsingId?: InputMaybe<PlotNameLongPlotIdFkeyInverseInput>;
  plotNameShortsUsingId?: InputMaybe<PlotNameShortPlotIdFkeyInverseInput>;
  plotPublicGrossSpacesUsingId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInverseInput>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotIdFkeyInverseInput>;
  plotTypeToTypeId?: InputMaybe<PlotTypeIdFkeyInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInverseInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `plotPublicGrossSpace` being updated. */
export type UpdatePlotPublicGrossSpaceOnPlotPublicGrossSpaceForPlotPublicGrossSpacePlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotPublicGrossSpacePlotIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `plotTypeAttr` being updated. */
export type UpdatePlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotTypeAttrPlotIdFkeyInput>;
  plotTypeId?: InputMaybe<Scalars['UUID']>;
  plotTypeToPlotTypeId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `plotTypeAttr` being updated. */
export type UpdatePlotTypeAttrOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<PlotTypeAttrPlotIdFkeyInput>;
  plotTypeToPlotTypeId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `plotType` being updated. */
export type UpdatePlotTypeOnPlotForPlotTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInverseInput>;
  plotsUsingId?: InputMaybe<PlotTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `plotType` being updated. */
export type UpdatePlotTypeOnPlotTypeAttrForPlotTypeAttrPlotTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plotTypeAttrsUsingId?: InputMaybe<PlotTypeAttrPlotTypeIdFkeyInverseInput>;
  plotsUsingId?: InputMaybe<PlotTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
export type UpdateProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaAreaIdFkeyPatch = {
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
export type UpdateProjectAllocationAreaOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
export type UpdateProjectAllocationAreaOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationArea` being updated. */
export type UpdateProjectAllocationAreaOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlPatch = {
  areaId?: InputMaybe<Scalars['UUID']>;
  areaToAreaId?: InputMaybe<ProjectAllocationAreaAreaIdFkeyInput>;
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInverseInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationAreaPhase` being updated. */
export type UpdateProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyPatch = {
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationAreaToAllocationId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectAllocationAreaPhase` being updated. */
export type UpdateProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationAreaToAllocationId?: InputMaybe<ProjectAllocationAreaPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectAllocationPlot` being updated. */
export type UpdateProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotPlotIdFkeyPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationPlot` being updated. */
export type UpdateProjectAllocationPlotOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationPlot` being updated. */
export type UpdateProjectAllocationPlotOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  plotId?: InputMaybe<Scalars['UUID']>;
  plotToPlotId?: InputMaybe<ProjectAllocationPlotPlotIdFkeyInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationPlotPhase` being updated. */
export type UpdateProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseAllocationIdFkeyPatch = {
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationPlotToAllocationId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectAllocationPlotPhase` being updated. */
export type UpdateProjectAllocationPlotPhaseOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationPlotToAllocationId?: InputMaybe<ProjectAllocationPlotPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
export type UpdateProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
export type UpdateProjectAllocationRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
export type UpdateProjectAllocationRoomOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationRoom` being updated. */
export type UpdateProjectAllocationRoomOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlPatch = {
  conflicts?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInverseInput>;
  projectVariantId?: InputMaybe<Scalars['UUID']>;
  projectVariantToProjectVariantId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInverseInput>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `projectAllocationRoomPhase` being updated. */
export type UpdateProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyPatch = {
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationRoomToAllocationId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
  usageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectAllocationRoomPhase` being updated. */
export type UpdateProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch = {
  allocationId?: InputMaybe<Scalars['UUID']>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<IntervalInput>;
  projectAllocationRoomToAllocationId?: InputMaybe<ProjectAllocationRoomPhaseAllocationIdFkeyInput>;
  projectAllocationUsageToUsageId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInput>;
  specializationType?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
export type UpdateProjectAllocationUsageOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseUsageIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type?: InputMaybe<ProjectAllocationUsageType>;
};

/** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
export type UpdateProjectAllocationUsageOnProjectAllocationPlotPhaseForProjectAllocationPlotPhaseUsageIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type?: InputMaybe<ProjectAllocationUsageType>;
};

/** An object where the defined keys will be set on the `projectAllocationUsage` being updated. */
export type UpdateProjectAllocationUsageOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseUsageIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  isExecution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  projectAllocationAreaPhasesUsingId?: InputMaybe<ProjectAllocationAreaPhaseUsageIdFkeyInverseInput>;
  projectAllocationPlotPhasesUsingId?: InputMaybe<ProjectAllocationPlotPhaseUsageIdFkeyInverseInput>;
  projectAllocationRoomPhasesUsingId?: InputMaybe<ProjectAllocationRoomPhaseUsageIdFkeyInverseInput>;
  type?: InputMaybe<ProjectAllocationUsageType>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectOtherDocumentsIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectOtherLinksIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectOtherSystemsIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectSeriesIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectVariantForProjectVariantProjectIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectOtherSystemsIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectSeriesToSeriesId?: InputMaybe<ProjectSeriesIdFkeyInput>;
  projectVariantsUsingId?: InputMaybe<ProjectVariantProjectIdFkeyInverseInput>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectSeries` being updated. */
export type UpdateProjectSeriesOnProjectForProjectSeriesIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectSeries` being updated. */
export type UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherDocumentsIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectSeries` being updated. */
export type UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherLinksIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectSeries` being updated. */
export type UpdateProjectSeriesOnProjectSeriesForProjectSeriesOtherSystemsIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  websitesId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `projectSeries` being updated. */
export type UpdateProjectSeriesOnProjectSeriesForProjectSeriesWebsitesIdFkeyPatch = {
  allocationHints?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  multilinkToOtherDocumentsId?: InputMaybe<ProjectSeriesOtherDocumentsIdFkeyInput>;
  multilinkToOtherLinksId?: InputMaybe<ProjectSeriesOtherLinksIdFkeyInput>;
  multilinkToOtherSystemsId?: InputMaybe<ProjectSeriesOtherSystemsIdFkeyInput>;
  multilinkToWebsitesId?: InputMaybe<ProjectSeriesWebsitesIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  projectsUsingId?: InputMaybe<ProjectSeriesIdFkeyInverseInput>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectAllocationAreaForProjectAllocationAreaProjectVariantIdFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectAllocationPlotForProjectAllocationPlotProjectVariantIdFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectAllocationRoomForProjectAllocationRoomProjectVariantIdFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectVariantForProjectVariantChangesIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectVariantForProjectVariantProjectIdFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationAreaIdProjectAlPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `projectVariant` being updated. */
export type UpdateProjectVariantOnProjectVariantForProjectVariantReferenceProjectAllocationRoomIdProjectAlPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Datetime']>;
  feedToChangesId?: InputMaybe<ProjectVariantChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectAllocationAreaToReferenceProjectAllocationAreaId?: InputMaybe<ProjectVariantReferenceProjectAllocationAreaIdProjectAlInput>;
  projectAllocationAreasUsingId?: InputMaybe<ProjectAllocationAreaProjectVariantIdFkeyInverseInput>;
  projectAllocationPlotsUsingId?: InputMaybe<ProjectAllocationPlotProjectVariantIdFkeyInverseInput>;
  projectAllocationRoomToReferenceProjectAllocationRoomId?: InputMaybe<ProjectVariantReferenceProjectAllocationRoomIdProjectAlInput>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomProjectVariantIdFkeyInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectToProjectId?: InputMaybe<ProjectVariantProjectIdFkeyInput>;
  referenceProjectAllocationAreaId?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomAirChangeRate` being updated. */
export type UpdateRoomAirChangeRateOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomAirConditioning` being updated. */
export type UpdateRoomAirConditioningOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomAirConditioningRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `roomCadGrossSpaceMin` being updated. */
export type UpdateRoomCadGrossSpaceMinOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCadHeightMax` being updated. */
export type UpdateRoomCadHeightMaxOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCadHeightMin` being updated. */
export type UpdateRoomCadHeightMinOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCadLengthMax` being updated. */
export type UpdateRoomCadLengthMaxOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCadLengthMin` being updated. */
export type UpdateRoomCadLengthMinOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCadWidthMax` being updated. */
export type UpdateRoomCadWidthMaxOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCadWidthMin` being updated. */
export type UpdateRoomCadWidthMinOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomCapacityCar` being updated. */
export type UpdateRoomCapacityCarOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `roomCapacityPax` being updated. */
export type UpdateRoomCapacityPaxOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `roomCapacityTruck` being updated. */
export type UpdateRoomCapacityTruckOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `roomCleaningGrossSpace` being updated. */
export type UpdateRoomCleaningGrossSpaceOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomClearanceConstruction` being updated. */
export type UpdateRoomClearanceConstructionOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomContactBooking` being updated. */
export type UpdateRoomContactBookingOnRoomContactBookingForRoomContactBookingRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomContactBookingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomDaylight` being updated. */
export type UpdateRoomDaylightOnRoomDaylightForRoomDaylightRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDaylightRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `roomDescription` being updated. */
export type UpdateRoomDescriptionOnRoomDescriptionForRoomDescriptionRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomDescriptionRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomKeyIssuanceNote` being updated. */
export type UpdateRoomKeyIssuanceNoteOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomKeyIssuance` being updated. */
export type UpdateRoomKeyIssuanceOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomLightShutter` being updated. */
export type UpdateRoomLightShutterOnRoomLightShutterForRoomLightShuttersRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomLightShuttersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `roomMaxLoadCeiling` being updated. */
export type UpdateRoomMaxLoadCeilingOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomMaxLoadFloor` being updated. */
export type UpdateRoomMaxLoadFloorOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomNameExtra` being updated. */
export type UpdateRoomNameExtraOnRoomNameExtraForRoomNameExtraRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameExtraRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNameKeyCad` being updated. */
export type UpdateRoomNameKeyCadOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNameKeyCafm` being updated. */
export type UpdateRoomNameKeyCafmOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNameKeyEbm` being updated. */
export type UpdateRoomNameKeyEbmOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNameKeyMarketing` being updated. */
export type UpdateRoomNameKeyMarketingOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNameLong` being updated. */
export type UpdateRoomNameLongOnRoomNameLongForRoomNameLongRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameLongRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNameShort` being updated. */
export type UpdateRoomNameShortOnRoomNameShortForRoomNameShortRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNameShortRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomNoVehicle` being updated. */
export type UpdateRoomNoVehicleOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnAllocationRoomForAllocationRoomRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnProjectAllocationRoomForProjectAllocationRoomRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomAirChangeRateForRoomAirChangeRateRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomAirConditioningForRoomAirConditioningRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadGrossSpaceMinForRoomCadGrossSpaceMinRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadHeightMaxForRoomCadHeightMaxRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadHeightMinForRoomCadHeightMinRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadLengthMaxForRoomCadLengthMaxRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadLengthMinForRoomCadLengthMinRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadWidthMaxForRoomCadWidthMaxRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCadWidthMinForRoomCadWidthMinRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCapacityCarForRoomCapacityCarsRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCapacityPaxForRoomCapacityPaxRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCapacityTruckForRoomCapacityTrucksRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomCleaningGrossSpaceForRoomCleaningGrossSpaceRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomClearanceConstructionForRoomClearanceConstructionRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomContactBookingForRoomContactBookingRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomDaylightForRoomDaylightRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomDescriptionForRoomDescriptionRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomForRoomLevelIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomForRoomTypeIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomKeyIssuanceForRoomKeyIssuanceRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomKeyIssuanceNoteForRoomKeyIssuanceNotesRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomLightShutterForRoomLightShuttersRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomMaxLoadCeilingForRoomMaxLoadCeilingRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomMaxLoadFloorForRoomMaxLoadFloorRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameExtraForRoomNameExtraRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameKeyCadForRoomNameKeyCadRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameKeyCafmForRoomNameKeyCafmRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameKeyEbmForRoomNameKeyEbmsRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameKeyMarketingForRoomNameKeyMarketingRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameLongForRoomNameLongRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNameShortForRoomNameShortRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomNoVehicleForRoomNoVehiclesRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomPartitionForRoomPartitionRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `room` being updated. */
export type UpdateRoomOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyPatch = {
  allocationRoomsUsingId?: InputMaybe<AllocationRoomRoomIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  levelId?: InputMaybe<Scalars['UUID']>;
  levelToLevelId?: InputMaybe<RoomLevelIdFkeyInput>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  projectAllocationRoomsUsingId?: InputMaybe<ProjectAllocationRoomRoomIdFkeyInverseInput>;
  roomAirChangeRatesUsingId?: InputMaybe<RoomAirChangeRateRoomIdFkeyInverseInput>;
  roomAirConditioningsUsingId?: InputMaybe<RoomAirConditioningRoomIdFkeyInverseInput>;
  roomCadGrossSpaceMinsUsingId?: InputMaybe<RoomCadGrossSpaceMinRoomIdFkeyInverseInput>;
  roomCadHeightMaxesUsingId?: InputMaybe<RoomCadHeightMaxRoomIdFkeyInverseInput>;
  roomCadHeightMinsUsingId?: InputMaybe<RoomCadHeightMinRoomIdFkeyInverseInput>;
  roomCadLengthMaxesUsingId?: InputMaybe<RoomCadLengthMaxRoomIdFkeyInverseInput>;
  roomCadLengthMinsUsingId?: InputMaybe<RoomCadLengthMinRoomIdFkeyInverseInput>;
  roomCadWidthMaxesUsingId?: InputMaybe<RoomCadWidthMaxRoomIdFkeyInverseInput>;
  roomCadWidthMinsUsingId?: InputMaybe<RoomCadWidthMinRoomIdFkeyInverseInput>;
  roomCapacityCarsUsingId?: InputMaybe<RoomCapacityCarsRoomIdFkeyInverseInput>;
  roomCapacityPaxesUsingId?: InputMaybe<RoomCapacityPaxRoomIdFkeyInverseInput>;
  roomCapacityTrucksUsingId?: InputMaybe<RoomCapacityTrucksRoomIdFkeyInverseInput>;
  roomCleaningGrossSpacesUsingId?: InputMaybe<RoomCleaningGrossSpaceRoomIdFkeyInverseInput>;
  roomClearanceConstructionsUsingId?: InputMaybe<RoomClearanceConstructionRoomIdFkeyInverseInput>;
  roomContactBookingsUsingId?: InputMaybe<RoomContactBookingRoomIdFkeyInverseInput>;
  roomDaylightsUsingId?: InputMaybe<RoomDaylightRoomIdFkeyInverseInput>;
  roomDescriptionsUsingId?: InputMaybe<RoomDescriptionRoomIdFkeyInverseInput>;
  roomKeyIssuanceNotesUsingId?: InputMaybe<RoomKeyIssuanceNotesRoomIdFkeyInverseInput>;
  roomKeyIssuancesUsingId?: InputMaybe<RoomKeyIssuanceRoomIdFkeyInverseInput>;
  roomLightShuttersUsingId?: InputMaybe<RoomLightShuttersRoomIdFkeyInverseInput>;
  roomMaxLoadCeilingsUsingId?: InputMaybe<RoomMaxLoadCeilingRoomIdFkeyInverseInput>;
  roomMaxLoadFloorsUsingId?: InputMaybe<RoomMaxLoadFloorRoomIdFkeyInverseInput>;
  roomNameExtrasUsingId?: InputMaybe<RoomNameExtraRoomIdFkeyInverseInput>;
  roomNameKeyCadsUsingId?: InputMaybe<RoomNameKeyCadRoomIdFkeyInverseInput>;
  roomNameKeyCafmsUsingId?: InputMaybe<RoomNameKeyCafmRoomIdFkeyInverseInput>;
  roomNameKeyEbmsUsingId?: InputMaybe<RoomNameKeyEbmsRoomIdFkeyInverseInput>;
  roomNameKeyMarketingsUsingId?: InputMaybe<RoomNameKeyMarketingRoomIdFkeyInverseInput>;
  roomNameLongsUsingId?: InputMaybe<RoomNameLongRoomIdFkeyInverseInput>;
  roomNameShortsUsingId?: InputMaybe<RoomNameShortRoomIdFkeyInverseInput>;
  roomNoVehiclesUsingId?: InputMaybe<RoomNoVehiclesRoomIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionRoomIdFkeyInverseInput>;
  roomPhoneNumbersUsingId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInverseInput>;
  roomPublicGrossSpacesUsingId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInverseInput>;
  roomSbvGrossSpacesUsingId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInverseInput>;
  roomTireLoadCarsUsingId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInverseInput>;
  roomTireLoadForkliftsUsingId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInverseInput>;
  roomTireLoadTrucksUsingId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInverseInput>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomIdFkeyInverseInput>;
  roomTypeToTypeId?: InputMaybe<RoomTypeIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadGrossSpaceMin` being updated. */
export type UpdateRoomPartitionCadGrossSpaceMinOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadHeightMax` being updated. */
export type UpdateRoomPartitionCadHeightMaxOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadHeightMin` being updated. */
export type UpdateRoomPartitionCadHeightMinOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadLengthMax` being updated. */
export type UpdateRoomPartitionCadLengthMaxOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadLengthMin` being updated. */
export type UpdateRoomPartitionCadLengthMinOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadWidthMax` being updated. */
export type UpdateRoomPartitionCadWidthMaxOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCadWidthMin` being updated. */
export type UpdateRoomPartitionCadWidthMinOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionCapacityPax` being updated. */
export type UpdateRoomPartitionCapacityPaxOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `roomPartitionCleaningGrossSpace` being updated. */
export type UpdateRoomPartitionCleaningGrossSpaceOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionDescription` being updated. */
export type UpdateRoomPartitionDescriptionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameExtra` being updated. */
export type UpdateRoomPartitionNameExtraOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameKeyCad` being updated. */
export type UpdateRoomPartitionNameKeyCadOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameKeyCafm` being updated. */
export type UpdateRoomPartitionNameKeyCafmOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameKeyEbm` being updated. */
export type UpdateRoomPartitionNameKeyEbmOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameKeyMarketing` being updated. */
export type UpdateRoomPartitionNameKeyMarketingOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameLong` being updated. */
export type UpdateRoomPartitionNameLongOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartitionNameShort` being updated. */
export type UpdateRoomPartitionNameShortOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadGrossSpaceMinForRoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadHeightMaxForRoomPartitionCadHeightMaxRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadHeightMinForRoomPartitionCadHeightMinRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadLengthMaxForRoomPartitionCadLengthMaxRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadLengthMinForRoomPartitionCadLengthMinRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadWidthMaxForRoomPartitionCadWidthMaxRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCadWidthMinForRoomPartitionCadWidthMinRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCapacityPaxForRoomPartitionCapacityPaxRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionCleaningGrossSpaceForRoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionDescriptionForRoomPartitionDescriptionRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionForRoomPartitionRoomIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionForRoomPartitionTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameExtraForRoomPartitionNameExtraRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameKeyCadForRoomPartitionNameKeyCadRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameKeyCafmForRoomPartitionNameKeyCafmRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameKeyEbmForRoomPartitionNameKeyEbmsRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameKeyMarketingForRoomPartitionNameKeyMarketingRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameLongForRoomPartitionNameLongRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionNameShortForRoomPartitionNameShortRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartition` being updated. */
export type UpdateRoomPartitionOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomPartitionCadGrossSpaceMinsUsingId?: InputMaybe<RoomPartitionCadGrossSpaceMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMaxesUsingId?: InputMaybe<RoomPartitionCadHeightMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadHeightMinsUsingId?: InputMaybe<RoomPartitionCadHeightMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMaxesUsingId?: InputMaybe<RoomPartitionCadLengthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadLengthMinsUsingId?: InputMaybe<RoomPartitionCadLengthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMaxesUsingId?: InputMaybe<RoomPartitionCadWidthMaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCadWidthMinsUsingId?: InputMaybe<RoomPartitionCadWidthMinRoomPartitionIdFkeyInverseInput>;
  roomPartitionCapacityPaxesUsingId?: InputMaybe<RoomPartitionCapacityPaxRoomPartitionIdFkeyInverseInput>;
  roomPartitionCleaningGrossSpacesUsingId?: InputMaybe<RoomPartitionCleaningGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionDescriptionsUsingId?: InputMaybe<RoomPartitionDescriptionRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameExtrasUsingId?: InputMaybe<RoomPartitionNameExtraRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCadsUsingId?: InputMaybe<RoomPartitionNameKeyCadRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyCafmsUsingId?: InputMaybe<RoomPartitionNameKeyCafmRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyEbmsUsingId?: InputMaybe<RoomPartitionNameKeyEbmsRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameKeyMarketingsUsingId?: InputMaybe<RoomPartitionNameKeyMarketingRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameLongsUsingId?: InputMaybe<RoomPartitionNameLongRoomPartitionIdFkeyInverseInput>;
  roomPartitionNameShortsUsingId?: InputMaybe<RoomPartitionNameShortRoomPartitionIdFkeyInverseInput>;
  roomPartitionPublicGrossSpacesUsingId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionSbvGrossSpacesUsingId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInverseInput>;
  roomPartitionTypeToTypeId?: InputMaybe<RoomPartitionTypeIdFkeyInput>;
  roomToRoomId?: InputMaybe<RoomPartitionRoomIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roomPartitionPublicGrossSpace` being updated. */
export type UpdateRoomPartitionPublicGrossSpaceOnRoomPartitionPublicGrossSpaceForRoomPartitionPublicGrossSpaceRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionPublicGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionSbvGrossSpace` being updated. */
export type UpdateRoomPartitionSbvGrossSpaceOnRoomPartitionSbvGrossSpaceForRoomPartitionSbvGrossSpaceRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionSbvGrossSpaceRoomPartitionIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomPartitionTypeAttr` being updated. */
export type UpdateRoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInput>;
  roomPartitionTypeId?: InputMaybe<Scalars['UUID']>;
  roomPartitionTypeToRoomPartitionTypeId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roomPartitionTypeAttr` being updated. */
export type UpdateRoomPartitionTypeAttrOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomPartitionId?: InputMaybe<Scalars['UUID']>;
  roomPartitionToRoomPartitionId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionIdFkeyInput>;
  roomPartitionTypeToRoomPartitionTypeId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roomPartitionType` being updated. */
export type UpdateRoomPartitionTypeOnRoomPartitionForRoomPartitionTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `roomPartitionType` being updated. */
export type UpdateRoomPartitionTypeOnRoomPartitionTypeAttrForRoomPartitionTypeAttrRoomPartitionTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roomPartitionTypeAttrsUsingId?: InputMaybe<RoomPartitionTypeAttrRoomPartitionTypeIdFkeyInverseInput>;
  roomPartitionsUsingId?: InputMaybe<RoomPartitionTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `roomPhoneNumber` being updated. */
export type UpdateRoomPhoneNumberOnRoomPhoneNumberForRoomPhoneNumbersRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPhoneNumbersRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roomPublicGrossSpace` being updated. */
export type UpdateRoomPublicGrossSpaceOnRoomPublicGrossSpaceForRoomPublicGrossSpaceRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomPublicGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomSbvGrossSpace` being updated. */
export type UpdateRoomSbvGrossSpaceOnRoomSbvGrossSpaceForRoomSbvGrossSpaceRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomSbvGrossSpaceRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomTireLoadCar` being updated. */
export type UpdateRoomTireLoadCarOnRoomTireLoadCarForRoomTireLoadCarRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadCarRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomTireLoadForklift` being updated. */
export type UpdateRoomTireLoadForkliftOnRoomTireLoadForkliftForRoomTireLoadForkliftRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadForkliftRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomTireLoadTruck` being updated. */
export type UpdateRoomTireLoadTruckOnRoomTireLoadTruckForRoomTireLoadTruckRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTireLoadTruckRoomIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
};

/** An object where the defined keys will be set on the `roomTypeAttr` being updated. */
export type UpdateRoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTypeAttrRoomIdFkeyInput>;
  roomTypeId?: InputMaybe<Scalars['UUID']>;
  roomTypeToRoomTypeId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roomTypeAttr` being updated. */
export type UpdateRoomTypeAttrOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roomId?: InputMaybe<Scalars['UUID']>;
  roomToRoomId?: InputMaybe<RoomTypeAttrRoomIdFkeyInput>;
  roomTypeToRoomTypeId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roomType` being updated. */
export type UpdateRoomTypeOnRoomForRoomTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInverseInput>;
  roomsUsingId?: InputMaybe<RoomTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `roomType` being updated. */
export type UpdateRoomTypeOnRoomTypeAttrForRoomTypeAttrRoomTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roomTypeAttrsUsingId?: InputMaybe<RoomTypeAttrRoomTypeIdFkeyInverseInput>;
  roomsUsingId?: InputMaybe<RoomTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `scenarioGroup` being updated. */
export type UpdateScenarioGroupOnScenarioForScenarioScenarioGroupIdFkeyPatch = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** An object where the defined keys will be set on the `scenarioGroup` being updated. */
export type UpdateScenarioGroupOnScenarioGroupForScenarioGroupChangesIdFkeyPatch = {
  businessDomain?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** An object where the defined keys will be set on the `scenarioGroup` being updated. */
export type UpdateScenarioGroupOnScenarioGroupForScenarioGroupCreatedByFkeyPatch = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** An object where the defined keys will be set on the `scenarioGroup` being updated. */
export type UpdateScenarioGroupOnScenarioGroupForScenarioGroupOrganisationalChangesIdFkeyPatch = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** An object where the defined keys will be set on the `scenarioGroup` being updated. */
export type UpdateScenarioGroupOnScenarioGroupForScenarioGroupUpdatedByFkeyPatch = {
  businessDomain?: InputMaybe<Scalars['String']>;
  changesId?: InputMaybe<Scalars['UUID']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioGroupChangesIdFkeyInput>;
  feedToOrganisationalChangesId?: InputMaybe<ScenarioGroupOrganisationalChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  organisationalChangesId?: InputMaybe<Scalars['UUID']>;
  responsible?: InputMaybe<Scalars['String']>;
  scenariosUsingId?: InputMaybe<ScenarioScenarioGroupIdFkeyInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioGroupCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioGroupUpdatedByFkeyInput>;
};

/** An object where the defined keys will be set on the `scenario` being updated. */
export type UpdateScenarioOnScenarioForScenarioChangesIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenario` being updated. */
export type UpdateScenarioOnScenarioForScenarioCreatedByFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenario` being updated. */
export type UpdateScenarioOnScenarioForScenarioScenarioGroupIdFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenario` being updated. */
export type UpdateScenarioOnScenarioForScenarioUpdatedByFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenario` being updated. */
export type UpdateScenarioOnScenarioSettingForScenarioSettingScenarioIdFkeyPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenario` being updated. */
export type UpdateScenarioOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkPatch = {
  changesId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  createdByName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feedToChangesId?: InputMaybe<ScenarioChangesIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  scenarioGroupId?: InputMaybe<Scalars['UUID']>;
  scenarioGroupToScenarioGroupId?: InputMaybe<ScenarioScenarioGroupIdFkeyInput>;
  scenarioSettingUsingId?: InputMaybe<ScenarioSettingScenarioIdFkeyInverseInput>;
  scenarioVariantVisibilitiesUsingId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInverseInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['UUID']>;
  updatedByName?: InputMaybe<Scalars['String']>;
  userToCreatedBy?: InputMaybe<ScenarioCreatedByFkeyInput>;
  userToUpdatedBy?: InputMaybe<ScenarioUpdatedByFkeyInput>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenarioSetting` being updated. */
export type UpdateScenarioSettingOnScenarioSettingForScenarioSettingScenarioIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  monthsAfter?: InputMaybe<Scalars['Int']>;
  monthsBefore?: InputMaybe<Scalars['Int']>;
  quarter?: InputMaybe<Scalars['Int']>;
  scenarioToScenarioId?: InputMaybe<ScenarioSettingScenarioIdFkeyInput>;
  showSections?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['Datetime']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `scenarioVariantVisibility` being updated. */
export type UpdateScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  scenarioToScenarioId?: InputMaybe<ScenarioVariantVisibilityScenarioIdScenarioIdFkInput>;
  variantId?: InputMaybe<Scalars['UUID']>;
  variantType?: InputMaybe<VariantType>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteDescription` being updated. */
export type UpdateSiteDescriptionOnSiteDescriptionForSiteDescriptionSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteDescriptionSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameExtra` being updated. */
export type UpdateSiteNameExtraOnSiteNameExtraForSiteNameExtraSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameExtraSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameKeyCad` being updated. */
export type UpdateSiteNameKeyCadOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameKeyCafm` being updated. */
export type UpdateSiteNameKeyCafmOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameKeyEbm` being updated. */
export type UpdateSiteNameKeyEbmOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameKeyMarketing` being updated. */
export type UpdateSiteNameKeyMarketingOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameLong` being updated. */
export type UpdateSiteNameLongOnSiteNameLongForSiteNameLongSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameLongSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `siteNameShort` being updated. */
export type UpdateSiteNameShortOnSiteNameShortForSiteNameShortSiteIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<SiteNameShortSiteIdFkeyInput>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnBuildingForBuildingSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteDescriptionForSiteDescriptionSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameExtraForSiteNameExtraSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameKeyCadForSiteNameKeyCadSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameKeyCafmForSiteNameKeyCafmSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameKeyEbmForSiteNameKeyEbmsSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameKeyMarketingForSiteNameKeyMarketingSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameLongForSiteNameLongSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnSiteNameShortForSiteNameShortSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `site` being updated. */
export type UpdateSiteOnZoneForZoneSiteIdFkeyPatch = {
  buildingsUsingId?: InputMaybe<BuildingSiteIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteDescriptionsUsingId?: InputMaybe<SiteDescriptionSiteIdFkeyInverseInput>;
  siteNameExtrasUsingId?: InputMaybe<SiteNameExtraSiteIdFkeyInverseInput>;
  siteNameKeyCadsUsingId?: InputMaybe<SiteNameKeyCadSiteIdFkeyInverseInput>;
  siteNameKeyCafmsUsingId?: InputMaybe<SiteNameKeyCafmSiteIdFkeyInverseInput>;
  siteNameKeyEbmsUsingId?: InputMaybe<SiteNameKeyEbmsSiteIdFkeyInverseInput>;
  siteNameKeyMarketingsUsingId?: InputMaybe<SiteNameKeyMarketingSiteIdFkeyInverseInput>;
  siteNameLongsUsingId?: InputMaybe<SiteNameLongSiteIdFkeyInverseInput>;
  siteNameShortsUsingId?: InputMaybe<SiteNameShortSiteIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneSiteIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFeedEntryForFeedEntryCreatedByIdFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFeedEntryForFeedEntryUpdatedByIdFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnScenarioForScenarioCreatedByFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnScenarioForScenarioUpdatedByFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnScenarioGroupForScenarioGroupCreatedByFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnScenarioGroupForScenarioGroupUpdatedByFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserPasswordLoginForUserPasswordLoginUserIdFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserSsoLoginForUserSsoLoginUserIdFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  feedEntriesToCreatedByIdUsingId?: InputMaybe<FeedEntryCreatedByIdFkeyInverseInput>;
  feedEntriesToUpdatedByIdUsingId?: InputMaybe<FeedEntryUpdatedByIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  scenarioGroupsToCreatedByUsingId?: InputMaybe<ScenarioGroupCreatedByFkeyInverseInput>;
  scenarioGroupsToUpdatedByUsingId?: InputMaybe<ScenarioGroupUpdatedByFkeyInverseInput>;
  scenariosToCreatedByUsingId?: InputMaybe<ScenarioCreatedByFkeyInverseInput>;
  scenariosToUpdatedByUsingId?: InputMaybe<ScenarioUpdatedByFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userPasswordLoginUsingId?: InputMaybe<UserPasswordLoginUserIdFkeyInverseInput>;
  userSsoLoginsUsingId?: InputMaybe<UserSsoLoginUserIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `userPasswordLogin` being updated. */
export type UpdateUserPasswordLoginOnUserPasswordLoginForUserPasswordLoginUserIdFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<UserPasswordLoginUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `userSsoLogin` being updated. */
export type UpdateUserSsoLoginOnUserSsoLoginForUserSsoLoginUserIdFkeyPatch = {
  activatedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deactivatedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  oid?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<SsoProvider>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<UserSsoLoginUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneCadGrossSpaceMin` being updated. */
export type UpdateZoneCadGrossSpaceMinOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneToZoneId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneCapacityCar` being updated. */
export type UpdateZoneCapacityCarOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
  zoneToZoneId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneCapacityTruck` being updated. */
export type UpdateZoneCapacityTruckOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Int']>;
  zoneToZoneId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneDescription` being updated. */
export type UpdateZoneDescriptionOnZoneDescriptionForZoneDescriptionZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneDescriptionZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneMaxLoadFloor` being updated. */
export type UpdateZoneMaxLoadFloorOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneToZoneId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameExtra` being updated. */
export type UpdateZoneNameExtraOnZoneNameExtraForZoneNameExtraZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameExtraZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameKeyCad` being updated. */
export type UpdateZoneNameKeyCadOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameKeyCafm` being updated. */
export type UpdateZoneNameKeyCafmOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameKeyEbm` being updated. */
export type UpdateZoneNameKeyEbmOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameKeyMarketing` being updated. */
export type UpdateZoneNameKeyMarketingOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameLong` being updated. */
export type UpdateZoneNameLongOnZoneNameLongForZoneNameLongZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameLongZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNameShort` being updated. */
export type UpdateZoneNameShortOnZoneNameShortForZoneNameShortZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
  zoneToZoneId?: InputMaybe<ZoneNameShortZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneNoVehicle` being updated. */
export type UpdateZoneNoVehicleOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['Boolean']>;
  zoneToZoneId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnAreaForAreaZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneCadGrossSpaceMinForZoneCadGrossSpaceMinZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneCapacityCarForZoneCapacityCarsZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneCapacityTruckForZoneCapacityTrucksZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneDescriptionForZoneDescriptionZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneForZoneSiteIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneForZoneTypeIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneMaxLoadFloorForZoneMaxLoadFloorZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameExtraForZoneNameExtraZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameKeyCadForZoneNameKeyCadZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameKeyCafmForZoneNameKeyCafmZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameKeyEbmForZoneNameKeyEbmsZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameKeyMarketingForZoneNameKeyMarketingZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameLongForZoneNameLongZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNameShortForZoneNameShortZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneNoVehicleForZoneNoVehiclesZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zone` being updated. */
export type UpdateZoneOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyPatch = {
  areasUsingId?: InputMaybe<AreaZoneIdFkeyInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['UUID']>;
  siteToSiteId?: InputMaybe<ZoneSiteIdFkeyInput>;
  typeId?: InputMaybe<Scalars['UUID']>;
  zoneCadGrossSpaceMinsUsingId?: InputMaybe<ZoneCadGrossSpaceMinZoneIdFkeyInverseInput>;
  zoneCapacityCarsUsingId?: InputMaybe<ZoneCapacityCarsZoneIdFkeyInverseInput>;
  zoneCapacityTrucksUsingId?: InputMaybe<ZoneCapacityTrucksZoneIdFkeyInverseInput>;
  zoneDescriptionsUsingId?: InputMaybe<ZoneDescriptionZoneIdFkeyInverseInput>;
  zoneMaxLoadFloorsUsingId?: InputMaybe<ZoneMaxLoadFloorZoneIdFkeyInverseInput>;
  zoneNameExtrasUsingId?: InputMaybe<ZoneNameExtraZoneIdFkeyInverseInput>;
  zoneNameKeyCadsUsingId?: InputMaybe<ZoneNameKeyCadZoneIdFkeyInverseInput>;
  zoneNameKeyCafmsUsingId?: InputMaybe<ZoneNameKeyCafmZoneIdFkeyInverseInput>;
  zoneNameKeyEbmsUsingId?: InputMaybe<ZoneNameKeyEbmsZoneIdFkeyInverseInput>;
  zoneNameKeyMarketingsUsingId?: InputMaybe<ZoneNameKeyMarketingZoneIdFkeyInverseInput>;
  zoneNameLongsUsingId?: InputMaybe<ZoneNameLongZoneIdFkeyInverseInput>;
  zoneNameShortsUsingId?: InputMaybe<ZoneNameShortZoneIdFkeyInverseInput>;
  zoneNoVehiclesUsingId?: InputMaybe<ZoneNoVehiclesZoneIdFkeyInverseInput>;
  zonePublicGrossSpacesUsingId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInverseInput>;
  zoneTireLoadCarsUsingId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInverseInput>;
  zoneTireLoadForkliftsUsingId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInverseInput>;
  zoneTireLoadTrucksUsingId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInverseInput>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInverseInput>;
  zoneTypeToTypeId?: InputMaybe<ZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zonePublicGrossSpace` being updated. */
export type UpdateZonePublicGrossSpaceOnZonePublicGrossSpaceForZonePublicGrossSpaceZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneToZoneId?: InputMaybe<ZonePublicGrossSpaceZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneTireLoadCar` being updated. */
export type UpdateZoneTireLoadCarOnZoneTireLoadCarForZoneTireLoadCarZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadCarZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneTireLoadForklift` being updated. */
export type UpdateZoneTireLoadForkliftOnZoneTireLoadForkliftForZoneTireLoadForkliftZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadForkliftZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneTireLoadTruck` being updated. */
export type UpdateZoneTireLoadTruckOnZoneTireLoadTruckForZoneTireLoadTruckZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['BigFloat']>;
  zoneToZoneId?: InputMaybe<ZoneTireLoadTruckZoneIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneTypeAttr` being updated. */
export type UpdateZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  zoneToZoneId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInput>;
  zoneTypeId?: InputMaybe<Scalars['UUID']>;
  zoneTypeToZoneTypeId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneTypeAttr` being updated. */
export type UpdateZoneTypeAttrOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyPatch = {
  end?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  start?: InputMaybe<Scalars['Datetime']>;
  zoneId?: InputMaybe<Scalars['UUID']>;
  zoneToZoneId?: InputMaybe<ZoneTypeAttrZoneIdFkeyInput>;
  zoneTypeToZoneTypeId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInput>;
};

/** An object where the defined keys will be set on the `zoneType` being updated. */
export type UpdateZoneTypeOnZoneForZoneTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneTypeIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `zoneType` being updated. */
export type UpdateZoneTypeOnZoneTypeAttrForZoneTypeAttrZoneTypeIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  zoneTypeAttrsUsingId?: InputMaybe<ZoneTypeAttrZoneTypeIdFkeyInverseInput>;
  zonesUsingId?: InputMaybe<ZoneTypeIdFkeyInverseInput>;
};

export type GetSectionsDataForAllocationDesignerTimelineQueryVariables = Exact<{
  startDateTime?: InputMaybe<Scalars['Datetime']>;
  endDateTime?: InputMaybe<Scalars['Datetime']>;
  roomTypes: Array<Scalars['String']> | Scalars['String'];
  areaTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetSectionsDataForAllocationDesignerTimelineQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', id: string, nameShort: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } }> } }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } }> } }> } | null, rooms?: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } | null, allocationRooms?: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', isCurrent: boolean, id: string, index: number, name: string, status: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string, nameLong: string, status: string, companyGroup: string, businessDomain: string, responsible: string } }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null, projectAllocationRooms?: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', isCurrent: boolean, id: string, index: number, name: string, status: string, referenceProjectAllocationRoomId?: string | null, referenceProjectAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string, nameLong: string, status: string, companyGroup: string, businessDomain: string } }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null, areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } | null, allocationAreas?: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', isCurrent: boolean, id: string, index: number, name: string, status: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string, nameLong: string, status: string, companyGroup: string, businessDomain: string, responsible: string } }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null, projectAllocationAreas?: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', isCurrent: boolean, id: string, index: number, name: string, status: string, referenceProjectAllocationRoomId?: string | null, referenceProjectAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string, nameLong: string, status: string, companyGroup: string, businessDomain: string } }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null, allocationUsages?: { __typename?: 'AllocationUsagesConnection', nodes: Array<{ __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }> } | null, projectAllocationUsages?: { __typename?: 'ProjectAllocationUsagesConnection', nodes: Array<{ __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }> } | null, externalEventAllocationUsages?: { __typename?: 'ExternalEventAllocationUsagesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }> } | null };

export type DesignerScenarioFragment = { __typename?: 'Scenario', id: string, index: number, nameShort: string, year: number, variantVisibilities: { __typename?: 'ScenarioVariantVisibilitiesConnection', nodes: Array<{ __typename?: 'ScenarioVariantVisibility', id: string, variantId: string, variantType: VariantType, visibility: string }> } };

export type GetDesignerScenarioQueryVariables = Exact<{
  scenarioId: Scalars['UUID'];
}>;


export type GetDesignerScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, index: number, nameShort: string, year: number, variantVisibilities: { __typename?: 'ScenarioVariantVisibilitiesConnection', nodes: Array<{ __typename?: 'ScenarioVariantVisibility', id: string, variantId: string, variantType: VariantType, visibility: string }> } } | null };

export type UpdateScenarioVisibilitiesMutationVariables = Exact<{
  scenarioId: Scalars['UUID'];
  create?: InputMaybe<Array<ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioVariantVisibilityCreateInput> | ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioVariantVisibilityCreateInput>;
  deleteById?: InputMaybe<Array<ScenarioVariantVisibilityScenarioVariantVisibilityPkeyDelete> | ScenarioVariantVisibilityScenarioVariantVisibilityPkeyDelete>;
  updateById?: InputMaybe<Array<ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityPkeyUpdate> | ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityPkeyUpdate>;
}>;


export type UpdateScenarioVisibilitiesMutation = { __typename?: 'Mutation', updateScenario?: { __typename?: 'UpdateScenarioPayload', scenario?: { __typename?: 'Scenario', id: string, scenarioVariantVisibilities: { __typename?: 'ScenarioVariantVisibilitiesConnection', nodes: Array<{ __typename?: 'ScenarioVariantVisibility', id: string, variantId: string, variantType: VariantType, visibility: string }> } } | null } | null };

export type GetAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAreasQuery = { __typename?: 'Query', areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, nameLong: string }> } | null };

export type GetAreaChildrenForTreeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAreaChildrenForTreeQuery = { __typename?: 'Query', area?: { __typename?: 'Area', id: string, plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, nameShort: string, nameLong: string, type?: { __typename?: 'PlotType', id: string, name: string } | null }> } } | null };

export type GetAreaForAreaDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAreaForAreaDetailsQuery = { __typename?: 'Query', area?: { __typename?: 'Area', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } }, plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, allocationPlots: { __typename?: 'AllocationPlotsConnection', nodes: Array<{ __typename?: 'AllocationPlot', id: string }> } }> }, type?: { __typename?: 'AreaType', name: string } | null, nameExtra: { __typename?: 'AreaNameExtrasConnection', nodes: Array<{ __typename?: 'AreaNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'AreaClearanceConstructionsConnection', nodes: Array<{ __typename?: 'AreaClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'AreaKeyIssuancesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'AreaKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } } | null, areaTypes?: { __typename?: 'AreaTypesConnection', nodes: Array<{ __typename?: 'AreaType', id: string, name: string }> } | null };

export type GetAreaForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAreaForEditQuery = { __typename?: 'Query', area?: { __typename?: 'Area', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } }, type?: { __typename?: 'AreaType', name: string } | null, nameExtra: { __typename?: 'AreaNameExtrasConnection', nodes: Array<{ __typename?: 'AreaNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'AreaClearanceConstructionsConnection', nodes: Array<{ __typename?: 'AreaClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'AreaKeyIssuancesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'AreaKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } } | null, areaTypes?: { __typename?: 'AreaTypesConnection', nodes: Array<{ __typename?: 'AreaType', id: string, name: string }> } | null };

export type GetAreaForCreateQueryVariables = Exact<{
  zoneId: Scalars['UUID'];
}>;


export type GetAreaForCreateQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } | null, areaTypes?: { __typename?: 'AreaTypesConnection', nodes: Array<{ __typename?: 'AreaType', id: string, name: string }> } | null };

export type CreateAreaMutationVariables = Exact<{
  zoneId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type CreateAreaMutation = { __typename?: 'Mutation', createArea?: { __typename?: 'CreateAreaPayload', area?: { __typename?: 'Area', id: string, nameShort: string } | null } | null };

export type GetAreaTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAreaTypesQuery = { __typename?: 'Query', areaTypes?: { __typename?: 'AreaTypesConnection', nodes: Array<{ __typename?: 'AreaType', id: string, name: string, index: number }> } | null };

export type UpdateAreaMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type UpdateAreaMutation = { __typename?: 'Mutation', updateArea?: { __typename?: 'UpdateAreaPayload', area?: { __typename?: 'Area', id: string, nameLong: string, nameShort: string, description: string, type?: { __typename?: 'AreaType', id: string, name: string } | null } | null } | null };

export type DeleteAreaMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteAreaMutation = { __typename?: 'Mutation', deleteArea?: { __typename?: 'DeleteAreaPayload', area?: { __typename?: 'Area', id: string, nameShort: string, zoneId: string } | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename: 'InvalidCredentials' } | { __typename: 'Session', jwt: string, user: { __typename?: 'SessionUser', name: string, firstName: string, lastName: string, email: string, isAdmin: boolean, provider: SessionProvider } } };

export type TokenRefreshMutationVariables = Exact<{
  provider: SessionProvider;
}>;


export type TokenRefreshMutation = { __typename?: 'Mutation', refreshJwt: { __typename: 'Session', jwt: string, user: { __typename?: 'SessionUser', name: string, firstName: string, lastName: string, email: string, isAdmin: boolean, provider: SessionProvider } } };

export type GetIsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsAdminQuery = { __typename?: 'Query', myUser?: { __typename?: 'User', isAdmin: boolean } | null };

export type SetPasswordMutationVariables = Exact<{
  userId: Scalars['UUID'];
  password: Scalars['String'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: { __typename: 'Success', message: string } };

export type UpdatePasswordMutationVariables = Exact<{
  userId: Scalars['UUID'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename: 'InvalidCredentials', message: string } | { __typename: 'Success', message: string } };

export type EntraLoginMutationVariables = Exact<{
  provider: SsoProvider;
  idToken: Scalars['String'];
}>;


export type EntraLoginMutation = { __typename?: 'Mutation', entraLogin: { __typename: 'InvalidCredentials', message: string } | { __typename: 'Session', jwt: string, user: { __typename?: 'SessionUser', name: string, firstName: string, lastName: string, email: string, isAdmin: boolean, provider: SessionProvider } } };

export type ActivateSsoLoginMutationVariables = Exact<{
  userId: Scalars['UUID'];
  provider: SsoProvider;
  oid: Scalars['String'];
}>;


export type ActivateSsoLoginMutation = { __typename?: 'Mutation', activateSsoLogin: { __typename?: 'AlreadyLinked', message: string } | { __typename?: 'InvalidEntraToken' } | { __typename?: 'InvalidOid' } | { __typename?: 'SsoLoginData', id: string, isActive: boolean, oid: string, provider: SsoProvider, createdAt: string, updatedAt: string } };

export type DeactivateSsoLoginMutationVariables = Exact<{
  userId: Scalars['UUID'];
  provider: SsoProvider;
  oid: Scalars['String'];
}>;


export type DeactivateSsoLoginMutation = { __typename?: 'Mutation', deactivateSsoLogin: { __typename?: 'NotFound', message: string } | { __typename?: 'Success', message: string } };

export type DeactivatePasswordLoginMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type DeactivatePasswordLoginMutation = { __typename?: 'Mutation', deactivatePasswordLogin: { __typename?: 'NotFound', message: string } | { __typename?: 'Success', message: string } };

export type GetBuildingTypeChildrenForTreeQueryVariables = Exact<{
  typeId: Scalars['UUID'];
  siteId: Scalars['UUID'];
}>;


export type GetBuildingTypeChildrenForTreeQuery = { __typename?: 'Query', buildingType?: { __typename?: 'BuildingType', id: string, buildingsByTypeId: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, nameLong: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string }> }, type?: { __typename?: 'BuildingType', id: string, name: string } | null }> } } | null };

export type GetCreateBuildingParamsQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetCreateBuildingParamsQuery = { __typename?: 'Query', site?: { __typename?: 'Site', id: string, nameShort: string } | null, buildingTypes?: { __typename?: 'BuildingTypesConnection', nodes: Array<{ __typename?: 'BuildingType', id: string, name: string }> } | null };

export type GetBuildingChildrenForTreeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBuildingChildrenForTreeQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, nameLong: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string }> }, type?: { __typename?: 'LevelType', id: string, name: string } | null }> } } | null };

export type GetBuildingForDetailsPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBuildingForDetailsPageQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, site: { __typename?: 'Site', id: string, nameShort: string }, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, allocationRooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string }> } }> } }> }, type?: { __typename?: 'BuildingType', name: string } | null, nameExtra: { __typename?: 'BuildingNameExtrasConnection', nodes: Array<{ __typename?: 'BuildingNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'BuildingNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'BuildingNameKeyCadsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'BuildingNameKeyEbmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'BuildingNameKeyCafmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } } | null, buildingTypes?: { __typename?: 'BuildingTypesConnection', nodes: Array<{ __typename?: 'BuildingType', id: string, name: string }> } | null };

export type GetBuildingForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBuildingForEditQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, site: { __typename?: 'Site', id: string, nameShort: string }, type?: { __typename?: 'BuildingType', name: string } | null, nameExtra: { __typename?: 'BuildingNameExtrasConnection', nodes: Array<{ __typename?: 'BuildingNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'BuildingNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'BuildingNameKeyCadsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'BuildingNameKeyEbmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'BuildingNameKeyCafmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } } | null, buildingTypes?: { __typename?: 'BuildingTypesConnection', nodes: Array<{ __typename?: 'BuildingType', id: string, name: string }> } | null };

export type GetBuildingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuildingTypesQuery = { __typename?: 'Query', buildingTypes?: { __typename?: 'BuildingTypesConnection', nodes: Array<{ __typename?: 'BuildingType', id: string, name: string, index: number }> } | null };

export type CreateBuildingMutationVariables = Exact<{
  siteId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type CreateBuildingMutation = { __typename?: 'Mutation', createBuilding?: { __typename?: 'CreateBuildingPayload', building?: { __typename?: 'Building', id: string, nameShort: string } | null } | null };

export type UpdateBuildingMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type UpdateBuildingMutation = { __typename?: 'Mutation', updateBuilding?: { __typename?: 'UpdateBuildingPayload', building?: { __typename?: 'Building', id: string, nameLong: string, nameShort: string, description: string, type?: { __typename?: 'BuildingType', id: string, name: string } | null } | null } | null };

export type DeleteBuildingMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteBuildingMutation = { __typename?: 'Mutation', deleteBuilding?: { __typename?: 'DeleteBuildingPayload', building?: { __typename?: 'Building', id: string, nameShort: string, siteId: string } | null } | null };

export type AllocationSelectionFilterEventVariantFragment = { __typename?: 'EventVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string }> } };

export type AllocationSelectionFilterEventFragment = { __typename?: 'Event', id: string, nameShort: string, status: string, activeVariants: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string }> } }> }, nonActiveVariants: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string }> } }> } };

export type GetEventsInTimeRangeQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
}>;


export type GetEventsInTimeRangeQuery = { __typename?: 'Query', allocationGroups?: { __typename?: 'EventsConnection', nodes: Array<{ __typename?: 'Event', id: string, nameShort: string, status: string, activeVariants: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string }> } }> }, nonActiveVariants: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string }> } }> } }> } | null };

export type AllocationSelectionFilterProjectVariantFragment = { __typename?: 'ProjectVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string }> } };

export type AllocationSelectionFilterProjectFragment = { __typename?: 'Project', id: string, nameShort: string, status: string, activeVariants: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string }> } }> }, nonActiveVariants: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string }> } }> } };

export type GetProjectsInTimeRangeQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
}>;


export type GetProjectsInTimeRangeQuery = { __typename?: 'Query', allocationGroups?: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, nameShort: string, status: string, activeVariants: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string }> } }> }, nonActiveVariants: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, name: string, isCurrent: boolean, index: number, status: string, rooms: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string }> } }> } }> } | null };

export type AllocationSelectionFilterExternalEventVariantFragment = { __typename?: 'ExternalEventVariant', id: string, name: string, isCurrent: boolean, index: number, status: ExternalEventVariantStatus, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, start: string, end: string, locationId: string }> } };

export type AllocationSelectionFilterExternalEventFragment = { __typename?: 'ExternalEvent', id: string, nameShort: string, status: ExternalEventEventStatus, series: { __typename?: 'ExternalEventSeries', id: string, national: boolean, category: ExternalEventSeriesCategory }, activeVariants: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, name: string, isCurrent: boolean, index: number, status: ExternalEventVariantStatus, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, start: string, end: string, locationId: string }> } }> }, nonActiveVariants: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, name: string, isCurrent: boolean, index: number, status: ExternalEventVariantStatus, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, start: string, end: string, locationId: string }> } }> }, visibilities: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, locationId: string, visibility: ExternalEventLocationVisibility }> } };

export type GetExternalEventsInTimeRangeQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
}>;


export type GetExternalEventsInTimeRangeQuery = { __typename?: 'Query', allocationGroups?: { __typename?: 'ExternalEventsConnection', nodes: Array<{ __typename?: 'ExternalEvent', id: string, nameShort: string, status: ExternalEventEventStatus, series: { __typename?: 'ExternalEventSeries', id: string, national: boolean, category: ExternalEventSeriesCategory }, activeVariants: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, name: string, isCurrent: boolean, index: number, status: ExternalEventVariantStatus, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, start: string, end: string, locationId: string }> } }> }, nonActiveVariants: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, name: string, isCurrent: boolean, index: number, status: ExternalEventVariantStatus, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, start: string, end: string, locationId: string }> } }> }, visibilities: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, locationId: string, visibility: ExternalEventLocationVisibility }> } }> } | null };

export type MultiLinkDataFragment = { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } };

export type CreateMultiLinkMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateMultiLinkMutation = { __typename?: 'Mutation', createMultilink?: { __typename?: 'CreateMultilinkPayload', multilink?: { __typename?: 'Multilink', id: string } | null } | null };

export type CreateLinkMutationVariables = Exact<{
  multiLinkId: Scalars['UUID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
}>;


export type CreateLinkMutation = { __typename?: 'Mutation', createLink?: { __typename?: 'CreateLinkPayload', link?: { __typename?: 'Link', id: string, name: string, description: string, to: string } | null } | null };

export type UpdateLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
}>;


export type UpdateLinkMutation = { __typename?: 'Mutation', updateLink?: { __typename?: 'UpdateLinkPayload', link?: { __typename?: 'Link', id: string, description: string, name: string, to: string } | null } | null };

export type DeleteLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteLinkMutation = { __typename?: 'Mutation', deleteLink?: { __typename?: 'DeleteLinkPayload', clientMutationId?: string | null } | null };

export type DeleteMultiLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteMultiLinkMutation = { __typename?: 'Mutation', deleteMultilink?: { __typename?: 'DeleteMultilinkPayload', clientMutationId?: string | null } | null };

export type PhaseTileAreaPhaseFragment = { __typename?: 'AllocationAreaPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'AllocationUsage', id: string, nameShort: string, name: string, type: AllocationUsageType } };

export type PhaseTileRoomPhaseFragment = { __typename?: 'AllocationRoomPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'AllocationUsage', id: string, nameShort: string, name: string, type: AllocationUsageType } };

export type ProjectPhaseTileAreaPhaseFragment = { __typename?: 'ProjectAllocationAreaPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'ProjectAllocationUsage', id: string, nameShort: string, name: string, type: ProjectAllocationUsageType } };

export type ProjectPhaseTileRoomPhaseFragment = { __typename?: 'ProjectAllocationRoomPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'ProjectAllocationUsage', id: string, nameShort: string, name: string, type: ProjectAllocationUsageType } };

export type PhaseTileExternalEventPhaseFragment = { __typename?: 'ExternalEventAllocationPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, nameShort: string, name: string, type: ExternalEventAllocationUsageType } };

export type AllocationAreaPhaseTileDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AllocationAreaPhaseTileDataQuery = { __typename?: 'Query', allocation?: { __typename?: 'AllocationArea', id: string, start: string, end: string, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'AllocationUsage', id: string, nameShort: string, name: string, type: AllocationUsageType } }> } } | null };

export type AllocationRoomPhaseTileDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AllocationRoomPhaseTileDataQuery = { __typename?: 'Query', allocation?: { __typename?: 'AllocationRoom', id: string, start: string, end: string, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'AllocationUsage', id: string, nameShort: string, name: string, type: AllocationUsageType } }> } } | null };

export type ProjectAllocationAreaPhaseTileDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectAllocationAreaPhaseTileDataQuery = { __typename?: 'Query', allocation?: { __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'ProjectAllocationUsage', id: string, nameShort: string, name: string, type: ProjectAllocationUsageType } }> } } | null };

export type ProjectAllocationRoomPhaseTileDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectAllocationRoomPhaseTileDataQuery = { __typename?: 'Query', allocation?: { __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'ProjectAllocationUsage', id: string, nameShort: string, name: string, type: ProjectAllocationUsageType } }> } } | null };

export type ExternalEventAllocationPhaseTileDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ExternalEventAllocationPhaseTileDataQuery = { __typename?: 'Query', allocation?: { __typename?: 'ExternalEventAllocation', id: string, start: string, end: string, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, nameShort: string, name: string, type: ExternalEventAllocationUsageType } }> } } | null };

export type DeleteEventAllocationRoomMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
}>;


export type DeleteEventAllocationRoomMutation = { __typename?: 'Mutation', delete?: { __typename?: 'DeleteAllocationRoomPayload', allocation?: { __typename?: 'AllocationRoom', id: string, start: string, end: string, locationId: string, variantId: string } | null } | null };

export type DeleteEventAllocationAreaMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
}>;


export type DeleteEventAllocationAreaMutation = { __typename?: 'Mutation', delete?: { __typename?: 'DeleteAllocationAreaPayload', allocation?: { __typename?: 'AllocationArea', id: string, locationId: string, variantId: string } | null } | null };

export type DeleteProjectAllocationRoomMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
}>;


export type DeleteProjectAllocationRoomMutation = { __typename?: 'Mutation', delete?: { __typename?: 'DeleteProjectAllocationRoomPayload', allocation?: { __typename?: 'ProjectAllocationRoom', id: string, locationId: string, variantId: string } | null } | null };

export type DeleteProjectAllocationAreaMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
}>;


export type DeleteProjectAllocationAreaMutation = { __typename?: 'Mutation', delete?: { __typename?: 'DeleteProjectAllocationAreaPayload', allocation?: { __typename?: 'ProjectAllocationArea', id: string, locationId: string, variantId: string } | null } | null };

export type GetAllocationUsagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllocationUsagesQuery = { __typename?: 'Query', allocationUsages?: { __typename?: 'AllocationUsagesConnection', nodes: Array<{ __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }> } | null };

export type GetProjectAllocationUsagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectAllocationUsagesQuery = { __typename?: 'Query', projectAllocationUsages?: { __typename?: 'ProjectAllocationUsagesConnection', nodes: Array<{ __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }> } | null };

export type GetAllocationUsageIdByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetAllocationUsageIdByNameQuery = { __typename?: 'Query', allocationUsageByName?: { __typename?: 'AllocationUsage', id: string } | null };

export type AllocationRoomUpdateAndDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  updateAllocation: AllocationUpdateInput;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>> | InputMaybe<AllocationPhaseCreateInput>>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>> | InputMaybe<AllocationPhaseUpdateInput>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type AllocationRoomUpdateAndDuplicateMutation = { __typename?: 'Mutation', updateAndDuplicate?: { __typename?: 'AllocationRoomUpdateAndDuplicatePayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type AllocationAreaUpdateAndDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  updateAllocation: AllocationUpdateInput;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>> | InputMaybe<AllocationPhaseCreateInput>>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>> | InputMaybe<AllocationPhaseUpdateInput>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type AllocationAreaUpdateAndDuplicateMutation = { __typename?: 'Mutation', updateAndDuplicate?: { __typename?: 'AllocationAreaUpdateAndDuplicatePayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type AllocationRoomDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type AllocationRoomDuplicateMutation = { __typename?: 'Mutation', duplicate?: { __typename?: 'AllocationRoomDuplicatePayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type AllocationAreaDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type AllocationAreaDuplicateMutation = { __typename?: 'Mutation', duplicate?: { __typename?: 'AllocationAreaDuplicatePayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type ProjectAllocationRoomUpdateAndDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  updateAllocation: AllocationUpdateInput;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>> | InputMaybe<AllocationPhaseCreateInput>>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>> | InputMaybe<AllocationPhaseUpdateInput>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  areaIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type ProjectAllocationRoomUpdateAndDuplicateMutation = { __typename?: 'Mutation', updateAndDuplicate?: { __typename?: 'ProjectAllocationRoomUpdateAndDuplicatePayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type ProjectAllocationAreaUpdateAndDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  updateAllocation: AllocationUpdateInput;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>> | InputMaybe<AllocationPhaseCreateInput>>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>> | InputMaybe<AllocationPhaseUpdateInput>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type ProjectAllocationAreaUpdateAndDuplicateMutation = { __typename?: 'Mutation', updateAndDuplicate?: { __typename?: 'ProjectAllocationAreaUpdateAndDuplicatePayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type ProjectAllocationRoomDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type ProjectAllocationRoomDuplicateMutation = { __typename?: 'Mutation', duplicate?: { __typename?: 'ProjectAllocationRoomDuplicatePayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type ProjectAllocationAreaDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  roomIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type ProjectAllocationAreaDuplicateMutation = { __typename?: 'Mutation', duplicate?: { __typename?: 'ProjectAllocationAreaDuplicatePayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type AllocationRoomGetQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AllocationRoomGetQuery = { __typename?: 'Query', allocationRoom?: { __typename?: 'AllocationRoom', id: string, roomId: string, start: string, end: string, eventVariant: { __typename?: 'EventVariant', id: string, name: string }, allocationRoomPhasesByAllocationId: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null };

export type EventPhaseTypeFragment = { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean };

export type TimelineEventRoomPhaseFragment = { __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineEventAreaPhaseFragment = { __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineEventPlotPhaseFragment = { __typename?: 'AllocationPlotPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineEventAllocationRoomFragment = { __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type TimelineEventAllocationAreaFragment = { __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type TimelineEventAllocationPlotFragment = { __typename?: 'AllocationPlot', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string }, phases: { __typename?: 'AllocationPlotPhasesConnection', nodes: Array<{ __typename?: 'AllocationPlotPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type TimelineEventVariantFragment = { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } };

export type TimelineEventFragment = { __typename?: 'Event', id: string, nameShort: string, executionYear: number, series?: { __typename?: 'EventSeries', nameShort: string } | null, variants: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } }> } };

export type ProjectPhaseTypeFragment = { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean };

export type TimelineProjectRoomPhaseFragment = { __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineProjectAreaPhaseFragment = { __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineProjectPlotPhaseFragment = { __typename?: 'ProjectAllocationPlotPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineProjectAllocationRoomFragment = { __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type TimelineProjectAllocationAreaFragment = { __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type TimelineProjectAllocationPlotFragment = { __typename?: 'ProjectAllocationPlot', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string }, phases: { __typename?: 'ProjectAllocationPlotPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationPlotPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type TimelineProjectVariantFragment = { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } };

export type TimelineProjectFragment = { __typename?: 'Project', id: string, nameShort: string, executionYear: number, series?: { __typename?: 'ProjectSeries', nameShort: string } | null, variants: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } }> } };

export type TimelineSiteFragment = { __typename?: 'Site', id: string, nameShort: string };

export type TimelineFullSiteFragment = { __typename?: 'Site', id: string, nameShort: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } }> } }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } }> } };

export type TimelineRoomFragment = { __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null };

export type TimelineAreaFragment = { __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null };

export type GetEventDataForTimelineQueryVariables = Exact<{
  eventId: Scalars['UUID'];
  activeStates: Array<Scalars['String']> | Scalars['String'];
  roomTypes: Array<Scalars['String']> | Scalars['String'];
  areaTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetEventDataForTimelineQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', id: string, nameShort: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } }> } }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } }> } }> } | null, rooms?: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } | null, areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } | null, event?: { __typename?: 'Event', id: string, nameShort: string, executionYear: number, series?: { __typename?: 'EventSeries', nameShort: string } | null, variants: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } }> } } | null, usages?: { __typename?: 'AllocationUsagesConnection', nodes: Array<{ __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }> } | null, allocationRooms?: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, locationId: string }> } | null, allocationAreas?: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, locationId: string }> } | null, firstAllocationRoom?: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string }> } | null, firstAllocationArea?: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string }> } | null };

export type GetAllocationsForEventVariantsQueryVariables = Exact<{
  eventVariantIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetAllocationsForEventVariantsQuery = { __typename?: 'Query', allocationRooms?: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, roomId: string, eventVariantId: string, start: string, end: string, conflicts: number, allocationRoomPhasesByAllocationId: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null };

export type GetProjectDataForTimelineQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  activeStates: Array<Scalars['String']> | Scalars['String'];
  roomTypes: Array<Scalars['String']> | Scalars['String'];
  areaTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetProjectDataForTimelineQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', id: string, nameShort: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } }> } }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } }> } }> } | null, rooms?: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } | null, areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } | null, project?: { __typename?: 'Project', id: string, nameShort: string, executionYear: number, series?: { __typename?: 'ProjectSeries', nameShort: string } | null, variants: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } }> } } | null, usages?: { __typename?: 'ProjectAllocationUsagesConnection', nodes: Array<{ __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }> } | null, projectAllocationRooms?: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, locationId: string }> } | null, projectAllocationAreas?: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, locationId: string }> } | null, firstAllocationRoom?: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string }> } | null, firstAllocationArea?: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string }> } | null };

export type SeriesMultiLinkFieldsFragment = { __typename?: 'EventSeries', organizers?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, executors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, sponsors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type EventMultiLinkFieldsFragment = { __typename?: 'Event', extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type GetEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventsQuery = { __typename?: 'Query', eventSerieses?: { __typename?: 'EventSeriesConnection', nodes: Array<{ __typename?: 'EventSeries', id: string, nameShort: string, singleEvent: boolean }> } | null, events?: { __typename?: 'EventsConnection', nodes: Array<{ __typename?: 'Event', id: string, nameShort: string, series?: { __typename?: 'EventSeries', id: string, nameShort: string } | null, mainVariant: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, name: string, start?: string | null, end?: string | null }> } }> } | null };

export type GetEventSeriesBaseDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventSeriesBaseDataQuery = { __typename?: 'Query', eventSerieses?: { __typename?: 'EventSeriesConnection', nodes: Array<{ __typename?: 'EventSeries', id: string, nameShort: string, singleEvent: boolean, status: string }> } | null };

export type SeriesEventMainVariantFragment = { __typename?: 'EventVariant', id: string, index: number, name: string, start?: string | null, end?: string | null, status: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null };

export type SeriesEventDataFragment = { __typename?: 'Event', id: string, nameShort: string, status: string, executionYear: number, mainVariant: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, index: number, name: string, start?: string | null, end?: string | null, status: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null }> }, eventVariants: { __typename?: 'EventVariantsConnection', totalCount: number } };

export type EventSeriesDataFragment = { __typename?: 'EventSeries', id: string, status: string, nameShort: string, nameLong: string, subtitle: string, numberKapman: string, numberShort: string, foundationYear?: number | null, notes: string, description: string, category: string, type: string, isTechnical?: boolean | null, isPublic?: boolean | null, partnersOverviewName: string, partnersOverviewLink: string, additionalPartners: string, iconUploadStatus?: UploadStatus | null, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, notesDayOrder: string, notesSetup: string, notesEarlyConstructionInternal: string, notesEarlyConstructionExternal: string, notesConstruction: string, notesExecution: string, notesDismantling: string, notesExtendedDismantlingExternal: string, notesExtendedDismantlingInternal: string, notesTechnicalDismantling: string, notesDayOrderHistory: string, notesAppointmentRules: string, notesMonths: string, notesHolidaysNrw: string, notesHolidaysNational: string, notesHolidaysInternational: string, notesPublicHolidaysNrw: string, notesPublicHolidaysNational: string, notesPublicHolidaysInternational: string, otherNotesAppointmentRules: string, appointmentHistory: string, cycle: string, cycleChanges: string, allocationRules: string, locationHistory: string, otherAllocationNeeds: string, notesHallExhibitionAreas: string, notesBoulevardSections: string, notesPassages: string, notesEntrances: string, notesServiceCenters: string, notesConferenceRooms: string, notesOfficesInternal: string, notesStorageInternal: string, notesOfficesExternal: string, notesStorageExternal: string, notesAreas: string, notesParking: string, singleEvent: boolean, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } }, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null, events: { __typename?: 'EventsConnection', nodes: Array<{ __typename?: 'Event', id: string, nameShort: string, status: string, executionYear: number, mainVariant: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, index: number, name: string, start?: string | null, end?: string | null, status: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null }> }, eventVariants: { __typename?: 'EventVariantsConnection', totalCount: number } }> }, organizers?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, executors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, sponsors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type GetSeriesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSeriesQuery = { __typename?: 'Query', eventSeries?: { __typename?: 'EventSeries', id: string, status: string, nameShort: string, nameLong: string, subtitle: string, numberKapman: string, numberShort: string, foundationYear?: number | null, notes: string, description: string, category: string, type: string, isTechnical?: boolean | null, isPublic?: boolean | null, partnersOverviewName: string, partnersOverviewLink: string, additionalPartners: string, iconUploadStatus?: UploadStatus | null, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, notesDayOrder: string, notesSetup: string, notesEarlyConstructionInternal: string, notesEarlyConstructionExternal: string, notesConstruction: string, notesExecution: string, notesDismantling: string, notesExtendedDismantlingExternal: string, notesExtendedDismantlingInternal: string, notesTechnicalDismantling: string, notesDayOrderHistory: string, notesAppointmentRules: string, notesMonths: string, notesHolidaysNrw: string, notesHolidaysNational: string, notesHolidaysInternational: string, notesPublicHolidaysNrw: string, notesPublicHolidaysNational: string, notesPublicHolidaysInternational: string, otherNotesAppointmentRules: string, appointmentHistory: string, cycle: string, cycleChanges: string, allocationRules: string, locationHistory: string, otherAllocationNeeds: string, notesHallExhibitionAreas: string, notesBoulevardSections: string, notesPassages: string, notesEntrances: string, notesServiceCenters: string, notesConferenceRooms: string, notesOfficesInternal: string, notesStorageInternal: string, notesOfficesExternal: string, notesStorageExternal: string, notesAreas: string, notesParking: string, singleEvent: boolean, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } }, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null, events: { __typename?: 'EventsConnection', nodes: Array<{ __typename?: 'Event', id: string, nameShort: string, status: string, executionYear: number, mainVariant: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, index: number, name: string, start?: string | null, end?: string | null, status: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null }> }, eventVariants: { __typename?: 'EventVariantsConnection', totalCount: number } }> }, organizers?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, executors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, sponsors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null };

export type GetEventSeriesLogoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEventSeriesLogoQuery = { __typename?: 'Query', eventSeries?: { __typename?: 'EventSeries', id: string, iconUploadStatus?: UploadStatus | null, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null };

export type CreateEventMutationVariables = Exact<{
  seriesId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong: Scalars['String'];
  executionYear: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent?: { __typename?: 'CreateEventPayload', event?: { __typename?: 'Event', id: string, nameShort: string, nameLong: string, executionYear: number, status: string } | null } | null };

export type CreateEventSeriesMutationVariables = Exact<{
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateEventSeriesMutation = { __typename?: 'Mutation', createEventSeries?: { __typename?: 'CreateEventSeriesPayload', eventSeries?: { __typename?: 'EventSeries', id: string, nameShort: string, nameLong: string, subtitle: string, singleEvent: boolean } | null } | null };

export type SetSingleEventMutationVariables = Exact<{
  id: Scalars['UUID'];
  singleEvent: Scalars['Boolean'];
}>;


export type SetSingleEventMutation = { __typename?: 'Mutation', updateEventSeries?: { __typename?: 'UpdateEventSeriesPayload', eventSeries?: { __typename?: 'EventSeries', id: string, nameShort: string, singleEvent: boolean } | null } | null };

export type UpdateEventSeriesStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
}>;


export type UpdateEventSeriesStatusMutation = { __typename?: 'Mutation', updateEventSeries?: { __typename?: 'UpdateEventSeriesPayload', eventSeries?: { __typename?: 'EventSeries', id: string, status: string } | null } | null };

export type UpdateEventSeriesMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  allocationRules?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  cycleChanges?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  foundationYear?: InputMaybe<Scalars['Int']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notesAppointmentRules?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesDayOrderHistory?: InputMaybe<Scalars['String']>;
  numberKapman?: InputMaybe<Scalars['String']>;
  numberShort?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  otherAllocationNeeds?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  partnersOverviewName?: InputMaybe<Scalars['String']>;
  partnersOverviewLink?: InputMaybe<Scalars['String']>;
  additionalPartners?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  isTechnical?: InputMaybe<Scalars['Boolean']>;
  notesSetup?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionInternal?: InputMaybe<Scalars['String']>;
  notesEarlyConstructionExternal?: InputMaybe<Scalars['String']>;
  notesConstruction?: InputMaybe<Scalars['String']>;
  notesExecution?: InputMaybe<Scalars['String']>;
  notesDismantling?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingExternal?: InputMaybe<Scalars['String']>;
  notesExtendedDismantlingInternal?: InputMaybe<Scalars['String']>;
  notesTechnicalDismantling?: InputMaybe<Scalars['String']>;
  notesMonths?: InputMaybe<Scalars['String']>;
  notesHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesHolidaysNational?: InputMaybe<Scalars['String']>;
  notesHolidaysInternational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNrw?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysNational?: InputMaybe<Scalars['String']>;
  notesPublicHolidaysInternational?: InputMaybe<Scalars['String']>;
  otherNotesAppointmentRules?: InputMaybe<Scalars['String']>;
  appointmentHistory?: InputMaybe<Scalars['String']>;
  locationHistory?: InputMaybe<Scalars['String']>;
  notesHallExhibitionAreas?: InputMaybe<Scalars['String']>;
  notesBoulevardSections?: InputMaybe<Scalars['String']>;
  notesPassages?: InputMaybe<Scalars['String']>;
  notesEntrances?: InputMaybe<Scalars['String']>;
  notesServiceCenters?: InputMaybe<Scalars['String']>;
  notesConferenceRooms?: InputMaybe<Scalars['String']>;
  notesOfficesInternal?: InputMaybe<Scalars['String']>;
  notesStorageInternal?: InputMaybe<Scalars['String']>;
  notesOfficesExternal?: InputMaybe<Scalars['String']>;
  notesStorageExternal?: InputMaybe<Scalars['String']>;
  notesAreas?: InputMaybe<Scalars['String']>;
  notesParking?: InputMaybe<Scalars['String']>;
  singleEvent?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEventSeriesMutation = { __typename?: 'Mutation', updateEventSeries?: { __typename?: 'UpdateEventSeriesPayload', eventSeries?: { __typename?: 'EventSeries', id: string, nameShort: string, nameLong: string, subtitle: string, numberShort: string, foundationYear?: number | null, notes: string, description: string, iconUploadStatus?: UploadStatus | null, category: string, type: string, isPublic?: boolean | null, isTechnical?: boolean | null, partnersOverviewName: string, partnersOverviewLink: string, additionalPartners: string, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, notesDayOrder: string, notesDayOrderHistory: string, notesAppointmentRules: string, cycle: string, cycleChanges: string, allocationRules: string, otherAllocationNeeds: string, notesSetup: string, notesEarlyConstructionInternal: string, notesEarlyConstructionExternal: string, notesConstruction: string, notesExecution: string, notesDismantling: string, notesExtendedDismantlingExternal: string, notesExtendedDismantlingInternal: string, notesTechnicalDismantling: string, notesMonths: string, notesHolidaysNrw: string, notesHolidaysNational: string, notesHolidaysInternational: string, notesPublicHolidaysNrw: string, notesPublicHolidaysNational: string, notesPublicHolidaysInternational: string, otherNotesAppointmentRules: string, appointmentHistory: string, locationHistory: string, notesHallExhibitionAreas: string, notesBoulevardSections: string, notesPassages: string, notesEntrances: string, notesServiceCenters: string, notesConferenceRooms: string, notesOfficesInternal: string, notesStorageInternal: string, notesOfficesExternal: string, notesStorageExternal: string, notesAreas: string, notesParking: string, singleEvent: boolean, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null } | null };

export type UpdateEventSeriesMultiLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
  organizersId?: InputMaybe<Scalars['UUID']>;
  executorsId?: InputMaybe<Scalars['UUID']>;
  sponsorsId?: InputMaybe<Scalars['UUID']>;
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateEventSeriesMultiLinkMutation = { __typename?: 'Mutation', updateEventSeries?: { __typename?: 'UpdateEventSeriesPayload', eventSeries?: { __typename?: 'EventSeries', id: string, organizers?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, executors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, sponsors?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null } | null };

export type UpdateEventMultiLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
  extraDocumentsId?: InputMaybe<Scalars['UUID']>;
  extraSystemsId?: InputMaybe<Scalars['UUID']>;
  externalDataId?: InputMaybe<Scalars['UUID']>;
  internalDataId?: InputMaybe<Scalars['UUID']>;
  subeventsLocalId?: InputMaybe<Scalars['UUID']>;
  subeventsOtherLocationsId?: InputMaybe<Scalars['UUID']>;
  fairAbroadId?: InputMaybe<Scalars['UUID']>;
  fairAbroadCooperationId?: InputMaybe<Scalars['UUID']>;
  competitionNationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionNationalId?: InputMaybe<Scalars['UUID']>;
  competitionInternationalId?: InputMaybe<Scalars['UUID']>;
  otherCompetitionInternationalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsInternalId?: InputMaybe<Scalars['UUID']>;
  favoredParallelsExternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksInternalId?: InputMaybe<Scalars['UUID']>;
  otherLinksExternalId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateEventMultiLinkMutation = { __typename?: 'Mutation', updateEvent?: { __typename?: 'UpdateEventPayload', event?: { __typename?: 'Event', id: string, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null } | null };

export type GetEventByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetEventByNameQuery = { __typename?: 'Query', existingObject?: { __typename?: 'Event', id: string } | null };

export type GetEventSeriesByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetEventSeriesByNameQuery = { __typename?: 'Query', existingObject?: { __typename?: 'EventSeries', id: string } | null };

export type DeleteSeriesMutationVariables = Exact<{
  seriesId: Scalars['UUID'];
}>;


export type DeleteSeriesMutation = { __typename?: 'Mutation', deleteEventSeries?: { __typename?: 'DeleteEventSeriesPayload', clientMutationId?: string | null } | null };

export type EventVariantDataFragment = { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null };

export type GetEventVariantsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEventVariantsQuery = { __typename?: 'Query', variants?: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null }> } | null };

export type CreateEventVariantMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateEventVariantMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateEventVariantPayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type UpdateEventVariantAllocationsMutationVariables = Exact<{
  id: Scalars['UUID'];
  deleteRooms?: InputMaybe<Array<AllocationRoomAllocationRoomPkeyDelete> | AllocationRoomAllocationRoomPkeyDelete>;
  createRooms?: InputMaybe<Array<AllocationRoomEventVariantIdFkeyAllocationRoomCreateInput> | AllocationRoomEventVariantIdFkeyAllocationRoomCreateInput>;
  deleteAreas?: InputMaybe<Array<AllocationAreaAllocationAreaPkeyDelete> | AllocationAreaAllocationAreaPkeyDelete>;
  createAreas?: InputMaybe<Array<AllocationAreaEventVariantIdFkeyAllocationAreaCreateInput> | AllocationAreaEventVariantIdFkeyAllocationAreaCreateInput>;
}>;


export type UpdateEventVariantAllocationsMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateEventVariantPayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type DeleteEventMutationVariables = Exact<{
  eventId: Scalars['UUID'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: { __typename?: 'DeleteEventPayload', event?: { __typename?: 'Event', id: string, nameShort: string } | null } | null };

export type ArchiveVariantMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  archive: Scalars['Boolean'];
}>;


export type ArchiveVariantMutation = { __typename?: 'Mutation', updateEventVariant?: { __typename?: 'UpdateEventVariantPayload', eventVariant?: { __typename?: 'EventVariant', id: string, isCurrent: boolean, isArchived: boolean } | null } | null };

export type EventBaseDataFragment = { __typename?: 'Event', id: string, nameShort: string, nameLong: string, subtitle: string, executionYear: number, description: string, annualSpecifics: string, companyGroup: string, businessDomain: string, department: string, responsible: string, assistant: string, teamChanges: string, status: string, iconUploadStatus?: UploadStatus | null, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null, series?: { __typename?: 'EventSeries', id: string, nameShort: string, nameLong: string, singleEvent: boolean, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null, mainVariant: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, start?: string | null, end?: string | null, version: number }> }, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type GetEventQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, nameShort: string, nameLong: string, subtitle: string, executionYear: number, description: string, annualSpecifics: string, companyGroup: string, businessDomain: string, department: string, responsible: string, assistant: string, teamChanges: string, status: string, iconUploadStatus?: UploadStatus | null, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null, series?: { __typename?: 'EventSeries', id: string, nameShort: string, nameLong: string, singleEvent: boolean, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null, mainVariant: { __typename?: 'EventVariantsConnection', nodes: Array<{ __typename?: 'EventVariant', id: string, start?: string | null, end?: string | null, version: number }> }, extraDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, extraSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, externalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, internalData?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsLocal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, subeventsOtherLocations?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroad?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, fairAbroadCooperation?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionNational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, competitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherCompetitionInternational?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, favoredParallelsExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksInternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinksExternal?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null };

export type GetEventLogoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEventLogoQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, iconUploadStatus?: UploadStatus | null, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null };

export type UpdateEventStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
}>;


export type UpdateEventStatusMutation = { __typename?: 'Mutation', updateEvent?: { __typename?: 'UpdateEventPayload', event?: { __typename?: 'Event', id: string, status: string } | null } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  annualSpecifics?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  responsible?: InputMaybe<Scalars['String']>;
  assistant?: InputMaybe<Scalars['String']>;
  teamChanges?: InputMaybe<Scalars['String']>;
  seriesId?: InputMaybe<Scalars['UUID']>;
  iconUpload?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent?: { __typename?: 'UpdateEventPayload', event?: { __typename?: 'Event', id: string, nameShort: string, nameLong: string, subtitle: string, executionYear: number, description: string, annualSpecifics: string, companyGroup: string, businessDomain: string, department: string, responsible: string, assistant: string, teamChanges: string, iconUploadStatus?: UploadStatus | null, series?: { __typename?: 'EventSeries', id: string, nameShort: string, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null, icon?: { __typename?: 'File', id: string, url: string, url128: string, url512: string } | null } | null } | null };

export type CreateEventVariantWithAllocationsFromMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateEventVariantWithAllocationsFromMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateEventVariantWithAllocationsFromPayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CopyEventVariantAllocationsMutationVariables = Exact<{
  sourceId: Scalars['UUID'];
  targetId: Scalars['UUID'];
}>;


export type CopyEventVariantAllocationsMutation = { __typename?: 'Mutation', copyEventVariantAllocations?: { __typename?: 'CopyEventVariantAllocationsPayload', eventVariant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null, event: { __typename?: 'Event', id: string, nameShort: string }, rooms: { __typename?: 'AllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'AllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CreateEventAllocationRoomMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  phases?: InputMaybe<Array<AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput> | AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput>;
}>;


export type CreateEventAllocationRoomMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateAllocationRoomPayload', allocation?: { __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type CreateEventAllocationAreaMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  phases?: InputMaybe<Array<AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput> | AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput>;
}>;


export type CreateEventAllocationAreaMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateAllocationAreaPayload', allocation?: { __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type CreateEventAllocationPlotMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  phases?: InputMaybe<Array<AllocationPlotPhaseAllocationIdFkeyAllocationPlotPhaseCreateInput> | AllocationPlotPhaseAllocationIdFkeyAllocationPlotPhaseCreateInput>;
}>;


export type CreateEventAllocationPlotMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateAllocationPlotPayload', allocation?: { __typename?: 'AllocationPlot', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string }, phases: { __typename?: 'AllocationPlotPhasesConnection', nodes: Array<{ __typename?: 'AllocationPlotPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type EventAllocationRoomUpdateMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  createPhases?: InputMaybe<Array<AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput> | AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput>;
  updatePhases?: InputMaybe<Array<AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPhasePkeyUpdate> | AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPhasePkeyUpdate>;
  deletePhases?: InputMaybe<Array<AllocationRoomPhaseAllocationRoomPhasePkeyDelete> | AllocationRoomPhaseAllocationRoomPhasePkeyDelete>;
}>;


export type EventAllocationRoomUpdateMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateAllocationRoomPayload', allocation?: { __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type EventAllocationAreaUpdateMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  createPhases?: InputMaybe<Array<AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput> | AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput>;
  updatePhases?: InputMaybe<Array<AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPhasePkeyUpdate> | AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPhasePkeyUpdate>;
  deletePhases?: InputMaybe<Array<AllocationAreaPhaseAllocationAreaPhasePkeyDelete> | AllocationAreaPhaseAllocationAreaPhasePkeyDelete>;
}>;


export type EventAllocationAreaUpdateMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateAllocationAreaPayload', allocation?: { __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type UpdateEventVariantReferenceAllocationIdMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateEventVariantReferenceAllocationIdMutation = { __typename?: 'Mutation', updateVariant?: { __typename?: 'UpdateEventVariantPayload', variant?: { __typename?: 'EventVariant', id: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null } | null } | null };

export type UpdateEventVariantMutationVariables = Exact<{
  id: Scalars['UUID'];
  feedId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  createFeedEntry?: InputMaybe<Array<FeedEntryFeedIdFkeyFeedEntryCreateInput> | FeedEntryFeedIdFkeyFeedEntryCreateInput>;
}>;


export type UpdateEventVariantMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateEventVariantPayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string } | null } | null };

export type GetEventVariantCommentsQueryVariables = Exact<{
  variantId: Scalars['UUID'];
}>;


export type GetEventVariantCommentsQuery = { __typename?: 'Query', variant?: { __typename?: 'EventVariant', comments: { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } } | null };

export type LocationDotsBuildingFragment = { __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, elevation?: { __typename?: 'ElevationLevel', id: string, value: any, nameShort: string } | null, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', roomCadGrossSpaceMins: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', value: any, start?: string | null, end?: string | null, id: string }> }, allocationRooms: { __typename?: 'AllocationRoomsConnection', totalCount: number }, optionalAllocationRooms: { __typename?: 'AllocationRoomsConnection', totalCount: number } }> } }> } };

export type GetBuildingsForLocationDotsQueryVariables = Exact<{
  roomType: Scalars['String'];
  levelType: Scalars['String'];
  eventVariantId: Scalars['UUID'];
}>;


export type GetBuildingsForLocationDotsQuery = { __typename?: 'Query', buildings?: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, elevation?: { __typename?: 'ElevationLevel', id: string, value: any, nameShort: string } | null, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', roomCadGrossSpaceMins: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', value: any, start?: string | null, end?: string | null, id: string }> }, allocationRooms: { __typename?: 'AllocationRoomsConnection', totalCount: number }, optionalAllocationRooms: { __typename?: 'AllocationRoomsConnection', totalCount: number } }> } }> } }> } | null };

export type EventVariantsWithAllocationsCountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EventVariantsWithAllocationsCountQuery = { __typename?: 'Query', object?: { __typename?: 'Event', id: string, variantsWithAllocationsCount: { __typename?: 'EventVariantsConnection', totalCount: number } } | null };

export type GetEventAllocationsForEventQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEventAllocationsForEventQuery = { __typename?: 'Query', allocationRooms?: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'AllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null, allocationAreas?: { __typename?: 'AllocationAreasConnection', nodes: Array<{ __typename?: 'AllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'EventVariant', id: string, index: number, name: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null }, phases: { __typename?: 'AllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'AllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'AllocationUsage', id: string, name: string, nameShort: string, type: AllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null };

export type ExternalEventDataFragment = { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, description: string, contact: string, status: ExternalEventEventStatus, locationId?: string | null, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, national: boolean }, links: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } };

export type ExternalEventWithAllocationExistsDataFragment = { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, description: string, contact: string, status: ExternalEventEventStatus, locationId?: string | null, variantsWithAllocations: { __typename?: 'ExternalEventVariantsConnection', totalCount: number }, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, national: boolean }, links: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } };

export type ExternalEventSeriesDataFragment = { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, notes: string, description: string, explanation: string, category: ExternalEventSeriesCategory, status: ExternalEventSeriesStatus, national: boolean, silent: boolean, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, to: string, description: string }> } }, events: { __typename?: 'ExternalEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEvent', id: string, locationId?: string | null, nameShort: string, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, externalEventAllocationsByVariantId: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number } }> } }> } };

export type ExternalEventMainVariantWithAllocationsFragment = { __typename?: 'ExternalEventVariant', id: string, eventId: string, index: number, status: ExternalEventVariantStatus, changesId: string, referenceAllocationId?: string | null, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, isOptional: boolean }> } };

export type ExternalEventWithMainVariantDataFragment = { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, description: string, year: number, status: ExternalEventEventStatus, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', totalCount: number }, mainVariant: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, eventId: string, index: number, status: ExternalEventVariantStatus, changesId: string, referenceAllocationId?: string | null, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, isOptional: boolean }> } }> } };

export type ExternalEventSeriesWithEventsDataFragment = { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, status: ExternalEventSeriesStatus, national: boolean, events: { __typename?: 'ExternalEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, description: string, year: number, status: ExternalEventEventStatus, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', totalCount: number }, mainVariant: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, eventId: string, index: number, status: ExternalEventVariantStatus, changesId: string, referenceAllocationId?: string | null, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, isOptional: boolean }> } }> } }> } };

export type ExternalEventMainVariantFragment = { __typename?: 'ExternalEventVariant', id: string, index: number, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null };

export type ExternalEventPhaseTypeFragment = { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean };

export type ExternalEventVariantDataFragment = { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceAllocationId?: string | null };

export type GetExternalEventSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalEventSeriesQuery = { __typename?: 'Query', externalEventSerieses?: { __typename?: 'ExternalEventSeriesConnection', nodes: Array<{ __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, notes: string, description: string, explanation: string, category: ExternalEventSeriesCategory, status: ExternalEventSeriesStatus, national: boolean, silent: boolean, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, to: string, description: string }> } }, events: { __typename?: 'ExternalEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEvent', id: string, locationId?: string | null, nameShort: string, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, externalEventAllocationsByVariantId: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number } }> } }> } }> } | null };

export type CreateExternalEventSeriesMutationVariables = Exact<{
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  category: ExternalEventSeriesCategory;
  national: Scalars['Boolean'];
}>;


export type CreateExternalEventSeriesMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateExternalEventSeriesPayload', externalEventSeries?: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string } | null } | null };

export type GetExternalEventSeriesByNameShortQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetExternalEventSeriesByNameShortQuery = { __typename?: 'Query', existingObject?: { __typename?: 'ExternalEventSeries', id: string, nameShort: string } | null };

export type GetExternalEventSeriesDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExternalEventSeriesDataQuery = { __typename?: 'Query', externalEventSeries?: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, notes: string, description: string, explanation: string, category: ExternalEventSeriesCategory, status: ExternalEventSeriesStatus, national: boolean, silent: boolean, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, to: string, description: string }> } }, events: { __typename?: 'ExternalEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEvent', id: string, locationId?: string | null, nameShort: string, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, externalEventAllocationsByVariantId: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number } }> } }> } } | null };

export type GetExternalEventSeriesWithEventsDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExternalEventSeriesWithEventsDataQuery = { __typename?: 'Query', externalEventSeries?: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, status: ExternalEventSeriesStatus, national: boolean, events: { __typename?: 'ExternalEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, description: string, year: number, status: ExternalEventEventStatus, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', totalCount: number }, mainVariant: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, eventId: string, index: number, status: ExternalEventVariantStatus, changesId: string, referenceAllocationId?: string | null, allocations: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, isOptional: boolean }> } }> } }> } } | null };

export type DeleteExternalEventSeriesMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteExternalEventSeriesMutation = { __typename?: 'Mutation', deleteExternalEventSeries?: { __typename?: 'DeleteExternalEventSeriesPayload', clientMutationId?: string | null } | null };

export type UpdateExternalEventSeriesStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: ExternalEventSeriesStatus;
}>;


export type UpdateExternalEventSeriesStatusMutation = { __typename?: 'Mutation', updateExternalEventSeries?: { __typename?: 'UpdateExternalEventSeriesPayload', externalEventSeries?: { __typename?: 'ExternalEventSeries', id: string, status: ExternalEventSeriesStatus } | null } | null };

export type GetExternalEventSeriesEventsQueryVariables = Exact<{
  seriesId: Scalars['UUID'];
}>;


export type GetExternalEventSeriesEventsQuery = { __typename?: 'Query', externalEvents?: { __typename?: 'ExternalEventsConnection', nodes: Array<{ __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, description: string, contact: string, status: ExternalEventEventStatus, locationId?: string | null, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, national: boolean }, links: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } }> } | null };

export type GetExternalEventAllocationUsagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalEventAllocationUsagesQuery = { __typename?: 'Query', externalEventAllocationUsages?: { __typename?: 'ExternalEventAllocationUsagesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }> } | null };

export type GetExternalEventEventByNameShortQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetExternalEventEventByNameShortQuery = { __typename?: 'Query', existingObject?: { __typename?: 'ExternalEvent', id: string, nameShort: string } | null };

export type CreateExternalEventEventMutationVariables = Exact<{
  seriesId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateExternalEventEventMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateExternalEventPayload', externalEvent?: { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, locationId?: string | null, series: { __typename?: 'ExternalEventSeries', id: string, national: boolean } } | null } | null };

export type GetExternalEventEventDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExternalEventEventDataQuery = { __typename?: 'Query', externalEvent?: { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, description: string, contact: string, status: ExternalEventEventStatus, locationId?: string | null, variantsWithAllocations: { __typename?: 'ExternalEventVariantsConnection', totalCount: number }, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, national: boolean }, links: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } } | null };

export type DeleteExternalEventEventMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteExternalEventEventMutation = { __typename?: 'Mutation', deleteExternalEvent?: { __typename?: 'DeleteExternalEventPayload', clientMutationId?: string | null } | null };

export type UpdateExternalEventEventStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: ExternalEventEventStatus;
}>;


export type UpdateExternalEventEventStatusMutation = { __typename?: 'Mutation', updateExternalEvent?: { __typename?: 'UpdateExternalEventPayload', externalEvent?: { __typename?: 'ExternalEvent', id: string, status: ExternalEventEventStatus } | null } | null };

export type UpdateExternalEventEventMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
}>;


export type UpdateExternalEventEventMutation = { __typename?: 'Mutation', updateExternalEvent?: { __typename?: 'UpdateExternalEventPayload', externalEvent?: { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, description: string, contact: string, status: ExternalEventEventStatus, locationId?: string | null, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, category: ExternalEventSeriesCategory, national: boolean }, links: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } } | null } | null };

export type GetExternalEventVariantsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExternalEventVariantsQuery = { __typename?: 'Query', externalEvent?: { __typename?: 'ExternalEvent', id: string, series: { __typename?: 'ExternalEventSeries', id: string, national: boolean, category: ExternalEventSeriesCategory } } | null, variants?: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceAllocationId?: string | null }> } | null };

export type UpdateExternalEventVariantMutationVariables = Exact<{
  id: Scalars['UUID'];
  feedId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalEventVariantStatus>;
  createFeedEntry?: InputMaybe<Array<FeedEntryFeedIdFkeyFeedEntryCreateInput> | FeedEntryFeedIdFkeyFeedEntryCreateInput>;
}>;


export type UpdateExternalEventVariantMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateExternalEventVariantPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string } | null } | null };

export type UpdateExternalEventSeriesResultFragment = { __typename?: 'ExternalEventSeries', id: string, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, to: string, description: string }> } } };

export type UpdateExternalEventSeriesMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameLong?: InputMaybe<Scalars['String']>;
  nameShort?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ExternalEventSeriesCategory>;
  description?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  national?: InputMaybe<Scalars['Boolean']>;
  silent?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ExternalEventSeriesStatus>;
  explanation?: InputMaybe<Scalars['String']>;
}>;


export type UpdateExternalEventSeriesMutation = { __typename?: 'Mutation', updateExternalEventSeries?: { __typename?: 'UpdateExternalEventSeriesPayload', externalEventSeries?: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, nameLong: string, notes: string, description: string, explanation: string, category: ExternalEventSeriesCategory, status: ExternalEventSeriesStatus, national: boolean, silent: boolean, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, to: string, description: string }> } }, events: { __typename?: 'ExternalEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEvent', id: string, locationId?: string | null, nameShort: string, externalEventVariantsByEventId: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, externalEventAllocationsByVariantId: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number } }> } }> } } | null } | null };

export type TimelineExternalEventLocationFragment = { __typename?: 'ExternalEventLocation', id: string, index: number, name: string, isNationalDefault: boolean, visibility: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, eventId: string, locationId: string, visibility: ExternalEventLocationVisibility }> } };

export type TimelineExternalEventVariantFragment = { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } };

export type TimelineExternalEventFragment = { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, national: boolean, category: ExternalEventSeriesCategory }, location?: { __typename?: 'ExternalEventLocation', id: string, index: number, name: string, isNationalDefault: boolean, visibility: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, eventId: string, locationId: string, visibility: ExternalEventLocationVisibility }> } } | null, variants: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } }> } };

export type GetExternalEventDataForTimelineQueryVariables = Exact<{
  id: Scalars['UUID'];
  activeStates: Array<ExternalEventVariantStatus> | ExternalEventVariantStatus;
}>;


export type GetExternalEventDataForTimelineQuery = { __typename?: 'Query', locationsNational?: { __typename?: 'ExternalEventLocationsConnection', nodes: Array<{ __typename?: 'ExternalEventLocation', id: string, index: number, name: string, isNationalDefault: boolean, visibility: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, eventId: string, locationId: string, visibility: ExternalEventLocationVisibility }> } }> } | null, externalEvent?: { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, year: number, series: { __typename?: 'ExternalEventSeries', id: string, nameShort: string, national: boolean, category: ExternalEventSeriesCategory }, location?: { __typename?: 'ExternalEventLocation', id: string, index: number, name: string, isNationalDefault: boolean, visibility: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, eventId: string, locationId: string, visibility: ExternalEventLocationVisibility }> } } | null, variants: { __typename?: 'ExternalEventVariantsConnection', nodes: Array<{ __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } }> } } | null, externalEventAllocations?: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string }> } | null, usages?: { __typename?: 'ExternalEventAllocationUsagesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }> } | null, firstAllocation?: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, start: string }> } | null };

export type GetExternalEventAllocationsForEventQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetExternalEventAllocationsForEventQuery = { __typename?: 'Query', externalEventAllocations?: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null };

export type TimelineExternalEventPhaseFragment = { __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } };

export type TimelineExternalEventAllocationFragment = { __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } };

export type CreateExternalEventAllocationMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  phases?: InputMaybe<Array<ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput> | ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput>;
}>;


export type CreateExternalEventAllocationMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateExternalEventAllocationPayload', allocation?: { __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type ExternalEventAllocationUpdateMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  createPhases?: InputMaybe<Array<ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput> | ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput>;
  updatePhases?: InputMaybe<Array<ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPhasePkeyUpdate> | ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPhasePkeyUpdate>;
  deletePhases?: InputMaybe<Array<ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyDelete> | ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyDelete>;
}>;


export type ExternalEventAllocationUpdateMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateExternalEventAllocationPayload', allocation?: { __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type ExternalEventAllocationDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  locationIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type ExternalEventAllocationDuplicateMutation = { __typename?: 'Mutation', duplicate?: { __typename?: 'ExternalEventAllocationDuplicatePayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type ExternalEventAllocationUpdateAndDuplicateMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  allocationId: Scalars['UUID'];
  updateAllocation: AllocationUpdateInput;
  createPhases?: InputMaybe<Array<InputMaybe<AllocationPhaseCreateInput>> | InputMaybe<AllocationPhaseCreateInput>>;
  updatePhases?: InputMaybe<Array<InputMaybe<AllocationPhaseUpdateInput>> | InputMaybe<AllocationPhaseUpdateInput>>;
  deletePhases?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  locationIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type ExternalEventAllocationUpdateAndDuplicateMutation = { __typename?: 'Mutation', updateAndDuplicate?: { __typename?: 'ExternalEventAllocationUpdateAndDuplicatePayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type GetExternalEventVariantForTimelineQueryVariables = Exact<{
  variantId: Scalars['UUID'];
}>;


export type GetExternalEventVariantForTimelineQuery = { __typename?: 'Query', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null };

export type DeleteExternalEventAllocationMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
}>;


export type DeleteExternalEventAllocationMutation = { __typename?: 'Mutation', delete?: { __typename?: 'DeleteExternalEventAllocationPayload', allocation?: { __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, variantId: string } | null } | null };

export type ExternalEventVariantsWithAllocationsCountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ExternalEventVariantsWithAllocationsCountQuery = { __typename?: 'Query', object?: { __typename?: 'ExternalEvent', id: string, variantsWithAllocationsCount: { __typename?: 'ExternalEventVariantsConnection', totalCount: number } } | null };

export type DeleteExternalEventLocationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteExternalEventLocationMutation = { __typename?: 'Mutation', deleteExternalEventLocation?: { __typename?: 'DeleteExternalEventLocationPayload', clientMutationId?: string | null } | null };

export type UpdateExternalEventReferenceAllocationIdMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  referenceAllocationId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateExternalEventReferenceAllocationIdMutation = { __typename?: 'Mutation', updateVariant?: { __typename?: 'UpdateExternalEventVariantPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, referenceExternalEventAllocationId?: string | null } | null } | null };

export type AllocationForDaysRowsFragment = { __typename?: 'ExternalEventAllocation', id: string, isOptional: boolean, locationId: string, start: string, end: string, location: { __typename?: 'ExternalEventLocation', id: string, name: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> }, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, isCurrent: boolean, status: ExternalEventVariantStatus, referenceExternalEventAllocationId?: string | null, changesId: string, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, series: { __typename?: 'ExternalEventSeries', id: string, national: boolean, category: ExternalEventSeriesCategory }, visibilities: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, visibility: ExternalEventLocationVisibility, locationId: string }> } } } };

export type GetExternalEventAllocationsForDaysRowsQueryVariables = Exact<{
  startDateTime?: InputMaybe<Scalars['Datetime']>;
  endDateTime?: InputMaybe<Scalars['Datetime']>;
}>;


export type GetExternalEventAllocationsForDaysRowsQuery = { __typename?: 'Query', allocations?: { __typename?: 'ExternalEventAllocationsConnection', nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, isOptional: boolean, locationId: string, start: string, end: string, location: { __typename?: 'ExternalEventLocation', id: string, name: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> }, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, isCurrent: boolean, status: ExternalEventVariantStatus, referenceExternalEventAllocationId?: string | null, changesId: string, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, nameLong: string, series: { __typename?: 'ExternalEventSeries', id: string, national: boolean, category: ExternalEventSeriesCategory }, visibilities: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', id: string, visibility: ExternalEventLocationVisibility, locationId: string }> } } } }> } | null, nationalLocations?: { __typename?: 'ExternalEventLocationsConnection', nodes: Array<{ __typename?: 'ExternalEventLocation', id: string, name: string }> } | null };

export type CreateExternalEventEventLocationVisibilityMutationVariables = Exact<{
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  visibility: ExternalEventLocationVisibility;
}>;


export type CreateExternalEventEventLocationVisibilityMutation = { __typename?: 'Mutation', createExternalEventEventLocationVisibility?: { __typename?: 'CreateExternalEventEventLocationVisibilityPayload', externalEventEventLocationVisibility?: { __typename?: 'ExternalEventEventLocationVisibility', id: string, eventId: string, locationId: string, visibility: ExternalEventLocationVisibility } | null } | null };

export type UpdateExternalEventEventLocationVisibilityMutationVariables = Exact<{
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  visibility: ExternalEventLocationVisibility;
}>;


export type UpdateExternalEventEventLocationVisibilityMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateExternalEventEventLocationVisibilityPayload', externalEventEventLocationVisibility?: { __typename?: 'ExternalEventEventLocationVisibility', id: string, eventId: string, locationId: string, visibility: ExternalEventLocationVisibility } | null } | null };

export type ExternalEventLocationBaseDataFragment = { __typename?: 'ExternalEventLocation', id: string, index: number, name: string };

export type ExternalEventLocationWithAllocationsFragment = { __typename?: 'ExternalEventLocation', id: string, index: number, name: string, optionalAllocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number }, visibilities: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', visibility: ExternalEventLocationVisibility }> } };

export type GetExternalEventDefaultLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalEventDefaultLocationsQuery = { __typename?: 'Query', externalEventLocations?: { __typename?: 'ExternalEventLocationsConnection', nodes: Array<{ __typename?: 'ExternalEventLocation', id: string, index: number, name: string, isNationalDefault: boolean }> } | null };

export type GetExternalEventLocationDotsDataNationalQueryVariables = Exact<{
  eventId: Scalars['UUID'];
  variantId: Scalars['UUID'];
}>;


export type GetExternalEventLocationDotsDataNationalQuery = { __typename?: 'Query', externalEventLocations?: { __typename?: 'ExternalEventLocationsConnection', nodes: Array<{ __typename?: 'ExternalEventLocation', id: string, index: number, name: string, optionalAllocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number }, visibilities: { __typename?: 'ExternalEventEventLocationVisibilitiesConnection', nodes: Array<{ __typename?: 'ExternalEventEventLocationVisibility', visibility: ExternalEventLocationVisibility }> } }> } | null };

export type CreateExternalEventVariantMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateExternalEventVariantMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateExternalEventVariantPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CreateExternalEventVariantWithAllocationsFromMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateExternalEventVariantWithAllocationsFromMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateExternalEventVariantWithAllocationsFromPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CopyExternalEventVariantAllocationsMutationVariables = Exact<{
  sourceId: Scalars['UUID'];
  targetId: Scalars['UUID'];
}>;


export type CopyExternalEventVariantAllocationsMutation = { __typename?: 'Mutation', copyExternalEventVariantAllocations?: { __typename?: 'CopyExternalEventVariantAllocationsPayload', externalEventVariant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type UpdateExternalEventVariantAllocationsMutationVariables = Exact<{
  id: Scalars['UUID'];
  deleteAllocations?: InputMaybe<Array<ExternalEventAllocationExternalEventAllocationPkeyDelete> | ExternalEventAllocationExternalEventAllocationPkeyDelete>;
  createAllocations?: InputMaybe<Array<ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventAllocationCreateInput> | ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventAllocationCreateInput>;
}>;


export type UpdateExternalEventVariantAllocationsMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateExternalEventVariantPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string, referenceExternalEventAllocationId?: string | null, event: { __typename?: 'ExternalEvent', id: string, nameShort: string, series: { __typename?: 'ExternalEventSeries', category: ExternalEventSeriesCategory } }, allocations: { __typename?: 'ExternalEventAllocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'ExternalEventAllocation', id: string, locationId: string, start: string, end: string, isOptional: boolean, variant: { __typename?: 'ExternalEventVariant', id: string, index: number, name: string, referenceExternalEventAllocationId?: string | null, changesId: string }, phases: { __typename?: 'ExternalEventAllocationPhasesConnection', nodes: Array<{ __typename?: 'ExternalEventAllocationPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ExternalEventAllocationUsage', id: string, name: string, nameShort: string, type: ExternalEventAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type DeleteExternalEventLocationVisibilityMutationVariables = Exact<{
  eventId: Scalars['UUID'];
  locationId: Scalars['UUID'];
}>;


export type DeleteExternalEventLocationVisibilityMutation = { __typename?: 'Mutation', deleteExternalEventEventLocationVisibilityByEventIdAndLocationId?: { __typename?: 'DeleteExternalEventEventLocationVisibilityPayload', clientMutationId?: string | null } | null };

export type CreateExternalEventLocationMutationVariables = Exact<{
  eventId: Scalars['UUID'];
  locationName?: InputMaybe<Scalars['String']>;
}>;


export type CreateExternalEventLocationMutation = { __typename?: 'Mutation', updateExternalEvent?: { __typename?: 'UpdateExternalEventPayload', externalEvent?: { __typename?: 'ExternalEvent', id: string, locationId?: string | null } | null } | null };

export type UpdateExternalEventLocationMutationVariables = Exact<{
  locationId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateExternalEventLocationMutation = { __typename?: 'Mutation', updateExternalEventLocation?: { __typename?: 'UpdateExternalEventLocationPayload', externalEventLocation?: { __typename?: 'ExternalEventLocation', id: string, name: string } | null } | null };

export type UpdateExternalEventSeriesMultiLinksMutationVariables = Exact<{
  id: Scalars['UUID'];
  websitesId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateExternalEventSeriesMultiLinksMutation = { __typename?: 'Mutation', updateExternalEventSeries?: { __typename?: 'UpdateExternalEventSeriesPayload', externalEventSeries?: { __typename?: 'ExternalEventSeries', id: string, websites: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } } | null } | null };

export type UpdateExternalEventMultiLinksMutationVariables = Exact<{
  id: Scalars['UUID'];
  linksId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateExternalEventMultiLinksMutation = { __typename?: 'Mutation', updateExternalEvent?: { __typename?: 'UpdateExternalEventPayload', externalEvent?: { __typename?: 'ExternalEvent', id: string, links: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } } | null } | null };

export type FeedEntryDataFragment = { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null };

export type FeedDataFragment = { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } };

export type CreateFeedMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateFeedMutation = { __typename?: 'Mutation', createFeed?: { __typename?: 'CreateFeedPayload', feed?: { __typename?: 'Feed', id: string } | null } | null };

export type CreateFeedEntryMutationVariables = Exact<{
  feedId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  type: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  markdownText?: InputMaybe<Scalars['String']>;
  createdByName?: InputMaybe<Scalars['String']>;
  objectCreatedAt?: InputMaybe<Scalars['Datetime']>;
}>;


export type CreateFeedEntryMutation = { __typename?: 'Mutation', createFeedEntry?: { __typename?: 'CreateFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type CreateUserTextEntryMutationVariables = Exact<{
  feedId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  type: Scalars['String'];
  text: Scalars['String'];
}>;


export type CreateUserTextEntryMutation = { __typename?: 'Mutation', createFeedEntry?: { __typename?: 'CreateFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type UpdateUserTextEntryMutationVariables = Exact<{
  id: Scalars['UUID'];
  updatedById: Scalars['UUID'];
  updatedByName: Scalars['String'];
  text: Scalars['String'];
}>;


export type UpdateUserTextEntryMutation = { __typename?: 'Mutation', updateFeedEntry?: { __typename?: 'UpdateFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type CreateCreatedAtEntryMutationVariables = Exact<{
  feedId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  type: Scalars['String'];
  objectCreatedAt: Scalars['Datetime'];
}>;


export type CreateCreatedAtEntryMutation = { __typename?: 'Mutation', createFeedEntry?: { __typename?: 'CreateFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type CreateStatusChangeEntryMutationVariables = Exact<{
  feedId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  type: Scalars['String'];
  oldStatus: Scalars['String'];
  newStatus: Scalars['String'];
}>;


export type CreateStatusChangeEntryMutation = { __typename?: 'Mutation', createFeedEntry?: { __typename?: 'CreateFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type CreateNewMainVariantEntryMutationVariables = Exact<{
  feedId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  type: Scalars['String'];
  oldMainVariantId: Scalars['UUID'];
  oldMainVariantIndex: Scalars['Int'];
  newMainVariantId: Scalars['UUID'];
  newMainVariantIndex: Scalars['Int'];
}>;


export type CreateNewMainVariantEntryMutation = { __typename?: 'Mutation', createFeedEntry?: { __typename?: 'CreateFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type GetFeedQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFeedQuery = { __typename?: 'Query', feed?: { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } | null };

export type DeleteFeedEntryMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteFeedEntryMutation = { __typename?: 'Mutation', deleteFeedEntry?: { __typename?: 'DeleteFeedEntryPayload', feedEntry?: { __typename?: 'FeedEntry', id: string } | null } | null };

export type GetCreateLevelParamsQueryVariables = Exact<{
  buildingId: Scalars['UUID'];
}>;


export type GetCreateLevelParamsQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } | null, levelTypes?: { __typename?: 'LevelTypesConnection', nodes: Array<{ __typename?: 'LevelType', id: string, name: string }> } | null };

export type CreateLevelMutationVariables = Exact<{
  buildingId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
  elevationId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateLevelMutation = { __typename?: 'Mutation', createLevel?: { __typename?: 'CreateLevelPayload', level?: { __typename?: 'Level', id: string, nameShort: string } | null } | null };

export type GetLevelChildrenForTreeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetLevelChildrenForTreeQuery = { __typename?: 'Query', level?: { __typename?: 'Level', id: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, nameLong: string, type?: { __typename?: 'RoomType', id: string, name: string } | null, roomPartitions: { __typename?: 'RoomPartitionsConnection', nodes: Array<{ __typename?: 'RoomPartition', id: string }> } }> } } | null };

export type GetLevelForDetailsPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetLevelForDetailsPageQuery = { __typename?: 'Query', level?: { __typename?: 'Level', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, elevationId?: string | null, description: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } }, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, allocationRooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string }> } }> }, type?: { __typename?: 'LevelType', name: string } | null, elevation?: { __typename?: 'ElevationLevel', nameShort: string, nameLong: string } | null, nameExtra: { __typename?: 'LevelNameExtrasConnection', nodes: Array<{ __typename?: 'LevelNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'LevelNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'LevelNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'LevelNameKeyCadsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'LevelNameKeyEbmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'LevelNameKeyCafmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, fkmGrossSpace: { __typename?: 'LevelFkmGrossSpacesConnection', nodes: Array<{ __typename?: 'LevelFkmGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'LevelCapacityPaxesConnection', nodes: Array<{ __typename?: 'LevelCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } } | null, levelTypes?: { __typename?: 'LevelTypesConnection', nodes: Array<{ __typename?: 'LevelType', id: string, name: string }> } | null, elevationLevels?: { __typename?: 'ElevationLevelsConnection', nodes: Array<{ __typename?: 'ElevationLevel', id: string, name: string }> } | null };

export type GetLevelForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetLevelForEditQuery = { __typename?: 'Query', level?: { __typename?: 'Level', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, elevationId?: string | null, description: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } }, type?: { __typename?: 'LevelType', name: string } | null, elevation?: { __typename?: 'ElevationLevel', nameShort: string, nameLong: string } | null, nameExtra: { __typename?: 'LevelNameExtrasConnection', nodes: Array<{ __typename?: 'LevelNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'LevelNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'LevelNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'LevelNameKeyCadsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'LevelNameKeyEbmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'LevelNameKeyCafmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, fkmGrossSpace: { __typename?: 'LevelFkmGrossSpacesConnection', nodes: Array<{ __typename?: 'LevelFkmGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'LevelCapacityPaxesConnection', nodes: Array<{ __typename?: 'LevelCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } } | null, levelTypes?: { __typename?: 'LevelTypesConnection', nodes: Array<{ __typename?: 'LevelType', id: string, name: string }> } | null };

export type UpdateLevelMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateLevelMutation = { __typename?: 'Mutation', updateLevel?: { __typename?: 'UpdateLevelPayload', level?: { __typename?: 'Level', id: string, nameLong: string, nameShort: string, description: string } | null } | null };

export type DeleteLevelMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteLevelMutation = { __typename?: 'Mutation', deleteLevel?: { __typename?: 'DeleteLevelPayload', level?: { __typename?: 'Level', id: string, nameShort: string, buildingId: string } | null } | null };

export type SiteTimeVariantsFragment = { __typename?: 'Site', nameExtra: { __typename?: 'SiteNameExtrasConnection', nodes: Array<{ __typename?: 'SiteNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'SiteNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'SiteNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'SiteNameKeyCadsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'SiteNameKeyEbmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'SiteNameKeyCafmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } };

export type SiteAttributesFragment = { __typename?: 'Site', id: string, extId: string, nameShort: string, nameLong: string, description: string, nameExtra: { __typename?: 'SiteNameExtrasConnection', nodes: Array<{ __typename?: 'SiteNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'SiteNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'SiteNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'SiteNameKeyCadsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'SiteNameKeyEbmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'SiteNameKeyCafmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } };

export type SiteExportAttributesFragment = { __typename?: 'Site', extId: string, nameShort: string, nameLong: string, description: string, nameExtra: { __typename?: 'SiteNameExtrasConnection', nodes: Array<{ __typename?: 'SiteNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'SiteNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'SiteNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'SiteNameKeyCadsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'SiteNameKeyEbmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'SiteNameKeyCafmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } };

export type BuildingTimeVariantsFragment = { __typename?: 'Building', nameExtra: { __typename?: 'BuildingNameExtrasConnection', nodes: Array<{ __typename?: 'BuildingNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'BuildingNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'BuildingNameKeyCadsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'BuildingNameKeyEbmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'BuildingNameKeyCafmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } };

export type BuildingExportAttributesFragment = { __typename?: 'Building', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'BuildingType', name: string } | null, nameExtra: { __typename?: 'BuildingNameExtrasConnection', nodes: Array<{ __typename?: 'BuildingNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'BuildingNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'BuildingNameKeyCadsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'BuildingNameKeyEbmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'BuildingNameKeyCafmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } };

export type BuildingAttributesFragment = { __typename?: 'Building', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, type?: { __typename?: 'BuildingType', name: string } | null, nameExtra: { __typename?: 'BuildingNameExtrasConnection', nodes: Array<{ __typename?: 'BuildingNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'BuildingNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'BuildingNameKeyCadsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'BuildingNameKeyEbmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'BuildingNameKeyCafmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } };

export type LevelTimeVariantsFragment = { __typename?: 'Level', nameExtra: { __typename?: 'LevelNameExtrasConnection', nodes: Array<{ __typename?: 'LevelNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'LevelNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'LevelNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'LevelNameKeyCadsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'LevelNameKeyEbmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'LevelNameKeyCafmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, fkmGrossSpace: { __typename?: 'LevelFkmGrossSpacesConnection', nodes: Array<{ __typename?: 'LevelFkmGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'LevelCapacityPaxesConnection', nodes: Array<{ __typename?: 'LevelCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } };

export type LevelExportAttributesFragment = { __typename?: 'Level', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'LevelType', name: string } | null, nameExtra: { __typename?: 'LevelNameExtrasConnection', nodes: Array<{ __typename?: 'LevelNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'LevelNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'LevelNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'LevelNameKeyCadsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'LevelNameKeyEbmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'LevelNameKeyCafmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, fkmGrossSpace: { __typename?: 'LevelFkmGrossSpacesConnection', nodes: Array<{ __typename?: 'LevelFkmGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'LevelCapacityPaxesConnection', nodes: Array<{ __typename?: 'LevelCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } };

export type LevelAttributesFragment = { __typename?: 'Level', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, elevationId?: string | null, description: string, type?: { __typename?: 'LevelType', name: string } | null, elevation?: { __typename?: 'ElevationLevel', nameShort: string, nameLong: string } | null, nameExtra: { __typename?: 'LevelNameExtrasConnection', nodes: Array<{ __typename?: 'LevelNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'LevelNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'LevelNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'LevelNameKeyCadsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'LevelNameKeyEbmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'LevelNameKeyCafmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, fkmGrossSpace: { __typename?: 'LevelFkmGrossSpacesConnection', nodes: Array<{ __typename?: 'LevelFkmGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'LevelCapacityPaxesConnection', nodes: Array<{ __typename?: 'LevelCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } };

export type RoomTimeVariantsFragment = { __typename?: 'Room', nameExtra: { __typename?: 'RoomNameExtrasConnection', nodes: Array<{ __typename?: 'RoomNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> }, capacityCars: { __typename?: 'RoomCapacityCarsConnection', nodes: Array<{ __typename?: 'RoomCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'RoomCapacityTrucksConnection', nodes: Array<{ __typename?: 'RoomCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'RoomMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, maxLoadCeiling: { __typename?: 'RoomMaxLoadCeilingsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadCeiling', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'RoomTireLoadCarsConnection', nodes: Array<{ __typename?: 'RoomTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'RoomTireLoadTrucksConnection', nodes: Array<{ __typename?: 'RoomTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'RoomTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'RoomTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'RoomNoVehiclesConnection', nodes: Array<{ __typename?: 'RoomNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, daylight: { __typename?: 'RoomDaylightsConnection', nodes: Array<{ __typename?: 'RoomDaylight', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, lightShutters: { __typename?: 'RoomLightShuttersConnection', nodes: Array<{ __typename?: 'RoomLightShutter', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, phoneNumbers: { __typename?: 'RoomPhoneNumbersConnection', nodes: Array<{ __typename?: 'RoomPhoneNumber', id: string, start?: string | null, end?: string | null, value: string }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'RoomClearanceConstructionsConnection', nodes: Array<{ __typename?: 'RoomClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'RoomKeyIssuancesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'RoomKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } };

export type RoomExportAttributesFragment = { __typename?: 'Room', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'RoomType', name: string } | null, nameExtra: { __typename?: 'RoomNameExtrasConnection', nodes: Array<{ __typename?: 'RoomNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> }, capacityCars: { __typename?: 'RoomCapacityCarsConnection', nodes: Array<{ __typename?: 'RoomCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'RoomCapacityTrucksConnection', nodes: Array<{ __typename?: 'RoomCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'RoomMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, maxLoadCeiling: { __typename?: 'RoomMaxLoadCeilingsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadCeiling', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'RoomTireLoadCarsConnection', nodes: Array<{ __typename?: 'RoomTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'RoomTireLoadTrucksConnection', nodes: Array<{ __typename?: 'RoomTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'RoomTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'RoomTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'RoomNoVehiclesConnection', nodes: Array<{ __typename?: 'RoomNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, daylight: { __typename?: 'RoomDaylightsConnection', nodes: Array<{ __typename?: 'RoomDaylight', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, lightShutters: { __typename?: 'RoomLightShuttersConnection', nodes: Array<{ __typename?: 'RoomLightShutter', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, phoneNumbers: { __typename?: 'RoomPhoneNumbersConnection', nodes: Array<{ __typename?: 'RoomPhoneNumber', id: string, start?: string | null, end?: string | null, value: string }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'RoomClearanceConstructionsConnection', nodes: Array<{ __typename?: 'RoomClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'RoomKeyIssuancesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'RoomKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } };

export type RoomAttributesFragment = { __typename?: 'Room', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, type?: { __typename?: 'RoomType', name: string } | null, nameExtra: { __typename?: 'RoomNameExtrasConnection', nodes: Array<{ __typename?: 'RoomNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> }, capacityCars: { __typename?: 'RoomCapacityCarsConnection', nodes: Array<{ __typename?: 'RoomCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'RoomCapacityTrucksConnection', nodes: Array<{ __typename?: 'RoomCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'RoomMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, maxLoadCeiling: { __typename?: 'RoomMaxLoadCeilingsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadCeiling', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'RoomTireLoadCarsConnection', nodes: Array<{ __typename?: 'RoomTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'RoomTireLoadTrucksConnection', nodes: Array<{ __typename?: 'RoomTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'RoomTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'RoomTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'RoomNoVehiclesConnection', nodes: Array<{ __typename?: 'RoomNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, daylight: { __typename?: 'RoomDaylightsConnection', nodes: Array<{ __typename?: 'RoomDaylight', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, lightShutters: { __typename?: 'RoomLightShuttersConnection', nodes: Array<{ __typename?: 'RoomLightShutter', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, phoneNumbers: { __typename?: 'RoomPhoneNumbersConnection', nodes: Array<{ __typename?: 'RoomPhoneNumber', id: string, start?: string | null, end?: string | null, value: string }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'RoomClearanceConstructionsConnection', nodes: Array<{ __typename?: 'RoomClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'RoomKeyIssuancesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'RoomKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } };

export type ZoneTimeVariantsFragment = { __typename?: 'Zone', nameExtra: { __typename?: 'ZoneNameExtrasConnection', nodes: Array<{ __typename?: 'ZoneNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'ZoneNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'ZoneNameKeyCadsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'ZoneNameKeyEbmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'ZoneNameKeyCafmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'ZoneCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'ZoneCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, capacityCars: { __typename?: 'ZoneCapacityCarsConnection', nodes: Array<{ __typename?: 'ZoneCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'ZoneCapacityTrucksConnection', nodes: Array<{ __typename?: 'ZoneCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'ZoneMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'ZoneMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'ZoneTireLoadCarsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'ZoneTireLoadTrucksConnection', nodes: Array<{ __typename?: 'ZoneTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'ZoneTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'ZoneNoVehiclesConnection', nodes: Array<{ __typename?: 'ZoneNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> } };

export type ZoneExportAttributesFragment = { __typename?: 'Zone', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'ZoneType', name: string } | null, nameExtra: { __typename?: 'ZoneNameExtrasConnection', nodes: Array<{ __typename?: 'ZoneNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'ZoneNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'ZoneNameKeyCadsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'ZoneNameKeyEbmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'ZoneNameKeyCafmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'ZoneCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'ZoneCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, capacityCars: { __typename?: 'ZoneCapacityCarsConnection', nodes: Array<{ __typename?: 'ZoneCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'ZoneCapacityTrucksConnection', nodes: Array<{ __typename?: 'ZoneCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'ZoneMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'ZoneMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'ZoneTireLoadCarsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'ZoneTireLoadTrucksConnection', nodes: Array<{ __typename?: 'ZoneTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'ZoneTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'ZoneNoVehiclesConnection', nodes: Array<{ __typename?: 'ZoneNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> } };

export type ZoneAttributesFragment = { __typename?: 'Zone', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, type?: { __typename?: 'ZoneType', name: string } | null, nameExtra: { __typename?: 'ZoneNameExtrasConnection', nodes: Array<{ __typename?: 'ZoneNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'ZoneNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'ZoneNameKeyCadsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'ZoneNameKeyEbmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'ZoneNameKeyCafmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'ZoneCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'ZoneCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, capacityCars: { __typename?: 'ZoneCapacityCarsConnection', nodes: Array<{ __typename?: 'ZoneCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'ZoneCapacityTrucksConnection', nodes: Array<{ __typename?: 'ZoneCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'ZoneMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'ZoneMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'ZoneTireLoadCarsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'ZoneTireLoadTrucksConnection', nodes: Array<{ __typename?: 'ZoneTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'ZoneTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'ZoneNoVehiclesConnection', nodes: Array<{ __typename?: 'ZoneNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> } };

export type AreaTimeVariantsFragment = { __typename?: 'Area', nameExtra: { __typename?: 'AreaNameExtrasConnection', nodes: Array<{ __typename?: 'AreaNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'AreaClearanceConstructionsConnection', nodes: Array<{ __typename?: 'AreaClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'AreaKeyIssuancesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'AreaKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } };

export type AreaExportAttributesFragment = { __typename?: 'Area', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'AreaType', name: string } | null, nameExtra: { __typename?: 'AreaNameExtrasConnection', nodes: Array<{ __typename?: 'AreaNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'AreaClearanceConstructionsConnection', nodes: Array<{ __typename?: 'AreaClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'AreaKeyIssuancesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'AreaKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } };

export type AreaAttributesFragment = { __typename?: 'Area', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, type?: { __typename?: 'AreaType', name: string } | null, nameExtra: { __typename?: 'AreaNameExtrasConnection', nodes: Array<{ __typename?: 'AreaNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'AreaClearanceConstructionsConnection', nodes: Array<{ __typename?: 'AreaClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'AreaKeyIssuancesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'AreaKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } };

export type PlotTimeVariantsFragment = { __typename?: 'Plot', nameExtra: { __typename?: 'PlotNameExtrasConnection', nodes: Array<{ __typename?: 'PlotNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> } };

export type PlotExportAttributesFragment = { __typename?: 'Plot', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'PlotType', name: string } | null, nameExtra: { __typename?: 'PlotNameExtrasConnection', nodes: Array<{ __typename?: 'PlotNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> } };

export type PlotAttributesFragment = { __typename?: 'Plot', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, type?: { __typename?: 'PlotType', name: string } | null, nameExtra: { __typename?: 'PlotNameExtrasConnection', nodes: Array<{ __typename?: 'PlotNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> } };

export type RoomPartitionTimeVariantsFragment = { __typename?: 'RoomPartition', nameExtra: { __typename?: 'RoomPartitionNameExtrasConnection', nodes: Array<{ __typename?: 'RoomPartitionNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomPartitionCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomPartitionCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomPartitionCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomPartitionCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomPartitionCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomPartitionCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomPartitionCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } };

export type RoomPartitionExportAttributesFragment = { __typename?: 'RoomPartition', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'RoomPartitionType', name: string } | null, nameExtra: { __typename?: 'RoomPartitionNameExtrasConnection', nodes: Array<{ __typename?: 'RoomPartitionNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomPartitionCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomPartitionCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomPartitionCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomPartitionCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomPartitionCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomPartitionCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomPartitionCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } };

export type RoomPartitionAttributesFragment = { __typename?: 'RoomPartition', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, type?: { __typename?: 'RoomPartitionType', name: string } | null, nameExtra: { __typename?: 'RoomPartitionNameExtrasConnection', nodes: Array<{ __typename?: 'RoomPartitionNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomPartitionCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomPartitionCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomPartitionCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomPartitionCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomPartitionCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomPartitionCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomPartitionCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } };

export type LocationSearchQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type LocationSearchQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', id: string, nameShort: string }> } | null, buildings?: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, type?: { __typename?: 'BuildingType', name: string } | null }> } | null, levels?: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, type?: { __typename?: 'LevelType', name: string } | null }> } | null, rooms?: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, type?: { __typename?: 'RoomType', name: string } | null }> } | null, zones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, type?: { __typename?: 'ZoneType', name: string } | null }> } | null, areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, type?: { __typename?: 'AreaType', name: string } | null }> } | null, plots?: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, nameShort: string, type?: { __typename?: 'PlotType', name: string } | null }> } | null, roomPartitions?: { __typename?: 'RoomPartitionsConnection', nodes: Array<{ __typename?: 'RoomPartition', id: string, nameShort: string, type?: { __typename?: 'RoomPartitionType', name: string } | null }> } | null };

export type GetBuildingTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBuildingTreePathQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, typeId?: string | null, site: { __typename?: 'Site', id: string } } | null };

export type GetLevelTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetLevelTreePathQuery = { __typename?: 'Query', level?: { __typename?: 'Level', id: string, building: { __typename?: 'Building', id: string, typeId?: string | null, site: { __typename?: 'Site', id: string } } } | null };

export type GetRoomTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomTreePathQuery = { __typename?: 'Query', room?: { __typename?: 'Room', id: string, level: { __typename?: 'Level', id: string, building: { __typename?: 'Building', id: string, typeId?: string | null, site: { __typename?: 'Site', id: string } } } } | null };

export type GetZoneTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetZoneTreePathQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, site: { __typename?: 'Site', id: string } } | null };

export type GetAreaTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAreaTreePathQuery = { __typename?: 'Query', area?: { __typename?: 'Area', id: string, zone: { __typename?: 'Zone', id: string, typeId?: string | null, site: { __typename?: 'Site', id: string } } } | null };

export type GetPlotTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPlotTreePathQuery = { __typename?: 'Query', plot?: { __typename?: 'Plot', id: string, area: { __typename?: 'Area', id: string, zone: { __typename?: 'Zone', id: string, typeId?: string | null, site: { __typename?: 'Site', id: string } } } } | null };

export type GetRoomPartitionTreePathQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomPartitionTreePathQuery = { __typename?: 'Query', roomPartition?: { __typename?: 'RoomPartition', id: string, room: { __typename?: 'Room', id: string, level: { __typename?: 'Level', id: string, building: { __typename?: 'Building', id: string, typeId?: string | null, site: { __typename?: 'Site', id: string } } } } } | null };

export type GetSiteTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSiteTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Site', id: string, nameShort: string, nameLong: string, description: string } | null };

export type GetBuildingTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetBuildingTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Building', id: string, nameShort: string, nameLong: string, description: string, site: { __typename?: 'Site', id: string, nameShort: string } } | null };

export type GetLevelTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetLevelTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Level', id: string, nameShort: string, nameLong: string, description: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } | null };

export type GetRoomTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Room', id: string, nameShort: string, nameLong: string, description: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } } | null };

export type GetZoneTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetZoneTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Zone', id: string, nameShort: string, nameLong: string, description: string, site: { __typename?: 'Site', id: string, nameShort: string } } | null };

export type GetAreaTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAreaTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Area', id: string, nameShort: string, nameLong: string, description: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } | null };

export type GetPlotTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPlotTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'Plot', id: string, nameShort: string, nameLong: string, description: string, area: { __typename?: 'Area', id: string, nameShort: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } } | null };

export type GetRoomPartitionTooltipDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomPartitionTooltipDataQuery = { __typename?: 'Query', data?: { __typename?: 'RoomPartition', id: string, nameShort: string, nameLong: string, description: string, room: { __typename?: 'Room', id: string, nameShort: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } } } | null };

export type GetLeefLocationsQueryVariables = Exact<{
  siteIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  buildingIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  levelIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  zoneIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  areaIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type GetLeefLocationsQuery = { __typename?: 'Query', levels?: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, nameLong: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, nameLong: string }> } }> } | null, buildings?: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, nameLong: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, nameLong: string }> } }> } }> } | null, sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', id: string, nameShort: string, nameLong: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, nameLong: string }> } }> } }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, nameShort: string, nameLong: string }> } }> } }> } }> } | null, zones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, nameLong: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, nameShort: string, nameLong: string }> } }> } }> } | null, areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, nameLong: string, plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, nameShort: string, nameLong: string }> } }> } | null };

export type GetLocationsForDownloadQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsForDownloadQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', extId: string, nameShort: string, nameLong: string, description: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', extId: string, nameShort: string, nameLong: string, description: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', extId: string, nameShort: string, nameLong: string, description: string, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', extId: string, nameShort: string, nameLong: string, description: string, roomPartitions: { __typename?: 'RoomPartitionsConnection', nodes: Array<{ __typename?: 'RoomPartition', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'RoomPartitionType', name: string } | null, nameExtra: { __typename?: 'RoomPartitionNameExtrasConnection', nodes: Array<{ __typename?: 'RoomPartitionNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomPartitionCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomPartitionCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomPartitionCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomPartitionCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomPartitionCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomPartitionCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomPartitionCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } }> }, type?: { __typename?: 'RoomType', name: string } | null, nameExtra: { __typename?: 'RoomNameExtrasConnection', nodes: Array<{ __typename?: 'RoomNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> }, capacityCars: { __typename?: 'RoomCapacityCarsConnection', nodes: Array<{ __typename?: 'RoomCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'RoomCapacityTrucksConnection', nodes: Array<{ __typename?: 'RoomCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'RoomMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, maxLoadCeiling: { __typename?: 'RoomMaxLoadCeilingsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadCeiling', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'RoomTireLoadCarsConnection', nodes: Array<{ __typename?: 'RoomTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'RoomTireLoadTrucksConnection', nodes: Array<{ __typename?: 'RoomTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'RoomTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'RoomTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'RoomNoVehiclesConnection', nodes: Array<{ __typename?: 'RoomNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, daylight: { __typename?: 'RoomDaylightsConnection', nodes: Array<{ __typename?: 'RoomDaylight', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, lightShutters: { __typename?: 'RoomLightShuttersConnection', nodes: Array<{ __typename?: 'RoomLightShutter', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, phoneNumbers: { __typename?: 'RoomPhoneNumbersConnection', nodes: Array<{ __typename?: 'RoomPhoneNumber', id: string, start?: string | null, end?: string | null, value: string }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'RoomClearanceConstructionsConnection', nodes: Array<{ __typename?: 'RoomClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'RoomKeyIssuancesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'RoomKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } }> }, type?: { __typename?: 'LevelType', name: string } | null, nameExtra: { __typename?: 'LevelNameExtrasConnection', nodes: Array<{ __typename?: 'LevelNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'LevelNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'LevelNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'LevelNameKeyCadsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'LevelNameKeyEbmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'LevelNameKeyCafmsConnection', nodes: Array<{ __typename?: 'LevelNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, fkmGrossSpace: { __typename?: 'LevelFkmGrossSpacesConnection', nodes: Array<{ __typename?: 'LevelFkmGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'LevelCapacityPaxesConnection', nodes: Array<{ __typename?: 'LevelCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } }> }, type?: { __typename?: 'BuildingType', name: string } | null, nameExtra: { __typename?: 'BuildingNameExtrasConnection', nodes: Array<{ __typename?: 'BuildingNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'BuildingNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'BuildingNameKeyCadsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'BuildingNameKeyEbmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'BuildingNameKeyCafmsConnection', nodes: Array<{ __typename?: 'BuildingNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', extId: string, nameShort: string, nameLong: string, description: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', extId: string, nameShort: string, nameLong: string, description: string, plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', extId: string, nameShort: string, nameLong: string, description: string, type?: { __typename?: 'PlotType', name: string } | null, nameExtra: { __typename?: 'PlotNameExtrasConnection', nodes: Array<{ __typename?: 'PlotNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> } }> }, type?: { __typename?: 'AreaType', name: string } | null, nameExtra: { __typename?: 'AreaNameExtrasConnection', nodes: Array<{ __typename?: 'AreaNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'AreaClearanceConstructionsConnection', nodes: Array<{ __typename?: 'AreaClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'AreaKeyIssuancesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'AreaKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'AreaKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } }> }, type?: { __typename?: 'ZoneType', name: string } | null, nameExtra: { __typename?: 'ZoneNameExtrasConnection', nodes: Array<{ __typename?: 'ZoneNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'ZoneNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'ZoneNameKeyCadsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'ZoneNameKeyEbmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'ZoneNameKeyCafmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'ZoneCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'ZoneCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, capacityCars: { __typename?: 'ZoneCapacityCarsConnection', nodes: Array<{ __typename?: 'ZoneCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'ZoneCapacityTrucksConnection', nodes: Array<{ __typename?: 'ZoneCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'ZoneMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'ZoneMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'ZoneTireLoadCarsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'ZoneTireLoadTrucksConnection', nodes: Array<{ __typename?: 'ZoneTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'ZoneTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'ZoneNoVehiclesConnection', nodes: Array<{ __typename?: 'ZoneNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> } }> }, nameExtra: { __typename?: 'SiteNameExtrasConnection', nodes: Array<{ __typename?: 'SiteNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'SiteNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'SiteNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'SiteNameKeyCadsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'SiteNameKeyEbmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'SiteNameKeyCafmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } }> } | null };

export type GetElevationLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetElevationLevelsQuery = { __typename?: 'Query', elevationLevels?: { __typename?: 'ElevationLevelsConnection', nodes: Array<{ __typename?: 'ElevationLevel', id: string, nameShort: string, nameLong: string, value: any }> } | null };

export type GetLevelsWithoutElevationQueryVariables = Exact<{
  levelTypeName: Scalars['String'];
}>;


export type GetLevelsWithoutElevationQuery = { __typename?: 'Query', levels?: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string }> } | null };

export type GetLevelsWithElevationQueryVariables = Exact<{
  levelTypeName: Scalars['String'];
}>;


export type GetLevelsWithElevationQuery = { __typename?: 'Query', buildings?: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, elevation?: { __typename?: 'ElevationLevel', id: string, value: any } | null }> } }> } | null };

export type GetPlotDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPlotDetailsQuery = { __typename?: 'Query', plot?: { __typename?: 'Plot', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, area: { __typename?: 'Area', id: string, nameShort: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } }, type?: { __typename?: 'PlotType', name: string } | null, nameExtra: { __typename?: 'PlotNameExtrasConnection', nodes: Array<{ __typename?: 'PlotNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> } } | null, plotTypes?: { __typename?: 'PlotTypesConnection', nodes: Array<{ __typename?: 'PlotType', id: string, name: string }> } | null };

export type GetPlotForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPlotForEditQuery = { __typename?: 'Query', plot?: { __typename?: 'Plot', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, area: { __typename?: 'Area', id: string, nameShort: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } }, type?: { __typename?: 'PlotType', name: string } | null, nameExtra: { __typename?: 'PlotNameExtrasConnection', nodes: Array<{ __typename?: 'PlotNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> } } | null, plotTypes?: { __typename?: 'PlotTypesConnection', nodes: Array<{ __typename?: 'PlotType', id: string, name: string }> } | null };

export type GetPlotForCreateQueryVariables = Exact<{
  areaId: Scalars['UUID'];
}>;


export type GetPlotForCreateQuery = { __typename?: 'Query', area?: { __typename?: 'Area', id: string, nameShort: string, zone: { __typename?: 'Zone', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } | null, plotTypes?: { __typename?: 'PlotTypesConnection', nodes: Array<{ __typename?: 'PlotType', id: string, name: string }> } | null };

export type UpdatePlotMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePlotMutation = { __typename?: 'Mutation', updatePlot?: { __typename?: 'UpdatePlotPayload', plot?: { __typename?: 'Plot', id: string, nameLong: string, nameShort: string, description: string } | null } | null };

export type CreatePlotMutationVariables = Exact<{
  areaId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type CreatePlotMutation = { __typename?: 'Mutation', createPlot?: { __typename?: 'CreatePlotPayload', plot?: { __typename?: 'Plot', id: string, nameShort: string } | null } | null };

export type DeletePlotMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePlotMutation = { __typename?: 'Mutation', deletePlot?: { __typename?: 'DeletePlotPayload', plot?: { __typename?: 'Plot', id: string, nameShort: string, areaId: string } | null } | null };

export type ProjectSeriesMultiLinkFieldsFragment = { __typename?: 'ProjectSeries', websites?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type ProjectMultiLinkFieldsFragment = { __typename?: 'Project', otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type CreateProjectSeriesMutationVariables = Exact<{
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  singleProject?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateProjectSeriesMutation = { __typename?: 'Mutation', createProjectSeries?: { __typename?: 'CreateProjectSeriesPayload', projectSeries?: { __typename?: 'ProjectSeries', id: string, nameShort: string, nameLong: string, singleProject: boolean } | null } | null };

export type GetProjectSeriesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectSeriesQuery = { __typename?: 'Query', projectSeries?: { __typename?: 'ProjectSeries', id: string, nameShort: string, nameLong: string, notes: string, description: string, category: string, type: string, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, cycle: string, notesCycle: string, notesDayOrder: string, notesAppointment: string, locationRequirements: string, allocationHints: string, singleProject: boolean, projects: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, nameShort: string, status: string, executionYear: number }> }, websites?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null };

export type GetProjectSeriesByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetProjectSeriesByNameQuery = { __typename?: 'Query', existingObject?: { __typename?: 'ProjectSeries', id: string } | null };

export type SetSingleProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
  singleProject: Scalars['Boolean'];
}>;


export type SetSingleProjectMutation = { __typename?: 'Mutation', updateProjectSeries?: { __typename?: 'UpdateProjectSeriesPayload', projectSeries?: { __typename?: 'ProjectSeries', id: string, nameShort: string, singleProject: boolean } | null } | null };

export type DeleteProjectSeriesMutationVariables = Exact<{
  seriesId: Scalars['UUID'];
}>;


export type DeleteProjectSeriesMutation = { __typename?: 'Mutation', deleteProjectSeries?: { __typename?: 'DeleteProjectSeriesPayload', projectSeries?: { __typename?: 'ProjectSeries', id: string, nameShort: string } | null } | null };

export type GetAllProjectSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectSeriesQuery = { __typename?: 'Query', projectSerieses?: { __typename?: 'ProjectSeriesConnection', nodes: Array<{ __typename?: 'ProjectSeries', id: string, nameShort: string, singleProject: boolean, projects: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, nameShort: string, status: string, executionYear: number }> } }> } | null };

export type UpdateProjectSeriesMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  cycle?: InputMaybe<Scalars['String']>;
  notesCycle?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  allocationHints?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProjectSeriesMutation = { __typename?: 'Mutation', updateProjectSeries?: { __typename?: 'UpdateProjectSeriesPayload', projectSeries?: { __typename?: 'ProjectSeries', id: string, nameShort: string, nameLong: string, notes: string, description: string, category: string, type: string, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, cycle: string, notesCycle: string, notesDayOrder: string, notesAppointment: string, locationRequirements: string, allocationHints: string } | null } | null };

export type UpdateProjectSeriesMultilinksMutationVariables = Exact<{
  id: Scalars['UUID'];
  websitesId?: InputMaybe<Scalars['UUID']>;
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateProjectSeriesMultilinksMutation = { __typename?: 'Mutation', updateProjectSeries?: { __typename?: 'UpdateProjectSeriesPayload', projectSeries?: { __typename?: 'ProjectSeries', id: string, websites?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null } | null };

export type CreateProjectMutationVariables = Exact<{
  seriesId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong: Scalars['String'];
  executionYear: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'CreateProjectPayload', project?: { __typename?: 'Project', id: string, nameShort: string, nameLong: string, executionYear: number, status: string } | null } | null };

export type ProjectBaseDataFragment = { __typename?: 'Project', id: string, nameShort: string, nameLong: string, subtitle: string, executionYear: number, description: string, category: string, type: string, disturbanceNoise: string, disturbanceDust: string, disturbanceOther: string, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, notesDayOrder: string, notesAppointment: string, locationRequirements: string, allocationHints: string, status: string, series?: { __typename?: 'ProjectSeries', id: string, nameShort: string, nameLong: string } | null, otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, nameShort: string, nameLong: string, subtitle: string, executionYear: number, description: string, category: string, type: string, disturbanceNoise: string, disturbanceDust: string, disturbanceOther: string, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, notesDayOrder: string, notesAppointment: string, locationRequirements: string, allocationHints: string, status: string, series?: { __typename?: 'ProjectSeries', id: string, nameShort: string, nameLong: string } | null, otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null };

export type GetProjectByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetProjectByNameQuery = { __typename?: 'Query', existingObject?: { __typename?: 'Project', id: string } | null };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject?: { __typename?: 'DeleteProjectPayload', project?: { __typename?: 'Project', id: string, nameShort: string } | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  executionYear?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  disturbanceNoise?: InputMaybe<Scalars['String']>;
  disturbanceDust?: InputMaybe<Scalars['String']>;
  disturbanceOther?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  organisationalChanges?: InputMaybe<Scalars['String']>;
  notesDayOrder?: InputMaybe<Scalars['String']>;
  notesAppointment?: InputMaybe<Scalars['String']>;
  locationRequirements?: InputMaybe<Scalars['String']>;
  allocationHints?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, nameShort: string, nameLong: string, subtitle: string, executionYear: number, description: string, category: string, type: string, disturbanceNoise: string, disturbanceDust: string, disturbanceOther: string, companyGroup: string, businessDomain: string, department: string, organisationalChanges: string, notesDayOrder: string, notesAppointment: string, locationRequirements: string, allocationHints: string } | null } | null };

export type UpdateProjectMultilinksMutationVariables = Exact<{
  id: Scalars['UUID'];
  otherDocumentsId?: InputMaybe<Scalars['UUID']>;
  otherSystemsId?: InputMaybe<Scalars['UUID']>;
  otherLinksId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateProjectMultilinksMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, otherDocuments?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherSystems?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null, otherLinks?: { __typename?: 'Multilink', id: string, name: string, links: { __typename?: 'LinksConnection', nodes: Array<{ __typename?: 'Link', id: string, name: string, description: string, to: string }> } } | null } | null } | null };

export type UpdateProjectStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
}>;


export type UpdateProjectStatusMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, status: string } | null } | null };

export type CreateProjectVariantMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateProjectVariantMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateProjectVariantPayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CreateProjectVariantWithAllocationsFromMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateProjectVariantWithAllocationsFromMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateProjectVariantWithAllocationsFromPayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CopyProjectVariantAllocationsMutationVariables = Exact<{
  sourceId: Scalars['UUID'];
  targetId: Scalars['UUID'];
}>;


export type CopyProjectVariantAllocationsMutation = { __typename?: 'Mutation', copyProjectVariantAllocations?: { __typename?: 'CopyProjectVariantAllocationsPayload', projectVariant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type UpdateProjectVariantAllocationsMutationVariables = Exact<{
  id: Scalars['UUID'];
  deleteRooms?: InputMaybe<Array<ProjectAllocationRoomProjectAllocationRoomPkeyDelete> | ProjectAllocationRoomProjectAllocationRoomPkeyDelete>;
  createRooms?: InputMaybe<Array<ProjectAllocationRoomProjectVariantIdFkeyProjectAllocationRoomCreateInput> | ProjectAllocationRoomProjectVariantIdFkeyProjectAllocationRoomCreateInput>;
  deleteAreas?: InputMaybe<Array<ProjectAllocationAreaProjectAllocationAreaPkeyDelete> | ProjectAllocationAreaProjectAllocationAreaPkeyDelete>;
  createAreas?: InputMaybe<Array<ProjectAllocationAreaProjectVariantIdFkeyProjectAllocationAreaCreateInput> | ProjectAllocationAreaProjectVariantIdFkeyProjectAllocationAreaCreateInput>;
}>;


export type UpdateProjectVariantAllocationsMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateProjectVariantPayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationRoomId?: string | null, referenceAllocationAreaId?: string | null, project: { __typename?: 'Project', id: string, nameShort: string }, rooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> }, areas: { __typename?: 'ProjectAllocationAreasConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } } | null } | null };

export type CreateProjectAllocationRoomMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  phases?: InputMaybe<Array<ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput> | ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput>;
}>;


export type CreateProjectAllocationRoomMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateProjectAllocationRoomPayload', allocation?: { __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type CreateProjectAllocationAreaMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  locationId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  phases?: InputMaybe<Array<ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput> | ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput>;
}>;


export type CreateProjectAllocationAreaMutation = { __typename?: 'Mutation', create?: { __typename?: 'CreateProjectAllocationAreaPayload', allocation?: { __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type ProjectAllocationRoomUpdateMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  createPhases?: InputMaybe<Array<ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput> | ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput>;
  updatePhases?: InputMaybe<Array<ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate> | ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate>;
  deletePhases?: InputMaybe<Array<ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyDelete> | ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyDelete>;
}>;


export type ProjectAllocationRoomUpdateMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateProjectAllocationRoomPayload', allocation?: { __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type ProjectAllocationAreaUpdateMutationVariables = Exact<{
  allocationId: Scalars['UUID'];
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  createPhases?: InputMaybe<Array<ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput> | ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput>;
  updatePhases?: InputMaybe<Array<ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate> | ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate>;
  deletePhases?: InputMaybe<Array<ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyDelete> | ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyDelete>;
}>;


export type ProjectAllocationAreaUpdateMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateProjectAllocationAreaPayload', allocation?: { __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } } | null } | null };

export type UpdateProjectVariantReferenceAllocationIdMutationVariables = Exact<{
  variantId: Scalars['UUID'];
  referenceAllocationRoomId?: InputMaybe<Scalars['UUID']>;
  referenceAllocationAreaId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateProjectVariantReferenceAllocationIdMutation = { __typename?: 'Mutation', updateVariant?: { __typename?: 'UpdateProjectVariantPayload', variant?: { __typename?: 'ProjectVariant', id: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null } | null } | null };

export type GetProjectVariantsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectVariantsQuery = { __typename?: 'Query', variants?: { __typename?: 'ProjectVariantsConnection', nodes: Array<{ __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null }> } | null };

export type UpdateProjectVariantMutationVariables = Exact<{
  id: Scalars['UUID'];
  feedId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  createFeedEntry?: InputMaybe<Array<FeedEntryFeedIdFkeyFeedEntryCreateInput> | FeedEntryFeedIdFkeyFeedEntryCreateInput>;
}>;


export type UpdateProjectVariantMutation = { __typename?: 'Mutation', update?: { __typename?: 'UpdateProjectVariantPayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string } | null } | null };

export type GetProjectVariantCommentsQueryVariables = Exact<{
  variantId: Scalars['UUID'];
}>;


export type GetProjectVariantCommentsQuery = { __typename?: 'Query', variant?: { __typename?: 'ProjectVariant', comments: { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } } | null };

export type ProjectVariantsWithAllocationsCountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectVariantsWithAllocationsCountQuery = { __typename?: 'Query', object?: { __typename?: 'Project', id: string, variantsWithAllocationsCount: { __typename?: 'ProjectVariantsConnection', totalCount: number } } | null };

export type ProjectLocationDotsBuildingFragment = { __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, elevation?: { __typename?: 'ElevationLevel', id: string, value: any, nameShort: string } | null, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', roomCadGrossSpaceMins: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', value: any, start?: string | null, end?: string | null, id: string }> }, allocationRooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number }, optionalAllocationRooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number } }> } }> } };

export type GetProjectLocationDotsDataQueryVariables = Exact<{
  roomType: Scalars['String'];
  levelType: Scalars['String'];
  variantId: Scalars['UUID'];
}>;


export type GetProjectLocationDotsDataQuery = { __typename?: 'Query', buildings?: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string, nameShort: string, levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', id: string, nameShort: string, elevation?: { __typename?: 'ElevationLevel', id: string, value: any, nameShort: string } | null, rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', roomCadGrossSpaceMins: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', value: any, start?: string | null, end?: string | null, id: string }> }, allocationRooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number }, optionalAllocationRooms: { __typename?: 'ProjectAllocationRoomsConnection', totalCount: number } }> } }> } }> } | null };

export type ProjectVariantDataFragment = { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string, referenceAllocationAreaId?: string | null, referenceAllocationRoomId?: string | null };

export type GetProjectAllocationsForProjectQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectAllocationsForProjectQuery = { __typename?: 'Query', projectAllocationRooms?: { __typename?: 'ProjectAllocationRoomsConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoom', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationRoomPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationRoomPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null, projectAllocationAreas?: { __typename?: 'ProjectAllocationAreasConnection', nodes: Array<{ __typename?: 'ProjectAllocationArea', id: string, start: string, end: string, isOptional: boolean, locationId: string, variant: { __typename?: 'ProjectVariant', id: string, index: number, name: string, referenceProjectAllocationAreaId?: string | null, referenceProjectAllocationRoomId?: string | null }, phases: { __typename?: 'ProjectAllocationAreaPhasesConnection', nodes: Array<{ __typename?: 'ProjectAllocationAreaPhase', id: string, allocationId: string, specializationType: string, usage: { __typename?: 'ProjectAllocationUsage', id: string, name: string, nameShort: string, type: ProjectAllocationUsageType, position: number, isExecution: boolean }, offset: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, duration: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } }> } }> } | null };

export type SpaceAreaFragment = { __typename?: 'Area', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, nameMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, value: string, start?: string | null, end?: string | null }> }, subspaces: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, extId: string, nameShort: string, nameLong: string, type?: { __typename?: 'PlotType', id: string, name: string } | null, nameMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> } }> } };

export type SpaceRoomFragment = { __typename?: 'Room', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, nameMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, value: string, start?: string | null, end?: string | null }> }, subspaces: { __typename?: 'RoomPartitionsConnection', nodes: Array<{ __typename?: 'RoomPartition', id: string, extId: string, nameShort: string, nameLong: string, type?: { __typename?: 'RoomPartitionType', id: string, name: string } | null, nameMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> } }> } };

export type GetExhibitionSpacesAreasQueryVariables = Exact<{
  typeId: Scalars['UUID'];
}>;


export type GetExhibitionSpacesAreasQuery = { __typename?: 'Query', areas?: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, nameMarketing: { __typename?: 'AreaNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'AreaNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'AreaNameKeyCadsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'AreaNameKeyEbmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'AreaNameKeyCafmsConnection', nodes: Array<{ __typename?: 'AreaNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'AreaCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'AreaCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, contactBooking: { __typename?: 'AreaContactBookingsConnection', nodes: Array<{ __typename?: 'AreaContactBooking', id: string, value: string, start?: string | null, end?: string | null }> }, subspaces: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, extId: string, nameShort: string, nameLong: string, type?: { __typename?: 'PlotType', id: string, name: string } | null, nameMarketing: { __typename?: 'PlotNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'PlotNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'PlotCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'PlotCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'PlotNameKeyCadsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'PlotNameKeyEbmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'PlotNameKeyCafmsConnection', nodes: Array<{ __typename?: 'PlotNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> } }> } }> } | null };

export type GetExhibitionSpacesRoomsQueryVariables = Exact<{
  typeId: Scalars['UUID'];
}>;


export type GetExhibitionSpacesRoomsQuery = { __typename?: 'Query', rooms?: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, nameMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, value: string, start?: string | null, end?: string | null }> }, subspaces: { __typename?: 'RoomPartitionsConnection', nodes: Array<{ __typename?: 'RoomPartition', id: string, extId: string, nameShort: string, nameLong: string, type?: { __typename?: 'RoomPartitionType', id: string, name: string } | null, nameMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, value: string, start?: string | null, end?: string | null }> }, cadGrossSpace: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, value: any, start?: string | null, end?: string | null }> }, nameCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, value: string, start?: string | null, end?: string | null }> }, nameEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, value: string, start?: string | null, end?: string | null }> }, nameCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, value: string, start?: string | null, end?: string | null }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, value: any, start?: string | null, end?: string | null }> } }> } }> } | null };

export type GetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTypesQuery = { __typename?: 'Query', roomTypes?: { __typename?: 'RoomTypesConnection', nodes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null, areaTypes?: { __typename?: 'AreaTypesConnection', nodes: Array<{ __typename?: 'AreaType', id: string, name: string }> } | null };

export type GetRoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomsQuery = { __typename?: 'Query', rooms?: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string, nameShort: string, nameLong: string }> } | null };

export type GetRoomForRoomDetailsPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomForRoomDetailsPageQuery = { __typename?: 'Query', room?: { __typename?: 'Room', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } }, allocationRooms: { __typename?: 'AllocationRoomsConnection', nodes: Array<{ __typename?: 'AllocationRoom', id: string }> }, type?: { __typename?: 'RoomType', name: string } | null, nameExtra: { __typename?: 'RoomNameExtrasConnection', nodes: Array<{ __typename?: 'RoomNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> }, capacityCars: { __typename?: 'RoomCapacityCarsConnection', nodes: Array<{ __typename?: 'RoomCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'RoomCapacityTrucksConnection', nodes: Array<{ __typename?: 'RoomCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'RoomMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, maxLoadCeiling: { __typename?: 'RoomMaxLoadCeilingsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadCeiling', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'RoomTireLoadCarsConnection', nodes: Array<{ __typename?: 'RoomTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'RoomTireLoadTrucksConnection', nodes: Array<{ __typename?: 'RoomTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'RoomTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'RoomTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'RoomNoVehiclesConnection', nodes: Array<{ __typename?: 'RoomNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, daylight: { __typename?: 'RoomDaylightsConnection', nodes: Array<{ __typename?: 'RoomDaylight', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, lightShutters: { __typename?: 'RoomLightShuttersConnection', nodes: Array<{ __typename?: 'RoomLightShutter', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, phoneNumbers: { __typename?: 'RoomPhoneNumbersConnection', nodes: Array<{ __typename?: 'RoomPhoneNumber', id: string, start?: string | null, end?: string | null, value: string }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'RoomClearanceConstructionsConnection', nodes: Array<{ __typename?: 'RoomClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'RoomKeyIssuancesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'RoomKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } } | null, roomTypes?: { __typename?: 'RoomTypesConnection', nodes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null };

export type GetCreateRoomParamsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCreateRoomParamsQuery = { __typename?: 'Query', level?: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } | null, roomTypes?: { __typename?: 'RoomTypesConnection', nodes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null };

export type CreateRoomMutationVariables = Exact<{
  levelId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type CreateRoomMutation = { __typename?: 'Mutation', createRoom?: { __typename?: 'CreateRoomPayload', room?: { __typename?: 'Room', id: string, nameShort: string } | null } | null };

export type GetRoomForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomForEditQuery = { __typename?: 'Query', room?: { __typename?: 'Room', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } }, type?: { __typename?: 'RoomType', name: string } | null, nameExtra: { __typename?: 'RoomNameExtrasConnection', nodes: Array<{ __typename?: 'RoomNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> }, capacityCars: { __typename?: 'RoomCapacityCarsConnection', nodes: Array<{ __typename?: 'RoomCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'RoomCapacityTrucksConnection', nodes: Array<{ __typename?: 'RoomCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'RoomMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, maxLoadCeiling: { __typename?: 'RoomMaxLoadCeilingsConnection', nodes: Array<{ __typename?: 'RoomMaxLoadCeiling', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'RoomTireLoadCarsConnection', nodes: Array<{ __typename?: 'RoomTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'RoomTireLoadTrucksConnection', nodes: Array<{ __typename?: 'RoomTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'RoomTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'RoomTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'RoomNoVehiclesConnection', nodes: Array<{ __typename?: 'RoomNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, daylight: { __typename?: 'RoomDaylightsConnection', nodes: Array<{ __typename?: 'RoomDaylight', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, lightShutters: { __typename?: 'RoomLightShuttersConnection', nodes: Array<{ __typename?: 'RoomLightShutter', id: string, start?: string | null, end?: string | null, value?: boolean | null }> }, phoneNumbers: { __typename?: 'RoomPhoneNumbersConnection', nodes: Array<{ __typename?: 'RoomPhoneNumber', id: string, start?: string | null, end?: string | null, value: string }> }, contactBooking: { __typename?: 'RoomContactBookingsConnection', nodes: Array<{ __typename?: 'RoomContactBooking', id: string, start?: string | null, end?: string | null, value: string }> }, clearanceConstruction: { __typename?: 'RoomClearanceConstructionsConnection', nodes: Array<{ __typename?: 'RoomClearanceConstruction', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuance: { __typename?: 'RoomKeyIssuancesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuance', id: string, start?: string | null, end?: string | null, value: string }> }, keyIssuanceNotes: { __typename?: 'RoomKeyIssuanceNotesConnection', nodes: Array<{ __typename?: 'RoomKeyIssuanceNote', id: string, start?: string | null, end?: string | null, value: string }> } } | null, roomTypes?: { __typename?: 'RoomTypesConnection', nodes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null };

export type GetRoomsInBuildingQueryVariables = Exact<{
  buildingId: Scalars['UUID'];
}>;


export type GetRoomsInBuildingQuery = { __typename?: 'Query', building?: { __typename?: 'Building', levels: { __typename?: 'LevelsConnection', nodes: Array<{ __typename?: 'Level', rooms: { __typename?: 'RoomsConnection', nodes: Array<{ __typename?: 'Room', id: string }> } }> } } | null };

export type UpdateRoomMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom?: { __typename?: 'UpdateRoomPayload', room?: { __typename?: 'Room', id: string, nameLong: string, nameShort: string, description: string } | null } | null };

export type GetRoomChildrenForTreeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomChildrenForTreeQuery = { __typename?: 'Query', room?: { __typename?: 'Room', id: string, roomPartitions: { __typename?: 'RoomPartitionsConnection', nodes: Array<{ __typename?: 'RoomPartition', id: string, nameShort: string, nameLong: string, type?: { __typename?: 'RoomPartitionType', id: string, name: string } | null }> } } | null };

export type DeleteRoomMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRoomMutation = { __typename?: 'Mutation', deleteRoom?: { __typename?: 'DeleteRoomPayload', room?: { __typename?: 'Room', id: string, nameShort: string, levelId: string } | null } | null };

export type GetRoomPartitionQueryVariables = Exact<{
  partitionId: Scalars['UUID'];
}>;


export type GetRoomPartitionQuery = { __typename?: 'Query', roomPartition?: { __typename?: 'RoomPartition', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, room: { __typename?: 'Room', id: string, nameShort: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } }, type?: { __typename?: 'RoomPartitionType', name: string } | null, nameExtra: { __typename?: 'RoomPartitionNameExtrasConnection', nodes: Array<{ __typename?: 'RoomPartitionNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomPartitionCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomPartitionCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomPartitionCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomPartitionCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomPartitionCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomPartitionCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomPartitionCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } } | null, roomPartitionTypes?: { __typename?: 'RoomPartitionTypesConnection', nodes: Array<{ __typename?: 'RoomPartitionType', id: string, name: string }> } | null };

export type GetRoomPartitionForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetRoomPartitionForEditQuery = { __typename?: 'Query', roomPartition?: { __typename?: 'RoomPartition', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, room: { __typename?: 'Room', id: string, nameShort: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } }, type?: { __typename?: 'RoomPartitionType', name: string } | null, nameExtra: { __typename?: 'RoomPartitionNameExtrasConnection', nodes: Array<{ __typename?: 'RoomPartitionNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'RoomPartitionNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'RoomPartitionNameKeyCadsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'RoomPartitionNameKeyEbmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'RoomPartitionNameKeyCafmsConnection', nodes: Array<{ __typename?: 'RoomPartitionNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'RoomPartitionCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, cleaningGrossSpace: { __typename?: 'RoomPartitionCleaningGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionCleaningGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, sbvGrossSpace: { __typename?: 'RoomPartitionSbvGrossSpacesConnection', nodes: Array<{ __typename?: 'RoomPartitionSbvGrossSpace', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMin: { __typename?: 'RoomPartitionCadLengthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadLengthMax: { __typename?: 'RoomPartitionCadLengthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadLengthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMin: { __typename?: 'RoomPartitionCadWidthMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadWidthMax: { __typename?: 'RoomPartitionCadWidthMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadWidthMax', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMin: { __typename?: 'RoomPartitionCadHeightMinsConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMin', id: string, start?: string | null, end?: string | null, value: any }> }, cadHeightMax: { __typename?: 'RoomPartitionCadHeightMaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCadHeightMax', id: string, start?: string | null, end?: string | null, value: any }> }, capacityPax: { __typename?: 'RoomPartitionCapacityPaxesConnection', nodes: Array<{ __typename?: 'RoomPartitionCapacityPax', id: string, start?: string | null, end?: string | null, value: number }> } } | null, roomPartitionTypes?: { __typename?: 'RoomPartitionTypesConnection', nodes: Array<{ __typename?: 'RoomPartitionType', id: string, name: string }> } | null };

export type GetCreateRoomPartitionParamsQueryVariables = Exact<{
  roomId: Scalars['UUID'];
}>;


export type GetCreateRoomPartitionParamsQuery = { __typename?: 'Query', room?: { __typename?: 'Room', id: string, nameShort: string, level: { __typename?: 'Level', id: string, nameShort: string, building: { __typename?: 'Building', id: string, nameShort: string, site: { __typename?: 'Site', id: string, nameShort: string } } } } | null, roomPartitionTypes?: { __typename?: 'RoomPartitionTypesConnection', nodes: Array<{ __typename?: 'RoomPartitionType', id: string, name: string }> } | null };

export type DeleteRoomPartitionMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRoomPartitionMutation = { __typename?: 'Mutation', deleteRoomPartition?: { __typename?: 'DeleteRoomPartitionPayload', roomPartition?: { __typename?: 'RoomPartition', id: string, nameShort: string, roomId: string } | null } | null };

export type ScenarioDataFragment = { __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string };

export type ScenarioDetailsFragment = { __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string, scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string } | null, changes: { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } };

export type ScenarioGroupDataFragment = { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, status: string, kapmanNumber: string, companyGroup: string, businessDomain: string, department: string, responsible: string, createdAt: string };

export type ScenarioGroupDetailsFragment = { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, status: string, kapmanNumber: string, companyGroup: string, businessDomain: string, department: string, responsible: string, createdAt: string, scenarios: { __typename?: 'ScenariosConnection', totalCount: number, nodes: Array<{ __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string }> }, organisationalChanges: { __typename?: 'Feed', id: string }, changes: { __typename?: 'Feed', id: string } };

export type GetScenarioGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScenarioGroupsQuery = { __typename?: 'Query', scenarioGroups?: { __typename?: 'ScenarioGroupsConnection', nodes: Array<{ __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, status: string, kapmanNumber: string, companyGroup: string, businessDomain: string, department: string, responsible: string, createdAt: string, scenarios: { __typename?: 'ScenariosConnection', totalCount: number, nodes: Array<{ __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string }> }, organisationalChanges: { __typename?: 'Feed', id: string }, changes: { __typename?: 'Feed', id: string } }> } | null };

export type CreateScenarioGroupMutationVariables = Exact<{
  nameShort: Scalars['String'];
  nameLong: Scalars['String'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateScenarioGroupMutation = { __typename?: 'Mutation', createScenarioGroup?: { __typename?: 'CreateScenarioGroupPayload', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, createdAt: string } | null } | null };

export type GetScenarioGroupQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetScenarioGroupQuery = { __typename?: 'Query', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, status: string, kapmanNumber: string, companyGroup: string, businessDomain: string, department: string, responsible: string, createdAt: string, scenarios: { __typename?: 'ScenariosConnection', totalCount: number, nodes: Array<{ __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string }> }, organisationalChanges: { __typename?: 'Feed', id: string }, changes: { __typename?: 'Feed', id: string } } | null };

export type GetScenarioGroupByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetScenarioGroupByNameQuery = { __typename?: 'Query', existingObject?: { __typename?: 'ScenarioGroup', id: string } | null };

export type DeleteScenarioGroupMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteScenarioGroupMutation = { __typename?: 'Mutation', deleteScenarioGroup?: { __typename?: 'DeleteScenarioGroupPayload', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string } | null } | null };

export type CreateScenarioMutationVariables = Exact<{
  scenarioGroupId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong: Scalars['String'];
  year: Scalars['Int'];
  createdById: Scalars['UUID'];
  createdByName: Scalars['String'];
}>;


export type CreateScenarioMutation = { __typename?: 'Mutation', createScenario?: { __typename?: 'CreateScenarioPayload', scenario?: { __typename?: 'Scenario', id: string, createdAt: string } | null } | null };

export type GetScenarioQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string, scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string } | null, changes: { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } } | null };

export type GetScenarioByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetScenarioByNameQuery = { __typename?: 'Query', existingObject?: { __typename?: 'Scenario', id: string } | null };

export type DeleteScenarioMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteScenarioMutation = { __typename?: 'Mutation', deleteScenario?: { __typename?: 'DeleteScenarioPayload', scenario?: { __typename?: 'Scenario', id: string } | null } | null };

export type UpdateScenarioGroupMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  intention?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  kapmanNumber?: InputMaybe<Scalars['String']>;
  companyGroup?: InputMaybe<Scalars['String']>;
  businessDomain?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  responsible?: InputMaybe<Scalars['String']>;
}>;


export type UpdateScenarioGroupMutation = { __typename?: 'Mutation', updateScenarioGroup?: { __typename?: 'UpdateScenarioGroupPayload', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, status: string, kapmanNumber: string, companyGroup: string, businessDomain: string, department: string, responsible: string, createdAt: string, scenarios: { __typename?: 'ScenariosConnection', totalCount: number, nodes: Array<{ __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string }> }, organisationalChanges: { __typename?: 'Feed', id: string }, changes: { __typename?: 'Feed', id: string } } | null } | null };

export type UpdateScenarioMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
  intention?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateScenarioMutation = { __typename?: 'Mutation', updateScenario?: { __typename?: 'UpdateScenarioPayload', scenario?: { __typename?: 'Scenario', id: string, index: number, nameShort: string, nameLong: string, intention: string, description: string, year: number, status: string, createdAt: string, scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, index: number, nameShort: string, nameLong: string } | null, changes: { __typename?: 'Feed', id: string, feedEntries: { __typename?: 'FeedEntriesConnection', nodes: Array<{ __typename?: 'FeedEntry', id: string, createdByName: string, createdAt: string, text: string, type: string, markdownText: string, oldStatus: string, newStatus: string, oldMainVariantId?: string | null, oldMainVariantIndex?: number | null, newMainVariantId?: string | null, newMainVariantIndex?: number | null, objectCreatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } } | null } | null };

export type SetScenarioChangesIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  changesId: Scalars['UUID'];
}>;


export type SetScenarioChangesIdMutation = { __typename?: 'Mutation', updateScenario?: { __typename?: 'UpdateScenarioPayload', scenario?: { __typename?: 'Scenario', id: string, changesId: string } | null } | null };

export type SetScenarioGroupChangesIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  changesId: Scalars['UUID'];
}>;


export type SetScenarioGroupChangesIdMutation = { __typename?: 'Mutation', updateScenarioGroup?: { __typename?: 'UpdateScenarioGroupPayload', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, changesId: string } | null } | null };

export type SetScenarioGroupOrganisationalChangesIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  changesId: Scalars['UUID'];
}>;


export type SetScenarioGroupOrganisationalChangesIdMutation = { __typename?: 'Mutation', updateScenarioGroup?: { __typename?: 'UpdateScenarioGroupPayload', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, organisationalChangesId: string } | null } | null };

export type GetScenarioByNameShortQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetScenarioByNameShortQuery = { __typename?: 'Query', existingObject?: { __typename?: 'Scenario', id: string } | null };

export type GetScenarioGroupByNameShortQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetScenarioGroupByNameShortQuery = { __typename?: 'Query', existingObject?: { __typename?: 'ScenarioGroup', id: string } | null };

export type UpdateScenarioGroupStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
}>;


export type UpdateScenarioGroupStatusMutation = { __typename?: 'Mutation', updateScenarioGroup?: { __typename?: 'UpdateScenarioGroupPayload', scenarioGroup?: { __typename?: 'ScenarioGroup', id: string, status: string } | null } | null };

export type UpdateScenarioStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: Scalars['String'];
}>;


export type UpdateScenarioStatusMutation = { __typename?: 'Mutation', updateScenario?: { __typename?: 'UpdateScenarioPayload', scenario?: { __typename?: 'Scenario', id: string, status: string } | null } | null };

export type DesignerScenarioSettingFragment = { __typename?: 'ScenarioSetting', scenarioId: string, showSections: boolean, start: string, end: string, year: number, quarter: number, monthsBefore: number, monthsAfter: number, scenario: { __typename?: 'Scenario', index: number, nameShort: string, year: number } };

export type GetScenarioSettingByScenarioIdQueryVariables = Exact<{
  scenarioId: Scalars['UUID'];
}>;


export type GetScenarioSettingByScenarioIdQuery = { __typename?: 'Query', scenarioSetting?: { __typename?: 'ScenarioSetting', scenarioId: string, showSections: boolean, start: string, end: string, year: number, quarter: number, monthsBefore: number, monthsAfter: number, scenario: { __typename?: 'Scenario', index: number, nameShort: string, year: number } } | null };

export type CreateScenarioSettingMutationVariables = Exact<{
  scenarioId: Scalars['UUID'];
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  year: Scalars['Int'];
  quarter: Scalars['Int'];
  monthsBefore: Scalars['Int'];
  monthsAfter: Scalars['Int'];
  showSections: Scalars['Boolean'];
}>;


export type CreateScenarioSettingMutation = { __typename?: 'Mutation', createScenarioSetting?: { __typename?: 'CreateScenarioSettingPayload', scenarioSetting?: { __typename?: 'ScenarioSetting', scenarioId: string, showSections: boolean, start: string, end: string, year: number, quarter: number, monthsBefore: number, monthsAfter: number, scenario: { __typename?: 'Scenario', index: number, nameShort: string, year: number } } | null } | null };

export type UpdateScenarioSettingMutationVariables = Exact<{
  scenarioId: Scalars['UUID'];
  start?: InputMaybe<Scalars['Datetime']>;
  end?: InputMaybe<Scalars['Datetime']>;
  year?: InputMaybe<Scalars['Int']>;
  quarter?: InputMaybe<Scalars['Int']>;
  monthsBefore?: InputMaybe<Scalars['Int']>;
  monthsAfter?: InputMaybe<Scalars['Int']>;
  showSections?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateScenarioSettingMutation = { __typename?: 'Mutation', updateScenarioSetting?: { __typename?: 'UpdateScenarioSettingPayload', scenarioSetting?: { __typename?: 'ScenarioSetting', scenarioId: string, showSections: boolean, start: string, end: string, year: number, quarter: number, monthsBefore: number, monthsAfter: number, scenario: { __typename?: 'Scenario', index: number, nameShort: string, year: number } } | null } | null };

export type DeleteScenarioSettingMutationVariables = Exact<{
  scenarioId: Scalars['UUID'];
}>;


export type DeleteScenarioSettingMutation = { __typename?: 'Mutation', deleteScenarioSetting?: { __typename?: 'DeleteScenarioSettingPayload', clientMutationId?: string | null } | null };

export type GetSiteChildrenForTreeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSiteChildrenForTreeQuery = { __typename?: 'Query', buildingTypes?: { __typename?: 'BuildingTypesConnection', nodes: Array<{ __typename?: 'BuildingType', id: string, name: string, buildingsByTypeId: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string }> } }> } | null, zoneTypes?: { __typename?: 'ZoneTypesConnection', nodes: Array<{ __typename?: 'ZoneType', id: string, name: string, zonesByTypeId: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string }> } }> } | null };

export type GetLocationTreeRootsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationTreeRootsQuery = { __typename?: 'Query', sites?: { __typename?: 'SitesConnection', nodes: Array<{ __typename?: 'Site', id: string, nameShort: string, nameLong: string, buildings: { __typename?: 'BuildingsConnection', nodes: Array<{ __typename?: 'Building', id: string }> }, zones: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string }> } }> } | null };

export type GetSiteForDetailsPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSiteForDetailsPageQuery = { __typename?: 'Query', site?: { __typename?: 'Site', id: string, extId: string, nameShort: string, nameLong: string, description: string, nameExtra: { __typename?: 'SiteNameExtrasConnection', nodes: Array<{ __typename?: 'SiteNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'SiteNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'SiteNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'SiteNameKeyCadsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'SiteNameKeyEbmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'SiteNameKeyCafmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } } | null };

export type GetSiteForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetSiteForEditQuery = { __typename?: 'Query', site?: { __typename?: 'Site', id: string, extId: string, nameShort: string, nameLong: string, description: string, nameExtra: { __typename?: 'SiteNameExtrasConnection', nodes: Array<{ __typename?: 'SiteNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'SiteNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'SiteNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'SiteNameKeyCadsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'SiteNameKeyEbmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'SiteNameKeyCafmsConnection', nodes: Array<{ __typename?: 'SiteNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> } } | null };

export type CreateSiteMutationVariables = Exact<{
  nameShort: Scalars['String'];
  nameLong: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite?: { __typename?: 'CreateSitePayload', site?: { __typename?: 'Site', id: string, nameShort: string } | null } | null };

export type UpdateSiteMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite?: { __typename?: 'UpdateSitePayload', site?: { __typename?: 'Site', id: string, nameLong: string, nameShort: string, description: string } | null } | null };

export type SiteExistsQueryVariables = Exact<{
  nameShort?: InputMaybe<Scalars['String']>;
}>;


export type SiteExistsQuery = { __typename?: 'Query', siteByNameShort?: { __typename?: 'Site', id: string } | null };

export type GetUploadUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GetUploadUrlMutation = { __typename?: 'Mutation', createUploadUrl: { __typename?: 'CreateUploadUrlResponse', url: string, upload_id: string } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, name: string, firstName: string, lastName: string, isAdmin: boolean, userPasswordLogin?: { __typename?: 'UserPasswordLogin', id: string, isActive: boolean, email: string } | null }> } | null };

export type GetUserWithLoginDataQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type GetUserWithLoginDataQuery = { __typename?: 'Query', userWithLoginData?: { __typename?: 'UserWithLoginData', id: string, isActive: boolean, firstName: string, lastName: string, isAdmin: boolean, createdAt: string, updatedAt: string, activatedAt?: string | null, deactivatedAt?: string | null, company?: string | null, jobTitle?: string | null, avatarUrl?: string | null, provider?: SsoProvider | null, matchingEntraUsers: Array<{ __typename?: 'EntraMatch', id: string, provider: SsoProvider, email: string }>, ssoLogins: Array<{ __typename?: 'SsoLoginData', id: string, isActive: boolean, oid: string, provider: SsoProvider, email?: string | null, createdAt: string, updatedAt: string, phone?: string | null, room?: string | null }>, passwordLogin?: { __typename?: 'PasswordLoginData', id: string, email: string, isActive: boolean, createdAt: string, updatedAt: string } | null } | null };

export type GetUsersWithLoginDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersWithLoginDataQuery = { __typename?: 'Query', usersWithLoginData: Array<{ __typename?: 'UserWithLoginData', id: string, isActive: boolean, firstName: string, lastName: string, isAdmin: boolean, createdAt: string, updatedAt: string, provider?: SsoProvider | null, matchingEntraUsers: Array<{ __typename?: 'EntraMatch', id: string, provider: SsoProvider, email: string }>, ssoLogins: Array<{ __typename?: 'SsoLoginData', id: string, isActive: boolean, oid: string, provider: SsoProvider, email?: string | null, createdAt: string, updatedAt: string }>, passwordLogin?: { __typename?: 'PasswordLoginData', id: string, isActive: boolean, email: string, createdAt: string, updatedAt: string } | null }> };

export type GetUserPasswordLoginByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUserPasswordLoginByEmailQuery = { __typename?: 'Query', existingObject?: { __typename?: 'UserPasswordLogin', id: string, email: string } | null };

export type MyUserFragment = { __typename?: 'User', id: string, name: string, firstName: string, lastName: string, userPasswordLogin?: { __typename?: 'UserPasswordLogin', id: string, email: string } | null };

export type GetMyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUserQuery = { __typename?: 'Query', myUser?: { __typename?: 'User', id: string, name: string, firstName: string, lastName: string, userPasswordLogin?: { __typename?: 'UserPasswordLogin', id: string, email: string } | null } | null };

export type CreateUserWithPasswordLoginMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  isAdmin: Scalars['Boolean'];
}>;


export type CreateUserWithPasswordLoginMutation = { __typename?: 'Mutation', createUserWithPasswordLogin: { __typename: 'CreatedUser', id: string } | { __typename: 'EmailTaken', message: string } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['UUID'];
  firstName?: InputMaybe<Scalars['String']>;
  iconUpload?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string, isActive: boolean, name: string, firstName: string, lastName: string, isAdmin: boolean, userPasswordLogin?: { __typename?: 'UserPasswordLogin', id: string, email: string } | null } | null } | null };

export type UpdateUserIsAdminMutationVariables = Exact<{
  userId: Scalars['UUID'];
  isAdmin: Scalars['Boolean'];
}>;


export type UpdateUserIsAdminMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string, isAdmin: boolean } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'DeleteUserPayload', user?: { __typename?: 'User', id: string, name: string } | null } | null };

export type DeactivateUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser?: { __typename?: 'DeactivateUserResponse', id?: string | null } | null };

export type GetEntraUserDataQueryVariables = Exact<{
  oid: Scalars['String'];
  provider: SsoProvider;
}>;


export type GetEntraUserDataQuery = { __typename?: 'Query', getEntraUserData?: { __typename?: 'GetEntraUserDataResponse', errors?: Array<string> | null, user?: { __typename?: 'EntraUserData', oid: string, firstName: string, lastName: string, email?: string | null, company?: string | null, position?: string | null, phone?: string | null, room?: string | null, avatarUrl?: string | null } | null } | null };

export type ActivateEntraUserMutationVariables = Exact<{
  oid: Scalars['String'];
  provider: SsoProvider;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type ActivateEntraUserMutation = { __typename?: 'Mutation', activateEntraUser: { __typename?: 'AlreadyLinked', message: string } | { __typename?: 'InvalidOid', message: string } | { __typename?: 'UserWithLoginData', id: string } };

export type SetCurrentEventVariantMutationVariables = Exact<{
  oldCurrentId: Scalars['UUID'];
  newCurrentId: Scalars['UUID'];
}>;


export type SetCurrentEventVariantMutation = { __typename?: 'Mutation', updateOld?: { __typename?: 'UpdateEventVariantPayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string } | null } | null, updateNew?: { __typename?: 'UpdateEventVariantPayload', variant?: { __typename?: 'EventVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string } | null } | null };

export type SetCurrentProjectVariantMutationVariables = Exact<{
  oldCurrentId: Scalars['UUID'];
  newCurrentId: Scalars['UUID'];
}>;


export type SetCurrentProjectVariantMutation = { __typename?: 'Mutation', updateOld?: { __typename?: 'UpdateProjectVariantPayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string } | null } | null, updateNew?: { __typename?: 'UpdateProjectVariantPayload', variant?: { __typename?: 'ProjectVariant', id: string, index: number, isCurrent: boolean, name: string, status: string, changesId: string } | null } | null };

export type SetCurrentExternalEventVariantMutationVariables = Exact<{
  oldCurrentId: Scalars['UUID'];
  newCurrentId: Scalars['UUID'];
}>;


export type SetCurrentExternalEventVariantMutation = { __typename?: 'Mutation', updateOld?: { __typename?: 'UpdateExternalEventVariantPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string } | null } | null, updateNew?: { __typename?: 'UpdateExternalEventVariantPayload', variant?: { __typename?: 'ExternalEventVariant', id: string, index: number, isCurrent: boolean, name: string, status: ExternalEventVariantStatus, changesId: string } | null } | null };

export type GetZoneTypeChildrenForTreeQueryVariables = Exact<{
  typeId: Scalars['UUID'];
  siteId: Scalars['UUID'];
}>;


export type GetZoneTypeChildrenForTreeQuery = { __typename?: 'Query', zoneType?: { __typename?: 'ZoneType', id: string, zonesByTypeId: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: string, nameShort: string, nameLong: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string }> }, type?: { __typename?: 'ZoneType', id: string, name: string } | null }> } } | null };

export type CreateZoneMutationVariables = Exact<{
  siteId: Scalars['UUID'];
  nameShort: Scalars['String'];
  nameLong?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type CreateZoneMutation = { __typename?: 'Mutation', createZone?: { __typename?: 'CreateZonePayload', zone?: { __typename?: 'Zone', id: string, nameShort: string } | null } | null };

export type GetZoneTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetZoneTypesQuery = { __typename?: 'Query', zoneTypes?: { __typename?: 'ZoneTypesConnection', nodes: Array<{ __typename?: 'ZoneType', id: string, name: string, index: number }> } | null };

export type GetZoneChildrenForTreeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetZoneChildrenForTreeQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, nameShort: string, nameLong: string, plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string }> }, type?: { __typename?: 'AreaType', id: string, name: string } | null }> } } | null };

export type GetZoneDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetZoneDetailsQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, extId: string, nameShort: string, nameLong: string, typeId?: string | null, description: string, site: { __typename?: 'Site', id: string, nameShort: string }, areas: { __typename?: 'AreasConnection', nodes: Array<{ __typename?: 'Area', id: string, plots: { __typename?: 'PlotsConnection', nodes: Array<{ __typename?: 'Plot', id: string, allocationPlots: { __typename?: 'AllocationPlotsConnection', nodes: Array<{ __typename?: 'AllocationPlot', id: string }> } }> } }> }, type?: { __typename?: 'ZoneType', name: string } | null, nameExtra: { __typename?: 'ZoneNameExtrasConnection', nodes: Array<{ __typename?: 'ZoneNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'ZoneNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'ZoneNameKeyCadsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'ZoneNameKeyEbmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'ZoneNameKeyCafmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'ZoneCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'ZoneCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, capacityCars: { __typename?: 'ZoneCapacityCarsConnection', nodes: Array<{ __typename?: 'ZoneCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'ZoneCapacityTrucksConnection', nodes: Array<{ __typename?: 'ZoneCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'ZoneMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'ZoneMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'ZoneTireLoadCarsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'ZoneTireLoadTrucksConnection', nodes: Array<{ __typename?: 'ZoneTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'ZoneTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'ZoneNoVehiclesConnection', nodes: Array<{ __typename?: 'ZoneNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> } } | null, zoneTypes?: { __typename?: 'ZoneTypesConnection', nodes: Array<{ __typename?: 'ZoneType', id: string, name: string, index: number }> } | null };

export type GetZoneForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetZoneForEditQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', typeId?: string | null, id: string, extId: string, nameShort: string, nameLong: string, description: string, site: { __typename?: 'Site', id: string, nameShort: string }, type?: { __typename?: 'ZoneType', name: string } | null, nameExtra: { __typename?: 'ZoneNameExtrasConnection', nodes: Array<{ __typename?: 'ZoneNameExtra', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyMarketing: { __typename?: 'ZoneNameKeyMarketingsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyMarketing', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCad: { __typename?: 'ZoneNameKeyCadsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCad', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyEbms: { __typename?: 'ZoneNameKeyEbmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyEbm', id: string, start?: string | null, end?: string | null, value: string }> }, nameKeyCafm: { __typename?: 'ZoneNameKeyCafmsConnection', nodes: Array<{ __typename?: 'ZoneNameKeyCafm', id: string, start?: string | null, end?: string | null, value: string }> }, cadGrossSpaceMin: { __typename?: 'ZoneCadGrossSpaceMinsConnection', nodes: Array<{ __typename?: 'ZoneCadGrossSpaceMin', id: string, start?: string | null, end?: string | null, value: any }> }, capacityCars: { __typename?: 'ZoneCapacityCarsConnection', nodes: Array<{ __typename?: 'ZoneCapacityCar', id: string, start?: string | null, end?: string | null, value: number }> }, capacityTrucks: { __typename?: 'ZoneCapacityTrucksConnection', nodes: Array<{ __typename?: 'ZoneCapacityTruck', id: string, start?: string | null, end?: string | null, value: number }> }, maxLoadFloor: { __typename?: 'ZoneMaxLoadFloorsConnection', nodes: Array<{ __typename?: 'ZoneMaxLoadFloor', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadCar: { __typename?: 'ZoneTireLoadCarsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadCar', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadTruck: { __typename?: 'ZoneTireLoadTrucksConnection', nodes: Array<{ __typename?: 'ZoneTireLoadTruck', id: string, start?: string | null, end?: string | null, value: any }> }, tireLoadForklift: { __typename?: 'ZoneTireLoadForkliftsConnection', nodes: Array<{ __typename?: 'ZoneTireLoadForklift', id: string, start?: string | null, end?: string | null, value: any }> }, noVehicles: { __typename?: 'ZoneNoVehiclesConnection', nodes: Array<{ __typename?: 'ZoneNoVehicle', id: string, start?: string | null, end?: string | null, value?: boolean | null }> } } | null, zoneTypes?: { __typename?: 'ZoneTypesConnection', nodes: Array<{ __typename?: 'ZoneType', id: string, name: string }> } | null };

export type GetZoneForCreateQueryVariables = Exact<{
  siteId: Scalars['UUID'];
}>;


export type GetZoneForCreateQuery = { __typename?: 'Query', site?: { __typename?: 'Site', id: string, nameShort: string } | null, zoneTypes?: { __typename?: 'ZoneTypesConnection', nodes: Array<{ __typename?: 'ZoneType', id: string, name: string }> } | null };

export type UpdateZoneMutationVariables = Exact<{
  id: Scalars['UUID'];
  nameShort?: InputMaybe<Scalars['String']>;
  nameLong?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  typeId: Scalars['UUID'];
}>;


export type UpdateZoneMutation = { __typename?: 'Mutation', updateZone?: { __typename?: 'UpdateZonePayload', zone?: { __typename?: 'Zone', id: string, nameLong: string, nameShort: string, description: string, type?: { __typename?: 'ZoneType', id: string, name: string } | null } | null } | null };

export type DeleteZoneMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteZoneMutation = { __typename?: 'Mutation', deleteZone?: { __typename?: 'DeleteZonePayload', zone?: { __typename?: 'Zone', id: string, nameShort: string, siteId: string } | null } | null };

export const DesignerScenarioFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DesignerScenario"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Scenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","alias":{"kind":"Name","value":"variantVisibilities"},"name":{"kind":"Name","value":"scenarioVariantVisibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"variantType"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]} as unknown as DocumentNode<DesignerScenarioFragment, unknown>;
export const AllocationSelectionFilterEventVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationSelectionFilterEventVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"rooms"},"name":{"kind":"Name","value":"allocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areas"},"name":{"kind":"Name","value":"allocationAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]} as unknown as DocumentNode<AllocationSelectionFilterEventVariantFragment, unknown>;
export const AllocationSelectionFilterEventFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationSelectionFilterEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"activeVariants"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"active-1","block":false},{"kind":"StringValue","value":"active-2","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterEventVariant"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonActiveVariants"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"passive","block":false},{"kind":"StringValue","value":"discontinued","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterEventVariant"}}]}}]}}]}},...AllocationSelectionFilterEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationSelectionFilterEventFragment, unknown>;
export const AllocationSelectionFilterProjectVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationSelectionFilterProjectVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"rooms"},"name":{"kind":"Name","value":"projectAllocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areas"},"name":{"kind":"Name","value":"projectAllocationAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]} as unknown as DocumentNode<AllocationSelectionFilterProjectVariantFragment, unknown>;
export const AllocationSelectionFilterProjectFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationSelectionFilterProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"activeVariants"},"name":{"kind":"Name","value":"projectVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"active-1","block":false},{"kind":"StringValue","value":"active-2","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterProjectVariant"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonActiveVariants"},"name":{"kind":"Name","value":"projectVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"passive","block":false},{"kind":"StringValue","value":"discontinued","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterProjectVariant"}}]}}]}}]}},...AllocationSelectionFilterProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationSelectionFilterProjectFragment, unknown>;
export const AllocationSelectionFilterExternalEventVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationSelectionFilterExternalEventVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"allocations"},"name":{"kind":"Name","value":"externalEventAllocationsByVariantId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]}}]} as unknown as DocumentNode<AllocationSelectionFilterExternalEventVariantFragment, unknown>;
export const AllocationSelectionFilterExternalEventFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationSelectionFilterExternalEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"national"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeVariants"},"name":{"kind":"Name","value":"externalEventVariantsByEventId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"fix"},{"kind":"EnumValue","value":"option"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterExternalEventVariant"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonActiveVariants"},"name":{"kind":"Name","value":"externalEventVariantsByEventId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"discontinued"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterExternalEventVariant"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visibilities"},"name":{"kind":"Name","value":"externalEventEventLocationVisibilitiesByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}},...AllocationSelectionFilterExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationSelectionFilterExternalEventFragment, unknown>;
export const PhaseTileAreaPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseTileAreaPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<PhaseTileAreaPhaseFragment, unknown>;
export const PhaseTileRoomPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseTileRoomPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<PhaseTileRoomPhaseFragment, unknown>;
export const ProjectPhaseTileAreaPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPhaseTileAreaPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ProjectPhaseTileAreaPhaseFragment, unknown>;
export const ProjectPhaseTileRoomPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPhaseTileRoomPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ProjectPhaseTileRoomPhaseFragment, unknown>;
export const PhaseTileExternalEventPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseTileExternalEventPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<PhaseTileExternalEventPhaseFragment, unknown>;
export const EventPhaseTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventPhaseType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]} as unknown as DocumentNode<EventPhaseTypeFragment, unknown>;
export const TimelineEventPlotPhaseFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventPlotPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPlotPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventPhaseType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},...EventPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventPlotPhaseFragment, unknown>;
export const TimelineEventAllocationPlotFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventAllocationPlot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPlot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"plotId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationPlotPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventPlotPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineEventPlotPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventAllocationPlotFragment, unknown>;
export const TimelineEventRoomPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventRoomPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]} as unknown as DocumentNode<TimelineEventRoomPhaseFragment, unknown>;
export const TimelineEventAllocationRoomFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventAllocationRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoom"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventRoomPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineEventRoomPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventAllocationRoomFragment, unknown>;
export const TimelineEventAreaPhaseFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventAreaPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventPhaseType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},...EventPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventAreaPhaseFragment, unknown>;
export const TimelineEventAllocationAreaFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventAllocationArea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationAreaPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAreaPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineEventAreaPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventAllocationAreaFragment, unknown>;
export const TimelineEventVariantFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEventVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rooms"},"name":{"kind":"Name","value":"allocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationRoom"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areas"},"name":{"kind":"Name","value":"allocationAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationArea"}}]}}]}}]}},...TimelineEventAllocationRoomFragmentDoc.definitions,...TimelineEventAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventVariantFragment, unknown>;
export const TimelineEventFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<TimelineEventFragment, unknown>;
export const ProjectPhaseTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectPhaseType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]} as unknown as DocumentNode<ProjectPhaseTypeFragment, unknown>;
export const TimelineProjectPlotPhaseFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectPlotPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationPlotPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPhaseType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},...ProjectPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectPlotPhaseFragment, unknown>;
export const TimelineProjectAllocationPlotFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectAllocationPlot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationPlot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"plotId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationPlotPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectPlotPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineProjectPlotPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectAllocationPlotFragment, unknown>;
export const TimelineProjectRoomPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectRoomPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]} as unknown as DocumentNode<TimelineProjectRoomPhaseFragment, unknown>;
export const TimelineProjectAllocationRoomFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectAllocationRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoom"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectRoomPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineProjectRoomPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectAllocationRoomFragment, unknown>;
export const TimelineProjectAreaPhaseFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectAreaPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPhaseType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},...ProjectPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectAreaPhaseFragment, unknown>;
export const TimelineProjectAllocationAreaFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectAllocationArea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationAreaPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAreaPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineProjectAreaPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectAllocationAreaFragment, unknown>;
export const TimelineProjectVariantFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProjectVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"referenceAllocationRoomId"},"name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}},{"kind":"Field","alias":{"kind":"Name","value":"referenceAllocationAreaId"},"name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","alias":{"kind":"Name","value":"rooms"},"name":{"kind":"Name","value":"projectAllocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationRoom"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"areas"},"name":{"kind":"Name","value":"projectAllocationAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationArea"}}]}}]}}]}},...TimelineProjectAllocationRoomFragmentDoc.definitions,...TimelineProjectAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectVariantFragment, unknown>;
export const TimelineProjectFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"projectVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<TimelineProjectFragment, unknown>;
export const TimelineSiteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineSite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]} as unknown as DocumentNode<TimelineSiteFragment, unknown>;
export const TimelineFullSiteFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineFullSite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineSite"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},...TimelineSiteFragmentDoc.definitions]} as unknown as DocumentNode<TimelineFullSiteFragment, unknown>;
export const TimelineRoomFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TimelineRoomFragment, unknown>;
export const TimelineAreaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineArea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Area"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TimelineAreaFragment, unknown>;
export const MultiLinkDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiLinkData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Multilink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<MultiLinkDataFragment, unknown>;
export const SeriesMultiLinkFieldsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeriesMultiLinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventSeries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"executors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sponsors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subeventsLocal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subeventsOtherLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fairAbroad"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fairAbroadCooperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitionNational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCompetitionNational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitionInternational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCompetitionInternational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"favoredParallelsInternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"favoredParallelsExternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherLinksInternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherLinksExternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<SeriesMultiLinkFieldsFragment, unknown>;
export const SeriesEventMainVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeriesEventMainVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}}]}}]} as unknown as DocumentNode<SeriesEventMainVariantFragment, unknown>;
export const SeriesEventDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeriesEventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","alias":{"kind":"Name","value":"mainVariant"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeriesEventMainVariant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVariants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...SeriesEventMainVariantFragmentDoc.definitions]} as unknown as DocumentNode<SeriesEventDataFragment, unknown>;
export const EventSeriesDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSeriesData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventSeries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"websites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberKapman"}},{"kind":"Field","name":{"kind":"Name","value":"numberShort"}},{"kind":"Field","name":{"kind":"Name","value":"foundationYear"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isTechnical"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"partnersOverviewName"}},{"kind":"Field","name":{"kind":"Name","value":"partnersOverviewLink"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeriesMultiLinkFields"}},{"kind":"Field","name":{"kind":"Name","value":"additionalPartners"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconUploadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"notesSetup"}},{"kind":"Field","name":{"kind":"Name","value":"notesEarlyConstructionInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesEarlyConstructionExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesConstruction"}},{"kind":"Field","name":{"kind":"Name","value":"notesExecution"}},{"kind":"Field","name":{"kind":"Name","value":"notesDismantling"}},{"kind":"Field","name":{"kind":"Name","value":"notesExtendedDismantlingExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesExtendedDismantlingInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesTechnicalDismantling"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrderHistory"}},{"kind":"Field","name":{"kind":"Name","value":"notesAppointmentRules"}},{"kind":"Field","name":{"kind":"Name","value":"notesMonths"}},{"kind":"Field","name":{"kind":"Name","value":"notesHolidaysNrw"}},{"kind":"Field","name":{"kind":"Name","value":"notesHolidaysNational"}},{"kind":"Field","name":{"kind":"Name","value":"notesHolidaysInternational"}},{"kind":"Field","name":{"kind":"Name","value":"notesPublicHolidaysNrw"}},{"kind":"Field","name":{"kind":"Name","value":"notesPublicHolidaysNational"}},{"kind":"Field","name":{"kind":"Name","value":"notesPublicHolidaysInternational"}},{"kind":"Field","name":{"kind":"Name","value":"otherNotesAppointmentRules"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentHistory"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"cycleChanges"}},{"kind":"Field","name":{"kind":"Name","value":"allocationRules"}},{"kind":"Field","name":{"kind":"Name","value":"locationHistory"}},{"kind":"Field","name":{"kind":"Name","value":"otherAllocationNeeds"}},{"kind":"Field","name":{"kind":"Name","value":"notesHallExhibitionAreas"}},{"kind":"Field","name":{"kind":"Name","value":"notesBoulevardSections"}},{"kind":"Field","name":{"kind":"Name","value":"notesPassages"}},{"kind":"Field","name":{"kind":"Name","value":"notesEntrances"}},{"kind":"Field","name":{"kind":"Name","value":"notesServiceCenters"}},{"kind":"Field","name":{"kind":"Name","value":"notesConferenceRooms"}},{"kind":"Field","name":{"kind":"Name","value":"notesOfficesInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesStorageInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesOfficesExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesStorageExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesAreas"}},{"kind":"Field","name":{"kind":"Name","value":"notesParking"}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}},{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"eventsBySeriesId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EXECUTION_YEAR_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeriesEventData"}}]}}]}}]}},...SeriesMultiLinkFieldsFragmentDoc.definitions,...SeriesEventDataFragmentDoc.definitions]} as unknown as DocumentNode<EventSeriesDataFragment, unknown>;
export const EventVariantDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventVariantData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}}]}}]} as unknown as DocumentNode<EventVariantDataFragment, unknown>;
export const EventMultiLinkFieldsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventMultiLinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extraDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subeventsLocal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subeventsOtherLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fairAbroad"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fairAbroadCooperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitionNational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCompetitionNational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitionInternational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCompetitionInternational"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"favoredParallelsInternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"favoredParallelsExternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherLinksInternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherLinksExternal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<EventMultiLinkFieldsFragment, unknown>;
export const EventBaseDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventBaseData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"annualSpecifics"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"responsible"}},{"kind":"Field","name":{"kind":"Name","value":"assistant"}},{"kind":"Field","name":{"kind":"Name","value":"teamChanges"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconUploadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventMultiLinkFields"}},{"kind":"Field","alias":{"kind":"Name","value":"mainVariant"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}},...EventMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<EventBaseDataFragment, unknown>;
export const LocationDotsBuildingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationDotsBuilding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Building"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelType"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ELEVATION_LEVEL_BY_ELEVATION_ID__VALUE_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"elevation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomType"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventVariantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"optionalAllocationRooms"},"name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventVariantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocationDotsBuildingFragment, unknown>;
export const ExternalEventDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"national"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventDataFragment, unknown>;
export const ExternalEventWithAllocationExistsDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventWithAllocationExistsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventData"}},{"kind":"Field","alias":{"kind":"Name","value":"variantsWithAllocations"},"name":{"kind":"Name","value":"externalEventVariantsByEventId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationsByVariantIdExist"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...ExternalEventDataFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventWithAllocationExistsDataFragment, unknown>;
export const ExternalEventSeriesDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventSeriesData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"national"}},{"kind":"Field","name":{"kind":"Name","value":"silent"}},{"kind":"Field","name":{"kind":"Name","value":"websites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"externalEventsBySeriesId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"externalEventVariantsByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalEventAllocationsByVariantId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalEventSeriesDataFragment, unknown>;
export const ExternalEventMainVariantWithAllocationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventMainVariantWithAllocations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","alias":{"kind":"Name","value":"referenceAllocationId"},"name":{"kind":"Name","value":"referenceExternalEventAllocationId"}},{"kind":"Field","alias":{"kind":"Name","value":"allocations"},"name":{"kind":"Name","value":"externalEventAllocationsByVariantId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}}]}}]}}]} as unknown as DocumentNode<ExternalEventMainVariantWithAllocationsFragment, unknown>;
export const ExternalEventWithMainVariantDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventWithMainVariantData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalEventVariantsByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mainVariant"},"name":{"kind":"Name","value":"externalEventVariantsByEventId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventMainVariantWithAllocations"}}]}}]}}]}},...ExternalEventMainVariantWithAllocationsFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventWithMainVariantDataFragment, unknown>;
export const ExternalEventSeriesWithEventsDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventSeriesWithEventsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"national"}},{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"externalEventsBySeriesId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventWithMainVariantData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...ExternalEventWithMainVariantDataFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventSeriesWithEventsDataFragment, unknown>;
export const ExternalEventMainVariantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventMainVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceExternalEventAllocationId"}}]}}]} as unknown as DocumentNode<ExternalEventMainVariantFragment, unknown>;
export const ExternalEventPhaseTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventPhaseType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]} as unknown as DocumentNode<ExternalEventPhaseTypeFragment, unknown>;
export const ExternalEventVariantDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventVariantData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","alias":{"kind":"Name","value":"referenceAllocationId"},"name":{"kind":"Name","value":"referenceExternalEventAllocationId"}}]}}]} as unknown as DocumentNode<ExternalEventVariantDataFragment, unknown>;
export const UpdateExternalEventSeriesResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateExternalEventSeriesResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"websites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventSeriesResultFragment, unknown>;
export const TimelineExternalEventLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineExternalEventLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isNationalDefault"}},{"kind":"Field","alias":{"kind":"Name","value":"visibility"},"name":{"kind":"Name","value":"externalEventEventLocationVisibilitiesByLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]} as unknown as DocumentNode<TimelineExternalEventLocationFragment, unknown>;
export const TimelineExternalEventPhaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineExternalEventPhase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]} as unknown as DocumentNode<TimelineExternalEventPhaseFragment, unknown>;
export const TimelineExternalEventAllocationFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineExternalEventAllocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"referenceExternalEventAllocationId"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"externalEventAllocationPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}}]}},...TimelineExternalEventPhaseFragmentDoc.definitions]} as unknown as DocumentNode<TimelineExternalEventAllocationFragment, unknown>;
export const TimelineExternalEventVariantFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineExternalEventVariant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceExternalEventAllocationId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allocations"},"name":{"kind":"Name","value":"externalEventAllocationsByVariantId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventAllocation"}}]}}]}}]}},...TimelineExternalEventAllocationFragmentDoc.definitions]} as unknown as DocumentNode<TimelineExternalEventVariantFragment, unknown>;
export const TimelineExternalEventFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimelineExternalEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"national"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isNationalDefault"}},{"kind":"Field","alias":{"kind":"Name","value":"visibility"},"name":{"kind":"Name","value":"externalEventEventLocationVisibilitiesByLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"externalEventVariantsByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<TimelineExternalEventFragment, unknown>;
export const AllocationForDaysRowsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationForDaysRows"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"externalEventAllocationPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventPhase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceExternalEventAllocationId"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"national"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visibilities"},"name":{"kind":"Name","value":"externalEventEventLocationVisibilitiesByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]}}]}}]}},...TimelineExternalEventPhaseFragmentDoc.definitions]} as unknown as DocumentNode<AllocationForDaysRowsFragment, unknown>;
export const ExternalEventLocationBaseDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventLocationBaseData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ExternalEventLocationBaseDataFragment, unknown>;
export const ExternalEventLocationWithAllocationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalEventLocationWithAllocations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"optionalAllocations"},"name":{"kind":"Name","value":"externalEventAllocationsByLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"variantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allocations"},"name":{"kind":"Name","value":"externalEventAllocationsByLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"variantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visibilities"},"name":{"kind":"Name","value":"externalEventEventLocationVisibilitiesByLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]} as unknown as DocumentNode<ExternalEventLocationWithAllocationsFragment, unknown>;
export const SiteTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"siteNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"siteNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"siteNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"siteNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"siteNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<SiteTimeVariantsFragment, unknown>;
export const SiteAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteTimeVariants"}}]}},...SiteTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<SiteAttributesFragment, unknown>;
export const SiteExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteTimeVariants"}}]}},...SiteTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<SiteExportAttributesFragment, unknown>;
export const BuildingTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildingTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Building"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"buildingNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"buildingNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"buildingNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"buildingNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"buildingNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BuildingTimeVariantsFragment, unknown>;
export const BuildingExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildingExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Building"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingTimeVariants"}}]}},...BuildingTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<BuildingExportAttributesFragment, unknown>;
export const BuildingAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildingAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Building"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingTimeVariants"}}]}},...BuildingTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<BuildingAttributesFragment, unknown>;
export const LevelTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LevelTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"levelNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"levelNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"levelNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"levelNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"levelNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fkmGrossSpace"},"name":{"kind":"Name","value":"levelFkmGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityPax"},"name":{"kind":"Name","value":"levelCapacityPaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<LevelTimeVariantsFragment, unknown>;
export const LevelExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LevelExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LevelTimeVariants"}}]}},...LevelTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<LevelExportAttributesFragment, unknown>;
export const LevelAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LevelAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"elevationId"}},{"kind":"Field","name":{"kind":"Name","value":"elevation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LevelTimeVariants"}}]}},...LevelTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<LevelAttributesFragment, unknown>;
export const RoomTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"roomNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"roomNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"roomNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"roomNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"roomNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpaceMin"},"name":{"kind":"Name","value":"roomCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cleaningGrossSpace"},"name":{"kind":"Name","value":"roomCleaningGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sbvGrossSpace"},"name":{"kind":"Name","value":"roomSbvGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadLengthMin"},"name":{"kind":"Name","value":"roomCadLengthMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadLengthMax"},"name":{"kind":"Name","value":"roomCadLengthMaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadWidthMin"},"name":{"kind":"Name","value":"roomCadWidthMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadWidthMax"},"name":{"kind":"Name","value":"roomCadWidthMaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadHeightMin"},"name":{"kind":"Name","value":"roomCadHeightMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadHeightMax"},"name":{"kind":"Name","value":"roomCadHeightMaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityPax"},"name":{"kind":"Name","value":"roomCapacityPaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityCars"},"name":{"kind":"Name","value":"roomCapacityCars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityTrucks"},"name":{"kind":"Name","value":"roomCapacityTrucks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"maxLoadFloor"},"name":{"kind":"Name","value":"roomMaxLoadFloors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"maxLoadCeiling"},"name":{"kind":"Name","value":"roomMaxLoadCeilings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tireLoadCar"},"name":{"kind":"Name","value":"roomTireLoadCars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tireLoadTruck"},"name":{"kind":"Name","value":"roomTireLoadTrucks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tireLoadForklift"},"name":{"kind":"Name","value":"roomTireLoadForklifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"noVehicles"},"name":{"kind":"Name","value":"roomNoVehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"daylight"},"name":{"kind":"Name","value":"roomDaylights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lightShutters"},"name":{"kind":"Name","value":"roomLightShutters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumbers"},"name":{"kind":"Name","value":"roomPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contactBooking"},"name":{"kind":"Name","value":"roomContactBookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clearanceConstruction"},"name":{"kind":"Name","value":"roomClearanceConstructions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"keyIssuance"},"name":{"kind":"Name","value":"roomKeyIssuances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"keyIssuanceNotes"},"name":{"kind":"Name","value":"roomKeyIssuanceNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<RoomTimeVariantsFragment, unknown>;
export const RoomExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomTimeVariants"}}]}},...RoomTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<RoomExportAttributesFragment, unknown>;
export const RoomAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomTimeVariants"}}]}},...RoomTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<RoomAttributesFragment, unknown>;
export const ZoneTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ZoneTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"zoneNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"zoneNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"zoneNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"zoneNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"zoneNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpaceMin"},"name":{"kind":"Name","value":"zoneCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityCars"},"name":{"kind":"Name","value":"zoneCapacityCars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityTrucks"},"name":{"kind":"Name","value":"zoneCapacityTrucks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"maxLoadFloor"},"name":{"kind":"Name","value":"zoneMaxLoadFloors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tireLoadCar"},"name":{"kind":"Name","value":"zoneTireLoadCars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tireLoadTruck"},"name":{"kind":"Name","value":"zoneTireLoadTrucks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tireLoadForklift"},"name":{"kind":"Name","value":"zoneTireLoadForklifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"noVehicles"},"name":{"kind":"Name","value":"zoneNoVehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ZoneTimeVariantsFragment, unknown>;
export const ZoneExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ZoneExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneTimeVariants"}}]}},...ZoneTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<ZoneExportAttributesFragment, unknown>;
export const ZoneAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ZoneAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneTimeVariants"}}]}},...ZoneTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<ZoneAttributesFragment, unknown>;
export const AreaTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AreaTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Area"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"areaNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"areaNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"areaNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"areaNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"areaNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpaceMin"},"name":{"kind":"Name","value":"areaCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contactBooking"},"name":{"kind":"Name","value":"areaContactBookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clearanceConstruction"},"name":{"kind":"Name","value":"areaClearanceConstructions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"keyIssuance"},"name":{"kind":"Name","value":"areaKeyIssuances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"keyIssuanceNotes"},"name":{"kind":"Name","value":"areaKeyIssuanceNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<AreaTimeVariantsFragment, unknown>;
export const AreaExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AreaExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Area"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AreaTimeVariants"}}]}},...AreaTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<AreaExportAttributesFragment, unknown>;
export const AreaAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AreaAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Area"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AreaTimeVariants"}}]}},...AreaTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<AreaAttributesFragment, unknown>;
export const PlotTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlotTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"plotNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"plotNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"plotNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"plotNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"plotNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpaceMin"},"name":{"kind":"Name","value":"plotCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<PlotTimeVariantsFragment, unknown>;
export const PlotExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlotExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlotTimeVariants"}}]}},...PlotTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<PlotExportAttributesFragment, unknown>;
export const PlotAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlotAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlotTimeVariants"}}]}},...PlotTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<PlotAttributesFragment, unknown>;
export const RoomPartitionTimeVariantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomPartitionTimeVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomPartition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nameExtra"},"name":{"kind":"Name","value":"roomPartitionNameExtras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyMarketing"},"name":{"kind":"Name","value":"roomPartitionNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCad"},"name":{"kind":"Name","value":"roomPartitionNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyEbms"},"name":{"kind":"Name","value":"roomPartitionNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameKeyCafm"},"name":{"kind":"Name","value":"roomPartitionNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpaceMin"},"name":{"kind":"Name","value":"roomPartitionCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cleaningGrossSpace"},"name":{"kind":"Name","value":"roomPartitionCleaningGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sbvGrossSpace"},"name":{"kind":"Name","value":"roomPartitionSbvGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadLengthMin"},"name":{"kind":"Name","value":"roomPartitionCadLengthMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadLengthMax"},"name":{"kind":"Name","value":"roomPartitionCadLengthMaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadWidthMin"},"name":{"kind":"Name","value":"roomPartitionCadWidthMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadWidthMax"},"name":{"kind":"Name","value":"roomPartitionCadWidthMaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadHeightMin"},"name":{"kind":"Name","value":"roomPartitionCadHeightMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadHeightMax"},"name":{"kind":"Name","value":"roomPartitionCadHeightMaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"capacityPax"},"name":{"kind":"Name","value":"roomPartitionCapacityPaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<RoomPartitionTimeVariantsFragment, unknown>;
export const RoomPartitionExportAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomPartitionExportAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomPartition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomPartitionTimeVariants"}}]}},...RoomPartitionTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<RoomPartitionExportAttributesFragment, unknown>;
export const RoomPartitionAttributesFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomPartitionAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoomPartition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomPartitionTimeVariants"}}]}},...RoomPartitionTimeVariantsFragmentDoc.definitions]} as unknown as DocumentNode<RoomPartitionAttributesFragment, unknown>;
export const ProjectSeriesMultiLinkFieldsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectSeriesMultiLinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectSeries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"websites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<ProjectSeriesMultiLinkFieldsFragment, unknown>;
export const ProjectMultiLinkFieldsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectMultiLinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<ProjectMultiLinkFieldsFragment, unknown>;
export const ProjectBaseDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectBaseData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"disturbanceNoise"}},{"kind":"Field","name":{"kind":"Name","value":"disturbanceDust"}},{"kind":"Field","name":{"kind":"Name","value":"disturbanceOther"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"notesAppointment"}},{"kind":"Field","name":{"kind":"Name","value":"locationRequirements"}},{"kind":"Field","name":{"kind":"Name","value":"allocationHints"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectMultiLinkFields"}}]}},...ProjectMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ProjectBaseDataFragment, unknown>;
export const ProjectLocationDotsBuildingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectLocationDotsBuilding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Building"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelType"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ELEVATION_LEVEL_BY_ELEVATION_ID__VALUE_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"elevation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomType"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allocationRooms"},"name":{"kind":"Name","value":"projectAllocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"optionalAllocationRooms"},"name":{"kind":"Name","value":"projectAllocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectLocationDotsBuildingFragment, unknown>;
export const ProjectVariantDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectVariantData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}},{"kind":"Field","alias":{"kind":"Name","value":"referenceAllocationAreaId"},"name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","alias":{"kind":"Name","value":"referenceAllocationRoomId"},"name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}}]}}]} as unknown as DocumentNode<ProjectVariantDataFragment, unknown>;
export const SpaceAreaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpaceArea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Area"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","alias":{"kind":"Name","value":"nameMarketing"},"name":{"kind":"Name","value":"areaNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCad"},"name":{"kind":"Name","value":"areaNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameEbms"},"name":{"kind":"Name","value":"areaNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCafm"},"name":{"kind":"Name","value":"areaNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpace"},"name":{"kind":"Name","value":"areaCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contactBooking"},"name":{"kind":"Name","value":"areaContactBookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"subspaces"},"name":{"kind":"Name","value":"plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameMarketing"},"name":{"kind":"Name","value":"plotNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpace"},"name":{"kind":"Name","value":"plotCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCad"},"name":{"kind":"Name","value":"plotNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameEbms"},"name":{"kind":"Name","value":"plotNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCafm"},"name":{"kind":"Name","value":"plotNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SpaceAreaFragment, unknown>;
export const SpaceRoomFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpaceRoom"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","alias":{"kind":"Name","value":"nameMarketing"},"name":{"kind":"Name","value":"roomNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCad"},"name":{"kind":"Name","value":"roomNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameEbms"},"name":{"kind":"Name","value":"roomNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCafm"},"name":{"kind":"Name","value":"roomNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpace"},"name":{"kind":"Name","value":"roomCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cleaningGrossSpace"},"name":{"kind":"Name","value":"roomCleaningGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sbvGrossSpace"},"name":{"kind":"Name","value":"roomSbvGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contactBooking"},"name":{"kind":"Name","value":"roomContactBookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"subspaces"},"name":{"kind":"Name","value":"roomPartitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extId"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameMarketing"},"name":{"kind":"Name","value":"roomPartitionNameKeyMarketings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cadGrossSpace"},"name":{"kind":"Name","value":"roomPartitionCadGrossSpaceMins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCad"},"name":{"kind":"Name","value":"roomPartitionNameKeyCads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameEbms"},"name":{"kind":"Name","value":"roomPartitionNameKeyEbms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nameCafm"},"name":{"kind":"Name","value":"roomPartitionNameKeyCafms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cleaningGrossSpace"},"name":{"kind":"Name","value":"roomPartitionCleaningGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sbvGrossSpace"},"name":{"kind":"Name","value":"roomPartitionSbvGrossSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SpaceRoomFragment, unknown>;
export const ScenarioDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScenarioData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Scenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"intention"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<ScenarioDataFragment, unknown>;
export const FeedEntryDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeedEntryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"markdownText"}},{"kind":"Field","name":{"kind":"Name","value":"oldStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newStatus"}},{"kind":"Field","name":{"kind":"Name","value":"oldMainVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"oldMainVariantIndex"}},{"kind":"Field","name":{"kind":"Name","value":"newMainVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"newMainVariantIndex"}},{"kind":"Field","name":{"kind":"Name","value":"objectCreatedAt"}}]}}]} as unknown as DocumentNode<FeedEntryDataFragment, unknown>;
export const FeedDataFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeedData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feedEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<FeedDataFragment, unknown>;
export const ScenarioDetailsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScenarioDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Scenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioData"}},{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedData"}}]}}]}},...ScenarioDataFragmentDoc.definitions,...FeedDataFragmentDoc.definitions]} as unknown as DocumentNode<ScenarioDetailsFragment, unknown>;
export const ScenarioGroupDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScenarioGroupData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScenarioGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"intention"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"kapmanNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"responsible"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<ScenarioGroupDataFragment, unknown>;
export const ScenarioGroupDetailsFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScenarioGroupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScenarioGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioGroupData"}},{"kind":"Field","name":{"kind":"Name","value":"scenarios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},...ScenarioGroupDataFragmentDoc.definitions,...ScenarioDataFragmentDoc.definitions]} as unknown as DocumentNode<ScenarioGroupDetailsFragment, unknown>;
export const DesignerScenarioSettingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DesignerScenarioSetting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScenarioSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioId"}},{"kind":"Field","name":{"kind":"Name","value":"showSections"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"quarter"}},{"kind":"Field","name":{"kind":"Name","value":"monthsBefore"}},{"kind":"Field","name":{"kind":"Name","value":"monthsAfter"}},{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<DesignerScenarioSettingFragment, unknown>;
export const MyUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPasswordLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<MyUserFragment, unknown>;
export const GetSectionsDataForAllocationDesignerTimelineDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSectionsDataForAllocationDesignerTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineFullSite"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomTypes"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"responsible"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventRoomPhase"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAllocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectRoomPhase"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaTypes"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"responsible"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationAreaPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAreaPhase"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAllocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}},{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationAreaPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAreaPhase"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalEventAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]}}]}},...TimelineFullSiteFragmentDoc.definitions,...TimelineEventRoomPhaseFragmentDoc.definitions,...TimelineProjectRoomPhaseFragmentDoc.definitions,...TimelineEventAreaPhaseFragmentDoc.definitions,...TimelineProjectAreaPhaseFragmentDoc.definitions]} as unknown as DocumentNode<GetSectionsDataForAllocationDesignerTimelineQuery, GetSectionsDataForAllocationDesignerTimelineQueryVariables>;
export const GetDesignerScenarioDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDesignerScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DesignerScenario"}}]}}]}},...DesignerScenarioFragmentDoc.definitions]} as unknown as DocumentNode<GetDesignerScenarioQuery, GetDesignerScenarioQueryVariables>;
export const UpdateScenarioVisibilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScenarioVisibilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScenarioVariantVisibilityScenarioIdScenarioIdFkScenarioVariantVisibilityCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteById"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScenarioVariantVisibilityScenarioVariantVisibilityPkeyDelete"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateById"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScenarioVariantVisibilityOnScenarioVariantVisibilityForScenarioVariantVisibilityScenarioIdScenarioIdFkUsingScenarioVariantVisibilityPkeyUpdate"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioVariantVisibilitiesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateById"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scenarioVariantVisibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"variantType"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScenarioVisibilitiesMutation, UpdateScenarioVisibilitiesMutationVariables>;
export const GetAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]} as unknown as DocumentNode<GetAreasQuery, GetAreasQueryVariables>;
export const GetAreaChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAreaChildrenForTreeQuery, GetAreaChildrenForTreeQueryVariables>;
export const GetAreaForAreaDetailsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaForAreaDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AreaAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationPlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areaTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...AreaAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAreaForAreaDetailsQuery, GetAreaForAreaDetailsQueryVariables>;
export const GetAreaForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AreaAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areaTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...AreaAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAreaForEditQuery, GetAreaForEditQueryVariables>;
export const GetAreaForCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaForCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areaTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetAreaForCreateQuery, GetAreaForCreateQueryVariables>;
export const CreateAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAreaMutation, CreateAreaMutationVariables>;
export const GetAreaTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areaTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]}}]} as unknown as DocumentNode<GetAreaTypesQuery, GetAreaTypesQueryVariables>;
export const UpdateAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAreaMutation, UpdateAreaMutationVariables>;
export const DeleteAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"zoneId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAreaMutation, DeleteAreaMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const TokenRefreshDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TokenRefresh"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionProvider"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshJwt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TokenRefreshMutation, TokenRefreshMutationVariables>;
export const GetIsAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIsAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]}}]} as unknown as DocumentNode<GetIsAdminQuery, GetIsAdminQueryVariables>;
export const SetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetPasswordMutation, SetPasswordMutationVariables>;
export const UpdatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const EntraLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EntraLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SsoProvider"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entraLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}},{"kind":"Argument","name":{"kind":"Name","value":"idToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<EntraLoginMutation, EntraLoginMutationVariables>;
export const ActivateSsoLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateSsoLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SsoProvider"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateSsoLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}},{"kind":"Argument","name":{"kind":"Name","value":"oid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SsoLoginData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlreadyLinked"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ActivateSsoLoginMutation, ActivateSsoLoginMutationVariables>;
export const DeactivateSsoLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateSsoLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SsoProvider"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateSsoLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}},{"kind":"Argument","name":{"kind":"Name","value":"oid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateSsoLoginMutation, DeactivateSsoLoginMutationVariables>;
export const DeactivatePasswordLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivatePasswordLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivatePasswordLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivatePasswordLoginMutation, DeactivatePasswordLoginMutationVariables>;
export const GetBuildingTypeChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingTypeChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buildingsByTypeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingTypeChildrenForTreeQuery, GetBuildingTypeChildrenForTreeQueryVariables>;
export const GetCreateBuildingParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateBuildingParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buildingTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateBuildingParamsQuery, GetCreateBuildingParamsQueryVariables>;
export const GetBuildingChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingChildrenForTreeQuery, GetBuildingChildrenForTreeQueryVariables>;
export const GetBuildingForDetailsPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingForDetailsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buildingTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...BuildingAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetBuildingForDetailsPageQuery, GetBuildingForDetailsPageQueryVariables>;
export const GetBuildingForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buildingTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...BuildingAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetBuildingForEditQuery, GetBuildingForEditQueryVariables>;
export const GetBuildingTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingTypesQuery, GetBuildingTypesQueryVariables>;
export const CreateBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"building"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBuildingMutation, CreateBuildingMutationVariables>;
export const UpdateBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBuildingMutation, UpdateBuildingMutationVariables>;
export const DeleteBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteBuildingMutation, DeleteBuildingMutationVariables>;
export const GetEventsInTimeRangeDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventsInTimeRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocationGroups"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariants"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRoomsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationAreasExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationAreas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}]}}]}}]}}]}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterEvent"}}]}}]}}]}},...AllocationSelectionFilterEventFragmentDoc.definitions]} as unknown as DocumentNode<GetEventsInTimeRangeQuery, GetEventsInTimeRangeQueryVariables>;
export const GetProjectsInTimeRangeDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectsInTimeRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocationGroups"},"name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariants"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRoomsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationAreasExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationAreas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}]}}]}}]}}]}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterProject"}}]}}]}}]}},...AllocationSelectionFilterProjectFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectsInTimeRangeQuery, GetProjectsInTimeRangeQueryVariables>;
export const GetExternalEventsInTimeRangeDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventsInTimeRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocationGroups"},"name":{"kind":"Name","value":"externalEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventVariantsByEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationsByVariantIdExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationsByVariantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationSelectionFilterExternalEvent"}}]}}]}}]}},...AllocationSelectionFilterExternalEventFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventsInTimeRangeQuery, GetExternalEventsInTimeRangeQueryVariables>;
export const CreateMultiLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMultiLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMultilink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"multilink"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multilink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMultiLinkMutation, CreateMultiLinkMutationVariables>;
export const CreateLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"multiLinkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"link"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"multilinkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"multiLinkId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<CreateLinkMutation, CreateLinkMutationVariables>;
export const UpdateLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLinkMutation, UpdateLinkMutationVariables>;
export const DeleteLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteLinkMutation, DeleteLinkMutationVariables>;
export const DeleteMultiLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMultiLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMultilink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteMultiLinkMutation, DeleteMultiLinkMutationVariables>;
export const AllocationAreaPhaseTileDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllocationAreaPhaseTileData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationAreaPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseTileAreaPhase"}}]}}]}}]}}]}},...PhaseTileAreaPhaseFragmentDoc.definitions]} as unknown as DocumentNode<AllocationAreaPhaseTileDataQuery, AllocationAreaPhaseTileDataQueryVariables>;
export const AllocationRoomPhaseTileDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllocationRoomPhaseTileData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"allocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseTileRoomPhase"}}]}}]}}]}}]}},...PhaseTileRoomPhaseFragmentDoc.definitions]} as unknown as DocumentNode<AllocationRoomPhaseTileDataQuery, AllocationRoomPhaseTileDataQueryVariables>;
export const ProjectAllocationAreaPhaseTileDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectAllocationAreaPhaseTileData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationAreaPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPhaseTileAreaPhase"}}]}}]}}]}}]}},...ProjectPhaseTileAreaPhaseFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationAreaPhaseTileDataQuery, ProjectAllocationAreaPhaseTileDataQueryVariables>;
export const ProjectAllocationRoomPhaseTileDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectAllocationRoomPhaseTileData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"projectAllocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPhaseTileRoomPhase"}}]}}]}}]}}]}},...ProjectPhaseTileRoomPhaseFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationRoomPhaseTileDataQuery, ProjectAllocationRoomPhaseTileDataQueryVariables>;
export const ExternalEventAllocationPhaseTileDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalEventAllocationPhaseTileData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"externalEventAllocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"phases"},"name":{"kind":"Name","value":"externalEventAllocationPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseTileExternalEventPhase"}}]}}]}}]}}]}},...PhaseTileExternalEventPhaseFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventAllocationPhaseTileDataQuery, ExternalEventAllocationPhaseTileDataQueryVariables>;
export const DeleteEventAllocationRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEventAllocationRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delete"},"name":{"kind":"Name","value":"deleteAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","alias":{"kind":"Name","value":"variantId"},"name":{"kind":"Name","value":"eventVariantId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteEventAllocationRoomMutation, DeleteEventAllocationRoomMutationVariables>;
export const DeleteEventAllocationAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEventAllocationArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delete"},"name":{"kind":"Name","value":"deleteAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}},{"kind":"Field","alias":{"kind":"Name","value":"variantId"},"name":{"kind":"Name","value":"eventVariantId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteEventAllocationAreaMutation, DeleteEventAllocationAreaMutationVariables>;
export const DeleteProjectAllocationRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectAllocationRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delete"},"name":{"kind":"Name","value":"deleteProjectAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}},{"kind":"Field","alias":{"kind":"Name","value":"variantId"},"name":{"kind":"Name","value":"projectVariantId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectAllocationRoomMutation, DeleteProjectAllocationRoomMutationVariables>;
export const DeleteProjectAllocationAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectAllocationArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delete"},"name":{"kind":"Name","value":"deleteProjectAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}},{"kind":"Field","alias":{"kind":"Name","value":"variantId"},"name":{"kind":"Name","value":"projectVariantId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectAllocationAreaMutation, DeleteProjectAllocationAreaMutationVariables>;
export const GetAllocationUsagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationUsages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"POSITION_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventPhaseType"}}]}}]}}]}},...EventPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<GetAllocationUsagesQuery, GetAllocationUsagesQueryVariables>;
export const GetProjectAllocationUsagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectAllocationUsages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"POSITION_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPhaseType"}}]}}]}}]}},...ProjectPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectAllocationUsagesQuery, GetProjectAllocationUsagesQueryVariables>;
export const GetAllocationUsageIdByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllocationUsageIdByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationUsageByName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAllocationUsageIdByNameQuery, GetAllocationUsageIdByNameQueryVariables>;
export const AllocationRoomUpdateAndDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllocationRoomUpdateAndDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateAndDuplicate"},"name":{"kind":"Name","value":"allocationRoomUpdateAndDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateAllocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createPhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationRoomUpdateAndDuplicateMutation, AllocationRoomUpdateAndDuplicateMutationVariables>;
export const AllocationAreaUpdateAndDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllocationAreaUpdateAndDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateAndDuplicate"},"name":{"kind":"Name","value":"allocationAreaUpdateAndDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateAllocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createPhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationAreaUpdateAndDuplicateMutation, AllocationAreaUpdateAndDuplicateMutationVariables>;
export const AllocationRoomDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllocationRoomDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"duplicate"},"name":{"kind":"Name","value":"allocationRoomDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationRoomDuplicateMutation, AllocationRoomDuplicateMutationVariables>;
export const AllocationAreaDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllocationAreaDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"duplicate"},"name":{"kind":"Name","value":"allocationAreaDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<AllocationAreaDuplicateMutation, AllocationAreaDuplicateMutationVariables>;
export const ProjectAllocationRoomUpdateAndDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectAllocationRoomUpdateAndDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateAndDuplicate"},"name":{"kind":"Name","value":"projectAllocationRoomUpdateAndDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateAllocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createPhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationRoomUpdateAndDuplicateMutation, ProjectAllocationRoomUpdateAndDuplicateMutationVariables>;
export const ProjectAllocationAreaUpdateAndDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectAllocationAreaUpdateAndDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateAndDuplicate"},"name":{"kind":"Name","value":"projectAllocationAreaUpdateAndDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateAllocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createPhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationAreaUpdateAndDuplicateMutation, ProjectAllocationAreaUpdateAndDuplicateMutationVariables>;
export const ProjectAllocationRoomDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectAllocationRoomDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"duplicate"},"name":{"kind":"Name","value":"projectAllocationRoomDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationRoomDuplicateMutation, ProjectAllocationRoomDuplicateMutationVariables>;
export const ProjectAllocationAreaDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectAllocationAreaDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"duplicate"},"name":{"kind":"Name","value":"projectAllocationAreaDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationAreaDuplicateMutation, ProjectAllocationAreaDuplicateMutationVariables>;
export const AllocationRoomGetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllocationRoomGet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"allocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationId"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllocationRoomGetQuery, AllocationRoomGetQueryVariables>;
export const GetEventDataForTimelineDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventDataForTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineFullSite"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomTypes"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineRoom"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaTypes"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineArea"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEvent"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usages"},"name":{"kind":"Name","value":"allocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstAllocationRoom"},"name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"START_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstAllocationArea"},"name":{"kind":"Name","value":"allocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"START_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}}]}}]}},...TimelineFullSiteFragmentDoc.definitions,...TimelineRoomFragmentDoc.definitions,...TimelineAreaFragmentDoc.definitions,...TimelineEventFragmentDoc.definitions]} as unknown as DocumentNode<GetEventDataForTimelineQuery, GetEventDataForTimelineQueryVariables>;
export const GetAllocationsForEventVariantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllocationsForEventVariants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventVariantIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventVariantIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"eventVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"conflicts"}},{"kind":"Field","name":{"kind":"Name","value":"allocationRoomPhasesByAllocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"OFFSET_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specializationType"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllocationsForEventVariantsQuery, GetAllocationsForEventVariantsQueryVariables>;
export const GetProjectDataForTimelineDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectDataForTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineFullSite"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomTypes"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineRoom"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaTypes"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineArea"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProject"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usages"},"name":{"kind":"Name","value":"projectAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"isExecution"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAllocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"roomId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAllocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"areaId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstAllocationRoom"},"name":{"kind":"Name","value":"projectAllocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"START_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstAllocationArea"},"name":{"kind":"Name","value":"projectAllocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"START_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}}]}}]}},...TimelineFullSiteFragmentDoc.definitions,...TimelineRoomFragmentDoc.definitions,...TimelineAreaFragmentDoc.definitions,...TimelineProjectFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectDataForTimelineQuery, GetProjectDataForTimelineQueryVariables>;
export const GetEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSerieses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mainVariant"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEventsQuery, GetEventsQueryVariables>;
export const GetEventSeriesBaseDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventSeriesBaseData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSerieses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetEventSeriesBaseDataQuery, GetEventSeriesBaseDataQueryVariables>;
export const GetSeriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSeriesData"}}]}}]}},...EventSeriesDataFragmentDoc.definitions]} as unknown as DocumentNode<GetSeriesQuery, GetSeriesQueryVariables>;
export const GetEventSeriesLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventSeriesLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconUploadStatus"}}]}}]}}]} as unknown as DocumentNode<GetEventSeriesLogoQuery, GetEventSeriesLogoQueryVariables>;
export const CreateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seriesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"executionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantsUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const CreateEventSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"singleEvent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventSeries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subtitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"singleEvent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"singleEvent"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"multilinkToWebsitesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEventSeriesMutation, CreateEventSeriesMutationVariables>;
export const SetSingleEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSingleEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"singleEvent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"singleEvent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"singleEvent"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}}]}}]}}]}}]} as unknown as DocumentNode<SetSingleEventMutation, SetSingleEventMutationVariables>;
export const UpdateEventSeriesStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventSeriesStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventSeriesStatusMutation, UpdateEventSeriesStatusMutationVariables>;
export const UpdateEventSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationRules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cycle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cycleChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"foundationYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iconUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesAppointmentRules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrderHistory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberKapman"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationalChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAllocationNeeds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnersOverviewName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnersOverviewLink"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalPartners"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isTechnical"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesSetup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesEarlyConstructionInternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesEarlyConstructionExternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesConstruction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesExecution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesDismantling"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesExtendedDismantlingExternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesExtendedDismantlingInternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesTechnicalDismantling"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesMonths"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesHolidaysNrw"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesHolidaysNational"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesHolidaysInternational"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesPublicHolidaysNrw"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesPublicHolidaysNational"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesPublicHolidaysInternational"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherNotesAppointmentRules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentHistory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationHistory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesHallExhibitionAreas"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesBoulevardSections"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesPassages"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesEntrances"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesServiceCenters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesConferenceRooms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesOfficesInternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesStorageInternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesOfficesExternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesStorageExternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesAreas"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesParking"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"singleEvent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationRules"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cycle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cycleChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cycleChanges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"foundationYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"foundationYear"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"iconUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iconUpload"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesAppointmentRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesAppointmentRules"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesDayOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesDayOrderHistory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrderHistory"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"numberKapman"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberKapman"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"numberShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organisationalChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationalChanges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherAllocationNeeds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherAllocationNeeds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPublic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"partnersOverviewName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnersOverviewName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"partnersOverviewLink"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnersOverviewLink"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalPartners"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalPartners"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subtitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isTechnical"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isTechnical"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesSetup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesSetup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesEarlyConstructionInternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesEarlyConstructionInternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesEarlyConstructionExternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesEarlyConstructionExternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesConstruction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesConstruction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesExecution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesExecution"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesDismantling"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesDismantling"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesExtendedDismantlingExternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesExtendedDismantlingExternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesExtendedDismantlingInternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesExtendedDismantlingInternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesTechnicalDismantling"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesTechnicalDismantling"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesMonths"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesMonths"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesHolidaysNrw"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesHolidaysNrw"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesHolidaysNational"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesHolidaysNational"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesHolidaysInternational"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesHolidaysInternational"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesPublicHolidaysNrw"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesPublicHolidaysNrw"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesPublicHolidaysNational"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesPublicHolidaysNational"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesPublicHolidaysInternational"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesPublicHolidaysInternational"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherNotesAppointmentRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherNotesAppointmentRules"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentHistory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentHistory"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationHistory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationHistory"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesHallExhibitionAreas"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesHallExhibitionAreas"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesBoulevardSections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesBoulevardSections"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesPassages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesPassages"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesEntrances"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesEntrances"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesServiceCenters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesServiceCenters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesConferenceRooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesConferenceRooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesOfficesInternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesOfficesInternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesStorageInternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesStorageInternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesOfficesExternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesOfficesExternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesStorageExternal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesStorageExternal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesAreas"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesAreas"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesParking"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesParking"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"singleEvent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"singleEvent"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"numberShort"}},{"kind":"Field","name":{"kind":"Name","value":"foundationYear"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconUploadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isTechnical"}},{"kind":"Field","name":{"kind":"Name","value":"partnersOverviewName"}},{"kind":"Field","name":{"kind":"Name","value":"partnersOverviewLink"}},{"kind":"Field","name":{"kind":"Name","value":"additionalPartners"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrderHistory"}},{"kind":"Field","name":{"kind":"Name","value":"notesAppointmentRules"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"cycleChanges"}},{"kind":"Field","name":{"kind":"Name","value":"allocationRules"}},{"kind":"Field","name":{"kind":"Name","value":"otherAllocationNeeds"}},{"kind":"Field","name":{"kind":"Name","value":"notesSetup"}},{"kind":"Field","name":{"kind":"Name","value":"notesEarlyConstructionInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesEarlyConstructionExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesConstruction"}},{"kind":"Field","name":{"kind":"Name","value":"notesExecution"}},{"kind":"Field","name":{"kind":"Name","value":"notesDismantling"}},{"kind":"Field","name":{"kind":"Name","value":"notesExtendedDismantlingExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesExtendedDismantlingInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesTechnicalDismantling"}},{"kind":"Field","name":{"kind":"Name","value":"notesMonths"}},{"kind":"Field","name":{"kind":"Name","value":"notesHolidaysNrw"}},{"kind":"Field","name":{"kind":"Name","value":"notesHolidaysNational"}},{"kind":"Field","name":{"kind":"Name","value":"notesHolidaysInternational"}},{"kind":"Field","name":{"kind":"Name","value":"notesPublicHolidaysNrw"}},{"kind":"Field","name":{"kind":"Name","value":"notesPublicHolidaysNational"}},{"kind":"Field","name":{"kind":"Name","value":"notesPublicHolidaysInternational"}},{"kind":"Field","name":{"kind":"Name","value":"otherNotesAppointmentRules"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentHistory"}},{"kind":"Field","name":{"kind":"Name","value":"locationHistory"}},{"kind":"Field","name":{"kind":"Name","value":"notesHallExhibitionAreas"}},{"kind":"Field","name":{"kind":"Name","value":"notesBoulevardSections"}},{"kind":"Field","name":{"kind":"Name","value":"notesPassages"}},{"kind":"Field","name":{"kind":"Name","value":"notesEntrances"}},{"kind":"Field","name":{"kind":"Name","value":"notesServiceCenters"}},{"kind":"Field","name":{"kind":"Name","value":"notesConferenceRooms"}},{"kind":"Field","name":{"kind":"Name","value":"notesOfficesInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesStorageInternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesOfficesExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesStorageExternal"}},{"kind":"Field","name":{"kind":"Name","value":"notesAreas"}},{"kind":"Field","name":{"kind":"Name","value":"notesParking"}},{"kind":"Field","name":{"kind":"Name","value":"singleEvent"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventSeriesMutation, UpdateEventSeriesMutationVariables>;
export const UpdateEventSeriesMultiLinkDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventSeriesMultiLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizersId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executorsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sponsorsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraDocumentsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraSystemsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalDataId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalDataId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subeventsLocalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subeventsOtherLocationsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadCooperationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitionNationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionNationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitionInternationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionInternationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsInternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsExternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksInternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksExternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizersId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizersId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"executorsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executorsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sponsorsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sponsorsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"extraDocumentsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraDocumentsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"extraSystemsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraSystemsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalDataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalDataId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"internalDataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalDataId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subeventsLocalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subeventsLocalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subeventsOtherLocationsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subeventsOtherLocationsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fairAbroadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fairAbroadCooperationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadCooperationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competitionNationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitionNationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherCompetitionNationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionNationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competitionInternationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitionInternationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherCompetitionInternationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionInternationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"favoredParallelsInternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsInternalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"favoredParallelsExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsExternalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherLinksInternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksInternalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherLinksExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksExternalId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeriesMultiLinkFields"}}]}}]}}]}},...SeriesMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateEventSeriesMultiLinkMutation, UpdateEventSeriesMultiLinkMutationVariables>;
export const UpdateEventMultiLinkDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventMultiLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraDocumentsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraSystemsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalDataId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalDataId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subeventsLocalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subeventsOtherLocationsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadCooperationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitionNationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionNationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitionInternationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionInternationalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsInternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsExternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksInternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksExternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"extraDocumentsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraDocumentsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"extraSystemsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraSystemsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalDataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalDataId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"internalDataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalDataId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subeventsLocalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subeventsLocalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subeventsOtherLocationsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subeventsOtherLocationsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fairAbroadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fairAbroadCooperationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fairAbroadCooperationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competitionNationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitionNationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherCompetitionNationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionNationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competitionInternationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitionInternationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherCompetitionInternationalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCompetitionInternationalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"favoredParallelsInternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsInternalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"favoredParallelsExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoredParallelsExternalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherLinksInternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksInternalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherLinksExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksExternalId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventMultiLinkFields"}}]}}]}}]}},...EventMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateEventMultiLinkMutation, UpdateEventMultiLinkMutationVariables>;
export const GetEventByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"eventByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetEventByNameQuery, GetEventByNameQueryVariables>;
export const GetEventSeriesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventSeriesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"eventSeriesByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetEventSeriesByNameQuery, GetEventSeriesByNameQueryVariables>;
export const DeleteSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteSeriesMutation, DeleteSeriesMutationVariables>;
export const GetEventVariantsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventVariants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventVariantData"}}]}}]}}]}},...EventVariantDataFragmentDoc.definitions]} as unknown as DocumentNode<GetEventVariantsQuery, GetEventVariantsQueryVariables>;
export const CreateEventVariantDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<CreateEventVariantMutation, CreateEventVariantMutationVariables>;
export const UpdateEventVariantAllocationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventVariantAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteRooms"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomAllocationRoomPkeyDelete"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createRooms"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomEventVariantIdFkeyAllocationRoomCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAreas"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaAllocationAreaPkeyDelete"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createAreas"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaEventVariantIdFkeyAllocationAreaCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRoomsUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteRooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createRooms"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationAreasUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAreas"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createAreas"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<UpdateEventVariantAllocationsMutation, UpdateEventVariantAllocationsMutationVariables>;
export const DeleteEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteEventMutation, DeleteEventMutationVariables>;
export const ArchiveVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ArchiveVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archive"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archive"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveVariantMutation, ArchiveVariantMutationVariables>;
export const GetEventDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventBaseData"}}]}}]}},...EventBaseDataFragmentDoc.definitions]} as unknown as DocumentNode<GetEventQuery, GetEventQueryVariables>;
export const GetEventLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconUploadStatus"}}]}}]}}]} as unknown as DocumentNode<GetEventLogoQuery, GetEventLogoQueryVariables>;
export const UpdateEventStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>;
export const UpdateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annualSpecifics"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assistant"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iconUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subtitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"executionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"annualSpecifics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annualSpecifics"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsible"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assistant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assistant"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teamChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamChanges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seriesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"iconUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iconUpload"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"annualSpecifics"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"responsible"}},{"kind":"Field","name":{"kind":"Name","value":"assistant"}},{"kind":"Field","name":{"kind":"Name","value":"teamChanges"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"url128"}},{"kind":"Field","name":{"kind":"Name","value":"url512"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconUploadStatus"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const CreateEventVariantWithAllocationsFromDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventVariantWithAllocationsFrom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createEventVariantWithAllocationsFrom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newVariantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<CreateEventVariantWithAllocationsFromMutation, CreateEventVariantWithAllocationsFromMutationVariables>;
export const CopyEventVariantAllocationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyEventVariantAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyEventVariantAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventVariant"}}]}}]}}]}},...TimelineEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<CopyEventVariantAllocationsMutation, CopyEventVariantAllocationsMutationVariables>;
export const CreateEventAllocationRoomDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventAllocationRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRoom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRoomPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationRoom"}}]}}]}}]}},...TimelineEventAllocationRoomFragmentDoc.definitions]} as unknown as DocumentNode<CreateEventAllocationRoomMutation, CreateEventAllocationRoomMutationVariables>;
export const CreateEventAllocationAreaDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventAllocationArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationArea"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationAreaPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationArea"}}]}}]}}]}},...TimelineEventAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<CreateEventAllocationAreaMutation, CreateEventAllocationAreaMutationVariables>;
export const CreateEventAllocationPlotDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventAllocationPlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPlotPhaseAllocationIdFkeyAllocationPlotPhaseCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createAllocationPlot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationPlot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationPlotPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationPlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationPlot"}}]}}]}}]}},...TimelineEventAllocationPlotFragmentDoc.definitions]} as unknown as DocumentNode<CreateEventAllocationPlotMutation, CreateEventAllocationPlotMutationVariables>;
export const EventAllocationRoomUpdateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EventAllocationRoomUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomPhaseAllocationIdFkeyAllocationRoomPhaseCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomPhaseOnAllocationRoomPhaseForAllocationRoomPhaseAllocationIdFkeyUsingAllocationRoomPhasePkeyUpdate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationRoomPhaseAllocationRoomPhasePkeyDelete"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRoomPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationRoom"}}]}}]}}]}},...TimelineEventAllocationRoomFragmentDoc.definitions]} as unknown as DocumentNode<EventAllocationRoomUpdateMutation, EventAllocationRoomUpdateMutationVariables>;
export const EventAllocationAreaUpdateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EventAllocationAreaUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaPhaseAllocationIdFkeyAllocationAreaPhaseCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaPhaseOnAllocationAreaPhaseForAllocationAreaPhaseAllocationIdFkeyUsingAllocationAreaPhasePkeyUpdate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationAreaPhaseAllocationAreaPhasePkeyDelete"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationAreaPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"allocationArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationArea"}}]}}]}}]}},...TimelineEventAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<EventAllocationAreaUpdateMutation, EventAllocationAreaUpdateMutationVariables>;
export const UpdateEventVariantReferenceAllocationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventVariantReferenceAllocationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationRoomId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationAreaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateVariant"},"name":{"kind":"Name","value":"updateEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"referenceAllocationAreaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationAreaId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceAllocationRoomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationRoomId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceAllocationRoomId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventVariantReferenceAllocationIdMutation, UpdateEventVariantReferenceAllocationIdMutationVariables>;
export const UpdateEventVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createFeedEntry"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedEntryFeedIdFkeyFeedEntryCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createFeedEntry"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventVariantMutation, UpdateEventVariantMutationVariables>;
export const GetEventVariantCommentsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventVariantComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"comments"},"name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedData"}}]}}]}}]}},...FeedDataFragmentDoc.definitions]} as unknown as DocumentNode<GetEventVariantCommentsQuery, GetEventVariantCommentsQueryVariables>;
export const GetBuildingsForLocationDotsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingsForLocationDots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventVariantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"levelsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"levels"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomType"}}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationDotsBuilding"}}]}}]}}]}},...LocationDotsBuildingFragmentDoc.definitions]} as unknown as DocumentNode<GetBuildingsForLocationDotsQuery, GetBuildingsForLocationDotsQueryVariables>;
export const EventVariantsWithAllocationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventVariantsWithAllocationsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variantsWithAllocationsCount"},"name":{"kind":"Name","value":"eventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationAreasExist"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationPlotsExist"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocationRoomsExist"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<EventVariantsWithAllocationsCountQuery, EventVariantsWithAllocationsCountQueryVariables>;
export const GetEventAllocationsForEventDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventAllocationsForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationRoom"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineEventAllocationArea"}}]}}]}}]}},...TimelineEventAllocationRoomFragmentDoc.definitions,...TimelineEventAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<GetEventAllocationsForEventQuery, GetEventAllocationsForEventQueryVariables>;
export const GetExternalEventSeriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSerieses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventSeriesData"}}]}}]}}]}},...ExternalEventSeriesDataFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventSeriesQuery, GetExternalEventSeriesQueryVariables>;
export const CreateExternalEventSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeriesCategory"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"national"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createExternalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventSeries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"national"},"value":{"kind":"Variable","name":{"kind":"Name","value":"national"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"multilinkToWebsitesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]} as unknown as DocumentNode<CreateExternalEventSeriesMutation, CreateExternalEventSeriesMutationVariables>;
export const GetExternalEventSeriesByNameShortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventSeriesByNameShort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"externalEventSeriesByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]} as unknown as DocumentNode<GetExternalEventSeriesByNameShortQuery, GetExternalEventSeriesByNameShortQueryVariables>;
export const GetExternalEventSeriesDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventSeriesData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventSeriesData"}}]}}]}},...ExternalEventSeriesDataFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventSeriesDataQuery, GetExternalEventSeriesDataQueryVariables>;
export const GetExternalEventSeriesWithEventsDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventSeriesWithEventsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventSeriesWithEventsData"}}]}}]}},...ExternalEventSeriesWithEventsDataFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventSeriesWithEventsDataQuery, GetExternalEventSeriesWithEventsDataQueryVariables>;
export const DeleteExternalEventSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExternalEventSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExternalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteExternalEventSeriesMutation, DeleteExternalEventSeriesMutationVariables>;
export const UpdateExternalEventSeriesStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventSeriesStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeriesStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventSeriesStatusMutation, UpdateExternalEventSeriesStatusMutationVariables>;
export const GetExternalEventSeriesEventsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventSeriesEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seriesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventData"}}]}}]}}]}},...ExternalEventDataFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventSeriesEventsQuery, GetExternalEventSeriesEventsQueryVariables>;
export const GetExternalEventAllocationUsagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventAllocationUsages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"POSITION_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventPhaseType"}}]}}]}}]}},...ExternalEventPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventAllocationUsagesQuery, GetExternalEventAllocationUsagesQueryVariables>;
export const GetExternalEventEventByNameShortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventEventByNameShort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"externalEventByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]} as unknown as DocumentNode<GetExternalEventEventByNameShortQuery, GetExternalEventEventByNameShortQueryVariables>;
export const CreateExternalEventEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createExternalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seriesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"multilinkToLinksId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventVariantsUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"national"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateExternalEventEventMutation, CreateExternalEventEventMutationVariables>;
export const GetExternalEventEventDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventEventData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventWithAllocationExistsData"}}]}}]}},...ExternalEventWithAllocationExistsDataFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventEventDataQuery, GetExternalEventEventDataQueryVariables>;
export const DeleteExternalEventEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExternalEventEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExternalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteExternalEventEventMutation, DeleteExternalEventEventMutationVariables>;
export const UpdateExternalEventEventStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventEventStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventEventStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventEventStatusMutation, UpdateExternalEventEventStatusMutationVariables>;
export const UpdateExternalEventEventDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventData"}}]}}]}}]}},...ExternalEventDataFragmentDoc.definitions]} as unknown as DocumentNode<UpdateExternalEventEventMutation, UpdateExternalEventEventMutationVariables>;
export const GetExternalEventVariantsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventVariants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"national"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"externalEventVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventVariantData"}}]}}]}}]}},...ExternalEventVariantDataFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventVariantsQuery, GetExternalEventVariantsQueryVariables>;
export const UpdateExternalEventVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariantStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createFeedEntry"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedEntryFeedIdFkeyFeedEntryCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateExternalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createFeedEntry"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventVariantMutation, UpdateExternalEventVariantMutationVariables>;
export const UpdateExternalEventSeriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeriesCategory"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"national"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"silent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventSeriesStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"explanation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"national"},"value":{"kind":"Variable","name":{"kind":"Name","value":"national"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"silent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"silent"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"explanation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"explanation"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventSeriesData"}}]}}]}}]}},...ExternalEventSeriesDataFragmentDoc.definitions]} as unknown as DocumentNode<UpdateExternalEventSeriesMutation, UpdateExternalEventSeriesMutationVariables>;
export const GetExternalEventDataForTimelineDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventDataForTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventVariantStatus"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locationsNational"},"name":{"kind":"Name","value":"externalEventLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNationalDefault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEvent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalEventAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"variant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usages"},"name":{"kind":"Name","value":"externalEventAllocationUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventPhaseType"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstAllocation"},"name":{"kind":"Name","value":"externalEventAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"variant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeStates"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"START_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}}]}}]}},...TimelineExternalEventLocationFragmentDoc.definitions,...TimelineExternalEventFragmentDoc.definitions,...ExternalEventPhaseTypeFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventDataForTimelineQuery, GetExternalEventDataForTimelineQueryVariables>;
export const GetExternalEventAllocationsForEventDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventAllocationsForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"variant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventAllocation"}}]}}]}}]}},...TimelineExternalEventAllocationFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventAllocationsForEventQuery, GetExternalEventAllocationsForEventQueryVariables>;
export const CreateExternalEventAllocationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventAllocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createExternalEventAllocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"variantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"externalEventAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventAllocation"}}]}}]}}]}},...TimelineExternalEventAllocationFragmentDoc.definitions]} as unknown as DocumentNode<CreateExternalEventAllocationMutation, CreateExternalEventAllocationMutationVariables>;
export const ExternalEventAllocationUpdateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExternalEventAllocationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationPhaseAllocationIdExternalEventAlExternalEventAllocationPhaseCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationPhaseOnExternalEventAllocationPhaseForExternalEventAllocationPhaseAllocationIdExternalEventAlUsingExternalEventAllocationPhasePkeyUpdate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationPhaseExternalEventAllocationPhasePkeyDelete"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateExternalEventAllocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"externalEventAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventAllocation"}}]}}]}}]}},...TimelineExternalEventAllocationFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventAllocationUpdateMutation, ExternalEventAllocationUpdateMutationVariables>;
export const ExternalEventAllocationDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExternalEventAllocationDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"duplicate"},"name":{"kind":"Name","value":"externalEventAllocationDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"variantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventAllocationDuplicateMutation, ExternalEventAllocationDuplicateMutationVariables>;
export const ExternalEventAllocationUpdateAndDuplicateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExternalEventAllocationUpdateAndDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationPhaseUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateAndDuplicate"},"name":{"kind":"Name","value":"externalEventAllocationUpdateAndDuplicate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"variantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateAllocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAllocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createPhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletePhases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<ExternalEventAllocationUpdateAndDuplicateMutation, ExternalEventAllocationUpdateAndDuplicateMutationVariables>;
export const GetExternalEventVariantForTimelineDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventVariantForTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventVariantForTimelineQuery, GetExternalEventVariantForTimelineQueryVariables>;
export const DeleteExternalEventAllocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExternalEventAllocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delete"},"name":{"kind":"Name","value":"deleteExternalEventAllocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"externalEventAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteExternalEventAllocationMutation, DeleteExternalEventAllocationMutationVariables>;
export const ExternalEventVariantsWithAllocationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalEventVariantsWithAllocationsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"externalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variantsWithAllocationsCount"},"name":{"kind":"Name","value":"externalEventVariantsByEventId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationsByVariantIdExist"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ExternalEventVariantsWithAllocationsCountQuery, ExternalEventVariantsWithAllocationsCountQueryVariables>;
export const DeleteExternalEventLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExternalEventLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExternalEventLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteExternalEventLocationMutation, DeleteExternalEventLocationMutationVariables>;
export const UpdateExternalEventReferenceAllocationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventReferenceAllocationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateVariant"},"name":{"kind":"Name","value":"updateExternalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"referenceExternalEventAllocationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceExternalEventAllocationId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventReferenceAllocationIdMutation, UpdateExternalEventReferenceAllocationIdMutationVariables>;
export const GetExternalEventAllocationsForDaysRowsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventAllocationsForDaysRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocations"},"name":{"kind":"Name","value":"externalEventAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDateTime"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationForDaysRows"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nationalLocations"},"name":{"kind":"Name","value":"externalEventLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNationalDefault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...AllocationForDaysRowsFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventAllocationsForDaysRowsQuery, GetExternalEventAllocationsForDaysRowsQueryVariables>;
export const CreateExternalEventEventLocationVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventEventLocationVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventLocationVisibility"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExternalEventEventLocationVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventEventLocationVisibility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"visibility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventEventLocationVisibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]} as unknown as DocumentNode<CreateExternalEventEventLocationVisibilityMutation, CreateExternalEventEventLocationVisibilityMutationVariables>;
export const UpdateExternalEventEventLocationVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventEventLocationVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventLocationVisibility"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateExternalEventEventLocationVisibilityByEventIdAndLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventEventLocationVisibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventEventLocationVisibilityMutation, UpdateExternalEventEventLocationVisibilityMutationVariables>;
export const GetExternalEventDefaultLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventDefaultLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNationalDefault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isNationalDefault"}}]}}]}}]}}]} as unknown as DocumentNode<GetExternalEventDefaultLocationsQuery, GetExternalEventDefaultLocationsQueryVariables>;
export const GetExternalEventLocationDotsDataNationalDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalEventLocationDotsDataNational"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNationalDefault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalEventLocationWithAllocations"}}]}}]}}]}},...ExternalEventLocationWithAllocationsFragmentDoc.definitions]} as unknown as DocumentNode<GetExternalEventLocationDotsDataNationalQuery, GetExternalEventLocationDotsDataNationalQueryVariables>;
export const CreateExternalEventVariantDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createExternalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<CreateExternalEventVariantMutation, CreateExternalEventVariantMutationVariables>;
export const CreateExternalEventVariantWithAllocationsFromDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventVariantWithAllocationsFrom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createExternalEventVariantWithAllocationsFrom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newVariantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<CreateExternalEventVariantWithAllocationsFromMutation, CreateExternalEventVariantWithAllocationsFromMutationVariables>;
export const CopyExternalEventVariantAllocationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyExternalEventVariantAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyExternalEventVariantAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<CopyExternalEventVariantAllocationsMutation, CopyExternalEventVariantAllocationsMutationVariables>;
export const UpdateExternalEventVariantAllocationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventVariantAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAllocations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationExternalEventAllocationPkeyDelete"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createAllocations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEventAllocationVariantIdExternalEventVariantIdExternalEventAllocationCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateExternalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventAllocationsUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAllocations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createAllocations"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineExternalEventVariant"}}]}}]}}]}},...TimelineExternalEventVariantFragmentDoc.definitions]} as unknown as DocumentNode<UpdateExternalEventVariantAllocationsMutation, UpdateExternalEventVariantAllocationsMutationVariables>;
export const DeleteExternalEventLocationVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExternalEventLocationVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExternalEventEventLocationVisibilityByEventIdAndLocationId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteExternalEventLocationVisibilityMutation, DeleteExternalEventLocationVisibilityMutationVariables>;
export const CreateExternalEventLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalEventLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalEventLocationToLocationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"index"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationName"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateExternalEventLocationMutation, CreateExternalEventLocationMutationVariables>;
export const UpdateExternalEventLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEventLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateExternalEventLocationMutation, UpdateExternalEventLocationMutationVariables>;
export const UpdateExternalEventSeriesMultiLinksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventSeriesMultiLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websitesId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEventSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"websitesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websitesId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEventSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"websites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<UpdateExternalEventSeriesMultiLinksMutation, UpdateExternalEventSeriesMultiLinksMutationVariables>;
export const UpdateExternalEventMultiLinksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExternalEventMultiLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linksId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"linksId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linksId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiLinkData"}}]}}]}}]}}]}},...MultiLinkDataFragmentDoc.definitions]} as unknown as DocumentNode<UpdateExternalEventMultiLinksMutation, UpdateExternalEventMultiLinksMutationVariables>;
export const CreateFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feed"},"value":{"kind":"ObjectValue","fields":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFeedMutation, CreateFeedMutationVariables>;
export const CreateFeedEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeedEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdownText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectCreatedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"markdownText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdownText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectCreatedAt"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<CreateFeedEntryMutation, CreateFeedEntryMutationVariables>;
export const CreateUserTextEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserTextEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<CreateUserTextEntryMutation, CreateUserTextEntryMutationVariables>;
export const UpdateUserTextEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserTextEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<UpdateUserTextEntryMutation, UpdateUserTextEntryMutationVariables>;
export const CreateCreatedAtEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCreatedAtEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectCreatedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectCreatedAt"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<CreateCreatedAtEntryMutation, CreateCreatedAtEntryMutationVariables>;
export const CreateStatusChangeEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStatusChangeEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"oldStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldStatus"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newStatus"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<CreateStatusChangeEntryMutation, CreateStatusChangeEntryMutationVariables>;
export const CreateNewMainVariantEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewMainVariantEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldMainVariantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldMainVariantIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newMainVariantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newMainVariantIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"oldMainVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldMainVariantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"oldMainVariantIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldMainVariantIndex"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newMainVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newMainVariantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newMainVariantIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newMainVariantIndex"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedEntryData"}}]}}]}}]}},...FeedEntryDataFragmentDoc.definitions]} as unknown as DocumentNode<CreateNewMainVariantEntryMutation, CreateNewMainVariantEntryMutationVariables>;
export const GetFeedDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedData"}}]}}]}},...FeedDataFragmentDoc.definitions]} as unknown as DocumentNode<GetFeedQuery, GetFeedQueryVariables>;
export const DeleteFeedEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFeedEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFeedEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFeedEntryMutation, DeleteFeedEntryMutationVariables>;
export const GetCreateLevelParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateLevelParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"levelTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateLevelParamsQuery, GetCreateLevelParamsQueryVariables>;
export const CreateLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"elevationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"elevationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"elevationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreateLevelMutation, CreateLevelMutationVariables>;
export const GetLevelChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLevelChildrenForTreeQuery, GetLevelChildrenForTreeQueryVariables>;
export const GetLevelForDetailsPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelForDetailsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LevelAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"levelTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"elevationLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"VALUE_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"nameLong"}}]}}]}}]}},...LevelAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetLevelForDetailsPageQuery, GetLevelForDetailsPageQueryVariables>;
export const GetLevelForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LevelAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"levelTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...LevelAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetLevelForEditQuery, GetLevelForEditQueryVariables>;
export const UpdateLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLevelMutation, UpdateLevelMutationVariables>;
export const DeleteLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"buildingId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteLevelMutation, DeleteLevelMutationVariables>;
export const LocationSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocationSearchQuery, LocationSearchQueryVariables>;
export const GetBuildingTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingTreePathQuery, GetBuildingTreePathQueryVariables>;
export const GetLevelTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLevelTreePathQuery, GetLevelTreePathQueryVariables>;
export const GetRoomTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomTreePathQuery, GetRoomTreePathQueryVariables>;
export const GetZoneTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneTreePathQuery, GetZoneTreePathQueryVariables>;
export const GetAreaTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAreaTreePathQuery, GetAreaTreePathQueryVariables>;
export const GetPlotTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlotTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPlotTreePathQuery, GetPlotTreePathQueryVariables>;
export const GetRoomPartitionTreePathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomPartitionTreePath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomPartition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomPartitionTreePathQuery, GetRoomPartitionTreePathQueryVariables>;
export const GetSiteTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetSiteTooltipDataQuery, GetSiteTooltipDataQueryVariables>;
export const GetBuildingTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingTooltipDataQuery, GetBuildingTooltipDataQueryVariables>;
export const GetLevelTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLevelTooltipDataQuery, GetLevelTooltipDataQueryVariables>;
export const GetRoomTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomTooltipDataQuery, GetRoomTooltipDataQueryVariables>;
export const GetZoneTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneTooltipDataQuery, GetZoneTooltipDataQueryVariables>;
export const GetAreaTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAreaTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAreaTooltipDataQuery, GetAreaTooltipDataQueryVariables>;
export const GetPlotTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlotTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"plot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPlotTooltipDataQuery, GetPlotTooltipDataQueryVariables>;
export const GetRoomPartitionTooltipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomPartitionTooltipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"roomPartition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomPartitionTooltipDataQuery, GetRoomPartitionTooltipDataQueryVariables>;
export const GetLeefLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeefLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLeefLocationsQuery, GetLeefLocationsQueryVariables>;
export const GetLocationsForDownloadDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationsForDownload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteExportAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingExportAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LevelExportAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomExportAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomPartitionExportAttributes"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneExportAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AreaExportAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlotExportAttributes"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},...SiteExportAttributesFragmentDoc.definitions,...BuildingExportAttributesFragmentDoc.definitions,...LevelExportAttributesFragmentDoc.definitions,...RoomExportAttributesFragmentDoc.definitions,...RoomPartitionExportAttributesFragmentDoc.definitions,...ZoneExportAttributesFragmentDoc.definitions,...AreaExportAttributesFragmentDoc.definitions,...PlotExportAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetLocationsForDownloadQuery, GetLocationsForDownloadQueryVariables>;
export const GetElevationLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetElevationLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elevationLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"VALUE_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetElevationLevelsQuery, GetElevationLevelsQueryVariables>;
export const GetLevelsWithoutElevationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelsWithoutElevation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelTypeName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elevationExists"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelTypeName"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<GetLevelsWithoutElevationQuery, GetLevelsWithoutElevationQueryVariables>;
export const GetLevelsWithElevationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLevelsWithElevation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelTypeName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"levelsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"levels"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elevationExists"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelTypeName"}}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"elevationExists"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelTypeName"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"elevation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLevelsWithElevationQuery, GetLevelsWithElevationQueryVariables>;
export const GetPlotDetailsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlotDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlotAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plotTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...PlotAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPlotDetailsQuery, GetPlotDetailsQueryVariables>;
export const GetPlotForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlotForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlotAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plotTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...PlotAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPlotForEditQuery, GetPlotForEditQueryVariables>;
export const GetPlotForCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlotForCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plotTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlotForCreateQuery, GetPlotForCreateQueryVariables>;
export const UpdatePlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePlotMutation, UpdatePlotMutationVariables>;
export const CreatePlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"areaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePlotMutation, CreatePlotMutationVariables>;
export const DeletePlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"areaId"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePlotMutation, DeletePlotMutationVariables>;
export const CreateProjectSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"singleProject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectSeries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"singleProject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"singleProject"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"singleProject"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectSeriesMutation, CreateProjectSeriesMutationVariables>;
export const GetProjectSeriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"notesCycle"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"notesAppointment"}},{"kind":"Field","name":{"kind":"Name","value":"locationRequirements"}},{"kind":"Field","name":{"kind":"Name","value":"allocationHints"}},{"kind":"Field","name":{"kind":"Name","value":"singleProject"}},{"kind":"Field","alias":{"kind":"Name","value":"projects"},"name":{"kind":"Name","value":"projectsBySeriesId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EXECUTION_YEAR_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectSeriesMultiLinkFields"}}]}}]}},...ProjectSeriesMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectSeriesQuery, GetProjectSeriesQueryVariables>;
export const GetProjectSeriesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectSeriesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"projectSeriesByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetProjectSeriesByNameQuery, GetProjectSeriesByNameQueryVariables>;
export const SetSingleProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSingleProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"singleProject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"singleProject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"singleProject"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"singleProject"}}]}}]}}]}}]} as unknown as DocumentNode<SetSingleProjectMutation, SetSingleProjectMutationVariables>;
export const DeleteProjectSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProjectSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectSeriesMutation, DeleteProjectSeriesMutationVariables>;
export const GetAllProjectSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllProjectSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSerieses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"singleProject"}},{"kind":"Field","alias":{"kind":"Name","value":"projects"},"name":{"kind":"Name","value":"projectsBySeriesId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllProjectSeriesQuery, GetAllProjectSeriesQueryVariables>;
export const UpdateProjectSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationalChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cycle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesCycle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesAppointment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationRequirements"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationHints"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organisationalChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationalChanges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cycle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesCycle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesDayOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesAppointment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesAppointment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationRequirements"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationRequirements"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationHints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationHints"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"notesCycle"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"notesAppointment"}},{"kind":"Field","name":{"kind":"Name","value":"locationRequirements"}},{"kind":"Field","name":{"kind":"Name","value":"allocationHints"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectSeriesMutation, UpdateProjectSeriesMutationVariables>;
export const UpdateProjectSeriesMultilinksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectSeriesMultilinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websitesId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherDocumentsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherSystemsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectSeries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"websitesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websitesId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherDocumentsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherDocumentsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherSystemsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherSystemsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherLinksId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectSeries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectSeriesMultiLinkFields"}}]}}]}}]}},...ProjectSeriesMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateProjectSeriesMultilinksMutation, UpdateProjectSeriesMultilinksMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seriesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"executionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantsUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const GetProjectDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectBaseData"}}]}}]}},...ProjectBaseDataFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"projectByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetProjectByNameQuery, GetProjectByNameQueryVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disturbanceNoise"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disturbanceDust"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disturbanceOther"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationalChanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesAppointment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationRequirements"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationHints"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subtitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subtitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"executionYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionYear"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disturbanceNoise"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disturbanceNoise"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disturbanceDust"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disturbanceDust"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disturbanceOther"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disturbanceOther"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organisationalChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationalChanges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesDayOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesDayOrder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notesAppointment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesAppointment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationRequirements"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationRequirements"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocationHints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationHints"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"executionYear"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"disturbanceNoise"}},{"kind":"Field","name":{"kind":"Name","value":"disturbanceDust"}},{"kind":"Field","name":{"kind":"Name","value":"disturbanceOther"}},{"kind":"Field","name":{"kind":"Name","value":"companyGroup"}},{"kind":"Field","name":{"kind":"Name","value":"businessDomain"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChanges"}},{"kind":"Field","name":{"kind":"Name","value":"notesDayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"notesAppointment"}},{"kind":"Field","name":{"kind":"Name","value":"locationRequirements"}},{"kind":"Field","name":{"kind":"Name","value":"allocationHints"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectMultilinksDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectMultilinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherDocumentsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherSystemsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"otherDocumentsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherDocumentsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherSystemsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherSystemsId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherLinksId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherLinksId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectMultiLinkFields"}}]}}]}}]}},...ProjectMultiLinkFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateProjectMultilinksMutation, UpdateProjectMultilinksMutationVariables>;
export const UpdateProjectStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const CreateProjectVariantDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createProjectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectVariantMutation, CreateProjectVariantMutationVariables>;
export const CreateProjectVariantWithAllocationsFromDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectVariantWithAllocationsFrom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createProjectVariantWithAllocationsFrom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newVariantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectVariantWithAllocationsFromMutation, CreateProjectVariantWithAllocationsFromMutationVariables>;
export const CopyProjectVariantAllocationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyProjectVariantAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyProjectVariantAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<CopyProjectVariantAllocationsMutation, CopyProjectVariantAllocationsMutationVariables>;
export const UpdateProjectVariantAllocationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectVariantAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteRooms"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomProjectAllocationRoomPkeyDelete"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createRooms"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomProjectVariantIdFkeyProjectAllocationRoomCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAreas"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaProjectAllocationAreaPkeyDelete"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createAreas"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaProjectVariantIdFkeyProjectAllocationAreaCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateProjectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRoomsUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteRooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createRooms"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationAreasUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAreas"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createAreas"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectVariant"}}]}}]}}]}},...TimelineProjectVariantFragmentDoc.definitions]} as unknown as DocumentNode<UpdateProjectVariantAllocationsMutation, UpdateProjectVariantAllocationsMutationVariables>;
export const CreateProjectAllocationRoomDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectAllocationRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createProjectAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRoom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRoomPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationRoom"}}]}}]}}]}},...TimelineProjectAllocationRoomFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectAllocationRoomMutation, CreateProjectAllocationRoomMutationVariables>;
export const CreateProjectAllocationAreaDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProjectAllocationArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"create"},"name":{"kind":"Name","value":"createProjectAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationArea"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"areaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationAreaPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationArea"}}]}}]}}]}},...TimelineProjectAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<CreateProjectAllocationAreaMutation, CreateProjectAllocationAreaMutationVariables>;
export const ProjectAllocationRoomUpdateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectAllocationRoomUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomPhaseAllocationIdFkeyProjectAllocationRoomPhaseCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomPhaseOnProjectAllocationRoomPhaseForProjectAllocationRoomPhaseAllocationIdFkeyUsingProjectAllocationRoomPhasePkeyUpdate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationRoomPhaseProjectAllocationRoomPhasePkeyDelete"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateProjectAllocationRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRoomPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationRoom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationRoom"}}]}}]}}]}},...TimelineProjectAllocationRoomFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationRoomUpdateMutation, ProjectAllocationRoomUpdateMutationVariables>;
export const ProjectAllocationAreaUpdateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectAllocationAreaUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaPhaseAllocationIdFkeyProjectAllocationAreaPhaseCreateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaPhaseOnProjectAllocationAreaPhaseForProjectAllocationAreaPhaseAllocationIdFkeyUsingProjectAllocationAreaPhasePkeyUpdate"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAllocationAreaPhaseProjectAllocationAreaPhasePkeyDelete"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateProjectAllocationArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOptional"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOptional"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationAreaPhasesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhases"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePhases"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"projectAllocationArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationArea"}}]}}]}}]}},...TimelineProjectAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<ProjectAllocationAreaUpdateMutation, ProjectAllocationAreaUpdateMutationVariables>;
export const UpdateProjectVariantReferenceAllocationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectVariantReferenceAllocationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationRoomId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationAreaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateVariant"},"name":{"kind":"Name","value":"updateProjectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"referenceProjectAllocationAreaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationAreaId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceProjectAllocationRoomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceAllocationRoomId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceProjectAllocationRoomId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectVariantReferenceAllocationIdMutation, UpdateProjectVariantReferenceAllocationIdMutationVariables>;
export const GetProjectVariantsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectVariants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"projectVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectVariantData"}}]}}]}}]}},...ProjectVariantDataFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectVariantsQuery, GetProjectVariantsQueryVariables>;
export const UpdateProjectVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createFeedEntry"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedEntryFeedIdFkeyFeedEntryCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"updateProjectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createFeedEntry"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectVariantMutation, UpdateProjectVariantMutationVariables>;
export const GetProjectVariantCommentsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectVariantComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"comments"},"name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedData"}}]}}]}}]}},...FeedDataFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectVariantCommentsQuery, GetProjectVariantCommentsQueryVariables>;
export const ProjectVariantsWithAllocationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectVariantsWithAllocationsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"variantsWithAllocationsCount"},"name":{"kind":"Name","value":"projectVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationAreasExist"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationPlotsExist"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectAllocationRoomsExist"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectVariantsWithAllocationsCountQuery, ProjectVariantsWithAllocationsCountQueryVariables>;
export const GetProjectLocationDotsDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectLocationDotsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"levelsExist"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"levels"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomType"}}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectLocationDotsBuilding"}}]}}]}}]}},...ProjectLocationDotsBuildingFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectLocationDotsDataQuery, GetProjectLocationDotsDataQueryVariables>;
export const GetProjectAllocationsForProjectDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectAllocationsForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectAllocationRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationRoom"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectAllocationAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelineProjectAllocationArea"}}]}}]}}]}},...TimelineProjectAllocationRoomFragmentDoc.definitions,...TimelineProjectAllocationAreaFragmentDoc.definitions]} as unknown as DocumentNode<GetProjectAllocationsForProjectQuery, GetProjectAllocationsForProjectQueryVariables>;
export const GetExhibitionSpacesAreasDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExhibitionSpacesAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceArea"}}]}}]}}]}},...SpaceAreaFragmentDoc.definitions]} as unknown as DocumentNode<GetExhibitionSpacesAreasQuery, GetExhibitionSpacesAreasQueryVariables>;
export const GetExhibitionSpacesRoomsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExhibitionSpacesRooms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceRoom"}}]}}]}}]}},...SpaceRoomFragmentDoc.definitions]} as unknown as DocumentNode<GetExhibitionSpacesRoomsQuery, GetExhibitionSpacesRoomsQueryVariables>;
export const GetTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"areaTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTypesQuery, GetTypesQueryVariables>;
export const GetRoomsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomsQuery, GetRoomsQueryVariables>;
export const GetRoomForRoomDetailsPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomForRoomDetailsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allocationRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...RoomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetRoomForRoomDetailsPageQuery, GetRoomForRoomDetailsPageQueryVariables>;
export const GetCreateRoomParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateRoomParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateRoomParamsQuery, GetCreateRoomParamsQueryVariables>;
export const CreateRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"room"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"levelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRoomMutation, CreateRoomMutationVariables>;
export const GetRoomForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...RoomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetRoomForEditQuery, GetRoomForEditQueryVariables>;
export const GetRoomsInBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoomsInBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomsInBuildingQuery, GetRoomsInBuildingQueryVariables>;
export const UpdateRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const GetRoomChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomChildrenForTreeQuery, GetRoomChildrenForTreeQueryVariables>;
export const DeleteRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"levelId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoomMutation, DeleteRoomMutationVariables>;
export const GetRoomPartitionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomPartition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partitionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomPartition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partitionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomPartitionAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...RoomPartitionAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetRoomPartitionQuery, GetRoomPartitionQueryVariables>;
export const GetRoomPartitionForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoomPartitionForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomPartition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomPartitionAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...RoomPartitionAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetRoomPartitionForEditQuery, GetRoomPartitionForEditQueryVariables>;
export const GetCreateRoomPartitionParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateRoomPartitionParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomPartitionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateRoomPartitionParamsQuery, GetCreateRoomPartitionParamsQueryVariables>;
export const DeleteRoomPartitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRoomPartition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRoomPartition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomPartition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoomPartitionMutation, DeleteRoomPartitionMutationVariables>;
export const GetScenarioGroupsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioGroupDetails"}}]}}]}}]}},...ScenarioGroupDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetScenarioGroupsQuery, GetScenarioGroupsQueryVariables>;
export const CreateScenarioGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScenarioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToOrganisationalChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateScenarioGroupMutation, CreateScenarioGroupMutationVariables>;
export const GetScenarioGroupDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioGroupDetails"}}]}}]}},...ScenarioGroupDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetScenarioGroupQuery, GetScenarioGroupQueryVariables>;
export const GetScenarioGroupByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioGroupByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"scenarioGroupByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetScenarioGroupByNameQuery, GetScenarioGroupByNameQueryVariables>;
export const DeleteScenarioGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScenarioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteScenarioGroupMutation, DeleteScenarioGroupMutationVariables>;
export const CreateScenarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedToChangesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedEntriesUsingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"created-at","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectCreatedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateScenarioMutation, CreateScenarioMutationVariables>;
export const GetScenarioDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioDetails"}}]}}]}},...ScenarioDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetScenarioQuery, GetScenarioQueryVariables>;
export const GetScenarioByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"scenarioByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetScenarioByNameQuery, GetScenarioByNameQueryVariables>;
export const DeleteScenarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteScenarioMutation, DeleteScenarioMutationVariables>;
export const UpdateScenarioGroupDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScenarioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intention"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kapmanNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intention"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intention"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"kapmanNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kapmanNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessDomain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsible"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioGroupDetails"}}]}}]}}]}},...ScenarioGroupDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateScenarioGroupMutation, UpdateScenarioGroupMutationVariables>;
export const UpdateScenarioDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intention"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intention"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intention"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScenarioDetails"}}]}}]}}]}},...ScenarioDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateScenarioMutation, UpdateScenarioMutationVariables>;
export const SetScenarioChangesIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetScenarioChangesId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<SetScenarioChangesIdMutation, SetScenarioChangesIdMutationVariables>;
export const SetScenarioGroupChangesIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetScenarioGroupChangesId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<SetScenarioGroupChangesIdMutation, SetScenarioGroupChangesIdMutationVariables>;
export const SetScenarioGroupOrganisationalChangesIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetScenarioGroupOrganisationalChangesId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisationalChangesId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalChangesId"}}]}}]}}]}}]} as unknown as DocumentNode<SetScenarioGroupOrganisationalChangesIdMutation, SetScenarioGroupOrganisationalChangesIdMutationVariables>;
export const GetScenarioByNameShortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioByNameShort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"scenarioByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetScenarioByNameShortQuery, GetScenarioByNameShortQueryVariables>;
export const GetScenarioGroupByNameShortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioGroupByNameShort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"scenarioGroupByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetScenarioGroupByNameShortQuery, GetScenarioGroupByNameShortQueryVariables>;
export const UpdateScenarioGroupStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScenarioGroupStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenarioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScenarioGroupStatusMutation, UpdateScenarioGroupStatusMutationVariables>;
export const UpdateScenarioStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScenarioStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScenarioStatusMutation, UpdateScenarioStatusMutationVariables>;
export const GetScenarioSettingByScenarioIdDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScenarioSettingByScenarioId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scenarioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DesignerScenarioSetting"}}]}}]}},...DesignerScenarioSettingFragmentDoc.definitions]} as unknown as DocumentNode<GetScenarioSettingByScenarioIdQuery, GetScenarioSettingByScenarioIdQueryVariables>;
export const CreateScenarioSettingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScenarioSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quarter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthsBefore"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthsAfter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showSections"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScenarioSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioSetting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quarter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quarter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"monthsAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthsAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"monthsBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthsBefore"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"showSections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showSections"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DesignerScenarioSetting"}}]}}]}}]}},...DesignerScenarioSettingFragmentDoc.definitions]} as unknown as DocumentNode<CreateScenarioSettingMutation, CreateScenarioSettingMutationVariables>;
export const UpdateScenarioSettingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScenarioSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quarter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthsBefore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthsAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showSections"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScenarioSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quarter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quarter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"monthsBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthsBefore"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"monthsAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthsAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"showSections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showSections"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DesignerScenarioSetting"}}]}}]}}]}},...DesignerScenarioSettingFragmentDoc.definitions]} as unknown as DocumentNode<UpdateScenarioSettingMutation, UpdateScenarioSettingMutationVariables>;
export const DeleteScenarioSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScenarioSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScenarioSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scenarioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteScenarioSettingMutation, DeleteScenarioSettingMutationVariables>;
export const GetSiteChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"buildingsByTypeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoneTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"zonesByTypeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSiteChildrenForTreeQuery, GetSiteChildrenForTreeQueryVariables>;
export const GetLocationTreeRootsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationTreeRoots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationTreeRootsQuery, GetLocationTreeRootsQueryVariables>;
export const GetSiteForDetailsPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteForDetailsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteAttributes"}}]}}]}},...SiteAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetSiteForDetailsPageQuery, GetSiteForDetailsPageQueryVariables>;
export const GetSiteForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteAttributes"}}]}}]}},...SiteAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetSiteForEditQuery, GetSiteForEditQueryVariables>;
export const CreateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSiteMutation, CreateSiteMutationVariables>;
export const UpdateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const SiteExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiteExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteByNameShort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SiteExistsQuery, SiteExistsQueryVariables>;
export const GetUploadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetUploadUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUploadUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"upload_id"}}]}}]}}]} as unknown as DocumentNode<GetUploadUrlMutation, GetUploadUrlMutationVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"FIRST_NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPasswordLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserWithLoginDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserWithLoginData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userWithLoginData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"matchingEntraUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ssoLogins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"room"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passwordLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]} as unknown as DocumentNode<GetUserWithLoginDataQuery, GetUserWithLoginDataQueryVariables>;
export const GetUsersWithLoginDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersWithLoginData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersWithLoginData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matchingEntraUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ssoLogins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passwordLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]} as unknown as DocumentNode<GetUsersWithLoginDataQuery, GetUsersWithLoginDataQueryVariables>;
export const GetUserPasswordLoginByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPasswordLoginByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existingObject"},"name":{"kind":"Name","value":"userPasswordLoginByEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetUserPasswordLoginByEmailQuery, GetUserPasswordLoginByEmailQueryVariables>;
export const GetMyUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyUser"}}]}}]}},...MyUserFragmentDoc.definitions]} as unknown as DocumentNode<GetMyUserQuery, GetMyUserQueryVariables>;
export const CreateUserWithPasswordLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserWithPasswordLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAdmin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserWithPasswordLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAdmin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreatedUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTaken"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserWithPasswordLoginMutation, CreateUserWithPasswordLoginMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iconUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAdmin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAdmin"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPasswordLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserIsAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserIsAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAdmin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAdmin"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserIsAdminMutation, UpdateUserIsAdminMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeactivateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const GetEntraUserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntraUserData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SsoProvider"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEntraUserData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oid"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"room"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<GetEntraUserDataQuery, GetEntraUserDataQueryVariables>;
export const ActivateEntraUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateEntraUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SsoProvider"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"position"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateEntraUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oid"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"company"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company"}}},{"kind":"Argument","name":{"kind":"Name","value":"position"},"value":{"kind":"Variable","name":{"kind":"Name","value":"position"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserWithLoginData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidOid"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlreadyLinked"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ActivateEntraUserMutation, ActivateEntraUserMutationVariables>;
export const SetCurrentEventVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCurrentEventVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldCurrentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newCurrentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateOld"},"name":{"kind":"Name","value":"updateEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldCurrentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"updateNew"},"name":{"kind":"Name","value":"updateEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newCurrentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"eventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<SetCurrentEventVariantMutation, SetCurrentEventVariantMutationVariables>;
export const SetCurrentProjectVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCurrentProjectVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldCurrentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newCurrentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateOld"},"name":{"kind":"Name","value":"updateProjectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldCurrentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"updateNew"},"name":{"kind":"Name","value":"updateProjectVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newCurrentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"projectVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<SetCurrentProjectVariantMutation, SetCurrentProjectVariantMutationVariables>;
export const SetCurrentExternalEventVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCurrentExternalEventVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldCurrentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newCurrentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateOld"},"name":{"kind":"Name","value":"updateExternalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldCurrentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"updateNew"},"name":{"kind":"Name","value":"updateExternalEventVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newCurrentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"variant"},"name":{"kind":"Name","value":"externalEventVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"changesId"}}]}}]}}]}}]} as unknown as DocumentNode<SetCurrentExternalEventVariantMutation, SetCurrentExternalEventVariantMutationVariables>;
export const GetZoneTypeChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneTypeChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoneType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zonesByTypeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneTypeChildrenForTreeQuery, GetZoneTypeChildrenForTreeQueryVariables>;
export const CreateZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}}]}}]}}]} as unknown as DocumentNode<CreateZoneMutation, CreateZoneMutationVariables>;
export const GetZoneTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoneTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneTypesQuery, GetZoneTypesQueryVariables>;
export const GetZoneChildrenForTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneChildrenForTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_SHORT_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneChildrenForTreeQuery, GetZoneChildrenForTreeQueryVariables>;
export const GetZoneDetailsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocationPlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoneTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]}},...ZoneAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetZoneDetailsQuery, GetZoneDetailsQueryVariables>;
export const GetZoneForEditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoneTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...ZoneAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetZoneForEditQuery, GetZoneForEditQueryVariables>;
export const GetZoneForCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneForCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoneTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"INDEX_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneForCreateQuery, GetZoneForCreateQueryVariables>;
export const UpdateZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLong"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"typeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"typeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameLong"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateZoneMutation, UpdateZoneMutationVariables>;
export const DeleteZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameShort"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteZoneMutation, DeleteZoneMutationVariables>;